const configData = {
  translations: {
    'onboarding.features-carousel.slide-two.title': { en: 'Find Your Path!' },
    'onboarding.features-carousel.slide-three.title': {
      en: '52 Cards, 52 Chances!',
    },
    'onboarding.features-carousel.slide-one.title': {
      en: 'Join My Fun Workouts!',
    },
    'onboarding.features-carousel.slide-two.copy': {
      en: 'Work out just like Carrie.\nWork out with friends - from anywhere!\nAchieve your fitness goals.\nShare your success.',
    },
    'onboarding.features-carousel.slide-one.description': {
      en: "With HiNote Life, every workout is different.\nWhat exercise will you do next?\nHow many reps?\nIt's all luck of the draw.",
    },
    'admin.translation.create-success': {
      en: 'Translation created successfully!',
    },
    'onboarding.features-carousel.slide-three.copy': {
      en: 'Work out whenever and wherever.\nNeed to start small? Try a half workout.\nAchieve milestones and share success.\nMeasure what matters - your progress!',
    },
    'auth.screen.features.title': { en: 'Welcome to HiNote Life' },
    'auth.screen.title.sign-up': { en: 'Sign Up with Email' },
    'auth.screen.title.forgot-password': { en: 'Forgot Password' },
    'auth.screen.title.reset-password': { en: 'Reset Password' },
    'auth.screen.title.auth-loading': { en: 'Loading' },
    'screen.workout-achievements.title': { en: 'New Achievements' },
    'screen.workout-start.title': { en: 'Workout Start' },
    'screen.workout-info.title': { en: 'Workout Info' },
    'screen.workout-loading.title': { en: 'Workout Loading' },
    'screen.workout-player.title': { en: 'Workout Player' },
    'screen.title.user-profile': { en: 'Edit Profile' },
    'screen.title.update-name': { en: 'Update Name' },
    'screen.title.update-schedule': { en: 'Update Workout Schedule' },
    'share-workout-screen.image-upload.title': { en: 'Select Workout Photo' },
    'screen.workout-feedback.title': { en: 'Workout Feedback' },
    'screen.workout-setup.title': { en: 'Workout Setup' },
    'screen.workout-summary.title': { en: 'Workout Summary' },
    'profile-screen.image-upload.title': { en: 'Select Profile Picture' },
    'screen.paths-explore.title': { en: 'Explore paths' },
    'screen.title.update-fit-level': { en: 'Update Fitness Level' },
    'screen.title.update-email': { en: 'Update Email' },
    'screen.title.settings': { en: 'Settings' },
    'screen.title.manage-subscription': { en: 'Subscription' },
    'auth.screen.title.confirm-account': { en: 'Confirm Account' },
    'screen.title.help-support': { en: 'Help & Support' },
    'screen.my-profile.title': { en: 'My Profile' },
    'screen.title.integrations': { en: 'Integrations' },
    'screen.paths-filter.title': { en: 'Paths' },
    'screen.achievements.title': { en: 'All Achievements' },
    'screen.my-path.title': { en: 'My Path' },
    'bottom-nav.workout.title': { en: 'Workout' },
    'bottom-nav.paths-explore.title': { en: 'Explore' },
    'bottom-nav.my-path.title': { en: 'My Path' },
    'screen.path.title': { en: 'Path' },
    'onboarding.screen.title.subscription': { en: 'Subscriptions' },
    'bottom-nav.my-profile.tab.title': { en: 'Profile' },
    'users.store.success': { en: 'User created successfully!' },
    'button.label.login-prefix': { en: 'Already a member?' },
    'button.label.log-in': { en: 'Log In' },
    'button.label.sign-up-with-email': { en: 'Sign Up with Email' },
    'button.label.facebook-sign-in': { en: 'Continue with Facebook' },
    'auth.success': { en: 'Successfully logged in user!' },
    'admin.setting.created.success.message': {
      en: 'Setting created successfully!',
    },
    'auth.screen.onboarding.start': { en: 'Hi %s,\nwelcome to HiNote Life' },
    'button.continue': { en: 'Continue' },
    'auth.screen.description.onboarding-get-started': {
      en: 'Thanks for joining the HiNote Life! Before we jump in, we have a few questions to help you find your path.',
    },
    'button.label.go-back': { en: 'Back' },
    'button.label.skip': { en: 'Skip' },
    'onboarding.screen.fitlevel.title': {
      en: 'How would you describe your current fitness level?',
    },
    'onboarding.screen.fitlevel.description': {
      en: 'This helps us recommend workouts and calculate your daily calorie goals based on your activity level. You can change this anytime in Settings.',
    },
    'time-of-day.afternoon.label': { en: 'AFTERNOON' },
    'onboarding.screen.preferred-time-of-day.title': {
      en: 'When do you prefer to exercise?',
    },
    'onboarding.screen.preferred-time-of-day.description': {
      en: 'This will help us recommend the best workouts.',
    },
    'time-of-day.morning.label': { en: 'MORNING' },
    'time-of-day.evening.label': { en: 'EVENING' },
    'users.update.success': { en: 'Profile updated successfully!' },
    'weekdays.sunday.label': { en: 'Su' },
    'onboarding.screen.schedule.title': {
      en: 'What does your ideal fitness week look like?',
    },
    'auth.screen.description.select-workout-days': {
      en: "Tap to select the day(s) that work best for you. We recommend you start with two workouts per week.\nBut don't worry, you can always do a fun HiNote Life workout at any time!",
    },
    'weekdays.monday.label': { en: 'Mo' },
    'weekdays.tuesday.label': { en: 'Tu' },
    'weekdays.wednesday.label': { en: 'We' },
    'weekdays.thursday.label': { en: 'Th' },
    'weekdays.friday.label': { en: 'Fr' },
    'weekdays.saturday.label': { en: 'Sa' },
    'button.label.close': { en: 'Close' },
    'onboarding.screen.subscription.title': { en: 'Have fun. Feel great.' },
    'carrie-underwood': { en: 'Carrie Underwood' },
    'onboarding.screen.subscription.description': {
      en: '52 cards, 52 weeks, 52 chances to make significant changes in your health, your body, and your well-being.',
    },
    'onboarding.subscription.restore': { en: 'Restore' },
    'subscription-screen.start-subscription.label': { en: 'Subscribe Now' },
    'free-trial-view.close-button.label': { en: 'No Thanks' },
    'label.already-subscribed': { en: 'Already a subscriber?' },
    'onboarding.screen.subscription.get-started.description': {
      en: 'Choose a plan for after your',
    },
    'subscription-terms.title': { en: 'Subscription Terms' },
    'subscription-offering.offering-length.singular': { en: 'month' },
    'subscription-screen.cancel.description': {
      en: 'Cancel anytime in the App Store.',
    },
    'onboarding.screen.subscription.get-started.trial': { en: 'free trial' },
    'banner.best-value.label': { en: 'Best Value' },
    'onboarding.screen.subscription.get-started.title': {
      en: "Let's get started!",
    },
    'subscription-offering.offering-length.plural': { en: 'months' },
    'form.label.email-address': { en: 'Email Address' },
    'auth.placeholder.email-address': { en: 'Email Address' },
    'login-options.or': { en: 'Or' },
    'form.label.password': { en: 'Password' },
    'button.label.forgot-password': { en: 'Forgot your Password?' },
    'icon.label': { en: 'Password Visibility' },
    'term-privacy-agreement.prefix': {
      en: "By continuing, you agree to HiNote Life's",
    },
    'link.privacy.label': { en: 'Privacy Policy' },
    'conjunction.and': { en: 'and' },
    'link.terms.label': { en: 'Terms Of Service' },
    'facebook.login.cancel': { en: 'Login attempt through Facebook canceled' },
    'button.continue.label': { en: 'Continue' },
    'onboarding.screen.subscription.thanks.description': {
      en: "We're excited to have you join the HiNote Life family. With HiNote Life, every workout is different. What exercise will you do next? How many reps? It's all luck of the draw.",
    },
    'onboarding.screen.subscription.thanks.title': {
      en: 'Thanks for joining HiNote Life!',
    },
    'button.label.continue': { en: 'Continue' },
    'onboarding.screen.notification.title': {
      en: 'Turn on your notifications so we can send you some inspiration!',
    },
    'onboarding.screen.recommended-path.description': {
      en: 'Start your HiNote Life journey with this recommended path, a fun workout with others like you!',
    },
    'button.label.join': { en: 'Join' },
    'button.explore-all-paths.label': { en: 'Explore All Paths' },
    'onboarding-screen.recommended-path.detail': {
      en: '%s Workouts per week \n%s',
    },
    'onboarding.screen.recommended-path.duration': { en: '%s Mins' },
    'button.try-path-workout': { en: 'Try My First Path Workout' },
    'onboarding.screen.recommended-path.title': { en: 'Next Steps' },
    'onboarding.screen.recommended-path.recommended.label': {
      en: 'Recommended Path',
    },
    'recommended-path-screen.progress-view.title': {
      en: 'Track Your Progress',
    },
    'button.explore-app': { en: 'Explore App' },
    'workout.cta.sublabel': { en: "Follow Carrie Underwood's Workouts" },
    'screen.workout.intro': { en: '%s,\nReady to begin?' },
    'workout.cta.label': { en: "Join Carrie's Path" },
    'screen.workout.title': { en: 'Individual Workouts' },
    'link.explore-paths.label': { en: 'Explore all paths' },
    'button.label.workout-info': { en: 'Workout Information' },
    'screen.workout-setup.description': { en: 'Now Choose the Intensity' },
    'title.workout': { en: 'Workout' },
    'fit-level-selection.intermediate.label': { en: 'INTERMEDIATE' },
    'workout.type.half': { en: 'Half' },
    'fit-level-selection.advanced.label': { en: 'ADVANCED' },
    'fit-level-selection.beginner.label': { en: 'BEGINNER' },
    'minutes.text': { en: 'Mins' },
    'exercises.text': { en: 'Exercises' },
    'button.label.start': { en: 'Start' },
    'music-button.label.audio-prompts': { en: 'Exercise Audio Prompts' },
    'button.label.save-workout': { en: 'Save' },
    'workout-music-location-list.switch.audio-prompts': {
      en: 'Exercise Audio Prompts',
    },
    'workout-music-location-list.title': { en: 'WORKOUT MUSIC' },
    'workout-music-location-list.switch.no-audio': { en: 'No Audio' },
    'music-view.header.title': { en: 'Workout Audio' },
    'workout-music-location-list.switch.apple-music': { en: 'Apple Music' },
    'music-view.not-subscribed.text': {
      en: 'You are not an Apple Music subscriber',
    },
    'button.label.pause': { en: 'Pause' },
    'label.next-up': { en: 'Next Up' },
    'segment-type.warm_up': { en: 'Warm Up' },
    'segment.grouping.warm_up': { en: 'Warm Up' },
    'user.workout.segment.update.success': {
      en: 'User workout segment updated successfully!',
    },
    'schedule.workout-time.title': { en: 'Workout Time' },
    'auth.failed': { en: 'Problem with Email or Password' },
    'auth.login.error': { en: 'Error with login' },
    'path.join.success': { en: 'Path joined successfully!' },
    'button.label.joined': { en: 'Joined' },
    'workout.label': { en: 'Workout' },
    'segment.grouping.exercise': { en: 'Exercise' },
    'current-path.prefix': { en: 'on' },
    'profile.screen.progress.completed-exercises': {
      en: 'Exercises Completed',
    },
    'profile.screen.progress.active-time': { en: 'Active Time' },
    'profile.screen.progress.active-time.minutes': { en: 'mins' },
    'profile.screen.progress.workout.full': { en: 'full' },
    'profile.screen.progress.workout.half': { en: 'half' },
    'profile.screen.progress.active-time.hours': { en: 'hrs' },
    'profile.screen.progress.workout-sessions': { en: 'Workout Sessions' },
    'button.label.settings': { en: 'Settings' },
    'profile.screen.progress.suit-streak': { en: 'Suit Streak' },
    'profile.screen.progress.steps': { en: 'Steps This Week' },
    'profile.screen.progress.energy-burned': { en: 'Energy Burned' },
    'calendar.week.label': { en: 'Week' },
    'profile.screen.progress.energy-consumed': { en: 'Energy Consumed' },
    'profile.screen.achievements.label': { en: 'Achievements' },
    'profile.screen.progress.repetitions-completed': { en: 'Reps Completed' },
    'screen.path-explore.title': { en: 'Find Your Path' },
    'screen.path-explore.lifestyle.title': {
      en: 'Paths that suit your lifestyle',
    },
    'screen.path-explore.path-by-workouts.title': { en: 'Workouts per Week' },
    'screen.path-explore.beginner-paths.title': {
      en: 'New to HiNote Life? Start here',
    },
    'screen.path-explore.vip-paths.title': { en: 'Featured Paths' },
    'screen.paths.card.description': { en: '%s | %s Days' },
    'screen.path-explore.description': {
      en: 'Explore the paths below to achieve your fitness goals with other HiNote Life members!',
    },
    'screen.path-explore.half-workout-paths.title': {
      en: 'Short on time? Try these',
    },
    'screen.path-explore.path-by-level.title': { en: 'Fitness Level' },
    'button.show-all.label': { en: 'show all' },
    'screen.paths.paths': { en: '%s Paths' },
    'button.label.actions': { en: 'Actions' },
    'screen.my-path.description': { en: '%s %s Workouts per week | %s' },
    'screen.my-path.progress.week': { en: 'Week' },
    'screen.my-path.completed-workouts.workouts.label': { en: '%s workouts' },
    'screen.my-path.completed-workouts.workouts.sublabel': { en: 'this week' },
    'screen.my-path.completed-workouts.members.label': {
      en: '%s path members',
    },
    'screen.my-path.progress.title': { en: 'My progress' },
    'button.edit-schedule.label': { en: 'Edit Schedule' },
    'screen.my-path.progress.total-time': { en: 'Total Time' },
    'screen.my-path.completed-workouts.members.sublabel': {
      en: 'have completed',
    },
    'button.label.back': { en: 'Back' },
    'form.label.first-name': { en: 'First Name' },
    'auth.screen.subtitle.sign-up': { en: 'Create your profile' },
    'auth.screen.description.sign-up': {
      en: 'This will help you store your workouts, track progress and help your HiNote Life friends find you.',
    },
    'form.placeholder.last-name': { en: 'Last Name' },
    'form.placeholder.first-name': { en: 'First Name' },
    'form.label.last-name': { en: 'Last Name' },
    'newsletter-opt-in.text': {
      en: 'Get workout tips and offers from HiNote Life & partners',
    },
    'button.label.get-started': { en: 'Get Started' },
    'password-requirement.length': { en: '8 characters' },
    'password-requirement.prefix': { en: 'Password must be at least' },
    'list-separator': { en: ',' },
    lower: { en: '1 lower' },
    'password-requirement.suffix': { en: 'and contain:' },
    number: { en: '1 number' },
    'email.email-verification.subject': {
      en: 'HiNote Life - Verify your Account',
    },
    'email.email-verification.greeting': { en: 'Welcome to HiNote Life' },
    'email.email-verification.line1': {
      en: ' Thank you for signing up for HiNote Life. Please verify your email address by entering the code :code in the HiNote Life profile screen, or click the button below.',
    },
    'email.email-verification.action': {
      en: ' Click HERE to verify your account',
    },
    'email.email-verification.line2': { en: 'Thanks,' },
    'email.email-verification.salutation': { en: 'The HiNote Life Team' },
    'register.success': { en: 'Successfully created user!' },
    'screen.title.subscription': { en: 'Subscription' },
    'subscription-screen.button.try-free.label': { en: 'Try HiNote Life for' },
    'screen.workout.paused': { en: 'Workout Paused' },
    'button.resume-workout.label': { en: 'Resume Workout' },
    'workout.type.full': { en: 'Full' },
    'label.dumbbells': { en: 'Dumbbells' },
    'workout-feedback.end-early.heading': { en: 'Ending workout early?' },
    'workout-feedback.end-early.description': {
      en: "Why weren't you able to complete the workout?",
    },
    'userworkout.feedback.store.success': {
      en: 'User workout feedback created successfully!',
    },
    'workout.path.unfinished.time-remaining.label': { en: '%s Mins Left' },
    'screen.my-path.actions': { en: 'My Path Actions' },
    'button.path-workout.restart.label': { en: 'Restart path workout' },
    'button.path-workout.resume.label': { en: 'Resume path workout' },
    'button.cancel.label': { en: 'Cancel' },
    'profile.screen.email.verification.label': {
      en: 'Please verify your email',
    },
    'profile.screen.email.verification.button': { en: 'Verify Your Email' },
    'path.weekly-active-streak.label': { en: 'Week Active Streak' },
    'profile.screen.progress.common-exercise': { en: 'Most Common Exercise' },
    'screen.integrations.section.details.title': { en: 'Integration Details' },
    'integrations.option.apple-music': { en: 'Apple Music' },
    'apple-health.toggle-permissions': { en: 'Apple Health' },
    'screen.path-detail.equipment.label': { en: 'Recommended Equipment' },
    'screen.path-detail.description': {
      en: '%s Workout | %s Workouts per week | %s',
    },
    'screen.path-detail.description.label': { en: 'Description' },
    'screen.paths.members': { en: '%s Members' },
    'alert.label.join-path.reminder': {
      en: 'You can re-join your previous path at any time. Are you ready?',
    },
    'alert.title.join-path.reminder': {
      en: 'You are about to join a new path.',
    },
    'alert.label.yes': { en: 'Yes' },
    'alert.label.no': { en: 'No' },
    'screen.path-detail.member.label': { en: 'You are a member of this path' },
    'screen.music.recommended-playlist.title': { en: 'Recommended Playlists' },
    'music-button.label.apple-music': { en: 'Apple Music' },
    'workout-music-location-list.now-playing': { en: 'Now Playing' },
    'workout.card.resume.label': { en: 'Resume' },
    'screen.my-profile.tab.title': { en: 'My Profile' },
    'auth.screen.loading.title': { en: 'Loading...' },
    'workout.card.actions': { en: 'Workout Actions' },
    'button.custom-workout.resume.label': { en: 'Resume Workout' },
    'button.custom-workout.new.label': { en: 'New Workout' },
    'alert.title.path-workout.remaining': {
      en: 'You have %s path workouts remaining this week.',
    },
    'alert.label.path-workout.remaining': {
      en: 'Are you sure you want to start a new workout before completing your path workouts?',
    },
    'music-button.label.no-audio': { en: 'No Audio' },
    'segment-type.cool_down': { en: 'Cool Down' },
    'segment.grouping.cool_down': { en: 'Cool Down' },
    'button.label.next': { en: 'Next' },
    'button.workout.save': { en: 'Save This Workout' },
    'screen.workout-completion.congratulations': { en: 'Congratulations!' },
    'button.label.share-to-social': { en: 'Share to Social' },
    'screen.workout-completion.feedback': { en: 'How was your workout?' },
    'workout.like.update.success': { en: 'Workout saved successfully!' },
    'button.workout.unsave': { en: 'Workout Saved' },
    'screen.share-workout.header': { en: 'Sharing is caring!' },
    'screen.share-workout.description': {
      en: 'Share your workout with your friends and the HiNote Life community!',
    },
    'button.label.add-photo': { en: 'Add a Photo' },
    'section.save-workout.title': { en: 'Saved Workouts' },
    'workout.segment.label.half-time': { en: 'Rest' },
    'segment-type.rest': { en: 'Rest' },
    'segment.grouping.rest': { en: 'Rest' },
    'notifications.toggle-switch.message': {
      en: "To enable notifications, you'll need to change your phone settings first.",
    },
    'user-profile.option.workout-time': { en: 'Workout Schedule' },
    'user-profile.option.fitness-level': { en: 'Fitness Level' },
    'user-profile.option.workout-reminders': { en: 'Workout Reminders' },
    'button.change-profile-image.label': { en: 'Change Profile Image' },
    'button.label.confirm': { en: 'Confirm' },
    'user-account.option.password': { en: 'Password' },
    'screen.user-account.section.communications.title': {
      en: 'Communications',
    },
    'user-account.option.email_opt_in': { en: 'Emails from HiNote Life' },
    'user-account.option.email-address': { en: 'Email' },
    'screen.user-account.section.account-details.title': {
      en: 'Account Details',
    },
    'button.label.delete-account': { en: 'Delete My Account' },
    'button.label.logout': { en: 'Logout' },
    'user-account.option.remote_notifications': { en: 'Workout Inspirations' },
    'logout.success': { en: 'Successfully logged out user!' },
    'subscription.purchase.error': {
      en: 'Error on subscription purchase! Contact Support for further information.',
    },
    'email.verification.success': { en: 'Email address verified!' },
    'manage-subscription.option.status': { en: 'Subscription Status' },
    'manage-subscription.user-subscribed.inactive': { en: 'Inactive' },
    'manage-subscription.option.plan': { en: 'Plan' },
    'manage-subscription.subscription-type': { en: 'Not Subscribed' },
    'manage-subscription.billing-cycle': { en: 'Not Subscribed' },
    'manage-subscription.button.label.manage-subscription': {
      en: 'Manage Subscription',
    },
    'manage-subscription.button.label.restore-purchase': {
      en: 'Restore Purchase',
    },
    'manage-subscription.button.label.subscribe': { en: 'Subscribe' },
    'manage-subscription.option.billing-cycle': { en: 'Billing Cycle' },
    'manage-subscription.renewal-date': { en: 'Not Subscribed' },
    'manage-subscription.option.next-renewal': { en: 'Next Renewal' },
    'manage-subscription.user-subscribed.active': { en: 'Active' },
    'manage-subscription.billing-cycle.monthly': {
      en: 'Monthly Billing Cycle',
    },
    'manage-subscription.subscribed-entitlement.current-user': {
      en: 'Premium Subscription',
    },
    'manage-subscription.button.label.change-subscribe': {
      en: 'Change Subscription',
    },
    'calendar.button.today': { en: 'Today' },
    'label.achievement-unit.workouts': { en: 'Workouts' },
    'label.achievement-unit.cards': { en: 'Cards' },
    'achievements.section.cards-collected.label': { en: 'Cards Completed' },
    'label.achievement-unit.hours': { en: 'Hours' },
    'achievements.section.number-of-workouts.label': {
      en: 'Number of Workouts',
    },
    'achievements.section.total-workout-time.label': {
      en: 'Total Workout Time',
    },
    'alert.label.workout-reminders': {
      en: 'Would you like to update your reminders to match your new workout schedule?',
    },
    'alert.title.workout-reminders': {
      en: 'Workout reminders are currently set to %s days per week.',
    },
    'screen.update-schedule.description': {
      en: 'Configure the days you want to receive a little encouragement',
    },
    'screen.update-schedule.title': { en: 'Need a dose of inspiration?' },
    'screen.update-schedule.with.label': { en: 'with' },
    'screen.update-schedule.path.workouts-per-week': {
      en: 'workouts per week',
    },
    'screen.update-schedule.path.label': { en: 'You are currently on' },
    'screen.update-schedule.path.sublabel': {
      en: 'HiNote Life members that align their workout reminders with their goal achieve maximum results.',
    },
    'subscription-screen.restore-success.description': { en: 'Welcome back!' },
    'subscription-screen.restore-success.heading': {
      en: 'Your purchase has been restored!',
    },
    'button.label.share-to-path': { en: 'Share to Path Feed' },
    'button.label.delete': { en: 'Delete' },
    'screen.my-path.post.encouragement.label': {
      en: 'Be the first one to give encouragement!',
    },
    'button.label.like': { en: 'Like' },
    'post.like.update.success': { en: 'Post saved successfully!' },
    'screen.my-path.post.encouragement.users.label': {
      en: 'Liked by %s and others',
    },
    'profile-image.loading.text': { en: 'Loading Picture' },
    'screen.paths.category.title-fitness_level': { en: 'Paths by %s' },
    'screen.path-detail.actions': { en: 'Path Actions' },
    'button.paths.leave.label': { en: 'Leave Path' },
    'button.close.label': { en: 'Close' },
    'subscription-terms.text': {
      en: 'All payments made through iTunes or Google Play are controlled and managed by Apple and Google respectively. Payments will be charged to your iTunes or Google Play account at confirmation of purchase. Subscriptions will automatically renew unless canceled within 24-hours before the end of the current period. You can cancel anytime in your iTunes or Google Play account settings. \nAny unused portion of a free trial will be forfeited if you purchase a subscription.',
    },
    'subscription-terms.text.links.prefix': {
      en: 'For more information, see our',
    },
    'button.label.resend-confirmation': { en: 'Resend Confirmation Code' },
    'button.label.submit': { en: 'Submit' },
    'screen.title.verify-email': { en: 'Verify Email' },
    'form.formlabel.confirmation-code': { en: 'Confirmation Code' },
    'form.picker.close-button': { en: 'Done' },
    'screen.workout-completion.new-achievement': { en: 'New Achievement' },
    'path.goal.met.text': {
      en: 'Feel like more? You can always do a Half or Full Workout!',
    },
    'path.goal.met.label': {
      en: 'Congratulations! You met your weekly path goal!',
    },
    'button.feed.delete.label': { en: 'Delete Post' },
    'button.feed.path.label': { en: 'View Path' },
    'button.feed.report.label': { en: 'Report Image' },
    'settings.screen.fitlevel.title': {
      en: 'How would you describe your current fitness level?',
    },
    'settings.screen.fitlevel.description': {
      en: 'This will help us recommend the best workouts for you and to find your path.',
    },
    'subscription-screen.start-trial.button.label': { en: 'Subscribe Now' },
    'profile.screen.apple-health.label': { en: 'Apple Health Integration' },
    'profile.screen.apple-health.enable-button.label': {
      en: 'Allow Apple Health',
    },
    'profile.screen.apple-health.description': {
      en: 'In order to display these stats, HiNote Life needs permission to integrate with Apple Health.',
    },
    'email.verified.resend-confirmation': {
      en: 'Email verification sent out again!',
    },
    'auth.confirmation.success.send': { en: 'Confirmation email sent!' },
    'email.verified.error': { en: 'Email already verified!' },
    'auth.confirmation.error.send': { en: 'Error sending confirmation email' },
    'form.label.retype-password': { en: 'Retype Password' },
    'auth.placeholder.new-password': { en: 'New Password' },
    'form.label.new-password': { en: 'New Password' },
    'auth.placeholder.new-password-retyped': { en: 'Retype Password' },
    'auth.placeholder.old-password': { en: 'Old Password' },
    'screen.title.update-password': { en: 'Update Password' },
    'form.label.current-password': { en: 'Current Password' },
    'email.password.subject': { en: 'HiNote Life - Reset your Password' },
    'email.password.greeting': { en: 'Hello' },
    'email.password.reset.line1': {
      en: 'You are receiving this email because we received a password reset request for your account.',
    },
    'email.password.reset.action': { en: 'Reset Password' },
    'email.password.reset.line2': {
      en: 'If you did not request a password reset, no further action is required.',
    },
    'email.password.salutation': { en: 'Regards' },
    'password.email.success': { en: 'Password reset email successfully sent!' },
    'auth.password.reset.success.send': { en: 'Reset password email sent!' },
    'password.reset.success': { en: 'Successfully reset the password!' },
    'password.change.success': { en: 'Successfully changed password!' },
    'alert.label.ok': { en: 'Ok' },
    'alert.label.delete-account': {
      en: 'Are you sure you want to delete your account?\nThis cannot be undone and your data cannot be restored!',
    },
    'alert.title.delete-account': { en: 'Delete Account?' },
    'alert.label.cancel': { en: 'Cancel' },
    'users.delete.success': { en: 'User successfully deleted!' },
    'user.delete.success': { en: 'Account deleted!' },
    'health-store.denied-health-permission-types.energy-burned': {
      en: 'Energy Burned',
    },
    'apple-health-permission.toggle-button.message-start': {
      en: 'Permissions currently denied for sharing:',
    },
    'apple-health-permission.toggle-button.message-end': {
      en: 'Please go to your iPhone settings to update the settings.',
    },
    'health-store.denied-health-permission-types.energy-consumed': {
      en: 'Energy Consumed',
    },
    'health-store.denied-health-permission-types.workouts': { en: 'Workouts' },
    'register.error': { en: 'Error occurred creating user!' },
    'auth.register.error': { en: 'Error with registration' },
    'subscription.restore.error': {
      en: 'Sorry, but we could not find an active subscription to restore.',
    },
    'notification.workout-day.sunday.1.title': {
      en: '💪 Sunday sweat session',
    },
    'notification.workout-day.sunday.2.message': {
      en: "Let's get those muscles moving with HiNote Life!",
    },
    'notification.workout-day.sunday.1.message': {
      en: "Let's start the day off right with a HiNote Life workout, my friend!",
    },
    'notification.workout-day.sunday.3.title': { en: '💪 Sunday motivation' },
    'notification.workout-day.sunday.3.message': {
      en: 'Keep that workout streak alive with HiNote Life!',
    },
    'notification.workout-day.sunday.4.title': {
      en: '🌟 Sunday workout goals',
    },
    'notification.workout-day.monday.2.message': {
      en: 'Ready to sweat and feel amazing?',
    },
    'notification.workout-day.monday.1.message': {
      en: "It's time to crush your HiNote Life workout and start the week strong!",
    },
    'notification.workout-day.sunday.5.title': {
      en: '🎉 Sunday funday workout',
    },
    'notification.workout-day.sunday.5.message': {
      en: "Let's have some fun and sweat it out with HiNote Life!",
    },
    'notification.workout-day.sunday.4.message': {
      en: "You got this, let's make them happen with HiNote Life!",
    },
    'notification.workout-day.monday.2.title': {
      en: '💪 It’s Monday, Let’s Go!',
    },
    'notification.workout-day.monday.3.title': {
      en: '🏋️‍♂️ Monday morning workout',
    },
    'notification.workout-day.sunday.2.title': {
      en: "🌅 Rise and shine, it's Sunday",
    },
    'notification.workout-day.monday.1.title': {
      en: "💪 Monday, let's get after it!",
    },
    'notification.workout-day.monday.4.message': {
      en: "Let's chase those Monday blues away with a killer HiNote Life workout!",
    },
    'notification.workout-day.monday.4.title': {
      en: '💪 No Monday blues here!',
    },
    'notification.workout-day.monday.3.message': {
      en: 'The only way to start the week right is with a HiNote Life sesh!',
    },
    'notification.workout-day.monday.5.message': {
      en: "Every card, every rep, every sweat drop - let's give it all we've got!",
    },
    'notification.workout-day.monday.5.title': { en: '🌟 Make Monday count!' },
    'notification.workout-day.tuesday.1.message': {
      en: "Let's make the most of this Tuesday with a HiNote Life workout!",
    },
    'notification.workout-day.tuesday.2.title': {
      en: "🌅 It’s workout day so let's go!",
    },
    'notification.workout-day.tuesday.2.message': {
      en: "It's time to do today right with a HiNote Life workout!",
    },
    'notification.workout-day.tuesday.3.message': {
      en: "Another day, another chance to crush it! Let's do this!",
    },
    'notification.workout-day.tuesday.1.title': {
      en: "🏋️‍♀️ Get moving, it's Tuesday!",
    },
    'notification.workout-day.tuesday.3.title': { en: '💪 Tuesday motivation' },
    'notification.workout-day.tuesday.4.title': {
      en: "💪 Let's make Tuesday great!",
    },
    'notification.workout-day.wednesday.1.title': {
      en: '💪 Midweek motivation',
    },
    'notification.workout-day.tuesday.5.message': {
      en: "Let's set the bar high and exceed our goals with HiNote Life!",
    },
    'notification.workout-day.wednesday.1.message': {
      en: 'Keep the momentum going with a HiNote Life workout, we got this!',
    },
    'notification.workout-day.tuesday.5.title': {
      en: '🌟 Reach for the stars on Tuesday!',
    },
    'notification.workout-day.tuesday.4.message': {
      en: 'A HiNote Life workout is just what we need to make this day amazing!',
    },
    'notification.workout-day.wednesday.2.title': { en: '🐫 Hump day workout' },
    'notification.workout-day.wednesday.3.title': {
      en: '🏋️‍♂️ Wednesday workout time',
    },
    'notification.workout-day.wednesday.3.message': {
      en: "It's time to push ourselves to the limit with HiNote Life!",
    },
    'notification.workout-day.wednesday.4.title': {
      en: "💪 Wednesday, let's make it count",
    },
    'notification.workout-day.wednesday.4.message': {
      en: 'A fun HiNote Life workout is just what we need to make this day amazing!',
    },
    'notification.workout-day.wednesday.2.message': {
      en: "Let's power through the week with a HiNote Life sesh!",
    },
    'notification.workout-day.thursday.2.title': {
      en: '🏋️‍♀️ Thursday workout time',
    },
    'notification.workout-day.thursday.3.title': {
      en: "💪 Thursday, let's do this!",
    },
    'notification.workout-day.thursday.1.title': {
      en: '🕺 Thursday throwback workout',
    },
    'notification.workout-day.wednesday.5.message': {
      en: "Let's tackle the week head-on with a HiNote Life workout!",
    },
    'notification.workout-day.wednesday.5.title': {
      en: '🌟 Wednesday goals, here we come!',
    },
    'notification.workout-day.thursday.2.message': {
      en: "It's time to get our sweat on with a HiNote Life sesh!",
    },
    'notification.workout-day.thursday.1.message': {
      en: "Let's get our groove on with a HiNote Life workout!",
    },
    'notification.workout-day.friday.4.message': {
      en: "It's the last day of the week, let's give it our all!",
    },
    'notification.workout-day.thursday.4.title': {
      en: "🌟 Thursday goals, let's make them happen!",
    },
    'notification.workout-day.thursday.3.message': {
      en: 'A fun HiNote Life workout is just what we need to power through the day!',
    },
    'notification.workout-day.friday.5.title': { en: '🎉 TGIF workout' },
    'notification.workout-day.thursday.4.message': {
      en: 'With HiNote Life, we can achieve anything!',
    },
    'notification.workout-day.thursday.5.message': {
      en: "Another chance to crush it! Let's go!",
    },
    'notification.workout-day.friday.2.message': {
      en: 'A fun HiNote Life workout is the perfect way to start the weekend!',
    },
    'notification.workout-day.friday.1.message': {
      en: "Let's end the week strong with a HiNote Life workout!",
    },
    'notification.workout-day.friday.1.title': { en: '🏋️‍♂️ Friday workout time' },
    'notification.workout-day.thursday.5.title': {
      en: '💪 Thursday motivation',
    },
    'notification.workout-day.friday.3.message': {
      en: "With HiNote Life, the sky's the limit!",
    },
    'notification.workout-day.saturday.3.title': {
      en: '💪 Saturday motivation',
    },
    'notification.workout-day.saturday.4.message': {
      en: "You got this, let's make them happen with HiNote Life!",
    },
    'notification.workout-day.saturday.5.title': {
      en: '🎉 Weekend workout vibes',
    },
    'notification.workout-day.saturday.5.message': {
      en: "Let's make the most of the weekend with a HiNote Life sweat sesh!",
    },
    'notification.workout-day.saturday.4.title': {
      en: '🌟 Saturday workout goals',
    },
    'notification.workout-day.saturday.3.message': {
      en: 'Pick your exercises, your chance to show off those gains!',
    },
    'notification.workout-day.friday.2.title': {
      en: "💪 It's Friday, let's make it count!",
    },
    'notification.workout-day.saturday.2.title': {
      en: "🌟 It's Saturday, let's do this!",
    },
    'notification.workout-day.saturday.1.message': {
      en: "Let's get those muscles moving with HiNote Life, my friend!",
    },
    'notification.workout-day.saturday.1.title': {
      en: '💪 Weekend workout time',
    },
    'notification.workout-day.friday.4.title': { en: '💪 Friday motivation' },
    'notification.workout-day.friday.5.message': {
      en: "Let's celebrate the end of the week with a HiNote Life workout!",
    },
    'notification.workout-day.friday.3.title': {
      en: "🌟 Friday goals, let's crush them!",
    },
    'notification.workout-day.saturday.2.message': {
      en: "It's time to crush some workout goals with HiNote Life!",
    },
    'manage-subscription.billing-cycle.annually': {
      en: 'Annual Billing Cycle',
    },
    'subscription-offering.current-plan.label': { en: 'Current Plan' },
    'auth.screen.title.sign-in': { en: 'Log In' },
    'fit-level-selection.intermediate.label-descriptive': {
      en: 'Reasonably Active',
    },
    'fit-level-selection.beginner.sub-label-descriptive': {
      en: "I haven't worked out in a while (or ever)",
    },
    'fit-level-selection.beginner.label-descriptive': { en: 'Getting Started' },
    'fit-level-selection.intermediate.sub-label-descriptive': {
      en: 'Most weeks I work out 1-3 times',
    },
    'fit-level-selection.advanced.label-descriptive': { en: 'Very Active' },
    'fit-level-selection.advanced.sub-label-descriptive': {
      en: 'Most weeks I work out 3+ times',
    },
    'screen.title.user-account': { en: 'Account' },
    'auth.placeholder.password': { en: 'Password (8+ Characters)' },
    'recommended-path-screen.progress-view.subtitle': {
      en: 'Connecting to *Apple Health* allows you to see your Steps and Calories in HiNote Life. This helps motivate you to keep going!',
    },
    'workout-video.label.how-to': { en: 'How To:' },
    'button.explore-paths.label': { en: 'Explore Paths' },
    'screen.update-schedule.no-path.label': {
      en: 'You are not currently on a path',
    },
    'screen.update-schedule.no-path.sublabel': {
      en: 'Looking for extra motivation? Join a path with a target number of workouts per week and smash your fitness goals with others!',
    },
    'manage-subscription.billing-cycle.quarterly': {
      en: 'Quarterly Billing Cycle',
    },
    'email.verified.user.error': { en: 'User not found!' },
    'code.error.invalid-code': { en: 'Invalid code' },
    'auth.confirmation.error.code': { en: 'Error with confirmation code' },
    'screen.workout-info.instructions.suit-description-two': {
      en: 'Full workouts contain 2 exercises from each suit, switching at half-time.',
    },
    'screen.workout-info.instructions.heading': { en: 'Workout Instructions:' },
    'screen.workout-info.instructions.half-workout.card-count': {
      en: 'Half Workouts = 26 cards',
    },
    'screen.workout-info.instructions.suit-description-one': {
      en: 'Each suit represents a different exercise group.',
    },
    'screen.workout-info.instructions.full-workout.card-count': {
      en: 'Full Workouts = 52 cards',
    },
    'screen.workout-info.levels.heading': { en: 'Workout Levels:' },
    'screen.workout-info.instructions.suit-description-three': {
      en: 'Value of Card = Number of Reps to Complete',
    },
    'fit-level-selection.intermediate.long-text': {
      en: 'Intermediate workouts are designed to get you going with more difficult variations. Many of these exercises recommend the use of dumbbells or hand weights.',
    },
    'fit-level-selection.beginner.long-text': {
      en: 'Beginner workouts are the perfect place to start. They require no equipment, you can work out when- and wherever you want, and still get a full body workout. The exercises are scaled down to maximize the fun.',
    },
    'recommended-equipment.label': { en: 'Recommended Equipment' },
    'fit-level-selection.advanced.long-text': {
      en: "Advanced workouts are designed by Carrie's trainer Eve Overland, ideal for those that are already working out regularly or have progressed from intermediate workouts.",
    },
    'scope.error.invalid-scope': {
      en: 'The user has no permission to perform this action',
    },
    'toast.profile-image-picker.camera-error': {
      en: 'There was a problem using the camera! Please check the camera permissions in your phone settings!',
    },
    'screen.title.help-and-support': { en: 'Help & Support' },
    'app.version-number': { en: 'Version %s' },
    'help-and-support.option.help-center': { en: 'Support' },
    'help-and-support.option.about': { en: 'About HiNote Life' },
    'help-and-support.option.feedback': { en: 'Send Feedback' },
    'help-and-support.option.rate': { en: 'Rate HiNote Life' },
    'help-and-support.option.terms': { en: 'Terms of Service' },
    'help-and-support.option.privacy': { en: 'Privacy Policy' },
    'screen.help-support.footer-copyright': {
      en: '© 2026 Fit in 52, LLC. All rights reserved. HiNote Life\r\n and FIT IN 52 are trademarks of Fit in 52, LLC.',
    },
    'form.label.email': { en: 'Email Address' },
    'button.label.verify-email': { en: 'Send Email Verification' },
    'password.change.error': { en: 'Error occurred changing password!' },
    'auth.password.change.error': { en: 'Error changing the password' },
    'users.update.error': { en: 'Error occurred updating user!' },
    'password.email.error': {
      en: 'Error occurred sending password reset email!',
    },
    'auth.password.reset.error.send': {
      en: 'Error sending reset password email',
    },
    'onboarding.screen.recommended-path.path.members': { en: '%s Members' },
    'offer-duration.per-year': { en: 'per year' },
    'offer-duration.per-three-months': { en: 'every three months' },
    'offer-duration.per-month': { en: 'per month' },
    'button.label.delete-photo': { en: 'Delete Photo' },
    'learn-more': { en: 'Learn More' },
    restore: { en: 'Restore' },
    'subscription-offers.line-one': { en: 'Try %s for Free.' },
    'subscription-offers.line-two': { en: 'Then %s %s.' },
    'alert.label.leave-path': {
      en: 'You will leave your current path. Are you sure about the change?',
    },
    'alert.title.leave-path': {
      en: 'Are you sure you want to leave this path?',
    },
    'alert.title.delete-workout': { en: 'Delete Workout' },
    'alert.label.delete-workout': {
      en: 'Are you sure you want to delete this workout?',
    },
    'screen.my-path.post.encouragement.community.label': {
      en: 'Kudos from the *HiNote Life community*',
    },
    'screen.my-path.post.encouragement.current-user.label': {
      en: 'Kudos from *you* and the *HiNote Life community*',
    },
    'email.verified.error.invalid-signature': { en: 'Invalid signature' },
    'music-view.denied-music.text': {
      en: 'You have denied this app access to your music library and the Apple Music catalog.',
    },
    'music.denied-view.go-to-setting.button-label': {
      en: 'Authorize in Settings',
    },
    'onboarding.workout-instruction.feedback': {
      en: 'Have Questions? Feedback? Shake your phone to submit.',
    },
    'action-confirmation': { en: 'Got it!' },
    'email.post-flagged.greeting': { en: 'Hello!' },
    'email.post-flagged.line1': { en: ':user flagged a post.' },
    'email.post-flagged.action': { en: 'Go to the flagged post' },
    'email.post-flagged.salutation': { en: 'Team HiNote Life' },
    'slack-message.post-flagged.author': { en: ':user flagged a post.' },
    'slack-message.post-flagged.title': { en: 'Flagged post' },
    'post.flag.store.success': { en: 'Successfully reported image!' },
    'auth.error': { en: 'Error occurred logging user!' },
    'path.leave.success': { en: 'Path left successfully!' },
    'screen.paths.category.title-workouts_per_week': { en: 'Paths by %s' },
    'promo-codes.error.invalid': { en: 'Promo code invalid!' },
    'promo-codes.error.reusable': {
      en: 'You have already used this promo code. Contact Support for further information.',
    },
    'email.promo-code.error.subject': { en: 'HiNote Life - Promo Code Error' },
    'email.promo-code.error.greeting': { en: 'Hello' },
    'email.promo-code.error.instructions': {
      en: 'There was an error creating a promo code for a user',
    },
    'email.promo-code.error.user': { en: 'User email: :email' },
    'email.promo-code.error.code': { en: 'Promo Code: :code' },
    'email.promo-code.error.message': { en: 'Reason of the error: ' },
    'email.promo-code.error.salutation': { en: 'HiNote Life Team' },
    'email.promo-code.subject': {
      en: 'HiNote Life - Access your complimentary subscription!',
    },
    'email.promo-code.greeting': { en: 'Thanks for being a HiNote Life VIP!' },
    'email.promo-code.instructions': {
      en: 'Please <a href="https://fit52.page.link/manpromo" target="_blank">download the app here</a>, and login using your unique credentials shown below.',
    },
    'email.promo-code.account': {
      en: '<strong>Your HiNote Life login details to claim complimentary subscription:</strong>',
    },
    'email.promo-code.email': { en: 'Email: :email' },
    'email.promo-code.password': { en: 'Password: :password' },
    'email.promo-code.thanks': {
      en: 'Enjoy and thanks for joining HiNote Life!',
    },
    'email.promo-code.salutation': { en: 'The HiNote Life Team' },
    'email.promo-code.existing.user': {
      en: 'You can login with your chosen password.',
    },
    'promo-codes.error.required-fields': {
      en: 'Email, first name and last name are required to grant a Promo code!',
    },
    'email.promo-code.account-existing-user': {
      en: '<strong>Your HiNote Life login details to claim your complimentary subscription:</strong>',
    },
    'email.promo-code.password.existing-user': {
      en: 'You can login with your chosen password.',
    },
    'email.promo-code.account-new-user': {
      en: '<strong>Your HiNote Life login details to claim your complimentary subscription:</strong>',
    },
    'email.promo-code.password.new-user': { en: 'Password: :password' },
    'toast.share-to-social.error': { en: 'Error occurred while sharing!' },
    'toast.sharing.error': { en: 'Error occurred while sharing!' },
    'manage-subscription.billing-cycle.promotion': { en: 'Promotion' },
    'users.device-token.success': {
      en: 'User device token updated successfully!',
    },
    'alert.label.delete-post': { en: 'Are you sure you want to continue?' },
    'alert.title.delete-post': { en: 'You are about to delete your post.' },
    'posts.delete.success': { en: 'Post successfully deleted!' },
    'toast.update-name.error': { en: 'Error updating name.' },
    'toast.update-email.error': { en: 'Error updating email.' },
    'form.label.password-confirmation': { en: 'Password Confirmation' },
    'form.placeholder.password-confirmation': { en: 'Password Confirmation' },
    'form.placeholder.new-password': { en: 'New Password' },
    'next-workout.label': { en: '*Next* Workout' },
    'workouts-in-path-number.label': { en: 'Workout %s of %s' },
    'number-of-exercises': { en: '%s Exercises' },
    'button.load-more.label': { en: 'Load More' },
    'number-of-exercises-complete': { en: '%s/%s Exercises' },
    'subscription-offers.single-line': { en: '%s %s.' },
    'music-button.label.exercise-prompts': { en: 'Audio Prompts' },
    'alert.workout.end-early.title': {
      en: 'Are you sure you want to stop your workout?',
    },
    'alert.workout.end-early.label': {
      en: "You'll be able to pick up where you left off, when you're ready!",
    },
    'resume-path-workout.label': { en: '*Resume* Workout' },
    'workout-music-location-list.switch.your-library': { en: 'Your Library' },
    'apple-music.availability.unauthoricated-message': {
      en: "Apple music playback isn't available! Authorize playback in your settings.",
    },
    'music.library.search': { en: 'Search Your Library' },
    'music-view.denied-media-library.text': {
      en: 'You have denied this app access to your music library.',
    },
    'audio.search.description': {
      en: 'Search for albums and artists from your music library for playback during your workout',
    },
    'button.label.search': { en: 'Search' },
    'alert.workout.restart.title': {
      en: 'Are you sure you want to restart your workout?',
    },
    'music.library.playlist.carries-suggestions': {
      en: "Carrie's Suggestions",
    },
    'workout-music-location-list.recently-played.title': {
      en: 'RECENTLY PLAYED',
    },
    'workout-music-location-list.now_playing': { en: 'NOW PLAYING' },
    'music-category.4.title': { en: "CARRIE'S PLAYLIST" },
    'button.clear-input.title': { en: 'Clear Input' },
    'music-category.3.title': { en: 'ARTIST' },
    'music-category.1.title': { en: 'ALBUM' },
    'workout.audio.search.result.title': { en: 'Results for "%s"' },
    'workout.audio.search.no-result.title': { en: 'No results for "%s"' },
    'music.denied-view.connect-apple-music.button-label': {
      en: 'Connect Apple Music',
    },
    'music-view.denied-apple-music.text': {
      en: "You don't have access to the Apple Music catalog. Connect to Apple Music for access to Carrie's Playlists!",
    },
    'email.verified.error.already-verified': { en: 'Email already verified!' },
    'password.reset.error': { en: 'Error occurred reseting password!' },
    'auth.password.reset.error.reset': { en: 'Error resetting the password' },
    'auth.confirmation.error.link': { en: 'Error with confirmation link' },
    'userworkout.feedback.store.error.type': {
      en: 'You already gave feedback on this workout!',
    },
    'userworkout.feedback.store.error': {
      en: 'Error occurred creating feedback for user workout!',
    },
    'email.subscription-cancel-survey.subject': {
      en: 'HiNote Life - Subscription cancellation survey',
    },
    'email.subscription-cancel-survey.greeting': {
      en: 'We are sad to see you leave HiNote Life',
    },
    'email.subscription-cancel-survey.instructions': {
      en: 'Please follow this personalized link for user name :firstName to fill a little survery for user id :userId',
    },
    'email.subscription-cancel-survey.thanks': {
      en: 'Thank you for being a member of the HiNote Life community and for trying Carrie Underwood’s fitness app.',
    },
    'email.subscription-cancel-survey.salutation': {
      en: 'The HiNote Life team',
    },
    'screen.workout-health.title': { en: 'Apple Health Integration' },
    'screen.workout-share.title': { en: 'Share Screen' },
    'screen.title.update-about': { en: 'Update Bio' },
    'screen.title.user-details': { en: 'User Details' },
    'screen.my-path.tab.all-paths': { en: 'All Paths' },
    'screen.my-path.tab.my-path': { en: 'My Path' },
    'button.label.sign-up': { en: 'Sign Up' },
    'form.placeholder.name': { en: 'Name' },
    'form.label.name': { en: 'Name' },
    'screen.my-path.no-posts.text': {
      en: 'Be the first to post by completing a path workout!',
    },
    'screen.my-path.no-posts.heading': {
      en: "This path doesn't have any posts",
    },
    'user-profile.option.about': { en: 'Bio' },
    'user-profile.option.view-profile': { en: 'View Public Profile' },
    'screen.user-detail.no-posts.title': { en: 'Nothing to see here!' },
    'screen.user-detail.no-about.message.current-user': {
      en: 'Tap to add your bio!',
    },
    'screen.user-detail.tab.feed': { en: 'Feed' },
    'screen.user-detail.no-posts.message.current-user': {
      en: "You don't appear to have any posts yet.",
    },
    'settings.screen.about.description': {
      en: 'What would you like others to know about your journey?',
    },
    'form.label.about.requirements': {
      en: 'Your bio may be up to 150 characters long',
    },
    'form.placeholder.about': { en: 'Share something about you' },
    'settings.screen.about.title': { en: 'Tell us about yourself!' },
    'form.label.about': { en: 'Bio' },
    'screen.user-detail.no-posts.message.other-user': {
      en: "This user doesn't appear to have any posts yet.",
    },
    'music-button.label.no-music': { en: 'No Music' },
    'music-button.label.exercise-prompts.disabled': { en: 'No Audio Prompts' },
    'screen.workout.pause-menu.button.end': { en: 'Stop Workout' },
    'screen.workout.pause-menu.button.restart': { en: 'Restart Workout' },
    'button.join-path': { en: 'Join Path' },
    'onboarding.screen.recommended-path.current-path.label': {
      en: 'Your Current Path',
    },
    'screen.my-path.no-path.text': { en: 'Join a path to get started!' },
    'screen.my-path.no-path.heading': { en: "You aren't part of a path yet" },
    'workout-music-location-list.switch.no-music': { en: 'No Music' },
    'workout-music-location-list.section.title': { en: 'Music' },
    'skip-limit.button.resume': { en: 'Keep Going!' },
    'skip-limit.heading': { en: 'Yeah, that was\na hard one!' },
    'skip-limit.message': {
      en: "You've reached your maximum number of skips you can take for this workout. You are doing great. Just find your pace and do your best!",
    },
    'skip-limit.button.end': { en: 'Stop Workout' },
    'screen.user-detail.actions': { en: 'User Actions' },
    'button.label.report-user': { en: 'Report User Content' },
    'alert.label.report-user': { en: 'Are you sure you want to continue?' },
    'alert.title.report-user': { en: 'You are about to report this user.' },
    'flag.store.success': {
      en: 'Thanks for letting us know, we will look into this!',
    },
    'button.feed.profile.label': { en: 'View Profile' },
    'alert.title.report-post': { en: 'You are about to report this post.' },
    'alert.label.report-post': { en: 'Are you sure you want to continue?' },
    'button.label.back-to-login': { en: 'Log In' },
    'workout-music-location-list.spotify': { en: 'Spotify' },
    'workout-music-location-list.carries-spotify': { en: "Carrie's Playlists" },
    'apple.login.error': {
      en: 'Sorry, there was an error logging in with Apple',
    },
    'button.join-recommended-path': { en: 'Join Recommended Path' },
    'screen.path-detail.new-path-label': { en: 'New Path!' },
    'auth.placeholder.current-password': { en: 'Current Password' },
    'input-validation.max-length': {
      en: 'may be up to %s characters long. *(%s/%s)*',
    },
    'input-validation.about.prefix': { en: 'Your bio' },
    'email.subscription-cancel-survey.cta': {
      en: 'This simple <a href="https://hellocaravan.typeform.com/to/eM0Ubf?uid=:userId" target="_blank">survey</a> will take <strong>less than 3 minutes</strong> and we appreciate your feedback.',
    },
    'email.subscription-cancel-survey.subject-line': {
      en: 'Help us improve HiNote Life!',
    },
    'equipment.dumbbells': { en: 'Dumbbells' },
    'equipment.bench': { en: 'Bench' },
    'subscription-screen.cancel.description.android': {
      en: 'Cancel anytime in the Play Store.',
    },
    'subscription-terms.text.android': {
      en: 'All payments made through Google Play are controlled and managed by Google. Payments will be charged to your payment method configured in your Google Play account on confirmation of purchase. Subscriptions will automatically renew unless canceled within 24-hours before the end of the current period. You can cancel anytime in your Google Play account settings. Any unused portion of a free trial will be forfeited if you purchase a subscription.',
    },
    'post-frame.title.original': { en: 'Original' },
    'post-frame.title.summary_note': { en: 'Summary Note' },
    'post-frame.title.i_did_it': { en: 'I Did It' },
    'post-frame.title.respect': { en: 'Respect' },
    'post-frame.title.plain_note': { en: 'Plain Note' },
    'post-frame.title.nailed_it': { en: 'Nailed It' },
    'screen.title.user-feed': { en: 'User Feed' },
    'screen.workout-swap.title': { en: 'Workout Swap' },
    'image-upload.title': { en: 'Select Image' },
    'social-post.workout-count': { en: 'Workout %s of %s' },
    'button.label.done': { en: 'Done' },
    'social-post.total-exercises': { en: '*%s* Exercises' },
    'button.label.cancel': { en: 'Cancel' },
    'screen.personalize-post.header': { en: 'Select a Frame' },
    'button.label.change-image': { en: 'Change Image' },
    'screen.personalize-post.description': { en: 'Customize your post!' },
    'textinput.placeholder.add-note': { en: 'Add a Note' },
    'social-post.workout-count-bold': { en: 'Workout *%s* of *%s*' },
    'button.label.edit': { en: 'Edit' },
    'equipment.recommended': { en: 'Equipment' },
    'button.personalize-workout.label': { en: 'Personalize Workout' },
    'workout.personalize.button.reset.label': { en: 'Reset' },
    'workout.personalize.button.done.label': { en: 'Done' },
    'workout.personalize.summary.label': { en: 'Workout Exercises' },
    'workout.personalize.header.title': { en: 'Personalize' },
    'workout.personalize.button.reveal.label': { en: 'Reveal Workout' },
    'workout.swap-button.label': { en: 'Swap (%s of %s)' },
    'workout.personalize.instruction.swap': {
      en: 'Tap any exercise card to *swap*',
    },
    'workout.personalize.instruction.max-reached': {
      en: 'You have reached your\nmaximum number of swaps',
    },
    'workout.personalized.title-suffix': { en: 'Personalized' },
    'workout.personalize.reset-alert.subtitle': {
      en: 'Would you like to reset your swaps?',
    },
    'workout.personalize.reset-alert.title': { en: 'Reset Swaps' },
    'workout.intro-screen.subtitle': { en: 'Starting in' },
    'workout.intro-screen.title': { en: 'Workout' },
    'workout-music-location-list.xo-radio': { en: 'XO Radio' },
    'music-button.label.xo-radio': { en: 'XO Radio' },
    'audio.search.apple-music.description': {
      en: 'Search for albums and artists from Apple Music for playback during your workout',
    },
    'music-tab.label.search-apple-music': { en: 'Search' },
    'music-tab.label.carrie-suggestion': { en: 'Featured' },
    playlist: { en: 'Playlist' },
    'music-category.2.title': { en: 'PLAYLIST' },
    'social-post.workout-count-bold-short': { en: '*%s* of *%s*' },
    'equipment.step': { en: 'Step' },
    'apple-music-media-selector.no-text': { en: 'A search term is required.' },
    'auth.facebook.failed': { en: 'Problem signing in with Facebook' },
    'facebook.login.error': {
      en: 'Sorry, there was an error logging in with Facebook',
    },
    'notification-email.error.promo-code': {
      en: 'Trying to assing non existing promo code: :promoCode',
    },
    'slack-message.email-notification.title': {
      en: 'Sending :notification failed',
    },
    'email.subscription-promo.subject-line': {
      en: 'A month of HiNote Life for free!',
    },
    'email.subscription-promo.header': {
      en: 'A month of HiNote Life for free! ',
    },
    'email.subscription-promo.greeting': { en: 'Hi :firstName' },
    'email.subscription-promo.intro': {
      en: 'During these challenging times, it’s important to make time for yourself and stay active. The HiNote Life community is here to support you.',
    },
    'email.subscription-promo.noticed': {
      en: 'We noticed you downloaded the HiNote Life app but haven’t had a chance to complete a workout. We understand that it can be difficult to get started, so we’re inviting you to join the HiNote Life community by giving you <b>FREE access for ONE MONTH</b> from today until :promoValidUntil. No purchase or ongoing commitment is required.',
    },
    'email.subscription-promo.join': {
      en: 'Join Carrie Underwood, her longtime personal trainer Eve Overland, and thousands of others who are motivating each other to stay active!',
    },
    'email.subscription-promo.action': { en: 'Get Started' },
    'email.subscription-promo.app-store': {
      en: 'https://fit52.page.link/nevsub',
    },
    'email.subscription-promo.best': { en: 'All the best,' },
    'email.subscription-promo.salutation': { en: 'The HiNote Life team' },
    'toast.image-picker.error': {
      en: 'There was a problem selecting an image.',
    },
    'toast.workout-image-picker.android-permission-error': {
      en: 'HiNote Life needs access to the camera and phone storage',
    },
    'toast.workout-image-picker.android-permission-needed': {
      en: "HiNote Life needs permissions ('Camera' and 'Storage') for this to work. You can grant them in Settings, under the Permissions section.",
    },
    'toast.workout-image-picker.ios-permission-needed': {
      en: "HiNote Life needs permissions ('Camera') for this to work. You can grant them in Settings, under the Permissions section.",
    },
    'input-validation.name.prefix': { en: 'Your name' },
    'input-validation.between-length': {
      en: 'must be between %s and %s characters long *(%s)*',
    },
    'button.label.discard-post': { en: 'Discard Post' },
    'screen.workout-share.actions': { en: 'Discard Changes' },
    'screen.title.workout-settings': { en: 'Workout Settings' },
    'workout.exclude-button.label': { en: 'Always Remove' },
    'swap-screen.info-modal.button.label': { en: 'Got It!' },
    'swap-screen.info-modal.text': {
      en: "The selected exercise won't be shown in future workouts. \nYou can revert these changes in *Settings → Excluded Exercises*.",
    },
    'swap-screen.info-modal.title': { en: 'Remove from\nfuture workouts?' },
    'screen.title.excluded-exercises': { en: 'Excluded Exercises' },
    'description.excluded-exercises.empty': {
      en: "You don't have any excluded exercises",
    },
    'description.excluded-exercises': {
      en: 'These are exercises you have chosen to exclude from your workouts. None of these exercises will be shown in your workouts.',
    },
    'button.label.remove-excluded-exercises': { en: 'Remove' },
    'excluded-exercises.text.remove': {
      en: 'Tap the cards you want to remove from your exclusion list.',
    },
    'subscription.access.title': { en: 'Get Unlimited Access' },
    'subscription.access.items-list': {
      en: "1000's of workouts you can do anywhere\nTrack your progress to build healthy habits\nTry free for 14 days, cancel anytime",
    },
    'subscriptions.label.other-plans': { en: 'View Other Plans' },
    'subscription.yearly.intro-trial-details': {
      en: '%s FREE then %s per year',
    },
    'purchase-intro.subscribe-button.label': { en: 'Continue' },
    'workout-player.label.change-sides': { en: 'Change Sides!' },
    'exclusion.segments.store.success': {
      en: 'Exercise exclusions created successfully!',
    },
    'swap-screen.instruction.swap': {
      en: '*Swap* or *Always Remove* (%s of %s)',
    },
    'swap-screen.button.label.swap': { en: 'Swap' },
    'swap-screen.button.label.exclude': { en: 'Always Remove' },
    'toast.workout-swaps.max-reached': {
      en: 'Maximum total swaps reached for this focus area! Go to settings to change your exclusions...',
    },
    'workout-builder.user-workout.error': {
      en: 'User, workout and day of the week are required to create a user workout',
    },
    'user-workout.store.error': { en: 'Error occurred creating workout!' },
    'workout-swap.error.save-personalization': {
      en: 'Unable to apply exercise swaps!',
    },
    'userworkout.exclusions.error': {
      en: 'There are not enough segments to create a user workout on app version :version, workout :workout  and exclusions :exclusions',
    },
    'workout-builder.segment.error': {
      en: 'There are not enough segments to create a workout on app version :version, fitness level :level, template type :type, equipment :equipment and exclusions :exclusions',
    },
    'workout-music-location-list.xo-radio_with_carrie': {
      en: 'XO Radio with Carrie Underwood',
    },
    'subscription.yearly.regular-details': { en: '%s per year' },
    'alert.title.path-workout.remaining-workout': {
      en: 'You have %s path %s remaining this week.',
    },
    'alert.label.path-workout.remaining-next-path-workout': {
      en: 'Are you sure you want to start a new workout before completing your next path %s?',
    },
    'screen.paths.card.description-level-times-per-week': { en: '%s | %s %s' },
    'screen.path-detail.description-format-workout-per-week': {
      en: '%s Workout | %s %s per week | %s',
    },
    'screen.my-path.description.text': { en: '%s %s %s per week | %s' },
    'excluded-exercises.button.remove-excluded-exercises': { en: 'Remove%s' },
    'image-upload.permissions.title': { en: 'Need permissions' },
    'image-upload.permissions.title.retry': { en: 'GO TO SETTINGS' },
    'image-upload.permissions.title.ok': { en: 'CANCEL' },
    'subscriptions.label.not-found-error-description-android': {
      en: 'Could not find subscriptions from Play Store. Please make sure you are logged into Play Store and have the latest version of HiNote Life.',
    },
    'subscriptions.label.not-found-error': {
      en: 'Something went wrong while loading subscriptions',
    },
    'post-frame.title.my_gift_silver': { en: 'My Gift\nSilver' },
    'screen.path-post-detail.title': { en: 'Post' },
    'post-frame.title.my_gift_red': { en: 'My Gift\nRed' },
    'screen.my-path.empty-state.heading': { en: 'No posts to display!' },
    'screen.my-path.empty-state.text': {
      en: 'Try refreshing the path feed to see the latest posts',
    },
    'path-post.kudos.empty': { en: 'Be the first to give kudos!' },
    'button.label.give-kudos': { en: 'Give Kudos' },
    'path-post.kudos.and': { en: 'and' },
    'button.label.comment': { en: 'Comment' },
    'path-post.kudos.prefix': { en: 'Kudos from' },
    'post-detail.screen.title': { en: 'Comments' },
    'post-comment.comment-input.placeholder': { en: 'Leave a comment...' },
    'button.label.gave-kudos': { en: 'Gave Kudos' },
    'path-post.kudos.you': { en: 'you' },
    'screen.workout-info.instructions.value-of-card': {
      en: 'Value of Card = Number of Reps',
    },
    'screen.workout-info.instructions.title': { en: 'The HiNote Life Workout' },
    'onboarding.screen.autojoined-path.title': { en: 'We Found Your Path!' },
    'onboarding.screen.autojoined-path.description': {
      en: 'Start your HiNote Life journey with this personalized path, a fun workout with others like you!',
    },
    'onboarding-screen.autojoined-path.detail': {
      en: 'Up to %s %s per week \n%s',
    },
    'button.start-path-workout': { en: 'Start My First Workout' },
    'comments.view-all.label': { en: 'View All Comments' },
    'alert.debug-screen.no-workouts.title': {
      en: 'No workouts found on your user',
    },
    'alert.debug-screenno-workouts.label': {
      en: 'You need to start a workout to debug this screen',
    },
    'post-comment.actions': { en: 'Comment Actions' },
    'button.post.comment.report.label': { en: 'Report Comment' },
    'button.post.comment.update.label': { en: 'Edit' },
    'button.post.comment.delete.label': { en: 'Delete' },
    'post-comment.delete-alert.body': {
      en: 'Are you sure you want to delete your comment?',
    },
    'post-comment.delete-alert.title': { en: 'Delete Comment' },
    'comments.delete.success': { en: 'Comment successfully deleted!' },
    'path-post.kudos.separator': { en: ',' },
    'path-post.kudos.suffix': { en: 'and* others*' },
    'comments.update.success': { en: 'Comment updated successfully!' },
    'path-post.kudos.prefix.from-others': { en: 'Kudos from' },
    'path-post.kudos.prefix.liked': { en: 'Kudos from *you*' },
    'comment.body.see-more': { en: 'See More' },
    'comment.body.see-less': { en: 'See Less' },
    'app.build-number': { en: 'Build %s' },
    'post-frame.title.commit_to_fit': { en: 'Commit\nTo Fit' },
    'screen.path-post-like.title': { en: 'Post Like' },
    'path-post.kudos.suffix.others': { en: '*others*' },
    'path-post.kudos.suffix.separator': { en: 'and' },
    'subscription.access.offer.items-list': {
      en: "1000's of workouts you can do anywhere\nTrack your progress to build healthy habits\nTry free for %s, cancel anytime",
    },
    'path-post.kudos.prefix.you-link': { en: '*you*' },
    'path-post.kudos.prefix.liked-text': { en: 'Kudos from' },
    'post-like.screen.title': { en: 'Kudos' },
    'tooltip.personalize-workout.label': {
      en: 'Tap to personalize your workout and audio settings!',
    },
    'exercise-player.segment.rest.title': { en: 'Hydration Break' },
    'users.promo-code.success': { en: 'Promo code successfully assigned!' },
    'onboarding.screen.subscription.offering.referral-text': {
      en: '%s has invited you to try HiNote Life for *free for %s!*',
    },
    'users.promo-code.redeem.success': {
      en: 'Promo code successfully redeemed!',
    },
    'promo-codes.error.redeem.promo': {
      en: "You can't use this promo code! Contact Support for further information.",
    },
    'users.promo-code.redeem.error': {
      en: 'Error occurred redeeming promo code!',
    },
    'subscription.cost-per-duration.intro-trial-details': {
      en: '%s FREE\nthen %s %s',
    },
    'subscription.access.offer-no-trial.items-list': {
      en: "1000's of workouts you can do anywhere\nTrack your progress to build healthy habits\nCancel anytime",
    },
    'post-comment.report-alert.body': {
      en: 'Are you sure you want to report this comment?',
    },
    'post-comment.report-alert.title': { en: 'Report Comment' },
    'promo-codes.error.redeem.expired': {
      en: 'Promo code is expired. Contact Support for further information.',
    },
    'promo-codes.error.max-redemptions': {
      en: 'Maximum redemption count reached! Contact Support for further information.',
    },
    'promo-codes.error.unique': {
      en: "You can't redeem this promo anymore. Contact Support for further information.",
    },
    'promo-codes.error.redeemed': {
      en: "You can't redeem another promo code. Contact Support for further information.",
    },
    'promo-codes.error.offering': {
      en: "You can't get this trial because you already had it once. Contact Support for further information.",
    },
    'promo-codes.error.android.purchase-exists': {
      en: "You can't get this trial as you already had one before. Contact Support for further information.",
    },
    'promo-codes.error.expired': {
      en: 'Promo code expired. Contact Support for further information.',
    },
    'promo-codes.error.referral-user.missing': {
      en: 'Referral user needed for this Promo code',
    },
    'users.promo-code.error': { en: 'Error occurred assigning promo code!' },
    'onboarding.screen.subscription.offering.referral-text.no-trial': {
      en: '%s has invited you to try HiNote Life',
    },
    'button.label.discard-changes': { en: 'Discard Changes' },
    'screen.title.equipment-settings': { en: 'Equipment Settings' },
    'equipment-setting.description.text': {
      en: 'Select the equipment you have access to – only exercises with these items will appear in your workouts.',
    },
    'equipment-setting.description.header': { en: 'My Equipment' },
    'equipment-settings.button.confirm': { en: 'Confirm' },
    'equipment_user.store.success': {
      en: 'User equipment added successfully!',
    },
    'referral.banner.message.subject': {
      en: 'Join me for HiNote Life workout!',
    },
    'referral.banner.message.text': {
      en: 'I have an exclusive invite for you to try the fun HiNote Life workouts with me FREE for 30 days! Join me and thousands of others to find your path to fitness! \r\n\r\nLet’s work out together with Carrie Underwood’s fitness app. Every workout is different and so much fun! Tap to join me:',
    },
    'button.label.share-summary': { en: 'Share\nSummary' },
    'exclusion.store.error.invalid-exclusion': {
      en: ':exclusion can not be excluded!',
    },
    'exclusion.segments.store.error': {
      en: 'Sorry, you already have too many excluded exercises. Please view Settings -> Workout Settings -> Excluded Exercises to remove some exclusions or contact Support.',
    },
    'equipment_user.store.error': {
      en: 'Error occurred adding equipment for user!',
    },
    'equipment.not-enough-exercises-modal.subheading': {
      en: 'Please adjust your\n equipment or exercises',
    },
    'equipment.not-enough-exercises-modal.title': {
      en: "You don't have\n enough exercises!",
    },
    'equipment.not-enough-exercises-modal.text': {
      en: "With this equipment selection and the exercises you have already excluded, you don't have enough exercises left to generate a workout. You can either reset your excluded exercises or edit your equipment selection.",
    },
    'equipment.not-enough-exercises-modal.secondary-button-label': {
      en: 'Edit My Equipment Selection',
    },
    'equipment.not-enough-exercises-modal.primary-button-label.reset': {
      en: 'Reset My Excluded Exercises',
    },
    'onboarding.screen.subscription.start-today.description': {
      en: 'Join the 550,000+ members\r\nin the HiNote Life community.',
    },
    'onboarding.screen.subscription.start-today.title': {
      en: 'See Results Faster!',
    },
    'banner.discount.label': { en: '%s% off' },
    'subscription-offering.offering-length': { en: '%s' },
    'pre-workout.description.header.equipment-settings': {
      en: 'What equipment do you \n have access to?',
    },
    'pre-workout.description.text': {
      en: 'Your workouts are personalized based off the equipment you have. You can always update this in *Settings → Equipment Settings*',
    },
    'pre-workout.submit-button.label': { en: 'Done' },
    'equipment.info-modal.body': {
      en: 'For Intermediate and Advanced workouts, dumbbells are recommended for increased resistance. You can always substitute with alternative objects such as water bottles!',
    },
    'equipment.info-modal.title': { en: 'HiNote Life is for everyone!' },
    'equipment.info-modal.button.label': { en: 'Got It!' },
    'post-list.actions': { en: 'Post Actions' },
    'screen.workout-share.actions-menu.edit': { en: 'Edit Post' },
    'button.label.edit-post': { en: 'Edit Post' },
    'screen.workout-share.discard-alert.body': {
      en: 'Are you sure you want to discard your post?',
    },
    'screen.workout-share.discard-alert.title': { en: 'Discard Post' },
    'alert.title.reset-all-excluded-excercises': {
      en: 'Reset My Excluded Exercises',
    },
    'alert.label.clear-all-excluded-exercises': {
      en: 'Are you sure you want clear all your excluded exercises?',
    },
    'toast.remove-all-exercises-exclusions-and-add-equipment.success': {
      en: 'Added selected equipment and cleared all exercise exclusions!',
    },
    'subscription.access.offer.items-list-bold': {
      en: "*1000's of workouts* you can do anywhere - PLUS a friend can join for free.\r\n*Track your progress* to build healthy habits\r\n*Try free for %s*, cancel anytime",
    },
    'subscription.access.offer-no-trial.items-list-bold': {
      en: "*1000's of workouts* you can do anywhere - PLUS a friend can join for free.\r\n*Track your progress* to build healthy habits\r\n*Cancel anytime*",
    },
    'auth.apple.account.duplicated': {
      en: 'We found a duplicated account with that email, please contact support',
    },
    'apple.login.account.error': {
      en: 'You need to revoke permissions on your settings before trying to log in with Apple again on this app. Settings > Apple ID, iCloud, iTunes & App Store > Password & Security > Apps Using Your Apple ID > HiNote Life > Stop Using Apple ID',
    },
    'button.label.toggle-summary-card-view': { en: 'Toggle Summary Card View' },
    'screen.workout-share.actions-menu.discard': { en: 'Discard Changes' },
    'screen.workout-completion.new-achievements': { en: 'New Achievements' },
    'exclusion.store.error.already-excluded': {
      en: ':exclusion is already excluded!',
    },
    'toast.app-equipment-version-behind.warning': {
      en: 'Your app version is behind. Please update your app to get access to the latest equipment.',
    },
    'email.subscription-cancel-survey.header': { en: 'Sorry to see you go!' },
    'email.subscription-cancel-survey.intro': { en: 'Hi :firstName' },
    'email.subscription-cancel-survey.hope': {
      en: 'We had hoped you’d stay around for a while longer and would love to know why you decided to cancel, so we can improve HiNote Life and continue to help more people find their path to fitness.',
    },
    'email.subscription-cancel-survey.action': { en: ' Take Survey' },
    'email.subscription-cancel-survey.url': {
      en: 'https://hellocaravan.typeform.com/to/eM0Ubf?uid=:userId',
    },
    'email.subscription-cancel-survey.best': { en: 'All the best,' },
    'admin.server.error': { en: 'Sorry, something went wrong.' },
    'code.error.expired-code': { en: 'Expired code' },
    'slack-message.leanplum.title': { en: 'Leanplum call failed!' },
    'auth.apple.account.failed': {
      en: 'You need to revoke permissions on your settings before trying to log in with Apple again on this app. Settings > Apple ID, iCloud, iTunes & App Store > Password & Security > Apps Using Your Apple ID > HiNote Life > Stop Using Apple ID',
    },
    'email.verified.resend.throttled': {
      en: 'You have requested verification email recently, please check your email.',
    },
    'email.flagged.greeting': { en: 'Hello!' },
    'email.flagged.line1': { en: ':user flagged a :modelName.' },
    'email.flagged.action': { en: 'Go to the flagged :modelName' },
    'email.flagged.salutation': { en: 'Team HiNote Life' },
    'slack-message.flagged.author': { en: ':user flagged a :modelName.' },
    'slack-message.flagged.title': { en: 'Flagged :modelName' },
    'promo-codes.error.referral': { en: "You can't refer yourself, sorry!" },
    'like.update.success': { en: 'Like saved successfully!' },
    'user.exclusions.exercise.store.error': {
      en: 'Error occurred excluding exercise for user!',
    },
    'users.property.success': { en: 'User property updated successfully!' },
    'screen.workout.workouts-section.title': { en: 'Mix it up?' },
    'screen.workout.join-your-path': {
      en: 'Find your Path and get support from HiNote Life community!',
    },
    'screen.workout.welcome': { en: "%s's Path" },
    'workout.type.full.end': { en: 'Workout' },
    'workout.type.half.end': { en: 'Workout' },
    'workout.type.test': { en: 'Test' },
    'workout.type.test.end': { en: 'Workout' },
    'workout.type.mini': { en: 'Mini' },
    'workout.type.card_draw_13': { en: '13 Card' },
    'workout.type.mini.end': { en: 'Workout' },
    'workout.type.card_draw_13.end': { en: 'Draw' },
    'tooltip.refer-friend.label': {
      en: 'Tap to invite your friends to try HiNote Life free for 30 days!',
    },
    'workout.title.user': { en: "%s's" },
    'button.personalized-workout.label': { en: 'Preview & Personalize' },
    'workout-music-location-list.fit52-spotify': {
      en: 'HiNote Life fam Playlists',
    },
    'screen.workout.next-workout': { en: '*NEXT* WORKOUT' },
    'screen.workout.workout-duration': { en: '%s MINS' },
    'screen.workout.workout-exercises': { en: '%s CARDS' },
    'workout.personalize.preview-instruction.swap': {
      en: 'Tap exercise cards to *Preview* \nexercise video',
    },
    'workout.personalize.instruction.disabled-card': {
      en: 'You have run out of swaps for this suit.',
    },
    'screens.recipe-detail.buttons.like': { en: 'Like this Recipe' },
    'screens.recipe-detail.buttons.liked': { en: 'Liked this Recipe' },
    'screens.recipe-detail.buttons.share': { en: 'Share Yours' },
    'screen.recipe-detail.title': { en: 'Recipe' },
    'screen.recipe-share.title': { en: 'Share Recipe' },
    'bottom-nav.nutrition.title': { en: 'Nutrition' },
    'screen.personalized-workout.tab.exercises': { en: 'Exercises' },
    'screen.nutrition.title': { en: 'Nutrition' },
    'screen.workout-personalized.title': { en: 'Personalize' },
    'post-frame.title.yum': { en: 'Yum!' },
    'screen.personalized-workout.tab.audion-music': { en: 'Audio/Music' },
    'post-frame.title.i_made_this': { en: 'I Made This!' },
    'screen.workout-countdown.title': { en: 'Workout Countdown' },
    'workout.personalize.instruction.started-workout': {
      en: 'You cannot modify *saved* or\r\n*resumable* workouts!',
    },
    'slack-message.apple-signin.title': { en: 'Apple sign in failed' },
    'userworkout.swap.limit.error': {
      en: 'Limit of :limit exercise swaps on :type workout exceeded',
    },
    'userworkout.swap.store.error': {
      en: 'Error occurred creating swaps for user workout!',
    },
    'auth.throttle': { en: 'Temporary blocked, try again in :minutes minutes' },
    'workout.store.error': { en: 'Error occurred creating workout!' },
    'dynamic-link.social-tag.title': {
      en: 'You were invited to join HiNote Life',
    },
    'dynamic-link.user.social-tag.description': {
      en: "Check out :userName's profile on HiNote Life and join now to get 14 days free!",
    },
    'dynamic-link.social-tag.image-url': {
      en: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/uploads/fit52-preview.jpg',
    },
    'users.follow.success': { en: 'User successfully followed!' },
    'users.unfollow.success': { en: 'User successfully unfollowed!' },
    'onboarding.screen.welcome.description': {
      en: 'Work out today and you are 2x more likely to hit your fitness goals.',
    },
    'user-profile.option.share-progress': { en: 'Share Workout Progress' },
    'subscription.intro-third.step-description': {
      en: "You'll automatically subscribe. Cancel anytime before if you didn't love HiNote Life.",
    },
    'workout-builder.segment-item.error': {
      en: 'There are not enough segment items to create a workout on app version :version, fitness level :level, template type :type, included equipment :equipment and exclusions :exclusions',
    },
    'components.workouts-count.members.label': { en: '%s HiNote Life member' },
    'screen.get-started.button': { en: 'Try HiNote Life Now' },
    'challenge.detail.dates': { en: '%s – %s' },
    'challenge.join.success': { en: 'Successfully joined the Challenge!' },
    'challenge.leave.success': { en: 'Challenge left successfully!' },
    'screen.workout.stretch-session.title': { en: 'Stretch & Recovery' },
    'challenge.invite.success': {
      en: 'Successfully invited user to the Challenge!',
    },
    'workout-builder.workout-template.error': {
      en: 'No active workout template found for level :level and type :type',
    },
    'challenge.join.error.challenge-ended': {
      en: 'Error joining the Challenge! The Challenge has already finished.',
    },
    'slack-message.verifiation-email.author': { en: 'Error with :user.' },
    'slack-message.verification-email.title': {
      en: 'Sending verification email failed',
    },
    'components.profile-info.add-favorite': { en: 'Favorite' },
    'components.profile-info.favorite': { en: 'Favorited' },
    'comments.store.error.user.blocked': {
      en: 'You are blocked from commenting!',
    },
    'comments.store.error': { en: 'Error occurred creating comment!' },
    'screen.workout.challenge.title': { en: 'HiNote Life Challenges' },
    'screen.path-explore.challenges.title': { en: 'HiNote Life Challenges' },
    'screen.share.button.label.share-to-path': { en: 'Share to HiNote Life' },
    'screen.share.label.shared-to-path': { en: 'Shared to HiNote Life' },
    'users.following.success': { en: 'Favorites retrieved successfully!' },
    'users.followers.success': { en: 'Followers retrieved successfully!' },
    'dynamic-link.recipe.share-url.title': {
      en: 'Check out the ":title" recipe in HiNote Life!',
    },
    'dynamic-link.recipe.default-image-url': {
      en: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/uploads/fit52-preview.jpg',
    },
    'dynamic-link.path.share-url.title': {
      en: 'Check out the ":pathName" workout path in HiNote Life! ',
    },
    'dynamic-link.path.default-image-url': {
      en: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/uploads/fit52-preview.jpg',
    },
    'email.stripe-subscription-on-success.subject': {
      en: 'HiNote Life - Subscription',
    },
    'email.stripe-subscription-on-success.greeting': { en: 'Hello' },
    'email.stripe-subscription-on-success.reset.line1': {
      en: 'You are receiving this email because you have successfully subscribed to HiNote Life. You can link the subscription to your HiNote Life account clicking the button below.',
    },
    'email.stripe-subscription-on-success.reset.action': {
      en: 'Link Subscription',
    },
    'email.stripe-subscription-on-success.salutation': { en: 'Regards' },
    'email.stripe-subscription-download.subject': {
      en: 'HiNote Life - Download',
    },
    'email.stripe-subscription-download.greeting': { en: 'Hello' },
    'email.stripe-subscription-download.reset.confirmation': {
      en: 'You are receiving this email because you have successfully linked your subscription to an account on HiNote Life!',
    },
    'email.stripe-subscription-download.reset.multiple-subscriptions': {
      en: 'Your account is currently linked with more than one subscription. Please contact support or cancel one of the subscriptions',
    },
    'email.stripe-subscription-download.reset.action': { en: 'Download' },
    'email.stripe-subscription-download.reset.remember-to-sign-in': {
      en: 'Remember to sign in with your email :email and password.',
    },
    'email.stripe-subscription-download.salutation': { en: 'Regards' },
    'stripe.notificaiton.error.link-user.revenuecat-subscription-link': {
      en: 'Error linking user to subscription. userId=:userId, subscriptionId=:subscriptionId',
    },
    'slack-message.stripe.title': { en: 'Stripe Error' },
    'screen.my-path.favorites-tab.empty-state.body': {
      en: "Tap on a HiNote Life member's *profile* in the 'All Posts' feed to add them to your *favorites* and *follow their progress*",
    },
    'challenge.invited.text-alt': { en: 'has invited you to join %s!' },
    'subscription.free-trial-period': { en: 'First %s free, then' },
    'stripe.notificaiton.error.link-subscription.missing-subscription': {
      en: 'Missing both sessionId and subscriptionId. userId=:userId',
    },
    'stripe.error.session-expired.title': { en: 'Expired Session' },
    'stripe.error.session-expired.message': {
      en: 'Your session has expired. Look for the link sent to your email to start a new session.',
    },
    'stripe.notificaiton.warn.link-subscription.subscription-linked-to-subscribed-user':
      {
        en: 'Subscription linked to user that was already subscribed. userId=:userId, subscriptionId=:subscriptionId',
      },
    'views.stripe.on-success.successfully-subscribed-message': {
      en: 'You have successfully subscribed to HiNote Life!',
    },
    'views.stripe.on-success.title': {
      en: 'Link your subscription to an account',
    },
    'views.stripe.on-success.subtitle': {
      en: 'Create an account or login to an existing one to start using the app',
    },
    'views.stripe.on-success.register-button': { en: 'Register' },
    'views.stripe.on-success.login-button': { en: 'Login' },
    'views.layouts.guest.aria-toggle-navigation-button': {
      en: 'Toggle navigation',
    },
    'views.stripe.login-register-links.login-button': { en: 'Login' },
    'views.stripe.login-register-links.register-button': { en: 'Register' },
    'views.stripe.register.title': { en: 'Register' },
    'views.stripe.register.form-aria-label': { en: 'Register' },
    'views.stripe.register.name': { en: 'Name' },
    'views.stripe.register.email': { en: 'Email Address' },
    'views.stripe.register.password': { en: 'Password' },
    'views.stripe.register.register-button': { en: 'Register' },
    'views.layouts.app.aria-toggle-navigation-button': {
      en: 'Toggle navigation',
    },
    'views.layouts.app.login-button': { en: 'Login' },
    'views.layouts.app.register-button': { en: 'Register' },
    'views.stripe.subscribed.title': { en: 'Subscribed' },
    'views.stripe.subscribed.successfully-subscribed': {
      en: 'Successfully started subscription',
    },
    'views.components.download-app.title': { en: 'After you download...' },
    'views.components.download-app.subtitle': {
      en: 'Remember to sign in with your email :email and password.',
    },
    'views.components.download-app.restart-message': {
      en: "If you don't see your subscription in the app, close the app and reopen it to update the subscription status.",
    },
    'views.components.download-app.download-button': { en: 'Download' },
    'views.stripe.login.title': { en: 'Login' },
    'views.stripe.login.form-aria-label': { en: 'Login' },
    'views.stripe.login.email': { en: 'Email Address' },
    'views.stripe.login.password': { en: 'Password' },
    'views.stripe.login.login-button': { en: 'Login' },
    'views.stripe.login.forgot-password-link': { en: 'Forgot Your Password?' },
    'views.auth.passwords.email.title': { en: 'Reset Password' },
    'views.auth.passwords.email.form-aria-label': { en: 'Reset Password' },
    'views.auth.passwords.email.email': { en: 'E-Mail Address' },
    'views.auth.passwords.email.send-email-button': {
      en: 'Send Password Reset Link',
    },
    'stripe.notificaiton.error.already-subscribed': {
      en: 'User already have an active subscription. userId=:userId',
    },
    'views.stripe.session-already-subscribed.title': { en: 'Hello :name!' },
    'views.stripe.session-already-subscribed.subtitle': {
      en: 'You can start using your subscription in HiNote Life!',
    },
    'views.stripe.session-already-subscribed.logout-message': {
      en: 'Not :name?',
    },
    'views.stripe.session-already-subscribed.logout-link': {
      en: 'Click here to subscribe with a different account.',
    },
    'views.auth.passwords.reset.title': { en: 'Reset Password' },
    'views.auth.passwords.reset.form-aria-label': { en: 'Reset Password' },
    'views.auth.passwords.reset.email': { en: 'E-Mail Address' },
    'views.auth.passwords.reset.password': { en: 'Password' },
    'views.auth.passwords.reset.confirm-password': { en: 'Confirm Password' },
    'views.auth.passwords.reset.reset-password-button': {
      en: 'Reset Password',
    },
    'views.auth.verify.title': { en: 'Verify Your Email Address' },
    'views.stripe.on-success-already-linked.linked-subscription-message': {
      en: 'This subscription :subscriptionId is already linked to another account',
    },
    'views.stripe.on-success-already-linked.login-message': {
      en: 'Login to your account',
    },
    'views.stripe.on-success-already-linked.support-message': {
      en: 'or contact support to link this subscription to a different account',
    },
    'views.stripe.on-success-already-linked.support-button': { en: 'Support' },
    'views.stripe.subscribed.account-already-linked': {
      en: 'Your account is currently linked with more than one subscription. Please contact support or cancel one of the subscriptions',
    },
    'slack-message.revenuecat.title': { en: 'RevenueCat API call failed' },
    'views.stripe.error.title': { en: 'Error' },
    'views.stripe.error.default-message': {
      en: 'Sorry, we cannot find what you are looking for.',
    },
    'challenge-invite.share.link.message-body': {
      en: 'I have an exclusive invite for you to try the fun HiNote Life workouts with me FREE for 30 days! Join me and thousands of others to find your path to fitness! \r\n\r\nLet’s work out together with Carrie Underwood’s fitness app. Every workout is different and so much fun! Tap to join me:',
    },
    'stripe.notificaiton.error.portal.missing-stripe-subscription': {
      en: 'Error generating stripe portal. User missing stripe subscription :userId',
    },
    'stripe-subscription.portal.error': {
      en: 'Error generating portal session',
    },
    'stripe.notificaiton.error.stripe-retrieve-methods': {
      en: 'Error retrieving Stripe Objects.\nuserId=:userId, customerId=:customerId, sessionId=:sessionId, subscriptionId=:subscriptionId, url=:url\nInvalid checkout.session id: df_yvif_b427faVBHYmIBmjEdw9ITAaX0VAaCAwhi7uJmM5FZbfWYabta6EZcVhBdv',
    },
    'views.stripe.already-linked.account-linked-alert-line-1': {
      en: 'Your account (:email) is currently linked with another subscription.',
    },
    'views.stripe.already-linked.account-linked-alert-line-2': {
      en: 'Please contact support or cancel one of the subscriptions (subscription: :subscriptionId)',
    },
    'views.stripe.already-linked.support-button': { en: 'Support' },
    'views.auth.login.title': { en: 'Login' },
    'views.auth.login.form-aria-label': { en: 'Login' },
    'views.auth.login.email': { en: 'E-Mail Address' },
    'views.auth.login.password': { en: 'Password' },
    'views.auth.login.remember-me': { en: 'Remember Me' },
    'views.auth.login.login-button': { en: 'Login' },
    'views.auth.login.forgot-password': { en: 'Forgot Your Password?' },
    'views.layouts.app.logout-button': { en: 'Logout' },
    'generator-workout-builder.error.create-workout': {
      en: 'There was an error creating generator workout.\\n:message\\n\\nErrors:errors\\n\\nConfig: :config',
    },
    'slack-message.workout-generator.title': {
      en: 'Something went wrong creating generator workout',
    },
    'screen.challenge-details.challenge-expired': {
      en: 'This challenge has ended',
    },
    'screens.recipe-detail.source': { en: '*SOURCE*' },
    'screens.recipe-detail.nutrition-facts': {
      en: '*NUTRITION FACTS* (PER SERVING)',
    },
    'screens.recipe-detail.how-to': { en: '*HOW TO*' },
    'screens.recipe-detail.ingredients': { en: '*INGREDIENTS*' },
    'screen.personalize.segment.heading.target-area': { en: 'Target Area' },
    'screen.personalize.segment.heading.how-to': { en: 'How To' },
    'challenge-progress-display-value.plural.days_active': {
      en: 'Active Days',
    },
    'challenge-progress-display-value.singular.days_active': {
      en: 'Active Day',
    },
    'auth.email-exists.fail': {
      en: "Sorry, we can't find a user with that email address.",
    },
    'auth.email-email.fail': {
      en: "Uh oh, that doesn't look like a valid email address.",
    },
    'auth.valid-login-password.fail': {
      en: 'Sorry, the entered password is incorrect. Please try again or reset your password.',
    },
    'screen.members.search.empty-state.title': { en: 'No User Found' },
    'subscription.intro-first.step-description': {
      en: 'Get full access for you + friend\r\nto ALL workouts & recipes',
    },
    'subscription.intro-second.step-description': {
      en: 'Get a reminder about when your trial will end.',
    },
    'views.apply-promo-code.error.title': { en: 'Error' },
    'views.apply-promo-code.error.footer-contact-support': {
      en: 'Contact support at',
    },
    'workout-instruction-sheet.stretch-session.long-description': {
      en: 'A range of different stretches of various lengths, focusing on different target areas. Each card will show you the stretch and the time required.',
    },
    'screen.workout-home.workout-card.recover_stretch_back_chest_foam_roller.title':
      { en: 'Upper Body' },
    'views.apply-promo-code.success.title': { en: 'Success' },
    'views.apply-promo-code.success.default-message': {
      en: 'Your promotion was applied successfully! Enjoy HiNote Life premium!',
    },
    'views.apply-promo-code.success.redirect-message': {
      en: 'If you are not redirected automatically, click here',
    },
    'stripe.notificaiton.error.invalid-promotion': {
      en: 'Promotion is not valid for this user. userId=:userId, promoCode=:promoCode',
    },
    'toast.creating-non-path-workout.error.not-enough-segments': {
      en: 'Sorry, due to your exclusions and/or modifications you don’t have enough exercises for this workout. Please view Settings -> Workout Settings -> Excluded Exercises or contact Support.',
    },
    'onboarding.screen.recommended-path.header': {
      en: 'Personalizing for you...',
    },
    'onboarding.screen.recommended-path.header-2': {
      en: 'Best place to start  👇',
    },
    'screen.feed.tab.progress': { en: 'Activities' },
    'user-modifications.post.invalid-modification': {
      en: "You can't create this modification with all your excluded exercises in place. There wouldn't be enough exercises to create workouts.",
    },
    'user-modifications.post.success': {
      en: 'Successfully set user modifications',
    },
    'dynamic-link.challenge-share-url.title': {
      en: 'Check out the ":title" challenge in HiNote Life!',
    },
    'dynamic-link.challenge-share-url.description': {
      en: 'Check out the ":title" challenge in HiNote Life!',
    },
    'dynamic-link.challenge-share-url.default-image': {
      en: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/uploads/fit52-preview.jpg',
    },
    'screen.members.search.empty-state.body': {
      en: 'Please make sure everything is spelled correctly. The keyword must be at least 2 characters long.',
    },
    'auth.apple.signup-with-existing-user.error': {
      en: 'We already have an account with that email. Try a different signup method.',
    },
    'auth.facebook.signup-with-existing-user.error': {
      en: 'We already have an account with that email. Try a different signup method.',
    },
    'auth.google.signup-with-existing-user.error': {
      en: 'We already have an account with that email. Try a different signup method.',
    },
    'label.achievement-unit.exercises': { en: 'Stretches' },
    'equipment.disabled-info-modal.message': {
      en: 'You currently have %s %s applied, which restricts the usage of any equipment during workouts. If you wish to select equipment, please update your %s.',
    },
    'onboarding.screen.guest-mode-username.subtitle': {
      en: 'What should we call you?',
    },
    'auth.google.failed': { en: 'Problem signing in with Google' },
    'onboarding.features-carousel.feature-community.description': {
      en: 'Join 500,000+ members and\r\nachieve your fitness goals',
    },
    'screen.workout.workout-generator.title': {
      en: 'Can’t Find What You Want?',
    },
    'screen.user-account.section.social.title': { en: 'Community' },
    'stripe.notificaiton.error.session-create.session-create-failed': {
      en: 'Error generating Stripe Session.\\n:message\\nURL::url',
    },
    'screen.workout.challenge.individual.title': { en: 'Personal Challenges' },
    'stripe.notificaiton.error.link-user.email-subscription-link': {
      en: 'Error emailing user subscription download link. userId=:userId, subscriptionId=:subscriptionId',
    },
    'users.blockuser.success': { en: 'User blocked successfully' },
    'subscriptions.error-description-ios.not-found': {
      en: 'Could not find subscriptions from App Store. Please make sure you are logged into the App Store and have the latest version of HiNote Life.',
    },
    'subscriptions.error-description-android.not-found': {
      en: 'Could not find subscriptions from Play Store. Please make sure you are logged into the Play Store and have the latest version of HiNote Life.',
    },
    'onboarding.screen.activity-time.activityTimeOptions.full': {
      en: '30-45+ mins',
    },
    'onboarding.screen.activity-time.activityTimeOptions.card-draw-13': {
      en: '<15 mins',
    },
    'settings.screen.update-workout-preferences.confirm': {
      en: 'Update My Goal',
    },
    'cancellation.instructions.stripe.step-1.part-1': { en: '1. Open ' },
    'user-update.pregnancy-due-date-modification-invalid': {
      en: 'The selected modification is invalid for user 397939',
    },
    'screen.update-reminders.path.sublabel': {
      en: 'HiNote Life members that align their workout reminders with their goal achieve maximum results.',
    },
    'screen.workout-settings.section.content-settings.title': { en: 'Content' },
    'screen.workout-settings.section.workout-settings.title': { en: 'Workout' },
    'screen.workout-settings.section.exercise-settings.title': {
      en: 'Exercise',
    },
    'workout-goal-tracker.subtitle': { en: 'Weekly Goal' },
    'users.unblockuser.success': { en: 'User unblocked successfully' },
    'incentive.screen.cta.button': { en: 'Give HiNote Life for FREE!' },
    'challenge.invite.state.button': { en: 'View Challenge' },
    'challenge.restart.success': {
      en: 'Successfully restarted the Challenge!',
    },
    'screen.workout.promotional.banner.cta': {
      en: 'Special Offer.\r\nTap to get %s FREE!',
    },
    'users.follow.error': { en: 'Error occurred following user!' },
    'onboarding-time-selection.button.morning': { en: 'Morning' },
    'onboarding-time-selection.button.afternoon': { en: 'Afternoon' },
    'onboarding-time-selection.button.evening': { en: 'Evening' },
    'users.index.error': { en: 'Error occurred searching for users!' },
    'incentive.screen.referral.message.text': {
      en: "Have you tried Carrie Underwood's new fitness app, HiNote Life? I've been using it recently and really like the workouts. Here's a free 30-day Guest Pass, give it a try and let me know how you like the workouts.",
    },
    'incentive.screen.referral.message.subject': {
      en: 'You should try this app out!',
    },
    'exclusion.store.error.not-excluded': {
      en: ':exclusion was not excluded!',
    },
    'button.feed.block-user.label': { en: 'Hide Post and Block User' },
    'workout-music-location-list.carries-country-on-sxm': {
      en: "Carrie's Country on SiriusXM",
    },
    'screen.blocked-users.empty-list.message': {
      en: 'You haven’t blocked any users',
    },
    'workout-music-location-list.pandora_get_moving_with_carrie': {
      en: 'Get Moving With Carrie Playlist',
    },
    'streak-freeze-tracker.info-modal.body': {
      en: "A *Streak Freeze* allows you to maintain your activity week streak, even when life happens. Upon completion of an activity, you'll receive a Streak Freeze credit which automatically will be used to keep your *streak alive* during weeks when you *can't* complete an activity. You can collect a maximum of one Streak Freeze per week, and have up to three saved. This means, even if you're traveling, have an injury, or simply need a break, you can return to HiNote Life *without losing* your hard-earned streak, promoting a more flexible and understanding approach to maintaining your fitness journey.",
    },
    'slack-message.week-streak-freeze.success.message': {
      en: 'Successfully applied to (:numOfSuccessUsers) and unsuccessfully applied to (:numOfFailedUsers).',
    },
    'slack-message.week-streak-freeze.success.title': {
      en: 'Success applying streak freezes!',
    },
    'onboarding.screen.modifications.title': {
      en: 'Any considerations we should be aware of?',
    },
    'screen.workout.new-user-checklist.sub-head': {
      en: 'Finish all 3 & enter to win a HiNote Life Water Bottle',
    },
    'post.store.error': { en: 'Error occurred creating post!' },
    'email-message.carrie-post.subject': {
      en: 'New post by Carrie Underwood on HiNote Life',
    },
    'email-message.carrie-post.greeting': {
      en: 'Carrie just posted to the HiNote Life app',
    },
    'email-message.carrie-post.line1': {
      en: 'Click the link below to see the post:',
    },
    'email-message.carrie-post.line2': { en: 'Kind regards,' },
    'email-message.carrie-post.salutation': { en: 'The HiNote Life team' },
    'onboarding.features-carousel.feature-workouts.description': {
      en: '1000s of fun, varied workouts that\r\ncan be done anytime, anywhere!',
    },
    'profile.feed-tab.title': { en: 'Posts' },
    'screen.get-started.counter-label': {
      en: '*Carrie & %s* others trust *HiNote Life*.\r\nTake 5 mins to see why HiNote Life works.',
    },
    'promo-codes.error.api': { en: 'Error assigning promo code to user :user' },
    'button.post-details.delete.label': { en: 'Delete Post' },
    'subscription.intro-second.step-title': { en: 'Day 5' },
    'subscription.blinkist-two-week.step-two.title': { en: 'Day 5' },
    'subscription.blinkist-one-week.step-two.title': { en: 'Day 5' },
    'users.promo-code.redeem.error-n': {
      en: 'Error occurred redeeming promo code :promoCode :',
    },
    'views.stripe.register.password-hint': {
      en: 'Minimum 8 characters, including one letter and one number.',
    },
    'dynamic-link.sponsorship-message.header': {
      en: ':userName invited you to join HiNote Life for free!',
    },
    'dynamic-link.sponsorship-message.subheader': {
      en: 'A workout challenge with :userName awaits you, get started now!',
    },
    'dynamic-link.sponsorship-message.image-url': {
      en: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/uploads/fit52-preview.jpg',
    },
    'button.post.comment.block-user.label': {
      en: 'Hide Comment and Block User',
    },
    'slack-message.send-event-for-inactive-streak-holders.error.title': {
      en: 'Error sending event for inactive streak holders!',
    },
    'users.promo-code.sponsorship.error.creating_sponsorship': {
      en: 'Error occurred assigning sponsorship promo code!',
    },
    'revenuecat.user-attribute.error.api': {
      en: 'Error getting user attribute :attribute for user :user',
    },
    'sponsorship.show.success': { en: 'Sponsorship found successfully!' },
    'sponsorship.destroy.success.deleted': {
      en: 'Sponsorship deleted successfully!',
    },
    'sponsorship.sponsored-user.first-name-fallback': { en: 'Friend' },
    'screen.share-milestone.description': {
      en: 'Share your milestone with your friends and the HiNote Life community!',
    },
    'user-profile.option.workout-preferences': { en: 'Activity Preferences' },
    'content-settings.delete-all-exercise-videos.text-button': {
      en: 'Delete All Videos',
    },
    'content-settings.download-all-exercise-videos.text-button': {
      en: 'Download All Videos',
    },
    'settings.screen.title.update-modification': { en: 'Update Modification' },
    'screen.title.update-modification': { en: 'Update Modification' },
    'subscription.blinkist-free-for-friend.step-one.description': {
      en: 'Get full access for you + friend.\r\nYou don’t have to pay anything.',
    },
    'email.email-update-verification-resend.subject': {
      en: 'HiNote Life - Verify your email',
    },
    'email.email-update-verification-resend.greeting': {
      en: 'Verify your email adress',
    },
    'email.email-update-verification-resend.line1': {
      en: 'Please verify your email address by entering the code :code in the HiNote Life profile screen, or click the button below. If this was not requested by you, please contact us immediately.',
    },
    'email.email-update-verification-resend.action': {
      en: 'Click here to verify your account',
    },
    'email.email-update-verification-resend.line2': { en: 'Thanks,' },
    'email.email-update-verification-resend.salutation': {
      en: 'The HiNote Life team',
    },
    'email.email-update-verification.subject': {
      en: 'HiNote Life - Verify your email',
    },
    'email.email-update-verification.greeting': {
      en: 'Your registered email was just changed',
    },
    'email.email-update-verification.line1': {
      en: 'We just received a request to update your email. Please verify your email address by entering the code :code in the HiNote Life profile screen, or click the button below. If this was not done by you, please contact us immediately.',
    },
    'email.email-update-verification.action': {
      en: ' Click here to verify your account',
    },
    'email.email-update-verification.line2': { en: 'Thanks,' },
    'email.email-update-verification.salutation': {
      en: 'The HiNote Life team',
    },
    'comments.delete.error': { en: 'Error occurred deleting comment!' },
    'user.chapter.segment.update.success': {
      en: 'User chapter segment updated successfully!',
    },
    'image-extension.error': { en: 'Invalid image extension!' },
    'components.download-progress-modal.downloading-exercises': {
      en: 'Downloading\r\nContent...',
    },
    'social-post.total-poses': { en: '*%s* Poses' },
    'food.find-by-barcode.error.food-not-found': { en: 'Food not found.' },
    'slack-message.remove-unused-workouts.success.message': {
      en: "*Finished processing (:numOfProcessedWorkouts) user workouts created before (:cutoffDate) that haven't been started.*\n\n*Detailed stats:*\n>Parent workouts removed: *(:parentWorkoutRemovalSuccessCounter) successful*, *(:parentWorkoutRemovalErrorCounter) failed*.\n>User workouts removed: *(:userWorkoutRemovalSuccessCounter) successful*, *(:userWorkoutRemovalErrorCounter) failed*.",
    },
    'slack-message.remove-unused-workouts.success.title': {
      en: 'Finished removing workouts not started',
    },
    'foodentry.delete.success': { en: 'Journal entry deleted!' },
    'screens.food-search.quick-add-toast-success-toast': {
      en: 'Food entry logged to your journal!',
    },
    'components.calories-progress.calories-left': { en: 'left' },
    'components.calories-progress.calories-over': { en: 'over' },
    'users.weightinput.success': { en: 'Weight inputted successfully' },
    'userworkout.update-difficulty-rating.success': {
      en: 'User workout rating updated successfully!',
    },
    'apple-health-permission.info.body.text': {
      en: 'To enable Apple Health for *%s*, you must go to your device *Settings* -> *Health* -> *Data Access & Devices* -> *HiNote Life* and enable both *write* and *read* permissions.\r\n\r\nIf you wish to enable all possible permissions to gain full access to all Apple Health integration features, press *Turn on All*. You can disable Apple Health integration in settings.',
    },
    'components.custom-calories-goal-modal.disclaimer': {
      en: 'Your Calorie Goal is based on your Height and Weight and your Health Goal. You can update these in Settings.',
    },
    'settings.screen.update-workout-preferences.header.title': {
      en: 'What is your weekly goal?',
    },
    'screen.workout-health-integration.apple-health.body.description-update': {
      en: 'Update your *Apple Health* settings to improve your HiNote Life experience. This helps track your workouts, calories burned, and more. For the best results, we recommend using a smartwatch.',
    },
    'food.index.error': { en: 'Error occurred searching for foods!' },
    'screen.update-body-metrics-height.about-you.sub-title.default': {
      en: 'Input your details to help us personalize your workouts and calculate your daily calorie goals',
    },
    'onboarding.screen.health-goal-survey.sub-title': {
      en: 'This helps calculate your daily calorie targets and tailor your workouts for the best results. You can update this anytime.',
    },
    'screens.food-search.no-food-found': {
      en: 'Item not found. Use ‘Create Food/Drink’.',
    },
    'components.calories-card.exercise-burn.label': { en: 'Activity Burn' },
    'views.auth.register.title': { en: 'Register' },
    'views.auth.register.form-aria-label': { en: 'Register' },
    'views.auth.register.first-name': { en: 'First Name' },
    'views.auth.register.last-name': { en: 'Last Name' },
    'views.auth.register.email': { en: 'E-Mail Address' },
    'views.auth.register.password': { en: 'Password' },
    'views.auth.register.confirm-password': { en: 'Confirm Password' },
    'views.auth.register.register-button': { en: 'Register' },
    'recipe.search.error': { en: 'Error occurred searching for recipes!' },
    'screens.food-add.title.edit-food': { en: 'Update Journal Entry' },
    'screens.foodAiCaptureNutritionalFacts.explanation-unrecognized-barcode': {
      en: "We couldn't find the scanned barcode. Take a photo of the full nutrition facts table on the product packaging.",
    },
    'screens.foodAiCaptureNutritionalFacts.explanation': {
      en: 'Take a photo of the full nutrition facts table on the product packaging.',
    },
    'unavailable.workout-modal.settings-button-label': { en: 'Go to Settings' },
    'screens.food-search.create-food-tile-with-ai': { en: 'Quick Capture' },
    'subscription.trial-available.button.label': { en: 'Try for Free' },
  },
  settings: {
    'nutrition.force-external-provider-call': false,
    'food.search.internal_foods_per_page': '3',
    'app.min_nutrition_version': '3.7.0',
    'nutrition.food-entries.recent-limit': '30',
    workout_cleanup_query_limit: '2500',
    workout_cleanup_cutoff_days: '10',
    'number-of-new-users-per-hour': 10,
    'carrie-post-email-list': [
      'kim@fit52.com',
      'kerrigan@fit52.com',
      'robin@m56.app',
      'Roger.Widynowski@theh-q.com',
      'michelle.deleon@theh-q.com',
      'ann.edelblute@theh-q.com',
      'cu@loveyoursocialmedia.com',
    ],
    'active-campaigns-names': 'BODY_ARMOR_COMMIT_TO_FIT',
    'has-active-campaigns': true,
    'featured-users-ttl': 86400,
    'all-users-liked-segments-ttl': 86400,
    'all-paths-ttl': 86400,
    'users-per-challenge': 3,
    'comments-per-page': 15,
    'comments-per-post': 1,
    'slack-notifications-generator-workout-builder': true,
    'cloudfront-files-base-url': 'https://dj14u43q22646.cloudfront.net',
    'files-base-url': 'https://dj14u43q22646.cloudfront.net',
    'followers-per-page': 15,
    'highlighted-post-queried-notify-slack': true,
    'highlighted-post-forbidden-content-types': [
      'WORKOUT_SUMMARY',
      'WORKOUT_LEADERBOARD',
      'RECIPE_DEFAULT',
    ],
    'likes-per-page': 30,
    'top-liked-segments': 25,
    'visible-notification-number': 50,
    'nutrition-frames-promo-end-milliseconds': 1623481200000,
    'max-names-listed-in-kudos-message': 2,
    'post-comment-max-characters': 255,
    'my-gift-red-promo-end-milliseconds': 1606809600000,
    'my-gift-silver-promo-end-milliseconds': 1606809600000,
    'post-per-page': 15,
    'post-refresh-minutes': 30,
    'likes-per-post': 4,
    'exponential-decay-rate': '-0.005',
    'timestamp-diff-type': 'MINUTE',
    'exclude-nutrition-posts-older-than-x-months': '12',
    'exclude-following-posts-older-than-x-months': '12',
    'max-comments-score': 90,
    'exclude-posts-older-than-x-months': '4',
    'comments-score-weight': 30,
    'max-likes-score': 50,
    'regular-base-score': 50,
    'recipe-base-score': 70,
    'likes-score-weight': 8,
    'apply-promo-code.auto-redirect': true,
    'apply-promo-code.default-redirect-url': 'https://fit52.page.link/download',
    'apply-promo-code.redirect-after-seconds': 2,
    'likes-per-recipe': 4,
    recipes_per_page: 10,
    recipes_likes_user_profile_limit_show: 5,
    recipes_likes_user_profile_limit_index: 5,
    'charts-minutes-in-cache': 5,
    'seconds-in-cache': 10800,
    'liked-segments-results-limit': 20,
    'liked-segments-days-limit': 15,
    'week-streak-initial-increment': 2,
    'week-streak-increment-interval': 5,
    'week-streak-maximum-count': 3,
    'stripe-fallback-cancel-route': 'https://app.hinote.com',
    'send-subscription-cancellation-survey': false,
    'top-completed-workouts-results': 3,
    user_default_leap_year: '1892',
    'hours-pinned': 18,
    'grandfathered-streak-cutoff-date': 6,
    'workout-recover-stretch-hips-legs-skip-limit': 4,
    'max-repeated-focus-area': 2,
    'workout-full-swap-limit': 8,
    'workout-half-swap-limit': 4,
    'workout-recover-stretch-revive-recover-skip-limit': 4,
    'workout-recover-stretch-full-body-flow-skip-limit': 4,
    'workout-recover-eve-favorite-segments-skip-limit': 8,
    'workout-recover-stretch-energy-booster-skip-limit': 4,
    'workout-recover-stretch-wind-down-skip-limit': 4,
    'workout-half-segment-skip-limit': 16,
    'workout-recover-stretch-yoga-flow-skip-limit': 4,
    'workout-full-segment-skip-limit': 32,
    'workout-card-draw-13-segment-skip-limit': 8,
    'workout-recover-all-favorite-segments-skip-limit': 8,
    'workout-recover-carrie-favorite-segments-skip-limit': 8,
  },
  feedback: [
    {
      id: 1,
      name: 'Post Workout Feedback',
      enum_value: 'POST_WORKOUT',
      description: 'post workout feedback',
      options: [
        { id: 1, order: 1, text: 'Easy', emoji: '😛' },
        { id: 2, order: 2, text: 'Perfect', emoji: '😊' },
        { id: 3, order: 3, text: 'Hard', emoji: '😥' },
      ],
    },
    {
      id: 2,
      name: 'Early Ending Workout Feedback',
      enum_value: 'EARLY_ENDING',
      description: 'early ending workout feedback',
      options: [
        { id: 4, order: 1, text: 'Too easy', emoji: '😛' },
        { id: 5, order: 2, text: 'Too hard', emoji: '😥' },
        { id: 6, order: 3, text: 'Out of Time', emoji: '⌛️' },
        { id: 7, order: 4, text: 'Pace of Activity', emoji: '⏩' },
        { id: 8, order: 5, text: 'Too repetitive', emoji: '🔂' },
        { id: 9, order: 0, text: 'Technical Issues', emoji: '🔧' },
      ],
    },
  ],
  paths: {
    1: {
      id: 1,
      name: 'Easy Does It',
      long_name: 'Easy Does It',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'EASY_DOES_IT',
      description:
        "New to fitness? Getting back into it? This is the perfect place to start. Get going with two half workouts per week. Start with beginner exercises and build a routine that works for you. 'Easy Does It' is also a great level for those that don't have a lot of time, but really want to squeeze in two quick workouts per week. Give it a try for yourself!",
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'HALF',
      workouts_per_week: 2,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137844,
          imageable_type: 'App\\Path',
          imageable_id: 1,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/1_pathInfo_3x',
          version: '1626457801',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/1_pathInfo_3x/1626457801.jpg',
        },
        {
          id: 137845,
          imageable_type: 'App\\Path',
          imageable_id: 1,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/1_preWorkout_3x',
          version: '1626457802',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/1_preWorkout_3x/1626457802.jpg',
        },
        {
          id: 137846,
          imageable_type: 'App\\Path',
          imageable_id: 1,
          collection_name: 'saved_image',
          name: 'fit52/ugc/1_saved_3x',
          version: '1626457801',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/1_saved_3x/1626457801.jpg',
        },
        {
          id: 137847,
          imageable_type: 'App\\Path',
          imageable_id: 1,
          collection_name: 'social_image',
          name: 'fit52/ugc/1_social_3x',
          version: '1626457802',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/1_social_3x/1626457802.jpg',
        },
        {
          id: 137848,
          imageable_type: 'App\\Path',
          imageable_id: 1,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/1_myPath_3x',
          version: '1626457801',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/1_myPath_3x/1626457801.jpg',
        },
        {
          id: 137849,
          imageable_type: 'App\\Path',
          imageable_id: 1,
          collection_name: 'card_image',
          name: 'fit52/ugc/1_card_3x',
          version: '1626457800',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/1_card_3x/1626457800.jpg',
        },
      ],
    },
    2: {
      id: 2,
      name: 'Complete The Deck!',
      long_name: 'Complete The Deck!',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'COMPLETE_THE_DECK',
      description:
        'Each path is different, each workout is different, each week is different. Maybe this path is the right one for you? Maybe you want to just try it? With this path, the goal is to complete 52 cards in a week in one beginner workout. Give it a try!',
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'FULL',
      workouts_per_week: 1,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 210469,
          imageable_type: 'App\\Path',
          imageable_id: 2,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/m31jfh1eoqhweejqd0uz',
          version: '1652969016',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/m31jfh1eoqhweejqd0uz/1652969016.jpg',
        },
        {
          id: 210470,
          imageable_type: 'App\\Path',
          imageable_id: 2,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/vpdbltoog7wbjwhqqwxt',
          version: '1652969026',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 7, width: 1241, height: 2681 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1241,trim.height=2681,trim.left=0,trim.top=7/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/vpdbltoog7wbjwhqqwxt/1652969026.jpg',
        },
        {
          id: 210471,
          imageable_type: 'App\\Path',
          imageable_id: 2,
          collection_name: 'social_image',
          name: 'fit52/ugc/dnlwukfivebl4yp9mlg9',
          version: '1652969042',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/dnlwukfivebl4yp9mlg9/1652969042.jpg',
        },
        {
          id: 210472,
          imageable_type: 'App\\Path',
          imageable_id: 2,
          collection_name: 'saved_image',
          name: 'fit52/ugc/g8uqkd9nno5d9nrna0w2',
          version: '1652969057',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/g8uqkd9nno5d9nrna0w2/1652969057.jpg',
        },
        {
          id: 210473,
          imageable_type: 'App\\Path',
          imageable_id: 2,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/yg3gisdjx9gfjoibdahi',
          version: '1652969067',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/yg3gisdjx9gfjoibdahi/1652969067.jpg',
        },
        {
          id: 210474,
          imageable_type: 'App\\Path',
          imageable_id: 2,
          collection_name: 'card_image',
          name: 'fit52/ugc/u9wlibhuoewfm1akckhf',
          version: '1652969079',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/u9wlibhuoewfm1akckhf/1652969079.jpg',
        },
      ],
    },
    3: {
      id: 3,
      name: 'Two By Two',
      long_name: 'Two By Two',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'TWO_BY_TWO',
      description:
        "Two beginner workouts per week. This is a great path to step up to once you move on from the 'Easy Does It' path, or if you are  just looking for two fun workouts per week. Complete 'Two by Two' on the days that work best for you, and share your success with the HiNote Life community!",
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'FULL',
      workouts_per_week: 2,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137856,
          imageable_type: 'App\\Path',
          imageable_id: 3,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/3_pathInfo_3x',
          version: '1626208494',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/3_pathInfo_3x/1626208494.jpg',
        },
        {
          id: 137857,
          imageable_type: 'App\\Path',
          imageable_id: 3,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/3_preWorkout_3x',
          version: '1626208494',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/3_preWorkout_3x/1626208494.jpg',
        },
        {
          id: 137858,
          imageable_type: 'App\\Path',
          imageable_id: 3,
          collection_name: 'saved_image',
          name: 'fit52/ugc/3_saved_3x',
          version: '1626208494',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/3_saved_3x/1626208494.jpg',
        },
        {
          id: 137859,
          imageable_type: 'App\\Path',
          imageable_id: 3,
          collection_name: 'social_image',
          name: 'fit52/ugc/3_social_3x',
          version: '1626208495',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/3_social_3x/1626208495.jpg',
        },
        {
          id: 137860,
          imageable_type: 'App\\Path',
          imageable_id: 3,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/3_myPath_3x',
          version: '1626208493',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/3_myPath_3x/1626208493.jpg',
        },
        {
          id: 137861,
          imageable_type: 'App\\Path',
          imageable_id: 3,
          collection_name: 'card_image',
          name: 'fit52/ugc/3_card_3x',
          version: '1626208493',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/3_card_3x/1626208493.jpg',
        },
      ],
    },
    4: {
      id: 4,
      name: 'Get Started With Carrie',
      long_name: 'Get Started With Carrie',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'GET_STARTED_WITH_CARRIE',
      description:
        "This path is designed specifically for those that are getting started with fitness. Complete three beginner workouts per week to 'Get Started With Carrie'. This path is a lot of fun and you are supported by the HiNote Life community along the way.",
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'FULL',
      workouts_per_week: 3,
      is_private: false,
      is_vip: true,
      author: null,
      equipment: [],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 3,
      images: [
        {
          id: 343609,
          imageable_type: 'App\\Path',
          imageable_id: 4,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/4_pathInfo_3x-min',
          version: '1701799820',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/4_pathInfo_3x-min/1701799820.jpg',
        },
        {
          id: 343610,
          imageable_type: 'App\\Path',
          imageable_id: 4,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/4_preWorkout_3x-min',
          version: '1701799821',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/4_preWorkout_3x-min/1701799821.jpg',
        },
        {
          id: 343611,
          imageable_type: 'App\\Path',
          imageable_id: 4,
          collection_name: 'social_image',
          name: 'fit52/ugc/4_social_3x-min',
          version: '1701799821',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/4_social_3x-min/1701799821.jpg',
        },
        {
          id: 343612,
          imageable_type: 'App\\Path',
          imageable_id: 4,
          collection_name: 'saved_image',
          name: 'fit52/ugc/4_saved_3x-min',
          version: '1701799821',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/4_saved_3x-min/1701799821.jpg',
        },
        {
          id: 343613,
          imageable_type: 'App\\Path',
          imageable_id: 4,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/4_myPath_3x-min',
          version: '1701799821',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/4_myPath_3x-min/1701799821.jpg',
        },
        {
          id: 343614,
          imageable_type: 'App\\Path',
          imageable_id: 4,
          collection_name: 'card_image',
          name: 'fit52/ugc/4_card_3x-min',
          version: '1701799820',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/4_card_3x-min/1701799820.jpg',
        },
      ],
    },
    5: {
      id: 5,
      name: 'Four By Four',
      long_name: 'Four By Four',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'FOUR_BY_FOUR',
      description:
        "A step up from the 'Two By Two' path. This one is four workouts, four days per week. These beginner workouts will really help you develop a routine. Select the days that work best for you, and don't forget to share your post-workout pics!",
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'FULL',
      workouts_per_week: 4,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137868,
          imageable_type: 'App\\Path',
          imageable_id: 5,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/5_pathInfo_3x',
          version: '1626208497',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/5_pathInfo_3x/1626208497.jpg',
        },
        {
          id: 137869,
          imageable_type: 'App\\Path',
          imageable_id: 5,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/5_preWorkout_3x',
          version: '1626208498',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/5_preWorkout_3x/1626208498.jpg',
        },
        {
          id: 137870,
          imageable_type: 'App\\Path',
          imageable_id: 5,
          collection_name: 'saved_image',
          name: 'fit52/ugc/5_saved_3x',
          version: '1626208497',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/5_saved_3x/1626208497.jpg',
        },
        {
          id: 137871,
          imageable_type: 'App\\Path',
          imageable_id: 5,
          collection_name: 'social_image',
          name: 'fit52/ugc/5_social_3x',
          version: '1626208498',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/5_social_3x/1626208498.jpg',
        },
        {
          id: 137872,
          imageable_type: 'App\\Path',
          imageable_id: 5,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/5_myPath_3x',
          version: '1626208497',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/5_myPath_3x/1626208497.jpg',
        },
        {
          id: 137873,
          imageable_type: 'App\\Path',
          imageable_id: 5,
          collection_name: 'card_image',
          name: 'fit52/ugc/5_card_3x',
          version: '1626208496',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/5_card_3x/1626208496.jpg',
        },
      ],
    },
    6: {
      id: 6,
      name: 'Cards, More Cards',
      long_name: 'Cards, More Cards',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'CARDS_MORE_CARDS',
      description:
        "Now we're talking! Five beginner workouts per week. That's a lot of cards. Like 260 to be exact. Go you!",
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'FULL',
      workouts_per_week: 5,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137874,
          imageable_type: 'App\\Path',
          imageable_id: 6,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/6_pathInfo_3x',
          version: '1626208498',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/6_pathInfo_3x/1626208498.jpg',
        },
        {
          id: 137875,
          imageable_type: 'App\\Path',
          imageable_id: 6,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/6_preWorkout_3x',
          version: '1626208499',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/6_preWorkout_3x/1626208499.jpg',
        },
        {
          id: 137876,
          imageable_type: 'App\\Path',
          imageable_id: 6,
          collection_name: 'saved_image',
          name: 'fit52/ugc/6_saved_3x',
          version: '1626208499',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/6_saved_3x/1626208499.jpg',
        },
        {
          id: 137877,
          imageable_type: 'App\\Path',
          imageable_id: 6,
          collection_name: 'social_image',
          name: 'fit52/ugc/6_social_3x',
          version: '1626208499',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/6_social_3x/1626208499.jpg',
        },
        {
          id: 137878,
          imageable_type: 'App\\Path',
          imageable_id: 6,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/6_myPath_3x',
          version: '1626208498',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/6_myPath_3x/1626208498.jpg',
        },
        {
          id: 137879,
          imageable_type: 'App\\Path',
          imageable_id: 6,
          collection_name: 'card_image',
          name: 'fit52/ugc/6_card_3x',
          version: '1626208498',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/6_card_3x/1626208498.jpg',
        },
      ],
    },
    7: {
      id: 7,
      name: 'Play On',
      long_name: 'Play On',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'PLAY_ON',
      description:
        "Time to 'Play On'. Six beginner workouts per week. This is for those that are really committed, but enjoy the fun factor of beginner workouts. Do these workouts from anywhere.",
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'FULL',
      workouts_per_week: 6,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 210463,
          imageable_type: 'App\\Path',
          imageable_id: 7,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/ysirutrnyhoamnfbyysn',
          version: '1652968923',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ysirutrnyhoamnfbyysn/1652968923.jpg',
        },
        {
          id: 210464,
          imageable_type: 'App\\Path',
          imageable_id: 7,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/avz3tphjxohvkcnxboyy',
          version: '1652968935',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 7, y: 7, width: 1235, height: 2667 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1235,trim.height=2667,trim.left=7,trim.top=7/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/avz3tphjxohvkcnxboyy/1652968935.jpg',
        },
        {
          id: 210465,
          imageable_type: 'App\\Path',
          imageable_id: 7,
          collection_name: 'social_image',
          name: 'fit52/ugc/ucfktzairgngozj4dfch',
          version: '1652968949',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ucfktzairgngozj4dfch/1652968949.jpg',
        },
        {
          id: 210466,
          imageable_type: 'App\\Path',
          imageable_id: 7,
          collection_name: 'saved_image',
          name: 'fit52/ugc/maii7pmlzjjjr3p2lxys',
          version: '1652968960',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/maii7pmlzjjjr3p2lxys/1652968960.jpg',
        },
        {
          id: 210467,
          imageable_type: 'App\\Path',
          imageable_id: 7,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/xzjr4zgcebbnic7vapy2',
          version: '1652968971',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/xzjr4zgcebbnic7vapy2/1652968971.jpg',
        },
        {
          id: 210468,
          imageable_type: 'App\\Path',
          imageable_id: 7,
          collection_name: 'card_image',
          name: 'fit52/ugc/dsho1bkbadqaznq0dmkw',
          version: '1652968981',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/dsho1bkbadqaznq0dmkw/1652968981.jpg',
        },
      ],
    },
    8: {
      id: 8,
      name: "Let's Go Halves",
      long_name: "Let's Go Halves",
      branded_name: null,
      branded_long_name: null,
      enum_value: 'LETS_GO_HALVES',
      description:
        "Three half workouts per week. Although that doesn't mean this is easy! This is a great path for those that want a high-intensity workout, but are pressed for time. 26 cards per workout, 100% fun.",
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'HALF',
      workouts_per_week: 3,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137886,
          imageable_type: 'App\\Path',
          imageable_id: 8,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/8_pathInfo_3x',
          version: '1626457849',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/8_pathInfo_3x/1626457849.jpg',
        },
        {
          id: 137887,
          imageable_type: 'App\\Path',
          imageable_id: 8,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/8_preWorkout_3x',
          version: '1626457850',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/8_preWorkout_3x/1626457850.jpg',
        },
        {
          id: 137888,
          imageable_type: 'App\\Path',
          imageable_id: 8,
          collection_name: 'saved_image',
          name: 'fit52/ugc/8_saved_3x',
          version: '1626457850',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/8_saved_3x/1626457850.jpg',
        },
        {
          id: 137889,
          imageable_type: 'App\\Path',
          imageable_id: 8,
          collection_name: 'social_image',
          name: 'fit52/ugc/8_social_3x',
          version: '1626457853',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/8_social_3x/1626457853.jpg',
        },
        {
          id: 137890,
          imageable_type: 'App\\Path',
          imageable_id: 8,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/8_myPath_3x',
          version: '1626457844',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/8_myPath_3x/1626457844.jpg',
        },
        {
          id: 137891,
          imageable_type: 'App\\Path',
          imageable_id: 8,
          collection_name: 'card_image',
          name: 'fit52/ugc/8_card_3x',
          version: '1626457843',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/8_card_3x/1626457843.jpg',
        },
      ],
    },
    9: {
      id: 9,
      name: 'Level Up',
      long_name: 'Level Up',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'LEVEL_UP',
      description:
        "Time to 'Level Up'! This path is designed for those wanting to push themselves with an intermediate workout, and are committing to one workout per week. 'Level Up' is a great place to progress to once you feel like you've mastered the beginner level paths.",
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'FULL',
      workouts_per_week: 1,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137892,
          imageable_type: 'App\\Path',
          imageable_id: 9,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/9_pathInfo_3x',
          version: '1626208509',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/9_pathInfo_3x/1626208509.jpg',
        },
        {
          id: 137893,
          imageable_type: 'App\\Path',
          imageable_id: 9,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/9_preWorkout_3x',
          version: '1626208509',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/9_preWorkout_3x/1626208509.jpg',
        },
        {
          id: 137894,
          imageable_type: 'App\\Path',
          imageable_id: 9,
          collection_name: 'saved_image',
          name: 'fit52/ugc/9_saved_3x',
          version: '1626208509',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/9_saved_3x/1626208509.jpg',
        },
        {
          id: 137895,
          imageable_type: 'App\\Path',
          imageable_id: 9,
          collection_name: 'social_image',
          name: 'fit52/ugc/9_social_3x',
          version: '1626208510',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/9_social_3x/1626208510.jpg',
        },
        {
          id: 137896,
          imageable_type: 'App\\Path',
          imageable_id: 9,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/9_myPath_3x',
          version: '1626208509',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/9_myPath_3x/1626208509.jpg',
        },
        {
          id: 137897,
          imageable_type: 'App\\Path',
          imageable_id: 9,
          collection_name: 'card_image',
          name: 'fit52/ugc/9_card_3x',
          version: '1626208508',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/9_card_3x/1626208508.jpg',
        },
      ],
    },
    10: {
      id: 10,
      name: 'Working To Work Out',
      long_name: 'Working To Work Out',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'WORKING_TO_WORK_OUT',
      description:
        "Juggling a busy work schedule and struggling to find the time for fitness? Then 'Working To Work Out' is the path for you. Squeeze in two intermediate workouts per week. Even if each week is different, two workouts per week is a great achievement. The HiNote Life community is here to support you every step of the way.",
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'FULL',
      workouts_per_week: 2,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 210457,
          imageable_type: 'App\\Path',
          imageable_id: 10,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/ojxwdgzqwzjihqkisrfk',
          version: '1652968811',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ojxwdgzqwzjihqkisrfk/1652968811.jpg',
        },
        {
          id: 210458,
          imageable_type: 'App\\Path',
          imageable_id: 10,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/dnlpiscstxgdwa4qhrkv',
          version: '1652968838',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 7, width: 1241, height: 2681 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1241,trim.height=2681,trim.left=0,trim.top=7/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/dnlpiscstxgdwa4qhrkv/1652968838.jpg',
        },
        {
          id: 210459,
          imageable_type: 'App\\Path',
          imageable_id: 10,
          collection_name: 'social_image',
          name: 'fit52/ugc/vj6bdfq5jgrv3fngtjuc',
          version: '1652968851',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/vj6bdfq5jgrv3fngtjuc/1652968851.jpg',
        },
        {
          id: 210460,
          imageable_type: 'App\\Path',
          imageable_id: 10,
          collection_name: 'saved_image',
          name: 'fit52/ugc/ujjzaiulvkoo0s7a4sie',
          version: '1652968864',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ujjzaiulvkoo0s7a4sie/1652968864.jpg',
        },
        {
          id: 210461,
          imageable_type: 'App\\Path',
          imageable_id: 10,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/s5vv1ns8lnelelp2rkwi',
          version: '1652968875',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/s5vv1ns8lnelelp2rkwi/1652968875.jpg',
        },
        {
          id: 210462,
          imageable_type: 'App\\Path',
          imageable_id: 10,
          collection_name: 'card_image',
          name: 'fit52/ugc/e0vpawwaoz8bgxalbez5',
          version: '1652968887',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/e0vpawwaoz8bgxalbez5/1652968887.jpg',
        },
      ],
    },
    11: {
      id: 11,
      name: 'Putting In The Time',
      long_name: 'Putting In The Time',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'PUTTING_IN_THE_TIME',
      description:
        "Three workouts per week, that's 156 cards and 156 exercises! You are definitely 'Putting In The Time' when you're on this path. Go you!",
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'FULL',
      workouts_per_week: 3,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 210450,
          imageable_type: 'App\\Path',
          imageable_id: 11,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/e8hagsw1euagoiawctcx',
          version: '1652968709',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/e8hagsw1euagoiawctcx/1652968709.jpg',
        },
        {
          id: 210451,
          imageable_type: 'App\\Path',
          imageable_id: 11,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/cftjtcbwmanyadr6tx5l',
          version: '1652968726',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 7, width: 1241, height: 2681 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1241,trim.height=2681,trim.left=0,trim.top=7/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/cftjtcbwmanyadr6tx5l/1652968726.jpg',
        },
        {
          id: 210452,
          imageable_type: 'App\\Path',
          imageable_id: 11,
          collection_name: 'social_image',
          name: 'fit52/ugc/elkagjyymyk514vj0hwr',
          version: '1652968738',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/elkagjyymyk514vj0hwr/1652968738.jpg',
        },
        {
          id: 210453,
          imageable_type: 'App\\Path',
          imageable_id: 11,
          collection_name: 'saved_image',
          name: 'fit52/ugc/piavuaogxxbq0kcv71pl',
          version: '1652968750',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/piavuaogxxbq0kcv71pl/1652968750.jpg',
        },
        {
          id: 210454,
          imageable_type: 'App\\Path',
          imageable_id: 11,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/qjzbhwfilurlpcjwchxw',
          version: '1652968764',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/qjzbhwfilurlpcjwchxw/1652968764.jpg',
        },
        {
          id: 210455,
          imageable_type: 'App\\Path',
          imageable_id: 11,
          collection_name: 'card_image',
          name: 'fit52/ugc/s3roop7kdkfic2vfkgrm',
          version: '1652968776',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/s3roop7kdkfic2vfkgrm/1652968776.jpg',
        },
      ],
    },
    12: {
      id: 12,
      name: 'You Got This!',
      long_name: 'You Got This!',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'YOU_GOT_THIS',
      description:
        "HiNote Life allows you to find your path, and maybe this one is perfect for you? Four intermediate workouts per week. You got this! Join this path if you're ready to push it. Find the days and times that work best for you and share your journey with others on your path.",
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'FULL',
      workouts_per_week: 4,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137910,
          imageable_type: 'App\\Path',
          imageable_id: 12,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/12_pathInfo_3x',
          version: '1626208517',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/12_pathInfo_3x/1626208517.jpg',
        },
        {
          id: 137911,
          imageable_type: 'App\\Path',
          imageable_id: 12,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/12_preWorkout_3x',
          version: '1626208519',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/12_preWorkout_3x/1626208519.jpg',
        },
        {
          id: 137912,
          imageable_type: 'App\\Path',
          imageable_id: 12,
          collection_name: 'saved_image',
          name: 'fit52/ugc/12_saved_3x',
          version: '1626208518',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/12_saved_3x/1626208518.jpg',
        },
        {
          id: 137913,
          imageable_type: 'App\\Path',
          imageable_id: 12,
          collection_name: 'social_image',
          name: 'fit52/ugc/12_social_3x',
          version: '1626208518',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/12_social_3x/1626208518.jpg',
        },
        {
          id: 137914,
          imageable_type: 'App\\Path',
          imageable_id: 12,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/12_myPath_3x',
          version: '1626208517',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/12_myPath_3x/1626208517.jpg',
        },
        {
          id: 137915,
          imageable_type: 'App\\Path',
          imageable_id: 12,
          collection_name: 'card_image',
          name: 'fit52/ugc/12_card_3x',
          version: '1626208517',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/12_card_3x/1626208517.jpg',
        },
      ],
    },
    13: {
      id: 13,
      name: "Carrie's Path",
      long_name: "Carrie's Path",
      branded_name: null,
      branded_long_name: null,
      enum_value: 'CARRIES_PATH',
      description:
        "These intermediate workouts allow you and your friends to complete the same workouts as Carrie Underwood herself. With a busy lifestyle and active family life, these HiNote Life workouts 'fit' around Carrie's life. Challenge yourself and feel great!",
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'FULL',
      workouts_per_week: 5,
      is_private: false,
      is_vip: true,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 1,
      images: [
        {
          id: 343601,
          imageable_type: 'App\\Path',
          imageable_id: 13,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/13_pathInfo_3x-min',
          version: '1701799822',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/13_pathInfo_3x-min/1701799822.jpg',
        },
        {
          id: 343602,
          imageable_type: 'App\\Path',
          imageable_id: 13,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/13_preWorkout_3x-min',
          version: '1701799823',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/13_preWorkout_3x-min/1701799823.jpg',
        },
        {
          id: 343603,
          imageable_type: 'App\\Path',
          imageable_id: 13,
          collection_name: 'social_image',
          name: 'fit52/ugc/13_social_3x-min',
          version: '1701799824',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/13_social_3x-min/1701799824.jpg',
        },
        {
          id: 343604,
          imageable_type: 'App\\Path',
          imageable_id: 13,
          collection_name: 'saved_image',
          name: 'fit52/ugc/13_saved_3x-min',
          version: '1701799823',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/13_saved_3x-min/1701799823.jpg',
        },
        {
          id: 343605,
          imageable_type: 'App\\Path',
          imageable_id: 13,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/13_myPath_3x-min',
          version: '1701799821',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/13_myPath_3x-min/1701799821.jpg',
        },
        {
          id: 343606,
          imageable_type: 'App\\Path',
          imageable_id: 13,
          collection_name: 'card_image',
          name: 'fit52/ugc/13_card_3x-min',
          version: '1701799821',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/13_card_3x-min/1701799821.jpg',
        },
      ],
    },
    14: {
      id: 14,
      name: 'Flat On The Floor',
      long_name: 'Flat On The Floor',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'FLAT_ON_THE_FLOOR',
      description:
        "Six intermediate workouts per week. Wow, that's impressive! Join this path if you are ready to push it. We know by the time you have finished these six workouts, you will be 'Flat On The Floor'. But in a good way :)",
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'FULL',
      workouts_per_week: 6,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137922,
          imageable_type: 'App\\Path',
          imageable_id: 14,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/14_pathInfo_3x',
          version: '1626208521',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/14_pathInfo_3x/1626208521.jpg',
        },
        {
          id: 137923,
          imageable_type: 'App\\Path',
          imageable_id: 14,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/14_preWorkout_3x',
          version: '1626208522',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/14_preWorkout_3x/1626208522.jpg',
        },
        {
          id: 137924,
          imageable_type: 'App\\Path',
          imageable_id: 14,
          collection_name: 'saved_image',
          name: 'fit52/ugc/14_saved_3x',
          version: '1626208522',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/14_saved_3x/1626208522.jpg',
        },
        {
          id: 137925,
          imageable_type: 'App\\Path',
          imageable_id: 14,
          collection_name: 'social_image',
          name: 'fit52/ugc/14_social_3x',
          version: '1626208527',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/14_social_3x/1626208527.jpg',
        },
        {
          id: 137926,
          imageable_type: 'App\\Path',
          imageable_id: 14,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/14_myPath_3x',
          version: '1626208521',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/14_myPath_3x/1626208521.jpg',
        },
        {
          id: 137927,
          imageable_type: 'App\\Path',
          imageable_id: 14,
          collection_name: 'card_image',
          name: 'fit52/ugc/14_card_3x',
          version: '1626208520',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/14_card_3x/1626208520.jpg',
        },
      ],
    },
    15: {
      id: 15,
      name: 'Step Up',
      long_name: 'Step Up',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'STEP_UP',
      description:
        "Ready to 'Step Up' to advanced workouts, but only have the time for three short explosive workouts per week? Then this path is for you! While the workouts may only be half the time, the intensity is turned up to full!",
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'HALF',
      workouts_per_week: 3,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137928,
          imageable_type: 'App\\Path',
          imageable_id: 15,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/15_pathInfo_3x',
          version: '1626208527',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/15_pathInfo_3x/1626208527.jpg',
        },
        {
          id: 137929,
          imageable_type: 'App\\Path',
          imageable_id: 15,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/15_preWorkout_3x',
          version: '1626208527',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/15_preWorkout_3x/1626208527.jpg',
        },
        {
          id: 137930,
          imageable_type: 'App\\Path',
          imageable_id: 15,
          collection_name: 'saved_image',
          name: 'fit52/ugc/15_saved_3x',
          version: '1626208527',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/15_saved_3x/1626208527.jpg',
        },
        {
          id: 137931,
          imageable_type: 'App\\Path',
          imageable_id: 15,
          collection_name: 'social_image',
          name: 'fit52/ugc/15_social_3x',
          version: '1626208527',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/15_social_3x/1626208527.jpg',
        },
        {
          id: 137932,
          imageable_type: 'App\\Path',
          imageable_id: 15,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/15_myPath_3x',
          version: '1626208526',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/15_myPath_3x/1626208526.jpg',
        },
        {
          id: 137933,
          imageable_type: 'App\\Path',
          imageable_id: 15,
          collection_name: 'card_image',
          name: 'fit52/ugc/15_card_3x',
          version: '1626208526',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/15_card_3x/1626208526.jpg',
        },
      ],
    },
    16: {
      id: 16,
      name: 'Next Level',
      long_name: 'Next Level',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'NEXT_LEVEL',
      description:
        "Feel like you've mastered the intermediate workouts? Ready for the 'Next Level'? This is the perfect path to show the world what you've got with one advanced workout per week. A great starting path for those wanting to really test themselves at the advanced level. Dumbbells are recommended, but be sure to find the right weight for you. The goal is to feel good and have fun throughout these workouts.",
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'FULL',
      workouts_per_week: 1,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137934,
          imageable_type: 'App\\Path',
          imageable_id: 16,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/16_pathInfo_3x',
          version: '1626208528',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/16_pathInfo_3x/1626208528.jpg',
        },
        {
          id: 137935,
          imageable_type: 'App\\Path',
          imageable_id: 16,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/16_preWorkout_3x',
          version: '1626208529',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/16_preWorkout_3x/1626208529.jpg',
        },
        {
          id: 137936,
          imageable_type: 'App\\Path',
          imageable_id: 16,
          collection_name: 'saved_image',
          name: 'fit52/ugc/16_saved_3x',
          version: '1626208529',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/16_saved_3x/1626208529.jpg',
        },
        {
          id: 137937,
          imageable_type: 'App\\Path',
          imageable_id: 16,
          collection_name: 'social_image',
          name: 'fit52/ugc/16_social_3x',
          version: '1626208529',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/16_social_3x/1626208529.jpg',
        },
        {
          id: 137938,
          imageable_type: 'App\\Path',
          imageable_id: 16,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/16_myPath_3x',
          version: '1626208528',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/16_myPath_3x/1626208528.jpg',
        },
        {
          id: 137939,
          imageable_type: 'App\\Path',
          imageable_id: 16,
          collection_name: 'card_image',
          name: 'fit52/ugc/16_card_3x',
          version: '1626208528',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/16_card_3x/1626208528.jpg',
        },
      ],
    },
    17: {
      id: 17,
      name: 'Push It',
      long_name: 'Push It',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'PUSH_IT',
      description:
        "Time to 'Push It'! Two advanced workouts per week and you have the whole HiNote Life community behind you. We know you can do this! Remember to share your post workout selfie with your path.",
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'FULL',
      workouts_per_week: 2,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137940,
          imageable_type: 'App\\Path',
          imageable_id: 17,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/17_pathInfo_3x',
          version: '1626208530',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/17_pathInfo_3x/1626208530.jpg',
        },
        {
          id: 137941,
          imageable_type: 'App\\Path',
          imageable_id: 17,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/17_preWorkout_3x',
          version: '1626208530',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/17_preWorkout_3x/1626208530.jpg',
        },
        {
          id: 137942,
          imageable_type: 'App\\Path',
          imageable_id: 17,
          collection_name: 'saved_image',
          name: 'fit52/ugc/17_saved_3x',
          version: '1626208530',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/17_saved_3x/1626208530.jpg',
        },
        {
          id: 137943,
          imageable_type: 'App\\Path',
          imageable_id: 17,
          collection_name: 'social_image',
          name: 'fit52/ugc/17_social_3x',
          version: '1626208532',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/17_social_3x/1626208532.jpg',
        },
        {
          id: 137944,
          imageable_type: 'App\\Path',
          imageable_id: 17,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/17_myPath_3x',
          version: '1626208531',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/17_myPath_3x/1626208531.jpg',
        },
        {
          id: 137945,
          imageable_type: 'App\\Path',
          imageable_id: 17,
          collection_name: 'card_image',
          name: 'fit52/ugc/17_card_3x',
          version: '1626208529',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/17_card_3x/1626208529.jpg',
        },
      ],
    },
    18: {
      id: 18,
      name: "Eve's Advanced",
      long_name: "Eve's Advanced",
      branded_name: null,
      branded_long_name: null,
      enum_value: 'EVES_ADVANCED',
      description:
        "These advanced workouts were designed by Carrie's personal trainer, Eve Overland. We may not all have the ability to sing like a rock star, but by joining the 'Eve's Advanced' path, you can train like one!",
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'FULL',
      workouts_per_week: 3,
      is_private: false,
      is_vip: true,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 3,
      images: [
        {
          id: 343595,
          imageable_type: 'App\\Path',
          imageable_id: 18,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/18_pathInfo_3x-min',
          version: '1701799825',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/18_pathInfo_3x-min/1701799825.jpg',
        },
        {
          id: 343596,
          imageable_type: 'App\\Path',
          imageable_id: 18,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/18_preWorkout_3x-min',
          version: '1701799826',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/18_preWorkout_3x-min/1701799826.jpg',
        },
        {
          id: 343597,
          imageable_type: 'App\\Path',
          imageable_id: 18,
          collection_name: 'social_image',
          name: 'fit52/ugc/18_social_3x-min',
          version: '1701799826',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/18_social_3x-min/1701799826.jpg',
        },
        {
          id: 343598,
          imageable_type: 'App\\Path',
          imageable_id: 18,
          collection_name: 'saved_image',
          name: 'fit52/ugc/18_saved_3x-min',
          version: '1701799825',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/18_saved_3x-min/1701799825.jpg',
        },
        {
          id: 343599,
          imageable_type: 'App\\Path',
          imageable_id: 18,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/18_myPath_3x-min',
          version: '1701799824',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/18_myPath_3x-min/1701799824.jpg',
        },
        {
          id: 343600,
          imageable_type: 'App\\Path',
          imageable_id: 18,
          collection_name: 'card_image',
          name: 'fit52/ugc/18_card_3x-min',
          version: '1701799824',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/18_card_3x-min/1701799824.jpg',
        },
      ],
    },
    19: {
      id: 19,
      name: "Can't Stop, Won't Stop",
      long_name: "Can't Stop, Won't Stop",
      branded_name: null,
      branded_long_name: null,
      enum_value: 'CANT_STOP_WONT_STOP',
      description:
        'Each path is different, each workout is different, each week is different. Maybe this path is the right one for you. Maybe you want to just try it? HiNote Life allows you to find your path.',
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'FULL',
      workouts_per_week: 4,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 210442,
          imageable_type: 'App\\Path',
          imageable_id: 19,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/jmab6spxa8oiyyxmhmgf',
          version: '1652968554',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/jmab6spxa8oiyyxmhmgf/1652968554.jpg',
        },
        {
          id: 210443,
          imageable_type: 'App\\Path',
          imageable_id: 19,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/ol5tqrpge0at4ruowxky',
          version: '1652968566',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 7, width: 1241, height: 2681 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1241,trim.height=2681,trim.left=0,trim.top=7/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ol5tqrpge0at4ruowxky/1652968566.jpg',
        },
        {
          id: 210444,
          imageable_type: 'App\\Path',
          imageable_id: 19,
          collection_name: 'social_image',
          name: 'fit52/ugc/p8ueet5yvjloofmjdb8y',
          version: '1652968581',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/p8ueet5yvjloofmjdb8y/1652968581.jpg',
        },
        {
          id: 210445,
          imageable_type: 'App\\Path',
          imageable_id: 19,
          collection_name: 'saved_image',
          name: 'fit52/ugc/uhs4rztxoxfhmzcwd2l8',
          version: '1652968593',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/uhs4rztxoxfhmzcwd2l8/1652968593.jpg',
        },
        {
          id: 210446,
          imageable_type: 'App\\Path',
          imageable_id: 19,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/wzsjw5jp0icpujzqhojz',
          version: '1652968608',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/wzsjw5jp0icpujzqhojz/1652968608.jpg',
        },
        {
          id: 210447,
          imageable_type: 'App\\Path',
          imageable_id: 19,
          collection_name: 'card_image',
          name: 'fit52/ugc/etq0xw5e5p8byjz96wmw',
          version: '1652968619',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/etq0xw5e5p8byjz96wmw/1652968619.jpg',
        },
      ],
    },
    20: {
      id: 20,
      name: 'Work Hard, Work Out Harder!',
      long_name: 'Work Hard, Work Out Harder!',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'WORK_HARD_WORK_OUT_HARDER',
      description:
        "You're putting in the hours at work, at life, just being you. You're also putting in the hours working out. This path is for those really looking to push it. Five advanced workouts per week. With this path you're really committing to working hard, and working out harder!",
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'FULL',
      workouts_per_week: 5,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 210436,
          imageable_type: 'App\\Path',
          imageable_id: 20,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/tvwdioafex3c7mab3qnz',
          version: '1652968456',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/tvwdioafex3c7mab3qnz/1652968456.jpg',
        },
        {
          id: 210437,
          imageable_type: 'App\\Path',
          imageable_id: 20,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/e7lxb7ogwwroi5fcer60',
          version: '1652968468',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 7, width: 1241, height: 2681 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1241,trim.height=2681,trim.left=0,trim.top=7/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/e7lxb7ogwwroi5fcer60/1652968468.jpg',
        },
        {
          id: 210438,
          imageable_type: 'App\\Path',
          imageable_id: 20,
          collection_name: 'social_image',
          name: 'fit52/ugc/iskaj4qba3lszaxbhtqj',
          version: '1652968481',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/iskaj4qba3lszaxbhtqj/1652968481.jpg',
        },
        {
          id: 210439,
          imageable_type: 'App\\Path',
          imageable_id: 20,
          collection_name: 'saved_image',
          name: 'fit52/ugc/cpqc9il5dk3zx1khrhd3',
          version: '1652968492',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/cpqc9il5dk3zx1khrhd3/1652968492.jpg',
        },
        {
          id: 210440,
          imageable_type: 'App\\Path',
          imageable_id: 20,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/kn5kmvxxvwvbgoyz4ekj',
          version: '1652968507',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/kn5kmvxxvwvbgoyz4ekj/1652968507.jpg',
        },
        {
          id: 210441,
          imageable_type: 'App\\Path',
          imageable_id: 20,
          collection_name: 'card_image',
          name: 'fit52/ugc/miie6kttoqihxnvkafwv',
          version: '1652968519',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/miie6kttoqihxnvkafwv/1652968519.jpg',
        },
      ],
    },
    21: {
      id: 21,
      name: "Eve's Extreme",
      long_name: "Eve's Extreme",
      branded_name: null,
      branded_long_name: null,
      enum_value: 'EVES_EXTREME',
      description:
        "Burpees for breakfast? Lunges for lunch? Divebombers for dinner? If this sounds like you, then you've found the right path with 'Eve's Extreme'. Six advanced workouts each week designed by Carrie's personal trainer, Eve Overland. This is intense, but it's your chance to show the world what you've got. Just remember to enjoy that rest day :)",
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'FULL',
      workouts_per_week: 6,
      is_private: false,
      is_vip: true,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100000000,
      campaign_guid: null,
      order: 4,
      images: [
        {
          id: 343589,
          imageable_type: 'App\\Path',
          imageable_id: 21,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/21_pathInfo_3x-min',
          version: '1701799827',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/21_pathInfo_3x-min/1701799827.jpg',
        },
        {
          id: 343590,
          imageable_type: 'App\\Path',
          imageable_id: 21,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/21_preWorkout_3x-min',
          version: '1701799828',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/21_preWorkout_3x-min/1701799828.jpg',
        },
        {
          id: 343591,
          imageable_type: 'App\\Path',
          imageable_id: 21,
          collection_name: 'social_image',
          name: 'fit52/ugc/21_social_3x-min',
          version: '1701799828',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/21_social_3x-min/1701799828.jpg',
        },
        {
          id: 343592,
          imageable_type: 'App\\Path',
          imageable_id: 21,
          collection_name: 'saved_image',
          name: 'fit52/ugc/21_saved_3x-min',
          version: '1701799828',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/21_saved_3x-min/1701799828.jpg',
        },
        {
          id: 343593,
          imageable_type: 'App\\Path',
          imageable_id: 21,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/21_myPath_3x-min',
          version: '1701799827',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/21_myPath_3x-min/1701799827.jpg',
        },
        {
          id: 343594,
          imageable_type: 'App\\Path',
          imageable_id: 21,
          collection_name: 'card_image',
          name: 'fit52/ugc/21_card_3x-min',
          version: '1701799826',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: 457414,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/21_card_3x-min/1701799826.jpg',
        },
      ],
    },
    22: {
      id: 22,
      name: "Let's Get Moving!",
      long_name: "Let's Get Moving!",
      branded_name: null,
      branded_long_name: null,
      enum_value: 'LETS_GET_MOVING',
      description:
        'Curious what HiNote Life is all about, but not ready for a multi-day commitment? Well, you have found the right path! Start with one half workout per week and get moving. This is a great way to ease into HiNote Life, we are excited to see what you can do on your fitness journey!',
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'HALF',
      workouts_per_week: 1,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137970,
          imageable_type: 'App\\Path',
          imageable_id: 22,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/22_pathInfo_3x',
          version: '1626208569',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/22_pathInfo_3x/1626208569.jpg',
        },
        {
          id: 137971,
          imageable_type: 'App\\Path',
          imageable_id: 22,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/22_preWorkout_3x',
          version: '1626208570',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/22_preWorkout_3x/1626208570.jpg',
        },
        {
          id: 137972,
          imageable_type: 'App\\Path',
          imageable_id: 22,
          collection_name: 'saved_image',
          name: 'fit52/ugc/22_saved_3x',
          version: '1626208570',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/22_saved_3x/1626208570.jpg',
        },
        {
          id: 137973,
          imageable_type: 'App\\Path',
          imageable_id: 22,
          collection_name: 'social_image',
          name: 'fit52/ugc/22_social_3x',
          version: '1626208573',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/22_social_3x/1626208573.jpg',
        },
        {
          id: 137974,
          imageable_type: 'App\\Path',
          imageable_id: 22,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/22_myPath_3x',
          version: '1626208569',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/22_myPath_3x/1626208569.jpg',
        },
        {
          id: 137975,
          imageable_type: 'App\\Path',
          imageable_id: 22,
          collection_name: 'card_image',
          name: 'fit52/ugc/22_card_3x',
          version: '1626208569',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/22_card_3x/1626208569.jpg',
        },
      ],
    },
    23: {
      id: 23,
      name: 'Kickstart',
      long_name: 'Kickstart',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'KICKSTART',
      description:
        "Looking for a beginner introduction to ease your way into HiNote Life? The 'Kickstart' path helps you get going, and from here you can progress into full workouts or a higher frequency of workouts per week. Each of these workouts can be completed in less than 30 minutes.",
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'HALF',
      workouts_per_week: 3,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137976,
          imageable_type: 'App\\Path',
          imageable_id: 23,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/23_pathInfo_3x',
          version: '1626457938',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/23_pathInfo_3x/1626457938.jpg',
        },
        {
          id: 137977,
          imageable_type: 'App\\Path',
          imageable_id: 23,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/23_preWorkout_3x',
          version: '1626457938',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/23_preWorkout_3x/1626457938.jpg',
        },
        {
          id: 137978,
          imageable_type: 'App\\Path',
          imageable_id: 23,
          collection_name: 'saved_image',
          name: 'fit52/ugc/23_saved_3x',
          version: '1626457939',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/23_saved_3x/1626457939.jpg',
        },
        {
          id: 137979,
          imageable_type: 'App\\Path',
          imageable_id: 23,
          collection_name: 'social_image',
          name: 'fit52/ugc/23_social_3x',
          version: '1626457939',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/23_social_3x/1626457939.jpg',
        },
        {
          id: 137980,
          imageable_type: 'App\\Path',
          imageable_id: 23,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/23_myPath_3x',
          version: '1626457938',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/23_myPath_3x/1626457938.jpg',
        },
        {
          id: 137981,
          imageable_type: 'App\\Path',
          imageable_id: 23,
          collection_name: 'card_image',
          name: 'fit52/ugc/23_card_3x',
          version: '1626457937',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/23_card_3x/1626457937.jpg',
        },
      ],
    },
    24: {
      id: 24,
      name: 'Moving On Up',
      long_name: 'Moving On Up',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'MOVING_ON_UP',
      description:
        "Way to work it! With this path, your goal is to complete four half workouts per week. Sounds daunting? Don't worry, you have the support of the entire HiNote Life community!",
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'HALF',
      workouts_per_week: 4,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 137982,
          imageable_type: 'App\\Path',
          imageable_id: 24,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/24_pathInfo_3x',
          version: '1626457949',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/24_pathInfo_3x/1626457949.jpg',
        },
        {
          id: 137983,
          imageable_type: 'App\\Path',
          imageable_id: 24,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/24_preWorkout_3x',
          version: '1626457949',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/24_preWorkout_3x/1626457949.jpg',
        },
        {
          id: 137984,
          imageable_type: 'App\\Path',
          imageable_id: 24,
          collection_name: 'saved_image',
          name: 'fit52/ugc/24_saved_3x',
          version: '1626457950',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/24_saved_3x/1626457950.jpg',
        },
        {
          id: 137985,
          imageable_type: 'App\\Path',
          imageable_id: 24,
          collection_name: 'social_image',
          name: 'fit52/ugc/24_social_3x',
          version: '1626457950',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/24_social_3x/1626457950.jpg',
        },
        {
          id: 137986,
          imageable_type: 'App\\Path',
          imageable_id: 24,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/24_myPath_3x',
          version: '1626457949',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/24_myPath_3x/1626457949.jpg',
        },
        {
          id: 137987,
          imageable_type: 'App\\Path',
          imageable_id: 24,
          collection_name: 'card_image',
          name: 'fit52/ugc/24_card_3x',
          version: '1626457940',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/24_card_3x/1626457940.jpg',
        },
      ],
    },
    25: {
      id: 25,
      name: 'Mix It Up',
      long_name: 'Mix It Up',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'MIX_IT_UP',
      description:
        'Five half workouts per week. Go you! You could be a Monday-Friday type of person, work out on weekends, or every week is different. With HiNote Life, you just do what works best for you.',
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'HALF',
      workouts_per_week: 5,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 210430,
          imageable_type: 'App\\Path',
          imageable_id: 25,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/azwfql7ovciffqjjauvp',
          version: '1652968356',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/azwfql7ovciffqjjauvp/1652968356.jpg',
        },
        {
          id: 210431,
          imageable_type: 'App\\Path',
          imageable_id: 25,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/farr4c0fmjtqxbjisgvf',
          version: '1652968368',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 7, width: 1241, height: 2681 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1241,trim.height=2681,trim.left=0,trim.top=7/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/farr4c0fmjtqxbjisgvf/1652968368.jpg',
        },
        {
          id: 210432,
          imageable_type: 'App\\Path',
          imageable_id: 25,
          collection_name: 'social_image',
          name: 'fit52/ugc/hucdca8l5r0ulmut72if',
          version: '1652968383',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/hucdca8l5r0ulmut72if/1652968383.jpg',
        },
        {
          id: 210433,
          imageable_type: 'App\\Path',
          imageable_id: 25,
          collection_name: 'saved_image',
          name: 'fit52/ugc/nhlep7fuq0odzrtl24ox',
          version: '1652968394',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/nhlep7fuq0odzrtl24ox/1652968394.jpg',
        },
        {
          id: 210434,
          imageable_type: 'App\\Path',
          imageable_id: 25,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/m1g0cu1f8ulz5kuu2x8r',
          version: '1652968408',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/m1g0cu1f8ulz5kuu2x8r/1652968408.jpg',
        },
        {
          id: 210435,
          imageable_type: 'App\\Path',
          imageable_id: 25,
          collection_name: 'card_image',
          name: 'fit52/ugc/rngnrqgnpw3io1vfgfqr',
          version: '1652968419',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/rngnrqgnpw3io1vfgfqr/1652968419.jpg',
        },
      ],
    },
    26: {
      id: 26,
      name: 'Card Shark',
      long_name: 'Card Shark',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'CARD_SHARK',
      description:
        'With this path, you really are a card shark. You will see 26 different cards in your half workouts, six days per week. With this many cards, you are well on your way to full workouts.',
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'HALF',
      workouts_per_week: 6,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 210424,
          imageable_type: 'App\\Path',
          imageable_id: 26,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/woq0cbdr6gelfms7y0oq',
          version: '1652968262',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/woq0cbdr6gelfms7y0oq/1652968262.jpg',
        },
        {
          id: 210425,
          imageable_type: 'App\\Path',
          imageable_id: 26,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/lbhamet9uq56lis8nibb',
          version: '1652968273',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 7, width: 1241, height: 2681 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1241,trim.height=2681,trim.left=0,trim.top=7/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/lbhamet9uq56lis8nibb/1652968273.jpg',
        },
        {
          id: 210426,
          imageable_type: 'App\\Path',
          imageable_id: 26,
          collection_name: 'social_image',
          name: 'fit52/ugc/nbpqfdey4wimbibceq6a',
          version: '1652968286',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/nbpqfdey4wimbibceq6a/1652968286.jpg',
        },
        {
          id: 210427,
          imageable_type: 'App\\Path',
          imageable_id: 26,
          collection_name: 'saved_image',
          name: 'fit52/ugc/pdhxorrbn6v0dmlzyylc',
          version: '1652968296',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/pdhxorrbn6v0dmlzyylc/1652968296.jpg',
        },
        {
          id: 210428,
          imageable_type: 'App\\Path',
          imageable_id: 26,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/a6tscysqbxbqkvwsixpa',
          version: '1652968308',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/a6tscysqbxbqkvwsixpa/1652968308.jpg',
        },
        {
          id: 210429,
          imageable_type: 'App\\Path',
          imageable_id: 26,
          collection_name: 'card_image',
          name: 'fit52/ugc/vlyhthpa2xmvpua9ricu',
          version: '1652968318',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/vlyhthpa2xmvpua9ricu/1652968318.jpg',
        },
      ],
    },
    27: {
      id: 27,
      name: 'Making Me-Time',
      long_name: 'Making Me-Time',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'MAKING_ME_TIME',
      description:
        "We all know how important fitness is for your physical and mental health, and this path is all about making 'me-time'. Two half workouts per week. You are doing it for you!",
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'HALF',
      workouts_per_week: 2,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 230606,
          imageable_type: 'App\\Path',
          imageable_id: 27,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/dyex9yuzaecyoycepapi',
          version: '1659553544',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/dyex9yuzaecyoycepapi/1659553544.jpg',
        },
        {
          id: 230607,
          imageable_type: 'App\\Path',
          imageable_id: 27,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/qe9gwpqyt4i1j28ly3sz',
          version: '1659553555',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 7, width: 1241, height: 2681 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1241,trim.height=2681,trim.left=0,trim.top=7/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/qe9gwpqyt4i1j28ly3sz/1659553555.jpg',
        },
        {
          id: 230608,
          imageable_type: 'App\\Path',
          imageable_id: 27,
          collection_name: 'social_image',
          name: 'fit52/ugc/unh9hrsnbupkyrk4wygk',
          version: '1659553566',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/unh9hrsnbupkyrk4wygk/1659553566.jpg',
        },
        {
          id: 230609,
          imageable_type: 'App\\Path',
          imageable_id: 27,
          collection_name: 'saved_image',
          name: 'fit52/ugc/tr1zxbim3gssapfb3q1p',
          version: '1659553578',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/tr1zxbim3gssapfb3q1p/1659553578.jpg',
        },
        {
          id: 230610,
          imageable_type: 'App\\Path',
          imageable_id: 27,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/xr2si9b7afdvtb5sbebx',
          version: '1659553591',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/xr2si9b7afdvtb5sbebx/1659553591.jpg',
        },
        {
          id: 230611,
          imageable_type: 'App\\Path',
          imageable_id: 27,
          collection_name: 'card_image',
          name: 'fit52/ugc/epch82esiorbguh7zvmp',
          version: '1659553604',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/epch82esiorbguh7zvmp/1659553604.jpg',
        },
      ],
    },
    28: {
      id: 28,
      name: 'Push Yourself',
      long_name: 'Push Yourself',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'PUSH_YOURSELF',
      description:
        "This path is about pushing yourself, four half workouts per week. It's less than two hours per week, but with these intermediate workouts, you are really pushing yourself.",
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'HALF',
      workouts_per_week: 4,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 210416,
          imageable_type: 'App\\Path',
          imageable_id: 28,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/lre0uzlzh62cxer8cajc',
          version: '1652968173',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/lre0uzlzh62cxer8cajc/1652968173.jpg',
        },
        {
          id: 210417,
          imageable_type: 'App\\Path',
          imageable_id: 28,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/mirh13a32uqnu4c4zkhd',
          version: '1652968185',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 7, width: 1241, height: 2681 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1241,trim.height=2681,trim.left=0,trim.top=7/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/mirh13a32uqnu4c4zkhd/1652968185.jpg',
        },
        {
          id: 210418,
          imageable_type: 'App\\Path',
          imageable_id: 28,
          collection_name: 'social_image',
          name: 'fit52/ugc/j8fjtxuxfpzjctjh84dl',
          version: '1652968196',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/j8fjtxuxfpzjctjh84dl/1652968196.jpg',
        },
        {
          id: 210419,
          imageable_type: 'App\\Path',
          imageable_id: 28,
          collection_name: 'saved_image',
          name: 'fit52/ugc/icfihimeporugr65hjvh',
          version: '1652968207',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/icfihimeporugr65hjvh/1652968207.jpg',
        },
        {
          id: 210420,
          imageable_type: 'App\\Path',
          imageable_id: 28,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/nxj5ve1dax9xmhwg5t38',
          version: '1652968218',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/nxj5ve1dax9xmhwg5t38/1652968218.jpg',
        },
        {
          id: 210421,
          imageable_type: 'App\\Path',
          imageable_id: 28,
          collection_name: 'card_image',
          name: 'fit52/ugc/k2byiewt8ebbdsxplug9',
          version: '1652968230',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/k2byiewt8ebbdsxplug9/1652968230.jpg',
        },
      ],
    },
    29: {
      id: 29,
      name: 'This is my Self-Care',
      long_name: 'This is my Self-Care',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'THIS_IS_MY_SELF_CARE',
      description:
        'With this path, you are working out five times per week, five fresh and fun HiNote Life workouts. Now that is what we call self-care.',
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'HALF',
      workouts_per_week: 5,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 210408,
          imageable_type: 'App\\Path',
          imageable_id: 29,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/pwwebkb6zua3luqpdwbv',
          version: '1652968077',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/pwwebkb6zua3luqpdwbv/1652968077.jpg',
        },
        {
          id: 210409,
          imageable_type: 'App\\Path',
          imageable_id: 29,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/a3fjmxa7wxdtxx6swpug',
          version: '1652968092',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 7, width: 1241, height: 2681 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1241,trim.height=2681,trim.left=0,trim.top=7/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/a3fjmxa7wxdtxx6swpug/1652968092.jpg',
        },
        {
          id: 210410,
          imageable_type: 'App\\Path',
          imageable_id: 29,
          collection_name: 'social_image',
          name: 'fit52/ugc/wwnquqwnb60eb8t4y9v1',
          version: '1652968104',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/wwnquqwnb60eb8t4y9v1/1652968104.jpg',
        },
        {
          id: 210411,
          imageable_type: 'App\\Path',
          imageable_id: 29,
          collection_name: 'saved_image',
          name: 'fit52/ugc/g5lpg4fpxyen27p32hi4',
          version: '1652968115',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/g5lpg4fpxyen27p32hi4/1652968115.jpg',
        },
        {
          id: 210412,
          imageable_type: 'App\\Path',
          imageable_id: 29,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/isn2t2a9nd45vpwdqxcb',
          version: '1652968126',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/isn2t2a9nd45vpwdqxcb/1652968126.jpg',
        },
        {
          id: 210413,
          imageable_type: 'App\\Path',
          imageable_id: 29,
          collection_name: 'card_image',
          name: 'fit52/ugc/tfkhaajljtewei6wxcvw',
          version: '1652968138',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/tfkhaajljtewei6wxcvw/1652968138.jpg',
        },
      ],
    },
    30: {
      id: 30,
      name: 'Feeling Strong!',
      long_name: 'Feeling Strong!',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'FEELING_STRONG',
      description:
        'Six half workouts per week might sound like a lot, but you are not alone during this journey. The HiNote Life community is here to support you achieve your fitness goals, and together we are strong!',
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'HALF',
      workouts_per_week: 6,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 230613,
          imageable_type: 'App\\Path',
          imageable_id: 30,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/zrlajrlbep8ghwxiu84f',
          version: '1659553664',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/zrlajrlbep8ghwxiu84f/1659553664.jpg',
        },
        {
          id: 230614,
          imageable_type: 'App\\Path',
          imageable_id: 30,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/j9hqy65s26zgnzyxuqgm',
          version: '1659553682',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 7, width: 1241, height: 2681 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1241,trim.height=2681,trim.left=0,trim.top=7/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/j9hqy65s26zgnzyxuqgm/1659553682.jpg',
        },
        {
          id: 230615,
          imageable_type: 'App\\Path',
          imageable_id: 30,
          collection_name: 'social_image',
          name: 'fit52/ugc/b2hyuupennyewy7fe3js',
          version: '1659553695',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/b2hyuupennyewy7fe3js/1659553695.jpg',
        },
        {
          id: 230616,
          imageable_type: 'App\\Path',
          imageable_id: 30,
          collection_name: 'saved_image',
          name: 'fit52/ugc/hmtbt2hu9oihe7qtapom',
          version: '1659553705',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/hmtbt2hu9oihe7qtapom/1659553705.jpg',
        },
        {
          id: 230617,
          imageable_type: 'App\\Path',
          imageable_id: 30,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/ybcscadeum7yl2qvpl3x',
          version: '1659553716',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ybcscadeum7yl2qvpl3x/1659553716.jpg',
        },
        {
          id: 230618,
          imageable_type: 'App\\Path',
          imageable_id: 30,
          collection_name: 'card_image',
          name: 'fit52/ugc/qdxthayxu9uxua9cqph5',
          version: '1659553728',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/qdxthayxu9uxua9cqph5/1659553728.jpg',
        },
      ],
    },
    31: {
      id: 31,
      name: 'Type Two Fun',
      long_name: 'Type Two Fun',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'TYPE_TWO_FUN',
      description:
        "Two advanced half workouts per week may be a challenge, but you're up for it! Get ready to work up a sweat.",
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'HALF',
      workouts_per_week: 2,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 210402,
          imageable_type: 'App\\Path',
          imageable_id: 31,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/xuwwskkkfpckzs42cp3e',
          version: '1652967973',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1242, height: 858 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=858,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/xuwwskkkfpckzs42cp3e/1652967973.jpg',
        },
        {
          id: 210403,
          imageable_type: 'App\\Path',
          imageable_id: 31,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/nzukuxhjhshyjt03q09a',
          version: '1652967986',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 7, y: 0, width: 1230, height: 2655 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1230,trim.height=2655,trim.left=7,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/nzukuxhjhshyjt03q09a/1652967986.jpg',
        },
        {
          id: 210404,
          imageable_type: 'App\\Path',
          imageable_id: 31,
          collection_name: 'social_image',
          name: 'fit52/ugc/uiggsiyd0umhpzmn0md7',
          version: '1652968003',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 1176, height: 896 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1176,trim.height=896,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/uiggsiyd0umhpzmn0md7/1652968003.jpg',
        },
        {
          id: 210405,
          imageable_type: 'App\\Path',
          imageable_id: 31,
          collection_name: 'saved_image',
          name: 'fit52/ugc/zlmorkdqdioqarj1i6qd',
          version: '1652968015',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 391, height: 298 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=391,trim.height=298,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/zlmorkdqdioqarj1i6qd/1652968015.jpg',
        },
        {
          id: 210406,
          imageable_type: 'App\\Path',
          imageable_id: 31,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/bgckgs5litfpbwqix9b9',
          version: '1652968027',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 2, y: 0, width: 1239, height: 712 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=712,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/bgckgs5litfpbwqix9b9/1652968027.jpg',
        },
        {
          id: 210407,
          imageable_type: 'App\\Path',
          imageable_id: 31,
          collection_name: 'card_image',
          name: 'fit52/ugc/k2zk9zsxjx8cvj0pe6cv',
          version: '1652968039',
          folder: 'image',
          format: 'jpg',
          manipulations: { crop: { x: 0, y: 0, width: 471, height: 617 } },
          user_id: 397939,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=471,trim.height=617,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/k2zk9zsxjx8cvj0pe6cv/1652968039.jpg',
        },
      ],
    },
    32: {
      id: 32,
      name: 'Four Times For Me',
      long_name: 'Four Times For Me',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'FOUR_TIMES_FOR_ME',
      description:
        'Four times per week, four half workouts, four times the fun? Grab some dumbbells and give this path a try to really challenge yourself.',
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'HALF',
      workouts_per_week: 4,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 138030,
          imageable_type: 'App\\Path',
          imageable_id: 32,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/32_pathInfo_3x',
          version: '1626208610',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/32_pathInfo_3x/1626208610.jpg',
        },
        {
          id: 138031,
          imageable_type: 'App\\Path',
          imageable_id: 32,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/32_preWorkout_3x',
          version: '1626208611',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/32_preWorkout_3x/1626208611.jpg',
        },
        {
          id: 138032,
          imageable_type: 'App\\Path',
          imageable_id: 32,
          collection_name: 'saved_image',
          name: 'fit52/ugc/32_saved_3x',
          version: '1626208611',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/32_saved_3x/1626208611.jpg',
        },
        {
          id: 138033,
          imageable_type: 'App\\Path',
          imageable_id: 32,
          collection_name: 'social_image',
          name: 'fit52/ugc/32_social_3x',
          version: '1626208613',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/32_social_3x/1626208613.jpg',
        },
        {
          id: 138034,
          imageable_type: 'App\\Path',
          imageable_id: 32,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/32_myPath_3x',
          version: '1626208610',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/32_myPath_3x/1626208610.jpg',
        },
        {
          id: 138035,
          imageable_type: 'App\\Path',
          imageable_id: 32,
          collection_name: 'card_image',
          name: 'fit52/ugc/32_card_3x',
          version: '1626208610',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/32_card_3x/1626208610.jpg',
        },
      ],
    },
    33: {
      id: 33,
      name: 'High Fives for Days',
      long_name: 'High Fives for Days',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'HIGH_FIVES_FOR_DAYS',
      description: 'As the name suggests, this path is all about the fives.',
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'HALF',
      workouts_per_week: 5,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 138036,
          imageable_type: 'App\\Path',
          imageable_id: 33,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/33_pathInfo_3x',
          version: '1626208620',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/33_pathInfo_3x/1626208620.jpg',
        },
        {
          id: 138037,
          imageable_type: 'App\\Path',
          imageable_id: 33,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/33_preWorkout_3x',
          version: '1626208620',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/33_preWorkout_3x/1626208620.jpg',
        },
        {
          id: 138038,
          imageable_type: 'App\\Path',
          imageable_id: 33,
          collection_name: 'saved_image',
          name: 'fit52/ugc/33_saved_3x',
          version: '1626208620',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/33_saved_3x/1626208620.jpg',
        },
        {
          id: 138039,
          imageable_type: 'App\\Path',
          imageable_id: 33,
          collection_name: 'social_image',
          name: 'fit52/ugc/33_social_3x',
          version: '1626208621',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/33_social_3x/1626208621.jpg',
        },
        {
          id: 138040,
          imageable_type: 'App\\Path',
          imageable_id: 33,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/33_myPath_3x',
          version: '1626208619',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/33_myPath_3x/1626208619.jpg',
        },
        {
          id: 138041,
          imageable_type: 'App\\Path',
          imageable_id: 33,
          collection_name: 'card_image',
          name: 'fit52/ugc/33_card_3x',
          version: '1626208619',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/33_card_3x/1626208619.jpg',
        },
      ],
    },
    34: {
      id: 34,
      name: 'Going Beyond',
      long_name: 'Going Beyond',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'GOING_BEYOND',
      description:
        'You really are going above and beyond with this path. Six advanced half workouts per week. You are really going to feel this one.',
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'HALF',
      workouts_per_week: 6,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100020000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 138042,
          imageable_type: 'App\\Path',
          imageable_id: 34,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/34_pathInfo_3x',
          version: '1626208621',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/34_pathInfo_3x/1626208621.jpg',
        },
        {
          id: 138043,
          imageable_type: 'App\\Path',
          imageable_id: 34,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/34_preWorkout_3x',
          version: '1626208622',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/34_preWorkout_3x/1626208622.jpg',
        },
        {
          id: 138044,
          imageable_type: 'App\\Path',
          imageable_id: 34,
          collection_name: 'saved_image',
          name: 'fit52/ugc/34_saved_3x',
          version: '1626208622',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/34_saved_3x/1626208622.jpg',
        },
        {
          id: 138045,
          imageable_type: 'App\\Path',
          imageable_id: 34,
          collection_name: 'social_image',
          name: 'fit52/ugc/34_social_3x',
          version: '1626208622',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/34_social_3x/1626208622.jpg',
        },
        {
          id: 138046,
          imageable_type: 'App\\Path',
          imageable_id: 34,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/34_myPath_3x',
          version: '1626208621',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/34_myPath_3x/1626208621.jpg',
        },
        {
          id: 138047,
          imageable_type: 'App\\Path',
          imageable_id: 34,
          collection_name: 'card_image',
          name: 'fit52/ugc/34_card_3x',
          version: '1626208621',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/34_card_3x/1626208621.jpg',
        },
      ],
    },
    35: {
      id: 35,
      name: "Mike's Path",
      long_name: "Mike's Path",
      branded_name: null,
      branded_long_name: null,
      enum_value: 'MIKES_PATH',
      description:
        "Ever wanted to train like a pro athlete? Now you can, with 'Mike's Path'! Challenge yourself to complete four advanced workouts per week, and join Mike Fisher, former NHL player, in these high-intensity workouts that will get you ready for any big game!",
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'FULL',
      workouts_per_week: 4,
      is_private: false,
      is_vip: true,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      min_app_version: 100040000,
      campaign_guid: null,
      order: 5,
      images: [
        {
          id: 138048,
          imageable_type: 'App\\Path',
          imageable_id: 35,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/35_pathInfo_3x',
          version: '1626208629',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/35_pathInfo_3x/1626208629.jpg',
        },
        {
          id: 138049,
          imageable_type: 'App\\Path',
          imageable_id: 35,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/35_preWorkout_3x',
          version: '1626208629',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/35_preWorkout_3x/1626208629.jpg',
        },
        {
          id: 138050,
          imageable_type: 'App\\Path',
          imageable_id: 35,
          collection_name: 'saved_image',
          name: 'fit52/ugc/35_saved_3x',
          version: '1626208629',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/35_saved_3x/1626208629.jpg',
        },
        {
          id: 138051,
          imageable_type: 'App\\Path',
          imageable_id: 35,
          collection_name: 'social_image',
          name: 'fit52/ugc/35_social_3x',
          version: '1626208630',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/35_social_3x/1626208630.jpg',
        },
        {
          id: 138052,
          imageable_type: 'App\\Path',
          imageable_id: 35,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/35_myPath_3x',
          version: '1626208629',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/35_myPath_3x/1626208629.jpg',
        },
        {
          id: 138053,
          imageable_type: 'App\\Path',
          imageable_id: 35,
          collection_name: 'card_image',
          name: 'fit52/ugc/35_card_3x',
          version: '1626208622',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/35_card_3x/1626208622.jpg',
        },
      ],
    },
    36: {
      id: 36,
      name: 'Commit to Fit',
      long_name: 'Commit to Fit',
      branded_name: 'Commit to Fit',
      branded_long_name: 'Commit to Fit with BODYARMOR',
      enum_value: 'COMMIT_TO_FIT',
      description:
        'This is the perfect path to help you Commit to Fit. Start strong with four fun workouts per week. Share your success and show us how you Commit to Fit!',
      branded_description:
        "This is the perfect path to help you Commit to Fit in 2021. Start the year out strong with four fun workouts per week with BODYARMOR LYTE. As a member of the 'Commit to Fit' path, you can unlock exclusive rewards and achievements ─ courtesy of our friends at BODYARMOR. Share your success and show us how you Commit to Fit!",
      fitness_level: 'BEGINNER',
      workout_template_type: 'FULL',
      workouts_per_week: 4,
      is_private: false,
      is_vip: true,
      author: null,
      equipment: [],
      min_app_version: 100060000,
      campaign_guid: 'BODY_ARMOR_COMMIT_TO_FIT',
      order: 2,
      images: [
        {
          id: 138054,
          imageable_type: 'App\\Path',
          imageable_id: 36,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/36_pathInfo_3x',
          version: '1626208631',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/36_pathInfo_3x/1626208631.jpg',
        },
        {
          id: 138055,
          imageable_type: 'App\\Path',
          imageable_id: 36,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/36_preWorkout_3x',
          version: '1626208631',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/36_preWorkout_3x/1626208631.jpg',
        },
        {
          id: 138056,
          imageable_type: 'App\\Path',
          imageable_id: 36,
          collection_name: 'saved_image',
          name: 'fit52/ugc/36_saved_3x',
          version: '1626208631',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/36_saved_3x/1626208631.jpg',
        },
        {
          id: 138057,
          imageable_type: 'App\\Path',
          imageable_id: 36,
          collection_name: 'social_image',
          name: 'fit52/ugc/36_social_3x',
          version: '1626208638',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/36_social_3x/1626208638.jpg',
        },
        {
          id: 138058,
          imageable_type: 'App\\Path',
          imageable_id: 36,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/36_myPath_3x',
          version: '1626208631',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/36_myPath_3x/1626208631.jpg',
        },
        {
          id: 138059,
          imageable_type: 'App\\Path',
          imageable_id: 36,
          collection_name: 'card_image',
          name: 'fit52/ugc/36_card_3x',
          version: '1626208630',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/36_card_3x/1626208630.jpg',
        },
        {
          id: 138060,
          imageable_type: 'App\\Path',
          imageable_id: 36,
          collection_name: 'path_info_branded_image',
          name: 'fit52/ugc/36_pathInfo_branded_3x',
          version: '1626208631',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/36_pathInfo_branded_3x/1626208631.jpg',
        },
      ],
    },
    37: {
      id: 37,
      name: 'Getting Back Into It!',
      long_name: 'Getting Back Into It!',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'GETTING_BACK_INTO_IT',
      description:
        "Ready to kick it up a notch once a week? We understand multi-day commitments are difficult but that won't stop you from achieving your fitness goals. Our intermediate level workout is only a half workout per week. It's the perfect path to get you into more intense exercises without over-committing.",
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'HALF',
      workouts_per_week: 1,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      min_app_version: 200070000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 232498,
          imageable_type: 'App\\Path',
          imageable_id: 37,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/GETTING_BACK_INTO_IT__pathInfo_3x',
          version: '1657742091',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/GETTING_BACK_INTO_IT__pathInfo_3x/1657742091.jpg',
        },
        {
          id: 232499,
          imageable_type: 'App\\Path',
          imageable_id: 37,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/GETTING_BACK_INTO_IT__preWorkout_3x',
          version: '1657742091',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/GETTING_BACK_INTO_IT__preWorkout_3x/1657742091.jpg',
        },
        {
          id: 232500,
          imageable_type: 'App\\Path',
          imageable_id: 37,
          collection_name: 'saved_image',
          name: 'fit52/ugc/GETTING_BACK_INTO_IT__saved_3x',
          version: '1657742091',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/GETTING_BACK_INTO_IT__saved_3x/1657742091.jpg',
        },
        {
          id: 232501,
          imageable_type: 'App\\Path',
          imageable_id: 37,
          collection_name: 'social_image',
          name: 'fit52/ugc/GETTING_BACK_INTO_IT__social_3x',
          version: '1657742091',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/GETTING_BACK_INTO_IT__social_3x/1657742091.jpg',
        },
        {
          id: 232502,
          imageable_type: 'App\\Path',
          imageable_id: 37,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/GETTING_BACK_INTO_IT__myPath_3x',
          version: '1657742091',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/GETTING_BACK_INTO_IT__myPath_3x/1657742091.jpg',
        },
        {
          id: 232503,
          imageable_type: 'App\\Path',
          imageable_id: 37,
          collection_name: 'card_image',
          name: 'fit52/ugc/GETTING_BACK_INTO_IT__card_3x',
          version: '1657742091',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/GETTING_BACK_INTO_IT__card_3x/1657742091.jpg',
        },
      ],
    },
    38: {
      id: 38,
      name: 'Ready To Rock!',
      long_name: 'Ready To Rock!',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'READY_TO_ROCK',
      description:
        'Have you reached your full potential with intermediate workouts? Ease into advanced workouts with this one day a week program. With this path, each half workout will bring you closer to reaching your fitness goals without overscheduling yourself.',
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'HALF',
      workouts_per_week: 1,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      min_app_version: 200070000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 232504,
          imageable_type: 'App\\Path',
          imageable_id: 38,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/READY_TO_ROCK__pathInfo_3x',
          version: '1657742093',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/READY_TO_ROCK__pathInfo_3x/1657742093.jpg',
        },
        {
          id: 232505,
          imageable_type: 'App\\Path',
          imageable_id: 38,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/READY_TO_ROCK__preWorkout_3x',
          version: '1657742093',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/READY_TO_ROCK__preWorkout_3x/1657742093.jpg',
        },
        {
          id: 232506,
          imageable_type: 'App\\Path',
          imageable_id: 38,
          collection_name: 'saved_image',
          name: 'fit52/ugc/READY_TO_ROCK__saved_3x',
          version: '1657742093',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/READY_TO_ROCK__saved_3x/1657742093.jpg',
        },
        {
          id: 232507,
          imageable_type: 'App\\Path',
          imageable_id: 38,
          collection_name: 'social_image',
          name: 'fit52/ugc/READY_TO_ROCK__social_3x',
          version: '1657742094',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/READY_TO_ROCK__social_3x/1657742094.jpg',
        },
        {
          id: 232508,
          imageable_type: 'App\\Path',
          imageable_id: 38,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/READY_TO_ROCK__myPath_3x',
          version: '1657742093',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/READY_TO_ROCK__myPath_3x/1657742093.jpg',
        },
        {
          id: 232509,
          imageable_type: 'App\\Path',
          imageable_id: 38,
          collection_name: 'card_image',
          name: 'fit52/ugc/READY_TO_ROCK__card_3x',
          version: '1657742093',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/READY_TO_ROCK__card_3x/1657742093.jpg',
        },
      ],
    },
    39: {
      id: 39,
      name: 'Super Seven',
      long_name: 'Super Seven',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'SUPER_SEVEN',
      description:
        "Feeling ready to workout seven days a week? Then the 'Super 7' path is for you! This beginner half workout program is great for building trust with yourself to put in the work. It's super important to be committed and engaged!",
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'HALF',
      workouts_per_week: 7,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 200070000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 232510,
          imageable_type: 'App\\Path',
          imageable_id: 39,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/SUPER_SEVEN__pathInfo_3x',
          version: '1657742096',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/SUPER_SEVEN__pathInfo_3x/1657742096.jpg',
        },
        {
          id: 232511,
          imageable_type: 'App\\Path',
          imageable_id: 39,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/SUPER_SEVEN__preWorkout_3x',
          version: '1657742095',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/SUPER_SEVEN__preWorkout_3x/1657742095.jpg',
        },
        {
          id: 232512,
          imageable_type: 'App\\Path',
          imageable_id: 39,
          collection_name: 'saved_image',
          name: 'fit52/ugc/SUPER_SEVEN__saved_3x',
          version: '1657742096',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/SUPER_SEVEN__saved_3x/1657742096.jpg',
        },
        {
          id: 232513,
          imageable_type: 'App\\Path',
          imageable_id: 39,
          collection_name: 'social_image',
          name: 'fit52/ugc/SUPER_SEVEN__social_3x',
          version: '1657742096',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/SUPER_SEVEN__social_3x/1657742096.jpg',
        },
        {
          id: 232514,
          imageable_type: 'App\\Path',
          imageable_id: 39,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/SUPER_SEVEN__myPath_3x',
          version: '1657742095',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/SUPER_SEVEN__myPath_3x/1657742095.jpg',
        },
        {
          id: 232515,
          imageable_type: 'App\\Path',
          imageable_id: 39,
          collection_name: 'card_image',
          name: 'fit52/ugc/SUPER_SEVEN__card_3x',
          version: '1657742094',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/SUPER_SEVEN__card_3x/1657742094.jpg',
        },
      ],
    },
    40: {
      id: 40,
      name: 'Full House',
      long_name: 'Full House',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'FULL_HOUSE',
      description:
        'What is a Full House? 1 full beginner workout per day. This path is for those wanting to max out their beginner level and prove their commitment to their own workout goals!',
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'FULL',
      workouts_per_week: 7,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 200070000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 232516,
          imageable_type: 'App\\Path',
          imageable_id: 40,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/FULL_HOUSE__pathInfo_3x',
          version: '1657742090',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FULL_HOUSE__pathInfo_3x/1657742090.jpg',
        },
        {
          id: 232517,
          imageable_type: 'App\\Path',
          imageable_id: 40,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/FULL_HOUSE__preWorkout_3x',
          version: '1657742090',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FULL_HOUSE__preWorkout_3x/1657742090.jpg',
        },
        {
          id: 232518,
          imageable_type: 'App\\Path',
          imageable_id: 40,
          collection_name: 'saved_image',
          name: 'fit52/ugc/FULL_HOUSE__saved_3x',
          version: '1657742090',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FULL_HOUSE__saved_3x/1657742090.jpg',
        },
        {
          id: 232519,
          imageable_type: 'App\\Path',
          imageable_id: 40,
          collection_name: 'social_image',
          name: 'fit52/ugc/FULL_HOUSE__social_3x',
          version: '1657742090',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FULL_HOUSE__social_3x/1657742090.jpg',
        },
        {
          id: 232520,
          imageable_type: 'App\\Path',
          imageable_id: 40,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/FULL_HOUSE__myPath_3x',
          version: '1657742090',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FULL_HOUSE__myPath_3x/1657742090.jpg',
        },
        {
          id: 232521,
          imageable_type: 'App\\Path',
          imageable_id: 40,
          collection_name: 'card_image',
          name: 'fit52/ugc/FULL_HOUSE__card_3x',
          version: '1657742090',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FULL_HOUSE__card_3x/1657742090.jpg',
        },
      ],
    },
    41: {
      id: 41,
      name: 'No Limits',
      long_name: 'No Limits',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'NO_LIMITS',
      description:
        'Break through your workout barriers with No Limits. Daily half workouts at an intermediate level will allow you to push yourself beyond your limits.',
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'FULL',
      workouts_per_week: 7,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      min_app_version: 200070000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 232522,
          imageable_type: 'App\\Path',
          imageable_id: 41,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/NO_LIMITS__pathInfo_3x',
          version: '1657742092',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/NO_LIMITS__pathInfo_3x/1657742092.jpg',
        },
        {
          id: 232523,
          imageable_type: 'App\\Path',
          imageable_id: 41,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/NO_LIMITS__preWorkout_3x',
          version: '1657742092',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/NO_LIMITS__preWorkout_3x/1657742092.jpg',
        },
        {
          id: 232524,
          imageable_type: 'App\\Path',
          imageable_id: 41,
          collection_name: 'saved_image',
          name: 'fit52/ugc/NO_LIMITS__saved_3x',
          version: '1657742092',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/NO_LIMITS__saved_3x/1657742092.jpg',
        },
        {
          id: 232525,
          imageable_type: 'App\\Path',
          imageable_id: 41,
          collection_name: 'social_image',
          name: 'fit52/ugc/NO_LIMITS__social_3x',
          version: '1657742093',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/NO_LIMITS__social_3x/1657742093.jpg',
        },
        {
          id: 232526,
          imageable_type: 'App\\Path',
          imageable_id: 41,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/NO_LIMITS__myPath_3x',
          version: '1657742092',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/NO_LIMITS__myPath_3x/1657742092.jpg',
        },
        {
          id: 232527,
          imageable_type: 'App\\Path',
          imageable_id: 41,
          collection_name: 'card_image',
          name: 'fit52/ugc/NO_LIMITS__card_3x',
          version: '1657742092',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/NO_LIMITS__card_3x/1657742092.jpg',
        },
      ],
    },
    42: {
      id: 42,
      name: 'Ultimate Seven',
      long_name: 'Ultimate Seven',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'ULTIMATE_SEVEN',
      description:
        'Ultimate Seven is exactly what it sounds like. Workout seven times a week with a half HiNote Life workout each day. Its the ultimate commitment and ultimate workout, for the ultimate results!',
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'HALF',
      workouts_per_week: 7,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      min_app_version: 200070000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 232528,
          imageable_type: 'App\\Path',
          imageable_id: 42,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/ULTIMATE_SEVEN__pathInfo_3x',
          version: '1657742096',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ULTIMATE_SEVEN__pathInfo_3x/1657742096.jpg',
        },
        {
          id: 232529,
          imageable_type: 'App\\Path',
          imageable_id: 42,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/ULTIMATE_SEVEN__preWorkout_3x',
          version: '1657742097',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ULTIMATE_SEVEN__preWorkout_3x/1657742097.jpg',
        },
        {
          id: 232530,
          imageable_type: 'App\\Path',
          imageable_id: 42,
          collection_name: 'saved_image',
          name: 'fit52/ugc/ULTIMATE_SEVEN__saved_3x',
          version: '1657742096',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ULTIMATE_SEVEN__saved_3x/1657742096.jpg',
        },
        {
          id: 232531,
          imageable_type: 'App\\Path',
          imageable_id: 42,
          collection_name: 'social_image',
          name: 'fit52/ugc/ULTIMATE_SEVEN__social_3x',
          version: '1657742097',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ULTIMATE_SEVEN__social_3x/1657742097.jpg',
        },
        {
          id: 232532,
          imageable_type: 'App\\Path',
          imageable_id: 42,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/ULTIMATE_SEVEN__myPath_3x',
          version: '1657742096',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ULTIMATE_SEVEN__myPath_3x/1657742096.jpg',
        },
        {
          id: 232533,
          imageable_type: 'App\\Path',
          imageable_id: 42,
          collection_name: 'card_image',
          name: 'fit52/ugc/ULTIMATE_SEVEN__card_3x',
          version: '1657742096',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ULTIMATE_SEVEN__card_3x/1657742096.jpg',
        },
      ],
    },
    43: {
      id: 43,
      name: 'Stacked',
      long_name: 'Stacked',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'STACKED',
      description:
        'These workouts are stacked and soon you will be too! With seven half workouts a week, these advanced workouts guarantee you will get stronger and build your endurance.',
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'HALF',
      workouts_per_week: 7,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      min_app_version: 200070000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 232534,
          imageable_type: 'App\\Path',
          imageable_id: 43,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/STACKED__pathInfo_3x',
          version: '1657742094',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/STACKED__pathInfo_3x/1657742094.jpg',
        },
        {
          id: 232535,
          imageable_type: 'App\\Path',
          imageable_id: 43,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/STACKED__preWorkout_3x',
          version: '1657742094',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/STACKED__preWorkout_3x/1657742094.jpg',
        },
        {
          id: 232536,
          imageable_type: 'App\\Path',
          imageable_id: 43,
          collection_name: 'saved_image',
          name: 'fit52/ugc/STACKED__saved_3x',
          version: '1657742094',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/STACKED__saved_3x/1657742094.jpg',
        },
        {
          id: 232537,
          imageable_type: 'App\\Path',
          imageable_id: 43,
          collection_name: 'social_image',
          name: 'fit52/ugc/STACKED__social_3x',
          version: '1657742094',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/STACKED__social_3x/1657742094.jpg',
        },
        {
          id: 232538,
          imageable_type: 'App\\Path',
          imageable_id: 43,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/STACKED__myPath_3x',
          version: '1657742094',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/STACKED__myPath_3x/1657742094.jpg',
        },
        {
          id: 232539,
          imageable_type: 'App\\Path',
          imageable_id: 43,
          collection_name: 'card_image',
          name: 'fit52/ugc/STACKED__card_3x',
          version: '1657742094',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/STACKED__card_3x/1657742094.jpg',
        },
      ],
    },
    44: {
      id: 44,
      name: 'Peak Performer',
      long_name: 'Peak Performer',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'HIGH_PERFORMANCE',
      description:
        'With seven full workouts a week, this path will get you working out at a High Performance level. Push yourself with our most challenging workout series yet!',
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'FULL',
      workouts_per_week: 7,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      min_app_version: 200070000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 232540,
          imageable_type: 'App\\Path',
          imageable_id: 44,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/HIGH_PERFORMANCE__pathInfo_3x',
          version: '1657742091',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/HIGH_PERFORMANCE__pathInfo_3x/1657742091.jpg',
        },
        {
          id: 232541,
          imageable_type: 'App\\Path',
          imageable_id: 44,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/HIGH_PERFORMANCE__preWorkout_3x',
          version: '1657742092',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/HIGH_PERFORMANCE__preWorkout_3x/1657742092.jpg',
        },
        {
          id: 232542,
          imageable_type: 'App\\Path',
          imageable_id: 44,
          collection_name: 'saved_image',
          name: 'fit52/ugc/HIGH_PERFORMANCE__saved_3x',
          version: '1657742092',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/HIGH_PERFORMANCE__saved_3x/1657742092.jpg',
        },
        {
          id: 232543,
          imageable_type: 'App\\Path',
          imageable_id: 44,
          collection_name: 'social_image',
          name: 'fit52/ugc/HIGH_PERFORMANCE__social_3x',
          version: '1657742092',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/HIGH_PERFORMANCE__social_3x/1657742092.jpg',
        },
        {
          id: 232544,
          imageable_type: 'App\\Path',
          imageable_id: 44,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/HIGH_PERFORMANCE__myPath_3x',
          version: '1657742091',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/HIGH_PERFORMANCE__myPath_3x/1657742091.jpg',
        },
        {
          id: 232545,
          imageable_type: 'App\\Path',
          imageable_id: 44,
          collection_name: 'card_image',
          name: 'fit52/ugc/HIGH_PERFORMANCE__card_3x',
          version: '1657742091',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/HIGH_PERFORMANCE__card_3x/1657742091.jpg',
        },
      ],
    },
    45: {
      id: 45,
      name: 'Short and Sweet',
      long_name: 'Short and Sweet',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'SHORT_AND_SWEET',
      description:
        'This path really is short and sweet, with our quick workout and a low commitment of only once per week! This is a perfect way to get yourself moving.',
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 1,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264487,
          imageable_type: 'App\\Path',
          imageable_id: 45,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/ShortAndSweet_pathInfo_3x',
          version: '1666916322',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ShortAndSweet_pathInfo_3x/1666916322.jpg',
        },
        {
          id: 264488,
          imageable_type: 'App\\Path',
          imageable_id: 45,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/ShortAndSweet_preWorkout_3x',
          version: '1666916322',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ShortAndSweet_preWorkout_3x/1666916322.jpg',
        },
        {
          id: 264489,
          imageable_type: 'App\\Path',
          imageable_id: 45,
          collection_name: 'saved_image',
          name: 'fit52/ugc/ShortAndSweet_saved_3x',
          version: '1666916323',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ShortAndSweet_saved_3x/1666916323.jpg',
        },
        {
          id: 264490,
          imageable_type: 'App\\Path',
          imageable_id: 45,
          collection_name: 'social_image',
          name: 'fit52/ugc/ShortAndSweet_social_3x',
          version: '1666916323',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ShortAndSweet_social_3x/1666916323.jpg',
        },
        {
          id: 264491,
          imageable_type: 'App\\Path',
          imageable_id: 45,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/ShortAndSweet_myPath_3x',
          version: '1666916321',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ShortAndSweet_myPath_3x/1666916321.jpg',
        },
        {
          id: 264492,
          imageable_type: 'App\\Path',
          imageable_id: 45,
          collection_name: 'card_image',
          name: 'fit52/ugc/ShortAndSweet_card_3x',
          version: '1666916320',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ShortAndSweet_card_3x/1666916320.jpg',
        },
      ],
    },
    46: {
      id: 46,
      name: 'Ready, Sweat, Go!',
      long_name: 'Ready, Sweat, Go!',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'READY,_SWEAT,_GO',
      description:
        'While 13 cards may seem short, you are sure to break a sweat with this one. This path is realistically achievable but will make you feel accomplished!',
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 2,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264493,
          imageable_type: 'App\\Path',
          imageable_id: 46,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/ReadySweatGo_pathInfo_3x',
          version: '1666916319',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ReadySweatGo_pathInfo_3x/1666916319.jpg',
        },
        {
          id: 264494,
          imageable_type: 'App\\Path',
          imageable_id: 46,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/ReadySweatGo_preWorkout_3x',
          version: '1666916319',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ReadySweatGo_preWorkout_3x/1666916319.jpg',
        },
        {
          id: 264495,
          imageable_type: 'App\\Path',
          imageable_id: 46,
          collection_name: 'saved_image',
          name: 'fit52/ugc/ReadySweatGo_saved_3x',
          version: '1666916320',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ReadySweatGo_saved_3x/1666916320.jpg',
        },
        {
          id: 264496,
          imageable_type: 'App\\Path',
          imageable_id: 46,
          collection_name: 'social_image',
          name: 'fit52/ugc/ReadySweatGo_social_3x',
          version: '1666916320',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ReadySweatGo_social_3x/1666916320.jpg',
        },
        {
          id: 264497,
          imageable_type: 'App\\Path',
          imageable_id: 46,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/ReadySweatGo_myPath_3x',
          version: '1666916319',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ReadySweatGo_myPath_3x/1666916319.jpg',
        },
        {
          id: 264498,
          imageable_type: 'App\\Path',
          imageable_id: 46,
          collection_name: 'card_image',
          name: 'fit52/ugc/ReadySweatGo_card_3x',
          version: '1666916318',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ReadySweatGo_card_3x/1666916318.jpg',
        },
      ],
    },
    47: {
      id: 47,
      name: 'Make it 13',
      long_name: 'Make it 13',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'MAKE_IT13',
      description:
        "13 cards is quick, 3 days a week is short, and together makes this path a great foundation to build upon. That's why Make it 13 works for everyone, why not give it a try?",
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 3,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264499,
          imageable_type: 'App\\Path',
          imageable_id: 47,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/MakeIt13_pathInfo_3x',
          version: '1666916311',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/MakeIt13_pathInfo_3x/1666916311.jpg',
        },
        {
          id: 264500,
          imageable_type: 'App\\Path',
          imageable_id: 47,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/MakeIt13_preWorkout_3x',
          version: '1666916311',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/MakeIt13_preWorkout_3x/1666916311.jpg',
        },
        {
          id: 264501,
          imageable_type: 'App\\Path',
          imageable_id: 47,
          collection_name: 'saved_image',
          name: 'fit52/ugc/MakeIt13_saved_3x',
          version: '1666916312',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/MakeIt13_saved_3x/1666916312.jpg',
        },
        {
          id: 264502,
          imageable_type: 'App\\Path',
          imageable_id: 47,
          collection_name: 'social_image',
          name: 'fit52/ugc/MakeIt13_social_3x',
          version: '1666916312',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/MakeIt13_social_3x/1666916312.jpg',
        },
        {
          id: 264503,
          imageable_type: 'App\\Path',
          imageable_id: 47,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/MakeIt13_myPath_3x',
          version: '1666916311',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/MakeIt13_myPath_3x/1666916311.jpg',
        },
        {
          id: 264504,
          imageable_type: 'App\\Path',
          imageable_id: 47,
          collection_name: 'card_image',
          name: 'fit52/ugc/MakeIt13_card_3x',
          version: '1666916310',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/MakeIt13_card_3x/1666916310.jpg',
        },
      ],
    },
    48: {
      id: 48,
      name: "I Don't Sweat I Sparkle!",
      long_name: "I Don't Sweat I Sparkle!",
      branded_name: null,
      branded_long_name: null,
      enum_value: 'I_DONT_SWEAT_I_SPARKLE',
      description:
        "Who said you can't look good while working out? With this path you will work up a sweat...I mean sparkle!",
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 4,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264505,
          imageable_type: 'App\\Path',
          imageable_id: 48,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/IDontSweatISparkle_pathInfo_3x',
          version: '1666916303',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/IDontSweatISparkle_pathInfo_3x/1666916303.jpg',
        },
        {
          id: 264506,
          imageable_type: 'App\\Path',
          imageable_id: 48,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/IDontSweatISparkle_preWorkout_3x',
          version: '1666916304',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/IDontSweatISparkle_preWorkout_3x/1666916304.jpg',
        },
        {
          id: 264507,
          imageable_type: 'App\\Path',
          imageable_id: 48,
          collection_name: 'saved_image',
          name: 'fit52/ugc/IDontSweatISparkle_saved_3x',
          version: '1666916304',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/IDontSweatISparkle_saved_3x/1666916304.jpg',
        },
        {
          id: 264508,
          imageable_type: 'App\\Path',
          imageable_id: 48,
          collection_name: 'social_image',
          name: 'fit52/ugc/IDontSweatISparkle_social_3x',
          version: '1666916304',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/IDontSweatISparkle_social_3x/1666916304.jpg',
        },
        {
          id: 264509,
          imageable_type: 'App\\Path',
          imageable_id: 48,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/IDontSweatISparkle_myPath_3x',
          version: '1666916303',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/IDontSweatISparkle_myPath_3x/1666916303.jpg',
        },
        {
          id: 264510,
          imageable_type: 'App\\Path',
          imageable_id: 48,
          collection_name: 'card_image',
          name: 'fit52/ugc/IDontSweatISparkle_card_3x',
          version: '1666916302',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/IDontSweatISparkle_card_3x/1666916302.jpg',
        },
      ],
    },
    49: {
      id: 49,
      name: 'Stronger Day by Day',
      long_name: 'Stronger Day by Day',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'STRONGER_DAY_BY_DAY',
      description:
        'Comitting to yourself is a full time job, and with 5 workouts per week, you take your fitness seriously. These workouts will help build stregth, but you have to take it day by day.',
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 5,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264511,
          imageable_type: 'App\\Path',
          imageable_id: 49,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/StrongerDayByDay_pathInfo_3x',
          version: '1666916327',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/StrongerDayByDay_pathInfo_3x/1666916327.jpg',
        },
        {
          id: 264512,
          imageable_type: 'App\\Path',
          imageable_id: 49,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/StrongerDayByDay_preWorkout_3x',
          version: '1666916327',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/StrongerDayByDay_preWorkout_3x/1666916327.jpg',
        },
        {
          id: 264513,
          imageable_type: 'App\\Path',
          imageable_id: 49,
          collection_name: 'saved_image',
          name: 'fit52/ugc/StrongerDayByDay_saved_3x',
          version: '1666916327',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/StrongerDayByDay_saved_3x/1666916327.jpg',
        },
        {
          id: 264514,
          imageable_type: 'App\\Path',
          imageable_id: 49,
          collection_name: 'social_image',
          name: 'fit52/ugc/StrongerDayByDay_social_3x',
          version: '1666916328',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/StrongerDayByDay_social_3x/1666916328.jpg',
        },
        {
          id: 264515,
          imageable_type: 'App\\Path',
          imageable_id: 49,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/StrongerDayByDay_myPath_3x',
          version: '1666916326',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/StrongerDayByDay_myPath_3x/1666916326.jpg',
        },
        {
          id: 264516,
          imageable_type: 'App\\Path',
          imageable_id: 49,
          collection_name: 'card_image',
          name: 'fit52/ugc/StrongerDayByDay_card_3x',
          version: '1666916326',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/StrongerDayByDay_card_3x/1666916326.jpg',
        },
      ],
    },
    50: {
      id: 50,
      name: 'Getting it Done!',
      long_name: 'Getting it Done!',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'GETTING_IT_DONE',
      description:
        'Sometimes you need to step up your game. 6 workouts a week means no excuses, and getting it done!',
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 6,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264517,
          imageable_type: 'App\\Path',
          imageable_id: 50,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/GettingItDone_pathInfo_3x',
          version: '1666916300',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/GettingItDone_pathInfo_3x/1666916300.jpg',
        },
        {
          id: 264518,
          imageable_type: 'App\\Path',
          imageable_id: 50,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/GettingItDone_preWorkout_3x',
          version: '1666916300',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/GettingItDone_preWorkout_3x/1666916300.jpg',
        },
        {
          id: 264519,
          imageable_type: 'App\\Path',
          imageable_id: 50,
          collection_name: 'saved_image',
          name: 'fit52/ugc/GettingItDone_saved_3x',
          version: '1666916301',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/GettingItDone_saved_3x/1666916301.jpg',
        },
        {
          id: 264520,
          imageable_type: 'App\\Path',
          imageable_id: 50,
          collection_name: 'social_image',
          name: 'fit52/ugc/GettingItDone_social_3x',
          version: '1666916301',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/GettingItDone_social_3x/1666916301.jpg',
        },
        {
          id: 264521,
          imageable_type: 'App\\Path',
          imageable_id: 50,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/GettingItDone_myPath_3x',
          version: '1666916299',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/GettingItDone_myPath_3x/1666916299.jpg',
        },
        {
          id: 264522,
          imageable_type: 'App\\Path',
          imageable_id: 50,
          collection_name: 'card_image',
          name: 'fit52/ugc/GettingItDone_card_3x',
          version: '1666916298',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/GettingItDone_card_3x/1666916298.jpg',
        },
      ],
    },
    51: {
      id: 51,
      name: 'Lucky 7',
      long_name: 'Lucky 7',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'LUCKY7',
      description:
        'With this beginner path you will be stepping it up to seven workouts per week. Keeping it effective with 13 cards!',
      branded_description: null,
      fitness_level: 'BEGINNER',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 7,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264523,
          imageable_type: 'App\\Path',
          imageable_id: 51,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/Lucky7_pathInfo_3x',
          version: '1666916308',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Lucky7_pathInfo_3x/1666916308.jpg',
        },
        {
          id: 264524,
          imageable_type: 'App\\Path',
          imageable_id: 51,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/Lucky7_preWorkout_3x',
          version: '1666916309',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Lucky7_preWorkout_3x/1666916309.jpg',
        },
        {
          id: 264525,
          imageable_type: 'App\\Path',
          imageable_id: 51,
          collection_name: 'saved_image',
          name: 'fit52/ugc/Lucky7_saved_3x',
          version: '1666916309',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Lucky7_saved_3x/1666916309.jpg',
        },
        {
          id: 264526,
          imageable_type: 'App\\Path',
          imageable_id: 51,
          collection_name: 'social_image',
          name: 'fit52/ugc/Lucky7_social_3x',
          version: '1666916310',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Lucky7_social_3x/1666916310.jpg',
        },
        {
          id: 264527,
          imageable_type: 'App\\Path',
          imageable_id: 51,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/Lucky7_myPath_3x',
          version: '1666916308',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Lucky7_myPath_3x/1666916308.jpg',
        },
        {
          id: 264528,
          imageable_type: 'App\\Path',
          imageable_id: 51,
          collection_name: 'card_image',
          name: 'fit52/ugc/Lucky7_card_3x',
          version: '1666916307',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Lucky7_card_3x/1666916307.jpg',
        },
      ],
    },
    52: {
      id: 52,
      name: 'Step by Step',
      long_name: 'Step by Step',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'STEP_BY_STEP',
      description:
        'Take on intermediate workouts Step by Step! With one workout per week, this path will ease you into the intermediate level!',
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 1,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264529,
          imageable_type: 'App\\Path',
          imageable_id: 52,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/StepByStep_pathInfo_3x',
          version: '1666916324',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/StepByStep_pathInfo_3x/1666916324.jpg',
        },
        {
          id: 264530,
          imageable_type: 'App\\Path',
          imageable_id: 52,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/StepByStep_preWorkout_3x',
          version: '1666916325',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/StepByStep_preWorkout_3x/1666916325.jpg',
        },
        {
          id: 264531,
          imageable_type: 'App\\Path',
          imageable_id: 52,
          collection_name: 'saved_image',
          name: 'fit52/ugc/StepByStep_saved_3x',
          version: '1666916325',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/StepByStep_saved_3x/1666916325.jpg',
        },
        {
          id: 264532,
          imageable_type: 'App\\Path',
          imageable_id: 52,
          collection_name: 'social_image',
          name: 'fit52/ugc/StepByStep_social_3x',
          version: '1666916325',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/StepByStep_social_3x/1666916325.jpg',
        },
        {
          id: 264533,
          imageable_type: 'App\\Path',
          imageable_id: 52,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/StepByStep_myPath_3x',
          version: '1666916324',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/StepByStep_myPath_3x/1666916324.jpg',
        },
        {
          id: 264534,
          imageable_type: 'App\\Path',
          imageable_id: 52,
          collection_name: 'card_image',
          name: 'fit52/ugc/StepByStep_card_3x',
          version: '1666916323',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/StepByStep_card_3x/1666916323.jpg',
        },
      ],
    },
    53: {
      id: 53,
      name: 'Progress over Perfection',
      long_name: 'Progress over Perfection',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'PROGRESS_OVER_PERFECTION',
      description:
        'Progress over Perfection is all about building up confidence, displine, and technique. Sounds like a good fit for you? Get started today!',
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 2,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264535,
          imageable_type: 'App\\Path',
          imageable_id: 53,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/ProgressOverPerfection_pathInfo_3x',
          version: '1666916316',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ProgressOverPerfection_pathInfo_3x/1666916316.jpg',
        },
        {
          id: 264536,
          imageable_type: 'App\\Path',
          imageable_id: 53,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/ProgressOverPerfection_preWorkout_3x',
          version: '1666916317',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ProgressOverPerfection_preWorkout_3x/1666916317.jpg',
        },
        {
          id: 264537,
          imageable_type: 'App\\Path',
          imageable_id: 53,
          collection_name: 'saved_image',
          name: 'fit52/ugc/ProgressOverPerfection_saved_3x',
          version: '1666916317',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ProgressOverPerfection_saved_3x/1666916317.jpg',
        },
        {
          id: 264538,
          imageable_type: 'App\\Path',
          imageable_id: 53,
          collection_name: 'social_image',
          name: 'fit52/ugc/ProgressOverPerfection_social_3x',
          version: '1666916318',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ProgressOverPerfection_social_3x/1666916318.jpg',
        },
        {
          id: 264539,
          imageable_type: 'App\\Path',
          imageable_id: 53,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/ProgressOverPerfection_myPath_3x',
          version: '1666916316',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ProgressOverPerfection_myPath_3x/1666916316.jpg',
        },
        {
          id: 264540,
          imageable_type: 'App\\Path',
          imageable_id: 53,
          collection_name: 'card_image',
          name: 'fit52/ugc/ProgressOverPerfection_card_3x',
          version: '1666916316',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/ProgressOverPerfection_card_3x/1666916316.jpg',
        },
      ],
    },
    54: {
      id: 54,
      name: 'Work it Out',
      long_name: 'Work it Out',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'WORK_IT_OUT',
      description:
        'Take the stresses from your everyday life and channel it into Work it Out. This is your *you* time, enjoy it!',
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 3,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264541,
          imageable_type: 'App\\Path',
          imageable_id: 54,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/WorkItOut_pathInfo_3x',
          version: '1666916332',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/WorkItOut_pathInfo_3x/1666916332.jpg',
        },
        {
          id: 264542,
          imageable_type: 'App\\Path',
          imageable_id: 54,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/WorkItOut_preWorkout_3x',
          version: '1666916332',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/WorkItOut_preWorkout_3x/1666916332.jpg',
        },
        {
          id: 264543,
          imageable_type: 'App\\Path',
          imageable_id: 54,
          collection_name: 'saved_image',
          name: 'fit52/ugc/WorkItOut_saved_3x',
          version: '1666916333',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/WorkItOut_saved_3x/1666916333.jpg',
        },
        {
          id: 264544,
          imageable_type: 'App\\Path',
          imageable_id: 54,
          collection_name: 'social_image',
          name: 'fit52/ugc/WorkItOut_social_3x',
          version: '1666916333',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/WorkItOut_social_3x/1666916333.jpg',
        },
        {
          id: 264545,
          imageable_type: 'App\\Path',
          imageable_id: 54,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/WorkItOut_myPath_3x',
          version: '1666916332',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/WorkItOut_myPath_3x/1666916332.jpg',
        },
        {
          id: 264546,
          imageable_type: 'App\\Path',
          imageable_id: 54,
          collection_name: 'card_image',
          name: 'fit52/ugc/WorkItOut_card_3x',
          version: '1666916331',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/WorkItOut_card_3x/1666916331.jpg',
        },
      ],
    },
    55: {
      id: 55,
      name: 'Fab Four!',
      long_name: 'Fab Four!',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'FAB_FOUR',
      description:
        "You will be feeling fab with four intermediate workouts a week. They're quick enough for a higher level of commitment and will lift your endurance.",
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 4,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264547,
          imageable_type: 'App\\Path',
          imageable_id: 55,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/FabInFour__pathInfo_3x',
          version: '1666916282',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FabInFour__pathInfo_3x/1666916282.jpg',
        },
        {
          id: 264548,
          imageable_type: 'App\\Path',
          imageable_id: 55,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/FabInFour__preWorkout_3x',
          version: '1666916283',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FabInFour__preWorkout_3x/1666916283.jpg',
        },
        {
          id: 264549,
          imageable_type: 'App\\Path',
          imageable_id: 55,
          collection_name: 'saved_image',
          name: 'fit52/ugc/FabInFour__saved_3x',
          version: '1666916284',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FabInFour__saved_3x/1666916284.jpg',
        },
        {
          id: 264550,
          imageable_type: 'App\\Path',
          imageable_id: 55,
          collection_name: 'social_image',
          name: 'fit52/ugc/FabInFour__social_3x',
          version: '1666916284',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FabInFour__social_3x/1666916284.jpg',
        },
        {
          id: 264551,
          imageable_type: 'App\\Path',
          imageable_id: 55,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/FabInFour__myPath_3x',
          version: '1666916282',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FabInFour__myPath_3x/1666916282.jpg',
        },
        {
          id: 264552,
          imageable_type: 'App\\Path',
          imageable_id: 55,
          collection_name: 'card_image',
          name: 'fit52/ugc/FabInFour__card_3x',
          version: '1666916281',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FabInFour__card_3x/1666916281.jpg',
        },
      ],
    },
    56: {
      id: 56,
      name: 'Card Crusher',
      long_name: 'Card Crusher',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'CARD_CRUSHER',
      description:
        'If you are ready to crush some cards then this is the path for you. Get though 13 cards, 5 days a week, and start calling yourself a certified Card Crusher.',
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 5,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264553,
          imageable_type: 'App\\Path',
          imageable_id: 56,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/CardCrusher_pathInfo_3x',
          version: '1666916295',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/CardCrusher_pathInfo_3x/1666916295.jpg',
        },
        {
          id: 264554,
          imageable_type: 'App\\Path',
          imageable_id: 56,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/CardCrusher_preWorkout_3x',
          version: '1666916297',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/CardCrusher_preWorkout_3x/1666916297.jpg',
        },
        {
          id: 264555,
          imageable_type: 'App\\Path',
          imageable_id: 56,
          collection_name: 'saved_image',
          name: 'fit52/ugc/CardCrusher_saved_3x',
          version: '1666916276',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/CardCrusher_saved_3x/1666916276.jpg',
        },
        {
          id: 264556,
          imageable_type: 'App\\Path',
          imageable_id: 56,
          collection_name: 'social_image',
          name: 'fit52/ugc/CardCrusher_social_3x',
          version: '1666916277',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/CardCrusher_social_3x/1666916277.jpg',
        },
        {
          id: 264557,
          imageable_type: 'App\\Path',
          imageable_id: 56,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/CardCrusher_myPath_3x',
          version: '1666916293',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/CardCrusher_myPath_3x/1666916293.jpg',
        },
        {
          id: 264558,
          imageable_type: 'App\\Path',
          imageable_id: 56,
          collection_name: 'card_image',
          name: 'fit52/ugc/CardCrusher_card_3x',
          version: '1666916289',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/CardCrusher_card_3x/1666916289.jpg',
        },
      ],
    },
    57: {
      id: 57,
      name: 'Fierce Fitness',
      long_name: 'Fierce Fitness',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'FIERCE_FITNESS',
      description:
        'Attack your workout routine with Fierce Fitness! Keep your works quick and intense. 6 workouts a week, you got this.',
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 6,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264559,
          imageable_type: 'App\\Path',
          imageable_id: 57,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/FierceFitness_pathInfo_3x',
          version: '1666916289',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FierceFitness_pathInfo_3x/1666916289.jpg',
        },
        {
          id: 264560,
          imageable_type: 'App\\Path',
          imageable_id: 57,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/FierceFitness_preWorkout_3x',
          version: '1666916290',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FierceFitness_preWorkout_3x/1666916290.jpg',
        },
        {
          id: 264561,
          imageable_type: 'App\\Path',
          imageable_id: 57,
          collection_name: 'saved_image',
          name: 'fit52/ugc/FierceFitness_saved_3x',
          version: '1666916290',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FierceFitness_saved_3x/1666916290.jpg',
        },
        {
          id: 264562,
          imageable_type: 'App\\Path',
          imageable_id: 57,
          collection_name: 'social_image',
          name: 'fit52/ugc/FierceFitness_social_3x',
          version: '1666916291',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FierceFitness_social_3x/1666916291.jpg',
        },
        {
          id: 264563,
          imageable_type: 'App\\Path',
          imageable_id: 57,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/FierceFitness_myPath_3x',
          version: '1666916289',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FierceFitness_myPath_3x/1666916289.jpg',
        },
        {
          id: 264564,
          imageable_type: 'App\\Path',
          imageable_id: 57,
          collection_name: 'card_image',
          name: 'fit52/ugc/FierceFitness_card_3x',
          version: '1666916288',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FierceFitness_card_3x/1666916288.jpg',
        },
      ],
    },
    58: {
      id: 58,
      name: 'Everyday Energy',
      long_name: 'Everyday Energy',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'EVERYDAY_ENERGY',
      description:
        'Looking to implement some routine into your life? This intermediate 7 workouts per week path is perfect for you. Feel better with Everyday Energy and start today!',
      branded_description: null,
      fitness_level: 'INTERMEDIATE',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 7,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264565,
          imageable_type: 'App\\Path',
          imageable_id: 58,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/EverydayEnergy_pathInfo_3x',
          version: '1666916279',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/EverydayEnergy_pathInfo_3x/1666916279.jpg',
        },
        {
          id: 264566,
          imageable_type: 'App\\Path',
          imageable_id: 58,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/EverydayEnergy_preWorkout_3x',
          version: '1666916280',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/EverydayEnergy_preWorkout_3x/1666916280.jpg',
        },
        {
          id: 264567,
          imageable_type: 'App\\Path',
          imageable_id: 58,
          collection_name: 'saved_image',
          name: 'fit52/ugc/EverydayEnergy_saved_3x',
          version: '1666916280',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/EverydayEnergy_saved_3x/1666916280.jpg',
        },
        {
          id: 264568,
          imageable_type: 'App\\Path',
          imageable_id: 58,
          collection_name: 'social_image',
          name: 'fit52/ugc/EverydayEnergy_social_3x',
          version: '1666916281',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/EverydayEnergy_social_3x/1666916281.jpg',
        },
        {
          id: 264569,
          imageable_type: 'App\\Path',
          imageable_id: 58,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/EverydayEnergy_myPath_3x',
          version: '1666916278',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/EverydayEnergy_myPath_3x/1666916278.jpg',
        },
        {
          id: 264570,
          imageable_type: 'App\\Path',
          imageable_id: 58,
          collection_name: 'card_image',
          name: 'fit52/ugc/EverydayEnergy_card_3x',
          version: '1666916278',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/EverydayEnergy_card_3x/1666916278.jpg',
        },
      ],
    },
    59: {
      id: 59,
      name: 'Fast & Fit',
      long_name: 'Fast & Fit',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'FAST&_FIT',
      description:
        'Looking to level up your fitness journey with one advanced workout per week? Fast & Fit will get you where you need to go!',
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 1,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264571,
          imageable_type: 'App\\Path',
          imageable_id: 59,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/FastandFit_pathInfo_3x',
          version: '1666916286',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FastandFit_pathInfo_3x/1666916286.jpg',
        },
        {
          id: 264572,
          imageable_type: 'App\\Path',
          imageable_id: 59,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/FastandFit_preWorkout_3x',
          version: '1666916287',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FastandFit_preWorkout_3x/1666916287.jpg',
        },
        {
          id: 264573,
          imageable_type: 'App\\Path',
          imageable_id: 59,
          collection_name: 'saved_image',
          name: 'fit52/ugc/FastandFit_saved_3x',
          version: '1666916287',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FastandFit_saved_3x/1666916287.jpg',
        },
        {
          id: 264574,
          imageable_type: 'App\\Path',
          imageable_id: 59,
          collection_name: 'social_image',
          name: 'fit52/ugc/FastandFit_social_3x',
          version: '1666916287',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FastandFit_social_3x/1666916287.jpg',
        },
        {
          id: 264575,
          imageable_type: 'App\\Path',
          imageable_id: 59,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/FastandFit_myPath_3x',
          version: '1666916285',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FastandFit_myPath_3x/1666916285.jpg',
        },
        {
          id: 264576,
          imageable_type: 'App\\Path',
          imageable_id: 59,
          collection_name: 'card_image',
          name: 'fit52/ugc/FastandFit_card_3x',
          version: '1666916285',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FastandFit_card_3x/1666916285.jpg',
        },
      ],
    },
    60: {
      id: 60,
      name: 'Make your Move',
      long_name: 'Make your Move',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'MAKE_YOUR_MOVE',
      description:
        'Make your Move with two advanced workouts per week! This is the perfect way to feel accomplished during your week without getting overwhelmed.',
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 2,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264577,
          imageable_type: 'App\\Path',
          imageable_id: 60,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/MakeYourMove_pathInfo_3x',
          version: '1666916314',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/MakeYourMove_pathInfo_3x/1666916314.jpg',
        },
        {
          id: 264578,
          imageable_type: 'App\\Path',
          imageable_id: 60,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/MakeYourMove_preWorkout_3x',
          version: '1666916314',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/MakeYourMove_preWorkout_3x/1666916314.jpg',
        },
        {
          id: 264579,
          imageable_type: 'App\\Path',
          imageable_id: 60,
          collection_name: 'saved_image',
          name: 'fit52/ugc/MakeYourMove_saved_3x',
          version: '1666916315',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/MakeYourMove_saved_3x/1666916315.jpg',
        },
        {
          id: 264580,
          imageable_type: 'App\\Path',
          imageable_id: 60,
          collection_name: 'social_image',
          name: 'fit52/ugc/MakeYourMove_social_3x',
          version: '1666916315',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/MakeYourMove_social_3x/1666916315.jpg',
        },
        {
          id: 264581,
          imageable_type: 'App\\Path',
          imageable_id: 60,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/MakeYourMove_myPath_3x',
          version: '1666916313',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/MakeYourMove_myPath_3x/1666916313.jpg',
        },
        {
          id: 264582,
          imageable_type: 'App\\Path',
          imageable_id: 60,
          collection_name: 'card_image',
          name: 'fit52/ugc/MakeYourMove_card_3x',
          version: '1666916313',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/MakeYourMove_card_3x/1666916313.jpg',
        },
      ],
    },
    61: {
      id: 61,
      name: 'Triple Threat',
      long_name: 'Triple Threat',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'TRIPLE_THREAT',
      description:
        "This path will ensure you're a triple threat by getting three workouts in per week!",
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 3,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264583,
          imageable_type: 'App\\Path',
          imageable_id: 61,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/TripleThreat_pathInfo_3x',
          version: '1666916330',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/TripleThreat_pathInfo_3x/1666916330.jpg',
        },
        {
          id: 264584,
          imageable_type: 'App\\Path',
          imageable_id: 61,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/TripleThreat_preWorkout_3x',
          version: '1666916330',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/TripleThreat_preWorkout_3x/1666916330.jpg',
        },
        {
          id: 264585,
          imageable_type: 'App\\Path',
          imageable_id: 61,
          collection_name: 'saved_image',
          name: 'fit52/ugc/TripleThreat_saved_3x',
          version: '1666916330',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/TripleThreat_saved_3x/1666916330.jpg',
        },
        {
          id: 264586,
          imageable_type: 'App\\Path',
          imageable_id: 61,
          collection_name: 'social_image',
          name: 'fit52/ugc/TripleThreat_social_3x',
          version: '1666916331',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/TripleThreat_social_3x/1666916331.jpg',
        },
        {
          id: 264587,
          imageable_type: 'App\\Path',
          imageable_id: 61,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/TripleThreat_myPath_3x',
          version: '1666916329',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/TripleThreat_myPath_3x/1666916329.jpg',
        },
        {
          id: 264588,
          imageable_type: 'App\\Path',
          imageable_id: 61,
          collection_name: 'card_image',
          name: 'fit52/ugc/TripleThreat_card_3x',
          version: '1666916328',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/TripleThreat_card_3x/1666916328.jpg',
        },
      ],
    },
    62: {
      id: 62,
      name: 'Fun in Four!',
      long_name: 'Fun in Four!',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'FUN_IN_FOUR',
      description:
        'As the name implies, you will be having fun with the four workouts a week! Give it a shot to see if it is right for you! ',
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 4,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264589,
          imageable_type: 'App\\Path',
          imageable_id: 62,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/FunInFour_pathInfo_3x',
          version: '1666916296',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FunInFour_pathInfo_3x/1666916296.jpg',
        },
        {
          id: 264590,
          imageable_type: 'App\\Path',
          imageable_id: 62,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/FunInFour_preWorkout_3x',
          version: '1666916296',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FunInFour_preWorkout_3x/1666916296.jpg',
        },
        {
          id: 264591,
          imageable_type: 'App\\Path',
          imageable_id: 62,
          collection_name: 'saved_image',
          name: 'fit52/ugc/FunInFour_saved_3x',
          version: '1666916297',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FunInFour_saved_3x/1666916297.jpg',
        },
        {
          id: 264592,
          imageable_type: 'App\\Path',
          imageable_id: 62,
          collection_name: 'social_image',
          name: 'fit52/ugc/FunInFour_social_3x',
          version: '1666916298',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FunInFour_social_3x/1666916298.jpg',
        },
        {
          id: 264593,
          imageable_type: 'App\\Path',
          imageable_id: 62,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/FunInFour_myPath_3x',
          version: '1666916295',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FunInFour_myPath_3x/1666916295.jpg',
        },
        {
          id: 264594,
          imageable_type: 'App\\Path',
          imageable_id: 62,
          collection_name: 'card_image',
          name: 'fit52/ugc/FunInFour_card_3x',
          version: '1666916294',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FunInFour_card_3x/1666916294.jpg',
        },
      ],
    },
    63: {
      id: 63,
      name: 'Fit in Five',
      long_name: 'Fit in Five',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'FIT_IN_FIVE',
      description:
        "By the time you've completed this path, you will be feeling fit! Crush five advanced workouts and start your path to a new level of fitness!",
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 5,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264595,
          imageable_type: 'App\\Path',
          imageable_id: 63,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/FitInFive_pathInfo_3x',
          version: '1666916293',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FitInFive_pathInfo_3x/1666916293.jpg',
        },
        {
          id: 264596,
          imageable_type: 'App\\Path',
          imageable_id: 63,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/FitInFive_preWorkout_3x',
          version: '1666916293',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FitInFive_preWorkout_3x/1666916293.jpg',
        },
        {
          id: 264597,
          imageable_type: 'App\\Path',
          imageable_id: 63,
          collection_name: 'saved_image',
          name: 'fit52/ugc/FitInFive_saved_3x',
          version: '1666916293',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FitInFive_saved_3x/1666916293.jpg',
        },
        {
          id: 264598,
          imageable_type: 'App\\Path',
          imageable_id: 63,
          collection_name: 'social_image',
          name: 'fit52/ugc/FitInFive_social_3x',
          version: '1666916294',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FitInFive_social_3x/1666916294.jpg',
        },
        {
          id: 264599,
          imageable_type: 'App\\Path',
          imageable_id: 63,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/FitInFive_myPath_3x',
          version: '1666916292',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FitInFive_myPath_3x/1666916292.jpg',
        },
        {
          id: 264600,
          imageable_type: 'App\\Path',
          imageable_id: 63,
          collection_name: 'card_image',
          name: 'fit52/ugc/FitInFive_card_3x',
          version: '1666916291',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/FitInFive_card_3x/1666916291.jpg',
        },
      ],
    },
    64: {
      id: 64,
      name: 'Advanced Active',
      long_name: 'Advanced Active',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'ADVANCED_ACTIVE',
      description:
        "By choosing this path you've earned the title of Advanced Active, now let's get to it!",
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 6,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264601,
          imageable_type: 'App\\Path',
          imageable_id: 64,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/AdvancedActive_pathInfo_3x',
          version: '1666916283',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/AdvancedActive_pathInfo_3x/1666916283.jpg',
        },
        {
          id: 264602,
          imageable_type: 'App\\Path',
          imageable_id: 64,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/AdvancedActive_preWorkout_3x',
          version: '1666916284',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/AdvancedActive_preWorkout_3x/1666916284.jpg',
        },
        {
          id: 264603,
          imageable_type: 'App\\Path',
          imageable_id: 64,
          collection_name: 'saved_image',
          name: 'fit52/ugc/AdvancedActive_saved_3x',
          version: '1666916285',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/AdvancedActive_saved_3x/1666916285.jpg',
        },
        {
          id: 264604,
          imageable_type: 'App\\Path',
          imageable_id: 64,
          collection_name: 'social_image',
          name: 'fit52/ugc/AdvancedActive_social_3x',
          version: '1666916287',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/AdvancedActive_social_3x/1666916287.jpg',
        },
        {
          id: 264605,
          imageable_type: 'App\\Path',
          imageable_id: 64,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/AdvancedActive_myPath_3x',
          version: '1666916281',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/AdvancedActive_myPath_3x/1666916281.jpg',
        },
        {
          id: 264606,
          imageable_type: 'App\\Path',
          imageable_id: 64,
          collection_name: 'card_image',
          name: 'fit52/ugc/AdvancedActive_card_3x',
          version: '1666916278',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/AdvancedActive_card_3x/1666916278.jpg',
        },
      ],
    },
    65: {
      id: 65,
      name: 'Intense 13',
      long_name: 'Intense 13',
      branded_name: null,
      branded_long_name: null,
      enum_value: 'INTENSE13',
      description:
        'No if, ands, or buts about it, this will be an Intense 13 cards. Can you handle it? We are cheering you on! ',
      branded_description: null,
      fitness_level: 'ADVANCED',
      workout_template_type: 'CARD_DRAW_13',
      workouts_per_week: 7,
      is_private: false,
      is_vip: false,
      author: null,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      min_app_version: 300000000,
      campaign_guid: null,
      order: 10,
      images: [
        {
          id: 264607,
          imageable_type: 'App\\Path',
          imageable_id: 65,
          collection_name: 'path_info_image',
          name: 'fit52/ugc/Intense13_pathInfo_3x',
          version: '1666916306',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Intense13_pathInfo_3x/1666916306.jpg',
        },
        {
          id: 264608,
          imageable_type: 'App\\Path',
          imageable_id: 65,
          collection_name: 'pre_workout_image',
          name: 'fit52/ugc/Intense13_preWorkout_3x',
          version: '1666916306',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Intense13_preWorkout_3x/1666916306.jpg',
        },
        {
          id: 264609,
          imageable_type: 'App\\Path',
          imageable_id: 65,
          collection_name: 'saved_image',
          name: 'fit52/ugc/Intense13_saved_3x',
          version: '1666916307',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Intense13_saved_3x/1666916307.jpg',
        },
        {
          id: 264610,
          imageable_type: 'App\\Path',
          imageable_id: 65,
          collection_name: 'social_image',
          name: 'fit52/ugc/Intense13_social_3x',
          version: '1666916307',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Intense13_social_3x/1666916307.jpg',
        },
        {
          id: 264611,
          imageable_type: 'App\\Path',
          imageable_id: 65,
          collection_name: 'my_path_image',
          name: 'fit52/ugc/Intense13_myPath_3x',
          version: '1666916305',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Intense13_myPath_3x/1666916305.jpg',
        },
        {
          id: 264612,
          imageable_type: 'App\\Path',
          imageable_id: 65,
          collection_name: 'card_image',
          name: 'fit52/ugc/Intense13_card_3x',
          version: '1666916305',
          folder: 'image',
          format: 'jpg',
          manipulations: null,
          user_id: null,
          url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Intense13_card_3x/1666916305.jpg',
        },
      ],
    },
  },
  segments: {
    'BEGINNER-Rest': {
      id: 1,
      segment_type: 'REST',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Rest',
      short_name: 'Rest',
      unique_name: 'BEGINNER-Rest',
      description: 'description',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [],
      files: [
        {
          id: 1,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9',
          file_name:
            'audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          name: 'Rest.mp3',
          description: null,
          size: 15808,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Rest': {
      id: 44,
      segment_type: 'REST',
      fitness_level: 'INTERMEDIATE',
      focus_area: null,
      name: 'Rest',
      short_name: 'Rest',
      unique_name: 'INTERMEDIATE-Rest',
      description: 'description',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [],
      files: [
        {
          id: 2,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9',
          file_name:
            'audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          name: 'Rest.mp3',
          description: null,
          size: 15808,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Rest': {
      id: 87,
      segment_type: 'REST',
      fitness_level: 'ADVANCED',
      focus_area: null,
      name: 'Rest',
      short_name: 'Rest',
      unique_name: 'ADVANCED-Rest',
      description: 'description',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [],
      files: [
        {
          id: 3,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9',
          file_name:
            'audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          name: 'Rest.mp3',
          description: null,
          size: 15808,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Rest_30': {
      id: 924,
      segment_type: 'REST',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Rest',
      short_name: 'Rest',
      unique_name: 'BEGINNER-Rest_30',
      description: 'description',
      preview_time: null,
      min_app_version: 200070000,
      archived: true,
      equipment: [],
      tags: [],
      files: [
        {
          id: 2390,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9',
          file_name:
            'audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          name: 'Rest.mp3',
          description: null,
          size: 15808,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Rest_30': {
      id: 925,
      segment_type: 'REST',
      fitness_level: 'INTERMEDIATE',
      focus_area: null,
      name: 'Rest',
      short_name: 'Rest',
      unique_name: 'INTERMEDIATE-Rest_30',
      description: 'description',
      preview_time: null,
      min_app_version: 200070000,
      archived: true,
      equipment: [],
      tags: [],
      files: [
        {
          id: 2391,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9',
          file_name:
            'audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          name: 'Rest.mp3',
          description: null,
          size: 15808,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Rest_30': {
      id: 926,
      segment_type: 'REST',
      fitness_level: 'ADVANCED',
      focus_area: null,
      name: 'Rest',
      short_name: 'Rest',
      unique_name: 'ADVANCED-Rest_30',
      description: 'description',
      preview_time: null,
      min_app_version: 200070000,
      archived: true,
      equipment: [],
      tags: [],
      files: [
        {
          id: 2392,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9',
          file_name:
            'audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          name: 'Rest.mp3',
          description: null,
          size: 15808,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Rest_15': {
      id: 927,
      segment_type: 'REST',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Rest',
      short_name: 'Rest',
      unique_name: 'BEGINNER-Rest_15',
      description: 'description',
      preview_time: null,
      min_app_version: 200070000,
      archived: true,
      equipment: [],
      tags: [],
      files: [
        {
          id: 2393,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9',
          file_name:
            'audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          name: 'Rest.mp3',
          description: null,
          size: 15808,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Rest_15': {
      id: 928,
      segment_type: 'REST',
      fitness_level: 'INTERMEDIATE',
      focus_area: null,
      name: 'Rest',
      short_name: 'Rest',
      unique_name: 'INTERMEDIATE-Rest_15',
      description: 'description',
      preview_time: null,
      min_app_version: 200070000,
      archived: true,
      equipment: [],
      tags: [],
      files: [
        {
          id: 2394,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9',
          file_name:
            'audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          name: 'Rest.mp3',
          description: null,
          size: 15808,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Rest_15': {
      id: 929,
      segment_type: 'REST',
      fitness_level: 'ADVANCED',
      focus_area: null,
      name: 'Rest',
      short_name: 'Rest',
      unique_name: 'ADVANCED-Rest_15',
      description: 'description',
      preview_time: null,
      min_app_version: 200070000,
      archived: true,
      equipment: [],
      tags: [],
      files: [
        {
          id: 2395,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9',
          file_name:
            'audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/91fb049135c4099956e16062ee3ac26fe42bf6fc46519169a194a7bd3b8d1eb9.mp3',
          name: 'Rest.mp3',
          description: null,
          size: 15808,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Reverse Lunge with Overhead Reach': {
      id: 2,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Lunge with Overhead Reach',
      short_name: 'Rev. Lunge w. Overh. Reach',
      unique_name: 'BEGINNER-Reverse Lunge with Overhead Reach',
      description:
        '1. From a standing position, step backwards with one leg and bend your front knee to 90 degrees as you reach both arms up overhead.\r\n2. Pause for a beat and return back to standing.\r\n3. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 4,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '3f452b9b502d2fe6a784746a75a8717c318737fae7ba8a9d4663c0df252fbb1f',
          file_name:
            'videos/3f452b9b502d2fe6a784746a75a8717c318737fae7ba8a9d4663c0df252fbb1f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3f452b9b502d2fe6a784746a75a8717c318737fae7ba8a9d4663c0df252fbb1f.mp4',
          name: 'LOGAN_ALT_LUNGE_WITH_REACH_AC_30sec_SMALL_720.mp4',
          description: null,
          size: 1235454,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 5,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '4a8c0ddfc57fc8b297fc248299d47162552201b39abdbaadbd56f8d26568ef80',
          file_name:
            'audios/4a8c0ddfc57fc8b297fc248299d47162552201b39abdbaadbd56f8d26568ef80.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4a8c0ddfc57fc8b297fc248299d47162552201b39abdbaadbd56f8d26568ef80.mp3',
          name: 'Reverse_Lunges_with_Overhead_Reach.mp3',
          description: null,
          size: 41139,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Standing Quad Stretch': {
      id: 3,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Standing Quad Stretch',
      short_name: 'Standing Quad Stretch',
      unique_name: 'BEGINNER-Standing Quad Stretch',
      description:
        '1. Stand on one leg and hold your opposite foot behind you. Shift your hips forward for a deeper stretch.\n2. Release your foot and step forward.\n3. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 6,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '3b3fdef8016c4a67f76f7e7475a2ed7ab5d6fd7302767fff7756dc38f8a18589',
          file_name:
            'videos/3b3fdef8016c4a67f76f7e7475a2ed7ab5d6fd7302767fff7756dc38f8a18589.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3b3fdef8016c4a67f76f7e7475a2ed7ab5d6fd7302767fff7756dc38f8a18589.mp4',
          name: 'LOGAN_STANDING_QUAD_STRETCH_AB_2_30sec_SAMLL_720.mp4',
          description: null,
          size: 907758,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 7,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'f59a64d9393e4ee8d9fadc635c2c23c625e68f967a57ca51d5346ee3bbdd2d1f',
          file_name:
            'audios/f59a64d9393e4ee8d9fadc635c2c23c625e68f967a57ca51d5346ee3bbdd2d1f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f59a64d9393e4ee8d9fadc635c2c23c625e68f967a57ca51d5346ee3bbdd2d1f.mp3',
          name: 'Standing_Quad_Stretch.mp3',
          description: null,
          size: 26464,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Body Weight Good Mornings': {
      id: 4,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Bodyweight Good Mornings',
      short_name: 'Bodyw. Good Mornings',
      unique_name: 'BEGINNER-Body Weight Good Mornings',
      description:
        '1. From a standing position, feet shoulder-width apart, put your hands behind your head, elbows extended out wide.\n2. With a slight bend in your knees, push your hips back and “take a bow.”\n3. Pause for a beat when your torso is parallel to the floor.\n4. Return to standing and repeat.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 8,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '99d3aea07dfc805f7cc323743a04de2459231da486b7a5e0d91225afc714f39f',
          file_name:
            'videos/99d3aea07dfc805f7cc323743a04de2459231da486b7a5e0d91225afc714f39f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/99d3aea07dfc805f7cc323743a04de2459231da486b7a5e0d91225afc714f39f.mp4',
          name: 'LOGAN_BODY_WEIGHT_GOODMORNINGS_AD_30sec_SMALL_720.mp4',
          description: null,
          size: 976023,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 9,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '234fe59abf1bd3e62a77d2ac8ed1946f270b08b0d88c857f205c8497aee02eed',
          file_name:
            'audios/234fe59abf1bd3e62a77d2ac8ed1946f270b08b0d88c857f205c8497aee02eed.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/234fe59abf1bd3e62a77d2ac8ed1946f270b08b0d88c857f205c8497aee02eed.mp3',
          name: 'Bodyweight_Good_Mornings.mp3',
          description: null,
          size: 28192,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Inchworms': {
      id: 5,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Inchworms',
      short_name: 'Inchworms',
      unique_name: 'BEGINNER-Inchworms',
      description:
        '1. From a standing position, bend from your hips until your hands reach the floor. (You can bend your knees if necessary).\n2. Walk your hands out in front of you until you are in Plank position. Pause for a beat.\n3. Walk your hands back to your feet, keeping your legs as straight as possible.\n4. Return to standing. Repeat.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 10,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'a7e58572e1d5ead5d143be0dd569a04f96a02a7d03120cf7977d91daab434e29',
          file_name:
            'videos/a7e58572e1d5ead5d143be0dd569a04f96a02a7d03120cf7977d91daab434e29.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a7e58572e1d5ead5d143be0dd569a04f96a02a7d03120cf7977d91daab434e29.mp4',
          name: 'LOGAN_INCH_WORMS_AA_30sec_SAMLL_720.mp4',
          description: null,
          size: 1374799,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 11,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '6c9e9548ae5d30bd5c9200923712d24a361ba5182f40090f86f8302085efcf75',
          file_name:
            'audios/6c9e9548ae5d30bd5c9200923712d24a361ba5182f40090f86f8302085efcf75.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6c9e9548ae5d30bd5c9200923712d24a361ba5182f40090f86f8302085efcf75.mp3',
          name: 'BEG-INT-ADV-Inchworms-WARM_UP.mp3',
          description: null,
          size: 19038,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-High Knees': {
      id: 6,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'High Knees',
      short_name: 'High Knees',
      unique_name: 'BEGINNER-High Knees',
      description:
        '1. Jog or walk in place while lifting your knees as high as you can.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 12,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '56282dbee53b13d73867331a678df6dd81cacd504fd933920a4e17bb80b79278',
          file_name:
            'videos/56282dbee53b13d73867331a678df6dd81cacd504fd933920a4e17bb80b79278.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/56282dbee53b13d73867331a678df6dd81cacd504fd933920a4e17bb80b79278.mp4',
          name: 'EVE_HIGH_KNEES_1_30sec_SMALL_720.mp4',
          description: null,
          size: 2177353,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 13,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '718d82f535c46ca9673eec9821b2bfd5ef78b98584cfe355adc3df3d0b6a584a',
          file_name:
            'audios/718d82f535c46ca9673eec9821b2bfd5ef78b98584cfe355adc3df3d0b6a584a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/718d82f535c46ca9673eec9821b2bfd5ef78b98584cfe355adc3df3d0b6a584a.mp3',
          name: 'High_Knees.mp3',
          description: null,
          size: 19264,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Low Squat with Alternating Hip Openers': {
      id: 7,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Low Squat with Alternating Hip Openers',
      short_name: 'Low Squat w. Alt. Hip Opener',
      unique_name: 'BEGINNER-Low Squat with Alternating Hip Openers',
      description:
        '1. Start standing with your feet roughly shoulder-width apart.\n2. Keeping your chest up, drive your hips back and bend your knees to squat down as low as you can.\n3. As you come up, swing one leg up and out, as if swinging it over an invisible chair. (You can bend your knees if necessary)\n4. Squat again and repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 14,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '42bb3f542b347a258a1a084028bb8b4b5028c8ce99bc6cf4b4f013f64c825519',
          file_name:
            'videos/42bb3f542b347a258a1a084028bb8b4b5028c8ce99bc6cf4b4f013f64c825519.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/42bb3f542b347a258a1a084028bb8b4b5028c8ce99bc6cf4b4f013f64c825519.mp4',
          name: 'EVE_LOW_SQUAT_W_ALT_HIP_OPENERS_1_30sec_SMALL_720.mp4',
          description: null,
          size: 1645902,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 15,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'fe4982b7661d947d51aac3fdcc4c4658316e3461265d26b52ef87fe598bc0832',
          file_name:
            'audios/fe4982b7661d947d51aac3fdcc4c4658316e3461265d26b52ef87fe598bc0832.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fe4982b7661d947d51aac3fdcc4c4658316e3461265d26b52ef87fe598bc0832.mp3',
          name: 'BEG-INT-ADV-Low_Squat_with_Alternating_Hip_Opener-WARM_UP.mp3',
          description: null,
          size: 45142,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Five Fast Feet to Tuck Jump': {
      id: 8,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Five Fast Feet to Tuck Jump',
      short_name: 'Five Fast Feet to Tuck Jump',
      unique_name: 'BEGINNER-Five Fast Feet to Tuck Jump',
      description:
        '1. Start standing with your feet a little wider than hip-width apart and knees slightly bent.  Take five tiny fast running steps in place.\n2. Jump as high as you can while tucking both knees to your chest. Land soft.\n3. Repeat. (To modify, omit the tuck and simply jump as high as you can or perform a squat instead)',
      preview_time: null,
      min_app_version: 100000000,
      archived: true,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 20,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '9a710a8a0ac3ddf8bb17f6f922d9445906c93eda1db8974c2aa9cd20b9fad8a9',
          file_name:
            'videos/9a710a8a0ac3ddf8bb17f6f922d9445906c93eda1db8974c2aa9cd20b9fad8a9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9a710a8a0ac3ddf8bb17f6f922d9445906c93eda1db8974c2aa9cd20b9fad8a9.mp4',
          name: 'EVE_FIVE_FAST_FEET_JUMP_2_30sec_SMALL_720.mp4',
          description: null,
          size: 2250466,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 21,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d',
          file_name:
            'audios/53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d.mp3',
          name: 'Five_Fast_Feet_to_Tuck_Jump.mp3',
          description: null,
          size: 32863,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating Lizard Lunge with Rotation': {
      id: 9,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Lizard Lunge with Rotation',
      short_name: 'Alt. Lizard Lunge w. Rotation',
      unique_name: 'BEGINNER-Alternating Lizard Lunge with Rotation',
      description:
        '1. Start in Plank position.  Step forward with one leg and place your foot outside the same side hand, front knee bent at 90 degrees.\n2. Twist your torso towards the bent knee as you raise your arm straight up. The other hand remains on the floor. Pause.\n3. Return your extended hand back to the floor and return to Plank position.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 23,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'a425931c9081839136c16e5150c893fd633be8cd2f2f8816c3c6835ff3693fe7',
          file_name:
            'audios/a425931c9081839136c16e5150c893fd633be8cd2f2f8816c3c6835ff3693fe7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a425931c9081839136c16e5150c893fd633be8cd2f2f8816c3c6835ff3693fe7.mp3',
          name: 'Alternating_Lizard_Lunge_with_Rotation.mp3',
          description: null,
          size: 40063,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2575,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'a93a15824a635efa2a4a3415c3d1446f8c24a07e90204df32ad372d5d8baef0b',
          file_name:
            'videos/a93a15824a635efa2a4a3415c3d1446f8c24a07e90204df32ad372d5d8baef0b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a93a15824a635efa2a4a3415c3d1446f8c24a07e90204df32ad372d5d8baef0b.mp4',
          name: 'BEG-INT-ADV-Alternating_Lizard_Lunge_with_Rotation-WARM_UP',
          description: null,
          size: 2132338,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Up Down Dog': {
      id: 10,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Up/Down Dog',
      short_name: 'Up/Down Dog',
      unique_name: 'BEGINNER-Up Down Dog',
      description:
        '1. Start in Down Dog position.  Your hands are on the ground with your head between your upper arms and your hips are up and back making an inverted "V"\n2. Lower your hips towards the floor while raising your head and chest. Keep your arms straight and look slightly upward. Pause.\n3. Move back and forth between these two positions with control and core engaged.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 25,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '730fe33ed8a74637eb0bf7ae6180870c716697c91f872e774176a7e5ca72356e',
          file_name:
            'audios/730fe33ed8a74637eb0bf7ae6180870c716697c91f872e774176a7e5ca72356e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/730fe33ed8a74637eb0bf7ae6180870c716697c91f872e774176a7e5ca72356e.mp3',
          name: 'BEG-INT-ADV-Up_Down_Dog-WARM_UP.mp3',
          description: null,
          size: 32894,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2578,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '633999f878a7ad34ab4e2c4c03f12d2b03df57dc78febb238a1ac31f4d95ea28',
          file_name:
            'videos/633999f878a7ad34ab4e2c4c03f12d2b03df57dc78febb238a1ac31f4d95ea28.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/633999f878a7ad34ab4e2c4c03f12d2b03df57dc78febb238a1ac31f4d95ea28.mp4',
          name: 'BEG-INT-ADV-Up_Down_Dog-WARM_UP',
          description: null,
          size: 1204984,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating Knee Huggers': {
      id: 11,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Knee Huggers',
      short_name: 'Alt. Knee Huggers',
      unique_name: 'BEGINNER-Alternating Knee Huggers',
      description:
        '1. Stand on one leg and lift the opposite knee.\n2. Hug your knee in close to your chest.\n3. Pause for a beat and return back to standing.\n4. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 27,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '8dfec456034636b8d27e6365eab489beac265293732a8d041764d67f0eac9eab',
          file_name:
            'audios/8dfec456034636b8d27e6365eab489beac265293732a8d041764d67f0eac9eab.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8dfec456034636b8d27e6365eab489beac265293732a8d041764d67f0eac9eab.mp3',
          name: 'Alternating_Knee_Huggers.mp3',
          description: null,
          size: 26176,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2581,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '5f66307fc893d5cadde7f214a004c3e6a6c6d17c572ba3361942f0271a74d9b7',
          file_name:
            'videos/5f66307fc893d5cadde7f214a004c3e6a6c6d17c572ba3361942f0271a74d9b7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5f66307fc893d5cadde7f214a004c3e6a6c6d17c572ba3361942f0271a74d9b7.mp4',
          name: 'BEG-INT-ADV-Alternating_Knee_Huggers-WARM_UP',
          description: null,
          size: 1011443,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Butt Kickers': {
      id: 12,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Butt Kickers',
      short_name: 'Butt Kickers',
      unique_name: 'BEGINNER-Butt Kickers',
      description:
        '1. Jog or walk in place, trying to kick your rear with each foot when it is bent behind you.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 28,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '8ef82b713a5cbe6d2eef7a83938a83f1153fe4a535193f519b5b67c637309a36',
          file_name:
            'videos/8ef82b713a5cbe6d2eef7a83938a83f1153fe4a535193f519b5b67c637309a36.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8ef82b713a5cbe6d2eef7a83938a83f1153fe4a535193f519b5b67c637309a36.mp4',
          name: 'CARRIE_BUTT_KICKERS_1_30sec_720.mp4',
          description: null,
          size: 1941665,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 29,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '6ce6454efb35f4ad0f8349012bda450ea403ea58f696a728c47e304cfc8dea8f',
          file_name:
            'audios/6ce6454efb35f4ad0f8349012bda450ea403ea58f696a728c47e304cfc8dea8f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6ce6454efb35f4ad0f8349012bda450ea403ea58f696a728c47e304cfc8dea8f.mp3',
          name: 'Butt_Kickers.mp3',
          description: null,
          size: 20416,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Slow Outside Mountain Climbers': {
      id: 13,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Slow Outside Mountain Climbers',
      short_name: 'Slow Outside Mountain Climbers',
      unique_name: 'BEGINNER-Slow Outside Mountain Climbers',
      description:
        '1. Start in Plank position.\n2. Bring one knee out to the side and as close to the same side tricep as possible. Pause for a beat.\n3. Move your leg back and return to Plank position.\n4. Repeat on the other side',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 31,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'c8564961368a45a0d02fd33a85b7e93f034e5ec5f977fd4c13fc6c7744530b46',
          file_name:
            'audios/c8564961368a45a0d02fd33a85b7e93f034e5ec5f977fd4c13fc6c7744530b46.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c8564961368a45a0d02fd33a85b7e93f034e5ec5f977fd4c13fc6c7744530b46.mp3',
          name: 'Slow_Outside_Mountain_Climbers.mp3',
          description: null,
          size: 34529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2584,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '86c94357c56e34f845c3927bfb6cdeb8b2a4680f18f818d61d2ec7cbc5f11bc4',
          file_name:
            'videos/86c94357c56e34f845c3927bfb6cdeb8b2a4680f18f818d61d2ec7cbc5f11bc4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86c94357c56e34f845c3927bfb6cdeb8b2a4680f18f818d61d2ec7cbc5f11bc4.mp4',
          name: 'BEG-INT-ADV-Slow_Outside_Mountain_Climbers-WARM_UP',
          description: null,
          size: 843247,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Reverse Lunge with Overhead Reach': {
      id: 45,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Lunge with Overhead Reach',
      short_name: 'Rev. Lunge w. Overh. Reach',
      unique_name: 'INTERMEDIATE-Reverse Lunge with Overhead Reach',
      description:
        '1. From a standing position, step backwards with one leg and bend your front knee to 90 degrees as you reach both arms up overhead.\r\n2. Pause for a beat and return back to standing.\r\n3. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 98,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '3f452b9b502d2fe6a784746a75a8717c318737fae7ba8a9d4663c0df252fbb1f',
          file_name:
            'videos/3f452b9b502d2fe6a784746a75a8717c318737fae7ba8a9d4663c0df252fbb1f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3f452b9b502d2fe6a784746a75a8717c318737fae7ba8a9d4663c0df252fbb1f.mp4',
          name: 'LOGAN_ALT_LUNGE_WITH_REACH_AC_30sec_SMALL_720.mp4',
          description: null,
          size: 1235454,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 99,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '4a8c0ddfc57fc8b297fc248299d47162552201b39abdbaadbd56f8d26568ef80',
          file_name:
            'audios/4a8c0ddfc57fc8b297fc248299d47162552201b39abdbaadbd56f8d26568ef80.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4a8c0ddfc57fc8b297fc248299d47162552201b39abdbaadbd56f8d26568ef80.mp3',
          name: 'Reverse_Lunges_with_Overhead_Reach.mp3',
          description: null,
          size: 41139,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Standing Quad Stretch': {
      id: 46,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Standing Quad Stretch',
      short_name: 'Standing Quad Stretch',
      unique_name: 'INTERMEDIATE-Standing Quad Stretch',
      description:
        '1. Stand on one leg and hold your opposite foot behind you. Shift your hips forward for a deeper stretch.\n2. Release your foot and step forward.\n3. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 100,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '3b3fdef8016c4a67f76f7e7475a2ed7ab5d6fd7302767fff7756dc38f8a18589',
          file_name:
            'videos/3b3fdef8016c4a67f76f7e7475a2ed7ab5d6fd7302767fff7756dc38f8a18589.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3b3fdef8016c4a67f76f7e7475a2ed7ab5d6fd7302767fff7756dc38f8a18589.mp4',
          name: 'LOGAN_STANDING_QUAD_STRETCH_AB_2_30sec_SAMLL_720.mp4',
          description: null,
          size: 907758,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 101,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'f59a64d9393e4ee8d9fadc635c2c23c625e68f967a57ca51d5346ee3bbdd2d1f',
          file_name:
            'audios/f59a64d9393e4ee8d9fadc635c2c23c625e68f967a57ca51d5346ee3bbdd2d1f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f59a64d9393e4ee8d9fadc635c2c23c625e68f967a57ca51d5346ee3bbdd2d1f.mp3',
          name: 'Standing_Quad_Stretch.mp3',
          description: null,
          size: 26464,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Body Weight Good Mornings': {
      id: 47,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Bodyweight Good Mornings',
      short_name: 'Bodyw. Good Mornings',
      unique_name: 'INTERMEDIATE-Body Weight Good Mornings',
      description:
        '1. From a standing position, feet shoulder-width apart, put your hands behind your head, elbows extended out wide.\n2. With a slight bend in your knees, push your hips back and “take a bow.”\n3. Pause for a beat when your torso is parallel to the floor.\n4. Return to standing and repeat.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 102,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '99d3aea07dfc805f7cc323743a04de2459231da486b7a5e0d91225afc714f39f',
          file_name:
            'videos/99d3aea07dfc805f7cc323743a04de2459231da486b7a5e0d91225afc714f39f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/99d3aea07dfc805f7cc323743a04de2459231da486b7a5e0d91225afc714f39f.mp4',
          name: 'LOGAN_BODY_WEIGHT_GOODMORNINGS_AD_30sec_SMALL_720.mp4',
          description: null,
          size: 976023,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 103,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '234fe59abf1bd3e62a77d2ac8ed1946f270b08b0d88c857f205c8497aee02eed',
          file_name:
            'audios/234fe59abf1bd3e62a77d2ac8ed1946f270b08b0d88c857f205c8497aee02eed.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/234fe59abf1bd3e62a77d2ac8ed1946f270b08b0d88c857f205c8497aee02eed.mp3',
          name: 'Bodyweight_Good_Mornings.mp3',
          description: null,
          size: 28192,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Inchworms': {
      id: 48,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Inchworms',
      short_name: 'Inchworms',
      unique_name: 'INTERMEDIATE-Inchworms',
      description:
        '1. From a standing position, bend from your hips until your hands reach the floor. (You can bend your knees if necessary).\n2. Walk your hands out in front of you until you are in Plank position. Pause for a beat.\n3. Walk your hands back to your feet, keeping your legs as straight as possible.\n4. Return to standing. Repeat.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 104,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'a7e58572e1d5ead5d143be0dd569a04f96a02a7d03120cf7977d91daab434e29',
          file_name:
            'videos/a7e58572e1d5ead5d143be0dd569a04f96a02a7d03120cf7977d91daab434e29.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a7e58572e1d5ead5d143be0dd569a04f96a02a7d03120cf7977d91daab434e29.mp4',
          name: 'LOGAN_INCH_WORMS_AA_30sec_SAMLL_720.mp4',
          description: null,
          size: 1374799,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 105,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '6c9e9548ae5d30bd5c9200923712d24a361ba5182f40090f86f8302085efcf75',
          file_name:
            'audios/6c9e9548ae5d30bd5c9200923712d24a361ba5182f40090f86f8302085efcf75.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6c9e9548ae5d30bd5c9200923712d24a361ba5182f40090f86f8302085efcf75.mp3',
          name: 'BEG-INT-ADV-Inchworms-WARM_UP.mp3',
          description: null,
          size: 19038,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-High Knees': {
      id: 49,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'High Knees',
      short_name: 'High Knees',
      unique_name: 'INTERMEDIATE-High Knees',
      description:
        '1. Jog or walk in place while lifting your knees as high as you can.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 106,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '56282dbee53b13d73867331a678df6dd81cacd504fd933920a4e17bb80b79278',
          file_name:
            'videos/56282dbee53b13d73867331a678df6dd81cacd504fd933920a4e17bb80b79278.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/56282dbee53b13d73867331a678df6dd81cacd504fd933920a4e17bb80b79278.mp4',
          name: 'EVE_HIGH_KNEES_1_30sec_SMALL_720.mp4',
          description: null,
          size: 2177353,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 107,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '718d82f535c46ca9673eec9821b2bfd5ef78b98584cfe355adc3df3d0b6a584a',
          file_name:
            'audios/718d82f535c46ca9673eec9821b2bfd5ef78b98584cfe355adc3df3d0b6a584a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/718d82f535c46ca9673eec9821b2bfd5ef78b98584cfe355adc3df3d0b6a584a.mp3',
          name: 'High_Knees.mp3',
          description: null,
          size: 19264,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Low Squat with Alternating Hip Openers': {
      id: 50,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Low Squat with Alternating Hip Openers',
      short_name: 'Low Squat w. Alt. Hip Opener',
      unique_name: 'INTERMEDIATE-Low Squat with Alternating Hip Openers',
      description:
        '1. Start standing with your feet roughly shoulder-width apart.\n2. Keeping your chest up, drive your hips back and bend your knees to squat down as low as you can.\n3. As you come up, swing one leg up and out, as if swinging it over an invisible chair. (You can bend your knees if necessary)\n4. Squat again and repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 16,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '42bb3f542b347a258a1a084028bb8b4b5028c8ce99bc6cf4b4f013f64c825519',
          file_name:
            'videos/42bb3f542b347a258a1a084028bb8b4b5028c8ce99bc6cf4b4f013f64c825519.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/42bb3f542b347a258a1a084028bb8b4b5028c8ce99bc6cf4b4f013f64c825519.mp4',
          name: 'EVE_LOW_SQUAT_W_ALT_HIP_OPENERS_1_30sec_SMALL_720.mp4',
          description: null,
          size: 1645902,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 17,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'fe4982b7661d947d51aac3fdcc4c4658316e3461265d26b52ef87fe598bc0832',
          file_name:
            'audios/fe4982b7661d947d51aac3fdcc4c4658316e3461265d26b52ef87fe598bc0832.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fe4982b7661d947d51aac3fdcc4c4658316e3461265d26b52ef87fe598bc0832.mp3',
          name: 'BEG-INT-ADV-Low_Squat_with_Alternating_Hip_Opener-WARM_UP.mp3',
          description: null,
          size: 45142,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Five Fast Feet to Tuck Jump': {
      id: 51,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Five Fast Feet to Tuck Jump',
      short_name: 'Five Fast Feet to Tuck Jump',
      unique_name: 'INTERMEDIATE-Five Fast Feet to Tuck Jump',
      description:
        '1. Start standing with your feet a little wider than hip-width apart and knees slightly bent. Take five tiny fast running steps in place.\n2. Jump as high as you can while tucking both knees to your chest. Land soft.\n3. Repeat. (To modify, omit the tuck and simply jump as high as you can or perform a squat instead)',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 108,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '9a710a8a0ac3ddf8bb17f6f922d9445906c93eda1db8974c2aa9cd20b9fad8a9',
          file_name:
            'videos/9a710a8a0ac3ddf8bb17f6f922d9445906c93eda1db8974c2aa9cd20b9fad8a9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9a710a8a0ac3ddf8bb17f6f922d9445906c93eda1db8974c2aa9cd20b9fad8a9.mp4',
          name: 'EVE_FIVE_FAST_FEET_JUMP_2_30sec_SMALL_720.mp4',
          description: null,
          size: 2250466,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 109,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d',
          file_name:
            'audios/53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d.mp3',
          name: 'Five_Fast_Feet_to_Tuck_Jump.mp3',
          description: null,
          size: 32863,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Alternating Lizard Lunge with Rotation': {
      id: 52,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Lizard Lunge with Rotation',
      short_name: 'Alt. Lizard Lunge w. Rotation',
      unique_name: 'INTERMEDIATE-Alternating Lizard Lunge with Rotation',
      description:
        '1. Start in Plank position. Step forward with one leg and place your foot outside the same side hand, front knee bent at 90 degrees.\n2. Twist your torso towards the bent knee as you raise your arm straight up. The other hand remains on the floor. Pause.\n3. Return your extended hand back to the floor and return to Plank position.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 111,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'a425931c9081839136c16e5150c893fd633be8cd2f2f8816c3c6835ff3693fe7',
          file_name:
            'audios/a425931c9081839136c16e5150c893fd633be8cd2f2f8816c3c6835ff3693fe7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a425931c9081839136c16e5150c893fd633be8cd2f2f8816c3c6835ff3693fe7.mp3',
          name: 'Alternating_Lizard_Lunge_with_Rotation.mp3',
          description: null,
          size: 40063,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2576,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'a93a15824a635efa2a4a3415c3d1446f8c24a07e90204df32ad372d5d8baef0b',
          file_name:
            'videos/a93a15824a635efa2a4a3415c3d1446f8c24a07e90204df32ad372d5d8baef0b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a93a15824a635efa2a4a3415c3d1446f8c24a07e90204df32ad372d5d8baef0b.mp4',
          name: 'BEG-INT-ADV-Alternating_Lizard_Lunge_with_Rotation-WARM_UP',
          description: null,
          size: 2132338,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Up Down Dog': {
      id: 53,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Up/Down Dog',
      short_name: 'Up/Down Dog',
      unique_name: 'INTERMEDIATE-Up Down Dog',
      description:
        '1. Start in Down Dog position. Your hands are on the ground with your head between your upper arms and your hips are up and back making an inverted "V"\n2. Lower your hips towards the floor while raising your head and chest. Keep your arms straight and look slightly upward. Pause.\n3. Move back and forth between these two positions with control and core engaged.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 113,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '730fe33ed8a74637eb0bf7ae6180870c716697c91f872e774176a7e5ca72356e',
          file_name:
            'audios/730fe33ed8a74637eb0bf7ae6180870c716697c91f872e774176a7e5ca72356e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/730fe33ed8a74637eb0bf7ae6180870c716697c91f872e774176a7e5ca72356e.mp3',
          name: 'BEG-INT-ADV-Up_Down_Dog-WARM_UP.mp3',
          description: null,
          size: 32894,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2579,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '633999f878a7ad34ab4e2c4c03f12d2b03df57dc78febb238a1ac31f4d95ea28',
          file_name:
            'videos/633999f878a7ad34ab4e2c4c03f12d2b03df57dc78febb238a1ac31f4d95ea28.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/633999f878a7ad34ab4e2c4c03f12d2b03df57dc78febb238a1ac31f4d95ea28.mp4',
          name: 'BEG-INT-ADV-Up_Down_Dog-WARM_UP',
          description: null,
          size: 1204984,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Alternating Knee Huggers': {
      id: 54,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Knee Huggers',
      short_name: 'Alt. Knee Huggers',
      unique_name: 'INTERMEDIATE-Alternating Knee Huggers',
      description:
        '1. Stand on one leg and lift the opposite knee.\n2. Hug your knee in close to your chest.\n3. Pause for a beat and return back to standing.\n4. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 115,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '8dfec456034636b8d27e6365eab489beac265293732a8d041764d67f0eac9eab',
          file_name:
            'audios/8dfec456034636b8d27e6365eab489beac265293732a8d041764d67f0eac9eab.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8dfec456034636b8d27e6365eab489beac265293732a8d041764d67f0eac9eab.mp3',
          name: 'Alternating_Knee_Huggers.mp3',
          description: null,
          size: 26176,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2582,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '5f66307fc893d5cadde7f214a004c3e6a6c6d17c572ba3361942f0271a74d9b7',
          file_name:
            'videos/5f66307fc893d5cadde7f214a004c3e6a6c6d17c572ba3361942f0271a74d9b7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5f66307fc893d5cadde7f214a004c3e6a6c6d17c572ba3361942f0271a74d9b7.mp4',
          name: 'BEG-INT-ADV-Alternating_Knee_Huggers-WARM_UP',
          description: null,
          size: 1011443,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Butt Kickers': {
      id: 55,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Butt Kickers',
      short_name: 'Butt Kickers',
      unique_name: 'INTERMEDIATE-Butt Kickers',
      description:
        '1. Jog or walk in place, trying to kick your rear with each foot when it is bent behind you.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 116,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '8ef82b713a5cbe6d2eef7a83938a83f1153fe4a535193f519b5b67c637309a36',
          file_name:
            'videos/8ef82b713a5cbe6d2eef7a83938a83f1153fe4a535193f519b5b67c637309a36.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8ef82b713a5cbe6d2eef7a83938a83f1153fe4a535193f519b5b67c637309a36.mp4',
          name: 'CARRIE_BUTT_KICKERS_1_30sec_720.mp4',
          description: null,
          size: 1941665,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 117,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '6ce6454efb35f4ad0f8349012bda450ea403ea58f696a728c47e304cfc8dea8f',
          file_name:
            'audios/6ce6454efb35f4ad0f8349012bda450ea403ea58f696a728c47e304cfc8dea8f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6ce6454efb35f4ad0f8349012bda450ea403ea58f696a728c47e304cfc8dea8f.mp3',
          name: 'Butt_Kickers.mp3',
          description: null,
          size: 20416,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Slow Outside Mountain Climbers': {
      id: 56,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Slow Outside Mountain Climbers',
      short_name: 'Slow Outside Mountain Climbers',
      unique_name: 'INTERMEDIATE-Slow Outside Mountain Climbers',
      description:
        '1. Start in Plank position.\n2. Bring one knee out to the side and as close to the same side tricep as possible. Pause for a beat.\n3. Move your leg back and return to Plank position.\n4. Repeat on the other side',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 119,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'c8564961368a45a0d02fd33a85b7e93f034e5ec5f977fd4c13fc6c7744530b46',
          file_name:
            'audios/c8564961368a45a0d02fd33a85b7e93f034e5ec5f977fd4c13fc6c7744530b46.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c8564961368a45a0d02fd33a85b7e93f034e5ec5f977fd4c13fc6c7744530b46.mp3',
          name: 'Slow_Outside_Mountain_Climbers.mp3',
          description: null,
          size: 34529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2585,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '86c94357c56e34f845c3927bfb6cdeb8b2a4680f18f818d61d2ec7cbc5f11bc4',
          file_name:
            'videos/86c94357c56e34f845c3927bfb6cdeb8b2a4680f18f818d61d2ec7cbc5f11bc4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86c94357c56e34f845c3927bfb6cdeb8b2a4680f18f818d61d2ec7cbc5f11bc4.mp4',
          name: 'BEG-INT-ADV-Slow_Outside_Mountain_Climbers-WARM_UP',
          description: null,
          size: 843247,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Reverse Lunge with Overhead Reach': {
      id: 88,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Lunge with Overhead Reach',
      short_name: 'Rev. Lunge w. Overh. Reach',
      unique_name: 'ADVANCED-Reverse Lunge with Overhead Reach',
      description:
        '1. From a standing position, step backwards with one leg and bend your front knee to 90 degrees as you reach both arms up overhead.\r\n2. Pause for a beat and return back to standing.\r\n3. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 186,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '3f452b9b502d2fe6a784746a75a8717c318737fae7ba8a9d4663c0df252fbb1f',
          file_name:
            'videos/3f452b9b502d2fe6a784746a75a8717c318737fae7ba8a9d4663c0df252fbb1f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3f452b9b502d2fe6a784746a75a8717c318737fae7ba8a9d4663c0df252fbb1f.mp4',
          name: 'LOGAN_ALT_LUNGE_WITH_REACH_AC_30sec_SMALL_720.mp4',
          description: null,
          size: 1235454,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 187,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '4a8c0ddfc57fc8b297fc248299d47162552201b39abdbaadbd56f8d26568ef80',
          file_name:
            'audios/4a8c0ddfc57fc8b297fc248299d47162552201b39abdbaadbd56f8d26568ef80.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4a8c0ddfc57fc8b297fc248299d47162552201b39abdbaadbd56f8d26568ef80.mp3',
          name: 'Reverse_Lunges_with_Overhead_Reach.mp3',
          description: null,
          size: 41139,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Standing Quad Stretch': {
      id: 89,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Standing Quad Stretch',
      short_name: 'Standing Quad Stretch',
      unique_name: 'ADVANCED-Standing Quad Stretch',
      description:
        '1. Stand on one leg and hold your opposite foot behind you. Shift your hips forward for a deeper stretch.\n2. Release your foot and step forward.\n3. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 188,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '3b3fdef8016c4a67f76f7e7475a2ed7ab5d6fd7302767fff7756dc38f8a18589',
          file_name:
            'videos/3b3fdef8016c4a67f76f7e7475a2ed7ab5d6fd7302767fff7756dc38f8a18589.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3b3fdef8016c4a67f76f7e7475a2ed7ab5d6fd7302767fff7756dc38f8a18589.mp4',
          name: 'LOGAN_STANDING_QUAD_STRETCH_AB_2_30sec_SAMLL_720.mp4',
          description: null,
          size: 907758,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 189,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'f59a64d9393e4ee8d9fadc635c2c23c625e68f967a57ca51d5346ee3bbdd2d1f',
          file_name:
            'audios/f59a64d9393e4ee8d9fadc635c2c23c625e68f967a57ca51d5346ee3bbdd2d1f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f59a64d9393e4ee8d9fadc635c2c23c625e68f967a57ca51d5346ee3bbdd2d1f.mp3',
          name: 'Standing_Quad_Stretch.mp3',
          description: null,
          size: 26464,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Body Weight Good Mornings': {
      id: 90,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Bodyweight Good Mornings',
      short_name: 'Bodyw. Good Mornings',
      unique_name: 'ADVANCED-Body Weight Good Mornings',
      description:
        '1. From a standing position, feet shoulder-width apart, put your hands behind your head, elbows extended out wide.\n2. With a slight bend in your knees, push your hips back and “take a bow".\n3. Pause for a beat when your torso is parallel to the floor.\n4. Return to standing and repeat.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 190,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '99d3aea07dfc805f7cc323743a04de2459231da486b7a5e0d91225afc714f39f',
          file_name:
            'videos/99d3aea07dfc805f7cc323743a04de2459231da486b7a5e0d91225afc714f39f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/99d3aea07dfc805f7cc323743a04de2459231da486b7a5e0d91225afc714f39f.mp4',
          name: 'LOGAN_BODY_WEIGHT_GOODMORNINGS_AD_30sec_SMALL_720.mp4',
          description: null,
          size: 976023,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 191,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '234fe59abf1bd3e62a77d2ac8ed1946f270b08b0d88c857f205c8497aee02eed',
          file_name:
            'audios/234fe59abf1bd3e62a77d2ac8ed1946f270b08b0d88c857f205c8497aee02eed.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/234fe59abf1bd3e62a77d2ac8ed1946f270b08b0d88c857f205c8497aee02eed.mp3',
          name: 'Bodyweight_Good_Mornings.mp3',
          description: null,
          size: 28192,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Inchworms': {
      id: 91,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Inchworms',
      short_name: 'Inchworms',
      unique_name: 'ADVANCED-Inchworms',
      description:
        '1. From a standing position, bend from your hips until your hands reach the floor. (You can bend your knees if necessary).\n2. Walk your hands out in front of you until you are in Plank position. Pause for a beat.\n3. Walk your hands back to your feet, keeping your legs as straight as possible.\n4. Return to standing. Repeat.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 192,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'a7e58572e1d5ead5d143be0dd569a04f96a02a7d03120cf7977d91daab434e29',
          file_name:
            'videos/a7e58572e1d5ead5d143be0dd569a04f96a02a7d03120cf7977d91daab434e29.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a7e58572e1d5ead5d143be0dd569a04f96a02a7d03120cf7977d91daab434e29.mp4',
          name: 'LOGAN_INCH_WORMS_AA_30sec_SAMLL_720.mp4',
          description: null,
          size: 1374799,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 193,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '6c9e9548ae5d30bd5c9200923712d24a361ba5182f40090f86f8302085efcf75',
          file_name:
            'audios/6c9e9548ae5d30bd5c9200923712d24a361ba5182f40090f86f8302085efcf75.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6c9e9548ae5d30bd5c9200923712d24a361ba5182f40090f86f8302085efcf75.mp3',
          name: 'BEG-INT-ADV-Inchworms-WARM_UP.mp3',
          description: null,
          size: 19038,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-High Knees': {
      id: 92,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'High Knees',
      short_name: 'High Knees',
      unique_name: 'ADVANCED-High Knees',
      description:
        '1. Jog or walk in place while lifting your knees as high as you can.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 194,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '56282dbee53b13d73867331a678df6dd81cacd504fd933920a4e17bb80b79278',
          file_name:
            'videos/56282dbee53b13d73867331a678df6dd81cacd504fd933920a4e17bb80b79278.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/56282dbee53b13d73867331a678df6dd81cacd504fd933920a4e17bb80b79278.mp4',
          name: 'EVE_HIGH_KNEES_1_30sec_SMALL_720.mp4',
          description: null,
          size: 2177353,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 195,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '718d82f535c46ca9673eec9821b2bfd5ef78b98584cfe355adc3df3d0b6a584a',
          file_name:
            'audios/718d82f535c46ca9673eec9821b2bfd5ef78b98584cfe355adc3df3d0b6a584a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/718d82f535c46ca9673eec9821b2bfd5ef78b98584cfe355adc3df3d0b6a584a.mp3',
          name: 'High_Knees.mp3',
          description: null,
          size: 19264,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Low Squat with Alternating Hip Openers': {
      id: 93,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Low Squat with Alternating Hip Openers',
      short_name: 'Low Squat w. Alt. Hip Opener',
      unique_name: 'ADVANCED-Low Squat with Alternating Hip Openers',
      description:
        '1. Start standing with your feet roughly shoulder-width apart.\n2. Keeping your chest up, drive your hips back and bend your knees to squat down as low as you can.\n3. As you come up, swing one leg up and out, as if swinging it over an invisible chair. (You can bend your knees if necessary)\n4. Squat again and repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 18,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '42bb3f542b347a258a1a084028bb8b4b5028c8ce99bc6cf4b4f013f64c825519',
          file_name:
            'videos/42bb3f542b347a258a1a084028bb8b4b5028c8ce99bc6cf4b4f013f64c825519.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/42bb3f542b347a258a1a084028bb8b4b5028c8ce99bc6cf4b4f013f64c825519.mp4',
          name: 'EVE_LOW_SQUAT_W_ALT_HIP_OPENERS_1_30sec_SMALL_720.mp4',
          description: null,
          size: 1645902,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 19,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'fe4982b7661d947d51aac3fdcc4c4658316e3461265d26b52ef87fe598bc0832',
          file_name:
            'audios/fe4982b7661d947d51aac3fdcc4c4658316e3461265d26b52ef87fe598bc0832.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fe4982b7661d947d51aac3fdcc4c4658316e3461265d26b52ef87fe598bc0832.mp3',
          name: 'BEG-INT-ADV-Low_Squat_with_Alternating_Hip_Opener-WARM_UP.mp3',
          description: null,
          size: 45142,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Five Fast Feet to Tuck Jump': {
      id: 94,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Five Fast Feet to Tuck Jump',
      short_name: 'Five Fast Feet to Tuck Jump',
      unique_name: 'ADVANCED-Five Fast Feet to Tuck Jump',
      description:
        '1. Start standing with your feet a little wider than hip-width apart and knees slightly bent. Take five tiny fast running steps in place.\n2. Jump as high as you can while tucking both knees to your chest. Land soft.\n3. Repeat. (To modify, omit the tuck and simply jump as high as you can or perform a squat instead)',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 196,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '9a710a8a0ac3ddf8bb17f6f922d9445906c93eda1db8974c2aa9cd20b9fad8a9',
          file_name:
            'videos/9a710a8a0ac3ddf8bb17f6f922d9445906c93eda1db8974c2aa9cd20b9fad8a9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9a710a8a0ac3ddf8bb17f6f922d9445906c93eda1db8974c2aa9cd20b9fad8a9.mp4',
          name: 'EVE_FIVE_FAST_FEET_JUMP_2_30sec_SMALL_720.mp4',
          description: null,
          size: 2250466,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 197,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d',
          file_name:
            'audios/53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d.mp3',
          name: 'Five_Fast_Feet_to_Tuck_Jump.mp3',
          description: null,
          size: 32863,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Alternating Lizard Lunge with Rotation': {
      id: 95,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Lizard Lunge with Rotation',
      short_name: 'Alt. Lizard Lunge w. Rotation',
      unique_name: 'ADVANCED-Alternating Lizard Lunge with Rotation',
      description:
        '1. Start in Plank position. Step forward with one leg and place your foot outside the same side hand, front knee bent at 90 degrees.\n2. Twist your torso towards the bent knee as you raise your arm straight up. The other hand remains on the floor. Pause.\n3. Return your extended hand back to the floor and return to Plank position.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 199,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'a425931c9081839136c16e5150c893fd633be8cd2f2f8816c3c6835ff3693fe7',
          file_name:
            'audios/a425931c9081839136c16e5150c893fd633be8cd2f2f8816c3c6835ff3693fe7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a425931c9081839136c16e5150c893fd633be8cd2f2f8816c3c6835ff3693fe7.mp3',
          name: 'Alternating_Lizard_Lunge_with_Rotation.mp3',
          description: null,
          size: 40063,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2577,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'a93a15824a635efa2a4a3415c3d1446f8c24a07e90204df32ad372d5d8baef0b',
          file_name:
            'videos/a93a15824a635efa2a4a3415c3d1446f8c24a07e90204df32ad372d5d8baef0b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a93a15824a635efa2a4a3415c3d1446f8c24a07e90204df32ad372d5d8baef0b.mp4',
          name: 'BEG-INT-ADV-Alternating_Lizard_Lunge_with_Rotation-WARM_UP',
          description: null,
          size: 2132338,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Up Down Dog': {
      id: 96,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Up/Down Dog',
      short_name: 'Up/Down Dog',
      unique_name: 'ADVANCED-Up Down Dog',
      description:
        '1. Start in Down Dog position. Your hands are on the ground with your head between your upper arms and your hips are up and back making an inverted "V".\n2. Lower your hips towards the floor while raising your head and chest. Keep your arms straight and look slightly upward. Pause.\n3. Move back and forth between these two positions with control and your core engaged.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 201,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '730fe33ed8a74637eb0bf7ae6180870c716697c91f872e774176a7e5ca72356e',
          file_name:
            'audios/730fe33ed8a74637eb0bf7ae6180870c716697c91f872e774176a7e5ca72356e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/730fe33ed8a74637eb0bf7ae6180870c716697c91f872e774176a7e5ca72356e.mp3',
          name: 'BEG-INT-ADV-Up_Down_Dog-WARM_UP.mp3',
          description: null,
          size: 32894,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2580,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '633999f878a7ad34ab4e2c4c03f12d2b03df57dc78febb238a1ac31f4d95ea28',
          file_name:
            'videos/633999f878a7ad34ab4e2c4c03f12d2b03df57dc78febb238a1ac31f4d95ea28.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/633999f878a7ad34ab4e2c4c03f12d2b03df57dc78febb238a1ac31f4d95ea28.mp4',
          name: 'BEG-INT-ADV-Up_Down_Dog-WARM_UP',
          description: null,
          size: 1204984,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Alternating Knee Huggers': {
      id: 97,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Knee Huggers',
      short_name: 'Alt. Knee Huggers',
      unique_name: 'ADVANCED-Alternating Knee Huggers',
      description:
        '1. Stand on one leg and lift the opposite knee.\n2. Hug your knee in close to your chest.\n3. Pause for a beat and return back to standing.\n4. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 203,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '8dfec456034636b8d27e6365eab489beac265293732a8d041764d67f0eac9eab',
          file_name:
            'audios/8dfec456034636b8d27e6365eab489beac265293732a8d041764d67f0eac9eab.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8dfec456034636b8d27e6365eab489beac265293732a8d041764d67f0eac9eab.mp3',
          name: 'Alternating_Knee_Huggers.mp3',
          description: null,
          size: 26176,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2583,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '5f66307fc893d5cadde7f214a004c3e6a6c6d17c572ba3361942f0271a74d9b7',
          file_name:
            'videos/5f66307fc893d5cadde7f214a004c3e6a6c6d17c572ba3361942f0271a74d9b7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5f66307fc893d5cadde7f214a004c3e6a6c6d17c572ba3361942f0271a74d9b7.mp4',
          name: 'BEG-INT-ADV-Alternating_Knee_Huggers-WARM_UP',
          description: null,
          size: 1011443,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Butt Kickers': {
      id: 98,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Butt Kickers',
      short_name: 'Butt Kickers',
      unique_name: 'ADVANCED-Butt Kickers',
      description:
        '1. Jog (or walk) in place, trying to kick your rear with each foot when it is bent behind you.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 204,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '8ef82b713a5cbe6d2eef7a83938a83f1153fe4a535193f519b5b67c637309a36',
          file_name:
            'videos/8ef82b713a5cbe6d2eef7a83938a83f1153fe4a535193f519b5b67c637309a36.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8ef82b713a5cbe6d2eef7a83938a83f1153fe4a535193f519b5b67c637309a36.mp4',
          name: 'CARRIE_BUTT_KICKERS_1_30sec_720.mp4',
          description: null,
          size: 1941665,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 205,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '6ce6454efb35f4ad0f8349012bda450ea403ea58f696a728c47e304cfc8dea8f',
          file_name:
            'audios/6ce6454efb35f4ad0f8349012bda450ea403ea58f696a728c47e304cfc8dea8f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6ce6454efb35f4ad0f8349012bda450ea403ea58f696a728c47e304cfc8dea8f.mp3',
          name: 'Butt_Kickers.mp3',
          description: null,
          size: 20416,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Slow Outside Mountain Climbers': {
      id: 99,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Slow Outside Mountain Climbers',
      short_name: 'Slow Outside Mountain Climbers',
      unique_name: 'ADVANCED-Slow Outside Mountain Climbers',
      description:
        '1. Start in Plank position.\n2. Bring one knee out to the side and as close to the same side tricep as possible. Pause for a beat.\n3. Move your leg back and return to Plank position.\n4. Repeat on the other side',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 207,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'c8564961368a45a0d02fd33a85b7e93f034e5ec5f977fd4c13fc6c7744530b46',
          file_name:
            'audios/c8564961368a45a0d02fd33a85b7e93f034e5ec5f977fd4c13fc6c7744530b46.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c8564961368a45a0d02fd33a85b7e93f034e5ec5f977fd4c13fc6c7744530b46.mp3',
          name: 'Slow_Outside_Mountain_Climbers.mp3',
          description: null,
          size: 34529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2586,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '86c94357c56e34f845c3927bfb6cdeb8b2a4680f18f818d61d2ec7cbc5f11bc4',
          file_name:
            'videos/86c94357c56e34f845c3927bfb6cdeb8b2a4680f18f818d61d2ec7cbc5f11bc4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86c94357c56e34f845c3927bfb6cdeb8b2a4680f18f818d61d2ec7cbc5f11bc4.mp4',
          name: 'BEG-INT-ADV-Slow_Outside_Mountain_Climbers-WARM_UP',
          description: null,
          size: 843247,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Seal Jacks-WARM_UP': {
      id: 169,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Seal Jacks',
      short_name: 'Seal Jacks',
      unique_name: 'BEGINNER-Seal Jacks-WARM_UP',
      description:
        '1. Start standing with your feet together and your arms extended in front of you at shoulder height, palms touching.\n2. Jump up and land with your feet slightly wider than shoulder-width apart as you open your arms out to a "T".\n3. Simultaneously jump your feet back together and bring your arms back to start position.',
      preview_time: null,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 348,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '4fe226669bb4eb3892a9c5f02661f41ff0af1545fe30aeab35e488eaf13bf27f',
          file_name:
            'videos/4fe226669bb4eb3892a9c5f02661f41ff0af1545fe30aeab35e488eaf13bf27f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4fe226669bb4eb3892a9c5f02661f41ff0af1545fe30aeab35e488eaf13bf27f.mp4',
          name: 'TRUDIE_023_SEAL_JACKS_2_small_720.mp4',
          description: null,
          size: 1867569,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 349,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '26ea33c3a0dab3ff079a04225a7efe8991e1b366a4b4117363eea30e371f8405',
          file_name:
            'audios/26ea33c3a0dab3ff079a04225a7efe8991e1b366a4b4117363eea30e371f8405.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/26ea33c3a0dab3ff079a04225a7efe8991e1b366a4b4117363eea30e371f8405.mp3',
          name: 'SealJacks.mp3',
          description: null,
          size: 21596,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Seal Jacks-WARM_UP': {
      id: 170,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Seal Jacks',
      short_name: 'Seal Jacks',
      unique_name: 'INTERMEDIATE-Seal Jacks-WARM_UP',
      description:
        '1. Start standing with your feet together and your arms extended in front of you at shoulder height, palms touching.\n2. Jump up and land with your feet slightly wider than shoulder-width apart as you open your arms out to a "T".\n3. Simultaneously jump your feet back together and bring your arms back to start position.',
      preview_time: null,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 350,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '4fe226669bb4eb3892a9c5f02661f41ff0af1545fe30aeab35e488eaf13bf27f',
          file_name:
            'videos/4fe226669bb4eb3892a9c5f02661f41ff0af1545fe30aeab35e488eaf13bf27f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4fe226669bb4eb3892a9c5f02661f41ff0af1545fe30aeab35e488eaf13bf27f.mp4',
          name: 'TRUDIE_023_SEAL_JACKS_2_small_720.mp4',
          description: null,
          size: 1867569,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 351,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '26ea33c3a0dab3ff079a04225a7efe8991e1b366a4b4117363eea30e371f8405',
          file_name:
            'audios/26ea33c3a0dab3ff079a04225a7efe8991e1b366a4b4117363eea30e371f8405.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/26ea33c3a0dab3ff079a04225a7efe8991e1b366a4b4117363eea30e371f8405.mp3',
          name: 'SealJacks.mp3',
          description: null,
          size: 21596,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Seal Jacks-WARM_UP': {
      id: 171,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Seal Jacks',
      short_name: 'Seal Jacks',
      unique_name: 'ADVANCED-Seal Jacks-WARM_UP',
      description:
        '1. Start standing with your feet together and your arms extended in front of you at shoulder height, palms touching.\n2. Jump up and land with your feet slightly wider than shoulder-width apart as you open your arms out to a "T".\n3. Simultaneously jump your feet back together and bring your arms back to start position.',
      preview_time: null,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 352,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '4fe226669bb4eb3892a9c5f02661f41ff0af1545fe30aeab35e488eaf13bf27f',
          file_name:
            'videos/4fe226669bb4eb3892a9c5f02661f41ff0af1545fe30aeab35e488eaf13bf27f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4fe226669bb4eb3892a9c5f02661f41ff0af1545fe30aeab35e488eaf13bf27f.mp4',
          name: 'TRUDIE_023_SEAL_JACKS_2_small_720.mp4',
          description: null,
          size: 1867569,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 353,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '26ea33c3a0dab3ff079a04225a7efe8991e1b366a4b4117363eea30e371f8405',
          file_name:
            'audios/26ea33c3a0dab3ff079a04225a7efe8991e1b366a4b4117363eea30e371f8405.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/26ea33c3a0dab3ff079a04225a7efe8991e1b366a4b4117363eea30e371f8405.mp3',
          name: 'SealJacks.mp3',
          description: null,
          size: 21596,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Jumping Jacks-WARM_UP': {
      id: 172,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Jumping Jacks',
      short_name: 'Jumping Jacks',
      unique_name: 'BEGINNER-Jumping Jacks-WARM_UP',
      description:
        '1. Start with your feet together and your arms by your sides.\n2. Jump up and land with your feet slightly wider than shoulder-width apart as you reach your arms out and overhead.\n3. Simultaneously jump your feet back together and bring your arms back to start position.',
      preview_time: null,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 354,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '83d6e136ace37cf7692299c2e5a23092cbc1d4f6d0a29051e559a898db289ea3',
          file_name:
            'videos/83d6e136ace37cf7692299c2e5a23092cbc1d4f6d0a29051e559a898db289ea3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/83d6e136ace37cf7692299c2e5a23092cbc1d4f6d0a29051e559a898db289ea3.mp4',
          name: 'PHIL_001_JUMPING_JACKS_2_SMALL_720.mp4',
          description: null,
          size: 2334320,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 355,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '60a13755c61e8c3e19bc3d5df26282994f0da9756ab4e429c252f64f04969693',
          file_name:
            'audios/60a13755c61e8c3e19bc3d5df26282994f0da9756ab4e429c252f64f04969693.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/60a13755c61e8c3e19bc3d5df26282994f0da9756ab4e429c252f64f04969693.mp3',
          name: 'JumpingJacks.mp3',
          description: null,
          size: 21884,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Jumping Jacks-WARM_UP': {
      id: 173,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Jumping Jacks',
      short_name: 'Jumping Jacks',
      unique_name: 'INTERMEDIATE-Jumping Jacks-WARM_UP',
      description:
        '1. Start with your feet together and your arms by your sides.\n2. Jump up and land with your feet slightly wider than shoulder-width apart as you reach your arms out and overhead.\n3. Simultaneously jump your feet back together and bring your arms back to start position.',
      preview_time: null,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 356,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '83d6e136ace37cf7692299c2e5a23092cbc1d4f6d0a29051e559a898db289ea3',
          file_name:
            'videos/83d6e136ace37cf7692299c2e5a23092cbc1d4f6d0a29051e559a898db289ea3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/83d6e136ace37cf7692299c2e5a23092cbc1d4f6d0a29051e559a898db289ea3.mp4',
          name: 'PHIL_001_JUMPING_JACKS_2_SMALL_720.mp4',
          description: null,
          size: 2334320,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 357,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '60a13755c61e8c3e19bc3d5df26282994f0da9756ab4e429c252f64f04969693',
          file_name:
            'audios/60a13755c61e8c3e19bc3d5df26282994f0da9756ab4e429c252f64f04969693.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/60a13755c61e8c3e19bc3d5df26282994f0da9756ab4e429c252f64f04969693.mp3',
          name: 'JumpingJacks.mp3',
          description: null,
          size: 21884,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Jumping Jacks-WARM_UP': {
      id: 174,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Jumping Jacks',
      short_name: 'Jumping Jacks',
      unique_name: 'ADVANCED-Jumping Jacks-WARM_UP',
      description:
        '1. Start with your feet together and your arms by your sides.\n2. Jump up and land with your feet slightly wider than shoulder-width apart as you reach your arms out and overhead.\n3. Simultaneously jump your feet back together and bring your arms back to start position.',
      preview_time: null,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 358,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '83d6e136ace37cf7692299c2e5a23092cbc1d4f6d0a29051e559a898db289ea3',
          file_name:
            'videos/83d6e136ace37cf7692299c2e5a23092cbc1d4f6d0a29051e559a898db289ea3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/83d6e136ace37cf7692299c2e5a23092cbc1d4f6d0a29051e559a898db289ea3.mp4',
          name: 'PHIL_001_JUMPING_JACKS_2_SMALL_720.mp4',
          description: null,
          size: 2334320,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 359,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '60a13755c61e8c3e19bc3d5df26282994f0da9756ab4e429c252f64f04969693',
          file_name:
            'audios/60a13755c61e8c3e19bc3d5df26282994f0da9756ab4e429c252f64f04969693.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/60a13755c61e8c3e19bc3d5df26282994f0da9756ab4e429c252f64f04969693.mp3',
          name: 'JumpingJacks.mp3',
          description: null,
          size: 21884,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Windmills-WARM_UP': {
      id: 175,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Windmills',
      short_name: 'Windmills',
      unique_name: 'BEGINNER-Windmills-WARM_UP',
      description:
        '1. Stand with your feet wider than shoulder-width, arms extended up to a "V".\n2. With your core tight and legs straight, push your hip back and "take a bow".\n3. When your upper body is parallel to the floor, rotate torso and reach the hand closest to the floor to the opposite foot. Keep the other arm extended behind you.\n4. Return to standing and repeat with the other side. Right and left is one rep.',
      preview_time: null,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 360,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '756619d33eb21638b28a8c95b3567b4332f4ed6f4def90d33981f30b566c654b',
          file_name:
            'videos/756619d33eb21638b28a8c95b3567b4332f4ed6f4def90d33981f30b566c654b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/756619d33eb21638b28a8c95b3567b4332f4ed6f4def90d33981f30b566c654b.mp4',
          name: 'PHIL_002_WINDMILLS_1_small_720.mp4',
          description: null,
          size: 1486745,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 361,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e76e217d95d32a306b25cda30b897acdf2470843b9b1b2fa4527072c0fa59be3',
          file_name:
            'audios/e76e217d95d32a306b25cda30b897acdf2470843b9b1b2fa4527072c0fa59be3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e76e217d95d32a306b25cda30b897acdf2470843b9b1b2fa4527072c0fa59be3.mp3',
          name: 'Windmills.mp3',
          description: null,
          size: 19879,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Windmills-WARM_UP': {
      id: 176,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Windmills',
      short_name: 'Windmills',
      unique_name: 'INTERMEDIATE-Windmills-WARM_UP',
      description:
        '1. Stand with your feet wider than shoulder-width, arms extended up to a "V".\n2. With your core tight and legs straight, push your hip back and "take a bow".\n3. When your upper body is parallel to the floor, rotate torso and reach the hand closest to the floor to the opposite foot. Keep the other arm extended behind you.\n4. Return to standing and repeat with the other side. Right and left is one rep.',
      preview_time: null,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 362,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '756619d33eb21638b28a8c95b3567b4332f4ed6f4def90d33981f30b566c654b',
          file_name:
            'videos/756619d33eb21638b28a8c95b3567b4332f4ed6f4def90d33981f30b566c654b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/756619d33eb21638b28a8c95b3567b4332f4ed6f4def90d33981f30b566c654b.mp4',
          name: 'PHIL_002_WINDMILLS_1_small_720.mp4',
          description: null,
          size: 1486745,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 363,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e76e217d95d32a306b25cda30b897acdf2470843b9b1b2fa4527072c0fa59be3',
          file_name:
            'audios/e76e217d95d32a306b25cda30b897acdf2470843b9b1b2fa4527072c0fa59be3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e76e217d95d32a306b25cda30b897acdf2470843b9b1b2fa4527072c0fa59be3.mp3',
          name: 'Windmills.mp3',
          description: null,
          size: 19879,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Windmills-WARM_UP': {
      id: 177,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Windmills',
      short_name: 'Windmills',
      unique_name: 'ADVANCED-Windmills-WARM_UP',
      description:
        '1. Stand with your feet wider than shoulder-width, arms extended up to a "V".\n2. With your core tight and legs straight, push your hip back and "take a bow".\n3. When your upper body is parallel to the floor, rotate torso and reach the hand closest to the floor to the opposite foot. Keep the other arm extended behind you.\n4. Return to standing and repeat with the other side. Right and left is one rep.',
      preview_time: null,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 364,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '756619d33eb21638b28a8c95b3567b4332f4ed6f4def90d33981f30b566c654b',
          file_name:
            'videos/756619d33eb21638b28a8c95b3567b4332f4ed6f4def90d33981f30b566c654b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/756619d33eb21638b28a8c95b3567b4332f4ed6f4def90d33981f30b566c654b.mp4',
          name: 'PHIL_002_WINDMILLS_1_small_720.mp4',
          description: null,
          size: 1486745,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 365,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e76e217d95d32a306b25cda30b897acdf2470843b9b1b2fa4527072c0fa59be3',
          file_name:
            'audios/e76e217d95d32a306b25cda30b897acdf2470843b9b1b2fa4527072c0fa59be3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e76e217d95d32a306b25cda30b897acdf2470843b9b1b2fa4527072c0fa59be3.mp3',
          name: 'Windmills.mp3',
          description: null,
          size: 19879,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Five Fast Feet to Squat-WARM_UP': {
      id: 205,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Five Fast Feet to Squat',
      short_name: 'Five Fast Feet to Squat',
      unique_name: 'BEGINNER-Five Fast Feet to Squat-WARM_UP',
      description:
        '1. Start standing with your feet a little wider than hip-width apart and knees slightly bent. Take five tiny fast running steps in place.\n2. Immediately drop into a squat.\n3. Return to standing and repeat.',
      preview_time: null,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 425,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'ec44d89afd39ecbf3a4240e0ed8f508620f9b513fa0b9ce4e3f4af85f197c306',
          file_name:
            'audios/ec44d89afd39ecbf3a4240e0ed8f508620f9b513fa0b9ce4e3f4af85f197c306.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ec44d89afd39ecbf3a4240e0ed8f508620f9b513fa0b9ce4e3f4af85f197c306.mp3',
          name: 'Five-Fast-Feet-to-Squat.mp3',
          description: null,
          size: 29383,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2587,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'f0ca44fbb9849b1ef430c3ff84e50b2e9ac8c05d692198d7f1c1d91cd6e95bed',
          file_name:
            'videos/f0ca44fbb9849b1ef430c3ff84e50b2e9ac8c05d692198d7f1c1d91cd6e95bed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f0ca44fbb9849b1ef430c3ff84e50b2e9ac8c05d692198d7f1c1d91cd6e95bed.mp4',
          name: 'BEG-INT-ADV-Five_Fast_Feet_to_Squat-WARM_UP',
          description: null,
          size: 1465200,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Five Fast Feet to Squat-WARM_UP': {
      id: 206,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Five Fast Feet to Squat',
      short_name: 'Five Fast Feet to Squat',
      unique_name: 'INTERMEDIATE-Five Fast Feet to Squat-WARM_UP',
      description:
        '1. Start standing with your feet a little wider than hip-width apart and knees slightly bent. Take five tiny fast running steps in place.\n2. Immediately drop into a squat.\n3. Return to standing and repeat.',
      preview_time: null,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 427,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'ec44d89afd39ecbf3a4240e0ed8f508620f9b513fa0b9ce4e3f4af85f197c306',
          file_name:
            'audios/ec44d89afd39ecbf3a4240e0ed8f508620f9b513fa0b9ce4e3f4af85f197c306.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ec44d89afd39ecbf3a4240e0ed8f508620f9b513fa0b9ce4e3f4af85f197c306.mp3',
          name: 'Five-Fast-Feet-to-Squat.mp3',
          description: null,
          size: 29383,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2588,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'f0ca44fbb9849b1ef430c3ff84e50b2e9ac8c05d692198d7f1c1d91cd6e95bed',
          file_name:
            'videos/f0ca44fbb9849b1ef430c3ff84e50b2e9ac8c05d692198d7f1c1d91cd6e95bed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f0ca44fbb9849b1ef430c3ff84e50b2e9ac8c05d692198d7f1c1d91cd6e95bed.mp4',
          name: 'BEG-INT-ADV-Five_Fast_Feet_to_Squat-WARM_UP',
          description: null,
          size: 1465200,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Five Fast Feet to Squat-WARM_UP': {
      id: 207,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Five Fast Feet to Squat',
      short_name: 'Five Fast Feet to Squat',
      unique_name: 'ADVANCED-Five Fast Feet to Squat-WARM_UP',
      description:
        '1. Start standing with your feet a little wider than hip-width apart and knees slightly bent. Take five tiny fast running steps in place.\n2. Immediately drop into a squat.\n3. Return to standing and repeat.',
      preview_time: null,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 429,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'ec44d89afd39ecbf3a4240e0ed8f508620f9b513fa0b9ce4e3f4af85f197c306',
          file_name:
            'audios/ec44d89afd39ecbf3a4240e0ed8f508620f9b513fa0b9ce4e3f4af85f197c306.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ec44d89afd39ecbf3a4240e0ed8f508620f9b513fa0b9ce4e3f4af85f197c306.mp3',
          name: 'Five-Fast-Feet-to-Squat.mp3',
          description: null,
          size: 29383,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2589,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'f0ca44fbb9849b1ef430c3ff84e50b2e9ac8c05d692198d7f1c1d91cd6e95bed',
          file_name:
            'videos/f0ca44fbb9849b1ef430c3ff84e50b2e9ac8c05d692198d7f1c1d91cd6e95bed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f0ca44fbb9849b1ef430c3ff84e50b2e9ac8c05d692198d7f1c1d91cd6e95bed.mp4',
          name: 'BEG-INT-ADV-Five_Fast_Feet_to_Squat-WARM_UP',
          description: null,
          size: 1465200,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Air Squats-WARM_UP': {
      id: 278,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Air Squats',
      short_name: 'Air Squats',
      unique_name: 'BEGINNER-Air Squats-WARM_UP',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 441,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'd471e17339c6bdb52a169f19c2ba730f6cd4262814a6503f4ad1bad579b4c0e1',
          file_name:
            'audios/d471e17339c6bdb52a169f19c2ba730f6cd4262814a6503f4ad1bad579b4c0e1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d471e17339c6bdb52a169f19c2ba730f6cd4262814a6503f4ad1bad579b4c0e1.mp3',
          name: 'BEGINNER-Air_Squats-WARM_UP.mp3',
          description: null,
          size: 18976,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2590,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '001cc899b49da3030748810d79c245ab3f802f992c8bae3e116c997f9e9919e7',
          file_name:
            'videos/001cc899b49da3030748810d79c245ab3f802f992c8bae3e116c997f9e9919e7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/001cc899b49da3030748810d79c245ab3f802f992c8bae3e116c997f9e9919e7.mp4',
          name: 'BEG-INT-ADV-Air_Squats-WARM_UP',
          description: null,
          size: 1448485,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Air Squats-WARM_UP': {
      id: 279,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Air Squats',
      short_name: 'Air Squats',
      unique_name: 'INTERMEDIATE-Air Squats-WARM_UP',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 443,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'd471e17339c6bdb52a169f19c2ba730f6cd4262814a6503f4ad1bad579b4c0e1',
          file_name:
            'audios/d471e17339c6bdb52a169f19c2ba730f6cd4262814a6503f4ad1bad579b4c0e1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d471e17339c6bdb52a169f19c2ba730f6cd4262814a6503f4ad1bad579b4c0e1.mp3',
          name: 'INTERMEDIATE-Air_Squats-WARM_UP.mp3',
          description: null,
          size: 18976,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2591,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '001cc899b49da3030748810d79c245ab3f802f992c8bae3e116c997f9e9919e7',
          file_name:
            'videos/001cc899b49da3030748810d79c245ab3f802f992c8bae3e116c997f9e9919e7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/001cc899b49da3030748810d79c245ab3f802f992c8bae3e116c997f9e9919e7.mp4',
          name: 'BEG-INT-ADV-Air_Squats-WARM_UP',
          description: null,
          size: 1448485,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Air Squats-WARM_UP': {
      id: 280,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Air Squats',
      short_name: 'Air Squats',
      unique_name: 'ADVANCED-Air Squats-WARM_UP',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 445,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'd471e17339c6bdb52a169f19c2ba730f6cd4262814a6503f4ad1bad579b4c0e1',
          file_name:
            'audios/d471e17339c6bdb52a169f19c2ba730f6cd4262814a6503f4ad1bad579b4c0e1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d471e17339c6bdb52a169f19c2ba730f6cd4262814a6503f4ad1bad579b4c0e1.mp3',
          name: 'ADVANCED-Air_Squats-WARM_UP.mp3',
          description: null,
          size: 18976,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2592,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '001cc899b49da3030748810d79c245ab3f802f992c8bae3e116c997f9e9919e7',
          file_name:
            'videos/001cc899b49da3030748810d79c245ab3f802f992c8bae3e116c997f9e9919e7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/001cc899b49da3030748810d79c245ab3f802f992c8bae3e116c997f9e9919e7.mp4',
          name: 'BEG-INT-ADV-Air_Squats-WARM_UP',
          description: null,
          size: 1448485,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Dolphin Push-Ups-WARM_UP': {
      id: 281,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Dolphin Push-Ups',
      short_name: 'Dolphin Push-Ups',
      unique_name: 'BEGINNER-Dolphin Push-Ups-WARM_UP',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat.\n2. Draw your hips up and back, shift your torso close to your thighs. Head neutral and ears by armpits. You are in an inverted "V" shape. Think "Down Dog on forearms".\n3. Engage your core, shift your body forward and lower your hips back down to Forearm Plank start position.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 447,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '8908324206eed8041af87bb114624c12628cc875d0a8f45436382257fcadd08a',
          file_name:
            'audios/8908324206eed8041af87bb114624c12628cc875d0a8f45436382257fcadd08a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8908324206eed8041af87bb114624c12628cc875d0a8f45436382257fcadd08a.mp3',
          name: 'BEGINNER-Dolphin_Push-Ups-WARM_UP.mp3',
          description: null,
          size: 24198,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2593,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '2fd2eb3c878c0024fa632d0536171b8173f4c8a016a87dee54c8d85253059b70',
          file_name:
            'videos/2fd2eb3c878c0024fa632d0536171b8173f4c8a016a87dee54c8d85253059b70.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2fd2eb3c878c0024fa632d0536171b8173f4c8a016a87dee54c8d85253059b70.mp4',
          name: 'BEG-INT-ADV-Dolphin_Push-Ups-WARM_UP',
          description: null,
          size: 841056,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Dolphin Push-Ups-WARM_UP': {
      id: 282,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dolphin Push-Ups',
      short_name: 'Dolphin Push-Ups',
      unique_name: 'INTERMEDIATE-Dolphin Push-Ups-WARM_UP',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat.\n2. Draw your hips up and back, shift your torso close to your thighs. Head neutral and ears by armpits. You are in an inverted "V" shape. Think "Down Dog on forearms".\n3. Engage your core, shift your body forward and lower your hips back down to Forearm Plank start position.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 449,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '8908324206eed8041af87bb114624c12628cc875d0a8f45436382257fcadd08a',
          file_name:
            'audios/8908324206eed8041af87bb114624c12628cc875d0a8f45436382257fcadd08a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8908324206eed8041af87bb114624c12628cc875d0a8f45436382257fcadd08a.mp3',
          name: 'INTERMEDIATE-Dolphin_Push-Ups-WARM_UP.mp3',
          description: null,
          size: 24198,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2594,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '2fd2eb3c878c0024fa632d0536171b8173f4c8a016a87dee54c8d85253059b70',
          file_name:
            'videos/2fd2eb3c878c0024fa632d0536171b8173f4c8a016a87dee54c8d85253059b70.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2fd2eb3c878c0024fa632d0536171b8173f4c8a016a87dee54c8d85253059b70.mp4',
          name: 'BEG-INT-ADV-Dolphin_Push-Ups-WARM_UP',
          description: null,
          size: 841056,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Dolphin Push-Ups-WARM_UP': {
      id: 283,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dolphin Push-Ups',
      short_name: 'Dolphin Push-Ups',
      unique_name: 'ADVANCED-Dolphin Push-Ups-WARM_UP',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat.\n2. Draw your hips up and back, shift your torso close to your thighs. Head neutral and ears by armpits. You are in an inverted "V" shape. Think "Down Dog on forearms".\n3. Engage your core, shift your body forward and lower your hips back down to Forearm Plank start position.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 451,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '8908324206eed8041af87bb114624c12628cc875d0a8f45436382257fcadd08a',
          file_name:
            'audios/8908324206eed8041af87bb114624c12628cc875d0a8f45436382257fcadd08a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8908324206eed8041af87bb114624c12628cc875d0a8f45436382257fcadd08a.mp3',
          name: 'ADVANCED-Dolphin_Push-Ups-WARM_UP.mp3',
          description: null,
          size: 24198,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2595,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '2fd2eb3c878c0024fa632d0536171b8173f4c8a016a87dee54c8d85253059b70',
          file_name:
            'videos/2fd2eb3c878c0024fa632d0536171b8173f4c8a016a87dee54c8d85253059b70.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2fd2eb3c878c0024fa632d0536171b8173f4c8a016a87dee54c8d85253059b70.mp4',
          name: 'BEG-INT-ADV-Dolphin_Push-Ups-WARM_UP',
          description: null,
          size: 841056,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Ski Jumpers-WARM_UP': {
      id: 284,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Ski Jumpers',
      short_name: 'Ski Jumpers',
      unique_name: 'BEGINNER-Ski Jumpers-WARM_UP',
      description:
        '1. Start with your feet together and your arms by your sides.\n2. Jump up and land with your feet slightly wider than shoulder-width apart.\n3. Simultaneously jump your feet back together and bring your arms back to start position.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 453,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '7175b9bd3eca03ac08767c617b1841497be4bd158fe20ff521d61676188b2082',
          file_name:
            'audios/7175b9bd3eca03ac08767c617b1841497be4bd158fe20ff521d61676188b2082.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7175b9bd3eca03ac08767c617b1841497be4bd158fe20ff521d61676188b2082.mp3',
          name: 'BEGINNER-Ski_Jumpers-WARM_UP.mp3',
          description: null,
          size: 23046,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2596,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '2de82c8e0d7ff0c8a116d8c295d238af27da5ad4ea27d7174bb98b96804c978f',
          file_name:
            'videos/2de82c8e0d7ff0c8a116d8c295d238af27da5ad4ea27d7174bb98b96804c978f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2de82c8e0d7ff0c8a116d8c295d238af27da5ad4ea27d7174bb98b96804c978f.mp4',
          name: 'BEG-INT-ADV-Ski_Jumpers-WARM_UP',
          description: null,
          size: 2692335,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Ski Jumpers-WARM_UP': {
      id: 285,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Ski Jumpers',
      short_name: 'Ski Jumpers',
      unique_name: 'INTERMEDIATE-Ski Jumpers-WARM_UP',
      description:
        '1. Start with your feet together and your arms by your sides.\n2. Jump up and land with your feet slightly wider than shoulder-width apart.\n3. Simultaneously jump your feet back together and bring your arms back to start position.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 455,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '7175b9bd3eca03ac08767c617b1841497be4bd158fe20ff521d61676188b2082',
          file_name:
            'audios/7175b9bd3eca03ac08767c617b1841497be4bd158fe20ff521d61676188b2082.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7175b9bd3eca03ac08767c617b1841497be4bd158fe20ff521d61676188b2082.mp3',
          name: 'INTERMEDIATE-Ski_Jumpers-WARM_UP.mp3',
          description: null,
          size: 23046,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2597,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '2de82c8e0d7ff0c8a116d8c295d238af27da5ad4ea27d7174bb98b96804c978f',
          file_name:
            'videos/2de82c8e0d7ff0c8a116d8c295d238af27da5ad4ea27d7174bb98b96804c978f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2de82c8e0d7ff0c8a116d8c295d238af27da5ad4ea27d7174bb98b96804c978f.mp4',
          name: 'BEG-INT-ADV-Ski_Jumpers-WARM_UP',
          description: null,
          size: 2692335,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Ski Jumpers-WARM_UP': {
      id: 286,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Ski Jumpers',
      short_name: 'Ski Jumpers',
      unique_name: 'ADVANCED-Ski Jumpers-WARM_UP',
      description:
        '1. Start with your feet together and your arms by your sides.\n2. Jump up and land with your feet slightly wider than shoulder-width apart.\n3. Simultaneously jump your feet back together and bring your arms back to start position.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 457,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '7175b9bd3eca03ac08767c617b1841497be4bd158fe20ff521d61676188b2082',
          file_name:
            'audios/7175b9bd3eca03ac08767c617b1841497be4bd158fe20ff521d61676188b2082.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7175b9bd3eca03ac08767c617b1841497be4bd158fe20ff521d61676188b2082.mp3',
          name: 'ADVANCED-Ski_Jumpers-WARM_UP.mp3',
          description: null,
          size: 23046,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2598,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '2de82c8e0d7ff0c8a116d8c295d238af27da5ad4ea27d7174bb98b96804c978f',
          file_name:
            'videos/2de82c8e0d7ff0c8a116d8c295d238af27da5ad4ea27d7174bb98b96804c978f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2de82c8e0d7ff0c8a116d8c295d238af27da5ad4ea27d7174bb98b96804c978f.mp4',
          name: 'BEG-INT-ADV-Ski_Jumpers-WARM_UP',
          description: null,
          size: 2692335,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bird Dog-WARM_UP': {
      id: 287,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Bird Dog',
      short_name: 'Bird Dog',
      unique_name: 'BEGINNER-Bird Dog-WARM_UP',
      description:
        '1. Start on all fours with your shoulders over wrists and hips over your knees.\n2. Reach one arm straight in front of you while raising the opposite leg straight back.\n3. Engage your core and pause for a beat.\n4. Return to starting position and repeat on the other side.\n5. Do the number of reps on your card.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 459,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '97070f30bfd512273de3ccb7eac14e4cb2db6b84298c2e5e6c77a437f831cb18',
          file_name:
            'audios/97070f30bfd512273de3ccb7eac14e4cb2db6b84298c2e5e6c77a437f831cb18.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/97070f30bfd512273de3ccb7eac14e4cb2db6b84298c2e5e6c77a437f831cb18.mp3',
          name: 'BEGINNER-Bird_Dog-WARM_UP.mp3',
          description: null,
          size: 20190,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2599,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'c13e768ff9337ba85a0767b1d8899bf115e0c3db54ac05a6888d0d0ae3a045dc',
          file_name:
            'videos/c13e768ff9337ba85a0767b1d8899bf115e0c3db54ac05a6888d0d0ae3a045dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c13e768ff9337ba85a0767b1d8899bf115e0c3db54ac05a6888d0d0ae3a045dc.mp4',
          name: 'BEG-INT-ADV-Bird_Dog-WARM_UP',
          description: null,
          size: 993113,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Bird Dog-WARM_UP': {
      id: 288,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Bird Dog',
      short_name: 'Bird Dog',
      unique_name: 'INTERMEDIATE-Bird Dog-WARM_UP',
      description:
        '1. Start on all fours with your shoulders over wrists and hips over your knees.\n2. Reach one arm straight in front of you while raising the opposite leg straight back.\n3. Engage your core and pause for a beat.\n4. Return to starting position and repeat on the other side.\n5. Do the number of reps on your card.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 461,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '97070f30bfd512273de3ccb7eac14e4cb2db6b84298c2e5e6c77a437f831cb18',
          file_name:
            'audios/97070f30bfd512273de3ccb7eac14e4cb2db6b84298c2e5e6c77a437f831cb18.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/97070f30bfd512273de3ccb7eac14e4cb2db6b84298c2e5e6c77a437f831cb18.mp3',
          name: 'INTERMEDIATE-Bird_Dog-WARM_UP.mp3',
          description: null,
          size: 20190,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2600,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'c13e768ff9337ba85a0767b1d8899bf115e0c3db54ac05a6888d0d0ae3a045dc',
          file_name:
            'videos/c13e768ff9337ba85a0767b1d8899bf115e0c3db54ac05a6888d0d0ae3a045dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c13e768ff9337ba85a0767b1d8899bf115e0c3db54ac05a6888d0d0ae3a045dc.mp4',
          name: 'BEG-INT-ADV-Bird_Dog-WARM_UP',
          description: null,
          size: 993113,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Bird Dog-WARM_UP': {
      id: 289,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Bird Dog',
      short_name: 'Bird Dog',
      unique_name: 'ADVANCED-Bird Dog-WARM_UP',
      description:
        '1. Start on all fours with your shoulders over wrists and hips over your knees.\n2. Reach one arm straight in front of you while raising the opposite leg straight back.\n3. Engage your core and pause for a beat.\n4. Return to starting position and repeat on the other side.\n5. Do the number of reps on your card.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 463,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '97070f30bfd512273de3ccb7eac14e4cb2db6b84298c2e5e6c77a437f831cb18',
          file_name:
            'audios/97070f30bfd512273de3ccb7eac14e4cb2db6b84298c2e5e6c77a437f831cb18.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/97070f30bfd512273de3ccb7eac14e4cb2db6b84298c2e5e6c77a437f831cb18.mp3',
          name: 'ADVANCED-Bird_Dog-WARM_UP.mp3',
          description: null,
          size: 20190,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2601,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'c13e768ff9337ba85a0767b1d8899bf115e0c3db54ac05a6888d0d0ae3a045dc',
          file_name:
            'videos/c13e768ff9337ba85a0767b1d8899bf115e0c3db54ac05a6888d0d0ae3a045dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c13e768ff9337ba85a0767b1d8899bf115e0c3db54ac05a6888d0d0ae3a045dc.mp4',
          name: 'BEG-INT-ADV-Bird_Dog-WARM_UP',
          description: null,
          size: 993113,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Reverse Lunge with Torso Twist-WARM_UP': {
      id: 290,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Lunge with Torso Twist',
      short_name: 'Reverse Lunge with Torso Twist',
      unique_name: 'BEGINNER-Reverse Lunge with Torso Twist-WARM_UP',
      description:
        '1. From standing position, step backwards with one leg and bend your front knee to 90 degrees.\n2. Clasp the opposite hand on your front knee and extend the other arm behind you as you rotate your torso.\n3. Pause for a beat in the spinal twist and return back to standing.\n4. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 490,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '33b399f6c1edaa513381ae929571ba46bbb641d1619d9d691056360b562181d9',
          file_name:
            'audios/33b399f6c1edaa513381ae929571ba46bbb641d1619d9d691056360b562181d9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/33b399f6c1edaa513381ae929571ba46bbb641d1619d9d691056360b562181d9.mp3',
          name: 'BEG-INT-ADV-Reverse_Lunge_with_Torso_Twist-WARM_UP.mp3',
          description: null,
          size: 38424,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2602,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '1934657bd0cf88ac6a42ed7eaa67a15753822c761132d66dfc91c90b9648e5d6',
          file_name:
            'videos/1934657bd0cf88ac6a42ed7eaa67a15753822c761132d66dfc91c90b9648e5d6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1934657bd0cf88ac6a42ed7eaa67a15753822c761132d66dfc91c90b9648e5d6.mp4',
          name: 'BEG-INT-ADV-Reverse_Lunge_with_Torso_Twist-WARM_UP',
          description: null,
          size: 2007194,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Reverse Lunge with Torso Twist-WARM_UP': {
      id: 291,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Lunge with Torso Twist',
      short_name: 'Reverse Lunge with Torso Twist',
      unique_name: 'INTERMEDIATE-Reverse Lunge with Torso Twist-WARM_UP',
      description:
        '1. From standing position, step backwards with one leg and bend your front knee to 90 degrees.\n2. Clasp the opposite hand on your front knee and extend the other arm behind you as you rotate your torso.\n3. Pause for a beat in the spinal twist and return back to standing.\n4. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 492,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '33b399f6c1edaa513381ae929571ba46bbb641d1619d9d691056360b562181d9',
          file_name:
            'audios/33b399f6c1edaa513381ae929571ba46bbb641d1619d9d691056360b562181d9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/33b399f6c1edaa513381ae929571ba46bbb641d1619d9d691056360b562181d9.mp3',
          name: 'BEG-INT-ADV-Reverse_Lunge_with_Torso_Twist-WARM_UP.mp3',
          description: null,
          size: 38424,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2603,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '1934657bd0cf88ac6a42ed7eaa67a15753822c761132d66dfc91c90b9648e5d6',
          file_name:
            'videos/1934657bd0cf88ac6a42ed7eaa67a15753822c761132d66dfc91c90b9648e5d6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1934657bd0cf88ac6a42ed7eaa67a15753822c761132d66dfc91c90b9648e5d6.mp4',
          name: 'BEG-INT-ADV-Reverse_Lunge_with_Torso_Twist-WARM_UP',
          description: null,
          size: 2007194,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Reverse Lunge with Torso Twist-WARM_UP': {
      id: 292,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Lunge with Torso Twist',
      short_name: 'Reverse Lunge with Torso Twist',
      unique_name: 'ADVANCED-Reverse Lunge with Torso Twist-WARM_UP',
      description:
        '1. From standing position, step backwards with one leg and bend your front knee to 90 degrees.\n2. Clasp the opposite hand on your front knee and extend the other arm behind you as you rotate your torso.\n3. Pause for a beat in the spinal twist and return back to standing.\n4. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 494,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '33b399f6c1edaa513381ae929571ba46bbb641d1619d9d691056360b562181d9',
          file_name:
            'audios/33b399f6c1edaa513381ae929571ba46bbb641d1619d9d691056360b562181d9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/33b399f6c1edaa513381ae929571ba46bbb641d1619d9d691056360b562181d9.mp3',
          name: 'BEG-INT-ADV-Reverse_Lunge_with_Torso_Twist-WARM_UP.mp3',
          description: null,
          size: 38424,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2604,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '1934657bd0cf88ac6a42ed7eaa67a15753822c761132d66dfc91c90b9648e5d6',
          file_name:
            'videos/1934657bd0cf88ac6a42ed7eaa67a15753822c761132d66dfc91c90b9648e5d6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1934657bd0cf88ac6a42ed7eaa67a15753822c761132d66dfc91c90b9648e5d6.mp4',
          name: 'BEG-INT-ADV-Reverse_Lunge_with_Torso_Twist-WARM_UP',
          description: null,
          size: 2007194,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bear Plank Knee Taps-WARM_UP': {
      id: 360,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Bear Plank Knee Taps',
      short_name: 'Bear Plank Knee Taps',
      unique_name: 'BEGINNER-Bear Plank Knee Taps-WARM_UP',
      description:
        '1. Start on all fours with your shoulders over wrists and knees under hips.\n2. Engage your core and hover your knees a few inches off the ground. Hips square.\n3. Bring one knee slightly forward as you reach your opposite hand back to tap that knee.\n4. Return to start position and repeat with the other side.',
      preview_time: null,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 684,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '2205d1d8071e8522bb09d41d90a79cef07403ece467c880c09197ca6df2f154a',
          file_name:
            'videos/2205d1d8071e8522bb09d41d90a79cef07403ece467c880c09197ca6df2f154a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2205d1d8071e8522bb09d41d90a79cef07403ece467c880c09197ca6df2f154a.mp4',
          name: 'BEG-INT-ADV-Bear_Plank_Knee_Taps-WARM_UP.mp4',
          description: null,
          size: 1165771,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 685,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '7afdcac23c9c18150c76ed87a26107e62b4b3b69bfaf6ec0ea2b4c7eb76c8862',
          file_name:
            'audios/7afdcac23c9c18150c76ed87a26107e62b4b3b69bfaf6ec0ea2b4c7eb76c8862.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7afdcac23c9c18150c76ed87a26107e62b4b3b69bfaf6ec0ea2b4c7eb76c8862.mp3',
          name: 'BEG-INT-ADV-Bear_Plank_Knee_Taps-WARM_UP.mp3',
          description: null,
          size: 33533,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Bear Plank Knee Taps-WARM_UP': {
      id: 361,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Bear Plank Knee Taps',
      short_name: 'Bear Plank Knee Taps',
      unique_name: 'INTERMEDIATE-Bear Plank Knee Taps-WARM_UP',
      description:
        '1. Start on all fours with your shoulders over wrists and knees under hips.\n2. Engage your core and hover your knees a few inches off the ground. Hips square.\n3. Bring one knee slightly forward as you reach your opposite hand back to tap that knee.\n4. Return to start position and repeat with the other side.',
      preview_time: null,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 686,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '2205d1d8071e8522bb09d41d90a79cef07403ece467c880c09197ca6df2f154a',
          file_name:
            'videos/2205d1d8071e8522bb09d41d90a79cef07403ece467c880c09197ca6df2f154a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2205d1d8071e8522bb09d41d90a79cef07403ece467c880c09197ca6df2f154a.mp4',
          name: 'BEG-INT-ADV-Bear_Plank_Knee_Taps-WARM_UP.mp4',
          description: null,
          size: 1165771,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 687,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '7afdcac23c9c18150c76ed87a26107e62b4b3b69bfaf6ec0ea2b4c7eb76c8862',
          file_name:
            'audios/7afdcac23c9c18150c76ed87a26107e62b4b3b69bfaf6ec0ea2b4c7eb76c8862.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7afdcac23c9c18150c76ed87a26107e62b4b3b69bfaf6ec0ea2b4c7eb76c8862.mp3',
          name: 'BEG-INT-ADV-Bear_Plank_Knee_Taps-WARM_UP.mp3',
          description: null,
          size: 33533,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Bear Plank Knee Taps-WARM_UP': {
      id: 362,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Bear Plank Knee Taps',
      short_name: 'Bear Plank Knee Taps',
      unique_name: 'ADVANCED-Bear Plank Knee Taps-WARM_UP',
      description:
        '1. Start on all fours with your shoulders over wrists and knees under hips.\n2. Engage your core and hover your knees a few inches off the ground. Hips square.\n3. Bring one knee slightly forward as you reach your opposite hand back to tap that knee.\n4. Return to start position and repeat with the other side.',
      preview_time: null,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 688,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '2205d1d8071e8522bb09d41d90a79cef07403ece467c880c09197ca6df2f154a',
          file_name:
            'videos/2205d1d8071e8522bb09d41d90a79cef07403ece467c880c09197ca6df2f154a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2205d1d8071e8522bb09d41d90a79cef07403ece467c880c09197ca6df2f154a.mp4',
          name: 'BEG-INT-ADV-Bear_Plank_Knee_Taps-WARM_UP.mp4',
          description: null,
          size: 1165771,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 689,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '7afdcac23c9c18150c76ed87a26107e62b4b3b69bfaf6ec0ea2b4c7eb76c8862',
          file_name:
            'audios/7afdcac23c9c18150c76ed87a26107e62b4b3b69bfaf6ec0ea2b4c7eb76c8862.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7afdcac23c9c18150c76ed87a26107e62b4b3b69bfaf6ec0ea2b4c7eb76c8862.mp3',
          name: 'BEG-INT-ADV-Bear_Plank_Knee_Taps-WARM_UP.mp3',
          description: null,
          size: 33533,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Plank Tap Outs-WARM_UP': {
      id: 363,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Plank Tap Outs',
      short_name: 'Plank Tap Outs',
      unique_name: 'BEGINNER-Plank Tap Outs-WARM_UP',
      description:
        '1. Start in plank position, shoulders over wrists, hips square.\n2. Tap one foot out to the side. Return to center.\n3. Tap the other foot out to the side. Return to center.',
      preview_time: null,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 756,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'de22c51191758e7b2c58f733b3fe49bdbe572b58950acdb823344973386ff980',
          file_name:
            'videos/de22c51191758e7b2c58f733b3fe49bdbe572b58950acdb823344973386ff980.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/de22c51191758e7b2c58f733b3fe49bdbe572b58950acdb823344973386ff980.mp4',
          name: 'BEG-INT-ADV-Plank_Tap_Outs-WARM_UP.mp4',
          description: null,
          size: 836440,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 757,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '8cc8d0fa84acb7a125afcb8f283b76fddfef2a42afc958223bc8c95564991e3c',
          file_name:
            'audios/8cc8d0fa84acb7a125afcb8f283b76fddfef2a42afc958223bc8c95564991e3c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8cc8d0fa84acb7a125afcb8f283b76fddfef2a42afc958223bc8c95564991e3c.mp3',
          name: 'BEG-INT-ADV-Plank_Tap_Outs-WARM_UP.mp3',
          description: null,
          size: 28640,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Plank Tap Outs-WARM_UP': {
      id: 364,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Plank Tap Outs',
      short_name: 'Plank Tap Outs',
      unique_name: 'INTERMEDIATE-Plank Tap Outs-WARM_UP',
      description:
        '1. Start in plank position, shoulders over wrists, hips square.\n2. Tap one foot out to the side. Return to center.\n3. Tap the other foot out to the side. Return to center.',
      preview_time: null,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 758,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'de22c51191758e7b2c58f733b3fe49bdbe572b58950acdb823344973386ff980',
          file_name:
            'videos/de22c51191758e7b2c58f733b3fe49bdbe572b58950acdb823344973386ff980.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/de22c51191758e7b2c58f733b3fe49bdbe572b58950acdb823344973386ff980.mp4',
          name: 'BEG-INT-ADV-Plank_Tap_Outs-WARM_UP.mp4',
          description: null,
          size: 836440,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 759,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '8cc8d0fa84acb7a125afcb8f283b76fddfef2a42afc958223bc8c95564991e3c',
          file_name:
            'audios/8cc8d0fa84acb7a125afcb8f283b76fddfef2a42afc958223bc8c95564991e3c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8cc8d0fa84acb7a125afcb8f283b76fddfef2a42afc958223bc8c95564991e3c.mp3',
          name: 'BEG-INT-ADV-Plank_Tap_Outs-WARM_UP.mp3',
          description: null,
          size: 28640,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Plank Tap Outs-WARM_UP': {
      id: 365,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Plank Tap Outs',
      short_name: 'Plank Tap Outs',
      unique_name: 'ADVANCED-Plank Tap Outs-WARM_UP',
      description:
        '1. Start in plank position, shoulders over wrists, hips square.\n2. Tap one foot out to the side. Return to center.\n3. Tap the other foot out to the side. Return to center.',
      preview_time: null,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 760,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'de22c51191758e7b2c58f733b3fe49bdbe572b58950acdb823344973386ff980',
          file_name:
            'videos/de22c51191758e7b2c58f733b3fe49bdbe572b58950acdb823344973386ff980.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/de22c51191758e7b2c58f733b3fe49bdbe572b58950acdb823344973386ff980.mp4',
          name: 'BEG-INT-ADV-Plank_Tap_Outs-WARM_UP.mp4',
          description: null,
          size: 836440,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 761,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '8cc8d0fa84acb7a125afcb8f283b76fddfef2a42afc958223bc8c95564991e3c',
          file_name:
            'audios/8cc8d0fa84acb7a125afcb8f283b76fddfef2a42afc958223bc8c95564991e3c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8cc8d0fa84acb7a125afcb8f283b76fddfef2a42afc958223bc8c95564991e3c.mp3',
          name: 'BEG-INT-ADV-Plank_Tap_Outs-WARM_UP.mp3',
          description: null,
          size: 28640,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating_Sumo_Side_Bends-WARM_UP': {
      id: 463,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Alternating Sumo Side Bends',
      short_name: 'Alternating Sumo Side Bends',
      unique_name: 'BEGINNER-Alternating_Sumo_Side_Bends-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart, rest your hands behind your head and bring elbows out wide.\n2. Keeping your core tight, transfer all your weight on one leg and bring your other knee up to hip height.\n3. Rotate your torso toward the bent leg and tap your elbow to your knee.\n4. Return to start position and repeat with the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1039,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6d94f68b9ddcef62c042181a72bf44249046d3c0422959bd57213b219eff5184',
          file_name:
            'videos/6d94f68b9ddcef62c042181a72bf44249046d3c0422959bd57213b219eff5184.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6d94f68b9ddcef62c042181a72bf44249046d3c0422959bd57213b219eff5184.mp4',
          name: 'BEG-INT-ADV-Alternating_Sumo_Side_Bends-WARM_UP.mp4',
          description: null,
          size: 801775,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1040,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '44c25c395df86c45900a50444adb78730e7fa47ce8dd38fc0b48af0467c074c0',
          file_name:
            'audios/44c25c395df86c45900a50444adb78730e7fa47ce8dd38fc0b48af0467c074c0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/44c25c395df86c45900a50444adb78730e7fa47ce8dd38fc0b48af0467c074c0.mp3',
          name: 'BEG-INT-ADV-Alternating_Sumo_Side_Bends-WARM_UP.mp3',
          description: null,
          size: 35917,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Alternating_Sumo_Side_Bends-WARM_UP': {
      id: 464,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Alternating Sumo Side Bends',
      short_name: 'Alternating Sumo Side Bends',
      unique_name: 'INTERMEDIATE-Alternating_Sumo_Side_Bends-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart, rest your hands behind your head and bring elbows out wide.\n2. Keeping your core tight, transfer all your weight on one leg and bring your other knee up to hip height.\n3. Rotate your torso toward the bent leg and tap your elbow to your knee.\n4. Return to start position and repeat with the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1041,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6d94f68b9ddcef62c042181a72bf44249046d3c0422959bd57213b219eff5184',
          file_name:
            'videos/6d94f68b9ddcef62c042181a72bf44249046d3c0422959bd57213b219eff5184.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6d94f68b9ddcef62c042181a72bf44249046d3c0422959bd57213b219eff5184.mp4',
          name: 'BEG-INT-ADV-Alternating_Sumo_Side_Bends-WARM_UP.mp4',
          description: null,
          size: 801775,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1042,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '44c25c395df86c45900a50444adb78730e7fa47ce8dd38fc0b48af0467c074c0',
          file_name:
            'audios/44c25c395df86c45900a50444adb78730e7fa47ce8dd38fc0b48af0467c074c0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/44c25c395df86c45900a50444adb78730e7fa47ce8dd38fc0b48af0467c074c0.mp3',
          name: 'BEG-INT-ADV-Alternating_Sumo_Side_Bends-WARM_UP.mp3',
          description: null,
          size: 35917,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Alternating_Sumo_Side_Bends-WARM_UP': {
      id: 465,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Alternating Sumo Side Bends',
      short_name: 'Alternating Sumo Side Bends',
      unique_name: 'ADVANCED-Alternating_Sumo_Side_Bends-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart, rest your hands behind your head and bring elbows out wide.\n2. Keeping your core tight, transfer all your weight on one leg and bring your other knee up to hip height.\n3. Rotate your torso toward the bent leg and tap your elbow to your knee.\n4. Return to start position and repeat with the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1043,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6d94f68b9ddcef62c042181a72bf44249046d3c0422959bd57213b219eff5184',
          file_name:
            'videos/6d94f68b9ddcef62c042181a72bf44249046d3c0422959bd57213b219eff5184.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6d94f68b9ddcef62c042181a72bf44249046d3c0422959bd57213b219eff5184.mp4',
          name: 'BEG-INT-ADV-Alternating_Sumo_Side_Bends-WARM_UP.mp4',
          description: null,
          size: 801775,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1044,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '44c25c395df86c45900a50444adb78730e7fa47ce8dd38fc0b48af0467c074c0',
          file_name:
            'audios/44c25c395df86c45900a50444adb78730e7fa47ce8dd38fc0b48af0467c074c0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/44c25c395df86c45900a50444adb78730e7fa47ce8dd38fc0b48af0467c074c0.mp3',
          name: 'BEG-INT-ADV-Alternating_Sumo_Side_Bends-WARM_UP.mp3',
          description: null,
          size: 35917,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating_Knee_to_Elbow_Twist-WARM_UP': {
      id: 466,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Alternating Knee to Elbow Twist',
      short_name: 'Alt. Knee to Elbow Twist',
      unique_name: 'BEGINNER-Alternating_Knee_to_Elbow_Twist-WARM_UP',
      description:
        '1. Start with feet wider than shoulder-width apart, toes turned out slightly.\n2. Bend knees and sink hips back into a sumo squat with arms straight down behind your legs.\n3. Keeping chest up, core engaged and hips square, tilt your upper body to one side closing the gap between hips and low ribcage as your arm reaches toward the floor.\n4. Using core, return to start position and repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1059,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '1123cbe2b6f9f370b9ac27529370f558d56dcb3c7d94956457882f7cb99ed505',
          file_name:
            'videos/1123cbe2b6f9f370b9ac27529370f558d56dcb3c7d94956457882f7cb99ed505.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1123cbe2b6f9f370b9ac27529370f558d56dcb3c7d94956457882f7cb99ed505.mp4',
          name: 'BEG-INT-ADV-Alternating_Knee_to_Elbow_Twist-WARM_UP.mp4',
          description: null,
          size: 1198051,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1060,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '89e1c9cdb39dd10cbe1110c6c52568a84f4804c249883366c36c7ac8099285f4',
          file_name:
            'audios/89e1c9cdb39dd10cbe1110c6c52568a84f4804c249883366c36c7ac8099285f4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/89e1c9cdb39dd10cbe1110c6c52568a84f4804c249883366c36c7ac8099285f4.mp3',
          name: 'BEG-INT-ADV-Alternating_Knee_to_Elbow_Twist-WARM_UP.mp3',
          description: null,
          size: 36858,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Alternating_Knee_to_Elbow_Twist-WARM_UP': {
      id: 467,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Alternating Knee to Elbow Twist',
      short_name: 'Alt. Knee to Elbow Twist',
      unique_name: 'INTERMEDIATE-Alternating_Knee_to_Elbow_Twist-WARM_UP',
      description:
        '1. Start with feet wider than shoulder-width apart, toes turned out slightly.\n2. Bend knees and sink hips back into a sumo squat with arms straight down behind your legs.\n3. Keeping chest up, core engaged and hips square, tilt your upper body to one side closing the gap between hips and low ribcage as your arm reaches toward the floor.\n4. Using core, return to start position and repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1061,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '1123cbe2b6f9f370b9ac27529370f558d56dcb3c7d94956457882f7cb99ed505',
          file_name:
            'videos/1123cbe2b6f9f370b9ac27529370f558d56dcb3c7d94956457882f7cb99ed505.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1123cbe2b6f9f370b9ac27529370f558d56dcb3c7d94956457882f7cb99ed505.mp4',
          name: 'BEG-INT-ADV-Alternating_Knee_to_Elbow_Twist-WARM_UP.mp4',
          description: null,
          size: 1198051,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1062,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '89e1c9cdb39dd10cbe1110c6c52568a84f4804c249883366c36c7ac8099285f4',
          file_name:
            'audios/89e1c9cdb39dd10cbe1110c6c52568a84f4804c249883366c36c7ac8099285f4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/89e1c9cdb39dd10cbe1110c6c52568a84f4804c249883366c36c7ac8099285f4.mp3',
          name: 'BEG-INT-ADV-Alternating_Knee_to_Elbow_Twist-WARM_UP.mp3',
          description: null,
          size: 36858,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Alternating_Knee_to_Elbow_Twist-WARM_UP': {
      id: 468,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Alternating Knee to Elbow Twist',
      short_name: 'Alt. Knee to Elbow Twist',
      unique_name: 'ADVANCED-Alternating_Knee_to_Elbow_Twist-WARM_UP',
      description:
        '1. Start with feet wider than shoulder-width apart, toes turned out slightly.\n2. Bend knees and sink hips back into a sumo squat with arms straight down behind your legs.\n3. Keeping chest up, core engaged and hips square, tilt your upper body to one side closing the gap between hips and low ribcage as your arm reaches toward the floor.\n4. Using core, return to start position and repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1063,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '1123cbe2b6f9f370b9ac27529370f558d56dcb3c7d94956457882f7cb99ed505',
          file_name:
            'videos/1123cbe2b6f9f370b9ac27529370f558d56dcb3c7d94956457882f7cb99ed505.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1123cbe2b6f9f370b9ac27529370f558d56dcb3c7d94956457882f7cb99ed505.mp4',
          name: 'BEG-INT-ADV-Alternating_Knee_to_Elbow_Twist-WARM_UP.mp4',
          description: null,
          size: 1198051,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1064,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '89e1c9cdb39dd10cbe1110c6c52568a84f4804c249883366c36c7ac8099285f4',
          file_name:
            'audios/89e1c9cdb39dd10cbe1110c6c52568a84f4804c249883366c36c7ac8099285f4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/89e1c9cdb39dd10cbe1110c6c52568a84f4804c249883366c36c7ac8099285f4.mp3',
          name: 'BEG-INT-ADV-Alternating_Knee_to_Elbow_Twist-WARM_UP.mp3',
          description: null,
          size: 36858,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Boxer_Shuffle-WARM_UP': {
      id: 469,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Boxer Shuffle',
      short_name: 'Boxer Shuffle',
      unique_name: 'BEGINNER-Boxer_Shuffle-WARM_UP',
      description:
        '1. Start with feet shoulder-width apart and take a step forward with one leg. Toes forward, hips squared.\n2. Bend your  knees slightly, raise the back heel and bring both fists in front of your face.\n3. Drive off the back foot and transfer weight onto the front foot with a slight hop, back heel stays elevated.\n4. Immediately take a slight hop back, transferring weight to rear leg. Repeat in a continuous motion.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1075,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'daf12fb42a543e743b3de362016f7469784a8f8f01f02a62f13c868752e10b4d',
          file_name:
            'videos/daf12fb42a543e743b3de362016f7469784a8f8f01f02a62f13c868752e10b4d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/daf12fb42a543e743b3de362016f7469784a8f8f01f02a62f13c868752e10b4d.mp4',
          name: 'BEG-INT-ADV-Boxer_Shuffle-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 578719,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1076,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '83f89ce8811b29bff5f901c8de6d5e3a75f250501178eff04fb6f8a57c974ca2',
          file_name:
            'videos/83f89ce8811b29bff5f901c8de6d5e3a75f250501178eff04fb6f8a57c974ca2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/83f89ce8811b29bff5f901c8de6d5e3a75f250501178eff04fb6f8a57c974ca2.mp4',
          name: 'BEG-INT-ADV-Boxer_Shuffle-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 548259,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1077,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'f2dd45451a8198ca4d895d802c5dc811fdc4a5944ac173a5632c8db67f05cd95',
          file_name:
            'audios/f2dd45451a8198ca4d895d802c5dc811fdc4a5944ac173a5632c8db67f05cd95.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f2dd45451a8198ca4d895d802c5dc811fdc4a5944ac173a5632c8db67f05cd95.mp3',
          name: 'BEG-INT-ADV-Boxer_Shuffle-WARM_UP.mp3',
          description: null,
          size: 21811,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Boxer_Shuffle-WARM_UP': {
      id: 470,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Boxer Shuffle',
      short_name: 'Boxer Shuffle',
      unique_name: 'INTERMEDIATE-Boxer_Shuffle-WARM_UP',
      description:
        '1. Start with feet shoulder-width apart and take a step forward with one leg. Toes forward, hips squared.\n2. Bend your  knees slightly, raise the back heel and bring both fists in front of your face.\n3. Drive off the back foot and transfer weight onto the front foot with a slight hop, back heel stays elevated.\n4. Immediately take a slight hop back, transferring weight to rear leg. Repeat in a continuous motion.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1078,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'daf12fb42a543e743b3de362016f7469784a8f8f01f02a62f13c868752e10b4d',
          file_name:
            'videos/daf12fb42a543e743b3de362016f7469784a8f8f01f02a62f13c868752e10b4d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/daf12fb42a543e743b3de362016f7469784a8f8f01f02a62f13c868752e10b4d.mp4',
          name: 'BEG-INT-ADV-Boxer_Shuffle-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 578719,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1079,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '83f89ce8811b29bff5f901c8de6d5e3a75f250501178eff04fb6f8a57c974ca2',
          file_name:
            'videos/83f89ce8811b29bff5f901c8de6d5e3a75f250501178eff04fb6f8a57c974ca2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/83f89ce8811b29bff5f901c8de6d5e3a75f250501178eff04fb6f8a57c974ca2.mp4',
          name: 'BEG-INT-ADV-Boxer_Shuffle-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 548259,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1080,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'f2dd45451a8198ca4d895d802c5dc811fdc4a5944ac173a5632c8db67f05cd95',
          file_name:
            'audios/f2dd45451a8198ca4d895d802c5dc811fdc4a5944ac173a5632c8db67f05cd95.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f2dd45451a8198ca4d895d802c5dc811fdc4a5944ac173a5632c8db67f05cd95.mp3',
          name: 'BEG-INT-ADV-Boxer_Shuffle-WARM_UP.mp3',
          description: null,
          size: 21811,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Boxer_Shuffle-WARM_UP': {
      id: 471,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Boxer Shuffle',
      short_name: 'Boxer Shuffle',
      unique_name: 'ADVANCED-Boxer_Shuffle-WARM_UP',
      description:
        '1. Start with feet shoulder-width apart and take a step forward with one leg. Toes forward, hips squared.\n2. Bend your  knees slightly, raise the back heel and bring both fists in front of your face.\n3. Drive off the back foot and transfer weight onto the front foot with a slight hop, back heel stays elevated.\n4. Immediately take a slight hop back, transferring weight to rear leg. Repeat in a continuous motion.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1081,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'daf12fb42a543e743b3de362016f7469784a8f8f01f02a62f13c868752e10b4d',
          file_name:
            'videos/daf12fb42a543e743b3de362016f7469784a8f8f01f02a62f13c868752e10b4d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/daf12fb42a543e743b3de362016f7469784a8f8f01f02a62f13c868752e10b4d.mp4',
          name: 'BEG-INT-ADV-Boxer_Shuffle-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 578719,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1082,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '83f89ce8811b29bff5f901c8de6d5e3a75f250501178eff04fb6f8a57c974ca2',
          file_name:
            'videos/83f89ce8811b29bff5f901c8de6d5e3a75f250501178eff04fb6f8a57c974ca2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/83f89ce8811b29bff5f901c8de6d5e3a75f250501178eff04fb6f8a57c974ca2.mp4',
          name: 'BEG-INT-ADV-Boxer_Shuffle-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 548259,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1083,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'f2dd45451a8198ca4d895d802c5dc811fdc4a5944ac173a5632c8db67f05cd95',
          file_name:
            'audios/f2dd45451a8198ca4d895d802c5dc811fdc4a5944ac173a5632c8db67f05cd95.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f2dd45451a8198ca4d895d802c5dc811fdc4a5944ac173a5632c8db67f05cd95.mp3',
          name: 'BEG-INT-ADV-Boxer_Shuffle-WARM_UP.mp3',
          description: null,
          size: 21811,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Kneeling_Hip_Flexor-WARM_UP': {
      id: 472,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Kneeling Hip Flexor',
      short_name: 'Kneeling Hip Flexor',
      unique_name: 'BEGINNER-Kneeling_Hip_Flexor-WARM_UP',
      description:
        '1. Kneel on the floor with core engaged and spine straight.\n2. Step one foot in front, your knee is over your ankle.\n3. Keeping your chest up, lead with your hips and shift forward until you feel a stretch in the hip flexor of back leg. Your front knee may travel past your toes.\n4. Hold and breathe.\n5. With control, shift your weight back to neutral, return to start position and repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1106,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '9263ae430470ad1167fbd7511b2df06643feeed00d0cc98b981eff5524a299ed',
          file_name:
            'videos/9263ae430470ad1167fbd7511b2df06643feeed00d0cc98b981eff5524a299ed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9263ae430470ad1167fbd7511b2df06643feeed00d0cc98b981eff5524a299ed.mp4',
          name: 'BEG-INT-ADV-Kneeling_Hip_Flexor-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 348062,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1107,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'b486bca5c62f7d03d32bfb2c3e2d33551108befd135a2d4d903f09113e5ccf5e',
          file_name:
            'videos/b486bca5c62f7d03d32bfb2c3e2d33551108befd135a2d4d903f09113e5ccf5e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b486bca5c62f7d03d32bfb2c3e2d33551108befd135a2d4d903f09113e5ccf5e.mp4',
          name: 'BEG-INT-ADV-Kneeling_Hip_Flexor-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 388350,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1108,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '63cba754792d8b10ccf9047691098fe6f99e6e275c199758b6ef45d9279ef805',
          file_name:
            'audios/63cba754792d8b10ccf9047691098fe6f99e6e275c199758b6ef45d9279ef805.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/63cba754792d8b10ccf9047691098fe6f99e6e275c199758b6ef45d9279ef805.mp3',
          name: 'BEG-INT-ADV-Kneeling_Hip_Flexor-WARM_UP.mp3',
          description: null,
          size: 27140,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Kneeling_Hip_Flexor-WARM_UP': {
      id: 473,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Kneeling Hip Flexor',
      short_name: 'Kneeling Hip Flexor',
      unique_name: 'INTERMEDIATE-Kneeling_Hip_Flexor-WARM_UP',
      description:
        '1. Kneel on the floor with core engaged and spine straight.\n2. Step one foot in front, your knee is over your ankle.\n3. Keeping your chest up, lead with your hips and shift forward until you feel a stretch in the hip flexor of back leg. Your front knee may travel past your toes.\n4. Hold and breathe.\n5. With control, shift your weight back to neutral, return to start position and repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1109,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '9263ae430470ad1167fbd7511b2df06643feeed00d0cc98b981eff5524a299ed',
          file_name:
            'videos/9263ae430470ad1167fbd7511b2df06643feeed00d0cc98b981eff5524a299ed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9263ae430470ad1167fbd7511b2df06643feeed00d0cc98b981eff5524a299ed.mp4',
          name: 'BEG-INT-ADV-Kneeling_Hip_Flexor-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 348062,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1110,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'b486bca5c62f7d03d32bfb2c3e2d33551108befd135a2d4d903f09113e5ccf5e',
          file_name:
            'videos/b486bca5c62f7d03d32bfb2c3e2d33551108befd135a2d4d903f09113e5ccf5e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b486bca5c62f7d03d32bfb2c3e2d33551108befd135a2d4d903f09113e5ccf5e.mp4',
          name: 'BEG-INT-ADV-Kneeling_Hip_Flexor-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 388350,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1111,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '63cba754792d8b10ccf9047691098fe6f99e6e275c199758b6ef45d9279ef805',
          file_name:
            'audios/63cba754792d8b10ccf9047691098fe6f99e6e275c199758b6ef45d9279ef805.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/63cba754792d8b10ccf9047691098fe6f99e6e275c199758b6ef45d9279ef805.mp3',
          name: 'BEG-INT-ADV-Kneeling_Hip_Flexor-WARM_UP.mp3',
          description: null,
          size: 27140,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Kneeling_Hip_Flexor-WARM_UP': {
      id: 474,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kneeling Hip Flexor',
      short_name: 'Kneeling Hip Flexor',
      unique_name: 'ADVANCED-Kneeling_Hip_Flexor-WARM_UP',
      description:
        '1. Kneel on the floor with core engaged and spine straight.\n2. Step one foot in front, your knee is over your ankle.\n3. Keeping your chest up, lead with your hips and shift forward until you feel a stretch in the hip flexor of back leg. Your front knee may travel past your toes.\n4. Hold and breathe.\n5. With control, shift your weight back to neutral, return to start position and repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1112,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '9263ae430470ad1167fbd7511b2df06643feeed00d0cc98b981eff5524a299ed',
          file_name:
            'videos/9263ae430470ad1167fbd7511b2df06643feeed00d0cc98b981eff5524a299ed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9263ae430470ad1167fbd7511b2df06643feeed00d0cc98b981eff5524a299ed.mp4',
          name: 'BEG-INT-ADV-Kneeling_Hip_Flexor-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 348062,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1113,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'b486bca5c62f7d03d32bfb2c3e2d33551108befd135a2d4d903f09113e5ccf5e',
          file_name:
            'videos/b486bca5c62f7d03d32bfb2c3e2d33551108befd135a2d4d903f09113e5ccf5e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b486bca5c62f7d03d32bfb2c3e2d33551108befd135a2d4d903f09113e5ccf5e.mp4',
          name: 'BEG-INT-ADV-Kneeling_Hip_Flexor-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 388350,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1114,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '63cba754792d8b10ccf9047691098fe6f99e6e275c199758b6ef45d9279ef805',
          file_name:
            'audios/63cba754792d8b10ccf9047691098fe6f99e6e275c199758b6ef45d9279ef805.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/63cba754792d8b10ccf9047691098fe6f99e6e275c199758b6ef45d9279ef805.mp3',
          name: 'BEG-INT-ADV-Kneeling_Hip_Flexor-WARM_UP.mp3',
          description: null,
          size: 27140,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Plank_to_Down_Dog_with_Opposite_Reach-WARM_UP': {
      id: 475,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Plank to Down Dog with Opposite Reach',
      short_name: 'Plank to Down Dog with Reach',
      unique_name: 'BEGINNER-Plank_to_Down_Dog_with_Opposite_Reach-WARM_UP',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine.\n2. Engage your core, draw your hips up and back. Drop your chest toward your thighs, making an inverted "V" while reaching one arm back to tap the opposite foot.\n3. Drop your hips and return to Plank.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1117,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '077f473dc8c3e70bd023b8a1c8981ba2997179d3e0b68a6e34d0a5ac4f4109a7',
          file_name:
            'videos/077f473dc8c3e70bd023b8a1c8981ba2997179d3e0b68a6e34d0a5ac4f4109a7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/077f473dc8c3e70bd023b8a1c8981ba2997179d3e0b68a6e34d0a5ac4f4109a7.mp4',
          name: 'BEG-INT-ADV-Plank_to_Down_Dog_with_Opposite_Reach-WARM_UP.mp4',
          description: null,
          size: 862873,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1118,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '6c3988de43241e48105bcd5b22373f5c5dc7994055f5e47659bd6ad75749ae2a',
          file_name:
            'audios/6c3988de43241e48105bcd5b22373f5c5dc7994055f5e47659bd6ad75749ae2a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6c3988de43241e48105bcd5b22373f5c5dc7994055f5e47659bd6ad75749ae2a.mp3',
          name: 'BEG-INT-ADV-Plank_to_Down_Dog_with_Opposite_Reach-WARM_UP.mp3',
          description: null,
          size: 39679,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Plank_to_Down_Dog_with_Opposite_Reach-WARM_UP': {
      id: 476,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Plank to Down Dog with Opposite Reach',
      short_name: 'Plank to Down Dog with Reach',
      unique_name: 'INTERMEDIATE-Plank_to_Down_Dog_with_Opposite_Reach-WARM_UP',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine.\n2. Engage your core, draw your hips up and back. Drop your chest toward your thighs, making an inverted "V" while reaching one arm back to tap the opposite foot.\n3. Drop your hips and return to Plank.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1119,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '077f473dc8c3e70bd023b8a1c8981ba2997179d3e0b68a6e34d0a5ac4f4109a7',
          file_name:
            'videos/077f473dc8c3e70bd023b8a1c8981ba2997179d3e0b68a6e34d0a5ac4f4109a7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/077f473dc8c3e70bd023b8a1c8981ba2997179d3e0b68a6e34d0a5ac4f4109a7.mp4',
          name: 'BEG-INT-ADV-Plank_to_Down_Dog_with_Opposite_Reach-WARM_UP.mp4',
          description: null,
          size: 862873,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1120,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '6c3988de43241e48105bcd5b22373f5c5dc7994055f5e47659bd6ad75749ae2a',
          file_name:
            'audios/6c3988de43241e48105bcd5b22373f5c5dc7994055f5e47659bd6ad75749ae2a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6c3988de43241e48105bcd5b22373f5c5dc7994055f5e47659bd6ad75749ae2a.mp3',
          name: 'BEG-INT-ADV-Plank_to_Down_Dog_with_Opposite_Reach-WARM_UP.mp3',
          description: null,
          size: 39679,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Plank_to_Down_Dog_with_Opposite_Reach-WARM_UP': {
      id: 477,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Plank to Down Dog with Opposite Reach',
      short_name: 'Plank to Down Dog with Reach',
      unique_name: 'ADVANCED-Plank_to_Down_Dog_with_Opposite_Reach-WARM_UP',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine.\n2. Engage your core, draw your hips up and back. Drop your chest toward your thighs, making an inverted "V" while reaching one arm back to tap the opposite foot.\n3. Drop your hips and return to Plank.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1121,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '077f473dc8c3e70bd023b8a1c8981ba2997179d3e0b68a6e34d0a5ac4f4109a7',
          file_name:
            'videos/077f473dc8c3e70bd023b8a1c8981ba2997179d3e0b68a6e34d0a5ac4f4109a7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/077f473dc8c3e70bd023b8a1c8981ba2997179d3e0b68a6e34d0a5ac4f4109a7.mp4',
          name: 'BEG-INT-ADV-Plank_to_Down_Dog_with_Opposite_Reach-WARM_UP.mp4',
          description: null,
          size: 862873,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1122,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '6c3988de43241e48105bcd5b22373f5c5dc7994055f5e47659bd6ad75749ae2a',
          file_name:
            'audios/6c3988de43241e48105bcd5b22373f5c5dc7994055f5e47659bd6ad75749ae2a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6c3988de43241e48105bcd5b22373f5c5dc7994055f5e47659bd6ad75749ae2a.mp3',
          name: 'BEG-INT-ADV-Plank_to_Down_Dog_with_Opposite_Reach-WARM_UP.mp3',
          description: null,
          size: 39679,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Frankensteins-WARM_UP': {
      id: 478,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Frankensteins',
      short_name: 'Frankensteins',
      unique_name: 'BEGINNER-Frankensteins-WARM_UP',
      description:
        '1. Stand tall with your feet about shoulder-width apart, core tight and arms straight down by your sides.\n2. With control, swing one leg up in front of you to hip height, keeping your leg as straight as possible, foot flexed. Simultaneously swing your opposite arm straight up to reach for your toe.\n3. Keeping both arms and legs straight, return to start and repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 939,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6e0f086e6b80a8b2cd72ee1279fa42f690890d72a3d940872dc3ac0ba7968ed8',
          file_name:
            'videos/6e0f086e6b80a8b2cd72ee1279fa42f690890d72a3d940872dc3ac0ba7968ed8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6e0f086e6b80a8b2cd72ee1279fa42f690890d72a3d940872dc3ac0ba7968ed8.mp4',
          name: 'BEG-INT-ADV-Frankensteins-WARM_UP.mp4',
          description: null,
          size: 1186965,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 940,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'f8442164aa3d2cc132979e0e59ad9d5186a26645fca8ca0974f0f2b2d79d2022',
          file_name:
            'audios/f8442164aa3d2cc132979e0e59ad9d5186a26645fca8ca0974f0f2b2d79d2022.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f8442164aa3d2cc132979e0e59ad9d5186a26645fca8ca0974f0f2b2d79d2022.mp3',
          name: 'BEG-INT-ADV-Frankensteins-WARM_UP.mp3',
          description: null,
          size: 22124,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Frankensteins-WARM_UP': {
      id: 479,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Frankensteins',
      short_name: 'Frankensteins',
      unique_name: 'INTERMEDIATE-Frankensteins-WARM_UP',
      description:
        '1. Stand tall with your feet about shoulder-width apart, core tight and arms straight down by your sides.\n2. With control, swing one leg up in front of you to hip height, keeping your leg as straight as possible, foot flexed. Simultaneously swing your opposite arm straight up to reach for your toe.\n3. Keeping both arms and legs straight, return to start and repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 941,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6e0f086e6b80a8b2cd72ee1279fa42f690890d72a3d940872dc3ac0ba7968ed8',
          file_name:
            'videos/6e0f086e6b80a8b2cd72ee1279fa42f690890d72a3d940872dc3ac0ba7968ed8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6e0f086e6b80a8b2cd72ee1279fa42f690890d72a3d940872dc3ac0ba7968ed8.mp4',
          name: 'BEG-INT-ADV-Frankensteins-WARM_UP.mp4',
          description: null,
          size: 1186965,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 942,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'f8442164aa3d2cc132979e0e59ad9d5186a26645fca8ca0974f0f2b2d79d2022',
          file_name:
            'audios/f8442164aa3d2cc132979e0e59ad9d5186a26645fca8ca0974f0f2b2d79d2022.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f8442164aa3d2cc132979e0e59ad9d5186a26645fca8ca0974f0f2b2d79d2022.mp3',
          name: 'BEG-INT-ADV-Frankensteins-WARM_UP.mp3',
          description: null,
          size: 22124,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Frankensteins-WARM_UP': {
      id: 480,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Frankensteins',
      short_name: 'Frankensteins',
      unique_name: 'ADVANCED-Frankensteins-WARM_UP',
      description:
        '1. Stand tall with your feet about shoulder-width apart, core tight and arms straight down by your sides.\n2. With control, swing one leg up in front of you to hip height, keeping your leg as straight as possible, foot flexed. Simultaneously swing your opposite arm straight up to reach for your toe.\n3. Keeping both arms and legs straight, return to start and repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 943,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6e0f086e6b80a8b2cd72ee1279fa42f690890d72a3d940872dc3ac0ba7968ed8',
          file_name:
            'videos/6e0f086e6b80a8b2cd72ee1279fa42f690890d72a3d940872dc3ac0ba7968ed8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6e0f086e6b80a8b2cd72ee1279fa42f690890d72a3d940872dc3ac0ba7968ed8.mp4',
          name: 'BEG-INT-ADV-Frankensteins-WARM_UP.mp4',
          description: null,
          size: 1186965,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 944,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'f8442164aa3d2cc132979e0e59ad9d5186a26645fca8ca0974f0f2b2d79d2022',
          file_name:
            'audios/f8442164aa3d2cc132979e0e59ad9d5186a26645fca8ca0974f0f2b2d79d2022.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f8442164aa3d2cc132979e0e59ad9d5186a26645fca8ca0974f0f2b2d79d2022.mp3',
          name: 'BEG-INT-ADV-Frankensteins-WARM_UP.mp3',
          description: null,
          size: 22124,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Arm_Circles_Forward_and_Backward-WARM_UP': {
      id: 481,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Arm Circles Forward and Backward',
      short_name: 'Arm Circles',
      unique_name: 'BEGINNER-Arm_Circles_Forward_and_Backward-WARM_UP',
      description:
        '1. Stand with your feet shoulder-width apart. Raise both arms straight out to your sides as a "T" on shoulder height. Maintain good posture and roll your shoulder blades back and down.\n2. With straight arms, draw tiny circles with your hands forward and backward. 15 seconds each way.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 947,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '0ff083dfc1ba89eb9d5487d812ff3ffbead05525571bb5612669795b5779a55c',
          file_name:
            'videos/0ff083dfc1ba89eb9d5487d812ff3ffbead05525571bb5612669795b5779a55c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0ff083dfc1ba89eb9d5487d812ff3ffbead05525571bb5612669795b5779a55c.mp4',
          name: 'BEG-INT-ADV-Arm_Circles_Forward_and_Backward-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 280555,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 948,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'ae420194c087009f5e43d715246bd98d31e4b5f0bd21b6d781ea6eb27cdbcdbf',
          file_name:
            'videos/ae420194c087009f5e43d715246bd98d31e4b5f0bd21b6d781ea6eb27cdbcdbf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ae420194c087009f5e43d715246bd98d31e4b5f0bd21b6d781ea6eb27cdbcdbf.mp4',
          name: 'BEG-INT-ADV-Arm_Circles_Forward_and_Backward-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 295642,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 949,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '371ee976f5cd2c75991e6925595ef4e8689d163d6d69e258687ba9ac9d9b0cc9',
          file_name:
            'audios/371ee976f5cd2c75991e6925595ef4e8689d163d6d69e258687ba9ac9d9b0cc9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/371ee976f5cd2c75991e6925595ef4e8689d163d6d69e258687ba9ac9d9b0cc9.mp3',
          name: 'BEG-INT-ADV-Arm_Circles_Forward_and_Backward-WARM_UP.mp3',
          description: null,
          size: 38111,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Arm_Circles_Forward_and_Backward-WARM_UP': {
      id: 482,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Arm Circles Forward and Backward',
      short_name: 'Arm Circles',
      unique_name: 'INTERMEDIATE-Arm_Circles_Forward_and_Backward-WARM_UP',
      description:
        '1. Stand with your feet shoulder-width apart. Raise both arms straight out to your sides as a "T" on shoulder height. Maintain good posture and roll your shoulder blades back and down.\n2. With straight arms, draw tiny circles with your hands forward and backward. 15 seconds each way.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 950,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '0ff083dfc1ba89eb9d5487d812ff3ffbead05525571bb5612669795b5779a55c',
          file_name:
            'videos/0ff083dfc1ba89eb9d5487d812ff3ffbead05525571bb5612669795b5779a55c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0ff083dfc1ba89eb9d5487d812ff3ffbead05525571bb5612669795b5779a55c.mp4',
          name: 'BEG-INT-ADV-Arm_Circles_Forward_and_Backward-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 280555,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 951,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'ae420194c087009f5e43d715246bd98d31e4b5f0bd21b6d781ea6eb27cdbcdbf',
          file_name:
            'videos/ae420194c087009f5e43d715246bd98d31e4b5f0bd21b6d781ea6eb27cdbcdbf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ae420194c087009f5e43d715246bd98d31e4b5f0bd21b6d781ea6eb27cdbcdbf.mp4',
          name: 'BEG-INT-ADV-Arm_Circles_Forward_and_Backward-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 295642,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 952,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '371ee976f5cd2c75991e6925595ef4e8689d163d6d69e258687ba9ac9d9b0cc9',
          file_name:
            'audios/371ee976f5cd2c75991e6925595ef4e8689d163d6d69e258687ba9ac9d9b0cc9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/371ee976f5cd2c75991e6925595ef4e8689d163d6d69e258687ba9ac9d9b0cc9.mp3',
          name: 'BEG-INT-ADV-Arm_Circles_Forward_and_Backward-WARM_UP.mp3',
          description: null,
          size: 38111,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Arm_Circles_Forward_and_Backward-WARM_UP': {
      id: 483,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Arm Circles Forward and Backward',
      short_name: 'Arm Circles',
      unique_name: 'ADVANCED-Arm_Circles_Forward_and_Backward-WARM_UP',
      description:
        '1. Stand with your feet shoulder-width apart. Raise both arms straight out to your sides as a "T" on shoulder height. Maintain good posture and roll your shoulder blades back and down.\n2. With straight arms, draw tiny circles with your hands forward and backward. 15 seconds each way.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 953,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '0ff083dfc1ba89eb9d5487d812ff3ffbead05525571bb5612669795b5779a55c',
          file_name:
            'videos/0ff083dfc1ba89eb9d5487d812ff3ffbead05525571bb5612669795b5779a55c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0ff083dfc1ba89eb9d5487d812ff3ffbead05525571bb5612669795b5779a55c.mp4',
          name: 'BEG-INT-ADV-Arm_Circles_Forward_and_Backward-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 280555,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 954,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'ae420194c087009f5e43d715246bd98d31e4b5f0bd21b6d781ea6eb27cdbcdbf',
          file_name:
            'videos/ae420194c087009f5e43d715246bd98d31e4b5f0bd21b6d781ea6eb27cdbcdbf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ae420194c087009f5e43d715246bd98d31e4b5f0bd21b6d781ea6eb27cdbcdbf.mp4',
          name: 'BEG-INT-ADV-Arm_Circles_Forward_and_Backward-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 295642,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 955,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '371ee976f5cd2c75991e6925595ef4e8689d163d6d69e258687ba9ac9d9b0cc9',
          file_name:
            'audios/371ee976f5cd2c75991e6925595ef4e8689d163d6d69e258687ba9ac9d9b0cc9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/371ee976f5cd2c75991e6925595ef4e8689d163d6d69e258687ba9ac9d9b0cc9.mp3',
          name: 'BEG-INT-ADV-Arm_Circles_Forward_and_Backward-WARM_UP.mp3',
          description: null,
          size: 38111,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Big_Arm_Circles_Forward_and_Backward-WARM_UP': {
      id: 484,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Big Arm Circles Forward and Backward',
      short_name: 'Big Arm Circles',
      unique_name: 'BEGINNER-Big_Arm_Circles_Forward_and_Backward-WARM_UP',
      description:
        '1. Stand with your feet shoulder-width apart. Raise both arms straight out to your sides as a "T" on shoulder height. Maintain good posture and roll your shoulder blades back and down.\n2. With straight arms, draw large circles with your hands forward and backward. 15 seconds each way.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 958,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '8f8748798ed0de1407879dbd1e3844f512b55da4bc2125e04617ae64c4c8bdb2',
          file_name:
            'audios/8f8748798ed0de1407879dbd1e3844f512b55da4bc2125e04617ae64c4c8bdb2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8f8748798ed0de1407879dbd1e3844f512b55da4bc2125e04617ae64c4c8bdb2.mp3',
          name: 'BEG-INT-ADV-Big_Arm_Circles_Forward_and_Backward-WARM_UP.mp3',
          description: null,
          size: 40933,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2569,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '02305da2ae95b3ab002e7a4d71db9d71f9a5ffcaa3c95937e7b740c3c3924fa4',
          file_name:
            'videos/02305da2ae95b3ab002e7a4d71db9d71f9a5ffcaa3c95937e7b740c3c3924fa4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/02305da2ae95b3ab002e7a4d71db9d71f9a5ffcaa3c95937e7b740c3c3924fa4.mp4',
          name: 'BEG-INT-ADV-Big_Arm_Circles_Forward_and_Backward-WARM_UP-(LEFT)',
          description: 'Left Side',
          size: 439496,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2570,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '5dad4e69a2ffc66018cbf87aab7115335f03aa06d32b18298cf9cedb158ca3eb',
          file_name:
            'videos/5dad4e69a2ffc66018cbf87aab7115335f03aa06d32b18298cf9cedb158ca3eb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5dad4e69a2ffc66018cbf87aab7115335f03aa06d32b18298cf9cedb158ca3eb.mp4',
          name: 'BEG-INT-ADV-Big_Arm_Circles_Forward_and_Backward-WARM_UP-(RIGHT)',
          description: 'Right Side',
          size: 454650,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Big_Arm_Circles_Forward_and_Backward-WARM_UP': {
      id: 485,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Big Arm Circles Forward and Backward',
      short_name: 'Big Arm Circles',
      unique_name: 'INTERMEDIATE-Big_Arm_Circles_Forward_and_Backward-WARM_UP',
      description:
        '1. Stand with your feet shoulder-width apart. Raise both arms straight out to your sides as a "T" on shoulder height. Maintain good posture and roll your shoulder blades back and down.\n2. With straight arms, draw large circles with your hands forward and backward. 15 seconds each way.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 961,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '8f8748798ed0de1407879dbd1e3844f512b55da4bc2125e04617ae64c4c8bdb2',
          file_name:
            'audios/8f8748798ed0de1407879dbd1e3844f512b55da4bc2125e04617ae64c4c8bdb2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8f8748798ed0de1407879dbd1e3844f512b55da4bc2125e04617ae64c4c8bdb2.mp3',
          name: 'BEG-INT-ADV-Big_Arm_Circles_Forward_and_Backward-WARM_UP.mp3',
          description: null,
          size: 40933,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2571,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '02305da2ae95b3ab002e7a4d71db9d71f9a5ffcaa3c95937e7b740c3c3924fa4',
          file_name:
            'videos/02305da2ae95b3ab002e7a4d71db9d71f9a5ffcaa3c95937e7b740c3c3924fa4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/02305da2ae95b3ab002e7a4d71db9d71f9a5ffcaa3c95937e7b740c3c3924fa4.mp4',
          name: 'BEG-INT-ADV-Big_Arm_Circles_Forward_and_Backward-WARM_UP-(LEFT)',
          description: 'Left Side',
          size: 439496,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2572,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '5dad4e69a2ffc66018cbf87aab7115335f03aa06d32b18298cf9cedb158ca3eb',
          file_name:
            'videos/5dad4e69a2ffc66018cbf87aab7115335f03aa06d32b18298cf9cedb158ca3eb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5dad4e69a2ffc66018cbf87aab7115335f03aa06d32b18298cf9cedb158ca3eb.mp4',
          name: 'BEG-INT-ADV-Big_Arm_Circles_Forward_and_Backward-WARM_UP-(RIGHT)',
          description: 'Right Side',
          size: 454650,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Big_Arm_Circles_Forward_and_Backward-WARM_UP': {
      id: 486,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Big Arm Circles Forward and Backward',
      short_name: 'Big Arm Circles',
      unique_name: 'ADVANCED-Big_Arm_Circles_Forward_and_Backward-WARM_UP',
      description:
        '1. Stand with your feet shoulder-width apart. Raise both arms straight out to your sides as a "T" on shoulder height. Maintain good posture and roll your shoulder blades back and down.\n2. With straight arms, draw large circles with your hands forward and backward. 15 seconds each way.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 964,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '8f8748798ed0de1407879dbd1e3844f512b55da4bc2125e04617ae64c4c8bdb2',
          file_name:
            'audios/8f8748798ed0de1407879dbd1e3844f512b55da4bc2125e04617ae64c4c8bdb2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8f8748798ed0de1407879dbd1e3844f512b55da4bc2125e04617ae64c4c8bdb2.mp3',
          name: 'BEG-INT-ADV-Big_Arm_Circles_Forward_and_Backward-WARM_UP.mp3',
          description: null,
          size: 40933,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2573,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '02305da2ae95b3ab002e7a4d71db9d71f9a5ffcaa3c95937e7b740c3c3924fa4',
          file_name:
            'videos/02305da2ae95b3ab002e7a4d71db9d71f9a5ffcaa3c95937e7b740c3c3924fa4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/02305da2ae95b3ab002e7a4d71db9d71f9a5ffcaa3c95937e7b740c3c3924fa4.mp4',
          name: 'BEG-INT-ADV-Big_Arm_Circles_Forward_and_Backward-WARM_UP-(LEFT)',
          description: 'Left Side',
          size: 439496,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2574,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '5dad4e69a2ffc66018cbf87aab7115335f03aa06d32b18298cf9cedb158ca3eb',
          file_name:
            'videos/5dad4e69a2ffc66018cbf87aab7115335f03aa06d32b18298cf9cedb158ca3eb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5dad4e69a2ffc66018cbf87aab7115335f03aa06d32b18298cf9cedb158ca3eb.mp4',
          name: 'BEG-INT-ADV-Big_Arm_Circles_Forward_and_Backward-WARM_UP-(RIGHT)',
          description: 'Right Side',
          size: 454650,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bulldog_Floor_Squats-WARM_UP': {
      id: 487,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bulldog Floor Squats',
      short_name: 'Bulldog Floor Squats',
      unique_name: 'BEGINNER-Bulldog_Floor_Squats-WARM_UP',
      description:
        '1. Start in a squat with your feet a little wider than hip-width apart, hands up in front of your chest, palms facing out.\n2. Maintain the squat, brace your core and rock forward until your palms meet the floor.\n3. Land with a soft bend in your elbows, keeping the bent knees hovering off the floor underneath hips.\n4. Bend elbows slightly, and straighten arms to push back up to start position.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 967,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'c0facf17b442aa5c883defecefb9501b6bdecbadde223896cfe5018e84e91247',
          file_name:
            'videos/c0facf17b442aa5c883defecefb9501b6bdecbadde223896cfe5018e84e91247.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c0facf17b442aa5c883defecefb9501b6bdecbadde223896cfe5018e84e91247.mp4',
          name: 'BEG-INT-ADV-Bulldog_Floor_Squats-WARM_UP.mp4',
          description: null,
          size: 1031563,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 968,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'd72e2f7b928ab21c535e15e25affbaf5a4a174e223fc71de001cb6333bd18d20',
          file_name:
            'audios/d72e2f7b928ab21c535e15e25affbaf5a4a174e223fc71de001cb6333bd18d20.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d72e2f7b928ab21c535e15e25affbaf5a4a174e223fc71de001cb6333bd18d20.mp3',
          name: 'BEG-INT-ADV-Bulldog_Floor_Squats-WARM_UP.mp3',
          description: null,
          size: 28071,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Bulldog_Floor_Squats-WARM_UP': {
      id: 488,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Bulldog Floor Squats',
      short_name: 'Bulldog Floor Squats',
      unique_name: 'INTERMEDIATE-Bulldog_Floor_Squats-WARM_UP',
      description:
        '1. Start in a squat with your feet a little wider than hip-width apart, hands up in front of your chest, palms facing out.\n2. Maintain the squat, brace your core and rock forward until your palms meet the floor.\n3. Land with a soft bend in your elbows, keeping the bent knees hovering off the floor underneath hips.\n4. Bend elbows slightly, and straighten arms to push back up to start position.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 969,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'c0facf17b442aa5c883defecefb9501b6bdecbadde223896cfe5018e84e91247',
          file_name:
            'videos/c0facf17b442aa5c883defecefb9501b6bdecbadde223896cfe5018e84e91247.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c0facf17b442aa5c883defecefb9501b6bdecbadde223896cfe5018e84e91247.mp4',
          name: 'BEG-INT-ADV-Bulldog_Floor_Squats-WARM_UP.mp4',
          description: null,
          size: 1031563,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 970,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'd72e2f7b928ab21c535e15e25affbaf5a4a174e223fc71de001cb6333bd18d20',
          file_name:
            'audios/d72e2f7b928ab21c535e15e25affbaf5a4a174e223fc71de001cb6333bd18d20.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d72e2f7b928ab21c535e15e25affbaf5a4a174e223fc71de001cb6333bd18d20.mp3',
          name: 'BEG-INT-ADV-Bulldog_Floor_Squats-WARM_UP.mp3',
          description: null,
          size: 28071,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Bulldog_Floor_Squats-WARM_UP': {
      id: 489,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Bulldog Floor Squats',
      short_name: 'Bulldog Floor Squats',
      unique_name: 'ADVANCED-Bulldog_Floor_Squats-WARM_UP',
      description:
        '1. Start in a squat with your feet a little wider than hip-width apart, hands up in front of your chest, palms facing out.\n2. Maintain the squat, brace your core and rock forward until your palms meet the floor.\n3. Land with a soft bend in your elbows, keeping the bent knees hovering off the floor underneath hips.\n4. Bend elbows slightly, and straighten arms to push back up to start position.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 971,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'c0facf17b442aa5c883defecefb9501b6bdecbadde223896cfe5018e84e91247',
          file_name:
            'videos/c0facf17b442aa5c883defecefb9501b6bdecbadde223896cfe5018e84e91247.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c0facf17b442aa5c883defecefb9501b6bdecbadde223896cfe5018e84e91247.mp4',
          name: 'BEG-INT-ADV-Bulldog_Floor_Squats-WARM_UP.mp4',
          description: null,
          size: 1031563,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 972,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'd72e2f7b928ab21c535e15e25affbaf5a4a174e223fc71de001cb6333bd18d20',
          file_name:
            'audios/d72e2f7b928ab21c535e15e25affbaf5a4a174e223fc71de001cb6333bd18d20.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d72e2f7b928ab21c535e15e25affbaf5a4a174e223fc71de001cb6333bd18d20.mp3',
          name: 'BEG-INT-ADV-Bulldog_Floor_Squats-WARM_UP.mp3',
          description: null,
          size: 28071,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Chair_Pose_to_Divers_Pose-WARM_UP': {
      id: 490,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: "Chair Pose to Diver's Pose",
      short_name: "Chair Pose to Diver's Pose",
      unique_name: 'BEGINNER-Chair_Pose_to_Divers_Pose-WARM_UP',
      description:
        '1. Start with feet, knees and legs together. Keep a tall spine, bend your knees and sink your hips back into a narrow squat while raising arms overhead, biceps close to your ears.\n2. With core engaged, swing your arms down and behind you, tilt your upper body over your quads slightly and raise up on your toes.\n3. Pause for a beat before dropping your heels to the floor and return to Chair Pose.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 973,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'dc0e091da6d661cf0e88ac2500b5fe901cf423bfd311ad04a423480347b1232a',
          file_name:
            'videos/dc0e091da6d661cf0e88ac2500b5fe901cf423bfd311ad04a423480347b1232a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dc0e091da6d661cf0e88ac2500b5fe901cf423bfd311ad04a423480347b1232a.mp4',
          name: 'BEG-INT-ADV-Chair_Pose_to_Divers_Pose-WARM_UP.mp4',
          description: null,
          size: 888018,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 974,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '739958bf46f0a5c9f71e6ca7d13f8c42de13106473c8f59f4dde15fb0e6b38bb',
          file_name:
            'audios/739958bf46f0a5c9f71e6ca7d13f8c42de13106473c8f59f4dde15fb0e6b38bb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/739958bf46f0a5c9f71e6ca7d13f8c42de13106473c8f59f4dde15fb0e6b38bb.mp3',
          name: 'BEG-INT-ADV-Chair_Pose_to_Divers_Pose-WARM_UP.mp3',
          description: null,
          size: 33096,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Chair_Pose_to_Divers_Pose-WARM_UP': {
      id: 491,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: "Chair Pose to Diver's Pose",
      short_name: "Chair Pose to Diver's Pose",
      unique_name: 'INTERMEDIATE-Chair_Pose_to_Divers_Pose-WARM_UP',
      description:
        '1. Start with feet, knees and legs together. Keep a tall spine, bend your knees and sink your hips back into a narrow squat while raising arms overhead, biceps close to your ears.\n2. With core engaged, swing your arms down and behind you, tilt your upper body over your quads slightly and raise up on your toes.\n3. Pause for a beat before dropping your heels to the floor and return to Chair Pose.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 975,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'dc0e091da6d661cf0e88ac2500b5fe901cf423bfd311ad04a423480347b1232a',
          file_name:
            'videos/dc0e091da6d661cf0e88ac2500b5fe901cf423bfd311ad04a423480347b1232a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dc0e091da6d661cf0e88ac2500b5fe901cf423bfd311ad04a423480347b1232a.mp4',
          name: 'BEG-INT-ADV-Chair_Pose_to_Divers_Pose-WARM_UP.mp4',
          description: null,
          size: 888018,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 976,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '739958bf46f0a5c9f71e6ca7d13f8c42de13106473c8f59f4dde15fb0e6b38bb',
          file_name:
            'audios/739958bf46f0a5c9f71e6ca7d13f8c42de13106473c8f59f4dde15fb0e6b38bb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/739958bf46f0a5c9f71e6ca7d13f8c42de13106473c8f59f4dde15fb0e6b38bb.mp3',
          name: 'BEG-INT-ADV-Chair_Pose_to_Divers_Pose-WARM_UP.mp3',
          description: null,
          size: 33096,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Chair_Pose_to_Divers_Pose-WARM_UP': {
      id: 492,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: "Chair Pose to Diver's Pose",
      short_name: "Chair Pose to Diver's Pose",
      unique_name: 'ADVANCED-Chair_Pose_to_Divers_Pose-WARM_UP',
      description:
        '1. Start with feet, knees and legs together. Keep a tall spine, bend your knees and sink your hips back into a narrow squat while raising arms overhead, biceps close to your ears.\n2. With core engaged, swing your arms down and behind you, tilt your upper body over your quads slightly and raise up on your toes.\n3. Pause for a beat before dropping your heels to the floor and return to Chair Pose.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 977,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'dc0e091da6d661cf0e88ac2500b5fe901cf423bfd311ad04a423480347b1232a',
          file_name:
            'videos/dc0e091da6d661cf0e88ac2500b5fe901cf423bfd311ad04a423480347b1232a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dc0e091da6d661cf0e88ac2500b5fe901cf423bfd311ad04a423480347b1232a.mp4',
          name: 'BEG-INT-ADV-Chair_Pose_to_Divers_Pose-WARM_UP.mp4',
          description: null,
          size: 888018,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 978,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '739958bf46f0a5c9f71e6ca7d13f8c42de13106473c8f59f4dde15fb0e6b38bb',
          file_name:
            'audios/739958bf46f0a5c9f71e6ca7d13f8c42de13106473c8f59f4dde15fb0e6b38bb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/739958bf46f0a5c9f71e6ca7d13f8c42de13106473c8f59f4dde15fb0e6b38bb.mp3',
          name: 'BEG-INT-ADV-Chair_Pose_to_Divers_Pose-WARM_UP.mp3',
          description: null,
          size: 33096,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-High_Knees_with_Clap-WARM_UP': {
      id: 493,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'High Knees with Clap',
      short_name: 'High Knees with Clap',
      unique_name: 'BEGINNER-High_Knees_with_Clap-WARM_UP',
      description:
        '1. Jog in place while lifting your knees as high as you can and clap under each leg.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 1006,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'a4c4242289fa8fc0a89833588c34e81578d22c69bdfe4f9567bc6433d6371aa3',
          file_name:
            'videos/a4c4242289fa8fc0a89833588c34e81578d22c69bdfe4f9567bc6433d6371aa3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a4c4242289fa8fc0a89833588c34e81578d22c69bdfe4f9567bc6433d6371aa3.mp4',
          name: 'BEG-INT-ADV-High_Knees_with_Clap-WARM_UP.mp4',
          description: null,
          size: 1407387,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1007,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'e430dc83df2be6a6f3bcc6a0d02d9b996949132e72390a474ecdee4c03619afd',
          file_name:
            'audios/e430dc83df2be6a6f3bcc6a0d02d9b996949132e72390a474ecdee4c03619afd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e430dc83df2be6a6f3bcc6a0d02d9b996949132e72390a474ecdee4c03619afd.mp3',
          name: 'BEG-INT-ADV-High_Knees_with_Clap-WARM_UP.mp3',
          description: null,
          size: 24946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-High_Knees_with_Clap-WARM_UP': {
      id: 494,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'High Knees with Clap',
      short_name: 'High Knees with Clap',
      unique_name: 'INTERMEDIATE-High_Knees_with_Clap-WARM_UP',
      description:
        '1. Jog in place while lifting your knees as high as you can and clap under each leg.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 1008,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'a4c4242289fa8fc0a89833588c34e81578d22c69bdfe4f9567bc6433d6371aa3',
          file_name:
            'videos/a4c4242289fa8fc0a89833588c34e81578d22c69bdfe4f9567bc6433d6371aa3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a4c4242289fa8fc0a89833588c34e81578d22c69bdfe4f9567bc6433d6371aa3.mp4',
          name: 'BEG-INT-ADV-High_Knees_with_Clap-WARM_UP.mp4',
          description: null,
          size: 1407387,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1009,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'e430dc83df2be6a6f3bcc6a0d02d9b996949132e72390a474ecdee4c03619afd',
          file_name:
            'audios/e430dc83df2be6a6f3bcc6a0d02d9b996949132e72390a474ecdee4c03619afd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e430dc83df2be6a6f3bcc6a0d02d9b996949132e72390a474ecdee4c03619afd.mp3',
          name: 'BEG-INT-ADV-High_Knees_with_Clap-WARM_UP.mp3',
          description: null,
          size: 24946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-High_Knees_with_Clap-WARM_UP': {
      id: 495,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'High Knees with Clap',
      short_name: 'High Knees with Clap',
      unique_name: 'ADVANCED-High_Knees_with_Clap-WARM_UP',
      description:
        '1. Jog in place while lifting your knees as high as you can and clap under each leg.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 1010,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'a4c4242289fa8fc0a89833588c34e81578d22c69bdfe4f9567bc6433d6371aa3',
          file_name:
            'videos/a4c4242289fa8fc0a89833588c34e81578d22c69bdfe4f9567bc6433d6371aa3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a4c4242289fa8fc0a89833588c34e81578d22c69bdfe4f9567bc6433d6371aa3.mp4',
          name: 'BEG-INT-ADV-High_Knees_with_Clap-WARM_UP.mp4',
          description: null,
          size: 1407387,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1011,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'e430dc83df2be6a6f3bcc6a0d02d9b996949132e72390a474ecdee4c03619afd',
          file_name:
            'audios/e430dc83df2be6a6f3bcc6a0d02d9b996949132e72390a474ecdee4c03619afd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e430dc83df2be6a6f3bcc6a0d02d9b996949132e72390a474ecdee4c03619afd.mp3',
          name: 'BEG-INT-ADV-High_Knees_with_Clap-WARM_UP.mp3',
          description: null,
          size: 24946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Imaginary_Jump_Rope-WARM_UP': {
      id: 496,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Imaginary Jump Rope',
      short_name: 'Imaginary Jump Rope',
      unique_name: 'BEGINNER-Imaginary_Jump_Rope-WARM_UP',
      description:
        '1. Stand with your feet roughly shoulder-width apart. Keep your chest up and core tight. Arms are at your sides and fists are by your hips as if you were holding a jump rope.\n2. Keeping your elbows close to your sides, circle your wrists back and then forward.\n3. Hop up in the air with both feet when your wrists are in front of your hips. Land soft and repeat in a continuous rhythm.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1012,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '894766bc248afdfcce6c7163a70000cb9071df3427f402a5bdf52c96b37a2b3a',
          file_name:
            'videos/894766bc248afdfcce6c7163a70000cb9071df3427f402a5bdf52c96b37a2b3a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/894766bc248afdfcce6c7163a70000cb9071df3427f402a5bdf52c96b37a2b3a.mp4',
          name: 'BEG-INT-ADV-Imaginary_Jump_Rope-WARM_UP.mp4',
          description: null,
          size: 1010429,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1013,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '71ad67d8223f3aaa25b7c2e3ccc146698ca131b8220494edcd0616ddcb2689d3',
          file_name:
            'audios/71ad67d8223f3aaa25b7c2e3ccc146698ca131b8220494edcd0616ddcb2689d3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/71ad67d8223f3aaa25b7c2e3ccc146698ca131b8220494edcd0616ddcb2689d3.mp3',
          name: 'BEG-INT-ADV-Imaginary_Jump_Rope-WARM_UP.mp3',
          description: null,
          size: 24946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Imaginary_Jump_Rope-WARM_UP': {
      id: 497,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Imaginary Jump Rope',
      short_name: 'Imaginary Jump Rope',
      unique_name: 'INTERMEDIATE-Imaginary_Jump_Rope-WARM_UP',
      description:
        '1. Stand with your feet roughly shoulder-width apart. Keep your chest up and core tight. Arms are at your sides and fists are by your hips as if you were holding a jump rope.\n2. Keeping your elbows close to your sides, circle your wrists back and then forward.\n3. Hop up in the air with both feet when your wrists are in front of your hips. Land soft and repeat in a continuous rhythm.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1014,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '894766bc248afdfcce6c7163a70000cb9071df3427f402a5bdf52c96b37a2b3a',
          file_name:
            'videos/894766bc248afdfcce6c7163a70000cb9071df3427f402a5bdf52c96b37a2b3a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/894766bc248afdfcce6c7163a70000cb9071df3427f402a5bdf52c96b37a2b3a.mp4',
          name: 'BEG-INT-ADV-Imaginary_Jump_Rope-WARM_UP.mp4',
          description: null,
          size: 1010429,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1015,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '71ad67d8223f3aaa25b7c2e3ccc146698ca131b8220494edcd0616ddcb2689d3',
          file_name:
            'audios/71ad67d8223f3aaa25b7c2e3ccc146698ca131b8220494edcd0616ddcb2689d3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/71ad67d8223f3aaa25b7c2e3ccc146698ca131b8220494edcd0616ddcb2689d3.mp3',
          name: 'BEG-INT-ADV-Imaginary_Jump_Rope-WARM_UP.mp3',
          description: null,
          size: 24946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Imaginary_Jump_Rope-WARM_UP': {
      id: 498,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Imaginary Jump Rope',
      short_name: 'Imaginary Jump Rope',
      unique_name: 'ADVANCED-Imaginary_Jump_Rope-WARM_UP',
      description:
        '1. Stand with your feet roughly shoulder-width apart. Keep your chest up and core tight. Arms are at your sides and fists are by your hips as if you were holding a jump rope.\n2. Keeping your elbows close to your sides, circle your wrists back and then forward.\n3. Hop up in the air with both feet when your wrists are in front of your hips. Land soft and repeat in a continuous rhythm.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1016,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '894766bc248afdfcce6c7163a70000cb9071df3427f402a5bdf52c96b37a2b3a',
          file_name:
            'videos/894766bc248afdfcce6c7163a70000cb9071df3427f402a5bdf52c96b37a2b3a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/894766bc248afdfcce6c7163a70000cb9071df3427f402a5bdf52c96b37a2b3a.mp4',
          name: 'BEG-INT-ADV-Imaginary_Jump_Rope-WARM_UP.mp4',
          description: null,
          size: 1010429,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1017,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '71ad67d8223f3aaa25b7c2e3ccc146698ca131b8220494edcd0616ddcb2689d3',
          file_name:
            'audios/71ad67d8223f3aaa25b7c2e3ccc146698ca131b8220494edcd0616ddcb2689d3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/71ad67d8223f3aaa25b7c2e3ccc146698ca131b8220494edcd0616ddcb2689d3.mp3',
          name: 'BEG-INT-ADV-Imaginary_Jump_Rope-WARM_UP.mp3',
          description: null,
          size: 24946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Plank_to_Childs_Pose-WARM_UP': {
      id: 499,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: "Plank to Child's Pose",
      short_name: "Plank to Child's Pose",
      unique_name: 'BEGINNER-Plank_to_Childs_Pose-WARM_UP',
      description:
        "1. Start in Plank position, shoulders over wrists, long spine.\n2. Engage your core, bend your knees and push weight back until your hips rest close to your heels. Knees are out wide, arms are straight and chest rests in between your knees in Child's Pose.\n3. Using leg, core and shoulder strength, shift your weight forward and return to Plank.",
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1018,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '32b1ba248cabba8587d4798c1be3567ddc58aa80fb5eb922e8e0b1999e3bbea1',
          file_name:
            'videos/32b1ba248cabba8587d4798c1be3567ddc58aa80fb5eb922e8e0b1999e3bbea1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/32b1ba248cabba8587d4798c1be3567ddc58aa80fb5eb922e8e0b1999e3bbea1.mp4',
          name: 'BEG-INT-ADV-Plank_to_Childs_Pose-WARM_UP.mp4',
          description: null,
          size: 831429,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1019,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '1654f0c02f99b80a715e6693c51e6296eb81cd4a06831f222e426227663ff6fb',
          file_name:
            'audios/1654f0c02f99b80a715e6693c51e6296eb81cd4a06831f222e426227663ff6fb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1654f0c02f99b80a715e6693c51e6296eb81cd4a06831f222e426227663ff6fb.mp3',
          name: 'BEG-INT-ADV-Plank_to_Childs_Pose-WARM_UP.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Plank_to_Childs_Pose-WARM_UP': {
      id: 500,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: "Plank to Child's Pose",
      short_name: "Plank to Child's Pose",
      unique_name: 'INTERMEDIATE-Plank_to_Childs_Pose-WARM_UP',
      description:
        "1. Start in Plank position, shoulders over wrists, long spine.\n2. Engage your core, bend your knees and push weight back until your hips rest close to your heels. Knees are out wide, arms are straight and chest rests in between your knees in Child's Pose.\n3. Using leg, core and shoulder strength, shift your weight forward and return to Plank.",
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1020,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '32b1ba248cabba8587d4798c1be3567ddc58aa80fb5eb922e8e0b1999e3bbea1',
          file_name:
            'videos/32b1ba248cabba8587d4798c1be3567ddc58aa80fb5eb922e8e0b1999e3bbea1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/32b1ba248cabba8587d4798c1be3567ddc58aa80fb5eb922e8e0b1999e3bbea1.mp4',
          name: 'BEG-INT-ADV-Plank_to_Childs_Pose-WARM_UP.mp4',
          description: null,
          size: 831429,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1021,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '1654f0c02f99b80a715e6693c51e6296eb81cd4a06831f222e426227663ff6fb',
          file_name:
            'audios/1654f0c02f99b80a715e6693c51e6296eb81cd4a06831f222e426227663ff6fb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1654f0c02f99b80a715e6693c51e6296eb81cd4a06831f222e426227663ff6fb.mp3',
          name: 'BEG-INT-ADV-Plank_to_Childs_Pose-WARM_UP.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Plank_to_Childs_Pose-WARM_UP': {
      id: 501,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: "Plank to Child's Pose",
      short_name: "Plank to Child's Pose",
      unique_name: 'ADVANCED-Plank_to_Childs_Pose-WARM_UP',
      description:
        "1. Start in Plank position, shoulders over wrists, long spine.\n2. Engage your core, bend your knees and push weight back until your hips rest close to your heels. Knees are out wide, arms are straight and chest rests in between your knees in Child's Pose.\n3. Using leg, core and shoulder strength, shift your weight forward and return to Plank.",
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1022,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '32b1ba248cabba8587d4798c1be3567ddc58aa80fb5eb922e8e0b1999e3bbea1',
          file_name:
            'videos/32b1ba248cabba8587d4798c1be3567ddc58aa80fb5eb922e8e0b1999e3bbea1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/32b1ba248cabba8587d4798c1be3567ddc58aa80fb5eb922e8e0b1999e3bbea1.mp4',
          name: 'BEG-INT-ADV-Plank_to_Childs_Pose-WARM_UP.mp4',
          description: null,
          size: 831429,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1023,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '1654f0c02f99b80a715e6693c51e6296eb81cd4a06831f222e426227663ff6fb',
          file_name:
            'audios/1654f0c02f99b80a715e6693c51e6296eb81cd4a06831f222e426227663ff6fb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1654f0c02f99b80a715e6693c51e6296eb81cd4a06831f222e426227663ff6fb.mp3',
          name: 'BEG-INT-ADV-Plank_to_Childs_Pose-WARM_UP.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Criss_Cross_Jacks-WARM_UP': {
      id: 502,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Criss Cross Jacks',
      short_name: 'Criss Cross Jacks',
      unique_name: 'BEGINNER-Criss_Cross_Jacks-WARM_UP',
      description:
        '1. Start standing with your feet together and arms by your sides.\n2. Jump up and land with your feet slightly wider than shoulder-width apart and open your arms out to a "T".\n3. Immediately jump your feet back to center and land with one foot crossed in front of the other as you cross your arms in front of your chest at shoulder height.\n4. Jump back out, legs and arms wide and repeat.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 900,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '9de12ab64c60829cc02968b01638718897e08d2208bfb0bbd9d186485e6a4c4b',
          file_name:
            'videos/9de12ab64c60829cc02968b01638718897e08d2208bfb0bbd9d186485e6a4c4b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9de12ab64c60829cc02968b01638718897e08d2208bfb0bbd9d186485e6a4c4b.mp4',
          name: 'BEG-INT-ADV-Criss_Cross_Jacks-WARM_UP.mp4',
          description: null,
          size: 1282572,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 901,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '18d20f9203990294126b1bd870421ccaea5010533cebf3fd4e25a152b393d5a9',
          file_name:
            'audios/18d20f9203990294126b1bd870421ccaea5010533cebf3fd4e25a152b393d5a9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/18d20f9203990294126b1bd870421ccaea5010533cebf3fd4e25a152b393d5a9.mp3',
          name: 'BEG-INT-ADV-Criss_Cross_Jacks-WARM_UP.mp3',
          description: null,
          size: 24316,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Criss_Cross_Jacks-WARM_UP': {
      id: 503,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Criss Cross Jacks',
      short_name: 'Criss Cross Jacks',
      unique_name: 'INTERMEDIATE-Criss_Cross_Jacks-WARM_UP',
      description:
        '1. Start standing with your feet together and arms by your sides.\n2. Jump up and land with your feet slightly wider than shoulder-width apart and open your arms out to a "T".\n3. Immediately jump your feet back to center and land with one foot crossed in front of the other as you cross your arms in front of your chest at shoulder height.\n4. Jump back out, legs and arms wide and repeat.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 902,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '9de12ab64c60829cc02968b01638718897e08d2208bfb0bbd9d186485e6a4c4b',
          file_name:
            'videos/9de12ab64c60829cc02968b01638718897e08d2208bfb0bbd9d186485e6a4c4b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9de12ab64c60829cc02968b01638718897e08d2208bfb0bbd9d186485e6a4c4b.mp4',
          name: 'BEG-INT-ADV-Criss_Cross_Jacks-WARM_UP.mp4',
          description: null,
          size: 1282572,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 903,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '18d20f9203990294126b1bd870421ccaea5010533cebf3fd4e25a152b393d5a9',
          file_name:
            'audios/18d20f9203990294126b1bd870421ccaea5010533cebf3fd4e25a152b393d5a9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/18d20f9203990294126b1bd870421ccaea5010533cebf3fd4e25a152b393d5a9.mp3',
          name: 'BEG-INT-ADV-Criss_Cross_Jacks-WARM_UP.mp3',
          description: null,
          size: 24316,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Criss_Cross_Jacks-WARM_UP': {
      id: 504,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Criss Cross Jacks',
      short_name: 'Criss Cross Jacks',
      unique_name: 'ADVANCED-Criss_Cross_Jacks-WARM_UP',
      description:
        '1. Start standing with your feet together and arms by your sides.\n2. Jump up and land with your feet slightly wider than shoulder-width apart and open your arms out to a "T".\n3. Immediately jump your feet back to center and land with one foot crossed in front of the other as you cross your arms in front of your chest at shoulder height.\n4. Jump back out, legs and arms wide and repeat.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 904,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '9de12ab64c60829cc02968b01638718897e08d2208bfb0bbd9d186485e6a4c4b',
          file_name:
            'videos/9de12ab64c60829cc02968b01638718897e08d2208bfb0bbd9d186485e6a4c4b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9de12ab64c60829cc02968b01638718897e08d2208bfb0bbd9d186485e6a4c4b.mp4',
          name: 'BEG-INT-ADV-Criss_Cross_Jacks-WARM_UP.mp4',
          description: null,
          size: 1282572,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 905,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '18d20f9203990294126b1bd870421ccaea5010533cebf3fd4e25a152b393d5a9',
          file_name:
            'audios/18d20f9203990294126b1bd870421ccaea5010533cebf3fd4e25a152b393d5a9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/18d20f9203990294126b1bd870421ccaea5010533cebf3fd4e25a152b393d5a9.mp3',
          name: 'BEG-INT-ADV-Criss_Cross_Jacks-WARM_UP.mp3',
          description: null,
          size: 24316,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Squat_to_Calf_Raise-WARM_UP': {
      id: 592,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Squat to Calf Raise',
      short_name: 'Squat to Calf Raise',
      unique_name: 'BEGINNER-Squat_to_Calf_Raise-WARM_UP',
      description:
        '1. Start standing with your feet roughly shoulder-width apart.\n2. Keeping your chest up, drive your hips back and bend your knees to squat down as low as you can.\n3. Drive through your heels to stand and raise up onto the balls of your feet.\n4. Pause for a beat and lower your feet back down to start position.',
      preview_time: null,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1291,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '202dd26f5893f420d0df74bd91b4ad58bf63843b3f4469bc68c10dcd0fe1289a',
          file_name:
            'videos/202dd26f5893f420d0df74bd91b4ad58bf63843b3f4469bc68c10dcd0fe1289a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/202dd26f5893f420d0df74bd91b4ad58bf63843b3f4469bc68c10dcd0fe1289a.mp4',
          name: 'BEG-INT-ADV-Squat_to_Calf_Raise-WARM_UP.mp4',
          description: null,
          size: 704808,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1292,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '3df8ea12bba51c24409fff8bb838c7dcf3b421181bd5bfb119729f78421e1dae',
          file_name:
            'audios/3df8ea12bba51c24409fff8bb838c7dcf3b421181bd5bfb119729f78421e1dae.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3df8ea12bba51c24409fff8bb838c7dcf3b421181bd5bfb119729f78421e1dae.mp3',
          name: 'BEG-INT-ADV-Squat_to_Calf_Raise-WARM_UP.mp3',
          description: null,
          size: 28080,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Squat_to_Calf_Raise-WARM_UP': {
      id: 593,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Squat to Calf Raise',
      short_name: 'Squat to Calf Raise',
      unique_name: 'INTERMEDIATE-Squat_to_Calf_Raise-WARM_UP',
      description:
        '1. Start standing with your feet roughly shoulder-width apart.\n2. Keeping your chest up, drive your hips back and bend your knees to squat down as low as you can.\n3. Drive through your heels to stand and raise up onto the balls of your feet.\n4. Pause for a beat and lower your feet back down to start position.',
      preview_time: null,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1293,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '202dd26f5893f420d0df74bd91b4ad58bf63843b3f4469bc68c10dcd0fe1289a',
          file_name:
            'videos/202dd26f5893f420d0df74bd91b4ad58bf63843b3f4469bc68c10dcd0fe1289a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/202dd26f5893f420d0df74bd91b4ad58bf63843b3f4469bc68c10dcd0fe1289a.mp4',
          name: 'BEG-INT-ADV-Squat_to_Calf_Raise-WARM_UP.mp4',
          description: null,
          size: 704808,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1294,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '3df8ea12bba51c24409fff8bb838c7dcf3b421181bd5bfb119729f78421e1dae',
          file_name:
            'audios/3df8ea12bba51c24409fff8bb838c7dcf3b421181bd5bfb119729f78421e1dae.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3df8ea12bba51c24409fff8bb838c7dcf3b421181bd5bfb119729f78421e1dae.mp3',
          name: 'BEG-INT-ADV-Squat_to_Calf_Raise-WARM_UP.mp3',
          description: null,
          size: 28080,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Squat_to_Calf_Raise-WARM_UP': {
      id: 594,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Squat to Calf Raise',
      short_name: 'Squat to Calf Raise',
      unique_name: 'ADVANCED-Squat_to_Calf_Raise-WARM_UP',
      description:
        '1. Start standing with your feet roughly shoulder-width apart.\n2. Keeping your chest up, drive your hips back and bend your knees to squat down as low as you can.\n3. Drive through your heels to stand and raise up onto the balls of your feet.\n4. Pause for a beat and lower your feet back down to start position.',
      preview_time: null,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1295,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '202dd26f5893f420d0df74bd91b4ad58bf63843b3f4469bc68c10dcd0fe1289a',
          file_name:
            'videos/202dd26f5893f420d0df74bd91b4ad58bf63843b3f4469bc68c10dcd0fe1289a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/202dd26f5893f420d0df74bd91b4ad58bf63843b3f4469bc68c10dcd0fe1289a.mp4',
          name: 'BEG-INT-ADV-Squat_to_Calf_Raise-WARM_UP.mp4',
          description: null,
          size: 704808,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1296,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '3df8ea12bba51c24409fff8bb838c7dcf3b421181bd5bfb119729f78421e1dae',
          file_name:
            'audios/3df8ea12bba51c24409fff8bb838c7dcf3b421181bd5bfb119729f78421e1dae.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3df8ea12bba51c24409fff8bb838c7dcf3b421181bd5bfb119729f78421e1dae.mp3',
          name: 'BEG-INT-ADV-Squat_to_Calf_Raise-WARM_UP.mp3',
          description: null,
          size: 28080,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating_Standing_Crunches-WARM_UP': {
      id: 595,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Alternating Standing Crunches',
      short_name: 'Alternating Standing Crunches',
      unique_name: 'BEGINNER-Alternating_Standing_Crunches-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart and your arms up overhead, elbows bent by your ears, fists facing behind you.\n2. Engage your core and raise one knee up to hip height as you hollow out your body and bring both elbows down toward your knee. Crunch and hold for a beat.\n3. Return to start position and repeat on the other side. Right and left equals one rep.',
      preview_time: null,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1166,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '10a3230b5253558a649058099d3f1018689aa124f02e91d162946a6ac39cfcd8',
          file_name:
            'videos/10a3230b5253558a649058099d3f1018689aa124f02e91d162946a6ac39cfcd8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/10a3230b5253558a649058099d3f1018689aa124f02e91d162946a6ac39cfcd8.mp4',
          name: 'BEG-INT-ADV-Alternating_Standing_Crunches-WARM_UP.mp4',
          description: null,
          size: 1118489,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1167,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '8da2d02f6ff65eed6e7f30d0e57e46cab2b1b5c199c95e97ede4c1e2a6f23866',
          file_name:
            'audios/8da2d02f6ff65eed6e7f30d0e57e46cab2b1b5c199c95e97ede4c1e2a6f23866.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8da2d02f6ff65eed6e7f30d0e57e46cab2b1b5c199c95e97ede4c1e2a6f23866.mp3',
          name: 'BEG-INT-ADV-Alternating_Standing_Crunches-WARM_UP.mp3',
          description: null,
          size: 32469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Alternating_Standing_Crunches-WARM_UP': {
      id: 596,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Alternating Standing Crunches',
      short_name: 'Alternating Standing Crunches',
      unique_name: 'INTERMEDIATE-Alternating_Standing_Crunches-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart and your arms up overhead, elbows bent by your ears, fists facing behind you.\n2. Engage your core and raise one knee up to hip height as you hollow out your body and bring both elbows down toward your knee. Crunch and hold for a beat.\n3. Return to start position and repeat on the other side. Right and left equals one rep.',
      preview_time: null,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1168,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '10a3230b5253558a649058099d3f1018689aa124f02e91d162946a6ac39cfcd8',
          file_name:
            'videos/10a3230b5253558a649058099d3f1018689aa124f02e91d162946a6ac39cfcd8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/10a3230b5253558a649058099d3f1018689aa124f02e91d162946a6ac39cfcd8.mp4',
          name: 'BEG-INT-ADV-Alternating_Standing_Crunches-WARM_UP.mp4',
          description: null,
          size: 1118489,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1169,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '8da2d02f6ff65eed6e7f30d0e57e46cab2b1b5c199c95e97ede4c1e2a6f23866',
          file_name:
            'audios/8da2d02f6ff65eed6e7f30d0e57e46cab2b1b5c199c95e97ede4c1e2a6f23866.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8da2d02f6ff65eed6e7f30d0e57e46cab2b1b5c199c95e97ede4c1e2a6f23866.mp3',
          name: 'BEG-INT-ADV-Alternating_Standing_Crunches-WARM_UP.mp3',
          description: null,
          size: 32469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Alternating_Standing_Crunches-WARM_UP': {
      id: 597,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Alternating Standing Crunches',
      short_name: 'Alternating Standing Crunches',
      unique_name: 'ADVANCED-Alternating_Standing_Crunches-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart and your arms up overhead, elbows bent by your ears, fists facing behind you.\n2. Engage your core and raise one knee up to hip height as you hollow out your body and bring both elbows down toward your knee. Crunch and hold for a beat.\n3. Return to start position and repeat on the other side. Right and left equals one rep.',
      preview_time: null,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1170,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '10a3230b5253558a649058099d3f1018689aa124f02e91d162946a6ac39cfcd8',
          file_name:
            'videos/10a3230b5253558a649058099d3f1018689aa124f02e91d162946a6ac39cfcd8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/10a3230b5253558a649058099d3f1018689aa124f02e91d162946a6ac39cfcd8.mp4',
          name: 'BEG-INT-ADV-Alternating_Standing_Crunches-WARM_UP.mp4',
          description: null,
          size: 1118489,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1171,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '8da2d02f6ff65eed6e7f30d0e57e46cab2b1b5c199c95e97ede4c1e2a6f23866',
          file_name:
            'audios/8da2d02f6ff65eed6e7f30d0e57e46cab2b1b5c199c95e97ede4c1e2a6f23866.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8da2d02f6ff65eed6e7f30d0e57e46cab2b1b5c199c95e97ede4c1e2a6f23866.mp3',
          name: 'BEG-INT-ADV-Alternating_Standing_Crunches-WARM_UP.mp3',
          description: null,
          size: 32469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CROSS_BODY_PUNCHES-WARM_UP': {
      id: 647,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Cross Body Punches',
      short_name: 'Cross Body Punches',
      unique_name: 'BEGINNER-CROSS_BODY_PUNCHES-WARM_UP',
      description:
        '1. Stand with feet wider than hip-width apart; soft bend in both knees. Bring fists up to protect your face, elbows in tight to your body.\n2. Punch one arm across your body, wrist down and rotate your shoulders and hips in the same direction. Pivot on the base foot.\n3. Recoil back to start and repeat other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1446,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '1e4a88d300fca7e2d3d021b4f75b8487dec3b45574d8b59e5fa07addf6add1df',
          file_name:
            'videos/1e4a88d300fca7e2d3d021b4f75b8487dec3b45574d8b59e5fa07addf6add1df.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1e4a88d300fca7e2d3d021b4f75b8487dec3b45574d8b59e5fa07addf6add1df.mp4',
          name: 'BEG-INT-ADV-Cross_Body_Punches-WARM_UP.mp4',
          description: null,
          size: 1089971,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1447,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '0837952e5f71ba2577f48cbba1d7743d3da8feebaf81d30eb2d020b85b0743c8',
          file_name:
            'audios/0837952e5f71ba2577f48cbba1d7743d3da8feebaf81d30eb2d020b85b0743c8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0837952e5f71ba2577f48cbba1d7743d3da8feebaf81d30eb2d020b85b0743c8.mp3',
          name: 'BEG-INT-ADV-Cross_Body_Punches-WARM_UP.mp3',
          description: null,
          size: 26200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-CROSS_BODY_PUNCHES-WARM_UP': {
      id: 648,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Cross Body Punches',
      short_name: 'Cross Body Punches',
      unique_name: 'INTERMEDIATE-CROSS_BODY_PUNCHES-WARM_UP',
      description:
        '1. Stand with feet wider than hip-width apart; soft bend in both knees. Bring fists up to protect your face, elbows in tight to your body.\n2. Punch one arm across your body, wrist down and rotate your shoulders and hips in the same direction. Pivot on the base foot.\n3. Recoil back to start and repeat other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1448,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '1e4a88d300fca7e2d3d021b4f75b8487dec3b45574d8b59e5fa07addf6add1df',
          file_name:
            'videos/1e4a88d300fca7e2d3d021b4f75b8487dec3b45574d8b59e5fa07addf6add1df.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1e4a88d300fca7e2d3d021b4f75b8487dec3b45574d8b59e5fa07addf6add1df.mp4',
          name: 'BEG-INT-ADV-Cross_Body_Punches-WARM_UP.mp4',
          description: null,
          size: 1089971,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1449,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '0837952e5f71ba2577f48cbba1d7743d3da8feebaf81d30eb2d020b85b0743c8',
          file_name:
            'audios/0837952e5f71ba2577f48cbba1d7743d3da8feebaf81d30eb2d020b85b0743c8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0837952e5f71ba2577f48cbba1d7743d3da8feebaf81d30eb2d020b85b0743c8.mp3',
          name: 'BEG-INT-ADV-Cross_Body_Punches-WARM_UP.mp3',
          description: null,
          size: 26200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-CROSS_BODY_PUNCHES-WARM_UP': {
      id: 649,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Cross Body Punches',
      short_name: 'Cross Body Punches',
      unique_name: 'ADVANCED-CROSS_BODY_PUNCHES-WARM_UP',
      description:
        '1. Stand with feet wider than hip-width apart; soft bend in both knees. Bring fists up to protect your face, elbows in tight to your body.\n2. Punch one arm across your body, wrist down and rotate your shoulders and hips in the same direction. Pivot on the base foot.\n3. Recoil back to start and repeat other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1450,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '1e4a88d300fca7e2d3d021b4f75b8487dec3b45574d8b59e5fa07addf6add1df',
          file_name:
            'videos/1e4a88d300fca7e2d3d021b4f75b8487dec3b45574d8b59e5fa07addf6add1df.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1e4a88d300fca7e2d3d021b4f75b8487dec3b45574d8b59e5fa07addf6add1df.mp4',
          name: 'BEG-INT-ADV-Cross_Body_Punches-WARM_UP.mp4',
          description: null,
          size: 1089971,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1451,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '0837952e5f71ba2577f48cbba1d7743d3da8feebaf81d30eb2d020b85b0743c8',
          file_name:
            'audios/0837952e5f71ba2577f48cbba1d7743d3da8feebaf81d30eb2d020b85b0743c8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0837952e5f71ba2577f48cbba1d7743d3da8feebaf81d30eb2d020b85b0743c8.mp3',
          name: 'BEG-INT-ADV-Cross_Body_Punches-WARM_UP.mp3',
          description: null,
          size: 26200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-HEISMANS-WARM_UP': {
      id: 650,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Heismans',
      short_name: 'Heismans',
      unique_name: 'BEGINNER-HEISMANS-WARM_UP',
      description:
        '1. Stand tall with your feet about shoulder-width apart.\n2. Take three athletic high knee steps/jogs to the side while pumping your arms. Make sure to drive your knees up to hip height and keep core engaged.\n3. On the third step, balance on the standing leg, keeping your knee up.\n4. Pause for a beat before repeating in the opposite direction.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1452,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '5d0b8c13a2037602b34c8861385bce544112d5d9329b88fdd423f5535e4fb7bb',
          file_name:
            'videos/5d0b8c13a2037602b34c8861385bce544112d5d9329b88fdd423f5535e4fb7bb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5d0b8c13a2037602b34c8861385bce544112d5d9329b88fdd423f5535e4fb7bb.mp4',
          name: 'BEG-INT-ADV-Heismans-WARM_UP.mp4',
          description: null,
          size: 1552600,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1453,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '8d0d000ff3084353db8619a8ceea267a5286ef7e916a472af34dd7a5e386c297',
          file_name:
            'audios/8d0d000ff3084353db8619a8ceea267a5286ef7e916a472af34dd7a5e386c297.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8d0d000ff3084353db8619a8ceea267a5286ef7e916a472af34dd7a5e386c297.mp3',
          name: 'BEG-INT-ADV-Heismans-WARM_UP.mp3',
          description: null,
          size: 18049,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-HEISMANS-WARM_UP': {
      id: 651,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Heismans',
      short_name: 'Heismans',
      unique_name: 'INTERMEDIATE-HEISMANS-WARM_UP',
      description:
        '1. Stand tall with your feet about shoulder-width apart.\n2. Take three athletic high knee steps/jogs to the side while pumping your arms. Make sure to drive your knees up to hip height and keep core engaged.\n3. On the third step, balance on the standing leg, keeping your knee up.\n4. Pause for a beat before repeating in the opposite direction.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1454,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '5d0b8c13a2037602b34c8861385bce544112d5d9329b88fdd423f5535e4fb7bb',
          file_name:
            'videos/5d0b8c13a2037602b34c8861385bce544112d5d9329b88fdd423f5535e4fb7bb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5d0b8c13a2037602b34c8861385bce544112d5d9329b88fdd423f5535e4fb7bb.mp4',
          name: 'BEG-INT-ADV-Heismans-WARM_UP.mp4',
          description: null,
          size: 1552600,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1455,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '8d0d000ff3084353db8619a8ceea267a5286ef7e916a472af34dd7a5e386c297',
          file_name:
            'audios/8d0d000ff3084353db8619a8ceea267a5286ef7e916a472af34dd7a5e386c297.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8d0d000ff3084353db8619a8ceea267a5286ef7e916a472af34dd7a5e386c297.mp3',
          name: 'BEG-INT-ADV-Heismans-WARM_UP.mp3',
          description: null,
          size: 18049,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-HEISMANS-WARM_UP': {
      id: 652,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Heismans',
      short_name: 'Heismans',
      unique_name: 'ADVANCED-HEISMANS-WARM_UP',
      description:
        '1. Stand tall with your feet about shoulder-width apart.\n2. Take three athletic high knee steps/jogs to the side while pumping your arms. Make sure to drive your knees up to hip height and keep core engaged.\n3. On the third step, balance on the standing leg, keeping your knee up.\n4. Pause for a beat before repeating in the opposite direction.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1456,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '5d0b8c13a2037602b34c8861385bce544112d5d9329b88fdd423f5535e4fb7bb',
          file_name:
            'videos/5d0b8c13a2037602b34c8861385bce544112d5d9329b88fdd423f5535e4fb7bb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5d0b8c13a2037602b34c8861385bce544112d5d9329b88fdd423f5535e4fb7bb.mp4',
          name: 'BEG-INT-ADV-Heismans-WARM_UP.mp4',
          description: null,
          size: 1552600,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1457,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '8d0d000ff3084353db8619a8ceea267a5286ef7e916a472af34dd7a5e386c297',
          file_name:
            'audios/8d0d000ff3084353db8619a8ceea267a5286ef7e916a472af34dd7a5e386c297.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8d0d000ff3084353db8619a8ceea267a5286ef7e916a472af34dd7a5e386c297.mp3',
          name: 'BEG-INT-ADV-Heismans-WARM_UP.mp3',
          description: null,
          size: 18049,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-HIGH_KNEE_MARCH-WARM_UP': {
      id: 653,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'High Knee March',
      short_name: 'High Knee March',
      unique_name: 'BEGINNER-HIGH_KNEE_MARCH-WARM_UP',
      description:
        '1. Stand tall and march in place bringing your knees up to hip-height.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1458,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '27434a0359d9d79dcfc1bd4a08de57af32762ed332d54d5e335bc0cfc46301e2',
          file_name:
            'videos/27434a0359d9d79dcfc1bd4a08de57af32762ed332d54d5e335bc0cfc46301e2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/27434a0359d9d79dcfc1bd4a08de57af32762ed332d54d5e335bc0cfc46301e2.mp4',
          name: 'BEG-INT-ADV-High_Knee_March-WARM_UP.mp4',
          description: null,
          size: 840378,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1459,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '72b59ffcad867368feafcf2b56aba796d2a5b6a0d70779e3b1ac35ef1713a23b',
          file_name:
            'audios/72b59ffcad867368feafcf2b56aba796d2a5b6a0d70779e3b1ac35ef1713a23b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/72b59ffcad867368feafcf2b56aba796d2a5b6a0d70779e3b1ac35ef1713a23b.mp3',
          name: 'BEG-INT-ADV-High_Knee_March-WARM_UP.mp3',
          description: null,
          size: 23065,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-HIGH_KNEE_MARCH-WARM_UP': {
      id: 654,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'High Knee March',
      short_name: 'High Knee March',
      unique_name: 'INTERMEDIATE-HIGH_KNEE_MARCH-WARM_UP',
      description:
        '1. Stand tall and march in place bringing your knees up to hip-height.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1460,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '27434a0359d9d79dcfc1bd4a08de57af32762ed332d54d5e335bc0cfc46301e2',
          file_name:
            'videos/27434a0359d9d79dcfc1bd4a08de57af32762ed332d54d5e335bc0cfc46301e2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/27434a0359d9d79dcfc1bd4a08de57af32762ed332d54d5e335bc0cfc46301e2.mp4',
          name: 'BEG-INT-ADV-High_Knee_March-WARM_UP.mp4',
          description: null,
          size: 840378,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1461,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '72b59ffcad867368feafcf2b56aba796d2a5b6a0d70779e3b1ac35ef1713a23b',
          file_name:
            'audios/72b59ffcad867368feafcf2b56aba796d2a5b6a0d70779e3b1ac35ef1713a23b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/72b59ffcad867368feafcf2b56aba796d2a5b6a0d70779e3b1ac35ef1713a23b.mp3',
          name: 'BEG-INT-ADV-High_Knee_March-WARM_UP.mp3',
          description: null,
          size: 23065,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-HIGH_KNEE_MARCH-WARM_UP': {
      id: 655,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'High Knee March',
      short_name: 'High Knee March',
      unique_name: 'ADVANCED-HIGH_KNEE_MARCH-WARM_UP',
      description:
        '1. Stand tall and march in place bringing your knees up to hip-height.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1462,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '27434a0359d9d79dcfc1bd4a08de57af32762ed332d54d5e335bc0cfc46301e2',
          file_name:
            'videos/27434a0359d9d79dcfc1bd4a08de57af32762ed332d54d5e335bc0cfc46301e2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/27434a0359d9d79dcfc1bd4a08de57af32762ed332d54d5e335bc0cfc46301e2.mp4',
          name: 'BEG-INT-ADV-High_Knee_March-WARM_UP.mp4',
          description: null,
          size: 840378,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1463,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '72b59ffcad867368feafcf2b56aba796d2a5b6a0d70779e3b1ac35ef1713a23b',
          file_name:
            'audios/72b59ffcad867368feafcf2b56aba796d2a5b6a0d70779e3b1ac35ef1713a23b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/72b59ffcad867368feafcf2b56aba796d2a5b6a0d70779e3b1ac35ef1713a23b.mp3',
          name: 'BEG-INT-ADV-High_Knee_March-WARM_UP.mp3',
          description: null,
          size: 23065,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-HIP_CIRCLES-WARM_UP': {
      id: 656,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Hip Circles',
      short_name: 'Hip Circles',
      unique_name: 'BEGINNER-HIP_CIRCLES-WARM_UP',
      description:
        '1. Stand with your feet about shoulder-width apart, hands on hips, knees soft.\n2. Keeping hips and shoulders square, engage your core and draw large circles with your hips in one direction.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1464,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'cde0a55a1b4fa392babc38dc860a46344ed018e07ece3f0b82c6a5344cabcb67',
          file_name:
            'videos/cde0a55a1b4fa392babc38dc860a46344ed018e07ece3f0b82c6a5344cabcb67.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cde0a55a1b4fa392babc38dc860a46344ed018e07ece3f0b82c6a5344cabcb67.mp4',
          name: 'BEG-INT-ADV-Hip_Circles-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 468270,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1465,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '4cd013ca9dde7335c42ce8db3bd5d6dd5e29e41685a6744d405e2d22a49e88a3',
          file_name:
            'videos/4cd013ca9dde7335c42ce8db3bd5d6dd5e29e41685a6744d405e2d22a49e88a3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4cd013ca9dde7335c42ce8db3bd5d6dd5e29e41685a6744d405e2d22a49e88a3.mp4',
          name: 'BEG-INT-ADV-Hip_Circles-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 472973,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1466,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '3d25b64b2f54df22bc988d58933b73a4ce4fc232e5708b329759a31d06890cb7',
          file_name:
            'audios/3d25b64b2f54df22bc988d58933b73a4ce4fc232e5708b329759a31d06890cb7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3d25b64b2f54df22bc988d58933b73a4ce4fc232e5708b329759a31d06890cb7.mp3',
          name: 'BEG-INT-ADV-Hip_Circles-WARM_UP.mp3',
          description: null,
          size: 20244,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-HIP_CIRCLES-WARM_UP': {
      id: 657,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Hip Circles',
      short_name: 'Hip Circles',
      unique_name: 'INTERMEDIATE-HIP_CIRCLES-WARM_UP',
      description:
        '1. Stand with your feet about shoulder-width apart, hands on hips, knees soft.\n2. Keeping hips and shoulders square, engage your core and draw large circles with your hips in one direction.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1467,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'cde0a55a1b4fa392babc38dc860a46344ed018e07ece3f0b82c6a5344cabcb67',
          file_name:
            'videos/cde0a55a1b4fa392babc38dc860a46344ed018e07ece3f0b82c6a5344cabcb67.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cde0a55a1b4fa392babc38dc860a46344ed018e07ece3f0b82c6a5344cabcb67.mp4',
          name: 'BEG-INT-ADV-Hip_Circles-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 468270,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1468,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '4cd013ca9dde7335c42ce8db3bd5d6dd5e29e41685a6744d405e2d22a49e88a3',
          file_name:
            'videos/4cd013ca9dde7335c42ce8db3bd5d6dd5e29e41685a6744d405e2d22a49e88a3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4cd013ca9dde7335c42ce8db3bd5d6dd5e29e41685a6744d405e2d22a49e88a3.mp4',
          name: 'BEG-INT-ADV-Hip_Circles-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 472973,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1469,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '3d25b64b2f54df22bc988d58933b73a4ce4fc232e5708b329759a31d06890cb7',
          file_name:
            'audios/3d25b64b2f54df22bc988d58933b73a4ce4fc232e5708b329759a31d06890cb7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3d25b64b2f54df22bc988d58933b73a4ce4fc232e5708b329759a31d06890cb7.mp3',
          name: 'BEG-INT-ADV-Hip_Circles-WARM_UP.mp3',
          description: null,
          size: 20244,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-HIP_CIRCLES-WARM_UP': {
      id: 658,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Hip Circles',
      short_name: 'Hip Circles',
      unique_name: 'ADVANCED-HIP_CIRCLES-WARM_UP',
      description:
        '1. Stand with your feet about shoulder-width apart, hands on hips, knees soft.\n2. Keeping hips and shoulders square, engage your core and draw large circles with your hips in one direction.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1470,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'cde0a55a1b4fa392babc38dc860a46344ed018e07ece3f0b82c6a5344cabcb67',
          file_name:
            'videos/cde0a55a1b4fa392babc38dc860a46344ed018e07ece3f0b82c6a5344cabcb67.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cde0a55a1b4fa392babc38dc860a46344ed018e07ece3f0b82c6a5344cabcb67.mp4',
          name: 'BEG-INT-ADV-Hip_Circles-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 468270,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1471,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '4cd013ca9dde7335c42ce8db3bd5d6dd5e29e41685a6744d405e2d22a49e88a3',
          file_name:
            'videos/4cd013ca9dde7335c42ce8db3bd5d6dd5e29e41685a6744d405e2d22a49e88a3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4cd013ca9dde7335c42ce8db3bd5d6dd5e29e41685a6744d405e2d22a49e88a3.mp4',
          name: 'BEG-INT-ADV-Hip_Circles-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 472973,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1472,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '3d25b64b2f54df22bc988d58933b73a4ce4fc232e5708b329759a31d06890cb7',
          file_name:
            'audios/3d25b64b2f54df22bc988d58933b73a4ce4fc232e5708b329759a31d06890cb7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3d25b64b2f54df22bc988d58933b73a4ce4fc232e5708b329759a31d06890cb7.mp3',
          name: 'BEG-INT-ADV-Hip_Circles-WARM_UP.mp3',
          description: null,
          size: 20244,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-MODIFIED_WINDSHIELD_WIPERS-WARM_UP': {
      id: 659,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Modified Windshield Wipers',
      short_name: 'Modified Windshield Wipers',
      unique_name: 'BEGINNER-MODIFIED_WINDSHIELD_WIPERS-WARM_UP',
      description:
        '1. Stand with your feet about shoulder-width apart, hands on hips, knees soft.\n2. Keeping hips and shoulders square, engage your core and draw large circles with your hips in one direction.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1473,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '23d6fd44f5fd8c70527d583f27741c547b5c0859bc6561a47150c52b5464a410',
          file_name:
            'videos/23d6fd44f5fd8c70527d583f27741c547b5c0859bc6561a47150c52b5464a410.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/23d6fd44f5fd8c70527d583f27741c547b5c0859bc6561a47150c52b5464a410.mp4',
          name: 'BEG-INT-ADV-Modified_Windshield_Wipers-WARM_UP.mp4',
          description: null,
          size: 669874,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1474,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '5410f8274327d22a12adec945349a9cf9d5843aef9dc430c993450a3803fa2b4',
          file_name:
            'audios/5410f8274327d22a12adec945349a9cf9d5843aef9dc430c993450a3803fa2b4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5410f8274327d22a12adec945349a9cf9d5843aef9dc430c993450a3803fa2b4.mp3',
          name: 'BEG-INT-ADV-Modified_Windshield_Wipers-WARM_UP.mp3',
          description: null,
          size: 31529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MODIFIED_WINDSHIELD_WIPERS-WARM_UP': {
      id: 660,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Modified Windshield Wipers',
      short_name: 'Modified Windshield Wipers',
      unique_name: 'INTERMEDIATE-MODIFIED_WINDSHIELD_WIPERS-WARM_UP',
      description:
        '1. Stand with your feet about shoulder-width apart, hands on hips, knees soft.\n2. Keeping hips and shoulders square, engage your core and draw large circles with your hips in one direction.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1475,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '23d6fd44f5fd8c70527d583f27741c547b5c0859bc6561a47150c52b5464a410',
          file_name:
            'videos/23d6fd44f5fd8c70527d583f27741c547b5c0859bc6561a47150c52b5464a410.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/23d6fd44f5fd8c70527d583f27741c547b5c0859bc6561a47150c52b5464a410.mp4',
          name: 'BEG-INT-ADV-Modified_Windshield_Wipers-WARM_UP.mp4',
          description: null,
          size: 669874,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1476,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '5410f8274327d22a12adec945349a9cf9d5843aef9dc430c993450a3803fa2b4',
          file_name:
            'audios/5410f8274327d22a12adec945349a9cf9d5843aef9dc430c993450a3803fa2b4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5410f8274327d22a12adec945349a9cf9d5843aef9dc430c993450a3803fa2b4.mp3',
          name: 'BEG-INT-ADV-Modified_Windshield_Wipers-WARM_UP.mp3',
          description: null,
          size: 31529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MODIFIED_WINDSHIELD_WIPERS-WARM_UP': {
      id: 661,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Modified Windshield Wipers',
      short_name: 'Modified Windshield Wipers',
      unique_name: 'ADVANCED-MODIFIED_WINDSHIELD_WIPERS-WARM_UP',
      description:
        '1. Stand with your feet about shoulder-width apart, hands on hips, knees soft.\n2. Keeping hips and shoulders square, engage your core and draw large circles with your hips in one direction.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1477,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '23d6fd44f5fd8c70527d583f27741c547b5c0859bc6561a47150c52b5464a410',
          file_name:
            'videos/23d6fd44f5fd8c70527d583f27741c547b5c0859bc6561a47150c52b5464a410.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/23d6fd44f5fd8c70527d583f27741c547b5c0859bc6561a47150c52b5464a410.mp4',
          name: 'BEG-INT-ADV-Modified_Windshield_Wipers-WARM_UP.mp4',
          description: null,
          size: 669874,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1478,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '5410f8274327d22a12adec945349a9cf9d5843aef9dc430c993450a3803fa2b4',
          file_name:
            'audios/5410f8274327d22a12adec945349a9cf9d5843aef9dc430c993450a3803fa2b4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5410f8274327d22a12adec945349a9cf9d5843aef9dc430c993450a3803fa2b4.mp3',
          name: 'BEG-INT-ADV-Modified_Windshield_Wipers-WARM_UP.mp3',
          description: null,
          size: 31529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SPRINTERS_START-WARM_UP': {
      id: 662,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Sprinters Start',
      short_name: 'Sprinters Start',
      unique_name: 'BEGINNER-SPRINTERS_START-WARM_UP',
      description:
        '1. Stand with feet hip-width apart. Take a big step forward with one leg, bend both knees and hover back knee off the floor. Lean over your quad and place fingertips on either side of your foot.\n2. Straighten both legs and raise hips toward ceiling. Keep fingertips on floor.\n3. Pause for a beat and bend knees to return to start.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1479,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'bf4ede07de1d692d8484e93690c2a6252b79d42258c6fb6086be2e6b10c7c952',
          file_name:
            'videos/bf4ede07de1d692d8484e93690c2a6252b79d42258c6fb6086be2e6b10c7c952.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf4ede07de1d692d8484e93690c2a6252b79d42258c6fb6086be2e6b10c7c952.mp4',
          name: 'BEG-INT-ADV-Sprinters_Start-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 365804,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1480,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '5254cf949746e216eba23d400b3ebc648b3980d84de427e6033ea27461ebab4e',
          file_name:
            'videos/5254cf949746e216eba23d400b3ebc648b3980d84de427e6033ea27461ebab4e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5254cf949746e216eba23d400b3ebc648b3980d84de427e6033ea27461ebab4e.mp4',
          name: 'BEG-INT-ADV-Sprinters_Start-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 377701,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1481,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '43c4cbc2ed0a221a295fa15419ad84fd264188c2fc3902873aff3ce64babec0e',
          file_name:
            'audios/43c4cbc2ed0a221a295fa15419ad84fd264188c2fc3902873aff3ce64babec0e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/43c4cbc2ed0a221a295fa15419ad84fd264188c2fc3902873aff3ce64babec0e.mp3',
          name: 'BEG-INT-ADV-Sprinters_Start-WARM_UP.mp3',
          description: null,
          size: 24319,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SPRINTERS_START-WARM_UP': {
      id: 663,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Sprinters Start',
      short_name: 'Sprinters Start',
      unique_name: 'INTERMEDIATE-SPRINTERS_START-WARM_UP',
      description:
        '1. Stand with feet hip-width apart. Take a big step forward with one leg, bend both knees and hover back knee off the floor. Lean over your quad and place fingertips on either side of your foot.\n2. Straighten both legs and raise hips toward ceiling. Keep fingertips on floor.\n3. Pause for a beat and bend knees to return to start.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1482,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'bf4ede07de1d692d8484e93690c2a6252b79d42258c6fb6086be2e6b10c7c952',
          file_name:
            'videos/bf4ede07de1d692d8484e93690c2a6252b79d42258c6fb6086be2e6b10c7c952.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf4ede07de1d692d8484e93690c2a6252b79d42258c6fb6086be2e6b10c7c952.mp4',
          name: 'BEG-INT-ADV-Sprinters_Start-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 365804,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1483,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '5254cf949746e216eba23d400b3ebc648b3980d84de427e6033ea27461ebab4e',
          file_name:
            'videos/5254cf949746e216eba23d400b3ebc648b3980d84de427e6033ea27461ebab4e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5254cf949746e216eba23d400b3ebc648b3980d84de427e6033ea27461ebab4e.mp4',
          name: 'BEG-INT-ADV-Sprinters_Start-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 377701,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1484,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '43c4cbc2ed0a221a295fa15419ad84fd264188c2fc3902873aff3ce64babec0e',
          file_name:
            'audios/43c4cbc2ed0a221a295fa15419ad84fd264188c2fc3902873aff3ce64babec0e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/43c4cbc2ed0a221a295fa15419ad84fd264188c2fc3902873aff3ce64babec0e.mp3',
          name: 'BEG-INT-ADV-Sprinters_Start-WARM_UP.mp3',
          description: null,
          size: 24319,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SPRINTERS_START-WARM_UP': {
      id: 664,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Sprinters Start',
      short_name: 'Sprinters Start',
      unique_name: 'ADVANCED-SPRINTERS_START-WARM_UP',
      description:
        '1. Stand with feet hip-width apart. Take a big step forward with one leg, bend both knees and hover back knee off the floor. Lean over your quad and place fingertips on either side of your foot.\n2. Straighten both legs and raise hips toward ceiling. Keep fingertips on floor.\n3. Pause for a beat and bend knees to return to start.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1485,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'bf4ede07de1d692d8484e93690c2a6252b79d42258c6fb6086be2e6b10c7c952',
          file_name:
            'videos/bf4ede07de1d692d8484e93690c2a6252b79d42258c6fb6086be2e6b10c7c952.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf4ede07de1d692d8484e93690c2a6252b79d42258c6fb6086be2e6b10c7c952.mp4',
          name: 'BEG-INT-ADV-Sprinters_Start-WARM_UP-RIGHT.mp4',
          description: 'Right Side',
          size: 365804,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1486,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '5254cf949746e216eba23d400b3ebc648b3980d84de427e6033ea27461ebab4e',
          file_name:
            'videos/5254cf949746e216eba23d400b3ebc648b3980d84de427e6033ea27461ebab4e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5254cf949746e216eba23d400b3ebc648b3980d84de427e6033ea27461ebab4e.mp4',
          name: 'BEG-INT-ADV-Sprinters_Start-WARM_UP-LEFT.mp4',
          description: 'Left Side',
          size: 377701,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1487,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '43c4cbc2ed0a221a295fa15419ad84fd264188c2fc3902873aff3ce64babec0e',
          file_name:
            'audios/43c4cbc2ed0a221a295fa15419ad84fd264188c2fc3902873aff3ce64babec0e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/43c4cbc2ed0a221a295fa15419ad84fd264188c2fc3902873aff3ce64babec0e.mp3',
          name: 'BEG-INT-ADV-Sprinters_Start-WARM_UP.mp3',
          description: null,
          size: 24319,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SUMO_SCISSORS-WARM_UP': {
      id: 665,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Sumo Scissors',
      short_name: 'Sumo Scissors',
      unique_name: 'BEGINNER-SUMO_SCISSORS-WARM_UP',
      description:
        '1. Stand with your feet together and elbows bent at 90 degrees by your sides.\n2. Jump up and perform 2 Scissor Feet, landing softly with one foot in front of the other. Take your arms with you as if you were running.\n3. After 2 Scissors, jump and land into a Sumo Squat, hands touch the floor.\n4. Jump again and repeat Scissors with the opposite foot forward. Alternate right and left lead each rep.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1488,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '5adef399de3f4657e9de90c09eea39d188e4799f783a3765ae02815188c52c98',
          file_name:
            'videos/5adef399de3f4657e9de90c09eea39d188e4799f783a3765ae02815188c52c98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5adef399de3f4657e9de90c09eea39d188e4799f783a3765ae02815188c52c98.mp4',
          name: 'BEG-INT-ADV-Sumo_Scissors-WARM_UP.mp4',
          description: null,
          size: 1142555,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1489,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '291ed9accdfccb38da6135525e17620c33be049094e9da8ab694527f807cb41b',
          file_name:
            'audios/291ed9accdfccb38da6135525e17620c33be049094e9da8ab694527f807cb41b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/291ed9accdfccb38da6135525e17620c33be049094e9da8ab694527f807cb41b.mp3',
          name: 'BEG-INT-ADV-Sumo_Scissors-WARM_UP.mp3',
          description: null,
          size: 23692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SUMO_SCISSORS-WARM_UP': {
      id: 666,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Sumo Scissors',
      short_name: 'Sumo Scissors',
      unique_name: 'INTERMEDIATE-SUMO_SCISSORS-WARM_UP',
      description:
        '1. Stand with your feet together and elbows bent at 90 degrees by your sides.\n2. Jump up and perform 2 Scissor Feet, landing softly with one foot in front of the other. Take your arms with you as if you were running.\n3. After 2 Scissors, jump and land into a Sumo Squat, hands touch the floor.\n4. Jump again and repeat Scissors with the opposite foot forward. Alternate right and left lead each rep.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1490,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '5adef399de3f4657e9de90c09eea39d188e4799f783a3765ae02815188c52c98',
          file_name:
            'videos/5adef399de3f4657e9de90c09eea39d188e4799f783a3765ae02815188c52c98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5adef399de3f4657e9de90c09eea39d188e4799f783a3765ae02815188c52c98.mp4',
          name: 'BEG-INT-ADV-Sumo_Scissors-WARM_UP.mp4',
          description: null,
          size: 1142555,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1491,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '291ed9accdfccb38da6135525e17620c33be049094e9da8ab694527f807cb41b',
          file_name:
            'audios/291ed9accdfccb38da6135525e17620c33be049094e9da8ab694527f807cb41b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/291ed9accdfccb38da6135525e17620c33be049094e9da8ab694527f807cb41b.mp3',
          name: 'BEG-INT-ADV-Sumo_Scissors-WARM_UP.mp3',
          description: null,
          size: 23692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SUMO_SCISSORS-WARM_UP': {
      id: 667,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Sumo Scissors',
      short_name: 'Sumo Scissors',
      unique_name: 'ADVANCED-SUMO_SCISSORS-WARM_UP',
      description:
        '1. Stand with your feet together and elbows bent at 90 degrees by your sides.\n2. Jump up and perform 2 Scissor Feet, landing softly with one foot in front of the other. Take your arms with you as if you were running.\n3. After 2 Scissors, jump and land into a Sumo Squat, hands touch the floor.\n4. Jump again and repeat Scissors with the opposite foot forward. Alternate right and left lead each rep.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1492,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '5adef399de3f4657e9de90c09eea39d188e4799f783a3765ae02815188c52c98',
          file_name:
            'videos/5adef399de3f4657e9de90c09eea39d188e4799f783a3765ae02815188c52c98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5adef399de3f4657e9de90c09eea39d188e4799f783a3765ae02815188c52c98.mp4',
          name: 'BEG-INT-ADV-Sumo_Scissors-WARM_UP.mp4',
          description: null,
          size: 1142555,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1493,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '291ed9accdfccb38da6135525e17620c33be049094e9da8ab694527f807cb41b',
          file_name:
            'audios/291ed9accdfccb38da6135525e17620c33be049094e9da8ab694527f807cb41b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/291ed9accdfccb38da6135525e17620c33be049094e9da8ab694527f807cb41b.mp3',
          name: 'BEG-INT-ADV-Sumo_Scissors-WARM_UP.mp3',
          description: null,
          size: 23692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-TWIST_AND_SHOUT-WARM_UP': {
      id: 668,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Twist and Shout',
      short_name: 'Twist and Shout',
      unique_name: 'BEGINNER-TWIST_AND_SHOUT-WARM_UP',
      description:
        '1. Stand tall with your feet together. Raise both arms up in front of you, shoulder height.\n2. Jump up and twist your hips and lower body in one direction as you twist your shoulders and arms in the opposite direction.\n3. Land soft and immediately jump and twist in the opposite direction.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1494,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '7df2a252fa5f185b9a77533d592cbbf023ffcc460c2ef258415f1d8453328e57',
          file_name:
            'videos/7df2a252fa5f185b9a77533d592cbbf023ffcc460c2ef258415f1d8453328e57.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7df2a252fa5f185b9a77533d592cbbf023ffcc460c2ef258415f1d8453328e57.mp4',
          name: 'BEG-INT-ADV-Twist_and_Shout-WARM_UP.mp4',
          description: null,
          size: 1341514,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1495,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'ade410976d29665313e1acdd4a9c90f0c9f1ae0adde3390a9556da5a25595415',
          file_name:
            'audios/ade410976d29665313e1acdd4a9c90f0c9f1ae0adde3390a9556da5a25595415.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ade410976d29665313e1acdd4a9c90f0c9f1ae0adde3390a9556da5a25595415.mp3',
          name: 'BEG-INT-ADV-Twist_and_Shout-WARM_UP.mp3',
          description: null,
          size: 20557,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-TWIST_AND_SHOUT-WARM_UP': {
      id: 669,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Twist and Shout',
      short_name: 'Twist and Shout',
      unique_name: 'INTERMEDIATE-TWIST_AND_SHOUT-WARM_UP',
      description:
        '1. Stand tall with your feet together. Raise both arms up in front of you, shoulder height.\n2. Jump up and twist your hips and lower body in one direction as you twist your shoulders and arms in the opposite direction.\n3. Land soft and immediately jump and twist in the opposite direction.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1496,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '7df2a252fa5f185b9a77533d592cbbf023ffcc460c2ef258415f1d8453328e57',
          file_name:
            'videos/7df2a252fa5f185b9a77533d592cbbf023ffcc460c2ef258415f1d8453328e57.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7df2a252fa5f185b9a77533d592cbbf023ffcc460c2ef258415f1d8453328e57.mp4',
          name: 'BEG-INT-ADV-Twist_and_Shout-WARM_UP.mp4',
          description: null,
          size: 1341514,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1497,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'ade410976d29665313e1acdd4a9c90f0c9f1ae0adde3390a9556da5a25595415',
          file_name:
            'audios/ade410976d29665313e1acdd4a9c90f0c9f1ae0adde3390a9556da5a25595415.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ade410976d29665313e1acdd4a9c90f0c9f1ae0adde3390a9556da5a25595415.mp3',
          name: 'BEG-INT-ADV-Twist_and_Shout-WARM_UP.mp3',
          description: null,
          size: 20557,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-TWIST_AND_SHOUT-WARM_UP': {
      id: 670,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Twist and Shout',
      short_name: 'Twist and Shout',
      unique_name: 'ADVANCED-TWIST_AND_SHOUT-WARM_UP',
      description:
        '1. Stand tall with your feet together. Raise both arms up in front of you, shoulder height.\n2. Jump up and twist your hips and lower body in one direction as you twist your shoulders and arms in the opposite direction.\n3. Land soft and immediately jump and twist in the opposite direction.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1498,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '7df2a252fa5f185b9a77533d592cbbf023ffcc460c2ef258415f1d8453328e57',
          file_name:
            'videos/7df2a252fa5f185b9a77533d592cbbf023ffcc460c2ef258415f1d8453328e57.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7df2a252fa5f185b9a77533d592cbbf023ffcc460c2ef258415f1d8453328e57.mp4',
          name: 'BEG-INT-ADV-Twist_and_Shout-WARM_UP.mp4',
          description: null,
          size: 1341514,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1499,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'ade410976d29665313e1acdd4a9c90f0c9f1ae0adde3390a9556da5a25595415',
          file_name:
            'audios/ade410976d29665313e1acdd4a9c90f0c9f1ae0adde3390a9556da5a25595415.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ade410976d29665313e1acdd4a9c90f0c9f1ae0adde3390a9556da5a25595415.mp3',
          name: 'BEG-INT-ADV-Twist_and_Shout-WARM_UP.mp3',
          description: null,
          size: 20557,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SPEED_BAG-WARM_UP': {
      id: 723,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Speed Bag',
      short_name: 'Speed Bag',
      unique_name: 'BEGINNER-SPEED_BAG-WARM_UP',
      description:
        '1. Start with feet shoulder-width apart and step one leg forward. Hips square.\n2. Bend knees slightly and raise back heel. Keeping elbows out, circle your fists around each other above your chin.\n3. Drive off the back foot and transfer weight onto the front foot with a slight hop, back heel stays up.\n4. Immediately hop back, transferring weight to rear leg. Repeat in continuous motion.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1948,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '8319bc465e0fefb81a4ad82b3e26811c4f9f78ccca8e72ceccaa532d7b13a7f5',
          file_name:
            'videos/8319bc465e0fefb81a4ad82b3e26811c4f9f78ccca8e72ceccaa532d7b13a7f5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8319bc465e0fefb81a4ad82b3e26811c4f9f78ccca8e72ceccaa532d7b13a7f5.mp4',
          name: 'FSTEP-BEG-INT-ADV-Speed_Bag-WARM_UP-LEFT',
          description: 'Left Side',
          size: 601680,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1949,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '01d79406ed036c1daf9612e85bf545a7b987e084bf3f89fb856af0806f8e33af',
          file_name:
            'videos/01d79406ed036c1daf9612e85bf545a7b987e084bf3f89fb856af0806f8e33af.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/01d79406ed036c1daf9612e85bf545a7b987e084bf3f89fb856af0806f8e33af.mp4',
          name: 'FSTEP-BEG-INT-ADV-Speed_Bag-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 586371,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1950,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'b7e862f27e2e31122dab2502459fccc7daaab3564891af54fd09048f1953ad87',
          file_name:
            'audios/b7e862f27e2e31122dab2502459fccc7daaab3564891af54fd09048f1953ad87.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b7e862f27e2e31122dab2502459fccc7daaab3564891af54fd09048f1953ad87.mp3',
          name: 'FSTEP-BEG-INT-ADV-Speed_Bag-WARM_UP',
          description: null,
          size: 24558,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SPEED_BAG-WARM_UP': {
      id: 724,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Speed Bag',
      short_name: 'Speed Bag',
      unique_name: 'INTERMEDIATE-SPEED_BAG-WARM_UP',
      description:
        '1. Start with feet shoulder-width apart and step one leg forward. Hips square.\n2. Bend knees slightly and raise back heel. Keeping elbows out, circle your fists around each other above your chin.\n3. Drive off the back foot and transfer weight onto the front foot with a slight hop, back heel stays up.\n4. Immediately hop back, transferring weight to rear leg. Repeat in continuous motion.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1951,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '8319bc465e0fefb81a4ad82b3e26811c4f9f78ccca8e72ceccaa532d7b13a7f5',
          file_name:
            'videos/8319bc465e0fefb81a4ad82b3e26811c4f9f78ccca8e72ceccaa532d7b13a7f5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8319bc465e0fefb81a4ad82b3e26811c4f9f78ccca8e72ceccaa532d7b13a7f5.mp4',
          name: 'FSTEP-BEG-INT-ADV-Speed_Bag-WARM_UP-LEFT',
          description: 'Left Side',
          size: 601680,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1952,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '01d79406ed036c1daf9612e85bf545a7b987e084bf3f89fb856af0806f8e33af',
          file_name:
            'videos/01d79406ed036c1daf9612e85bf545a7b987e084bf3f89fb856af0806f8e33af.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/01d79406ed036c1daf9612e85bf545a7b987e084bf3f89fb856af0806f8e33af.mp4',
          name: 'FSTEP-BEG-INT-ADV-Speed_Bag-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 586371,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1953,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'b7e862f27e2e31122dab2502459fccc7daaab3564891af54fd09048f1953ad87',
          file_name:
            'audios/b7e862f27e2e31122dab2502459fccc7daaab3564891af54fd09048f1953ad87.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b7e862f27e2e31122dab2502459fccc7daaab3564891af54fd09048f1953ad87.mp3',
          name: 'FSTEP-BEG-INT-ADV-Speed_Bag-WARM_UP',
          description: null,
          size: 24558,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SPEED_BAG-WARM_UP': {
      id: 725,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Speed Bag',
      short_name: 'Speed Bag',
      unique_name: 'ADVANCED-SPEED_BAG-WARM_UP',
      description:
        '1. Start with feet shoulder-width apart and step one leg forward. Hips square.\n2. Bend knees slightly and raise back heel. Keeping elbows out, circle your fists around each other above your chin.\n3. Drive off the back foot and transfer weight onto the front foot with a slight hop, back heel stays up.\n4. Immediately hop back, transferring weight to rear leg. Repeat in continuous motion.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1954,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '8319bc465e0fefb81a4ad82b3e26811c4f9f78ccca8e72ceccaa532d7b13a7f5',
          file_name:
            'videos/8319bc465e0fefb81a4ad82b3e26811c4f9f78ccca8e72ceccaa532d7b13a7f5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8319bc465e0fefb81a4ad82b3e26811c4f9f78ccca8e72ceccaa532d7b13a7f5.mp4',
          name: 'FSTEP-BEG-INT-ADV-Speed_Bag-WARM_UP-LEFT',
          description: 'Left Side',
          size: 601680,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1955,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '01d79406ed036c1daf9612e85bf545a7b987e084bf3f89fb856af0806f8e33af',
          file_name:
            'videos/01d79406ed036c1daf9612e85bf545a7b987e084bf3f89fb856af0806f8e33af.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/01d79406ed036c1daf9612e85bf545a7b987e084bf3f89fb856af0806f8e33af.mp4',
          name: 'FSTEP-BEG-INT-ADV-Speed_Bag-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 586371,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1956,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'b7e862f27e2e31122dab2502459fccc7daaab3564891af54fd09048f1953ad87',
          file_name:
            'audios/b7e862f27e2e31122dab2502459fccc7daaab3564891af54fd09048f1953ad87.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b7e862f27e2e31122dab2502459fccc7daaab3564891af54fd09048f1953ad87.mp3',
          name: 'FSTEP-BEG-INT-ADV-Speed_Bag-WARM_UP',
          description: null,
          size: 24558,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SCAPULAR_PUSH-_UPS_ON_KNEES-WARM_UP': {
      id: 726,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Scapular Push-Ups on Knees',
      short_name: 'Scapular Push-Ups on Knees',
      unique_name: 'BEGINNER-SCAPULAR_PUSH-_UPS_ON_KNEES-WARM_UP',
      description:
        '1. Start in Plank position, shoulders over wrists. Drop knees to the floor and lift feet up.\n2. Keeping body in one line and arms straight, retract your shoulder blades by squeezing them back and together as your chest moves slightly toward the floor. Pause.\n3. Keeping arms straight, protract your shoulder blades by pushing them away from each other to create a slight rounding of your upper back.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1957,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '3874f7b0790267dc748f6ef34e851cf10d171caddf05d2ed7e907b168158c971',
          file_name:
            'videos/3874f7b0790267dc748f6ef34e851cf10d171caddf05d2ed7e907b168158c971.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3874f7b0790267dc748f6ef34e851cf10d171caddf05d2ed7e907b168158c971.mp4',
          name: 'BEG-INT-ADV-Scapular_Push-Ups_on_Knees-WARM_UP',
          description: null,
          size: 413752,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1958,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'af91739ff998297bb949fa948f2525f560b638789855da8a0a9ab6fe81370a2d',
          file_name:
            'audios/af91739ff998297bb949fa948f2525f560b638789855da8a0a9ab6fe81370a2d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/af91739ff998297bb949fa948f2525f560b638789855da8a0a9ab6fe81370a2d.mp3',
          name: 'BEG-INT-ADV-Scapular_Push-Ups_on_Knees-WARM_UP',
          description: null,
          size: 34589,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SCAPULAR_PUSH-_UPS_ON_KNEES-WARM_UP': {
      id: 727,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Scapular Push-Ups on Knees',
      short_name: 'Scapular Push-Ups on Knees',
      unique_name: 'INTERMEDIATE-SCAPULAR_PUSH-_UPS_ON_KNEES-WARM_UP',
      description:
        '1. Start in Plank position, shoulders over wrists. Drop knees to the floor and lift feet up.\n2. Keeping body in one line and arms straight, retract your shoulder blades by squeezing them back and together as your chest moves slightly toward the floor. Pause.\n3. Keeping arms straight, protract your shoulder blades by pushing them away from each other to create a slight rounding of your upper back.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1959,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '3874f7b0790267dc748f6ef34e851cf10d171caddf05d2ed7e907b168158c971',
          file_name:
            'videos/3874f7b0790267dc748f6ef34e851cf10d171caddf05d2ed7e907b168158c971.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3874f7b0790267dc748f6ef34e851cf10d171caddf05d2ed7e907b168158c971.mp4',
          name: 'BEG-INT-ADV-Scapular_Push-Ups_on_Knees-WARM_UP',
          description: null,
          size: 413752,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1960,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'af91739ff998297bb949fa948f2525f560b638789855da8a0a9ab6fe81370a2d',
          file_name:
            'audios/af91739ff998297bb949fa948f2525f560b638789855da8a0a9ab6fe81370a2d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/af91739ff998297bb949fa948f2525f560b638789855da8a0a9ab6fe81370a2d.mp3',
          name: 'BEG-INT-ADV-Scapular_Push-Ups_on_Knees-WARM_UP',
          description: null,
          size: 34589,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SCAPULAR_PUSH-_UPS_ON_KNEES-WARM_UP': {
      id: 728,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Scapular Push-Ups on Knees',
      short_name: 'Scapular Push-Ups on Knees',
      unique_name: 'ADVANCED-SCAPULAR_PUSH-_UPS_ON_KNEES-WARM_UP',
      description:
        '1. Start in Plank position, shoulders over wrists. Drop knees to the floor and lift feet up.\n2. Keeping body in one line and arms straight, retract your shoulder blades by squeezing them back and together as your chest moves slightly toward the floor. Pause.\n3. Keeping arms straight, protract your shoulder blades by pushing them away from each other to create a slight rounding of your upper back.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1961,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '3874f7b0790267dc748f6ef34e851cf10d171caddf05d2ed7e907b168158c971',
          file_name:
            'videos/3874f7b0790267dc748f6ef34e851cf10d171caddf05d2ed7e907b168158c971.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3874f7b0790267dc748f6ef34e851cf10d171caddf05d2ed7e907b168158c971.mp4',
          name: 'BEG-INT-ADV-Scapular_Push-Ups_on_Knees-WARM_UP',
          description: null,
          size: 413752,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1962,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'af91739ff998297bb949fa948f2525f560b638789855da8a0a9ab6fe81370a2d',
          file_name:
            'audios/af91739ff998297bb949fa948f2525f560b638789855da8a0a9ab6fe81370a2d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/af91739ff998297bb949fa948f2525f560b638789855da8a0a9ab6fe81370a2d.mp3',
          name: 'BEG-INT-ADV-Scapular_Push-Ups_on_Knees-WARM_UP',
          description: null,
          size: 34589,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-PLANK_TO_BEAR_CRAWL-WARM_UP': {
      id: 733,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Plank to Bear Crawl',
      short_name: 'Plank to Bear Crawl',
      unique_name: 'BEGINNER-PLANK_TO_BEAR_CRAWL-WARM_UP',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine.\n2. Keeping arms straight and core tight, step one foot in at a time so your knees are directly under your hips in Bear Plank position.\n3. Starting with the same lead leg, step your feet back one at a time to Plank.\n4. Repeat leading with the other leg. Right and Left is one rep.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1971,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'c0ae39b64f19b4b1ce813e1feb2644d7fc1bd8e379c1d487cd1a637160adf93f',
          file_name:
            'videos/c0ae39b64f19b4b1ce813e1feb2644d7fc1bd8e379c1d487cd1a637160adf93f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c0ae39b64f19b4b1ce813e1feb2644d7fc1bd8e379c1d487cd1a637160adf93f.mp4',
          name: 'FSTEP-BEG-INT-ADV-Plank_to_Bear_Crawl-WARM_UP',
          description: null,
          size: 467343,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1972,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'f61d5f0eef1a48f579798758eb8cf632fa40513b5477e3927fc525a732fd6072',
          file_name:
            'audios/f61d5f0eef1a48f579798758eb8cf632fa40513b5477e3927fc525a732fd6072.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f61d5f0eef1a48f579798758eb8cf632fa40513b5477e3927fc525a732fd6072.mp3',
          name: 'FSTEP-BEG-INT-ADV-Plank_to_Bear_Crawl-WARM_UP',
          description: null,
          size: 30514,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PLANK_TO_BEAR_CRAWL-WARM_UP': {
      id: 734,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Plank to Bear Crawl',
      short_name: 'Plank to Bear Crawl',
      unique_name: 'INTERMEDIATE-PLANK_TO_BEAR_CRAWL-WARM_UP',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine.\n2. Keeping arms straight and core tight, step one foot in at a time so your knees are directly under your hips in Bear Plank position.\n3. Starting with the same lead leg, step your feet back one at a time to Plank.\n4. Repeat leading with the other leg. Right and Left is one rep.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1973,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'c0ae39b64f19b4b1ce813e1feb2644d7fc1bd8e379c1d487cd1a637160adf93f',
          file_name:
            'videos/c0ae39b64f19b4b1ce813e1feb2644d7fc1bd8e379c1d487cd1a637160adf93f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c0ae39b64f19b4b1ce813e1feb2644d7fc1bd8e379c1d487cd1a637160adf93f.mp4',
          name: 'FSTEP-BEG-INT-ADV-Plank_to_Bear_Crawl-WARM_UP',
          description: null,
          size: 467343,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1974,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'f61d5f0eef1a48f579798758eb8cf632fa40513b5477e3927fc525a732fd6072',
          file_name:
            'audios/f61d5f0eef1a48f579798758eb8cf632fa40513b5477e3927fc525a732fd6072.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f61d5f0eef1a48f579798758eb8cf632fa40513b5477e3927fc525a732fd6072.mp3',
          name: 'FSTEP-BEG-INT-ADV-Plank_to_Bear_Crawl-WARM_UP',
          description: null,
          size: 30514,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PLANK_TO_BEAR_CRAWL-WARM_UP': {
      id: 735,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Plank to Bear Crawl',
      short_name: 'Plank to Bear Crawl',
      unique_name: 'ADVANCED-PLANK_TO_BEAR_CRAWL-WARM_UP',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine.\n2. Keeping arms straight and core tight, step one foot in at a time so your knees are directly under your hips in Bear Plank position.\n3. Starting with the same lead leg, step your feet back one at a time to Plank.\n4. Repeat leading with the other leg. Right and Left is one rep.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1975,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'c0ae39b64f19b4b1ce813e1feb2644d7fc1bd8e379c1d487cd1a637160adf93f',
          file_name:
            'videos/c0ae39b64f19b4b1ce813e1feb2644d7fc1bd8e379c1d487cd1a637160adf93f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c0ae39b64f19b4b1ce813e1feb2644d7fc1bd8e379c1d487cd1a637160adf93f.mp4',
          name: 'FSTEP-BEG-INT-ADV-Plank_to_Bear_Crawl-WARM_UP',
          description: null,
          size: 467343,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1976,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'f61d5f0eef1a48f579798758eb8cf632fa40513b5477e3927fc525a732fd6072',
          file_name:
            'audios/f61d5f0eef1a48f579798758eb8cf632fa40513b5477e3927fc525a732fd6072.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f61d5f0eef1a48f579798758eb8cf632fa40513b5477e3927fc525a732fd6072.mp3',
          name: 'FSTEP-BEG-INT-ADV-Plank_to_Bear_Crawl-WARM_UP',
          description: null,
          size: 30514,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-MODIFIED_SEAL_JACKS-WARM_UP': {
      id: 754,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Modified Seal Jacks',
      short_name: 'Modified Seal Jacks',
      unique_name: 'BEGINNER-MODIFIED_SEAL_JACKS-WARM_UP',
      description:
        '1. Start standing with your feet together and your arms extended in front of you at shoulder height, palms touching.\n2. Take a big step directly to the side with one foot, opening your arms out to a "T".\n3. Step the other foot in to meet it as you bring your arms back together in front of your body.\n4. Repeat stepping in the other direction. Right and left is one rep. ',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2016,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'd0c2a35ccc35cd2c8b403156919777e6f8aa0df4e07c5c65ac2c5f5e01e3a267',
          file_name:
            'videos/d0c2a35ccc35cd2c8b403156919777e6f8aa0df4e07c5c65ac2c5f5e01e3a267.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d0c2a35ccc35cd2c8b403156919777e6f8aa0df4e07c5c65ac2c5f5e01e3a267.mp4',
          name: 'FSTEP-BEG-INT-ADV-Modified_Seal_Jacks-WARM_UP',
          description: null,
          size: 846262,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2017,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '740ac605a123716432fac6db678697ff311a904fe60fb2a1c81259f58b3a5e58',
          file_name:
            'audios/740ac605a123716432fac6db678697ff311a904fe60fb2a1c81259f58b3a5e58.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/740ac605a123716432fac6db678697ff311a904fe60fb2a1c81259f58b3a5e58.mp3',
          name: 'FSTEP-BEG-INT-ADV-Modified_Seal_Jacks-WARM_UP',
          description: null,
          size: 30514,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MODIFIED_SEAL_JACKS-WARM_UP': {
      id: 755,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Modified Seal Jacks',
      short_name: 'Modified Seal Jacks',
      unique_name: 'INTERMEDIATE-MODIFIED_SEAL_JACKS-WARM_UP',
      description:
        '1. Start standing with your feet together and your arms extended in front of you at shoulder height, palms touching.\n2. Take a big step directly to the side with one foot, opening your arms out to a "T".\n3. Step the other foot in to meet it as you bring your arms back together in front of your body.\n4. Repeat stepping in the other direction. Right and left is one rep. ',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2018,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'd0c2a35ccc35cd2c8b403156919777e6f8aa0df4e07c5c65ac2c5f5e01e3a267',
          file_name:
            'videos/d0c2a35ccc35cd2c8b403156919777e6f8aa0df4e07c5c65ac2c5f5e01e3a267.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d0c2a35ccc35cd2c8b403156919777e6f8aa0df4e07c5c65ac2c5f5e01e3a267.mp4',
          name: 'FSTEP-BEG-INT-ADV-Modified_Seal_Jacks-WARM_UP',
          description: null,
          size: 846262,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2019,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '740ac605a123716432fac6db678697ff311a904fe60fb2a1c81259f58b3a5e58',
          file_name:
            'audios/740ac605a123716432fac6db678697ff311a904fe60fb2a1c81259f58b3a5e58.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/740ac605a123716432fac6db678697ff311a904fe60fb2a1c81259f58b3a5e58.mp3',
          name: 'FSTEP-BEG-INT-ADV-Modified_Seal_Jacks-WARM_UP',
          description: null,
          size: 30514,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MODIFIED_SEAL_JACKS-WARM_UP': {
      id: 756,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Modified Seal Jacks',
      short_name: 'Modified Seal Jacks',
      unique_name: 'ADVANCED-MODIFIED_SEAL_JACKS-WARM_UP',
      description:
        '1. Start standing with your feet together and your arms extended in front of you at shoulder height, palms touching.\n2. Take a big step directly to the side with one foot, opening your arms out to a "T".\n3. Step the other foot in to meet it as you bring your arms back together in front of your body.\n4. Repeat stepping in the other direction. Right and left is one rep. ',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2020,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'd0c2a35ccc35cd2c8b403156919777e6f8aa0df4e07c5c65ac2c5f5e01e3a267',
          file_name:
            'videos/d0c2a35ccc35cd2c8b403156919777e6f8aa0df4e07c5c65ac2c5f5e01e3a267.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d0c2a35ccc35cd2c8b403156919777e6f8aa0df4e07c5c65ac2c5f5e01e3a267.mp4',
          name: 'FSTEP-BEG-INT-ADV-Modified_Seal_Jacks-WARM_UP',
          description: null,
          size: 846262,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2021,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '740ac605a123716432fac6db678697ff311a904fe60fb2a1c81259f58b3a5e58',
          file_name:
            'audios/740ac605a123716432fac6db678697ff311a904fe60fb2a1c81259f58b3a5e58.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/740ac605a123716432fac6db678697ff311a904fe60fb2a1c81259f58b3a5e58.mp3',
          name: 'FSTEP-BEG-INT-ADV-Modified_Seal_Jacks-WARM_UP',
          description: null,
          size: 30514,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SWIMMERS-WARM_UP': {
      id: 764,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Swimmers',
      short_name: 'Swimmers',
      unique_name: 'BEGINNER-SWIMMERS-WARM_UP',
      description:
        '1. Lie flat on your stomach, legs long and arms extended overhead. Keep your neck in line with your spine and gaze toward the floor.\n2. Lift your arms and legs off the ground.\n3. Keeping arms and legs lifted, flutter opposite arms and legs in a continuous motion. Right and left is one rep. ',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2036,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1aec0e1a44c906c75d355cb00bf3b187fd9497a3f93e7e61946c86b486ae029b',
          file_name:
            'videos/1aec0e1a44c906c75d355cb00bf3b187fd9497a3f93e7e61946c86b486ae029b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1aec0e1a44c906c75d355cb00bf3b187fd9497a3f93e7e61946c86b486ae029b.mp4',
          name: 'FSTEP-BEG-INT-ADV-Swimmers-WARM_UP',
          description: null,
          size: 526330,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2037,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda',
          file_name:
            'audios/8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda.mp3',
          name: 'FSTEP-BEG-INT-ADV-Swimmers-WARM_UP',
          description: null,
          size: 22050,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SWIMMERS-WARM_UP': {
      id: 765,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Swimmers',
      short_name: 'Swimmers',
      unique_name: 'INTERMEDIATE-SWIMMERS-WARM_UP',
      description:
        '1. Lie flat on your stomach, legs long and arms extended overhead. Keep your neck in line with your spine and gaze toward the floor.\n2. Lift your arms and legs off the ground.\n3. Keeping arms and legs lifted, flutter opposite arms and legs in a continuous motion. Right and left is one rep. ',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2038,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1aec0e1a44c906c75d355cb00bf3b187fd9497a3f93e7e61946c86b486ae029b',
          file_name:
            'videos/1aec0e1a44c906c75d355cb00bf3b187fd9497a3f93e7e61946c86b486ae029b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1aec0e1a44c906c75d355cb00bf3b187fd9497a3f93e7e61946c86b486ae029b.mp4',
          name: 'FSTEP-BEG-INT-ADV-Swimmers-WARM_UP',
          description: null,
          size: 526330,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2039,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda',
          file_name:
            'audios/8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda.mp3',
          name: 'FSTEP-BEG-INT-ADV-Swimmers-WARM_UP',
          description: null,
          size: 22050,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SWIMMERS-WARM_UP': {
      id: 766,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Swimmers',
      short_name: 'Swimmers',
      unique_name: 'ADVANCED-SWIMMERS-WARM_UP',
      description:
        '1. Lie flat on your stomach, legs long and arms extended overhead. Keep your neck in line with your spine and gaze toward the floor.\n2. Lift your arms and legs off the ground.\n3. Keeping arms and legs lifted, flutter opposite arms and legs in a continuous motion. Right and left is one rep. ',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2040,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1aec0e1a44c906c75d355cb00bf3b187fd9497a3f93e7e61946c86b486ae029b',
          file_name:
            'videos/1aec0e1a44c906c75d355cb00bf3b187fd9497a3f93e7e61946c86b486ae029b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1aec0e1a44c906c75d355cb00bf3b187fd9497a3f93e7e61946c86b486ae029b.mp4',
          name: 'FSTEP-BEG-INT-ADV-Swimmers-WARM_UP',
          description: null,
          size: 526330,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2041,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda',
          file_name:
            'audios/8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda.mp3',
          name: 'FSTEP-BEG-INT-ADV-Swimmers-WARM_UP',
          description: null,
          size: 22050,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-REVERSE_WARRIOR-WARM_UP': {
      id: 776,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Warrior',
      short_name: 'Reverse Warrior',
      unique_name: 'BEGINNER-REVERSE_WARRIOR-WARM_UP',
      description:
        '1. Stand feet hip-width apart. Take a big step forward with one leg and spin your back foot to 45 degrees, both heels flat.\n2. Rotate torso open and lift arms up to a "T" as you drop into a lunge. Front knee should be directly over ankle and back leg straight.\n3. Reach front arm up and overhead as you stretch your body back. Rest the other hand on your back leg. Hold for time.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2066,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1db384f52b43b84d89c55b9f8cd2273a88b72d865e89ebb9b386c9eb80879840',
          file_name:
            'videos/1db384f52b43b84d89c55b9f8cd2273a88b72d865e89ebb9b386c9eb80879840.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1db384f52b43b84d89c55b9f8cd2273a88b72d865e89ebb9b386c9eb80879840.mp4',
          name: 'FSTEP-BEG-INT-ADV-Reverse_Warrior-WARM_UP-LEFT',
          description: 'Left Side',
          size: 227785,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2067,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: 'e5946fb0cd4a5f1bb64f1ed485c6c5c5af857f5cc54471bdd5daa633f33d7195',
          file_name:
            'videos/e5946fb0cd4a5f1bb64f1ed485c6c5c5af857f5cc54471bdd5daa633f33d7195.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e5946fb0cd4a5f1bb64f1ed485c6c5c5af857f5cc54471bdd5daa633f33d7195.mp4',
          name: 'FSTEP-BEG-INT-ADV-Reverse_Warrior-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 232924,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2068,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '42875aca213d7fcc0a3b8ff23aeabf7d04618c7ae4a85c535b15ce0a95848c77',
          file_name:
            'audios/42875aca213d7fcc0a3b8ff23aeabf7d04618c7ae4a85c535b15ce0a95848c77.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/42875aca213d7fcc0a3b8ff23aeabf7d04618c7ae4a85c535b15ce0a95848c77.mp3',
          name: 'FSTEP-BEG-INT-ADV-Reverse_Warrior-WARM_UP',
          description: null,
          size: 25185,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-REVERSE_WARRIOR-WARM_UP': {
      id: 777,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Warrior',
      short_name: 'Reverse Warrior',
      unique_name: 'INTERMEDIATE-REVERSE_WARRIOR-WARM_UP',
      description:
        '1. Stand feet hip-width apart. Take a big step forward with one leg and spin your back foot to 45 degrees, both heels flat.\n2. Rotate torso open and lift arms up to a "T" as you drop into a lunge. Front knee should be directly over ankle and back leg straight.\n3. Reach front arm up and overhead as you stretch your body back. Rest the other hand on your back leg. Hold for time.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2069,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1db384f52b43b84d89c55b9f8cd2273a88b72d865e89ebb9b386c9eb80879840',
          file_name:
            'videos/1db384f52b43b84d89c55b9f8cd2273a88b72d865e89ebb9b386c9eb80879840.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1db384f52b43b84d89c55b9f8cd2273a88b72d865e89ebb9b386c9eb80879840.mp4',
          name: 'FSTEP-BEG-INT-ADV-Reverse_Warrior-WARM_UP-LEFT',
          description: 'Left Side',
          size: 227785,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2070,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: 'e5946fb0cd4a5f1bb64f1ed485c6c5c5af857f5cc54471bdd5daa633f33d7195',
          file_name:
            'videos/e5946fb0cd4a5f1bb64f1ed485c6c5c5af857f5cc54471bdd5daa633f33d7195.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e5946fb0cd4a5f1bb64f1ed485c6c5c5af857f5cc54471bdd5daa633f33d7195.mp4',
          name: 'FSTEP-BEG-INT-ADV-Reverse_Warrior-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 232924,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2071,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '42875aca213d7fcc0a3b8ff23aeabf7d04618c7ae4a85c535b15ce0a95848c77',
          file_name:
            'audios/42875aca213d7fcc0a3b8ff23aeabf7d04618c7ae4a85c535b15ce0a95848c77.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/42875aca213d7fcc0a3b8ff23aeabf7d04618c7ae4a85c535b15ce0a95848c77.mp3',
          name: 'FSTEP-BEG-INT-ADV-Reverse_Warrior-WARM_UP',
          description: null,
          size: 25185,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-REVERSE_WARRIOR-WARM_UP': {
      id: 778,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Warrior',
      short_name: 'Reverse Warrior',
      unique_name: 'ADVANCED-REVERSE_WARRIOR-WARM_UP',
      description:
        '1. Stand feet hip-width apart. Take a big step forward with one leg and spin your back foot to 45 degrees, both heels flat.\n2. Rotate torso open and lift arms up to a "T" as you drop into a lunge. Front knee should be directly over ankle and back leg straight.\n3. Reach front arm up and overhead as you stretch your body back. Rest the other hand on your back leg. Hold for time.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2072,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1db384f52b43b84d89c55b9f8cd2273a88b72d865e89ebb9b386c9eb80879840',
          file_name:
            'videos/1db384f52b43b84d89c55b9f8cd2273a88b72d865e89ebb9b386c9eb80879840.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1db384f52b43b84d89c55b9f8cd2273a88b72d865e89ebb9b386c9eb80879840.mp4',
          name: 'FSTEP-BEG-INT-ADV-Reverse_Warrior-WARM_UP-LEFT',
          description: 'Left Side',
          size: 227785,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2073,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: 'e5946fb0cd4a5f1bb64f1ed485c6c5c5af857f5cc54471bdd5daa633f33d7195',
          file_name:
            'videos/e5946fb0cd4a5f1bb64f1ed485c6c5c5af857f5cc54471bdd5daa633f33d7195.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e5946fb0cd4a5f1bb64f1ed485c6c5c5af857f5cc54471bdd5daa633f33d7195.mp4',
          name: 'FSTEP-BEG-INT-ADV-Reverse_Warrior-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 232924,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2074,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '42875aca213d7fcc0a3b8ff23aeabf7d04618c7ae4a85c535b15ce0a95848c77',
          file_name:
            'audios/42875aca213d7fcc0a3b8ff23aeabf7d04618c7ae4a85c535b15ce0a95848c77.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/42875aca213d7fcc0a3b8ff23aeabf7d04618c7ae4a85c535b15ce0a95848c77.mp3',
          name: 'FSTEP-BEG-INT-ADV-Reverse_Warrior-WARM_UP',
          description: null,
          size: 25185,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ALTERNATING_DOWN_DOG_WITH_LEG_LIFTS-WARM_UP': {
      id: 784,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Down Dog with Alternating Leg Lifts',
      short_name: 'Down Dog w Alt. Leg Lifts',
      unique_name: 'BEGINNER-ALTERNATING_DOWN_DOG_WITH_LEG_LIFTS-WARM_UP',
      description:
        '1. Start in Down Dog position. Your hands are on the ground with your head between your upper arms, your hips up and back making an inverted "V."\n2. Lift one leg high into the air, hips square and toes pointed down. Squeeze glutes at the top.\n3. Lower your leg back to Down Dog position and repeat other leg. ',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2085,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '32790f0bc0458ab3de5d3491eabec5786596dda306810a53e6edce9fe6b19279',
          file_name:
            'videos/32790f0bc0458ab3de5d3491eabec5786596dda306810a53e6edce9fe6b19279.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/32790f0bc0458ab3de5d3491eabec5786596dda306810a53e6edce9fe6b19279.mp4',
          name: 'BEG-INT-ADV-Alternating_Down_Dog_with_Leg_Lifts-WARM_UP',
          description: null,
          size: 758925,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2564,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144',
          file_name:
            'audios/ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144.mp3',
          name: 'BEG-INT-ADV-Down_Dog_with_Alternating_Leg_Lifts-WARM_UP',
          description: null,
          size: 39384,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_DOWN_DOG_WITH_LEG_LIFTS-WARM_UP': {
      id: 785,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Down Dog with Alternating Leg Lifts',
      short_name: 'Down Dog w Alt. Leg Lifts',
      unique_name: 'INTERMEDIATE-ALTERNATING_DOWN_DOG_WITH_LEG_LIFTS-WARM_UP',
      description:
        '1. Start in Down Dog position. Your hands are on the ground with your head between your upper arms, your hips up and back making an inverted "V."\n2. Lift one leg high into the air, hips square and toes pointed down. Squeeze glutes at the top.\n3. Lower your leg back to Down Dog position and repeat other leg. ',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2087,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '32790f0bc0458ab3de5d3491eabec5786596dda306810a53e6edce9fe6b19279',
          file_name:
            'videos/32790f0bc0458ab3de5d3491eabec5786596dda306810a53e6edce9fe6b19279.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/32790f0bc0458ab3de5d3491eabec5786596dda306810a53e6edce9fe6b19279.mp4',
          name: 'BEG-INT-ADV-Alternating_Down_Dog_with_Leg_Lifts-WARM_UP',
          description: null,
          size: 758925,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2565,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144',
          file_name:
            'audios/ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144.mp3',
          name: 'BEG-INT-ADV-Down_Dog_with_Alternating_Leg_Lifts-WARM_UP',
          description: null,
          size: 39384,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_DOWN_DOG_WITH_LEG_LIFTS-WARM_UP': {
      id: 786,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Down Dog with Alternating Leg Lifts',
      short_name: 'Down Dog w Alt. Leg Lifts',
      unique_name: 'ADVANCED-ALTERNATING_DOWN_DOG_WITH_LEG_LIFTS-WARM_UP',
      description:
        '1. Start in Down Dog position. Your hands are on the ground with your head between your upper arms, your hips up and back making an inverted "V."\n2. Lift one leg high into the air, hips square and toes pointed down. Squeeze glutes at the top.\n3. Lower your leg back to Down Dog position and repeat other leg. ',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2089,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '32790f0bc0458ab3de5d3491eabec5786596dda306810a53e6edce9fe6b19279',
          file_name:
            'videos/32790f0bc0458ab3de5d3491eabec5786596dda306810a53e6edce9fe6b19279.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/32790f0bc0458ab3de5d3491eabec5786596dda306810a53e6edce9fe6b19279.mp4',
          name: 'BEG-INT-ADV-Alternating_Down_Dog_with_Leg_Lifts-WARM_UP',
          description: null,
          size: 758925,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2566,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144',
          file_name:
            'audios/ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144.mp3',
          name: 'BEG-INT-ADV-Down_Dog_with_Alternating_Leg_Lifts-WARM_UP',
          description: null,
          size: 39384,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-JUMPING_JILLS-WARM_UP': {
      id: 809,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Jumping Jills',
      short_name: 'Jumping Jills',
      unique_name: 'BEGINNER-JUMPING_JILLS-WARM_UP',
      description:
        '1. Stand with your feet together and your arms straight down by your sides.\n2. Jump and land softly on the balls of your feet with one foot in front of you and the other one behind you. Raise the arm opposite to the front foot straight up, and keep the other down by your side.\n3. Immediately jump up and switch your legs and arms.\n4. Right and left is one rep.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2138,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'e665f6ffd27e4afd09cd3281a576900ad333568ee21d134753a4fcf05c3383f2',
          file_name:
            'videos/e665f6ffd27e4afd09cd3281a576900ad333568ee21d134753a4fcf05c3383f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e665f6ffd27e4afd09cd3281a576900ad333568ee21d134753a4fcf05c3383f2.mp4',
          name: 'BEG-INT-ADV-Jumping_Jills-WARM_UP',
          description: null,
          size: 952088,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2139,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'df8c578c6a36ad903e1b7861ef11f6f061ae8efca0d4766bddcc4e72371d6545',
          file_name:
            'audios/df8c578c6a36ad903e1b7861ef11f6f061ae8efca0d4766bddcc4e72371d6545.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/df8c578c6a36ad903e1b7861ef11f6f061ae8efca0d4766bddcc4e72371d6545.mp3',
          name: 'BEG-INT-ADV-Jumping_Jills-WARM_UP',
          description: null,
          size: 25812,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-JUMPING_JILLS-WARM_UP': {
      id: 810,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Jumping Jills',
      short_name: 'Jumping Jills',
      unique_name: 'INTERMEDIATE-JUMPING_JILLS-WARM_UP',
      description:
        '1. Stand with your feet together and your arms straight down by your sides.\n2. Jump and land softly on the balls of your feet with one foot in front of you and the other one behind you. Raise the arm opposite to the front foot straight up, and keep the other down by your side.\n3. Immediately jump up and switch your legs and arms.\n4. Right and left is one rep.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2140,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'e665f6ffd27e4afd09cd3281a576900ad333568ee21d134753a4fcf05c3383f2',
          file_name:
            'videos/e665f6ffd27e4afd09cd3281a576900ad333568ee21d134753a4fcf05c3383f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e665f6ffd27e4afd09cd3281a576900ad333568ee21d134753a4fcf05c3383f2.mp4',
          name: 'BEG-INT-ADV-Jumping_Jills-WARM_UP',
          description: null,
          size: 952088,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2141,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'df8c578c6a36ad903e1b7861ef11f6f061ae8efca0d4766bddcc4e72371d6545',
          file_name:
            'audios/df8c578c6a36ad903e1b7861ef11f6f061ae8efca0d4766bddcc4e72371d6545.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/df8c578c6a36ad903e1b7861ef11f6f061ae8efca0d4766bddcc4e72371d6545.mp3',
          name: 'BEG-INT-ADV-Jumping_Jills-WARM_UP',
          description: null,
          size: 25812,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-JUMPING_JILLS-WARM_UP': {
      id: 811,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Jumping Jills',
      short_name: 'Jumping Jills',
      unique_name: 'ADVANCED-JUMPING_JILLS-WARM_UP',
      description:
        '1. Stand with your feet together and your arms straight down by your sides.\n2. Jump and land softly on the balls of your feet with one foot in front of you and the other one behind you. Raise the arm opposite to the front foot straight up, and keep the other down by your side.\n3. Immediately jump up and switch your legs and arms.\n4. Right and left is one rep.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2142,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'e665f6ffd27e4afd09cd3281a576900ad333568ee21d134753a4fcf05c3383f2',
          file_name:
            'videos/e665f6ffd27e4afd09cd3281a576900ad333568ee21d134753a4fcf05c3383f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e665f6ffd27e4afd09cd3281a576900ad333568ee21d134753a4fcf05c3383f2.mp4',
          name: 'BEG-INT-ADV-Jumping_Jills-WARM_UP',
          description: null,
          size: 952088,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2143,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'df8c578c6a36ad903e1b7861ef11f6f061ae8efca0d4766bddcc4e72371d6545',
          file_name:
            'audios/df8c578c6a36ad903e1b7861ef11f6f061ae8efca0d4766bddcc4e72371d6545.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/df8c578c6a36ad903e1b7861ef11f6f061ae8efca0d4766bddcc4e72371d6545.mp3',
          name: 'BEG-INT-ADV-Jumping_Jills-WARM_UP',
          description: null,
          size: 25812,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ALTERNATING_SIDE_BENDS_W_REACH-WARM_UP': {
      id: 818,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Alternating Side Bends with Reach',
      short_name: 'Alternating Side Bends w Reach',
      unique_name: 'BEGINNER-ALTERNATING_SIDE_BENDS_W_REACH-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart.\n2. Reach one arm overhead and lean over to feel the stretch in your side. Reach the other arm toward the opposite hip. Keep hips and shoulders square as you hold this position.\n3. Repeat other side.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2157,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '3f77cc10bc1f5968b7fcc748345976ba2a8fce7bfc8467a9716504b11b10b843',
          file_name:
            'videos/3f77cc10bc1f5968b7fcc748345976ba2a8fce7bfc8467a9716504b11b10b843.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3f77cc10bc1f5968b7fcc748345976ba2a8fce7bfc8467a9716504b11b10b843.mp4',
          name: 'FSTEP-BEG-INT-ADV-Alternating_Side_Bends_w_Reach-WARM_UP',
          description: null,
          size: 683009,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2158,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'b7cf27544076ad0ae40ce2740c5e60ef4780ae1917dcc73b7355ca3e9b1c46a8',
          file_name:
            'audios/b7cf27544076ad0ae40ce2740c5e60ef4780ae1917dcc73b7355ca3e9b1c46a8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b7cf27544076ad0ae40ce2740c5e60ef4780ae1917dcc73b7355ca3e9b1c46a8.mp3',
          name: 'FSTEP-BEG-INT-ADV-Alternating_Side_Bends_w_Reach-WARM_UP',
          description: null,
          size: 36470,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_SIDE_BENDS_W_REACH-WARM_UP': {
      id: 819,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Alternating Side Bends with Reach',
      short_name: 'Alternating Side Bends w Reach',
      unique_name: 'INTERMEDIATE-ALTERNATING_SIDE_BENDS_W_REACH-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart.\n2. Reach one arm overhead and lean over to feel the stretch in your side. Reach the other arm toward the opposite hip. Keep hips and shoulders square as you hold this position.\n3. Repeat other side.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2159,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '3f77cc10bc1f5968b7fcc748345976ba2a8fce7bfc8467a9716504b11b10b843',
          file_name:
            'videos/3f77cc10bc1f5968b7fcc748345976ba2a8fce7bfc8467a9716504b11b10b843.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3f77cc10bc1f5968b7fcc748345976ba2a8fce7bfc8467a9716504b11b10b843.mp4',
          name: 'FSTEP-BEG-INT-ADV-Alternating_Side_Bends_w_Reach-WARM_UP',
          description: null,
          size: 683009,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2160,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'b7cf27544076ad0ae40ce2740c5e60ef4780ae1917dcc73b7355ca3e9b1c46a8',
          file_name:
            'audios/b7cf27544076ad0ae40ce2740c5e60ef4780ae1917dcc73b7355ca3e9b1c46a8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b7cf27544076ad0ae40ce2740c5e60ef4780ae1917dcc73b7355ca3e9b1c46a8.mp3',
          name: 'FSTEP-BEG-INT-ADV-Alternating_Side_Bends_w_Reach-WARM_UP',
          description: null,
          size: 36470,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_SIDE_BENDS_W_REACH-WARM_UP': {
      id: 820,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Alternating Side Bends with Reach',
      short_name: 'Alternating Side Bends w Reach',
      unique_name: 'ADVANCED-ALTERNATING_SIDE_BENDS_W_REACH-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart.\n2. Reach one arm overhead and lean over to feel the stretch in your side. Reach the other arm toward the opposite hip. Keep hips and shoulders square as you hold this position.\n3. Repeat other side.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2161,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '3f77cc10bc1f5968b7fcc748345976ba2a8fce7bfc8467a9716504b11b10b843',
          file_name:
            'videos/3f77cc10bc1f5968b7fcc748345976ba2a8fce7bfc8467a9716504b11b10b843.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3f77cc10bc1f5968b7fcc748345976ba2a8fce7bfc8467a9716504b11b10b843.mp4',
          name: 'FSTEP-BEG-INT-ADV-Alternating_Side_Bends_w_Reach-WARM_UP',
          description: null,
          size: 683009,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2162,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'b7cf27544076ad0ae40ce2740c5e60ef4780ae1917dcc73b7355ca3e9b1c46a8',
          file_name:
            'audios/b7cf27544076ad0ae40ce2740c5e60ef4780ae1917dcc73b7355ca3e9b1c46a8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b7cf27544076ad0ae40ce2740c5e60ef4780ae1917dcc73b7355ca3e9b1c46a8.mp3',
          name: 'FSTEP-BEG-INT-ADV-Alternating_Side_Bends_w_Reach-WARM_UP',
          description: null,
          size: 36470,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SQUAT_WITH_ALTERNATING_KNEE-WARM_UP': {
      id: 829,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Squats with Alternating Knee',
      short_name: 'Squat with Alternating Knee',
      unique_name: 'BEGINNER-SQUAT_WITH_ALTERNATING_KNEE-WARM_UP',
      description:
        '1. Start standing with your feet roughly shoulder-width apart.\n2. Keeping your chest up, drive your hips back and bend your knees to squat down as low as you can.\n3. As you come up, transfer all your weight onto one leg and bring your other knee up to hip height.\n4. Lower your leg, squat again and repeat with the other leg.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2181,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '18f073127e3cdf66b81a9af683b2ac63e3dbd474122f0ef11adf420e66ea6445',
          file_name:
            'videos/18f073127e3cdf66b81a9af683b2ac63e3dbd474122f0ef11adf420e66ea6445.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/18f073127e3cdf66b81a9af683b2ac63e3dbd474122f0ef11adf420e66ea6445.mp4',
          name: 'FSTEP-BEG-INT-ADV-Squat_with_Alternating_Knee-WARM_UP',
          description: null,
          size: 906366,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2557,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '3c58f7672452e9620c7075f2d4d3844a52c4d1841b894ea4a4b40fd8ddb8d007',
          file_name:
            'audios/3c58f7672452e9620c7075f2d4d3844a52c4d1841b894ea4a4b40fd8ddb8d007.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3c58f7672452e9620c7075f2d4d3844a52c4d1841b894ea4a4b40fd8ddb8d007.mp3',
          name: 'BEG-INT-ADV-Squats_with_Alternating_Knee-WARM_UP',
          description: null,
          size: 32841,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SQUAT_WITH_ALTERNATING_KNEE-WARM_UP': {
      id: 830,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Squats with Alternating Knee',
      short_name: 'Squat with Alternating Knee',
      unique_name: 'INTERMEDIATE-SQUAT_WITH_ALTERNATING_KNEE-WARM_UP',
      description:
        '1. Start standing with your feet roughly shoulder-width apart.\n2. Keeping your chest up, drive your hips back and bend your knees to squat down as low as you can.\n3. As you come up, transfer all your weight onto one leg and bring your other knee up to hip height.\n4. Lower your leg, squat again and repeat with the other leg.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2183,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '18f073127e3cdf66b81a9af683b2ac63e3dbd474122f0ef11adf420e66ea6445',
          file_name:
            'videos/18f073127e3cdf66b81a9af683b2ac63e3dbd474122f0ef11adf420e66ea6445.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/18f073127e3cdf66b81a9af683b2ac63e3dbd474122f0ef11adf420e66ea6445.mp4',
          name: 'FSTEP-BEG-INT-ADV-Squat_with_Alternating_Knee-WARM_UP',
          description: null,
          size: 906366,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2558,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '3c58f7672452e9620c7075f2d4d3844a52c4d1841b894ea4a4b40fd8ddb8d007',
          file_name:
            'audios/3c58f7672452e9620c7075f2d4d3844a52c4d1841b894ea4a4b40fd8ddb8d007.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3c58f7672452e9620c7075f2d4d3844a52c4d1841b894ea4a4b40fd8ddb8d007.mp3',
          name: 'BEG-INT-ADV-Squats_with_Alternating_Knee-WARM_UP',
          description: null,
          size: 32841,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SQUAT_WITH_ALTERNATING_KNEE-WARM_UP': {
      id: 831,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Squats with Alternating Knee',
      short_name: 'Squat with Alternating Knee',
      unique_name: 'ADVANCED-SQUAT_WITH_ALTERNATING_KNEE-WARM_UP',
      description:
        '1. Start standing with your feet roughly shoulder-width apart.\n2. Keeping your chest up, drive your hips back and bend your knees to squat down as low as you can.\n3. As you come up, transfer all your weight onto one leg and bring your other knee up to hip height.\n4. Lower your leg, squat again and repeat with the other leg.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2185,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '18f073127e3cdf66b81a9af683b2ac63e3dbd474122f0ef11adf420e66ea6445',
          file_name:
            'videos/18f073127e3cdf66b81a9af683b2ac63e3dbd474122f0ef11adf420e66ea6445.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/18f073127e3cdf66b81a9af683b2ac63e3dbd474122f0ef11adf420e66ea6445.mp4',
          name: 'FSTEP-BEG-INT-ADV-Squat_with_Alternating_Knee-WARM_UP',
          description: null,
          size: 906366,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2559,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '3c58f7672452e9620c7075f2d4d3844a52c4d1841b894ea4a4b40fd8ddb8d007',
          file_name:
            'audios/3c58f7672452e9620c7075f2d4d3844a52c4d1841b894ea4a4b40fd8ddb8d007.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3c58f7672452e9620c7075f2d4d3844a52c4d1841b894ea4a4b40fd8ddb8d007.mp3',
          name: 'BEG-INT-ADV-Squats_with_Alternating_Knee-WARM_UP',
          description: null,
          size: 32841,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CRAB_WALK-WARM_UP': {
      id: 839,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Crab Walk',
      short_name: 'Crab Walk',
      unique_name: 'BEGINNER-CRAB_WALK-WARM_UP',
      description:
        '1. Start in a Crab Walk position with your knees bent, feet and hands on the floor, hips up.\n2. Keeping your hips off the floor, walk backwards on your hands and feet the length of your mat or longer.\n3. Crab Walk forward the length of your mat or longer, focusing on the pull of your hamstrings.\n4. Continue going back and forth for time.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2201,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '759071c4b62f8c317bf374fbb6ef76329a8f08ea68df471489216e675b50c7ba',
          file_name:
            'videos/759071c4b62f8c317bf374fbb6ef76329a8f08ea68df471489216e675b50c7ba.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/759071c4b62f8c317bf374fbb6ef76329a8f08ea68df471489216e675b50c7ba.mp4',
          name: 'BEG-INT-ADV-Crab_Walk-WARM_UP',
          description: null,
          size: 714568,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2202,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '079e63fde92891945aee41d9a7082fa0af2a0fd504e14e4508f8bb411ab3b239',
          file_name:
            'audios/079e63fde92891945aee41d9a7082fa0af2a0fd504e14e4508f8bb411ab3b239.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/079e63fde92891945aee41d9a7082fa0af2a0fd504e14e4508f8bb411ab3b239.mp3',
          name: 'BEG-INT-ADV-Crab_Walk-WARM_UP',
          description: null,
          size: 23306,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-CRAB_WALK-WARM_UP': {
      id: 840,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Crab Walk',
      short_name: 'Crab Walk',
      unique_name: 'INTERMEDIATE-CRAB_WALK-WARM_UP',
      description:
        '1. Start in a Crab Walk position with your knees bent, feet and hands on the floor, hips up.\n2. Keeping your hips off the floor, walk backwards on your hands and feet the length of your mat or longer.\n3. Crab Walk forward the length of your mat or longer, focusing on the pull of your hamstrings.\n4. Continue going back and forth for time.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2203,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '759071c4b62f8c317bf374fbb6ef76329a8f08ea68df471489216e675b50c7ba',
          file_name:
            'videos/759071c4b62f8c317bf374fbb6ef76329a8f08ea68df471489216e675b50c7ba.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/759071c4b62f8c317bf374fbb6ef76329a8f08ea68df471489216e675b50c7ba.mp4',
          name: 'BEG-INT-ADV-Crab_Walk-WARM_UP',
          description: null,
          size: 714568,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2204,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '079e63fde92891945aee41d9a7082fa0af2a0fd504e14e4508f8bb411ab3b239',
          file_name:
            'audios/079e63fde92891945aee41d9a7082fa0af2a0fd504e14e4508f8bb411ab3b239.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/079e63fde92891945aee41d9a7082fa0af2a0fd504e14e4508f8bb411ab3b239.mp3',
          name: 'BEG-INT-ADV-Crab_Walk-WARM_UP',
          description: null,
          size: 23306,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-CRAB_WALK-WARM_UP': {
      id: 841,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Crab Walk',
      short_name: 'Crab Walk',
      unique_name: 'ADVANCED-CRAB_WALK-WARM_UP',
      description:
        '1. Start in a Crab Walk position with your knees bent, feet and hands on the floor, hips up.\n2. Keeping your hips off the floor, walk backwards on your hands and feet the length of your mat or longer.\n3. Crab Walk forward the length of your mat or longer, focusing on the pull of your hamstrings.\n4. Continue going back and forth for time.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2205,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '759071c4b62f8c317bf374fbb6ef76329a8f08ea68df471489216e675b50c7ba',
          file_name:
            'videos/759071c4b62f8c317bf374fbb6ef76329a8f08ea68df471489216e675b50c7ba.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/759071c4b62f8c317bf374fbb6ef76329a8f08ea68df471489216e675b50c7ba.mp4',
          name: 'BEG-INT-ADV-Crab_Walk-WARM_UP',
          description: null,
          size: 714568,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2206,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '079e63fde92891945aee41d9a7082fa0af2a0fd504e14e4508f8bb411ab3b239',
          file_name:
            'audios/079e63fde92891945aee41d9a7082fa0af2a0fd504e14e4508f8bb411ab3b239.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/079e63fde92891945aee41d9a7082fa0af2a0fd504e14e4508f8bb411ab3b239.mp3',
          name: 'BEG-INT-ADV-Crab_Walk-WARM_UP',
          description: null,
          size: 23306,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SCAPULAR_PUSH-_UPS-WARM_UP': {
      id: 844,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Scapular Push-Ups',
      short_name: 'Scapular Push-Ups',
      unique_name: 'INTERMEDIATE-SCAPULAR_PUSH-_UPS-WARM_UP',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine.\n2. Keeping your body in one line and arms straight, retract your shoulder blades by squeezing them back and together as your chest moves slightly toward the floor. Pause for a beat.\n3. Keeping your arms straight, protract your shoulder blades by pushing them away from each other to create a slight rounding of your upper back.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2211,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '1805c02bf47d32d5d0d91460f64da8f8c93091398ffae6d60f98fe942bf56c48',
          file_name:
            'videos/1805c02bf47d32d5d0d91460f64da8f8c93091398ffae6d60f98fe942bf56c48.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1805c02bf47d32d5d0d91460f64da8f8c93091398ffae6d60f98fe942bf56c48.mp4',
          name: 'INT-ADV-Scapular_Push-Ups-WARM_UP',
          description: null,
          size: 397295,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2212,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '8375754f0ab0d2a00c2a200851f8ba1d1677fecfe2d4a1d68a9272a9b63811c6',
          file_name:
            'audios/8375754f0ab0d2a00c2a200851f8ba1d1677fecfe2d4a1d68a9272a9b63811c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8375754f0ab0d2a00c2a200851f8ba1d1677fecfe2d4a1d68a9272a9b63811c6.mp3',
          name: 'INT-ADV-Scapular_Push-Ups-WARM_UP',
          description: null,
          size: 28946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SCAPULAR_PUSH-_UPS-WARM_UP': {
      id: 845,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Scapular Push-Ups',
      short_name: 'Scapular Push-Ups',
      unique_name: 'ADVANCED-SCAPULAR_PUSH-_UPS-WARM_UP',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine.\n2. Keeping your body in one line and arms straight, retract your shoulder blades by squeezing them back and together as your chest moves slightly toward the floor. Pause for a beat.\n3. Keeping your arms straight, protract your shoulder blades by pushing them away from each other to create a slight rounding of your upper back.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2213,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '1805c02bf47d32d5d0d91460f64da8f8c93091398ffae6d60f98fe942bf56c48',
          file_name:
            'videos/1805c02bf47d32d5d0d91460f64da8f8c93091398ffae6d60f98fe942bf56c48.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1805c02bf47d32d5d0d91460f64da8f8c93091398ffae6d60f98fe942bf56c48.mp4',
          name: 'INT-ADV-Scapular_Push-Ups-WARM_UP',
          description: null,
          size: 397295,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2214,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '8375754f0ab0d2a00c2a200851f8ba1d1677fecfe2d4a1d68a9272a9b63811c6',
          file_name:
            'audios/8375754f0ab0d2a00c2a200851f8ba1d1677fecfe2d4a1d68a9272a9b63811c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8375754f0ab0d2a00c2a200851f8ba1d1677fecfe2d4a1d68a9272a9b63811c6.mp3',
          name: 'INT-ADV-Scapular_Push-Ups-WARM_UP',
          description: null,
          size: 28946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_BOX_SQUATS-WARM_UP': {
      id: 922,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Box Squats',
      short_name: 'Dumbbell Box Squats',
      unique_name: 'INTERMEDIATE-DUMBBELL_BOX_SQUATS-WARM_UP',
      description:
        '1. Start standing in front of the step. Hold a dumbbell in each hand, resting lightly on your shoulders, elbows pointing down.\n2. Maintaining good posture, bend your knees and sink your hips back to slowly lower yourself to sit on the step. Do not fully relax into a seated position, or lightly tap your glutes. Keep your muscles activated.\n3. Drive through your heels and return to stand.\n4. Repeat for designated time. ',
      preview_time: null,
      min_app_version: 200070000,
      archived: true,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2386,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '1c9eb98d7bbed62081a9d1b18a52b66bcc8bcf661a7166589f72aea638ff7fb5',
          file_name:
            'videos/1c9eb98d7bbed62081a9d1b18a52b66bcc8bcf661a7166589f72aea638ff7fb5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1c9eb98d7bbed62081a9d1b18a52b66bcc8bcf661a7166589f72aea638ff7fb5.mp4',
          name: 'INT-ADV-Dumbbell_Box_Squats-WARM_UP',
          description: null,
          size: 624941,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2387,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24',
          file_name:
            'audios/3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24.mp3',
          name: 'INT-ADV-Dumbbell_Box_Squats-WARM_UP',
          description: null,
          size: 29585,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_BOX_SQUATS-WARM_UP': {
      id: 923,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Box Squats',
      short_name: 'Dumbbell Box Squats',
      unique_name: 'ADVANCED-DUMBBELL_BOX_SQUATS-WARM_UP',
      description:
        '1. Start standing in front of the step. Hold a dumbbell in each hand, resting lightly on your shoulders, elbows pointing down.\n2. Maintaining good posture, bend your knees and sink your hips back to slowly lower yourself to sit on the step. Do not fully relax into a seated position, or lightly tap your glutes. Keep your muscles activated.\n3. Drive through your heels and return to stand.\n4. Repeat for designated time. ',
      preview_time: null,
      min_app_version: 200070000,
      archived: true,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2388,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '1c9eb98d7bbed62081a9d1b18a52b66bcc8bcf661a7166589f72aea638ff7fb5',
          file_name:
            'videos/1c9eb98d7bbed62081a9d1b18a52b66bcc8bcf661a7166589f72aea638ff7fb5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1c9eb98d7bbed62081a9d1b18a52b66bcc8bcf661a7166589f72aea638ff7fb5.mp4',
          name: 'INT-ADV-Dumbbell_Box_Squats-WARM_UP',
          description: null,
          size: 624941,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2389,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24',
          file_name:
            'audios/3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24.mp3',
          name: 'INT-ADV-Dumbbell_Box_Squats-WARM_UP',
          description: null,
          size: 29585,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-STANDING_GLUTE_KICKBACKS-WARM_UP': {
      id: 988,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Standing Glute Kickbacks',
      short_name: 'Standing Glute Kickbacks',
      unique_name: 'BEGINNER-STANDING_GLUTE_KICKBACKS-WARM_UP',
      description:
        '1. Stand feet in a close stance. Place hands on hips or hold onto a chair or wall for assistance.\n2. Keeping hips square, bend one knee bringing your heel toward your glutes. Shin should be about parallel to the floor.\n3. Push through heel to extend leg straight back behind you, toes toward the floor. Do not arch low back.\n4. Bend knee and return to start. Perform all reps. Repeat other side.',
      preview_time: null,
      min_app_version: 300000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2530,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'af132704d2fc18bbdb856165720ed469e6cf4072fc79c8c29e395e114abbb3dc',
          file_name:
            'videos/af132704d2fc18bbdb856165720ed469e6cf4072fc79c8c29e395e114abbb3dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/af132704d2fc18bbdb856165720ed469e6cf4072fc79c8c29e395e114abbb3dc.mp4',
          name: 'BEG-INT-ADV-Standing_Glute_Kickbacks-WARM_UP-LEFT',
          description: 'Left Side',
          size: 403693,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2531,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'ccf26cac4414d22a09f1c9ac7c12de5ece0227fde0b3e060e8c9545c000307b4',
          file_name:
            'videos/ccf26cac4414d22a09f1c9ac7c12de5ece0227fde0b3e060e8c9545c000307b4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ccf26cac4414d22a09f1c9ac7c12de5ece0227fde0b3e060e8c9545c000307b4.mp4',
          name: 'BEG-INT-ADV-Standing_Glute_Kickbacks-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 410059,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2532,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '7194f2e60d168a340843ca34e86bb47a13e1bed9f553f8dbabd8c12fbd3bcde8',
          file_name:
            'audios/7194f2e60d168a340843ca34e86bb47a13e1bed9f553f8dbabd8c12fbd3bcde8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7194f2e60d168a340843ca34e86bb47a13e1bed9f553f8dbabd8c12fbd3bcde8.mp3',
          name: 'BEG-INT-ADV-Standing_Glute_Kickbacks-WARM_UP',
          description: null,
          size: 33021,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-STANDING_GLUTE_KICKBACKS-WARM_UP': {
      id: 989,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Standing Glute Kickbacks',
      short_name: 'Standing Glute Kickbacks',
      unique_name: 'INTERMEDIATE-STANDING_GLUTE_KICKBACKS-WARM_UP',
      description:
        '1. Stand feet in a close stance. Place hands on hips or hold onto a chair or wall for assistance.\n2. Keeping hips square, bend one knee bringing your heel toward your glutes. Shin should be about parallel to the floor.\n3. Push through heel to extend leg straight back behind you, toes toward the floor. Do not arch low back.\n4. Bend knee and return to start. Perform all reps. Repeat other side.',
      preview_time: null,
      min_app_version: 300000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2533,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'af132704d2fc18bbdb856165720ed469e6cf4072fc79c8c29e395e114abbb3dc',
          file_name:
            'videos/af132704d2fc18bbdb856165720ed469e6cf4072fc79c8c29e395e114abbb3dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/af132704d2fc18bbdb856165720ed469e6cf4072fc79c8c29e395e114abbb3dc.mp4',
          name: 'BEG-INT-ADV-Standing_Glute_Kickbacks-WARM_UP-LEFT',
          description: 'Left Side',
          size: 403693,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2534,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'ccf26cac4414d22a09f1c9ac7c12de5ece0227fde0b3e060e8c9545c000307b4',
          file_name:
            'videos/ccf26cac4414d22a09f1c9ac7c12de5ece0227fde0b3e060e8c9545c000307b4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ccf26cac4414d22a09f1c9ac7c12de5ece0227fde0b3e060e8c9545c000307b4.mp4',
          name: 'BEG-INT-ADV-Standing_Glute_Kickbacks-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 410059,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2535,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '7194f2e60d168a340843ca34e86bb47a13e1bed9f553f8dbabd8c12fbd3bcde8',
          file_name:
            'audios/7194f2e60d168a340843ca34e86bb47a13e1bed9f553f8dbabd8c12fbd3bcde8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7194f2e60d168a340843ca34e86bb47a13e1bed9f553f8dbabd8c12fbd3bcde8.mp3',
          name: 'BEG-INT-ADV-Standing_Glute_Kickbacks-WARM_UP',
          description: null,
          size: 33021,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-STANDING_GLUTE_KICKBACKS-WARM_UP': {
      id: 990,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Standing Glute Kickbacks',
      short_name: 'Standing Glute Kickbacks',
      unique_name: 'ADVANCED-STANDING_GLUTE_KICKBACKS-WARM_UP',
      description:
        '1. Stand feet in a close stance. Place hands on hips or hold onto a chair or wall for assistance.\n2. Keeping hips square, bend one knee bringing your heel toward your glutes. Shin should be about parallel to the floor.\n3. Push through heel to extend leg straight back behind you, toes toward the floor. Do not arch low back.\n4. Bend knee and return to start. Perform all reps. Repeat other side.',
      preview_time: null,
      min_app_version: 300000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2536,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'af132704d2fc18bbdb856165720ed469e6cf4072fc79c8c29e395e114abbb3dc',
          file_name:
            'videos/af132704d2fc18bbdb856165720ed469e6cf4072fc79c8c29e395e114abbb3dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/af132704d2fc18bbdb856165720ed469e6cf4072fc79c8c29e395e114abbb3dc.mp4',
          name: 'BEG-INT-ADV-Standing_Glute_Kickbacks-WARM_UP-LEFT',
          description: 'Left Side',
          size: 403693,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2537,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'ccf26cac4414d22a09f1c9ac7c12de5ece0227fde0b3e060e8c9545c000307b4',
          file_name:
            'videos/ccf26cac4414d22a09f1c9ac7c12de5ece0227fde0b3e060e8c9545c000307b4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ccf26cac4414d22a09f1c9ac7c12de5ece0227fde0b3e060e8c9545c000307b4.mp4',
          name: 'BEG-INT-ADV-Standing_Glute_Kickbacks-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 410059,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2538,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '7194f2e60d168a340843ca34e86bb47a13e1bed9f553f8dbabd8c12fbd3bcde8',
          file_name:
            'audios/7194f2e60d168a340843ca34e86bb47a13e1bed9f553f8dbabd8c12fbd3bcde8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7194f2e60d168a340843ca34e86bb47a13e1bed9f553f8dbabd8c12fbd3bcde8.mp3',
          name: 'BEG-INT-ADV-Standing_Glute_Kickbacks-WARM_UP',
          description: null,
          size: 33021,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-BODYWEIGHT_SQUATS-WARM_UP': {
      id: 991,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Squats',
      short_name: 'Bodyweight Squats',
      unique_name: 'BEGINNER-BODYWEIGHT_SQUATS-WARM_UP',
      description:
        '1. Stand with your feet shoulder-width apart.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chet up and shoulders back.\n3. Drive through your heels and stand back up to a starting position. ',
      preview_time: null,
      min_app_version: 300000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2539,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'beb4110c0a9d0bf2fc5ce29de7f2e7e7878d0b31442f4a2d2af1474389fad8b2',
          file_name:
            'videos/beb4110c0a9d0bf2fc5ce29de7f2e7e7878d0b31442f4a2d2af1474389fad8b2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/beb4110c0a9d0bf2fc5ce29de7f2e7e7878d0b31442f4a2d2af1474389fad8b2.mp4',
          name: 'BEG-INT-ADV-Bodyweight_Squats-WARM_UP',
          description: null,
          size: 1453197,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2540,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '5d40ec980f209b1bdb83a5fc43011e1936e7d5d0b75585bae375c2e8c2e30d08',
          file_name:
            'audios/5d40ec980f209b1bdb83a5fc43011e1936e7d5d0b75585bae375c2e8c2e30d08.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5d40ec980f209b1bdb83a5fc43011e1936e7d5d0b75585bae375c2e8c2e30d08.mp3',
          name: 'BEG-INT-ADV-Bodyweight_Squats-WARM_UP',
          description: null,
          size: 31502,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-BODYWEIGHT_SQUATS-WARM_UP': {
      id: 992,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Squats',
      short_name: 'Bodyweight Squats',
      unique_name: 'INTERMEDIATE-BODYWEIGHT_SQUATS-WARM_UP',
      description:
        '1. Stand with your feet shoulder-width apart.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chet up and shoulders back.\n3. Drive through your heels and stand back up to a starting position. ',
      preview_time: null,
      min_app_version: 300000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2541,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'beb4110c0a9d0bf2fc5ce29de7f2e7e7878d0b31442f4a2d2af1474389fad8b2',
          file_name:
            'videos/beb4110c0a9d0bf2fc5ce29de7f2e7e7878d0b31442f4a2d2af1474389fad8b2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/beb4110c0a9d0bf2fc5ce29de7f2e7e7878d0b31442f4a2d2af1474389fad8b2.mp4',
          name: 'BEG-INT-ADV-Bodyweight_Squats-WARM_UP',
          description: null,
          size: 1453197,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2542,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '5d40ec980f209b1bdb83a5fc43011e1936e7d5d0b75585bae375c2e8c2e30d08',
          file_name:
            'audios/5d40ec980f209b1bdb83a5fc43011e1936e7d5d0b75585bae375c2e8c2e30d08.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5d40ec980f209b1bdb83a5fc43011e1936e7d5d0b75585bae375c2e8c2e30d08.mp3',
          name: 'BEG-INT-ADV-Bodyweight_Squats-WARM_UP',
          description: null,
          size: 31502,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-BODYWEIGHT_SQUATS-WARM_UP': {
      id: 993,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Squats',
      short_name: 'Bodyweight Squats',
      unique_name: 'ADVANCED-BODYWEIGHT_SQUATS-WARM_UP',
      description:
        '1. Stand with your feet shoulder-width apart.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chet up and shoulders back.\n3. Drive through your heels and stand back up to a starting position. ',
      preview_time: null,
      min_app_version: 300000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2543,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'beb4110c0a9d0bf2fc5ce29de7f2e7e7878d0b31442f4a2d2af1474389fad8b2',
          file_name:
            'videos/beb4110c0a9d0bf2fc5ce29de7f2e7e7878d0b31442f4a2d2af1474389fad8b2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/beb4110c0a9d0bf2fc5ce29de7f2e7e7878d0b31442f4a2d2af1474389fad8b2.mp4',
          name: 'BEG-INT-ADV-Bodyweight_Squats-WARM_UP',
          description: null,
          size: 1453197,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2544,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '5d40ec980f209b1bdb83a5fc43011e1936e7d5d0b75585bae375c2e8c2e30d08',
          file_name:
            'audios/5d40ec980f209b1bdb83a5fc43011e1936e7d5d0b75585bae375c2e8c2e30d08.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5d40ec980f209b1bdb83a5fc43011e1936e7d5d0b75585bae375c2e8c2e30d08.mp3',
          name: 'BEG-INT-ADV-Bodyweight_Squats-WARM_UP',
          description: null,
          size: 31502,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ALTERNATING_FRONT_KICKS-WARM_UP': {
      id: 994,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Alternating Front Kicks',
      short_name: 'Alternating Front Kicks',
      unique_name: 'BEGINNER-ALTERNATING_FRONT_KICKS-WARM_UP',
      description:
        '1. Stand with your feet roughly shoulder-width apart. Keeping your chest up and core tight. Hands in fists in front of your chin.\n2. Pick up one knee and extend your leg in front of you (like you are kicking off your shoe).\n3. Recoil your leg back into start position.\n4. Repeat with the other leg. Right and left equals one rep.',
      preview_time: null,
      min_app_version: 300000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2545,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '43f7801da9ebe09ce69cdeac568d372d0f1c529c43374117f0ee53acea658cd6',
          file_name:
            'videos/43f7801da9ebe09ce69cdeac568d372d0f1c529c43374117f0ee53acea658cd6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/43f7801da9ebe09ce69cdeac568d372d0f1c529c43374117f0ee53acea658cd6.mp4',
          name: 'BEG-INT-ADV-Alternating_Front_Kicks-WARM_UP',
          description: null,
          size: 1200200,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2546,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '5b565fc37a7976cbe82530ac3b31937bff968d1b7ad33e8d286c0f2173050b01',
          file_name:
            'audios/5b565fc37a7976cbe82530ac3b31937bff968d1b7ad33e8d286c0f2173050b01.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5b565fc37a7976cbe82530ac3b31937bff968d1b7ad33e8d286c0f2173050b01.mp3',
          name: 'BEG-INT-ADV-Alternating_Front_Kicks-WARM_UP',
          description: null,
          size: 26200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_FRONT_KICKS-WARM_UP': {
      id: 995,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Alternating Front Kicks',
      short_name: 'Alternating Front Kicks',
      unique_name: 'INTERMEDIATE-ALTERNATING_FRONT_KICKS-WARM_UP',
      description:
        '1. Stand with your feet roughly shoulder-width apart. Keeping your chest up and core tight. Hands in fists in front of your chin.\n2. Pick up one knee and extend your leg in front of you (like you are kicking off your shoe).\n3. Recoil your leg back into start position.\n4. Repeat with the other leg. Right and left equals one rep.',
      preview_time: null,
      min_app_version: 300000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2547,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '43f7801da9ebe09ce69cdeac568d372d0f1c529c43374117f0ee53acea658cd6',
          file_name:
            'videos/43f7801da9ebe09ce69cdeac568d372d0f1c529c43374117f0ee53acea658cd6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/43f7801da9ebe09ce69cdeac568d372d0f1c529c43374117f0ee53acea658cd6.mp4',
          name: 'BEG-INT-ADV-Alternating_Front_Kicks-WARM_UP',
          description: null,
          size: 1200200,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2548,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '5b565fc37a7976cbe82530ac3b31937bff968d1b7ad33e8d286c0f2173050b01',
          file_name:
            'audios/5b565fc37a7976cbe82530ac3b31937bff968d1b7ad33e8d286c0f2173050b01.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5b565fc37a7976cbe82530ac3b31937bff968d1b7ad33e8d286c0f2173050b01.mp3',
          name: 'BEG-INT-ADV-Alternating_Front_Kicks-WARM_UP',
          description: null,
          size: 26200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_FRONT_KICKS-WARM_UP': {
      id: 996,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Alternating Front Kicks',
      short_name: 'Alternating Front Kicks',
      unique_name: 'ADVANCED-ALTERNATING_FRONT_KICKS-WARM_UP',
      description:
        '1. Stand with your feet roughly shoulder-width apart. Keeping your chest up and core tight. Hands in fists in front of your chin.\n2. Pick up one knee and extend your leg in front of you (like you are kicking off your shoe).\n3. Recoil your leg back into start position.\n4. Repeat with the other leg. Right and left equals one rep.',
      preview_time: null,
      min_app_version: 300000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2549,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '43f7801da9ebe09ce69cdeac568d372d0f1c529c43374117f0ee53acea658cd6',
          file_name:
            'videos/43f7801da9ebe09ce69cdeac568d372d0f1c529c43374117f0ee53acea658cd6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/43f7801da9ebe09ce69cdeac568d372d0f1c529c43374117f0ee53acea658cd6.mp4',
          name: 'BEG-INT-ADV-Alternating_Front_Kicks-WARM_UP',
          description: null,
          size: 1200200,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2550,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '5b565fc37a7976cbe82530ac3b31937bff968d1b7ad33e8d286c0f2173050b01',
          file_name:
            'audios/5b565fc37a7976cbe82530ac3b31937bff968d1b7ad33e8d286c0f2173050b01.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5b565fc37a7976cbe82530ac3b31937bff968d1b7ad33e8d286c0f2173050b01.mp3',
          name: 'BEG-INT-ADV-Alternating_Front_Kicks-WARM_UP',
          description: null,
          size: 26200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-BODYWEIGHT_SUMO_SQUATS_WITH_ROW-WARM_UP': {
      id: 997,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Sumo Squats with Row',
      short_name: 'Bodyweight Sumo Squats with Row',
      unique_name: 'BEGINNER-BODYWEIGHT_SUMO_SQUATS_WITH_ROW-WARM_UP',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointed out and arms down in front of your body, palms facing inward.\n2. Lower into a wide squat bringing your hands towards the floor.\n3. Drive through your heels and explode up to stand as you raise your fists towards your chin and your elbows upward to a "V".\n4. Squat back down as you bring your fists towards the floor. ',
      preview_time: null,
      min_app_version: 300000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2551,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'f87b7863562546abb90da37f1a4f397d55fbd3bb44d1947209aa5db3660129c4',
          file_name:
            'videos/f87b7863562546abb90da37f1a4f397d55fbd3bb44d1947209aa5db3660129c4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f87b7863562546abb90da37f1a4f397d55fbd3bb44d1947209aa5db3660129c4.mp4',
          name: 'BEG-INT-ADV-Bodyweight_Sumo_Squats_with_Row-WARM_UP',
          description: null,
          size: 1604360,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2552,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'eea6386d57d523b25da58ee822d12879b1599ee9b7e95b014d593345d617db39',
          file_name:
            'audios/eea6386d57d523b25da58ee822d12879b1599ee9b7e95b014d593345d617db39.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eea6386d57d523b25da58ee822d12879b1599ee9b7e95b014d593345d617db39.mp3',
          name: 'BEG-INT-ADV-Bodyweight_Sumo_Squats_with_Row-WARM_UP',
          description: null,
          size: 36032,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-BODYWEIGHT_SUMO_SQUATS_WITH_ROW-WARM_UP': {
      id: 998,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Sumo Squats with Row',
      short_name: 'Bodyweight Sumo Squats with Row',
      unique_name: 'INTERMEDIATE-BODYWEIGHT_SUMO_SQUATS_WITH_ROW-WARM_UP',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointed out and arms down in front of your body, palms facing inward.\n2. Lower into a wide squat bringing your hands towards the floor.\n3. Drive through your heels and explode up to stand as you raise your fists towards your chin and your elbows upward to a "V".\n4. Squat back down as you bring your fists towards the floor. ',
      preview_time: null,
      min_app_version: 300000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2553,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'f87b7863562546abb90da37f1a4f397d55fbd3bb44d1947209aa5db3660129c4',
          file_name:
            'videos/f87b7863562546abb90da37f1a4f397d55fbd3bb44d1947209aa5db3660129c4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f87b7863562546abb90da37f1a4f397d55fbd3bb44d1947209aa5db3660129c4.mp4',
          name: 'BEG-INT-ADV-Bodyweight_Sumo_Squats_with_Row-WARM_UP',
          description: null,
          size: 1604360,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2554,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'eea6386d57d523b25da58ee822d12879b1599ee9b7e95b014d593345d617db39',
          file_name:
            'audios/eea6386d57d523b25da58ee822d12879b1599ee9b7e95b014d593345d617db39.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eea6386d57d523b25da58ee822d12879b1599ee9b7e95b014d593345d617db39.mp3',
          name: 'BEG-INT-ADV-Bodyweight_Sumo_Squats_with_Row-WARM_UP',
          description: null,
          size: 36032,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-BODYWEIGHT_SUMO_SQUATS_WITH_ROW-WARM_UP': {
      id: 999,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Sumo Squats with Row',
      short_name: 'Bodyweight Sumo Squats with Row',
      unique_name: 'ADVANCED-BODYWEIGHT_SUMO_SQUATS_WITH_ROW-WARM_UP',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointed out and arms down in front of your body, palms facing inward.\n2. Lower into a wide squat bringing your hands towards the floor.\n3. Drive through your heels and explode up to stand as you raise your fists towards your chin and your elbows upward to a "V".\n4. Squat back down as you bring your fists towards the floor. ',
      preview_time: null,
      min_app_version: 300000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2555,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'f87b7863562546abb90da37f1a4f397d55fbd3bb44d1947209aa5db3660129c4',
          file_name:
            'videos/f87b7863562546abb90da37f1a4f397d55fbd3bb44d1947209aa5db3660129c4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f87b7863562546abb90da37f1a4f397d55fbd3bb44d1947209aa5db3660129c4.mp4',
          name: 'BEG-INT-ADV-Bodyweight_Sumo_Squats_with_Row-WARM_UP',
          description: null,
          size: 1604360,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2556,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'eea6386d57d523b25da58ee822d12879b1599ee9b7e95b014d593345d617db39',
          file_name:
            'audios/eea6386d57d523b25da58ee822d12879b1599ee9b7e95b014d593345d617db39.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eea6386d57d523b25da58ee822d12879b1599ee9b7e95b014d593345d617db39.mp3',
          name: 'BEG-INT-ADV-Bodyweight_Sumo_Squats_with_Row-WARM_UP',
          description: null,
          size: 36032,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ALTERNATING_FOOT_SLAPS_WITH_HOP-WARM_UP': {
      id: 1050,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Alternating Foot Slaps With Hop',
      short_name: 'Alternating Foot Slaps With Hop',
      unique_name: 'BEGINNER-ALTERNATING_FOOT_SLAPS_WITH_HOP-WARM_UP',
      description:
        '1. Stand with your feet wider than hip-width apart, toes point forward, arms above your head in a "V"\n2. Bend both knees and transfer all your weight onto one leg.\n3. Lift your opposite knee and kick your foot toward your midline. Tap your foot with the opposite arm as you hop on your standing leg. \n4. Lower foot and raise arm back up to start. Repeat other side. Right and left is one rep.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2716,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '121b123e2d171c67f8b80eca57b47bff6bfbd25f7ba4b77d2ee9f2cd305a6ac0',
          file_name:
            'videos/121b123e2d171c67f8b80eca57b47bff6bfbd25f7ba4b77d2ee9f2cd305a6ac0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/121b123e2d171c67f8b80eca57b47bff6bfbd25f7ba4b77d2ee9f2cd305a6ac0.mp4',
          name: 'BEG-INT-ADV-Alternating_Foot_Slaps_With_Hop-WARM_UP',
          description: null,
          size: 2348429,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3033,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'beb202f7117b989cad6e765a47c09b11bb03e6bc6e57b0502adc55280f44576b',
          file_name:
            'audios/beb202f7117b989cad6e765a47c09b11bb03e6bc6e57b0502adc55280f44576b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/beb202f7117b989cad6e765a47c09b11bb03e6bc6e57b0502adc55280f44576b.mp3',
          name: 'BEG-INT-ADV-Alternating_Foot_Slaps_With_Hop-WARM_UP',
          description: null,
          size: 32959,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_FOOT_SLAPS_WITH_HOP-WARM_UP': {
      id: 1051,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Alternating Foot Slaps With Hop',
      short_name: 'Alternating Foot Slaps With Hop',
      unique_name: 'INTERMEDIATE-ALTERNATING_FOOT_SLAPS_WITH_HOP-WARM_UP',
      description:
        '1. Stand with your feet wider than hip-width apart, toes point forward, arms above your head in a "V"\n2. Bend both knees and transfer all your weight onto one leg.\n3. Lift your opposite knee and kick your foot toward your midline. Tap your foot with the opposite arm as you hop on your standing leg. \n4. Lower foot and raise arm back up to start. Repeat other side. Right and left is one rep.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2718,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '121b123e2d171c67f8b80eca57b47bff6bfbd25f7ba4b77d2ee9f2cd305a6ac0',
          file_name:
            'videos/121b123e2d171c67f8b80eca57b47bff6bfbd25f7ba4b77d2ee9f2cd305a6ac0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/121b123e2d171c67f8b80eca57b47bff6bfbd25f7ba4b77d2ee9f2cd305a6ac0.mp4',
          name: 'BEG-INT-ADV-Alternating_Foot_Slaps_With_Hop-WARM_UP',
          description: null,
          size: 2348429,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3034,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'beb202f7117b989cad6e765a47c09b11bb03e6bc6e57b0502adc55280f44576b',
          file_name:
            'audios/beb202f7117b989cad6e765a47c09b11bb03e6bc6e57b0502adc55280f44576b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/beb202f7117b989cad6e765a47c09b11bb03e6bc6e57b0502adc55280f44576b.mp3',
          name: 'BEG-INT-ADV-Alternating_Foot_Slaps_With_Hop-WARM_UP',
          description: null,
          size: 32959,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_FOOT_SLAPS_WITH_HOP-WARM_UP': {
      id: 1052,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Alternating Foot Slaps With Hop',
      short_name: 'Alternating Foot Slaps With Hop',
      unique_name: 'ADVANCED-ALTERNATING_FOOT_SLAPS_WITH_HOP-WARM_UP',
      description:
        '1. Stand with your feet wider than hip-width apart, toes point forward, arms above your head in a "V"\n2. Bend both knees and transfer all your weight onto one leg.\n3. Lift your opposite knee and kick your foot toward your midline. Tap your foot with the opposite arm as you hop on your standing leg. \n4. Lower foot and raise arm back up to start. Repeat other side. Right and left is one rep.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2720,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '121b123e2d171c67f8b80eca57b47bff6bfbd25f7ba4b77d2ee9f2cd305a6ac0',
          file_name:
            'videos/121b123e2d171c67f8b80eca57b47bff6bfbd25f7ba4b77d2ee9f2cd305a6ac0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/121b123e2d171c67f8b80eca57b47bff6bfbd25f7ba4b77d2ee9f2cd305a6ac0.mp4',
          name: 'BEG-INT-ADV-Alternating_Foot_Slaps_With_Hop-WARM_UP',
          description: null,
          size: 2348429,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3035,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'beb202f7117b989cad6e765a47c09b11bb03e6bc6e57b0502adc55280f44576b',
          file_name:
            'audios/beb202f7117b989cad6e765a47c09b11bb03e6bc6e57b0502adc55280f44576b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/beb202f7117b989cad6e765a47c09b11bb03e6bc6e57b0502adc55280f44576b.mp3',
          name: 'BEG-INT-ADV-Alternating_Foot_Slaps_With_Hop-WARM_UP',
          description: null,
          size: 32959,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ANKLE_BOUNCE-WARM_UP': {
      id: 1053,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Ankle Bounce',
      short_name: 'Ankle Bounce',
      unique_name: 'BEGINNER-ANKLE_BOUNCE-WARM_UP',
      description:
        '1. Stand tall with your feet hip-width apart.\n2. Bend knees and bounce both feet up off the floor, legs straight. \n3. Land soft and slightly rock back into your heels to feel a stretch. Continue in a quick repetive motion. String reps together.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2722,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '7124f2234ea016f5c9f1efafaeda3d1b4cf458b0ca9423436021c3099eaac54d',
          file_name:
            'videos/7124f2234ea016f5c9f1efafaeda3d1b4cf458b0ca9423436021c3099eaac54d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7124f2234ea016f5c9f1efafaeda3d1b4cf458b0ca9423436021c3099eaac54d.mp4',
          name: 'BEG-INT-ADV-Ankle_Bounce-WARM_UP',
          description: null,
          size: 1369053,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3036,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'b9775a8f0729b0d268bb99db42a14972a518201938fc01c5a15b44297d36998f',
          file_name:
            'audios/b9775a8f0729b0d268bb99db42a14972a518201938fc01c5a15b44297d36998f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b9775a8f0729b0d268bb99db42a14972a518201938fc01c5a15b44297d36998f.mp3',
          name: 'BEG-INT-ADV-Ankle_Bounce-WARM_UP',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ANKLE_BOUNCE-WARM_UP': {
      id: 1054,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Ankle Bounce',
      short_name: 'Ankle Bounce',
      unique_name: 'INTERMEDIATE-ANKLE_BOUNCE-WARM_UP',
      description:
        '1. Stand tall with your feet hip-width apart.\n2. Bend knees and bounce both feet up off the floor, legs straight. \n3. Land soft and slightly rock back into your heels to feel a stretch. Continue in a quick repetive motion. String reps together.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2724,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '7124f2234ea016f5c9f1efafaeda3d1b4cf458b0ca9423436021c3099eaac54d',
          file_name:
            'videos/7124f2234ea016f5c9f1efafaeda3d1b4cf458b0ca9423436021c3099eaac54d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7124f2234ea016f5c9f1efafaeda3d1b4cf458b0ca9423436021c3099eaac54d.mp4',
          name: 'BEG-INT-ADV-Ankle_Bounce-WARM_UP',
          description: null,
          size: 1369053,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3037,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'b9775a8f0729b0d268bb99db42a14972a518201938fc01c5a15b44297d36998f',
          file_name:
            'audios/b9775a8f0729b0d268bb99db42a14972a518201938fc01c5a15b44297d36998f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b9775a8f0729b0d268bb99db42a14972a518201938fc01c5a15b44297d36998f.mp3',
          name: 'BEG-INT-ADV-Ankle_Bounce-WARM_UP',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ANKLE_BOUNCE-WARM_UP': {
      id: 1055,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Ankle Bounce',
      short_name: 'Ankle Bounce',
      unique_name: 'ADVANCED-ANKLE_BOUNCE-WARM_UP',
      description:
        '1. Stand tall with your feet hip-width apart.\n2. Bend knees and bounce both feet up off the floor, legs straight. \n3. Land soft and slightly rock back into your heels to feel a stretch. Continue in a quick repetive motion. String reps together.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2726,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '7124f2234ea016f5c9f1efafaeda3d1b4cf458b0ca9423436021c3099eaac54d',
          file_name:
            'videos/7124f2234ea016f5c9f1efafaeda3d1b4cf458b0ca9423436021c3099eaac54d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7124f2234ea016f5c9f1efafaeda3d1b4cf458b0ca9423436021c3099eaac54d.mp4',
          name: 'BEG-INT-ADV-Ankle_Bounce-WARM_UP',
          description: null,
          size: 1369053,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3038,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'b9775a8f0729b0d268bb99db42a14972a518201938fc01c5a15b44297d36998f',
          file_name:
            'audios/b9775a8f0729b0d268bb99db42a14972a518201938fc01c5a15b44297d36998f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b9775a8f0729b0d268bb99db42a14972a518201938fc01c5a15b44297d36998f.mp3',
          name: 'BEG-INT-ADV-Ankle_Bounce-WARM_UP',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ANKLE_CIRCLES-WARM_UP': {
      id: 1056,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Ankle Circles',
      short_name: 'Ankle Circles',
      unique_name: 'BEGINNER-ANKLE_CIRCLES-WARM_UP',
      description:
        '1. Stand tall with your feet hip-width apart. \n2. Transfer your weight to one leg and rest the opposite toe on the floor, heel raised.\n3. Trace large circles with your ankle, using your toe as the anchor.\n4. Reverse the motion and circle the other direction. Repeat on other leg.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2728,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '0d8c64f8575de1162ab954712c2f104b4dd340ca79285fc988f843d812f8203a',
          file_name:
            'videos/0d8c64f8575de1162ab954712c2f104b4dd340ca79285fc988f843d812f8203a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0d8c64f8575de1162ab954712c2f104b4dd340ca79285fc988f843d812f8203a.mp4',
          name: 'BEG-INT-ADV-Ankle_Circles-WARM_UP',
          description: null,
          size: 908028,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3039,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'bd6fda6976913b97cf72cdbfc2fcca2f2863c8e77565517f43352eb83dbb6589',
          file_name:
            'audios/bd6fda6976913b97cf72cdbfc2fcca2f2863c8e77565517f43352eb83dbb6589.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/bd6fda6976913b97cf72cdbfc2fcca2f2863c8e77565517f43352eb83dbb6589.mp3',
          name: 'BEG-INT-ADV-Ankle_Circles-WARM_UP',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ANKLE_CIRCLES-WARM_UP': {
      id: 1057,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Ankle Circles',
      short_name: 'Ankle Circles',
      unique_name: 'INTERMEDIATE-ANKLE_CIRCLES-WARM_UP',
      description:
        '1. Stand tall with your feet hip-width apart. \n2. Transfer your weight to one leg and rest the opposite toe on the floor, heel raised.\n3. Trace large circles with your ankle, using your toe as the anchor.\n4. Reverse the motion and circle the other direction. Repeat on other leg.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2730,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '0d8c64f8575de1162ab954712c2f104b4dd340ca79285fc988f843d812f8203a',
          file_name:
            'videos/0d8c64f8575de1162ab954712c2f104b4dd340ca79285fc988f843d812f8203a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0d8c64f8575de1162ab954712c2f104b4dd340ca79285fc988f843d812f8203a.mp4',
          name: 'BEG-INT-ADV-Ankle_Circles-WARM_UP',
          description: null,
          size: 908028,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3040,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'bd6fda6976913b97cf72cdbfc2fcca2f2863c8e77565517f43352eb83dbb6589',
          file_name:
            'audios/bd6fda6976913b97cf72cdbfc2fcca2f2863c8e77565517f43352eb83dbb6589.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/bd6fda6976913b97cf72cdbfc2fcca2f2863c8e77565517f43352eb83dbb6589.mp3',
          name: 'BEG-INT-ADV-Ankle_Circles-WARM_UP',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ANKLE_CIRCLES-WARM_UP': {
      id: 1058,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Ankle Circles',
      short_name: 'Ankle Circles',
      unique_name: 'ADVANCED-ANKLE_CIRCLES-WARM_UP',
      description:
        '1. Stand tall with your feet hip-width apart. \n2. Transfer your weight to one leg and rest the opposite toe on the floor, heel raised.\n3. Trace large circles with your ankle, using your toe as the anchor.\n4. Reverse the motion and circle the other direction. Repeat on other leg.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2732,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '0d8c64f8575de1162ab954712c2f104b4dd340ca79285fc988f843d812f8203a',
          file_name:
            'videos/0d8c64f8575de1162ab954712c2f104b4dd340ca79285fc988f843d812f8203a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0d8c64f8575de1162ab954712c2f104b4dd340ca79285fc988f843d812f8203a.mp4',
          name: 'BEG-INT-ADV-Ankle_Circles-WARM_UP',
          description: null,
          size: 908028,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3041,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'bd6fda6976913b97cf72cdbfc2fcca2f2863c8e77565517f43352eb83dbb6589',
          file_name:
            'audios/bd6fda6976913b97cf72cdbfc2fcca2f2863c8e77565517f43352eb83dbb6589.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/bd6fda6976913b97cf72cdbfc2fcca2f2863c8e77565517f43352eb83dbb6589.mp3',
          name: 'BEG-INT-ADV-Ankle_Circles-WARM_UP',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ANKLE_ROCKS-WARM_UP': {
      id: 1059,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Ankle Rocks',
      short_name: 'Ankle Rocks',
      unique_name: 'BEGINNER-ANKLE_ROCKS-WARM_UP',
      description:
        '1. Stand tall with your feet hip-width apart. \n2. Transfer your weight forward and rock up onto your tip-toes. \n3. Slowly return to standing and rock back into your heels and flex your ankle up, toes toward your face. Feel the stretch. \n4. Continue to rock back in a controlled, continous motion. Make sure to articulate all areas of your foot as you rock. Front, Mid, Heel.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2734,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'f2c089457278bf4196093966207e3b3b8f1624107dec87d41b3eab26081ae974',
          file_name:
            'videos/f2c089457278bf4196093966207e3b3b8f1624107dec87d41b3eab26081ae974.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f2c089457278bf4196093966207e3b3b8f1624107dec87d41b3eab26081ae974.mp4',
          name: 'BEG-INT-ADV-Ankle_Rocks-WARM_UP',
          description: null,
          size: 821630,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3042,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'a04165d338df6fc37957444a10caf36b63eed326d31339c1b34297e9900d3520',
          file_name:
            'audios/a04165d338df6fc37957444a10caf36b63eed326d31339c1b34297e9900d3520.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a04165d338df6fc37957444a10caf36b63eed326d31339c1b34297e9900d3520.mp3',
          name: 'BEG-INT-ADV-Ankle_Rocks-WARM_UP',
          description: null,
          size: 17901,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ANKLE_ROCKS-WARM_UP': {
      id: 1060,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Ankle Rocks',
      short_name: 'Ankle Rocks',
      unique_name: 'INTERMEDIATE-ANKLE_ROCKS-WARM_UP',
      description:
        '1. Stand tall with your feet hip-width apart. \n2. Transfer your weight forward and rock up onto your tip-toes. \n3. Slowly return to standing and rock back into your heels and flex your ankle up, toes toward your face. Feel the stretch. \n4. Continue to rock back in a controlled, continous motion. Make sure to articulate all areas of your foot as you rock. Front, Mid, Heel.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2736,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'f2c089457278bf4196093966207e3b3b8f1624107dec87d41b3eab26081ae974',
          file_name:
            'videos/f2c089457278bf4196093966207e3b3b8f1624107dec87d41b3eab26081ae974.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f2c089457278bf4196093966207e3b3b8f1624107dec87d41b3eab26081ae974.mp4',
          name: 'BEG-INT-ADV-Ankle_Rocks-WARM_UP',
          description: null,
          size: 821630,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3043,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'a04165d338df6fc37957444a10caf36b63eed326d31339c1b34297e9900d3520',
          file_name:
            'audios/a04165d338df6fc37957444a10caf36b63eed326d31339c1b34297e9900d3520.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a04165d338df6fc37957444a10caf36b63eed326d31339c1b34297e9900d3520.mp3',
          name: 'BEG-INT-ADV-Ankle_Rocks-WARM_UP',
          description: null,
          size: 17901,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ANKLE_ROCKS-WARM_UP': {
      id: 1061,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Ankle Rocks',
      short_name: 'Ankle Rocks',
      unique_name: 'ADVANCED-ANKLE_ROCKS-WARM_UP',
      description:
        '1. Stand tall with your feet hip-width apart. \n2. Transfer your weight forward and rock up onto your tip-toes. \n3. Slowly return to standing and rock back into your heels and flex your ankle up, toes toward your face. Feel the stretch. \n4. Continue to rock back in a controlled, continous motion. Make sure to articulate all areas of your foot as you rock. Front, Mid, Heel.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2738,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'f2c089457278bf4196093966207e3b3b8f1624107dec87d41b3eab26081ae974',
          file_name:
            'videos/f2c089457278bf4196093966207e3b3b8f1624107dec87d41b3eab26081ae974.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f2c089457278bf4196093966207e3b3b8f1624107dec87d41b3eab26081ae974.mp4',
          name: 'BEG-INT-ADV-Ankle_Rocks-WARM_UP',
          description: null,
          size: 821630,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3044,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'a04165d338df6fc37957444a10caf36b63eed326d31339c1b34297e9900d3520',
          file_name:
            'audios/a04165d338df6fc37957444a10caf36b63eed326d31339c1b34297e9900d3520.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a04165d338df6fc37957444a10caf36b63eed326d31339c1b34297e9900d3520.mp3',
          name: 'BEG-INT-ADV-Ankle_Rocks-WARM_UP',
          description: null,
          size: 17901,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-KNEE_CIRCLES-WARM_UP': {
      id: 1070,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Knee Circles',
      short_name: 'Knee Circles',
      unique_name: 'BEGINNER-KNEE_CIRCLES-WARM_UP',
      description:
        '1. Stand with your feet together, knees soft and place your hands on your knees. \n2. Keeping hips and shoulders square, engage your core and draw large circles with your knees in one direction.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2761,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'b2ddbb0368e1beb676661437a36be66ecc316efab8165c8a6ebb48a1b063031f',
          file_name:
            'videos/b2ddbb0368e1beb676661437a36be66ecc316efab8165c8a6ebb48a1b063031f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b2ddbb0368e1beb676661437a36be66ecc316efab8165c8a6ebb48a1b063031f.mp4',
          name: 'BEG-INT-ADV-Knee_Circles-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 512962,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2762,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'b922b283bc16423119d9ce4194660291ebaac4c617f53dd9948eb37862512d95',
          file_name:
            'videos/b922b283bc16423119d9ce4194660291ebaac4c617f53dd9948eb37862512d95.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b922b283bc16423119d9ce4194660291ebaac4c617f53dd9948eb37862512d95.mp4',
          name: 'BEG-INT-ADV-Knee_Circles-WARM_UP-LEFT',
          description: 'Left Side',
          size: 497148,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3053,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'eb4042da627808a5e782469d8fb5fbdc0c26b3d55425b3dfe76ccb28426eef4a',
          file_name:
            'audios/eb4042da627808a5e782469d8fb5fbdc0c26b3d55425b3dfe76ccb28426eef4a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eb4042da627808a5e782469d8fb5fbdc0c26b3d55425b3dfe76ccb28426eef4a.mp3',
          name: 'BEG-INT-ADV-Knee_Circles-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KNEE_CIRCLES-WARM_UP': {
      id: 1071,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Knee Circles',
      short_name: 'Knee Circles',
      unique_name: 'INTERMEDIATE-KNEE_CIRCLES-WARM_UP',
      description:
        '1. Stand with your feet together, knees soft and place your hands on your knees. \n2. Keeping hips and shoulders square, engage your core and draw large circles with your knees in one direction.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2764,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'b2ddbb0368e1beb676661437a36be66ecc316efab8165c8a6ebb48a1b063031f',
          file_name:
            'videos/b2ddbb0368e1beb676661437a36be66ecc316efab8165c8a6ebb48a1b063031f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b2ddbb0368e1beb676661437a36be66ecc316efab8165c8a6ebb48a1b063031f.mp4',
          name: 'BEG-INT-ADV-Knee_Circles-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 512962,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2765,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'b922b283bc16423119d9ce4194660291ebaac4c617f53dd9948eb37862512d95',
          file_name:
            'videos/b922b283bc16423119d9ce4194660291ebaac4c617f53dd9948eb37862512d95.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b922b283bc16423119d9ce4194660291ebaac4c617f53dd9948eb37862512d95.mp4',
          name: 'BEG-INT-ADV-Knee_Circles-WARM_UP-LEFT',
          description: 'Left Side',
          size: 497148,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3054,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'eb4042da627808a5e782469d8fb5fbdc0c26b3d55425b3dfe76ccb28426eef4a',
          file_name:
            'audios/eb4042da627808a5e782469d8fb5fbdc0c26b3d55425b3dfe76ccb28426eef4a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eb4042da627808a5e782469d8fb5fbdc0c26b3d55425b3dfe76ccb28426eef4a.mp3',
          name: 'BEG-INT-ADV-Knee_Circles-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KNEE_CIRCLES-WARM_UP': {
      id: 1072,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Knee Circles',
      short_name: 'Knee Circles',
      unique_name: 'ADVANCED-KNEE_CIRCLES-WARM_UP',
      description:
        '1. Stand with your feet together, knees soft and place your hands on your knees. \n2. Keeping hips and shoulders square, engage your core and draw large circles with your knees in one direction.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2767,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'b2ddbb0368e1beb676661437a36be66ecc316efab8165c8a6ebb48a1b063031f',
          file_name:
            'videos/b2ddbb0368e1beb676661437a36be66ecc316efab8165c8a6ebb48a1b063031f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b2ddbb0368e1beb676661437a36be66ecc316efab8165c8a6ebb48a1b063031f.mp4',
          name: 'BEG-INT-ADV-Knee_Circles-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 512962,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2768,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'b922b283bc16423119d9ce4194660291ebaac4c617f53dd9948eb37862512d95',
          file_name:
            'videos/b922b283bc16423119d9ce4194660291ebaac4c617f53dd9948eb37862512d95.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b922b283bc16423119d9ce4194660291ebaac4c617f53dd9948eb37862512d95.mp4',
          name: 'BEG-INT-ADV-Knee_Circles-WARM_UP-LEFT',
          description: 'Left Side',
          size: 497148,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3055,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'eb4042da627808a5e782469d8fb5fbdc0c26b3d55425b3dfe76ccb28426eef4a',
          file_name:
            'audios/eb4042da627808a5e782469d8fb5fbdc0c26b3d55425b3dfe76ccb28426eef4a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eb4042da627808a5e782469d8fb5fbdc0c26b3d55425b3dfe76ccb28426eef4a.mp3',
          name: 'BEG-INT-ADV-Knee_Circles-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-NECK_ROLLS-WARM_UP': {
      id: 1073,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Neck Rolls',
      short_name: 'Neck Rolls',
      unique_name: 'BEGINNER-NECK_ROLLS-WARM_UP',
      description:
        '1. Stand with feet hip-width apart and arms by your sides. \n2. Slowly drop your chin toward your chest, while keeping a neutral spine and shoulders out of your ears. \n3. Drawing a circle, rotate your neck to one side, lift your chin as you roll to the back and then rotate to the opposite side. \n4. Continue rolling your neck in a continous motion. Repeat other direction.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 18,
          unique_name: 'TRAPS',
          name: 'Traps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2770,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'a60de304a83dd7fedbfbd4f48a9ebba210e0529ba2535fa13474976df811887f',
          file_name:
            'videos/a60de304a83dd7fedbfbd4f48a9ebba210e0529ba2535fa13474976df811887f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a60de304a83dd7fedbfbd4f48a9ebba210e0529ba2535fa13474976df811887f.mp4',
          name: 'BEG-INT-ADV-Neck_Rolls-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 418731,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2771,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '9f71819b73beb8eb924885341f9c2461e3898a8a6ac4f81bc6a7170aea711d0d',
          file_name:
            'videos/9f71819b73beb8eb924885341f9c2461e3898a8a6ac4f81bc6a7170aea711d0d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9f71819b73beb8eb924885341f9c2461e3898a8a6ac4f81bc6a7170aea711d0d.mp4',
          name: 'BEG-INT-ADV-Neck_Rolls-WARM_UP-LEFT',
          description: 'Left Side',
          size: 405105,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3056,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '652d1db5faa76d93e403a9345b22c32de1ea51fd3535c2c8382a6195002de3de',
          file_name:
            'audios/652d1db5faa76d93e403a9345b22c32de1ea51fd3535c2c8382a6195002de3de.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/652d1db5faa76d93e403a9345b22c32de1ea51fd3535c2c8382a6195002de3de.mp3',
          name: 'BEG-INT-ADV-Neck_Rolls-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 20781,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-NECK_ROLLS-WARM_UP': {
      id: 1074,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Neck Rolls',
      short_name: 'Neck Rolls',
      unique_name: 'INTERMEDIATE-NECK_ROLLS-WARM_UP',
      description:
        '1. Stand with feet hip-width apart and arms by your sides. \n2. Slowly drop your chin toward your chest, while keeping a neutral spine and shoulders out of your ears. \n3. Drawing a circle, rotate your neck to one side, lift your chin as you roll to the back and then rotate to the opposite side. \n4. Continue rolling your neck in a continous motion. Repeat other direction.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 18,
          unique_name: 'TRAPS',
          name: 'Traps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2773,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'a60de304a83dd7fedbfbd4f48a9ebba210e0529ba2535fa13474976df811887f',
          file_name:
            'videos/a60de304a83dd7fedbfbd4f48a9ebba210e0529ba2535fa13474976df811887f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a60de304a83dd7fedbfbd4f48a9ebba210e0529ba2535fa13474976df811887f.mp4',
          name: 'BEG-INT-ADV-Neck_Rolls-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 418731,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2774,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '9f71819b73beb8eb924885341f9c2461e3898a8a6ac4f81bc6a7170aea711d0d',
          file_name:
            'videos/9f71819b73beb8eb924885341f9c2461e3898a8a6ac4f81bc6a7170aea711d0d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9f71819b73beb8eb924885341f9c2461e3898a8a6ac4f81bc6a7170aea711d0d.mp4',
          name: 'BEG-INT-ADV-Neck_Rolls-WARM_UP-LEFT',
          description: 'Left Side',
          size: 405105,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3057,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '652d1db5faa76d93e403a9345b22c32de1ea51fd3535c2c8382a6195002de3de',
          file_name:
            'audios/652d1db5faa76d93e403a9345b22c32de1ea51fd3535c2c8382a6195002de3de.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/652d1db5faa76d93e403a9345b22c32de1ea51fd3535c2c8382a6195002de3de.mp3',
          name: 'BEG-INT-ADV-Neck_Rolls-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 20781,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-NECK_ROLLS-WARM_UP': {
      id: 1075,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Neck Rolls',
      short_name: 'Neck Rolls',
      unique_name: 'ADVANCED-NECK_ROLLS-WARM_UP',
      description:
        '1. Stand with feet hip-width apart and arms by your sides. \n2. Slowly drop your chin toward your chest, while keeping a neutral spine and shoulders out of your ears. \n3. Drawing a circle, rotate your neck to one side, lift your chin as you roll to the back and then rotate to the opposite side. \n4. Continue rolling your neck in a continous motion. Repeat other direction.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 18,
          unique_name: 'TRAPS',
          name: 'Traps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2776,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'a60de304a83dd7fedbfbd4f48a9ebba210e0529ba2535fa13474976df811887f',
          file_name:
            'videos/a60de304a83dd7fedbfbd4f48a9ebba210e0529ba2535fa13474976df811887f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a60de304a83dd7fedbfbd4f48a9ebba210e0529ba2535fa13474976df811887f.mp4',
          name: 'BEG-INT-ADV-Neck_Rolls-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 418731,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2777,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '9f71819b73beb8eb924885341f9c2461e3898a8a6ac4f81bc6a7170aea711d0d',
          file_name:
            'videos/9f71819b73beb8eb924885341f9c2461e3898a8a6ac4f81bc6a7170aea711d0d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9f71819b73beb8eb924885341f9c2461e3898a8a6ac4f81bc6a7170aea711d0d.mp4',
          name: 'BEG-INT-ADV-Neck_Rolls-WARM_UP-LEFT',
          description: 'Left Side',
          size: 405105,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3058,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '652d1db5faa76d93e403a9345b22c32de1ea51fd3535c2c8382a6195002de3de',
          file_name:
            'audios/652d1db5faa76d93e403a9345b22c32de1ea51fd3535c2c8382a6195002de3de.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/652d1db5faa76d93e403a9345b22c32de1ea51fd3535c2c8382a6195002de3de.mp3',
          name: 'BEG-INT-ADV-Neck_Rolls-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 20781,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-STEP_TO_HAMSTRING_CURL_WITH_LAT_PULL-WARM_UP': {
      id: 1078,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Step to Hamstring Curl with Lat Pull',
      short_name: 'Step to Curl with Lat Pull',
      unique_name: 'BEGINNER-STEP_TO_HAMSTRING_CURL_WITH_LAT_PULL-WARM_UP',
      description:
        '1. Stand with feet wider than hip-width apart, toes point forward, arms stretched straight in front of you to shoulder height. \n2. Bend both knees and perform a mini squat.\n3. As you come up, transfer all your weight onto one leg and curl your other heel toward your backside. Bend both elbows and row arms back, elbows wide. \n4. Return arms and leg back to start. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2783,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '221c1ac705313c0919cae69bdef63c236805b8f14844bac39aea1c88405cade2',
          file_name:
            'videos/221c1ac705313c0919cae69bdef63c236805b8f14844bac39aea1c88405cade2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/221c1ac705313c0919cae69bdef63c236805b8f14844bac39aea1c88405cade2.mp4',
          name: 'BEG-INT-ADV-Step_to_Hamstring_Curl_with_Lat_Pull-WARM_UP',
          description: null,
          size: 1510520,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3061,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '98e33e3fd2f9a45455b800c0074bb3fea1b54af429dad38d3308f13d212dad57',
          file_name:
            'audios/98e33e3fd2f9a45455b800c0074bb3fea1b54af429dad38d3308f13d212dad57.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/98e33e3fd2f9a45455b800c0074bb3fea1b54af429dad38d3308f13d212dad57.mp3',
          name: 'BEG-INT-ADV-Step_to_Hamstring_Curl_with_Lat_Pull-WARM_UP',
          description: null,
          size: 40365,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-STEP_TO_HAMSTRING_CURL_WITH_LAT_PULL-WARM_UP': {
      id: 1079,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Step to Hamstring Curl with Lat Pull',
      short_name: 'Step to Curl with Lat Pull',
      unique_name: 'INTERMEDIATE-STEP_TO_HAMSTRING_CURL_WITH_LAT_PULL-WARM_UP',
      description:
        '1. Stand with feet wider than hip-width apart, toes point forward, arms stretched straight in front of you to shoulder height. \n2. Bend both knees and perform a mini squat.\n3. As you come up, transfer all your weight onto one leg and curl your other heel toward your backside. Bend both elbows and row arms back, elbows wide. \n4. Return arms and leg back to start. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2785,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '221c1ac705313c0919cae69bdef63c236805b8f14844bac39aea1c88405cade2',
          file_name:
            'videos/221c1ac705313c0919cae69bdef63c236805b8f14844bac39aea1c88405cade2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/221c1ac705313c0919cae69bdef63c236805b8f14844bac39aea1c88405cade2.mp4',
          name: 'BEG-INT-ADV-Step_to_Hamstring_Curl_with_Lat_Pull-WARM_UP',
          description: null,
          size: 1510520,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3062,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '98e33e3fd2f9a45455b800c0074bb3fea1b54af429dad38d3308f13d212dad57',
          file_name:
            'audios/98e33e3fd2f9a45455b800c0074bb3fea1b54af429dad38d3308f13d212dad57.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/98e33e3fd2f9a45455b800c0074bb3fea1b54af429dad38d3308f13d212dad57.mp3',
          name: 'BEG-INT-ADV-Step_to_Hamstring_Curl_with_Lat_Pull-WARM_UP',
          description: null,
          size: 40365,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-STEP_TO_HAMSTRING_CURL_WITH_LAT_PULL-WARM_UP': {
      id: 1080,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Step to Hamstring Curl with Lat Pull',
      short_name: 'Step to Curl with Lat Pull',
      unique_name: 'ADVANCED-STEP_TO_HAMSTRING_CURL_WITH_LAT_PULL-WARM_UP',
      description:
        '1. Stand with feet wider than hip-width apart, toes point forward, arms stretched straight in front of you to shoulder height. \n2. Bend both knees and perform a mini squat.\n3. As you come up, transfer all your weight onto one leg and curl your other heel toward your backside. Bend both elbows and row arms back, elbows wide. \n4. Return arms and leg back to start. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2787,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '221c1ac705313c0919cae69bdef63c236805b8f14844bac39aea1c88405cade2',
          file_name:
            'videos/221c1ac705313c0919cae69bdef63c236805b8f14844bac39aea1c88405cade2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/221c1ac705313c0919cae69bdef63c236805b8f14844bac39aea1c88405cade2.mp4',
          name: 'BEG-INT-ADV-Step_to_Hamstring_Curl_with_Lat_Pull-WARM_UP',
          description: null,
          size: 1510520,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3063,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '98e33e3fd2f9a45455b800c0074bb3fea1b54af429dad38d3308f13d212dad57',
          file_name:
            'audios/98e33e3fd2f9a45455b800c0074bb3fea1b54af429dad38d3308f13d212dad57.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/98e33e3fd2f9a45455b800c0074bb3fea1b54af429dad38d3308f13d212dad57.mp3',
          name: 'BEG-INT-ADV-Step_to_Hamstring_Curl_with_Lat_Pull-WARM_UP',
          description: null,
          size: 40365,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-A_SKIPS-WARM_UP': {
      id: 1085,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'A Skips',
      short_name: 'A Skips',
      unique_name: 'BEGINNER-A_SKIPS-WARM_UP',
      description:
        '1. Stand tall with feet hip-width apart. \n2. Raise one leg to hip height. Knee bent and skip on the ball of opposite foot. Your arms follow your leg movement as if running. \n3. Return foot back down and repeat the skip on the opposite side. \n4. Skip in a continous motion for time.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2797,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'db96666e3d2482690905bdc60e9df56c6a6b712c8fd59023635f74bc461648bc',
          file_name:
            'videos/db96666e3d2482690905bdc60e9df56c6a6b712c8fd59023635f74bc461648bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/db96666e3d2482690905bdc60e9df56c6a6b712c8fd59023635f74bc461648bc.mp4',
          name: 'BEG-INT-ADV-A_Skips-WARM_UP',
          description: null,
          size: 1856487,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3068,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'ab87aef324a0d7dfcbfe32247eab102fb8e2e9eb130ec75156d6deadab127301',
          file_name:
            'audios/ab87aef324a0d7dfcbfe32247eab102fb8e2e9eb130ec75156d6deadab127301.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ab87aef324a0d7dfcbfe32247eab102fb8e2e9eb130ec75156d6deadab127301.mp3',
          name: 'BEG-INT-ADV-A_Skips-WARM_UP',
          description: null,
          size: 17901,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-A_SKIPS-WARM_UP': {
      id: 1086,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'A Skips',
      short_name: 'A Skips',
      unique_name: 'INTERMEDIATE-A_SKIPS-WARM_UP',
      description:
        '1. Stand tall with feet hip-width apart. \n2. Raise one leg to hip height. Knee bent and skip on the ball of opposite foot. Your arms follow your leg movement as if running. \n3. Return foot back down and repeat the skip on the opposite side. \n4. Skip in a continous motion for time.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2799,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'db96666e3d2482690905bdc60e9df56c6a6b712c8fd59023635f74bc461648bc',
          file_name:
            'videos/db96666e3d2482690905bdc60e9df56c6a6b712c8fd59023635f74bc461648bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/db96666e3d2482690905bdc60e9df56c6a6b712c8fd59023635f74bc461648bc.mp4',
          name: 'BEG-INT-ADV-A_Skips-WARM_UP',
          description: null,
          size: 1856487,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3069,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'ab87aef324a0d7dfcbfe32247eab102fb8e2e9eb130ec75156d6deadab127301',
          file_name:
            'audios/ab87aef324a0d7dfcbfe32247eab102fb8e2e9eb130ec75156d6deadab127301.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ab87aef324a0d7dfcbfe32247eab102fb8e2e9eb130ec75156d6deadab127301.mp3',
          name: 'BEG-INT-ADV-A_Skips-WARM_UP',
          description: null,
          size: 17901,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-A_SKIPS-WARM_UP': {
      id: 1087,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'A Skips',
      short_name: 'A Skips',
      unique_name: 'ADVANCED-A_SKIPS-WARM_UP',
      description:
        '1. Stand tall with feet hip-width apart. \n2. Raise one leg to hip height. Knee bent and skip on the ball of opposite foot. Your arms follow your leg movement as if running. \n3. Return foot back down and repeat the skip on the opposite side. \n4. Skip in a continous motion for time.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2801,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'db96666e3d2482690905bdc60e9df56c6a6b712c8fd59023635f74bc461648bc',
          file_name:
            'videos/db96666e3d2482690905bdc60e9df56c6a6b712c8fd59023635f74bc461648bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/db96666e3d2482690905bdc60e9df56c6a6b712c8fd59023635f74bc461648bc.mp4',
          name: 'BEG-INT-ADV-A_Skips-WARM_UP',
          description: null,
          size: 1856487,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3070,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'ab87aef324a0d7dfcbfe32247eab102fb8e2e9eb130ec75156d6deadab127301',
          file_name:
            'audios/ab87aef324a0d7dfcbfe32247eab102fb8e2e9eb130ec75156d6deadab127301.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ab87aef324a0d7dfcbfe32247eab102fb8e2e9eb130ec75156d6deadab127301.mp3',
          name: 'BEG-INT-ADV-A_Skips-WARM_UP',
          description: null,
          size: 17901,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ALTERNATING_LATERAL_LUNGE-WARM_UP': {
      id: 1088,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Lateral Lunge',
      short_name: 'Alternating Lateral Lunge',
      unique_name: 'BEGINNER-ALTERNATING_LATERAL_LUNGE-WARM_UP',
      description:
        '1. Stand tall in a wide stance, feet wider than shouder-width, toes forward. Hands where comfortable.  \n2. Keeping your chest up, bend one knee, shift your weight, and sink your hips down until you feel a comfortable stretch. The other leg remains straight. \n3. Return to center in your wide stance. Repeat other side. String reps together in a continous motion for time.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2803,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '41f309ffa75c59563d6bfbce25b7b7ca7797b91d5a8127044fc494760d0c77dc',
          file_name:
            'videos/41f309ffa75c59563d6bfbce25b7b7ca7797b91d5a8127044fc494760d0c77dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/41f309ffa75c59563d6bfbce25b7b7ca7797b91d5a8127044fc494760d0c77dc.mp4',
          name: 'BEG-INT-ADV-Alternating_Lateral_Lunge-WARM_UP',
          description: null,
          size: 1044749,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3071,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '872fb754b8dc899b176e84f91157615eb6d1587cf7b319073a36cac2aa6cd14d',
          file_name:
            'audios/872fb754b8dc899b176e84f91157615eb6d1587cf7b319073a36cac2aa6cd14d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/872fb754b8dc899b176e84f91157615eb6d1587cf7b319073a36cac2aa6cd14d.mp3',
          name: 'BEG-INT-ADV-Alternating_Lateral_Lunge-WARM_UP',
          description: null,
          size: 25965,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_LATERAL_LUNGE-WARM_UP': {
      id: 1089,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Lateral Lunge',
      short_name: 'Alternating Lateral Lunge',
      unique_name: 'INTERMEDIATE-ALTERNATING_LATERAL_LUNGE-WARM_UP',
      description:
        '1. Stand tall in a wide stance, feet wider than shouder-width, toes forward. Hands where comfortable.  \n2. Keeping your chest up, bend one knee, shift your weight, and sink your hips down until you feel a comfortable stretch. The other leg remains straight. \n3. Return to center in your wide stance. Repeat other side. String reps together in a continous motion for time.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2805,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '41f309ffa75c59563d6bfbce25b7b7ca7797b91d5a8127044fc494760d0c77dc',
          file_name:
            'videos/41f309ffa75c59563d6bfbce25b7b7ca7797b91d5a8127044fc494760d0c77dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/41f309ffa75c59563d6bfbce25b7b7ca7797b91d5a8127044fc494760d0c77dc.mp4',
          name: 'BEG-INT-ADV-Alternating_Lateral_Lunge-WARM_UP',
          description: null,
          size: 1044749,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3072,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '872fb754b8dc899b176e84f91157615eb6d1587cf7b319073a36cac2aa6cd14d',
          file_name:
            'audios/872fb754b8dc899b176e84f91157615eb6d1587cf7b319073a36cac2aa6cd14d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/872fb754b8dc899b176e84f91157615eb6d1587cf7b319073a36cac2aa6cd14d.mp3',
          name: 'BEG-INT-ADV-Alternating_Lateral_Lunge-WARM_UP',
          description: null,
          size: 25965,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_LATERAL_LUNGE-WARM_UP': {
      id: 1090,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Lateral Lunge',
      short_name: 'Alternating Lateral Lunge',
      unique_name: 'ADVANCED-ALTERNATING_LATERAL_LUNGE-WARM_UP',
      description:
        '1. Stand tall in a wide stance, feet wider than shouder-width, toes forward. Hands where comfortable.  \n2. Keeping your chest up, bend one knee, shift your weight, and sink your hips down until you feel a comfortable stretch. The other leg remains straight. \n3. Return to center in your wide stance. Repeat other side. String reps together in a continous motion for time.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2807,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '41f309ffa75c59563d6bfbce25b7b7ca7797b91d5a8127044fc494760d0c77dc',
          file_name:
            'videos/41f309ffa75c59563d6bfbce25b7b7ca7797b91d5a8127044fc494760d0c77dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/41f309ffa75c59563d6bfbce25b7b7ca7797b91d5a8127044fc494760d0c77dc.mp4',
          name: 'BEG-INT-ADV-Alternating_Lateral_Lunge-WARM_UP',
          description: null,
          size: 1044749,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3073,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '872fb754b8dc899b176e84f91157615eb6d1587cf7b319073a36cac2aa6cd14d',
          file_name:
            'audios/872fb754b8dc899b176e84f91157615eb6d1587cf7b319073a36cac2aa6cd14d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/872fb754b8dc899b176e84f91157615eb6d1587cf7b319073a36cac2aa6cd14d.mp3',
          name: 'BEG-INT-ADV-Alternating_Lateral_Lunge-WARM_UP',
          description: null,
          size: 25965,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHEST_OPENER-WARM_UP': {
      id: 1091,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Chest Opener',
      short_name: 'Chest Opener',
      unique_name: 'BEGINNER-CHEST_OPENER-WARM_UP',
      description:
        '1. Stand tall with feet hip-width apart. Interlace your fingers and place hands lightly on the back of your neck, elbows wide.\n2. Exhale and flex your neck and upper spine inward, chin toward your chest bringing elbows together. Pause in the stretch.\n3. Inhale and extend your spine, opening up elbows wide and expand your chest. Pause in the stretch.\n4. Repeat in a continous motion.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2809,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '93e643e78151e84bffb8afb8dd7343cbf20bdba8fe1bd330b0c05c3b85f63df4',
          file_name:
            'videos/93e643e78151e84bffb8afb8dd7343cbf20bdba8fe1bd330b0c05c3b85f63df4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/93e643e78151e84bffb8afb8dd7343cbf20bdba8fe1bd330b0c05c3b85f63df4.mp4',
          name: 'BEG-INT-ADV-Chest_Opener-WARM_UP',
          description: null,
          size: 767313,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3074,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '832834e03af88822dd7f4214c75b5b74c956fa321f6ce46b465ad685229c1148',
          file_name:
            'audios/832834e03af88822dd7f4214c75b5b74c956fa321f6ce46b465ad685229c1148.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/832834e03af88822dd7f4214c75b5b74c956fa321f6ce46b465ad685229c1148.mp3',
          name: 'BEG-INT-ADV-Chest_Opener-WARM_UP',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-CHEST_OPENER-WARM_UP': {
      id: 1092,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Chest Opener',
      short_name: 'Chest Opener',
      unique_name: 'INTERMEDIATE-CHEST_OPENER-WARM_UP',
      description:
        '1. Stand tall with feet hip-width apart. Interlace your fingers and place hands lightly on the back of your neck, elbows wide.\n2. Exhale and flex your neck and upper spine inward, chin toward your chest bringing elbows together. Pause in the stretch.\n3. Inhale and extend your spine, opening up elbows wide and expand your chest. Pause in the stretch.\n4. Repeat in a continous motion.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2811,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '93e643e78151e84bffb8afb8dd7343cbf20bdba8fe1bd330b0c05c3b85f63df4',
          file_name:
            'videos/93e643e78151e84bffb8afb8dd7343cbf20bdba8fe1bd330b0c05c3b85f63df4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/93e643e78151e84bffb8afb8dd7343cbf20bdba8fe1bd330b0c05c3b85f63df4.mp4',
          name: 'BEG-INT-ADV-Chest_Opener-WARM_UP',
          description: null,
          size: 767313,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3075,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '832834e03af88822dd7f4214c75b5b74c956fa321f6ce46b465ad685229c1148',
          file_name:
            'audios/832834e03af88822dd7f4214c75b5b74c956fa321f6ce46b465ad685229c1148.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/832834e03af88822dd7f4214c75b5b74c956fa321f6ce46b465ad685229c1148.mp3',
          name: 'BEG-INT-ADV-Chest_Opener-WARM_UP',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-CHEST_OPENER-WARM_UP': {
      id: 1093,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Chest Opener',
      short_name: 'Chest Opener',
      unique_name: 'ADVANCED-CHEST_OPENER-WARM_UP',
      description:
        '1. Stand tall with feet hip-width apart. Interlace your fingers and place hands lightly on the back of your neck, elbows wide.\n2. Exhale and flex your neck and upper spine inward, chin toward your chest bringing elbows together. Pause in the stretch.\n3. Inhale and extend your spine, opening up elbows wide and expand your chest. Pause in the stretch.\n4. Repeat in a continous motion.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2813,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '93e643e78151e84bffb8afb8dd7343cbf20bdba8fe1bd330b0c05c3b85f63df4',
          file_name:
            'videos/93e643e78151e84bffb8afb8dd7343cbf20bdba8fe1bd330b0c05c3b85f63df4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/93e643e78151e84bffb8afb8dd7343cbf20bdba8fe1bd330b0c05c3b85f63df4.mp4',
          name: 'BEG-INT-ADV-Chest_Opener-WARM_UP',
          description: null,
          size: 767313,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3076,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '832834e03af88822dd7f4214c75b5b74c956fa321f6ce46b465ad685229c1148',
          file_name:
            'audios/832834e03af88822dd7f4214c75b5b74c956fa321f6ce46b465ad685229c1148.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/832834e03af88822dd7f4214c75b5b74c956fa321f6ce46b465ad685229c1148.mp3',
          name: 'BEG-INT-ADV-Chest_Opener-WARM_UP',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SINGLE_LEG_ANKLE_BOUNCE-WARM_UP': {
      id: 1112,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Single Leg Ankle Bounce',
      short_name: 'Single Leg Ankle Bounce',
      unique_name: 'BEGINNER-SINGLE_LEG_ANKLE_BOUNCE-WARM_UP',
      description:
        '1. Stand tall with your feet hip-width apart.\n2. Transfer all weight into one leg, other foot rests lightly on the floor for balance. Bounce off the floor, keeping bottom leg straight. \n3. Land soft and slightly rock back into your heel to feel a stretch. Continue in a quick repetitive motion. String reps together. \n4. Perform all reps on one side. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2856,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '218a41bb411101992920649f1974317eb05766833b7147a3cfe90ca0d4452f9a',
          file_name:
            'videos/218a41bb411101992920649f1974317eb05766833b7147a3cfe90ca0d4452f9a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/218a41bb411101992920649f1974317eb05766833b7147a3cfe90ca0d4452f9a.mp4',
          name: 'BEG-INT-ADV-Single_Leg_Ankle_Bounce-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 672252,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2857,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'af642e0dad1c25bf45c516fa86791eca9e693afe658f87fdd8418ea0d227b6ec',
          file_name:
            'videos/af642e0dad1c25bf45c516fa86791eca9e693afe658f87fdd8418ea0d227b6ec.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/af642e0dad1c25bf45c516fa86791eca9e693afe658f87fdd8418ea0d227b6ec.mp4',
          name: 'BEG-INT-ADV-Single_Leg_Ankle_Bounce-WARM_UP-LEFT',
          description: 'Left Side',
          size: 658233,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3098,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '9db409b8f069ac0813c2808e707a65a68a54467410fbd764b186724477c257ff',
          file_name:
            'audios/9db409b8f069ac0813c2808e707a65a68a54467410fbd764b186724477c257ff.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9db409b8f069ac0813c2808e707a65a68a54467410fbd764b186724477c257ff.mp3',
          name: 'BEG-INT-ADV-Single_Leg_Ankle_Bounce-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 27405,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SINGLE_LEG_ANKLE_BOUNCE-WARM_UP': {
      id: 1113,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Single Leg Ankle Bounce',
      short_name: 'Single Leg Ankle Bounce',
      unique_name: 'INTERMEDIATE-SINGLE_LEG_ANKLE_BOUNCE-WARM_UP',
      description:
        '1. Stand tall with your feet hip-width apart.\n2. Transfer all weight into one leg, other foot rests lightly on the floor for balance. Bounce off the floor, keeping bottom leg straight. \n3. Land soft and slightly rock back into your heel to feel a stretch. Continue in a quick repetitive motion. String reps together. \n4. Perform all reps on one side. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2859,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '218a41bb411101992920649f1974317eb05766833b7147a3cfe90ca0d4452f9a',
          file_name:
            'videos/218a41bb411101992920649f1974317eb05766833b7147a3cfe90ca0d4452f9a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/218a41bb411101992920649f1974317eb05766833b7147a3cfe90ca0d4452f9a.mp4',
          name: 'BEG-INT-ADV-Single_Leg_Ankle_Bounce-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 672252,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2860,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'af642e0dad1c25bf45c516fa86791eca9e693afe658f87fdd8418ea0d227b6ec',
          file_name:
            'videos/af642e0dad1c25bf45c516fa86791eca9e693afe658f87fdd8418ea0d227b6ec.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/af642e0dad1c25bf45c516fa86791eca9e693afe658f87fdd8418ea0d227b6ec.mp4',
          name: 'BEG-INT-ADV-Single_Leg_Ankle_Bounce-WARM_UP-LEFT',
          description: 'Left Side',
          size: 658233,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3099,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '9db409b8f069ac0813c2808e707a65a68a54467410fbd764b186724477c257ff',
          file_name:
            'audios/9db409b8f069ac0813c2808e707a65a68a54467410fbd764b186724477c257ff.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9db409b8f069ac0813c2808e707a65a68a54467410fbd764b186724477c257ff.mp3',
          name: 'BEG-INT-ADV-Single_Leg_Ankle_Bounce-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 27405,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SINGLE_LEG_ANKLE_BOUNCE-WARM_UP': {
      id: 1114,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Single Leg Ankle Bounce',
      short_name: 'Single Leg Ankle Bounce',
      unique_name: 'ADVANCED-SINGLE_LEG_ANKLE_BOUNCE-WARM_UP',
      description:
        '1. Stand tall with your feet hip-width apart.\n2. Transfer all weight into one leg, other foot rests lightly on the floor for balance. Bounce off the floor, keeping bottom leg straight. \n3. Land soft and slightly rock back into your heel to feel a stretch. Continue in a quick repetitive motion. String reps together. \n4. Perform all reps on one side. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2862,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '218a41bb411101992920649f1974317eb05766833b7147a3cfe90ca0d4452f9a',
          file_name:
            'videos/218a41bb411101992920649f1974317eb05766833b7147a3cfe90ca0d4452f9a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/218a41bb411101992920649f1974317eb05766833b7147a3cfe90ca0d4452f9a.mp4',
          name: 'BEG-INT-ADV-Single_Leg_Ankle_Bounce-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 672252,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2863,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'af642e0dad1c25bf45c516fa86791eca9e693afe658f87fdd8418ea0d227b6ec',
          file_name:
            'videos/af642e0dad1c25bf45c516fa86791eca9e693afe658f87fdd8418ea0d227b6ec.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/af642e0dad1c25bf45c516fa86791eca9e693afe658f87fdd8418ea0d227b6ec.mp4',
          name: 'BEG-INT-ADV-Single_Leg_Ankle_Bounce-WARM_UP-LEFT',
          description: 'Left Side',
          size: 658233,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3100,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '9db409b8f069ac0813c2808e707a65a68a54467410fbd764b186724477c257ff',
          file_name:
            'audios/9db409b8f069ac0813c2808e707a65a68a54467410fbd764b186724477c257ff.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9db409b8f069ac0813c2808e707a65a68a54467410fbd764b186724477c257ff.mp3',
          name: 'BEG-INT-ADV-Single_Leg_Ankle_Bounce-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 27405,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-LEG_SWING-WARM_UP': {
      id: 1115,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Leg Swing',
      short_name: 'Leg Swing',
      unique_name: 'BEGINNER-LEG_SWING-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart, arms by your sides or holding something sturdy.\n2. Transfer all weight on one leg and swing the opposite leg up in front of you to hip height, leg straight or with a soft bend. \n3. Maintain tall posture and swing your leg back directly behind you to your range of motion.  \n4. With control, swing back and forth for time. Repeat other leg.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2865,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '48db31e8cb9237ef4e0da374fb1d31f2edcb4a14f5b22a75ef6e8db217762673',
          file_name:
            'videos/48db31e8cb9237ef4e0da374fb1d31f2edcb4a14f5b22a75ef6e8db217762673.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/48db31e8cb9237ef4e0da374fb1d31f2edcb4a14f5b22a75ef6e8db217762673.mp4',
          name: 'BEG-INT-ADV-Leg_Swing-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 866168,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2866,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'dce718c73613f033568da0872b4bbfcb6bc5c43db6ea5bc715385502cc171bf6',
          file_name:
            'videos/dce718c73613f033568da0872b4bbfcb6bc5c43db6ea5bc715385502cc171bf6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dce718c73613f033568da0872b4bbfcb6bc5c43db6ea5bc715385502cc171bf6.mp4',
          name: 'BEG-INT-ADV-Leg_Swing-WARM_UP-LEFT',
          description: 'Left Side',
          size: 814013,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3101,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '535465ef4009d06489db043f24ce270b8b6238c2513989b0cef668b01a713fb7',
          file_name:
            'audios/535465ef4009d06489db043f24ce270b8b6238c2513989b0cef668b01a713fb7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/535465ef4009d06489db043f24ce270b8b6238c2513989b0cef668b01a713fb7.mp3',
          name: 'BEG-INT-ADV-Leg_Swing-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 16749,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-LEG_SWING-WARM_UP': {
      id: 1116,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Leg Swing',
      short_name: 'Leg Swing',
      unique_name: 'INTERMEDIATE-LEG_SWING-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart, arms by your sides or holding something sturdy.\n2. Transfer all weight on one leg and swing the opposite leg up in front of you to hip height, leg straight or with a soft bend. \n3. Maintain tall posture and swing your leg back directly behind you to your range of motion.  \n4. With control, swing back and forth for time. Repeat other leg.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2868,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '48db31e8cb9237ef4e0da374fb1d31f2edcb4a14f5b22a75ef6e8db217762673',
          file_name:
            'videos/48db31e8cb9237ef4e0da374fb1d31f2edcb4a14f5b22a75ef6e8db217762673.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/48db31e8cb9237ef4e0da374fb1d31f2edcb4a14f5b22a75ef6e8db217762673.mp4',
          name: 'BEG-INT-ADV-Leg_Swing-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 866168,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2869,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'dce718c73613f033568da0872b4bbfcb6bc5c43db6ea5bc715385502cc171bf6',
          file_name:
            'videos/dce718c73613f033568da0872b4bbfcb6bc5c43db6ea5bc715385502cc171bf6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dce718c73613f033568da0872b4bbfcb6bc5c43db6ea5bc715385502cc171bf6.mp4',
          name: 'BEG-INT-ADV-Leg_Swing-WARM_UP-LEFT',
          description: 'Left Side',
          size: 814013,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3102,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '535465ef4009d06489db043f24ce270b8b6238c2513989b0cef668b01a713fb7',
          file_name:
            'audios/535465ef4009d06489db043f24ce270b8b6238c2513989b0cef668b01a713fb7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/535465ef4009d06489db043f24ce270b8b6238c2513989b0cef668b01a713fb7.mp3',
          name: 'BEG-INT-ADV-Leg_Swing-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 16749,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-LEG_SWING-WARM_UP': {
      id: 1117,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Leg Swing',
      short_name: 'Leg Swing',
      unique_name: 'ADVANCED-LEG_SWING-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart, arms by your sides or holding something sturdy.\n2. Transfer all weight on one leg and swing the opposite leg up in front of you to hip height, leg straight or with a soft bend. \n3. Maintain tall posture and swing your leg back directly behind you to your range of motion.  \n4. With control, swing back and forth for time. Repeat other leg.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2871,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '48db31e8cb9237ef4e0da374fb1d31f2edcb4a14f5b22a75ef6e8db217762673',
          file_name:
            'videos/48db31e8cb9237ef4e0da374fb1d31f2edcb4a14f5b22a75ef6e8db217762673.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/48db31e8cb9237ef4e0da374fb1d31f2edcb4a14f5b22a75ef6e8db217762673.mp4',
          name: 'BEG-INT-ADV-Leg_Swing-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 866168,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2872,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'dce718c73613f033568da0872b4bbfcb6bc5c43db6ea5bc715385502cc171bf6',
          file_name:
            'videos/dce718c73613f033568da0872b4bbfcb6bc5c43db6ea5bc715385502cc171bf6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dce718c73613f033568da0872b4bbfcb6bc5c43db6ea5bc715385502cc171bf6.mp4',
          name: 'BEG-INT-ADV-Leg_Swing-WARM_UP-LEFT',
          description: 'Left Side',
          size: 814013,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3103,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '535465ef4009d06489db043f24ce270b8b6238c2513989b0cef668b01a713fb7',
          file_name:
            'audios/535465ef4009d06489db043f24ce270b8b6238c2513989b0cef668b01a713fb7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/535465ef4009d06489db043f24ce270b8b6238c2513989b0cef668b01a713fb7.mp3',
          name: 'BEG-INT-ADV-Leg_Swing-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 16749,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SHOULDER_SHRUG_TO_SCAPULAR_RETRACTION-WARM_UP': {
      id: 1139,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Shoulder Shrug to Scapular Retraction',
      short_name: 'Shoulder Shrug to Scapular Retraction',
      unique_name: 'BEGINNER-SHOULDER_SHRUG_TO_SCAPULAR_RETRACTION-WARM_UP',
      description:
        '1.Stand with feet shoulder-width apart, arms by your sides, neutral neck and spine. \n2.Shrug your shoulders upwards towards your ears. Squeeze Traps at the top. \n3. Squeeze your shoulder blades together  opening up your chest. \n4.Slowly lower back down and depress your shoulder blades at the bottom as you return to start position.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 18,
          unique_name: 'TRAPS',
          name: 'Traps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2929,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '3449cbff8b6248de5144c3fb44cd8b24025b4361d9771e2f472364b6b98b7620',
          file_name:
            'videos/3449cbff8b6248de5144c3fb44cd8b24025b4361d9771e2f472364b6b98b7620.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3449cbff8b6248de5144c3fb44cd8b24025b4361d9771e2f472364b6b98b7620.mp4',
          name: 'BEG-INT-ADV-Shoulder_Shrug_to_Scapular_Retraction-WARM_UP',
          description: null,
          size: 688904,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3125,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '67fab2338c9222c301fa4110d7a02b38a753da1fdb08e8ee14db8ff7c20798c6',
          file_name:
            'audios/67fab2338c9222c301fa4110d7a02b38a753da1fdb08e8ee14db8ff7c20798c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/67fab2338c9222c301fa4110d7a02b38a753da1fdb08e8ee14db8ff7c20798c6.mp3',
          name: 'BEG-INT-ADV-Shoulder_Shrug_to_Scapular_Retraction-WARM_UP',
          description: null,
          size: 35469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SHOULDER_SHRUG_TO_SCAPULAR_RETRACTION-WARM_UP': {
      id: 1140,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Shoulder Shrug to Scapular Retraction',
      short_name: 'Shoulder Shrug to Scapular Retraction',
      unique_name: 'INTERMEDIATE-SHOULDER_SHRUG_TO_SCAPULAR_RETRACTION-WARM_UP',
      description:
        '1.Stand with feet shoulder-width apart, arms by your sides, neutral neck and spine. \n2.Shrug your shoulders upwards towards your ears. Squeeze Traps at the top. \n3. Squeeze your shoulder blades together  opening up your chest. \n4.Slowly lower back down and depress your shoulder blades at the bottom as you return to start position.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 18,
          unique_name: 'TRAPS',
          name: 'Traps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2931,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '3449cbff8b6248de5144c3fb44cd8b24025b4361d9771e2f472364b6b98b7620',
          file_name:
            'videos/3449cbff8b6248de5144c3fb44cd8b24025b4361d9771e2f472364b6b98b7620.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3449cbff8b6248de5144c3fb44cd8b24025b4361d9771e2f472364b6b98b7620.mp4',
          name: 'BEG-INT-ADV-Shoulder_Shrug_to_Scapular_Retraction-WARM_UP',
          description: null,
          size: 688904,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3126,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '67fab2338c9222c301fa4110d7a02b38a753da1fdb08e8ee14db8ff7c20798c6',
          file_name:
            'audios/67fab2338c9222c301fa4110d7a02b38a753da1fdb08e8ee14db8ff7c20798c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/67fab2338c9222c301fa4110d7a02b38a753da1fdb08e8ee14db8ff7c20798c6.mp3',
          name: 'BEG-INT-ADV-Shoulder_Shrug_to_Scapular_Retraction-WARM_UP',
          description: null,
          size: 35469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SHOULDER_SHRUG_TO_SCAPULAR_RETRACTION-WARM_UP': {
      id: 1141,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Shoulder Shrug to Scapular Retraction',
      short_name: 'Shoulder Shrug to Scapular Retraction',
      unique_name: 'ADVANCED-SHOULDER_SHRUG_TO_SCAPULAR_RETRACTION-WARM_UP',
      description:
        '1.Stand with feet shoulder-width apart, arms by your sides, neutral neck and spine. \n2.Shrug your shoulders upwards towards your ears. Squeeze Traps at the top. \n3. Squeeze your shoulder blades together  opening up your chest. \n4.Slowly lower back down and depress your shoulder blades at the bottom as you return to start position.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 18,
          unique_name: 'TRAPS',
          name: 'Traps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2933,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '3449cbff8b6248de5144c3fb44cd8b24025b4361d9771e2f472364b6b98b7620',
          file_name:
            'videos/3449cbff8b6248de5144c3fb44cd8b24025b4361d9771e2f472364b6b98b7620.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3449cbff8b6248de5144c3fb44cd8b24025b4361d9771e2f472364b6b98b7620.mp4',
          name: 'BEG-INT-ADV-Shoulder_Shrug_to_Scapular_Retraction-WARM_UP',
          description: null,
          size: 688904,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3127,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '67fab2338c9222c301fa4110d7a02b38a753da1fdb08e8ee14db8ff7c20798c6',
          file_name:
            'audios/67fab2338c9222c301fa4110d7a02b38a753da1fdb08e8ee14db8ff7c20798c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/67fab2338c9222c301fa4110d7a02b38a753da1fdb08e8ee14db8ff7c20798c6.mp3',
          name: 'BEG-INT-ADV-Shoulder_Shrug_to_Scapular_Retraction-WARM_UP',
          description: null,
          size: 35469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SEATED_WINDSHIELD_WIPERS-WARM_UP': {
      id: 1142,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Seated Windshield Wipers',
      short_name: 'Seated Windshield Wipers',
      unique_name: 'BEGINNER-SEATED_WINDSHIELD_WIPERS-WARM_UP',
      description:
        '1. Sit on the floor with both knees bent, feet flat on the floor about hip-width apart. Place both hands on the floor behind you for support. \n2. Keeping spine straight, drop both knees to one side, as close to the floor as possible. \n3. Pause and return knees to center. \n4. Repeat in the opposite direction. \n5. Move slowly and continously for time.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2935,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'eb2f90d09acad1184736ecbf33ffc1c3ce1cdd60a150c7f36a265e097ce7cec9',
          file_name:
            'videos/eb2f90d09acad1184736ecbf33ffc1c3ce1cdd60a150c7f36a265e097ce7cec9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eb2f90d09acad1184736ecbf33ffc1c3ce1cdd60a150c7f36a265e097ce7cec9.mp4',
          name: 'BEG-INT-ADV-Seated_Windshield_Wipers-WARM_UP',
          description: null,
          size: 1040181,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3128,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd7804b65abdb9d7fadb990516f510bee668fa474c830b25853f44dc0132a5ac8',
          file_name:
            'audios/d7804b65abdb9d7fadb990516f510bee668fa474c830b25853f44dc0132a5ac8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d7804b65abdb9d7fadb990516f510bee668fa474c830b25853f44dc0132a5ac8.mp3',
          name: 'BEG-INT-ADV-Seated_Windshield_Wipers-WARM_UP',
          description: null,
          size: 21360,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SEATED_WINDSHIELD_WIPERS-WARM_UP': {
      id: 1143,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Seated Windshield Wipers',
      short_name: 'Seated Windshield Wipers',
      unique_name: 'INTERMEDIATE-SEATED_WINDSHIELD_WIPERS-WARM_UP',
      description:
        '1. Sit on the floor with both knees bent, feet flat on the floor about hip-width apart. Place both hands on the floor behind you for support. \n2. Keeping spine straight, drop both knees to one side, as close to the floor as possible. \n3. Pause and return knees to center. \n4. Repeat in the opposite direction. \n5. Move slowly and continously for time.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2937,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'eb2f90d09acad1184736ecbf33ffc1c3ce1cdd60a150c7f36a265e097ce7cec9',
          file_name:
            'videos/eb2f90d09acad1184736ecbf33ffc1c3ce1cdd60a150c7f36a265e097ce7cec9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eb2f90d09acad1184736ecbf33ffc1c3ce1cdd60a150c7f36a265e097ce7cec9.mp4',
          name: 'BEG-INT-ADV-Seated_Windshield_Wipers-WARM_UP',
          description: null,
          size: 1040181,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3129,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd7804b65abdb9d7fadb990516f510bee668fa474c830b25853f44dc0132a5ac8',
          file_name:
            'audios/d7804b65abdb9d7fadb990516f510bee668fa474c830b25853f44dc0132a5ac8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d7804b65abdb9d7fadb990516f510bee668fa474c830b25853f44dc0132a5ac8.mp3',
          name: 'BEG-INT-ADV-Seated_Windshield_Wipers-WARM_UP',
          description: null,
          size: 21360,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SEATED_WINDSHIELD_WIPERS-WARM_UP': {
      id: 1144,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Seated Windshield Wipers',
      short_name: 'Seated Windshield Wipers',
      unique_name: 'ADVANCED-SEATED_WINDSHIELD_WIPERS-WARM_UP',
      description:
        '1. Sit on the floor with both knees bent, feet flat on the floor about hip-width apart. Place both hands on the floor behind you for support. \n2. Keeping spine straight, drop both knees to one side, as close to the floor as possible. \n3. Pause and return knees to center. \n4. Repeat in the opposite direction. \n5. Move slowly and continously for time.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2939,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'eb2f90d09acad1184736ecbf33ffc1c3ce1cdd60a150c7f36a265e097ce7cec9',
          file_name:
            'videos/eb2f90d09acad1184736ecbf33ffc1c3ce1cdd60a150c7f36a265e097ce7cec9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eb2f90d09acad1184736ecbf33ffc1c3ce1cdd60a150c7f36a265e097ce7cec9.mp4',
          name: 'BEG-INT-ADV-Seated_Windshield_Wipers-WARM_UP',
          description: null,
          size: 1040181,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3130,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd7804b65abdb9d7fadb990516f510bee668fa474c830b25853f44dc0132a5ac8',
          file_name:
            'audios/d7804b65abdb9d7fadb990516f510bee668fa474c830b25853f44dc0132a5ac8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d7804b65abdb9d7fadb990516f510bee668fa474c830b25853f44dc0132a5ac8.mp3',
          name: 'BEG-INT-ADV-Seated_Windshield_Wipers-WARM_UP',
          description: null,
          size: 21360,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-QUAD_STRETCH_WITH_HIP_HINGE-WARM_UP': {
      id: 1145,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Quad Stretch with Hip Hinge',
      short_name: 'Quad Stretch with Hip Hinge',
      unique_name: 'BEGINNER-QUAD_STRETCH_WITH_HIP_HINGE-WARM_UP',
      description:
        '1. Stand on one leg and hold your opposite foot behind you. Keep hips square and knee close to your body. \n2. Hinge at your waist and lower your torso toward the floor for a deeper stretch. \n3. Release your foot and step forward.\n4. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2941,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'e8717eade392116a86de40ccda2278d9b404f448aa9bfa1a351cb9d95cc47dc7',
          file_name:
            'videos/e8717eade392116a86de40ccda2278d9b404f448aa9bfa1a351cb9d95cc47dc7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e8717eade392116a86de40ccda2278d9b404f448aa9bfa1a351cb9d95cc47dc7.mp4',
          name: 'BEG-INT-ADV-Quad_Stretch_with_Hip_Hinge-WARM_UP',
          description: null,
          size: 1262814,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3131,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '4f48c8079a877797eb6d00bd97d293f8d31a630c40e9aad37d721debe3046c97',
          file_name:
            'audios/4f48c8079a877797eb6d00bd97d293f8d31a630c40e9aad37d721debe3046c97.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4f48c8079a877797eb6d00bd97d293f8d31a630c40e9aad37d721debe3046c97.mp3',
          name: 'BEG-INT-ADV-Quad_Stretch_with_Hip_Hinge-WARM_UP',
          description: null,
          size: 29421,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-QUAD_STRETCH_WITH_HIP_HINGE-WARM_UP': {
      id: 1146,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Quad Stretch with Hip Hinge',
      short_name: 'Quad Stretch with Hip Hinge',
      unique_name: 'INTERMEDIATE-QUAD_STRETCH_WITH_HIP_HINGE-WARM_UP',
      description:
        '1. Stand on one leg and hold your opposite foot behind you. Keep hips square and knee close to your body. \n2. Hinge at your waist and lower your torso toward the floor for a deeper stretch. \n3. Release your foot and step forward.\n4. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2943,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'e8717eade392116a86de40ccda2278d9b404f448aa9bfa1a351cb9d95cc47dc7',
          file_name:
            'videos/e8717eade392116a86de40ccda2278d9b404f448aa9bfa1a351cb9d95cc47dc7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e8717eade392116a86de40ccda2278d9b404f448aa9bfa1a351cb9d95cc47dc7.mp4',
          name: 'BEG-INT-ADV-Quad_Stretch_with_Hip_Hinge-WARM_UP',
          description: null,
          size: 1262814,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3132,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '4f48c8079a877797eb6d00bd97d293f8d31a630c40e9aad37d721debe3046c97',
          file_name:
            'audios/4f48c8079a877797eb6d00bd97d293f8d31a630c40e9aad37d721debe3046c97.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4f48c8079a877797eb6d00bd97d293f8d31a630c40e9aad37d721debe3046c97.mp3',
          name: 'BEG-INT-ADV-Quad_Stretch_with_Hip_Hinge-WARM_UP',
          description: null,
          size: 29421,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-QUAD_STRETCH_WITH_HIP_HINGE-WARM_UP': {
      id: 1147,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Quad Stretch with Hip Hinge',
      short_name: 'Quad Stretch with Hip Hinge',
      unique_name: 'ADVANCED-QUAD_STRETCH_WITH_HIP_HINGE-WARM_UP',
      description:
        '1. Stand on one leg and hold your opposite foot behind you. Keep hips square and knee close to your body. \n2. Hinge at your waist and lower your torso toward the floor for a deeper stretch. \n3. Release your foot and step forward.\n4. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2945,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'e8717eade392116a86de40ccda2278d9b404f448aa9bfa1a351cb9d95cc47dc7',
          file_name:
            'videos/e8717eade392116a86de40ccda2278d9b404f448aa9bfa1a351cb9d95cc47dc7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e8717eade392116a86de40ccda2278d9b404f448aa9bfa1a351cb9d95cc47dc7.mp4',
          name: 'BEG-INT-ADV-Quad_Stretch_with_Hip_Hinge-WARM_UP',
          description: null,
          size: 1262814,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3133,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '4f48c8079a877797eb6d00bd97d293f8d31a630c40e9aad37d721debe3046c97',
          file_name:
            'audios/4f48c8079a877797eb6d00bd97d293f8d31a630c40e9aad37d721debe3046c97.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4f48c8079a877797eb6d00bd97d293f8d31a630c40e9aad37d721debe3046c97.mp3',
          name: 'BEG-INT-ADV-Quad_Stretch_with_Hip_Hinge-WARM_UP',
          description: null,
          size: 29421,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CROSS_BODY_LEG_SWING-WARM_UP': {
      id: 1148,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Cross Body Leg Swing',
      short_name: 'Cross Body Leg Swing',
      unique_name: 'BEGINNER-CROSS_BODY_LEG_SWING-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart, arms by your sides or holding something sturdy. \n2. Transfer all weight to one leg and swing the opposite leg across your body as high as possible, leg straight or with a soft bend. \n3. With control, swing your leg out to the opposite side. Maintain tall posture. \n4. Continue to swing back and forth for time. Repeat other leg.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2947,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '35016bb9fd96bd847b9d2b39a88a5a7667b2df8613f5300cc892006385ca450e',
          file_name:
            'videos/35016bb9fd96bd847b9d2b39a88a5a7667b2df8613f5300cc892006385ca450e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/35016bb9fd96bd847b9d2b39a88a5a7667b2df8613f5300cc892006385ca450e.mp4',
          name: 'BEG-INT-ADV-Cross_Body_Leg_Swing-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 682489,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2948,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'e3fcd28beb6cafd86453e10c15f5b421bd5546522874268ab727ebd3b519eeb5',
          file_name:
            'videos/e3fcd28beb6cafd86453e10c15f5b421bd5546522874268ab727ebd3b519eeb5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e3fcd28beb6cafd86453e10c15f5b421bd5546522874268ab727ebd3b519eeb5.mp4',
          name: 'BEG-INT-ADV-Cross_Body_Leg_Swing-WARM_UP-LEFT',
          description: 'Left Side',
          size: 697697,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3134,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '61e0b1c3b99930c70f308a4c0b288000d0bbbf6e7ebd66ae8a85a6157bf298d3',
          file_name:
            'audios/61e0b1c3b99930c70f308a4c0b288000d0bbbf6e7ebd66ae8a85a6157bf298d3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/61e0b1c3b99930c70f308a4c0b288000d0bbbf6e7ebd66ae8a85a6157bf298d3.mp3',
          name: 'BEG-INT-ADV-Cross_Body_Leg_Swing-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-CROSS_BODY_LEG_SWING-WARM_UP': {
      id: 1149,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Cross Body Leg Swing',
      short_name: 'Cross Body Leg Swing',
      unique_name: 'INTERMEDIATE-CROSS_BODY_LEG_SWING-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart, arms by your sides or holding something sturdy. \n2. Transfer all weight to one leg and swing the opposite leg across your body as high as possible, leg straight or with a soft bend. \n3. With control, swing your leg out to the opposite side. Maintain tall posture. \n4. Continue to swing back and forth for time. Repeat other leg.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2950,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '35016bb9fd96bd847b9d2b39a88a5a7667b2df8613f5300cc892006385ca450e',
          file_name:
            'videos/35016bb9fd96bd847b9d2b39a88a5a7667b2df8613f5300cc892006385ca450e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/35016bb9fd96bd847b9d2b39a88a5a7667b2df8613f5300cc892006385ca450e.mp4',
          name: 'BEG-INT-ADV-Cross_Body_Leg_Swing-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 682489,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2951,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'e3fcd28beb6cafd86453e10c15f5b421bd5546522874268ab727ebd3b519eeb5',
          file_name:
            'videos/e3fcd28beb6cafd86453e10c15f5b421bd5546522874268ab727ebd3b519eeb5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e3fcd28beb6cafd86453e10c15f5b421bd5546522874268ab727ebd3b519eeb5.mp4',
          name: 'BEG-INT-ADV-Cross_Body_Leg_Swing-WARM_UP-LEFT',
          description: 'Left Side',
          size: 697697,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3135,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '61e0b1c3b99930c70f308a4c0b288000d0bbbf6e7ebd66ae8a85a6157bf298d3',
          file_name:
            'audios/61e0b1c3b99930c70f308a4c0b288000d0bbbf6e7ebd66ae8a85a6157bf298d3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/61e0b1c3b99930c70f308a4c0b288000d0bbbf6e7ebd66ae8a85a6157bf298d3.mp3',
          name: 'BEG-INT-ADV-Cross_Body_Leg_Swing-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-CROSS_BODY_LEG_SWING-WARM_UP': {
      id: 1150,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Cross Body Leg Swing',
      short_name: 'Cross Body Leg Swing',
      unique_name: 'ADVANCED-CROSS_BODY_LEG_SWING-WARM_UP',
      description:
        '1. Stand tall with your feet shoulder-width apart, arms by your sides or holding something sturdy. \n2. Transfer all weight to one leg and swing the opposite leg across your body as high as possible, leg straight or with a soft bend. \n3. With control, swing your leg out to the opposite side. Maintain tall posture. \n4. Continue to swing back and forth for time. Repeat other leg.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2953,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '35016bb9fd96bd847b9d2b39a88a5a7667b2df8613f5300cc892006385ca450e',
          file_name:
            'videos/35016bb9fd96bd847b9d2b39a88a5a7667b2df8613f5300cc892006385ca450e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/35016bb9fd96bd847b9d2b39a88a5a7667b2df8613f5300cc892006385ca450e.mp4',
          name: 'BEG-INT-ADV-Cross_Body_Leg_Swing-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 682489,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2954,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'e3fcd28beb6cafd86453e10c15f5b421bd5546522874268ab727ebd3b519eeb5',
          file_name:
            'videos/e3fcd28beb6cafd86453e10c15f5b421bd5546522874268ab727ebd3b519eeb5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e3fcd28beb6cafd86453e10c15f5b421bd5546522874268ab727ebd3b519eeb5.mp4',
          name: 'BEG-INT-ADV-Cross_Body_Leg_Swing-WARM_UP-LEFT',
          description: 'Left Side',
          size: 697697,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3136,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '61e0b1c3b99930c70f308a4c0b288000d0bbbf6e7ebd66ae8a85a6157bf298d3',
          file_name:
            'audios/61e0b1c3b99930c70f308a4c0b288000d0bbbf6e7ebd66ae8a85a6157bf298d3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/61e0b1c3b99930c70f308a4c0b288000d0bbbf6e7ebd66ae8a85a6157bf298d3.mp3',
          name: 'BEG-INT-ADV-Cross_Body_Leg_Swing-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ALTERNATING_HAMSTRING_SWEEP-WARM_UP': {
      id: 1151,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Hamstring Sweep',
      short_name: 'Alternating Hamstring Sweep',
      unique_name: 'BEGINNER-ALTERNATING_HAMSTRING_SWEEP-WARM_UP',
      description:
        '1. Stand tall with feet hip-width apart, arms in front of you, elbows bent. \n2. Transfer all your weight onto one leg, hinge at your hips and step the other foot out in front of you. Rest your heel on the floor, toes point up. \n3. Keeping back straight, drop your torso parallel to the floor and sweep both arms alongside the front leg toward your foot.  \n4. Return to stand and repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2956,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '1f56e072d12abd55ccc45a8666362409cd7c269399e97599809a254dd07941ee',
          file_name:
            'videos/1f56e072d12abd55ccc45a8666362409cd7c269399e97599809a254dd07941ee.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1f56e072d12abd55ccc45a8666362409cd7c269399e97599809a254dd07941ee.mp4',
          name: 'BEG-INT-ADV-Alternating_Hamstring_Sweep-WARM_UP',
          description: null,
          size: 1608618,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3137,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '491caf6b03769270089972990ed8c251c24614504eaae39d00e5a6c8726c4948',
          file_name:
            'audios/491caf6b03769270089972990ed8c251c24614504eaae39d00e5a6c8726c4948.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/491caf6b03769270089972990ed8c251c24614504eaae39d00e5a6c8726c4948.mp3',
          name: 'BEG-INT-ADV-Alternating_Hamstring_Sweep-WARM_UP',
          description: null,
          size: 29421,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_HAMSTRING_SWEEP-WARM_UP': {
      id: 1152,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Hamstring Sweep',
      short_name: 'Alternating Hamstring Sweep',
      unique_name: 'INTERMEDIATE-ALTERNATING_HAMSTRING_SWEEP-WARM_UP',
      description:
        '1. Stand tall with feet hip-width apart, arms in front of you, elbows bent. \n2. Transfer all your weight onto one leg, hinge at your hips and step the other foot out in front of you. Rest your heel on the floor, toes point up. \n3. Keeping back straight, drop your torso parallel to the floor and sweep both arms alongside the front leg toward your foot.  \n4. Return to stand and repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2958,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '1f56e072d12abd55ccc45a8666362409cd7c269399e97599809a254dd07941ee',
          file_name:
            'videos/1f56e072d12abd55ccc45a8666362409cd7c269399e97599809a254dd07941ee.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1f56e072d12abd55ccc45a8666362409cd7c269399e97599809a254dd07941ee.mp4',
          name: 'BEG-INT-ADV-Alternating_Hamstring_Sweep-WARM_UP',
          description: null,
          size: 1608618,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3138,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '491caf6b03769270089972990ed8c251c24614504eaae39d00e5a6c8726c4948',
          file_name:
            'audios/491caf6b03769270089972990ed8c251c24614504eaae39d00e5a6c8726c4948.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/491caf6b03769270089972990ed8c251c24614504eaae39d00e5a6c8726c4948.mp3',
          name: 'BEG-INT-ADV-Alternating_Hamstring_Sweep-WARM_UP',
          description: null,
          size: 29421,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_HAMSTRING_SWEEP-WARM_UP': {
      id: 1153,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Hamstring Sweep',
      short_name: 'Alternating Hamstring Sweep',
      unique_name: 'ADVANCED-ALTERNATING_HAMSTRING_SWEEP-WARM_UP',
      description:
        '1. Stand tall with feet hip-width apart, arms in front of you, elbows bent. \n2. Transfer all your weight onto one leg, hinge at your hips and step the other foot out in front of you. Rest your heel on the floor, toes point up. \n3. Keeping back straight, drop your torso parallel to the floor and sweep both arms alongside the front leg toward your foot.  \n4. Return to stand and repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2960,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '1f56e072d12abd55ccc45a8666362409cd7c269399e97599809a254dd07941ee',
          file_name:
            'videos/1f56e072d12abd55ccc45a8666362409cd7c269399e97599809a254dd07941ee.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1f56e072d12abd55ccc45a8666362409cd7c269399e97599809a254dd07941ee.mp4',
          name: 'BEG-INT-ADV-Alternating_Hamstring_Sweep-WARM_UP',
          description: null,
          size: 1608618,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3139,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '491caf6b03769270089972990ed8c251c24614504eaae39d00e5a6c8726c4948',
          file_name:
            'audios/491caf6b03769270089972990ed8c251c24614504eaae39d00e5a6c8726c4948.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/491caf6b03769270089972990ed8c251c24614504eaae39d00e5a6c8726c4948.mp3',
          name: 'BEG-INT-ADV-Alternating_Hamstring_Sweep-WARM_UP',
          description: null,
          size: 29421,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SUMO_SQUAT_WITH_LOW_TO_HIGH_CHOP-WARM_UP': {
      id: 1300,
      segment_type: 'WARM_UP',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Sumo Squat with Low to High Chop',
      short_name: 'Sumo Squat with Low to High Chop',
      unique_name: 'BEGINNER-SUMO_SQUAT_WITH_LOW_TO_HIGH_CHOP-WARM_UP',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes point out. Put one hand on top of the other and bring both arms down and across your body, arms straight.\n2. Drive your hips back and bend your knees to lower into a wide squat. Keep your chest up and shoulders back.\n3. Drive through your heels to stand and chop both arms up at a diagnoal toward the opposite shoulder. \n4. With control, lower back to start.',
      preview_time: null,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3442,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '948f7bf272e361ecda4bcdcad13e77b747fdb46efe627dba166c034b17060f68',
          file_name:
            'videos/948f7bf272e361ecda4bcdcad13e77b747fdb46efe627dba166c034b17060f68.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/948f7bf272e361ecda4bcdcad13e77b747fdb46efe627dba166c034b17060f68.mp4',
          name: 'BEG-INT-ADV-Sumo_Squat_with_Low_to_High_Chop-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 669372,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3443,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'f5fdcee060626ceeedfce62d1c0ffbe244a918968210b4d0f28d139d0326f1c5',
          file_name:
            'videos/f5fdcee060626ceeedfce62d1c0ffbe244a918968210b4d0f28d139d0326f1c5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f5fdcee060626ceeedfce62d1c0ffbe244a918968210b4d0f28d139d0326f1c5.mp4',
          name: 'BEG-INT-ADV-Sumo_Squat_with_Low_to_High_Chop-WARM_UP-LEFT',
          description: 'Left Side',
          size: 673664,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3444,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '6ab2a6254a01e2fbfed2cdf60a8dc18e9b36c8f01eb90b4994f74f735026ebfb',
          file_name:
            'audios/6ab2a6254a01e2fbfed2cdf60a8dc18e9b36c8f01eb90b4994f74f735026ebfb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6ab2a6254a01e2fbfed2cdf60a8dc18e9b36c8f01eb90b4994f74f735026ebfb.mp3',
          name: 'BEG-INT-ADV-Sumo_Squat_with_Low_to_High_Chop-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 34893,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SUMO_SQUAT_WITH_LOW_TO_HIGH_CHOP-WARM_UP': {
      id: 1301,
      segment_type: 'WARM_UP',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Sumo Squat with Low to High Chop',
      short_name: 'Sumo Squat with Low to High Chop',
      unique_name: 'INTERMEDIATE-SUMO_SQUAT_WITH_LOW_TO_HIGH_CHOP-WARM_UP',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes point out. Put one hand on top of the other and bring both arms down and across your body, arms straight.\n2. Drive your hips back and bend your knees to lower into a wide squat. Keep your chest up and shoulders back.\n3. Drive through your heels to stand and chop both arms up at a diagnoal toward the opposite shoulder. \n4. With control, lower back to start.',
      preview_time: null,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3445,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '948f7bf272e361ecda4bcdcad13e77b747fdb46efe627dba166c034b17060f68',
          file_name:
            'videos/948f7bf272e361ecda4bcdcad13e77b747fdb46efe627dba166c034b17060f68.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/948f7bf272e361ecda4bcdcad13e77b747fdb46efe627dba166c034b17060f68.mp4',
          name: 'BEG-INT-ADV-Sumo_Squat_with_Low_to_High_Chop-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 669372,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3446,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'f5fdcee060626ceeedfce62d1c0ffbe244a918968210b4d0f28d139d0326f1c5',
          file_name:
            'videos/f5fdcee060626ceeedfce62d1c0ffbe244a918968210b4d0f28d139d0326f1c5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f5fdcee060626ceeedfce62d1c0ffbe244a918968210b4d0f28d139d0326f1c5.mp4',
          name: 'BEG-INT-ADV-Sumo_Squat_with_Low_to_High_Chop-WARM_UP-LEFT',
          description: 'Left Side',
          size: 673664,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3447,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '6ab2a6254a01e2fbfed2cdf60a8dc18e9b36c8f01eb90b4994f74f735026ebfb',
          file_name:
            'audios/6ab2a6254a01e2fbfed2cdf60a8dc18e9b36c8f01eb90b4994f74f735026ebfb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6ab2a6254a01e2fbfed2cdf60a8dc18e9b36c8f01eb90b4994f74f735026ebfb.mp3',
          name: 'BEG-INT-ADV-Sumo_Squat_with_Low_to_High_Chop-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 34893,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SUMO_SQUAT_WITH_LOW_TO_HIGH_CHOP-WARM_UP': {
      id: 1302,
      segment_type: 'WARM_UP',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Sumo Squat with Low to High Chop',
      short_name: 'Sumo Squat with Low to High Chop',
      unique_name: 'ADVANCED-SUMO_SQUAT_WITH_LOW_TO_HIGH_CHOP-WARM_UP',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes point out. Put one hand on top of the other and bring both arms down and across your body, arms straight.\n2. Drive your hips back and bend your knees to lower into a wide squat. Keep your chest up and shoulders back.\n3. Drive through your heels to stand and chop both arms up at a diagnoal toward the opposite shoulder. \n4. With control, lower back to start.',
      preview_time: null,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3448,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '948f7bf272e361ecda4bcdcad13e77b747fdb46efe627dba166c034b17060f68',
          file_name:
            'videos/948f7bf272e361ecda4bcdcad13e77b747fdb46efe627dba166c034b17060f68.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/948f7bf272e361ecda4bcdcad13e77b747fdb46efe627dba166c034b17060f68.mp4',
          name: 'BEG-INT-ADV-Sumo_Squat_with_Low_to_High_Chop-WARM_UP-RIGHT',
          description: 'Right Side',
          size: 669372,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3449,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'f5fdcee060626ceeedfce62d1c0ffbe244a918968210b4d0f28d139d0326f1c5',
          file_name:
            'videos/f5fdcee060626ceeedfce62d1c0ffbe244a918968210b4d0f28d139d0326f1c5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f5fdcee060626ceeedfce62d1c0ffbe244a918968210b4d0f28d139d0326f1c5.mp4',
          name: 'BEG-INT-ADV-Sumo_Squat_with_Low_to_High_Chop-WARM_UP-LEFT',
          description: 'Left Side',
          size: 673664,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3450,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '6ab2a6254a01e2fbfed2cdf60a8dc18e9b36c8f01eb90b4994f74f735026ebfb',
          file_name:
            'audios/6ab2a6254a01e2fbfed2cdf60a8dc18e9b36c8f01eb90b4994f74f735026ebfb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6ab2a6254a01e2fbfed2cdf60a8dc18e9b36c8f01eb90b4994f74f735026ebfb.mp3',
          name: 'BEG-INT-ADV-Sumo_Squat_with_Low_to_High_Chop-WARM_UP-(RIGHT/LEFT)',
          description: null,
          size: 34893,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Laying Hamstring Stretch': {
      id: 14,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Lying Hamstring Stretch',
      short_name: 'Lying Hamstr. Stretch',
      unique_name: 'BEGINNER-Laying Hamstring Stretch',
      description:
        '1. Lie on your back. Keep one leg long and connected to the floor. Extend the other leg up.\n2. Gently pull on the back of your thigh or calf, drawing your leg closer to your body.\n3. Pause for a beat. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 32,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '1616f58345ef9bf6c76e310c16b22801de93feeabf550e43b54a631cf3da0330',
          file_name:
            'videos/1616f58345ef9bf6c76e310c16b22801de93feeabf550e43b54a631cf3da0330.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1616f58345ef9bf6c76e310c16b22801de93feeabf550e43b54a631cf3da0330.mp4',
          name: 'Laying_Hamstring_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 423095,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 33,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: '3dd0d483b8929030aaff1f1953d1b0df64557bc2c1db9160bbb37ba187f4a6d8',
          file_name:
            'videos/3dd0d483b8929030aaff1f1953d1b0df64557bc2c1db9160bbb37ba187f4a6d8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3dd0d483b8929030aaff1f1953d1b0df64557bc2c1db9160bbb37ba187f4a6d8.mp4',
          name: 'Laying_Hamstring_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 428415,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 34,
          collection_name: 'audios',
          order: 1,
          version: 200000000,
          hash: '3014027a5a4bb563249f094643fe3a323ad77a00a711a0cfdd2718978dcd0073',
          file_name:
            'audios/3014027a5a4bb563249f094643fe3a323ad77a00a711a0cfdd2718978dcd0073.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3014027a5a4bb563249f094643fe3a323ad77a00a711a0cfdd2718978dcd0073.mp3',
          name: 'BEG-INT-ADV-Lying_Hamstring_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 37679,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Supine Scorpion Stretch': {
      id: 15,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Prone Scorpion Stretch',
      short_name: 'Prone Scorp. Stretch',
      unique_name: 'BEGINNER-Supine Scorpion Stretch',
      description:
        '1. Lie on your stomach and extend your arms out to a "T". Keep the front of your shoulders on the floor.\r\n2. Raise one leg straight up behind you and let it fall across your body to the opposite side. Try to touch your foot to your hand.\r\n3. Pause for a beat in the spinal twist.\r\n4. Return to starting position and repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 35,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '7de2d0b9944d8ae2d265de937e3aaefaf54db0d526fa290112d9e44b5db488b6',
          file_name:
            'videos/7de2d0b9944d8ae2d265de937e3aaefaf54db0d526fa290112d9e44b5db488b6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7de2d0b9944d8ae2d265de937e3aaefaf54db0d526fa290112d9e44b5db488b6.mp4',
          name: 'Prone_Scorpion_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 329715,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 36,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'b9e48c8b671237cfbb8268a75bdde951233d547eeffbea75fd8db649ba01df65',
          file_name:
            'videos/b9e48c8b671237cfbb8268a75bdde951233d547eeffbea75fd8db649ba01df65.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b9e48c8b671237cfbb8268a75bdde951233d547eeffbea75fd8db649ba01df65.mp4',
          name: 'Prone_Scorpion_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 375214,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 37,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'dabc90ae8f045c75329a5049f3accbae38148713d54bd5d777d36f33fc146e66',
          file_name:
            'audios/dabc90ae8f045c75329a5049f3accbae38148713d54bd5d777d36f33fc146e66.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dabc90ae8f045c75329a5049f3accbae38148713d54bd5d777d36f33fc146e66.mp3',
          name: 'Prone_Scorpion_Stretch.mp3',
          description: null,
          size: 29659,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Seated Spinal Twist': {
      id: 16,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Seated Spinal Twist',
      short_name: 'Seated Spinal Twist',
      unique_name: 'BEGINNER-Seated Spinal Twist',
      description:
        '1. Start in a seated position, legs extended.\n2. Cross one leg over the other and rest your foot flat on the floor.\n3. Twist your torso towards your bent knee and hook your opposite elbow over your knee.\n4. Sit up tall. Stretch and hold for a beat.\n5. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 38,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: 'aa7efa89bf685abfc9c077870edf254d0c523572ec881cef2ec9a3f6dabeedd8',
          file_name:
            'videos/aa7efa89bf685abfc9c077870edf254d0c523572ec881cef2ec9a3f6dabeedd8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/aa7efa89bf685abfc9c077870edf254d0c523572ec881cef2ec9a3f6dabeedd8.mp4',
          name: 'Seated_Spinal_Twist-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 349750,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 39,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: '822e6f5b350d93832f6b8feafc36623d4043789268ea4db71134d1707a77a0c8',
          file_name:
            'videos/822e6f5b350d93832f6b8feafc36623d4043789268ea4db71134d1707a77a0c8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/822e6f5b350d93832f6b8feafc36623d4043789268ea4db71134d1707a77a0c8.mp4',
          name: 'Seated_Spinal_Twist-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 362549,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 40,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e66d9604dc0e27574f07422780d1226decc130ff0350756345bb43e3e8aa0e1e',
          file_name:
            'audios/e66d9604dc0e27574f07422780d1226decc130ff0350756345bb43e3e8aa0e1e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e66d9604dc0e27574f07422780d1226decc130ff0350756345bb43e3e8aa0e1e.mp3',
          name: 'Seated_Spinal_Twist.mp3',
          description: null,
          size: 27601,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Pigeon Stretch': {
      id: 17,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Pigeon Stretch',
      short_name: 'Pigeon Stretch',
      unique_name: 'BEGINNER-Pigeon Stretch',
      description:
        '1. Start in Plank position. Bring one leg forward and place it on the floor with your knee bent at 90 degree angle horizontal to your body. Keep your hips square.\n2. Walk your hands in front of you and rest your torso on your front leg.\n3. Come out of the pose carefully and return to Plank position.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 41,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '69b624b57d805706a3530aab809cf0ef29e1b549b10a540858c3dafd7b0c7e0f',
          file_name:
            'videos/69b624b57d805706a3530aab809cf0ef29e1b549b10a540858c3dafd7b0c7e0f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/69b624b57d805706a3530aab809cf0ef29e1b549b10a540858c3dafd7b0c7e0f.mp4',
          name: 'Pigeon_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 545395,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 42,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: '9a61679edb16c9380bf00f8ebb4b468bcf0b461cf79a7e4d8afeea7096e6d0a0',
          file_name:
            'videos/9a61679edb16c9380bf00f8ebb4b468bcf0b461cf79a7e4d8afeea7096e6d0a0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9a61679edb16c9380bf00f8ebb4b468bcf0b461cf79a7e4d8afeea7096e6d0a0.mp4',
          name: 'Pigeon_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 538947,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 43,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'ff43683ff13da705097aa6ce023d182ea9c14e8c1b656a893f2d0e6716fb93c9',
          file_name:
            'audios/ff43683ff13da705097aa6ce023d182ea9c14e8c1b656a893f2d0e6716fb93c9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ff43683ff13da705097aa6ce023d182ea9c14e8c1b656a893f2d0e6716fb93c9.mp3',
          name: 'Pigeon_Stretch.mp3',
          description: null,
          size: 21568,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Runners Stretch': {
      id: 18,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Runners Stretch',
      short_name: 'Runners Stretch',
      unique_name: 'BEGINNER-Runners Stretch',
      description:
        '1. Start in a seated position with your legs straight. Bend one knee and bring it towards you until your foot is resting against the opposite inner thigh.\n2. Sit up tall and turn your torso towards your straight leg. Bend at the waist and reach for your toes.\n3. Hold and return to starting position.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 44,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '01ccc1ecfbb8363d8b327d6229b6b7dda4b32f1cac0d2a99663d6f0af5d00224',
          file_name:
            'videos/01ccc1ecfbb8363d8b327d6229b6b7dda4b32f1cac0d2a99663d6f0af5d00224.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/01ccc1ecfbb8363d8b327d6229b6b7dda4b32f1cac0d2a99663d6f0af5d00224.mp4',
          name: 'Runners_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 456459,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 45,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'd56692d690c9e63ca8b2a708e2ee86067f98a48660060262294710fd145c46e5',
          file_name:
            'videos/d56692d690c9e63ca8b2a708e2ee86067f98a48660060262294710fd145c46e5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d56692d690c9e63ca8b2a708e2ee86067f98a48660060262294710fd145c46e5.mp4',
          name: 'Runners_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 437320,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 46,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e886c241b21f613f249495429e26665a733121fbfd25cb8f0a4b2cfdf6356cfa',
          file_name:
            'audios/e886c241b21f613f249495429e26665a733121fbfd25cb8f0a4b2cfdf6356cfa.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e886c241b21f613f249495429e26665a733121fbfd25cb8f0a4b2cfdf6356cfa.mp3',
          name: 'Runners_Stretch.mp3',
          description: null,
          size: 22417,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Knee Hugs': {
      id: 19,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Knee Hugs',
      short_name: 'Knee Hugs',
      unique_name: 'BEGINNER-Knee Hugs',
      description:
        '1. Lie on your back, legs long. Keep one leg extended and hug the opposite knee into your chest.\n2. Hold and repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 47,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: 'a6353a19a09f026f6d6926848a9cbd661c975b51991c2344efb0c0c6ea740577',
          file_name:
            'videos/a6353a19a09f026f6d6926848a9cbd661c975b51991c2344efb0c0c6ea740577.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a6353a19a09f026f6d6926848a9cbd661c975b51991c2344efb0c0c6ea740577.mp4',
          name: 'Knee_Hugs-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 363325,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 48,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: '1f1707dac07e5d1dbe3db7aee8f41b56588c7efa5ac9bf91675803eb3f2959dd',
          file_name:
            'videos/1f1707dac07e5d1dbe3db7aee8f41b56588c7efa5ac9bf91675803eb3f2959dd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1f1707dac07e5d1dbe3db7aee8f41b56588c7efa5ac9bf91675803eb3f2959dd.mp4',
          name: 'Knee_Hugs-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 345199,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 49,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'f39fccf151d0baad426d0f451c5f5793b07b8b985c668dbf024c3d53dd31f75b',
          file_name:
            'audios/f39fccf151d0baad426d0f451c5f5793b07b8b985c668dbf024c3d53dd31f75b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f39fccf151d0baad426d0f451c5f5793b07b8b985c668dbf024c3d53dd31f75b.mp3',
          name: 'Knee_Hugs.mp3',
          description: null,
          size: 18976,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Laying Hamstring Stretch': {
      id: 57,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Lying Hamstring Stretch',
      short_name: 'Lying Hamstr. Stretch',
      unique_name: 'INTERMEDIATE-Laying Hamstring Stretch',
      description:
        '1. Lie on your back. Keep one leg long and connected to the floor. Extend the other leg up.\n2. Gently pull on the back of your thigh or calf, drawing your leg closer to your body.\n3. Pause for a beat. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 120,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '1616f58345ef9bf6c76e310c16b22801de93feeabf550e43b54a631cf3da0330',
          file_name:
            'videos/1616f58345ef9bf6c76e310c16b22801de93feeabf550e43b54a631cf3da0330.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1616f58345ef9bf6c76e310c16b22801de93feeabf550e43b54a631cf3da0330.mp4',
          name: 'Laying_Hamstring_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 423095,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 121,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: '3dd0d483b8929030aaff1f1953d1b0df64557bc2c1db9160bbb37ba187f4a6d8',
          file_name:
            'videos/3dd0d483b8929030aaff1f1953d1b0df64557bc2c1db9160bbb37ba187f4a6d8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3dd0d483b8929030aaff1f1953d1b0df64557bc2c1db9160bbb37ba187f4a6d8.mp4',
          name: 'Laying_Hamstring_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 428415,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 122,
          collection_name: 'audios',
          order: 1,
          version: 200000000,
          hash: '3014027a5a4bb563249f094643fe3a323ad77a00a711a0cfdd2718978dcd0073',
          file_name:
            'audios/3014027a5a4bb563249f094643fe3a323ad77a00a711a0cfdd2718978dcd0073.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3014027a5a4bb563249f094643fe3a323ad77a00a711a0cfdd2718978dcd0073.mp3',
          name: 'BEG-INT-ADV-Lying_Hamstring_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 37679,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Supine Scorpion Stretch': {
      id: 58,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Prone Scorpion Stretch',
      short_name: 'Prone Scorp. Stretch',
      unique_name: 'INTERMEDIATE-Supine Scorpion Stretch',
      description:
        '1. Lie on your stomach and extend your arms out to a "T". Keep the front of your shoulders on the floor.\r\n2. Raise one leg straight up behind you and let it fall across your body to the opposite side. Try to touch your foot to your hand.\r\n3. Pause for a beat in the spinal twist.\r\n4. Return to starting position and repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 123,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '7de2d0b9944d8ae2d265de937e3aaefaf54db0d526fa290112d9e44b5db488b6',
          file_name:
            'videos/7de2d0b9944d8ae2d265de937e3aaefaf54db0d526fa290112d9e44b5db488b6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7de2d0b9944d8ae2d265de937e3aaefaf54db0d526fa290112d9e44b5db488b6.mp4',
          name: 'Prone_Scorpion_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 329715,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 124,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'b9e48c8b671237cfbb8268a75bdde951233d547eeffbea75fd8db649ba01df65',
          file_name:
            'videos/b9e48c8b671237cfbb8268a75bdde951233d547eeffbea75fd8db649ba01df65.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b9e48c8b671237cfbb8268a75bdde951233d547eeffbea75fd8db649ba01df65.mp4',
          name: 'Prone_Scorpion_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 375214,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 125,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'dabc90ae8f045c75329a5049f3accbae38148713d54bd5d777d36f33fc146e66',
          file_name:
            'audios/dabc90ae8f045c75329a5049f3accbae38148713d54bd5d777d36f33fc146e66.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dabc90ae8f045c75329a5049f3accbae38148713d54bd5d777d36f33fc146e66.mp3',
          name: 'Prone_Scorpion_Stretch.mp3',
          description: null,
          size: 29659,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Seated Spinal Twist': {
      id: 59,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Seated Spinal Twist',
      short_name: 'Seated Spinal Twist',
      unique_name: 'INTERMEDIATE-Seated Spinal Twist',
      description:
        '1. Start in a seated position, legs extended.\n2. Cross one leg over the other and rest your foot flat on the floor.\n3. Twist your torso towards your bent knee and hook your opposite elbow over your knee.\n4. Sit up tall. Stretch and hold for a beat.\n5. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 126,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: 'aa7efa89bf685abfc9c077870edf254d0c523572ec881cef2ec9a3f6dabeedd8',
          file_name:
            'videos/aa7efa89bf685abfc9c077870edf254d0c523572ec881cef2ec9a3f6dabeedd8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/aa7efa89bf685abfc9c077870edf254d0c523572ec881cef2ec9a3f6dabeedd8.mp4',
          name: 'Seated_Spinal_Twist-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 349750,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 127,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: '822e6f5b350d93832f6b8feafc36623d4043789268ea4db71134d1707a77a0c8',
          file_name:
            'videos/822e6f5b350d93832f6b8feafc36623d4043789268ea4db71134d1707a77a0c8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/822e6f5b350d93832f6b8feafc36623d4043789268ea4db71134d1707a77a0c8.mp4',
          name: 'Seated_Spinal_Twist-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 362549,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 128,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e66d9604dc0e27574f07422780d1226decc130ff0350756345bb43e3e8aa0e1e',
          file_name:
            'audios/e66d9604dc0e27574f07422780d1226decc130ff0350756345bb43e3e8aa0e1e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e66d9604dc0e27574f07422780d1226decc130ff0350756345bb43e3e8aa0e1e.mp3',
          name: 'Seated_Spinal_Twist.mp3',
          description: null,
          size: 27601,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Pigeon Stretch': {
      id: 60,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Pigeon Stretch',
      short_name: 'Pigeon Stretch',
      unique_name: 'INTERMEDIATE-Pigeon Stretch',
      description:
        '1. Start in Plank position. Bring one leg forward and place it on the floor with your knee bent at 90 degree angle horizontal to your body. Keep your hips square.\n2. Walk your hands in front of you and rest your torso on your front leg.\n3. Come out of the pose carefully and return to Plank position.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 129,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '69b624b57d805706a3530aab809cf0ef29e1b549b10a540858c3dafd7b0c7e0f',
          file_name:
            'videos/69b624b57d805706a3530aab809cf0ef29e1b549b10a540858c3dafd7b0c7e0f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/69b624b57d805706a3530aab809cf0ef29e1b549b10a540858c3dafd7b0c7e0f.mp4',
          name: 'Pigeon_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 545395,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 130,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: '9a61679edb16c9380bf00f8ebb4b468bcf0b461cf79a7e4d8afeea7096e6d0a0',
          file_name:
            'videos/9a61679edb16c9380bf00f8ebb4b468bcf0b461cf79a7e4d8afeea7096e6d0a0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9a61679edb16c9380bf00f8ebb4b468bcf0b461cf79a7e4d8afeea7096e6d0a0.mp4',
          name: 'Pigeon_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 538947,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 131,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'ff43683ff13da705097aa6ce023d182ea9c14e8c1b656a893f2d0e6716fb93c9',
          file_name:
            'audios/ff43683ff13da705097aa6ce023d182ea9c14e8c1b656a893f2d0e6716fb93c9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ff43683ff13da705097aa6ce023d182ea9c14e8c1b656a893f2d0e6716fb93c9.mp3',
          name: 'Pigeon_Stretch.mp3',
          description: null,
          size: 21568,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Runners Stretch': {
      id: 61,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Runners Stretch',
      short_name: 'Runners Stretch',
      unique_name: 'INTERMEDIATE-Runners Stretch',
      description:
        '1. Start in a seated position with your legs straight. Bend one knee and bring it towards you until your foot is resting against the opposite inner thigh.\n2. Sit up tall and turn your torso towards your straight leg. Bend at the waist and reach for your toes.\n3. Hold and return to starting position.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 132,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '01ccc1ecfbb8363d8b327d6229b6b7dda4b32f1cac0d2a99663d6f0af5d00224',
          file_name:
            'videos/01ccc1ecfbb8363d8b327d6229b6b7dda4b32f1cac0d2a99663d6f0af5d00224.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/01ccc1ecfbb8363d8b327d6229b6b7dda4b32f1cac0d2a99663d6f0af5d00224.mp4',
          name: 'Runners_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 456459,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 133,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'd56692d690c9e63ca8b2a708e2ee86067f98a48660060262294710fd145c46e5',
          file_name:
            'videos/d56692d690c9e63ca8b2a708e2ee86067f98a48660060262294710fd145c46e5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d56692d690c9e63ca8b2a708e2ee86067f98a48660060262294710fd145c46e5.mp4',
          name: 'Runners_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 437320,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 134,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e886c241b21f613f249495429e26665a733121fbfd25cb8f0a4b2cfdf6356cfa',
          file_name:
            'audios/e886c241b21f613f249495429e26665a733121fbfd25cb8f0a4b2cfdf6356cfa.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e886c241b21f613f249495429e26665a733121fbfd25cb8f0a4b2cfdf6356cfa.mp3',
          name: 'Runners_Stretch.mp3',
          description: null,
          size: 22417,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Knee Hugs': {
      id: 62,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Knee Hugs',
      short_name: 'Knee Hugs',
      unique_name: 'INTERMEDIATE-Knee Hugs',
      description:
        '1. Lie on your back, legs long. Keep one leg extended and hug the opposite knee into your chest.\n2. Hold and repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 135,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: 'a6353a19a09f026f6d6926848a9cbd661c975b51991c2344efb0c0c6ea740577',
          file_name:
            'videos/a6353a19a09f026f6d6926848a9cbd661c975b51991c2344efb0c0c6ea740577.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a6353a19a09f026f6d6926848a9cbd661c975b51991c2344efb0c0c6ea740577.mp4',
          name: 'Knee_Hugs-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 363325,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 136,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: '1f1707dac07e5d1dbe3db7aee8f41b56588c7efa5ac9bf91675803eb3f2959dd',
          file_name:
            'videos/1f1707dac07e5d1dbe3db7aee8f41b56588c7efa5ac9bf91675803eb3f2959dd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1f1707dac07e5d1dbe3db7aee8f41b56588c7efa5ac9bf91675803eb3f2959dd.mp4',
          name: 'Knee_Hugs-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 345199,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 137,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'f39fccf151d0baad426d0f451c5f5793b07b8b985c668dbf024c3d53dd31f75b',
          file_name:
            'audios/f39fccf151d0baad426d0f451c5f5793b07b8b985c668dbf024c3d53dd31f75b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f39fccf151d0baad426d0f451c5f5793b07b8b985c668dbf024c3d53dd31f75b.mp3',
          name: 'Knee_Hugs.mp3',
          description: null,
          size: 18976,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Laying Hamstring Stretch': {
      id: 100,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Lying Hamstring Stretch',
      short_name: 'Lying Hamstr. Stretch',
      unique_name: 'ADVANCED-Laying Hamstring Stretch',
      description:
        '1. Lie on your back. Keep one leg long and connected to the floor. Extend the other leg up.\n2. Gently pull on the back of your thigh or calf, drawing your leg closer to your body.\n3. Pause for a beat. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 208,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '1616f58345ef9bf6c76e310c16b22801de93feeabf550e43b54a631cf3da0330',
          file_name:
            'videos/1616f58345ef9bf6c76e310c16b22801de93feeabf550e43b54a631cf3da0330.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1616f58345ef9bf6c76e310c16b22801de93feeabf550e43b54a631cf3da0330.mp4',
          name: 'Laying_Hamstring_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 423095,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 209,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: '3dd0d483b8929030aaff1f1953d1b0df64557bc2c1db9160bbb37ba187f4a6d8',
          file_name:
            'videos/3dd0d483b8929030aaff1f1953d1b0df64557bc2c1db9160bbb37ba187f4a6d8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3dd0d483b8929030aaff1f1953d1b0df64557bc2c1db9160bbb37ba187f4a6d8.mp4',
          name: 'Laying_Hamstring_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 428415,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 210,
          collection_name: 'audios',
          order: 1,
          version: 200000000,
          hash: '3014027a5a4bb563249f094643fe3a323ad77a00a711a0cfdd2718978dcd0073',
          file_name:
            'audios/3014027a5a4bb563249f094643fe3a323ad77a00a711a0cfdd2718978dcd0073.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3014027a5a4bb563249f094643fe3a323ad77a00a711a0cfdd2718978dcd0073.mp3',
          name: 'BEG-INT-ADV-Lying_Hamstring_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 37679,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Supine Scorpion Stretch': {
      id: 101,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Prone Scorpion Stretch',
      short_name: 'Prone Scorp. Stretch',
      unique_name: 'ADVANCED-Supine Scorpion Stretch',
      description:
        '1. Lie on your stomach and extend your arms out to a "T". Keep the front of your shoulders on the floor.\r\n2. Raise one leg straight up behind you and let it fall across your body to the opposite side. Try to touch your foot to your hand.\r\n3. Pause for a beat in the spinal twist.\r\n4. Return to starting position and repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 211,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '7de2d0b9944d8ae2d265de937e3aaefaf54db0d526fa290112d9e44b5db488b6',
          file_name:
            'videos/7de2d0b9944d8ae2d265de937e3aaefaf54db0d526fa290112d9e44b5db488b6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7de2d0b9944d8ae2d265de937e3aaefaf54db0d526fa290112d9e44b5db488b6.mp4',
          name: 'Prone_Scorpion_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 329715,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 212,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'b9e48c8b671237cfbb8268a75bdde951233d547eeffbea75fd8db649ba01df65',
          file_name:
            'videos/b9e48c8b671237cfbb8268a75bdde951233d547eeffbea75fd8db649ba01df65.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b9e48c8b671237cfbb8268a75bdde951233d547eeffbea75fd8db649ba01df65.mp4',
          name: 'Prone_Scorpion_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 375214,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 213,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'dabc90ae8f045c75329a5049f3accbae38148713d54bd5d777d36f33fc146e66',
          file_name:
            'audios/dabc90ae8f045c75329a5049f3accbae38148713d54bd5d777d36f33fc146e66.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dabc90ae8f045c75329a5049f3accbae38148713d54bd5d777d36f33fc146e66.mp3',
          name: 'Prone_Scorpion_Stretch.mp3',
          description: null,
          size: 29659,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Seated Spinal Twist': {
      id: 102,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Seated Spinal Twist',
      short_name: 'Seated Spinal Twist',
      unique_name: 'ADVANCED-Seated Spinal Twist',
      description:
        '1. Start in a seated position, legs extended.\n2. Cross one leg over the other and rest your foot flat on the floor.\n3. Twist your torso towards your bent knee and hook your opposite elbow over your knee.\n4. Sit up tall. Stretch and hold for a beat.\n5. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 214,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: 'aa7efa89bf685abfc9c077870edf254d0c523572ec881cef2ec9a3f6dabeedd8',
          file_name:
            'videos/aa7efa89bf685abfc9c077870edf254d0c523572ec881cef2ec9a3f6dabeedd8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/aa7efa89bf685abfc9c077870edf254d0c523572ec881cef2ec9a3f6dabeedd8.mp4',
          name: 'Seated_Spinal_Twist-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 349750,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 215,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: '822e6f5b350d93832f6b8feafc36623d4043789268ea4db71134d1707a77a0c8',
          file_name:
            'videos/822e6f5b350d93832f6b8feafc36623d4043789268ea4db71134d1707a77a0c8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/822e6f5b350d93832f6b8feafc36623d4043789268ea4db71134d1707a77a0c8.mp4',
          name: 'Seated_Spinal_Twist-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 362549,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 216,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e66d9604dc0e27574f07422780d1226decc130ff0350756345bb43e3e8aa0e1e',
          file_name:
            'audios/e66d9604dc0e27574f07422780d1226decc130ff0350756345bb43e3e8aa0e1e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e66d9604dc0e27574f07422780d1226decc130ff0350756345bb43e3e8aa0e1e.mp3',
          name: 'Seated_Spinal_Twist.mp3',
          description: null,
          size: 27601,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Pigeon Stretch': {
      id: 103,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Pigeon Stretch',
      short_name: 'Pigeon Stretch',
      unique_name: 'ADVANCED-Pigeon Stretch',
      description:
        '1. Start in Plank position. Bring one leg forward and place it on the floor with your knee bent at 90 degree angle horizontal to your body. Keep your hips square.\n2. Walk your hands in front of you and rest your torso on your front leg.\n3. Come out of the pose carefully and return to Plank position.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 217,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '69b624b57d805706a3530aab809cf0ef29e1b549b10a540858c3dafd7b0c7e0f',
          file_name:
            'videos/69b624b57d805706a3530aab809cf0ef29e1b549b10a540858c3dafd7b0c7e0f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/69b624b57d805706a3530aab809cf0ef29e1b549b10a540858c3dafd7b0c7e0f.mp4',
          name: 'Pigeon_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 545395,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 218,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: '9a61679edb16c9380bf00f8ebb4b468bcf0b461cf79a7e4d8afeea7096e6d0a0',
          file_name:
            'videos/9a61679edb16c9380bf00f8ebb4b468bcf0b461cf79a7e4d8afeea7096e6d0a0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9a61679edb16c9380bf00f8ebb4b468bcf0b461cf79a7e4d8afeea7096e6d0a0.mp4',
          name: 'Pigeon_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 538947,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 219,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'ff43683ff13da705097aa6ce023d182ea9c14e8c1b656a893f2d0e6716fb93c9',
          file_name:
            'audios/ff43683ff13da705097aa6ce023d182ea9c14e8c1b656a893f2d0e6716fb93c9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ff43683ff13da705097aa6ce023d182ea9c14e8c1b656a893f2d0e6716fb93c9.mp3',
          name: 'Pigeon_Stretch.mp3',
          description: null,
          size: 21568,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Runners Stretch': {
      id: 104,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Runners Stretch',
      short_name: 'Runners Stretch',
      unique_name: 'ADVANCED-Runners Stretch',
      description:
        '1. Start in a seated position with your legs straight. Bend one knee and bring it towards you until your foot is resting against the opposite inner thigh.\n2. Sit up tall and turn your torso towards your straight leg. Bend at the waist and reach for your toes.\n3. Hold and return to starting position.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 220,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '01ccc1ecfbb8363d8b327d6229b6b7dda4b32f1cac0d2a99663d6f0af5d00224',
          file_name:
            'videos/01ccc1ecfbb8363d8b327d6229b6b7dda4b32f1cac0d2a99663d6f0af5d00224.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/01ccc1ecfbb8363d8b327d6229b6b7dda4b32f1cac0d2a99663d6f0af5d00224.mp4',
          name: 'Runners_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 456459,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 221,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'd56692d690c9e63ca8b2a708e2ee86067f98a48660060262294710fd145c46e5',
          file_name:
            'videos/d56692d690c9e63ca8b2a708e2ee86067f98a48660060262294710fd145c46e5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d56692d690c9e63ca8b2a708e2ee86067f98a48660060262294710fd145c46e5.mp4',
          name: 'Runners_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 437320,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 222,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e886c241b21f613f249495429e26665a733121fbfd25cb8f0a4b2cfdf6356cfa',
          file_name:
            'audios/e886c241b21f613f249495429e26665a733121fbfd25cb8f0a4b2cfdf6356cfa.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e886c241b21f613f249495429e26665a733121fbfd25cb8f0a4b2cfdf6356cfa.mp3',
          name: 'Runners_Stretch.mp3',
          description: null,
          size: 22417,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Knee Hugs': {
      id: 105,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Knee Hugs',
      short_name: 'Knee Hugs',
      unique_name: 'ADVANCED-Knee Hugs',
      description:
        '1. Lie on your back, legs long. Keep one leg extended and hug the opposite knee into your chest.\n2. Hold and repeat with the other leg.',
      preview_time: null,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 223,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: 'a6353a19a09f026f6d6926848a9cbd661c975b51991c2344efb0c0c6ea740577',
          file_name:
            'videos/a6353a19a09f026f6d6926848a9cbd661c975b51991c2344efb0c0c6ea740577.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a6353a19a09f026f6d6926848a9cbd661c975b51991c2344efb0c0c6ea740577.mp4',
          name: 'Knee_Hugs-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 363325,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 224,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: '1f1707dac07e5d1dbe3db7aee8f41b56588c7efa5ac9bf91675803eb3f2959dd',
          file_name:
            'videos/1f1707dac07e5d1dbe3db7aee8f41b56588c7efa5ac9bf91675803eb3f2959dd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1f1707dac07e5d1dbe3db7aee8f41b56588c7efa5ac9bf91675803eb3f2959dd.mp4',
          name: 'Knee_Hugs-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 345199,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 225,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'f39fccf151d0baad426d0f451c5f5793b07b8b985c668dbf024c3d53dd31f75b',
          file_name:
            'audios/f39fccf151d0baad426d0f451c5f5793b07b8b985c668dbf024c3d53dd31f75b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f39fccf151d0baad426d0f451c5f5793b07b8b985c668dbf024c3d53dd31f75b.mp3',
          name: 'Knee_Hugs.mp3',
          description: null,
          size: 18976,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Thread the Needle-COOL_DOWN': {
      id: 293,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Thread the Needle',
      short_name: 'Thread the Needle',
      unique_name: 'BEGINNER-Thread the Needle-COOL_DOWN',
      description:
        "1. From Child's Pose 'thread' one arm under your chest and other arm, palm flat on the floor.\n2. Reach as far as you can across your body and sink into the shoulder stretch. The other arm is engaged and extended out long in front of you.\n3. Return to Child's Pose and repeat on the other side.",
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 471,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '1a9ca59f9937b2545db33838a3ec91d6fc0ce9ecd7f5e6f07303e1d9cefe7cac',
          file_name:
            'videos/1a9ca59f9937b2545db33838a3ec91d6fc0ce9ecd7f5e6f07303e1d9cefe7cac.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1a9ca59f9937b2545db33838a3ec91d6fc0ce9ecd7f5e6f07303e1d9cefe7cac.mp4',
          name: 'Thread_the_Needle-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 273631,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 472,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'e9fcc1d52e6b1ad36f17fe997f436bfd095849b9a3644da97f6bc4a299193f17',
          file_name:
            'videos/e9fcc1d52e6b1ad36f17fe997f436bfd095849b9a3644da97f6bc4a299193f17.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e9fcc1d52e6b1ad36f17fe997f436bfd095849b9a3644da97f6bc4a299193f17.mp4',
          name: 'Thread_the_Needle-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 311145,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 473,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '5a42b36eabb73d55a63b7243417e02aff044d240d9e2bb666dd376852da312da',
          file_name:
            'audios/5a42b36eabb73d55a63b7243417e02aff044d240d9e2bb666dd376852da312da.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5a42b36eabb73d55a63b7243417e02aff044d240d9e2bb666dd376852da312da.mp3',
          name: 'Thread_the_Needle-COOL_DOWN.mp3',
          description: null,
          size: 20166,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Thread the Needle-COOL_DOWN': {
      id: 294,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Thread the Needle',
      short_name: 'Thread the Needle',
      unique_name: 'INTERMEDIATE-Thread the Needle-COOL_DOWN',
      description:
        "1. From Child's Pose 'thread' one arm under your chest and other arm, palm flat on the floor.\n2. Reach as far as you can across your body and sink into the shoulder stretch. The other arm is engaged and extended out long in front of you.\n3. Return to Child's Pose and repeat on the other side.",
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 474,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '1a9ca59f9937b2545db33838a3ec91d6fc0ce9ecd7f5e6f07303e1d9cefe7cac',
          file_name:
            'videos/1a9ca59f9937b2545db33838a3ec91d6fc0ce9ecd7f5e6f07303e1d9cefe7cac.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1a9ca59f9937b2545db33838a3ec91d6fc0ce9ecd7f5e6f07303e1d9cefe7cac.mp4',
          name: 'Thread_the_Needle-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 273631,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 475,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'e9fcc1d52e6b1ad36f17fe997f436bfd095849b9a3644da97f6bc4a299193f17',
          file_name:
            'videos/e9fcc1d52e6b1ad36f17fe997f436bfd095849b9a3644da97f6bc4a299193f17.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e9fcc1d52e6b1ad36f17fe997f436bfd095849b9a3644da97f6bc4a299193f17.mp4',
          name: 'Thread_the_Needle-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 311145,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 476,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '5a42b36eabb73d55a63b7243417e02aff044d240d9e2bb666dd376852da312da',
          file_name:
            'audios/5a42b36eabb73d55a63b7243417e02aff044d240d9e2bb666dd376852da312da.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5a42b36eabb73d55a63b7243417e02aff044d240d9e2bb666dd376852da312da.mp3',
          name: 'Thread_the_Needle-COOL_DOWN.mp3',
          description: null,
          size: 20166,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Thread the Needle-COOL_DOWN': {
      id: 295,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Thread the Needle',
      short_name: 'Thread the Needle',
      unique_name: 'ADVANCED-Thread the Needle-COOL_DOWN',
      description:
        "1. From Child's Pose 'thread' one arm under your chest and other arm, palm flat on the floor.\n2. Reach as far as you can across your body and sink into the shoulder stretch. The other arm is engaged and extended out long in front of you.\n3. Return to Child's Pose and repeat on the other side.",
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 477,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '1a9ca59f9937b2545db33838a3ec91d6fc0ce9ecd7f5e6f07303e1d9cefe7cac',
          file_name:
            'videos/1a9ca59f9937b2545db33838a3ec91d6fc0ce9ecd7f5e6f07303e1d9cefe7cac.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1a9ca59f9937b2545db33838a3ec91d6fc0ce9ecd7f5e6f07303e1d9cefe7cac.mp4',
          name: 'Thread_the_Needle-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 273631,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 478,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'e9fcc1d52e6b1ad36f17fe997f436bfd095849b9a3644da97f6bc4a299193f17',
          file_name:
            'videos/e9fcc1d52e6b1ad36f17fe997f436bfd095849b9a3644da97f6bc4a299193f17.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e9fcc1d52e6b1ad36f17fe997f436bfd095849b9a3644da97f6bc4a299193f17.mp4',
          name: 'Thread_the_Needle-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 311145,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 479,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '5a42b36eabb73d55a63b7243417e02aff044d240d9e2bb666dd376852da312da',
          file_name:
            'audios/5a42b36eabb73d55a63b7243417e02aff044d240d9e2bb666dd376852da312da.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5a42b36eabb73d55a63b7243417e02aff044d240d9e2bb666dd376852da312da.mp3',
          name: 'Thread_the_Needle-COOL_DOWN.mp3',
          description: null,
          size: 20166,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Standing Shoulder Stretch-COOL_DOWN': {
      id: 296,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Standing Shoulder Stretch',
      short_name: 'Standing Shoulder Stretch',
      unique_name: 'BEGINNER-Standing Shoulder Stretch-COOL_DOWN',
      description:
        '1. Stand tall with your back straight and core tight. Bring one arm straight across your body.\n2. With your opposite hand, apply gentle pressure on your upper arm, pressing toward your chest. Breathe into the shoulder stretch.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 480,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '899fb1052dcd7e06f25a94e2af3eb7e8d0a847784f2052c0daf978360d53170e',
          file_name:
            'videos/899fb1052dcd7e06f25a94e2af3eb7e8d0a847784f2052c0daf978360d53170e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/899fb1052dcd7e06f25a94e2af3eb7e8d0a847784f2052c0daf978360d53170e.mp4',
          name: 'Standing_Shoulder_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 335762,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 481,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'cbc43ba98fdb7f511c35d0f3563efebde4954aacb840733954a874453d12dbdf',
          file_name:
            'videos/cbc43ba98fdb7f511c35d0f3563efebde4954aacb840733954a874453d12dbdf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cbc43ba98fdb7f511c35d0f3563efebde4954aacb840733954a874453d12dbdf.mp4',
          name: 'Standing_Shoulder_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 327528,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 482,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '1d50e106fab6687090cf79a7878393f41473a27394bc7ed8abeb071c8179dd47',
          file_name:
            'audios/1d50e106fab6687090cf79a7878393f41473a27394bc7ed8abeb071c8179dd47.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1d50e106fab6687090cf79a7878393f41473a27394bc7ed8abeb071c8179dd47.mp3',
          name: 'Standing_Shoulder_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 28230,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Standing Shoulder Stretch-COOL_DOWN': {
      id: 297,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Standing Shoulder Stretch',
      short_name: 'Standing Shoulder Stretch',
      unique_name: 'INTERMEDIATE-Standing Shoulder Stretch-COOL_DOWN',
      description:
        '1. Stand tall with your back straight and core tight. Bring one arm straight across your body.\n2. With your opposite hand, apply gentle pressure on your upper arm, pressing toward your chest. Breathe into the shoulder stretch.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 483,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '899fb1052dcd7e06f25a94e2af3eb7e8d0a847784f2052c0daf978360d53170e',
          file_name:
            'videos/899fb1052dcd7e06f25a94e2af3eb7e8d0a847784f2052c0daf978360d53170e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/899fb1052dcd7e06f25a94e2af3eb7e8d0a847784f2052c0daf978360d53170e.mp4',
          name: 'Standing_Shoulder_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 335762,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 484,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'cbc43ba98fdb7f511c35d0f3563efebde4954aacb840733954a874453d12dbdf',
          file_name:
            'videos/cbc43ba98fdb7f511c35d0f3563efebde4954aacb840733954a874453d12dbdf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cbc43ba98fdb7f511c35d0f3563efebde4954aacb840733954a874453d12dbdf.mp4',
          name: 'Standing_Shoulder_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 327528,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 485,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '1d50e106fab6687090cf79a7878393f41473a27394bc7ed8abeb071c8179dd47',
          file_name:
            'audios/1d50e106fab6687090cf79a7878393f41473a27394bc7ed8abeb071c8179dd47.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1d50e106fab6687090cf79a7878393f41473a27394bc7ed8abeb071c8179dd47.mp3',
          name: 'Standing_Shoulder_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 28230,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Standing Shoulder Stretch-COOL_DOWN': {
      id: 298,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Standing Shoulder Stretch',
      short_name: 'Standing Shoulder Stretch',
      unique_name: 'ADVANCED-Standing Shoulder Stretch-COOL_DOWN',
      description:
        '1. Stand tall with your back straight and core tight. Bring one arm straight across your body.\n2. With your opposite hand, apply gentle pressure on your upper arm, pressing toward your chest. Breathe into the shoulder stretch.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 486,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '899fb1052dcd7e06f25a94e2af3eb7e8d0a847784f2052c0daf978360d53170e',
          file_name:
            'videos/899fb1052dcd7e06f25a94e2af3eb7e8d0a847784f2052c0daf978360d53170e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/899fb1052dcd7e06f25a94e2af3eb7e8d0a847784f2052c0daf978360d53170e.mp4',
          name: 'Standing_Shoulder_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 335762,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 487,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'cbc43ba98fdb7f511c35d0f3563efebde4954aacb840733954a874453d12dbdf',
          file_name:
            'videos/cbc43ba98fdb7f511c35d0f3563efebde4954aacb840733954a874453d12dbdf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cbc43ba98fdb7f511c35d0f3563efebde4954aacb840733954a874453d12dbdf.mp4',
          name: 'Standing_Shoulder_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 327528,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 488,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '1d50e106fab6687090cf79a7878393f41473a27394bc7ed8abeb071c8179dd47',
          file_name:
            'audios/1d50e106fab6687090cf79a7878393f41473a27394bc7ed8abeb071c8179dd47.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1d50e106fab6687090cf79a7878393f41473a27394bc7ed8abeb071c8179dd47.mp3',
          name: 'Standing_Shoulder_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 28230,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Child’s Pose-COOL_DOWN': {
      id: 299,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Child’s Pose',
      short_name: 'Child’s Pose',
      unique_name: 'BEGINNER-Child’s Pose-COOL_DOWN',
      description:
        '1.Start on your hands and knees, bring big toes to touch and sink back. Rest your hips close to your heels and body between your knees.\n2. Walk your hands in front of you and rest your forehead on the floor.\n3. Extend your arms long in front of you, palms planted on the floor.\n4. Breathe into the stretch feeling your ribcage expand and your back release.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 534,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '2918d9c35a3e82dd865864b9922b4e7ea4a4dce5e5d9c83f005cb2cbeb6fd4f2',
          file_name:
            'videos/2918d9c35a3e82dd865864b9922b4e7ea4a4dce5e5d9c83f005cb2cbeb6fd4f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2918d9c35a3e82dd865864b9922b4e7ea4a4dce5e5d9c83f005cb2cbeb6fd4f2.mp4',
          name: 'Childs_Pose-COOL_DOWN.mp4',
          description: null,
          size: 250620,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 535,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'fef190d63210a31d53e9ddedf289efbe0591ce62a5fda09d6915db8942ce6351',
          file_name:
            'audios/fef190d63210a31d53e9ddedf289efbe0591ce62a5fda09d6915db8942ce6351.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fef190d63210a31d53e9ddedf289efbe0591ce62a5fda09d6915db8942ce6351.mp3',
          name: 'Childs-Pose.mp3',
          description: null,
          size: 25785,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Child’s Pose-COOL_DOWN': {
      id: 300,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Child’s Pose',
      short_name: 'Child’s Pose',
      unique_name: 'INTERMEDIATE-Child’s Pose-COOL_DOWN',
      description:
        '1.Start on your hands and knees, bring big toes to touch and sink back. Rest your hips close to your heels and body between your knees.\n2. Walk your hands in front of you and rest your forehead on the floor.\n3. Extend your arms long in front of you, palms planted on the floor.\n4. Breathe into the stretch feeling your ribcage expand and your back release.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 536,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '2918d9c35a3e82dd865864b9922b4e7ea4a4dce5e5d9c83f005cb2cbeb6fd4f2',
          file_name:
            'videos/2918d9c35a3e82dd865864b9922b4e7ea4a4dce5e5d9c83f005cb2cbeb6fd4f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2918d9c35a3e82dd865864b9922b4e7ea4a4dce5e5d9c83f005cb2cbeb6fd4f2.mp4',
          name: 'Childs_Pose-COOL_DOWN.mp4',
          description: null,
          size: 250620,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 537,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'fef190d63210a31d53e9ddedf289efbe0591ce62a5fda09d6915db8942ce6351',
          file_name:
            'audios/fef190d63210a31d53e9ddedf289efbe0591ce62a5fda09d6915db8942ce6351.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fef190d63210a31d53e9ddedf289efbe0591ce62a5fda09d6915db8942ce6351.mp3',
          name: 'Childs-Pose.mp3',
          description: null,
          size: 25785,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Child’s Pose-COOL_DOWN': {
      id: 301,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Child’s Pose',
      short_name: 'Child’s Pose',
      unique_name: 'ADVANCED-Child’s Pose-COOL_DOWN',
      description:
        '1.Start on your hands and knees, bring big toes to touch and sink back. Rest your hips close to your heels and body between your knees.\n2. Walk your hands in front of you and rest your forehead on the floor.\n3. Extend your arms long in front of you, palms planted on the floor.\n4. Breathe into the stretch feeling your ribcage expand and your back release.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 538,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '2918d9c35a3e82dd865864b9922b4e7ea4a4dce5e5d9c83f005cb2cbeb6fd4f2',
          file_name:
            'videos/2918d9c35a3e82dd865864b9922b4e7ea4a4dce5e5d9c83f005cb2cbeb6fd4f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2918d9c35a3e82dd865864b9922b4e7ea4a4dce5e5d9c83f005cb2cbeb6fd4f2.mp4',
          name: 'Childs_Pose-COOL_DOWN.mp4',
          description: null,
          size: 250620,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 539,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'fef190d63210a31d53e9ddedf289efbe0591ce62a5fda09d6915db8942ce6351',
          file_name:
            'audios/fef190d63210a31d53e9ddedf289efbe0591ce62a5fda09d6915db8942ce6351.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fef190d63210a31d53e9ddedf289efbe0591ce62a5fda09d6915db8942ce6351.mp3',
          name: 'Childs-Pose.mp3',
          description: null,
          size: 25785,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Child’s Pose with Side Stretch-COOL_DOWN': {
      id: 302,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Child’s Pose with Side Stretch',
      short_name: 'Child’s Pose with Side Stretch',
      unique_name: 'BEGINNER-Child’s Pose with Side Stretch-COOL_DOWN',
      description:
        '1.Start on your hands and knees, bring big toes to touch and sink back. Rest your hips close to your heels and body between your knees.\n2. Walk your hands long in front of you and rest your forehead on the floor, palms down. Breathe into the stretch.\n3. Walk both hands to one side. Breathe into the side stretch.\n4. Walk your hands back through center. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 540,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '3ea8109a68fed5cec2e6f63aafe427b0912ff163089feb61bbb6363749cd7d06',
          file_name:
            'videos/3ea8109a68fed5cec2e6f63aafe427b0912ff163089feb61bbb6363749cd7d06.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3ea8109a68fed5cec2e6f63aafe427b0912ff163089feb61bbb6363749cd7d06.mp4',
          name: 'Childs_Pose_with_Side_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 334561,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 541,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'a84c3858d7c979baf6db48656932465a57dd5bb34351cadbd8291c88c98f404c',
          file_name:
            'videos/a84c3858d7c979baf6db48656932465a57dd5bb34351cadbd8291c88c98f404c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a84c3858d7c979baf6db48656932465a57dd5bb34351cadbd8291c88c98f404c.mp4',
          name: 'Childs_Pose_with_Side_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 355060,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 542,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '5bc16aed3bc019fc3fca6a3f8cfb4b21e938875f003bfdbb0fbd9038d6c35770',
          file_name:
            'audios/5bc16aed3bc019fc3fca6a3f8cfb4b21e938875f003bfdbb0fbd9038d6c35770.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5bc16aed3bc019fc3fca6a3f8cfb4b21e938875f003bfdbb0fbd9038d6c35770.mp3',
          name: 'Childs_Pose_with_Side_Stretch.mp3',
          description: null,
          size: 38288,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Child’s Pose with Side Stretch-COOL_DOWN': {
      id: 303,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Child’s Pose with Side Stretch',
      short_name: 'Child’s Pose with Side Stretch',
      unique_name: 'INTERMEDIATE-Child’s Pose with Side Stretch-COOL_DOWN',
      description:
        '1.Start on your hands and knees, bring big toes to touch and sink back. Rest your hips close to your heels and body between your knees.\n2. Walk your hands long in front of you and rest your forehead on the floor, palms down. Breathe into the stretch.\n3. Walk both hands to one side. Breathe into the side stretch.\n4. Walk your hands back through center. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 543,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '3ea8109a68fed5cec2e6f63aafe427b0912ff163089feb61bbb6363749cd7d06',
          file_name:
            'videos/3ea8109a68fed5cec2e6f63aafe427b0912ff163089feb61bbb6363749cd7d06.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3ea8109a68fed5cec2e6f63aafe427b0912ff163089feb61bbb6363749cd7d06.mp4',
          name: 'Childs_Pose_with_Side_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 334561,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 544,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'a84c3858d7c979baf6db48656932465a57dd5bb34351cadbd8291c88c98f404c',
          file_name:
            'videos/a84c3858d7c979baf6db48656932465a57dd5bb34351cadbd8291c88c98f404c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a84c3858d7c979baf6db48656932465a57dd5bb34351cadbd8291c88c98f404c.mp4',
          name: 'Childs_Pose_with_Side_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 355060,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 545,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '5bc16aed3bc019fc3fca6a3f8cfb4b21e938875f003bfdbb0fbd9038d6c35770',
          file_name:
            'audios/5bc16aed3bc019fc3fca6a3f8cfb4b21e938875f003bfdbb0fbd9038d6c35770.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5bc16aed3bc019fc3fca6a3f8cfb4b21e938875f003bfdbb0fbd9038d6c35770.mp3',
          name: 'Childs_Pose_with_Side_Stretch.mp3',
          description: null,
          size: 38288,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Child’s Pose with Side Stretch-COOL_DOWN': {
      id: 304,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Child’s Pose with Side Stretch',
      short_name: 'Child’s Pose with Side Stretch',
      unique_name: 'ADVANCED-Child’s Pose with Side Stretch-COOL_DOWN',
      description:
        '1.Start on your hands and knees, bring big toes to touch and sink back. Rest your hips close to your heels and body between your knees.\n2. Walk your hands long in front of you and rest your forehead on the floor, palms down. Breathe into the stretch.\n3. Walk both hands to one side. Breathe into the side stretch.\n4. Walk your hands back through center. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 546,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '3ea8109a68fed5cec2e6f63aafe427b0912ff163089feb61bbb6363749cd7d06',
          file_name:
            'videos/3ea8109a68fed5cec2e6f63aafe427b0912ff163089feb61bbb6363749cd7d06.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3ea8109a68fed5cec2e6f63aafe427b0912ff163089feb61bbb6363749cd7d06.mp4',
          name: 'Childs_Pose_with_Side_Stretch-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 334561,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 547,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'a84c3858d7c979baf6db48656932465a57dd5bb34351cadbd8291c88c98f404c',
          file_name:
            'videos/a84c3858d7c979baf6db48656932465a57dd5bb34351cadbd8291c88c98f404c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a84c3858d7c979baf6db48656932465a57dd5bb34351cadbd8291c88c98f404c.mp4',
          name: 'Childs_Pose_with_Side_Stretch-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 355060,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 548,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '5bc16aed3bc019fc3fca6a3f8cfb4b21e938875f003bfdbb0fbd9038d6c35770',
          file_name:
            'audios/5bc16aed3bc019fc3fca6a3f8cfb4b21e938875f003bfdbb0fbd9038d6c35770.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5bc16aed3bc019fc3fca6a3f8cfb4b21e938875f003bfdbb0fbd9038d6c35770.mp3',
          name: 'Childs_Pose_with_Side_Stretch.mp3',
          description: null,
          size: 38288,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Lying Spinal Twists-COOL_DOWN': {
      id: 305,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Lying Spinal Twists',
      short_name: 'Lying Spinal Twists',
      unique_name: 'BEGINNER-Lying Spinal Twists-COOL_DOWN',
      description:
        '1. Start on your back with legs extended long.\n2. Hug one knee in close to your body with the opposite side arm. Extend the other arm out to the side resting on the floor.\n3. Guide your knee across your body with your hand letting your knee fall to the side. Press down lightly to feel the stretch. Turn your head in the opposite direction.\n4. Breathe into the spinal twist. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 549,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '2a98ba4f698f3b575b9bea56bab9343460554ec137cd451c0c48198dd5ab7eb8',
          file_name:
            'videos/2a98ba4f698f3b575b9bea56bab9343460554ec137cd451c0c48198dd5ab7eb8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2a98ba4f698f3b575b9bea56bab9343460554ec137cd451c0c48198dd5ab7eb8.mp4',
          name: 'Lying_Spinal_Twist-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 443605,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 550,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'f60e2d688232f63e1472d45c182bcc6fa8e49332111842adcdccd086cde4700a',
          file_name:
            'videos/f60e2d688232f63e1472d45c182bcc6fa8e49332111842adcdccd086cde4700a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f60e2d688232f63e1472d45c182bcc6fa8e49332111842adcdccd086cde4700a.mp4',
          name: 'Lying_Spinal_Twist-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 478484,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 551,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'ba65bbf9d2ce5d5496996d879734d78ea973bc371636ac5477d0be907bbb41b0',
          file_name:
            'audios/ba65bbf9d2ce5d5496996d879734d78ea973bc371636ac5477d0be907bbb41b0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ba65bbf9d2ce5d5496996d879734d78ea973bc371636ac5477d0be907bbb41b0.mp3',
          name: 'Lying_Spinal_Twists-COOL_DOWN.mp3',
          description: null,
          size: 27424,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Lying Spinal Twists-COOL_DOWN': {
      id: 306,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Lying Spinal Twists',
      short_name: 'Lying Spinal Twists',
      unique_name: 'INTERMEDIATE-Lying Spinal Twists-COOL_DOWN',
      description:
        '1. Start on your back with legs extended long.\n2. Hug one knee in close to your body with the opposite side arm. Extend the other arm out to the side resting on the floor.\n3. Guide your knee across your body with your hand letting your knee fall to the side. Press down lightly to feel the stretch. Turn your head in the opposite direction.\n4. Breathe into the spinal twist. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 552,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '2a98ba4f698f3b575b9bea56bab9343460554ec137cd451c0c48198dd5ab7eb8',
          file_name:
            'videos/2a98ba4f698f3b575b9bea56bab9343460554ec137cd451c0c48198dd5ab7eb8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2a98ba4f698f3b575b9bea56bab9343460554ec137cd451c0c48198dd5ab7eb8.mp4',
          name: 'Lying_Spinal_Twist-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 443605,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 553,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'f60e2d688232f63e1472d45c182bcc6fa8e49332111842adcdccd086cde4700a',
          file_name:
            'videos/f60e2d688232f63e1472d45c182bcc6fa8e49332111842adcdccd086cde4700a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f60e2d688232f63e1472d45c182bcc6fa8e49332111842adcdccd086cde4700a.mp4',
          name: 'Lying_Spinal_Twist-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 478484,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 554,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'ba65bbf9d2ce5d5496996d879734d78ea973bc371636ac5477d0be907bbb41b0',
          file_name:
            'audios/ba65bbf9d2ce5d5496996d879734d78ea973bc371636ac5477d0be907bbb41b0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ba65bbf9d2ce5d5496996d879734d78ea973bc371636ac5477d0be907bbb41b0.mp3',
          name: 'Lying_Spinal_Twists-COOL_DOWN.mp3',
          description: null,
          size: 27424,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Lying Spinal Twists-COOL_DOWN': {
      id: 307,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Lying Spinal Twists',
      short_name: 'Lying Spinal Twists',
      unique_name: 'ADVANCED-Lying Spinal Twists-COOL_DOWN',
      description:
        '1. Start on your back with legs extended long.\n2. Hug one knee in close to your body with the opposite side arm. Extend the other arm out to the side resting on the floor.\n3. Guide your knee across your body with your hand letting your knee fall to the side. Press down lightly to feel the stretch. Turn your head in the opposite direction.\n4. Breathe into the spinal twist. Repeat on the other side.',
      preview_time: null,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 555,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '2a98ba4f698f3b575b9bea56bab9343460554ec137cd451c0c48198dd5ab7eb8',
          file_name:
            'videos/2a98ba4f698f3b575b9bea56bab9343460554ec137cd451c0c48198dd5ab7eb8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2a98ba4f698f3b575b9bea56bab9343460554ec137cd451c0c48198dd5ab7eb8.mp4',
          name: 'Lying_Spinal_Twist-COOL_DOWN-(RIGHT).mp4',
          description: 'Right Side',
          size: 443605,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 556,
          collection_name: 'videos',
          order: 2,
          version: 200000000,
          hash: 'f60e2d688232f63e1472d45c182bcc6fa8e49332111842adcdccd086cde4700a',
          file_name:
            'videos/f60e2d688232f63e1472d45c182bcc6fa8e49332111842adcdccd086cde4700a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f60e2d688232f63e1472d45c182bcc6fa8e49332111842adcdccd086cde4700a.mp4',
          name: 'Lying_Spinal_Twist-COOL_DOWN-(LEFT).mp4',
          description: 'Left Side',
          size: 478484,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 557,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'ba65bbf9d2ce5d5496996d879734d78ea973bc371636ac5477d0be907bbb41b0',
          file_name:
            'audios/ba65bbf9d2ce5d5496996d879734d78ea973bc371636ac5477d0be907bbb41b0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ba65bbf9d2ce5d5496996d879734d78ea973bc371636ac5477d0be907bbb41b0.mp3',
          name: 'Lying_Spinal_Twists-COOL_DOWN.mp3',
          description: null,
          size: 27424,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Cat-Cow-COOL_DOWN': {
      id: 505,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Cat/Cow',
      short_name: 'Cat/Cow',
      unique_name: 'BEGINNER-Cat-Cow-COOL_DOWN',
      description:
        '1. Start on all fours with a flat back, shoulders over wrists, palms flat and hips over knees.\n2. Draw your navel in and round your back. Tuck your tailbone and your head travels toward your upper arms, ears close to biceps. Pause for a beat in "Cat".\n3. Return to neutral spine.\n4. Drop your belly toward the floor, lift your tailbone, arch your back and raise your chin. Keep shoulders away from the ears and open your chest. Pause for a beat in "Cow".\n5. Return to neutral and repeat.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1047,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6696d3fd73583c4e71062266c946e3b769b939166ca8539bc866d18504441b0c',
          file_name:
            'videos/6696d3fd73583c4e71062266c946e3b769b939166ca8539bc866d18504441b0c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6696d3fd73583c4e71062266c946e3b769b939166ca8539bc866d18504441b0c.mp4',
          name: 'BEG-INT-ADV-Cat-Cow-COOL_DOWN.mp4',
          description: null,
          size: 517137,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1048,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '3ebda8bfba3cc492fc5cdc86612550600db4caaa845b7fe670b18420c08a17c6',
          file_name:
            'audios/3ebda8bfba3cc492fc5cdc86612550600db4caaa845b7fe670b18420c08a17c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3ebda8bfba3cc492fc5cdc86612550600db4caaa845b7fe670b18420c08a17c6.mp3',
          name: 'BEG-INT-ADV-Cat-Cow-COOL_DOWN.mp3',
          description: null,
          size: 20557,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Cat-Cow-COOL_DOWN': {
      id: 506,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Cat/Cow',
      short_name: 'Cat/Cow',
      unique_name: 'INTERMEDIATE-Cat-Cow-COOL_DOWN',
      description:
        '1. Start on all fours with a flat back, shoulders over wrists, palms flat and hips over knees.\n2. Draw your navel in and round your back. Tuck your tailbone and your head travels toward your upper arms, ears close to biceps. Pause for a beat in "Cat".\n3. Return to neutral spine.\n4. Drop your belly toward the floor, lift your tailbone, arch your back and raise your chin. Keep shoulders away from the ears and open your chest. Pause for a beat in "Cow".\n5. Return to neutral and repeat.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1049,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6696d3fd73583c4e71062266c946e3b769b939166ca8539bc866d18504441b0c',
          file_name:
            'videos/6696d3fd73583c4e71062266c946e3b769b939166ca8539bc866d18504441b0c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6696d3fd73583c4e71062266c946e3b769b939166ca8539bc866d18504441b0c.mp4',
          name: 'BEG-INT-ADV-Cat-Cow-COOL_DOWN.mp4',
          description: null,
          size: 517137,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1050,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '3ebda8bfba3cc492fc5cdc86612550600db4caaa845b7fe670b18420c08a17c6',
          file_name:
            'audios/3ebda8bfba3cc492fc5cdc86612550600db4caaa845b7fe670b18420c08a17c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3ebda8bfba3cc492fc5cdc86612550600db4caaa845b7fe670b18420c08a17c6.mp3',
          name: 'BEG-INT-ADV-Cat-Cow-COOL_DOWN.mp3',
          description: null,
          size: 20557,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Cat-Cow-COOL_DOWN': {
      id: 507,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Cat/Cow',
      short_name: 'Cat/Cow',
      unique_name: 'ADVANCED-Cat-Cow-COOL_DOWN',
      description:
        '1. Start on all fours with a flat back, shoulders over wrists, palms flat and hips over knees.\n2. Draw your navel in and round your back. Tuck your tailbone and your head travels toward your upper arms, ears close to biceps. Pause for a beat in "Cat".\n3. Return to neutral spine.\n4. Drop your belly toward the floor, lift your tailbone, arch your back and raise your chin. Keep shoulders away from the ears and open your chest. Pause for a beat in "Cow".\n5. Return to neutral and repeat.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1051,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6696d3fd73583c4e71062266c946e3b769b939166ca8539bc866d18504441b0c',
          file_name:
            'videos/6696d3fd73583c4e71062266c946e3b769b939166ca8539bc866d18504441b0c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6696d3fd73583c4e71062266c946e3b769b939166ca8539bc866d18504441b0c.mp4',
          name: 'BEG-INT-ADV-Cat-Cow-COOL_DOWN.mp4',
          description: null,
          size: 517137,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1052,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '3ebda8bfba3cc492fc5cdc86612550600db4caaa845b7fe670b18420c08a17c6',
          file_name:
            'audios/3ebda8bfba3cc492fc5cdc86612550600db4caaa845b7fe670b18420c08a17c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3ebda8bfba3cc492fc5cdc86612550600db4caaa845b7fe670b18420c08a17c6.mp3',
          name: 'BEG-INT-ADV-Cat-Cow-COOL_DOWN.mp3',
          description: null,
          size: 20557,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Puppy_Pose-COOL_DOWN': {
      id: 508,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Puppy Pose',
      short_name: 'Puppy Pose',
      unique_name: 'BEGINNER-Puppy_Pose-COOL_DOWN',
      description:
        '1. Start on all fours in Table-Top position, shoulder over wrists, palms flat and hips over knees.\n2. Keeping your hips square and over knees, walk your hands out long in front of you.\n3. Drop your head and chest toward the floor, feeling a stretch in your shoulders, chest and upper back.\n4. Pause and breathe.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1100,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'faecaa4a7a41ee0891bdff2bb8013370468f3b09d03fe00fd9dcbd48ffb3b1df',
          file_name:
            'videos/faecaa4a7a41ee0891bdff2bb8013370468f3b09d03fe00fd9dcbd48ffb3b1df.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/faecaa4a7a41ee0891bdff2bb8013370468f3b09d03fe00fd9dcbd48ffb3b1df.mp4',
          name: 'BEG-INT-ADV-Puppy_Pose-COOL_DOWN.mp4',
          description: null,
          size: 301840,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1101,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '0a2e69d0a39bc64a0c2a0667f3896f99e7e97157a09ee1a0afab483a00a34f8d',
          file_name:
            'audios/0a2e69d0a39bc64a0c2a0667f3896f99e7e97157a09ee1a0afab483a00a34f8d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0a2e69d0a39bc64a0c2a0667f3896f99e7e97157a09ee1a0afab483a00a34f8d.mp3',
          name: 'BEG-INT-ADV-Puppy_Pose-COOL_DOWN.mp3',
          description: null,
          size: 19930,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Puppy_Pose-COOL_DOWN': {
      id: 509,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Puppy Pose',
      short_name: 'Puppy Pose',
      unique_name: 'INTERMEDIATE-Puppy_Pose-COOL_DOWN',
      description:
        '1. Start on all fours in Table-Top position, shoulder over wrists, palms flat and hips over knees.\n2. Keeping your hips square and over knees, walk your hands out long in front of you.\n3. Drop your head and chest toward the floor, feeling a stretch in your shoulders, chest and upper back.\n4. Pause and breathe.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1102,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'faecaa4a7a41ee0891bdff2bb8013370468f3b09d03fe00fd9dcbd48ffb3b1df',
          file_name:
            'videos/faecaa4a7a41ee0891bdff2bb8013370468f3b09d03fe00fd9dcbd48ffb3b1df.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/faecaa4a7a41ee0891bdff2bb8013370468f3b09d03fe00fd9dcbd48ffb3b1df.mp4',
          name: 'BEG-INT-ADV-Puppy_Pose-COOL_DOWN.mp4',
          description: null,
          size: 301840,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1103,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '0a2e69d0a39bc64a0c2a0667f3896f99e7e97157a09ee1a0afab483a00a34f8d',
          file_name:
            'audios/0a2e69d0a39bc64a0c2a0667f3896f99e7e97157a09ee1a0afab483a00a34f8d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0a2e69d0a39bc64a0c2a0667f3896f99e7e97157a09ee1a0afab483a00a34f8d.mp3',
          name: 'BEG-INT-ADV-Puppy_Pose-COOL_DOWN.mp3',
          description: null,
          size: 19930,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Puppy_Pose-COOL_DOWN': {
      id: 510,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Puppy Pose',
      short_name: 'Puppy Pose',
      unique_name: 'ADVANCED-Puppy_Pose-COOL_DOWN',
      description:
        '1. Start on all fours in Table-Top position, shoulder over wrists, palms flat and hips over knees.\n2. Keeping your hips square and over knees, walk your hands out long in front of you.\n3. Drop your head and chest toward the floor, feeling a stretch in your shoulders, chest and upper back.\n4. Pause and breathe.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1104,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'faecaa4a7a41ee0891bdff2bb8013370468f3b09d03fe00fd9dcbd48ffb3b1df',
          file_name:
            'videos/faecaa4a7a41ee0891bdff2bb8013370468f3b09d03fe00fd9dcbd48ffb3b1df.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/faecaa4a7a41ee0891bdff2bb8013370468f3b09d03fe00fd9dcbd48ffb3b1df.mp4',
          name: 'BEG-INT-ADV-Puppy_Pose-COOL_DOWN.mp4',
          description: null,
          size: 301840,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1105,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '0a2e69d0a39bc64a0c2a0667f3896f99e7e97157a09ee1a0afab483a00a34f8d',
          file_name:
            'audios/0a2e69d0a39bc64a0c2a0667f3896f99e7e97157a09ee1a0afab483a00a34f8d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0a2e69d0a39bc64a0c2a0667f3896f99e7e97157a09ee1a0afab483a00a34f8d.mp3',
          name: 'BEG-INT-ADV-Puppy_Pose-COOL_DOWN.mp3',
          description: null,
          size: 19930,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Seated_Forward_Fold-COOL_DOWN': {
      id: 511,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Seated Forward Fold',
      short_name: 'Seated Forward Fold',
      unique_name: 'BEGINNER-Seated_Forward_Fold-COOL_DOWN',
      description:
        '1. Sit with legs long in front of you. Keeping legs together, spine straight, and core tight, raise arms above your head.\n2. Maintain posture and straight legs. Hinge at the waist and fold your upper body forward while you reach for your toes.\n3. Go only as far as you can with a straight back to feel a good stretch in your hamstrings.\n4. Hold and breathe in the depth of your individual flexibility.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1123,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'd0a926dc4f49eaafa23814bf67c200ad7fcca7533e94ed76903528a9a0e2ff9a',
          file_name:
            'videos/d0a926dc4f49eaafa23814bf67c200ad7fcca7533e94ed76903528a9a0e2ff9a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d0a926dc4f49eaafa23814bf67c200ad7fcca7533e94ed76903528a9a0e2ff9a.mp4',
          name: 'BEG-INT-ADV-Seated_Forward_Fold-COOL_DOWN.mp4',
          description: null,
          size: 409588,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1124,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'e001e1a96a2779d3e12f26ee850353ba8327ecd7df1faef914f327b4012ba4d8',
          file_name:
            'audios/e001e1a96a2779d3e12f26ee850353ba8327ecd7df1faef914f327b4012ba4d8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e001e1a96a2779d3e12f26ee850353ba8327ecd7df1faef914f327b4012ba4d8.mp3',
          name: 'BEG-INT-ADV-Seated_Forward_Fold-COOL_DOWN.mp3',
          description: null,
          size: 26827,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Seated_Forward_Fold-COOL_DOWN': {
      id: 512,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Seated Forward Fold',
      short_name: 'Seated Forward Fold',
      unique_name: 'INTERMEDIATE-Seated_Forward_Fold-COOL_DOWN',
      description:
        '1. Sit with legs long in front of you. Keeping legs together, spine straight, and core tight, raise arms above your head.\n2. Maintain posture and straight legs. Hinge at the waist and fold your upper body forward while you reach for your toes.\n3. Go only as far as you can with a straight back to feel a good stretch in your hamstrings.\n4. Hold and breathe in the depth of your individual flexibility.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1125,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'd0a926dc4f49eaafa23814bf67c200ad7fcca7533e94ed76903528a9a0e2ff9a',
          file_name:
            'videos/d0a926dc4f49eaafa23814bf67c200ad7fcca7533e94ed76903528a9a0e2ff9a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d0a926dc4f49eaafa23814bf67c200ad7fcca7533e94ed76903528a9a0e2ff9a.mp4',
          name: 'BEG-INT-ADV-Seated_Forward_Fold-COOL_DOWN.mp4',
          description: null,
          size: 409588,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1126,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'e001e1a96a2779d3e12f26ee850353ba8327ecd7df1faef914f327b4012ba4d8',
          file_name:
            'audios/e001e1a96a2779d3e12f26ee850353ba8327ecd7df1faef914f327b4012ba4d8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e001e1a96a2779d3e12f26ee850353ba8327ecd7df1faef914f327b4012ba4d8.mp3',
          name: 'BEG-INT-ADV-Seated_Forward_Fold-COOL_DOWN.mp3',
          description: null,
          size: 26827,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Seated_Forward_Fold-COOL_DOWN': {
      id: 513,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Seated Forward Fold',
      short_name: 'Seated Forward Fold',
      unique_name: 'ADVANCED-Seated_Forward_Fold-COOL_DOWN',
      description:
        '1. Sit with legs long in front of you. Keeping legs together, spine straight, and core tight, raise arms above your head.\n2. Maintain posture and straight legs. Hinge at the waist and fold your upper body forward while you reach for your toes.\n3. Go only as far as you can with a straight back to feel a good stretch in your hamstrings.\n4. Hold and breathe in the depth of your individual flexibility.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1127,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'd0a926dc4f49eaafa23814bf67c200ad7fcca7533e94ed76903528a9a0e2ff9a',
          file_name:
            'videos/d0a926dc4f49eaafa23814bf67c200ad7fcca7533e94ed76903528a9a0e2ff9a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d0a926dc4f49eaafa23814bf67c200ad7fcca7533e94ed76903528a9a0e2ff9a.mp4',
          name: 'BEG-INT-ADV-Seated_Forward_Fold-COOL_DOWN.mp4',
          description: null,
          size: 409588,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1128,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'e001e1a96a2779d3e12f26ee850353ba8327ecd7df1faef914f327b4012ba4d8',
          file_name:
            'audios/e001e1a96a2779d3e12f26ee850353ba8327ecd7df1faef914f327b4012ba4d8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e001e1a96a2779d3e12f26ee850353ba8327ecd7df1faef914f327b4012ba4d8.mp3',
          name: 'BEG-INT-ADV-Seated_Forward_Fold-COOL_DOWN.mp3',
          description: null,
          size: 26827,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Seated_Butterfly_Stretch-COOL_DOWN': {
      id: 514,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Seated Butterfly Stretch',
      short_name: 'Seated Butterfly Stretch',
      unique_name: 'BEGINNER-Seated_Butterfly_Stretch-COOL_DOWN',
      description:
        '1. Sit up tall with the soles of your feet together, knees out wide, hands rest on tops of feet.\n2. With a long spine, hinge at the waist as you move your torso forward and toward the floor, in between your knees.\n3. Bend as far as you can, keeping a straight spine to feel a good stretch. Pause and breathe.\n4. Option to deepen the stretch by pressing your knees toward the floor with your elbows.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1129,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '7cffbb110f9eeb763ee88e25aec4c255053efd11acb60880590fd76a7603e98a',
          file_name:
            'videos/7cffbb110f9eeb763ee88e25aec4c255053efd11acb60880590fd76a7603e98a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7cffbb110f9eeb763ee88e25aec4c255053efd11acb60880590fd76a7603e98a.mp4',
          name: 'BEG-INT-ADV-Seated_Butterfly_Stretch-COOL_DOWN.mp4',
          description: null,
          size: 290912,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1130,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '9a19f69ebe78ec25bf6b084466a78a662915b3e4b38127f9d18d8acd36c2caf0',
          file_name:
            'audios/9a19f69ebe78ec25bf6b084466a78a662915b3e4b38127f9d18d8acd36c2caf0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9a19f69ebe78ec25bf6b084466a78a662915b3e4b38127f9d18d8acd36c2caf0.mp3',
          name: 'BEG-INT-ADV-Seated_Butterfly_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 30275,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Seated_Butterfly_Stretch-COOL_DOWN': {
      id: 515,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Seated Butterfly Stretch',
      short_name: 'Seated Butterfly Stretch',
      unique_name: 'INTERMEDIATE-Seated_Butterfly_Stretch-COOL_DOWN',
      description:
        '1. Sit up tall with the soles of your feet together, knees out wide, hands rest on tops of feet.\n2. With a long spine, hinge at the waist as you move your torso forward and toward the floor, in between your knees.\n3. Bend as far as you can, keeping a straight spine to feel a good stretch. Pause and breathe.\n4. Option to deepen the stretch by pressing your knees toward the floor with your elbows.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1131,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '7cffbb110f9eeb763ee88e25aec4c255053efd11acb60880590fd76a7603e98a',
          file_name:
            'videos/7cffbb110f9eeb763ee88e25aec4c255053efd11acb60880590fd76a7603e98a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7cffbb110f9eeb763ee88e25aec4c255053efd11acb60880590fd76a7603e98a.mp4',
          name: 'BEG-INT-ADV-Seated_Butterfly_Stretch-COOL_DOWN.mp4',
          description: null,
          size: 290912,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1132,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '9a19f69ebe78ec25bf6b084466a78a662915b3e4b38127f9d18d8acd36c2caf0',
          file_name:
            'audios/9a19f69ebe78ec25bf6b084466a78a662915b3e4b38127f9d18d8acd36c2caf0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9a19f69ebe78ec25bf6b084466a78a662915b3e4b38127f9d18d8acd36c2caf0.mp3',
          name: 'BEG-INT-ADV-Seated_Butterfly_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 30275,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Seated_Butterfly_Stretch-COOL_DOWN': {
      id: 516,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Seated Butterfly Stretch',
      short_name: 'Seated Butterfly Stretch',
      unique_name: 'ADVANCED-Seated_Butterfly_Stretch-COOL_DOWN',
      description:
        '1. Sit up tall with the soles of your feet together, knees out wide, hands rest on tops of feet.\n2. With a long spine, hinge at the waist as you move your torso forward and toward the floor, in between your knees.\n3. Bend as far as you can, keeping a straight spine to feel a good stretch. Pause and breathe.\n4. Option to deepen the stretch by pressing your knees toward the floor with your elbows.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1133,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '7cffbb110f9eeb763ee88e25aec4c255053efd11acb60880590fd76a7603e98a',
          file_name:
            'videos/7cffbb110f9eeb763ee88e25aec4c255053efd11acb60880590fd76a7603e98a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7cffbb110f9eeb763ee88e25aec4c255053efd11acb60880590fd76a7603e98a.mp4',
          name: 'BEG-INT-ADV-Seated_Butterfly_Stretch-COOL_DOWN.mp4',
          description: null,
          size: 290912,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1134,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '9a19f69ebe78ec25bf6b084466a78a662915b3e4b38127f9d18d8acd36c2caf0',
          file_name:
            'audios/9a19f69ebe78ec25bf6b084466a78a662915b3e4b38127f9d18d8acd36c2caf0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9a19f69ebe78ec25bf6b084466a78a662915b3e4b38127f9d18d8acd36c2caf0.mp3',
          name: 'BEG-INT-ADV-Seated_Butterfly_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 30275,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Twisted_Puppy-COOL_DOWN': {
      id: 517,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Twisted Puppy',
      short_name: 'Twisted Puppy',
      unique_name: 'BEGINNER-Twisted_Puppy-COOL_DOWN',
      description:
        '1. Start on all fours in Table Top position, shoulder over wrists, palms flat and your hips above your knees.\n2. Keeping your hips square and over knees, walk your hands out long in front of you.\n3. Take one arm and thread it underneath you across your chest, palm faces up.\n4. Pause and breathe, feeling the stretch in your shoulders, chest and upper back. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1146,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'f07037be35097245758ce270fbcaf17aae95a28bcc64e2c3155e71dccde26896',
          file_name:
            'videos/f07037be35097245758ce270fbcaf17aae95a28bcc64e2c3155e71dccde26896.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f07037be35097245758ce270fbcaf17aae95a28bcc64e2c3155e71dccde26896.mp4',
          name: 'BEG-INT-ADV-Twisted_Puppy-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 154273,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1147,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: '4021ed1cfe770eca4482abec65e7977375a3e72e5f7e740a9f21f262614e6d87',
          file_name:
            'videos/4021ed1cfe770eca4482abec65e7977375a3e72e5f7e740a9f21f262614e6d87.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4021ed1cfe770eca4482abec65e7977375a3e72e5f7e740a9f21f262614e6d87.mp4',
          name: 'BEG-INT-ADV-Twisted_Puppy-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 174802,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1148,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '46d020d2fb7c22dfac135c25e2251610d377e673c5411a9448db6a3f0b30a38e',
          file_name:
            'audios/46d020d2fb7c22dfac135c25e2251610d377e673c5411a9448db6a3f0b30a38e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/46d020d2fb7c22dfac135c25e2251610d377e673c5411a9448db6a3f0b30a38e.mp3',
          name: 'BEG-INT-ADV-Twisted_Puppy-COOL_DOWN.mp3',
          description: null,
          size: 21808,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Twisted_Puppy-COOL_DOWN': {
      id: 518,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Twisted Puppy',
      short_name: 'Twisted Puppy',
      unique_name: 'INTERMEDIATE-Twisted_Puppy-COOL_DOWN',
      description:
        '1. Start on all fours in Table Top position, shoulder over wrists, palms flat and your hips above your knees.\n2. Keeping your hips square and over knees, walk your hands out long in front of you.\n3. Take one arm and thread it underneath you across your chest, palm faces up.\n4. Pause and breathe, feeling the stretch in your shoulders, chest and upper back. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1149,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'f07037be35097245758ce270fbcaf17aae95a28bcc64e2c3155e71dccde26896',
          file_name:
            'videos/f07037be35097245758ce270fbcaf17aae95a28bcc64e2c3155e71dccde26896.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f07037be35097245758ce270fbcaf17aae95a28bcc64e2c3155e71dccde26896.mp4',
          name: 'BEG-INT-ADV-Twisted_Puppy-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 154273,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1150,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: '4021ed1cfe770eca4482abec65e7977375a3e72e5f7e740a9f21f262614e6d87',
          file_name:
            'videos/4021ed1cfe770eca4482abec65e7977375a3e72e5f7e740a9f21f262614e6d87.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4021ed1cfe770eca4482abec65e7977375a3e72e5f7e740a9f21f262614e6d87.mp4',
          name: 'BEG-INT-ADV-Twisted_Puppy-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 174802,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1151,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '46d020d2fb7c22dfac135c25e2251610d377e673c5411a9448db6a3f0b30a38e',
          file_name:
            'audios/46d020d2fb7c22dfac135c25e2251610d377e673c5411a9448db6a3f0b30a38e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/46d020d2fb7c22dfac135c25e2251610d377e673c5411a9448db6a3f0b30a38e.mp3',
          name: 'BEG-INT-ADV-Twisted_Puppy-COOL_DOWN.mp3',
          description: null,
          size: 21808,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Twisted_Puppy-COOL_DOWN': {
      id: 519,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Twisted Puppy',
      short_name: 'Twisted Puppy',
      unique_name: 'ADVANCED-Twisted_Puppy-COOL_DOWN',
      description:
        '1. Start on all fours in Table Top position, shoulder over wrists, palms flat and your hips above your knees.\n2. Keeping your hips square and over knees, walk your hands out long in front of you.\n3. Take one arm and thread it underneath you across your chest, palm faces up.\n4. Pause and breathe, feeling the stretch in your shoulders, chest and upper back. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1152,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'f07037be35097245758ce270fbcaf17aae95a28bcc64e2c3155e71dccde26896',
          file_name:
            'videos/f07037be35097245758ce270fbcaf17aae95a28bcc64e2c3155e71dccde26896.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f07037be35097245758ce270fbcaf17aae95a28bcc64e2c3155e71dccde26896.mp4',
          name: 'BEG-INT-ADV-Twisted_Puppy-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 154273,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1153,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: '4021ed1cfe770eca4482abec65e7977375a3e72e5f7e740a9f21f262614e6d87',
          file_name:
            'videos/4021ed1cfe770eca4482abec65e7977375a3e72e5f7e740a9f21f262614e6d87.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4021ed1cfe770eca4482abec65e7977375a3e72e5f7e740a9f21f262614e6d87.mp4',
          name: 'BEG-INT-ADV-Twisted_Puppy-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 174802,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1154,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '46d020d2fb7c22dfac135c25e2251610d377e673c5411a9448db6a3f0b30a38e',
          file_name:
            'audios/46d020d2fb7c22dfac135c25e2251610d377e673c5411a9448db6a3f0b30a38e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/46d020d2fb7c22dfac135c25e2251610d377e673c5411a9448db6a3f0b30a38e.mp3',
          name: 'BEG-INT-ADV-Twisted_Puppy-COOL_DOWN.mp3',
          description: null,
          size: 21808,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Twisting_Sumo_Squat_Stretch-COOL_DOWN': {
      id: 520,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Twisting Sumo Squat Stretch',
      short_name: 'Twisting Sumo Squat Stretch',
      unique_name: 'BEGINNER-Twisting_Sumo_Squat_Stretch-COOL_DOWN',
      description:
        '1. Stand with your feet wider than hip-width apart, toes turned out. Bend knees and sink with your hips back into a sumo squat. Place hands on knees, arms straight, back flat.\n2. Keeping your hips square, drop one shoulder to your midline. Rotate your torso and push your hand into the inside of your knee slightly to deepen the twist. Pause and breathe.\n3. With control, return to start position and repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1155,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'f7d4496dbd5067c8be9482a7f21c0be606925645eac46c14f70d4176d8e97869',
          file_name:
            'videos/f7d4496dbd5067c8be9482a7f21c0be606925645eac46c14f70d4176d8e97869.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f7d4496dbd5067c8be9482a7f21c0be606925645eac46c14f70d4176d8e97869.mp4',
          name: 'BEG-INT-ADV-Twisting_Sumo_Squat_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 200120,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1156,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'c52d26b2272345f9e98e962e2a03fd345837b6b58ef65617fc12e2e503b51dd4',
          file_name:
            'videos/c52d26b2272345f9e98e962e2a03fd345837b6b58ef65617fc12e2e503b51dd4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c52d26b2272345f9e98e962e2a03fd345837b6b58ef65617fc12e2e503b51dd4.mp4',
          name: 'BEG-INT-ADV-Twisting_Sumo_Squat_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 174698,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1157,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '89bb05e96836c5acafe1f46aeac6b1f46f8d6a9fdd233e4c9539a81d0db26798',
          file_name:
            'audios/89bb05e96836c5acafe1f46aeac6b1f46f8d6a9fdd233e4c9539a81d0db26798.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/89bb05e96836c5acafe1f46aeac6b1f46f8d6a9fdd233e4c9539a81d0db26798.mp3',
          name: 'BEG-INT-ADV-Twisting_Sumo_Squat_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 33409,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Twisting_Sumo_Squat_Stretch-COOL_DOWN': {
      id: 521,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Twisting Sumo Squat Stretch',
      short_name: 'Twisting Sumo Squat Stretch',
      unique_name: 'INTERMEDIATE-Twisting_Sumo_Squat_Stretch-COOL_DOWN',
      description:
        '1. Stand with your feet wider than hip-width apart, toes turned out. Bend knees and sink with your hips back into a sumo squat. Place hands on knees, arms straight, back flat.\n2. Keeping your hips square, drop one shoulder to your midline. Rotate your torso and push your hand into the inside of your knee slightly to deepen the twist. Pause and breathe.\n3. With control, return to start position and repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1158,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'f7d4496dbd5067c8be9482a7f21c0be606925645eac46c14f70d4176d8e97869',
          file_name:
            'videos/f7d4496dbd5067c8be9482a7f21c0be606925645eac46c14f70d4176d8e97869.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f7d4496dbd5067c8be9482a7f21c0be606925645eac46c14f70d4176d8e97869.mp4',
          name: 'BEG-INT-ADV-Twisting_Sumo_Squat_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 200120,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1159,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'c52d26b2272345f9e98e962e2a03fd345837b6b58ef65617fc12e2e503b51dd4',
          file_name:
            'videos/c52d26b2272345f9e98e962e2a03fd345837b6b58ef65617fc12e2e503b51dd4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c52d26b2272345f9e98e962e2a03fd345837b6b58ef65617fc12e2e503b51dd4.mp4',
          name: 'BEG-INT-ADV-Twisting_Sumo_Squat_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 174698,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1160,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '89bb05e96836c5acafe1f46aeac6b1f46f8d6a9fdd233e4c9539a81d0db26798',
          file_name:
            'audios/89bb05e96836c5acafe1f46aeac6b1f46f8d6a9fdd233e4c9539a81d0db26798.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/89bb05e96836c5acafe1f46aeac6b1f46f8d6a9fdd233e4c9539a81d0db26798.mp3',
          name: 'BEG-INT-ADV-Twisting_Sumo_Squat_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 33409,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Twisting_Sumo_Squat_Stretch-COOL_DOWN': {
      id: 522,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Twisting Sumo Squat Stretch',
      short_name: 'Twisting Sumo Squat Stretch',
      unique_name: 'ADVANCED-Twisting_Sumo_Squat_Stretch-COOL_DOWN',
      description:
        '1. Stand with your feet wider than hip-width apart, toes turned out. Bend knees and sink with your hips back into a sumo squat. Place hands on knees, arms straight, back flat.\n2. Keeping your hips square, drop one shoulder to your midline. Rotate your torso and push your hand into the inside of your knee slightly to deepen the twist. Pause and breathe.\n3. With control, return to start position and repeat on the other side.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1161,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'f7d4496dbd5067c8be9482a7f21c0be606925645eac46c14f70d4176d8e97869',
          file_name:
            'videos/f7d4496dbd5067c8be9482a7f21c0be606925645eac46c14f70d4176d8e97869.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f7d4496dbd5067c8be9482a7f21c0be606925645eac46c14f70d4176d8e97869.mp4',
          name: 'BEG-INT-ADV-Twisting_Sumo_Squat_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 200120,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1162,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'c52d26b2272345f9e98e962e2a03fd345837b6b58ef65617fc12e2e503b51dd4',
          file_name:
            'videos/c52d26b2272345f9e98e962e2a03fd345837b6b58ef65617fc12e2e503b51dd4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c52d26b2272345f9e98e962e2a03fd345837b6b58ef65617fc12e2e503b51dd4.mp4',
          name: 'BEG-INT-ADV-Twisting_Sumo_Squat_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 174698,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1163,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '89bb05e96836c5acafe1f46aeac6b1f46f8d6a9fdd233e4c9539a81d0db26798',
          file_name:
            'audios/89bb05e96836c5acafe1f46aeac6b1f46f8d6a9fdd233e4c9539a81d0db26798.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/89bb05e96836c5acafe1f46aeac6b1f46f8d6a9fdd233e4c9539a81d0db26798.mp3',
          name: 'BEG-INT-ADV-Twisting_Sumo_Squat_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 33409,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Down_Dog_Pedal-COOL_DOWN': {
      id: 523,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Down Dog Pedal',
      short_name: 'Down Dog Pedal',
      unique_name: 'BEGINNER-Down_Dog_Pedal-COOL_DOWN',
      description:
        '1. Start in Down Dog position. Your hands are on the ground with your head between your upper arms, your hips up and back making an inverted "V".\n2. Bend one knee toward the ground, elevating higher on your toe while keeping the other leg straight, pushing your heel closer to the floor. Feel stretch in calves and hamstrings.\n3. Repeat on the other side and continue the pedaling motion.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 927,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'c2817851c11b164e6e14816302f7f1976c114c10d2589a923b33e2bdf6d46be9',
          file_name:
            'videos/c2817851c11b164e6e14816302f7f1976c114c10d2589a923b33e2bdf6d46be9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c2817851c11b164e6e14816302f7f1976c114c10d2589a923b33e2bdf6d46be9.mp4',
          name: 'BEG-INT-ADV-Down_Dog_Pedal-COOL_DOWN.mp4',
          description: null,
          size: 630100,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 928,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'cae66afed00042163ba32aa12fd269605eacb9af90bf843e78a8c9ade8092aaa',
          file_name:
            'audios/cae66afed00042163ba32aa12fd269605eacb9af90bf843e78a8c9ade8092aaa.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cae66afed00042163ba32aa12fd269605eacb9af90bf843e78a8c9ade8092aaa.mp3',
          name: 'BEG-INT-ADV-Down_Dog_Pedal-COOL_DOWN.mp3',
          description: null,
          size: 23378,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Down_Dog_Pedal-COOL_DOWN': {
      id: 524,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Down Dog Pedal',
      short_name: 'Down Dog Pedal',
      unique_name: 'INTERMEDIATE-Down_Dog_Pedal-COOL_DOWN',
      description:
        '1. Start in Down Dog position. Your hands are on the ground with your head between your upper arms, your hips up and back making an inverted "V".\n2. Bend one knee toward the ground, elevating higher on your toe while keeping the other leg straight, pushing your heel closer to the floor. Feel stretch in calves and hamstrings.\n3. Repeat on the other side and continue the pedaling motion.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 929,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'c2817851c11b164e6e14816302f7f1976c114c10d2589a923b33e2bdf6d46be9',
          file_name:
            'videos/c2817851c11b164e6e14816302f7f1976c114c10d2589a923b33e2bdf6d46be9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c2817851c11b164e6e14816302f7f1976c114c10d2589a923b33e2bdf6d46be9.mp4',
          name: 'BEG-INT-ADV-Down_Dog_Pedal-COOL_DOWN.mp4',
          description: null,
          size: 630100,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 930,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'cae66afed00042163ba32aa12fd269605eacb9af90bf843e78a8c9ade8092aaa',
          file_name:
            'audios/cae66afed00042163ba32aa12fd269605eacb9af90bf843e78a8c9ade8092aaa.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cae66afed00042163ba32aa12fd269605eacb9af90bf843e78a8c9ade8092aaa.mp3',
          name: 'BEG-INT-ADV-Down_Dog_Pedal-COOL_DOWN.mp3',
          description: null,
          size: 23378,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Down_Dog_Pedal-COOL_DOWN': {
      id: 525,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Down Dog Pedal',
      short_name: 'Down Dog Pedal',
      unique_name: 'ADVANCED-Down_Dog_Pedal-COOL_DOWN',
      description:
        '1. Start in Down Dog position. Your hands are on the ground with your head between your upper arms, your hips up and back making an inverted "V".\n2. Bend one knee toward the ground, elevating higher on your toe while keeping the other leg straight, pushing your heel closer to the floor. Feel stretch in calves and hamstrings.\n3. Repeat on the other side and continue the pedaling motion.',
      preview_time: null,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 931,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'c2817851c11b164e6e14816302f7f1976c114c10d2589a923b33e2bdf6d46be9',
          file_name:
            'videos/c2817851c11b164e6e14816302f7f1976c114c10d2589a923b33e2bdf6d46be9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c2817851c11b164e6e14816302f7f1976c114c10d2589a923b33e2bdf6d46be9.mp4',
          name: 'BEG-INT-ADV-Down_Dog_Pedal-COOL_DOWN.mp4',
          description: null,
          size: 630100,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 932,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'cae66afed00042163ba32aa12fd269605eacb9af90bf843e78a8c9ade8092aaa',
          file_name:
            'audios/cae66afed00042163ba32aa12fd269605eacb9af90bf843e78a8c9ade8092aaa.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cae66afed00042163ba32aa12fd269605eacb9af90bf843e78a8c9ade8092aaa.mp3',
          name: 'BEG-INT-ADV-Down_Dog_Pedal-COOL_DOWN.mp3',
          description: null,
          size: 23378,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-HIP_FLEXOR_AND_SIDE_STRETCH-COOL_DOWN': {
      id: 671,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Hip Flexor and Side Stretch',
      short_name: 'Hip Flexor and Side Stretch',
      unique_name: 'BEGINNER-HIP_FLEXOR_AND_SIDE_STRETCH-COOL_DOWN',
      description:
        '1. Start half-kneeling with core engaged, spine straight and knee directly over ankle.\n2. Keeping chest up, shift your hips forward as you raise your arm and over to the side of the bent knee. Reach the opposite fingertips to the floor to stretch your side body and the hip flexor of back leg.\n3. Hold and breathe.\n4. Shift your weight back to neutral, return to start and repeat with the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1500,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'f43ba2b95a6b19d178c0c7026098f4089651437be474b5fb7a443bd045e1c76f',
          file_name:
            'videos/f43ba2b95a6b19d178c0c7026098f4089651437be474b5fb7a443bd045e1c76f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f43ba2b95a6b19d178c0c7026098f4089651437be474b5fb7a443bd045e1c76f.mp4',
          name: 'BEG-INT-ADV-Hip_Flexor_and_Side_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 320379,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1501,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '0127d1475f5ef85a08e4760c0c8ba926744c7123323f5a2161e5f63704da352a',
          file_name:
            'videos/0127d1475f5ef85a08e4760c0c8ba926744c7123323f5a2161e5f63704da352a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0127d1475f5ef85a08e4760c0c8ba926744c7123323f5a2161e5f63704da352a.mp4',
          name: 'BEG-INT-ADV-Hip_Flexor_and_Side_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 306386,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1502,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '85d8fb35fb75ffd38a4eaff7b7bf817527d61b44fe9016b24ecfcdb4d82c5d17',
          file_name:
            'audios/85d8fb35fb75ffd38a4eaff7b7bf817527d61b44fe9016b24ecfcdb4d82c5d17.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/85d8fb35fb75ffd38a4eaff7b7bf817527d61b44fe9016b24ecfcdb4d82c5d17.mp3',
          name: 'BEG-INT-ADV-Hip_Flexor_and_Side_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 32156,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-HIP_FLEXOR_AND_SIDE_STRETCH-COOL_DOWN': {
      id: 672,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Hip Flexor and Side Stretch',
      short_name: 'Hip Flexor and Side Stretch',
      unique_name: 'INTERMEDIATE-HIP_FLEXOR_AND_SIDE_STRETCH-COOL_DOWN',
      description:
        '1. Start half-kneeling with core engaged, spine straight and knee directly over ankle.\n2. Keeping chest up, shift your hips forward as you raise your arm and over to the side of the bent knee. Reach the opposite fingertips to the floor to stretch your side body and the hip flexor of back leg.\n3. Hold and breathe.\n4. Shift your weight back to neutral, return to start and repeat with the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1503,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'f43ba2b95a6b19d178c0c7026098f4089651437be474b5fb7a443bd045e1c76f',
          file_name:
            'videos/f43ba2b95a6b19d178c0c7026098f4089651437be474b5fb7a443bd045e1c76f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f43ba2b95a6b19d178c0c7026098f4089651437be474b5fb7a443bd045e1c76f.mp4',
          name: 'BEG-INT-ADV-Hip_Flexor_and_Side_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 320379,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1504,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '0127d1475f5ef85a08e4760c0c8ba926744c7123323f5a2161e5f63704da352a',
          file_name:
            'videos/0127d1475f5ef85a08e4760c0c8ba926744c7123323f5a2161e5f63704da352a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0127d1475f5ef85a08e4760c0c8ba926744c7123323f5a2161e5f63704da352a.mp4',
          name: 'BEG-INT-ADV-Hip_Flexor_and_Side_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 306386,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1505,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '85d8fb35fb75ffd38a4eaff7b7bf817527d61b44fe9016b24ecfcdb4d82c5d17',
          file_name:
            'audios/85d8fb35fb75ffd38a4eaff7b7bf817527d61b44fe9016b24ecfcdb4d82c5d17.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/85d8fb35fb75ffd38a4eaff7b7bf817527d61b44fe9016b24ecfcdb4d82c5d17.mp3',
          name: 'BEG-INT-ADV-Hip_Flexor_and_Side_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 32156,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-HIP_FLEXOR_AND_SIDE_STRETCH-COOL_DOWN': {
      id: 673,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Hip Flexor and Side Stretch',
      short_name: 'Hip Flexor and Side Stretch',
      unique_name: 'ADVANCED-HIP_FLEXOR_AND_SIDE_STRETCH-COOL_DOWN',
      description:
        '1. Start half-kneeling with core engaged, spine straight and knee directly over ankle.\n2. Keeping chest up, shift your hips forward as you raise your arm and over to the side of the bent knee. Reach the opposite fingertips to the floor to stretch your side body and the hip flexor of back leg.\n3. Hold and breathe.\n4. Shift your weight back to neutral, return to start and repeat with the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1506,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'f43ba2b95a6b19d178c0c7026098f4089651437be474b5fb7a443bd045e1c76f',
          file_name:
            'videos/f43ba2b95a6b19d178c0c7026098f4089651437be474b5fb7a443bd045e1c76f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f43ba2b95a6b19d178c0c7026098f4089651437be474b5fb7a443bd045e1c76f.mp4',
          name: 'BEG-INT-ADV-Hip_Flexor_and_Side_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 320379,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1507,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '0127d1475f5ef85a08e4760c0c8ba926744c7123323f5a2161e5f63704da352a',
          file_name:
            'videos/0127d1475f5ef85a08e4760c0c8ba926744c7123323f5a2161e5f63704da352a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0127d1475f5ef85a08e4760c0c8ba926744c7123323f5a2161e5f63704da352a.mp4',
          name: 'BEG-INT-ADV-Hip_Flexor_and_Side_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 306386,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1508,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '85d8fb35fb75ffd38a4eaff7b7bf817527d61b44fe9016b24ecfcdb4d82c5d17',
          file_name:
            'audios/85d8fb35fb75ffd38a4eaff7b7bf817527d61b44fe9016b24ecfcdb4d82c5d17.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/85d8fb35fb75ffd38a4eaff7b7bf817527d61b44fe9016b24ecfcdb4d82c5d17.mp3',
          name: 'BEG-INT-ADV-Hip_Flexor_and_Side_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 32156,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-HURDLER_STRETCH-COOL_DOWN': {
      id: 674,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Hurdler Stretch',
      short_name: 'Hurdler Stretch',
      unique_name: 'BEGINNER-HURDLER_STRETCH-COOL_DOWN',
      description:
        '1. Start in a seated position with your legs straight. Bend one knee and bring it behind you, resting on the floor.\n2. Sit up tall and turn your torso towards your straight leg. Bend at the waist and reach for your toes.\n3. Hold and return to starting position.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1509,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '626d6901d0e44a14d68ebe7cd4bffaacbc8c8c1136c8d4fa5518d34033d323ac',
          file_name:
            'videos/626d6901d0e44a14d68ebe7cd4bffaacbc8c8c1136c8d4fa5518d34033d323ac.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/626d6901d0e44a14d68ebe7cd4bffaacbc8c8c1136c8d4fa5518d34033d323ac.mp4',
          name: 'BEG-INT-ADV-Hurdler_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 220219,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1510,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '9060a233c36a4bcb91eb2269942864d126284b3200b7ff72d5dbb49cf77c5c12',
          file_name:
            'videos/9060a233c36a4bcb91eb2269942864d126284b3200b7ff72d5dbb49cf77c5c12.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9060a233c36a4bcb91eb2269942864d126284b3200b7ff72d5dbb49cf77c5c12.mp4',
          name: 'BEG-INT-ADV-Hurdler_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 266075,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1511,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '9a68463e88c6f8d60263ca0ba575ed2992b89d4b144120af5ad8126c70a3846d',
          file_name:
            'audios/9a68463e88c6f8d60263ca0ba575ed2992b89d4b144120af5ad8126c70a3846d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9a68463e88c6f8d60263ca0ba575ed2992b89d4b144120af5ad8126c70a3846d.mp3',
          name: 'BEG-INT-ADV-Hurdler_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 21498,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-HURDLER_STRETCH-COOL_DOWN': {
      id: 675,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Hurdler Stretch',
      short_name: 'Hurdler Stretch',
      unique_name: 'INTERMEDIATE-HURDLER_STRETCH-COOL_DOWN',
      description:
        '1. Start in a seated position with your legs straight. Bend one knee and bring it behind you, resting on the floor.\n2. Sit up tall and turn your torso towards your straight leg. Bend at the waist and reach for your toes.\n3. Hold and return to starting position.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1512,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '626d6901d0e44a14d68ebe7cd4bffaacbc8c8c1136c8d4fa5518d34033d323ac',
          file_name:
            'videos/626d6901d0e44a14d68ebe7cd4bffaacbc8c8c1136c8d4fa5518d34033d323ac.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/626d6901d0e44a14d68ebe7cd4bffaacbc8c8c1136c8d4fa5518d34033d323ac.mp4',
          name: 'BEG-INT-ADV-Hurdler_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 220219,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1513,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '9060a233c36a4bcb91eb2269942864d126284b3200b7ff72d5dbb49cf77c5c12',
          file_name:
            'videos/9060a233c36a4bcb91eb2269942864d126284b3200b7ff72d5dbb49cf77c5c12.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9060a233c36a4bcb91eb2269942864d126284b3200b7ff72d5dbb49cf77c5c12.mp4',
          name: 'BEG-INT-ADV-Hurdler_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 266075,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1514,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '9a68463e88c6f8d60263ca0ba575ed2992b89d4b144120af5ad8126c70a3846d',
          file_name:
            'audios/9a68463e88c6f8d60263ca0ba575ed2992b89d4b144120af5ad8126c70a3846d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9a68463e88c6f8d60263ca0ba575ed2992b89d4b144120af5ad8126c70a3846d.mp3',
          name: 'BEG-INT-ADV-Hurdler_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 21498,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-HURDLER_STRETCH-COOL_DOWN': {
      id: 676,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Hurdler Stretch',
      short_name: 'Hurdler Stretch',
      unique_name: 'ADVANCED-HURDLER_STRETCH-COOL_DOWN',
      description:
        '1. Start in a seated position with your legs straight. Bend one knee and bring it behind you, resting on the floor.\n2. Sit up tall and turn your torso towards your straight leg. Bend at the waist and reach for your toes.\n3. Hold and return to starting position.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1515,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '626d6901d0e44a14d68ebe7cd4bffaacbc8c8c1136c8d4fa5518d34033d323ac',
          file_name:
            'videos/626d6901d0e44a14d68ebe7cd4bffaacbc8c8c1136c8d4fa5518d34033d323ac.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/626d6901d0e44a14d68ebe7cd4bffaacbc8c8c1136c8d4fa5518d34033d323ac.mp4',
          name: 'BEG-INT-ADV-Hurdler_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 220219,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1516,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '9060a233c36a4bcb91eb2269942864d126284b3200b7ff72d5dbb49cf77c5c12',
          file_name:
            'videos/9060a233c36a4bcb91eb2269942864d126284b3200b7ff72d5dbb49cf77c5c12.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9060a233c36a4bcb91eb2269942864d126284b3200b7ff72d5dbb49cf77c5c12.mp4',
          name: 'BEG-INT-ADV-Hurdler_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 266075,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1517,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '9a68463e88c6f8d60263ca0ba575ed2992b89d4b144120af5ad8126c70a3846d',
          file_name:
            'audios/9a68463e88c6f8d60263ca0ba575ed2992b89d4b144120af5ad8126c70a3846d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9a68463e88c6f8d60263ca0ba575ed2992b89d4b144120af5ad8126c70a3846d.mp3',
          name: 'BEG-INT-ADV-Hurdler_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 21498,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-PRONE_QUAD_STRETCH-COOL_DOWN': {
      id: 677,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Prone Quad Stretch',
      short_name: 'Prone Quad Stretch',
      unique_name: 'BEGINNER-PRONE_QUAD_STRETCH-COOL_DOWN',
      description:
        '1. Lie on your stomach with your legs long and hands next to your shoulders, forearms on floor, palms flat.\n2. Bend one knee and reach back with the same side arm to grab your ankle. Keep your knees hip-width or closer.\n3. Gently pull your heel toward your glutes, as you kick back into your hand to feel a stretch in your quad.\n4. Repeat other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1518,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '68d15ab0dd19f5ca929c77cdb1fe976eef8a07b879d88af35bfb205f5e96bc9a',
          file_name:
            'videos/68d15ab0dd19f5ca929c77cdb1fe976eef8a07b879d88af35bfb205f5e96bc9a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/68d15ab0dd19f5ca929c77cdb1fe976eef8a07b879d88af35bfb205f5e96bc9a.mp4',
          name: 'BEG-INT-ADV-Prone_Quad_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 268160,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1519,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '9064f90d2f6c76875a9426c2fafca43e9322ff24b3e99b0b8606a61aa9ba3292',
          file_name:
            'videos/9064f90d2f6c76875a9426c2fafca43e9322ff24b3e99b0b8606a61aa9ba3292.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9064f90d2f6c76875a9426c2fafca43e9322ff24b3e99b0b8606a61aa9ba3292.mp4',
          name: 'BEG-INT-ADV-Prone_Quad_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 279070,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1520,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'b4bbde556f08046d33ca7a69f6e797bacce929eb4183ae7832f4e5fe9646ac14',
          file_name:
            'audios/b4bbde556f08046d33ca7a69f6e797bacce929eb4183ae7832f4e5fe9646ac14.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b4bbde556f08046d33ca7a69f6e797bacce929eb4183ae7832f4e5fe9646ac14.mp3',
          name: 'BEG-INT-ADV-Prone_Quad_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 25886,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PRONE_QUAD_STRETCH-COOL_DOWN': {
      id: 678,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Prone Quad Stretch',
      short_name: 'Prone Quad Stretch',
      unique_name: 'INTERMEDIATE-PRONE_QUAD_STRETCH-COOL_DOWN',
      description:
        '1. Lie on your stomach with your legs long and hands next to your shoulders, forearms on floor, palms flat.\n2. Bend one knee and reach back with the same side arm to grab your ankle. Keep your knees hip-width or closer.\n3. Gently pull your heel toward your glutes, as you kick back into your hand to feel a stretch in your quad.\n4. Repeat other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1521,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '68d15ab0dd19f5ca929c77cdb1fe976eef8a07b879d88af35bfb205f5e96bc9a',
          file_name:
            'videos/68d15ab0dd19f5ca929c77cdb1fe976eef8a07b879d88af35bfb205f5e96bc9a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/68d15ab0dd19f5ca929c77cdb1fe976eef8a07b879d88af35bfb205f5e96bc9a.mp4',
          name: 'BEG-INT-ADV-Prone_Quad_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 268160,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1522,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '9064f90d2f6c76875a9426c2fafca43e9322ff24b3e99b0b8606a61aa9ba3292',
          file_name:
            'videos/9064f90d2f6c76875a9426c2fafca43e9322ff24b3e99b0b8606a61aa9ba3292.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9064f90d2f6c76875a9426c2fafca43e9322ff24b3e99b0b8606a61aa9ba3292.mp4',
          name: 'BEG-INT-ADV-Prone_Quad_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 279070,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1523,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'b4bbde556f08046d33ca7a69f6e797bacce929eb4183ae7832f4e5fe9646ac14',
          file_name:
            'audios/b4bbde556f08046d33ca7a69f6e797bacce929eb4183ae7832f4e5fe9646ac14.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b4bbde556f08046d33ca7a69f6e797bacce929eb4183ae7832f4e5fe9646ac14.mp3',
          name: 'BEG-INT-ADV-Prone_Quad_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 25886,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PRONE_QUAD_STRETCH-COOL_DOWN': {
      id: 679,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Prone Quad Stretch',
      short_name: 'Prone Quad Stretch',
      unique_name: 'ADVANCED-PRONE_QUAD_STRETCH-COOL_DOWN',
      description:
        '1. Lie on your stomach with your legs long and hands next to your shoulders, forearms on floor, palms flat.\n2. Bend one knee and reach back with the same side arm to grab your ankle. Keep your knees hip-width or closer.\n3. Gently pull your heel toward your glutes, as you kick back into your hand to feel a stretch in your quad.\n4. Repeat other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1524,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '68d15ab0dd19f5ca929c77cdb1fe976eef8a07b879d88af35bfb205f5e96bc9a',
          file_name:
            'videos/68d15ab0dd19f5ca929c77cdb1fe976eef8a07b879d88af35bfb205f5e96bc9a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/68d15ab0dd19f5ca929c77cdb1fe976eef8a07b879d88af35bfb205f5e96bc9a.mp4',
          name: 'BEG-INT-ADV-Prone_Quad_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 268160,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1525,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '9064f90d2f6c76875a9426c2fafca43e9322ff24b3e99b0b8606a61aa9ba3292',
          file_name:
            'videos/9064f90d2f6c76875a9426c2fafca43e9322ff24b3e99b0b8606a61aa9ba3292.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9064f90d2f6c76875a9426c2fafca43e9322ff24b3e99b0b8606a61aa9ba3292.mp4',
          name: 'BEG-INT-ADV-Prone_Quad_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 279070,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1526,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'b4bbde556f08046d33ca7a69f6e797bacce929eb4183ae7832f4e5fe9646ac14',
          file_name:
            'audios/b4bbde556f08046d33ca7a69f6e797bacce929eb4183ae7832f4e5fe9646ac14.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b4bbde556f08046d33ca7a69f6e797bacce929eb4183ae7832f4e5fe9646ac14.mp3',
          name: 'BEG-INT-ADV-Prone_Quad_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 25886,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-RAG_DOLL-COOL_DOWN': {
      id: 680,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Rag Doll',
      short_name: 'Rag Doll',
      unique_name: 'BEGINNER-RAG_DOLL-COOL_DOWN',
      description:
        '1. Stand tall with your feet hip-width apart, arms by sides.\n2. Soften knees, hinge at the waist and roll down vertebrae by vertebrae until your chest is close to your thighs. Clasp opposite elbows. Let your head hang heavy and let gravity elongate your spine.\nNotes: Bend your knees as much as needed. Play with swaying side to side, shaking head "yes" and "no", and clasping elbows the other way.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1527,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'ec0b9cd9c1a6087bd281a75ef8385e03c300b11635023d5bab75ae1391da37a0',
          file_name:
            'videos/ec0b9cd9c1a6087bd281a75ef8385e03c300b11635023d5bab75ae1391da37a0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ec0b9cd9c1a6087bd281a75ef8385e03c300b11635023d5bab75ae1391da37a0.mp4',
          name: 'BEG-INT-ADV-Rag_Doll-COOL_DOWN.mp4',
          description: null,
          size: 407026,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1528,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'c306a81f50676ffd98347809362408cd6ec4c6f2933e15eb43e0a9dbb242728a',
          file_name:
            'audios/c306a81f50676ffd98347809362408cd6ec4c6f2933e15eb43e0a9dbb242728a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c306a81f50676ffd98347809362408cd6ec4c6f2933e15eb43e0a9dbb242728a.mp3',
          name: 'BEG-INT-ADV-Rag_Doll-COOL_DOWN.mp3',
          description: null,
          size: 19930,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-RAG_DOLL-COOL_DOWN': {
      id: 681,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Rag Doll',
      short_name: 'Rag Doll',
      unique_name: 'INTERMEDIATE-RAG_DOLL-COOL_DOWN',
      description:
        '1. Stand tall with your feet hip-width apart, arms by sides.\n2. Soften knees, hinge at the waist and roll down vertebrae by vertebrae until your chest is close to your thighs. Clasp opposite elbows. Let your head hang heavy and let gravity elongate your spine.\nNotes: Bend your knees as much as needed. Play with swaying side to side, shaking head "yes" and "no", and clasping elbows the other way.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1529,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'ec0b9cd9c1a6087bd281a75ef8385e03c300b11635023d5bab75ae1391da37a0',
          file_name:
            'videos/ec0b9cd9c1a6087bd281a75ef8385e03c300b11635023d5bab75ae1391da37a0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ec0b9cd9c1a6087bd281a75ef8385e03c300b11635023d5bab75ae1391da37a0.mp4',
          name: 'BEG-INT-ADV-Rag_Doll-COOL_DOWN.mp4',
          description: null,
          size: 407026,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1530,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'c306a81f50676ffd98347809362408cd6ec4c6f2933e15eb43e0a9dbb242728a',
          file_name:
            'audios/c306a81f50676ffd98347809362408cd6ec4c6f2933e15eb43e0a9dbb242728a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c306a81f50676ffd98347809362408cd6ec4c6f2933e15eb43e0a9dbb242728a.mp3',
          name: 'BEG-INT-ADV-Rag_Doll-COOL_DOWN.mp3',
          description: null,
          size: 19930,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-RAG_DOLL-COOL_DOWN': {
      id: 682,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Rag Doll',
      short_name: 'Rag Doll',
      unique_name: 'ADVANCED-RAG_DOLL-COOL_DOWN',
      description:
        '1. Stand tall with your feet hip-width apart, arms by sides.\n2. Soften knees, hinge at the waist and roll down vertebrae by vertebrae until your chest is close to your thighs. Clasp opposite elbows. Let your head hang heavy and let gravity elongate your spine.\nNotes: Bend your knees as much as needed. Play with swaying side to side, shaking head "yes" and "no", and clasping elbows the other way.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1531,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'ec0b9cd9c1a6087bd281a75ef8385e03c300b11635023d5bab75ae1391da37a0',
          file_name:
            'videos/ec0b9cd9c1a6087bd281a75ef8385e03c300b11635023d5bab75ae1391da37a0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ec0b9cd9c1a6087bd281a75ef8385e03c300b11635023d5bab75ae1391da37a0.mp4',
          name: 'BEG-INT-ADV-Rag_Doll-COOL_DOWN.mp4',
          description: null,
          size: 407026,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1532,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'c306a81f50676ffd98347809362408cd6ec4c6f2933e15eb43e0a9dbb242728a',
          file_name:
            'audios/c306a81f50676ffd98347809362408cd6ec4c6f2933e15eb43e0a9dbb242728a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c306a81f50676ffd98347809362408cd6ec4c6f2933e15eb43e0a9dbb242728a.mp3',
          name: 'BEG-INT-ADV-Rag_Doll-COOL_DOWN.mp3',
          description: null,
          size: 19930,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ROCKY_ROLLERS-COOL_DOWN': {
      id: 683,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Rocky Rollers',
      short_name: 'Rocky Rollers',
      unique_name: 'BEGINNER-ROCKY_ROLLERS-COOL_DOWN',
      description:
        '1. Lie on your back, bend both knees and bring them up toward your chest. Place your fists by shoulders and elbows glued to knees.\n2. Maintaining the elbow/knee connection, rock your body from front to back while you shift your hips to the side and shimmy your body around in a circle.\n3. Repeat in the other direction.',
      preview_time: null,
      min_app_version: 200030000,
      archived: true,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1533,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '7230e2f034dee70b1803763c11f3583d551c50d642da7a3bd75932056fc73c4c',
          file_name:
            'videos/7230e2f034dee70b1803763c11f3583d551c50d642da7a3bd75932056fc73c4c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7230e2f034dee70b1803763c11f3583d551c50d642da7a3bd75932056fc73c4c.mp4',
          name: 'BEG-INT-ADV-Rocky_Rollers-COOL_DOWN.mp4',
          description: null,
          size: 1765340,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1534,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '44df1e3f863db3c98030772fe68dfce3a4dedc4a2211a1640e368be91cf4931b',
          file_name:
            'audios/44df1e3f863db3c98030772fe68dfce3a4dedc4a2211a1640e368be91cf4931b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/44df1e3f863db3c98030772fe68dfce3a4dedc4a2211a1640e368be91cf4931b.mp3',
          name: 'BEG-INT-ADV-Rocky_Rollers-COOL_DOWN.mp3',
          description: null,
          size: 23062,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ROCKY_ROLLERS-COOL_DOWN': {
      id: 684,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Rocky Rollers',
      short_name: 'Rocky Rollers',
      unique_name: 'INTERMEDIATE-ROCKY_ROLLERS-COOL_DOWN',
      description:
        '1. Lie on your back, bend both knees and bring them up toward your chest. Place your fists by shoulders and elbows glued to knees.\n2. Maintaining the elbow/knee connection, rock your body from front to back while you shift your hips to the side and shimmy your body around in a circle.\n3. Repeat in the other direction.',
      preview_time: null,
      min_app_version: 200030000,
      archived: true,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1535,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '7230e2f034dee70b1803763c11f3583d551c50d642da7a3bd75932056fc73c4c',
          file_name:
            'videos/7230e2f034dee70b1803763c11f3583d551c50d642da7a3bd75932056fc73c4c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7230e2f034dee70b1803763c11f3583d551c50d642da7a3bd75932056fc73c4c.mp4',
          name: 'BEG-INT-ADV-Rocky_Rollers-COOL_DOWN.mp4',
          description: null,
          size: 1765340,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1536,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '44df1e3f863db3c98030772fe68dfce3a4dedc4a2211a1640e368be91cf4931b',
          file_name:
            'audios/44df1e3f863db3c98030772fe68dfce3a4dedc4a2211a1640e368be91cf4931b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/44df1e3f863db3c98030772fe68dfce3a4dedc4a2211a1640e368be91cf4931b.mp3',
          name: 'BEG-INT-ADV-Rocky_Rollers-COOL_DOWN.mp3',
          description: null,
          size: 23062,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ROCKY_ROLLERS-COOL_DOWN': {
      id: 685,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Rocky Rollers',
      short_name: 'Rocky Rollers',
      unique_name: 'ADVANCED-ROCKY_ROLLERS-COOL_DOWN',
      description:
        '1. Lie on your back, bend both knees and bring them up toward your chest. Place your fists by shoulders and elbows glued to knees.\n2. Maintaining the elbow/knee connection, rock your body from front to back while you shift your hips to the side and shimmy your body around in a circle.\n3. Repeat in the other direction.',
      preview_time: null,
      min_app_version: 200030000,
      archived: true,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1537,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '7230e2f034dee70b1803763c11f3583d551c50d642da7a3bd75932056fc73c4c',
          file_name:
            'videos/7230e2f034dee70b1803763c11f3583d551c50d642da7a3bd75932056fc73c4c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7230e2f034dee70b1803763c11f3583d551c50d642da7a3bd75932056fc73c4c.mp4',
          name: 'BEG-INT-ADV-Rocky_Rollers-COOL_DOWN.mp4',
          description: null,
          size: 1765340,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1538,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '44df1e3f863db3c98030772fe68dfce3a4dedc4a2211a1640e368be91cf4931b',
          file_name:
            'audios/44df1e3f863db3c98030772fe68dfce3a4dedc4a2211a1640e368be91cf4931b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/44df1e3f863db3c98030772fe68dfce3a4dedc4a2211a1640e368be91cf4931b.mp3',
          name: 'BEG-INT-ADV-Rocky_Rollers-COOL_DOWN.mp3',
          description: null,
          size: 23062,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SIDE_STRETCH-COOL_DOWN': {
      id: 686,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Side Stretch',
      short_name: 'Side Stretch',
      unique_name: 'BEGINNER-SIDE_STRETCH-COOL_DOWN',
      description:
        '1. Stand tall, with your feet shoulder-width apart. Raise both arms overhead.\n2. Grab one wrist, gently pull up and lean over in the opposite direction until you feel a nice side stretch. Keep hips and shoulders square as you hold this position.\n3. Repeat other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1539,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '5e07db3a7156d8fd1f19b017887e0c2b53d4d697d8fe180ffaac6f85f6a5843c',
          file_name:
            'videos/5e07db3a7156d8fd1f19b017887e0c2b53d4d697d8fe180ffaac6f85f6a5843c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5e07db3a7156d8fd1f19b017887e0c2b53d4d697d8fe180ffaac6f85f6a5843c.mp4',
          name: 'BEG-INT-ADV-Side_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 171649,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1540,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '3821524191254eb6582be0c466d5ddae92555cab328877a2732f2f444aad362a',
          file_name:
            'videos/3821524191254eb6582be0c466d5ddae92555cab328877a2732f2f444aad362a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3821524191254eb6582be0c466d5ddae92555cab328877a2732f2f444aad362a.mp4',
          name: 'BEG-INT-ADV-Side_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 184177,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1541,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'e1c8d8cdffd9f1778d7bb95278de996330710119e9d527186f27fe5a6bcca396',
          file_name:
            'audios/e1c8d8cdffd9f1778d7bb95278de996330710119e9d527186f27fe5a6bcca396.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e1c8d8cdffd9f1778d7bb95278de996330710119e9d527186f27fe5a6bcca396.mp3',
          name: 'BEG-INT-ADV-Side_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 20244,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SIDE_STRETCH-COOL_DOWN': {
      id: 687,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Side Stretch',
      short_name: 'Side Stretch',
      unique_name: 'INTERMEDIATE-SIDE_STRETCH-COOL_DOWN',
      description:
        '1. Stand tall, with your feet shoulder-width apart. Raise both arms overhead.\n2. Grab one wrist, gently pull up and lean over in the opposite direction until you feel a nice side stretch. Keep hips and shoulders square as you hold this position.\n3. Repeat other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1542,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '5e07db3a7156d8fd1f19b017887e0c2b53d4d697d8fe180ffaac6f85f6a5843c',
          file_name:
            'videos/5e07db3a7156d8fd1f19b017887e0c2b53d4d697d8fe180ffaac6f85f6a5843c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5e07db3a7156d8fd1f19b017887e0c2b53d4d697d8fe180ffaac6f85f6a5843c.mp4',
          name: 'BEG-INT-ADV-Side_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 171649,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1543,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '3821524191254eb6582be0c466d5ddae92555cab328877a2732f2f444aad362a',
          file_name:
            'videos/3821524191254eb6582be0c466d5ddae92555cab328877a2732f2f444aad362a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3821524191254eb6582be0c466d5ddae92555cab328877a2732f2f444aad362a.mp4',
          name: 'BEG-INT-ADV-Side_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 184177,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1544,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'e1c8d8cdffd9f1778d7bb95278de996330710119e9d527186f27fe5a6bcca396',
          file_name:
            'audios/e1c8d8cdffd9f1778d7bb95278de996330710119e9d527186f27fe5a6bcca396.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e1c8d8cdffd9f1778d7bb95278de996330710119e9d527186f27fe5a6bcca396.mp3',
          name: 'BEG-INT-ADV-Side_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 20244,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SIDE_STRETCH-COOL_DOWN': {
      id: 688,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Side Stretch',
      short_name: 'Side Stretch',
      unique_name: 'ADVANCED-SIDE_STRETCH-COOL_DOWN',
      description:
        '1. Stand tall, with your feet shoulder-width apart. Raise both arms overhead.\n2. Grab one wrist, gently pull up and lean over in the opposite direction until you feel a nice side stretch. Keep hips and shoulders square as you hold this position.\n3. Repeat other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1545,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '5e07db3a7156d8fd1f19b017887e0c2b53d4d697d8fe180ffaac6f85f6a5843c',
          file_name:
            'videos/5e07db3a7156d8fd1f19b017887e0c2b53d4d697d8fe180ffaac6f85f6a5843c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5e07db3a7156d8fd1f19b017887e0c2b53d4d697d8fe180ffaac6f85f6a5843c.mp4',
          name: 'BEG-INT-ADV-Side_Stretch-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 171649,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1546,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '3821524191254eb6582be0c466d5ddae92555cab328877a2732f2f444aad362a',
          file_name:
            'videos/3821524191254eb6582be0c466d5ddae92555cab328877a2732f2f444aad362a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3821524191254eb6582be0c466d5ddae92555cab328877a2732f2f444aad362a.mp4',
          name: 'BEG-INT-ADV-Side_Stretch-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 184177,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1547,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'e1c8d8cdffd9f1778d7bb95278de996330710119e9d527186f27fe5a6bcca396',
          file_name:
            'audios/e1c8d8cdffd9f1778d7bb95278de996330710119e9d527186f27fe5a6bcca396.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e1c8d8cdffd9f1778d7bb95278de996330710119e9d527186f27fe5a6bcca396.mp3',
          name: 'BEG-INT-ADV-Side_Stretch-COOL_DOWN.mp3',
          description: null,
          size: 20244,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SKANDASANA-COOL_DOWN': {
      id: 689,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Skandasana',
      short_name: 'Skandasana',
      unique_name: 'BEGINNER-SKANDASANA-COOL_DOWN',
      description:
        '1. Start with feet out wide, roughly double hip-width, toes turned out.\n2. Keeping your back straight, chest up and core engaged, bend one knee and drop your hips toward the floor as low as possible without lifting your heel. The other leg remains straight, toes pointed to ceiling. Place your hands on the floor in front of you and sit up tall.\n3. Stay as low as possible and transition to the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1548,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '83d906d933706133ebf158766fb2b9239e1957c9859263546971449d7370e55a',
          file_name:
            'videos/83d906d933706133ebf158766fb2b9239e1957c9859263546971449d7370e55a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/83d906d933706133ebf158766fb2b9239e1957c9859263546971449d7370e55a.mp4',
          name: 'BEG-INT-ADV-Skandasana-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 290750,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1549,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '292459739979cfacd6b529cc764f55e6ab27338c90e101c6e2bc54d252d9fe3f',
          file_name:
            'videos/292459739979cfacd6b529cc764f55e6ab27338c90e101c6e2bc54d252d9fe3f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/292459739979cfacd6b529cc764f55e6ab27338c90e101c6e2bc54d252d9fe3f.mp4',
          name: 'BEG-INT-ADV-Skandasana-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 298688,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1550,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '9deab32564f9106b6b6d9e43091170abf1f5567a14201e96d1d49b811cc9deee',
          file_name:
            'audios/9deab32564f9106b6b6d9e43091170abf1f5567a14201e96d1d49b811cc9deee.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9deab32564f9106b6b6d9e43091170abf1f5567a14201e96d1d49b811cc9deee.mp3',
          name: 'BEG-INT-ADV-Skandasana-COOL_DOWN.mp3',
          description: null,
          size: 18987,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SKANDASANA-COOL_DOWN': {
      id: 690,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Skandasana',
      short_name: 'Skandasana',
      unique_name: 'INTERMEDIATE-SKANDASANA-COOL_DOWN',
      description:
        '1. Start with feet out wide, roughly double hip-width, toes turned out.\n2. Keeping your back straight, chest up and core engaged, bend one knee and drop your hips toward the floor as low as possible without lifting your heel. The other leg remains straight, toes pointed to ceiling. Place your hands on the floor in front of you and sit up tall.\n3. Stay as low as possible and transition to the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1551,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '83d906d933706133ebf158766fb2b9239e1957c9859263546971449d7370e55a',
          file_name:
            'videos/83d906d933706133ebf158766fb2b9239e1957c9859263546971449d7370e55a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/83d906d933706133ebf158766fb2b9239e1957c9859263546971449d7370e55a.mp4',
          name: 'BEG-INT-ADV-Skandasana-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 290750,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1552,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '292459739979cfacd6b529cc764f55e6ab27338c90e101c6e2bc54d252d9fe3f',
          file_name:
            'videos/292459739979cfacd6b529cc764f55e6ab27338c90e101c6e2bc54d252d9fe3f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/292459739979cfacd6b529cc764f55e6ab27338c90e101c6e2bc54d252d9fe3f.mp4',
          name: 'BEG-INT-ADV-Skandasana-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 298688,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1553,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '9deab32564f9106b6b6d9e43091170abf1f5567a14201e96d1d49b811cc9deee',
          file_name:
            'audios/9deab32564f9106b6b6d9e43091170abf1f5567a14201e96d1d49b811cc9deee.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9deab32564f9106b6b6d9e43091170abf1f5567a14201e96d1d49b811cc9deee.mp3',
          name: 'BEG-INT-ADV-Skandasana-COOL_DOWN.mp3',
          description: null,
          size: 18987,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SKANDASANA-COOL_DOWN': {
      id: 691,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Skandasana',
      short_name: 'Skandasana',
      unique_name: 'ADVANCED-SKANDASANA-COOL_DOWN',
      description:
        '1. Start with feet out wide, roughly double hip-width, toes turned out.\n2. Keeping your back straight, chest up and core engaged, bend one knee and drop your hips toward the floor as low as possible without lifting your heel. The other leg remains straight, toes pointed to ceiling. Place your hands on the floor in front of you and sit up tall.\n3. Stay as low as possible and transition to the other side.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1554,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '83d906d933706133ebf158766fb2b9239e1957c9859263546971449d7370e55a',
          file_name:
            'videos/83d906d933706133ebf158766fb2b9239e1957c9859263546971449d7370e55a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/83d906d933706133ebf158766fb2b9239e1957c9859263546971449d7370e55a.mp4',
          name: 'BEG-INT-ADV-Skandasana-COOL_DOWN-RIGHT.mp4',
          description: 'Right Side',
          size: 290750,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1555,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '292459739979cfacd6b529cc764f55e6ab27338c90e101c6e2bc54d252d9fe3f',
          file_name:
            'videos/292459739979cfacd6b529cc764f55e6ab27338c90e101c6e2bc54d252d9fe3f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/292459739979cfacd6b529cc764f55e6ab27338c90e101c6e2bc54d252d9fe3f.mp4',
          name: 'BEG-INT-ADV-Skandasana-COOL_DOWN-LEFT.mp4',
          description: 'Left Side',
          size: 298688,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1556,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '9deab32564f9106b6b6d9e43091170abf1f5567a14201e96d1d49b811cc9deee',
          file_name:
            'audios/9deab32564f9106b6b6d9e43091170abf1f5567a14201e96d1d49b811cc9deee.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9deab32564f9106b6b6d9e43091170abf1f5567a14201e96d1d49b811cc9deee.mp3',
          name: 'BEG-INT-ADV-Skandasana-COOL_DOWN.mp3',
          description: null,
          size: 18987,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-YOGI_SQUAT-COOL_DOWN': {
      id: 692,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Yogi Squat',
      short_name: 'Yogi Squat',
      unique_name: 'BEGINNER-YOGI_SQUAT-COOL_DOWN',
      description:
        '1. Start with your feet out wide, roughly double hip-width, toes turned out.\n2. Keeping back straight, chest up and core engaged, bend your knees and drop hips towards the floor as low as possible without lifting your heels.\n3. Place your hands at heart center and gently press your elbows into the inside of your knees to deepen the stretch.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1557,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '49590769ea28819dc3654bc3e457deea4be51caaa3af91b8a8947d4ada35ff7f',
          file_name:
            'videos/49590769ea28819dc3654bc3e457deea4be51caaa3af91b8a8947d4ada35ff7f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/49590769ea28819dc3654bc3e457deea4be51caaa3af91b8a8947d4ada35ff7f.mp4',
          name: 'BEG-INT-ADV-Yogi_Squat-COOL_DOWN.mp4',
          description: null,
          size: 319497,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1558,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '29a4f7ab64de52d298c2fffbd5d083b6654c2f55123213103181b3d7c3fa034e',
          file_name:
            'audios/29a4f7ab64de52d298c2fffbd5d083b6654c2f55123213103181b3d7c3fa034e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/29a4f7ab64de52d298c2fffbd5d083b6654c2f55123213103181b3d7c3fa034e.mp3',
          name: 'BEG-INT-ADV-Yogi_Squat-COOL_DOWN.mp3',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-YOGI_SQUAT-COOL_DOWN': {
      id: 693,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Yogi Squat',
      short_name: 'Yogi Squat',
      unique_name: 'INTERMEDIATE-YOGI_SQUAT-COOL_DOWN',
      description:
        '1. Start with your feet out wide, roughly double hip-width, toes turned out.\n2. Keeping back straight, chest up and core engaged, bend your knees and drop hips towards the floor as low as possible without lifting your heels.\n3. Place your hands at heart center and gently press your elbows into the inside of your knees to deepen the stretch.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1559,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '49590769ea28819dc3654bc3e457deea4be51caaa3af91b8a8947d4ada35ff7f',
          file_name:
            'videos/49590769ea28819dc3654bc3e457deea4be51caaa3af91b8a8947d4ada35ff7f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/49590769ea28819dc3654bc3e457deea4be51caaa3af91b8a8947d4ada35ff7f.mp4',
          name: 'BEG-INT-ADV-Yogi_Squat-COOL_DOWN.mp4',
          description: null,
          size: 319497,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1560,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '29a4f7ab64de52d298c2fffbd5d083b6654c2f55123213103181b3d7c3fa034e',
          file_name:
            'audios/29a4f7ab64de52d298c2fffbd5d083b6654c2f55123213103181b3d7c3fa034e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/29a4f7ab64de52d298c2fffbd5d083b6654c2f55123213103181b3d7c3fa034e.mp3',
          name: 'BEG-INT-ADV-Yogi_Squat-COOL_DOWN.mp3',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-YOGI_SQUAT-COOL_DOWN': {
      id: 694,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Yogi Squat',
      short_name: 'Yogi Squat',
      unique_name: 'ADVANCED-YOGI_SQUAT-COOL_DOWN',
      description:
        '1. Start with your feet out wide, roughly double hip-width, toes turned out.\n2. Keeping back straight, chest up and core engaged, bend your knees and drop hips towards the floor as low as possible without lifting your heels.\n3. Place your hands at heart center and gently press your elbows into the inside of your knees to deepen the stretch.',
      preview_time: null,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1561,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '49590769ea28819dc3654bc3e457deea4be51caaa3af91b8a8947d4ada35ff7f',
          file_name:
            'videos/49590769ea28819dc3654bc3e457deea4be51caaa3af91b8a8947d4ada35ff7f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/49590769ea28819dc3654bc3e457deea4be51caaa3af91b8a8947d4ada35ff7f.mp4',
          name: 'BEG-INT-ADV-Yogi_Squat-COOL_DOWN.mp4',
          description: null,
          size: 319497,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1562,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '29a4f7ab64de52d298c2fffbd5d083b6654c2f55123213103181b3d7c3fa034e',
          file_name:
            'audios/29a4f7ab64de52d298c2fffbd5d083b6654c2f55123213103181b3d7c3fa034e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/29a4f7ab64de52d298c2fffbd5d083b6654c2f55123213103181b3d7c3fa034e.mp3',
          name: 'BEG-INT-ADV-Yogi_Squat-COOL_DOWN.mp3',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ADDUCTOR_ROCKS-COOL_DOWN': {
      id: 695,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Adductor Rocks',
      short_name: 'Adductor Rocks',
      unique_name: 'BEGINNER-ADDUCTOR_ROCKS-COOL_DOWN',
      description:
        '1. Start on all fours with a flat back, shoulders over wrists, palms flat and hips over knees.\n2. Extend one leg long directly to the side of you, toes point forward.\n3. Shift your weight back until your glutes are close to your heels. Pause.\n4. Rock yourself back up to start. ',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1886,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1012acf0f4e0c255d6e9e3b387f5c888416f117f4a86af379ad81dc38e490c8e',
          file_name:
            'videos/1012acf0f4e0c255d6e9e3b387f5c888416f117f4a86af379ad81dc38e490c8e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1012acf0f4e0c255d6e9e3b387f5c888416f117f4a86af379ad81dc38e490c8e.mp4',
          name: 'FSTEP-BEG-INT-ADV-Adductor_Rocks-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 518302,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1887,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '6cfb2550831659c21bc4b522c0d6bd4400b5fd04b16cffabf0d71c72431b8ca3',
          file_name:
            'videos/6cfb2550831659c21bc4b522c0d6bd4400b5fd04b16cffabf0d71c72431b8ca3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6cfb2550831659c21bc4b522c0d6bd4400b5fd04b16cffabf0d71c72431b8ca3.mp4',
          name: 'FSTEP-BEG-INT-ADV-Adductor_Rocks-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 507987,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1888,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '62b2fb3a3bb66856de8ddeed2d18f1dcfa8a5a5cbdbea9c30134c12a30401a8d',
          file_name:
            'audios/62b2fb3a3bb66856de8ddeed2d18f1dcfa8a5a5cbdbea9c30134c12a30401a8d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/62b2fb3a3bb66856de8ddeed2d18f1dcfa8a5a5cbdbea9c30134c12a30401a8d.mp3',
          name: 'FSTEP-BEG-INT-ADV-Adductor_Rocks-COOL_DOWN',
          description: null,
          size: 26121,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ADDUCTOR_ROCKS-COOL_DOWN': {
      id: 696,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Adductor Rocks',
      short_name: 'Adductor Rocks',
      unique_name: 'INTERMEDIATE-ADDUCTOR_ROCKS-COOL_DOWN',
      description:
        '1. Start on all fours with a flat back, shoulders over wrists, palms flat and hips over knees.\n2. Extend one leg long directly to the side of you, toes point forward.\n3. Shift your weight back until your glutes are close to your heels. Pause.\n4. Rock yourself back up to start. ',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1889,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1012acf0f4e0c255d6e9e3b387f5c888416f117f4a86af379ad81dc38e490c8e',
          file_name:
            'videos/1012acf0f4e0c255d6e9e3b387f5c888416f117f4a86af379ad81dc38e490c8e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1012acf0f4e0c255d6e9e3b387f5c888416f117f4a86af379ad81dc38e490c8e.mp4',
          name: 'FSTEP-BEG-INT-ADV-Adductor_Rocks-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 518302,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1890,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '6cfb2550831659c21bc4b522c0d6bd4400b5fd04b16cffabf0d71c72431b8ca3',
          file_name:
            'videos/6cfb2550831659c21bc4b522c0d6bd4400b5fd04b16cffabf0d71c72431b8ca3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6cfb2550831659c21bc4b522c0d6bd4400b5fd04b16cffabf0d71c72431b8ca3.mp4',
          name: 'FSTEP-BEG-INT-ADV-Adductor_Rocks-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 507987,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1891,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '62b2fb3a3bb66856de8ddeed2d18f1dcfa8a5a5cbdbea9c30134c12a30401a8d',
          file_name:
            'audios/62b2fb3a3bb66856de8ddeed2d18f1dcfa8a5a5cbdbea9c30134c12a30401a8d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/62b2fb3a3bb66856de8ddeed2d18f1dcfa8a5a5cbdbea9c30134c12a30401a8d.mp3',
          name: 'FSTEP-BEG-INT-ADV-Adductor_Rocks-COOL_DOWN',
          description: null,
          size: 26121,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ADDUCTOR_ROCKS-COOL_DOWN': {
      id: 697,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Adductor Rocks',
      short_name: 'Adductor Rocks',
      unique_name: 'ADVANCED-ADDUCTOR_ROCKS-COOL_DOWN',
      description:
        '1. Start on all fours with a flat back, shoulders over wrists, palms flat and hips over knees.\n2. Extend one leg long directly to the side of you, toes point forward.\n3. Shift your weight back until your glutes are close to your heels. Pause.\n4. Rock yourself back up to start. ',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1892,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1012acf0f4e0c255d6e9e3b387f5c888416f117f4a86af379ad81dc38e490c8e',
          file_name:
            'videos/1012acf0f4e0c255d6e9e3b387f5c888416f117f4a86af379ad81dc38e490c8e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1012acf0f4e0c255d6e9e3b387f5c888416f117f4a86af379ad81dc38e490c8e.mp4',
          name: 'FSTEP-BEG-INT-ADV-Adductor_Rocks-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 518302,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1893,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '6cfb2550831659c21bc4b522c0d6bd4400b5fd04b16cffabf0d71c72431b8ca3',
          file_name:
            'videos/6cfb2550831659c21bc4b522c0d6bd4400b5fd04b16cffabf0d71c72431b8ca3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6cfb2550831659c21bc4b522c0d6bd4400b5fd04b16cffabf0d71c72431b8ca3.mp4',
          name: 'FSTEP-BEG-INT-ADV-Adductor_Rocks-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 507987,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1894,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '62b2fb3a3bb66856de8ddeed2d18f1dcfa8a5a5cbdbea9c30134c12a30401a8d',
          file_name:
            'audios/62b2fb3a3bb66856de8ddeed2d18f1dcfa8a5a5cbdbea9c30134c12a30401a8d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/62b2fb3a3bb66856de8ddeed2d18f1dcfa8a5a5cbdbea9c30134c12a30401a8d.mp3',
          name: 'FSTEP-BEG-INT-ADV-Adductor_Rocks-COOL_DOWN',
          description: null,
          size: 26121,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-FIGURE_FOUR_STRETCH-COOL_DOWN': {
      id: 717,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Figure Four Stretch',
      short_name: 'Figure Four Stretch',
      unique_name: 'BEGINNER-FIGURE_FOUR_STRETCH-COOL_DOWN',
      description:
        '1. Lie on your back with your knees bent, feet flat on the floor.\n2 Cross one ankle over the opposite knee in a figure 4 position.\n3. Lift the other foot off the floor, thread your arms through the opening on either side of that leg and hug your knee to your chest.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1933,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1e6f70f5d836b80a36654f18f89febac2231a0cc2f02f01e16ce5ff628033c62',
          file_name:
            'videos/1e6f70f5d836b80a36654f18f89febac2231a0cc2f02f01e16ce5ff628033c62.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1e6f70f5d836b80a36654f18f89febac2231a0cc2f02f01e16ce5ff628033c62.mp4',
          name: 'FSTEP-BEG-INT-ADV-Figure_Four_Stretch-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 235499,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1934,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '62dbb1fd3964fb18445c7a6f3e6eae628ca88e50f6bf037135175bb222bc3ad1',
          file_name:
            'videos/62dbb1fd3964fb18445c7a6f3e6eae628ca88e50f6bf037135175bb222bc3ad1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/62dbb1fd3964fb18445c7a6f3e6eae628ca88e50f6bf037135175bb222bc3ad1.mp4',
          name: 'FSTEP-BEG-INT-ADV-Figure_Four_Stretch-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 257816,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1935,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '1915bbb7f82d9c0d1d5f1274cb6d1ee4615f134687cba14beede53a89bd8bda0',
          file_name:
            'audios/1915bbb7f82d9c0d1d5f1274cb6d1ee4615f134687cba14beede53a89bd8bda0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1915bbb7f82d9c0d1d5f1274cb6d1ee4615f134687cba14beede53a89bd8bda0.mp3',
          name: 'FSTEP-BEG-INT-ADV-Figure_Four_Stretch-COOL_DOWN',
          description: null,
          size: 29573,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-FIGURE_FOUR_STRETCH-COOL_DOWN': {
      id: 718,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Figure Four Stretch',
      short_name: 'Figure Four Stretch',
      unique_name: 'INTERMEDIATE-FIGURE_FOUR_STRETCH-COOL_DOWN',
      description:
        '1. Lie on your back with your knees bent, feet flat on the floor.\n2 Cross one ankle over the opposite knee in a figure 4 position.\n3. Lift the other foot off the floor, thread your arms through the opening on either side of that leg and hug your knee to your chest.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1936,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1e6f70f5d836b80a36654f18f89febac2231a0cc2f02f01e16ce5ff628033c62',
          file_name:
            'videos/1e6f70f5d836b80a36654f18f89febac2231a0cc2f02f01e16ce5ff628033c62.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1e6f70f5d836b80a36654f18f89febac2231a0cc2f02f01e16ce5ff628033c62.mp4',
          name: 'FSTEP-BEG-INT-ADV-Figure_Four_Stretch-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 235499,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1937,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '62dbb1fd3964fb18445c7a6f3e6eae628ca88e50f6bf037135175bb222bc3ad1',
          file_name:
            'videos/62dbb1fd3964fb18445c7a6f3e6eae628ca88e50f6bf037135175bb222bc3ad1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/62dbb1fd3964fb18445c7a6f3e6eae628ca88e50f6bf037135175bb222bc3ad1.mp4',
          name: 'FSTEP-BEG-INT-ADV-Figure_Four_Stretch-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 257816,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1938,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '1915bbb7f82d9c0d1d5f1274cb6d1ee4615f134687cba14beede53a89bd8bda0',
          file_name:
            'audios/1915bbb7f82d9c0d1d5f1274cb6d1ee4615f134687cba14beede53a89bd8bda0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1915bbb7f82d9c0d1d5f1274cb6d1ee4615f134687cba14beede53a89bd8bda0.mp3',
          name: 'FSTEP-BEG-INT-ADV-Figure_Four_Stretch-COOL_DOWN',
          description: null,
          size: 29573,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-FIGURE_FOUR_STRETCH-COOL_DOWN': {
      id: 719,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Figure Four Stretch',
      short_name: 'Figure Four Stretch',
      unique_name: 'ADVANCED-FIGURE_FOUR_STRETCH-COOL_DOWN',
      description:
        '1. Lie on your back with your knees bent, feet flat on the floor.\n2 Cross one ankle over the opposite knee in a figure 4 position.\n3. Lift the other foot off the floor, thread your arms through the opening on either side of that leg and hug your knee to your chest.\n4. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1939,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1e6f70f5d836b80a36654f18f89febac2231a0cc2f02f01e16ce5ff628033c62',
          file_name:
            'videos/1e6f70f5d836b80a36654f18f89febac2231a0cc2f02f01e16ce5ff628033c62.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1e6f70f5d836b80a36654f18f89febac2231a0cc2f02f01e16ce5ff628033c62.mp4',
          name: 'FSTEP-BEG-INT-ADV-Figure_Four_Stretch-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 235499,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1940,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '62dbb1fd3964fb18445c7a6f3e6eae628ca88e50f6bf037135175bb222bc3ad1',
          file_name:
            'videos/62dbb1fd3964fb18445c7a6f3e6eae628ca88e50f6bf037135175bb222bc3ad1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/62dbb1fd3964fb18445c7a6f3e6eae628ca88e50f6bf037135175bb222bc3ad1.mp4',
          name: 'FSTEP-BEG-INT-ADV-Figure_Four_Stretch-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 257816,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1941,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '1915bbb7f82d9c0d1d5f1274cb6d1ee4615f134687cba14beede53a89bd8bda0',
          file_name:
            'audios/1915bbb7f82d9c0d1d5f1274cb6d1ee4615f134687cba14beede53a89bd8bda0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1915bbb7f82d9c0d1d5f1274cb6d1ee4615f134687cba14beede53a89bd8bda0.mp3',
          name: 'FSTEP-BEG-INT-ADV-Figure_Four_Stretch-COOL_DOWN',
          description: null,
          size: 29573,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SUN_SALUTATION_A-COOL_DOWN': {
      id: 720,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Sun Salutation A',
      short_name: 'Sun Salutation A',
      unique_name: 'BEGINNER-SUN_SALUTATION_A-COOL_DOWN',
      description:
        '1. Stand tall with your feet about hip-width apart. Inhale, and raise both arms overhead.\n2. Exhale, soften your knees, hinge at the waist and with a flat back, dive your torso down to the floor until your hands touch.\n3. Inhale, lift your torso halfway, parallel to the floor and place your hands on your shins. Back flat.\n4. Exhale, fold forward until your hands reach the floor, palms flat. Jump or step your feet behind you to plank, elbows bent.\n5. Inhale, swoop your forehead, chin and chest through your arms and come to Up Dog position with your arms straight and hips low.\n6. Exhale, curl your toes, draw your hips up and back, keeping your arms straight to Down Dog position.\n7. Inhale, look forward, bend your knees, and jump both feet toward your hands. Exhale.\n8. Inhale, halfway lift, hands on shins. Exhale fold back down.\n9. Root to rise and stand tall, sweeping your arms overhead.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1942,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '86d399b3904d7ad5709d669686943897d18b2393e637618165315eacf497859f',
          file_name:
            'videos/86d399b3904d7ad5709d669686943897d18b2393e637618165315eacf497859f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86d399b3904d7ad5709d669686943897d18b2393e637618165315eacf497859f.mp4',
          name: 'FSTEP-BEG-INT-ADV-Sun_Salutation_A-COOL_DOWN',
          description: null,
          size: 1399523,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1943,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '27586ca3039c4a66f117040c180970933447bb7bce8b50309b153132acce5614',
          file_name:
            'audios/27586ca3039c4a66f117040c180970933447bb7bce8b50309b153132acce5614.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/27586ca3039c4a66f117040c180970933447bb7bce8b50309b153132acce5614.mp3',
          name: 'FSTEP-BEG-INT-ADV-Sun_Salutation_A-COOL_DOWN',
          description: null,
          size: 33021,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SUN_SALUTATION_A-COOL_DOWN': {
      id: 721,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Sun Salutation A',
      short_name: 'Sun Salutation A',
      unique_name: 'INTERMEDIATE-SUN_SALUTATION_A-COOL_DOWN',
      description:
        '1. Stand tall with your feet about hip-width apart. Inhale, and raise both arms overhead.\n2. Exhale, soften your knees, hinge at the waist and with a flat back, dive your torso down to the floor until your hands touch.\n3. Inhale, lift your torso halfway, parallel to the floor and place your hands on your shins. Back flat.\n4. Exhale, fold forward until your hands reach the floor, palms flat. Jump or step your feet behind you to plank, elbows bent.\n5. Inhale, swoop your forehead, chin and chest through your arms and come to Up Dog position with your arms straight and hips low.\n6. Exhale, curl your toes, draw your hips up and back, keeping your arms straight to Down Dog position.\n7. Inhale, look forward, bend your knees, and jump both feet toward your hands. Exhale.\n8. Inhale, halfway lift, hands on shins. Exhale fold back down.\n9. Root to rise and stand tall, sweeping your arms overhead.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1944,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '86d399b3904d7ad5709d669686943897d18b2393e637618165315eacf497859f',
          file_name:
            'videos/86d399b3904d7ad5709d669686943897d18b2393e637618165315eacf497859f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86d399b3904d7ad5709d669686943897d18b2393e637618165315eacf497859f.mp4',
          name: 'FSTEP-BEG-INT-ADV-Sun_Salutation_A-COOL_DOWN',
          description: null,
          size: 1399523,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1945,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '27586ca3039c4a66f117040c180970933447bb7bce8b50309b153132acce5614',
          file_name:
            'audios/27586ca3039c4a66f117040c180970933447bb7bce8b50309b153132acce5614.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/27586ca3039c4a66f117040c180970933447bb7bce8b50309b153132acce5614.mp3',
          name: 'FSTEP-BEG-INT-ADV-Sun_Salutation_A-COOL_DOWN',
          description: null,
          size: 33021,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SUN_SALUTATION_A-COOL_DOWN': {
      id: 722,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Sun Salutation A',
      short_name: 'Sun Salutation A',
      unique_name: 'ADVANCED-SUN_SALUTATION_A-COOL_DOWN',
      description:
        '1. Stand tall with your feet about hip-width apart. Inhale, and raise both arms overhead.\n2. Exhale, soften your knees, hinge at the waist and with a flat back, dive your torso down to the floor until your hands touch.\n3. Inhale, lift your torso halfway, parallel to the floor and place your hands on your shins. Back flat.\n4. Exhale, fold forward until your hands reach the floor, palms flat. Jump or step your feet behind you to plank, elbows bent.\n5. Inhale, swoop your forehead, chin and chest through your arms and come to Up Dog position with your arms straight and hips low.\n6. Exhale, curl your toes, draw your hips up and back, keeping your arms straight to Down Dog position.\n7. Inhale, look forward, bend your knees, and jump both feet toward your hands. Exhale.\n8. Inhale, halfway lift, hands on shins. Exhale fold back down.\n9. Root to rise and stand tall, sweeping your arms overhead.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1946,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '86d399b3904d7ad5709d669686943897d18b2393e637618165315eacf497859f',
          file_name:
            'videos/86d399b3904d7ad5709d669686943897d18b2393e637618165315eacf497859f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86d399b3904d7ad5709d669686943897d18b2393e637618165315eacf497859f.mp4',
          name: 'FSTEP-BEG-INT-ADV-Sun_Salutation_A-COOL_DOWN',
          description: null,
          size: 1399523,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1947,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '27586ca3039c4a66f117040c180970933447bb7bce8b50309b153132acce5614',
          file_name:
            'audios/27586ca3039c4a66f117040c180970933447bb7bce8b50309b153132acce5614.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/27586ca3039c4a66f117040c180970933447bb7bce8b50309b153132acce5614.mp3',
          name: 'FSTEP-BEG-INT-ADV-Sun_Salutation_A-COOL_DOWN',
          description: null,
          size: 33021,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-PLANK_TO_THREE_LEGGED_DOG-COOL_DOWN': {
      id: 750,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Plank to Three Legged Dog',
      short_name: 'Plank to Three Legged Dog',
      unique_name: 'BEGINNER-PLANK_TO_THREE_LEGGED_DOG-COOL_DOWN',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine.\n2. Engage your core, draw your hips up and back as you raise one leg into the air, hips square, toes point down. Drop your chest toward your thigh making an inverted "V" with one leg up.\n3. Lower your leg, drop your hips and return to Plank. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2008,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '91ba86b00b371a21eec0ae09e9143558b4b17245342ce2cc5f3aabc4d98cadca',
          file_name:
            'videos/91ba86b00b371a21eec0ae09e9143558b4b17245342ce2cc5f3aabc4d98cadca.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/91ba86b00b371a21eec0ae09e9143558b4b17245342ce2cc5f3aabc4d98cadca.mp4',
          name: 'FSTEP-BEG-INT-ADV-Plank_to_Three_Legged_Dog-COOL_DOWN',
          description: null,
          size: 699954,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2009,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'c6155d47d338d6e4fa08d517c63aa54e350aa5cd3ca9a65e49346eafa56e5a4a',
          file_name:
            'audios/c6155d47d338d6e4fa08d517c63aa54e350aa5cd3ca9a65e49346eafa56e5a4a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c6155d47d338d6e4fa08d517c63aa54e350aa5cd3ca9a65e49346eafa56e5a4a.mp3',
          name: 'FSTEP-BEG-INT-ADV-Plank_to_Three_Legged_Dog-COOL_DOWN',
          description: null,
          size: 33335,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PLANK_TO_THREE_LEGGED_DOG-COOL_DOWN': {
      id: 751,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Plank to Three Legged Dog',
      short_name: 'Plank to Three Legged Dog',
      unique_name: 'INTERMEDIATE-PLANK_TO_THREE_LEGGED_DOG-COOL_DOWN',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine.\n2. Engage your core, draw your hips up and back as you raise one leg into the air, hips square, toes point down. Drop your chest toward your thigh making an inverted "V" with one leg up.\n3. Lower your leg, drop your hips and return to Plank. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2010,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '91ba86b00b371a21eec0ae09e9143558b4b17245342ce2cc5f3aabc4d98cadca',
          file_name:
            'videos/91ba86b00b371a21eec0ae09e9143558b4b17245342ce2cc5f3aabc4d98cadca.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/91ba86b00b371a21eec0ae09e9143558b4b17245342ce2cc5f3aabc4d98cadca.mp4',
          name: 'FSTEP-BEG-INT-ADV-Plank_to_Three_Legged_Dog-COOL_DOWN',
          description: null,
          size: 699954,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2011,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'c6155d47d338d6e4fa08d517c63aa54e350aa5cd3ca9a65e49346eafa56e5a4a',
          file_name:
            'audios/c6155d47d338d6e4fa08d517c63aa54e350aa5cd3ca9a65e49346eafa56e5a4a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c6155d47d338d6e4fa08d517c63aa54e350aa5cd3ca9a65e49346eafa56e5a4a.mp3',
          name: 'FSTEP-BEG-INT-ADV-Plank_to_Three_Legged_Dog-COOL_DOWN',
          description: null,
          size: 33335,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PLANK_TO_THREE_LEGGED_DOG-COOL_DOWN': {
      id: 752,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Plank to Three Legged Dog',
      short_name: 'Plank to Three Legged Dog',
      unique_name: 'ADVANCED-PLANK_TO_THREE_LEGGED_DOG-COOL_DOWN',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine.\n2. Engage your core, draw your hips up and back as you raise one leg into the air, hips square, toes point down. Drop your chest toward your thigh making an inverted "V" with one leg up.\n3. Lower your leg, drop your hips and return to Plank. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2012,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '91ba86b00b371a21eec0ae09e9143558b4b17245342ce2cc5f3aabc4d98cadca',
          file_name:
            'videos/91ba86b00b371a21eec0ae09e9143558b4b17245342ce2cc5f3aabc4d98cadca.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/91ba86b00b371a21eec0ae09e9143558b4b17245342ce2cc5f3aabc4d98cadca.mp4',
          name: 'FSTEP-BEG-INT-ADV-Plank_to_Three_Legged_Dog-COOL_DOWN',
          description: null,
          size: 699954,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2013,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'c6155d47d338d6e4fa08d517c63aa54e350aa5cd3ca9a65e49346eafa56e5a4a',
          file_name:
            'audios/c6155d47d338d6e4fa08d517c63aa54e350aa5cd3ca9a65e49346eafa56e5a4a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c6155d47d338d6e4fa08d517c63aa54e350aa5cd3ca9a65e49346eafa56e5a4a.mp3',
          name: 'FSTEP-BEG-INT-ADV-Plank_to_Three_Legged_Dog-COOL_DOWN',
          description: null,
          size: 33335,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-WARRIOR_ONE_POSE-COOL_DOWN': {
      id: 770,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Warrior One Pose ',
      short_name: 'Warrior One Pose ',
      unique_name: 'BEGINNER-WARRIOR_ONE_POSE-COOL_DOWN',
      description:
        '1. Stand feet hip-width apart. Take a big step forward with one leg and spin your back foot to 45 degrees, both heels flat.\n2. Raise your arms directly overhead as you drop your hips toward the floor by bending the front knee to 90 degrees. Front knee should be directly over your ankle and back knee remains straight.\n3. Keeping hips square hold for time.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2048,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'a89c95b7a0e48a09cded5981ab30e520d2ee530cfb846fa9cdea5a5346d67336',
          file_name:
            'videos/a89c95b7a0e48a09cded5981ab30e520d2ee530cfb846fa9cdea5a5346d67336.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a89c95b7a0e48a09cded5981ab30e520d2ee530cfb846fa9cdea5a5346d67336.mp4',
          name: 'FSTEP-BEG-INT-ADV-Warrior_One_Pose-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 365811,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2049,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: 'c6ff29d1a3a0c5d9c3cafeec309f2109a5c9cc17b6391cdb1e6b181e1c97453f',
          file_name:
            'videos/c6ff29d1a3a0c5d9c3cafeec309f2109a5c9cc17b6391cdb1e6b181e1c97453f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c6ff29d1a3a0c5d9c3cafeec309f2109a5c9cc17b6391cdb1e6b181e1c97453f.mp4',
          name: 'FSTEP-BEG-INT-ADV-Warrior_One_Pose-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 374838,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2050,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'dee02bff8515714bf28a12532ca77c5ab3722ed5d765f1695f7f13a6c0845832',
          file_name:
            'audios/dee02bff8515714bf28a12532ca77c5ab3722ed5d765f1695f7f13a6c0845832.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dee02bff8515714bf28a12532ca77c5ab3722ed5d765f1695f7f13a6c0845832.mp3',
          name: 'FSTEP-BEG-INT-ADV-Warrior_One_Pose-COOL_DOWN',
          description: null,
          size: 29573,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-WARRIOR_ONE_POSE-COOL_DOWN': {
      id: 771,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Warrior One Pose ',
      short_name: 'Warrior One Pose ',
      unique_name: 'INTERMEDIATE-WARRIOR_ONE_POSE-COOL_DOWN',
      description:
        '1. Stand feet hip-width apart. Take a big step forward with one leg and spin your back foot to 45 degrees, both heels flat.\n2. Raise your arms directly overhead as you drop your hips toward the floor by bending the front knee to 90 degrees. Front knee should be directly over your ankle and back knee remains straight.\n3. Keeping hips square hold for time.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2051,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'a89c95b7a0e48a09cded5981ab30e520d2ee530cfb846fa9cdea5a5346d67336',
          file_name:
            'videos/a89c95b7a0e48a09cded5981ab30e520d2ee530cfb846fa9cdea5a5346d67336.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a89c95b7a0e48a09cded5981ab30e520d2ee530cfb846fa9cdea5a5346d67336.mp4',
          name: 'FSTEP-BEG-INT-ADV-Warrior_One_Pose-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 365811,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2052,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: 'c6ff29d1a3a0c5d9c3cafeec309f2109a5c9cc17b6391cdb1e6b181e1c97453f',
          file_name:
            'videos/c6ff29d1a3a0c5d9c3cafeec309f2109a5c9cc17b6391cdb1e6b181e1c97453f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c6ff29d1a3a0c5d9c3cafeec309f2109a5c9cc17b6391cdb1e6b181e1c97453f.mp4',
          name: 'FSTEP-BEG-INT-ADV-Warrior_One_Pose-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 374838,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2053,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'dee02bff8515714bf28a12532ca77c5ab3722ed5d765f1695f7f13a6c0845832',
          file_name:
            'audios/dee02bff8515714bf28a12532ca77c5ab3722ed5d765f1695f7f13a6c0845832.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dee02bff8515714bf28a12532ca77c5ab3722ed5d765f1695f7f13a6c0845832.mp3',
          name: 'FSTEP-BEG-INT-ADV-Warrior_One_Pose-COOL_DOWN',
          description: null,
          size: 29573,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-WARRIOR_ONE_POSE-COOL_DOWN': {
      id: 772,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Warrior One Pose ',
      short_name: 'Warrior One Pose ',
      unique_name: 'ADVANCED-WARRIOR_ONE_POSE-COOL_DOWN',
      description:
        '1. Stand feet hip-width apart. Take a big step forward with one leg and spin your back foot to 45 degrees, both heels flat.\n2. Raise your arms directly overhead as you drop your hips toward the floor by bending the front knee to 90 degrees. Front knee should be directly over your ankle and back knee remains straight.\n3. Keeping hips square hold for time.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2054,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'a89c95b7a0e48a09cded5981ab30e520d2ee530cfb846fa9cdea5a5346d67336',
          file_name:
            'videos/a89c95b7a0e48a09cded5981ab30e520d2ee530cfb846fa9cdea5a5346d67336.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a89c95b7a0e48a09cded5981ab30e520d2ee530cfb846fa9cdea5a5346d67336.mp4',
          name: 'FSTEP-BEG-INT-ADV-Warrior_One_Pose-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 365811,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2055,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: 'c6ff29d1a3a0c5d9c3cafeec309f2109a5c9cc17b6391cdb1e6b181e1c97453f',
          file_name:
            'videos/c6ff29d1a3a0c5d9c3cafeec309f2109a5c9cc17b6391cdb1e6b181e1c97453f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c6ff29d1a3a0c5d9c3cafeec309f2109a5c9cc17b6391cdb1e6b181e1c97453f.mp4',
          name: 'FSTEP-BEG-INT-ADV-Warrior_One_Pose-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 374838,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2056,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'dee02bff8515714bf28a12532ca77c5ab3722ed5d765f1695f7f13a6c0845832',
          file_name:
            'audios/dee02bff8515714bf28a12532ca77c5ab3722ed5d765f1695f7f13a6c0845832.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dee02bff8515714bf28a12532ca77c5ab3722ed5d765f1695f7f13a6c0845832.mp3',
          name: 'FSTEP-BEG-INT-ADV-Warrior_One_Pose-COOL_DOWN',
          description: null,
          size: 29573,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-WARRIOR_TWO_POSE-COOL_DOWN': {
      id: 773,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Warrior Two Pose ',
      short_name: 'Warrior Two Pose ',
      unique_name: 'BEGINNER-WARRIOR_TWO_POSE-COOL_DOWN',
      description:
        '1. Stand feet hip-width apart. Take a big step forward with one leg and spin your back foot to 45 degrees, both heels flat.\n2. Rotate torso open and raise arms out to a "T" as you drop into a lunge, bending the front knee to 90 degrees. Front knee should be directly over your ankle and back leg straight.\n3. Keep shoulders over hips, gaze forward over your front hand. Hold for time.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2057,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '61caa7522e791130b1c13c24994b780f51082cde5f31e227baa659a9da94eaff',
          file_name:
            'videos/61caa7522e791130b1c13c24994b780f51082cde5f31e227baa659a9da94eaff.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/61caa7522e791130b1c13c24994b780f51082cde5f31e227baa659a9da94eaff.mp4',
          name: 'FSTEP-BEG-INT-ADV-Warrior_Two_Pose-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 367172,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2058,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '7852dc67a7c1ed5355488e1bbd90b84fe155e324f1fdb97ad77b57372cd01954',
          file_name:
            'videos/7852dc67a7c1ed5355488e1bbd90b84fe155e324f1fdb97ad77b57372cd01954.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7852dc67a7c1ed5355488e1bbd90b84fe155e324f1fdb97ad77b57372cd01954.mp4',
          name: 'FSTEP-BEG-INT-ADV-Warrior_Two_Pose-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 355761,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2059,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'df716fb80e1c6ba77ff0e513a4c9514bd6fc9b6f1e46123f3ba5b91f5377e847',
          file_name:
            'audios/df716fb80e1c6ba77ff0e513a4c9514bd6fc9b6f1e46123f3ba5b91f5377e847.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/df716fb80e1c6ba77ff0e513a4c9514bd6fc9b6f1e46123f3ba5b91f5377e847.mp3',
          name: 'FSTEP-BEG-INT-ADV-Warrior_Two_Pose-COOL_DOWN',
          description: null,
          size: 29260,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-WARRIOR_TWO_POSE-COOL_DOWN': {
      id: 774,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Warrior Two Pose ',
      short_name: 'Warrior Two Pose ',
      unique_name: 'INTERMEDIATE-WARRIOR_TWO_POSE-COOL_DOWN',
      description:
        '1. Stand feet hip-width apart. Take a big step forward with one leg and spin your back foot to 45 degrees, both heels flat.\n2. Rotate torso open and raise arms out to a "T" as you drop into a lunge, bending the front knee to 90 degrees. Front knee should be directly over your ankle and back leg straight.\n3. Keep shoulders over hips, gaze forward over your front hand. Hold for time.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2060,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '61caa7522e791130b1c13c24994b780f51082cde5f31e227baa659a9da94eaff',
          file_name:
            'videos/61caa7522e791130b1c13c24994b780f51082cde5f31e227baa659a9da94eaff.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/61caa7522e791130b1c13c24994b780f51082cde5f31e227baa659a9da94eaff.mp4',
          name: 'FSTEP-BEG-INT-ADV-Warrior_Two_Pose-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 367172,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2061,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '7852dc67a7c1ed5355488e1bbd90b84fe155e324f1fdb97ad77b57372cd01954',
          file_name:
            'videos/7852dc67a7c1ed5355488e1bbd90b84fe155e324f1fdb97ad77b57372cd01954.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7852dc67a7c1ed5355488e1bbd90b84fe155e324f1fdb97ad77b57372cd01954.mp4',
          name: 'FSTEP-BEG-INT-ADV-Warrior_Two_Pose-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 355761,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2062,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'df716fb80e1c6ba77ff0e513a4c9514bd6fc9b6f1e46123f3ba5b91f5377e847',
          file_name:
            'audios/df716fb80e1c6ba77ff0e513a4c9514bd6fc9b6f1e46123f3ba5b91f5377e847.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/df716fb80e1c6ba77ff0e513a4c9514bd6fc9b6f1e46123f3ba5b91f5377e847.mp3',
          name: 'FSTEP-BEG-INT-ADV-Warrior_Two_Pose-COOL_DOWN',
          description: null,
          size: 29260,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-WARRIOR_TWO_POSE-COOL_DOWN': {
      id: 775,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Warrior Two Pose ',
      short_name: 'Warrior Two Pose ',
      unique_name: 'ADVANCED-WARRIOR_TWO_POSE-COOL_DOWN',
      description:
        '1. Stand feet hip-width apart. Take a big step forward with one leg and spin your back foot to 45 degrees, both heels flat.\n2. Rotate torso open and raise arms out to a "T" as you drop into a lunge, bending the front knee to 90 degrees. Front knee should be directly over your ankle and back leg straight.\n3. Keep shoulders over hips, gaze forward over your front hand. Hold for time.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2063,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '61caa7522e791130b1c13c24994b780f51082cde5f31e227baa659a9da94eaff',
          file_name:
            'videos/61caa7522e791130b1c13c24994b780f51082cde5f31e227baa659a9da94eaff.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/61caa7522e791130b1c13c24994b780f51082cde5f31e227baa659a9da94eaff.mp4',
          name: 'FSTEP-BEG-INT-ADV-Warrior_Two_Pose-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 367172,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2064,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '7852dc67a7c1ed5355488e1bbd90b84fe155e324f1fdb97ad77b57372cd01954',
          file_name:
            'videos/7852dc67a7c1ed5355488e1bbd90b84fe155e324f1fdb97ad77b57372cd01954.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7852dc67a7c1ed5355488e1bbd90b84fe155e324f1fdb97ad77b57372cd01954.mp4',
          name: 'FSTEP-BEG-INT-ADV-Warrior_Two_Pose-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 355761,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2065,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'df716fb80e1c6ba77ff0e513a4c9514bd6fc9b6f1e46123f3ba5b91f5377e847',
          file_name:
            'audios/df716fb80e1c6ba77ff0e513a4c9514bd6fc9b6f1e46123f3ba5b91f5377e847.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/df716fb80e1c6ba77ff0e513a4c9514bd6fc9b6f1e46123f3ba5b91f5377e847.mp3',
          name: 'FSTEP-BEG-INT-ADV-Warrior_Two_Pose-COOL_DOWN',
          description: null,
          size: 29260,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-THREE_LEGGED_DOG_WITH_KNEE_DRIVE-COOL_DOWN': {
      id: 803,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Three Legged Dog with Knee Drive',
      short_name: 'Three Leg Dog w Knee',
      unique_name: 'BEGINNER-THREE_LEGGED_DOG_WITH_KNEE_DRIVE-COOL_DOWN',
      description:
        '1. Start in Down Dog position. Lift one leg high into the air, hips square and toes pointed down.\n2. With extended leg, bend your knee and draw it up your midline as you shift your weight forward, shoulders over wrists. Round your upper back, dip your chin and bring your nose close to your knee. Pause.\n3. Shift your weight back to Three Legged Down Dog position. Perform all reps. Repeat other leg.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2123,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '2023e76bfc9f8673f01d00100c338577aa6bc36436b9fc01b0194ab2ca5ebcd0',
          file_name:
            'videos/2023e76bfc9f8673f01d00100c338577aa6bc36436b9fc01b0194ab2ca5ebcd0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2023e76bfc9f8673f01d00100c338577aa6bc36436b9fc01b0194ab2ca5ebcd0.mp4',
          name: 'BEG-INT-ADV-Three_Legged_Dog_with_Knee_Drive-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 756631,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2124,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '5ec2e1d9489fcd70577858546385097f3a625ad0c42ce75008833d149fccfde5',
          file_name:
            'videos/5ec2e1d9489fcd70577858546385097f3a625ad0c42ce75008833d149fccfde5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5ec2e1d9489fcd70577858546385097f3a625ad0c42ce75008833d149fccfde5.mp4',
          name: 'BEG-INT-ADV-Three_Legged_Dog_with_Knee_Drive-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 751924,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2125,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '87acd87bc7570f8668287796e394b85512fd971607a33e755774ed20e9f021ae',
          file_name:
            'audios/87acd87bc7570f8668287796e394b85512fd971607a33e755774ed20e9f021ae.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/87acd87bc7570f8668287796e394b85512fd971607a33e755774ed20e9f021ae.mp3',
          name: 'BEG-INT-ADV-Three_Legged_Dog_with_Knee_Drive-COOL_DOWN',
          description: null,
          size: 40858,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-THREE_LEGGED_DOG_WITH_KNEE_DRIVE-COOL_DOWN': {
      id: 804,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Three Legged Dog with Knee Drive',
      short_name: 'Three Leg Dog w Knee',
      unique_name: 'INTERMEDIATE-THREE_LEGGED_DOG_WITH_KNEE_DRIVE-COOL_DOWN',
      description:
        '1. Start in Down Dog position. Lift one leg high into the air, hips square and toes pointed down.\n2. With extended leg, bend your knee and draw it up your midline as you shift your weight forward, shoulders over wrists. Round your upper back, dip your chin and bring your nose close to your knee. Pause.\n3. Shift your weight back to Three Legged Down Dog position. Perform all reps. Repeat other leg.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2126,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '2023e76bfc9f8673f01d00100c338577aa6bc36436b9fc01b0194ab2ca5ebcd0',
          file_name:
            'videos/2023e76bfc9f8673f01d00100c338577aa6bc36436b9fc01b0194ab2ca5ebcd0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2023e76bfc9f8673f01d00100c338577aa6bc36436b9fc01b0194ab2ca5ebcd0.mp4',
          name: 'BEG-INT-ADV-Three_Legged_Dog_with_Knee_Drive-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 756631,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2127,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '5ec2e1d9489fcd70577858546385097f3a625ad0c42ce75008833d149fccfde5',
          file_name:
            'videos/5ec2e1d9489fcd70577858546385097f3a625ad0c42ce75008833d149fccfde5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5ec2e1d9489fcd70577858546385097f3a625ad0c42ce75008833d149fccfde5.mp4',
          name: 'BEG-INT-ADV-Three_Legged_Dog_with_Knee_Drive-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 751924,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2128,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '87acd87bc7570f8668287796e394b85512fd971607a33e755774ed20e9f021ae',
          file_name:
            'audios/87acd87bc7570f8668287796e394b85512fd971607a33e755774ed20e9f021ae.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/87acd87bc7570f8668287796e394b85512fd971607a33e755774ed20e9f021ae.mp3',
          name: 'BEG-INT-ADV-Three_Legged_Dog_with_Knee_Drive-COOL_DOWN',
          description: null,
          size: 40858,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-THREE_LEGGED_DOG_WITH_KNEE_DRIVE-COOL_DOWN': {
      id: 805,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Three Legged Dog with Knee Drive',
      short_name: 'Three Leg Dog w Knee',
      unique_name: 'ADVANCED-THREE_LEGGED_DOG_WITH_KNEE_DRIVE-COOL_DOWN',
      description:
        '1. Start in Down Dog position. Lift one leg high into the air, hips square and toes pointed down.\n2. With extended leg, bend your knee and draw it up your midline as you shift your weight forward, shoulders over wrists. Round your upper back, dip your chin and bring your nose close to your knee. Pause.\n3. Shift your weight back to Three Legged Down Dog position. Perform all reps. Repeat other leg.',
      preview_time: null,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2129,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '2023e76bfc9f8673f01d00100c338577aa6bc36436b9fc01b0194ab2ca5ebcd0',
          file_name:
            'videos/2023e76bfc9f8673f01d00100c338577aa6bc36436b9fc01b0194ab2ca5ebcd0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2023e76bfc9f8673f01d00100c338577aa6bc36436b9fc01b0194ab2ca5ebcd0.mp4',
          name: 'BEG-INT-ADV-Three_Legged_Dog_with_Knee_Drive-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 756631,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2130,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '5ec2e1d9489fcd70577858546385097f3a625ad0c42ce75008833d149fccfde5',
          file_name:
            'videos/5ec2e1d9489fcd70577858546385097f3a625ad0c42ce75008833d149fccfde5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5ec2e1d9489fcd70577858546385097f3a625ad0c42ce75008833d149fccfde5.mp4',
          name: 'BEG-INT-ADV-Three_Legged_Dog_with_Knee_Drive-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 751924,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2131,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '87acd87bc7570f8668287796e394b85512fd971607a33e755774ed20e9f021ae',
          file_name:
            'audios/87acd87bc7570f8668287796e394b85512fd971607a33e755774ed20e9f021ae.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/87acd87bc7570f8668287796e394b85512fd971607a33e755774ed20e9f021ae.mp3',
          name: 'BEG-INT-ADV-Three_Legged_Dog_with_Knee_Drive-COOL_DOWN',
          description: null,
          size: 40858,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-HALF_SPLITS_HAMSTRING_STRETCH-COOL_DOWN': {
      id: 1096,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Half Splits Hamstring Stretch',
      short_name: 'Half Splits Hamstring Stretch',
      unique_name: 'BEGINNER-HALF_SPLITS_HAMSTRING_STRETCH-COOL_DOWN',
      description:
        '1. Start in a half-kneel position with one leg straight in front of you, toe pointed up. Keep core engaged and spine straight.\n2. With tall posture, lead with your chest and fold your torso over your straight leg. Place hands on the floor for support. Hold and breathe. \n3. With control, return to start and repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2819,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '68af3a2188fd48584aa9edfdd66c8e4aab9b1fd0748d69e25c6e29ec5e672b1b',
          file_name:
            'videos/68af3a2188fd48584aa9edfdd66c8e4aab9b1fd0748d69e25c6e29ec5e672b1b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/68af3a2188fd48584aa9edfdd66c8e4aab9b1fd0748d69e25c6e29ec5e672b1b.mp4',
          name: 'BEG-INT-ADV-Half_Splits_Hamstring_Stretch-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 460206,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3079,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '4ec48545cb33723d0111c48f9c437b48b79b1c6b13f2453ef4a8bfacd4e7ab9d',
          file_name:
            'videos/4ec48545cb33723d0111c48f9c437b48b79b1c6b13f2453ef4a8bfacd4e7ab9d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4ec48545cb33723d0111c48f9c437b48b79b1c6b13f2453ef4a8bfacd4e7ab9d.mp4',
          name: 'BEG-INT-ADV-Half_Splits_Hamstring_Stretch-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 423989,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3080,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'a5c37581e1280de33315cfe45715c711506d2efb4a0ed26f2d1b72707ae258fc',
          file_name:
            'audios/a5c37581e1280de33315cfe45715c711506d2efb4a0ed26f2d1b72707ae258fc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a5c37581e1280de33315cfe45715c711506d2efb4a0ed26f2d1b72707ae258fc.mp3',
          name: 'BEG-INT-ADV-Half_Splits_Hamstring_Stretch-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 33165,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-HALF_SPLITS_HAMSTRING_STRETCH-COOL_DOWN': {
      id: 1097,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Half Splits Hamstring Stretch',
      short_name: 'Half Splits Hamstring Stretch',
      unique_name: 'INTERMEDIATE-HALF_SPLITS_HAMSTRING_STRETCH-COOL_DOWN',
      description:
        '1. Start in a half-kneel position with one leg straight in front of you, toe pointed up. Keep core engaged and spine straight.\n2. With tall posture, lead with your chest and fold your torso over your straight leg. Place hands on the floor for support. Hold and breathe. \n3. With control, return to start and repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2822,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '68af3a2188fd48584aa9edfdd66c8e4aab9b1fd0748d69e25c6e29ec5e672b1b',
          file_name:
            'videos/68af3a2188fd48584aa9edfdd66c8e4aab9b1fd0748d69e25c6e29ec5e672b1b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/68af3a2188fd48584aa9edfdd66c8e4aab9b1fd0748d69e25c6e29ec5e672b1b.mp4',
          name: 'BEG-INT-ADV-Half_Splits_Hamstring_Stretch-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 460206,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3081,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '4ec48545cb33723d0111c48f9c437b48b79b1c6b13f2453ef4a8bfacd4e7ab9d',
          file_name:
            'videos/4ec48545cb33723d0111c48f9c437b48b79b1c6b13f2453ef4a8bfacd4e7ab9d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4ec48545cb33723d0111c48f9c437b48b79b1c6b13f2453ef4a8bfacd4e7ab9d.mp4',
          name: 'BEG-INT-ADV-Half_Splits_Hamstring_Stretch-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 423989,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3082,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'a5c37581e1280de33315cfe45715c711506d2efb4a0ed26f2d1b72707ae258fc',
          file_name:
            'audios/a5c37581e1280de33315cfe45715c711506d2efb4a0ed26f2d1b72707ae258fc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a5c37581e1280de33315cfe45715c711506d2efb4a0ed26f2d1b72707ae258fc.mp3',
          name: 'BEG-INT-ADV-Half_Splits_Hamstring_Stretch-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 33165,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-HALF_SPLITS_HAMSTRING_STRETCH-COOL_DOWN': {
      id: 1098,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Half Splits Hamstring Stretch',
      short_name: 'Half Splits Hamstring Stretch',
      unique_name: 'ADVANCED-HALF_SPLITS_HAMSTRING_STRETCH-COOL_DOWN',
      description:
        '1. Start in a half-kneel position with one leg straight in front of you, toe pointed up. Keep core engaged and spine straight.\n2. With tall posture, lead with your chest and fold your torso over your straight leg. Place hands on the floor for support. Hold and breathe. \n3. With control, return to start and repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2825,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '68af3a2188fd48584aa9edfdd66c8e4aab9b1fd0748d69e25c6e29ec5e672b1b',
          file_name:
            'videos/68af3a2188fd48584aa9edfdd66c8e4aab9b1fd0748d69e25c6e29ec5e672b1b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/68af3a2188fd48584aa9edfdd66c8e4aab9b1fd0748d69e25c6e29ec5e672b1b.mp4',
          name: 'BEG-INT-ADV-Half_Splits_Hamstring_Stretch-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 460206,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3083,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '4ec48545cb33723d0111c48f9c437b48b79b1c6b13f2453ef4a8bfacd4e7ab9d',
          file_name:
            'videos/4ec48545cb33723d0111c48f9c437b48b79b1c6b13f2453ef4a8bfacd4e7ab9d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4ec48545cb33723d0111c48f9c437b48b79b1c6b13f2453ef4a8bfacd4e7ab9d.mp4',
          name: 'BEG-INT-ADV-Half_Splits_Hamstring_Stretch-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 423989,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3084,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'a5c37581e1280de33315cfe45715c711506d2efb4a0ed26f2d1b72707ae258fc',
          file_name:
            'audios/a5c37581e1280de33315cfe45715c711506d2efb4a0ed26f2d1b72707ae258fc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a5c37581e1280de33315cfe45715c711506d2efb4a0ed26f2d1b72707ae258fc.mp3',
          name: 'BEG-INT-ADV-Half_Splits_Hamstring_Stretch-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 33165,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-UP_DOG_WITH_OBLIQUE_STRETCH-COOL_DOWN': {
      id: 1107,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Up Dog with Oblique Stretch',
      short_name: 'Up Dog with Oblique Stretch',
      unique_name: 'BEGINNER-UP_DOG_WITH_OBLIQUE_STRETCH-COOL_DOWN',
      description:
        '1. Lie prone on the floor, shoulders over wrists, hands flat. \n2. Push into the ground with your hands, keeping chest open and shoulders out of ears. Lift your quads off the floor. This is Up Dog.\n3. Keeping hands planted, lift out of your ribcage and gently rotate your trunk to one side to stretch your obliques. \n4. Return to center. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2846,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '48da70e5a799885925811a1e7708d6df6ddf5abc1caa436473c18b98cf894fff',
          file_name:
            'videos/48da70e5a799885925811a1e7708d6df6ddf5abc1caa436473c18b98cf894fff.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/48da70e5a799885925811a1e7708d6df6ddf5abc1caa436473c18b98cf894fff.mp4',
          name: 'BEG-INT-ADV-Up_Dog_with_Oblique_Stretch-COOL_DOWN',
          description: null,
          size: 480629,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3093,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '47ca949139729f2a8ef0e7cbaa00966bef07a78b56356449157d13e20e912ff4',
          file_name:
            'audios/47ca949139729f2a8ef0e7cbaa00966bef07a78b56356449157d13e20e912ff4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/47ca949139729f2a8ef0e7cbaa00966bef07a78b56356449157d13e20e912ff4.mp3',
          name: 'BEG-INT-ADV-Up_Dog_with_Oblique_Stretch-COOL_DOWN',
          description: null,
          size: 26541,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-UP_DOG_WITH_OBLIQUE_STRETCH-COOL_DOWN': {
      id: 1108,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Up Dog with Oblique Stretch',
      short_name: 'Up Dog with Oblique Stretch',
      unique_name: 'INTERMEDIATE-UP_DOG_WITH_OBLIQUE_STRETCH-COOL_DOWN',
      description:
        '1. Lie prone on the floor, shoulders over wrists, hands flat. \n2. Push into the ground with your hands, keeping chest open and shoulders out of ears. Lift your quads off the floor. This is Up Dog.\n3. Keeping hands planted, lift out of your ribcage and gently rotate your trunk to one side to stretch your obliques. \n4. Return to center. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2848,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '48da70e5a799885925811a1e7708d6df6ddf5abc1caa436473c18b98cf894fff',
          file_name:
            'videos/48da70e5a799885925811a1e7708d6df6ddf5abc1caa436473c18b98cf894fff.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/48da70e5a799885925811a1e7708d6df6ddf5abc1caa436473c18b98cf894fff.mp4',
          name: 'BEG-INT-ADV-Up_Dog_with_Oblique_Stretch-COOL_DOWN',
          description: null,
          size: 480629,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3094,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '47ca949139729f2a8ef0e7cbaa00966bef07a78b56356449157d13e20e912ff4',
          file_name:
            'audios/47ca949139729f2a8ef0e7cbaa00966bef07a78b56356449157d13e20e912ff4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/47ca949139729f2a8ef0e7cbaa00966bef07a78b56356449157d13e20e912ff4.mp3',
          name: 'BEG-INT-ADV-Up_Dog_with_Oblique_Stretch-COOL_DOWN',
          description: null,
          size: 26541,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-UP_DOG_WITH_OBLIQUE_STRETCH-COOL_DOWN': {
      id: 1109,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Up Dog with Oblique Stretch',
      short_name: 'Up Dog with Oblique Stretch',
      unique_name: 'ADVANCED-UP_DOG_WITH_OBLIQUE_STRETCH-COOL_DOWN',
      description:
        '1. Lie prone on the floor, shoulders over wrists, hands flat. \n2. Push into the ground with your hands, keeping chest open and shoulders out of ears. Lift your quads off the floor. This is Up Dog.\n3. Keeping hands planted, lift out of your ribcage and gently rotate your trunk to one side to stretch your obliques. \n4. Return to center. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2850,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '48da70e5a799885925811a1e7708d6df6ddf5abc1caa436473c18b98cf894fff',
          file_name:
            'videos/48da70e5a799885925811a1e7708d6df6ddf5abc1caa436473c18b98cf894fff.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/48da70e5a799885925811a1e7708d6df6ddf5abc1caa436473c18b98cf894fff.mp4',
          name: 'BEG-INT-ADV-Up_Dog_with_Oblique_Stretch-COOL_DOWN',
          description: null,
          size: 480629,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3095,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '47ca949139729f2a8ef0e7cbaa00966bef07a78b56356449157d13e20e912ff4',
          file_name:
            'audios/47ca949139729f2a8ef0e7cbaa00966bef07a78b56356449157d13e20e912ff4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/47ca949139729f2a8ef0e7cbaa00966bef07a78b56356449157d13e20e912ff4.mp3',
          name: 'BEG-INT-ADV-Up_Dog_with_Oblique_Stretch-COOL_DOWN',
          description: null,
          size: 26541,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SHOULDER_CIRCLES_FORWARD_AND_BACKWARD_ON_KNEES-COOL_DOWN': {
      id: 1118,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Shoulder Circles Forward and Backward On Knees',
      short_name: 'Shoulder Circles on Knees',
      unique_name:
        'BEGINNER-SHOULDER_CIRCLES_FORWARD_AND_BACKWARD_ON_KNEES-COOL_DOWN',
      description:
        '1. Start in a full kneeling position, weight in heels. Arms by sides and spine nuetral. You can also do this standing or seated in a chair. \n2. Bring your shoulders up, forward and down in a large circular motion for time. \n3. Repeat other direction.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2874,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '902a25df967714cfd8eab35132035016ef985cd482a1bb2759f32d177dad75b0',
          file_name:
            'videos/902a25df967714cfd8eab35132035016ef985cd482a1bb2759f32d177dad75b0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/902a25df967714cfd8eab35132035016ef985cd482a1bb2759f32d177dad75b0.mp4',
          name: 'BEG-INT-ADV-Shoulder_Circles_Forward_and_Backward_On_Knees-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 340891,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2875,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '05df5631bf38945b146bae051a4af1d57f418371526917f0e637d2981b4b16a3',
          file_name:
            'videos/05df5631bf38945b146bae051a4af1d57f418371526917f0e637d2981b4b16a3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/05df5631bf38945b146bae051a4af1d57f418371526917f0e637d2981b4b16a3.mp4',
          name: 'BEG-INT-ADV-Shoulder_Circles_Forward_and_Backward_On_Knees-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 394374,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3104,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '388d0b5a9ecb08d34bc960d17251b430a32b0c7c4259f60dc529ee896f1d37b5',
          file_name:
            'audios/388d0b5a9ecb08d34bc960d17251b430a32b0c7c4259f60dc529ee896f1d37b5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/388d0b5a9ecb08d34bc960d17251b430a32b0c7c4259f60dc529ee896f1d37b5.mp3',
          name: 'BEG-INT-ADV-Shoulder_Circles_Forward_and_Backward_On_Knees-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 41517,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SHOULDER_CIRCLES_FORWARD_AND_BACKWARD_ON_KNEES-COOL_DOWN': {
      id: 1119,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Shoulder Circles Forward and Backward On Knees',
      short_name: 'Shoulder Circles on Knees',
      unique_name:
        'INTERMEDIATE-SHOULDER_CIRCLES_FORWARD_AND_BACKWARD_ON_KNEES-COOL_DOWN',
      description:
        '1. Start in a full kneeling position, weight in heels. Arms by sides and spine nuetral. You can also do this standing or seated in a chair. \n2. Bring your shoulders up, forward and down in a large circular motion for time. \n3. Repeat other direction.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2877,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '902a25df967714cfd8eab35132035016ef985cd482a1bb2759f32d177dad75b0',
          file_name:
            'videos/902a25df967714cfd8eab35132035016ef985cd482a1bb2759f32d177dad75b0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/902a25df967714cfd8eab35132035016ef985cd482a1bb2759f32d177dad75b0.mp4',
          name: 'BEG-INT-ADV-Shoulder_Circles_Forward_and_Backward_On_Knees-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 340891,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2878,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '05df5631bf38945b146bae051a4af1d57f418371526917f0e637d2981b4b16a3',
          file_name:
            'videos/05df5631bf38945b146bae051a4af1d57f418371526917f0e637d2981b4b16a3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/05df5631bf38945b146bae051a4af1d57f418371526917f0e637d2981b4b16a3.mp4',
          name: 'BEG-INT-ADV-Shoulder_Circles_Forward_and_Backward_On_Knees-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 394374,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3105,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '388d0b5a9ecb08d34bc960d17251b430a32b0c7c4259f60dc529ee896f1d37b5',
          file_name:
            'audios/388d0b5a9ecb08d34bc960d17251b430a32b0c7c4259f60dc529ee896f1d37b5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/388d0b5a9ecb08d34bc960d17251b430a32b0c7c4259f60dc529ee896f1d37b5.mp3',
          name: 'BEG-INT-ADV-Shoulder_Circles_Forward_and_Backward_On_Knees-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 41517,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SHOULDER_CIRCLES_FORWARD_AND_BACKWARD_ON_KNEES-COOL_DOWN': {
      id: 1120,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Shoulder Circles Forward and Backward On Knees',
      short_name: 'Shoulder Circles on Knees',
      unique_name:
        'ADVANCED-SHOULDER_CIRCLES_FORWARD_AND_BACKWARD_ON_KNEES-COOL_DOWN',
      description:
        '1. Start in a full kneeling position, weight in heels. Arms by sides and spine nuetral. You can also do this standing or seated in a chair. \n2. Bring your shoulders up, forward and down in a large circular motion for time. \n3. Repeat other direction.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2880,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '902a25df967714cfd8eab35132035016ef985cd482a1bb2759f32d177dad75b0',
          file_name:
            'videos/902a25df967714cfd8eab35132035016ef985cd482a1bb2759f32d177dad75b0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/902a25df967714cfd8eab35132035016ef985cd482a1bb2759f32d177dad75b0.mp4',
          name: 'BEG-INT-ADV-Shoulder_Circles_Forward_and_Backward_On_Knees-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 340891,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2881,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '05df5631bf38945b146bae051a4af1d57f418371526917f0e637d2981b4b16a3',
          file_name:
            'videos/05df5631bf38945b146bae051a4af1d57f418371526917f0e637d2981b4b16a3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/05df5631bf38945b146bae051a4af1d57f418371526917f0e637d2981b4b16a3.mp4',
          name: 'BEG-INT-ADV-Shoulder_Circles_Forward_and_Backward_On_Knees-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 394374,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3106,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '388d0b5a9ecb08d34bc960d17251b430a32b0c7c4259f60dc529ee896f1d37b5',
          file_name:
            'audios/388d0b5a9ecb08d34bc960d17251b430a32b0c7c4259f60dc529ee896f1d37b5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/388d0b5a9ecb08d34bc960d17251b430a32b0c7c4259f60dc529ee896f1d37b5.mp3',
          name: 'BEG-INT-ADV-Shoulder_Circles_Forward_and_Backward_On_Knees-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 41517,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-QUADRUPED_WRIST_STRETCH-COOL_DOWN': {
      id: 1121,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Quadruped Wrist Stretch',
      short_name: 'Quadruped Wrist Stretch',
      unique_name: 'BEGINNER-QUADRUPED_WRIST_STRETCH-COOL_DOWN',
      description:
        '1. Start on all fours with shoulders over wrists and hips square. Hands flat, fingers point forward. \n2. Keep palms planted, and rock your hips back toward your heels. Pause. \n3. Rock forward so your upper body travels past your wrists to stretch. \n4. Rock back and forth in a smooth, continuous motion for time. \n5. Repeat with both palms facing the other direction, fingers pointed toward you.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2883,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '0726627a759c3ba1b59a6cc5ee1ca63dc069fe9ff0971b1ef6efaa87e5be4874',
          file_name:
            'videos/0726627a759c3ba1b59a6cc5ee1ca63dc069fe9ff0971b1ef6efaa87e5be4874.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0726627a759c3ba1b59a6cc5ee1ca63dc069fe9ff0971b1ef6efaa87e5be4874.mp4',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Stretch-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 382179,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2884,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '3052138f2b8d706b287c868b394155ef924cda457dca6bafca3e44c521970f29',
          file_name:
            'videos/3052138f2b8d706b287c868b394155ef924cda457dca6bafca3e44c521970f29.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3052138f2b8d706b287c868b394155ef924cda457dca6bafca3e44c521970f29.mp4',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Stretch-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 362059,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3107,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '4dd6c7a4ce3387c925a8489580962323272a01e67961e9ebbc946bb1042a6957',
          file_name:
            'audios/4dd6c7a4ce3387c925a8489580962323272a01e67961e9ebbc946bb1042a6957.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4dd6c7a4ce3387c925a8489580962323272a01e67961e9ebbc946bb1042a6957.mp3',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Stretch-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-QUADRUPED_WRIST_STRETCH-COOL_DOWN': {
      id: 1122,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Quadruped Wrist Stretch',
      short_name: 'Quadruped Wrist Stretch',
      unique_name: 'INTERMEDIATE-QUADRUPED_WRIST_STRETCH-COOL_DOWN',
      description:
        '1. Start on all fours with shoulders over wrists and hips square. Hands flat, fingers point forward. \n2. Keep palms planted, and rock your hips back toward your heels. Pause. \n3. Rock forward so your upper body travels past your wrists to stretch. \n4. Rock back and forth in a smooth, continuous motion for time. \n5. Repeat with both palms facing the other direction, fingers pointed toward you.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2886,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '0726627a759c3ba1b59a6cc5ee1ca63dc069fe9ff0971b1ef6efaa87e5be4874',
          file_name:
            'videos/0726627a759c3ba1b59a6cc5ee1ca63dc069fe9ff0971b1ef6efaa87e5be4874.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0726627a759c3ba1b59a6cc5ee1ca63dc069fe9ff0971b1ef6efaa87e5be4874.mp4',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Stretch-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 382179,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2887,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '3052138f2b8d706b287c868b394155ef924cda457dca6bafca3e44c521970f29',
          file_name:
            'videos/3052138f2b8d706b287c868b394155ef924cda457dca6bafca3e44c521970f29.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3052138f2b8d706b287c868b394155ef924cda457dca6bafca3e44c521970f29.mp4',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Stretch-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 362059,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3108,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '4dd6c7a4ce3387c925a8489580962323272a01e67961e9ebbc946bb1042a6957',
          file_name:
            'audios/4dd6c7a4ce3387c925a8489580962323272a01e67961e9ebbc946bb1042a6957.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4dd6c7a4ce3387c925a8489580962323272a01e67961e9ebbc946bb1042a6957.mp3',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Stretch-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-QUADRUPED_WRIST_STRETCH-COOL_DOWN': {
      id: 1123,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Quadruped Wrist Stretch',
      short_name: 'Quadruped Wrist Stretch',
      unique_name: 'ADVANCED-QUADRUPED_WRIST_STRETCH-COOL_DOWN',
      description:
        '1. Start on all fours with shoulders over wrists and hips square. Hands flat, fingers point forward. \n2. Keep palms planted, and rock your hips back toward your heels. Pause. \n3. Rock forward so your upper body travels past your wrists to stretch. \n4. Rock back and forth in a smooth, continuous motion for time. \n5. Repeat with both palms facing the other direction, fingers pointed toward you.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2889,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '0726627a759c3ba1b59a6cc5ee1ca63dc069fe9ff0971b1ef6efaa87e5be4874',
          file_name:
            'videos/0726627a759c3ba1b59a6cc5ee1ca63dc069fe9ff0971b1ef6efaa87e5be4874.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0726627a759c3ba1b59a6cc5ee1ca63dc069fe9ff0971b1ef6efaa87e5be4874.mp4',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Stretch-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 382179,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2890,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '3052138f2b8d706b287c868b394155ef924cda457dca6bafca3e44c521970f29',
          file_name:
            'videos/3052138f2b8d706b287c868b394155ef924cda457dca6bafca3e44c521970f29.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3052138f2b8d706b287c868b394155ef924cda457dca6bafca3e44c521970f29.mp4',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Stretch-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 362059,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3109,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '4dd6c7a4ce3387c925a8489580962323272a01e67961e9ebbc946bb1042a6957',
          file_name:
            'audios/4dd6c7a4ce3387c925a8489580962323272a01e67961e9ebbc946bb1042a6957.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4dd6c7a4ce3387c925a8489580962323272a01e67961e9ebbc946bb1042a6957.mp3',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Stretch-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-QUADRUPED_WRIST_CIRCLES-COOL_DOWN': {
      id: 1124,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Quadruped Wrist Circles',
      short_name: 'Quadruped Wrist Circles',
      unique_name: 'BEGINNER-QUADRUPED_WRIST_CIRCLES-COOL_DOWN',
      description:
        '1. Start on all fours with your shoulders over wrists and hips over your knees. Hands flat. \n2. Keeping palms planted and arms straight, rotate your body in a circular motion around your wrists. \n3. Draw circles in a continous motion. \n4. Repeat other direction.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2892,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'dad36dc97bb6167ad60f8314e862ddc14809882b272e2bbc49ac9f6b80f96747',
          file_name:
            'videos/dad36dc97bb6167ad60f8314e862ddc14809882b272e2bbc49ac9f6b80f96747.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dad36dc97bb6167ad60f8314e862ddc14809882b272e2bbc49ac9f6b80f96747.mp4',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Circles-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 449848,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2893,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '37c21aa1e574cc5b991c5da52d5d049558aa884c6def17d7b900d703f89ba0f8',
          file_name:
            'videos/37c21aa1e574cc5b991c5da52d5d049558aa884c6def17d7b900d703f89ba0f8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/37c21aa1e574cc5b991c5da52d5d049558aa884c6def17d7b900d703f89ba0f8.mp4',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Circles-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 480269,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3110,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '3eb50a81d914de88507f370db60ff6b687317d7b9a5cc4bf29d7e30af46b826f',
          file_name:
            'audios/3eb50a81d914de88507f370db60ff6b687317d7b9a5cc4bf29d7e30af46b826f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3eb50a81d914de88507f370db60ff6b687317d7b9a5cc4bf29d7e30af46b826f.mp3',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Circles-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 26541,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-QUADRUPED_WRIST_CIRCLES-COOL_DOWN': {
      id: 1125,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Quadruped Wrist Circles',
      short_name: 'Quadruped Wrist Circles',
      unique_name: 'INTERMEDIATE-QUADRUPED_WRIST_CIRCLES-COOL_DOWN',
      description:
        '1. Start on all fours with your shoulders over wrists and hips over your knees. Hands flat. \n2. Keeping palms planted and arms straight, rotate your body in a circular motion around your wrists. \n3. Draw circles in a continous motion. \n4. Repeat other direction.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2895,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'dad36dc97bb6167ad60f8314e862ddc14809882b272e2bbc49ac9f6b80f96747',
          file_name:
            'videos/dad36dc97bb6167ad60f8314e862ddc14809882b272e2bbc49ac9f6b80f96747.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dad36dc97bb6167ad60f8314e862ddc14809882b272e2bbc49ac9f6b80f96747.mp4',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Circles-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 449848,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2896,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '37c21aa1e574cc5b991c5da52d5d049558aa884c6def17d7b900d703f89ba0f8',
          file_name:
            'videos/37c21aa1e574cc5b991c5da52d5d049558aa884c6def17d7b900d703f89ba0f8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/37c21aa1e574cc5b991c5da52d5d049558aa884c6def17d7b900d703f89ba0f8.mp4',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Circles-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 480269,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3111,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '3eb50a81d914de88507f370db60ff6b687317d7b9a5cc4bf29d7e30af46b826f',
          file_name:
            'audios/3eb50a81d914de88507f370db60ff6b687317d7b9a5cc4bf29d7e30af46b826f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3eb50a81d914de88507f370db60ff6b687317d7b9a5cc4bf29d7e30af46b826f.mp3',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Circles-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 26541,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-QUADRUPED_WRIST_CIRCLES-COOL_DOWN': {
      id: 1126,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Quadruped Wrist Circles',
      short_name: 'Quadruped Wrist Circles',
      unique_name: 'ADVANCED-QUADRUPED_WRIST_CIRCLES-COOL_DOWN',
      description:
        '1. Start on all fours with your shoulders over wrists and hips over your knees. Hands flat. \n2. Keeping palms planted and arms straight, rotate your body in a circular motion around your wrists. \n3. Draw circles in a continous motion. \n4. Repeat other direction.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2898,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'dad36dc97bb6167ad60f8314e862ddc14809882b272e2bbc49ac9f6b80f96747',
          file_name:
            'videos/dad36dc97bb6167ad60f8314e862ddc14809882b272e2bbc49ac9f6b80f96747.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dad36dc97bb6167ad60f8314e862ddc14809882b272e2bbc49ac9f6b80f96747.mp4',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Circles-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 449848,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2899,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '37c21aa1e574cc5b991c5da52d5d049558aa884c6def17d7b900d703f89ba0f8',
          file_name:
            'videos/37c21aa1e574cc5b991c5da52d5d049558aa884c6def17d7b900d703f89ba0f8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/37c21aa1e574cc5b991c5da52d5d049558aa884c6def17d7b900d703f89ba0f8.mp4',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Circles-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 480269,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3112,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '3eb50a81d914de88507f370db60ff6b687317d7b9a5cc4bf29d7e30af46b826f',
          file_name:
            'audios/3eb50a81d914de88507f370db60ff6b687317d7b9a5cc4bf29d7e30af46b826f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3eb50a81d914de88507f370db60ff6b687317d7b9a5cc4bf29d7e30af46b826f.mp3',
          name: 'BEG-INT-ADV-Quadruped_Wrist_Circles-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 26541,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-STRADDLE_STRETCH-COOL_DOWN': {
      id: 1154,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Straddle Stretch',
      short_name: 'Straddle Stretch',
      unique_name: 'BEGINNER-STRADDLE_STRETCH-COOL_DOWN',
      description:
        '1. Sit with legs long in front of you in a wide V shape. Keep spine straight, and core tight.\n2. Maintain posture and straight legs. Hinge at the waist and fold your upper body forward while you reach toward your feet.\n3. Go only as far as you can with a straight back to feel a good stretch in your hamstrings.\n4. Hold and breathe in the depth of your individual flexibility.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2962,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'da0aee16af44461051d9a8d06a655cd7609e6dbdd53f9c327feeac5a07e495f8',
          file_name:
            'videos/da0aee16af44461051d9a8d06a655cd7609e6dbdd53f9c327feeac5a07e495f8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/da0aee16af44461051d9a8d06a655cd7609e6dbdd53f9c327feeac5a07e495f8.mp4',
          name: 'BEG-INT-ADV-Straddle_Stretch-COOL_DOWN',
          description: null,
          size: 177580,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3140,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '0745ab35a434d364b3fc180742998d883f9f91eafc6ad05bfad374d1047a1417',
          file_name:
            'audios/0745ab35a434d364b3fc180742998d883f9f91eafc6ad05bfad374d1047a1417.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0745ab35a434d364b3fc180742998d883f9f91eafc6ad05bfad374d1047a1417.mp3',
          name: 'BEG-INT-ADV-Straddle_Stretch-COOL_DOWN',
          description: null,
          size: 20205,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-STRADDLE_STRETCH-COOL_DOWN': {
      id: 1155,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Straddle Stretch',
      short_name: 'Straddle Stretch',
      unique_name: 'INTERMEDIATE-STRADDLE_STRETCH-COOL_DOWN',
      description:
        '1. Sit with legs long in front of you in a wide V shape. Keep spine straight, and core tight.\n2. Maintain posture and straight legs. Hinge at the waist and fold your upper body forward while you reach toward your feet.\n3. Go only as far as you can with a straight back to feel a good stretch in your hamstrings.\n4. Hold and breathe in the depth of your individual flexibility.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2964,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'da0aee16af44461051d9a8d06a655cd7609e6dbdd53f9c327feeac5a07e495f8',
          file_name:
            'videos/da0aee16af44461051d9a8d06a655cd7609e6dbdd53f9c327feeac5a07e495f8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/da0aee16af44461051d9a8d06a655cd7609e6dbdd53f9c327feeac5a07e495f8.mp4',
          name: 'BEG-INT-ADV-Straddle_Stretch-COOL_DOWN',
          description: null,
          size: 177580,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3141,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '0745ab35a434d364b3fc180742998d883f9f91eafc6ad05bfad374d1047a1417',
          file_name:
            'audios/0745ab35a434d364b3fc180742998d883f9f91eafc6ad05bfad374d1047a1417.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0745ab35a434d364b3fc180742998d883f9f91eafc6ad05bfad374d1047a1417.mp3',
          name: 'BEG-INT-ADV-Straddle_Stretch-COOL_DOWN',
          description: null,
          size: 20205,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-STRADDLE_STRETCH-COOL_DOWN': {
      id: 1156,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Straddle Stretch',
      short_name: 'Straddle Stretch',
      unique_name: 'ADVANCED-STRADDLE_STRETCH-COOL_DOWN',
      description:
        '1. Sit with legs long in front of you in a wide V shape. Keep spine straight, and core tight.\n2. Maintain posture and straight legs. Hinge at the waist and fold your upper body forward while you reach toward your feet.\n3. Go only as far as you can with a straight back to feel a good stretch in your hamstrings.\n4. Hold and breathe in the depth of your individual flexibility.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2966,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'da0aee16af44461051d9a8d06a655cd7609e6dbdd53f9c327feeac5a07e495f8',
          file_name:
            'videos/da0aee16af44461051d9a8d06a655cd7609e6dbdd53f9c327feeac5a07e495f8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/da0aee16af44461051d9a8d06a655cd7609e6dbdd53f9c327feeac5a07e495f8.mp4',
          name: 'BEG-INT-ADV-Straddle_Stretch-COOL_DOWN',
          description: null,
          size: 177580,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3142,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '0745ab35a434d364b3fc180742998d883f9f91eafc6ad05bfad374d1047a1417',
          file_name:
            'audios/0745ab35a434d364b3fc180742998d883f9f91eafc6ad05bfad374d1047a1417.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0745ab35a434d364b3fc180742998d883f9f91eafc6ad05bfad374d1047a1417.mp3',
          name: 'BEG-INT-ADV-Straddle_Stretch-COOL_DOWN',
          description: null,
          size: 20205,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-STANDING_FIGURE4-COOL_DOWN': {
      id: 1157,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Standing Figure 4',
      short_name: 'Standing Figure 4',
      unique_name: 'BEGINNER-STANDING_FIGURE4-COOL_DOWN',
      description:
        '1. Stand with your feet shoulder-width apart. \n2. Transfer all weight to one leg and lift the opposite foot. Bend your knee and cross your ankle over the other knee in a 4 shape. \n3. Keeping chest up and spine straight, bend the knee of your standing leg and sink your hips to about 90 degrees. Keep foot flexed and core engaged. Hands at heart or where comfortable.\n4. Hold and breathe for time. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2968,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '4006d9f2143a5dab3a4ec9429d7441326e1d74c0fdb1a39b51da555ca2bbb500',
          file_name:
            'videos/4006d9f2143a5dab3a4ec9429d7441326e1d74c0fdb1a39b51da555ca2bbb500.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4006d9f2143a5dab3a4ec9429d7441326e1d74c0fdb1a39b51da555ca2bbb500.mp4',
          name: 'BEG-INT-ADV-Standing_Figure_4-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 298806,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2969,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '2dc057cb4ddcdf4af33402cf6973743413c0ef1bdea3a7be742378fed2637ca8',
          file_name:
            'videos/2dc057cb4ddcdf4af33402cf6973743413c0ef1bdea3a7be742378fed2637ca8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2dc057cb4ddcdf4af33402cf6973743413c0ef1bdea3a7be742378fed2637ca8.mp4',
          name: 'BEG-INT-ADV-Standing_Figure_4-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 306722,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3143,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'fcab1cc696143664efa24e06c6d7cb390d2f20f11a1bdf554afb49c777035267',
          file_name:
            'audios/fcab1cc696143664efa24e06c6d7cb390d2f20f11a1bdf554afb49c777035267.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fcab1cc696143664efa24e06c6d7cb390d2f20f11a1bdf554afb49c777035267.mp3',
          name: 'BEG-INT-ADV-Standing_Figure_4-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 27981,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-STANDING_FIGURE4-COOL_DOWN': {
      id: 1158,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Standing Figure 4',
      short_name: 'Standing Figure 4',
      unique_name: 'INTERMEDIATE-STANDING_FIGURE4-COOL_DOWN',
      description:
        '1. Stand with your feet shoulder-width apart. \n2. Transfer all weight to one leg and lift the opposite foot. Bend your knee and cross your ankle over the other knee in a 4 shape. \n3. Keeping chest up and spine straight, bend the knee of your standing leg and sink your hips to about 90 degrees. Keep foot flexed and core engaged. Hands at heart or where comfortable.\n4. Hold and breathe for time. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2971,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '4006d9f2143a5dab3a4ec9429d7441326e1d74c0fdb1a39b51da555ca2bbb500',
          file_name:
            'videos/4006d9f2143a5dab3a4ec9429d7441326e1d74c0fdb1a39b51da555ca2bbb500.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4006d9f2143a5dab3a4ec9429d7441326e1d74c0fdb1a39b51da555ca2bbb500.mp4',
          name: 'BEG-INT-ADV-Standing_Figure_4-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 298806,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2972,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '2dc057cb4ddcdf4af33402cf6973743413c0ef1bdea3a7be742378fed2637ca8',
          file_name:
            'videos/2dc057cb4ddcdf4af33402cf6973743413c0ef1bdea3a7be742378fed2637ca8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2dc057cb4ddcdf4af33402cf6973743413c0ef1bdea3a7be742378fed2637ca8.mp4',
          name: 'BEG-INT-ADV-Standing_Figure_4-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 306722,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3144,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'fcab1cc696143664efa24e06c6d7cb390d2f20f11a1bdf554afb49c777035267',
          file_name:
            'audios/fcab1cc696143664efa24e06c6d7cb390d2f20f11a1bdf554afb49c777035267.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fcab1cc696143664efa24e06c6d7cb390d2f20f11a1bdf554afb49c777035267.mp3',
          name: 'BEG-INT-ADV-Standing_Figure_4-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 27981,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-STANDING_FIGURE4-COOL_DOWN': {
      id: 1159,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Standing Figure 4',
      short_name: 'Standing Figure 4',
      unique_name: 'ADVANCED-STANDING_FIGURE4-COOL_DOWN',
      description:
        '1. Stand with your feet shoulder-width apart. \n2. Transfer all weight to one leg and lift the opposite foot. Bend your knee and cross your ankle over the other knee in a 4 shape. \n3. Keeping chest up and spine straight, bend the knee of your standing leg and sink your hips to about 90 degrees. Keep foot flexed and core engaged. Hands at heart or where comfortable.\n4. Hold and breathe for time. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2974,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '4006d9f2143a5dab3a4ec9429d7441326e1d74c0fdb1a39b51da555ca2bbb500',
          file_name:
            'videos/4006d9f2143a5dab3a4ec9429d7441326e1d74c0fdb1a39b51da555ca2bbb500.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4006d9f2143a5dab3a4ec9429d7441326e1d74c0fdb1a39b51da555ca2bbb500.mp4',
          name: 'BEG-INT-ADV-Standing_Figure_4-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 298806,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2975,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '2dc057cb4ddcdf4af33402cf6973743413c0ef1bdea3a7be742378fed2637ca8',
          file_name:
            'videos/2dc057cb4ddcdf4af33402cf6973743413c0ef1bdea3a7be742378fed2637ca8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2dc057cb4ddcdf4af33402cf6973743413c0ef1bdea3a7be742378fed2637ca8.mp4',
          name: 'BEG-INT-ADV-Standing_Figure_4-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 306722,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3145,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'fcab1cc696143664efa24e06c6d7cb390d2f20f11a1bdf554afb49c777035267',
          file_name:
            'audios/fcab1cc696143664efa24e06c6d7cb390d2f20f11a1bdf554afb49c777035267.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fcab1cc696143664efa24e06c6d7cb390d2f20f11a1bdf554afb49c777035267.mp3',
          name: 'BEG-INT-ADV-Standing_Figure_4-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 27981,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-OVERHEAD_TRICEP_STRETCH-COOL_DOWN': {
      id: 1164,
      segment_type: 'COOL_DOWN',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Overhead Tricep Stretch',
      short_name: 'Overhead Tricep Stretch',
      unique_name: 'BEGINNER-OVERHEAD_TRICEP_STRETCH-COOL_DOWN',
      description:
        '1. Stand with your feet shoulder-width apart with your spine tall and neck neutral. Raise one arm directly overhead. \n2. Bend your elbow and rest your hand down between your shoulderblades, palm facing in. Keep your chin off your chest. \n3. Using your other hand, apply gentle pressure to your elbow to deepen the stretch. \n4. Hold for time. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2988,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'd3363914db8315ecec720db35ba792d04b8e06a62f2c3abf44efc47a3a5d794e',
          file_name:
            'videos/d3363914db8315ecec720db35ba792d04b8e06a62f2c3abf44efc47a3a5d794e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d3363914db8315ecec720db35ba792d04b8e06a62f2c3abf44efc47a3a5d794e.mp4',
          name: 'BEG-INT-ADV-Overhead_Tricep_Stretch-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 261479,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2989,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'f75d741cbeca18f2160a7ffd39e5f44473ee25c3d135c6568bce76d16f996885',
          file_name:
            'videos/f75d741cbeca18f2160a7ffd39e5f44473ee25c3d135c6568bce76d16f996885.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f75d741cbeca18f2160a7ffd39e5f44473ee25c3d135c6568bce76d16f996885.mp4',
          name: 'BEG-INT-ADV-Overhead_Tricep_Stretch-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 260111,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3150,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '40eff6dd61e5581e7a4df8d5d9ba666d7aa8c09b9bb2419e4dbb216b5182f048',
          file_name:
            'audios/40eff6dd61e5581e7a4df8d5d9ba666d7aa8c09b9bb2419e4dbb216b5182f048.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/40eff6dd61e5581e7a4df8d5d9ba666d7aa8c09b9bb2419e4dbb216b5182f048.mp3',
          name: 'BEG-INT-ADV-Overhead_Tricep_Stretch-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-OVERHEAD_TRICEP_STRETCH-COOL_DOWN': {
      id: 1165,
      segment_type: 'COOL_DOWN',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Overhead Tricep Stretch',
      short_name: 'Overhead Tricep Stretch',
      unique_name: 'INTERMEDIATE-OVERHEAD_TRICEP_STRETCH-COOL_DOWN',
      description:
        '1. Stand with your feet shoulder-width apart with your spine tall and neck neutral. Raise one arm directly overhead. \n2. Bend your elbow and rest your hand down between your shoulderblades, palm facing in. Keep your chin off your chest. \n3. Using your other hand, apply gentle pressure to your elbow to deepen the stretch. \n4. Hold for time. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2991,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'd3363914db8315ecec720db35ba792d04b8e06a62f2c3abf44efc47a3a5d794e',
          file_name:
            'videos/d3363914db8315ecec720db35ba792d04b8e06a62f2c3abf44efc47a3a5d794e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d3363914db8315ecec720db35ba792d04b8e06a62f2c3abf44efc47a3a5d794e.mp4',
          name: 'BEG-INT-ADV-Overhead_Tricep_Stretch-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 261479,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2992,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'f75d741cbeca18f2160a7ffd39e5f44473ee25c3d135c6568bce76d16f996885',
          file_name:
            'videos/f75d741cbeca18f2160a7ffd39e5f44473ee25c3d135c6568bce76d16f996885.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f75d741cbeca18f2160a7ffd39e5f44473ee25c3d135c6568bce76d16f996885.mp4',
          name: 'BEG-INT-ADV-Overhead_Tricep_Stretch-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 260111,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3151,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '40eff6dd61e5581e7a4df8d5d9ba666d7aa8c09b9bb2419e4dbb216b5182f048',
          file_name:
            'audios/40eff6dd61e5581e7a4df8d5d9ba666d7aa8c09b9bb2419e4dbb216b5182f048.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/40eff6dd61e5581e7a4df8d5d9ba666d7aa8c09b9bb2419e4dbb216b5182f048.mp3',
          name: 'BEG-INT-ADV-Overhead_Tricep_Stretch-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-OVERHEAD_TRICEP_STRETCH-COOL_DOWN': {
      id: 1166,
      segment_type: 'COOL_DOWN',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Overhead Tricep Stretch',
      short_name: 'Overhead Tricep Stretch',
      unique_name: 'ADVANCED-OVERHEAD_TRICEP_STRETCH-COOL_DOWN',
      description:
        '1. Stand with your feet shoulder-width apart with your spine tall and neck neutral. Raise one arm directly overhead. \n2. Bend your elbow and rest your hand down between your shoulderblades, palm facing in. Keep your chin off your chest. \n3. Using your other hand, apply gentle pressure to your elbow to deepen the stretch. \n4. Hold for time. Repeat other side.',
      preview_time: null,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2994,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'd3363914db8315ecec720db35ba792d04b8e06a62f2c3abf44efc47a3a5d794e',
          file_name:
            'videos/d3363914db8315ecec720db35ba792d04b8e06a62f2c3abf44efc47a3a5d794e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d3363914db8315ecec720db35ba792d04b8e06a62f2c3abf44efc47a3a5d794e.mp4',
          name: 'BEG-INT-ADV-Overhead_Tricep_Stretch-COOL_DOWN-RIGHT',
          description: 'Right Side',
          size: 261479,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2995,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'f75d741cbeca18f2160a7ffd39e5f44473ee25c3d135c6568bce76d16f996885',
          file_name:
            'videos/f75d741cbeca18f2160a7ffd39e5f44473ee25c3d135c6568bce76d16f996885.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f75d741cbeca18f2160a7ffd39e5f44473ee25c3d135c6568bce76d16f996885.mp4',
          name: 'BEG-INT-ADV-Overhead_Tricep_Stretch-COOL_DOWN-LEFT',
          description: 'Left Side',
          size: 260111,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3152,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '40eff6dd61e5581e7a4df8d5d9ba666d7aa8c09b9bb2419e4dbb216b5182f048',
          file_name:
            'audios/40eff6dd61e5581e7a4df8d5d9ba666d7aa8c09b9bb2419e4dbb216b5182f048.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/40eff6dd61e5581e7a4df8d5d9ba666d7aa8c09b9bb2419e4dbb216b5182f048.mp3',
          name: 'BEG-INT-ADV-Overhead_Tricep_Stretch-COOL_DOWN-(RIGHT/LEFT)',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Knee Push-Ups': {
      id: 20,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Knee Push-Ups',
      short_name: 'Knee Push-Ups',
      unique_name: 'BEGINNER-Knee Push-Ups',
      description:
        '1. Start in Plank position, shoulders over wrists. Drop your knees straight down to the floor and lift your feet up. \n2. Bend your elbows, pointing them back towards your hips. Lower your body towards the floor. \n3. Straighten your arms and raise your body back up in one long line from the crown of your head to your tailbone.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 50,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'eaf23e00307a958ab78bec3a8b6077b06de1e1f52c1f46ee4e3ff4cbe65c7b88',
          file_name:
            'videos/eaf23e00307a958ab78bec3a8b6077b06de1e1f52c1f46ee4e3ff4cbe65c7b88.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eaf23e00307a958ab78bec3a8b6077b06de1e1f52c1f46ee4e3ff4cbe65c7b88.mp4',
          name: 'EVE_PUSHUPS_KNEES_2_REV_SMALL_720.mp4',
          description: null,
          size: 99841,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 51,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '203932a197d0992f4e1525dba93d7030b995354dce728b1975ddc2e316e1c5cc',
          file_name:
            'audios/203932a197d0992f4e1525dba93d7030b995354dce728b1975ddc2e316e1c5cc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/203932a197d0992f4e1525dba93d7030b995354dce728b1975ddc2e316e1c5cc.mp3',
          name: 'Knee_Push_Ups.mp3',
          description: null,
          size: 21054,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Up/Down Dog': {
      id: 21,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Up/Down Dog',
      short_name: 'Up/Down Dog',
      unique_name: 'BEGINNER-Up/Down Dog',
      description:
        '1. Start in Down Dog position. Your hands are on the ground with your head between your upper arms and your hips are up and back making an inverted "V"\n2. Lower your hips towards the floor while raising your head and chest. Keep your arms straight and look slightly upward.\n3. Move back and forth between these two positions with control and core engaged.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 54,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'c758d89663edfac3c5995d11a3d3f33e7cf42cac8bade6a8ca3977419fcbdcb5',
          file_name:
            'videos/c758d89663edfac3c5995d11a3d3f33e7cf42cac8bade6a8ca3977419fcbdcb5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c758d89663edfac3c5995d11a3d3f33e7cf42cac8bade6a8ca3977419fcbdcb5.mp4',
          name: 'LOGAN_UP_DOWN_DOG_J_3_LOOP_SAMLL_720.mp4',
          description: null,
          size: 156240,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 55,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '12a115b4ae7f33221aee31841925fbd334db184d13bf0980c822bc050e99ec5e',
          file_name:
            'audios/12a115b4ae7f33221aee31841925fbd334db184d13bf0980c822bc050e99ec5e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/12a115b4ae7f33221aee31841925fbd334db184d13bf0980c822bc050e99ec5e.mp3',
          name: 'BEGINNER-Up_Down_Dog-EXERCISE.mp3',
          description: null,
          size: 35664,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Bicep Curls': {
      id: 22,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bodyweight Bicep Curls',
      short_name: 'Bodyweight Bicep Curls',
      unique_name: 'BEGINNER-Bodyweight Bicep Curls',
      description:
        '1. Start standing with your hands by your sides and palms facing each other.\n2. Keep your elbows close to your ribcage and curl your arms up towards your shoulders as you rotate your wrists so your palms face your body at the top.\n3. Lower your arms back down to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 56,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '08dd7bc58cc939fa5a5572cd19397f2fd28899c35d9da9c1b15ff445da36ce8a',
          file_name:
            'videos/08dd7bc58cc939fa5a5572cd19397f2fd28899c35d9da9c1b15ff445da36ce8a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/08dd7bc58cc939fa5a5572cd19397f2fd28899c35d9da9c1b15ff445da36ce8a.mp4',
          name: 'EVE_BICEP_CURLS_ALT_2_REV_SMALL_720.mp4',
          description: null,
          size: 52436,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 57,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '46b003c6e77c0c86d927a4f30154f2875b8c1ed39b710a25e9d966d59892a1cd',
          file_name:
            'audios/46b003c6e77c0c86d927a4f30154f2875b8c1ed39b710a25e9d966d59892a1cd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/46b003c6e77c0c86d927a4f30154f2875b8c1ed39b710a25e9d966d59892a1cd.mp3',
          name: 'Bodyweight_Bicep_Curls.mp3',
          description: null,
          size: 29695,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Hindu Push-Ups': {
      id: 23,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Hindu Push-Ups',
      short_name: 'Hindu Push-Ups',
      unique_name: 'BEGINNER-Hindu Push-Ups',
      description:
        '1. Start in Down Dog Position. \n2. Bend your elbows and lower your upper body towards the floor leading with the crown of your head. Swoop your forehead, chin and chest through your arms and come to Up Dog position with your arms straight and hips low. \n3. Draw your hips up and back, keeping your arms straight and return to Down Dog position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: true,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 58,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'ab09dce84244bc653abf3279657236e081f0fcf6c1472f034f30ff29626a9972',
          file_name:
            'videos/ab09dce84244bc653abf3279657236e081f0fcf6c1472f034f30ff29626a9972.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ab09dce84244bc653abf3279657236e081f0fcf6c1472f034f30ff29626a9972.mp4',
          name: 'CARRIE_DIVEBOMBERS_2_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 184432,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 59,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '5fda0b4e3fb7e0ec6e2acecceabc5f05b206f8e0d00a6aac3af4cc42dfc0f68c',
          file_name:
            'audios/5fda0b4e3fb7e0ec6e2acecceabc5f05b206f8e0d00a6aac3af4cc42dfc0f68c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5fda0b4e3fb7e0ec6e2acecceabc5f05b206f8e0d00a6aac3af4cc42dfc0f68c.mp3',
          name: 'Hindu_Pushups.mp3',
          description: null,
          size: 21631,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Lateral Raises': {
      id: 24,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bodyweight Lateral Raises',
      short_name: 'Bodyweight Lateral Raises',
      unique_name: 'BEGINNER-Bodyweight Lateral Raises',
      description:
        '1. Stand up tall with your arms by your sides, palms facing your body.\n2. Raise both arms directly out to your sides to shoulder height.  Your arms are straight and palms face down.\n3. Lower your arms back down to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 60,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '7673e1353564d494ad56becca6298a5e61831c64a82e3570edee47e3eb379c92',
          file_name:
            'videos/7673e1353564d494ad56becca6298a5e61831c64a82e3570edee47e3eb379c92.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7673e1353564d494ad56becca6298a5e61831c64a82e3570edee47e3eb379c92.mp4',
          name: 'CARRIE_LATERAL_RAISES_1_FULL_REP_REV_720.mp4',
          description: null,
          size: 70208,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 61,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '2fe6624f63f7f4492c0d4bc1d083ffd09ac5eae0f79d0051d1d098a93eae8578',
          file_name:
            'audios/2fe6624f63f7f4492c0d4bc1d083ffd09ac5eae0f79d0051d1d098a93eae8578.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2fe6624f63f7f4492c0d4bc1d083ffd09ac5eae0f79d0051d1d098a93eae8578.mp3',
          name: 'Bodyweight_Lateral_Raises.mp3',
          description: null,
          size: 30271,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Renegade Rows': {
      id: 25,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bodyweight Renegade Rows',
      short_name: 'Bodyweight Renegade Rows',
      unique_name: 'BEGINNER-Bodyweight Renegade Rows',
      description:
        '1. Start in Plank position.\n2. Transfer your weight into one arm. Bend and raise the opposite elbow straight up as you bring your fist to your ribcage.\n3. Lower your arm back to the floor and return to Plank position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 80,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '8c41424daf5c1f8be6de415e97671e0329c72e817a6d5fe440d7287e32772a7a',
          file_name:
            'videos/8c41424daf5c1f8be6de415e97671e0329c72e817a6d5fe440d7287e32772a7a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8c41424daf5c1f8be6de415e97671e0329c72e817a6d5fe440d7287e32772a7a.mp4',
          name: 'LOGAN_RENEGADE_ROW_W_LOOP_SAMLL_720.mp4',
          description: null,
          size: 123638,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 81,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '7c1468b4b8ada011e1d15d8849882f255da79971651a7d22b91b3cb2ef16da25',
          file_name:
            'audios/7c1468b4b8ada011e1d15d8849882f255da79971651a7d22b91b3cb2ef16da25.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7c1468b4b8ada011e1d15d8849882f255da79971651a7d22b91b3cb2ef16da25.mp3',
          name: 'Bodyweight_Renegade_Rows.mp3',
          description: null,
          size: 30559,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Squat': {
      id: 26,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Squat',
      short_name: 'Bodyweight Squat',
      unique_name: 'BEGINNER-Bodyweight Squat',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 62,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'aba0b422bcd148bdabc217308896b7f8ebede4a1c1d289fef37541a5243182bc',
          file_name:
            'videos/aba0b422bcd148bdabc217308896b7f8ebede4a1c1d289fef37541a5243182bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/aba0b422bcd148bdabc217308896b7f8ebede4a1c1d289fef37541a5243182bc.mp4',
          name: 'EVE_BODYWEIGHT_SQUAT_ALT_2_REV_SMALL_720.mp4',
          description: null,
          size: 104705,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 63,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'eed3d3718445539e84daefbb024cfcb6ac87f9c734a7bd4b509ca549703ace8e',
          file_name:
            'audios/eed3d3718445539e84daefbb024cfcb6ac87f9c734a7bd4b509ca549703ace8e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eed3d3718445539e84daefbb024cfcb6ac87f9c734a7bd4b509ca549703ace8e.mp3',
          name: 'BEGINNER-Bodyweight_Squat-EXERCISE.mp3',
          description: null,
          size: 31502,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Thrusters': {
      id: 27,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Thrusters',
      short_name: 'Bodyweight Thrusters',
      unique_name: 'BEGINNER-Bodyweight Thrusters',
      description:
        '1. Stand with your feet about shoulder-width apart. Bring your fists to your shoulders, elbows down.\n2. Squat down and try to get your elbows close to your knees, keeping your chest up and shoulders back.\n3. Drive through your heels and explode up to a standing position raising your fists overhead.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 64,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'c823c36ae4dd6f7ca9353fc3defa09deeb3713f2fff4a2157985bbf3e9e1db6b',
          file_name:
            'videos/c823c36ae4dd6f7ca9353fc3defa09deeb3713f2fff4a2157985bbf3e9e1db6b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c823c36ae4dd6f7ca9353fc3defa09deeb3713f2fff4a2157985bbf3e9e1db6b.mp4',
          name: 'EVE_05_THRUSTERS_VAN_REV_SMALL_720.mp4',
          description: null,
          size: 92214,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 65,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '0fac540d1ab4bae86305ae9347bde02f8edca74389d753ac2232ba0751be0510',
          file_name:
            'audios/0fac540d1ab4bae86305ae9347bde02f8edca74389d753ac2232ba0751be0510.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0fac540d1ab4bae86305ae9347bde02f8edca74389d753ac2232ba0751be0510.mp3',
          name: 'Bodyweight_Thrusters.mp3',
          description: null,
          size: 24798,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating Curtsy Lunges': {
      id: 28,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Curtsy Lunges',
      short_name: 'Alternating Curtsy Lunges',
      unique_name: 'BEGINNER-Alternating Curtsy Lunges',
      description:
        '1. Start standing with your feet about shoulder-width apart, arms by your sides.\n2. Take a big step back and behind you at an angle, bend both knees and drop into a lunge.\n3. Keeping your hips square, drive through your front heel and return to standing.\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 66,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '313764175c64917c2e60046127b356b831ed378e7ce98081299de9b0c07adfc7',
          file_name:
            'videos/313764175c64917c2e60046127b356b831ed378e7ce98081299de9b0c07adfc7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/313764175c64917c2e60046127b356b831ed378e7ce98081299de9b0c07adfc7.mp4',
          name: 'LOGAN_ALTERNATING_CURTSY_Q_2_LOOP_SAMLL_720.mp4',
          description: null,
          size: 254923,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 67,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '90b9f629db806c840d171c37a0d883342a7ae3b025758b28744a6242a86cf2ea',
          file_name:
            'audios/90b9f629db806c840d171c37a0d883342a7ae3b025758b28744a6242a86cf2ea.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/90b9f629db806c840d171c37a0d883342a7ae3b025758b28744a6242a86cf2ea.mp3',
          name: 'Alternating_Curtsy_Lunges.mp3',
          description: null,
          size: 31071,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Sumo Squats with Row': {
      id: 29,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Sumo Squats with Row',
      short_name: 'Bodyweight Sumo Squats with Row',
      unique_name: 'BEGINNER-Bodyweight Sumo Squats with Row',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointed out and arms down in front of your body, palms facing inward.\n2. Lower into a wide squat bringing your hands towards the floor.\n3. Drive through your heels and explode up to stand as you raise your fists towards your chin and your elbows upward to a "V".\n4. Squat back down as you bring your fists towards the floor.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 68,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '55d2cf6724a95907f040cf28bc6971612fb9fe096e909a0186bb0b0b299b5fe8',
          file_name:
            'videos/55d2cf6724a95907f040cf28bc6971612fb9fe096e909a0186bb0b0b299b5fe8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/55d2cf6724a95907f040cf28bc6971612fb9fe096e909a0186bb0b0b299b5fe8.mp4',
          name: 'LOGAN_SUMO_SQUAT_AE_REV_SAMLL_720.mp4',
          description: null,
          size: 105035,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 69,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'c7a218665eb2e8a082c4a5ff79e0006125879e2ced8d4747b3d05a94b068c634',
          file_name:
            'audios/c7a218665eb2e8a082c4a5ff79e0006125879e2ced8d4747b3d05a94b068c634.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c7a218665eb2e8a082c4a5ff79e0006125879e2ced8d4747b3d05a94b068c634.mp3',
          name: 'Bodyweight_Sumo_Squats_with_Row.mp3',
          description: null,
          size: 36032,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Goblet Squats': {
      id: 30,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Goblet Squats',
      short_name: 'Bodyweight Goblet Squats',
      unique_name: 'BEGINNER-Bodyweight Goblet Squats',
      description:
        '1. Stand with your feet slightly wider than shoulder-width apart and hold your fists together at your chest.\n2. Keeping your chest up and shoulders back, squat as low as possible trying to touch the outside of your elbows to the inside of your knees.\n3. Drive through your heels and return to standing.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 70,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'd0b2178ed233bd3b76482bf766273876146ccdfbeea8da55f9b464b24b4575df',
          file_name:
            'videos/d0b2178ed233bd3b76482bf766273876146ccdfbeea8da55f9b464b24b4575df.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d0b2178ed233bd3b76482bf766273876146ccdfbeea8da55f9b464b24b4575df.mp4',
          name: 'CARRIE_GOBLET_SQUAT_1_FULL_REP_REV_720.mp4',
          description: null,
          size: 81870,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 71,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'cbfb0b12f8a0ee817e44f20fea83fc667184382209de31fcad24c7ae15b8cb24',
          file_name:
            'audios/cbfb0b12f8a0ee817e44f20fea83fc667184382209de31fcad24c7ae15b8cb24.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cbfb0b12f8a0ee817e44f20fea83fc667184382209de31fcad24c7ae15b8cb24.mp3',
          name: 'Bodyweight_Goblet_Squats.mp3',
          description: null,
          size: 28543,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating Reverse Lunges': {
      id: 31,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Reverse Lunges',
      short_name: 'Alt. Reverse Lunges',
      unique_name: 'BEGINNER-Alternating Reverse Lunges',
      description:
        '1. Start standing with your feet about shoulder-width apart, hands on hips.\n2. Take a big step backward with one leg, landing with your heel elevated and hips square. Drop down into a lunge by bending both knees 90 degrees.\n3. Drive through the front foot and return the back leg to starting position. \n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 72,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '62c455c391162e7d5e3c1d73ffb31e8493335229e6852731f97d08b7e3eaa9c6',
          file_name:
            'videos/62c455c391162e7d5e3c1d73ffb31e8493335229e6852731f97d08b7e3eaa9c6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/62c455c391162e7d5e3c1d73ffb31e8493335229e6852731f97d08b7e3eaa9c6.mp4',
          name: 'CARRIE_ALTERNATING_LUNGES_1b_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 194405,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 73,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '4f348712c21056ce8e644177eee15c8f834a92334a7d088577cac422b549ffca',
          file_name:
            'audios/4f348712c21056ce8e644177eee15c8f834a92334a7d088577cac422b549ffca.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4f348712c21056ce8e644177eee15c8f834a92334a7d088577cac422b549ffca.mp3',
          name: 'Alternating_Reverse_Lunges.mp3',
          description: null,
          size: 30208,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating Supermans': {
      id: 32,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Alternating Supermans',
      short_name: 'Alternating Supermans',
      unique_name: 'BEGINNER-Alternating Supermans',
      description:
        '1. Lie flat on your stomach, legs long and arms extended overhead.\n2. Lift your opposite arm and leg simultaneously off the ground. Keep your neck in line with your spine and gaze towards the floor.\n3. Pause for a beat at the top.\n4. Return to starting position and repeat on the other side.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 52,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'a72199a1c1f90106553b24e7011bc99a15653b885879f8b803b185cce49f1779',
          file_name:
            'videos/a72199a1c1f90106553b24e7011bc99a15653b885879f8b803b185cce49f1779.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a72199a1c1f90106553b24e7011bc99a15653b885879f8b803b185cce49f1779.mp4',
          name: 'EVE_SUPERMANS_ONE_LEG_2_LOOP_SMALL_720.mp4',
          description: null,
          size: 235459,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 53,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e1b924c5f105ef8e82913aa777e5aea83127367b3b9cb8f859087db1c2763426',
          file_name:
            'audios/e1b924c5f105ef8e82913aa777e5aea83127367b3b9cb8f859087db1c2763426.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e1b924c5f105ef8e82913aa777e5aea83127367b3b9cb8f859087db1c2763426.mp3',
          name: 'Alternating_Supermans.mp3',
          description: null,
          size: 25950,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Reverse Crunches with Bent Knees': {
      id: 33,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Reverse Crunches with Bent Knees',
      short_name: 'Rev. Crunches w. Bent Knees',
      unique_name: 'BEGINNER-Reverse Crunches with Bent Knees',
      description:
        '1. Lie on your back. Place your arms by your sides, palms facing down and your knees bent to 90 degrees over your hips.\n2. Lift your hips off the floor and draw your knees towards your chest.\n3. Lower your hips back down, then drop both legs towards the floor until your toes slightly touch. Keep your lower back connected to the floor.\n4. Raise both legs back up to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 74,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '9fe999ee114a453fa8b5b51aef8ae4b97274892fd0af5174a45908db82e31222',
          file_name:
            'videos/9fe999ee114a453fa8b5b51aef8ae4b97274892fd0af5174a45908db82e31222.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9fe999ee114a453fa8b5b51aef8ae4b97274892fd0af5174a45908db82e31222.mp4',
          name: 'EVE_REVERSE_CRUNCHES_1_REV_SMALL_720.mp4',
          description: null,
          size: 126768,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 75,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '50b9556b275b82d45eca852278821fa52700b30f7f94cd54ac3411856f8e24e1',
          file_name:
            'audios/50b9556b275b82d45eca852278821fa52700b30f7f94cd54ac3411856f8e24e1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/50b9556b275b82d45eca852278821fa52700b30f7f94cd54ac3411856f8e24e1.mp3',
          name: 'Reverse_Crunches_with_Bent_Knees.mp3',
          description: null,
          size: 33727,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bird Dog': {
      id: 34,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Bird Dog',
      short_name: 'Bird Dog',
      unique_name: 'BEGINNER-Bird Dog',
      description:
        '1. Start on all fours with your shoulders over wrists and hips over your knees.\n2. Reach one arm straight in front of you while raising the opposite leg straight back.\n3. Engage your core and pause for a beat.\n4. Return to starting position and repeat on the other side.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 76,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'ee31557a093bc879b81ec45d6951238356a515ef863ce8185b2507a36d65ed3e',
          file_name:
            'videos/ee31557a093bc879b81ec45d6951238356a515ef863ce8185b2507a36d65ed3e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ee31557a093bc879b81ec45d6951238356a515ef863ce8185b2507a36d65ed3e.mp4',
          name: 'EVE_PLANK_FROM_KNEES_ALT_3_LOOP_SMALL_720.mp4',
          description: null,
          size: 240516,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 77,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '97070f30bfd512273de3ccb7eac14e4cb2db6b84298c2e5e6c77a437f831cb18',
          file_name:
            'audios/97070f30bfd512273de3ccb7eac14e4cb2db6b84298c2e5e6c77a437f831cb18.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/97070f30bfd512273de3ccb7eac14e4cb2db6b84298c2e5e6c77a437f831cb18.mp3',
          name: 'Bird_Dogs.mp3',
          description: null,
          size: 20190,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Modified Crab Toe Touches with Dip': {
      id: 35,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Modified Crab Toe Touches with Dip',
      short_name: 'Modified Crab Toe Touches + Dip',
      unique_name: 'BEGINNER-Modified Crab Toe Touches with Dip',
      description:
        '1. Start in a Crab Walk position with your knees bent, feet and hands on the floor, hips up. \r\n2. Bend your elbows straight back and perform a tricep dip bringing your hips closer to the floor. \r\n3. Extend your elbows and raise your hips back up while extending one leg straight out. \r\n4. Return to Crab Walk position. \r\n5. Repeat with the other leg. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 78,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '968b86175c432e5b1ccc5331be3cc5eed5852492022d73e85e0e6601f669e029',
          file_name:
            'videos/968b86175c432e5b1ccc5331be3cc5eed5852492022d73e85e0e6601f669e029.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/968b86175c432e5b1ccc5331be3cc5eed5852492022d73e85e0e6601f669e029.mp4',
          name: 'LOGAN_CRAB_TOE_TOUCHES_NO_TOUCH_N_LOOP_SMALL_720.mp4',
          description: null,
          size: 140808,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 79,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '8a58755efdcbe283d9c0622fc752c051924929d7067073e3493592e4b155c333',
          file_name:
            'audios/8a58755efdcbe283d9c0622fc752c051924929d7067073e3493592e4b155c333.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8a58755efdcbe283d9c0622fc752c051924929d7067073e3493592e4b155c333.mp3',
          name: 'Modified_Crab_Toe_Touches_with_Dip.mp3',
          description: null,
          size: 38336,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Deadbugs': {
      id: 36,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Deadbugs',
      short_name: 'Deadbugs',
      unique_name: 'BEGINNER-Deadbugs',
      description:
        '1. Lie on your back and raise both arms up to the ceiling. Bend both knees and lift them off the floor until your knees are directly above your hips.\n2. Keeping your lower back connected to the floor, lower one arm back towards the floor and extend the opposite leg straight out to a hover.\n3. Return your arm and leg back to starting position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 82,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '1fb81f0bc470206b9bd3e3c4b32372d39e5c54a3d2ce3c17583541aeb7e6bb5e',
          file_name:
            'videos/1fb81f0bc470206b9bd3e3c4b32372d39e5c54a3d2ce3c17583541aeb7e6bb5e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1fb81f0bc470206b9bd3e3c4b32372d39e5c54a3d2ce3c17583541aeb7e6bb5e.mp4',
          name: 'CARRIE_BICYCLE_CRUNCHES_DEADBUG_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 186475,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 83,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'a098b8727714c3f86bab0814078eee76ba01b1b4c3c8bd77e383d35dc8dfde02',
          file_name:
            'audios/a098b8727714c3f86bab0814078eee76ba01b1b4c3c8bd77e383d35dc8dfde02.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a098b8727714c3f86bab0814078eee76ba01b1b4c3c8bd77e383d35dc8dfde02.mp3',
          name: 'Deadbugs.mp3',
          description: null,
          size: 17887,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating Slow Mountain Climbers': {
      id: 37,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Alternating Slow Mountain Climbers',
      short_name: 'Alt. Slow Mountain Climbers',
      unique_name: 'BEGINNER-Alternating Slow Mountain Climbers',
      description:
        '1. Start in Plank position.\r\n2. Draw one knee straight up towards your chest while the other remains engaged and extended. Pause for a beat.\r\n3. Return to Plank position and repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 84,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '7f2f305e41c3c342cf1dc02c547a7c982418df84ff4398453e757d194a96cf2c',
          file_name:
            'videos/7f2f305e41c3c342cf1dc02c547a7c982418df84ff4398453e757d194a96cf2c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7f2f305e41c3c342cf1dc02c547a7c982418df84ff4398453e757d194a96cf2c.mp4',
          name: 'CARRIE_MOUNTAIN_CLIMBER_1_FULL_REP_LOOP_50percent-faster_1_720.mp4',
          description: null,
          size: 113992,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 85,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'f01ef088a26f4858b330f93c25e4665722ce5289085ea032298d367e298b1c56',
          file_name:
            'audios/f01ef088a26f4858b330f93c25e4665722ce5289085ea032298d367e298b1c56.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f01ef088a26f4858b330f93c25e4665722ce5289085ea032298d367e298b1c56.mp3',
          name: 'Alternating_Slow_Mountain_Climbers.mp3',
          description: null,
          size: 34880,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating Star Jacks': {
      id: 38,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Alternating Star Jacks',
      short_name: 'Alternating Star Jacks',
      unique_name: 'BEGINNER-Alternating Star Jacks',
      description:
        '1. Stand with your feet close together. Keeping your chest up and heels on the ground, squat low and rest your arms lightly around your shins. \n2. Drive through your heels to stand as you bring your arms up overhead to a "V" shape and tap one foot out directly to the side. \n3. Bring your arms and leg back down and return to the narrow squat position.  \n4. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 86,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '9e98325788e24c8a018e27d049014bcae6b0c9fdde1dc92353cef3bf6bf278b0',
          file_name:
            'videos/9e98325788e24c8a018e27d049014bcae6b0c9fdde1dc92353cef3bf6bf278b0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9e98325788e24c8a018e27d049014bcae6b0c9fdde1dc92353cef3bf6bf278b0.mp4',
          name: 'Eve-Alternating-Star-Jacks-Beginner_720.mp4',
          description: null,
          size: 263576,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 87,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'c77f9266969b2df09da4a27ca8caebd9b9b812d2a6fc72934a3fd50c73f180c9',
          file_name:
            'audios/c77f9266969b2df09da4a27ca8caebd9b9b812d2a6fc72934a3fd50c73f180c9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c77f9266969b2df09da4a27ca8caebd9b9b812d2a6fc72934a3fd50c73f180c9.mp3',
          name: 'Alternating_Starjacks.mp3',
          description: null,
          size: 26527,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Broad Step Back Pedal': {
      id: 39,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Broad Steps Back Pedal',
      short_name: 'Broad Steps Back Pedal',
      unique_name: 'BEGINNER-Broad Step Back Pedal',
      description:
        '1. Start with your feet about shoulder-width apart and bend your knees slightly.\n2. Lean forward, swing your arms back and use that power to take a big step forward as far as you can.\n3. Staying low, take small steps backward to starting position. Perform the next rep stepping with the other leg.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 88,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'bf57773a8800b1fb7f4c759cf3a62ddaa529a8dd63640228bebe48cd7d1afc8b',
          file_name:
            'videos/bf57773a8800b1fb7f4c759cf3a62ddaa529a8dd63640228bebe48cd7d1afc8b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf57773a8800b1fb7f4c759cf3a62ddaa529a8dd63640228bebe48cd7d1afc8b.mp4',
          name: 'EVE_BROADJUMP_PEDALBACK_2_LOOP_SMALL_720.mp4',
          description: null,
          size: 244101,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 89,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'b7db087b2aa6a8a29054d639127a724fa0e3623f7ae7d3e0fa01639d9ae6b80a',
          file_name:
            'audios/b7db087b2aa6a8a29054d639127a724fa0e3623f7ae7d3e0fa01639d9ae6b80a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b7db087b2aa6a8a29054d639127a724fa0e3623f7ae7d3e0fa01639d9ae6b80a.mp3',
          name: 'Broad_Steps_Backpedal.mp3',
          description: null,
          size: 27103,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Modified Skaters': {
      id: 40,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Modified Skaters',
      short_name: 'Modified Skaters',
      unique_name: 'BEGINNER-Modified Skaters',
      description:
        '1. Start standing with your feet shoulder-width apart.\n2. Transfer your weight to one leg and bring the opposite leg behind you at an angle. Toes rest lightly on the floor.\n3. Take a big lateral step to the side. Land on the opposite leg and bring the other one back behind you at an angle, toes resting lightly on the floor.\n4. Repeat the motion on the opposite side\n5. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 90,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '603315d41dc63029079fa098fc64cbe55799b37c6351b3663d869765ba4c27f8',
          file_name:
            'videos/603315d41dc63029079fa098fc64cbe55799b37c6351b3663d869765ba4c27f8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/603315d41dc63029079fa098fc64cbe55799b37c6351b3663d869765ba4c27f8.mp4',
          name: 'LOGAN_SKATERS_P_2_REV_SAMLL_720.mp4',
          description: null,
          size: 158355,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 91,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '292f9a70fa677032e955e06c18439ece95d4b25c90018b6ef6fef7c5570b806b',
          file_name:
            'audios/292f9a70fa677032e955e06c18439ece95d4b25c90018b6ef6fef7c5570b806b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/292f9a70fa677032e955e06c18439ece95d4b25c90018b6ef6fef7c5570b806b.mp3',
          name: 'Modified_Skaters.mp3',
          description: null,
          size: 25087,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Frog Squats with Overhead Reach': {
      id: 41,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Frog Squats with Overhead Reach',
      short_name: 'Frog Squats w. Overhead Reach',
      unique_name: 'BEGINNER-Frog Squats with Overhead Reach',
      description:
        '1. Start with your feet wider than shoulder-width apart, toes turned out and your arms hanging down in front of you.\n2. Squat down as low as possible and lightly touch the floor between your feet.\n3. Drive through your heels and return to standing as you reach your arms up straight overhead.\n4. Bring your arms back down and immediately squat again.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 92,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '22c94114e53b1ccfb8a2b26cb36b7af9d70bc74ab1a3752c26ec88cf287a23d7',
          file_name:
            'videos/22c94114e53b1ccfb8a2b26cb36b7af9d70bc74ab1a3752c26ec88cf287a23d7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/22c94114e53b1ccfb8a2b26cb36b7af9d70bc74ab1a3752c26ec88cf287a23d7.mp4',
          name: 'LOGAN_FROG_JUMP_OVERHEAD_REACH_G_REV_SMALL_720.mp4',
          description: null,
          size: 114716,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 93,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '7010e10b65a0bb104aeb28e0275b335c512b6781f5faf13d831d05641735faeb',
          file_name:
            'audios/7010e10b65a0bb104aeb28e0275b335c512b6781f5faf13d831d05641735faeb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7010e10b65a0bb104aeb28e0275b335c512b6781f5faf13d831d05641735faeb.mp3',
          name: 'Frog_Squats_with_Overhead_Reach.mp3',
          description: null,
          size: 51223,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Burpees (No Push-Up)': {
      id: 42,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Burpees (No Push-Up)',
      short_name: 'Burpees (No Push-Up)',
      unique_name: 'BEGINNER-Burpees (No Push-Up)',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Bend your knees and hinge at your waist until you can plant your hands flat on the floor.\n3. Jump your feet back behind you to Plank position.\n4. Jump your feet back in, shoulder-width apart, heels on the ground\n5. Transfer your weight back into a low squat position and stand up.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 94,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '12c49c347de488bbd99456796968ff0e2f18e71adb335978067e331db6ad8c08',
          file_name:
            'videos/12c49c347de488bbd99456796968ff0e2f18e71adb335978067e331db6ad8c08.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/12c49c347de488bbd99456796968ff0e2f18e71adb335978067e331db6ad8c08.mp4',
          name: 'CARRIE_BURPEE_NO_PUSHUP_1_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 208758,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 95,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '9c9367e2d99809835255e4372af16ff220c035c743081616f645ca14cfef0180',
          file_name:
            'audios/9c9367e2d99809835255e4372af16ff220c035c743081616f645ca14cfef0180.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9c9367e2d99809835255e4372af16ff220c035c743081616f645ca14cfef0180.mp3',
          name: 'Burpees_No_Push_Up.mp3',
          description: null,
          size: 30205,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Air Squats': {
      id: 43,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Air Squats',
      short_name: 'Air Squats',
      unique_name: 'BEGINNER-Air Squats',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 96,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '5692bc9d041b8609843802860bc69180a77e1cd7472e03048c9bc3ebb71d7bdc',
          file_name:
            'videos/5692bc9d041b8609843802860bc69180a77e1cd7472e03048c9bc3ebb71d7bdc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5692bc9d041b8609843802860bc69180a77e1cd7472e03048c9bc3ebb71d7bdc.mp4',
          name: 'Logan-Air-Squats-Beginner.mp4',
          description: null,
          size: 73650,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 97,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'd471e17339c6bdb52a169f19c2ba730f6cd4262814a6503f4ad1bad579b4c0e1',
          file_name:
            'audios/d471e17339c6bdb52a169f19c2ba730f6cd4262814a6503f4ad1bad579b4c0e1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d471e17339c6bdb52a169f19c2ba730f6cd4262814a6503f4ad1bad579b4c0e1.mp3',
          name: 'Air_Squats.mp3',
          description: null,
          size: 18976,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Push-Ups': {
      id: 63,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Push-Ups',
      short_name: 'Push-Ups',
      unique_name: 'INTERMEDIATE-Push-Ups',
      description:
        '1. Start in Plank position, shoulders over wrists.\n2. Bend your elbows, pointing them back towards your hips. Lower your body towards the floor.\n3. Straighten your arms and raise your body back up in one long line from the crown of your head to your tailbone.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 138,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '18c561b36b600f81c7ac3b7d1848b929e09d7ad2989d5f5c1c677e808aff2170',
          file_name:
            'videos/18c561b36b600f81c7ac3b7d1848b929e09d7ad2989d5f5c1c677e808aff2170.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/18c561b36b600f81c7ac3b7d1848b929e09d7ad2989d5f5c1c677e808aff2170.mp4',
          name: 'CARRIE_PUSHUPS_1a_FULL_REP_REV_720.mp4',
          description: null,
          size: 79574,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 139,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '6dc897ae9a9766bf0ccbfe8754808a465958eff0f40c4dce1bd630663b5c7a39',
          file_name:
            'audios/6dc897ae9a9766bf0ccbfe8754808a465958eff0f40c4dce1bd630663b5c7a39.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6dc897ae9a9766bf0ccbfe8754808a465958eff0f40c4dce1bd630663b5c7a39.mp3',
          name: 'Push_Ups.mp3',
          description: null,
          size: 17823,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Hindu Push-Ups': {
      id: 64,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Hindu Push-Ups',
      short_name: 'Hindu Push-Ups',
      unique_name: 'INTERMEDIATE-Hindu Push-Ups',
      description:
        '1. Start in Down Dog Position. \n2. Bend your elbows and lower your upper body towards the floor leading with the crown of your head. Swoop your forehead, chin and chest through your arms and come to Up Dog position with your arms straight and hips low. \n3. Draw your hips up and back, keeping your arms straight and return to Down Dog position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 142,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'ab09dce84244bc653abf3279657236e081f0fcf6c1472f034f30ff29626a9972',
          file_name:
            'videos/ab09dce84244bc653abf3279657236e081f0fcf6c1472f034f30ff29626a9972.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ab09dce84244bc653abf3279657236e081f0fcf6c1472f034f30ff29626a9972.mp4',
          name: 'CARRIE_DIVEBOMBERS_2_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 184432,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 143,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '5fda0b4e3fb7e0ec6e2acecceabc5f05b206f8e0d00a6aac3af4cc42dfc0f68c',
          file_name:
            'audios/5fda0b4e3fb7e0ec6e2acecceabc5f05b206f8e0d00a6aac3af4cc42dfc0f68c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5fda0b4e3fb7e0ec6e2acecceabc5f05b206f8e0d00a6aac3af4cc42dfc0f68c.mp3',
          name: 'Hindu_Pushups.mp3',
          description: null,
          size: 21631,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Bicep Curls': {
      id: 65,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Bicep Curls',
      short_name: 'Bicep Curls',
      unique_name: 'INTERMEDIATE-Bicep Curls',
      description:
        '1. Start standing with your arms by your sides and a dumbbell in each hand. Palms face each other.\n2. Keep your elbows close to your ribcage and curl the weight up towards your shoulders as you rotate your wrists so your palms face your body at the top.\n3. Lower the weights back to the starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 144,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '7707eb9f5e01500d20d0035a18893148ad4dc6699debe2378f28089675b03455',
          file_name:
            'videos/7707eb9f5e01500d20d0035a18893148ad4dc6699debe2378f28089675b03455.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7707eb9f5e01500d20d0035a18893148ad4dc6699debe2378f28089675b03455.mp4',
          name: 'EVE_BICEP_CURLS_DUMBELLS_2_REV_SMALL_720.mp4',
          description: null,
          size: 76916,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 145,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '2180934007b654e511dc27a57fd3d64e009ea6046ffb4520b55eeea1921aab8d',
          file_name:
            'audios/2180934007b654e511dc27a57fd3d64e009ea6046ffb4520b55eeea1921aab8d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2180934007b654e511dc27a57fd3d64e009ea6046ffb4520b55eeea1921aab8d.mp3',
          name: 'Bicep_Curls.mp3',
          description: null,
          size: 22431,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Shoulder Presses': {
      id: 66,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Shoulder Presses',
      short_name: 'Shoulder Presses',
      unique_name: 'INTERMEDIATE-Shoulder Presses',
      description:
        '1. Stand with a solid foundation, back straight and core engaged. Hold a dumbbell in each hand at your shoulders, palms facing out.\n2. Raise both dumbbells straight overhead to full extension, biceps by your ears.\n3. Lower the dumbbells back to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 146,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '1391a2505601c848fb84155de4bb1983784a3252e08748cb8b6fad4b89e7efac',
          file_name:
            'videos/1391a2505601c848fb84155de4bb1983784a3252e08748cb8b6fad4b89e7efac.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1391a2505601c848fb84155de4bb1983784a3252e08748cb8b6fad4b89e7efac.mp4',
          name: 'LOGAN_SHOULDER_PRESS_W_DUMBELLS_B_LOOP_SAMLL_720.mp4',
          description: null,
          size: 111634,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 147,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '7a844024994839ef8aa76d875b7a91dda5ae46e2539ec9f5a7a5c2238691256e',
          file_name:
            'audios/7a844024994839ef8aa76d875b7a91dda5ae46e2539ec9f5a7a5c2238691256e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7a844024994839ef8aa76d875b7a91dda5ae46e2539ec9f5a7a5c2238691256e.mp3',
          name: 'Shoulder_Presses.mp3',
          description: null,
          size: 21919,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Lateral Raises': {
      id: 67,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Lateral Raises',
      short_name: 'Lateral Raises',
      unique_name: 'INTERMEDIATE-Lateral Raises',
      description:
        '1. Stand up tall and hold a dumbbell in each hand by your sides.\n2. Raise both arms directly out to your sides, bringing the dumbbells to shoulder height. Your arms are straight and palms face down.\n3. Lower your arms back down to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 148,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '147c186f0dafb5601e3d7af79434fecd93987e43c99201676156043f81178c6d',
          file_name:
            'videos/147c186f0dafb5601e3d7af79434fecd93987e43c99201676156043f81178c6d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/147c186f0dafb5601e3d7af79434fecd93987e43c99201676156043f81178c6d.mp4',
          name: 'LOGAN_LATERAL_RAISES_WITH_DUMBELLS_D_2_REV_SAMLL_720.mp4',
          description: null,
          size: 105567,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 149,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '5a545bc4ff79da59fe4d7dfb2dbffd0eaaa4949ab8e19c7ddc0fb14be69bb9af',
          file_name:
            'audios/5a545bc4ff79da59fe4d7dfb2dbffd0eaaa4949ab8e19c7ddc0fb14be69bb9af.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5a545bc4ff79da59fe4d7dfb2dbffd0eaaa4949ab8e19c7ddc0fb14be69bb9af.mp3',
          name: 'Lateral_Raises.mp3',
          description: null,
          size: 23008,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Renegade Rows': {
      id: 68,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Renegade Rows',
      short_name: 'Renegade Rows',
      unique_name: 'INTERMEDIATE-Renegade Rows',
      description:
        '1. Start in Plank position. Hold a dumbbell in each hand with your wrists as straight as possible.\n2. Transfer your weight into one arm. Bend and raise the opposite elbow straight up as you bring the dumbbell towards your ribcage.\n3. Lower your arm back to the floor and return to Plank position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 168,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'ba739368b71d822e444a794c7a6fca83647bf3e3866c8b6ed1f2138fa2e5cc67',
          file_name:
            'videos/ba739368b71d822e444a794c7a6fca83647bf3e3866c8b6ed1f2138fa2e5cc67.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ba739368b71d822e444a794c7a6fca83647bf3e3866c8b6ed1f2138fa2e5cc67.mp4',
          name: 'EVE_RENEGADE_ROWS_2_LOOP_SMALL_720.mp4',
          description: null,
          size: 130425,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 169,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '194cedfe609b3ece30a5a714f5e5767d126b6efd0054dde2c1c8828fb12ce6ea',
          file_name:
            'audios/194cedfe609b3ece30a5a714f5e5767d126b6efd0054dde2c1c8828fb12ce6ea.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/194cedfe609b3ece30a5a714f5e5767d126b6efd0054dde2c1c8828fb12ce6ea.mp3',
          name: 'Renegade_Rows.mp3',
          description: null,
          size: 22432,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Double Suitcase Squat': {
      id: 69,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Double Suitcase Squats',
      short_name: 'Double Suitcase Squats',
      unique_name: 'INTERMEDIATE-Double Suitcase Squat',
      description:
        '1. Stand with your feet about shoulder-width apart, holding a dumbbell in each hand down by your sides.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower.  Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 150,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'abe811301c07de6a00cd58e6fffdd6a9a5eac6aed156d1c849d23cf47be2e751',
          file_name:
            'videos/abe811301c07de6a00cd58e6fffdd6a9a5eac6aed156d1c849d23cf47be2e751.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/abe811301c07de6a00cd58e6fffdd6a9a5eac6aed156d1c849d23cf47be2e751.mp4',
          name: 'CARRIE_SUITCASE_SQUAT_1_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 101175,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 151,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'aeb392ba8ac364c24ce95c05b4e082bf337dc107540ca8f6f241207b4a0639d7',
          file_name:
            'audios/aeb392ba8ac364c24ce95c05b4e082bf337dc107540ca8f6f241207b4a0639d7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/aeb392ba8ac364c24ce95c05b4e082bf337dc107540ca8f6f241207b4a0639d7.mp3',
          name: 'Double_Suitcase_Squats.mp3',
          description: null,
          size: 38320,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Thrusters': {
      id: 70,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Thrusters',
      short_name: 'Thrusters',
      unique_name: 'INTERMEDIATE-Thrusters',
      description:
        '1. Stand with feet about shoulder-width apart. Hold a dumbbell in each hand at your shoulders, palms facing each other, elbows down.\n2. Keep your chest up and squat as low as possible. Try to get your elbows close to your knees.\n3. Drive through your heels and explode up to standing, raising the dumbbells overhead.\n4. Squat back down, bringing the dumbbells back to your shoulders.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 152,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '2c1a0fbeef46bc7de78753701fb2959cc44ba7ec0a870a979b6389c1fcf28e41',
          file_name:
            'videos/2c1a0fbeef46bc7de78753701fb2959cc44ba7ec0a870a979b6389c1fcf28e41.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2c1a0fbeef46bc7de78753701fb2959cc44ba7ec0a870a979b6389c1fcf28e41.mp4',
          name: 'CARRIE_THRUSTERS_W_DUMBELLS_1_FULL_REP_REV_720.mp4',
          description: null,
          size: 85238,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 153,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '44a2f5956587e41d02b64678d493d2134f83d7b4e7edf3a4dc587fc1f2fbb6ec',
          file_name:
            'audios/44a2f5956587e41d02b64678d493d2134f83d7b4e7edf3a4dc587fc1f2fbb6ec.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/44a2f5956587e41d02b64678d493d2134f83d7b4e7edf3a4dc587fc1f2fbb6ec.mp3',
          name: 'Thrusters.mp3',
          description: null,
          size: 17535,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Alternating Curtsy Lunges': {
      id: 71,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Curtsy Lunges',
      short_name: 'Alternating Curtsy Lunges',
      unique_name: 'INTERMEDIATE-Alternating Curtsy Lunges',
      description:
        '1. Start standing with your feet about shoulder-width apart, arms by your sides holding a dumbbell in each hand.\n2. Take a big step back and behind you at an angle, bend both knees and drop into a lunge.\n3. Keeping your hips square, drive through your front heel and return to standing.\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 154,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '4eaf6e9cf80f779f5f905ebe18620e4e014039b1c25c77e6cf69ac8de3db685c',
          file_name:
            'videos/4eaf6e9cf80f779f5f905ebe18620e4e014039b1c25c77e6cf69ac8de3db685c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4eaf6e9cf80f779f5f905ebe18620e4e014039b1c25c77e6cf69ac8de3db685c.mp4',
          name: 'EVE_07_ALTERNATING_CURTSY_VAN_LOOP_SMALL_720.mp4',
          description: null,
          size: 254853,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 155,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '90b9f629db806c840d171c37a0d883342a7ae3b025758b28744a6242a86cf2ea',
          file_name:
            'audios/90b9f629db806c840d171c37a0d883342a7ae3b025758b28744a6242a86cf2ea.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/90b9f629db806c840d171c37a0d883342a7ae3b025758b28744a6242a86cf2ea.mp3',
          name: 'Alternating_Curtsy_Lunges.mp3',
          description: null,
          size: 31071,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Sumo Squats with Upright Row': {
      id: 72,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Sumo Squats with Upright Row',
      short_name: 'Sumo Squats with Upright Row',
      unique_name: 'INTERMEDIATE-Sumo Squats with Upright Row',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointed out. Hold a dumbbell in each hand in front of your body, palms facing inward.\n2. Lower into a wide squat bringing the dumbbells towards the floor.\n3. As you stand, raise the dumbbells up towards your chin, elbows out and raised in a "V".\n4. Squat back down, as you bring the dumbbells towards the floor.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 156,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'b9e3d0bbc5a466f789017b9f588c4d2518bbaaa3dc3bda23189465d13ef5788e',
          file_name:
            'videos/b9e3d0bbc5a466f789017b9f588c4d2518bbaaa3dc3bda23189465d13ef5788e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b9e3d0bbc5a466f789017b9f588c4d2518bbaaa3dc3bda23189465d13ef5788e.mp4',
          name: 'EVE_SUMOSQUATS_W_UPRIGHT_ROW_2_REV_SMALL_720.mp4',
          description: null,
          size: 112917,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 157,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'dfaa817297adb6a5b853d66ba1a64f021eeb78eacd80dca67540100a954f73a6',
          file_name:
            'audios/dfaa817297adb6a5b853d66ba1a64f021eeb78eacd80dca67540100a954f73a6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dfaa817297adb6a5b853d66ba1a64f021eeb78eacd80dca67540100a954f73a6.mp3',
          name: 'Sumo_Squats_with_Upright_Row.mp3',
          description: null,
          size: 33664,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Goblet Squats': {
      id: 73,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Goblet Squat',
      short_name: 'Goblet Squat',
      unique_name: 'INTERMEDIATE-Goblet Squats',
      description:
        '1. Stand with your feet slightly wider than shoulder-width apart and hold a single dumbbell in front of your chest with both hands.\n2. Keeping your chest up and shoulders back, squat as low as possible trying to touch the outside of your elbows with the inside of your knee.\n3. Drive through your heels and return to standing.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 158,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '6ee33cdd71697afe5ed7ba97eac1a20606124b50d13c4508934ecc3f1e70c25f',
          file_name:
            'videos/6ee33cdd71697afe5ed7ba97eac1a20606124b50d13c4508934ecc3f1e70c25f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6ee33cdd71697afe5ed7ba97eac1a20606124b50d13c4508934ecc3f1e70c25f.mp4',
          name: 'LOGAN_GOBLET_SQUAT_W_DUMBELLS_CA_REV_SMALL_720.mp4',
          description: null,
          size: 87808,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 159,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'a1b99d8523a81f8ba07aca6b94d4f1ff68f1d99bc79f28d4360d2ecb21409bc7',
          file_name:
            'audios/a1b99d8523a81f8ba07aca6b94d4f1ff68f1d99bc79f28d4360d2ecb21409bc7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a1b99d8523a81f8ba07aca6b94d4f1ff68f1d99bc79f28d4360d2ecb21409bc7.mp3',
          name: 'INT-ADV-Goblet_Squat-EXERCISE.mp3',
          description: null,
          size: 26483,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Alternating Reverse Lunges': {
      id: 74,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Reverse Lunges',
      short_name: 'Alt. Reverse Lunges',
      unique_name: 'INTERMEDIATE-Alternating Reverse Lunges',
      description:
        '1. Start standing with your feet about shoulder-width apart, holding a dumbbell in each hand down by your sides.\n2. Take a big step backward with one leg, landing with your heel elevated and hips square. Drop down into a lunge by bending both knees 90 degrees.\n3. Drive through the front foot and return the back leg to starting position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 160,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '442e40d4dc672dee3bad301d970a3a56c36b67f3826d54f297196d4fb2bc76d2',
          file_name:
            'videos/442e40d4dc672dee3bad301d970a3a56c36b67f3826d54f297196d4fb2bc76d2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/442e40d4dc672dee3bad301d970a3a56c36b67f3826d54f297196d4fb2bc76d2.mp4',
          name: 'LOGAN_ALTERNATING_LUNGES_REVERSE_Ma_LOOP_SMALL_720.mp4',
          description: null,
          size: 255033,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 161,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '4f348712c21056ce8e644177eee15c8f834a92334a7d088577cac422b549ffca',
          file_name:
            'audios/4f348712c21056ce8e644177eee15c8f834a92334a7d088577cac422b549ffca.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4f348712c21056ce8e644177eee15c8f834a92334a7d088577cac422b549ffca.mp3',
          name: 'Alternating_Reverse_Lunges.mp3',
          description: null,
          size: 30208,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Supermans': {
      id: 75,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Supermans',
      short_name: 'Supermans',
      unique_name: 'INTERMEDIATE-Supermans',
      description:
        '1. Lie flat on your stomach, legs long and arms extended overhead.\n2. Lift your legs and arms simultaneously off the ground. Keep your neck in line with your spine and gaze towards the floor.\n3. Pause for a beat at the top and return to starting position.\n4. Do the number of reps on your card.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 140,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '7f670125f7ab27295aacfa55ccf9a7568d3c63a76fdefd7fa89675d3c714ec23',
          file_name:
            'videos/7f670125f7ab27295aacfa55ccf9a7568d3c63a76fdefd7fa89675d3c714ec23.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7f670125f7ab27295aacfa55ccf9a7568d3c63a76fdefd7fa89675d3c714ec23.mp4',
          name: 'Carrie-Supermans-Intermediate_720.mp4',
          description: null,
          size: 85639,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 141,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'becfa26eb066701f93e9ec8585c424aa699bf3f3d0fda5590108a855deba1715',
          file_name:
            'audios/becfa26eb066701f93e9ec8585c424aa699bf3f3d0fda5590108a855deba1715.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/becfa26eb066701f93e9ec8585c424aa699bf3f3d0fda5590108a855deba1715.mp3',
          name: 'Supermans.mp3',
          description: null,
          size: 20127,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Reverse Crunches with Leg Drop': {
      id: 76,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Reverse Crunches with Leg Drop',
      short_name: 'Rev. Crunches w. Leg Drop',
      unique_name: 'INTERMEDIATE-Reverse Crunches with Leg Drop',
      description:
        '1. Lie on your back. Place your arms by your sides, palms facing down. Bring both legs up, knees slightly bent over your hips.\n2. Lift your hips off the floor and raise your feet towards the ceiling.\n3. Lower your hips back down, then drop both legs towards the floor until your heels slightly touch. Keep your lower back connected to the floor.\n4. Raise both legs back up to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 162,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'c63fb4c117d998e4582bb974b4dcb5a6f6ea498305549bd7a9009fc4ab3b07a4',
          file_name:
            'videos/c63fb4c117d998e4582bb974b4dcb5a6f6ea498305549bd7a9009fc4ab3b07a4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c63fb4c117d998e4582bb974b4dcb5a6f6ea498305549bd7a9009fc4ab3b07a4.mp4',
          name: 'CARRIE_REVERSE_CRUNCH_W_LEG_DROP_1_FULL_REP_REV_720.mp4',
          description: null,
          size: 98019,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 163,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '69821de81bf4d376c026d8efbcde73a00bcf3ba9f9236915313fcb98a25f6219',
          file_name:
            'audios/69821de81bf4d376c026d8efbcde73a00bcf3ba9f9236915313fcb98a25f6219.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/69821de81bf4d376c026d8efbcde73a00bcf3ba9f9236915313fcb98a25f6219.mp3',
          name: 'Reverse_Crunches_with_Legdrop.mp3',
          description: null,
          size: 29630,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Super Planks': {
      id: 77,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Super Planks',
      short_name: 'Super Planks',
      unique_name: 'INTERMEDIATE-Super Planks',
      description:
        '1. Start in Plank position.\n2. Lower down to your forearms one at a time, keeping your elbows under your shoulders.\n3. Starting with the arm you began with, place your hand on the floor exactly where your elbow was and straighten your arm. Repeat on the other side and return to Plank position. Move your body in one piece and avoid twisting your hips.\n4. Right and left equals 1 rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 164,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '272dc595a408d1d2cd277b791f9611799b22e51397e4e259cd81d151e0fd2a79',
          file_name:
            'videos/272dc595a408d1d2cd277b791f9611799b22e51397e4e259cd81d151e0fd2a79.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/272dc595a408d1d2cd277b791f9611799b22e51397e4e259cd81d151e0fd2a79.mp4',
          name: 'EVE_SUPER_PLANK_2_REV_SMALL_720.mp4',
          description: null,
          size: 94451,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 165,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '8f4d354ecdad65f3528d270758934d3a354aa71ee7ddc6d64f86fa97a8948722',
          file_name:
            'audios/8f4d354ecdad65f3528d270758934d3a354aa71ee7ddc6d64f86fa97a8948722.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8f4d354ecdad65f3528d270758934d3a354aa71ee7ddc6d64f86fa97a8948722.mp3',
          name: 'Super_Planks.mp3',
          description: null,
          size: 20991,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Crab Toe Touches with Tricep Dip': {
      id: 78,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Crab Toe Touches with Tricep Dip',
      short_name: 'Crab Toe Touches with Tricep Dip',
      unique_name: 'INTERMEDIATE-Crab Toe Touches with Tricep Dip',
      description:
        '1. Start in a Crab Walk position with your knees bent, feet and hands on the floor, hips up.\n2. Bend your elbows straight back and perform a tricep dip bringing your hips closer to the floor.\n3. Extend your elbows and raise one leg straight up and lift the opposite arm to reach for your foot.\n4. Return to Crab Walk position.\n5. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 166,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'e0e8754f262e0adcc2443ec1d918f42ac74168e08d29d85a461598ff41efca0a',
          file_name:
            'videos/e0e8754f262e0adcc2443ec1d918f42ac74168e08d29d85a461598ff41efca0a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e0e8754f262e0adcc2443ec1d918f42ac74168e08d29d85a461598ff41efca0a.mp4',
          name: 'EVE_CRAB_TOE_TOUCHES_2_LOOP_SMALL_720.mp4',
          description: null,
          size: 144922,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 167,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '8754e058092cf57ff2bfc26cc08b7ff1dbfd0cee5186352f391f1e8ae0164527',
          file_name:
            'audios/8754e058092cf57ff2bfc26cc08b7ff1dbfd0cee5186352f391f1e8ae0164527.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8754e058092cf57ff2bfc26cc08b7ff1dbfd0cee5186352f391f1e8ae0164527.mp3',
          name: 'Crab_Toe_Touches_with_Tricep_Dip.mp3',
          description: null,
          size: 36032,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Bicycle Crunches': {
      id: 79,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Bicycle Crunches',
      short_name: 'Bicycle Crunches',
      unique_name: 'INTERMEDIATE-Bicycle Crunches',
      description:
        '1. Lie on your back, hands behind your head and elbows out. Bend your knees and lift them off the floor until they are directly over your hips.\n2. Lift your head and shoulders off the floor and bring one knee towards your chest and extend the opposite leg out. Twist your torso so your opposite elbow moves towards your bent knee.\n3. Repeat on the opposite side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 170,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '9e89e2bc2aba2f88efd88a2d071b19550a5dc5dcbd7842a7bfb3f9102955bb5f',
          file_name:
            'videos/9e89e2bc2aba2f88efd88a2d071b19550a5dc5dcbd7842a7bfb3f9102955bb5f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9e89e2bc2aba2f88efd88a2d071b19550a5dc5dcbd7842a7bfb3f9102955bb5f.mp4',
          name: 'LOGAN_BICYCLE_CRUNCHES_R_LOOP_SAMLL_720.mp4',
          description: null,
          size: 100322,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 171,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'c93a8897d182cc28ab6dd22bb6732c9aa64b357b41d19fb25223e9cc305ce1ca',
          file_name:
            'audios/c93a8897d182cc28ab6dd22bb6732c9aa64b357b41d19fb25223e9cc305ce1ca.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c93a8897d182cc28ab6dd22bb6732c9aa64b357b41d19fb25223e9cc305ce1ca.mp3',
          name: 'Bicycle_Crunches.mp3',
          description: null,
          size: 25024,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Mountain Climbers': {
      id: 80,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Mountain Climbers',
      short_name: 'Mountain Climbers',
      unique_name: 'INTERMEDIATE-Mountain Climbers',
      description:
        '1. Start in Plank position.\n2. Pull one knee straight up towards your chest while the other remains engaged and extended.\n3. Keeping your hips low, jump your bent knee back and extend it to a one leg Plank position while drawing the opposite knee up towards your chest. (Think High-Knees in Plank position).\n4. Repeat again on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 172,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'd3ac5e40aef2fc9c66f413d4d8d61a73f283b47813a40e717f47dd221b59a21d',
          file_name:
            'videos/d3ac5e40aef2fc9c66f413d4d8d61a73f283b47813a40e717f47dd221b59a21d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d3ac5e40aef2fc9c66f413d4d8d61a73f283b47813a40e717f47dd221b59a21d.mp4',
          name: 'LOGAN_MOUNTAIN_CLIMBERS_X_2_REV_SAMLL_720.mp4',
          description: null,
          size: 68323,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 173,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'eb80c51e7d243b58b4cb8731685492707cbf17ec197ff8fb12cd0597668dde47',
          file_name:
            'audios/eb80c51e7d243b58b4cb8731685492707cbf17ec197ff8fb12cd0597668dde47.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eb80c51e7d243b58b4cb8731685492707cbf17ec197ff8fb12cd0597668dde47.mp3',
          name: 'Mountain_Climbers.mp3',
          description: null,
          size: 23008,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Star Jacks': {
      id: 81,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Star Jacks',
      short_name: 'Star Jacks',
      unique_name: 'INTERMEDIATE-Star Jacks',
      description:
        '1. Stand with your feet close together. Keeping your chest up and heels on the ground, squat low and rest your arms lightly around your shins.\n2. From the squat, explode up and perform a jumping jack raising your arms above you and straightening your legs to make a star shape.\n3. Jump your feet back together and return to the narrow squat position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 174,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '8414c9fdf4e79a5e65a6417b4e011611c7cabe69fc672ab55d7056e157ecaa87',
          file_name:
            'videos/8414c9fdf4e79a5e65a6417b4e011611c7cabe69fc672ab55d7056e157ecaa87.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8414c9fdf4e79a5e65a6417b4e011611c7cabe69fc672ab55d7056e157ecaa87.mp4',
          name: 'CARRIE_STARJACKS_2_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 93466,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 175,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'fc27ed7ac864a0870e53eecfca0ed8b40c2cd8c806ec799d9d2b08415ad88c48',
          file_name:
            'audios/fc27ed7ac864a0870e53eecfca0ed8b40c2cd8c806ec799d9d2b08415ad88c48.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fc27ed7ac864a0870e53eecfca0ed8b40c2cd8c806ec799d9d2b08415ad88c48.mp3',
          name: 'Star_Jacks.mp3',
          description: null,
          size: 20127,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Broad Jump Back Pedal': {
      id: 82,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Broad Jumps Back Pedal',
      short_name: 'Broad Jumps Back Pedal',
      unique_name: 'INTERMEDIATE-Broad Jump Back Pedal',
      description:
        '1. Start with your feet about shoulder-width apart and bend your knees slightly.\n2. Lean forward, swing your arms back and use that power to jump forward as far as you can. Land soft with both feet at the same time.\n3. Staying low, take small steps backwards to your starting position, then jump again.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 176,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'ba92a01026cb8bc1b53d6b6c1d4a83db18b332c34a3fdc8b5ef82a8057804ba2',
          file_name:
            'videos/ba92a01026cb8bc1b53d6b6c1d4a83db18b332c34a3fdc8b5ef82a8057804ba2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ba92a01026cb8bc1b53d6b6c1d4a83db18b332c34a3fdc8b5ef82a8057804ba2.mp4',
          name: 'CARRIE_BROAD_JUMP_PEDAL_BACK_1_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 234033,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 177,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '29937ac79928153b1d3e7e0c69dbaf1744f09f0d63c1437ee2430faec280e81b',
          file_name:
            'audios/29937ac79928153b1d3e7e0c69dbaf1744f09f0d63c1437ee2430faec280e81b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/29937ac79928153b1d3e7e0c69dbaf1744f09f0d63c1437ee2430faec280e81b.mp3',
          name: 'Broad_Jumps_Backpedal.mp3',
          description: null,
          size: 26527,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Skaters': {
      id: 83,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Skaters',
      short_name: 'Skaters',
      unique_name: 'INTERMEDIATE-Skaters',
      description:
        '1. Start standing with your feet shoulder-width apart.\n2. Transfer your weight to one leg and bring the opposite leg behind you at an angle. Toes rest lightly on the floor.\n3. Take a big lateral hop to the side. Land on the opposite leg and bring the other one back behind you at an angle, toes resting lightly on the floor.\n4. Repeat the motion on the opposite side\n5. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 178,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '86cd6e49ee7a0951179c9badc93a11918683869b129183e93ddf530618c2d43a',
          file_name:
            'videos/86cd6e49ee7a0951179c9badc93a11918683869b129183e93ddf530618c2d43a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86cd6e49ee7a0951179c9badc93a11918683869b129183e93ddf530618c2d43a.mp4',
          name: 'Carrie-Skaters-Intermediate_720.mp4',
          description: null,
          size: 140058,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 179,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '5bf5314721b4474c8bdb688d4b9160eadb1d0d6da472c4291a630b1cd9c6c6b5',
          file_name:
            'audios/5bf5314721b4474c8bdb688d4b9160eadb1d0d6da472c4291a630b1cd9c6c6b5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5bf5314721b4474c8bdb688d4b9160eadb1d0d6da472c4291a630b1cd9c6c6b5.mp3',
          name: 'Skaters.mp3',
          description: null,
          size: 18112,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Frog Jumps with Overhead Reach': {
      id: 84,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Frog Jumps with Overhead Reach',
      short_name: 'Frog Jumps w. Overhead Reach',
      unique_name: 'INTERMEDIATE-Frog Jumps with Overhead Reach',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes turned out, and your arms hanging down in front of you.\n2. Squat down as low as possible and lightly touch the floor between your feet.\n3. From the squat position, jump up as high as you can and reach your arms straight up overhead.\n4. Land softly back into the squat and immediately jump again.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 180,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'e7459726dbf55aaa04247a7aafe68c3f2dd9f909f529252153158c7bf4a0fbfe',
          file_name:
            'videos/e7459726dbf55aaa04247a7aafe68c3f2dd9f909f529252153158c7bf4a0fbfe.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e7459726dbf55aaa04247a7aafe68c3f2dd9f909f529252153158c7bf4a0fbfe.mp4',
          name: 'Eve-Frog-Jump-Overhead-Reach-Intermediate_720.mp4',
          description: null,
          size: 93928,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 181,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '681a462f315b9ed790688d0cfc4c0fbe669c65459b3e7ad7afbc66e290705045',
          file_name:
            'audios/681a462f315b9ed790688d0cfc4c0fbe669c65459b3e7ad7afbc66e290705045.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/681a462f315b9ed790688d0cfc4c0fbe669c65459b3e7ad7afbc66e290705045.mp3',
          name: 'Frog_Jumps_with_Overhead_Reach.mp3',
          description: null,
          size: 32800,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Burpees': {
      id: 85,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Burpees',
      short_name: 'Burpees',
      unique_name: 'INTERMEDIATE-Burpees',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Bend your knees and hinge at your waist until you can plant your hands flat on the floor.\n3. Jump your feet back behind you to Plank position and perform one push up.\n4. Jump your feet back in, shoulder-width apart, heels on the ground.\n5. Sit back into a low squat position and jump straight up into the air, arms extend overhead. Land soft.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 182,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '25f296c21408a9dde859e6e307366017650650e8e2419cbef8e8605cd2a830e4',
          file_name:
            'videos/25f296c21408a9dde859e6e307366017650650e8e2419cbef8e8605cd2a830e4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/25f296c21408a9dde859e6e307366017650650e8e2419cbef8e8605cd2a830e4.mp4',
          name: 'LOGAN_BURPEES_H_2_LOOP_20percent_slow_1_720.mp4',
          description: null,
          size: 208291,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 183,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '939332f82d63cbe726416ba3dc81141ebf18f2f3b20733e1390607a070a5fdfe',
          file_name:
            'audios/939332f82d63cbe726416ba3dc81141ebf18f2f3b20733e1390607a070a5fdfe.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/939332f82d63cbe726416ba3dc81141ebf18f2f3b20733e1390607a070a5fdfe.mp3',
          name: 'Burpees.mp3',
          description: null,
          size: 18109,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Squat to Tuck Jumps': {
      id: 86,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Squat to Tuck Jumps',
      short_name: 'Squat to Tuck Jumps',
      unique_name: 'INTERMEDIATE-Squat to Tuck Jumps',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Keeping your chest up and shoulders back, squat down as low as possible.\n3. From the low squat position, jump straight up as high as you can, tucking your knees into your chest.\n4. Land softly and repeat.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 184,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '9406723391996feff74673e8c39f05e18c2fc5b73aa3c1d9c0f990aa220b9fb4',
          file_name:
            'videos/9406723391996feff74673e8c39f05e18c2fc5b73aa3c1d9c0f990aa220b9fb4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9406723391996feff74673e8c39f05e18c2fc5b73aa3c1d9c0f990aa220b9fb4.mp4',
          name: 'CARRIE_SQUAT_JUMP_TO_TUCK_2_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 79302,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 185,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e624f3fc51cd0d99460ca8623255048d72d99024dcf66f4d191057615f388a5b',
          file_name:
            'audios/e624f3fc51cd0d99460ca8623255048d72d99024dcf66f4d191057615f388a5b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e624f3fc51cd0d99460ca8623255048d72d99024dcf66f4d191057615f388a5b.mp3',
          name: 'Squat_to_Tuck_Jumps.mp3',
          description: null,
          size: 27616,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Alligator Push-Ups': {
      id: 106,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Alligator Push-Ups',
      short_name: 'Alligator Push-Ups',
      unique_name: 'ADVANCED-Alligator Push-Ups',
      description:
        '1. Start in Plank position.\n2. Stagger your hands by stepping one hand slightly forward and the other back towards your hips.\n3. Bring the knee that is closest to your hand up and out to the side so it touches the outside of your tricep and perform a push up.\n4. Return to Plank position and repeat on the other side.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 226,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '86af462e628f92df7dff80c2d016e66c124efdeeb7ac6a867a46ebc64b957d7b',
          file_name:
            'videos/86af462e628f92df7dff80c2d016e66c124efdeeb7ac6a867a46ebc64b957d7b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86af462e628f92df7dff80c2d016e66c124efdeeb7ac6a867a46ebc64b957d7b.mp4',
          name: 'LOGAN_PUSHUP_VARIATIONS_V_LOOP_SAMLL_720.mp4',
          description: null,
          size: 228759,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 227,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'c9fcc82c7080b982314701524e995706f3dcc4a5c2e3ce3432f325824735e832',
          file_name:
            'audios/c9fcc82c7080b982314701524e995706f3dcc4a5c2e3ce3432f325824735e832.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c9fcc82c7080b982314701524e995706f3dcc4a5c2e3ce3432f325824735e832.mp3',
          name: 'Alligator_Push_Ups.mp3',
          description: null,
          size: 23871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Divebombers': {
      id: 107,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Divebombers',
      short_name: 'Divebombers',
      unique_name: 'ADVANCED-Divebombers',
      description:
        '1. Start in Down Dog Position.\n2. Bend your elbows and lower your upper body towards the floor leading with the crown of your head. Swoop your forehead, chin and chest through your arms and come to Up Dog position with your arms straight and hips low.\n3. Bend your elbows and swoop back the way you came. Straighten your arms, bring your hips up and back and return to Down Dog position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 230,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '5d410509981e9a18472548988795cdc4d0563442f4926a826c39b985c2372f64',
          file_name:
            'videos/5d410509981e9a18472548988795cdc4d0563442f4926a826c39b985c2372f64.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5d410509981e9a18472548988795cdc4d0563442f4926a826c39b985c2372f64.mp4',
          name: 'EVE_DIVE_BOMBERS_1_REV_SMALL_720.mp4',
          description: null,
          size: 151332,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 231,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'bb3926698bdf4d0d47f3b5c25ab08298966597be251afb697087f11abe2a1633',
          file_name:
            'audios/bb3926698bdf4d0d47f3b5c25ab08298966597be251afb697087f11abe2a1633.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/bb3926698bdf4d0d47f3b5c25ab08298966597be251afb697087f11abe2a1633.mp3',
          name: 'Dive_Bombers.mp3',
          description: null,
          size: 22431,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Bicep Curls': {
      id: 108,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Bicep Curls',
      short_name: 'Bicep Curls',
      unique_name: 'ADVANCED-Bicep Curls',
      description:
        '1. Start standing with your arms by your sides and a dumbbell in each hand. Palms face each other.\n2. Keep your elbows close to your ribcage and curl the weight up towards your shoulders as you rotate your wrists so your palms face your body at the top.\n3. Lower the weights back to the starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 232,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'b3e53ab47c5d47c5f63f78157ab10d365c7ae2f2f917b1f2ce2709438237436a',
          file_name:
            'videos/b3e53ab47c5d47c5f63f78157ab10d365c7ae2f2f917b1f2ce2709438237436a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b3e53ab47c5d47c5f63f78157ab10d365c7ae2f2f917b1f2ce2709438237436a.mp4',
          name: 'CARRIE_BICEP_CURLS_HEAVEY_DUMBELLS_FULL_REP_REV_720.mp4',
          description: null,
          size: 78312,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 233,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '2180934007b654e511dc27a57fd3d64e009ea6046ffb4520b55eeea1921aab8d',
          file_name:
            'audios/2180934007b654e511dc27a57fd3d64e009ea6046ffb4520b55eeea1921aab8d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2180934007b654e511dc27a57fd3d64e009ea6046ffb4520b55eeea1921aab8d.mp3',
          name: 'Bicep_Curls.mp3',
          description: null,
          size: 22431,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Shoulder Presses': {
      id: 109,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Shoulder Presses',
      short_name: 'Shoulder Presses',
      unique_name: 'ADVANCED-Shoulder Presses',
      description:
        '1. Stand with a solid foundation, back straight and core engaged. Hold a dumbbell in each hand at your shoulders, palms facing out.\n2. Raise both dumbbells straight overhead to full extension, biceps by your ears.\n3. Lower the dumbbells back to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 234,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '2b775cf6f743eb9fc4026a9e0d382bc8707d54a7c4cf070fd02261b85b7ecba1',
          file_name:
            'videos/2b775cf6f743eb9fc4026a9e0d382bc8707d54a7c4cf070fd02261b85b7ecba1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2b775cf6f743eb9fc4026a9e0d382bc8707d54a7c4cf070fd02261b85b7ecba1.mp4',
          name: 'EVE_01_SHOULDER_RAISES_VAN_REV_SMALL_720.mp4',
          description: null,
          size: 88208,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 235,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '7a844024994839ef8aa76d875b7a91dda5ae46e2539ec9f5a7a5c2238691256e',
          file_name:
            'audios/7a844024994839ef8aa76d875b7a91dda5ae46e2539ec9f5a7a5c2238691256e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7a844024994839ef8aa76d875b7a91dda5ae46e2539ec9f5a7a5c2238691256e.mp3',
          name: 'Shoulder_Presses.mp3',
          description: null,
          size: 21919,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Front Raise To Lateral Raise': {
      id: 110,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Front Raise To Lateral Raises',
      short_name: 'Front Raise To Lateral Raises',
      unique_name: 'ADVANCED-Front Raise To Lateral Raise',
      description:
        '1. Stand up tall and hold a dumbbell in each hand in front of your body.\n2. Raise both dumbbells in front of you to shoulder height. Your arms are straight and palms face down. Then, bring both arms directly out to your sides to create a "T".\n3. Lower your arms back down to your sides.\n4. Repeat in the opposite direction.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 236,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '6234a643dbc453db3f2edacd1648968f86e41a29334d04ce8996aba614765602',
          file_name:
            'videos/6234a643dbc453db3f2edacd1648968f86e41a29334d04ce8996aba614765602.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6234a643dbc453db3f2edacd1648968f86e41a29334d04ce8996aba614765602.mp4',
          name: 'EVE_04_LATERAL_RAISES_VAN_REV_SMALL_720.mp4',
          description: null,
          size: 221219,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 237,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '0b295b100b4bb0c039cbb78b49b34a614cbf4f3fae38801e27388b693394945e',
          file_name:
            'audios/0b295b100b4bb0c039cbb78b49b34a614cbf4f3fae38801e27388b693394945e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0b295b100b4bb0c039cbb78b49b34a614cbf4f3fae38801e27388b693394945e.mp3',
          name: 'Front_Raise_to_Lateral_Raises.mp3',
          description: null,
          size: 33728,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Renegade Rows': {
      id: 111,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Renegade Rows',
      short_name: 'Renegade Rows',
      unique_name: 'ADVANCED-Renegade Rows',
      description:
        '1. Start in Plank position. Hold a dumbbell in each hand with your wrists as straight as possible.  \n2. Transfer your weight into one arm. Bend and raise the opposite elbow straight up as you bring the dumbbell towards your ribcage.  \n3. Lower your arm back to the floor and return to Plank position.  \n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 260,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '44e0856cf14c4c6a8372908f39fb1dfd6a93f5262a3d2de03a3c9d68a6056b38',
          file_name:
            'videos/44e0856cf14c4c6a8372908f39fb1dfd6a93f5262a3d2de03a3c9d68a6056b38.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/44e0856cf14c4c6a8372908f39fb1dfd6a93f5262a3d2de03a3c9d68a6056b38.mp4',
          name: 'CARRIE_RENEGADE_ROWS_W_DUMBELL_2_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 113194,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 261,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '194cedfe609b3ece30a5a714f5e5767d126b6efd0054dde2c1c8828fb12ce6ea',
          file_name:
            'audios/194cedfe609b3ece30a5a714f5e5767d126b6efd0054dde2c1c8828fb12ce6ea.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/194cedfe609b3ece30a5a714f5e5767d126b6efd0054dde2c1c8828fb12ce6ea.mp3',
          name: 'Renegade_Rows.mp3',
          description: null,
          size: 22432,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Double Suitcase Squat': {
      id: 112,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Double Suitcase Squats',
      short_name: 'Double Suitcase Squats',
      unique_name: 'ADVANCED-Double Suitcase Squat',
      description:
        '1. Stand with your feet about shoulder-width apart, holding a dumbbell in each hand down by your sides.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower.  Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 238,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '64dd62d9496357ed4f02ac578fead2db3b1164e7077ac409e7b4f39b09801ec5',
          file_name:
            'videos/64dd62d9496357ed4f02ac578fead2db3b1164e7077ac409e7b4f39b09801ec5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/64dd62d9496357ed4f02ac578fead2db3b1164e7077ac409e7b4f39b09801ec5.mp4',
          name: 'LOGAN_ALT_SUITCASE_Ia_2_REV_SMALL_720.mp4',
          description: null,
          size: 90015,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 239,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'aeb392ba8ac364c24ce95c05b4e082bf337dc107540ca8f6f241207b4a0639d7',
          file_name:
            'audios/aeb392ba8ac364c24ce95c05b4e082bf337dc107540ca8f6f241207b4a0639d7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/aeb392ba8ac364c24ce95c05b4e082bf337dc107540ca8f6f241207b4a0639d7.mp3',
          name: 'Double_Suitcase_Squats.mp3',
          description: null,
          size: 38320,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Thrusters': {
      id: 113,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Thrusters',
      short_name: 'Thrusters',
      unique_name: 'ADVANCED-Thrusters',
      description:
        '1. Stand with feet about shoulder-width apart. Hold a dumbbell in each hand at your shoulders, palms facing each other, elbows down.\n2. Keep your chest up and squat as low as possible. Try to get your elbows close to your knees.\n3. Drive through your heels and explode up to standing, raising the dumbbells overhead.\n4. Squat back down, bringing the dumbbells back to your shoulders.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 240,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '43e2b8c24d8048fbd86cdb1ddda0e0728b060c3c1fa5b8aef9d9941ee1b5f1cb',
          file_name:
            'videos/43e2b8c24d8048fbd86cdb1ddda0e0728b060c3c1fa5b8aef9d9941ee1b5f1cb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/43e2b8c24d8048fbd86cdb1ddda0e0728b060c3c1fa5b8aef9d9941ee1b5f1cb.mp4',
          name: 'LOGAN_THRUSTERS-ADVANCED-REV_SMALL_720.mp4',
          description: null,
          size: 100223,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 241,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '44a2f5956587e41d02b64678d493d2134f83d7b4e7edf3a4dc587fc1f2fbb6ec',
          file_name:
            'audios/44a2f5956587e41d02b64678d493d2134f83d7b4e7edf3a4dc587fc1f2fbb6ec.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/44a2f5956587e41d02b64678d493d2134f83d7b4e7edf3a4dc587fc1f2fbb6ec.mp3',
          name: 'Thrusters.mp3',
          description: null,
          size: 17535,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Alternating Curtsy Lunges': {
      id: 114,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Curtsy Lunges',
      short_name: 'Alternating Curtsy Lunges',
      unique_name: 'ADVANCED-Alternating Curtsy Lunges',
      description:
        '1. Start standing with your feet about shoulder-width apart, arms by your sides holding a dumbbell in each hand.\n2. Take a big step back and behind you at an angle, bend both knees and drop into a lunge.\n3. Keeping your hips square, drive through your front heel and return to standing.\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 242,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '20ba42413b5056190bffad093ab3ab11b15b9c9d00adff2042a8cd8fc09e62fe',
          file_name:
            'videos/20ba42413b5056190bffad093ab3ab11b15b9c9d00adff2042a8cd8fc09e62fe.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/20ba42413b5056190bffad093ab3ab11b15b9c9d00adff2042a8cd8fc09e62fe.mp4',
          name: 'CARRIE_ALTERNATING_CURTSEY_LUNGES_DUMBELLS_1_Full_Rep_LOOP_1_720.mp4',
          description: null,
          size: 214144,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 243,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '90b9f629db806c840d171c37a0d883342a7ae3b025758b28744a6242a86cf2ea',
          file_name:
            'audios/90b9f629db806c840d171c37a0d883342a7ae3b025758b28744a6242a86cf2ea.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/90b9f629db806c840d171c37a0d883342a7ae3b025758b28744a6242a86cf2ea.mp3',
          name: 'Alternating_Curtsy_Lunges.mp3',
          description: null,
          size: 31071,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Sumo Squats with Upright Row': {
      id: 115,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Sumo Squats with Upright Row',
      short_name: 'Sumo Squats with Upright Row',
      unique_name: 'ADVANCED-Sumo Squats with Upright Row',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointed out. Hold a dumbbell in each hand in front of your body, palms facing inward.\n2. Lower into a wide squat bringing the dumbbells towards the floor.\n3. As you stand, raise the dumbbells up towards your chin, elbows out and raised in a "V".\n4. Squat back down, as you bring the dumbbells towards the floor.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 244,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'aba0d7b18a13aa7618fa0de35339129782eab1853af8715536c133ff7ee552de',
          file_name:
            'videos/aba0d7b18a13aa7618fa0de35339129782eab1853af8715536c133ff7ee552de.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/aba0d7b18a13aa7618fa0de35339129782eab1853af8715536c133ff7ee552de.mp4',
          name: 'Carrie-Sumo-Squats-with-Upright-Row-Advanced_720.mp4',
          description: null,
          size: 109848,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 245,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'dfaa817297adb6a5b853d66ba1a64f021eeb78eacd80dca67540100a954f73a6',
          file_name:
            'audios/dfaa817297adb6a5b853d66ba1a64f021eeb78eacd80dca67540100a954f73a6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dfaa817297adb6a5b853d66ba1a64f021eeb78eacd80dca67540100a954f73a6.mp3',
          name: 'Sumo_Squats_with_Upright_Row.mp3',
          description: null,
          size: 33664,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Goblet Squats': {
      id: 116,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Goblet Squat',
      short_name: 'Goblet Squat',
      unique_name: 'ADVANCED-Goblet Squats',
      description:
        '1. Stand with your feet slightly wider than shoulder-width apart and hold a single dumbbell in front of your chest with both hands.\n2. Keeping your chest up and shoulders back, squat as low as possible trying to touch the outside of your elbows with the inside of your knee.\n3. Drive through your heels and return to standing.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 246,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'a43345bbc788a3b90198e14204ffd12b157669c465530a3bc350906e047eeec3',
          file_name:
            'videos/a43345bbc788a3b90198e14204ffd12b157669c465530a3bc350906e047eeec3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a43345bbc788a3b90198e14204ffd12b157669c465530a3bc350906e047eeec3.mp4',
          name: 'EVE_03_GOBLET_SQUAT_VAN_REV_SMALL_720.mp4',
          description: null,
          size: 81721,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 247,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'a1b99d8523a81f8ba07aca6b94d4f1ff68f1d99bc79f28d4360d2ecb21409bc7',
          file_name:
            'audios/a1b99d8523a81f8ba07aca6b94d4f1ff68f1d99bc79f28d4360d2ecb21409bc7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a1b99d8523a81f8ba07aca6b94d4f1ff68f1d99bc79f28d4360d2ecb21409bc7.mp3',
          name: 'INT-ADV-Goblet_Squat-EXERCISE.mp3',
          description: null,
          size: 26483,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Alternating Reverse Lunges': {
      id: 117,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Reverse Lunges',
      short_name: 'Alt. Reverse Lunges',
      unique_name: 'ADVANCED-Alternating Reverse Lunges',
      description:
        '1. Start standing with your feet about shoulder-width apart, holding a dumbbell in each hand down by your sides.\n2. Take a big step backward with one leg, landing with your heel elevated and hips square. Drop down into a lunge by bending  both knees 90 degrees.\n3. Drive through the front foot and return the back leg to starting position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 248,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '23449ee0141b72576fb4d9d3e1fd68590777e52705d00bb4e0cd2de530703073',
          file_name:
            'videos/23449ee0141b72576fb4d9d3e1fd68590777e52705d00bb4e0cd2de530703073.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/23449ee0141b72576fb4d9d3e1fd68590777e52705d00bb4e0cd2de530703073.mp4',
          name: 'EVE_ALTERNATING_LUNGES_HEAVY_1_LOOP_small_720.mp4',
          description: null,
          size: 267582,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 249,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '4f348712c21056ce8e644177eee15c8f834a92334a7d088577cac422b549ffca',
          file_name:
            'audios/4f348712c21056ce8e644177eee15c8f834a92334a7d088577cac422b549ffca.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4f348712c21056ce8e644177eee15c8f834a92334a7d088577cac422b549ffca.mp3',
          name: 'Alternating_Reverse_Lunges.mp3',
          description: null,
          size: 30208,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Supermans with Weight': {
      id: 118,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Supermans with Weight',
      short_name: 'Supermans with Weight',
      unique_name: 'ADVANCED-Supermans with Weight',
      description:
        '1. Lie flat on your stomach, legs long and arms extended overhead holding a light dumbbell.\n2. Lift your arms and legs simultaneously off the ground. Keep your neck in line with your spine and gaze towards the floor.\n3. Pause for a beat at the top and return to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 228,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'b9c477f92c0291d88ac7821f5761e1472cec23ca571adebb4bf46882be5f6d88',
          file_name:
            'videos/b9c477f92c0291d88ac7821f5761e1472cec23ca571adebb4bf46882be5f6d88.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b9c477f92c0291d88ac7821f5761e1472cec23ca571adebb4bf46882be5f6d88.mp4',
          name: 'LOGAN_SUPERMANS_WITH_DUMBELLS_U_REV_SAMLL_720.mp4',
          description: null,
          size: 122956,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 229,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e591bca1ecd78e711ac2305bebe03c0ce37d19b87c5bb562a5c5d3d11b4ea8ab',
          file_name:
            'audios/e591bca1ecd78e711ac2305bebe03c0ce37d19b87c5bb562a5c5d3d11b4ea8ab.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e591bca1ecd78e711ac2305bebe03c0ce37d19b87c5bb562a5c5d3d11b4ea8ab.mp3',
          name: 'Supermans_with_Weight.mp3',
          description: null,
          size: 27678,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Reverse Crunches with Straight Legs': {
      id: 119,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Reverse Crunches with Straight Legs',
      short_name: 'Rev. Crunches w. Straight Legs',
      unique_name: 'ADVANCED-Reverse Crunches with Straight Legs',
      description:
        '1. Lie on your back. Place your arms by your sides, palms facing down. Raise both legs straight up over your hips.\n2. Lift your hips off the floor and raise your feet straight up to the ceiling.\n3. Lower your hips back down, then drop both legs towards the floor as low as possible while still maintaining a lower back connection to the floor.\n4. Raise both legs back up to starting position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: true,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 250,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '3998f5de165c744b695b72cd69c3554fde97046e976b02cdd729fc794d913330',
          file_name:
            'videos/3998f5de165c744b695b72cd69c3554fde97046e976b02cdd729fc794d913330.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3998f5de165c744b695b72cd69c3554fde97046e976b02cdd729fc794d913330.mp4',
          name: 'LOGAN_REVERSE_CRUNCH_WITH_LEG_DROP_S_4_REV_SAMLL_720.mp4',
          description: null,
          size: 119751,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 251,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '4d6c6c00a8bde1c85d3f9c5b14b3801e267cdd6358f86874dd67843edab74526',
          file_name:
            'audios/4d6c6c00a8bde1c85d3f9c5b14b3801e267cdd6358f86874dd67843edab74526.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4d6c6c00a8bde1c85d3f9c5b14b3801e267cdd6358f86874dd67843edab74526.mp3',
          name: 'Reverse_Crunches_with_Straight_Legs.mp3',
          description: null,
          size: 33151,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Planks with Opposite Arm/Leg Lift': {
      id: 120,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Planks with Opposite Arm/Leg Lift',
      short_name: 'Planks with Arm/Leg Lift',
      unique_name: 'ADVANCED-Planks with Opposite Arm/Leg Lift',
      description:
        '1. Start in Plank position.\r\n2. Reach one arm out straight in front of you to shoulder height while raising the opposite leg straight back to hip height or slightly higher. Pause for a beat while keeping hips and shoulders square to the floor.\r\n3. Return to Plank position and repeat on the other side.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 252,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '064e76b65ff361e1ebb31746fc88c8c87d3b3451fa4e1eec40bf456e4837e857',
          file_name:
            'videos/064e76b65ff361e1ebb31746fc88c8c87d3b3451fa4e1eec40bf456e4837e857.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/064e76b65ff361e1ebb31746fc88c8c87d3b3451fa4e1eec40bf456e4837e857.mp4',
          name: 'CARRIE_PLANK_AROUND_THE_WORLD_ALT_3_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 156991,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 253,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'd189bb48f3543340e130d7281b3b0e6506fb36f6c2df474458b943eee2239836',
          file_name:
            'audios/d189bb48f3543340e130d7281b3b0e6506fb36f6c2df474458b943eee2239836.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d189bb48f3543340e130d7281b3b0e6506fb36f6c2df474458b943eee2239836.mp3',
          name: 'Planks_with_Opposite_Arm_and_Leg_Lift.mp3',
          description: null,
          size: 38335,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Straight Leg Bicycle Crunches': {
      id: 121,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Straight Leg Bicycle Crunches',
      short_name: 'Straight Leg Bicycle Crunches',
      unique_name: 'ADVANCED-Straight Leg Bicycle Crunches',
      description:
        '1. Lie on your back, hands behind your head and elbows out. Lift your legs straight up until they are directly over your hips.\n2. Lift your head and shoulders off the floor and bring one leg closer to your chest and lower the opposite down towards the floor to a hover. Twist your torso so your opposite elbow moves towards the closest leg.\n3. Repeat on the opposite side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 254,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '1b0f1853a5b0b80f398f34f04e0d4b67ae9db8d77a4c32e9f5ef05da3393b4d5',
          file_name:
            'videos/1b0f1853a5b0b80f398f34f04e0d4b67ae9db8d77a4c32e9f5ef05da3393b4d5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1b0f1853a5b0b80f398f34f04e0d4b67ae9db8d77a4c32e9f5ef05da3393b4d5.mp4',
          name: 'EVE_BICYCLE_CRUNCHES_ALT_2_LOOP_SMALL_720.mp4',
          description: null,
          size: 175562,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 255,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'f5459975fd9a36a865c8252b30ca5c86a5c3d1015c57d0e74873934180f133f1',
          file_name:
            'audios/f5459975fd9a36a865c8252b30ca5c86a5c3d1015c57d0e74873934180f133f1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f5459975fd9a36a865c8252b30ca5c86a5c3d1015c57d0e74873934180f133f1.mp3',
          name: 'Straight_Leg_Bicycle_Crunches.mp3',
          description: null,
          size: 31423,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Cross Leg Mountain Climbers': {
      id: 122,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Cross Leg Mountain Climbers',
      short_name: 'Cross Leg Mountain Climbers',
      unique_name: 'ADVANCED-Cross Leg Mountain Climbers',
      description:
        '1. Start in Plank position.\n2. Pull one knee up and across your body toward the opposite elbow, while the other remains extended.\n3. Jump your bent knee back and extend it into a one leg Plank position while drawing the opposite knee across your body toward the other shoulder. Repeat.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 256,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '44389d8522788f5d06a620da54b11f45dbafd8ea4143938bc54a20e0ff4843a9',
          file_name:
            'videos/44389d8522788f5d06a620da54b11f45dbafd8ea4143938bc54a20e0ff4843a9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/44389d8522788f5d06a620da54b11f45dbafd8ea4143938bc54a20e0ff4843a9.mp4',
          name: 'Eve_Cross_Leg_Mountain_Climbers-Advanced_720.mp4',
          description: null,
          size: 56026,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 257,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'ac0aea55b5919ed6059ff3d92cfa82323d3d4ea184298977e0126b48daf7c582',
          file_name:
            'audios/ac0aea55b5919ed6059ff3d92cfa82323d3d4ea184298977e0126b48daf7c582.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ac0aea55b5919ed6059ff3d92cfa82323d3d4ea184298977e0126b48daf7c582.mp3',
          name: 'Cross_Leg_Mountain_Climbers.mp3',
          description: null,
          size: 28192,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Crab Toe Touches with Two Tricep Dips': {
      id: 123,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Crab Toe Touches with Two Tricep Dips',
      short_name: 'Crab Toe Touches w. 2 Tricep Dips',
      unique_name: 'ADVANCED-Crab Toe Touches with Two Tricep Dips',
      description:
        '1. Start in a Crab Walk position with your knees bent, feet and hands on the floor, hips up.\r\n2. Bend your elbows straight back and perform two tricep dips bringing your hips closer to the floor.\r\n3. Extend your elbows and raise one leg straight up and lift the opposite arm to reach for your foot.\r\n4. Return to Crab Walk position and lift the opposite arm and leg. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 258,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '498f3556539388d937b4927f67e01c302dd52bec5b329c65b37c72b3cfcc7e9f',
          file_name:
            'videos/498f3556539388d937b4927f67e01c302dd52bec5b329c65b37c72b3cfcc7e9f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/498f3556539388d937b4927f67e01c302dd52bec5b329c65b37c72b3cfcc7e9f.mp4',
          name: 'CARRIE_CRAB_TOE_TOUCHES_1_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 210674,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 259,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e77b4e8135d59e25953321c15da8af42ba256800a0b3cfea309521fd5c60600e',
          file_name:
            'audios/e77b4e8135d59e25953321c15da8af42ba256800a0b3cfea309521fd5c60600e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e77b4e8135d59e25953321c15da8af42ba256800a0b3cfea309521fd5c60600e.mp3',
          name: 'Crab_Toe_Touches_with_Two_Tricep_Dips.mp3',
          description: null,
          size: 38624,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Star Jumps': {
      id: 124,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Star Jumps',
      short_name: 'Star Jumps',
      unique_name: 'ADVANCED-Star Jumps',
      description:
        '1. Stand with your feet close together. Keeping your chest up and heels on the ground, squat low and rest your arms lightly around your shins.\n2. From the squat, jump up in the air raising your arms overhead and straightening your legs outward to make a star shape.\n3. Bring your arms and legs together and land in the narrow squat position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 262,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'f18f6ffec39bfd7efd390830731a5d1ab8a90f3e2779f0a232be1a33598f39ff',
          file_name:
            'videos/f18f6ffec39bfd7efd390830731a5d1ab8a90f3e2779f0a232be1a33598f39ff.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f18f6ffec39bfd7efd390830731a5d1ab8a90f3e2779f0a232be1a33598f39ff.mp4',
          name: 'LOGAN_STAR_JACKS_E_2_REV_SMALL_720.mp4',
          description: null,
          size: 108229,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 263,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '007190532b794885d64eafa2e564f5b2cfe46918ce5cdd8f2be4739247f11e41',
          file_name:
            'audios/007190532b794885d64eafa2e564f5b2cfe46918ce5cdd8f2be4739247f11e41.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/007190532b794885d64eafa2e564f5b2cfe46918ce5cdd8f2be4739247f11e41.mp3',
          name: 'Star_Jumps.mp3',
          description: null,
          size: 19839,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Broad Jump Back Pedal': {
      id: 125,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Broad Jumps Back Pedal',
      short_name: 'Broad Jumps Back Pedal',
      unique_name: 'ADVANCED-Broad Jump Back Pedal',
      description:
        '1. Start with your feet about shoulder-width apart and bend your knees slightly.\n2. Lean forward, swing your arms back and use that power to jump forward as far as you can. Land soft with both feet at the same time.\n3. Staying low, take small steps backward to your starting position, then jump again.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 264,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '4ca463d32b452960552e9490bce1e25db0c6dfc14215360ae0570024b5f50191',
          file_name:
            'videos/4ca463d32b452960552e9490bce1e25db0c6dfc14215360ae0570024b5f50191.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4ca463d32b452960552e9490bce1e25db0c6dfc14215360ae0570024b5f50191.mp4',
          name: 'LOGAN_BROAD_JUMP_PEDAL_BACK_O_2_LOOP_SMALL_720.mp4',
          description: null,
          size: 185203,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 265,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '29937ac79928153b1d3e7e0c69dbaf1744f09f0d63c1437ee2430faec280e81b',
          file_name:
            'audios/29937ac79928153b1d3e7e0c69dbaf1744f09f0d63c1437ee2430faec280e81b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/29937ac79928153b1d3e7e0c69dbaf1744f09f0d63c1437ee2430faec280e81b.mp3',
          name: 'Broad_Jumps_Backpedal.mp3',
          description: null,
          size: 26527,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Skaters': {
      id: 126,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Skaters',
      short_name: 'Skaters',
      unique_name: 'ADVANCED-Skaters',
      description:
        '1. Start standing with your feet shoulder-width apart.\n2. Transfer your weight to one leg and bring the opposite leg behind you at an angle. Your back foot is off the floor.\n3. Take a big lateral jump to the side. Land on the opposite leg and bring the other one back behind you at an angle with your foot off the floor.\n4. Repeat the motion on the other side.\n5. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 266,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '5664ce3bc3dba8931ff1bf8ff6e28fa3b797105529e354144d57f00600a45d72',
          file_name:
            'videos/5664ce3bc3dba8931ff1bf8ff6e28fa3b797105529e354144d57f00600a45d72.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5664ce3bc3dba8931ff1bf8ff6e28fa3b797105529e354144d57f00600a45d72.mp4',
          name: 'Eve-Skaters-Advanced_720.mp4',
          description: null,
          size: 123173,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 267,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '5bf5314721b4474c8bdb688d4b9160eadb1d0d6da472c4291a630b1cd9c6c6b5',
          file_name:
            'audios/5bf5314721b4474c8bdb688d4b9160eadb1d0d6da472c4291a630b1cd9c6c6b5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5bf5314721b4474c8bdb688d4b9160eadb1d0d6da472c4291a630b1cd9c6c6b5.mp3',
          name: 'Skaters.mp3',
          description: null,
          size: 18112,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Snowboarder': {
      id: 127,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Snowboarder',
      short_name: 'Snowboarder',
      unique_name: 'ADVANCED-Snowboarder',
      description:
        '1. Stand with your feet wider than shoulder-width apart.\n2. Squat down and touch the ground lightly with one hand between your feet.\n3. From the squat position, jump as high as you can and rotate your body 180 degrees.\n4. Land softly into the squat position lightly touching the floor with the opposite hand.\n5. Immediately jump again and rotate 180 degrees to start position.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 268,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '04b16ac2edbd7e16fe58edfc0c2267726451ff5d9a5fa1cf8c7a9fa70aaeb19f',
          file_name:
            'videos/04b16ac2edbd7e16fe58edfc0c2267726451ff5d9a5fa1cf8c7a9fa70aaeb19f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/04b16ac2edbd7e16fe58edfc0c2267726451ff5d9a5fa1cf8c7a9fa70aaeb19f.mp4',
          name: 'Carrie-Snowboarder-Advanced_720.mp4',
          description: null,
          size: 166949,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 269,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '83572b82116c8f808024a7bcc37d159c0bdcbf612265b1cf217e8fc382e29a8b',
          file_name:
            'audios/83572b82116c8f808024a7bcc37d159c0bdcbf612265b1cf217e8fc382e29a8b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/83572b82116c8f808024a7bcc37d159c0bdcbf612265b1cf217e8fc382e29a8b.mp3',
          name: 'ADVANCED-Snowboarder-EXERCISE.mp3',
          description: null,
          size: 26712,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Knee Tuck Burpees': {
      id: 128,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Knee Tuck Burpees',
      short_name: 'Knee Tuck Burpees',
      unique_name: 'ADVANCED-Knee Tuck Burpees',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Bend your knees and hinge at your waist until you can plant your hands flat on the floor.\n3. Jump your feet back behind you to Plank position.\n4. Bend both knees and tuck jump them towards your triceps. Extend both legs back to Plank position.\n5. Sit back into a low squat position and jump up into the air, arms extend overhead. Land soft.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 270,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '02a2a89a27b271a9b29edd0c20d68b747aef38d0a62fdf1bf36ecb86a7acde42',
          file_name:
            'videos/02a2a89a27b271a9b29edd0c20d68b747aef38d0a62fdf1bf36ecb86a7acde42.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/02a2a89a27b271a9b29edd0c20d68b747aef38d0a62fdf1bf36ecb86a7acde42.mp4',
          name: 'EVE_BURPEES_3_LOOP_SMALL_720.mp4',
          description: null,
          size: 210068,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 271,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'f4624a22bae99f967149cde2e173728e486cb87b37928acb7a95278649d87d01',
          file_name:
            'audios/f4624a22bae99f967149cde2e173728e486cb87b37928acb7a95278649d87d01.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f4624a22bae99f967149cde2e173728e486cb87b37928acb7a95278649d87d01.mp3',
          name: 'Knee_Tuck_Burpees.mp3',
          description: null,
          size: 25375,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Double Pulse Squat to Tuck Jumps': {
      id: 129,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Double Pulse Squat to Tuck Jump',
      short_name: 'Double Pulse Squat to Tuck Jump',
      unique_name: 'ADVANCED-Double Pulse Squat to Tuck Jumps',
      description:
        '1  Stand with your feet about shoulder-width apart.\n2. Keeping your chest up and shoulders back, squat down as low as possible.\n3. From the low squat position, perform two, short pulsing squats.\n4. Jump straight up as high as you can, tucking your knees into your chest.\n5. Land soft and repeat.',
      preview_time: 10,
      min_app_version: 100000000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 272,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '2e60e0e1a4ad040daab7f14fb098b4b59dfc5f5460bb30d37e87776b55ac00cf',
          file_name:
            'videos/2e60e0e1a4ad040daab7f14fb098b4b59dfc5f5460bb30d37e87776b55ac00cf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2e60e0e1a4ad040daab7f14fb098b4b59dfc5f5460bb30d37e87776b55ac00cf.mp4',
          name: 'ADVANCED-Double_Pulse_Squat_to_Tuck_Jump-EXERCISE.mp4',
          description: null,
          size: 98815,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 273,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '149a2907702c98e0184391e8f7e4395217d1deca3291c0e830fab30b8e315cc2',
          file_name:
            'audios/149a2907702c98e0184391e8f7e4395217d1deca3291c0e830fab30b8e315cc2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/149a2907702c98e0184391e8f7e4395217d1deca3291c0e830fab30b8e315cc2.mp3',
          name: 'ADVANCED-Double_Pulse_Squat_to_Tuck_Jump-EXERCISE.mp3',
          description: null,
          size: 43531,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Body Weight Good Mornings-EXERCISE': {
      id: 130,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Good Mornings',
      short_name: 'Bodyw. Good Mornings',
      unique_name: 'BEGINNER-Body Weight Good Mornings-EXERCISE',
      description:
        '1. From a standing position, feet shoulder-width apart, put your hands behind your head, elbows extended out wide.\n2. With a slight bend in your knees, push your hips back and “take a bow".\n3. Pause for a beat when your torso is parallel to the floor.\n4. Return to standing position.',
      preview_time: 10,
      min_app_version: 100020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 274,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'b9884a4a07469fd0a2fb2d931da7f900a8b7ffad2684dc1518f7069e16f5599e',
          file_name:
            'videos/b9884a4a07469fd0a2fb2d931da7f900a8b7ffad2684dc1518f7069e16f5599e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b9884a4a07469fd0a2fb2d931da7f900a8b7ffad2684dc1518f7069e16f5599e.mp4',
          name: 'BEGINNER-Body-Weight-Good-Mornings-EXERCISE_720.mp4',
          description: null,
          size: 167706,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 275,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '234fe59abf1bd3e62a77d2ac8ed1946f270b08b0d88c857f205c8497aee02eed',
          file_name:
            'audios/234fe59abf1bd3e62a77d2ac8ed1946f270b08b0d88c857f205c8497aee02eed.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/234fe59abf1bd3e62a77d2ac8ed1946f270b08b0d88c857f205c8497aee02eed.mp3',
          name: 'Bodyweight_Good_Mornings.mp3',
          description: null,
          size: 28192,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Romanian Deadlifts-EXERCISE': {
      id: 131,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Romanian Deadlifts',
      short_name: 'Romanian Deadlifts',
      unique_name: 'INTERMEDIATE-Romanian Deadlifts-EXERCISE',
      description:
        '1. Hold a dumbbell in each hand, in front of your hips. Feet hip-width apart and knees slightly bent in a fixed position. Keep your chest up, shoulders back and core tight.\n2. With your back and arms straight, hinge at the hips and slide them back as you lower the dumbbells toward the floor. Stop mid-shin when you feel a good stretch in your hamstrings.\n3. Stand up straight using your hamstrings and squeeze your glutes at the top.',
      preview_time: 10,
      min_app_version: 100020000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 276,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '47a14f2546a1dc2044ca84eea458b815b3c4bea55c513f9e2c36ee176e50de90',
          file_name:
            'videos/47a14f2546a1dc2044ca84eea458b815b3c4bea55c513f9e2c36ee176e50de90.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/47a14f2546a1dc2044ca84eea458b815b3c4bea55c513f9e2c36ee176e50de90.mp4',
          name: 'INTERMEDIATE-Romanian-Deadlifts-EXERCISE_720.mp4',
          description: null,
          size: 92422,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 277,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '55831428497246ea3619d9e4411528cbac554994f50ce544451dbe51895c50f2',
          file_name:
            'audios/55831428497246ea3619d9e4411528cbac554994f50ce544451dbe51895c50f2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/55831428497246ea3619d9e4411528cbac554994f50ce544451dbe51895c50f2.mp3',
          name: 'Romanian-Dead-Lifts.mp3',
          description: null,
          size: 26527,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Romanian Deadlifts-EXERCISE': {
      id: 132,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Romanian Deadlifts',
      short_name: 'Romanian Deadlifts',
      unique_name: 'ADVANCED-Romanian Deadlifts-EXERCISE',
      description:
        '1. Hold a dumbbell in each hand, in front of your hips. Feet hip-width apart and knees slightly bent in a fixed position. Keep your chest up, shoulders back and core tight.\n2. With your back and arms straight, hinge at the hips and slide them back as you lower the dumbbells toward the floor. Stop mid-shin when you feel a good stretch in your hamstrings.\n3. Stand up straight using your hamstrings and squeeze your glutes at the top.',
      preview_time: 10,
      min_app_version: 100020000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 278,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '47a14f2546a1dc2044ca84eea458b815b3c4bea55c513f9e2c36ee176e50de90',
          file_name:
            'videos/47a14f2546a1dc2044ca84eea458b815b3c4bea55c513f9e2c36ee176e50de90.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/47a14f2546a1dc2044ca84eea458b815b3c4bea55c513f9e2c36ee176e50de90.mp4',
          name: 'INTERMEDIATE-Romanian-Deadlifts-EXERCISE_720.mp4',
          description: null,
          size: 92422,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 279,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '55831428497246ea3619d9e4411528cbac554994f50ce544451dbe51895c50f2',
          file_name:
            'audios/55831428497246ea3619d9e4411528cbac554994f50ce544451dbe51895c50f2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/55831428497246ea3619d9e4411528cbac554994f50ce544451dbe51895c50f2.mp3',
          name: 'Romanian-Dead-Lifts.mp3',
          description: null,
          size: 26527,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Plank Shoulder Taps-EXERCISE': {
      id: 133,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Plank Shoulder Taps',
      short_name: 'Plank Shoulder Taps',
      unique_name: 'INTERMEDIATE-Plank Shoulder Taps-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Keeping your hips and shoulders square to the floor, lift one hand off the ground and tap the opposite shoulder.\n3. Return to Plank position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 280,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '9e8e811ee8ffdc8113d1b7550ce137173b8326499a99b48988603edf8b67ade4',
          file_name:
            'videos/9e8e811ee8ffdc8113d1b7550ce137173b8326499a99b48988603edf8b67ade4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9e8e811ee8ffdc8113d1b7550ce137173b8326499a99b48988603edf8b67ade4.mp4',
          name: 'INTERMEDIATE-Plank-Shoulder-Taps-EXERCISE_720.mp4',
          description: null,
          size: 67962,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 281,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '3e214ef90f2c1d374fff4a41008b6749a964faac737a1f55b0b83d441066f6fe',
          file_name:
            'audios/3e214ef90f2c1d374fff4a41008b6749a964faac737a1f55b0b83d441066f6fe.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3e214ef90f2c1d374fff4a41008b6749a964faac737a1f55b0b83d441066f6fe.mp3',
          name: 'Plank-Shoulder-Taps.mp3',
          description: null,
          size: 23295,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Super Planks with Pop-Up-EXERCISE': {
      id: 134,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Plank Pop-Ups',
      short_name: 'Plank Pop-Ups',
      unique_name: 'ADVANCED-Super Planks with Pop-Up-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Lower to your forearms one at a time, keeping your elbows under your shoulders. Brace your core.\n3. Explosively drive through your forearms to lift both hands off the floor.\n4. Extend your elbows. Land in Plank position with your palms directly under your shoulders.',
      preview_time: 10,
      min_app_version: 100020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 284,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '8a6aa2f61c548b1cacd8cae3be6eeea72bf8019dd8053ac6cb24186b9946dac0',
          file_name:
            'videos/8a6aa2f61c548b1cacd8cae3be6eeea72bf8019dd8053ac6cb24186b9946dac0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8a6aa2f61c548b1cacd8cae3be6eeea72bf8019dd8053ac6cb24186b9946dac0.mp4',
          name: 'ADVANCED-Super-Planks-with-Pop-Up-EXERCISE_720.mp4',
          description: null,
          size: 82500,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 285,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'd9dbcce560dd47d8a7de9684cb82d761e968c717a2caae5280c9c110f6432bc5',
          file_name:
            'audios/d9dbcce560dd47d8a7de9684cb82d761e968c717a2caae5280c9c110f6432bc5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d9dbcce560dd47d8a7de9684cb82d761e968c717a2caae5280c9c110f6432bc5.mp3',
          name: 'Plank_Pop_Ups.mp3',
          description: null,
          size: 21595,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Super Planks-EXERCISE': {
      id: 135,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Super Planks',
      short_name: 'Super Planks',
      unique_name: 'ADVANCED-Super Planks-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Lower down to your forearms one at a time, keeping your elbows under your shoulders.\n3. Starting with the arm you began with, place your hand on the floor exactly where your elbow was and straighten your arm. Repeat on the other side and return to Plank position. Move your body in one piece and avoid twisting your hips.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 286,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'a9e03dbb1e526f641a85b324aac976acb1893c7eb96ae6c0382201915d954350',
          file_name:
            'videos/a9e03dbb1e526f641a85b324aac976acb1893c7eb96ae6c0382201915d954350.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a9e03dbb1e526f641a85b324aac976acb1893c7eb96ae6c0382201915d954350.mp4',
          name: 'ADVANCED-Super-Planks-EXERCISE_720.mp4',
          description: null,
          size: 190217,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 287,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '8f4d354ecdad65f3528d270758934d3a354aa71ee7ddc6d64f86fa97a8948722',
          file_name:
            'audios/8f4d354ecdad65f3528d270758934d3a354aa71ee7ddc6d64f86fa97a8948722.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8f4d354ecdad65f3528d270758934d3a354aa71ee7ddc6d64f86fa97a8948722.mp3',
          name: 'Super-Planks.mp3',
          description: null,
          size: 20991,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Plank Shoulder Taps-EXERCISE': {
      id: 136,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Plank Shoulder Taps',
      short_name: 'Plank Shoulder Taps',
      unique_name: 'ADVANCED-Plank Shoulder Taps-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Keeping your hips and shoulders square to the floor, lift one hand off the ground and tap the opposite shoulder.\n3. Return to Plank position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 282,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '9e8e811ee8ffdc8113d1b7550ce137173b8326499a99b48988603edf8b67ade4',
          file_name:
            'videos/9e8e811ee8ffdc8113d1b7550ce137173b8326499a99b48988603edf8b67ade4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9e8e811ee8ffdc8113d1b7550ce137173b8326499a99b48988603edf8b67ade4.mp4',
          name: 'INTERMEDIATE-Plank-Shoulder-Taps-EXERCISE_720.mp4',
          description: null,
          size: 67962,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 283,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '3e214ef90f2c1d374fff4a41008b6749a964faac737a1f55b0b83d441066f6fe',
          file_name:
            'audios/3e214ef90f2c1d374fff4a41008b6749a964faac737a1f55b0b83d441066f6fe.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3e214ef90f2c1d374fff4a41008b6749a964faac737a1f55b0b83d441066f6fe.mp3',
          name: 'Plank-Shoulder-Taps.mp3',
          description: null,
          size: 23295,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Five Fast Feet and Jump-EXERCISE': {
      id: 137,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Five Fast Feet to Tuck Jump',
      short_name: 'Five Fast Feet to Tuck Jump',
      unique_name: 'INTERMEDIATE-Five Fast Feet and Jump-EXERCISE',
      description:
        '1. Start standing with your feet a little wider than hip-width apart and knees slightly bent.\n2. Take five tiny fast running steps in place.\n3. Jump as high as you can while tucking both knees to your chest. Land soft.',
      preview_time: 10,
      min_app_version: 100020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 288,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'fe2a727358d2a3e769be5aac64e31195e71826efe7850b6767ae5dca3f9cfe04',
          file_name:
            'videos/fe2a727358d2a3e769be5aac64e31195e71826efe7850b6767ae5dca3f9cfe04.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fe2a727358d2a3e769be5aac64e31195e71826efe7850b6767ae5dca3f9cfe04.mp4',
          name: 'INTERMEDIATE-Five-Fast-Feet-and-Jump-EXERCISE_720.mp4',
          description: null,
          size: 120860,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 289,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d',
          file_name:
            'audios/53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d.mp3',
          name: 'Five_Fast_Feet_to_Tuck_Jump.mp3',
          description: null,
          size: 32863,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Five Fast Feet and Jump-EXERCISE': {
      id: 138,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Five Fast Feet to Tuck Jump',
      short_name: 'Five Fast Feet to Tuck Jump',
      unique_name: 'ADVANCED-Five Fast Feet and Jump-EXERCISE',
      description:
        '1. Start standing with your feet a little wider than hip-width apart and knees slightly bent.\n2. Take five tiny fast running steps in place.\n3. Jump as high as you can while tucking both knees to your chest. Land soft.',
      preview_time: 10,
      min_app_version: 100020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 290,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'fe2a727358d2a3e769be5aac64e31195e71826efe7850b6767ae5dca3f9cfe04',
          file_name:
            'videos/fe2a727358d2a3e769be5aac64e31195e71826efe7850b6767ae5dca3f9cfe04.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fe2a727358d2a3e769be5aac64e31195e71826efe7850b6767ae5dca3f9cfe04.mp4',
          name: 'INTERMEDIATE-Five-Fast-Feet-and-Jump-EXERCISE_720.mp4',
          description: null,
          size: 120860,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 291,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d',
          file_name:
            'audios/53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/53a22e6d90dcfdf679449f158c8f5e829a4eec5d7aba2f4fee51e8d23cf2b70d.mp3',
          name: 'Five_Fast_Feet_to_Tuck_Jump.mp3',
          description: null,
          size: 32863,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Plank Jack Shoulder Taps-EXERCISE': {
      id: 139,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Plank Jack Shoulder Taps',
      short_name: 'Plank Jack Shoulder Taps',
      unique_name: 'ADVANCED-Plank Jack Shoulder Taps-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Keeping your hips and shoulders square to the floor, lift one hand off the ground and tap the opposite shoulder.\n3. Return to Plank position. Repeat with the other hand.\n4. Jack your feet out into a wide "V" then back into start position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 292,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'fb5dfeb2096cc7db8ab72123e2ac5b4f861515b5d2e082509a91eac533f04092',
          file_name:
            'videos/fb5dfeb2096cc7db8ab72123e2ac5b4f861515b5d2e082509a91eac533f04092.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fb5dfeb2096cc7db8ab72123e2ac5b4f861515b5d2e082509a91eac533f04092.mp4',
          name: 'CARRIE-Plank-Shoulder-Taps-EXERCISE_720.mp4',
          description: null,
          size: 118208,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 293,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'bce28d524c9d489e989dfa71279a99c47db188220f0193fdca174e685b56317e',
          file_name:
            'audios/bce28d524c9d489e989dfa71279a99c47db188220f0193fdca174e685b56317e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/bce28d524c9d489e989dfa71279a99c47db188220f0193fdca174e685b56317e.mp3',
          name: 'Plank_Jack_Shoulder_Taps.mp3',
          description: null,
          size: 27103,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    "INTERMEDIATE-Carrie's Burpees-EXERCISE": {
      id: 140,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: "Carrie's Burpees",
      short_name: "Carrie's Burpees",
      unique_name: "INTERMEDIATE-Carrie's Burpees-EXERCISE",
      description:
        '1. Stand with your feet shoulder-width apart.\n2. Bend your knees and hinge at your waist until you can plant your hands on the floor.\n3. Jump your feet behind you to Plank position and lower yourself to the floor.\n4. Press up to Plank and jump your feet back in, shoulder-width apart, heels on the ground.\n5. Sit back into a low squat position. Jump straight up tapping your heels. Land soft.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 294,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'f199d835eb4f685429992896d38e0b7f731a887be369ea53c5ddf04fa7a26554',
          file_name:
            'videos/f199d835eb4f685429992896d38e0b7f731a887be369ea53c5ddf04fa7a26554.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f199d835eb4f685429992896d38e0b7f731a887be369ea53c5ddf04fa7a26554.mp4',
          name: 'CARRIE_BURPEE_1_FULL_REP_LOOP_15_percent_Slower_small_720.mp4',
          description: null,
          size: 184085,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 295,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'a3cec936eaa9a33efcdcdc7eafdd78b88499d4434309e60e480300bbafd18721',
          file_name:
            'audios/a3cec936eaa9a33efcdcdc7eafdd78b88499d4434309e60e480300bbafd18721.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a3cec936eaa9a33efcdcdc7eafdd78b88499d4434309e60e480300bbafd18721.mp3',
          name: 'Carries_Burpees.mp3',
          description: null,
          size: 23872,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    "ADVANCED-Carrie's Burpees-EXERCISE": {
      id: 141,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: "Carrie's Burpees",
      short_name: "Carrie's Burpees",
      unique_name: "ADVANCED-Carrie's Burpees-EXERCISE",
      description:
        '1. Stand with your feet shoulder-width apart.\n2. Bend your knees and hinge at your waist until you can plant your hands on the floor.\n3. Jump your feet behind you to Plank position and lower yourself to the floor.\n4. Press up to Plank and jump your feet back in, shoulder-width apart, heels on the ground.\n5. Sit back into a low squat position. Jump straight up tapping your heels. Land soft.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 296,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'f199d835eb4f685429992896d38e0b7f731a887be369ea53c5ddf04fa7a26554',
          file_name:
            'videos/f199d835eb4f685429992896d38e0b7f731a887be369ea53c5ddf04fa7a26554.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f199d835eb4f685429992896d38e0b7f731a887be369ea53c5ddf04fa7a26554.mp4',
          name: 'CARRIE_BURPEE_1_FULL_REP_LOOP_15_percent_Slower_small_720.mp4',
          description: null,
          size: 184085,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 297,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'a3cec936eaa9a33efcdcdc7eafdd78b88499d4434309e60e480300bbafd18721',
          file_name:
            'audios/a3cec936eaa9a33efcdcdc7eafdd78b88499d4434309e60e480300bbafd18721.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a3cec936eaa9a33efcdcdc7eafdd78b88499d4434309e60e480300bbafd18721.mp3',
          name: 'Carries_Burpees.mp3',
          description: null,
          size: 23872,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Tricep Floor Dips-EXERCISE': {
      id: 142,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Tricep Floor Dips',
      short_name: 'Tricep Floor Dips',
      unique_name: 'BEGINNER-Tricep Floor Dips-EXERCISE',
      description:
        '1. Start seated with your knees bent and feet on the floor. Place your  hands behind you under your shoulders, fingers point toward your body. Lift your hips up to Crab Walk position.\n2. Bend your elbows straight back and lower your hips to the floor.\n3. Extend your elbows and return to Crab Walk position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: true,
      equipment: [],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 298,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '94273cd8bea923c65f800c79453aac25ad4639f60cdbeb3bdeeedbae7f9c637a',
          file_name:
            'videos/94273cd8bea923c65f800c79453aac25ad4639f60cdbeb3bdeeedbae7f9c637a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/94273cd8bea923c65f800c79453aac25ad4639f60cdbeb3bdeeedbae7f9c637a.mp4',
          name: 'TRUDIE_016_TRICEP_FLOOR_DIPS_1_small_720.mp4',
          description: null,
          size: 53562,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 299,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'b77cda59e18a6ba586b0aadc5f8f0093da49ecd7bf145872a544ae455f0dbb18',
          file_name:
            'audios/b77cda59e18a6ba586b0aadc5f8f0093da49ecd7bf145872a544ae455f0dbb18.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b77cda59e18a6ba586b0aadc5f8f0093da49ecd7bf145872a544ae455f0dbb18.mp3',
          name: 'TricepFloorDips.mp3',
          description: null,
          size: 25915,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Wide Push-ups from Knees-EXERCISE': {
      id: 143,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Wide Push-Ups from Knees',
      short_name: 'Wide Push-Ups from Knees',
      unique_name: 'BEGINNER-Wide Push-ups from Knees-EXERCISE',
      description:
        '1. Start in Plank position with your hands wider than shoulder-width apart. Drop your knees straight down to the floor and lift feet up.\n2. Bend your elbows out to the side and point them back toward your hips. Lower your body toward the floor. Your elbows should resemble an arrow rather than a "T" at the bottom position.\n3. Straighten your arms and raise your body up in one long line.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 300,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'ddadb224b4bba373d929942885ac104fd22ed36b252cf91eda844c95888b974b',
          file_name:
            'videos/ddadb224b4bba373d929942885ac104fd22ed36b252cf91eda844c95888b974b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ddadb224b4bba373d929942885ac104fd22ed36b252cf91eda844c95888b974b.mp4',
          name: 'TRUDIE_005b_KNEE_WIDE_PUSHUPS_1_small_720.mp4',
          description: null,
          size: 74448,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 301,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '762191694b936255da08fbedbb6ac7797d700a31e8c74a34dcaa89786f2f025f',
          file_name:
            'audios/762191694b936255da08fbedbb6ac7797d700a31e8c74a34dcaa89786f2f025f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/762191694b936255da08fbedbb6ac7797d700a31e8c74a34dcaa89786f2f025f.mp3',
          name: 'WidePushUpsFromKnees.mp3',
          description: null,
          size: 32166,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Wide Push-ups-EXERCISE': {
      id: 144,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Wide Push-Ups',
      short_name: 'Wide Push-Ups',
      unique_name: 'INTERMEDIATE-Wide Push-ups-EXERCISE',
      description:
        '1. Start in Plank position with your hands wider than shoulder-width apart.\n2. Bend your elbows out to the side and point them back toward your hips. Lower your body toward the floor. Your elbows should resemble an arrow rather than a "T" at the bottom position.\n3. Straighten your arms and raise your body up in one long line.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 302,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'c7071c69138a6fa0ff1c445d1e8aeb1ed9eca19bd271ee0a4fe877ba99e3f92d',
          file_name:
            'videos/c7071c69138a6fa0ff1c445d1e8aeb1ed9eca19bd271ee0a4fe877ba99e3f92d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c7071c69138a6fa0ff1c445d1e8aeb1ed9eca19bd271ee0a4fe877ba99e3f92d.mp4',
          name: 'TRUDIE_005c_WIDE_PUSHUPS_2_small_720.mp4',
          description: null,
          size: 75153,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 303,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '42836ad8e7d23888ee388fb4f1ed178aff5ba767673d52b31022222ba142c72f',
          file_name:
            'audios/42836ad8e7d23888ee388fb4f1ed178aff5ba767673d52b31022222ba142c72f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/42836ad8e7d23888ee388fb4f1ed178aff5ba767673d52b31022222ba142c72f.mp3',
          name: 'WidePushUps.mp3',
          description: null,
          size: 23612,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Wide Push-ups-EXERCISE': {
      id: 145,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Wide Push-Ups',
      short_name: 'Wide Push-Ups',
      unique_name: 'ADVANCED-Wide Push-ups-EXERCISE',
      description:
        '1. Start in Plank position with your hands wider than shoulder-width apart.\n2. Bend your elbows out to the side and point them back toward your hips. Lower your body toward the floor. Your elbows should resemble an arrow rather than a "T" at the bottom position.\n3. Straighten your arms and raise your body up in one long line.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 304,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'c7071c69138a6fa0ff1c445d1e8aeb1ed9eca19bd271ee0a4fe877ba99e3f92d',
          file_name:
            'videos/c7071c69138a6fa0ff1c445d1e8aeb1ed9eca19bd271ee0a4fe877ba99e3f92d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c7071c69138a6fa0ff1c445d1e8aeb1ed9eca19bd271ee0a4fe877ba99e3f92d.mp4',
          name: 'TRUDIE_005c_WIDE_PUSHUPS_2_small_720.mp4',
          description: null,
          size: 75153,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 305,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '42836ad8e7d23888ee388fb4f1ed178aff5ba767673d52b31022222ba142c72f',
          file_name:
            'audios/42836ad8e7d23888ee388fb4f1ed178aff5ba767673d52b31022222ba142c72f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/42836ad8e7d23888ee388fb4f1ed178aff5ba767673d52b31022222ba142c72f.mp3',
          name: 'WidePushUps.mp3',
          description: null,
          size: 23612,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Overhead Tricep Extensions-EXERCISE': {
      id: 146,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Overhead Tricep Extensions',
      short_name: 'Overh. Tricep Extensions',
      unique_name: 'INTERMEDIATE-Overhead Tricep Extensions-EXERCISE',
      description:
        '1. Start standing with your feet shoulder-width apart, core tight and hold one dumbbell vertically in both hands.\n2. Lift the dumbbell overhead until your arms are fully extended, palms face the ceiling and elbows pointing forward.\n3. Bend your elbows and lower the dumbbell behind your head until your arms are just lower than 90 degrees.\n4. Extend your arms and return to starting position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 306,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '98618093aaf49143c5bbd880df207a09e013d0d7ad370230a666354cc802e02e',
          file_name:
            'videos/98618093aaf49143c5bbd880df207a09e013d0d7ad370230a666354cc802e02e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/98618093aaf49143c5bbd880df207a09e013d0d7ad370230a666354cc802e02e.mp4',
          name: '010_OVERHEAD_TRICEP_EXTENSIONS_1_2_30percent_small_720.mp4',
          description: null,
          size: 60082,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 307,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '166114ed9ee22b9a851695df8941ab6121ddaa246dbee69638920f0a74a6f92e',
          file_name:
            'audios/166114ed9ee22b9a851695df8941ab6121ddaa246dbee69638920f0a74a6f92e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/166114ed9ee22b9a851695df8941ab6121ddaa246dbee69638920f0a74a6f92e.mp3',
          name: 'INT-ADV-Overhead_Tricep_Extensions-EXERCISE.mp3',
          description: null,
          size: 33703,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Overhead Tricep Extensions-EXERCISE': {
      id: 147,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Overhead Tricep Extensions',
      short_name: 'Overh. Tricep Extensions',
      unique_name: 'ADVANCED-Overhead Tricep Extensions-EXERCISE',
      description:
        '1. Start standing with your feet shoulder-width apart, core tight and hold one dumbbell vertically in both hands.\n2. Lift the dumbbell overhead until your arms are fully extended, palms face the ceiling and elbows pointing forward.\n3. Bend your elbows and lower the dumbbell behind your head until your arms are just lower than 90 degrees.\n4. Extend your arms and return to starting position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 308,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '98618093aaf49143c5bbd880df207a09e013d0d7ad370230a666354cc802e02e',
          file_name:
            'videos/98618093aaf49143c5bbd880df207a09e013d0d7ad370230a666354cc802e02e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/98618093aaf49143c5bbd880df207a09e013d0d7ad370230a666354cc802e02e.mp4',
          name: '010_OVERHEAD_TRICEP_EXTENSIONS_1_2_30percent_small_720.mp4',
          description: null,
          size: 60082,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 309,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '166114ed9ee22b9a851695df8941ab6121ddaa246dbee69638920f0a74a6f92e',
          file_name:
            'audios/166114ed9ee22b9a851695df8941ab6121ddaa246dbee69638920f0a74a6f92e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/166114ed9ee22b9a851695df8941ab6121ddaa246dbee69638920f0a74a6f92e.mp3',
          name: 'INT-ADV-Overhead_Tricep_Extensions-EXERCISE.mp3',
          description: null,
          size: 33703,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Alternating Hammer Curls-EXERCISE': {
      id: 148,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Alternating Hammer Curls',
      short_name: 'Alt. Hammer Curls',
      unique_name: 'INTERMEDIATE-Alternating Hammer Curls-EXERCISE',
      description:
        '1. Start standing with your arms by your sides and a dumbbell in each hand. Palms face each other.\n2. Keep your elbows close to your ribcage and curl one weight up toward your shoulder. Dumbbell stays vertical.\n3. Lower the weight back to the starting position.\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 310,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'ca44999aa6f1d0426ed23c99b69e460c3ffd0c4570d2163c339966f3b48cae68',
          file_name:
            'videos/ca44999aa6f1d0426ed23c99b69e460c3ffd0c4570d2163c339966f3b48cae68.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ca44999aa6f1d0426ed23c99b69e460c3ffd0c4570d2163c339966f3b48cae68.mp4',
          name: '007_ALTERNATING_HAMMER_CURL_3_15percent_plus_30percent_small_720.mp4',
          description: null,
          size: 120354,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 311,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '1be11a503af47b3343406582bf666b4a7712fee8ce2b28cea96ce21370af0af9',
          file_name:
            'audios/1be11a503af47b3343406582bf666b4a7712fee8ce2b28cea96ce21370af0af9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1be11a503af47b3343406582bf666b4a7712fee8ce2b28cea96ce21370af0af9.mp3',
          name: 'AlternatingHammerCurls.mp3',
          description: null,
          size: 28508,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Alternating Hammer Curls-EXERCISE': {
      id: 149,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Alternating Hammer Curls',
      short_name: 'Alt. Hammer Curls',
      unique_name: 'ADVANCED-Alternating Hammer Curls-EXERCISE',
      description:
        '1. Start standing with your arms by your sides and a dumbbell in each hand. Palms face each other.\n2. Keep your elbows close to your ribcage and curl one weight up toward your shoulder. Dumbbell stays vertical.\n3. Lower the weight back to the starting position.\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 312,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'ca44999aa6f1d0426ed23c99b69e460c3ffd0c4570d2163c339966f3b48cae68',
          file_name:
            'videos/ca44999aa6f1d0426ed23c99b69e460c3ffd0c4570d2163c339966f3b48cae68.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ca44999aa6f1d0426ed23c99b69e460c3ffd0c4570d2163c339966f3b48cae68.mp4',
          name: '007_ALTERNATING_HAMMER_CURL_3_15percent_plus_30percent_small_720.mp4',
          description: null,
          size: 120354,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 313,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '1be11a503af47b3343406582bf666b4a7712fee8ce2b28cea96ce21370af0af9',
          file_name:
            'audios/1be11a503af47b3343406582bf666b4a7712fee8ce2b28cea96ce21370af0af9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1be11a503af47b3343406582bf666b4a7712fee8ce2b28cea96ce21370af0af9.mp3',
          name: 'AlternatingHammerCurls.mp3',
          description: null,
          size: 28508,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Triple Crush-EXERCISE': {
      id: 150,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Triple Crush',
      short_name: 'Triple Crush',
      unique_name: 'INTERMEDIATE-Triple Crush-EXERCISE',
      description:
        '1. Stand with feet wider than shoulder-width apart, toes pointed slightly out. With both hands, hold one dumbbell horizontally at the center of your chest.\n2. Squat down and lower the dumbbell toward the floor. Rest elbows inside your knees.\n3. At the bottom of the squat, perform 1/2 of a bicep curl bringing the dumbbell toward your shoulders.\n4. Return to standing and raise the dumbbell overhead, elbows forward.\n5. Bend both elbows and lower the dumbbell behind your head. Straighten arms and return to start.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 314,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '759e8108bb39902e1a524bbc41e15641c365385f43b7409b135b516d6a061a06',
          file_name:
            'videos/759e8108bb39902e1a524bbc41e15641c365385f43b7409b135b516d6a061a06.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/759e8108bb39902e1a524bbc41e15641c365385f43b7409b135b516d6a061a06.mp4',
          name: 'TRUDIE_008_TRIPLE_CRUSH_3_small_720.mp4',
          description: null,
          size: 235755,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 315,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '50c863e0e7efa2b8ee594e854e3a239f1c0fecac2b60437be762b54f95a9b519',
          file_name:
            'audios/50c863e0e7efa2b8ee594e854e3a239f1c0fecac2b60437be762b54f95a9b519.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/50c863e0e7efa2b8ee594e854e3a239f1c0fecac2b60437be762b54f95a9b519.mp3',
          name: 'INT-ADV-Triple_Crush-EXERCISE.mp3',
          description: null,
          size: 22470,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Triple Crush-EXERCISE': {
      id: 151,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Triple Crush',
      short_name: 'Triple Crush',
      unique_name: 'ADVANCED-Triple Crush-EXERCISE',
      description:
        '1. Stand with feet wider than shoulder-width apart, toes pointed slightly out. With both hands, hold one dumbbell horizontally at the center of your chest.\n2. Squat down and lower the dumbbell toward the floor. Rest elbows inside your knees.\n3. At the bottom of the squat, perform 1/2 of a bicep curl bringing the dumbbell toward your shoulders.\n4. Return to standing and raise the dumbbell overhead, elbows forward.\n5. Bend both elbows and lower the dumbbell behind your head. Straighten arms and return to start.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 316,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '759e8108bb39902e1a524bbc41e15641c365385f43b7409b135b516d6a061a06',
          file_name:
            'videos/759e8108bb39902e1a524bbc41e15641c365385f43b7409b135b516d6a061a06.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/759e8108bb39902e1a524bbc41e15641c365385f43b7409b135b516d6a061a06.mp4',
          name: 'TRUDIE_008_TRIPLE_CRUSH_3_small_720.mp4',
          description: null,
          size: 235755,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 317,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '50c863e0e7efa2b8ee594e854e3a239f1c0fecac2b60437be762b54f95a9b519',
          file_name:
            'audios/50c863e0e7efa2b8ee594e854e3a239f1c0fecac2b60437be762b54f95a9b519.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/50c863e0e7efa2b8ee594e854e3a239f1c0fecac2b60437be762b54f95a9b519.mp3',
          name: 'INT-ADV-Triple_Crush-EXERCISE.mp3',
          description: null,
          size: 22470,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating Glute Kickbacks-EXERCISE': {
      id: 152,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Glute Kickbacks',
      short_name: 'Alternating Glute Kickbacks',
      unique_name: 'BEGINNER-Alternating Glute Kickbacks-EXERCISE',
      description:
        '1. Start on all fours with your shoulders over your wrists and knees under your hips.\n2. Keeping your hips square and core tight, extend one leg straight back behind you, toes point toward the floor. Do not arch your lower back.\n3. Return to start position.\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 318,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '754a14dba11d58ca78d00bf2b5f7bbf29bf462239ef5badadc7a74c452f4b996',
          file_name:
            'videos/754a14dba11d58ca78d00bf2b5f7bbf29bf462239ef5badadc7a74c452f4b996.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/754a14dba11d58ca78d00bf2b5f7bbf29bf462239ef5badadc7a74c452f4b996.mp4',
          name: 'TRUDIE_006_ALTERNATING_GLUTE_KICKBACKS_1_small_720.mp4',
          description: null,
          size: 157262,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 319,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'd5088c2751bc520a60041fd69efb03285ed2fef8870a7789a2cb4e13f893373c',
          file_name:
            'audios/d5088c2751bc520a60041fd69efb03285ed2fef8870a7789a2cb4e13f893373c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d5088c2751bc520a60041fd69efb03285ed2fef8870a7789a2cb4e13f893373c.mp3',
          name: 'AlternatingGluteKickbacks.mp3',
          description: null,
          size: 31388,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Hip Thrusts-EXERCISE': {
      id: 153,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Hip Thrusts',
      short_name: 'Hip Thrusts',
      unique_name: 'INTERMEDIATE-Hip Thrusts-EXERCISE',
      description:
        '1. Place your upper back on the bench, just below your shoulder blades. Keep feet on the floor, hip-width apart under your knees.\n2. Hold a dumbbell horizontally below your hip bones. Keep core tight, chin slightly tucked.\n3. Drive through your heels and push hips up until your thighs and shins are at 90 degrees.\n4. Lower your hips back down.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 320,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: 'ba2b4c033cf387a2020ead45fa395ace8a556ea91fc4379b15aae38b62b0ec6f',
          file_name:
            'videos/ba2b4c033cf387a2020ead45fa395ace8a556ea91fc4379b15aae38b62b0ec6f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ba2b4c033cf387a2020ead45fa395ace8a556ea91fc4379b15aae38b62b0ec6f.mp4',
          name: 'INT-ADV-Hip_Thrusts-EXERCISE.mp4',
          description: null,
          size: 91780,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 321,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '8cad07410373af261e79c05af9e751aadaec487f20437710d97d67728bf45db5',
          file_name:
            'audios/8cad07410373af261e79c05af9e751aadaec487f20437710d97d67728bf45db5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8cad07410373af261e79c05af9e751aadaec487f20437710d97d67728bf45db5.mp3',
          name: 'HipThrusts.mp3',
          description: null,
          size: 20732,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Hip Thrusts-EXERCISE': {
      id: 154,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Hip Thrusts',
      short_name: 'Hip Thrusts',
      unique_name: 'ADVANCED-Hip Thrusts-EXERCISE',
      description:
        '1. Place your upper back on the bench, just below your shoulder blades. Keep feet on the floor, hip-width apart under your knees.\n2. Hold a dumbbell horizontally below your hip bones. Keep core tight, chin slightly tucked.\n3. Drive through your heels and push hips up until your thighs and shins are at 90 degrees.\n4. Lower your hips back down.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 322,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: 'ba2b4c033cf387a2020ead45fa395ace8a556ea91fc4379b15aae38b62b0ec6f',
          file_name:
            'videos/ba2b4c033cf387a2020ead45fa395ace8a556ea91fc4379b15aae38b62b0ec6f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ba2b4c033cf387a2020ead45fa395ace8a556ea91fc4379b15aae38b62b0ec6f.mp4',
          name: 'INT-ADV-Hip_Thrusts-EXERCISE.mp4',
          description: null,
          size: 91780,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 323,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '8cad07410373af261e79c05af9e751aadaec487f20437710d97d67728bf45db5',
          file_name:
            'audios/8cad07410373af261e79c05af9e751aadaec487f20437710d97d67728bf45db5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8cad07410373af261e79c05af9e751aadaec487f20437710d97d67728bf45db5.mp3',
          name: 'HipThrusts.mp3',
          description: null,
          size: 20732,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Glute Bridges-EXERCISE': {
      id: 155,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Glute Bridges',
      short_name: 'Glute Bridges',
      unique_name: 'BEGINNER-Glute Bridges-EXERCISE',
      description:
        "1. Lay on your back with your knees bent, hip-width apart and feet flat on the floor. Keep your arms at your sides, palms down.\n2. Keep your upper back on the floor and drive through your heels to raise your hip as high as possible without arching your back. Keep knees aligned so they don't splay out or buckle in.\n3. Lower with control back to start position.",
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 324,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '3f9c92a2c3f691839f480a069a5474ca560331ddf2b8462ca91d3636ef5e365a',
          file_name:
            'videos/3f9c92a2c3f691839f480a069a5474ca560331ddf2b8462ca91d3636ef5e365a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3f9c92a2c3f691839f480a069a5474ca560331ddf2b8462ca91d3636ef5e365a.mp4',
          name: 'TRUDIE_027_GLUTE_BRIDGES_1_small_720.mp4',
          description: null,
          size: 53790,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 325,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'b8ef747e7b2dcbec912d65919c9d8d919c6ddfb73a0b936ea51ae81ad948bb75',
          file_name:
            'audios/b8ef747e7b2dcbec912d65919c9d8d919c6ddfb73a0b936ea51ae81ad948bb75.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b8ef747e7b2dcbec912d65919c9d8d919c6ddfb73a0b936ea51ae81ad948bb75.mp3',
          name: 'GluteBridges.mp3',
          description: null,
          size: 22172,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Hammer Curl to Wide Curl-EXERCISE': {
      id: 156,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bodyweight Hammer Curl to Wide Curl',
      short_name: 'Bodyweight Hammer Curl to Wide Curl',
      unique_name: 'BEGINNER-Bodyweight Hammer Curl to Wide Curl-EXERCISE',
      description:
        '1. Stand with your fists by your sides, palms facing each other.\n2. Keep your elbows close to your ribcage and curl your arms up toward your shoulders, knuckles face the ceiling. Lower your arms back to start position.\n3. Rotate your palms up and curl your arms out to the side, fists toward your shoulders. Return to start position.\n4. Both motions are one rep.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 326,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '7b2ae0aef6eee6e9266ffaaa2f9e63803e2a00d7f338b97a96a94703e3d7053b',
          file_name:
            'videos/7b2ae0aef6eee6e9266ffaaa2f9e63803e2a00d7f338b97a96a94703e3d7053b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7b2ae0aef6eee6e9266ffaaa2f9e63803e2a00d7f338b97a96a94703e3d7053b.mp4',
          name: 'PHIL_015_BODY_WEIGHT_HAMMER_CURL_TO_WIDE_CURL_1_small_720.mp4',
          description: null,
          size: 96514,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 327,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'e127cd0e1fb8e0bf17d9b1c4a183ccf0b2a658532cdb2354c94cdc627673d19d',
          file_name:
            'audios/e127cd0e1fb8e0bf17d9b1c4a183ccf0b2a658532cdb2354c94cdc627673d19d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e127cd0e1fb8e0bf17d9b1c4a183ccf0b2a658532cdb2354c94cdc627673d19d.mp3',
          name: 'BEGINNER-Bodyweight_Hammer_Curl_to_Wide_Curl-EXERCISE.mp3',
          description: null,
          size: 44581,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Tricep Kickbacks-EXERCISE': {
      id: 157,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bodyweight Tricep Kickbacks',
      short_name: 'Bodyweight Tricep Kicks',
      unique_name: 'BEGINNER-Bodyweight Tricep Kickbacks-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, knees slightly bent, core tight.\r\n2. Hinge at the waist until your torso is close to parallel to the floor. Bend your elbows back behind you to 90 degrees. Bring your fists to your hips, palms in.\r\n3. Extend your elbows and lift your fists up and back behind you as you straighten your arms.\r\n4. Lower your fists back down to start position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 328,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'fc60a8adb3eda77fa0e43c05d8251a2d9bc83d0ba44f2b731b9c64270fe1adb2',
          file_name:
            'videos/fc60a8adb3eda77fa0e43c05d8251a2d9bc83d0ba44f2b731b9c64270fe1adb2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fc60a8adb3eda77fa0e43c05d8251a2d9bc83d0ba44f2b731b9c64270fe1adb2.mp4',
          name: 'PHIL_016_BODY_WEIGHT_TRICEP_KICKBACKS_1_small_720.mp4',
          description: null,
          size: 57383,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 329,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '70cf5017756f2c79ee962c3b2fe40959e161fce590a67da92d53966fa869ee55',
          file_name:
            'audios/70cf5017756f2c79ee962c3b2fe40959e161fce590a67da92d53966fa869ee55.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/70cf5017756f2c79ee962c3b2fe40959e161fce590a67da92d53966fa869ee55.mp3',
          name: 'BodyweightTricepKickbacks.mp3',
          description: null,
          size: 34269,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Triple Crush-EXERCISE': {
      id: 158,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bodyweight Triple Crush',
      short_name: 'Bodyweight Triple Crush',
      unique_name: 'BEGINNER-Bodyweight Triple Crush-EXERCISE',
      description:
        '1. Stand with feet wider than shoulder-width apart, toes pointed slightly out. Bring your fists together at the center of your chest, palms face in.\n2. Squat down and lower fists toward the floor. Rest elbows inside your knees.\n3. At the bottom of the squat, perform 1/2 of a bicep curl and bring fists back to the center of your chest.\n4. Return to standing and raise arms overhead, fists together and elbows forward.\n5. Bend both elbows and lower your fists behind your head. Straighten arms and return to start.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 330,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '70b7eeffdd4f0bec872e02240e33413026b25c494f6d4c8987d36f4e4d7652a2',
          file_name:
            'videos/70b7eeffdd4f0bec872e02240e33413026b25c494f6d4c8987d36f4e4d7652a2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/70b7eeffdd4f0bec872e02240e33413026b25c494f6d4c8987d36f4e4d7652a2.mp4',
          name: 'PHIL_017_BODYWEIGHT_TRIPLE_CRUSH_1_small_720.mp4',
          description: null,
          size: 212578,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 331,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '3bc3f25e0e67389fb7ad19f729c368d7ee07d2deb314eb259c21c650e62b2745',
          file_name:
            'audios/3bc3f25e0e67389fb7ad19f729c368d7ee07d2deb314eb259c21c650e62b2745.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3bc3f25e0e67389fb7ad19f729c368d7ee07d2deb314eb259c21c650e62b2745.mp3',
          name: 'BEGINNER-Bodyweight_Triple_Crush-EXERCISE.mp3',
          description: null,
          size: 30822,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Chest Fly-EXERCISE': {
      id: 159,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Chest Fly',
      short_name: 'Chest Fly',
      unique_name: 'INTERMEDIATE-Chest Fly-EXERCISE',
      description:
        '1. Lie on a bench with a dumbbell in each hand and your feet flat on the floor. Allow for a natural curve in your lower back.\n2. Raise dumbbells over your shoulders, palms in. Shrug shoulders down and bend your elbows slightly in a fixed position.\n3. Open your arms and lower dumbbells out to the side aiming for parallel with the floor.\n4. Squeeze your chest and bring dumbbells to start position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 332,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '8c435add29924ec18d75369940d1c6cd980fec15f41237e613a26dc3312b2653',
          file_name:
            'videos/8c435add29924ec18d75369940d1c6cd980fec15f41237e613a26dc3312b2653.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8c435add29924ec18d75369940d1c6cd980fec15f41237e613a26dc3312b2653.mp4',
          name: 'PHIL_024_CHEST_FLY_2_small_720.mp4',
          description: null,
          size: 101810,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 333,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'dbb374447c56e24ce932cb1023d7fda2a0a207f5664b5f061001a58ca7266b33',
          file_name:
            'audios/dbb374447c56e24ce932cb1023d7fda2a0a207f5664b5f061001a58ca7266b33.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dbb374447c56e24ce932cb1023d7fda2a0a207f5664b5f061001a58ca7266b33.mp3',
          name: 'ChestFlys.mp3',
          description: null,
          size: 21308,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Chest Fly-EXERCISE': {
      id: 160,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Chest Fly',
      short_name: 'Chest Fly',
      unique_name: 'ADVANCED-Chest Fly-EXERCISE',
      description:
        '1. Lie on a bench with a dumbbell in each hand and your feet flat on the floor. Allow for a natural curve in your lower back.\n2. Raise dumbbells over your shoulders, palms in. Shrug shoulders down and bend your elbows slightly in a fixed position.\n3. Open your arms and lower dumbbells out to the side aiming for parallel with the floor.\n4. Squeeze your chest and bring dumbbells to start position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 334,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '8c435add29924ec18d75369940d1c6cd980fec15f41237e613a26dc3312b2653',
          file_name:
            'videos/8c435add29924ec18d75369940d1c6cd980fec15f41237e613a26dc3312b2653.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8c435add29924ec18d75369940d1c6cd980fec15f41237e613a26dc3312b2653.mp4',
          name: 'PHIL_024_CHEST_FLY_2_small_720.mp4',
          description: null,
          size: 101810,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 335,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'dbb374447c56e24ce932cb1023d7fda2a0a207f5664b5f061001a58ca7266b33',
          file_name:
            'audios/dbb374447c56e24ce932cb1023d7fda2a0a207f5664b5f061001a58ca7266b33.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dbb374447c56e24ce932cb1023d7fda2a0a207f5664b5f061001a58ca7266b33.mp3',
          name: 'ChestFlys.mp3',
          description: null,
          size: 21308,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Tricep Kickbacks-EXERCISE': {
      id: 161,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Tricep Kickbacks',
      short_name: 'Tricep Kickbacks',
      unique_name: 'INTERMEDIATE-Tricep Kickbacks-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, knees slightly bent. Hold a dumbbell in each hand.\n2. Hinge at the waist until your torso is close to parallel to the floor. Bend your elbows back behind you to 90 degrees. Bring dumbbells to your hips, palms in.\n3. Extend your elbows and lift dumbbells up and back behind you as you straighten your arms.\n4. Lower dumbbells back to start position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 336,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'cda44244cb7a4db8149caf6a06b69ac84ed6899eda40b345b8b5195eefcb758e',
          file_name:
            'videos/cda44244cb7a4db8149caf6a06b69ac84ed6899eda40b345b8b5195eefcb758e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cda44244cb7a4db8149caf6a06b69ac84ed6899eda40b345b8b5195eefcb758e.mp4',
          name: 'PHIL_018_TRICEP_KICKBACKS_1_small_720.mp4',
          description: null,
          size: 64575,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 337,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'd7e776e75e78f3744932b75dba3a4bc7d0a4dc01ba4712b7c80d32c3a96a0949',
          file_name:
            'audios/d7e776e75e78f3744932b75dba3a4bc7d0a4dc01ba4712b7c80d32c3a96a0949.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d7e776e75e78f3744932b75dba3a4bc7d0a4dc01ba4712b7c80d32c3a96a0949.mp3',
          name: 'TricepKickbacks.mp3',
          description: null,
          size: 24188,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Tricep Kickbacks-EXERCISE': {
      id: 162,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Tricep Kickbacks',
      short_name: 'Tricep Kickbacks',
      unique_name: 'ADVANCED-Tricep Kickbacks-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, knees slightly bent. Hold a dumbbell in each hand.\n2. Hinge at the waist until your torso is close to parallel to the floor. Bend your elbows back behind you to 90 degrees. Bring dumbbells to your hips, palms in.\n3. Extend your elbows and lift dumbbells up and back behind you as you straighten your arms.\n4. Lower dumbbells back to start position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 338,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'cda44244cb7a4db8149caf6a06b69ac84ed6899eda40b345b8b5195eefcb758e',
          file_name:
            'videos/cda44244cb7a4db8149caf6a06b69ac84ed6899eda40b345b8b5195eefcb758e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cda44244cb7a4db8149caf6a06b69ac84ed6899eda40b345b8b5195eefcb758e.mp4',
          name: 'PHIL_018_TRICEP_KICKBACKS_1_small_720.mp4',
          description: null,
          size: 64575,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 339,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'd7e776e75e78f3744932b75dba3a4bc7d0a4dc01ba4712b7c80d32c3a96a0949',
          file_name:
            'audios/d7e776e75e78f3744932b75dba3a4bc7d0a4dc01ba4712b7c80d32c3a96a0949.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d7e776e75e78f3744932b75dba3a4bc7d0a4dc01ba4712b7c80d32c3a96a0949.mp3',
          name: 'TricepKickbacks.mp3',
          description: null,
          size: 24188,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Bent Over Rows-EXERCISE': {
      id: 163,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Bent Over Rows',
      short_name: 'Bent Over Rows',
      unique_name: 'INTERMEDIATE-Bent Over Rows-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart and a dumbbell in each hand, palms in.\n2. With your back straight, hinge at the waist so your torso is close to parallel with the floor, arms extended down. Pull shoulders away from your ears.\n3. Bend your elbows and pull the dumbbells toward your hips. Keep elbows tight to your body.\n4. Lower dumbbells back to start position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 340,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'b9b04fb9def02d888bc798d7404b70c85fa227b5607a5ef686caeec035fce1dc',
          file_name:
            'videos/b9b04fb9def02d888bc798d7404b70c85fa227b5607a5ef686caeec035fce1dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b9b04fb9def02d888bc798d7404b70c85fa227b5607a5ef686caeec035fce1dc.mp4',
          name: 'PHIL_019_BENT_OVER_ROWS_1_small_720.mp4',
          description: null,
          size: 58869,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 341,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'a568c307b6362f1bfe737a557e5338ea7420e17dff107a9d1617761dabee3ee0',
          file_name:
            'audios/a568c307b6362f1bfe737a557e5338ea7420e17dff107a9d1617761dabee3ee0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a568c307b6362f1bfe737a557e5338ea7420e17dff107a9d1617761dabee3ee0.mp3',
          name: 'BentOverRows.mp3',
          description: null,
          size: 23324,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Bent Over Rows-EXERCISE': {
      id: 164,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Bent Over Rows',
      short_name: 'Bent Over Rows',
      unique_name: 'ADVANCED-Bent Over Rows-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart and a dumbbell in each hand, palms in.\n2. With your back straight, hinge at the waist so your torso is close to parallel with the floor, arms extended down. Pull shoulders away from your ears.\n3. Bend your elbows and pull the dumbbells toward your hips. Keep elbows tight to your body.\n4. Lower dumbbells back to start position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 342,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'b9b04fb9def02d888bc798d7404b70c85fa227b5607a5ef686caeec035fce1dc',
          file_name:
            'videos/b9b04fb9def02d888bc798d7404b70c85fa227b5607a5ef686caeec035fce1dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b9b04fb9def02d888bc798d7404b70c85fa227b5607a5ef686caeec035fce1dc.mp4',
          name: 'PHIL_019_BENT_OVER_ROWS_1_small_720.mp4',
          description: null,
          size: 58869,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 343,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'a568c307b6362f1bfe737a557e5338ea7420e17dff107a9d1617761dabee3ee0',
          file_name:
            'audios/a568c307b6362f1bfe737a557e5338ea7420e17dff107a9d1617761dabee3ee0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a568c307b6362f1bfe737a557e5338ea7420e17dff107a9d1617761dabee3ee0.mp3',
          name: 'BentOverRows.mp3',
          description: null,
          size: 23324,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Dumbbell Pullovers-EXERCISE': {
      id: 165,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Pullovers',
      short_name: 'Dumbbell Pullovers',
      unique_name: 'INTERMEDIATE-Dumbbell Pullovers-EXERCISE',
      description:
        '1. Place your upper back on the bench, just below your shoulder blades. Keep feet on the floor, hip-width apart under your knees.\n2. With both hands, hold one dumbbell vertically overhead, arms directly above your shoulders, elbows slightly bent. Lift hip off the floor.\n3. Keeping elbows in, lower the dumbbell behind you until your forearms are in line with your body.\n4. Raise the dumbbell back up overhead and return to start position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 344,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'e9430ec0c3fed77e7ee2e01710cd3aab71f4d7c8d5258d420dbb725fe5b969ff',
          file_name:
            'videos/e9430ec0c3fed77e7ee2e01710cd3aab71f4d7c8d5258d420dbb725fe5b969ff.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e9430ec0c3fed77e7ee2e01710cd3aab71f4d7c8d5258d420dbb725fe5b969ff.mp4',
          name: 'PHIL_026_DUMBELL_PULLOVER_1_small_720.mp4',
          description: null,
          size: 138375,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 345,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '78df3d3613ac6ac012ed96ada70beb0af9a05ec02649d8053929fec4facc0648',
          file_name:
            'audios/78df3d3613ac6ac012ed96ada70beb0af9a05ec02649d8053929fec4facc0648.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/78df3d3613ac6ac012ed96ada70beb0af9a05ec02649d8053929fec4facc0648.mp3',
          name: 'DumbbellPullovers.mp3',
          description: null,
          size: 26780,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Dumbbell Pullovers-EXERCISE': {
      id: 166,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Pullovers',
      short_name: 'Dumbbell Pullovers',
      unique_name: 'ADVANCED-Dumbbell Pullovers-EXERCISE',
      description:
        '1. Place your upper back on the bench, just below your shoulder blades. Keep feet on the floor, hip-width apart under your knees.\n2. With both hands, hold one dumbbell vertically overhead, arms directly above your shoulders, elbows slightly bent. Lift hip off the floor.\n3. Keeping elbows in, lower the dumbbell behind you until your forearms are in line with your body.\n4. Raise the dumbbell back up overhead and return to start position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 346,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'e9430ec0c3fed77e7ee2e01710cd3aab71f4d7c8d5258d420dbb725fe5b969ff',
          file_name:
            'videos/e9430ec0c3fed77e7ee2e01710cd3aab71f4d7c8d5258d420dbb725fe5b969ff.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e9430ec0c3fed77e7ee2e01710cd3aab71f4d7c8d5258d420dbb725fe5b969ff.mp4',
          name: 'PHIL_026_DUMBELL_PULLOVER_1_small_720.mp4',
          description: null,
          size: 138375,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 347,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '78df3d3613ac6ac012ed96ada70beb0af9a05ec02649d8053929fec4facc0648',
          file_name:
            'audios/78df3d3613ac6ac012ed96ada70beb0af9a05ec02649d8053929fec4facc0648.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/78df3d3613ac6ac012ed96ada70beb0af9a05ec02649d8053929fec4facc0648.mp3',
          name: 'DumbbellPullovers.mp3',
          description: null,
          size: 26780,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Chest Press-EXERCISE': {
      id: 167,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Chest Press',
      short_name: 'Chest Press',
      unique_name: 'INTERMEDIATE-Chest Press-EXERCISE',
      description:
        '1. Lie on a bench with a dumbbell in each hand and your feet flat on the floor. Allow for a natural curve in your lower back.\n2. Raise the dumbbells up over your shoulders, palms facing your feet. Shrug your shoulders down "into your back pockets".\n3. Bend your elbows, and lower the dumbbells out to the sides until your arms are at 90 degrees.\n4. Squeeze your chest and bring dumbbells back to start position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 366,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'b8d667c74f1be766651eb577bbf10d06cec55f66e5f5265bd13492ce38718b10',
          file_name:
            'videos/b8d667c74f1be766651eb577bbf10d06cec55f66e5f5265bd13492ce38718b10.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b8d667c74f1be766651eb577bbf10d06cec55f66e5f5265bd13492ce38718b10.mp4',
          name: 'PHIL_025_CHEST_PRESS_2_small_720.mp4',
          description: null,
          size: 94503,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 367,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'c06372c00df81543a2a9d971fbae02b012a55b5bb4858aeb3c0adb41faed4656',
          file_name:
            'audios/c06372c00df81543a2a9d971fbae02b012a55b5bb4858aeb3c0adb41faed4656.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c06372c00df81543a2a9d971fbae02b012a55b5bb4858aeb3c0adb41faed4656.mp3',
          name: 'INT-ADV-Chest_Press-EXERCISE.mp3',
          description: null,
          size: 25998,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Chest Press-EXERCISE': {
      id: 168,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Chest Press',
      short_name: 'Chest Press',
      unique_name: 'ADVANCED-Chest Press-EXERCISE',
      description:
        '1. Lie on a bench with a dumbbell in each hand and your feet flat on the floor. Allow for a natural curve in your lower back.\n2. Raise the dumbbells up over your shoulders, palms facing your feet. Shrug your shoulders down "into your back pockets".\n3. Bend your elbows, and lower the dumbbells out to the sides until your arms are at 90 degrees.\n4. Squeeze your chest and bring dumbbells back to start position.',
      preview_time: 10,
      min_app_version: 100020005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 368,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'b8d667c74f1be766651eb577bbf10d06cec55f66e5f5265bd13492ce38718b10',
          file_name:
            'videos/b8d667c74f1be766651eb577bbf10d06cec55f66e5f5265bd13492ce38718b10.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b8d667c74f1be766651eb577bbf10d06cec55f66e5f5265bd13492ce38718b10.mp4',
          name: 'PHIL_025_CHEST_PRESS_2_small_720.mp4',
          description: null,
          size: 94503,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 369,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'c06372c00df81543a2a9d971fbae02b012a55b5bb4858aeb3c0adb41faed4656',
          file_name:
            'audios/c06372c00df81543a2a9d971fbae02b012a55b5bb4858aeb3c0adb41faed4656.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c06372c00df81543a2a9d971fbae02b012a55b5bb4858aeb3c0adb41faed4656.mp3',
          name: 'INT-ADV-Chest_Press-EXERCISE.mp3',
          description: null,
          size: 25998,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Crunches-EXERCISE': {
      id: 178,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Crunches',
      short_name: 'Crunches',
      unique_name: 'BEGINNER-Crunches-EXERCISE',
      description:
        '1. Lie on your back with your knees bent, feet on the floor hip-width apart.\n2. Place your hands behind your head with your thumbs behind your ears and elbows out wide.\n3. Engage your abs and curl up and forward so your head, neck and shoulder blades lift off the floor. Keep space between your chin and chest. Squeeze at the top.\n4. Lower down slow and controlled back to start position.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 370,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '1396120b64fa89a4771829f1db76055126229a3015eeb6827549ca95b3126430',
          file_name:
            'videos/1396120b64fa89a4771829f1db76055126229a3015eeb6827549ca95b3126430.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1396120b64fa89a4771829f1db76055126229a3015eeb6827549ca95b3126430.mp4',
          name: '003_CRUNCH_2_small_720.mp4',
          description: null,
          size: 73138,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 371,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'cb1e37816f162da00a8c76625e677d773c1ebcf2f3f41088ba74453e013f301f',
          file_name:
            'audios/cb1e37816f162da00a8c76625e677d773c1ebcf2f3f41088ba74453e013f301f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cb1e37816f162da00a8c76625e677d773c1ebcf2f3f41088ba74453e013f301f.mp3',
          name: 'Crunches.mp3',
          description: null,
          size: 17574,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Russian Twists-EXERCISE': {
      id: 179,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Bodyweight Russian Twists',
      short_name: 'Bodyweight Russian Twists',
      unique_name: 'BEGINNER-Bodyweight Russian Twists-EXERCISE',
      description:
        "1. Sit on the floor with your knees bent at 90 degrees, legs and feet together.\n2. Lean back slightly and elevate your feet off the floor about 45 degrees. Your hands together at your midline, shoulders back and chin neutral.\n3. Twist your upper body to one side so your hands touch the floor by your hip. Feet and legs don't move.\n4. Twist to the other side. Right and left equals one rep.",
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 372,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '5d152d8a1e20cd39959431c9752f3733cdcccbab51a856a12e44cff9538faa16',
          file_name:
            'videos/5d152d8a1e20cd39959431c9752f3733cdcccbab51a856a12e44cff9538faa16.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5d152d8a1e20cd39959431c9752f3733cdcccbab51a856a12e44cff9538faa16.mp4',
          name: '004_BODYWEIGHT_RUSSIAN_TWISTS_2_small_720.mp4',
          description: null,
          size: 65088,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 373,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'f32dbc51be0ac2623aca9bcf5611571450fa6409c87004638961f41cc1d9f763',
          file_name:
            'audios/f32dbc51be0ac2623aca9bcf5611571450fa6409c87004638961f41cc1d9f763.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f32dbc51be0ac2623aca9bcf5611571450fa6409c87004638961f41cc1d9f763.mp3',
          name: 'Bodyweight-Russian-Twists.mp3',
          description: null,
          size: 30534,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Dolphin Push-up-EXERCISE': {
      id: 180,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Dolphin Push-Ups',
      short_name: 'Dolphin Push-Ups',
      unique_name: 'BEGINNER-Dolphin Push-up-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat.\n2. Draw your hips up and back, shift your torso close to your thighs. Head neutral and ears by armpits. You are in an inverted "V" shape. Think "Down Dog on forearms".\n3. Engage your core, shift your body forward and lower your hips back down to Forearm Plank start position.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 374,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '467c55e6bd7e75f89f60ef6145188a57453d872dae95375120d988246bcd5be9',
          file_name:
            'videos/467c55e6bd7e75f89f60ef6145188a57453d872dae95375120d988246bcd5be9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/467c55e6bd7e75f89f60ef6145188a57453d872dae95375120d988246bcd5be9.mp4',
          name: '005a_DOLPHIN_PUSHUPS_1_small_720.mp4',
          description: null,
          size: 104475,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 375,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '8908324206eed8041af87bb114624c12628cc875d0a8f45436382257fcadd08a',
          file_name:
            'audios/8908324206eed8041af87bb114624c12628cc875d0a8f45436382257fcadd08a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8908324206eed8041af87bb114624c12628cc875d0a8f45436382257fcadd08a.mp3',
          name: 'Dolphin-Push-Ups.mp3',
          description: null,
          size: 24198,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Tricep Bench Dips-EXERCISE': {
      id: 181,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Tricep Bench Dips',
      short_name: 'Tricep Bench Dips',
      unique_name: 'INTERMEDIATE-Tricep Bench Dips-EXERCISE',
      description:
        '1. Sit on a bench and place your palms on either side of your hips.\n2. Slide forward off the bench. Keep your knees bent and feet on the floor. Keep your hips under your shoulders and your backside close to the bench.\n3. Bend your elbows and lower yourself down until your upper arms are parallel to the floor, elbows pointing behind you.\n4. Straighten your arms and raise yourself up to start position.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 376,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'a90b5a08a0017eadc5ecf820e2a749243b08c32ca633f472c85326a6360cb3d5',
          file_name:
            'videos/a90b5a08a0017eadc5ecf820e2a749243b08c32ca633f472c85326a6360cb3d5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a90b5a08a0017eadc5ecf820e2a749243b08c32ca633f472c85326a6360cb3d5.mp4',
          name: '021_TRICEP_BENCH_DIPS_1_small_720.mp4',
          description: null,
          size: 73459,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 377,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '4fc570670882f51800eebb5d6eeae9f7e7363514ce3d3ed0dc9b577f7f3cf726',
          file_name:
            'audios/4fc570670882f51800eebb5d6eeae9f7e7363514ce3d3ed0dc9b577f7f3cf726.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4fc570670882f51800eebb5d6eeae9f7e7363514ce3d3ed0dc9b577f7f3cf726.mp3',
          name: 'Tricep-Bench-Dips.mp3',
          description: null,
          size: 25638,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Tricep Bench Dips with Straight Legs-EXERCISE': {
      id: 182,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Tricep Bench Dips with Straight Legs',
      short_name: 'Tricep Bench Dips with Straight Legs',
      unique_name: 'ADVANCED-Tricep Bench Dips with Straight Legs-EXERCISE',
      description:
        '1. Sit on a bench and place your palms on either side of your hips.\n2. Slide forward off the bench. Extend your legs long in front of you. Keep your hips under your shoulders and your backside close to the bench.\n3. Bend your elbows and lower yourself down until your upper arms are parallel to the floor, elbows pointing behind you.\n4. Straighten your arms and raise yourself up to start position.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 378,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: 'f06b05e667c397d9499d24559373c23d243fa900632629ec818232934a0fc784',
          file_name:
            'videos/f06b05e667c397d9499d24559373c23d243fa900632629ec818232934a0fc784.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f06b05e667c397d9499d24559373c23d243fa900632629ec818232934a0fc784.mp4',
          name: 'ADVANCED-Tricep_Bench_Dips_with_Straight_Legs-EXERCISE.mp4',
          description: null,
          size: 97444,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 379,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '331a222d0a92056f3bae1333ad490cd752ec9bd50045b2ef2fff562951768f97',
          file_name:
            'audios/331a222d0a92056f3bae1333ad490cd752ec9bd50045b2ef2fff562951768f97.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/331a222d0a92056f3bae1333ad490cd752ec9bd50045b2ef2fff562951768f97.mp3',
          name: 'Tricep-Bench-Dips-with-Straight-Legs.mp3',
          description: null,
          size: 39751,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Wide Bicep Curls-EXERCISE': {
      id: 183,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Wide Bicep Curls',
      short_name: 'Wide Bicep Curls',
      unique_name: 'INTERMEDIATE-Wide Bicep Curls-EXERCISE',
      description:
        '1. Start standing with your feet about shoulder-width apart, hold one dumbbell in each hand, palms facing forward.\n2. Keep your elbows close to your ribcage. Rotate your palms toward the ceiling and curl the dumbbells up and out to the side toward your shoulders.\n3. Lower your arms back down to start position.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 380,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'e4fd97261436e2eddcd5961b49f0b04223f5b2511bc04544510fb363f8da8a14',
          file_name:
            'videos/e4fd97261436e2eddcd5961b49f0b04223f5b2511bc04544510fb363f8da8a14.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e4fd97261436e2eddcd5961b49f0b04223f5b2511bc04544510fb363f8da8a14.mp4',
          name: '011_WIDE_CURL_1_3_small_720.mp4',
          description: null,
          size: 92620,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 381,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '29b9283648bf376f32ec781ea49c9323aeb4cf8388527f0834c1ba030b239ac3',
          file_name:
            'audios/29b9283648bf376f32ec781ea49c9323aeb4cf8388527f0834c1ba030b239ac3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/29b9283648bf376f32ec781ea49c9323aeb4cf8388527f0834c1ba030b239ac3.mp3',
          name: 'Wide-Bicep-Curls.mp3',
          description: null,
          size: 30210,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Wide Bicep Curls-EXERCISE': {
      id: 184,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Wide Bicep Curls',
      short_name: 'Wide Bicep Curls',
      unique_name: 'ADVANCED-Wide Bicep Curls-EXERCISE',
      description:
        '1. Start standing with your feet about shoulder-width apart, hold one dumbbell in each hand, palms facing forward.\n2. Keep your elbows close to your ribcage. Rotate your palms toward the ceiling and curl the dumbbells up and out to the side toward your shoulders.\n3. Lower your arms back down to start position.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 382,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'e4fd97261436e2eddcd5961b49f0b04223f5b2511bc04544510fb363f8da8a14',
          file_name:
            'videos/e4fd97261436e2eddcd5961b49f0b04223f5b2511bc04544510fb363f8da8a14.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e4fd97261436e2eddcd5961b49f0b04223f5b2511bc04544510fb363f8da8a14.mp4',
          name: '011_WIDE_CURL_1_3_small_720.mp4',
          description: null,
          size: 92620,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 383,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '29b9283648bf376f32ec781ea49c9323aeb4cf8388527f0834c1ba030b239ac3',
          file_name:
            'audios/29b9283648bf376f32ec781ea49c9323aeb4cf8388527f0834c1ba030b239ac3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/29b9283648bf376f32ec781ea49c9323aeb4cf8388527f0834c1ba030b239ac3.mp3',
          name: 'Wide-Bicep-Curls.mp3',
          description: null,
          size: 30210,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Ski Jumpers-EXERCISE': {
      id: 185,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Ski Jumpers',
      short_name: 'Ski Jumpers',
      unique_name: 'BEGINNER-Ski Jumpers-EXERCISE',
      description:
        '1. Start standing with your feet together and arms by your sides. Bend your elbows to 90 degrees, hands naturally in front of your body.\n2. Keeping your feet together, hop up and over to one side as if you were jumping over an imaginary line. Land soft and immediately hop to the other side.\n3. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 384,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'edab36d1b2df5db66dcb601044f4cd9a7b0032e725f00e498d238fc30251ca60',
          file_name:
            'videos/edab36d1b2df5db66dcb601044f4cd9a7b0032e725f00e498d238fc30251ca60.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/edab36d1b2df5db66dcb601044f4cd9a7b0032e725f00e498d238fc30251ca60.mp4',
          name: '025_SKI_JUMPERS_1_small_720.mp4',
          description: null,
          size: 60742,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 385,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '7175b9bd3eca03ac08767c617b1841497be4bd158fe20ff521d61676188b2082',
          file_name:
            'audios/7175b9bd3eca03ac08767c617b1841497be4bd158fe20ff521d61676188b2082.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7175b9bd3eca03ac08767c617b1841497be4bd158fe20ff521d61676188b2082.mp3',
          name: 'Ski-Jumpers.mp3',
          description: null,
          size: 23046,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Jumping Jacks-EXERCISE': {
      id: 186,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Jumping Jacks',
      short_name: 'Jumping Jacks',
      unique_name: 'BEGINNER-Jumping Jacks-EXERCISE',
      description:
        '1. Start standing with your feet together and your arms by your sides.\n2. Jump up and land with your feet slightly wider than shoulder-width apart as you reach your arms out and overhead.\n3. Simultaneously jump your feet back together and bring your arms back to start position.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 386,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '7189bb926cd646121ad47996bcca78583a4fd73577666398db8a03a2e15e2f86',
          file_name:
            'videos/7189bb926cd646121ad47996bcca78583a4fd73577666398db8a03a2e15e2f86.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7189bb926cd646121ad47996bcca78583a4fd73577666398db8a03a2e15e2f86.mp4',
          name: '024_JUMPING_JACKS_1_small_720.mp4',
          description: null,
          size: 75588,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 387,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '56c40ac366daa53a27c75c5f9eb05ba9476afeaffeedc828c7e3a5cf5a2215dc',
          file_name:
            'audios/56c40ac366daa53a27c75c5f9eb05ba9476afeaffeedc828c7e3a5cf5a2215dc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/56c40ac366daa53a27c75c5f9eb05ba9476afeaffeedc828c7e3a5cf5a2215dc.mp3',
          name: 'Jumping-Jacks.mp3',
          description: null,
          size: 21894,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Scissor Feet-EXERCISE': {
      id: 187,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Scissor Feet',
      short_name: 'Scissor Feet',
      unique_name: 'BEGINNER-Scissor Feet-EXERCISE',
      description:
        '1. Start standing with your feet together and elbows bent at 90 degrees by your sides.\n2. Jump up, land softly on the balls of your feet with one foot in front of you and the other one behind you. Take your arms with you as if you were running.\n3. Immediately jump back up and switch your legs and arms.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 388,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '2233db5d7a06032e56b0260008a778c879424df794f230f08a061bab00cb74cf',
          file_name:
            'videos/2233db5d7a06032e56b0260008a778c879424df794f230f08a061bab00cb74cf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2233db5d7a06032e56b0260008a778c879424df794f230f08a061bab00cb74cf.mp4',
          name: '012_SCISSOR_FEET_1_small_720.mp4',
          description: null,
          size: 78781,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 389,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '4ccd01cea1aaa71d6aae0fe4f7ff84705629641af21b48c3fc612d9838c7e8a5',
          file_name:
            'audios/4ccd01cea1aaa71d6aae0fe4f7ff84705629641af21b48c3fc612d9838c7e8a5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4ccd01cea1aaa71d6aae0fe4f7ff84705629641af21b48c3fc612d9838c7e8a5.mp3',
          name: 'Scissor-Feet.mp3',
          description: null,
          size: 19875,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Log Hops-EXERCISE': {
      id: 188,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Log Hops',
      short_name: 'Log Hops',
      unique_name: 'INTERMEDIATE-Log Hops-EXERCISE',
      description:
        '1. Place both hands on the end of the step with both legs together and extended behind you. Your arms are straight but elbows not locked.\n2. Bend your knees, engage your core and jump both feet to one side of the step.\n3. Immediately jump your feet to the other side without a double bounce.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 390,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '4f14dc95d5fdf1da73a8cf58434a9d3dd498a06956419db037d58d285e0ee3e5',
          file_name:
            'videos/4f14dc95d5fdf1da73a8cf58434a9d3dd498a06956419db037d58d285e0ee3e5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4f14dc95d5fdf1da73a8cf58434a9d3dd498a06956419db037d58d285e0ee3e5.mp4',
          name: '028_LOG_HOP_2_small_720.mp4',
          description: null,
          size: 72599,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 391,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '00947d9c08d8381ce5c3ff5e880ac6f8c00aa58021df9dce272ec5fde627829a',
          file_name:
            'audios/00947d9c08d8381ce5c3ff5e880ac6f8c00aa58021df9dce272ec5fde627829a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/00947d9c08d8381ce5c3ff5e880ac6f8c00aa58021df9dce272ec5fde627829a.mp3',
          name: 'Log-Hops.mp3',
          description: null,
          size: 19636,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Sit-Ups with Cross Punches-EXERCISE': {
      id: 189,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Sit-Ups with Cross Punches',
      short_name: 'Sit-Ups with Cross Punches',
      unique_name: 'BEGINNER-Sit-Ups with Cross Punches-EXERCISE',
      description:
        '1. Lie on your back with your knees bent and feet flat on the floor, fists just below your chin.\n2. Sit up and twist your torso slightly to one side on the way up. Punch the inside arm across your body diagonally reaching past your knees.\n3. Return to the center then twist in the opposite direction and punch with the other hand.\n4. Lower down to start position and repeat leading with the opposite arm.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 392,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '53657cdb32763b8307d9271e7b2da8894f1434d2870985c179cbdab712e492f5',
          file_name:
            'videos/53657cdb32763b8307d9271e7b2da8894f1434d2870985c179cbdab712e492f5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/53657cdb32763b8307d9271e7b2da8894f1434d2870985c179cbdab712e492f5.mp4',
          name: '004_SITUPS_W_CROSS_PUNCHES_no-weight_1_logo_small_720.mp4',
          description: null,
          size: 138711,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 393,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '4878210a55f26dc3ca85ebf776856e16fbaacb3f6c07f37038d6fc32f4b68182',
          file_name:
            'audios/4878210a55f26dc3ca85ebf776856e16fbaacb3f6c07f37038d6fc32f4b68182.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4878210a55f26dc3ca85ebf776856e16fbaacb3f6c07f37038d6fc32f4b68182.mp3',
          name: 'Sit-Ups-with-Cross-Punches.mp3',
          description: null,
          size: 29095,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Sit-Ups with Cross Punches-EXERCISE': {
      id: 190,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Sit-Ups with Cross Punches',
      short_name: 'Sit-Ups with Cross Punches',
      unique_name: 'INTERMEDIATE-Sit-Ups with Cross Punches-EXERCISE',
      description:
        '1. Lie on your back with your knees bent and feet flat on the floor, holding two dumbbells just below your chin.\n2. Sit up and twist your torso to one side as you punch the inside arm across your body diagonally past your knees.\n3. Return to the center then twist in the opposite direction and punch with the other hand.\n4. Lower down to start position and repeat leading with the opposite arm.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 394,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '20f44975a5df9952f2998b1fea755aa9fb9904719b10cad57cc97d11943c3e8f',
          file_name:
            'videos/20f44975a5df9952f2998b1fea755aa9fb9904719b10cad57cc97d11943c3e8f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/20f44975a5df9952f2998b1fea755aa9fb9904719b10cad57cc97d11943c3e8f.mp4',
          name: '005_SITUPS_W_CROSS_PUNCHES_1_small_720.mp4',
          description: null,
          size: 156477,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 395,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '4878210a55f26dc3ca85ebf776856e16fbaacb3f6c07f37038d6fc32f4b68182',
          file_name:
            'audios/4878210a55f26dc3ca85ebf776856e16fbaacb3f6c07f37038d6fc32f4b68182.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4878210a55f26dc3ca85ebf776856e16fbaacb3f6c07f37038d6fc32f4b68182.mp3',
          name: 'Sit-Ups-with-Cross-Punches.mp3',
          description: null,
          size: 29095,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Sit-Ups with Cross Punches-EXERCISE': {
      id: 191,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Sit-Ups with Cross Punches',
      short_name: 'Sit-Ups with Cross Punches',
      unique_name: 'ADVANCED-Sit-Ups with Cross Punches-EXERCISE',
      description:
        '1. Lie on your back with your knees bent and feet flat on the floor, holding two dumbbells just below your chin.\n2. Sit up and twist your torso to one side as you punch the inside arm across your body diagonally past your knees.\n3. Return to the center then twist in the opposite direction and punch with the other hand.\n4. Lower down to start position and repeat leading with the opposite arm.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 396,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '20f44975a5df9952f2998b1fea755aa9fb9904719b10cad57cc97d11943c3e8f',
          file_name:
            'videos/20f44975a5df9952f2998b1fea755aa9fb9904719b10cad57cc97d11943c3e8f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/20f44975a5df9952f2998b1fea755aa9fb9904719b10cad57cc97d11943c3e8f.mp4',
          name: '005_SITUPS_W_CROSS_PUNCHES_1_small_720.mp4',
          description: null,
          size: 156477,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 397,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '4878210a55f26dc3ca85ebf776856e16fbaacb3f6c07f37038d6fc32f4b68182',
          file_name:
            'audios/4878210a55f26dc3ca85ebf776856e16fbaacb3f6c07f37038d6fc32f4b68182.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4878210a55f26dc3ca85ebf776856e16fbaacb3f6c07f37038d6fc32f4b68182.mp3',
          name: 'Sit-Ups-with-Cross-Punches.mp3',
          description: null,
          size: 29095,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Russian Twists-EXERCISE': {
      id: 192,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Russian Twists',
      short_name: 'Russian Twists',
      unique_name: 'INTERMEDIATE-Russian Twists-EXERCISE',
      description:
        "1. Sit on the floor with your knees bent at 90 degrees, legs and feet together. With both hands, hold one dumbbell.\n2. Lean back and elevate your feet off the floor. Dumbbell at your midline, shoulders back and chin neutral.\n3. Twist your upper body to one side, moving the dumbbell toward the floor by your hip. Feet and legs don't move.\n4. Twist to the other side. Right and left equals one rep.",
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 398,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'efd8bb8472081113e155e9eae32386d18e96c34c0a4c3f5f6487bdccfe3fa5fe',
          file_name:
            'videos/efd8bb8472081113e155e9eae32386d18e96c34c0a4c3f5f6487bdccfe3fa5fe.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/efd8bb8472081113e155e9eae32386d18e96c34c0a4c3f5f6487bdccfe3fa5fe.mp4',
          name: '003_RUSSIAN_TWISTS_2_small_720.mp4',
          description: null,
          size: 81397,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 399,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '34b5b7ccf74fe0aa333e8bf80e8f932529cf8ae0d639333d301f3d867ab4b6dc',
          file_name:
            'audios/34b5b7ccf74fe0aa333e8bf80e8f932529cf8ae0d639333d301f3d867ab4b6dc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/34b5b7ccf74fe0aa333e8bf80e8f932529cf8ae0d639333d301f3d867ab4b6dc.mp3',
          name: 'Russian-Twists.mp3',
          description: null,
          size: 21316,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Russian Twists-EXERCISE': {
      id: 193,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Russian Twists',
      short_name: 'Russian Twists',
      unique_name: 'ADVANCED-Russian Twists-EXERCISE',
      description:
        "1. Sit on the floor with your knees bent at 90 degrees, legs and feet together. With both hands, hold one dumbbell.\n2. Lean back and elevate your feet off the floor. Dumbbell at your midline, shoulders back and chin neutral.\n3. Twist your upper body to one side, moving the dumbbell toward the floor by your hip. Feet and legs don't move.\n4. Twist to the other side. Right and left equals one rep.",
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 400,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'efd8bb8472081113e155e9eae32386d18e96c34c0a4c3f5f6487bdccfe3fa5fe',
          file_name:
            'videos/efd8bb8472081113e155e9eae32386d18e96c34c0a4c3f5f6487bdccfe3fa5fe.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/efd8bb8472081113e155e9eae32386d18e96c34c0a4c3f5f6487bdccfe3fa5fe.mp4',
          name: '003_RUSSIAN_TWISTS_2_small_720.mp4',
          description: null,
          size: 81397,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 401,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '34b5b7ccf74fe0aa333e8bf80e8f932529cf8ae0d639333d301f3d867ab4b6dc',
          file_name:
            'audios/34b5b7ccf74fe0aa333e8bf80e8f932529cf8ae0d639333d301f3d867ab4b6dc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/34b5b7ccf74fe0aa333e8bf80e8f932529cf8ae0d639333d301f3d867ab4b6dc.mp3',
          name: 'Russian-Twists.mp3',
          description: null,
          size: 21316,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Incline Knee Push-ups-EXERCISE': {
      id: 194,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Incline Knee Push-ups',
      short_name: 'Incline Knee Push-ups',
      unique_name: 'INTERMEDIATE-Incline Knee Push-ups-EXERCISE',
      description:
        '1. Start in Incline Plank position. Place your hands on the end of a step, shoulders over wrists. Drop your knees straight down to the floor and lift your feet up.\n2. Bend your elbows, pointing them back toward your hip. Lower your body so the center of your chest meets the edge of the step.\n3. Straighten your arms and raise your body back up in one long line.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 402,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '86bd8da0ccf81f61748f8d8c0c1ef0913288a4da391f8449b172b9c344fba1b6',
          file_name:
            'videos/86bd8da0ccf81f61748f8d8c0c1ef0913288a4da391f8449b172b9c344fba1b6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86bd8da0ccf81f61748f8d8c0c1ef0913288a4da391f8449b172b9c344fba1b6.mp4',
          name: '029_KNEE_INCLINE_PUSHUPS_1_logo_minus_15percent_small_720.mp4',
          description: null,
          size: 92603,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 403,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '305e07f46dbef632482b5f6550cfdf0bd74f34f5a70ed352152767d535cdb897',
          file_name:
            'audios/305e07f46dbef632482b5f6550cfdf0bd74f34f5a70ed352152767d535cdb897.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/305e07f46dbef632482b5f6550cfdf0bd74f34f5a70ed352152767d535cdb897.mp3',
          name: 'Incline-Knee-Push-Ups.mp3',
          description: null,
          size: 27137,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Incline Push-Ups-EXERCISE': {
      id: 195,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Incline Push-Ups',
      short_name: 'Incline Push-Ups',
      unique_name: 'ADVANCED-Incline Push-Ups-EXERCISE',
      description:
        '1. Start in Incline Plank position. Place your hands on the end of a step, shoulders over wrists. Legs extended and the balls of your feet on the floor.\n2. Bend your elbows, pointing them back toward your hips. Lower your body so the center of your chest meets the edge of the step.\n3. Straighten your arms and raise your body back up in one long line from the crown of your head to your tailbone.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 404,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '438874be30df7d62994b8c3c8f6ea624f1b57b154ffca9c596e6d566eec86dc6',
          file_name:
            'videos/438874be30df7d62994b8c3c8f6ea624f1b57b154ffca9c596e6d566eec86dc6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/438874be30df7d62994b8c3c8f6ea624f1b57b154ffca9c596e6d566eec86dc6.mp4',
          name: '029a_INCLINE_PUSHUPS_1_small_720.mp4',
          description: null,
          size: 100435,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 405,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'c996b14cb8ee471a8cc89672745eb93b04f40e5a7f1abc01a1c0ed1c4e54b4ed',
          file_name:
            'audios/c996b14cb8ee471a8cc89672745eb93b04f40e5a7f1abc01a1c0ed1c4e54b4ed.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c996b14cb8ee471a8cc89672745eb93b04f40e5a7f1abc01a1c0ed1c4e54b4ed.mp3',
          name: 'Incline-Push-Ups.mp3',
          description: null,
          size: 25063,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Incline Plyo Push-Ups from Knees-EXERCISE': {
      id: 196,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Incline Plyo Push-Ups from Knees',
      short_name: 'Incline Plyo Push-Ups from Knees',
      unique_name: 'INTERMEDIATE-Incline Plyo Push-Ups from Knees-EXERCISE',
      description:
        '1. Start in Incline Plank position. Place your hands on the end of a step, shoulders over wrists. Drop knees to the floor and lift your feet up.\n2. Bend your elbows, pointing them back toward your hip. Lower your body so your chest meets the edge of the step.\n3. Explosively push your body away so your hands leave the step as you straighten your arms.\n4. Land with your hands in start position, soften elbows. Repeat.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 406,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '9639f943c6182b26f723c3c488a0316aea3004f26a62f796fdd17aa07f3110d0',
          file_name:
            'videos/9639f943c6182b26f723c3c488a0316aea3004f26a62f796fdd17aa07f3110d0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9639f943c6182b26f723c3c488a0316aea3004f26a62f796fdd17aa07f3110d0.mp4',
          name: '029b_KNEE_INCLINE_PLYO_PUSHUPS_1_small_720.mp4',
          description: null,
          size: 85574,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 407,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '291396829292ce6bb612f55e52ea54e15c3b94124f12faeeb154fe73283698dd',
          file_name:
            'audios/291396829292ce6bb612f55e52ea54e15c3b94124f12faeeb154fe73283698dd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/291396829292ce6bb612f55e52ea54e15c3b94124f12faeeb154fe73283698dd.mp3',
          name: 'Incline-Plyo-Push-Ups-From-Knees.mp3',
          description: null,
          size: 35490,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Incline Plyo Push-Ups-EXERCISE': {
      id: 197,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Incline Plyo Push-Ups',
      short_name: 'Incline Plyo Push-Ups',
      unique_name: 'ADVANCED-Incline Plyo Push-Ups-EXERCISE',
      description:
        '1. Start in Incline Plank position. Place your hands on the end of a step, shoulders over wrists. Legs extended and the balls of your feet on the floor.\n2. Bend your elbows, pointing them back toward your hip. Lower your body so your chest meets the edge of the step.\n3. Explosively push your body away so your hands leave the step as you straighten your arms.\n4. Land with your hands in start position, soften elbows. Repeat.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 408,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '0419c5ea1e494528e4437227814369f5b482b521318a2abf3190c3c5be800222',
          file_name:
            'videos/0419c5ea1e494528e4437227814369f5b482b521318a2abf3190c3c5be800222.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0419c5ea1e494528e4437227814369f5b482b521318a2abf3190c3c5be800222.mp4',
          name: '029c_INCLINE_PLYO_PUSHUPS_1_small_720.mp4',
          description: null,
          size: 78558,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 409,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'b38f839b94a1873c5670f20e59681b18e51b50f8dcf4e53f4c1568949cf03930',
          file_name:
            'audios/b38f839b94a1873c5670f20e59681b18e51b50f8dcf4e53f4c1568949cf03930.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b38f839b94a1873c5670f20e59681b18e51b50f8dcf4e53f4c1568949cf03930.mp3',
          name: 'Incline-Plyo-Push-Ups.mp3',
          description: null,
          size: 30247,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Cobra Lat Pulldowns-EXERCISE': {
      id: 198,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Cobra Lat Pulldowns',
      short_name: 'Cobra Lat Pulldowns',
      unique_name: 'BEGINNER-Cobra Lat Pulldowns-EXERCISE',
      description:
        '1. Lie on your stomach with your legs and arms fully extended.\n2. With long spine and core engaged, raise your upper body off the floor. Bend your elbows back toward your hip and squeeze your shoulder blades together. Pause for a beat.\n3. Lower your upper body down and extend your arms back to start position.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 410,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '689c803d5cca91b0631a5413cb310bfa4350061ed8e624285810e931d4155f94',
          file_name:
            'videos/689c803d5cca91b0631a5413cb310bfa4350061ed8e624285810e931d4155f94.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/689c803d5cca91b0631a5413cb310bfa4350061ed8e624285810e931d4155f94.mp4',
          name: '037_COBRA_LAT_PULLDOWN_1_logo_2_small_720.mp4',
          description: null,
          size: 91756,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 411,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '0bf32fe0fb38d39e0590e07b3cf63149ab942ae299d4c12038e5a34e4fe1267c',
          file_name:
            'audios/0bf32fe0fb38d39e0590e07b3cf63149ab942ae299d4c12038e5a34e4fe1267c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0bf32fe0fb38d39e0590e07b3cf63149ab942ae299d4c12038e5a34e4fe1267c.mp3',
          name: 'Cobra-Lat-Pull-Downs.mp3',
          description: null,
          size: 28519,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating Forward Lunges-EXERCISE': {
      id: 199,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Forward Lunges',
      short_name: 'Alternating Forward Lunges',
      unique_name: 'BEGINNER-Alternating Forward Lunges-EXERCISE',
      description:
        '1. Start standing with your feet about shoulder-width apart, hands on your hips.\n2. With one leg, take a big step forward while keeping your hip square. Drop down into a lunge by bending both knees 90 degrees. Your back heel is elevated.\n3. Drive through the front foot and return to starting position.\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 412,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'eb65944c998370caddfb839169f1ae353a0b408afaa1882c9dc65092655393ae',
          file_name:
            'videos/eb65944c998370caddfb839169f1ae353a0b408afaa1882c9dc65092655393ae.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eb65944c998370caddfb839169f1ae353a0b408afaa1882c9dc65092655393ae.mp4',
          name: '021_BODYWEIGHT_FORWARD_LUNGES_1_small_720.mp4',
          description: null,
          size: 217368,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 413,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '543404e79bae8de72e5b379b0649fbe5c4bda2900fdf765eb23d45212e61eec7',
          file_name:
            'audios/543404e79bae8de72e5b379b0649fbe5c4bda2900fdf765eb23d45212e61eec7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/543404e79bae8de72e5b379b0649fbe5c4bda2900fdf765eb23d45212e61eec7.mp3',
          name: 'Alternating-Forward-Lunges.mp3',
          description: null,
          size: 30534,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Five Fast Feet to Squat-EXERCISE': {
      id: 200,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Five Fast Feet to Squat',
      short_name: 'Five Fast Feet to Squat',
      unique_name: 'BEGINNER-Five Fast Feet to Squat-EXERCISE',
      description:
        '1. Start standing with your feet a little wider than hip-width apart and knees slightly bent. Take five tiny fast running steps in place.\n2. Immediately drop into a squat.\n3. Return to standing and repeat.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 414,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '2fd4344475f209799e65a52d8c14a8f6f68a02d87768992df4b8bcec2264d27a',
          file_name:
            'videos/2fd4344475f209799e65a52d8c14a8f6f68a02d87768992df4b8bcec2264d27a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2fd4344475f209799e65a52d8c14a8f6f68a02d87768992df4b8bcec2264d27a.mp4',
          name: '022a_FAST_FIVE_FEET_TO_SQUAT_1_single_small_720.mp4',
          description: null,
          size: 97884,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 415,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'ec44d89afd39ecbf3a4240e0ed8f508620f9b513fa0b9ce4e3f4af85f197c306',
          file_name:
            'audios/ec44d89afd39ecbf3a4240e0ed8f508620f9b513fa0b9ce4e3f4af85f197c306.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ec44d89afd39ecbf3a4240e0ed8f508620f9b513fa0b9ce4e3f4af85f197c306.mp3',
          name: 'Five-Fast-Feet-to-Squat.mp3',
          description: null,
          size: 29383,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Up and Overs-EXERCISE': {
      id: 201,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Up and Overs',
      short_name: 'Up and Overs',
      unique_name: 'INTERMEDIATE-Up and Overs-EXERCISE',
      description:
        '1. Stand sideways on a step. Step off to the side with one leg so one foot is on the floor and the other remains on the step.\n2. Drive through the foot that is on the step, and jump up and over so the opposite foot is on the step and the other on the floor.\n3. Immediately jump up and over again and return to start position.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 416,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '4bdf8bd02416291cf0771d9953dc8bcad315665356a6442cef6c56629b37986b',
          file_name:
            'videos/4bdf8bd02416291cf0771d9953dc8bcad315665356a6442cef6c56629b37986b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4bdf8bd02416291cf0771d9953dc8bcad315665356a6442cef6c56629b37986b.mp4',
          name: '028a_UP_AND_OVERS_ALT_1_small_720.mp4',
          description: null,
          size: 118812,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 417,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '64d13cc74c468ed0048bf85c0598c2e167ee04a6ff02d33d242162d8c8eba6c7',
          file_name:
            'audios/64d13cc74c468ed0048bf85c0598c2e167ee04a6ff02d33d242162d8c8eba6c7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/64d13cc74c468ed0048bf85c0598c2e167ee04a6ff02d33d242162d8c8eba6c7.mp3',
          name: 'Up-and-Overs.mp3',
          description: null,
          size: 19879,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Up and Overs-EXERCISE': {
      id: 202,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Up and Overs',
      short_name: 'Up and Overs',
      unique_name: 'ADVANCED-Up and Overs-EXERCISE',
      description:
        '1. Stand sideways on a bench. Step off to the side with one leg so one foot is on the floor and the other remains on the bench.\n2. Drive through the foot that is on the bench, and jump up and over so the opposite foot is on the bench and the other on the floor.\n3. Immediately jump up and over again and return to start position.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 418,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'ac2fe4f746e30d66a586506d96ea27b975172259685434b6d99e015a7b9e2760',
          file_name:
            'videos/ac2fe4f746e30d66a586506d96ea27b975172259685434b6d99e015a7b9e2760.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ac2fe4f746e30d66a586506d96ea27b975172259685434b6d99e015a7b9e2760.mp4',
          name: '028_UP_AND_OVERS_1_small_720.mp4',
          description: null,
          size: 174949,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 419,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '64d13cc74c468ed0048bf85c0598c2e167ee04a6ff02d33d242162d8c8eba6c7',
          file_name:
            'audios/64d13cc74c468ed0048bf85c0598c2e167ee04a6ff02d33d242162d8c8eba6c7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/64d13cc74c468ed0048bf85c0598c2e167ee04a6ff02d33d242162d8c8eba6c7.mp3',
          name: 'Up-and-Overs.mp3',
          description: null,
          size: 19879,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Plank Around the World-EXERCISE': {
      id: 203,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Plank Around the World',
      short_name: 'Plank Around the World',
      unique_name: 'INTERMEDIATE-Plank Around the World-EXERCISE',
      description:
        '1. Start in Plank position with shoulders over wrists, straight spine and core engaged.\n2. Reach one arm straight in front of you to shoulder height, then return to Plank. Repeat with the other arm and return to start position.\n3. Lift the same side leg as the previous arm to hip height without arching your back. Return to Plank and repeat with the other leg.\n4. All the way "around" is one rep.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 420,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '3576d84d166caf4eccd71482e456ff8c63b7b55437f32a5a1189a8ef6ca4a4da',
          file_name:
            'videos/3576d84d166caf4eccd71482e456ff8c63b7b55437f32a5a1189a8ef6ca4a4da.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3576d84d166caf4eccd71482e456ff8c63b7b55437f32a5a1189a8ef6ca4a4da.mp4',
          name: 'INT-ADV-Plank_Around_The_World-EXERCISE.mp4',
          description: null,
          size: 208739,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 421,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '7d00ea4c102e7d2908681efc9798982fbc4c8b98ace8b634feb7b2695632f8e2',
          file_name:
            'audios/7d00ea4c102e7d2908681efc9798982fbc4c8b98ace8b634feb7b2695632f8e2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7d00ea4c102e7d2908681efc9798982fbc4c8b98ace8b634feb7b2695632f8e2.mp3',
          name: 'INT-ADV-Plank_Around_the_World-EXERCISE.mp3',
          description: null,
          size: 28231,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Plank Around the World-EXERCISE': {
      id: 204,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Plank Around the World',
      short_name: 'Plank Around the World',
      unique_name: 'ADVANCED-Plank Around the World-EXERCISE',
      description:
        '1. Start in Plank position with shoulders over wrists, straight spine and core engaged.\n2. Reach one arm straight in front of you to shoulder height, then return to Plank. Repeat with the other arm and return to start position.\n3. Lift the same side leg as the previous arm to hip height without arching your back. Return to Plank and repeat with the other leg.\n4. All the way "around" is one rep.',
      preview_time: 10,
      min_app_version: 100030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 422,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '3576d84d166caf4eccd71482e456ff8c63b7b55437f32a5a1189a8ef6ca4a4da',
          file_name:
            'videos/3576d84d166caf4eccd71482e456ff8c63b7b55437f32a5a1189a8ef6ca4a4da.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3576d84d166caf4eccd71482e456ff8c63b7b55437f32a5a1189a8ef6ca4a4da.mp4',
          name: 'INT-ADV-Plank_Around_The_World-EXERCISE.mp4',
          description: null,
          size: 208739,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 423,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '7d00ea4c102e7d2908681efc9798982fbc4c8b98ace8b634feb7b2695632f8e2',
          file_name:
            'audios/7d00ea4c102e7d2908681efc9798982fbc4c8b98ace8b634feb7b2695632f8e2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7d00ea4c102e7d2908681efc9798982fbc4c8b98ace8b634feb7b2695632f8e2.mp3',
          name: 'INT-ADV-Plank_Around_the_World-EXERCISE.mp3',
          description: null,
          size: 28231,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Five Fast Feet to Vertical Jump-EXERCISE': {
      id: 208,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Five Fast Feet to Vertical Jump',
      short_name: 'Five Fast Feet to Vertical Jump',
      unique_name: 'BEGINNER-Five Fast Feet to Vertical Jump-EXERCISE',
      description:
        '1. Start standing with your feet a little wider than hip-width apart and knees slightly bent. Take five tiny fast running steps in place.\n2. Jump as high as you can.\n3. Land soft and repeat.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 430,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'ab22ad8f8c8749730ce4828e8ec90272d3e04ac5f9581a9ca3fa7677f9f2b306',
          file_name:
            'videos/ab22ad8f8c8749730ce4828e8ec90272d3e04ac5f9581a9ca3fa7677f9f2b306.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ab22ad8f8c8749730ce4828e8ec90272d3e04ac5f9581a9ca3fa7677f9f2b306.mp4',
          name: 'BEGINNER-Five_Fast_Feet_to_Vertical_Jump-EXERCISE.mp4',
          description: null,
          size: 135120,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 431,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'a867bf539bbe1e1d5e2e6231d76862d0c73d7f72bd2e46ea45f238cf1ef60753',
          file_name:
            'audios/a867bf539bbe1e1d5e2e6231d76862d0c73d7f72bd2e46ea45f238cf1ef60753.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a867bf539bbe1e1d5e2e6231d76862d0c73d7f72bd2e46ea45f238cf1ef60753.mp3',
          name: 'BEGINNER-Five_Fast_Feet_to_Vertical_Jump-EXERCISE.mp3',
          description: null,
          size: 33991,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Squat to Reverse Lunge-EXERCISE': {
      id: 209,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Squat to Reverse Lunge',
      short_name: 'Squat to Reverse Lunge',
      unique_name: 'INTERMEDIATE-Squat to Reverse Lunge-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, one dumbbell in each hand.\n2. Maintaining good posture, squat as low as possible. Drive through heels to stand.\n3. Take a big step backward with one leg, landing with your heel elevated and hips square. Drop down into a lunge bending both knees 90 degrees.\n4. Drive through the front foot and return to start position.\n5. Repeat on other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 432,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '2a5b183f90a726421918e7435685a4b90b2c9663c3c5b91e616e700f3b84472b',
          file_name:
            'videos/2a5b183f90a726421918e7435685a4b90b2c9663c3c5b91e616e700f3b84472b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2a5b183f90a726421918e7435685a4b90b2c9663c3c5b91e616e700f3b84472b.mp4',
          name: 'INT-ADV-Squat_to_Reverse_Lunge-EXERCISE.mp4',
          description: null,
          size: 391973,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 433,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '9ba92520e1b5dd70ec94b7fd6cd64c99e48568e63462c0c55c60b28f663133f1',
          file_name:
            'audios/9ba92520e1b5dd70ec94b7fd6cd64c99e48568e63462c0c55c60b28f663133f1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9ba92520e1b5dd70ec94b7fd6cd64c99e48568e63462c0c55c60b28f663133f1.mp3',
          name: 'BEG-INT-ADV-Squat_to_Reverse_Lunge-EXERCISE.mp3',
          description: null,
          size: 38258,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Squat to Reverse Lunge-EXERCISE': {
      id: 210,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Squat to Reverse Lunge',
      short_name: 'Squat to Reverse Lunge',
      unique_name: 'ADVANCED-Squat to Reverse Lunge-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, one dumbbell in each hand.\n2. Maintaining good posture, squat as low as possible. Drive through heels to stand.\n3. Take a big step backward with one leg, landing with your heel elevated and hips square. Drop down into a lunge bending both knees 90 degrees.\n4. Drive through the front foot and return to start position.\n5. Repeat on other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 434,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '2a5b183f90a726421918e7435685a4b90b2c9663c3c5b91e616e700f3b84472b',
          file_name:
            'videos/2a5b183f90a726421918e7435685a4b90b2c9663c3c5b91e616e700f3b84472b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2a5b183f90a726421918e7435685a4b90b2c9663c3c5b91e616e700f3b84472b.mp4',
          name: 'INT-ADV-Squat_to_Reverse_Lunge-EXERCISE.mp4',
          description: null,
          size: 391973,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 435,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '9ba92520e1b5dd70ec94b7fd6cd64c99e48568e63462c0c55c60b28f663133f1',
          file_name:
            'audios/9ba92520e1b5dd70ec94b7fd6cd64c99e48568e63462c0c55c60b28f663133f1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9ba92520e1b5dd70ec94b7fd6cd64c99e48568e63462c0c55c60b28f663133f1.mp3',
          name: 'BEG-INT-ADV-Squat_to_Reverse_Lunge-EXERCISE.mp3',
          description: null,
          size: 38258,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Plank Jack Shoulder Taps-EXERCISE': {
      id: 211,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Plank Jack Shoulder Taps',
      short_name: 'Plank Jack Shoulder Taps',
      unique_name: 'INTERMEDIATE-Plank Jack Shoulder Taps-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Keeping your hips and shoulders square to the floor, lift one hand off the ground and tap the opposite shoulder.\n3. Return to Plank position. Repeat with the other hand.\n4. Jack your feet out into a wide "V" then back into start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 436,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'fb5dfeb2096cc7db8ab72123e2ac5b4f861515b5d2e082509a91eac533f04092',
          file_name:
            'videos/fb5dfeb2096cc7db8ab72123e2ac5b4f861515b5d2e082509a91eac533f04092.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fb5dfeb2096cc7db8ab72123e2ac5b4f861515b5d2e082509a91eac533f04092.mp4',
          name: 'INTERMEDIATE-Plank_Jack_Shoulder_Taps-EXERCISE.mp4',
          description: null,
          size: 118208,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 437,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'bce28d524c9d489e989dfa71279a99c47db188220f0193fdca174e685b56317e',
          file_name:
            'audios/bce28d524c9d489e989dfa71279a99c47db188220f0193fdca174e685b56317e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/bce28d524c9d489e989dfa71279a99c47db188220f0193fdca174e685b56317e.mp3',
          name: 'INTERMEDIATE-Plank_Jack_Shoulder_Taps-EXERCISE.mp3',
          description: null,
          size: 27103,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Mountain Climbers-EXERCISE': {
      id: 212,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Mountain Climbers',
      short_name: 'Mountain Climbers',
      unique_name: 'ADVANCED-Mountain Climbers-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Pull one knee straight up toward your chest while the other remains engaged and extended.\n3. Keeping your hips low, jump your bent knee back and extend it to a one leg Plank position while drawing the opposite knee up towards your chest. (Think High-Knees in Plank position).\n4. Repeat again on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 438,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '1e3ccd80bf6c1264c9fd0624aa89ddd17506352ef277c2eb924fe57426234aae',
          file_name:
            'videos/1e3ccd80bf6c1264c9fd0624aa89ddd17506352ef277c2eb924fe57426234aae.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1e3ccd80bf6c1264c9fd0624aa89ddd17506352ef277c2eb924fe57426234aae.mp4',
          name: 'ADVANCED-Mountain_Climbers-EXERCISE.mp4',
          description: null,
          size: 67199,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 439,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'eb80c51e7d243b58b4cb8731685492707cbf17ec197ff8fb12cd0597668dde47',
          file_name:
            'audios/eb80c51e7d243b58b4cb8731685492707cbf17ec197ff8fb12cd0597668dde47.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eb80c51e7d243b58b4cb8731685492707cbf17ec197ff8fb12cd0597668dde47.mp3',
          name: 'ADVANCED-Mountain_Climbers-EXERCISE.mp3',
          description: null,
          size: 23008,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Donkey Kicks-EXERCISE': {
      id: 213,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Donkey Kicks',
      short_name: 'Donkey Kicks',
      unique_name: 'BEGINNER-Donkey Kicks-EXERCISE',
      description:
        '1. Start on all fours with shoulders over wrists and knees under hips. Keep your hips square and core tight.\n2. Hover one knee off the ground and raise your leg up behind you to hip level, driving your heel toward the ceiling. Pretend you are making a footprint.\n3. Squeeze glutes at the top. Do not arch your lower back. Slowly lower back to start position.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 464,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '70609fe5228a0850a57d497ee7a7b4752643e924235c8b91a2c8b1ca093dc7cb',
          file_name:
            'videos/70609fe5228a0850a57d497ee7a7b4752643e924235c8b91a2c8b1ca093dc7cb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/70609fe5228a0850a57d497ee7a7b4752643e924235c8b91a2c8b1ca093dc7cb.mp4',
          name: 'BEGINNER-Donkey_Kicks-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 70932,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 465,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '59a7a8b3cac65a767927ea1d1843c63105c570484f816db6db58a6d81ad9cc4e',
          file_name:
            'videos/59a7a8b3cac65a767927ea1d1843c63105c570484f816db6db58a6d81ad9cc4e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/59a7a8b3cac65a767927ea1d1843c63105c570484f816db6db58a6d81ad9cc4e.mp4',
          name: 'BEGINNER-Donkey_Kicks-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 60682,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 466,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '41b4b2291b6c16a1a3e16839b211d7529f06035d33df28a275080bbf31b79946',
          file_name:
            'audios/41b4b2291b6c16a1a3e16839b211d7529f06035d33df28a275080bbf31b79946.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/41b4b2291b6c16a1a3e16839b211d7529f06035d33df28a275080bbf31b79946.mp3',
          name: 'BEGINNER-Donkey_Kicks-EXERCISE.mp3',
          description: null,
          size: 21030,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Alternating Floor Presses-EXERCISE': {
      id: 214,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Alternating Floor Presses',
      short_name: 'Alternating Floor Presses',
      unique_name: 'INTERMEDIATE-Alternating Floor Presses-EXERCISE',
      description:
        '1. Lie on your back with knees bent and feet flat. Hold a dumbbell in each hand and bend elbows to 90 degrees. Upper arms are on the floor, palms face each other.\n2. Keep elbows tight to your body, pointing toward your hips at 45 degrees. Press one dumbbell straight up and rotate your palm toward your feet.\n3. Lower the arm back to start and repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 467,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'ae2b4609ad1b4ed86822c89ede310fc39c1685476a0809f28b4bb7fe811767f6',
          file_name:
            'videos/ae2b4609ad1b4ed86822c89ede310fc39c1685476a0809f28b4bb7fe811767f6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ae2b4609ad1b4ed86822c89ede310fc39c1685476a0809f28b4bb7fe811767f6.mp4',
          name: 'INTERMEDIATE-Alternating_Floor_Presses-EXERCISE.mp4',
          description: null,
          size: 97821,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 468,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '7e88dcefc80bcf322a08b854a7c08ff83f70c349c6a6c90eb834c3c20ba6f0ab',
          file_name:
            'audios/7e88dcefc80bcf322a08b854a7c08ff83f70c349c6a6c90eb834c3c20ba6f0ab.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7e88dcefc80bcf322a08b854a7c08ff83f70c349c6a6c90eb834c3c20ba6f0ab.mp3',
          name: 'INT-ADV-Alternating_Floor_Presses-EXERCISE.mp3',
          description: null,
          size: 29670,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Alternating Floor Presses-EXERCISE': {
      id: 215,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Alternating Floor Presses',
      short_name: 'Alternating Floor Presses',
      unique_name: 'ADVANCED-Alternating Floor Presses-EXERCISE',
      description:
        '1. Lie on your back with knees bent and feet flat. Hold a dumbbell in each hand and bend elbows to 90 degrees. Upper arms are on the floor, palms face each other.\n2. Keep elbows tight to your body, pointing toward your hips at 45 degrees. Press one dumbbell straight up and rotate your palm toward your feet.\n3. Lower the arm back to start and repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 469,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'ae2b4609ad1b4ed86822c89ede310fc39c1685476a0809f28b4bb7fe811767f6',
          file_name:
            'videos/ae2b4609ad1b4ed86822c89ede310fc39c1685476a0809f28b4bb7fe811767f6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ae2b4609ad1b4ed86822c89ede310fc39c1685476a0809f28b4bb7fe811767f6.mp4',
          name: 'ADVANCED-Alternating_Floor_Presses-EXERCISE.mp4',
          description: null,
          size: 97821,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 470,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '7e88dcefc80bcf322a08b854a7c08ff83f70c349c6a6c90eb834c3c20ba6f0ab',
          file_name:
            'audios/7e88dcefc80bcf322a08b854a7c08ff83f70c349c6a6c90eb834c3c20ba6f0ab.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7e88dcefc80bcf322a08b854a7c08ff83f70c349c6a6c90eb834c3c20ba6f0ab.mp3',
          name: 'INT-ADV-Alternating_Floor_Presses-EXERCISE.mp3',
          description: null,
          size: 29670,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Repeater Knees-EXERCISE': {
      id: 216,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Repeater Knees',
      short_name: 'Repeater Knees',
      unique_name: 'BEGINNER-Repeater Knees-EXERCISE',
      description:
        '1. Start in a lunge with the front knee bent to 90 degrees and back leg straight behind you, heel elevated.\n2. Tip your upper body over the front knee and reach both arms overhead.\n3. Transfer weight to the front leg and explosively drive your knee up the midline toward your chest. Your arms come down to meet your knee. Return to start.\n4. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 495,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '8bbc1daabedeeaa4773698d78f9650dd574cf7cc72840f09daca28dc00a4cb4e',
          file_name:
            'videos/8bbc1daabedeeaa4773698d78f9650dd574cf7cc72840f09daca28dc00a4cb4e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8bbc1daabedeeaa4773698d78f9650dd574cf7cc72840f09daca28dc00a4cb4e.mp4',
          name: 'BEGINNER-Repeater_Knees-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 66703,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 496,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: 'a211104517b2230ec26ed47681289501632ff89b09d045aa5c3c717c5b96a54d',
          file_name:
            'videos/a211104517b2230ec26ed47681289501632ff89b09d045aa5c3c717c5b96a54d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a211104517b2230ec26ed47681289501632ff89b09d045aa5c3c717c5b96a54d.mp4',
          name: 'BEGINNER-Repeater_Knees-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 65186,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 497,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'e382f234915646f206f10952df94ed792a6011b7e475ceff2d77cc7ea6808462',
          file_name:
            'audios/e382f234915646f206f10952df94ed792a6011b7e475ceff2d77cc7ea6808462.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e382f234915646f206f10952df94ed792a6011b7e475ceff2d77cc7ea6808462.mp3',
          name: 'BEGINNER-Repeater_Knees-EXERCISE.mp3',
          description: null,
          size: 22182,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Step Ups-EXERCISE': {
      id: 217,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Step Ups',
      short_name: 'Step Ups',
      unique_name: 'INTERMEDIATE-Step Ups-EXERCISE',
      description:
        '1. Start standing, facing a bench and holding a dumbbell in each hand by your sides. Feet close to the bench.\n2. Place one foot on the bench and lean slightly forward to put your weight in the front leg.\n3. Maintaining good posture, drive off the leg that is on the bench to stand up fully. Lower yourself back down with the same leg. Do not switch at the top.\n4. Perform all reps with one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 498,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'af3a00ec7f8c34ae7a47155499cfcb952981ae8bb5144957a7c3ad8e3c94ab73',
          file_name:
            'videos/af3a00ec7f8c34ae7a47155499cfcb952981ae8bb5144957a7c3ad8e3c94ab73.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/af3a00ec7f8c34ae7a47155499cfcb952981ae8bb5144957a7c3ad8e3c94ab73.mp4',
          name: 'INTERMEDIATE-Step_Ups-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 183572,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 499,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: 'd1944272637476127f2427ce9acd9d63155c42ba33acdcccb7ac04b56b6125ca',
          file_name:
            'videos/d1944272637476127f2427ce9acd9d63155c42ba33acdcccb7ac04b56b6125ca.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d1944272637476127f2427ce9acd9d63155c42ba33acdcccb7ac04b56b6125ca.mp4',
          name: 'INTERMEDIATE-Step_Ups-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 196796,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 500,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '7fb363aade6f1679b12ff0e6d2fa59497011a17b2cddd5666d837de68d8a0f54',
          file_name:
            'audios/7fb363aade6f1679b12ff0e6d2fa59497011a17b2cddd5666d837de68d8a0f54.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7fb363aade6f1679b12ff0e6d2fa59497011a17b2cddd5666d837de68d8a0f54.mp3',
          name: 'INTERMEDIATE-Step_Ups-EXERCISE.mp3',
          description: null,
          size: 18727,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Step Ups-EXERCISE': {
      id: 218,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Step Ups',
      short_name: 'Step Ups',
      unique_name: 'ADVANCED-Step Ups-EXERCISE',
      description:
        '1. Start standing, facing a bench and holding a dumbbell in each hand by your sides. Feet close to the bench.\n2. Place one foot on the bench and lean slightly forward to put your weight in the front leg.\n3. Maintaining good posture, drive off the leg that is on the bench to stand up fully. Lower yourself back down with the same leg. Do not switch at the top.\n4. Perform all reps with one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 501,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'af3a00ec7f8c34ae7a47155499cfcb952981ae8bb5144957a7c3ad8e3c94ab73',
          file_name:
            'videos/af3a00ec7f8c34ae7a47155499cfcb952981ae8bb5144957a7c3ad8e3c94ab73.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/af3a00ec7f8c34ae7a47155499cfcb952981ae8bb5144957a7c3ad8e3c94ab73.mp4',
          name: 'ADVANCED-Step_Ups-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 183572,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 502,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: 'd1944272637476127f2427ce9acd9d63155c42ba33acdcccb7ac04b56b6125ca',
          file_name:
            'videos/d1944272637476127f2427ce9acd9d63155c42ba33acdcccb7ac04b56b6125ca.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d1944272637476127f2427ce9acd9d63155c42ba33acdcccb7ac04b56b6125ca.mp4',
          name: 'ADVANCED-Step_Ups-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 196796,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 503,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '7fb363aade6f1679b12ff0e6d2fa59497011a17b2cddd5666d837de68d8a0f54',
          file_name:
            'audios/7fb363aade6f1679b12ff0e6d2fa59497011a17b2cddd5666d837de68d8a0f54.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7fb363aade6f1679b12ff0e6d2fa59497011a17b2cddd5666d837de68d8a0f54.mp3',
          name: 'ADVANCED-Step_Ups-EXERCISE.mp3',
          description: null,
          size: 18727,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Donkey Kicks with Weight-EXERCISE': {
      id: 219,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Donkey Kicks with Weight',
      short_name: 'Donkey Kicks with Weight',
      unique_name: 'INTERMEDIATE-Donkey Kicks with Weight-EXERCISE',
      description:
        '1. Start on all fours. Place one dumbbell behind your knee and squeeze. Keep shoulders and hips square, core tight.\n2. Hover weighted knee off the ground and raise your leg up behind you to hip level, driving heel toward the ceiling. Pretend to make a footprint.\n3. Squeeze glutes at the top. Do not arch your lower back. Slowly lower back to start position.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 516,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '7ac6d774c95202e97d27ddab94493bb39efdf3e2dce9468f5c50c2b20a1218e9',
          file_name:
            'videos/7ac6d774c95202e97d27ddab94493bb39efdf3e2dce9468f5c50c2b20a1218e9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7ac6d774c95202e97d27ddab94493bb39efdf3e2dce9468f5c50c2b20a1218e9.mp4',
          name: 'INT-ADV-Donkey_Kicks_with_Weight-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 83738,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 517,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '42984b156c4ea4cdd1b856d86c3b24ee184716ac20bfe2f8c89ba7d83ca93325',
          file_name:
            'videos/42984b156c4ea4cdd1b856d86c3b24ee184716ac20bfe2f8c89ba7d83ca93325.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/42984b156c4ea4cdd1b856d86c3b24ee184716ac20bfe2f8c89ba7d83ca93325.mp4',
          name: 'INT-ADV-Donkey_Kicks_with_Weight-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 77587,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 518,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'e121bb5260b04156e5831648ef210644c2cb9063885ef11124653158f1c87921',
          file_name:
            'audios/e121bb5260b04156e5831648ef210644c2cb9063885ef11124653158f1c87921.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e121bb5260b04156e5831648ef210644c2cb9063885ef11124653158f1c87921.mp3',
          name: 'INT-ADV-Donkey_Kicks_with_Weight-EXERCISE.mp3',
          description: null,
          size: 26503,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Donkey Kicks with Weight-EXERCISE': {
      id: 220,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Donkey Kicks with Weight',
      short_name: 'Donkey Kicks with Weight',
      unique_name: 'ADVANCED-Donkey Kicks with Weight-EXERCISE',
      description:
        '1. Start on all fours. Place one dumbbell behind your knee and squeeze. Keep shoulders and hips square, core tight.\n2. Hover weighted knee off the ground and raise your leg up behind you to hip level, driving heel toward the ceiling. Pretend to make a footprint.\n3. Squeeze glutes at the top. Do not arch your lower back. Slowly lower back to start position.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 513,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '7ac6d774c95202e97d27ddab94493bb39efdf3e2dce9468f5c50c2b20a1218e9',
          file_name:
            'videos/7ac6d774c95202e97d27ddab94493bb39efdf3e2dce9468f5c50c2b20a1218e9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7ac6d774c95202e97d27ddab94493bb39efdf3e2dce9468f5c50c2b20a1218e9.mp4',
          name: 'INT-ADV-Donkey_Kicks_with_Weight-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 83738,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 514,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '42984b156c4ea4cdd1b856d86c3b24ee184716ac20bfe2f8c89ba7d83ca93325',
          file_name:
            'videos/42984b156c4ea4cdd1b856d86c3b24ee184716ac20bfe2f8c89ba7d83ca93325.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/42984b156c4ea4cdd1b856d86c3b24ee184716ac20bfe2f8c89ba7d83ca93325.mp4',
          name: 'INT-ADV-Donkey_Kicks_with_Weight-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 77587,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 515,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'e121bb5260b04156e5831648ef210644c2cb9063885ef11124653158f1c87921',
          file_name:
            'audios/e121bb5260b04156e5831648ef210644c2cb9063885ef11124653158f1c87921.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e121bb5260b04156e5831648ef210644c2cb9063885ef11124653158f1c87921.mp3',
          name: 'INT-ADV-Donkey_Kicks_with_Weight-EXERCISE.mp3',
          description: null,
          size: 26503,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Static Lunges-EXERCISE': {
      id: 221,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Static Lunges',
      short_name: 'Bodyweight Static Lunges',
      unique_name: 'BEGINNER-Bodyweight Static Lunges-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, hands on hips. Take a big step forward with one leg, elevate your back heel.\n2. Drop your hips toward the floor by bending both knees to 90 degrees. Front knee should be directly over your ankle and back knee near the floor.\n3. Drive through your heel to straighten legs.\n4. Perform all reps with one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 519,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '1dafcacc7e47b180fe6ff5a59131e83365823731cf1e77a88c2a8e85180e140c',
          file_name:
            'videos/1dafcacc7e47b180fe6ff5a59131e83365823731cf1e77a88c2a8e85180e140c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1dafcacc7e47b180fe6ff5a59131e83365823731cf1e77a88c2a8e85180e140c.mp4',
          name: 'BEGINNER-Bodyweight_Static_Lunges-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 79642,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 520,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '3a0334b25fae6a07e35b2668c2f845d3da1537bc9e64e5ce38d599c237f0ba03',
          file_name:
            'videos/3a0334b25fae6a07e35b2668c2f845d3da1537bc9e64e5ce38d599c237f0ba03.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3a0334b25fae6a07e35b2668c2f845d3da1537bc9e64e5ce38d599c237f0ba03.mp4',
          name: 'BEGINNER-Bodyweight_Static_Lunges-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 76842,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 521,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'f9b3ffde9a9ea1bfa513a03352b2ecb4cb36b044a266771398ab239a3e0b5aee',
          file_name:
            'audios/f9b3ffde9a9ea1bfa513a03352b2ecb4cb36b044a266771398ab239a3e0b5aee.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f9b3ffde9a9ea1bfa513a03352b2ecb4cb36b044a266771398ab239a3e0b5aee.mp3',
          name: 'BEGINNER-Bodyweight_Static_Lunges-EXERCISE.mp3',
          description: null,
          size: 31687,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Single Leg Deadlifts-EXERCISE': {
      id: 222,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Single Leg Deadlifts',
      short_name: 'Single Leg Deadlifts',
      unique_name: 'INTERMEDIATE-Single Leg Deadlifts-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart. Hold a dumbbell in each hand in front of your body.\n2. Transfer your weight to one leg and hinge at the hips.\n3. Balancing on one leg, lower your torso until dumbbells are mid-shin and body is parallel to the floor. Extend the other leg straight behind you, toes point to the floor.\n4. Drive through the heel of your standing leg, raise your torso up to start.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 522,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'c9c99cc1aab19aa826cfc8a711181c1ace4bfdf9e5432c8c0b7053dd3bf635af',
          file_name:
            'videos/c9c99cc1aab19aa826cfc8a711181c1ace4bfdf9e5432c8c0b7053dd3bf635af.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c9c99cc1aab19aa826cfc8a711181c1ace4bfdf9e5432c8c0b7053dd3bf635af.mp4',
          name: 'INTERMEDIATE-Single_Leg_Deadlifts-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 203719,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 523,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: 'aa693fcde5cd8386bba13654c826e7a1f30595956af0db9ace7c401f6c6d956d',
          file_name:
            'videos/aa693fcde5cd8386bba13654c826e7a1f30595956af0db9ace7c401f6c6d956d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/aa693fcde5cd8386bba13654c826e7a1f30595956af0db9ace7c401f6c6d956d.mp4',
          name: 'INTERMEDIATE-Single_Leg_Deadlifts-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 195586,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 524,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '760586d5d171fbb77b98ca3675bebbcf2027d37664895a54eba94155aae5c7cc',
          file_name:
            'audios/760586d5d171fbb77b98ca3675bebbcf2027d37664895a54eba94155aae5c7cc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/760586d5d171fbb77b98ca3675bebbcf2027d37664895a54eba94155aae5c7cc.mp3',
          name: 'INTERMEDIATE-Single_Leg_Deadlifts-EXERCISE.mp3',
          description: null,
          size: 26791,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Single Leg Deadlifts-EXERCISE': {
      id: 223,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Single Leg Deadlifts',
      short_name: 'Single Leg Deadlifts',
      unique_name: 'ADVANCED-Single Leg Deadlifts-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart. Hold a dumbbell in each hand in front of your body.\n2. Transfer your weight to one leg and hinge at the hips.\n3. Balancing on one leg, lower your torso until dumbbells are mid-shin and body is parallel to the floor. Extend the other leg straight behind you, toes point to the floor.\n4. Drive through the heel of your standing leg, raise your torso up to start.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 525,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'c9c99cc1aab19aa826cfc8a711181c1ace4bfdf9e5432c8c0b7053dd3bf635af',
          file_name:
            'videos/c9c99cc1aab19aa826cfc8a711181c1ace4bfdf9e5432c8c0b7053dd3bf635af.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c9c99cc1aab19aa826cfc8a711181c1ace4bfdf9e5432c8c0b7053dd3bf635af.mp4',
          name: 'ADVANCED-Single_Leg_Deadlifts-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 203719,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 526,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: 'aa693fcde5cd8386bba13654c826e7a1f30595956af0db9ace7c401f6c6d956d',
          file_name:
            'videos/aa693fcde5cd8386bba13654c826e7a1f30595956af0db9ace7c401f6c6d956d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/aa693fcde5cd8386bba13654c826e7a1f30595956af0db9ace7c401f6c6d956d.mp4',
          name: 'ADVANCED-Single_Leg_Deadlifts-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 195586,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 527,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '760586d5d171fbb77b98ca3675bebbcf2027d37664895a54eba94155aae5c7cc',
          file_name:
            'audios/760586d5d171fbb77b98ca3675bebbcf2027d37664895a54eba94155aae5c7cc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/760586d5d171fbb77b98ca3675bebbcf2027d37664895a54eba94155aae5c7cc.mp3',
          name: 'ADVANCED-Single_Leg_Deadlifts-EXERCISE.mp3',
          description: null,
          size: 26791,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Bulgarian Split Squats-EXERCISE': {
      id: 224,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Bulgarian Split Squats',
      short_name: 'Bulgarian Split Squats',
      unique_name: 'INTERMEDIATE-Bulgarian Split Squats-EXERCISE',
      description:
        '1. Stand with your back toward the step. Take a step forward with one foot, bring the other one behind you and rest your toe on the step. Adjust for proper alignment.\n2. Maintaining good posture, drop the back knee straight down until your front thigh is parallel to the floor.\n3. Drive off the front heel to stand, keeping your back foot on the step.\n4. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 528,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'c6506d6cd2cf1e66bb141df7082f7fbe908c847f8a724c8e267b394bd319646a',
          file_name:
            'videos/c6506d6cd2cf1e66bb141df7082f7fbe908c847f8a724c8e267b394bd319646a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c6506d6cd2cf1e66bb141df7082f7fbe908c847f8a724c8e267b394bd319646a.mp4',
          name: 'INTERMEDIATE-Bulgarian_Split_Squats-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 96749,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 529,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '2da077a13399d95a061b78681738ed8adda2f0af578a0334be004a65e6c31e5e',
          file_name:
            'videos/2da077a13399d95a061b78681738ed8adda2f0af578a0334be004a65e6c31e5e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2da077a13399d95a061b78681738ed8adda2f0af578a0334be004a65e6c31e5e.mp4',
          name: 'INTERMEDIATE-Bulgarian_Split_Squats-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 96006,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 530,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '474d44176f9fe732e56f16841e154945b272a87955f4ec89b091acf3e3a3a601',
          file_name:
            'audios/474d44176f9fe732e56f16841e154945b272a87955f4ec89b091acf3e3a3a601.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/474d44176f9fe732e56f16841e154945b272a87955f4ec89b091acf3e3a3a601.mp3',
          name: 'INTERMEDIATE-Bulgarian_Split_Squats-EXERCISE.mp3',
          description: null,
          size: 28231,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Bulgarian Split Squats-EXERCISE': {
      id: 225,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Bulgarian Split Squats',
      short_name: 'Bulgarian Split Squats',
      unique_name: 'ADVANCED-Bulgarian Split Squats-EXERCISE',
      description:
        '1. Stand with your back toward the step. Take a step forward with one foot, bring the other one behind you and rest your toe on the step. Adjust for proper alignment.\n2. Maintaining good posture, drop the back knee straight down until your front thigh is parallel to the floor.\n3. Drive off the front heel to stand, keeping your back foot on the step.\n4. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 531,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'c511ea61efcec46834e59f5196b8b73d1491fcbf052dea61039e8fe852919d7b',
          file_name:
            'videos/c511ea61efcec46834e59f5196b8b73d1491fcbf052dea61039e8fe852919d7b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c511ea61efcec46834e59f5196b8b73d1491fcbf052dea61039e8fe852919d7b.mp4',
          name: 'ADVANCED-Bulgarian_Split_Squats-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 124562,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 532,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '4c83d63c7e73edde41d2c410c16ed448d83e15643e68159d32d315a0ab26f312',
          file_name:
            'videos/4c83d63c7e73edde41d2c410c16ed448d83e15643e68159d32d315a0ab26f312.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4c83d63c7e73edde41d2c410c16ed448d83e15643e68159d32d315a0ab26f312.mp4',
          name: 'ADVANCED-Bulgarian_Split_Squats-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 114839,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 533,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '474d44176f9fe732e56f16841e154945b272a87955f4ec89b091acf3e3a3a601',
          file_name:
            'audios/474d44176f9fe732e56f16841e154945b272a87955f4ec89b091acf3e3a3a601.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/474d44176f9fe732e56f16841e154945b272a87955f4ec89b091acf3e3a3a601.mp3',
          name: 'ADVANCED-Bulgarian_Split_Squats-EXERCISE.mp3',
          description: null,
          size: 28231,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Log Hops-EXERCISE': {
      id: 226,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Log Hops',
      short_name: 'Log Hops',
      unique_name: 'ADVANCED-Log Hops-EXERCISE',
      description:
        '1. Place both hands on the end of the bench with both legs together and extended behind you. Your arms are straight but elbows not locked.\n2. Bend your knees, engage your core and jump both feet up and over the bench to one side.\n3. Immediately jump your feet to the other side without a double bounce.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 558,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '52dd753fa3f2f5308c1df3be5fd9c24d11a84409a33c064333ee2158a5fd85b3',
          file_name:
            'videos/52dd753fa3f2f5308c1df3be5fd9c24d11a84409a33c064333ee2158a5fd85b3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/52dd753fa3f2f5308c1df3be5fd9c24d11a84409a33c064333ee2158a5fd85b3.mp4',
          name: 'ADVANCED-Log_Hops-EXERCISE.mp4',
          description: null,
          size: 115746,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 559,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '00947d9c08d8381ce5c3ff5e880ac6f8c00aa58021df9dce272ec5fde627829a',
          file_name:
            'audios/00947d9c08d8381ce5c3ff5e880ac6f8c00aa58021df9dce272ec5fde627829a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/00947d9c08d8381ce5c3ff5e880ac6f8c00aa58021df9dce272ec5fde627829a.mp3',
          name: 'ADVANCED-Log_Hops-EXERCISE.mp3',
          description: null,
          size: 19636,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Reverse Lunge with Knee Drive-EXERCISE': {
      id: 227,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Reverse Lunge with Knee Drive',
      short_name: 'Rev. Lunge with Knee Drive',
      unique_name: 'BEGINNER-Reverse Lunge with Knee Drive-EXERCISE',
      description:
        '1. Start standing with your feet shoulder-width apart.\n2. Take a big step backward with one leg, landing with your heel elevated and hips square. Drop down into a lunge by bending both knees 90 degrees.\n3. Drive through the front foot and bring your back knee up parallel to the floor as you stand tall.\n4. Return to lunge position. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 560,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'af3217af24368adce1ab5ba4bce7601e29b9939c327f3e6a4d003619d2ab9822',
          file_name:
            'videos/af3217af24368adce1ab5ba4bce7601e29b9939c327f3e6a4d003619d2ab9822.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/af3217af24368adce1ab5ba4bce7601e29b9939c327f3e6a4d003619d2ab9822.mp4',
          name: 'BEGINNER-Reverse_Lunge_with_Knee_Drive-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 112819,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 561,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '8a674e8a6dcdebaf744c1ebd093d269520a239cbda8ebfecf0e4981199ab8000',
          file_name:
            'videos/8a674e8a6dcdebaf744c1ebd093d269520a239cbda8ebfecf0e4981199ab8000.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8a674e8a6dcdebaf744c1ebd093d269520a239cbda8ebfecf0e4981199ab8000.mp4',
          name: 'BEGINNER-Reverse_Lunge_with_Knee_Drive-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 123365,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 562,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '835b36c56e872346e4201395523a130584f17e45987995bf35e8415378719ff1',
          file_name:
            'audios/835b36c56e872346e4201395523a130584f17e45987995bf35e8415378719ff1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/835b36c56e872346e4201395523a130584f17e45987995bf35e8415378719ff1.mp3',
          name: 'BEGINNER-Reverse_Lunge_with_Knee_Drive-EXERCISE.mp3',
          description: null,
          size: 39968,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Step Ups with Hop-EXERCISE': {
      id: 228,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Step Ups with Hop',
      short_name: 'Step Ups with Hop',
      unique_name: 'INTERMEDIATE-Step Ups with Hop-EXERCISE',
      description:
        '1.Stand with one foot on the bench. Your knee is bent at 90 degrees.\n2. Bend your standing leg slightly. Drive off the front leg to jump straight up and "get some air".\n3. Land in start position with the same foot on the bench and the same foot on the floor.\n4. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 563,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '1aceadbeb09faf1604aaef16caaabf2b198d0ff573a1279adb6ce7542197a5fd',
          file_name:
            'videos/1aceadbeb09faf1604aaef16caaabf2b198d0ff573a1279adb6ce7542197a5fd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1aceadbeb09faf1604aaef16caaabf2b198d0ff573a1279adb6ce7542197a5fd.mp4',
          name: 'INTERMEDIATE-Step_Ups_with_Hop-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 95849,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 564,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '1f630289bfe810efe08e4e485b22cc797593f0b1bf6a50664f35acd66ac6eda7',
          file_name:
            'videos/1f630289bfe810efe08e4e485b22cc797593f0b1bf6a50664f35acd66ac6eda7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1f630289bfe810efe08e4e485b22cc797593f0b1bf6a50664f35acd66ac6eda7.mp4',
          name: 'INTERMEDIATE-Step_Ups_with_Hop-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 98459,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 565,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '578973f823518be88e780a75711f9a84d3dd19ccf24f11b9fb181a6b69624bc0',
          file_name:
            'audios/578973f823518be88e780a75711f9a84d3dd19ccf24f11b9fb181a6b69624bc0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/578973f823518be88e780a75711f9a84d3dd19ccf24f11b9fb181a6b69624bc0.mp3',
          name: 'INTERMEDIATE-Step_Ups_with_Hop-EXERCISE.mp3',
          description: null,
          size: 26272,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Step Ups with Hop-EXERCISE': {
      id: 229,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Step Ups with Hop',
      short_name: 'Step Ups with Hop',
      unique_name: 'ADVANCED-Step Ups with Hop-EXERCISE',
      description:
        '1.Stand with one foot on the bench. Your knee is bent at 90 degrees.\n2. Bend your standing leg slightly. Drive off the front leg to jump straight up and "get some air".\n3. Land in start position with the same foot on the bench and the same foot on the floor.\n4. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 566,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '1aceadbeb09faf1604aaef16caaabf2b198d0ff573a1279adb6ce7542197a5fd',
          file_name:
            'videos/1aceadbeb09faf1604aaef16caaabf2b198d0ff573a1279adb6ce7542197a5fd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1aceadbeb09faf1604aaef16caaabf2b198d0ff573a1279adb6ce7542197a5fd.mp4',
          name: 'ADVANCED-Step_Ups_with_Hop-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 95849,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 567,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '1f630289bfe810efe08e4e485b22cc797593f0b1bf6a50664f35acd66ac6eda7',
          file_name:
            'videos/1f630289bfe810efe08e4e485b22cc797593f0b1bf6a50664f35acd66ac6eda7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1f630289bfe810efe08e4e485b22cc797593f0b1bf6a50664f35acd66ac6eda7.mp4',
          name: 'ADVANCED-Step_Ups_with_Hop-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 98459,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 568,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '578973f823518be88e780a75711f9a84d3dd19ccf24f11b9fb181a6b69624bc0',
          file_name:
            'audios/578973f823518be88e780a75711f9a84d3dd19ccf24f11b9fb181a6b69624bc0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/578973f823518be88e780a75711f9a84d3dd19ccf24f11b9fb181a6b69624bc0.mp3',
          name: 'ADVANCED-Step_Ups_with_Hop-EXERCISE.mp3',
          description: null,
          size: 26272,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Reverse Lunge with Hop-EXERCISE': {
      id: 230,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Reverse Lunge with Hop',
      short_name: 'Rev. Lunge with Hop',
      unique_name: 'INTERMEDIATE-Reverse Lunge with Hop-EXERCISE',
      description:
        '1. Stand in the center of a bench lengthwise with your feet shoulder-width apart.\n2. Take a big step backward with one leg. Land your foot on the floor with heel elevated and hips square. Drop down into a lunge by bending both knees 90 degrees.\n3. Drive through the foot on the bench to jump straight up and "get some air".\n4. Return to lunge position. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 569,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '2eb103ddddcf210820917a4b8744e25dd770feb80d5bab8aded3f17a2b28cc87',
          file_name:
            'videos/2eb103ddddcf210820917a4b8744e25dd770feb80d5bab8aded3f17a2b28cc87.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2eb103ddddcf210820917a4b8744e25dd770feb80d5bab8aded3f17a2b28cc87.mp4',
          name: 'INTERMEDIATE-Reverse_Lunge_with_Hop-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 136769,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 570,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '4801b0fa84c6204d8305a5bdbc3fd01ac262cb78495e8ccfb2dacb73001205bc',
          file_name:
            'videos/4801b0fa84c6204d8305a5bdbc3fd01ac262cb78495e8ccfb2dacb73001205bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4801b0fa84c6204d8305a5bdbc3fd01ac262cb78495e8ccfb2dacb73001205bc.mp4',
          name: 'INTERMEDIATE-Reverse_Lunge_with_Hop-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 131779,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 571,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '039c9730500f72d4133c8b98b4b8c7ba666cc51e95f6bca12b9cdfc6abfe2f4a',
          file_name:
            'audios/039c9730500f72d4133c8b98b4b8c7ba666cc51e95f6bca12b9cdfc6abfe2f4a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/039c9730500f72d4133c8b98b4b8c7ba666cc51e95f6bca12b9cdfc6abfe2f4a.mp3',
          name: 'INT-ADV-Reverse_Lunge_with_Hop-EXERCISE.mp3',
          description: null,
          size: 28806,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Reverse Lunge with Hop-EXERCISE': {
      id: 231,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Reverse Lunge with Hop',
      short_name: 'Rev. Lunge with Hop',
      unique_name: 'ADVANCED-Reverse Lunge with Hop-EXERCISE',
      description:
        '1. Stand in the center of a bench lengthwise with your feet shoulder-width apart.\n2. Take a big step backward with one leg. Land your foot on the floor with heel elevated and hips square. Drop down into a lunge by bending both knees 90 degrees.\n3. Drive through the foot on the bench to jump straight up and "get some air."\n4. Return to lunge position. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 572,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '2eb103ddddcf210820917a4b8744e25dd770feb80d5bab8aded3f17a2b28cc87',
          file_name:
            'videos/2eb103ddddcf210820917a4b8744e25dd770feb80d5bab8aded3f17a2b28cc87.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2eb103ddddcf210820917a4b8744e25dd770feb80d5bab8aded3f17a2b28cc87.mp4',
          name: 'ADVANCED-Reverse_Lunge_with_Hop-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 136769,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 573,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '4801b0fa84c6204d8305a5bdbc3fd01ac262cb78495e8ccfb2dacb73001205bc',
          file_name:
            'videos/4801b0fa84c6204d8305a5bdbc3fd01ac262cb78495e8ccfb2dacb73001205bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4801b0fa84c6204d8305a5bdbc3fd01ac262cb78495e8ccfb2dacb73001205bc.mp4',
          name: 'ADVANCED-Reverse_Lunge_with_Hop-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 131779,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 574,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '039c9730500f72d4133c8b98b4b8c7ba666cc51e95f6bca12b9cdfc6abfe2f4a',
          file_name:
            'audios/039c9730500f72d4133c8b98b4b8c7ba666cc51e95f6bca12b9cdfc6abfe2f4a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/039c9730500f72d4133c8b98b4b8c7ba666cc51e95f6bca12b9cdfc6abfe2f4a.mp3',
          name: 'INT-ADV-Reverse_Lunge_with_Hop-EXERCISE.mp3',
          description: null,
          size: 28806,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Single Leg Hip Hinge-EXERCISE': {
      id: 232,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Single Leg Hip Hinge',
      short_name: 'Single Leg Hip Hinge',
      unique_name: 'BEGINNER-Single Leg Hip Hinge-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, core tight and tall posture.\n2. Transfer all your weight to one leg and hinge at the hips.\n3. Balancing on one leg, lower your torso parallel to the floor, arms straight down. Extend the other leg straight behind you, toes point to the floor.\n4. Drive through the heel of your standing leg, raise your torso up and return to start.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 575,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '85aeb51df280092ea3071265f0972d28c7ccab702d3baf0d6eee021b7d221baf',
          file_name:
            'videos/85aeb51df280092ea3071265f0972d28c7ccab702d3baf0d6eee021b7d221baf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/85aeb51df280092ea3071265f0972d28c7ccab702d3baf0d6eee021b7d221baf.mp4',
          name: 'BEGINNER-Single_Leg_Hip_Hinge-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 183948,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 576,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '05eb0bfae16658fffc167186dd75c4d1ccbd86bdf0aa4779ce0e80832b70a2b2',
          file_name:
            'videos/05eb0bfae16658fffc167186dd75c4d1ccbd86bdf0aa4779ce0e80832b70a2b2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/05eb0bfae16658fffc167186dd75c4d1ccbd86bdf0aa4779ce0e80832b70a2b2.mp4',
          name: 'BEGINNER-Single_Leg_Hip_Hinge-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 153024,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 577,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '09de57282d883c809247d99f47cb57489e75297800d7df403fea7d1a503c04a2',
          file_name:
            'audios/09de57282d883c809247d99f47cb57489e75297800d7df403fea7d1a503c04a2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/09de57282d883c809247d99f47cb57489e75297800d7df403fea7d1a503c04a2.mp3',
          name: 'BEGINNER-Single_Leg_Hip_Hinge-EXERCISE.mp3',
          description: null,
          size: 35652,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Bench Jacks-EXERCISE': {
      id: 233,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Bench Jacks',
      short_name: 'Bench Jacks',
      unique_name: 'INTERMEDIATE-Bench Jacks-EXERCISE',
      description:
        '1. Stand in the middle of a bench lengthwise, feet together.\n2. Jump up and jack your feet out to the sides and land on the floor straddling the bench.\n3. Immediately jump back up bringing your feet together and land on the bench in start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 578,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '322c56dee356c961f8fa94a3c546af61ba6fad5154ec65c2371c95f2a0717d39',
          file_name:
            'videos/322c56dee356c961f8fa94a3c546af61ba6fad5154ec65c2371c95f2a0717d39.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/322c56dee356c961f8fa94a3c546af61ba6fad5154ec65c2371c95f2a0717d39.mp4',
          name: 'INTERMEDIATE-Bench_Jacks-EXERCISE.mp4',
          description: null,
          size: 64118,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 579,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '811b6d79f0d6baa7872ebc39f4d72f531417a235245624f02fd7890686d19f6b',
          file_name:
            'audios/811b6d79f0d6baa7872ebc39f4d72f531417a235245624f02fd7890686d19f6b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/811b6d79f0d6baa7872ebc39f4d72f531417a235245624f02fd7890686d19f6b.mp3',
          name: 'INTERMEDIATE-Bench_Jacks-EXERCISE.mp3',
          description: null,
          size: 26622,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Bench Jacks-EXERCISE': {
      id: 234,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Bench Jacks',
      short_name: 'Bench Jacks',
      unique_name: 'ADVANCED-Bench Jacks-EXERCISE',
      description:
        '1. Stand in the middle of a bench lengthwise, feet together.\n2. Jump up and jack your feet out to the sides and land on the floor straddling the bench.\n3. Immediately jump back up bringing your feet together and land on the bench in start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 580,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '322c56dee356c961f8fa94a3c546af61ba6fad5154ec65c2371c95f2a0717d39',
          file_name:
            'videos/322c56dee356c961f8fa94a3c546af61ba6fad5154ec65c2371c95f2a0717d39.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/322c56dee356c961f8fa94a3c546af61ba6fad5154ec65c2371c95f2a0717d39.mp4',
          name: 'ADVANCED-Bench_Jacks-EXERCISE.mp4',
          description: null,
          size: 64118,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 581,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '811b6d79f0d6baa7872ebc39f4d72f531417a235245624f02fd7890686d19f6b',
          file_name:
            'audios/811b6d79f0d6baa7872ebc39f4d72f531417a235245624f02fd7890686d19f6b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/811b6d79f0d6baa7872ebc39f4d72f531417a235245624f02fd7890686d19f6b.mp3',
          name: 'ADVANCED-Bench_Jacks-EXERCISE.mp3',
          description: null,
          size: 26622,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Oblique Crunches-EXERCISE': {
      id: 235,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Oblique Crunches',
      short_name: 'Oblique Crunches',
      unique_name: 'BEGINNER-Oblique Crunches-EXERCISE',
      description:
        '1. Lie on your back with knees bent and drop both knees to one side, legs and feet together. Place your top hand behind your head and other arm across your waist.\n2. Raise your shoulder blades off the floor bringing your upper body toward your midline. Keep your elbow wide and chest open.\n3. Pause for a beat, then lower back down to the floor.\n4. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 582,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '7055983cf30ddf37cd3741a02d558f4ff9bd348520aeaffd0dbd2fd27d40726c',
          file_name:
            'videos/7055983cf30ddf37cd3741a02d558f4ff9bd348520aeaffd0dbd2fd27d40726c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7055983cf30ddf37cd3741a02d558f4ff9bd348520aeaffd0dbd2fd27d40726c.mp4',
          name: 'BEGINNER-Oblique_Crunches-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 57112,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 583,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '190564287fc21fca7cfab7c69c29903bd113af666421b53b9c6ec4e3bc745f28',
          file_name:
            'videos/190564287fc21fca7cfab7c69c29903bd113af666421b53b9c6ec4e3bc745f28.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/190564287fc21fca7cfab7c69c29903bd113af666421b53b9c6ec4e3bc745f28.mp4',
          name: 'BEGINNER-Oblique_Crunches-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 61791,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 584,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '8156fe238c382614eea9b08ba99640128140d22241c141c379b6efead3271440',
          file_name:
            'audios/8156fe238c382614eea9b08ba99640128140d22241c141c379b6efead3271440.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8156fe238c382614eea9b08ba99640128140d22241c141c379b6efead3271440.mp3',
          name: 'BEGINNER-Oblique_Crunches-EXERCISE.mp3',
          description: null,
          size: 28524,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Oblique Crunches-EXERCISE': {
      id: 236,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Oblique Crunches',
      short_name: 'Oblique Crunches',
      unique_name: 'INTERMEDIATE-Oblique Crunches-EXERCISE',
      description:
        '1. Lie on your back with knees bent and drop both knees to one side, legs and feet together. Place your top hand behind your head and other arm across your waist.\n2. Raise your shoulder blades off the floor bringing your upper body toward your midline. Keep your elbow wide and chest open.\n3. Pause for a beat, then lower back down to the floor.\n4. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 585,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '7055983cf30ddf37cd3741a02d558f4ff9bd348520aeaffd0dbd2fd27d40726c',
          file_name:
            'videos/7055983cf30ddf37cd3741a02d558f4ff9bd348520aeaffd0dbd2fd27d40726c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7055983cf30ddf37cd3741a02d558f4ff9bd348520aeaffd0dbd2fd27d40726c.mp4',
          name: 'INTERMEDIATE-Oblique_Crunches-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 57112,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 586,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '190564287fc21fca7cfab7c69c29903bd113af666421b53b9c6ec4e3bc745f28',
          file_name:
            'videos/190564287fc21fca7cfab7c69c29903bd113af666421b53b9c6ec4e3bc745f28.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/190564287fc21fca7cfab7c69c29903bd113af666421b53b9c6ec4e3bc745f28.mp4',
          name: 'INTERMEDIATE-Oblique_Crunches-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 61791,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 587,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '8156fe238c382614eea9b08ba99640128140d22241c141c379b6efead3271440',
          file_name:
            'audios/8156fe238c382614eea9b08ba99640128140d22241c141c379b6efead3271440.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8156fe238c382614eea9b08ba99640128140d22241c141c379b6efead3271440.mp3',
          name: 'INTERMEDIATE-Oblique_Crunches-EXERCISE.mp3',
          description: null,
          size: 28524,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Oblique Crunches-EXERCISE': {
      id: 237,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Oblique Crunches',
      short_name: 'Oblique Crunches',
      unique_name: 'ADVANCED-Oblique Crunches-EXERCISE',
      description:
        '1. Lie on your back with knees bent and drop both knees to one side, legs and feet together. Place your top hand behind your head and other arm across your waist.\n2. Raise your shoulder blades off the floor bringing your upper body toward your midline. Keep your elbow wide and chest open.\n3. Pause for a beat, then lower back down to the floor.\n4. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 588,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '7055983cf30ddf37cd3741a02d558f4ff9bd348520aeaffd0dbd2fd27d40726c',
          file_name:
            'videos/7055983cf30ddf37cd3741a02d558f4ff9bd348520aeaffd0dbd2fd27d40726c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7055983cf30ddf37cd3741a02d558f4ff9bd348520aeaffd0dbd2fd27d40726c.mp4',
          name: 'ADVANCED-Oblique_Crunches-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 57112,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 589,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '190564287fc21fca7cfab7c69c29903bd113af666421b53b9c6ec4e3bc745f28',
          file_name:
            'videos/190564287fc21fca7cfab7c69c29903bd113af666421b53b9c6ec4e3bc745f28.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/190564287fc21fca7cfab7c69c29903bd113af666421b53b9c6ec4e3bc745f28.mp4',
          name: 'ADVANCED-Oblique_Crunches-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 61791,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 590,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '8156fe238c382614eea9b08ba99640128140d22241c141c379b6efead3271440',
          file_name:
            'audios/8156fe238c382614eea9b08ba99640128140d22241c141c379b6efead3271440.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8156fe238c382614eea9b08ba99640128140d22241c141c379b6efead3271440.mp3',
          name: 'ADVANCED-Oblique_Crunches-EXERCISE.mp3',
          description: null,
          size: 28524,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Oblique V-Ups-EXERCISE': {
      id: 238,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Oblique V-Ups',
      short_name: 'Oblique V-Ups',
      unique_name: 'INTERMEDIATE-Oblique V-Ups-EXERCISE',
      description:
        '1. Lie on your side with your legs extended and feet stacked. Angle legs inward 30 degrees. Place your top hand behind your head and rest the other on the floor in front of you.\n2. Lift both legs toward the ceiling as you draw your elbow toward your knee, bringing your upper body off the floor to create a "V".\n3. Pause and lower back to the floor.\n4. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 591,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'd1e87766135451d530f6a6b2b9fa8bbc93d5244e7de26fc1020e696f35606fbb',
          file_name:
            'videos/d1e87766135451d530f6a6b2b9fa8bbc93d5244e7de26fc1020e696f35606fbb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d1e87766135451d530f6a6b2b9fa8bbc93d5244e7de26fc1020e696f35606fbb.mp4',
          name: 'INTERMEDIATE-Oblique_V-Ups-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 91464,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 592,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '0faf9947ff99e3474380132c645f664e3b2103430d98a00643dcc5da268d3119',
          file_name:
            'videos/0faf9947ff99e3474380132c645f664e3b2103430d98a00643dcc5da268d3119.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0faf9947ff99e3474380132c645f664e3b2103430d98a00643dcc5da268d3119.mp4',
          name: 'INTERMEDIATE-Oblique_V-Ups-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 90040,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 593,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '95f09f8c4c856d1bd3d9b19a7348c2ea8df1a68932be947d71aeb7ef308527c4',
          file_name:
            'audios/95f09f8c4c856d1bd3d9b19a7348c2ea8df1a68932be947d71aeb7ef308527c4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/95f09f8c4c856d1bd3d9b19a7348c2ea8df1a68932be947d71aeb7ef308527c4.mp3',
          name: 'INTERMEDIATE-Oblique_V-Ups-EXERCISE.mp3',
          description: null,
          size: 27372,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Oblique V-Ups-EXERCISE': {
      id: 239,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Oblique V-Ups',
      short_name: 'Oblique V-Ups',
      unique_name: 'ADVANCED-Oblique V-Ups-EXERCISE',
      description:
        '1. Lie on your side with your legs extended and feet stacked. Angle legs inward 30 degrees. Place your top hand behind your head and rest the other on the floor in front of you.\n2. Lift both legs toward the ceiling as you draw your elbow toward your knee, bringing your upper body off the floor to create a "V".\n3. Pause and lower back to the floor.\n4. Perform all reps on one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 594,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'd1e87766135451d530f6a6b2b9fa8bbc93d5244e7de26fc1020e696f35606fbb',
          file_name:
            'videos/d1e87766135451d530f6a6b2b9fa8bbc93d5244e7de26fc1020e696f35606fbb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d1e87766135451d530f6a6b2b9fa8bbc93d5244e7de26fc1020e696f35606fbb.mp4',
          name: 'ADVANCED-Oblique_V-Ups-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 91464,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 595,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '0faf9947ff99e3474380132c645f664e3b2103430d98a00643dcc5da268d3119',
          file_name:
            'videos/0faf9947ff99e3474380132c645f664e3b2103430d98a00643dcc5da268d3119.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0faf9947ff99e3474380132c645f664e3b2103430d98a00643dcc5da268d3119.mp4',
          name: 'ADVANCED-Oblique_V-Ups-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 90040,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 596,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '95f09f8c4c856d1bd3d9b19a7348c2ea8df1a68932be947d71aeb7ef308527c4',
          file_name:
            'audios/95f09f8c4c856d1bd3d9b19a7348c2ea8df1a68932be947d71aeb7ef308527c4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/95f09f8c4c856d1bd3d9b19a7348c2ea8df1a68932be947d71aeb7ef308527c4.mp3',
          name: 'ADVANCED-Oblique_V-Ups-EXERCISE.mp3',
          description: null,
          size: 27372,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Pop Squats-EXERCISE': {
      id: 240,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Pop Squats',
      short_name: 'Pop Squats',
      unique_name: 'BEGINNER-Pop Squats-EXERCISE',
      description:
        '1. Start in a narrow squat position with your feet together.\n2. Staying in a low squat, jack your feet out to the sides.\n3. Jack feet in to return to starting position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 597,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '9cdd7e2fa9f92fd9aa719f73b66d983c2d4e50546843d25633649923c491a78c',
          file_name:
            'videos/9cdd7e2fa9f92fd9aa719f73b66d983c2d4e50546843d25633649923c491a78c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9cdd7e2fa9f92fd9aa719f73b66d983c2d4e50546843d25633649923c491a78c.mp4',
          name: 'BEGINNER-Pop_Squats-EXERCISE.mp4',
          description: null,
          size: 56035,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 598,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '5e35112357b753e5a36daaacc16fab0180b9b0039e07714430e1227d13a39e90',
          file_name:
            'audios/5e35112357b753e5a36daaacc16fab0180b9b0039e07714430e1227d13a39e90.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5e35112357b753e5a36daaacc16fab0180b9b0039e07714430e1227d13a39e90.mp3',
          name: 'BEGINNER-Pop_Squats-EXERCISE.mp3',
          description: null,
          size: 25008,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Pop Squats-EXERCISE': {
      id: 241,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Pop Squats',
      short_name: 'Pop Squats',
      unique_name: 'INTERMEDIATE-Pop Squats-EXERCISE',
      description:
        '1. Start in a narrow squat position with your feet together.\n2. Staying in a low squat, jack your feet out to the sides.\n3. Jack feet in to return to starting position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 599,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '9cdd7e2fa9f92fd9aa719f73b66d983c2d4e50546843d25633649923c491a78c',
          file_name:
            'videos/9cdd7e2fa9f92fd9aa719f73b66d983c2d4e50546843d25633649923c491a78c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9cdd7e2fa9f92fd9aa719f73b66d983c2d4e50546843d25633649923c491a78c.mp4',
          name: 'INTERMEDIATE-Pop_Squats-EXERCISE.mp4',
          description: null,
          size: 56035,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 600,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '5e35112357b753e5a36daaacc16fab0180b9b0039e07714430e1227d13a39e90',
          file_name:
            'audios/5e35112357b753e5a36daaacc16fab0180b9b0039e07714430e1227d13a39e90.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5e35112357b753e5a36daaacc16fab0180b9b0039e07714430e1227d13a39e90.mp3',
          name: 'INTERMEDIATE-Pop_Squats-EXERCISE.mp3',
          description: null,
          size: 25008,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Pop Squats-EXERCISE': {
      id: 242,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Pop Squats',
      short_name: 'Pop Squats',
      unique_name: 'ADVANCED-Pop Squats-EXERCISE',
      description:
        '1. Start in a narrow squat position with your feet together.\n2. Staying in a low squat, jack your feet out to the sides.\n3. Jack feet in to return to starting position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 601,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '9cdd7e2fa9f92fd9aa719f73b66d983c2d4e50546843d25633649923c491a78c',
          file_name:
            'videos/9cdd7e2fa9f92fd9aa719f73b66d983c2d4e50546843d25633649923c491a78c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9cdd7e2fa9f92fd9aa719f73b66d983c2d4e50546843d25633649923c491a78c.mp4',
          name: 'ADVANCED-Pop_Squats-EXERCISE.mp4',
          description: null,
          size: 56035,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 602,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '5e35112357b753e5a36daaacc16fab0180b9b0039e07714430e1227d13a39e90',
          file_name:
            'audios/5e35112357b753e5a36daaacc16fab0180b9b0039e07714430e1227d13a39e90.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5e35112357b753e5a36daaacc16fab0180b9b0039e07714430e1227d13a39e90.mp3',
          name: 'ADVANCED-Pop_Squats-EXERCISE.mp3',
          description: null,
          size: 25008,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Modified Side Plank Hip Drops-EXERCISE': {
      id: 243,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Modified Side Plank Hip Drops',
      short_name: 'Modified Side Plank Hip Drops',
      unique_name: 'BEGINNER-Modified Side Plank Hip Drops-EXERCISE',
      description:
        '1. Lie on your side, propping yourself on your forearm, elbow directly under your shoulder. Bend your bottom leg and extend the top leg.\n2. Keep the bottom leg resting on the floor, lift your hips up so your body is in a straight line in modified Side Plank.\n3. Lower your hips down to the floor and then raise them back up again.\n4. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 603,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '08a184d22a52921d885f84750965abea421d7f0f4f9b3b3ee16d71d28b424422',
          file_name:
            'videos/08a184d22a52921d885f84750965abea421d7f0f4f9b3b3ee16d71d28b424422.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/08a184d22a52921d885f84750965abea421d7f0f4f9b3b3ee16d71d28b424422.mp4',
          name: 'BEGINNER-Modified_Side_Plank_Hip_Drops-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 59760,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 604,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '0f0a5e4911e8f8a5038f564dadc6548f6b28b1a963bd267093e4ef4769bbf835',
          file_name:
            'videos/0f0a5e4911e8f8a5038f564dadc6548f6b28b1a963bd267093e4ef4769bbf835.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0f0a5e4911e8f8a5038f564dadc6548f6b28b1a963bd267093e4ef4769bbf835.mp4',
          name: 'BEGINNER-Modified_Side_Plank_Hip_Drops-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 55895,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 605,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '502fa4bad41fdcfbbc2153b75d56d53c2e5b0618cb473288f1da9dd8d6bb73b3',
          file_name:
            'audios/502fa4bad41fdcfbbc2153b75d56d53c2e5b0618cb473288f1da9dd8d6bb73b3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/502fa4bad41fdcfbbc2153b75d56d53c2e5b0618cb473288f1da9dd8d6bb73b3.mp3',
          name: 'BEGINNER-Modified_Side_Plank_Hip_Drops-EXERCISE.mp3',
          description: null,
          size: 41138,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Bench Toe Taps-EXERCISE': {
      id: 244,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Bench Toe Taps',
      short_name: 'Bench Toe Taps',
      unique_name: 'INTERMEDIATE-Bench Toe Taps-EXERCISE',
      description:
        '1. Stand in front of a bench. Lift one leg up and tap your toe to the bench.\n2. Jump off the foot on the floor and switch your feet mid-air so you land with the opposite foot on the floor and tap the other foot to the bench.\n3. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 606,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '389c0a016e96cbc1995f94bed2d111dd747641ad22b1fd997418a80841d0ef19',
          file_name:
            'videos/389c0a016e96cbc1995f94bed2d111dd747641ad22b1fd997418a80841d0ef19.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/389c0a016e96cbc1995f94bed2d111dd747641ad22b1fd997418a80841d0ef19.mp4',
          name: 'INTERMEDIATE-Bench_Toe_Taps-EXERCISE.mp4',
          description: null,
          size: 66984,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 607,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'cd863d5684149ae309c27678f71e0519a05b21d41c065fd4c14958913583959d',
          file_name:
            'audios/cd863d5684149ae309c27678f71e0519a05b21d41c065fd4c14958913583959d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cd863d5684149ae309c27678f71e0519a05b21d41c065fd4c14958913583959d.mp3',
          name: 'INTERMEDIATE-Bench_Toe_Taps-EXERCISE.mp3',
          description: null,
          size: 29388,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Bench Toe Taps-EXERCISE': {
      id: 245,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Bench Toe Taps',
      short_name: 'Bench Toe Taps',
      unique_name: 'ADVANCED-Bench Toe Taps-EXERCISE',
      description:
        '1. Stand in front of a bench holding one dumbbell in each hand by your sides. Lift one leg up and tap your toe to the bench.\n2. Jump off the foot on the floor and switch your feet mid-air so you land with the opposite foot on the floor and tap the other foot to the bench.\n3. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 608,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '5e011d44a931ea1e8b2bb0432136c077417a1ca5a5dd8890542bad3ca6cb8d3e',
          file_name:
            'videos/5e011d44a931ea1e8b2bb0432136c077417a1ca5a5dd8890542bad3ca6cb8d3e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5e011d44a931ea1e8b2bb0432136c077417a1ca5a5dd8890542bad3ca6cb8d3e.mp4',
          name: 'ADVANCED-Bench_Toe_Taps-EXERCISE.mp4',
          description: null,
          size: 60136,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 609,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'cd863d5684149ae309c27678f71e0519a05b21d41c065fd4c14958913583959d',
          file_name:
            'audios/cd863d5684149ae309c27678f71e0519a05b21d41c065fd4c14958913583959d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cd863d5684149ae309c27678f71e0519a05b21d41c065fd4c14958913583959d.mp3',
          name: 'ADVANCED-Bench_Toe_Taps-EXERCISE.mp3',
          description: null,
          size: 29388,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Jump Lunges-EXERCISE': {
      id: 246,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Jump Lunges',
      short_name: 'Jump Lunges',
      unique_name: 'INTERMEDIATE-Jump Lunges-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart and bring one leg in front of you, the other behind you. Bend both knees to 90 degrees and lower into a lunge.\n2. Keeping your back straight, jump up and switch your legs in the air landing in a lunge with the opposite foot forward.\n3. Jump back to the original lunge position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 610,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'edb9a19fac04b825cc0bcfa42ce85fcc4a27c7a62d62ff0b2eac6ca3392ab7ed',
          file_name:
            'videos/edb9a19fac04b825cc0bcfa42ce85fcc4a27c7a62d62ff0b2eac6ca3392ab7ed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/edb9a19fac04b825cc0bcfa42ce85fcc4a27c7a62d62ff0b2eac6ca3392ab7ed.mp4',
          name: 'INTERMEDIATE-Jump_Lunges-EXERCISE.mp4',
          description: null,
          size: 148048,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 611,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '7082503db8789c6367f0f452135b7348de45e56b49229ebac5a61289d2c6bde1',
          file_name:
            'audios/7082503db8789c6367f0f452135b7348de45e56b49229ebac5a61289d2c6bde1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7082503db8789c6367f0f452135b7348de45e56b49229ebac5a61289d2c6bde1.mp3',
          name: 'INTERMEDIATE-Jump_Lunges-EXERCISE.mp3',
          description: null,
          size: 27022,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Jump Lunges-EXERCISE': {
      id: 247,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Jump Lunges',
      short_name: 'Jump Lunges',
      unique_name: 'ADVANCED-Jump Lunges-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart and bring one leg in front of you, the other behind you. Bend both knees to 90 degrees and lower into a lunge.\n2. Keeping your back straight, jump up and switch your legs in the air landing in a lunge with the opposite foot forward.\n3. Jump back to the original lunge position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 612,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'edb9a19fac04b825cc0bcfa42ce85fcc4a27c7a62d62ff0b2eac6ca3392ab7ed',
          file_name:
            'videos/edb9a19fac04b825cc0bcfa42ce85fcc4a27c7a62d62ff0b2eac6ca3392ab7ed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/edb9a19fac04b825cc0bcfa42ce85fcc4a27c7a62d62ff0b2eac6ca3392ab7ed.mp4',
          name: 'ADVANCED-Jump_Lunges-EXERCISE.mp4',
          description: null,
          size: 148048,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 613,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '7082503db8789c6367f0f452135b7348de45e56b49229ebac5a61289d2c6bde1',
          file_name:
            'audios/7082503db8789c6367f0f452135b7348de45e56b49229ebac5a61289d2c6bde1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7082503db8789c6367f0f452135b7348de45e56b49229ebac5a61289d2c6bde1.mp3',
          name: 'ADVANCED-Jump_Lunges-EXERCISE.mp3',
          description: null,
          size: 27022,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Sit-Outs-EXERCISE': {
      id: 248,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Sit-Outs',
      short_name: 'Sit-Outs',
      unique_name: 'ADVANCED-Sit-Outs-EXERCISE',
      description:
        '1. Start in Bear Crawl position with your hands under wrists, hips over knees hovered a few inches off the ground.\n2. Pick up your right hand and rotate body, open up your chest and pivot right foot.\n3. Extend your left leg through to rotate bringing your glutes close to the floor.\n4. Use your core to bring your left leg back to Bear Crawl position. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 614,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'dea706d10f5980bfc760fc83d3f23b7e3f68505653334fd225f937982efbc082',
          file_name:
            'videos/dea706d10f5980bfc760fc83d3f23b7e3f68505653334fd225f937982efbc082.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dea706d10f5980bfc760fc83d3f23b7e3f68505653334fd225f937982efbc082.mp4',
          name: 'ADVANCED-Sit-Outs-EXERCISE.mp4',
          description: null,
          size: 206975,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 615,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '6bd9b27cb2d146fba4dc81439a0b2bc2b00cfd9d656a325b8bbb0f8c00d118e8',
          file_name:
            'audios/6bd9b27cb2d146fba4dc81439a0b2bc2b00cfd9d656a325b8bbb0f8c00d118e8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6bd9b27cb2d146fba4dc81439a0b2bc2b00cfd9d656a325b8bbb0f8c00d118e8.mp3',
          name: 'ADVANCED-Sit-Outs-EXERCISE.mp3',
          description: null,
          size: 23166,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Single Leg Box Squat-EXERCISE': {
      id: 249,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Single Leg Box Squat',
      short_name: 'Single Leg Box Squat',
      unique_name: 'INTERMEDIATE-Single Leg Box Squat-EXERCISE',
      description:
        '1. Start standing in front of the bench. Bend one leg and lift your foot off the floor. Clasp hands in front of your chest.\n2. Maintain good posture and slowly lower yourself to sit on the bench.\n3. Drive through the foot on the floor to stand up on that leg, keeping the other foot off the floor.\n4. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 616,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '462155d8261b52eeeb5e9f2e3ff34f04aec93975d1a790588ecb354f02ef50a9',
          file_name:
            'videos/462155d8261b52eeeb5e9f2e3ff34f04aec93975d1a790588ecb354f02ef50a9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/462155d8261b52eeeb5e9f2e3ff34f04aec93975d1a790588ecb354f02ef50a9.mp4',
          name: 'INTERMEDIATE-Single_Leg_Box_Squat-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 141061,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 617,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '62b1e1f3b2ae8863c11da1bf7749b516a6d5e6620baa0d6739cdb59567082412',
          file_name:
            'videos/62b1e1f3b2ae8863c11da1bf7749b516a6d5e6620baa0d6739cdb59567082412.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/62b1e1f3b2ae8863c11da1bf7749b516a6d5e6620baa0d6739cdb59567082412.mp4',
          name: 'INTERMEDIATE-Single_Leg_Box_Squat-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 148632,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 618,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '3327048cda9edcf133f78614207a24ef69eb05114f718e5214604cd5c46a5a7f',
          file_name:
            'audios/3327048cda9edcf133f78614207a24ef69eb05114f718e5214604cd5c46a5a7f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3327048cda9edcf133f78614207a24ef69eb05114f718e5214604cd5c46a5a7f.mp3',
          name: 'INT-ADV-Single_Leg_Box_Squat-EXERCISE.mp3',
          description: null,
          size: 34740,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Single Leg Box Squat-EXERCISE': {
      id: 250,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Single Leg Box Squat',
      short_name: 'Single Leg Box Squat',
      unique_name: 'ADVANCED-Single Leg Box Squat-EXERCISE',
      description:
        '1. Start standing in front of the bench. Bend one leg and lift your foot off the floor. Hold one dumbbell in front of your chest.\n2. Maintain good posture and slowly lower yourself to sit on the bench.\n3. Drive through the foot on the floor to stand up on that leg, keeping the other foot of the floor.\n4. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 619,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '661bcb2c5648c42277dc994e9938d6099fea134ef84fb5af7386060d0ed12b58',
          file_name:
            'videos/661bcb2c5648c42277dc994e9938d6099fea134ef84fb5af7386060d0ed12b58.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/661bcb2c5648c42277dc994e9938d6099fea134ef84fb5af7386060d0ed12b58.mp4',
          name: 'ADVANCED-Single_Leg_Box_Squat-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 134828,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 620,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: 'f6de4482d04e007c0500f960ad1b16bb42fe57988a9fb8560f4ce21a61e5dfa2',
          file_name:
            'videos/f6de4482d04e007c0500f960ad1b16bb42fe57988a9fb8560f4ce21a61e5dfa2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f6de4482d04e007c0500f960ad1b16bb42fe57988a9fb8560f4ce21a61e5dfa2.mp4',
          name: 'ADVANCED-Single_Leg_Box_Squat-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 126351,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 621,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '3327048cda9edcf133f78614207a24ef69eb05114f718e5214604cd5c46a5a7f',
          file_name:
            'audios/3327048cda9edcf133f78614207a24ef69eb05114f718e5214604cd5c46a5a7f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3327048cda9edcf133f78614207a24ef69eb05114f718e5214604cd5c46a5a7f.mp3',
          name: 'INT-ADV-Single_Leg_Box_Squat-EXERCISE.mp3',
          description: null,
          size: 34740,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Hammer Curl to Press-EXERCISE': {
      id: 251,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bodyweight Hammer Curl to Press',
      short_name: 'Bodyweight Hammer Curl to Press',
      unique_name: 'BEGINNER-Bodyweight Hammer Curl to Press-EXERCISE',
      description:
        '1. Start standing with your hands in fists by your sides and palms facing your body.\n2. Keep your elbows close to your ribcage, curl your arms up toward your shoulders.\n3. Raise both arms straight overhead to full extension, biceps by your ears.\n4. Lower your arms back down to shoulders. Extend your elbows to return to start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 622,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '3e85f39c1ca48ba4f8fe3d4364e9e86d592c55922867462a7fa6f4adec18733d',
          file_name:
            'videos/3e85f39c1ca48ba4f8fe3d4364e9e86d592c55922867462a7fa6f4adec18733d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3e85f39c1ca48ba4f8fe3d4364e9e86d592c55922867462a7fa6f4adec18733d.mp4',
          name: 'BEGINNER-Bodyweight_Hammer_Curl_to_Press-EXERCISE.mp4',
          description: null,
          size: 120181,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 623,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '1c588d476f9d1a775b4c5a963d6eebbcc78e9cef49377e116a60160acbcc6cbe',
          file_name:
            'audios/1c588d476f9d1a775b4c5a963d6eebbcc78e9cef49377e116a60160acbcc6cbe.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1c588d476f9d1a775b4c5a963d6eebbcc78e9cef49377e116a60160acbcc6cbe.mp3',
          name: 'BEGINNER-Bodyweight_Hammer_Curl_to_Press-EXERCISE.mp3',
          description: null,
          size: 45243,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Hammer Curl to Press-EXERCISE': {
      id: 252,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Hammer Curl to Press',
      short_name: 'Hammer Curl to Press',
      unique_name: 'INTERMEDIATE-Hammer Curl to Press-EXERCISE',
      description:
        '1. Start standing with a dumbbell in each hand by your sides and palms facing your body.\n2. Keep your elbows close to your ribcage, curl your arms up toward your shoulders.\n3. Raise both arms straight overhead to full extension, biceps by your ears.\n4. Lower your arms back down to shoulders. Extend your elbows to return to start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 624,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '20313e603a369312e408785b38f0455f898a36f26642f46fb09c6a2cf752d5fe',
          file_name:
            'videos/20313e603a369312e408785b38f0455f898a36f26642f46fb09c6a2cf752d5fe.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/20313e603a369312e408785b38f0455f898a36f26642f46fb09c6a2cf752d5fe.mp4',
          name: 'INTERMEDIATE-Hammer_Curl_to_Press-EXERCISE.mp4',
          description: null,
          size: 170066,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 625,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '94707665d738e9cf9ae7ae6a684698afb91eae2ee5b873d74f78104be0edc795',
          file_name:
            'audios/94707665d738e9cf9ae7ae6a684698afb91eae2ee5b873d74f78104be0edc795.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/94707665d738e9cf9ae7ae6a684698afb91eae2ee5b873d74f78104be0edc795.mp3',
          name: 'INT-ADV-Hammer_Curl_to_Press-EXERCISE.mp3',
          description: null,
          size: 33696,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Hammer Curl to Press-EXERCISE': {
      id: 253,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Hammer Curl to Press',
      short_name: 'Hammer Curl to Press',
      unique_name: 'ADVANCED-Hammer Curl to Press-EXERCISE',
      description:
        '1. Start standing with a dumbbell in each hand by your sides and palms facing your body.\n2. Keep your elbows close to your ribcage, curl your arms up toward your shoulders.\n3. Raise both arms straight overhead to full extension, biceps by your ears.\n4. Lower your arms back down to shoulders. Extend your elbows to return to start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 626,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '20313e603a369312e408785b38f0455f898a36f26642f46fb09c6a2cf752d5fe',
          file_name:
            'videos/20313e603a369312e408785b38f0455f898a36f26642f46fb09c6a2cf752d5fe.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/20313e603a369312e408785b38f0455f898a36f26642f46fb09c6a2cf752d5fe.mp4',
          name: 'ADVANCED-Hammer_Curl_to_Press-EXERCISE.mp4',
          description: null,
          size: 170066,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 627,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '94707665d738e9cf9ae7ae6a684698afb91eae2ee5b873d74f78104be0edc795',
          file_name:
            'audios/94707665d738e9cf9ae7ae6a684698afb91eae2ee5b873d74f78104be0edc795.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/94707665d738e9cf9ae7ae6a684698afb91eae2ee5b873d74f78104be0edc795.mp3',
          name: 'INT-ADV-Hammer_Curl_to_Press-EXERCISE.mp3',
          description: null,
          size: 33696,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Deadlift and Clean-EXERCISE': {
      id: 254,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Deadlift and Clean',
      short_name: 'Deadlift and Clean',
      unique_name: 'INTERMEDIATE-Deadlift and Clean-EXERCISE',
      description:
        '1. Start standing with your feet hip-width apart, knees slightly bent in a fixed position holding one dumbbell in each hand in front of your hips.\n2. With back and arms straight, hinge at the hips and slide them back as you lower the dumbbells toward the floor. Stop mid-shin.\n3. Stand up straight.\n4. Hinge again and in one motion, explosively bring your hips forward and jump up until your body is at full extension, shrug shoulders, bend elbows back and use the power of the jump and shrug to guide the dumbbells up toward your shoulders.\n5. When the dumbbells are almost at your shoulders, bend knees, push hips back and drop into a squat stance to get under the weight.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 628,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '3d05786d0c7771936ba059080437a17ce85ef9c4f8a67352cc1fb030415a6a2a',
          file_name:
            'videos/3d05786d0c7771936ba059080437a17ce85ef9c4f8a67352cc1fb030415a6a2a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3d05786d0c7771936ba059080437a17ce85ef9c4f8a67352cc1fb030415a6a2a.mp4',
          name: 'INTERMEDIATE-Deadlift_and_Clean-EXERCISE.mp4',
          description: null,
          size: 277038,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 629,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '3755a20a4b4d41ad900d4be633c68f692bff3999afd388b370518e2dab9bb463',
          file_name:
            'audios/3755a20a4b4d41ad900d4be633c68f692bff3999afd388b370518e2dab9bb463.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3755a20a4b4d41ad900d4be633c68f692bff3999afd388b370518e2dab9bb463.mp3',
          name: 'INT-ADV-Deadlift_to_Clean-EXERCISE.mp3',
          description: null,
          size: 30875,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Deadlift and Clean-EXERCISE': {
      id: 255,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Deadlift and Clean',
      short_name: 'Deadlift and Clean',
      unique_name: 'ADVANCED-Deadlift and Clean-EXERCISE',
      description:
        '1. Start standing with your feet hip-width apart, knees slightly bent in a fixed position holding one dumbbell in each hand in front of your hips.\n2. With back and arms straight, hinge at the hips and slide them back as you lower the dumbbells toward the floor. Stop mid-shin.\n3. Stand up straight.\n4. Hinge again and in one motion, explosively bring your hips forward and jump up until your body is at full extension, shrug shoulders, bend elbows back and use the power of the jump and shrug to guide the dumbbells up toward your shoulders.\n5. When the dumbbells are almost at your shoulders, bend knees, push hips back and drop into a squat stance to get under the weight.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 630,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '3d05786d0c7771936ba059080437a17ce85ef9c4f8a67352cc1fb030415a6a2a',
          file_name:
            'videos/3d05786d0c7771936ba059080437a17ce85ef9c4f8a67352cc1fb030415a6a2a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3d05786d0c7771936ba059080437a17ce85ef9c4f8a67352cc1fb030415a6a2a.mp4',
          name: 'ADVANCED-Deadlift_and_Clean-EXERCISE.mp4',
          description: null,
          size: 277038,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 631,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '3755a20a4b4d41ad900d4be633c68f692bff3999afd388b370518e2dab9bb463',
          file_name:
            'audios/3755a20a4b4d41ad900d4be633c68f692bff3999afd388b370518e2dab9bb463.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3755a20a4b4d41ad900d4be633c68f692bff3999afd388b370518e2dab9bb463.mp3',
          name: 'INT-ADV-Deadlift_to_Clean-EXERCISE.mp3',
          description: null,
          size: 30875,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Dumbbell Skull Crushers-EXERCISE': {
      id: 256,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Skull Crushers',
      short_name: 'Dumbbell Skull Crushers',
      unique_name: 'INTERMEDIATE-Dumbbell Skull Crushers-EXERCISE',
      description:
        '1. Lie on a bench, feet flat on the floor if possible.\n2. Hold one dumbbell in both hands horizontally, and extend the dumbbell straight up to the ceiling so your wrists are over your shoulders.\n3. Keeping your arms in place, bend your elbows only, pointing them toward your feet. Lower the dumbbell down to eyebrow level.\n4. Using your triceps, extend elbows to bring dumbbell back to start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 632,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'ac64881d318e69daafcefec41798857cbf14e5863859af152feb1197a9282662',
          file_name:
            'videos/ac64881d318e69daafcefec41798857cbf14e5863859af152feb1197a9282662.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ac64881d318e69daafcefec41798857cbf14e5863859af152feb1197a9282662.mp4',
          name: 'INTERMEDIATE-Dumbbell_Skull_Crushers-EXERCISE.mp4',
          description: null,
          size: 71099,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 633,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '9c73be65d095ad86decd8e7fe77fd1609c3a34b3e4d69fb0e17428ebd3969153',
          file_name:
            'audios/9c73be65d095ad86decd8e7fe77fd1609c3a34b3e4d69fb0e17428ebd3969153.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9c73be65d095ad86decd8e7fe77fd1609c3a34b3e4d69fb0e17428ebd3969153.mp3',
          name: 'INTERMEDIATE-Dumbbell_Skull_Crushers-EXERCISE.mp3',
          description: null,
          size: 35378,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Dumbbell Skull Crushers-EXERCISE': {
      id: 257,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Skull Crushers',
      short_name: 'Dumbbell Skull Crushers',
      unique_name: 'ADVANCED-Dumbbell Skull Crushers-EXERCISE',
      description:
        '1. Lie on a bench, feet flat on the floor if possible.\n2. Hold one dumbbell in both hands horizontally, and extend the dumbbell straight up to the ceiling so your wrists are over your shoulders.\n3. Keeping your arms in place, bend your elbows only, pointing them toward your feet. Lower the dumbbell down to eyebrow level.\n4. Using your triceps, extend elbows to bring dumbbell back to start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 634,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'ac64881d318e69daafcefec41798857cbf14e5863859af152feb1197a9282662',
          file_name:
            'videos/ac64881d318e69daafcefec41798857cbf14e5863859af152feb1197a9282662.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ac64881d318e69daafcefec41798857cbf14e5863859af152feb1197a9282662.mp4',
          name: 'ADVANCED-Dumbbell_Skull_Crushers-EXERCISE.mp4',
          description: null,
          size: 71099,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 635,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '9c73be65d095ad86decd8e7fe77fd1609c3a34b3e4d69fb0e17428ebd3969153',
          file_name:
            'audios/9c73be65d095ad86decd8e7fe77fd1609c3a34b3e4d69fb0e17428ebd3969153.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9c73be65d095ad86decd8e7fe77fd1609c3a34b3e4d69fb0e17428ebd3969153.mp3',
          name: 'ADVANCED-Dumbbell_Skull_Crushers-EXERCISE.mp3',
          description: null,
          size: 35378,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Dumbbell Straight Punches-EXERCISE': {
      id: 258,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Straight Punches',
      short_name: 'DB Straight Punches',
      unique_name: 'INTERMEDIATE-Dumbbell Straight Punches-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart. Take a natural step forward with one leg. Soft bend in both knees. Hold one dumbbell in each hand by your face.\r\n2. Reach lead hand out in front of you, rotating shoulders and hips.\r\n3. As you bring lead hand back, begin to punch with the opposite arm. Rotate shoulder and hip, pivot on base foot.\r\n4. Return to start. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 636,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '51a8e7df249cd47d5b11b77635c2dbb278615ef71b88b8977bd63b54dae6fb3e',
          file_name:
            'videos/51a8e7df249cd47d5b11b77635c2dbb278615ef71b88b8977bd63b54dae6fb3e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/51a8e7df249cd47d5b11b77635c2dbb278615ef71b88b8977bd63b54dae6fb3e.mp4',
          name: 'INTERMEDIATE-Dumbbell_Straight_Punches-EXERCISE.mp4',
          description: null,
          size: 80993,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 637,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'b08c4f2ee8811f87a6e245df874e085e2dbb08d96731e0421ce90e07bdd27339',
          file_name:
            'audios/b08c4f2ee8811f87a6e245df874e085e2dbb08d96731e0421ce90e07bdd27339.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b08c4f2ee8811f87a6e245df874e085e2dbb08d96731e0421ce90e07bdd27339.mp3',
          name: 'INTERMEDIATE-Dumbbell_Straight_Punches-EXERCISE.mp3',
          description: null,
          size: 35604,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Dumbbell Straight Punches-EXERCISE': {
      id: 259,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Straight Punches',
      short_name: 'DB Straight Punches',
      unique_name: 'ADVANCED-Dumbbell Straight Punches-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart. Take a natural step forward with one leg. Soft bend in both knees. Hold one dumbbell in each hand by your face.\r\n2. Reach lead hand out in front of you, rotating shoulders and hips.\r\n3. As you bring lead hand back, begin to punch with the opposite arm. Rotate shoulder and hip, pivot on base foot.\r\n4. Return to start. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 638,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '51a8e7df249cd47d5b11b77635c2dbb278615ef71b88b8977bd63b54dae6fb3e',
          file_name:
            'videos/51a8e7df249cd47d5b11b77635c2dbb278615ef71b88b8977bd63b54dae6fb3e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/51a8e7df249cd47d5b11b77635c2dbb278615ef71b88b8977bd63b54dae6fb3e.mp4',
          name: 'ADVANCED-Dumbbell_Straight_Punches-EXERCISE.mp4',
          description: null,
          size: 80993,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 639,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'b08c4f2ee8811f87a6e245df874e085e2dbb08d96731e0421ce90e07bdd27339',
          file_name:
            'audios/b08c4f2ee8811f87a6e245df874e085e2dbb08d96731e0421ce90e07bdd27339.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b08c4f2ee8811f87a6e245df874e085e2dbb08d96731e0421ce90e07bdd27339.mp3',
          name: 'ADVANCED-Dumbbell_Straight_Punches-EXERCISE.mp3',
          description: null,
          size: 35604,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Dumbbell Swings-EXERCISE': {
      id: 260,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Dumbbell Swings',
      short_name: 'Dumbbell Swings',
      unique_name: 'INTERMEDIATE-Dumbbell Swings-EXERCISE',
      description:
        '1. Stand with feet hip-width apart holding a dumbbell in both hands in front of you.\n2. Keeping chest up and back straight, bend knees, hinge at your hips and swing the dumbbell back in between legs.\n3. When the weight is behind you, explosively drive hips forward to swing the dumbbell in front of you to chest level.\n4. Let the dumbbell swing down and continue this motion. String reps together.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 640,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'fab056208d4289949510d10a7687e74b59d6ee40bc9eadc59594d0553e6ff83a',
          file_name:
            'videos/fab056208d4289949510d10a7687e74b59d6ee40bc9eadc59594d0553e6ff83a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fab056208d4289949510d10a7687e74b59d6ee40bc9eadc59594d0553e6ff83a.mp4',
          name: 'INTERMEDIATE-Dumbbell_Swings-EXERCISE.mp4',
          description: null,
          size: 99084,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 641,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '7e973962350378af06074d741fcdde017da2dfc049ca4aac156bd4308239025b',
          file_name:
            'audios/7e973962350378af06074d741fcdde017da2dfc049ca4aac156bd4308239025b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7e973962350378af06074d741fcdde017da2dfc049ca4aac156bd4308239025b.mp3',
          name: 'INTERMEDIATE-Dumbbell_Swings-EXERCISE.mp3',
          description: null,
          size: 28754,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Dumbbell Swings-EXERCISE': {
      id: 261,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Dumbbell Swings',
      short_name: 'Dumbbell Swings',
      unique_name: 'ADVANCED-Dumbbell Swings-EXERCISE',
      description:
        '1.Stand with feet hip-width apart holding a dumbbell in both hands in front of you.\n2. Keeping chest up and back straight, bend knees, hinge at your hips and swing the dumbbell back in between legs.\n3. When the weight is behind you, explosively drive hips forward to swing the dumbbell in front of you to chest level.\n4. Let the dumbbell swing down and continue this motion. String reps together.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 642,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'fab056208d4289949510d10a7687e74b59d6ee40bc9eadc59594d0553e6ff83a',
          file_name:
            'videos/fab056208d4289949510d10a7687e74b59d6ee40bc9eadc59594d0553e6ff83a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fab056208d4289949510d10a7687e74b59d6ee40bc9eadc59594d0553e6ff83a.mp4',
          name: 'ADVANCED-Dumbbell_Swings-EXERCISE.mp4',
          description: null,
          size: 99084,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 643,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '7e973962350378af06074d741fcdde017da2dfc049ca4aac156bd4308239025b',
          file_name:
            'audios/7e973962350378af06074d741fcdde017da2dfc049ca4aac156bd4308239025b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7e973962350378af06074d741fcdde017da2dfc049ca4aac156bd4308239025b.mp3',
          name: 'ADVANCED-Dumbbell_Swings-EXERCISE.mp3',
          description: null,
          size: 28754,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Forearm Plank Jacks-EXERCISE': {
      id: 262,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Forearm Plank Jacks',
      short_name: 'Forearm Plank Jacks',
      unique_name: 'INTERMEDIATE-Forearm Plank Jacks-EXERCISE',
      description:
        '1. Start in Forearm Plank position, elbows under shoulders, hips square.\n2. Bend your knees slightly and jack your feet out to the side in a wide "V" position.\n3. Jump both feet back to start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 644,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '35a2d0b09d2b9abe79432afd68c9d63710e618d0892a53f46ab830707363e30f',
          file_name:
            'videos/35a2d0b09d2b9abe79432afd68c9d63710e618d0892a53f46ab830707363e30f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/35a2d0b09d2b9abe79432afd68c9d63710e618d0892a53f46ab830707363e30f.mp4',
          name: 'INTERMEDIATE-Forearm_Plank_Jacks-EXERCISE.mp4',
          description: null,
          size: 67963,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 645,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '34c110a5af864ed274abaf3586d446b669a6e1771746a1757846348418675cc4',
          file_name:
            'audios/34c110a5af864ed274abaf3586d446b669a6e1771746a1757846348418675cc4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/34c110a5af864ed274abaf3586d446b669a6e1771746a1757846348418675cc4.mp3',
          name: 'INTERMEDIATE-Forearm_Plank_Jacks-EXERCISE.mp3',
          description: null,
          size: 32672,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Forearm Plank Jacks-EXERCISE': {
      id: 263,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Forearm Plank Jacks',
      short_name: 'Forearm Plank Jacks',
      unique_name: 'ADVANCED-Forearm Plank Jacks-EXERCISE',
      description:
        '1. Start in Forearm Plank position, elbows under shoulders, hips square.\n2. Bend your knees slightly and jack your feet out to the side in a wide "V" position.\n3. Jump both feet back to start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 646,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '35a2d0b09d2b9abe79432afd68c9d63710e618d0892a53f46ab830707363e30f',
          file_name:
            'videos/35a2d0b09d2b9abe79432afd68c9d63710e618d0892a53f46ab830707363e30f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/35a2d0b09d2b9abe79432afd68c9d63710e618d0892a53f46ab830707363e30f.mp4',
          name: 'ADVANCED-Forearm_Plank_Jacks-EXERCISE.mp4',
          description: null,
          size: 67963,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 647,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '34c110a5af864ed274abaf3586d446b669a6e1771746a1757846348418675cc4',
          file_name:
            'audios/34c110a5af864ed274abaf3586d446b669a6e1771746a1757846348418675cc4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/34c110a5af864ed274abaf3586d446b669a6e1771746a1757846348418675cc4.mp3',
          name: 'ADVANCED-Forearm_Plank_Jacks-EXERCISE.mp3',
          description: null,
          size: 32672,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Jump Lunge Burpees-EXERCISE': {
      id: 264,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Jump Lunge Burpees',
      short_name: 'Jump Lunge Burpees',
      unique_name: 'INTERMEDIATE-Jump Lunge Burpees-EXERCISE',
      description:
        '1. Start standing. Jump up, split stance and land in a lunge, bending both legs to 90 degrees.\n2. Jump up and switch legs in the air to land with the opposite foot forward.\n3. Jump feet to standing. Bend knees and hinge at waist until you can plant your hands on the floor.\n4. Jump feet behind you and do a push up. Jump feet back in to stand and jump at the top, hands in the air.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 648,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '4e1c5efc7054c9a3c263a0aa2b599c5801b956e59c775fcd678c7bb1053d46b9',
          file_name:
            'videos/4e1c5efc7054c9a3c263a0aa2b599c5801b956e59c775fcd678c7bb1053d46b9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4e1c5efc7054c9a3c263a0aa2b599c5801b956e59c775fcd678c7bb1053d46b9.mp4',
          name: 'INTERMEDIATE-Jump_Lunge_Burpees-EXERCISE.mp4',
          description: null,
          size: 289319,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 649,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '7bddfd173cf89c6aa53af7bc4c15176b4043a4e9954023fa52fe53374ff437da',
          file_name:
            'audios/7bddfd173cf89c6aa53af7bc4c15176b4043a4e9954023fa52fe53374ff437da.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7bddfd173cf89c6aa53af7bc4c15176b4043a4e9954023fa52fe53374ff437da.mp3',
          name: 'INTERMEDIATE-Jump_Lunge_Burpees-EXERCISE.mp3',
          description: null,
          size: 31692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Jump Lunge Burpees-EXERCISE': {
      id: 265,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Jump Lunge Burpees',
      short_name: 'Jump Lunge Burpees',
      unique_name: 'ADVANCED-Jump Lunge Burpees-EXERCISE',
      description:
        '1. Start standing. Jump up, split stance and land in a lunge, bending both legs to 90 degrees.\n2. Jump up and switch legs in the air to land with the opposite foot forward.\n3. Jump feet to standing. Bend knees and hinge at waist until you can plant your hands on the floor.\n4. Jump feet behind you and do a push up. Jump feet back in to stand and jump at the top, hands in the air.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 650,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '4e1c5efc7054c9a3c263a0aa2b599c5801b956e59c775fcd678c7bb1053d46b9',
          file_name:
            'videos/4e1c5efc7054c9a3c263a0aa2b599c5801b956e59c775fcd678c7bb1053d46b9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4e1c5efc7054c9a3c263a0aa2b599c5801b956e59c775fcd678c7bb1053d46b9.mp4',
          name: 'ADVANCED-Jump_Lunge_Burpees-EXERCISE.mp4',
          description: null,
          size: 289319,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 651,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '0db3cbe122422f8480cabead74c5f569b31aff5f89cfba7fb6fd5b9d583f7a2d',
          file_name:
            'audios/0db3cbe122422f8480cabead74c5f569b31aff5f89cfba7fb6fd5b9d583f7a2d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0db3cbe122422f8480cabead74c5f569b31aff5f89cfba7fb6fd5b9d583f7a2d.mp3',
          name: 'ADVANCED-Jump_Lunge_Burpees-EXERCISE.mp3',
          description: null,
          size: 31692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Knee Push-Up with Pulse-EXERCISE': {
      id: 266,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Knee Push-Up with Pulse',
      short_name: 'Knee Push-Up with Pulse',
      unique_name: 'BEGINNER-Knee Push-Up with Pulse-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists. Drop your knees straight down to the floor and lift your feet up.\n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor.\n3. Lift your body halfway up and lower back toward the floor.\n4. Straighten your arms and raise your body back up to starting position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 652,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'bfb62e7165bce5455c065ee0c7be592b20118e49b79e45395cfd67be66c56260',
          file_name:
            'videos/bfb62e7165bce5455c065ee0c7be592b20118e49b79e45395cfd67be66c56260.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bfb62e7165bce5455c065ee0c7be592b20118e49b79e45395cfd67be66c56260.mp4',
          name: 'BEGINNER-Knee_Push-Up_with_Pulse-EXERCISE.mp4',
          description: null,
          size: 122880,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 653,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'e39f9e49d4e208eb59ec8acc9d827ae1607baeec04ae073ebc8c1621dd668a5e',
          file_name:
            'audios/e39f9e49d4e208eb59ec8acc9d827ae1607baeec04ae073ebc8c1621dd668a5e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e39f9e49d4e208eb59ec8acc9d827ae1607baeec04ae073ebc8c1621dd668a5e.mp3',
          name: 'BEG-INT-Knee_Push-Up_with_Pulse-EXERCISE.mp3',
          description: null,
          size: 34802,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Knee Push-Up with Pulse-EXERCISE': {
      id: 267,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Knee Push-Up with Pulse',
      short_name: 'Knee Push-Up with Pulse',
      unique_name: 'INTERMEDIATE-Knee Push-Up with Pulse-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists. Drop your knees straight down to the floor and lift your feet up.\n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor.\n3. Lift your body halfway up and lower back toward the floor.\n4. Straighten your arms and raise your body back up to starting position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 654,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'bfb62e7165bce5455c065ee0c7be592b20118e49b79e45395cfd67be66c56260',
          file_name:
            'videos/bfb62e7165bce5455c065ee0c7be592b20118e49b79e45395cfd67be66c56260.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bfb62e7165bce5455c065ee0c7be592b20118e49b79e45395cfd67be66c56260.mp4',
          name: 'INTERMEDIATE-Knee_Push-Up_with_Pulse-EXERCISE.mp4',
          description: null,
          size: 122880,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 655,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'e39f9e49d4e208eb59ec8acc9d827ae1607baeec04ae073ebc8c1621dd668a5e',
          file_name:
            'audios/e39f9e49d4e208eb59ec8acc9d827ae1607baeec04ae073ebc8c1621dd668a5e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e39f9e49d4e208eb59ec8acc9d827ae1607baeec04ae073ebc8c1621dd668a5e.mp3',
          name: 'BEG-INT-Knee_Push-Up_with_Pulse-EXERCISE.mp3',
          description: null,
          size: 34802,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Push-Up with Pulse-EXERCISE': {
      id: 268,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Push-Up with Pulse',
      short_name: 'Push-Up with Pulse',
      unique_name: 'ADVANCED-Push-Up with Pulse-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists.\n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor.\n3. Lift your body halfway up and lower back toward the floor.\n4. Straighten your arms and raise your body back up to starting position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 656,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '2035aa0c6421bed803dad8c55211c372e74b17f51a67c953a7290392673940a9',
          file_name:
            'videos/2035aa0c6421bed803dad8c55211c372e74b17f51a67c953a7290392673940a9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2035aa0c6421bed803dad8c55211c372e74b17f51a67c953a7290392673940a9.mp4',
          name: 'ADVANCED-Push-Up_with_Pulse-EXERCISE.mp4',
          description: null,
          size: 112419,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 657,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'e0d4a2e2b746fc8e294dbbe2f5e470c4fc857836a7d2d45c61b425697ba81868',
          file_name:
            'audios/e0d4a2e2b746fc8e294dbbe2f5e470c4fc857836a7d2d45c61b425697ba81868.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e0d4a2e2b746fc8e294dbbe2f5e470c4fc857836a7d2d45c61b425697ba81868.mp3',
          name: 'ADVANCED-Push-Up_with_Pulse-EXERCISE.mp3',
          description: null,
          size: 30770,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Straight Leg Sit-Ups-EXERCISE': {
      id: 269,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Straight Leg Sit-Ups',
      short_name: 'Straight Leg Sit-Ups',
      unique_name: 'BEGINNER-Straight Leg Sit-Ups-EXERCISE',
      description:
        '1. Lie on your back with your legs straight, toes pointed up and arms straight up in the air.\n2. Sit up straight and bring your arms up above your head, biceps next to your ears. Keep legs flat on floor.\n3. Slowly lower back down to start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 658,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '27e1cf28b8cadb9b9912b0834f9d6bc8232ffe7428ed836e93e29d8b129aa967',
          file_name:
            'videos/27e1cf28b8cadb9b9912b0834f9d6bc8232ffe7428ed836e93e29d8b129aa967.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/27e1cf28b8cadb9b9912b0834f9d6bc8232ffe7428ed836e93e29d8b129aa967.mp4',
          name: 'BEGINNER-Straight_Leg_Sit-Ups-EXERCISE.mp4',
          description: null,
          size: 172705,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 659,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'be80401686821e830aa9867fef909cdc1953598a0d6fd80fc1951aaf9dd47fbd',
          file_name:
            'audios/be80401686821e830aa9867fef909cdc1953598a0d6fd80fc1951aaf9dd47fbd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/be80401686821e830aa9867fef909cdc1953598a0d6fd80fc1951aaf9dd47fbd.mp3',
          name: 'BEGINNER-Straight_Leg_Sit-Ups-EXERCISE.mp3',
          description: null,
          size: 30306,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Straight Leg Sit-Ups-EXERCISE': {
      id: 270,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Straight Leg Sit-Ups',
      short_name: 'Straight Leg Sit-Ups',
      unique_name: 'INTERMEDIATE-Straight Leg Sit-Ups-EXERCISE',
      description:
        '1. Lie on your back with your legs straight and toes pointed up. Hold your arms straight up in the air holding one dumbbell at each end.\n2. Sit up straight and lift the dumbbell up above your head, biceps next to your ears. Keeps legs flat on floor.\n3. Slowly lower back down to start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 660,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'b9b4564823994bad0c9c4a635a7f1314412faa05f41d6640d0054b258363081a',
          file_name:
            'videos/b9b4564823994bad0c9c4a635a7f1314412faa05f41d6640d0054b258363081a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b9b4564823994bad0c9c4a635a7f1314412faa05f41d6640d0054b258363081a.mp4',
          name: 'INTERMEDIATE-Straight_Leg_Sit-Ups-EXERCISE.mp4',
          description: null,
          size: 171878,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 661,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'be80401686821e830aa9867fef909cdc1953598a0d6fd80fc1951aaf9dd47fbd',
          file_name:
            'audios/be80401686821e830aa9867fef909cdc1953598a0d6fd80fc1951aaf9dd47fbd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/be80401686821e830aa9867fef909cdc1953598a0d6fd80fc1951aaf9dd47fbd.mp3',
          name: 'INTERMEDIATE-Straight_Leg_Sit-Ups-EXERCISE.mp3',
          description: null,
          size: 30306,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Straight Leg Sit-Ups-EXERCISE': {
      id: 271,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Straight Leg Sit-Ups',
      short_name: 'Straight Leg Sit-Ups',
      unique_name: 'ADVANCED-Straight Leg Sit-Ups-EXERCISE',
      description:
        '1. Lie on your back with your legs straight and toes pointed up. Hold your arms straight up in the air holding one dumbbell at each end.\n2. Sit up straight and lift the dumbbell up above your head, biceps next to your ears. Keeps legs flat on floor.\n3. Slowly lower back down to start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 662,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'b9b4564823994bad0c9c4a635a7f1314412faa05f41d6640d0054b258363081a',
          file_name:
            'videos/b9b4564823994bad0c9c4a635a7f1314412faa05f41d6640d0054b258363081a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b9b4564823994bad0c9c4a635a7f1314412faa05f41d6640d0054b258363081a.mp4',
          name: 'ADVANCED-Straight_Leg_Sit-Ups-EXERCISE.mp4',
          description: null,
          size: 171878,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 663,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'be80401686821e830aa9867fef909cdc1953598a0d6fd80fc1951aaf9dd47fbd',
          file_name:
            'audios/be80401686821e830aa9867fef909cdc1953598a0d6fd80fc1951aaf9dd47fbd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/be80401686821e830aa9867fef909cdc1953598a0d6fd80fc1951aaf9dd47fbd.mp3',
          name: 'ADVANCED-Straight_Leg_Sit-Ups-EXERCISE.mp3',
          description: null,
          size: 30306,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Straight Punches-EXERCISE': {
      id: 272,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Straight Punches',
      short_name: 'Straight Punches',
      unique_name: 'BEGINNER-Straight Punches-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart. Take a natural step forward with one leg. Soft bend in both knees. Bring fists up to protect your face.\n2. Reach lead hand out in front of you, rotating shoulders and hips, rotating wrist down.\n3. As you bring lead hand back, begin to punch with the opposite arm. Rotate shoulder and hip, pivot on base foot.\n4. Return to start. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 664,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '34642304be1bc4d970702513aaf7e2b2ff29d3a384b5ef548f081a16554fab32',
          file_name:
            'videos/34642304be1bc4d970702513aaf7e2b2ff29d3a384b5ef548f081a16554fab32.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/34642304be1bc4d970702513aaf7e2b2ff29d3a384b5ef548f081a16554fab32.mp4',
          name: 'BEGINNER-Straight_Punches-EXERCISE.mp4',
          description: null,
          size: 67494,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 665,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '0a9a7ca6f09da974c5222cbb00f564d677d3f044afeee94ee864210eacc4997d',
          file_name:
            'audios/0a9a7ca6f09da974c5222cbb00f564d677d3f044afeee94ee864210eacc4997d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0a9a7ca6f09da974c5222cbb00f564d677d3f044afeee94ee864210eacc4997d.mp3',
          name: 'BEGINNER-Straight_Punches-EXERCISE.mp3',
          description: null,
          size: 28176,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-V-Up Crunches-EXERCISE': {
      id: 273,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'V-Up Crunches',
      short_name: 'V-Up Crunches',
      unique_name: 'INTERMEDIATE-V-Up Crunches-EXERCISE',
      description:
        '1. Lie on your back with your arms extended behind your head and your legs long, feet together.\n2. Keeping your legs straight, lift them up into the air as you simultaneously crunch your upper body off the floor reaching straight arms for your toes.\n3. Extend legs and arms back down to start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 666,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '1e3465e15eb2908b49b93a2979a0661ae4916f06b63bb586bbcf53b0a540533e',
          file_name:
            'videos/1e3465e15eb2908b49b93a2979a0661ae4916f06b63bb586bbcf53b0a540533e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1e3465e15eb2908b49b93a2979a0661ae4916f06b63bb586bbcf53b0a540533e.mp4',
          name: 'INTERMEDIATE-V-Up_Crunches-EXERCISE.mp4',
          description: null,
          size: 157041,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 667,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '0a3c9ca33906b0c56fde455258447acaa59d17be9957807f51caae66f48bead3',
          file_name:
            'audios/0a3c9ca33906b0c56fde455258447acaa59d17be9957807f51caae66f48bead3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0a3c9ca33906b0c56fde455258447acaa59d17be9957807f51caae66f48bead3.mp3',
          name: 'INTERMEDIATE-V-Up_Crunches-EXERCISE.mp3',
          description: null,
          size: 28640,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-V-Ups-EXERCISE': {
      id: 274,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'V-Ups',
      short_name: 'V-Ups',
      unique_name: 'ADVANCED-V-Ups-EXERCISE',
      description:
        '1. Lie on your back with your arms extended behind your head and your legs long, feet together.\n2. Lift both legs toward the ceiling bringing your upper body off the floor to create a "V".\n3. Pause and lower back to the floor.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 668,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '898d5aea0903cab1cafb1e77b0e958c32d6131a53647b7c4bfb3eaab16332c96',
          file_name:
            'videos/898d5aea0903cab1cafb1e77b0e958c32d6131a53647b7c4bfb3eaab16332c96.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/898d5aea0903cab1cafb1e77b0e958c32d6131a53647b7c4bfb3eaab16332c96.mp4',
          name: 'ADVANCED-V-Ups-EXERCISE.mp4',
          description: null,
          size: 130593,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 669,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '70ce755450314039b9e4d73f1321bcb44b722fc5b2e2e91c1d81a7ecefcad23f',
          file_name:
            'audios/70ce755450314039b9e4d73f1321bcb44b722fc5b2e2e91c1d81a7ecefcad23f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/70ce755450314039b9e4d73f1321bcb44b722fc5b2e2e91c1d81a7ecefcad23f.mp3',
          name: 'ADVANCED-V-Ups-EXERCISE.mp3',
          description: null,
          size: 22188,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-V-Up Crunches-EXERCISE': {
      id: 275,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'V-Up Crunches',
      short_name: 'V-Up Crunches',
      unique_name: 'BEGINNER-V-Up Crunches-EXERCISE',
      description:
        '1. Lie on your back with your arms extended behind your head and your legs long, feet together.\n2. Keeping your legs straight, lift them up into the air as you simultaneously crunch your upper body off the floor reaching straight arms for your toes.\n3. Extend legs and arms back down to start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 670,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '1e3465e15eb2908b49b93a2979a0661ae4916f06b63bb586bbcf53b0a540533e',
          file_name:
            'videos/1e3465e15eb2908b49b93a2979a0661ae4916f06b63bb586bbcf53b0a540533e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1e3465e15eb2908b49b93a2979a0661ae4916f06b63bb586bbcf53b0a540533e.mp4',
          name: 'BEGINNER-V-Up_Crunches-EXERCISE.mp4',
          description: null,
          size: 157041,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 671,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '0a3c9ca33906b0c56fde455258447acaa59d17be9957807f51caae66f48bead3',
          file_name:
            'audios/0a3c9ca33906b0c56fde455258447acaa59d17be9957807f51caae66f48bead3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0a3c9ca33906b0c56fde455258447acaa59d17be9957807f51caae66f48bead3.mp3',
          name: 'BEGINNER-V-Up_Crunches-EXERCISE.mp3',
          description: null,
          size: 28640,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Plank Jacks-EXERCISE': {
      id: 276,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Plank Jacks',
      short_name: 'Plank Jacks',
      unique_name: 'INTERMEDIATE-Plank Jacks-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Keeping your hips and shoulders square to the floor, jack your feet out into a wide "V" then back into start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 672,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '7f1c4e1770a2947a1999ce0e72f9afad1e16bf6b48616306f39e97a7d42f08e9',
          file_name:
            'videos/7f1c4e1770a2947a1999ce0e72f9afad1e16bf6b48616306f39e97a7d42f08e9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7f1c4e1770a2947a1999ce0e72f9afad1e16bf6b48616306f39e97a7d42f08e9.mp4',
          name: 'INT-ADV-Plank_Jacks-EXERCISE.mp4',
          description: null,
          size: 70576,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 673,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '554781afbd013061cc0f5b3e9313bb8024dfd0d9efc1a727d660945404986492',
          file_name:
            'audios/554781afbd013061cc0f5b3e9313bb8024dfd0d9efc1a727d660945404986492.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/554781afbd013061cc0f5b3e9313bb8024dfd0d9efc1a727d660945404986492.mp3',
          name: 'INTERMEDIATE-Plank_Jacks-EXERCISE.mp3',
          description: null,
          size: 24894,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Plank Jacks-EXERCISE': {
      id: 277,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Plank Jacks',
      short_name: 'Plank Jacks',
      unique_name: 'ADVANCED-Plank Jacks-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Keeping your hips and shoulders square to the floor, jack your feet out into a wide "V" then back into start position.',
      preview_time: 10,
      min_app_version: 100040000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 674,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '7f1c4e1770a2947a1999ce0e72f9afad1e16bf6b48616306f39e97a7d42f08e9',
          file_name:
            'videos/7f1c4e1770a2947a1999ce0e72f9afad1e16bf6b48616306f39e97a7d42f08e9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7f1c4e1770a2947a1999ce0e72f9afad1e16bf6b48616306f39e97a7d42f08e9.mp4',
          name: 'INT-ADV-Plank_Jacks-EXERCISE.mp4',
          description: null,
          size: 70576,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 675,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '554781afbd013061cc0f5b3e9313bb8024dfd0d9efc1a727d660945404986492',
          file_name:
            'audios/554781afbd013061cc0f5b3e9313bb8024dfd0d9efc1a727d660945404986492.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/554781afbd013061cc0f5b3e9313bb8024dfd0d9efc1a727d660945404986492.mp3',
          name: 'ADVANCED-Plank_Jacks-EXERCISE.mp3',
          description: null,
          size: 24894,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Alternating Forward Lunges-EXERCISE': {
      id: 308,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Forward Lunges',
      short_name: 'Alternating Forward Lunges',
      unique_name: 'INTERMEDIATE-Alternating Forward Lunges-EXERCISE',
      description:
        '1. Start standing with your feet about shoulder-width apart, holding one dumbbell in each hand by your sides.\n2. With one leg, take a big step forward while keeping your hips square. Drop down into a lunge by bending both knees 90 degrees. Your back heel is elevated.\n3. Drive through the front foot and return to starting position.\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 676,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'e4f54ca624b2671781e088ade65b9a9f56ba6f5c332c0672a6a3514e01301090',
          file_name:
            'videos/e4f54ca624b2671781e088ade65b9a9f56ba6f5c332c0672a6a3514e01301090.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e4f54ca624b2671781e088ade65b9a9f56ba6f5c332c0672a6a3514e01301090.mp4',
          name: 'INT-ADV-Alternating_Forward_Lunges-EXERCISE.mp4',
          description: null,
          size: 250634,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 677,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '543404e79bae8de72e5b379b0649fbe5c4bda2900fdf765eb23d45212e61eec7',
          file_name:
            'audios/543404e79bae8de72e5b379b0649fbe5c4bda2900fdf765eb23d45212e61eec7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/543404e79bae8de72e5b379b0649fbe5c4bda2900fdf765eb23d45212e61eec7.mp3',
          name: 'INT-ADV-Alternating_Forward_Lunges-EXERCISE.mp3',
          description: null,
          size: 30534,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Alternating Forward Lunges-EXERCISE': {
      id: 309,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Forward Lunges',
      short_name: 'Alternating Forward Lunges',
      unique_name: 'ADVANCED-Alternating Forward Lunges-EXERCISE',
      description:
        '1. Start standing with your feet about shoulder-width apart, holding one dumbbell in each hand by your sides.\n2. With one leg, take a big step forward while keeping your hips square. Drop down into a lunge by bending both knees 90 degrees. Your back heel is elevated.\n3. Drive through the front foot and return to starting position.\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 678,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'e4f54ca624b2671781e088ade65b9a9f56ba6f5c332c0672a6a3514e01301090',
          file_name:
            'videos/e4f54ca624b2671781e088ade65b9a9f56ba6f5c332c0672a6a3514e01301090.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e4f54ca624b2671781e088ade65b9a9f56ba6f5c332c0672a6a3514e01301090.mp4',
          name: 'INT-ADV-Alternating_Forward_Lunges-EXERCISE.mp4',
          description: null,
          size: 250634,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 679,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '543404e79bae8de72e5b379b0649fbe5c4bda2900fdf765eb23d45212e61eec7',
          file_name:
            'audios/543404e79bae8de72e5b379b0649fbe5c4bda2900fdf765eb23d45212e61eec7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/543404e79bae8de72e5b379b0649fbe5c4bda2900fdf765eb23d45212e61eec7.mp3',
          name: 'INT-ADV-Alternating_Forward_Lunges-EXERCISE.mp3',
          description: null,
          size: 30534,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating Single Leg V-Ups-EXERCISE': {
      id: 310,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Alternating Single Leg V-Ups',
      short_name: 'Alternating Single Leg V-Ups',
      unique_name: 'BEGINNER-Alternating Single Leg V-Ups-EXERCISE',
      description:
        '1. Lie on your back with your arms extended behind your head and your legs long.\n2. Lift one leg toward the ceiling as you bring your upper body off the floor reaching for your foot with the opposite hand.\n3. Pause, then lower back to the floor.\n4. Repeat with the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 680,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '307b12e377fda1b57e001df231800b4443a911c7f423d2043591cb9e56fe0f57',
          file_name:
            'videos/307b12e377fda1b57e001df231800b4443a911c7f423d2043591cb9e56fe0f57.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/307b12e377fda1b57e001df231800b4443a911c7f423d2043591cb9e56fe0f57.mp4',
          name: 'BEGINNER-Alternating_Single_Leg_V-Ups-EXERCISE.mp4',
          description: null,
          size: 168838,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 681,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '7fe4a645973af528dbd913036422cd53e7de9ef9fc9a5fc6b8ffd4dba6b86543',
          file_name:
            'audios/7fe4a645973af528dbd913036422cd53e7de9ef9fc9a5fc6b8ffd4dba6b86543.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7fe4a645973af528dbd913036422cd53e7de9ef9fc9a5fc6b8ffd4dba6b86543.mp3',
          name: 'BEGINNER-Alternating_Single_Leg_V-Ups-EXERCISE.mp3',
          description: null,
          size: 41304,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating Squat Kicks-EXERCISE': {
      id: 311,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Alternating Squat Kicks',
      short_name: 'Alternating Squat Kicks',
      unique_name: 'BEGINNER-Alternating Squat Kicks-EXERCISE',
      description:
        '1. Stand with your feet roughly shoulder-width apart. Keeping your chest up, drive your hips back and bend your knees to squat down as low as you can.\n2. As you come up, pick up one knee and extend your leg in front of you (like you are kicking off your shoe).\n3. Recoil your leg back into start position.\n4. Squat again and repeat with the other leg. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 682,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'd9fb838c6b2a0ef093b78f523cce16e94af6f2f00bf77f25ebed653460686afa',
          file_name:
            'videos/d9fb838c6b2a0ef093b78f523cce16e94af6f2f00bf77f25ebed653460686afa.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d9fb838c6b2a0ef093b78f523cce16e94af6f2f00bf77f25ebed653460686afa.mp4',
          name: 'BEGINNER-Alternating_Squat_Kicks-EXERCISE.mp4',
          description: null,
          size: 163237,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 683,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '6dca76a25068a389ae92ba8334999fb908faf3f23d0768fa5887cbd32e4bd7a0',
          file_name:
            'audios/6dca76a25068a389ae92ba8334999fb908faf3f23d0768fa5887cbd32e4bd7a0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6dca76a25068a389ae92ba8334999fb908faf3f23d0768fa5887cbd32e4bd7a0.mp3',
          name: 'BEGINNER-Alternating_Squat_Kicks-EXERCISE.mp3',
          description: null,
          size: 34914,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bear Plank Knee Taps-EXERCISE': {
      id: 312,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Bear Plank Knee Taps',
      short_name: 'Bear Plank Knee Taps',
      unique_name: 'BEGINNER-Bear Plank Knee Taps-EXERCISE',
      description:
        '1. Start on all fours with your shoulders over wrists and knees under hips.\n2. Engage your core and hover your knees a few inches off the ground. Hips square.\n3. Bring one knee slightly forward as you reach your opposite hand back to tap that knee.\n4. Return to start position and repeat with the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 690,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'a109564568e79b33709b773c2ec11f20fb801a50903f5e54c3d7b47641c146c4',
          file_name:
            'videos/a109564568e79b33709b773c2ec11f20fb801a50903f5e54c3d7b47641c146c4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a109564568e79b33709b773c2ec11f20fb801a50903f5e54c3d7b47641c146c4.mp4',
          name: 'BEGINNER-Bear_Plank_Knee_Taps-EXERCISE.mp4',
          description: null,
          size: 120874,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 691,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '7afdcac23c9c18150c76ed87a26107e62b4b3b69bfaf6ec0ea2b4c7eb76c8862',
          file_name:
            'audios/7afdcac23c9c18150c76ed87a26107e62b4b3b69bfaf6ec0ea2b4c7eb76c8862.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7afdcac23c9c18150c76ed87a26107e62b4b3b69bfaf6ec0ea2b4c7eb76c8862.mp3',
          name: 'BEGINNER-Bear_Plank_Knee_Taps-EXERCISE.mp3',
          description: null,
          size: 33533,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight Squat to Curl-EXERCISE': {
      id: 313,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Squat to Curl',
      short_name: 'Bodyweight Squat to Curl',
      unique_name: 'BEGINNER-Bodyweight Squat to Curl-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, arms down and fists by your sides, palms face in.\n2. Squat down and lower fists toward the floor. Drive through your heels and return to stand.\n3. Keeping your elbows close to your ribcage, curl your arms up toward your shoulders as you rotate your wrists so your palms face your body at the top.\n4. Lower your arms back down to starting position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 799,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '64300ba831de25650fa0220cb0c14e1f2a94e1109bc23aa4a675e7e9b8beb237',
          file_name:
            'videos/64300ba831de25650fa0220cb0c14e1f2a94e1109bc23aa4a675e7e9b8beb237.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/64300ba831de25650fa0220cb0c14e1f2a94e1109bc23aa4a675e7e9b8beb237.mp4',
          name: 'BEGINNER-Bodyweight_Squat_to_Curl-EXERCISE.mp4',
          description: null,
          size: 118438,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 800,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '1175986b495d710c97a207805d20a5e0234f29dd80dcedb823798226fe727a70',
          file_name:
            'audios/1175986b495d710c97a207805d20a5e0234f29dd80dcedb823798226fe727a70.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1175986b495d710c97a207805d20a5e0234f29dd80dcedb823798226fe727a70.mp3',
          name: 'BEGINNER-Bodyweight_Squat_to_Curl-EXERCISE.mp3',
          description: null,
          size: 35488,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Close Stance Dumbbell Squats-EXERCISE': {
      id: 314,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Close Stance Dumbbell Squats',
      short_name: 'Close Stance Dumbbell Squats',
      unique_name: 'INTERMEDIATE-Close Stance Dumbbell Squats-EXERCISE',
      description:
        '1. Stand with your legs and feet close together, holding a dumbbell in each hand down by your sides.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 692,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '405543994b45efd344091dbc3e884d1fa5acb7688cedce1bd14bacc06479bd26',
          file_name:
            'videos/405543994b45efd344091dbc3e884d1fa5acb7688cedce1bd14bacc06479bd26.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/405543994b45efd344091dbc3e884d1fa5acb7688cedce1bd14bacc06479bd26.mp4',
          name: 'INT-ADV-Close_Stance_Dumbbell_Squats-EXERCISE.mp4',
          description: null,
          size: 89217,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 693,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'd7b282215838d67efd3544260b3d055d1f9ae485686ffb7557ff4bff3a95b99b',
          file_name:
            'audios/d7b282215838d67efd3544260b3d055d1f9ae485686ffb7557ff4bff3a95b99b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d7b282215838d67efd3544260b3d055d1f9ae485686ffb7557ff4bff3a95b99b.mp3',
          name: 'INT-ADV-Close_Stance_Dumbbell_Squats-EXERCISE.mp3',
          description: null,
          size: 45487,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Close Stance Dumbbell Squats-EXERCISE': {
      id: 315,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Close Stance Dumbbell Squats',
      short_name: 'Close Stance Dumbbell Squats',
      unique_name: 'ADVANCED-Close Stance Dumbbell Squats-EXERCISE',
      description:
        '1. Stand with your legs and feet close together, holding a dumbbell in each hand down by your sides.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 694,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '405543994b45efd344091dbc3e884d1fa5acb7688cedce1bd14bacc06479bd26',
          file_name:
            'videos/405543994b45efd344091dbc3e884d1fa5acb7688cedce1bd14bacc06479bd26.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/405543994b45efd344091dbc3e884d1fa5acb7688cedce1bd14bacc06479bd26.mp4',
          name: 'INT-ADV-Close_Stance_Dumbbell_Squats-EXERCISE.mp4',
          description: null,
          size: 89217,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 695,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'd7b282215838d67efd3544260b3d055d1f9ae485686ffb7557ff4bff3a95b99b',
          file_name:
            'audios/d7b282215838d67efd3544260b3d055d1f9ae485686ffb7557ff4bff3a95b99b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d7b282215838d67efd3544260b3d055d1f9ae485686ffb7557ff4bff3a95b99b.mp3',
          name: 'INT-ADV-Close_Stance_Dumbbell_Squats-EXERCISE.mp3',
          description: null,
          size: 45487,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Close Stance Squats-EXERCISE': {
      id: 316,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Close Stance Squats',
      short_name: 'Close Stance Squats',
      unique_name: 'BEGINNER-Close Stance Squats-EXERCISE',
      description:
        '1. Stand with your legs and feet close together, arms down by your sides, fists face in.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 696,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '68e95fd882f1198b8f1180269b5cf7b442b994b2564b22e4c5026759e49ef678',
          file_name:
            'videos/68e95fd882f1198b8f1180269b5cf7b442b994b2564b22e4c5026759e49ef678.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/68e95fd882f1198b8f1180269b5cf7b442b994b2564b22e4c5026759e49ef678.mp4',
          name: 'BEGINNER-Close_Stance_Squats-EXERCISE.mp4',
          description: null,
          size: 79686,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 697,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '09463a04de34875c70531ca0f244b8502288efdf014cc5c433a138b7ed752725',
          file_name:
            'audios/09463a04de34875c70531ca0f244b8502288efdf014cc5c433a138b7ed752725.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/09463a04de34875c70531ca0f244b8502288efdf014cc5c433a138b7ed752725.mp3',
          name: 'BEGINNER-Close_Stance_Squats-EXERCISE.mp3',
          description: null,
          size: 31346,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Forearm Plank Bench Jacks-EXERCISE': {
      id: 317,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Forearm Plank Bench Jacks',
      short_name: 'Forearm Plank Bench Jacks',
      unique_name: 'ADVANCED-Forearm Plank Bench Jacks-EXERCISE',
      description:
        '1. Start in Forearm Plank, elbows directly under shoulders and your feet together on top of the bench.\n2. Keeping your core engaged and back straight, jack both feet out to the sides and land on the floor straddling the bench.\n3. Jump both feet back up to start position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 698,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '94ffb1174616936306bd7e3d604d7c4ab47587c439313b69151461616dcef8f3',
          file_name:
            'videos/94ffb1174616936306bd7e3d604d7c4ab47587c439313b69151461616dcef8f3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/94ffb1174616936306bd7e3d604d7c4ab47587c439313b69151461616dcef8f3.mp4',
          name: 'ADVANCED-Forearm_Plank_Bench_Jacks-EXERCISE.mp4',
          description: null,
          size: 53643,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 699,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '00d8befd4ace3bf647912bcfe5f35fab74a6d7d88bb19c704bd1497c61e2a010',
          file_name:
            'audios/00d8befd4ace3bf647912bcfe5f35fab74a6d7d88bb19c704bd1497c61e2a010.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/00d8befd4ace3bf647912bcfe5f35fab74a6d7d88bb19c704bd1497c61e2a010.mp3',
          name: 'ADVANCED-Forearm_Plank_Bench_Jacks-EXERCISE.mp3',
          description: null,
          size: 46492,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Forearm Push-Ups-EXERCISE': {
      id: 318,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Forearm Push-Ups',
      short_name: 'Forearm Push-Ups',
      unique_name: 'ADVANCED-Forearm Push-Ups-EXERCISE',
      description:
        '1. Start in Forearm Plank position, elbows under shoulders, hips square.\n2. Shift your weight slightly forward and lower your body toward the floor by bending your elbows and bringing your shoulders toward your wrists.\n3. Drive through your forearms and lift your body back up to starting position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 700,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'c7f6e3e4fca5ee8a5daf8fd957d103a5e84bdae03b5397aafa5ae402702016eb',
          file_name:
            'videos/c7f6e3e4fca5ee8a5daf8fd957d103a5e84bdae03b5397aafa5ae402702016eb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c7f6e3e4fca5ee8a5daf8fd957d103a5e84bdae03b5397aafa5ae402702016eb.mp4',
          name: 'ADVANCED-Forearm_Push-Ups-EXERCISE.mp4',
          description: null,
          size: 73728,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 701,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '171e811d44afc2f0c907f0d7a4a68c279a7fc464c26c6e0b82613c36fd8b87a5',
          file_name:
            'audios/171e811d44afc2f0c907f0d7a4a68c279a7fc464c26c6e0b82613c36fd8b87a5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/171e811d44afc2f0c907f0d7a4a68c279a7fc464c26c6e0b82613c36fd8b87a5.mp3',
          name: 'ADVANCED-Forearm_Push-Ups-EXERCISE.mp3',
          description: null,
          size: 29792,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Forward Leaning Lunges-EXERCISE': {
      id: 319,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Forward Leaning Lunges',
      short_name: 'Forw. Leaning Lunges',
      unique_name: 'BEGINNER-Forward Leaning Lunges-EXERCISE',
      description:
        '1. Start in a lunge position, fists by your sides. Shift your weight to the front leg and lean slightly forward creating a diagonal line from the crown of your head to the heel.\r\n2. Drop hips toward the floor, bending both knees by 90 degrees. Your torso is leaning over your front quad and your back knee is near the floor.\r\n3. Drive through your heel to straighten the legs.\r\n4. Perform all reps with one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 702,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '18945c0c3526b02bc6f362626472a803674ef0172eb587c02624aa0eb82ea35e',
          file_name:
            'videos/18945c0c3526b02bc6f362626472a803674ef0172eb587c02624aa0eb82ea35e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/18945c0c3526b02bc6f362626472a803674ef0172eb587c02624aa0eb82ea35e.mp4',
          name: 'BEGINNER-Forward_Leaning_Lunges-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 68438,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 703,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '146738a7b762faa19360e8efc58bd23f90c9744e8ff66c0d52209f731015a4e5',
          file_name:
            'videos/146738a7b762faa19360e8efc58bd23f90c9744e8ff66c0d52209f731015a4e5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/146738a7b762faa19360e8efc58bd23f90c9744e8ff66c0d52209f731015a4e5.mp4',
          name: 'BEGINNER-Forward_Leaning_Lunges-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 74520,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 704,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'e24a6c5f48d292d57d8fdfdaff5724cdcee4b0b7afae1813b18bb0108c5517cf',
          file_name:
            'audios/e24a6c5f48d292d57d8fdfdaff5724cdcee4b0b7afae1813b18bb0108c5517cf.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e24a6c5f48d292d57d8fdfdaff5724cdcee4b0b7afae1813b18bb0108c5517cf.mp3',
          name: 'BEGINNER-Forward_Leaning_Lunges-EXERCISE.mp3',
          description: null,
          size: 33824,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Forward Leaning Lunges-EXERCISE': {
      id: 320,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Forward Leaning Lunges',
      short_name: 'Forw. Leaning Lunges',
      unique_name: 'INTERMEDIATE-Forward Leaning Lunges-EXERCISE',
      description:
        '1. Start in a lunge position, dumbbells by your sides. Shift your weight to the front leg and lean slightly forward, creating a diagonal line from the crown of your head to the heel.\r\n2. Drop your hips toward the floor, bending both knees to 90 degrees. Your torso is leaning over your front quad and back knee is near the floor.\r\n3. Drive through the heel to straighten your legs.\r\n4. Perform all reps with one leg. Repeat with the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 705,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '1f7f1e66e4d4b795743fc5c2db09ae3d9d1b7801fecb4b30f1ccc8603055ac3e',
          file_name:
            'videos/1f7f1e66e4d4b795743fc5c2db09ae3d9d1b7801fecb4b30f1ccc8603055ac3e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1f7f1e66e4d4b795743fc5c2db09ae3d9d1b7801fecb4b30f1ccc8603055ac3e.mp4',
          name: 'INT-ADV-Forward_Leaning_Lunges-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 70072,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 706,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '604e1ea22bf8543314b938bcf0e9f757b16b45fa3f274a435f66c4826f4e7e6a',
          file_name:
            'videos/604e1ea22bf8543314b938bcf0e9f757b16b45fa3f274a435f66c4826f4e7e6a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/604e1ea22bf8543314b938bcf0e9f757b16b45fa3f274a435f66c4826f4e7e6a.mp4',
          name: 'INT-ADV-Forward_Leaning_Lunges-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 75848,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 707,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'e24a6c5f48d292d57d8fdfdaff5724cdcee4b0b7afae1813b18bb0108c5517cf',
          file_name:
            'audios/e24a6c5f48d292d57d8fdfdaff5724cdcee4b0b7afae1813b18bb0108c5517cf.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e24a6c5f48d292d57d8fdfdaff5724cdcee4b0b7afae1813b18bb0108c5517cf.mp3',
          name: 'INT-ADV-Forward_Leaning_Lunges-EXERCISE.mp3',
          description: null,
          size: 33824,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Forward Leaning Lunges-EXERCISE': {
      id: 321,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Forward Leaning Lunges',
      short_name: 'Forw. Leaning Lunges',
      unique_name: 'ADVANCED-Forward Leaning Lunges-EXERCISE',
      description:
        '1. Start in a lunge position, dumbbells by your sides. Shift your weight to the front leg and lean slightly forward, creating a diagonal line from the crown of your head to the heel.\r\n2. Drop your hips toward the floor, bending both knees to 90 degrees. Your torso is leaning over your front quad and back knee is near the floor.\r\n3. Drive through the heel to straighten your legs.\r\n4. Perform all reps with one leg. Repeat with the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 708,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '1f7f1e66e4d4b795743fc5c2db09ae3d9d1b7801fecb4b30f1ccc8603055ac3e',
          file_name:
            'videos/1f7f1e66e4d4b795743fc5c2db09ae3d9d1b7801fecb4b30f1ccc8603055ac3e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1f7f1e66e4d4b795743fc5c2db09ae3d9d1b7801fecb4b30f1ccc8603055ac3e.mp4',
          name: 'INT-ADV-Forward_Leaning_Lunges-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 70072,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 709,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '604e1ea22bf8543314b938bcf0e9f757b16b45fa3f274a435f66c4826f4e7e6a',
          file_name:
            'videos/604e1ea22bf8543314b938bcf0e9f757b16b45fa3f274a435f66c4826f4e7e6a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/604e1ea22bf8543314b938bcf0e9f757b16b45fa3f274a435f66c4826f4e7e6a.mp4',
          name: 'INT-ADV-Forward_Leaning_Lunges-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 75848,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 710,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'e24a6c5f48d292d57d8fdfdaff5724cdcee4b0b7afae1813b18bb0108c5517cf',
          file_name:
            'audios/e24a6c5f48d292d57d8fdfdaff5724cdcee4b0b7afae1813b18bb0108c5517cf.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e24a6c5f48d292d57d8fdfdaff5724cdcee4b0b7afae1813b18bb0108c5517cf.mp3',
          name: 'INT-ADV-Forward_Leaning_Lunges-EXERCISE.mp3',
          description: null,
          size: 33824,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Front Kick to Touchdowns-EXERCISE': {
      id: 322,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Front Kick to Touchdowns',
      short_name: 'Front Kicks/Touchdowns',
      unique_name: 'INTERMEDIATE-Front Kick to Touchdowns-EXERCISE',
      description:
        '1. Stand with feet hip-width apart. Pick up one knee and extend your leg in front of you (like you are kicking off your shoe).\n2. Return kicking leg to start position. Immediately take a big step back with opposite leg and drop into a low lunge position. Touch the floor with the hand on the same side as your back leg.\n3. Step your back leg back in to meet the front and return to start position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 711,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '915562e54645481deef4d94926ef7af21a0ae66312127c2527623fdd34444430',
          file_name:
            'videos/915562e54645481deef4d94926ef7af21a0ae66312127c2527623fdd34444430.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/915562e54645481deef4d94926ef7af21a0ae66312127c2527623fdd34444430.mp4',
          name: 'INTERMEDIATE-Front_Kick_to_Touchdowns-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 102961,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 712,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: 'bd079e6a6ab0e8fb1234f5528e7ef7d4da313fcb10f707acc288e77896598ef4',
          file_name:
            'videos/bd079e6a6ab0e8fb1234f5528e7ef7d4da313fcb10f707acc288e77896598ef4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bd079e6a6ab0e8fb1234f5528e7ef7d4da313fcb10f707acc288e77896598ef4.mp4',
          name: 'INTERMEDIATE-Front_Kick_to_Touchdowns-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 106707,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 713,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'a4dbdec15f2aa5bdd5f33bac80c2c87954c522cc574c96a8b1659463639b61d4',
          file_name:
            'audios/a4dbdec15f2aa5bdd5f33bac80c2c87954c522cc574c96a8b1659463639b61d4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a4dbdec15f2aa5bdd5f33bac80c2c87954c522cc574c96a8b1659463639b61d4.mp3',
          name: 'INTERMEDIATE-Front_Kick_to_Touchdowns-EXERCISE.mp3',
          description: null,
          size: 33360,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Get up Sit-Up-EXERCISE': {
      id: 323,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Get up Sit-Up',
      short_name: 'Get up Sit-Up',
      unique_name: 'BEGINNER-Get up Sit-Up-EXERCISE',
      description:
        '1. Lie on your back with one knee bent and that arm raised straight up in the air. Keep other leg straight, toes pointed up and that arm on the floor at 45 degrees, palm flat.\n2. Sit up and roll slightly to an angle toward your straight arm. Come up to elbow and then palm as you reach the other arm up, bicep next to your ear. Keep foot and leg flat.\n3. Lower back to start.\n4. Perform all reps one side. Repeat with the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 714,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '35eb820bc6a754e8fce1e1bfc8f5462fa8096ca6da0c28800a410a6bd5e2ef77',
          file_name:
            'videos/35eb820bc6a754e8fce1e1bfc8f5462fa8096ca6da0c28800a410a6bd5e2ef77.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/35eb820bc6a754e8fce1e1bfc8f5462fa8096ca6da0c28800a410a6bd5e2ef77.mp4',
          name: 'BEGINNER-Get_up_Sit-Up-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 138522,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 715,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '0757f2a53542ba5d489077493dc303510ba022cb976fa89b0ce6eb78ac7b4485',
          file_name:
            'videos/0757f2a53542ba5d489077493dc303510ba022cb976fa89b0ce6eb78ac7b4485.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0757f2a53542ba5d489077493dc303510ba022cb976fa89b0ce6eb78ac7b4485.mp4',
          name: 'BEGINNER-Get_up_Sit-Up-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 155133,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 716,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'e096e069ed82e2def63b7e8108b359401edea65565264f7ede63a5abcd0eca96',
          file_name:
            'audios/e096e069ed82e2def63b7e8108b359401edea65565264f7ede63a5abcd0eca96.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e096e069ed82e2def63b7e8108b359401edea65565264f7ede63a5abcd0eca96.mp3',
          name: 'BEGINNER-Get_up_Sit-Up-EXERCISE.mp3',
          description: null,
          size: 26912,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Get up Sit-Up-EXERCISE': {
      id: 324,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Get up Sit-Up',
      short_name: 'Get up Sit-Up',
      unique_name: 'INTERMEDIATE-Get up Sit-Up-EXERCISE',
      description:
        '1. Lie on your back with one knee bent and a dumbbell in that hand raised straight up in the air. Keep the other leg straight, toes pointed up and that arm on the floor at 45 degrees, palm flat.\n2. Sit up and roll slightly to an angle toward your straight arm. Come up to elbow and then palm as you reach the dumbbell up, bicep next to your ear, keeping foot and leg flat.\n3. Lower back to start.\n4. Perform all reps on one side. Repeat with the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 717,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'bed19fa2c5ce146093171d53ccd926dcd21d7754c0c56dc0a37f89e5418fa082',
          file_name:
            'videos/bed19fa2c5ce146093171d53ccd926dcd21d7754c0c56dc0a37f89e5418fa082.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bed19fa2c5ce146093171d53ccd926dcd21d7754c0c56dc0a37f89e5418fa082.mp4',
          name: 'INT-ADV-Get_up_Sit-Up-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 163466,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 718,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '653f3a8c4b8bc9f8e83df05a894449661545ceb92f2589c20ed9432870393e6c',
          file_name:
            'videos/653f3a8c4b8bc9f8e83df05a894449661545ceb92f2589c20ed9432870393e6c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/653f3a8c4b8bc9f8e83df05a894449661545ceb92f2589c20ed9432870393e6c.mp4',
          name: 'INT-ADV-Get_up_Sit-Up-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 162268,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 719,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '1619229b0b573804d2643bf7707e839522a37ea4996218fa523c9f4794037b72',
          file_name:
            'audios/1619229b0b573804d2643bf7707e839522a37ea4996218fa523c9f4794037b72.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1619229b0b573804d2643bf7707e839522a37ea4996218fa523c9f4794037b72.mp3',
          name: 'INT-ADV-Get_up_Sit-Up-EXERCISE.mp3',
          description: null,
          size: 28236,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Get up Sit-Up-EXERCISE': {
      id: 325,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Get up Sit-Up',
      short_name: 'Get up Sit-Up',
      unique_name: 'ADVANCED-Get up Sit-Up-EXERCISE',
      description:
        '1. Lie on your back with one knee bent and a dumbbell in that hand raised straight up in the air. Keep the other leg straight, toes pointed up and that arm on the floor at 45 degrees, palm flat.\n2. Sit up and roll slightly to an angle toward your straight arm. Come up to elbow and then palm as you reach the dumbbell up, bicep next to your ear, keeping foot and leg flat.\n3. Lower back to start.\n4. Perform all reps on one side. Repeat with the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 720,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'bed19fa2c5ce146093171d53ccd926dcd21d7754c0c56dc0a37f89e5418fa082',
          file_name:
            'videos/bed19fa2c5ce146093171d53ccd926dcd21d7754c0c56dc0a37f89e5418fa082.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bed19fa2c5ce146093171d53ccd926dcd21d7754c0c56dc0a37f89e5418fa082.mp4',
          name: 'INT-ADV-Get_up_Sit-Up-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 163466,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 721,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '653f3a8c4b8bc9f8e83df05a894449661545ceb92f2589c20ed9432870393e6c',
          file_name:
            'videos/653f3a8c4b8bc9f8e83df05a894449661545ceb92f2589c20ed9432870393e6c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/653f3a8c4b8bc9f8e83df05a894449661545ceb92f2589c20ed9432870393e6c.mp4',
          name: 'INT-ADV-Get_up_Sit-Up-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 162268,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 722,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '1619229b0b573804d2643bf7707e839522a37ea4996218fa523c9f4794037b72',
          file_name:
            'audios/1619229b0b573804d2643bf7707e839522a37ea4996218fa523c9f4794037b72.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1619229b0b573804d2643bf7707e839522a37ea4996218fa523c9f4794037b72.mp3',
          name: 'INT-ADV-Get_up_Sit-Up-EXERCISE.mp3',
          description: null,
          size: 28236,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Glute Bridges on Toes-EXERCISE': {
      id: 326,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Glute Bridges on Toes',
      short_name: 'Glute Bridges on Toes',
      unique_name: 'BEGINNER-Glute Bridges on Toes-EXERCISE',
      description:
        "1. Lay on your back with your knees bent, feet hip-width apart. Keep your arms at your sides, palms down and lift your heels keeping your toes on the floor.\n2. Keep your upper back on the floor and drive through your toes to raise your hips as high as possible without arching your back. Keep knees aligned so they don't splay out or buckle in.\n3. Lower with control back to start position.",
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 723,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '8438d91a44e40291ad1c96956b7a850dad6dbfb2172f1587a5eaeab10de1c2f4',
          file_name:
            'videos/8438d91a44e40291ad1c96956b7a850dad6dbfb2172f1587a5eaeab10de1c2f4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8438d91a44e40291ad1c96956b7a850dad6dbfb2172f1587a5eaeab10de1c2f4.mp4',
          name: 'BEGINNER-Glute_Bridges_on_Toes-EXERCISE.mp4',
          description: null,
          size: 57230,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 724,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '0ab55bb4ce92244a2c9f393b633c1474ecb882fc37b1aa73b32cfe5761bbdf4b',
          file_name:
            'audios/0ab55bb4ce92244a2c9f393b633c1474ecb882fc37b1aa73b32cfe5761bbdf4b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0ab55bb4ce92244a2c9f393b633c1474ecb882fc37b1aa73b32cfe5761bbdf4b.mp3',
          name: 'BEGINNER-Glute_Bridges_on_Toes-EXERCISE.mp3',
          description: null,
          size: 37220,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Hamstring Walkouts-EXERCISE': {
      id: 327,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Hamstring Walkouts',
      short_name: 'Hamstring Walkouts',
      unique_name: 'BEGINNER-Hamstring Walkouts-EXERCISE',
      description:
        "1. Lay on your back with knees bent, feet hip-width apart. Keep arms at your sides, palms down. Drive through your heels to lift your hips off the floor. Keep knees aligned so they don't splay out or buckle in.\n2. Keep your upper back on the floor and take a step forward with one foot and then the other. Keep your hips up as high as possible.\n3. Step your feet back in one at a time to start position.",
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 725,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '8fc45953ec0775242ac46862a16487f4aff1bf5bbe6c105004919ec243e840c1',
          file_name:
            'videos/8fc45953ec0775242ac46862a16487f4aff1bf5bbe6c105004919ec243e840c1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8fc45953ec0775242ac46862a16487f4aff1bf5bbe6c105004919ec243e840c1.mp4',
          name: 'BEGINNER-Hamstring_Walkouts-EXERCISE.mp4',
          description: null,
          size: 140498,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 726,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '244fd0856150559364822bbe9eb1a06ebe89a135f34a85fd2d8511dc370a45bf',
          file_name:
            'audios/244fd0856150559364822bbe9eb1a06ebe89a135f34a85fd2d8511dc370a45bf.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/244fd0856150559364822bbe9eb1a06ebe89a135f34a85fd2d8511dc370a45bf.mp3',
          name: 'BEGINNER-Hamstring_Walkouts-EXERCISE.mp3',
          description: null,
          size: 32008,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Hitch Kick to Touchdowns-EXERCISE': {
      id: 328,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Hitch Kick to Touchdowns',
      short_name: 'Hitch Kick to Touchdowns',
      unique_name: 'ADVANCED-Hitch Kick to Touchdowns-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart. Take a big step back with one leg, drop into a low lunge position and touch the floor.\n2. Bring back leg forward and jump into the air, bringing your knee up to your chest as you kick the opposite leg in front of you. Straighten your bent knee to land on the floor.\n3. Return kicking leg to starting low lunge position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 727,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'febbe6cf94a2bbce8dba400ff0507af5f97814c53555bdebe1229b7a08abd178',
          file_name:
            'videos/febbe6cf94a2bbce8dba400ff0507af5f97814c53555bdebe1229b7a08abd178.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/febbe6cf94a2bbce8dba400ff0507af5f97814c53555bdebe1229b7a08abd178.mp4',
          name: 'ADVANCED-Hitch_Kick_to_Touchdowns-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 107827,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 728,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '236aa3878bf494885a1928f1a492ac0bf4ffb73688374a1d24371105abb3cad7',
          file_name:
            'videos/236aa3878bf494885a1928f1a492ac0bf4ffb73688374a1d24371105abb3cad7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/236aa3878bf494885a1928f1a492ac0bf4ffb73688374a1d24371105abb3cad7.mp4',
          name: 'ADVANCED-Hitch_Kick_to_Touchdowns-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 107053,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 729,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '7a9b6d66864edf980150387e4cb92499913af843b63221128a14cfe2c08e7df8',
          file_name:
            'audios/7a9b6d66864edf980150387e4cb92499913af843b63221128a14cfe2c08e7df8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7a9b6d66864edf980150387e4cb92499913af843b63221128a14cfe2c08e7df8.mp3',
          name: 'ADVANCED-Hitch_Kick_to_Touchdowns-EXERCISE.mp3',
          description: null,
          size: 33738,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Incline Forearm Plank Jacks-EXERCISE': {
      id: 329,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Incline Forearm Plank Jacks',
      short_name: 'Incl. Forearm Plank Jacks',
      unique_name: 'INTERMEDIATE-Incline Forearm Plank Jacks-EXERCISE',
      description:
        '1. Start in Forearm Plank position with forearms on bench, elbows under shoulders, hips square.\n2. Bend your knees slightly and jack your feet out to the side in a wide "V" position.\n3. Jump both feet back to start position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 730,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '22cd0d3ec27ce292b0d518c1c1edffd009849e76a58f8a3f0899b262059bb63c',
          file_name:
            'videos/22cd0d3ec27ce292b0d518c1c1edffd009849e76a58f8a3f0899b262059bb63c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/22cd0d3ec27ce292b0d518c1c1edffd009849e76a58f8a3f0899b262059bb63c.mp4',
          name: 'INT-ADV-Incline_Forearm_Plank_Jacks-EXERCISE.mp4',
          description: null,
          size: 45105,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 731,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '59aa4b536f083f5e2478c90a828a566b6d90ee7b206c090266ea903391207aae',
          file_name:
            'audios/59aa4b536f083f5e2478c90a828a566b6d90ee7b206c090266ea903391207aae.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/59aa4b536f083f5e2478c90a828a566b6d90ee7b206c090266ea903391207aae.mp3',
          name: 'INT-ADV-Incline_Forearm_Plank_Jacks-EXERCISE.mp3',
          description: null,
          size: 47142,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Incline Forearm Plank Jacks-EXERCISE': {
      id: 330,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Incline Forearm Plank Jacks',
      short_name: 'Incl. Forearm Plank Jacks',
      unique_name: 'ADVANCED-Incline Forearm Plank Jacks-EXERCISE',
      description:
        '1. Start in Forearm Plank position with forearms on bench, elbows under shoulders, hips square.\n2. Bend your knees slightly and jack your feet out to the side in a wide "V" position.\n3. Jump both feet back to start position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 732,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '22cd0d3ec27ce292b0d518c1c1edffd009849e76a58f8a3f0899b262059bb63c',
          file_name:
            'videos/22cd0d3ec27ce292b0d518c1c1edffd009849e76a58f8a3f0899b262059bb63c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/22cd0d3ec27ce292b0d518c1c1edffd009849e76a58f8a3f0899b262059bb63c.mp4',
          name: 'INT-ADV-Incline_Forearm_Plank_Jacks-EXERCISE.mp4',
          description: null,
          size: 45105,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 733,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '59aa4b536f083f5e2478c90a828a566b6d90ee7b206c090266ea903391207aae',
          file_name:
            'audios/59aa4b536f083f5e2478c90a828a566b6d90ee7b206c090266ea903391207aae.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/59aa4b536f083f5e2478c90a828a566b6d90ee7b206c090266ea903391207aae.mp3',
          name: 'INT-ADV-Incline_Forearm_Plank_Jacks-EXERCISE.mp3',
          description: null,
          size: 47142,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Incline Plank Jack-EXERCISE': {
      id: 331,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Incline Plank Jack',
      short_name: 'Incline Plank Jack',
      unique_name: 'INTERMEDIATE-Incline Plank Jack-EXERCISE',
      description:
        '1. Start in Plank position with palms on bench, elbows under shoulders, hips square.\n2. Bend your knees slightly and jack your feet out to the side in a wide "V" position.\n3. Jump both feet back to start position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 734,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '263c64c9c0c8545f4da77d2b9ef2c59ad103cbc883be098053ba192097da6d51',
          file_name:
            'videos/263c64c9c0c8545f4da77d2b9ef2c59ad103cbc883be098053ba192097da6d51.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/263c64c9c0c8545f4da77d2b9ef2c59ad103cbc883be098053ba192097da6d51.mp4',
          name: 'INT-ADV-Incline_Plank_Jack-EXERCISE.mp4',
          description: null,
          size: 50665,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 735,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'ef670c3e76d5d4b91a1665db8cf4ec027ba19df5ace353393cdc273d16d75fed',
          file_name:
            'audios/ef670c3e76d5d4b91a1665db8cf4ec027ba19df5ace353393cdc273d16d75fed.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ef670c3e76d5d4b91a1665db8cf4ec027ba19df5ace353393cdc273d16d75fed.mp3',
          name: 'INT-ADV-Incline_Plank_Jacks-EXERCISE.mp3',
          description: null,
          size: 31954,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Incline Plank Jack-EXERCISE': {
      id: 332,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Incline Plank Jack',
      short_name: 'Incline Plank Jack',
      unique_name: 'ADVANCED-Incline Plank Jack-EXERCISE',
      description:
        '1. Start in Plank position with palms on bench, elbows under shoulders, hips square.\n2. Bend your knees slightly and jack your feet out to the side in a wide "V" position.\n3. Jump both feet back to start position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 736,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '263c64c9c0c8545f4da77d2b9ef2c59ad103cbc883be098053ba192097da6d51',
          file_name:
            'videos/263c64c9c0c8545f4da77d2b9ef2c59ad103cbc883be098053ba192097da6d51.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/263c64c9c0c8545f4da77d2b9ef2c59ad103cbc883be098053ba192097da6d51.mp4',
          name: 'INT-ADV-Incline_Plank_Jack-EXERCISE.mp4',
          description: null,
          size: 50665,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 737,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'ef670c3e76d5d4b91a1665db8cf4ec027ba19df5ace353393cdc273d16d75fed',
          file_name:
            'audios/ef670c3e76d5d4b91a1665db8cf4ec027ba19df5ace353393cdc273d16d75fed.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ef670c3e76d5d4b91a1665db8cf4ec027ba19df5ace353393cdc273d16d75fed.mp3',
          name: 'INT-ADV-Incline_Plank_Jacks-EXERCISE.mp3',
          description: null,
          size: 31954,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Knee Forearm Push-Ups-EXERCISE': {
      id: 333,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Knee Forearm Push-Ups',
      short_name: 'Knee Forearm Push-Ups',
      unique_name: 'BEGINNER-Knee Forearm Push-Ups-EXERCISE',
      description:
        '1. Start in Forearm Plank position, elbows under shoulders, hips square. Drop your knees straight down to the floor and lift your feet up.\n2. Shift your weight slightly forward and lower your body toward the floor by bending your elbows and bringing your shoulders toward your wrists.\n3. Drive through your forearms and lift your body back up to starting position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 738,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'e35d768cb771a54c79614c7f7096d165515a3d93fb10ef86fcf71c1a040e0ae8',
          file_name:
            'videos/e35d768cb771a54c79614c7f7096d165515a3d93fb10ef86fcf71c1a040e0ae8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e35d768cb771a54c79614c7f7096d165515a3d93fb10ef86fcf71c1a040e0ae8.mp4',
          name: 'BEG-INT-Knee_Forearm_Push-Ups-EXERCISE.mp4',
          description: null,
          size: 72531,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 739,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '3ebaa2a3c737ab5ab886c8a8f1fb25532b49f6cfbc86f80f38a338e0df2707ba',
          file_name:
            'audios/3ebaa2a3c737ab5ab886c8a8f1fb25532b49f6cfbc86f80f38a338e0df2707ba.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3ebaa2a3c737ab5ab886c8a8f1fb25532b49f6cfbc86f80f38a338e0df2707ba.mp3',
          name: 'BEG-INT-Knee_Forearm_Push-Ups-EXERCISE.mp3',
          description: null,
          size: 34976,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Knee Forearm Push-Ups-EXERCISE': {
      id: 334,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Knee Forearm Push-Ups',
      short_name: 'Knee Forearm Push-Ups',
      unique_name: 'INTERMEDIATE-Knee Forearm Push-Ups-EXERCISE',
      description:
        '1. Start in Forearm Plank position, elbows under shoulders, hips square. Drop your knees straight down to the floor and lift your feet up.\n2. Shift your weight slightly forward and lower your body toward the floor by bending your elbows and bringing your shoulders toward your wrists.\n3. Drive through your forearms and lift your body back up to starting position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 740,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'e35d768cb771a54c79614c7f7096d165515a3d93fb10ef86fcf71c1a040e0ae8',
          file_name:
            'videos/e35d768cb771a54c79614c7f7096d165515a3d93fb10ef86fcf71c1a040e0ae8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e35d768cb771a54c79614c7f7096d165515a3d93fb10ef86fcf71c1a040e0ae8.mp4',
          name: 'BEG-INT-Knee_Forearm_Push-Ups-EXERCISE.mp4',
          description: null,
          size: 72531,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 741,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '3ebaa2a3c737ab5ab886c8a8f1fb25532b49f6cfbc86f80f38a338e0df2707ba',
          file_name:
            'audios/3ebaa2a3c737ab5ab886c8a8f1fb25532b49f6cfbc86f80f38a338e0df2707ba.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3ebaa2a3c737ab5ab886c8a8f1fb25532b49f6cfbc86f80f38a338e0df2707ba.mp3',
          name: 'BEG-INT-Knee_Forearm_Push-Ups-EXERCISE.mp3',
          description: null,
          size: 34976,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Low Squat Heel Taps-EXERCISE': {
      id: 335,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Low Squat Heel Taps',
      short_name: 'Low Squat Heel Taps',
      unique_name: 'BEGINNER-Low Squat Heel Taps-EXERCISE',
      description:
        '1. Stand with your feet close together. Bend your knees, drop your hips and sink into a narrow squat.\n2. Staying low, tap one heel out in front of you. Return to the center.\n3. Tap the other heel out in front of you. Return to narrow squat position.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 742,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'dad818d753fedf2b8ca7fb698564717b9b9e624c47947d091aa7291e4334e2b8',
          file_name:
            'videos/dad818d753fedf2b8ca7fb698564717b9b9e624c47947d091aa7291e4334e2b8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dad818d753fedf2b8ca7fb698564717b9b9e624c47947d091aa7291e4334e2b8.mp4',
          name: 'BEGINNER-Low_Squat_Heel_Taps-EXERCISE.mp4',
          description: null,
          size: 96296,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 743,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '7d88dabb8511eb24fae1a0a926cbb448d74fa9a67325c145288f3f6f1f839bd6',
          file_name:
            'audios/7d88dabb8511eb24fae1a0a926cbb448d74fa9a67325c145288f3f6f1f839bd6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7d88dabb8511eb24fae1a0a926cbb448d74fa9a67325c145288f3f6f1f839bd6.mp3',
          name: 'BEGINNER-Low_Squat_Heel_Taps-EXERCISE.mp3',
          description: null,
          size: 35602,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Low Squat Tap Outs-EXERCISE': {
      id: 336,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Low Squat Tap Outs',
      short_name: 'Low Squat Tap Outs',
      unique_name: 'BEGINNER-Low Squat Tap Outs-EXERCISE',
      description:
        '1. Stand with your feet close together. Bend your knees, drop your hips and sink into a narrow squat.\n2. Staying low, tap one toe out to the side. Return to the center.\n3. Tap the other toe out to the side. Return to narrow squat position.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 744,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '3cab036c8a42bbce284ee488256057e79a77d177547c888aee81a6350a1c2798',
          file_name:
            'videos/3cab036c8a42bbce284ee488256057e79a77d177547c888aee81a6350a1c2798.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3cab036c8a42bbce284ee488256057e79a77d177547c888aee81a6350a1c2798.mp4',
          name: 'BEGINNER-Low_Squat_Tap_Outs-EXERCISE.mp4',
          description: null,
          size: 83016,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 745,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '3fce83e26b87d23c4002c7195285d10cfd3af4536c7c1a021ef64b2294163001',
          file_name:
            'audios/3fce83e26b87d23c4002c7195285d10cfd3af4536c7c1a021ef64b2294163001.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3fce83e26b87d23c4002c7195285d10cfd3af4536c7c1a021ef64b2294163001.mp3',
          name: 'BEGINNER-Low_Squat_Tap_Outs-EXERCISE.mp3',
          description: null,
          size: 35378,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Lying Reverse Flies-EXERCISE': {
      id: 337,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Lying Reverse Flies',
      short_name: 'Lying Reverse Flies',
      unique_name: 'BEGINNER-Lying Reverse Flies-EXERCISE',
      description:
        '1. Lie on your stomach with legs extended long, forehead resting on the floor and arms out to a "T", palms down.\n2. Raise both arms toward the ceiling as high as you can, keeping your chest, forehead and lower body on the floor.\n3. Pause for a beat at the top.\n4. Return to start position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 746,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '1cbc9dc76e68a1d943ea04a6b5477193f8f6705eb75db38add9745101d7d91a2',
          file_name:
            'videos/1cbc9dc76e68a1d943ea04a6b5477193f8f6705eb75db38add9745101d7d91a2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1cbc9dc76e68a1d943ea04a6b5477193f8f6705eb75db38add9745101d7d91a2.mp4',
          name: 'BEGINNER-Lying_Reverse_Flies-EXERCISE.mp4',
          description: null,
          size: 42086,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 747,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'a5f857ace3a5cefb335608b1073d961a1b3bb4cf8f3305065e549f9c3e0860a4',
          file_name:
            'audios/a5f857ace3a5cefb335608b1073d961a1b3bb4cf8f3305065e549f9c3e0860a4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a5f857ace3a5cefb335608b1073d961a1b3bb4cf8f3305065e549f9c3e0860a4.mp3',
          name: 'BEGINNER-Lying_Reverse_Flies-EXERCISE.mp3',
          description: null,
          size: 35204,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Piked Push-Up on Bench-EXERCISE': {
      id: 338,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Piked Push-Up on Bench',
      short_name: 'Piked Push-Up on Bench',
      unique_name: 'ADVANCED-Piked Push-Up on Bench-EXERCISE',
      description:
        '1. Start in a decline Down Dog position with hands on the floor and feet on the bench.\n2. Keep your hips up, chin tucked and ears aligned with the pits of your elbows.\n3. Bend your elbows and bring the crown of your head down as far as you can, aiming for the center of your hands.\n4. Push through your palms to extend arms and body back up to start position. Think of a bodyweight shoulder press.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 748,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'a697354f8666e97f8c04f20ba81a68eb652fd9736d1d45f62a5942e3cb3d9eff',
          file_name:
            'videos/a697354f8666e97f8c04f20ba81a68eb652fd9736d1d45f62a5942e3cb3d9eff.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a697354f8666e97f8c04f20ba81a68eb652fd9736d1d45f62a5942e3cb3d9eff.mp4',
          name: 'ADVANCED-Piked_Push-Up_on_Bench-EXERCISE.mp4',
          description: null,
          size: 61156,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 749,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '63fbe0678e8373cf54c01c25a7ceed3e3464fc404b47afd1d6480b114a757038',
          file_name:
            'audios/63fbe0678e8373cf54c01c25a7ceed3e3464fc404b47afd1d6480b114a757038.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/63fbe0678e8373cf54c01c25a7ceed3e3464fc404b47afd1d6480b114a757038.mp3',
          name: 'ADVANCED-Piked_Push-Ups_on_Bench-EXERCISE.mp3',
          description: null,
          size: 35891,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Plank Bench Jacks-EXERCISE': {
      id: 339,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Plank Bench Jacks',
      short_name: 'Plank Bench Jacks',
      unique_name: 'ADVANCED-Plank Bench Jacks-EXERCISE',
      description:
        '1. Start in Plank position, hands on the floor directly under shoulders and your feet together on top of the bench.\n2. Keeping your core engaged and back straight, jack both feet out to the sides and land on the floor straddling the bench.\n3. Jump both feet back up to start position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 750,
          collection_name: 'videos',
          order: 1,
          version: 200000000,
          hash: '87305264c5f0705ffac373e63b6ca249a435245f4fa25422ed34457ec49fa89c',
          file_name:
            'videos/87305264c5f0705ffac373e63b6ca249a435245f4fa25422ed34457ec49fa89c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/87305264c5f0705ffac373e63b6ca249a435245f4fa25422ed34457ec49fa89c.mp4',
          name: 'ADVANCED-Plank_Bench_Jacks-EXERCISE.mp4',
          description: null,
          size: 60608,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 751,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'c0f72c144cc6778c0c4b479507d50a8bbb93666a8f46607a320f65346570ef9b',
          file_name:
            'audios/c0f72c144cc6778c0c4b479507d50a8bbb93666a8f46607a320f65346570ef9b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c0f72c144cc6778c0c4b479507d50a8bbb93666a8f46607a320f65346570ef9b.mp3',
          name: 'ADVANCED-Plank_Bench_Jacks-EXERCISE.mp3',
          description: null,
          size: 41644,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Plank Kick-Throughs-EXERCISE': {
      id: 340,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Plank Kick-Throughs',
      short_name: 'Plank Kick-Throughs',
      unique_name: 'INTERMEDIATE-Plank Kick-Throughs-EXERCISE',
      description:
        '1. Start in plank position with shoulders over palms and hips square.\n2. Lift one leg up, twist your torso and kick your leg through to the opposite side of your body. Keep your leg straight.\n3. Return to start position and repeat on the other side.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 752,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'ad0f02a444396145a32d2e16e888eef48f0d3a08f0944b1a59f70ac963a45926',
          file_name:
            'videos/ad0f02a444396145a32d2e16e888eef48f0d3a08f0944b1a59f70ac963a45926.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ad0f02a444396145a32d2e16e888eef48f0d3a08f0944b1a59f70ac963a45926.mp4',
          name: 'INTERMEDIATE-Plank_Kick-Throughs-EXERCISE.mp4',
          description: null,
          size: 181811,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 753,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'c65ad43da8c29fc6d067199421c8c4faea0ccf31421fbbbaee5ef18d8139cdd3',
          file_name:
            'audios/c65ad43da8c29fc6d067199421c8c4faea0ccf31421fbbbaee5ef18d8139cdd3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c65ad43da8c29fc6d067199421c8c4faea0ccf31421fbbbaee5ef18d8139cdd3.mp3',
          name: 'INTERMEDIATE-Plank_Kick-Throughs-EXERCISE.mp3',
          description: null,
          size: 29618,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Plank Tap Outs-EXERCISE': {
      id: 341,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Plank Tap Outs',
      short_name: 'Plank Tap Outs',
      unique_name: 'INTERMEDIATE-Plank Tap Outs-EXERCISE',
      description:
        '1. Start in plank position, shoulders over wrists, hips square.\n2. Tap one foot out to the side. Return to center.\n3. Tap the other foot out to the side. Return to center.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 754,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'a53a313583c106c09f1f7937158c5fcccedee700502161b45c3c9caccbf22b98',
          file_name:
            'videos/a53a313583c106c09f1f7937158c5fcccedee700502161b45c3c9caccbf22b98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a53a313583c106c09f1f7937158c5fcccedee700502161b45c3c9caccbf22b98.mp4',
          name: 'INTERMEDIATE-Plank_Tap_Outs-EXERCISE.mp4',
          description: null,
          size: 85721,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 755,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '8cc8d0fa84acb7a125afcb8f283b76fddfef2a42afc958223bc8c95564991e3c',
          file_name:
            'audios/8cc8d0fa84acb7a125afcb8f283b76fddfef2a42afc958223bc8c95564991e3c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8cc8d0fa84acb7a125afcb8f283b76fddfef2a42afc958223bc8c95564991e3c.mp3',
          name: 'INTERMEDIATE-Plank_Tap_Outs-EXERCISE.mp3',
          description: null,
          size: 28640,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Seated Knee Tucks-EXERCISE': {
      id: 342,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Seated Knee Tucks',
      short_name: 'Seated Knee Tucks',
      unique_name: 'BEGINNER-Seated Knee Tucks-EXERCISE',
      description:
        '1. Sit on the floor with your hands behind you, palms down. Keeping your spine straight, lean back, lift and extend legs long in front of you. Tuck your pelvis to support your lower back.\n2. Bend your legs and crunch both knees into your chest.\n3. Extend both legs back out again without them touching the floor.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 801,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '6851266c6c1d34a9ba1e5af8b466b31c50794afbb2493ec52238682c81c50759',
          file_name:
            'videos/6851266c6c1d34a9ba1e5af8b466b31c50794afbb2493ec52238682c81c50759.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6851266c6c1d34a9ba1e5af8b466b31c50794afbb2493ec52238682c81c50759.mp4',
          name: 'BEG-INT-ADV-Seated_Knee_Tucks-EXERCISE.mp4',
          description: null,
          size: 55034,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 802,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '859a002b424f42a75fd0479ce99dce90c65dbe8871fdb54a7ff059f0a7f0340c',
          file_name:
            'audios/859a002b424f42a75fd0479ce99dce90c65dbe8871fdb54a7ff059f0a7f0340c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/859a002b424f42a75fd0479ce99dce90c65dbe8871fdb54a7ff059f0a7f0340c.mp3',
          name: 'BEG-INT-ADV-Seated_Knee_Tucks-EXERCISE.mp3',
          description: null,
          size: 30304,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Seated Knee Tucks-EXERCISE': {
      id: 343,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Seated Knee Tucks',
      short_name: 'Seated Knee Tucks',
      unique_name: 'INTERMEDIATE-Seated Knee Tucks-EXERCISE',
      description:
        '1. Sit on the floor with your hands behind you, palms down. Keeping your spine straight, lean back, lift and extend legs long in front of you. Tuck your pelvis to support your lower back.\n2. Bend your legs and crunch both knees into your chest.\n3. Extend both legs back out again without them touching the floor.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 803,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '6851266c6c1d34a9ba1e5af8b466b31c50794afbb2493ec52238682c81c50759',
          file_name:
            'videos/6851266c6c1d34a9ba1e5af8b466b31c50794afbb2493ec52238682c81c50759.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6851266c6c1d34a9ba1e5af8b466b31c50794afbb2493ec52238682c81c50759.mp4',
          name: 'BEG-INT-ADV-Seated_Knee_Tucks-EXERCISE.mp4',
          description: null,
          size: 55034,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 804,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '859a002b424f42a75fd0479ce99dce90c65dbe8871fdb54a7ff059f0a7f0340c',
          file_name:
            'audios/859a002b424f42a75fd0479ce99dce90c65dbe8871fdb54a7ff059f0a7f0340c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/859a002b424f42a75fd0479ce99dce90c65dbe8871fdb54a7ff059f0a7f0340c.mp3',
          name: 'BEG-INT-ADV-Seated_Knee_Tucks-EXERCISE.mp3',
          description: null,
          size: 30304,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Seated Knee Tucks-EXERCISE': {
      id: 344,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Seated Knee Tucks',
      short_name: 'Seated Knee Tucks',
      unique_name: 'ADVANCED-Seated Knee Tucks-EXERCISE',
      description:
        '1. Sit on the floor with your hands behind you, palms down. Keeping your spine straight, lean back, lift and extend legs long in front of you. Tuck your pelvis to support your lower back.\n2. Bend your legs and crunch both knees into your chest.\n3. Extend both legs back out again without them touching the floor.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 805,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '6851266c6c1d34a9ba1e5af8b466b31c50794afbb2493ec52238682c81c50759',
          file_name:
            'videos/6851266c6c1d34a9ba1e5af8b466b31c50794afbb2493ec52238682c81c50759.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6851266c6c1d34a9ba1e5af8b466b31c50794afbb2493ec52238682c81c50759.mp4',
          name: 'BEG-INT-ADV-Seated_Knee_Tucks-EXERCISE.mp4',
          description: null,
          size: 55034,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 806,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '859a002b424f42a75fd0479ce99dce90c65dbe8871fdb54a7ff059f0a7f0340c',
          file_name:
            'audios/859a002b424f42a75fd0479ce99dce90c65dbe8871fdb54a7ff059f0a7f0340c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/859a002b424f42a75fd0479ce99dce90c65dbe8871fdb54a7ff059f0a7f0340c.mp3',
          name: 'BEG-INT-ADV-Seated_Knee_Tucks-EXERCISE.mp3',
          description: null,
          size: 30304,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Side Plank Hip Drops with Leg Up-EXERCISE': {
      id: 345,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Side Plank Hip Drops with Leg Up',
      short_name: 'Side Plank Hip Drops with Leg Up',
      unique_name: 'INTERMEDIATE-Side Plank Hip Drops with Leg Up-EXERCISE',
      description:
        '1. Lie on your side, propping yourself on your forearm, elbow directly below your shoulder, feet stacked.\n2. Lift your hips up so your body is in a straight line in Side Plank. Raise your top leg into the air and keep it elevated throughout the exercise.\n3. Lower your hip down to the floor and then raise it back up again.\n4. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
      ],
      files: [
        {
          id: 762,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '7b335ceec04f2e23b946f47b453b0a593ea9c44332c8a2aef2f1b32455b37e31',
          file_name:
            'videos/7b335ceec04f2e23b946f47b453b0a593ea9c44332c8a2aef2f1b32455b37e31.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7b335ceec04f2e23b946f47b453b0a593ea9c44332c8a2aef2f1b32455b37e31.mp4',
          name: 'INT-ADV-Side_Plank_Hip_Drops_with_Leg_Up-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 63400,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 763,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '2359118d18ff60554ca5041be7e7221998bd3a1cc1a3e6b66c88944218f88814',
          file_name:
            'videos/2359118d18ff60554ca5041be7e7221998bd3a1cc1a3e6b66c88944218f88814.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2359118d18ff60554ca5041be7e7221998bd3a1cc1a3e6b66c88944218f88814.mp4',
          name: 'INT-ADV-Side_Plank_Hip_Drops_with_Leg_Up-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 80819,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 764,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'cffefe706204fb7fa64d057ae245cf02e5aac2beda3123e3874b6660225e8868',
          file_name:
            'audios/cffefe706204fb7fa64d057ae245cf02e5aac2beda3123e3874b6660225e8868.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cffefe706204fb7fa64d057ae245cf02e5aac2beda3123e3874b6660225e8868.mp3',
          name: 'INT-ADV-Side_Plank_Hip_Drops_with_Leg_Up-EXERCISE.mp3',
          description: null,
          size: 36584,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Side Plank Hip Drops with Leg Up-EXERCISE': {
      id: 346,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Side Plank Hip Drops with Leg Up',
      short_name: 'Side Plank Hip Drops with Leg Up',
      unique_name: 'ADVANCED-Side Plank Hip Drops with Leg Up-EXERCISE',
      description:
        '1. Lie on your side, propping yourself on your forearm, elbow directly below your shoulder, feet stacked.\n2. Lift your hips up so your body is in a straight line in Side Plank. Raise your top leg into the air and keep it elevated throughout the exercise.\n3. Lower your hip down to the floor and then raise it back up again.\n4. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 765,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '7b335ceec04f2e23b946f47b453b0a593ea9c44332c8a2aef2f1b32455b37e31',
          file_name:
            'videos/7b335ceec04f2e23b946f47b453b0a593ea9c44332c8a2aef2f1b32455b37e31.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7b335ceec04f2e23b946f47b453b0a593ea9c44332c8a2aef2f1b32455b37e31.mp4',
          name: 'INT-ADV-Side_Plank_Hip_Drops_with_Leg_Up-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 63400,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 766,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '2359118d18ff60554ca5041be7e7221998bd3a1cc1a3e6b66c88944218f88814',
          file_name:
            'videos/2359118d18ff60554ca5041be7e7221998bd3a1cc1a3e6b66c88944218f88814.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2359118d18ff60554ca5041be7e7221998bd3a1cc1a3e6b66c88944218f88814.mp4',
          name: 'INT-ADV-Side_Plank_Hip_Drops_with_Leg_Up-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 80819,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 767,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'cffefe706204fb7fa64d057ae245cf02e5aac2beda3123e3874b6660225e8868',
          file_name:
            'audios/cffefe706204fb7fa64d057ae245cf02e5aac2beda3123e3874b6660225e8868.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cffefe706204fb7fa64d057ae245cf02e5aac2beda3123e3874b6660225e8868.mp3',
          name: 'INT-ADV-Side_Plank_Hip_Drops_with_Leg_Up-EXERCISE.mp3',
          description: null,
          size: 36584,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Side-Lying Tricep Push-Ups-EXERCISE': {
      id: 347,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Side-Lying Tricep Push-Ups',
      short_name: 'Side-Lying Tricep Push-Ups',
      unique_name: 'BEGINNER-Side-Lying Tricep Push-Ups-EXERCISE',
      description:
        '1. Lie on your side stacking your shoulders, hips and feet. Hollow your body slightly inward.\n2. Bring your top hand to the floor directly in front of your bottom shoulder. The other arm can rest on the floor, your top shoulder or wrapped around your waist.\n3. Push through the palm to press your upper body off the floor. Lower with control.\n4. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 504,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '0457dca66a49ee0c18a3ea2f40bcfe9e1ba426014c7598b5b6cc51041aa7487b',
          file_name:
            'videos/0457dca66a49ee0c18a3ea2f40bcfe9e1ba426014c7598b5b6cc51041aa7487b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0457dca66a49ee0c18a3ea2f40bcfe9e1ba426014c7598b5b6cc51041aa7487b.mp4',
          name: 'BEGINNER-Side-Lying_Tricep_Push-ups-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 87399,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 505,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '0482f60df718eda020a8639105b37029897350243f6bcb49bf37a91fb63993ee',
          file_name:
            'videos/0482f60df718eda020a8639105b37029897350243f6bcb49bf37a91fb63993ee.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0482f60df718eda020a8639105b37029897350243f6bcb49bf37a91fb63993ee.mp4',
          name: 'BEGINNER-Side-Lying_Tricep_Push-ups-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 76372,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 506,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '71f233a8a1ae80bdb52559ade9b760f266c3f8f1aaed82dcf4a5f9fabebad45e',
          file_name:
            'audios/71f233a8a1ae80bdb52559ade9b760f266c3f8f1aaed82dcf4a5f9fabebad45e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/71f233a8a1ae80bdb52559ade9b760f266c3f8f1aaed82dcf4a5f9fabebad45e.mp3',
          name: 'BEGINNER-Side-Lying_Tricep_Push-ups-EXERCISE.mp3',
          description: null,
          size: 40314,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Side-Lying Tricep Push-Ups-EXERCISE': {
      id: 348,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Side-Lying Tricep Push-Ups',
      short_name: 'Side-Lying Tricep Push-Ups',
      unique_name: 'INTERMEDIATE-Side-Lying Tricep Push-Ups-EXERCISE',
      description:
        '1. Lie on your side stacking your shoulders, hips and feet. Hollow your body slightly inward.\n2. Bring your top hand to the floor directly in front of your bottom shoulder. The other arm can rest on the floor, your top shoulder or wrapped around your waist.\n3. Push through the palm to press your upper body off the floor. Lower with control.\n4. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 507,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '0457dca66a49ee0c18a3ea2f40bcfe9e1ba426014c7598b5b6cc51041aa7487b',
          file_name:
            'videos/0457dca66a49ee0c18a3ea2f40bcfe9e1ba426014c7598b5b6cc51041aa7487b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0457dca66a49ee0c18a3ea2f40bcfe9e1ba426014c7598b5b6cc51041aa7487b.mp4',
          name: 'INTERMEDIATE-Side-Lying_Tricep_Push-ups-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 87399,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 508,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '0482f60df718eda020a8639105b37029897350243f6bcb49bf37a91fb63993ee',
          file_name:
            'videos/0482f60df718eda020a8639105b37029897350243f6bcb49bf37a91fb63993ee.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0482f60df718eda020a8639105b37029897350243f6bcb49bf37a91fb63993ee.mp4',
          name: 'INTERMEDIATE-Side-Lying_Tricep_Push-ups-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 76372,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 509,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '71f233a8a1ae80bdb52559ade9b760f266c3f8f1aaed82dcf4a5f9fabebad45e',
          file_name:
            'audios/71f233a8a1ae80bdb52559ade9b760f266c3f8f1aaed82dcf4a5f9fabebad45e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/71f233a8a1ae80bdb52559ade9b760f266c3f8f1aaed82dcf4a5f9fabebad45e.mp3',
          name: 'INTERMEDIATE-Side-Lying_Tricep_Push-ups-EXERCISE.mp3',
          description: null,
          size: 40314,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Side-Lying Tricep Push-Ups-EXERCISE': {
      id: 349,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Side-Lying Tricep Push-Ups',
      short_name: 'Side-Lying Tricep Push-Ups',
      unique_name: 'ADVANCED-Side-Lying Tricep Push-Ups-EXERCISE',
      description:
        '1. Lie on your side stacking your shoulders, hips and feet. Hollow your body slightly inward.\n2. Bring your top hand to the floor directly in front of your bottom shoulder. The other arm can rest on the floor, your top shoulder or wrapped around your waist.\n3. Push through the palm to press your upper body off the floor. Lower with control.\n4. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 510,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: '0457dca66a49ee0c18a3ea2f40bcfe9e1ba426014c7598b5b6cc51041aa7487b',
          file_name:
            'videos/0457dca66a49ee0c18a3ea2f40bcfe9e1ba426014c7598b5b6cc51041aa7487b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0457dca66a49ee0c18a3ea2f40bcfe9e1ba426014c7598b5b6cc51041aa7487b.mp4',
          name: 'ADVANCED-Side-Lying_Tricep_Push-ups-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 87399,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 511,
          collection_name: 'videos',
          order: 2,
          version: 100040000,
          hash: '0482f60df718eda020a8639105b37029897350243f6bcb49bf37a91fb63993ee',
          file_name:
            'videos/0482f60df718eda020a8639105b37029897350243f6bcb49bf37a91fb63993ee.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0482f60df718eda020a8639105b37029897350243f6bcb49bf37a91fb63993ee.mp4',
          name: 'ADVANCED-Side-Lying_Tricep_Push-ups-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 76372,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 512,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '71f233a8a1ae80bdb52559ade9b760f266c3f8f1aaed82dcf4a5f9fabebad45e',
          file_name:
            'audios/71f233a8a1ae80bdb52559ade9b760f266c3f8f1aaed82dcf4a5f9fabebad45e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/71f233a8a1ae80bdb52559ade9b760f266c3f8f1aaed82dcf4a5f9fabebad45e.mp3',
          name: 'ADVANCED-Side-Lying_Tricep_Push-ups-EXERCISE.mp3',
          description: null,
          size: 40314,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Sit and Reach-EXERCISE': {
      id: 350,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Sit and Reach',
      short_name: 'Sit and Reach',
      unique_name: 'INTERMEDIATE-Sit and Reach-EXERCISE',
      description:
        '1. Lie on your back with your feet on the floor, knees bent. Hold a single dumbbell horizontally against your chest.\n2. Sit up and extend your arms overhead, reaching the dumbbell toward the ceiling.\n3. Extend fully at the top with a straight spine and "peek through the window" bringing your ears in line with the pits of your elbows.\n4. In a controlled motion, lower down back to start.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 777,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'f644498695d0dedbc2db90c28c2fa4f4f1e448af828b6f69540dc18be8359b63',
          file_name:
            'videos/f644498695d0dedbc2db90c28c2fa4f4f1e448af828b6f69540dc18be8359b63.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f644498695d0dedbc2db90c28c2fa4f4f1e448af828b6f69540dc18be8359b63.mp4',
          name: 'INT-ADV-Sit_and_Reach-EXERCISE.mp4',
          description: null,
          size: 117960,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 778,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'c94f4b0e09cfa4f5edb257eda30a1cad415e20b58eefdcc484f2bc7c910a9057',
          file_name:
            'audios/c94f4b0e09cfa4f5edb257eda30a1cad415e20b58eefdcc484f2bc7c910a9057.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c94f4b0e09cfa4f5edb257eda30a1cad415e20b58eefdcc484f2bc7c910a9057.mp3',
          name: 'INT-ADV-Sit_and_Reach-EXERCISE.mp3',
          description: null,
          size: 20732,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Sit and Reach-EXERCISE': {
      id: 351,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Sit and Reach',
      short_name: 'Sit and Reach',
      unique_name: 'ADVANCED-Sit and Reach-EXERCISE',
      description:
        '1. Lie on your back with your feet on the floor, knees bent. Hold a single dumbbell horizontally against your chest.\n2. Sit up and extend your arms overhead, reaching the dumbbell toward the ceiling.\n3. Extend fully at the top with a straight spine and "peek through the window" bringing your ears in line with the pits of your elbows.\n4. In a controlled motion, lower down back to start.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 779,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'f644498695d0dedbc2db90c28c2fa4f4f1e448af828b6f69540dc18be8359b63',
          file_name:
            'videos/f644498695d0dedbc2db90c28c2fa4f4f1e448af828b6f69540dc18be8359b63.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f644498695d0dedbc2db90c28c2fa4f4f1e448af828b6f69540dc18be8359b63.mp4',
          name: 'INT-ADV-Sit_and_Reach-EXERCISE.mp4',
          description: null,
          size: 117960,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 780,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'c94f4b0e09cfa4f5edb257eda30a1cad415e20b58eefdcc484f2bc7c910a9057',
          file_name:
            'audios/c94f4b0e09cfa4f5edb257eda30a1cad415e20b58eefdcc484f2bc7c910a9057.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c94f4b0e09cfa4f5edb257eda30a1cad415e20b58eefdcc484f2bc7c910a9057.mp3',
          name: 'INT-ADV-Sit_and_Reach-EXERCISE.mp3',
          description: null,
          size: 20732,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Squat to Curl-EXERCISE': {
      id: 352,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Squat to Curl',
      short_name: 'Squat to Curl',
      unique_name: 'INTERMEDIATE-Squat to Curl-EXERCISE',
      description:
        '1. Start standing with your feet shoulder-width apart, holding one dumbbell in each hand, palms facing in.\n2. Squat down and lower the dumbbells toward the floor.\n3. Drive through your heels to stand as you curl the dumbbells toward your shoulders. Keep your elbows close to your ribcage.\n4. Lower your arms back down to starting position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 781,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'bda5ee81ac910fe3213823a87f6059b9abae3545c0ab30327cc7d1f07ad227d2',
          file_name:
            'videos/bda5ee81ac910fe3213823a87f6059b9abae3545c0ab30327cc7d1f07ad227d2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bda5ee81ac910fe3213823a87f6059b9abae3545c0ab30327cc7d1f07ad227d2.mp4',
          name: 'INT-ADV-Squat_to_Curl-EXERCISE.mp4',
          description: null,
          size: 127046,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 782,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '4f0e8a1dd92c81e763495e0b1dee1155d5b81066fd3ea2ef4b54327118ecfd71',
          file_name:
            'audios/4f0e8a1dd92c81e763495e0b1dee1155d5b81066fd3ea2ef4b54327118ecfd71.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4f0e8a1dd92c81e763495e0b1dee1155d5b81066fd3ea2ef4b54327118ecfd71.mp3',
          name: 'INT-ADV-Squat_with_Curl-EXERCISE.mp3',
          description: null,
          size: 29840,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Squat to Curl-EXERCISE': {
      id: 353,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Squat to Curl',
      short_name: 'Squat to Curl',
      unique_name: 'ADVANCED-Squat to Curl-EXERCISE',
      description:
        '1. Start standing with your feet shoulder-width apart, holding one dumbbell in each hand, palms facing in.\n2. Squat down and lower the dumbbells toward the floor.\n3. Drive through your heels to stand as you curl the dumbbells toward your shoulders. Keep your elbows close to your ribcage.\n4. Lower your arms back down to starting position.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 783,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'bda5ee81ac910fe3213823a87f6059b9abae3545c0ab30327cc7d1f07ad227d2',
          file_name:
            'videos/bda5ee81ac910fe3213823a87f6059b9abae3545c0ab30327cc7d1f07ad227d2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bda5ee81ac910fe3213823a87f6059b9abae3545c0ab30327cc7d1f07ad227d2.mp4',
          name: 'INT-ADV-Squat_to_Curl-EXERCISE.mp4',
          description: null,
          size: 127046,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 784,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '4f0e8a1dd92c81e763495e0b1dee1155d5b81066fd3ea2ef4b54327118ecfd71',
          file_name:
            'audios/4f0e8a1dd92c81e763495e0b1dee1155d5b81066fd3ea2ef4b54327118ecfd71.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4f0e8a1dd92c81e763495e0b1dee1155d5b81066fd3ea2ef4b54327118ecfd71.mp3',
          name: 'INT-ADV-Squat_with_Curl-EXERCISE.mp3',
          description: null,
          size: 29840,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Squat to Reverse Lunge-EXERCISE': {
      id: 354,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Squat to Reverse Lunge',
      short_name: 'Squat to Reverse Lunge',
      unique_name: 'BEGINNER-Squat to Reverse Lunge-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart.\n2. Maintaining good posture, squat as low as possible. Drive through heels to return to standing.\n3. Take a big step backward with one leg, landing with your heel elevated and hips square. Drop down into a lunge bending both knees 90 degrees.\n4. Drive through the front foot and return to start.\n5. Repeat on other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 785,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '1ca0f19c6bb6aad832b733a3a1ad96203488789facafe4e9b9e7135488d0e06a',
          file_name:
            'videos/1ca0f19c6bb6aad832b733a3a1ad96203488789facafe4e9b9e7135488d0e06a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1ca0f19c6bb6aad832b733a3a1ad96203488789facafe4e9b9e7135488d0e06a.mp4',
          name: 'BEGINNER-Squat_to_Reverse_Lunge-EXERCISE.mp4',
          description: null,
          size: 485506,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 786,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '9ba92520e1b5dd70ec94b7fd6cd64c99e48568e63462c0c55c60b28f663133f1',
          file_name:
            'audios/9ba92520e1b5dd70ec94b7fd6cd64c99e48568e63462c0c55c60b28f663133f1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9ba92520e1b5dd70ec94b7fd6cd64c99e48568e63462c0c55c60b28f663133f1.mp3',
          name: 'BEG-INT-ADV-Squat_to_Reverse_Lunge-EXERCISE.mp3',
          description: null,
          size: 38258,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Static Lunges-EXERCISE': {
      id: 355,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Static Lunges',
      short_name: 'Static Lunges',
      unique_name: 'INTERMEDIATE-Static Lunges-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, holding one dumbbell in each hand by your sides. Take a big step forward with one leg, elevate your back heel.\n2. Drop your hips toward the floor by bending both knees to 90 degrees. Front knee should be directly over your ankle and back knee near the floor.\n3. Drive through your heel to straighten legs.\n4. Perform all reps with one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 787,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '2ce84283dad4fc8369a2abaf9d78ccd76ad56237368b2cfd73ad9b8782596381',
          file_name:
            'videos/2ce84283dad4fc8369a2abaf9d78ccd76ad56237368b2cfd73ad9b8782596381.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2ce84283dad4fc8369a2abaf9d78ccd76ad56237368b2cfd73ad9b8782596381.mp4',
          name: 'INT-ADV-Static_Lunges-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 65350,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 788,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '043eca7570cbb78a40042eede21630c1ff8f56339c13abce7eb545e3b0cf8086',
          file_name:
            'videos/043eca7570cbb78a40042eede21630c1ff8f56339c13abce7eb545e3b0cf8086.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/043eca7570cbb78a40042eede21630c1ff8f56339c13abce7eb545e3b0cf8086.mp4',
          name: 'INT-ADV-Static_Lunges-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 70013,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 789,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'f094a7de6d6e1d808fce7ceafafc6fa575baafcd52f154df2063655b1244df83',
          file_name:
            'audios/f094a7de6d6e1d808fce7ceafafc6fa575baafcd52f154df2063655b1244df83.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f094a7de6d6e1d808fce7ceafafc6fa575baafcd52f154df2063655b1244df83.mp3',
          name: 'INT-ADV-Static_Lunges-EXERCISE.mp3',
          description: null,
          size: 23622,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Static Lunges-EXERCISE': {
      id: 356,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Static Lunges',
      short_name: 'Static Lunges',
      unique_name: 'ADVANCED-Static Lunges-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, holding one dumbbell in each hand by your sides. Take a big step forward with one leg, elevate your back heel.\n2. Drop your hips toward the floor by bending both knees to 90 degrees. Front knee should be directly over your ankle and back knee near the floor.\n3. Drive through your heel to straighten legs.\n4. Perform all reps with one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 790,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '2ce84283dad4fc8369a2abaf9d78ccd76ad56237368b2cfd73ad9b8782596381',
          file_name:
            'videos/2ce84283dad4fc8369a2abaf9d78ccd76ad56237368b2cfd73ad9b8782596381.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2ce84283dad4fc8369a2abaf9d78ccd76ad56237368b2cfd73ad9b8782596381.mp4',
          name: 'INT-ADV-Static_Lunges-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 65350,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 791,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '043eca7570cbb78a40042eede21630c1ff8f56339c13abce7eb545e3b0cf8086',
          file_name:
            'videos/043eca7570cbb78a40042eede21630c1ff8f56339c13abce7eb545e3b0cf8086.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/043eca7570cbb78a40042eede21630c1ff8f56339c13abce7eb545e3b0cf8086.mp4',
          name: 'INT-ADV-Static_Lunges-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 70013,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 792,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'f094a7de6d6e1d808fce7ceafafc6fa575baafcd52f154df2063655b1244df83',
          file_name:
            'audios/f094a7de6d6e1d808fce7ceafafc6fa575baafcd52f154df2063655b1244df83.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f094a7de6d6e1d808fce7ceafafc6fa575baafcd52f154df2063655b1244df83.mp3',
          name: 'INT-ADV-Static_Lunges-EXERCISE.mp3',
          description: null,
          size: 23622,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Touchdowns-EXERCISE': {
      id: 357,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Touchdowns',
      short_name: 'Touchdowns',
      unique_name: 'BEGINNER-Touchdowns-EXERCISE',
      description:
        '1. Stand with feet hip-width apart. Extend one leg long to the side. Bend the knee of your standing leg and sink your hips back to touch the floor in front of you.\n2. Keeping your chest up and shoulders back, jump up and switch your legs in the air.\n3. Land with the opposite foot under you and the other leg extended to the side. Touch the floor with the opposite hand.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 793,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'f1fd27ff89872c5e7a33558d7e03657841fd3be94caed4fbaed16c5fd00ccb51',
          file_name:
            'videos/f1fd27ff89872c5e7a33558d7e03657841fd3be94caed4fbaed16c5fd00ccb51.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f1fd27ff89872c5e7a33558d7e03657841fd3be94caed4fbaed16c5fd00ccb51.mp4',
          name: 'BEG-INT-ADV-Touchdowns-EXERCISE.mp4',
          description: null,
          size: 114156,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 794,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'c5e74b7ff6c3ca47905680a00746e94c6f31d8a89ac6037a3483582f3d7c10dd',
          file_name:
            'audios/c5e74b7ff6c3ca47905680a00746e94c6f31d8a89ac6037a3483582f3d7c10dd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c5e74b7ff6c3ca47905680a00746e94c6f31d8a89ac6037a3483582f3d7c10dd.mp3',
          name: 'BEG-INT-ADV-Touchdowns-EXERCISE.mp3',
          description: null,
          size: 25470,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Touchdowns-EXERCISE': {
      id: 358,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Touchdowns',
      short_name: 'Touchdowns',
      unique_name: 'INTERMEDIATE-Touchdowns-EXERCISE',
      description:
        '1. Stand with feet hip-width apart. Extend one leg long to the side. Bend the knee of your standing leg and sink your hips back to touch the floor in front of you.\n2. Keeping your chest up and shoulders back, jump up and switch your legs in the air.\n3. Land with the opposite foot under you and the other leg extended to the side. Touch the floor with the opposite hand.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 795,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'f1fd27ff89872c5e7a33558d7e03657841fd3be94caed4fbaed16c5fd00ccb51',
          file_name:
            'videos/f1fd27ff89872c5e7a33558d7e03657841fd3be94caed4fbaed16c5fd00ccb51.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f1fd27ff89872c5e7a33558d7e03657841fd3be94caed4fbaed16c5fd00ccb51.mp4',
          name: 'BEG-INT-ADV-Touchdowns-EXERCISE.mp4',
          description: null,
          size: 114156,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 796,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'c5e74b7ff6c3ca47905680a00746e94c6f31d8a89ac6037a3483582f3d7c10dd',
          file_name:
            'audios/c5e74b7ff6c3ca47905680a00746e94c6f31d8a89ac6037a3483582f3d7c10dd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c5e74b7ff6c3ca47905680a00746e94c6f31d8a89ac6037a3483582f3d7c10dd.mp3',
          name: 'BEG-INT-ADV-Touchdowns-EXERCISE.mp3',
          description: null,
          size: 25470,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Touchdowns-EXERCISE': {
      id: 359,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Touchdowns',
      short_name: 'Touchdowns',
      unique_name: 'ADVANCED-Touchdowns-EXERCISE',
      description:
        '1. Stand with feet hip-width apart. Extend one leg long to the side. Bend the knee of your standing leg and sink your hips back to touch the floor in front of you.\n2. Keeping your chest up and shoulders back, jump up and switch your legs in the air.\n3. Land with the opposite foot under you and the other leg extended to the side. Touch the floor with the opposite hand.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 100050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 797,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'f1fd27ff89872c5e7a33558d7e03657841fd3be94caed4fbaed16c5fd00ccb51',
          file_name:
            'videos/f1fd27ff89872c5e7a33558d7e03657841fd3be94caed4fbaed16c5fd00ccb51.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f1fd27ff89872c5e7a33558d7e03657841fd3be94caed4fbaed16c5fd00ccb51.mp4',
          name: 'BEG-INT-ADV-Touchdowns-EXERCISE.mp4',
          description: null,
          size: 114156,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 798,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'c5e74b7ff6c3ca47905680a00746e94c6f31d8a89ac6037a3483582f3d7c10dd',
          file_name:
            'audios/c5e74b7ff6c3ca47905680a00746e94c6f31d8a89ac6037a3483582f3d7c10dd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c5e74b7ff6c3ca47905680a00746e94c6f31d8a89ac6037a3483582f3d7c10dd.mp3',
          name: 'BEG-INT-ADV-Touchdowns-EXERCISE.mp3',
          description: null,
          size: 25470,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Alternating_Resistance_Band_Bicep_Curl-EXERCISE': {
      id: 366,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Alternating Resistance Band Bicep Curl',
      short_name: 'Alternating Band Bicep Curl',
      unique_name:
        'INTERMEDIATE-Alternating_Resistance_Band_Bicep_Curl-EXERCISE',
      description:
        '1. Stand in the center of a resistance band with your feet roughly hip-width apart. Hold one handle in each hand down by your sides, palms facing out.\r\n2. Keeping your elbows close to your ribcage, curl one hand up toward your shoulder.\r\n3. Lower the band back to start position.\r\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 809,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '9f06a436b0d14edfb31be3027b3478f82b57779e3e0d11bcccf200032548242c',
          file_name:
            'videos/9f06a436b0d14edfb31be3027b3478f82b57779e3e0d11bcccf200032548242c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9f06a436b0d14edfb31be3027b3478f82b57779e3e0d11bcccf200032548242c.mp4',
          name: 'INT-ADV-Alternating_Resistance_Band_Bicep_Curl-EXERCISE.mp4',
          description: null,
          size: 69026,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 810,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '207da11cef967f4c6fc5082729ad2ae8420eb79da88f8e56c9bddf1c38f1381a',
          file_name:
            'audios/207da11cef967f4c6fc5082729ad2ae8420eb79da88f8e56c9bddf1c38f1381a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/207da11cef967f4c6fc5082729ad2ae8420eb79da88f8e56c9bddf1c38f1381a.mp3',
          name: 'INT-ADV-Alternating_Resistance_Band_Bicep_Curl-EXERCISE.mp3',
          description: null,
          size: 61060,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Alternating_Resistance_Band_Bicep_Curl-EXERCISE': {
      id: 367,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Alternating Resistance Band Bicep Curl',
      short_name: 'Alternating Band Bicep Curl',
      unique_name: 'ADVANCED-Alternating_Resistance_Band_Bicep_Curl-EXERCISE',
      description:
        '1. Stand in the center of a resistance band with your feet roughly hip-width apart. Hold one handle in each hand down by your sides, palms facing out.\r\n2. Keeping your elbows close to your ribcage, curl one hand up toward your shoulder.\r\n3. Lower the band back to start position.\r\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 811,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '9f06a436b0d14edfb31be3027b3478f82b57779e3e0d11bcccf200032548242c',
          file_name:
            'videos/9f06a436b0d14edfb31be3027b3478f82b57779e3e0d11bcccf200032548242c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9f06a436b0d14edfb31be3027b3478f82b57779e3e0d11bcccf200032548242c.mp4',
          name: 'INT-ADV-Alternating_Resistance_Band_Bicep_Curl-EXERCISE.mp4',
          description: null,
          size: 69026,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 812,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '207da11cef967f4c6fc5082729ad2ae8420eb79da88f8e56c9bddf1c38f1381a',
          file_name:
            'audios/207da11cef967f4c6fc5082729ad2ae8420eb79da88f8e56c9bddf1c38f1381a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/207da11cef967f4c6fc5082729ad2ae8420eb79da88f8e56c9bddf1c38f1381a.mp3',
          name: 'INT-ADV-Alternating_Resistance_Band_Bicep_Curl-EXERCISE.mp3',
          description: null,
          size: 61060,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Hamstring_Roll-Outs-EXERCISE': {
      id: 368,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Hamstring Roll-Outs',
      short_name: 'Hamstring Roll-Outs',
      unique_name: 'INTERMEDIATE-Hamstring_Roll-Outs-EXERCISE',
      description:
        '1. Lie on the floor and put your heels on top of a stability ball. Legs straight, arms by your sides at a 45 degree angle, palms facing down.\r\n2. Lift your hips up, keeping your shoulders and head on the floor.\r\n3. Bend both knees and curl the ball toward your hips with your feet. Keep core engaged and hips as high as possible.\r\n4. Straighten both legs and roll the ball back out to return to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 813,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '08aa2b4f89a16fb392f3ab5f400fd29323d7a09eb8b834629ffef3d17ec0ab98',
          file_name:
            'videos/08aa2b4f89a16fb392f3ab5f400fd29323d7a09eb8b834629ffef3d17ec0ab98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/08aa2b4f89a16fb392f3ab5f400fd29323d7a09eb8b834629ffef3d17ec0ab98.mp4',
          name: 'INT-ADV-Hamstring_Roll-Outs-EXERCISE.mp4',
          description: null,
          size: 91237,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 814,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '457f2077b4dec9e40dcb4dd32aa16efede227641723f16b06a7803e08aba7a2a',
          file_name:
            'audios/457f2077b4dec9e40dcb4dd32aa16efede227641723f16b06a7803e08aba7a2a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/457f2077b4dec9e40dcb4dd32aa16efede227641723f16b06a7803e08aba7a2a.mp3',
          name: 'INT-ADV-Hamstring_Roll-Outs-EXERCISE.mp3',
          description: null,
          size: 31056,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Hamstring_Roll-Outs-EXERCISE': {
      id: 369,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Hamstring Roll-Outs',
      short_name: 'Hamstring Roll-Outs',
      unique_name: 'ADVANCED-Hamstring_Roll-Outs-EXERCISE',
      description:
        '1. Lie on the floor and put your heels on top of a stability ball. Legs straight, arms by your sides at a 45 degree angle, palms facing down.\r\n2. Lift your hips up, keeping your shoulders and head on the floor.\r\n3. Bend both knees and curl the ball toward your hips with your feet. Keep core engaged and hips as high as possible.\r\n4. Straighten both legs and roll the ball back out to return to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 815,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '08aa2b4f89a16fb392f3ab5f400fd29323d7a09eb8b834629ffef3d17ec0ab98',
          file_name:
            'videos/08aa2b4f89a16fb392f3ab5f400fd29323d7a09eb8b834629ffef3d17ec0ab98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/08aa2b4f89a16fb392f3ab5f400fd29323d7a09eb8b834629ffef3d17ec0ab98.mp4',
          name: 'INT-ADV-Hamstring_Roll-Outs-EXERCISE.mp4',
          description: null,
          size: 91237,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 816,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '457f2077b4dec9e40dcb4dd32aa16efede227641723f16b06a7803e08aba7a2a',
          file_name:
            'audios/457f2077b4dec9e40dcb4dd32aa16efede227641723f16b06a7803e08aba7a2a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/457f2077b4dec9e40dcb4dd32aa16efede227641723f16b06a7803e08aba7a2a.mp3',
          name: 'INT-ADV-Hamstring_Roll-Outs-EXERCISE.mp3',
          description: null,
          size: 31056,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Resistance_Band_Bicep_Curl-EXERCISE': {
      id: 370,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Bicep Curl',
      short_name: 'Resistance Band Bicep Curl',
      unique_name: 'INTERMEDIATE-Resistance_Band_Bicep_Curl-EXERCISE',
      description:
        '1. Stand in the center of a resistance band with your feet about hip-width apart. Hold one handle in each hand down by your sides, palms facing out.\r\n2. Keeping your elbows close to your ribcage, curl both handles up toward your shoulders.\r\n3. Lower back to starting position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 817,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: 'ddff7556f09803f952280304e27bd86133346e9848fd29cbbc428d770565f502',
          file_name:
            'videos/ddff7556f09803f952280304e27bd86133346e9848fd29cbbc428d770565f502.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ddff7556f09803f952280304e27bd86133346e9848fd29cbbc428d770565f502.mp4',
          name: 'INT-ADV-Resistance_Band_Bicep_Curl-EXERCISE.mp4',
          description: null,
          size: 78287,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 818,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '4616d2867b910c3d59c7556be048478b6c856898bf669d1491d762712444279a',
          file_name:
            'audios/4616d2867b910c3d59c7556be048478b6c856898bf669d1491d762712444279a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4616d2867b910c3d59c7556be048478b6c856898bf669d1491d762712444279a.mp3',
          name: 'INT-ADV-Resistance_Band_Bicep_Curl-EXERCISE.mp3',
          description: null,
          size: 42762,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Resistance_Band_Bicep_Curl-EXERCISE': {
      id: 371,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Bicep Curl',
      short_name: 'Resistance Band Bicep Curl',
      unique_name: 'ADVANCED-Resistance_Band_Bicep_Curl-EXERCISE',
      description:
        '1. Stand in the center of a resistance band with your feet about hip-width apart. Hold one handle in each hand down by your sides, palms facing out.\r\n2. Keeping your elbows close to your ribcage, curl both handles up toward your shoulders.\r\n3. Lower back to starting position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 819,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: 'ddff7556f09803f952280304e27bd86133346e9848fd29cbbc428d770565f502',
          file_name:
            'videos/ddff7556f09803f952280304e27bd86133346e9848fd29cbbc428d770565f502.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ddff7556f09803f952280304e27bd86133346e9848fd29cbbc428d770565f502.mp4',
          name: 'INT-ADV-Resistance_Band_Bicep_Curl-EXERCISE.mp4',
          description: null,
          size: 78287,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 820,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '4616d2867b910c3d59c7556be048478b6c856898bf669d1491d762712444279a',
          file_name:
            'audios/4616d2867b910c3d59c7556be048478b6c856898bf669d1491d762712444279a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4616d2867b910c3d59c7556be048478b6c856898bf669d1491d762712444279a.mp3',
          name: 'INT-ADV-Resistance_Band_Bicep_Curl-EXERCISE.mp3',
          description: null,
          size: 42762,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Resistance_Band_Lunge_with_Press-EXERCISE': {
      id: 372,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Lunge with Press',
      short_name: 'Resistance Band Lunge with Press',
      unique_name: 'INTERMEDIATE-Resistance_Band_Lunge_with_Press-EXERCISE',
      description:
        '1. Stand in the center of a band with one foot, holding the handles at your shoulders. Take a big step backward with your other leg and elevate your heel.\r\n2. Drop your hips toward the floor by bending both knees to 90 degrees. Front knee should be directly over your ankle and back knee near the floor.\r\n3. Drive through your heel to straighten your legs as you press the resistance band toward the ceiling.\r\n                4. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 821,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '70907d9c4463b225f54b49b577205a27e1bcf041869388c8e95a4338fbc2afde',
          file_name:
            'videos/70907d9c4463b225f54b49b577205a27e1bcf041869388c8e95a4338fbc2afde.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/70907d9c4463b225f54b49b577205a27e1bcf041869388c8e95a4338fbc2afde.mp4',
          name: 'INT-ADV-Resistance_Band_Lunge_with_Press-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 136574,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 822,
          collection_name: 'videos',
          order: 2,
          version: 100070000,
          hash: '6c453e9a5e75bda2560e60934b4c2d2b5e55ef0b3561760d2f567f2000c88468',
          file_name:
            'videos/6c453e9a5e75bda2560e60934b4c2d2b5e55ef0b3561760d2f567f2000c88468.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6c453e9a5e75bda2560e60934b4c2d2b5e55ef0b3561760d2f567f2000c88468.mp4',
          name: 'INT-ADV-Resistance_Band_Lunge_with_Press-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 148954,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 823,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '8abd6b96423d4efda12e0ea24d7831244b5085a15ee50c1620eec34cfa2e34f7',
          file_name:
            'audios/8abd6b96423d4efda12e0ea24d7831244b5085a15ee50c1620eec34cfa2e34f7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8abd6b96423d4efda12e0ea24d7831244b5085a15ee50c1620eec34cfa2e34f7.mp3',
          name: 'INT-ADV-Resistance_Band_Lunge_with_Press-EXERCISE.mp3',
          description: null,
          size: 43676,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Resistance_Band_Lunge_with_Press-EXERCISE': {
      id: 373,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Lunge with Press',
      short_name: 'Resistance Band Lunge with Press',
      unique_name: 'ADVANCED-Resistance_Band_Lunge_with_Press-EXERCISE',
      description:
        '1. Stand in the center of a band with one foot, holding the handles at your shoulders. Take a big step backward with your other leg and elevate your heel.\r\n2. Drop your hips toward the floor by bending both knees to 90 degrees. Front knee should be directly over your ankle and back knee near the floor.\r\n3. Drive through your heel to straighten your legs as you press the resistance band toward the ceiling.\r\n                4. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 824,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '70907d9c4463b225f54b49b577205a27e1bcf041869388c8e95a4338fbc2afde',
          file_name:
            'videos/70907d9c4463b225f54b49b577205a27e1bcf041869388c8e95a4338fbc2afde.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/70907d9c4463b225f54b49b577205a27e1bcf041869388c8e95a4338fbc2afde.mp4',
          name: 'INT-ADV-Resistance_Band_Lunge_with_Press-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 136574,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 825,
          collection_name: 'videos',
          order: 2,
          version: 100070000,
          hash: '6c453e9a5e75bda2560e60934b4c2d2b5e55ef0b3561760d2f567f2000c88468',
          file_name:
            'videos/6c453e9a5e75bda2560e60934b4c2d2b5e55ef0b3561760d2f567f2000c88468.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6c453e9a5e75bda2560e60934b4c2d2b5e55ef0b3561760d2f567f2000c88468.mp4',
          name: 'INT-ADV-Resistance_Band_Lunge_with_Press-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 148954,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 826,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '8abd6b96423d4efda12e0ea24d7831244b5085a15ee50c1620eec34cfa2e34f7',
          file_name:
            'audios/8abd6b96423d4efda12e0ea24d7831244b5085a15ee50c1620eec34cfa2e34f7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8abd6b96423d4efda12e0ea24d7831244b5085a15ee50c1620eec34cfa2e34f7.mp3',
          name: 'INT-ADV-Resistance_Band_Lunge_with_Press-EXERCISE.mp3',
          description: null,
          size: 43676,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Resistance_Band_Squats-EXERCISE': {
      id: 374,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Resistance Band Squats',
      short_name: 'Resistance Band Squats',
      unique_name: 'INTERMEDIATE-Resistance_Band_Squats-EXERCISE',
      description:
        '1. Stand on top of a resistance band with your feet about shoulder-width apart, holding the handles at shoulder height.\r\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\r\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 827,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '30e0a7dc147332426af62280f84c737f7e3a0e742c8c75b0ebdcf6b855044937',
          file_name:
            'videos/30e0a7dc147332426af62280f84c737f7e3a0e742c8c75b0ebdcf6b855044937.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/30e0a7dc147332426af62280f84c737f7e3a0e742c8c75b0ebdcf6b855044937.mp4',
          name: 'INT-ADV-Resistance_Band_Squats-EXERCISE.mp4',
          description: null,
          size: 96835,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 828,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '793db564161210d030978bb72284e71b511694e965b6a4789167f2b3f0646a26',
          file_name:
            'audios/793db564161210d030978bb72284e71b511694e965b6a4789167f2b3f0646a26.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/793db564161210d030978bb72284e71b511694e965b6a4789167f2b3f0646a26.mp3',
          name: 'INT-ADV-Resistance_Band_Squats-EXERCISE.mp3',
          description: null,
          size: 35040,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Resistance_Band_Squats-EXERCISE': {
      id: 375,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Resistance Band Squats',
      short_name: 'Resistance Band Squats',
      unique_name: 'ADVANCED-Resistance_Band_Squats-EXERCISE',
      description:
        '1. Stand on top of a resistance band with your feet about shoulder-width apart, holding the handles at shoulder height.\r\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\r\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 829,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '30e0a7dc147332426af62280f84c737f7e3a0e742c8c75b0ebdcf6b855044937',
          file_name:
            'videos/30e0a7dc147332426af62280f84c737f7e3a0e742c8c75b0ebdcf6b855044937.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/30e0a7dc147332426af62280f84c737f7e3a0e742c8c75b0ebdcf6b855044937.mp4',
          name: 'INT-ADV-Resistance_Band_Squats-EXERCISE.mp4',
          description: null,
          size: 96835,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 830,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '793db564161210d030978bb72284e71b511694e965b6a4789167f2b3f0646a26',
          file_name:
            'audios/793db564161210d030978bb72284e71b511694e965b6a4789167f2b3f0646a26.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/793db564161210d030978bb72284e71b511694e965b6a4789167f2b3f0646a26.mp3',
          name: 'INT-ADV-Resistance_Band_Squats-EXERCISE.mp3',
          description: null,
          size: 35040,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Resistance_Band_Stationary_Lunges-EXERCISE': {
      id: 376,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Resistance Band Stationary Lunges',
      short_name: 'Resistance Band Lunges',
      unique_name: 'INTERMEDIATE-Resistance_Band_Stationary_Lunges-EXERCISE',
      description:
        '1. Stand in the center of a band with one foot, holding the handles at your shoulders. Take a big step backward with your other leg and elevate your heel.\r\n2. Drop your hips toward the floor by bending both knees to 90 degrees. Front knee should be directly over your ankle and back knee near the floor.\r\n3. Drive through your heel to straighten legs.\r\n4. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 831,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: 'e3872b6722a87e6db091008cceb8b59dae2e9b9f0679069b13e4e83a2acfa09b',
          file_name:
            'videos/e3872b6722a87e6db091008cceb8b59dae2e9b9f0679069b13e4e83a2acfa09b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e3872b6722a87e6db091008cceb8b59dae2e9b9f0679069b13e4e83a2acfa09b.mp4',
          name: 'INT-ADV-Resistance_Band_Stationary_Lunges-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 104473,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 832,
          collection_name: 'videos',
          order: 2,
          version: 100070000,
          hash: '2a0d518cb20a19f81136771e45e4aed80cb9026c499ddbc616251340bb8591d8',
          file_name:
            'videos/2a0d518cb20a19f81136771e45e4aed80cb9026c499ddbc616251340bb8591d8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2a0d518cb20a19f81136771e45e4aed80cb9026c499ddbc616251340bb8591d8.mp4',
          name: 'INT-ADV-Resistance_Band_Stationary_Lunges-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 110389,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 833,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '6e2fe2969526c2c52f268480116b9532847fde84ac43f0c3e422dd897d863599',
          file_name:
            'audios/6e2fe2969526c2c52f268480116b9532847fde84ac43f0c3e422dd897d863599.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6e2fe2969526c2c52f268480116b9532847fde84ac43f0c3e422dd897d863599.mp3',
          name: 'INT-ADV-Resistance_Band_Stationary_Lunges-EXERCISE.mp3',
          description: null,
          size: 44376,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Resistance_Band_Stationary_Lunges-EXERCISE': {
      id: 377,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Resistance Band Stationary Lunges',
      short_name: 'Resistance Band Lunges',
      unique_name: 'ADVANCED-Resistance_Band_Stationary_Lunges-EXERCISE',
      description:
        '1. Stand in the center of a band with one foot, holding the handles at your shoulders. Take a big step backward with your other leg and elevate your heel.\r\n2. Drop your hips toward the floor by bending both knees to 90 degrees. Front knee should be directly over your ankle and back knee near the floor.\r\n3. Drive through your heel to straighten legs.\r\n4. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 834,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: 'e3872b6722a87e6db091008cceb8b59dae2e9b9f0679069b13e4e83a2acfa09b',
          file_name:
            'videos/e3872b6722a87e6db091008cceb8b59dae2e9b9f0679069b13e4e83a2acfa09b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e3872b6722a87e6db091008cceb8b59dae2e9b9f0679069b13e4e83a2acfa09b.mp4',
          name: 'INT-ADV-Resistance_Band_Stationary_Lunges-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 104473,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 835,
          collection_name: 'videos',
          order: 2,
          version: 100070000,
          hash: '2a0d518cb20a19f81136771e45e4aed80cb9026c499ddbc616251340bb8591d8',
          file_name:
            'videos/2a0d518cb20a19f81136771e45e4aed80cb9026c499ddbc616251340bb8591d8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2a0d518cb20a19f81136771e45e4aed80cb9026c499ddbc616251340bb8591d8.mp4',
          name: 'INT-ADV-Resistance_Band_Stationary_Lunges-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 110389,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 836,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '6e2fe2969526c2c52f268480116b9532847fde84ac43f0c3e422dd897d863599',
          file_name:
            'audios/6e2fe2969526c2c52f268480116b9532847fde84ac43f0c3e422dd897d863599.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6e2fe2969526c2c52f268480116b9532847fde84ac43f0c3e422dd897d863599.mp3',
          name: 'INT-ADV-Resistance_Band_Stationary_Lunges-EXERCISE.mp3',
          description: null,
          size: 44376,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Resistance_Band_Wide_Curl-EXERCISE': {
      id: 378,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Wide Curl',
      short_name: 'Resistance Band Wide Curl',
      unique_name: 'INTERMEDIATE-Resistance_Band_Wide_Curl-EXERCISE',
      description:
        '1. Stand in the center of a resistance band with your feet roughly hip-width apart. Hold one handle in each hand down by your sides, palms facing out.\r\n2. Keep your elbows close to your ribcage. Curl the band up and out to the side toward your shoulders.\r\n3. Lower your arms back down to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 837,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '923f427abe2dbb6fde7e3d9524e95f4fea968e739f228461f43cfd9162fb2870',
          file_name:
            'videos/923f427abe2dbb6fde7e3d9524e95f4fea968e739f228461f43cfd9162fb2870.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/923f427abe2dbb6fde7e3d9524e95f4fea968e739f228461f43cfd9162fb2870.mp4',
          name: 'INT-ADV-Resistance_Band_Wide_Curl-EXERCISE.mp4',
          description: null,
          size: 82002,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 838,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '505c20763100e32eb1f8e4cb725bd254a29b62528a1f7ef28ab7a95cc3b857e0',
          file_name:
            'audios/505c20763100e32eb1f8e4cb725bd254a29b62528a1f7ef28ab7a95cc3b857e0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/505c20763100e32eb1f8e4cb725bd254a29b62528a1f7ef28ab7a95cc3b857e0.mp3',
          name: 'INT-ADV-Resistance_Band_Wide_Curl-EXERCISE.mp3',
          description: null,
          size: 37346,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Resistance_Band_Wide_Curl-EXERCISE': {
      id: 379,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Wide Curl',
      short_name: 'Resistance Band Wide Curl',
      unique_name: 'ADVANCED-Resistance_Band_Wide_Curl-EXERCISE',
      description:
        '1. Stand in the center of a resistance band with your feet roughly hip-width apart. Hold one handle in each hand down by your sides, palms facing out.\r\n2. Keep your elbows close to your ribcage. Curl the band up and out to the side toward your shoulders.\r\n3. Lower your arms back down to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 839,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '923f427abe2dbb6fde7e3d9524e95f4fea968e739f228461f43cfd9162fb2870',
          file_name:
            'videos/923f427abe2dbb6fde7e3d9524e95f4fea968e739f228461f43cfd9162fb2870.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/923f427abe2dbb6fde7e3d9524e95f4fea968e739f228461f43cfd9162fb2870.mp4',
          name: 'INT-ADV-Resistance_Band_Wide_Curl-EXERCISE.mp4',
          description: null,
          size: 82002,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 840,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '505c20763100e32eb1f8e4cb725bd254a29b62528a1f7ef28ab7a95cc3b857e0',
          file_name:
            'audios/505c20763100e32eb1f8e4cb725bd254a29b62528a1f7ef28ab7a95cc3b857e0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/505c20763100e32eb1f8e4cb725bd254a29b62528a1f7ef28ab7a95cc3b857e0.mp3',
          name: 'INT-ADV-Resistance_Band_Wide_Curl-EXERCISE.mp3',
          description: null,
          size: 37346,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Single_Arm_Tricep_Extensions_with_Band-EXERCISE': {
      id: 380,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Single Arm Tricep Extensions with Band',
      short_name: ' Tricep Extensions with Band ',
      unique_name:
        'INTERMEDIATE-Single_Arm_Tricep_Extensions_with_Band-EXERCISE',
      description:
        '1. Stand on the band holding one side just below the handle. Adjust your feet so you can extend your arm straight overhead with appropriate tension.\r\n2. Slowly lower handle behind the back of your head until elbow is bent 90 degrees or lower, keeping elbow close to the side of your head.\r\n3. Press the band back overhead.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 841,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '7657cc11f2271739fb615898bef9b5099124685b653d7f4012e6e30cdb2c0a05',
          file_name:
            'videos/7657cc11f2271739fb615898bef9b5099124685b653d7f4012e6e30cdb2c0a05.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7657cc11f2271739fb615898bef9b5099124685b653d7f4012e6e30cdb2c0a05.mp4',
          name: 'INT-ADV-Single_Arm_Tricep_Extensions_with_Band-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 58618,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 842,
          collection_name: 'videos',
          order: 2,
          version: 100070000,
          hash: '716bf30e2f7e48ab316461b124fda25f43b17bb728d117d07c349f78ca496ef0',
          file_name:
            'videos/716bf30e2f7e48ab316461b124fda25f43b17bb728d117d07c349f78ca496ef0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/716bf30e2f7e48ab316461b124fda25f43b17bb728d117d07c349f78ca496ef0.mp4',
          name: 'INT-ADV-Single_Arm_Tricep_Extensions_with_Band-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 63006,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 843,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: 'c8cced3013240b45eee3d4be7ca3f188f9b5834d0b4dad6f4b6b3587e067f56d',
          file_name:
            'audios/c8cced3013240b45eee3d4be7ca3f188f9b5834d0b4dad6f4b6b3587e067f56d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c8cced3013240b45eee3d4be7ca3f188f9b5834d0b4dad6f4b6b3587e067f56d.mp3',
          name: 'INT-ADV-Single_Arm_Tricep_Extensions_with_Band-EXERCISE.mp3',
          description: null,
          size: 49330,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Single_Arm_Tricep_Extensions_with_Band-EXERCISE': {
      id: 381,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Single Arm Tricep Extensions with Band',
      short_name: ' Tricep Extensions with Band ',
      unique_name: 'ADVANCED-Single_Arm_Tricep_Extensions_with_Band-EXERCISE',
      description:
        '1. Stand on the band holding one side just below the handle. Adjust your feet so you can extend your arm straight overhead with appropriate tension.\r\n2. Slowly lower handle behind the back of your head until elbow is bent 90 degrees or lower, keeping elbow close to the side of your head.\r\n3. Press the band back overhead.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 5,
          name: 'Resistance Band',
          unique_name: 'RESISTANCE_BAND',
          min_app_version: 100070000,
          order: 4000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 844,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '7657cc11f2271739fb615898bef9b5099124685b653d7f4012e6e30cdb2c0a05',
          file_name:
            'videos/7657cc11f2271739fb615898bef9b5099124685b653d7f4012e6e30cdb2c0a05.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7657cc11f2271739fb615898bef9b5099124685b653d7f4012e6e30cdb2c0a05.mp4',
          name: 'INT-ADV-Single_Arm_Tricep_Extensions_with_Band-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 58618,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 845,
          collection_name: 'videos',
          order: 2,
          version: 100070000,
          hash: '716bf30e2f7e48ab316461b124fda25f43b17bb728d117d07c349f78ca496ef0',
          file_name:
            'videos/716bf30e2f7e48ab316461b124fda25f43b17bb728d117d07c349f78ca496ef0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/716bf30e2f7e48ab316461b124fda25f43b17bb728d117d07c349f78ca496ef0.mp4',
          name: 'INT-ADV-Single_Arm_Tricep_Extensions_with_Band-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 63006,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 846,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: 'c8cced3013240b45eee3d4be7ca3f188f9b5834d0b4dad6f4b6b3587e067f56d',
          file_name:
            'audios/c8cced3013240b45eee3d4be7ca3f188f9b5834d0b4dad6f4b6b3587e067f56d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c8cced3013240b45eee3d4be7ca3f188f9b5834d0b4dad6f4b6b3587e067f56d.mp3',
          name: 'INT-ADV-Single_Arm_Tricep_Extensions_with_Band-EXERCISE.mp3',
          description: null,
          size: 49330,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Single_Leg_Hamstring_Roll-Outs-EXERCISE': {
      id: 382,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Single Leg Hamstring Roll-Outs',
      short_name: 'Single Leg Hamstring Roll-Outs',
      unique_name: 'INTERMEDIATE-Single_Leg_Hamstring_Roll-Outs-EXERCISE',
      description:
        '1. Lie on the floor and put one heel on top of a stability ball and the other leg in the air. Keep both legs straight, arms by your sides at 45 degrees, palms facing down.\r\n2. Lift your hips up, keeping shoulders and head on the floor, one leg on the ball and the other one one in the air.\r\n3. With the leg that is on the ball, bend your knee and curl the ball toward your hips with your foot. Keep core engaged and hips as high as possible.\r\n4. Straighten your leg and roll the ball back out to start position.\r\n5. Perform all reps on one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 847,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: 'd2c2158b467c3ff9cb1eea37f9dd7519661cda365ef64f9b6e8d1bd805f90375',
          file_name:
            'videos/d2c2158b467c3ff9cb1eea37f9dd7519661cda365ef64f9b6e8d1bd805f90375.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d2c2158b467c3ff9cb1eea37f9dd7519661cda365ef64f9b6e8d1bd805f90375.mp4',
          name: 'INT-ADV-Single_Leg_Hamstring_Roll-Outs-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 88237,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 848,
          collection_name: 'videos',
          order: 2,
          version: 100070000,
          hash: 'cbd1009f923fc131e58f05f8d8335d605752f8b9ecab23cdb3fe5b8e950f4ee2',
          file_name:
            'videos/cbd1009f923fc131e58f05f8d8335d605752f8b9ecab23cdb3fe5b8e950f4ee2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cbd1009f923fc131e58f05f8d8335d605752f8b9ecab23cdb3fe5b8e950f4ee2.mp4',
          name: 'INT-ADV-Single_Leg_Hamstring_Roll-Outs-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 84020,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 849,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '01a097bb8bd886a8cada73023fd9138e24410f7774fd3edc03e5d9b929c02462',
          file_name:
            'audios/01a097bb8bd886a8cada73023fd9138e24410f7774fd3edc03e5d9b929c02462.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/01a097bb8bd886a8cada73023fd9138e24410f7774fd3edc03e5d9b929c02462.mp3',
          name: 'INT-ADV-Single_Leg_Hamstring_Roll-Outs-EXERCISE.mp3',
          description: null,
          size: 41944,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Single_Leg_Hamstring_Roll-Outs-EXERCISE': {
      id: 383,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Single Leg Hamstring Roll-Outs',
      short_name: 'Single Leg Hamstring Roll-Outs',
      unique_name: 'ADVANCED-Single_Leg_Hamstring_Roll-Outs-EXERCISE',
      description:
        '1. Lie on the floor and put one heel on top of a stability ball and the other leg in the air. Keep both legs straight, arms by your sides at 45 degrees, palms facing down.\r\n2. Lift your hips up, keeping shoulders and head on the floor, one leg on the ball and the other one one in the air.\r\n3. With the leg that is on the ball, bend your knee and curl the ball toward your hips with your foot. Keep core engaged and hips as high as possible.\r\n4. Straighten your leg and roll the ball back out to start position.\r\n5. Perform all reps on one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 850,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: 'd2c2158b467c3ff9cb1eea37f9dd7519661cda365ef64f9b6e8d1bd805f90375',
          file_name:
            'videos/d2c2158b467c3ff9cb1eea37f9dd7519661cda365ef64f9b6e8d1bd805f90375.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d2c2158b467c3ff9cb1eea37f9dd7519661cda365ef64f9b6e8d1bd805f90375.mp4',
          name: 'INT-ADV-Single_Leg_Hamstring_Roll-Outs-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 88237,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 851,
          collection_name: 'videos',
          order: 2,
          version: 100070000,
          hash: 'cbd1009f923fc131e58f05f8d8335d605752f8b9ecab23cdb3fe5b8e950f4ee2',
          file_name:
            'videos/cbd1009f923fc131e58f05f8d8335d605752f8b9ecab23cdb3fe5b8e950f4ee2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cbd1009f923fc131e58f05f8d8335d605752f8b9ecab23cdb3fe5b8e950f4ee2.mp4',
          name: 'INT-ADV-Single_Leg_Hamstring_Roll-Outs-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 84020,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 852,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '01a097bb8bd886a8cada73023fd9138e24410f7774fd3edc03e5d9b929c02462',
          file_name:
            'audios/01a097bb8bd886a8cada73023fd9138e24410f7774fd3edc03e5d9b929c02462.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/01a097bb8bd886a8cada73023fd9138e24410f7774fd3edc03e5d9b929c02462.mp3',
          name: 'INT-ADV-Single_Leg_Hamstring_Roll-Outs-EXERCISE.mp3',
          description: null,
          size: 41944,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Stability_Ball_Crunches-EXERCISE': {
      id: 384,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Stability Ball Crunches',
      short_name: 'Stability Ball Crunches',
      unique_name: 'INTERMEDIATE-Stability_Ball_Crunches-EXERCISE',
      description:
        '1. Lie with your back on a stability ball, knees bent and feet flat on the floor, arms crossed at your chest.\r\n2. Lift your shoulders and back off the ball to seated position.\r\n3. Lower with control back to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 853,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '412bba014e2f135b2c692e70b23b6457bc2ef08635e6f7a481202ec08c607dc6',
          file_name:
            'videos/412bba014e2f135b2c692e70b23b6457bc2ef08635e6f7a481202ec08c607dc6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/412bba014e2f135b2c692e70b23b6457bc2ef08635e6f7a481202ec08c607dc6.mp4',
          name: 'INT-ADV-Stability_Ball_Crunches-EXERCISE.mp4',
          description: null,
          size: 66385,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 854,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: 'fed3913bc1d85a2be8634e08d4d2194f1b3d491453240ed6f99f9ccfe1b0cfd8',
          file_name:
            'audios/fed3913bc1d85a2be8634e08d4d2194f1b3d491453240ed6f99f9ccfe1b0cfd8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fed3913bc1d85a2be8634e08d4d2194f1b3d491453240ed6f99f9ccfe1b0cfd8.mp3',
          name: 'INT-ADV-Stability_Ball_Crunches-EXERCISE.mp3',
          description: null,
          size: 34854,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Stability_Ball_Crunches-EXERCISE': {
      id: 385,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Stability Ball Crunches',
      short_name: 'Stability Ball Crunches',
      unique_name: 'ADVANCED-Stability_Ball_Crunches-EXERCISE',
      description:
        '1. Lie with your back on a stability ball, knees bent and feet flat on the floor, arms crossed at your chest.\r\n2. Lift your shoulders and back off the ball to seated position.\r\n3. Lower with control back to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 855,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '412bba014e2f135b2c692e70b23b6457bc2ef08635e6f7a481202ec08c607dc6',
          file_name:
            'videos/412bba014e2f135b2c692e70b23b6457bc2ef08635e6f7a481202ec08c607dc6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/412bba014e2f135b2c692e70b23b6457bc2ef08635e6f7a481202ec08c607dc6.mp4',
          name: 'INT-ADV-Stability_Ball_Crunches-EXERCISE.mp4',
          description: null,
          size: 66385,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 856,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: 'fed3913bc1d85a2be8634e08d4d2194f1b3d491453240ed6f99f9ccfe1b0cfd8',
          file_name:
            'audios/fed3913bc1d85a2be8634e08d4d2194f1b3d491453240ed6f99f9ccfe1b0cfd8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fed3913bc1d85a2be8634e08d4d2194f1b3d491453240ed6f99f9ccfe1b0cfd8.mp3',
          name: 'INT-ADV-Stability_Ball_Crunches-EXERCISE.mp3',
          description: null,
          size: 34854,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Stability_Ball_Glute_Bridge-EXERCISE': {
      id: 386,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Stability Ball Glute Bridge',
      short_name: 'Stability Ball Glute Bridge',
      unique_name: 'INTERMEDIATE-Stability_Ball_Glute_Bridge-EXERCISE',
      description:
        "1. Lie on your back with your heels on a stability ball, knees bent at 90 degrees. Keep your arms at your sides, palms facing down.\r\n2. Keeping your upper back on the floor, drive through your heels to raise your hips as high as possible without arching your back. Keep knees aligned so they don't splay out or buckle in.\r\n3. Lower with control back to start position.",
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 857,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '399a47aa064b7859f4047f1fc619ecba0dca7852b6b3792fcd321294e927f580',
          file_name:
            'videos/399a47aa064b7859f4047f1fc619ecba0dca7852b6b3792fcd321294e927f580.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/399a47aa064b7859f4047f1fc619ecba0dca7852b6b3792fcd321294e927f580.mp4',
          name: 'INT-ADV-Stability_Ball_Glute_Bridge-EXERCISE.mp4',
          description: null,
          size: 90756,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 858,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '284f34fb2c4d73480da3e7a8cd89ddb2f793ed4610f80e3dc0f25b26426812a2',
          file_name:
            'audios/284f34fb2c4d73480da3e7a8cd89ddb2f793ed4610f80e3dc0f25b26426812a2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/284f34fb2c4d73480da3e7a8cd89ddb2f793ed4610f80e3dc0f25b26426812a2.mp3',
          name: 'INT-ADV-Stability_Ball_Glute_Bridge-EXERCISE.mp3',
          description: null,
          size: 37220,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Stability_Ball_Glute_Bridge-EXERCISE': {
      id: 387,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Stability Ball Glute Bridge',
      short_name: 'Stability Ball Glute Bridge',
      unique_name: 'ADVANCED-Stability_Ball_Glute_Bridge-EXERCISE',
      description:
        "1. Lie on your back with your heels on a stability ball, knees bent at 90 degrees. Keep your arms at your sides, palms facing down.\r\n2. Keeping your upper back on the floor, drive through your heels to raise your hips as high as possible without arching your back. Keep knees aligned so they don't splay out or buckle in.\r\n3. Lower with control back to start position.",
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 859,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '399a47aa064b7859f4047f1fc619ecba0dca7852b6b3792fcd321294e927f580',
          file_name:
            'videos/399a47aa064b7859f4047f1fc619ecba0dca7852b6b3792fcd321294e927f580.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/399a47aa064b7859f4047f1fc619ecba0dca7852b6b3792fcd321294e927f580.mp4',
          name: 'INT-ADV-Stability_Ball_Glute_Bridge-EXERCISE.mp4',
          description: null,
          size: 90756,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 860,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '284f34fb2c4d73480da3e7a8cd89ddb2f793ed4610f80e3dc0f25b26426812a2',
          file_name:
            'audios/284f34fb2c4d73480da3e7a8cd89ddb2f793ed4610f80e3dc0f25b26426812a2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/284f34fb2c4d73480da3e7a8cd89ddb2f793ed4610f80e3dc0f25b26426812a2.mp3',
          name: 'INT-ADV-Stability_Ball_Glute_Bridge-EXERCISE.mp3',
          description: null,
          size: 37220,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Stability_Ball_Pass-EXERCISE': {
      id: 388,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Stability Ball Pass',
      short_name: 'Stability Ball Pass',
      unique_name: 'INTERMEDIATE-Stability_Ball_Pass-EXERCISE',
      description:
        '1. Lie on your back with your legs and arms extended holding a stability ball overhead.\r\n2. Raise your arms and legs up into the air and transfer the ball from your hands to between your shins. Squeeze legs together to secure.\r\n3. Lower your arms and legs back down to the floor.\r\n4. Raise your arms and legs back up into the air and pass the ball from your legs to your hands. Lower to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 861,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '45922bd14b239d4dc600415e6dd9be48d56d3630c908fff7fb5e6808dddd6c98',
          file_name:
            'videos/45922bd14b239d4dc600415e6dd9be48d56d3630c908fff7fb5e6808dddd6c98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/45922bd14b239d4dc600415e6dd9be48d56d3630c908fff7fb5e6808dddd6c98.mp4',
          name: 'INT-ADV-Stability_Ball_Pass-EXERCISE.mp4',
          description: null,
          size: 197832,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 862,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '12ffde7edaf6fabfe774754b32dd4d2f6832d73015ba17fba89f6fcba50fef96',
          file_name:
            'audios/12ffde7edaf6fabfe774754b32dd4d2f6832d73015ba17fba89f6fcba50fef96.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/12ffde7edaf6fabfe774754b32dd4d2f6832d73015ba17fba89f6fcba50fef96.mp3',
          name: 'INT-ADV-Stability_Ball_Pass-EXERCISE.mp3',
          description: null,
          size: 35892,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Stability_Ball_Pass-EXERCISE': {
      id: 389,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Stability Ball Pass',
      short_name: 'Stability Ball Pass',
      unique_name: 'ADVANCED-Stability_Ball_Pass-EXERCISE',
      description:
        '1. Lie on your back with your legs and arms extended holding a stability ball overhead.\r\n2. Raise your arms and legs up into the air and transfer the ball from your hands to between your shins. Squeeze legs together to secure.\r\n3. Lower your arms and legs back down to the floor.\r\n4. Raise your arms and legs back up into the air and pass the ball from your legs to your hands. Lower to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 863,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '45922bd14b239d4dc600415e6dd9be48d56d3630c908fff7fb5e6808dddd6c98',
          file_name:
            'videos/45922bd14b239d4dc600415e6dd9be48d56d3630c908fff7fb5e6808dddd6c98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/45922bd14b239d4dc600415e6dd9be48d56d3630c908fff7fb5e6808dddd6c98.mp4',
          name: 'INT-ADV-Stability_Ball_Pass-EXERCISE.mp4',
          description: null,
          size: 197832,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 864,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '12ffde7edaf6fabfe774754b32dd4d2f6832d73015ba17fba89f6fcba50fef96',
          file_name:
            'audios/12ffde7edaf6fabfe774754b32dd4d2f6832d73015ba17fba89f6fcba50fef96.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/12ffde7edaf6fabfe774754b32dd4d2f6832d73015ba17fba89f6fcba50fef96.mp3',
          name: 'INT-ADV-Stability_Ball_Pass-EXERCISE.mp3',
          description: null,
          size: 35892,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Stability_Ball_Pike-EXERCISE': {
      id: 390,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Stability Ball Pike',
      short_name: 'Stability Ball Pike',
      unique_name: 'ADVANCED-Stability_Ball_Pike-EXERCISE',
      description:
        '1. Start in Plank position with your hands on the floor, shoulders over wrist and both of your shins on top of a stability ball.\r\n2. Keeping your legs straight, use your core and lift your hips up as high as possible, rolling the ball toward your hands. Your arms remain straight and your head drops so your ears are in line with the pits of elbows.\r\n3. Drop your hips and roll the ball back to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 865,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '401341d1b67764f241f4971fd9eb6e03d0881dc31b3244b25fcc6e9e514623f2',
          file_name:
            'videos/401341d1b67764f241f4971fd9eb6e03d0881dc31b3244b25fcc6e9e514623f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/401341d1b67764f241f4971fd9eb6e03d0881dc31b3244b25fcc6e9e514623f2.mp4',
          name: 'ADVANCED-Stability_Ball_Pike-EXERCISE.mp4',
          description: null,
          size: 118536,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 866,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '238a2832c4856ebd0ec906fe942713897ac487f09f2daee0a24f45c5bc3220c1',
          file_name:
            'audios/238a2832c4856ebd0ec906fe942713897ac487f09f2daee0a24f45c5bc3220c1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/238a2832c4856ebd0ec906fe942713897ac487f09f2daee0a24f45c5bc3220c1.mp3',
          name: 'ADVANCED-Stability_Ball_Pike-EXERCISE.mp3',
          description: null,
          size: 32900,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Stability_Ball_Single_Leg_Glute_Bridge-EXERCISE': {
      id: 391,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Stability Ball Single Leg Glute Bridge',
      short_name: 'Stability Ball Single Leg Glute Bridge',
      unique_name: 'ADVANCED-Stability_Ball_Single_Leg_Glute_Bridge-EXERCISE',
      description:
        '1. Lie on your back with one heel on a stability ball, knee bent at 90 degrees. Raise the other leg up in the air. Keep your arms at your sides, palms down.\r\n2. Keeping your upper back on the floor, drive through your heel on the ball to raise your hips and opposite leg as high as possible.\r\n3. Lower back to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 867,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: 'bee0999b79ec35f6be346c99a37e0b1d44e24afb5912cf33a2d79e36552226c4',
          file_name:
            'videos/bee0999b79ec35f6be346c99a37e0b1d44e24afb5912cf33a2d79e36552226c4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bee0999b79ec35f6be346c99a37e0b1d44e24afb5912cf33a2d79e36552226c4.mp4',
          name: 'ADVANCED-Stability_Ball_Single_Leg_Glute_Bridge-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 84571,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 868,
          collection_name: 'videos',
          order: 2,
          version: 100070000,
          hash: '23d60f0c59e32b6f5759a6c940f9487148e35fbadb5140deaeb5696e9642bd14',
          file_name:
            'videos/23d60f0c59e32b6f5759a6c940f9487148e35fbadb5140deaeb5696e9642bd14.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/23d60f0c59e32b6f5759a6c940f9487148e35fbadb5140deaeb5696e9642bd14.mp4',
          name: 'ADVANCED-Stability_Ball_Single_Leg_Glute_Bridge-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 85257,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 869,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '3666c8008fc49e2595ab6f3099cf0480e10665787d9bd728cd7d3fca01dca5d7',
          file_name:
            'audios/3666c8008fc49e2595ab6f3099cf0480e10665787d9bd728cd7d3fca01dca5d7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3666c8008fc49e2595ab6f3099cf0480e10665787d9bd728cd7d3fca01dca5d7.mp3',
          name: 'ADVANCED-Stability_Ball_Single_Leg_Glute_Bridge-EXERCISE.mp3',
          description: null,
          size: 46264,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Stability_Ball_Sit-Ups-EXERCISE': {
      id: 392,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Stability Ball Sit-Ups',
      short_name: 'Stability Ball Sit-Ups',
      unique_name: 'INTERMEDIATE-Stability_Ball_Sit-Ups-EXERCISE',
      description:
        '1. Lie with your back on a stability ball, knees bent and feet flat on the floor, hands behind your head, elbows out.\r\n2. Lift shoulders and back up to seated position.\r\n3. Slowly return to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 870,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '820710e53fa19de3bc47f01824a4dfa42b5fd73389ce04ad251c154fdc447ffb',
          file_name:
            'videos/820710e53fa19de3bc47f01824a4dfa42b5fd73389ce04ad251c154fdc447ffb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/820710e53fa19de3bc47f01824a4dfa42b5fd73389ce04ad251c154fdc447ffb.mp4',
          name: 'INT-ADV-Stability_Ball_Sit-Ups-EXERCISE.mp4',
          description: null,
          size: 117589,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 871,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '2c245446e4d8963b478c4a21bdecd666713f152ac74484ffb561a18396c2aa03',
          file_name:
            'audios/2c245446e4d8963b478c4a21bdecd666713f152ac74484ffb561a18396c2aa03.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2c245446e4d8963b478c4a21bdecd666713f152ac74484ffb561a18396c2aa03.mp3',
          name: 'INT-ADV-Stability_Ball_Sit-Ups-EXERCISE.mp3',
          description: null,
          size: 33474,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Stability_Ball_Sit-Ups-EXERCISE': {
      id: 393,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Stability Ball Sit-Ups',
      short_name: 'Stability Ball Sit-Ups',
      unique_name: 'ADVANCED-Stability_Ball_Sit-Ups-EXERCISE',
      description:
        '1. Lie with your back on a stability ball, knees bent and feet flat on the floor, hands behind your head, elbows out.\r\n2. Lift shoulders and back up to seated position.\r\n3. Slowly return to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 872,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '820710e53fa19de3bc47f01824a4dfa42b5fd73389ce04ad251c154fdc447ffb',
          file_name:
            'videos/820710e53fa19de3bc47f01824a4dfa42b5fd73389ce04ad251c154fdc447ffb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/820710e53fa19de3bc47f01824a4dfa42b5fd73389ce04ad251c154fdc447ffb.mp4',
          name: 'INT-ADV-Stability_Ball_Sit-Ups-EXERCISE.mp4',
          description: null,
          size: 117589,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 873,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '2c245446e4d8963b478c4a21bdecd666713f152ac74484ffb561a18396c2aa03',
          file_name:
            'audios/2c245446e4d8963b478c4a21bdecd666713f152ac74484ffb561a18396c2aa03.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2c245446e4d8963b478c4a21bdecd666713f152ac74484ffb561a18396c2aa03.mp3',
          name: 'INT-ADV-Stability_Ball_Sit-Ups-EXERCISE.mp3',
          description: null,
          size: 33474,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Stability_Ball_Tucks-EXERCISE': {
      id: 394,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Stability Ball Tucks',
      short_name: 'Stability Ball Tucks',
      unique_name: 'INTERMEDIATE-Stability_Ball_Tucks-EXERCISE',
      description:
        '1. Start in Plank position with your hands on the floor, shoulders over wrists and both of your shins on top of a stability ball.\r\n2. Using your core, bend both knees and roll the ball toward your hands. Keep your arms straight.\r\n3. Straighten your legs and roll the ball back to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 874,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '3da13c193638e16769a750edc4b961c71d8a2138028137b9d99c68c6c758a4df',
          file_name:
            'videos/3da13c193638e16769a750edc4b961c71d8a2138028137b9d99c68c6c758a4df.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3da13c193638e16769a750edc4b961c71d8a2138028137b9d99c68c6c758a4df.mp4',
          name: 'INT-ADV-Stability_Ball_Tucks-EXERCISE.mp4',
          description: null,
          size: 86553,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 875,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '1c78482fc51d1b4a709b9835d38a05849d028c7dc0bf212e7f094b899a5f7648',
          file_name:
            'audios/1c78482fc51d1b4a709b9835d38a05849d028c7dc0bf212e7f094b899a5f7648.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1c78482fc51d1b4a709b9835d38a05849d028c7dc0bf212e7f094b899a5f7648.mp3',
          name: 'INT-ADV-Stability_Ball_Tucks-EXERCISE.mp3',
          description: null,
          size: 32474,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Stability_Ball_Tucks-EXERCISE': {
      id: 395,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Stability Ball Tucks',
      short_name: 'Stability Ball Tucks',
      unique_name: 'ADVANCED-Stability_Ball_Tucks-EXERCISE',
      description:
        '1. Start in Plank position with your hands on the floor, shoulders over wrists and both of your shins on top of a stability ball.\r\n2. Using your core, bend both knees and roll the ball toward your hands. Keep your arms straight.\r\n3. Straighten your legs and roll the ball back to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 876,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '3da13c193638e16769a750edc4b961c71d8a2138028137b9d99c68c6c758a4df',
          file_name:
            'videos/3da13c193638e16769a750edc4b961c71d8a2138028137b9d99c68c6c758a4df.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3da13c193638e16769a750edc4b961c71d8a2138028137b9d99c68c6c758a4df.mp4',
          name: 'INT-ADV-Stability_Ball_Tucks-EXERCISE.mp4',
          description: null,
          size: 86553,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 877,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '1c78482fc51d1b4a709b9835d38a05849d028c7dc0bf212e7f094b899a5f7648',
          file_name:
            'audios/1c78482fc51d1b4a709b9835d38a05849d028c7dc0bf212e7f094b899a5f7648.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1c78482fc51d1b4a709b9835d38a05849d028c7dc0bf212e7f094b899a5f7648.mp3',
          name: 'INT-ADV-Stability_Ball_Tucks-EXERCISE.mp3',
          description: null,
          size: 32474,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Wall_Diamond_Push-Ups-EXERCISE': {
      id: 396,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Wall Diamond Push-Ups',
      short_name: 'Wall Diamond Push-Ups',
      unique_name: 'BEGINNER-Wall_Diamond_Push-Ups-EXERCISE',
      description:
        '1. Place your palms on a door or wall at chest height in the shape of a diamond. Keep your arms straight.\r\n2. Walk back slightly so your body is at an angle toward the door.\r\n3. Bend your elbows, pointing them back toward your hips. Lower your body toward the door so the center of your chest meets the center of the diamond.\r\n4. Straighten your arms and raise your body back up to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 878,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '942648891c436b13d37ac9917196ad9ca67ff34c0c3b3663c5de2e38f7a59ce9',
          file_name:
            'videos/942648891c436b13d37ac9917196ad9ca67ff34c0c3b3663c5de2e38f7a59ce9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/942648891c436b13d37ac9917196ad9ca67ff34c0c3b3663c5de2e38f7a59ce9.mp4',
          name: 'BEGINNER-Wall_Diamond_Push-Ups-EXERCISE.mp4',
          description: null,
          size: 77434,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 879,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: 'cb8f1d1b8efdc9c46279e41df0b13662a6619e161c599f32881f4c8a99cc5ef4',
          file_name:
            'audios/cb8f1d1b8efdc9c46279e41df0b13662a6619e161c599f32881f4c8a99cc5ef4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cb8f1d1b8efdc9c46279e41df0b13662a6619e161c599f32881f4c8a99cc5ef4.mp3',
          name: 'BEGINNER-Wall_Diamond_Push-Ups-EXERCISE.mp3',
          description: null,
          size: 33542,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Wall_Push-Ups-EXERCISE': {
      id: 397,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Wall Push-Ups',
      short_name: 'Wall Push-Ups',
      unique_name: 'BEGINNER-Wall_Push-Ups-EXERCISE',
      description:
        '1. Place your palms on a door or wall at chest height, about shoulder-width apart. Keep your arms straight.\r\n2. Walk back slightly so your body is at an angle toward the door.\r\n3. Bend your elbows, pointing them back toward your hips. Lower your body until your chest is close to the door.\r\n4. Straighten your arms and raise your body back up to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 880,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: 'f8a88e5d3570edd7f301e515aa66c5ebc1e927b6d2da78e1ba75e4b5b1060216',
          file_name:
            'videos/f8a88e5d3570edd7f301e515aa66c5ebc1e927b6d2da78e1ba75e4b5b1060216.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f8a88e5d3570edd7f301e515aa66c5ebc1e927b6d2da78e1ba75e4b5b1060216.mp4',
          name: 'BEGINNER-Wall_Push-Ups-EXERCISE.mp4',
          description: null,
          size: 74088,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 881,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '57a58959905606349b6041770809a7d1395070a7d069eea7859a90f8957fbd15',
          file_name:
            'audios/57a58959905606349b6041770809a7d1395070a7d069eea7859a90f8957fbd15.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/57a58959905606349b6041770809a7d1395070a7d069eea7859a90f8957fbd15.mp3',
          name: 'BEGINNER-Wall_Push-Ups-EXERCISE.mp3',
          description: null,
          size: 27204,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Wide_Wall_Push-Ups-EXERCISE': {
      id: 398,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Wide Wall Push-Ups',
      short_name: 'Wide Wall Push-Ups',
      unique_name: 'BEGINNER-Wide_Wall_Push-Ups-EXERCISE',
      description:
        '1. Place your palms on a door or wall at chest height, wider than shoulder-width apart. Keep your arms straight.\r\n2. Walk back slightly so your body is at an angle toward the door.\r\n3. Bend your elbows out to the side and point them back toward your hips. Lower your body until your chest is close to the door.\r\n4. Straighten your arms and raise your body back up to start position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 882,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '1b96422d2892ccbac8a8a477a92cf8e8b571edd40c6011a7fa2d564873628e41',
          file_name:
            'videos/1b96422d2892ccbac8a8a477a92cf8e8b571edd40c6011a7fa2d564873628e41.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1b96422d2892ccbac8a8a477a92cf8e8b571edd40c6011a7fa2d564873628e41.mp4',
          name: 'BEGINNER-Wide_Wall_Push-Ups-EXERCISE.mp4',
          description: null,
          size: 69168,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 883,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '647a877a76341a0bf415e85920c09e758125107f424f993067999701cfa892dd',
          file_name:
            'audios/647a877a76341a0bf415e85920c09e758125107f424f993067999701cfa892dd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/647a877a76341a0bf415e85920c09e758125107f424f993067999701cfa892dd.mp3',
          name: 'BEGINNER-Wide_Wall_Push-Ups-EXERCISE.mp3',
          description: null,
          size: 32102,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Door_Rows-EXERCISE': {
      id: 399,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Door Rows',
      short_name: 'Door Rows',
      unique_name: 'BEGINNER-Door_Rows-EXERCISE',
      description:
        '1. Facing an open and secure door, grab the door knob with both hands.\r\n2. Walk backwards until your arms are fully extended. Step forward so you can lean back.\r\n3. Shrug your shoulders down and back, bend your elbows and row your body toward the door until your wrists meet the bottom of your ribcage.\r\n4. Straighten your arms and lower your body slow and with control until your arms are extended.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 807,
          collection_name: 'videos',
          order: 1,
          version: 100070000,
          hash: '768b3732940d32d541569af454ea38c67910c85226b099c79afda39cb7b2297f',
          file_name:
            'videos/768b3732940d32d541569af454ea38c67910c85226b099c79afda39cb7b2297f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/768b3732940d32d541569af454ea38c67910c85226b099c79afda39cb7b2297f.mp4',
          name: 'BEGINNER-Door_Rows-EXERCISE.mp4',
          description: null,
          size: 74720,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 808,
          collection_name: 'audios',
          order: 1,
          version: 100070000,
          hash: '22a9b61dee624271707ede6a7ccb46b7f87b04a3815c6d45b62bcc41133772c7',
          file_name:
            'audios/22a9b61dee624271707ede6a7ccb46b7f87b04a3815c6d45b62bcc41133772c7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/22a9b61dee624271707ede6a7ccb46b7f87b04a3815c6d45b62bcc41133772c7.mp3',
          name: 'BEGINNER-Door_Rows-EXERCISE.mp3',
          description: null,
          size: 25072,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Glute_Bridges_on_Toes-EXERCISE': {
      id: 400,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Glute Bridges on Toes',
      short_name: 'Glute Bridges on Toes',
      unique_name: 'INTERMEDIATE-Glute_Bridges_on_Toes-EXERCISE',
      description:
        "1. Lay on your back with your knees bent, feet hip-width apart. Keep your arms at your sides, palms down and lift your heels keeping your toes on the floor.\r\n2. Keep your upper back on the floor and drive through your toes to raise your hips as high as possible without arching your back. Keep knees aligned so they don't splay out or buckle in.\r\n3. Lower with control back to start position.",
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 884,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '8438d91a44e40291ad1c96956b7a850dad6dbfb2172f1587a5eaeab10de1c2f4',
          file_name:
            'videos/8438d91a44e40291ad1c96956b7a850dad6dbfb2172f1587a5eaeab10de1c2f4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8438d91a44e40291ad1c96956b7a850dad6dbfb2172f1587a5eaeab10de1c2f4.mp4',
          name: 'BEGINNER-Glute_Bridges_on_Toes-EXERCISE.mp4',
          description: null,
          size: 57230,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 885,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '0ab55bb4ce92244a2c9f393b633c1474ecb882fc37b1aa73b32cfe5761bbdf4b',
          file_name:
            'audios/0ab55bb4ce92244a2c9f393b633c1474ecb882fc37b1aa73b32cfe5761bbdf4b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0ab55bb4ce92244a2c9f393b633c1474ecb882fc37b1aa73b32cfe5761bbdf4b.mp3',
          name: 'BEGINNER-Glute_Bridges_on_Toes-EXERCISE.mp3',
          description: null,
          size: 37220,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Glute_Bridges_on_Toes-EXERCISE': {
      id: 401,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Glute Bridges on Toes',
      short_name: 'Glute Bridges on Toes',
      unique_name: 'ADVANCED-Glute_Bridges_on_Toes-EXERCISE',
      description:
        "1. Lay on your back with your knees bent, feet hip-width apart. Keep your arms at your sides, palms down and lift your heels keeping your toes on the floor.\r\n2. Keep your upper back on the floor and drive through your toes to raise your hips as high as possible without arching your back. Keep knees aligned so they don't splay out or buckle in.\r\n3. Lower with control back to start position.",
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 886,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '8438d91a44e40291ad1c96956b7a850dad6dbfb2172f1587a5eaeab10de1c2f4',
          file_name:
            'videos/8438d91a44e40291ad1c96956b7a850dad6dbfb2172f1587a5eaeab10de1c2f4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8438d91a44e40291ad1c96956b7a850dad6dbfb2172f1587a5eaeab10de1c2f4.mp4',
          name: 'BEGINNER-Glute_Bridges_on_Toes-EXERCISE.mp4',
          description: null,
          size: 57230,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 887,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '0ab55bb4ce92244a2c9f393b633c1474ecb882fc37b1aa73b32cfe5761bbdf4b',
          file_name:
            'audios/0ab55bb4ce92244a2c9f393b633c1474ecb882fc37b1aa73b32cfe5761bbdf4b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0ab55bb4ce92244a2c9f393b633c1474ecb882fc37b1aa73b32cfe5761bbdf4b.mp3',
          name: 'BEGINNER-Glute_Bridges_on_Toes-EXERCISE.mp3',
          description: null,
          size: 37220,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Hamstring_Walkouts-EXERCISE': {
      id: 402,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Hamstring Walkouts',
      short_name: 'Hamstring Walkouts',
      unique_name: 'INTERMEDIATE-Hamstring_Walkouts-EXERCISE',
      description:
        "1. Lay on your back with knees bent, feet hip-width apart. Keep arms at your sides, palms down. Drive through your heels to lift your hips off the floor. Keep knees aligned so they don't splay out or buckle in.\r\n2. Keep your upper back on the floor and take a step forward with one foot and then the other. Keep your hips up as high as possible.\r\n3. Step your feet back in one at a time to start position.",
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 888,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '8fc45953ec0775242ac46862a16487f4aff1bf5bbe6c105004919ec243e840c1',
          file_name:
            'videos/8fc45953ec0775242ac46862a16487f4aff1bf5bbe6c105004919ec243e840c1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8fc45953ec0775242ac46862a16487f4aff1bf5bbe6c105004919ec243e840c1.mp4',
          name: 'BEGINNER-Hamstring_Walkouts-EXERCISE.mp4',
          description: null,
          size: 140498,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 889,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '244fd0856150559364822bbe9eb1a06ebe89a135f34a85fd2d8511dc370a45bf',
          file_name:
            'audios/244fd0856150559364822bbe9eb1a06ebe89a135f34a85fd2d8511dc370a45bf.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/244fd0856150559364822bbe9eb1a06ebe89a135f34a85fd2d8511dc370a45bf.mp3',
          name: 'BEGINNER-Hamstring_Walkouts-EXERCISE.mp3',
          description: null,
          size: 32008,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Hamstring_Walkouts-EXERCISE': {
      id: 403,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Hamstring Walkouts',
      short_name: 'Hamstring Walkouts',
      unique_name: 'ADVANCED-Hamstring_Walkouts-EXERCISE',
      description:
        "1. Lay on your back with knees bent, feet hip-width apart. Keep arms at your sides, palms down. Drive through your heels to lift your hips off the floor. Keep knees aligned so they don't splay out or buckle in.\r\n2. Keep your upper back on the floor and take a step forward with one foot and then the other. Keep your hips up as high as possible.\r\n3. Step your feet back in one at a time to start position.",
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 890,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '8fc45953ec0775242ac46862a16487f4aff1bf5bbe6c105004919ec243e840c1',
          file_name:
            'videos/8fc45953ec0775242ac46862a16487f4aff1bf5bbe6c105004919ec243e840c1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8fc45953ec0775242ac46862a16487f4aff1bf5bbe6c105004919ec243e840c1.mp4',
          name: 'BEGINNER-Hamstring_Walkouts-EXERCISE.mp4',
          description: null,
          size: 140498,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 891,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '244fd0856150559364822bbe9eb1a06ebe89a135f34a85fd2d8511dc370a45bf',
          file_name:
            'audios/244fd0856150559364822bbe9eb1a06ebe89a135f34a85fd2d8511dc370a45bf.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/244fd0856150559364822bbe9eb1a06ebe89a135f34a85fd2d8511dc370a45bf.mp3',
          name: 'BEGINNER-Hamstring_Walkouts-EXERCISE.mp3',
          description: null,
          size: 32008,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Glute_Bridges-EXERCISE': {
      id: 404,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Glute Bridges',
      short_name: 'Glute Bridges',
      unique_name: 'INTERMEDIATE-Glute_Bridges-EXERCISE',
      description:
        "1. Lay on your back with your knees bent, hip-width apart and feet flat on the floor. Keep your arms at your sides, palms down.\r\n2. Keep your upper back on the floor and drive through your heels to raise your hips as high as possible without arching your back. Keep knees aligned so they don't splay out or buckle in.\r\n3. Lower with control back to start position.",
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 892,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '3f9c92a2c3f691839f480a069a5474ca560331ddf2b8462ca91d3636ef5e365a',
          file_name:
            'videos/3f9c92a2c3f691839f480a069a5474ca560331ddf2b8462ca91d3636ef5e365a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3f9c92a2c3f691839f480a069a5474ca560331ddf2b8462ca91d3636ef5e365a.mp4',
          name: 'TRUDIE_027_GLUTE_BRIDGES_1_small_720.mp4',
          description: null,
          size: 53790,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 893,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'b8ef747e7b2dcbec912d65919c9d8d919c6ddfb73a0b936ea51ae81ad948bb75',
          file_name:
            'audios/b8ef747e7b2dcbec912d65919c9d8d919c6ddfb73a0b936ea51ae81ad948bb75.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b8ef747e7b2dcbec912d65919c9d8d919c6ddfb73a0b936ea51ae81ad948bb75.mp3',
          name: 'GluteBridges.mp3',
          description: null,
          size: 22172,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Glute_Bridges-EXERCISE': {
      id: 405,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Glute Bridges',
      short_name: 'Glute Bridges',
      unique_name: 'ADVANCED-Glute_Bridges-EXERCISE',
      description:
        "1. Lay on your back with your knees bent, hip-width apart and feet flat on the floor. Keep your arms at your sides, palms down.\r\n2. Keep your upper back on the floor and drive through your heels to raise your hips as high as possible without arching your back. Keep knees aligned so they don't splay out or buckle in.\r\n3. Lower with control back to start position.",
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 894,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '3f9c92a2c3f691839f480a069a5474ca560331ddf2b8462ca91d3636ef5e365a',
          file_name:
            'videos/3f9c92a2c3f691839f480a069a5474ca560331ddf2b8462ca91d3636ef5e365a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3f9c92a2c3f691839f480a069a5474ca560331ddf2b8462ca91d3636ef5e365a.mp4',
          name: 'TRUDIE_027_GLUTE_BRIDGES_1_small_720.mp4',
          description: null,
          size: 53790,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 895,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'b8ef747e7b2dcbec912d65919c9d8d919c6ddfb73a0b936ea51ae81ad948bb75',
          file_name:
            'audios/b8ef747e7b2dcbec912d65919c9d8d919c6ddfb73a0b936ea51ae81ad948bb75.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b8ef747e7b2dcbec912d65919c9d8d919c6ddfb73a0b936ea51ae81ad948bb75.mp3',
          name: 'GluteBridges.mp3',
          description: null,
          size: 22172,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Bodyweight_Squat-EXERCISE': {
      id: 406,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Squat',
      short_name: 'Bodyweight Squat',
      unique_name: 'INTERMEDIATE-Bodyweight_Squat-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart.\r\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\r\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 896,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'aba0b422bcd148bdabc217308896b7f8ebede4a1c1d289fef37541a5243182bc',
          file_name:
            'videos/aba0b422bcd148bdabc217308896b7f8ebede4a1c1d289fef37541a5243182bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/aba0b422bcd148bdabc217308896b7f8ebede4a1c1d289fef37541a5243182bc.mp4',
          name: 'EVE_BODYWEIGHT_SQUAT_ALT_2_REV_SMALL_720.mp4',
          description: null,
          size: 104705,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 897,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'eed3d3718445539e84daefbb024cfcb6ac87f9c734a7bd4b509ca549703ace8e',
          file_name:
            'audios/eed3d3718445539e84daefbb024cfcb6ac87f9c734a7bd4b509ca549703ace8e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eed3d3718445539e84daefbb024cfcb6ac87f9c734a7bd4b509ca549703ace8e.mp3',
          name: 'BEGINNER-Bodyweight_Squat-EXERCISE.mp3',
          description: null,
          size: 31502,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Bodyweight_Squat-EXERCISE': {
      id: 407,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Squat',
      short_name: 'Bodyweight Squat',
      unique_name: 'ADVANCED-Bodyweight_Squat-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart.\r\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\r\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 100070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 898,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'aba0b422bcd148bdabc217308896b7f8ebede4a1c1d289fef37541a5243182bc',
          file_name:
            'videos/aba0b422bcd148bdabc217308896b7f8ebede4a1c1d289fef37541a5243182bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/aba0b422bcd148bdabc217308896b7f8ebede4a1c1d289fef37541a5243182bc.mp4',
          name: 'EVE_BODYWEIGHT_SQUAT_ALT_2_REV_SMALL_720.mp4',
          description: null,
          size: 104705,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 899,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'eed3d3718445539e84daefbb024cfcb6ac87f9c734a7bd4b509ca549703ace8e',
          file_name:
            'audios/eed3d3718445539e84daefbb024cfcb6ac87f9c734a7bd4b509ca549703ace8e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eed3d3718445539e84daefbb024cfcb6ac87f9c734a7bd4b509ca549703ace8e.mp3',
          name: 'BEGINNER-Bodyweight_Squat-EXERCISE.mp3',
          description: null,
          size: 31502,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating_Front_Kicks-EXERCISE': {
      id: 408,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Alternating Front Kicks',
      short_name: 'Alternating Front Kicks',
      unique_name: 'BEGINNER-Alternating_Front_Kicks-EXERCISE',
      description:
        '1. Stand with your feet roughly shoulder-width apart. Keeping your chest up and core tight. Hands in fists in front of your chin.\n2. Pick up one knee and extend your leg in front of you (like you are kicking off your shoe).\n3. Recoil your leg back into start position.\n4. Repeat with the other leg. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1037,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '63c368180838c554d3f993a4400fa374577d96eb5a76483008ea321d271d70dd',
          file_name:
            'videos/63c368180838c554d3f993a4400fa374577d96eb5a76483008ea321d271d70dd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/63c368180838c554d3f993a4400fa374577d96eb5a76483008ea321d271d70dd.mp4',
          name: 'BEGINNER-Alternating_Front_Kicks-EXERCISE.mp4',
          description: null,
          size: 103160,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1038,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '9d792c5e1d419255eb37682f292b7ca3678003581e709c91734f152a083ded32',
          file_name:
            'audios/9d792c5e1d419255eb37682f292b7ca3678003581e709c91734f152a083ded32.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9d792c5e1d419255eb37682f292b7ca3678003581e709c91734f152a083ded32.mp3',
          name: 'BEGINNER-Alternating_Front_Kicks-EXERCISE.mp3',
          description: null,
          size: 26200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight_Serve_the_Platter-EXERCISE': {
      id: 409,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bodyweight Serve the Platter',
      short_name: 'Bodyweight Serve the Platter',
      unique_name: 'BEGINNER-Bodyweight_Serve_the_Platter-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart, core engaged, knees slightly bent. Keep your arms close to your ribcage, bend both elbows, palms face up.\n2. Engage your biceps and move your fists away from your body as you straighten your arms up in front of you to shoulder height.\n3. Keep the tension in your arms, and with control return to start.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1045,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'ac47cafd2390bf3faa930b1da061ef9b093f7c359adb8ff4ef780e748c7aac5c',
          file_name:
            'videos/ac47cafd2390bf3faa930b1da061ef9b093f7c359adb8ff4ef780e748c7aac5c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ac47cafd2390bf3faa930b1da061ef9b093f7c359adb8ff4ef780e748c7aac5c.mp4',
          name: 'BEGINNER-Bodyweight_Serve_the_Platter-EXERCISE.mp4',
          description: null,
          size: 61369,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1046,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '45e74c7905e154ef933076c3ecc940c0831ef0ea40c86df5598a58393ff57ae1',
          file_name:
            'audios/45e74c7905e154ef933076c3ecc940c0831ef0ea40c86df5598a58393ff57ae1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/45e74c7905e154ef933076c3ecc940c0831ef0ea40c86df5598a58393ff57ae1.mp3',
          name: 'BEGINNER-Bodyweight_Serve_the_Platter-EXERCISE.mp3',
          description: null,
          size: 31529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Ab_Scissors-EXERCISE': {
      id: 410,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Ab Scissors',
      short_name: 'Ab Scissors',
      unique_name: 'BEGINNER-Ab_Scissors-EXERCISE',
      description:
        '1. Lie on your back with your hands on the floor by your sides, palms flat. Engage your core and tuck your pelvis, so your lower back is planted firmly on the floor. Raise your shoulders and head off the floor as you lift both feet about six inches off the floor.\n2. Scissor your legs out and in crossing one leg over, alternating which leg is on top.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1053,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '8ddade67e9d851b6ad125761af87d147018fe0e3b4d9a3e1105e989326940610',
          file_name:
            'videos/8ddade67e9d851b6ad125761af87d147018fe0e3b4d9a3e1105e989326940610.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8ddade67e9d851b6ad125761af87d147018fe0e3b4d9a3e1105e989326940610.mp4',
          name: 'BEG-INT-ADV-Ab_Scissors-EXERCISE.mp4',
          description: null,
          size: 45266,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1054,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '9e8c9e10c3e9a5f3ea4752a0a5e454724961c9df829c23502b90fdec74660f60',
          file_name:
            'audios/9e8c9e10c3e9a5f3ea4752a0a5e454724961c9df829c23502b90fdec74660f60.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9e8c9e10c3e9a5f3ea4752a0a5e454724961c9df829c23502b90fdec74660f60.mp3',
          name: 'BEG-INT-ADV-Ab_Scissors-EXERCISE.mp3',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Ab_Scissors-EXERCISE': {
      id: 411,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Ab Scissors',
      short_name: 'Ab Scissors',
      unique_name: 'INTERMEDIATE-Ab_Scissors-EXERCISE',
      description:
        '1. Lie on your back with your hands on the floor by your sides, palms flat. Engage your core and tuck your pelvis, so your lower back is planted firmly on the floor. Raise your shoulders and head off the floor as you lift both feet about six inches off the floor.\n2. Scissor your legs out and in crossing one leg over, alternating which leg is on top.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1055,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '8ddade67e9d851b6ad125761af87d147018fe0e3b4d9a3e1105e989326940610',
          file_name:
            'videos/8ddade67e9d851b6ad125761af87d147018fe0e3b4d9a3e1105e989326940610.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8ddade67e9d851b6ad125761af87d147018fe0e3b4d9a3e1105e989326940610.mp4',
          name: 'BEG-INT-ADV-Ab_Scissors-EXERCISE.mp4',
          description: null,
          size: 45266,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1056,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '9e8c9e10c3e9a5f3ea4752a0a5e454724961c9df829c23502b90fdec74660f60',
          file_name:
            'audios/9e8c9e10c3e9a5f3ea4752a0a5e454724961c9df829c23502b90fdec74660f60.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9e8c9e10c3e9a5f3ea4752a0a5e454724961c9df829c23502b90fdec74660f60.mp3',
          name: 'BEG-INT-ADV-Ab_Scissors-EXERCISE.mp3',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Ab_Scissors-EXERCISE': {
      id: 412,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Ab Scissors',
      short_name: 'Ab Scissors',
      unique_name: 'ADVANCED-Ab_Scissors-EXERCISE',
      description:
        '1. Lie on your back with your hands on the floor by your sides, palms flat. Engage your core and tuck your pelvis, so your lower back is planted firmly on the floor. Raise your shoulders and head off the floor as you lift both feet about six inches off the floor.\n2. Scissor your legs out and in crossing one leg over, alternating which leg is on top.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1057,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '8ddade67e9d851b6ad125761af87d147018fe0e3b4d9a3e1105e989326940610',
          file_name:
            'videos/8ddade67e9d851b6ad125761af87d147018fe0e3b4d9a3e1105e989326940610.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8ddade67e9d851b6ad125761af87d147018fe0e3b4d9a3e1105e989326940610.mp4',
          name: 'BEG-INT-ADV-Ab_Scissors-EXERCISE.mp4',
          description: null,
          size: 45266,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1058,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '9e8c9e10c3e9a5f3ea4752a0a5e454724961c9df829c23502b90fdec74660f60',
          file_name:
            'audios/9e8c9e10c3e9a5f3ea4752a0a5e454724961c9df829c23502b90fdec74660f60.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9e8c9e10c3e9a5f3ea4752a0a5e454724961c9df829c23502b90fdec74660f60.mp3',
          name: 'BEG-INT-ADV-Ab_Scissors-EXERCISE.mp3',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Crab_Knee_Taps-EXERCISE': {
      id: 413,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Crab Knee Taps',
      short_name: 'Crab Knee Taps',
      unique_name: 'BEGINNER-Crab_Knee_Taps-EXERCISE',
      description:
        '1. Start in a Crab Walk position with your knees bent, feet and hands on the floor, hips up.\n2. Raise one foot off the floor bringing your knee up closer to your chest. Lift the opposite arm off the floor to tap your knee.\n3. Return to Crab Walk position.\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1065,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '52228e62c9af693011f8771170ac6ab62f4514644dfc573c7c4cc6c2a3121363',
          file_name:
            'videos/52228e62c9af693011f8771170ac6ab62f4514644dfc573c7c4cc6c2a3121363.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/52228e62c9af693011f8771170ac6ab62f4514644dfc573c7c4cc6c2a3121363.mp4',
          name: 'BEGINNER-Crab_Knee_Taps-EXERCISE.mp4',
          description: null,
          size: 89714,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1066,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '50f157bfabacf90ef13f1066803d038047a688996c11c7bc3f1137e76588d3ea',
          file_name:
            'audios/50f157bfabacf90ef13f1066803d038047a688996c11c7bc3f1137e76588d3ea.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/50f157bfabacf90ef13f1066803d038047a688996c11c7bc3f1137e76588d3ea.mp3',
          name: 'BEGINNER-Crab_Knee_Taps-EXERCISE.mp3',
          description: null,
          size: 23692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Modified_Forearm_Plank_Hip_Drops-EXERCISE': {
      id: 414,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Modified Forearm Plank Hip Drops',
      short_name: 'Modified Forearm Plank Hip Drops',
      unique_name: 'BEGINNER-Modified_Forearm_Plank_Hip_Drops-EXERCISE',
      description:
        '1. Start in Forearm Plank position, elbows under shoulders, hips squared. Drop your knees straight down to the floor.\n2. Keeping your core engaged and shoulders square, rotate your hips to one side dropping bottom hip down toward the floor.\n3. Return to start position and repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1067,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '5d3abb457a235299a125cc69155e4a7a6b3611cf3898bab9b67c2865a8b9ce80',
          file_name:
            'videos/5d3abb457a235299a125cc69155e4a7a6b3611cf3898bab9b67c2865a8b9ce80.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5d3abb457a235299a125cc69155e4a7a6b3611cf3898bab9b67c2865a8b9ce80.mp4',
          name: 'BEGINNER-Modified_Forearm_Plank_Hip_Drops-EXERCISE.mp4',
          description: null,
          size: 66429,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1068,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'd3dc49cf0747b4b49b5d25061d009d83a48d78669caaecdbcf4148d455b9893d',
          file_name:
            'audios/d3dc49cf0747b4b49b5d25061d009d83a48d78669caaecdbcf4148d455b9893d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d3dc49cf0747b4b49b5d25061d009d83a48d78669caaecdbcf4148d455b9893d.mp3',
          name: 'BEGINNER-Modified_Forearm_Plank_Hip_Drops-EXERCISE.mp3',
          description: null,
          size: 42500,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Oblique_Climbers-EXERCISE': {
      id: 415,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Oblique Climbers',
      short_name: 'Oblique Climbers',
      unique_name: 'BEGINNER-Oblique_Climbers-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists, hips square.\n2. Keeping your legs together, bend your knees and hop both feet at a diagonal toward your hands, landing knees tucked outside of your triceps.\n3. Jump both feet back to Plank position and repeat on the other side.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: true,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1069,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '63861253ab05b876b63f27f935b0ed1592f7776c40292e51bda9cb26bad459a4',
          file_name:
            'videos/63861253ab05b876b63f27f935b0ed1592f7776c40292e51bda9cb26bad459a4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/63861253ab05b876b63f27f935b0ed1592f7776c40292e51bda9cb26bad459a4.mp4',
          name: 'BEG-INT-ADV-Oblique_Climbers-EXERCISE.mp4',
          description: null,
          size: 126667,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1070,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '7706d7046d39dd2b0fe5f69f418a4181efbe8eaa5e175cae5fd070b38c0ea8db',
          file_name:
            'audios/7706d7046d39dd2b0fe5f69f418a4181efbe8eaa5e175cae5fd070b38c0ea8db.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7706d7046d39dd2b0fe5f69f418a4181efbe8eaa5e175cae5fd070b38c0ea8db.mp3',
          name: 'BEG-INT-ADV-Oblique_Climbers-EXERCISE.mp3',
          description: null,
          size: 45294,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Oblique_Climbers-EXERCISE': {
      id: 416,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Oblique Climbers',
      short_name: 'Oblique Climbers',
      unique_name: 'INTERMEDIATE-Oblique_Climbers-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists, hips square.\n2. Keeping your legs together, bend your knees and hop both feet at a diagonal toward your hands, landing knees tucked outside of your triceps.\n3. Jump both feet back to Plank position and repeat on the other side.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1071,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '63861253ab05b876b63f27f935b0ed1592f7776c40292e51bda9cb26bad459a4',
          file_name:
            'videos/63861253ab05b876b63f27f935b0ed1592f7776c40292e51bda9cb26bad459a4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/63861253ab05b876b63f27f935b0ed1592f7776c40292e51bda9cb26bad459a4.mp4',
          name: 'BEG-INT-ADV-Oblique_Climbers-EXERCISE.mp4',
          description: null,
          size: 126667,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1072,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '7706d7046d39dd2b0fe5f69f418a4181efbe8eaa5e175cae5fd070b38c0ea8db',
          file_name:
            'audios/7706d7046d39dd2b0fe5f69f418a4181efbe8eaa5e175cae5fd070b38c0ea8db.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7706d7046d39dd2b0fe5f69f418a4181efbe8eaa5e175cae5fd070b38c0ea8db.mp3',
          name: 'BEG-INT-ADV-Oblique_Climbers-EXERCISE.mp3',
          description: null,
          size: 45294,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Oblique_Climbers-EXERCISE': {
      id: 417,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Oblique Climbers',
      short_name: 'Oblique Climbers',
      unique_name: 'ADVANCED-Oblique_Climbers-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists, hips square.\n2. Keeping your legs together, bend your knees and hop both feet at a diagonal toward your hands, landing knees tucked outside of your triceps.\n3. Jump both feet back to Plank position and repeat on the other side.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1073,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '63861253ab05b876b63f27f935b0ed1592f7776c40292e51bda9cb26bad459a4',
          file_name:
            'videos/63861253ab05b876b63f27f935b0ed1592f7776c40292e51bda9cb26bad459a4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/63861253ab05b876b63f27f935b0ed1592f7776c40292e51bda9cb26bad459a4.mp4',
          name: 'BEG-INT-ADV-Oblique_Climbers-EXERCISE.mp4',
          description: null,
          size: 126667,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1074,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '7706d7046d39dd2b0fe5f69f418a4181efbe8eaa5e175cae5fd070b38c0ea8db',
          file_name:
            'audios/7706d7046d39dd2b0fe5f69f418a4181efbe8eaa5e175cae5fd070b38c0ea8db.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7706d7046d39dd2b0fe5f69f418a4181efbe8eaa5e175cae5fd070b38c0ea8db.mp3',
          name: 'BEG-INT-ADV-Oblique_Climbers-EXERCISE.mp3',
          description: null,
          size: 45294,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Floor_Tricep_Dips-EXERCISE': {
      id: 418,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Floor Tricep Dips',
      short_name: 'Floor Tricep Dips',
      unique_name: 'BEGINNER-Floor_Tricep_Dips-EXERCISE',
      description:
        '1. Start in a Crab Walk position with your knees bent, feet and hands on the floor, hips up.\n2. Bend your elbows straight back and perform a tricep dip bringing your hips closer to the floor.\n3. Extend your elbows and return to Crab Walk position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1084,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '4053774f9652924617e362ee8ea8d7ad9315a9209e0485eb78676373f86ea459',
          file_name:
            'videos/4053774f9652924617e362ee8ea8d7ad9315a9209e0485eb78676373f86ea459.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4053774f9652924617e362ee8ea8d7ad9315a9209e0485eb78676373f86ea459.mp4',
          name: 'BEG-INT-ADV-Floor_Tricep_Dips-EXERCISE.mp4',
          description: null,
          size: 47299,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1085,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '39bef9e164e35adf20ec4f161e1e76d094b1955286cdfcb5d98ffba93b307499',
          file_name:
            'audios/39bef9e164e35adf20ec4f161e1e76d094b1955286cdfcb5d98ffba93b307499.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/39bef9e164e35adf20ec4f161e1e76d094b1955286cdfcb5d98ffba93b307499.mp3',
          name: 'BEG-INT-ADV-Floor_Tricep_Dips-EXERCISE.mp3',
          description: null,
          size: 27453,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Floor_Tricep_Dips-EXERCISE': {
      id: 419,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Floor Tricep Dips',
      short_name: 'Floor Tricep Dips',
      unique_name: 'INTERMEDIATE-Floor_Tricep_Dips-EXERCISE',
      description:
        '1. Start in a Crab Walk position with your knees bent, feet and hands on the floor, hips up.\n2. Bend your elbows straight back and perform a tricep dip bringing your hips closer to the floor.\n3. Extend your elbows and return to Crab Walk position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1086,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '4053774f9652924617e362ee8ea8d7ad9315a9209e0485eb78676373f86ea459',
          file_name:
            'videos/4053774f9652924617e362ee8ea8d7ad9315a9209e0485eb78676373f86ea459.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4053774f9652924617e362ee8ea8d7ad9315a9209e0485eb78676373f86ea459.mp4',
          name: 'BEG-INT-ADV-Floor_Tricep_Dips-EXERCISE.mp4',
          description: null,
          size: 47299,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1087,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '39bef9e164e35adf20ec4f161e1e76d094b1955286cdfcb5d98ffba93b307499',
          file_name:
            'audios/39bef9e164e35adf20ec4f161e1e76d094b1955286cdfcb5d98ffba93b307499.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/39bef9e164e35adf20ec4f161e1e76d094b1955286cdfcb5d98ffba93b307499.mp3',
          name: 'BEG-INT-ADV-Floor_Tricep_Dips-EXERCISE.mp3',
          description: null,
          size: 27453,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Floor_Tricep_Dips-EXERCISE': {
      id: 420,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Floor Tricep Dips',
      short_name: 'Floor Tricep Dips',
      unique_name: 'ADVANCED-Floor_Tricep_Dips-EXERCISE',
      description:
        '1. Start in a Crab Walk position with your knees bent, feet and hands on the floor, hips up.\n2. Bend your elbows straight back and perform a tricep dip bringing your hips closer to the floor.\n3. Extend your elbows and return to Crab Walk position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1088,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '4053774f9652924617e362ee8ea8d7ad9315a9209e0485eb78676373f86ea459',
          file_name:
            'videos/4053774f9652924617e362ee8ea8d7ad9315a9209e0485eb78676373f86ea459.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4053774f9652924617e362ee8ea8d7ad9315a9209e0485eb78676373f86ea459.mp4',
          name: 'BEG-INT-ADV-Floor_Tricep_Dips-EXERCISE.mp4',
          description: null,
          size: 47299,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1089,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '39bef9e164e35adf20ec4f161e1e76d094b1955286cdfcb5d98ffba93b307499',
          file_name:
            'audios/39bef9e164e35adf20ec4f161e1e76d094b1955286cdfcb5d98ffba93b307499.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/39bef9e164e35adf20ec4f161e1e76d094b1955286cdfcb5d98ffba93b307499.mp3',
          name: 'BEG-INT-ADV-Floor_Tricep_Dips-EXERCISE.mp3',
          description: null,
          size: 27453,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Hook_Punches-EXERCISE': {
      id: 421,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Hook Punches',
      short_name: 'Hook Punches',
      unique_name: 'BEGINNER-Hook_Punches-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart. Step forward with one leg. Toes forward, hips squared.\r\n2. Bend your knees slightly, raise the back heel and bring both fists in front of face.\r\n3. Bend one elbow 90 degrees to shoulder height. Using hips and shoulders for power, swing fist across your body. Pivot the same side foot in that direction.\r\n4. Recoil and return to start. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1090,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '605246e7be610534fbeb9ed1725befb243c97a4d6c59d62b15f68523e1886e7b',
          file_name:
            'videos/605246e7be610534fbeb9ed1725befb243c97a4d6c59d62b15f68523e1886e7b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/605246e7be610534fbeb9ed1725befb243c97a4d6c59d62b15f68523e1886e7b.mp4',
          name: 'BEG-INT-ADV-Hook_Punches-EXERCISE.mp4',
          description: null,
          size: 91093,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1091,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'dbb2fe2a531b6dbb8da4eae064f92b154fb9cf04b407a47b78b2b75784ce48e9',
          file_name:
            'audios/dbb2fe2a531b6dbb8da4eae064f92b154fb9cf04b407a47b78b2b75784ce48e9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dbb2fe2a531b6dbb8da4eae064f92b154fb9cf04b407a47b78b2b75784ce48e9.mp3',
          name: 'BEG-INT-ADV-Hook_Punches-EXERCISE.mp3',
          description: null,
          size: 20244,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Hook_Punches-EXERCISE': {
      id: 422,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Hook Punches',
      short_name: 'Hook Punches',
      unique_name: 'INTERMEDIATE-Hook_Punches-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart. Step forward with one leg. Toes forward, hips squared.\r\n2. Bend your knees slightly, raise the back heel and bring both fists in front of face.\r\n3. Bend one elbow 90 degrees to shoulder height. Using hips and shoulders for power, swing fist across your body. Pivot the same side foot in that direction.\r\n4. Recoil and return to start. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1092,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '605246e7be610534fbeb9ed1725befb243c97a4d6c59d62b15f68523e1886e7b',
          file_name:
            'videos/605246e7be610534fbeb9ed1725befb243c97a4d6c59d62b15f68523e1886e7b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/605246e7be610534fbeb9ed1725befb243c97a4d6c59d62b15f68523e1886e7b.mp4',
          name: 'BEG-INT-ADV-Hook_Punches-EXERCISE.mp4',
          description: null,
          size: 91093,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1093,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'dbb2fe2a531b6dbb8da4eae064f92b154fb9cf04b407a47b78b2b75784ce48e9',
          file_name:
            'audios/dbb2fe2a531b6dbb8da4eae064f92b154fb9cf04b407a47b78b2b75784ce48e9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dbb2fe2a531b6dbb8da4eae064f92b154fb9cf04b407a47b78b2b75784ce48e9.mp3',
          name: 'BEG-INT-ADV-Hook_Punches-EXERCISE.mp3',
          description: null,
          size: 20244,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Hook_Punches-EXERCISE': {
      id: 423,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Hook Punches',
      short_name: 'Hook Punches',
      unique_name: 'ADVANCED-Hook_Punches-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart. Step forward with one leg. Toes forward, hips squared.\r\n2. Bend your knees slightly, raise the back heel and bring both fists in front of face.\r\n3. Bend one elbow 90 degrees to shoulder height. Using hips and shoulders for power, swing fist across your body. Pivot the same side foot in that direction.\r\n4. Recoil and return to start. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1094,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '605246e7be610534fbeb9ed1725befb243c97a4d6c59d62b15f68523e1886e7b',
          file_name:
            'videos/605246e7be610534fbeb9ed1725befb243c97a4d6c59d62b15f68523e1886e7b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/605246e7be610534fbeb9ed1725befb243c97a4d6c59d62b15f68523e1886e7b.mp4',
          name: 'BEG-INT-ADV-Hook_Punches-EXERCISE.mp4',
          description: null,
          size: 91093,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1095,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'dbb2fe2a531b6dbb8da4eae064f92b154fb9cf04b407a47b78b2b75784ce48e9',
          file_name:
            'audios/dbb2fe2a531b6dbb8da4eae064f92b154fb9cf04b407a47b78b2b75784ce48e9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dbb2fe2a531b6dbb8da4eae064f92b154fb9cf04b407a47b78b2b75784ce48e9.mp3',
          name: 'BEG-INT-ADV-Hook_Punches-EXERCISE.mp3',
          description: null,
          size: 20244,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight_Arnold_Press-EXERCISE': {
      id: 424,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bodyweight Arnold Press',
      short_name: 'Bodyweight Arnold Press',
      unique_name: 'BEGINNER-Bodyweight_Arnold_Press-EXERCISE',
      description:
        '1. Stand with a solid foundation, back straight and core engaged. Bring fists in front of your chest, shoulder height, elbows close to ribcage, palms face in.\n2. Rotate your wrists out, bring your elbows away from your body and raise both arms straight overhead to full extension, biceps by your ears.\n3. Lower your arms down and rotate your wrists back in to start position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1096,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'bc8a15a395b60b34389a31afea004ce074b8cf435397a296632009808723f82e',
          file_name:
            'videos/bc8a15a395b60b34389a31afea004ce074b8cf435397a296632009808723f82e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bc8a15a395b60b34389a31afea004ce074b8cf435397a296632009808723f82e.mp4',
          name: 'BEGINNER-Bodyweight_Arnold_Press-EXERCISE.mp4',
          description: null,
          size: 82109,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1097,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '018bfc84a2f0e62ab96ef9eff6262a27d5032e71d0af7947563b006cf0a9f5ec',
          file_name:
            'audios/018bfc84a2f0e62ab96ef9eff6262a27d5032e71d0af7947563b006cf0a9f5ec.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/018bfc84a2f0e62ab96ef9eff6262a27d5032e71d0af7947563b006cf0a9f5ec.mp3',
          name: 'BEGINNER-Bodyweight_Arnold_Press-EXERCISE.mp3',
          description: null,
          size: 31842,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bulldog_Floor_Squats-EXERCISE': {
      id: 425,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bulldog Floor Squats',
      short_name: 'Bulldog Floor Squats',
      unique_name: 'BEGINNER-Bulldog_Floor_Squats-EXERCISE',
      description:
        '1. Start in a squat with your feet a little wider than hip-width apart, hands up in front of your chest, palms facing out.\n2. Maintain the squat, brace your core and rock forward until your palms meet the floor.\n3. Land with a soft bend in your elbows, keeping bent knees hovering off the floor underneath your hips.\n4. Bend elbows slightly, and straighten arms to push yourself back up to start position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1098,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '9df40bd41445fe10ed791119236de1deb5182cc72866755907c51a1d3bf2b1bc',
          file_name:
            'videos/9df40bd41445fe10ed791119236de1deb5182cc72866755907c51a1d3bf2b1bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9df40bd41445fe10ed791119236de1deb5182cc72866755907c51a1d3bf2b1bc.mp4',
          name: 'BEGINNER-Bulldog_Floor_Squats-EXERCISE.mp4',
          description: null,
          size: 138582,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1099,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'd72e2f7b928ab21c535e15e25affbaf5a4a174e223fc71de001cb6333bd18d20',
          file_name:
            'audios/d72e2f7b928ab21c535e15e25affbaf5a4a174e223fc71de001cb6333bd18d20.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d72e2f7b928ab21c535e15e25affbaf5a4a174e223fc71de001cb6333bd18d20.mp3',
          name: 'BEGINNER-Bulldog_Floor_Squats-EXERCISE.mp3',
          description: null,
          size: 28071,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Modified_Criss_Cross_Jacks-EXERCISE': {
      id: 426,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Modified Criss Cross Jacks',
      short_name: 'Modified Criss Cross Jacks',
      unique_name: 'BEGINNER-Modified_Criss_Cross_Jacks-EXERCISE',
      description:
        '1. Stand tall with your feet wider than shoulder-width apart and arms straight out to your sides in a "T".\n2. Transfer all your weight onto one leg and cross the opposite leg in front of you as you cross your straight arms in front of your chest.\n3. Return to start position and repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1115,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'b325bc576317189302f76aefba74a93bc72e5662bc248e046897407e0bd49dee',
          file_name:
            'videos/b325bc576317189302f76aefba74a93bc72e5662bc248e046897407e0bd49dee.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b325bc576317189302f76aefba74a93bc72e5662bc248e046897407e0bd49dee.mp4',
          name: 'BEGINNER-Modified_Criss_Cross_Jacks-EXERCISE.mp4',
          description: null,
          size: 110336,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1116,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'df010c632b609d99c9a7b253830c6b576fd5d878115803924bda82a9170bcfb5',
          file_name:
            'audios/df010c632b609d99c9a7b253830c6b576fd5d878115803924bda82a9170bcfb5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/df010c632b609d99c9a7b253830c6b576fd5d878115803924bda82a9170bcfb5.mp3',
          name: 'BEGINNER-Modified_Criss_Cross_Jacks-EXERCISE.mp3',
          description: null,
          size: 31842,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Side_Lying_Leg_Lifts-EXERCISE': {
      id: 427,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Side Lying Leg Lifts',
      short_name: 'Side Lying Leg Lifts',
      unique_name: 'BEGINNER-Side_Lying_Leg_Lifts-EXERCISE',
      description:
        "1. Start in side-lying position, resting on one forearm. Hips, shoulders and feet stacked, legs are straight.\n2. Keeping your hips square and toes and knees facing forward, raise your top leg up. Don't open up your hip to lift higher. Make sure to not roll forward or back.\n3. Pause for a beat and lower back down with control.",
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1135,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6244c5e398c8bb549395aafa4b63b5d4975f0324637fc43da2ff7cef140a19ad',
          file_name:
            'videos/6244c5e398c8bb549395aafa4b63b5d4975f0324637fc43da2ff7cef140a19ad.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6244c5e398c8bb549395aafa4b63b5d4975f0324637fc43da2ff7cef140a19ad.mp4',
          name: 'BEG-INT-ADV-Side_Lying_Leg_Lifts-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 52885,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1136,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: '2c9fbc132929c240d9e7365f9bdd01414c01cee59d778879bb584f5859938793',
          file_name:
            'videos/2c9fbc132929c240d9e7365f9bdd01414c01cee59d778879bb584f5859938793.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2c9fbc132929c240d9e7365f9bdd01414c01cee59d778879bb584f5859938793.mp4',
          name: 'BEG-INT-ADV-Side_Lying_Leg_Lifts-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 54524,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1137,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'e10956dd1c9a2204ba38abef79acb79aa32f35b13f157dc82b0dd18b7c041f18',
          file_name:
            'audios/e10956dd1c9a2204ba38abef79acb79aa32f35b13f157dc82b0dd18b7c041f18.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e10956dd1c9a2204ba38abef79acb79aa32f35b13f157dc82b0dd18b7c041f18.mp3',
          name: 'BEG-INT-ADV-Side_Lying_Leg_Lifts-EXERCISE.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Side_Lying_Leg_Lifts-EXERCISE': {
      id: 428,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Side Lying Leg Lifts',
      short_name: 'Side Lying Leg Lifts',
      unique_name: 'INTERMEDIATE-Side_Lying_Leg_Lifts-EXERCISE',
      description:
        "1. Start in side-lying position, resting on one forearm. Hips, shoulders and feet stacked, legs are straight.\n2. Keeping your hips square and toes and knees facing forward, raise your top leg up. Don't open up your hip to lift higher. Make sure to not roll forward or back.\n3. Pause for a beat and lower back down with control.",
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1138,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6244c5e398c8bb549395aafa4b63b5d4975f0324637fc43da2ff7cef140a19ad',
          file_name:
            'videos/6244c5e398c8bb549395aafa4b63b5d4975f0324637fc43da2ff7cef140a19ad.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6244c5e398c8bb549395aafa4b63b5d4975f0324637fc43da2ff7cef140a19ad.mp4',
          name: 'BEG-INT-ADV-Side_Lying_Leg_Lifts-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 52885,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1139,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: '2c9fbc132929c240d9e7365f9bdd01414c01cee59d778879bb584f5859938793',
          file_name:
            'videos/2c9fbc132929c240d9e7365f9bdd01414c01cee59d778879bb584f5859938793.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2c9fbc132929c240d9e7365f9bdd01414c01cee59d778879bb584f5859938793.mp4',
          name: 'BEG-INT-ADV-Side_Lying_Leg_Lifts-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 54524,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1140,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'e10956dd1c9a2204ba38abef79acb79aa32f35b13f157dc82b0dd18b7c041f18',
          file_name:
            'audios/e10956dd1c9a2204ba38abef79acb79aa32f35b13f157dc82b0dd18b7c041f18.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e10956dd1c9a2204ba38abef79acb79aa32f35b13f157dc82b0dd18b7c041f18.mp3',
          name: 'BEG-INT-ADV-Side_Lying_Leg_Lifts-EXERCISE.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Side_Lying_Leg_Lifts-EXERCISE': {
      id: 429,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Side Lying Leg Lifts',
      short_name: 'Side Lying Leg Lifts',
      unique_name: 'ADVANCED-Side_Lying_Leg_Lifts-EXERCISE',
      description:
        "1. Start in side-lying position, resting on one forearm. Hips, shoulders and feet stacked, legs are straight.\n2. Keeping your hips square and toes and knees facing forward, raise your top leg up. Don't open up your hip to lift higher. Make sure to not roll forward or back.\n3. Pause for a beat and lower back down with control.",
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1141,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6244c5e398c8bb549395aafa4b63b5d4975f0324637fc43da2ff7cef140a19ad',
          file_name:
            'videos/6244c5e398c8bb549395aafa4b63b5d4975f0324637fc43da2ff7cef140a19ad.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6244c5e398c8bb549395aafa4b63b5d4975f0324637fc43da2ff7cef140a19ad.mp4',
          name: 'BEG-INT-ADV-Side_Lying_Leg_Lifts-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 52885,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1142,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: '2c9fbc132929c240d9e7365f9bdd01414c01cee59d778879bb584f5859938793',
          file_name:
            'videos/2c9fbc132929c240d9e7365f9bdd01414c01cee59d778879bb584f5859938793.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2c9fbc132929c240d9e7365f9bdd01414c01cee59d778879bb584f5859938793.mp4',
          name: 'BEG-INT-ADV-Side_Lying_Leg_Lifts-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 54524,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1143,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'e10956dd1c9a2204ba38abef79acb79aa32f35b13f157dc82b0dd18b7c041f18',
          file_name:
            'audios/e10956dd1c9a2204ba38abef79acb79aa32f35b13f157dc82b0dd18b7c041f18.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e10956dd1c9a2204ba38abef79acb79aa32f35b13f157dc82b0dd18b7c041f18.mp3',
          name: 'BEG-INT-ADV-Side_Lying_Leg_Lifts-EXERCISE.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Side_Shuffles-EXERCISE': {
      id: 430,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Side Shuffles',
      short_name: 'Side Shuffles',
      unique_name: 'BEGINNER-Side_Shuffles-EXERCISE',
      description:
        '1. Start with your feet about shoulder-width apart, knees bent and a slight forward lean in a strong, athletic stance.\n2. Staying low, take five lateral shuffles to the side while pumping your arms in opposition. Keep your core tight and stay light on your feet.\n3. Pause and drive off the working leg to change directions. Down and back is one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1144,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'b62507044c0dd8c66b0584d21351b2ac4e1a9a05b5f75ac4f3250ff4a16e4a75',
          file_name:
            'videos/b62507044c0dd8c66b0584d21351b2ac4e1a9a05b5f75ac4f3250ff4a16e4a75.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b62507044c0dd8c66b0584d21351b2ac4e1a9a05b5f75ac4f3250ff4a16e4a75.mp4',
          name: 'BEGINNER-Side_Shuffles-EXERCISE.mp4',
          description: null,
          size: 171564,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1145,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'aa378c869878f08b1a1489076b17c004100edfcda834d208eb27a9f981173b49',
          file_name:
            'audios/aa378c869878f08b1a1489076b17c004100edfcda834d208eb27a9f981173b49.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/aa378c869878f08b1a1489076b17c004100edfcda834d208eb27a9f981173b49.mp3',
          name: 'BEGINNER-Side_Shuffles-EXERCISE.mp3',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Heel_Elevated_Plie_Squats-EXERCISE': {
      id: 431,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Heel Elevated Plie Squats',
      short_name: 'Heel Elevated Plie Squats',
      unique_name: 'BEGINNER-Heel_Elevated_Plie_Squats-EXERCISE',
      description:
        '1. Start with your feet out wide, roughly double hip-width, toes turned out. Your hands can be in front of you or holding onto something for support. Lift one heel off the floor.\n2. Keeping your back straight and core engaged, bend your knees and drop your tailbone straight down toward the floor, keeping your knees wide, tracking over your feet.\n3. Keeping heel elevated, return to start position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 906,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '9c524e59ab984e593f83ec3de0bd78774f099c78660a64c4e8a203aede19ad20',
          file_name:
            'videos/9c524e59ab984e593f83ec3de0bd78774f099c78660a64c4e8a203aede19ad20.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9c524e59ab984e593f83ec3de0bd78774f099c78660a64c4e8a203aede19ad20.mp4',
          name: 'BEG-INT-ADV-Heel_Elevated_Plie_Squats-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 60129,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 907,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: '0732151a15207f57681a1cd29e00860c81898bd0afeb87b5056bd5afdfd91c6e',
          file_name:
            'videos/0732151a15207f57681a1cd29e00860c81898bd0afeb87b5056bd5afdfd91c6e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0732151a15207f57681a1cd29e00860c81898bd0afeb87b5056bd5afdfd91c6e.mp4',
          name: 'BEG-INT-ADV-Heel_Elevated_Plie_Squats-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 69258,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 908,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'd95dd178b1fc74ac5bcf5f503e3b8a8becb078a9a3957225a7bbc0a0fcbd277b',
          file_name:
            'audios/d95dd178b1fc74ac5bcf5f503e3b8a8becb078a9a3957225a7bbc0a0fcbd277b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d95dd178b1fc74ac5bcf5f503e3b8a8becb078a9a3957225a7bbc0a0fcbd277b.mp3',
          name: 'BEG-INT-ADV-Heel_Elevated_Plie_Squats-EXERCISE.mp3',
          description: null,
          size: 34663,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Heel_Elevated_Plie_Squats-EXERCISE': {
      id: 432,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Heel Elevated Plie Squats',
      short_name: 'Heel Elevated Plie Squats',
      unique_name: 'INTERMEDIATE-Heel_Elevated_Plie_Squats-EXERCISE',
      description:
        '1. Start with your feet out wide, roughly double hip-width, toes turned out. Your hands can be in front of you or holding onto something for support. Lift one heel off the floor.\n2. Keeping your back straight and core engaged, bend your knees and drop your tailbone straight down toward the floor, keeping your knees wide, tracking over your feet.\n3. Keeping heel elevated, return to start position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 909,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '9c524e59ab984e593f83ec3de0bd78774f099c78660a64c4e8a203aede19ad20',
          file_name:
            'videos/9c524e59ab984e593f83ec3de0bd78774f099c78660a64c4e8a203aede19ad20.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9c524e59ab984e593f83ec3de0bd78774f099c78660a64c4e8a203aede19ad20.mp4',
          name: 'BEG-INT-ADV-Heel_Elevated_Plie_Squats-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 60129,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 910,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: '0732151a15207f57681a1cd29e00860c81898bd0afeb87b5056bd5afdfd91c6e',
          file_name:
            'videos/0732151a15207f57681a1cd29e00860c81898bd0afeb87b5056bd5afdfd91c6e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0732151a15207f57681a1cd29e00860c81898bd0afeb87b5056bd5afdfd91c6e.mp4',
          name: 'BEG-INT-ADV-Heel_Elevated_Plie_Squats-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 69258,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 911,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'd95dd178b1fc74ac5bcf5f503e3b8a8becb078a9a3957225a7bbc0a0fcbd277b',
          file_name:
            'audios/d95dd178b1fc74ac5bcf5f503e3b8a8becb078a9a3957225a7bbc0a0fcbd277b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d95dd178b1fc74ac5bcf5f503e3b8a8becb078a9a3957225a7bbc0a0fcbd277b.mp3',
          name: 'BEG-INT-ADV-Heel_Elevated_Plie_Squats-EXERCISE.mp3',
          description: null,
          size: 34663,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Heel_Elevated_Plie_Squats-EXERCISE': {
      id: 433,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Heel Elevated Plie Squats',
      short_name: 'Heel Elevated Plie Squats',
      unique_name: 'ADVANCED-Heel_Elevated_Plie_Squats-EXERCISE',
      description:
        '1. Start with your feet out wide, roughly double hip-width, toes turned out. Your hands can be in front of you or holding onto something for support. Lift one heel off the floor.\n2. Keeping your back straight and core engaged, bend your knees and drop your tailbone straight down toward the floor, keeping your knees wide, tracking over your feet.\n3. Keeping heel elevated, return to start position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 912,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '9c524e59ab984e593f83ec3de0bd78774f099c78660a64c4e8a203aede19ad20',
          file_name:
            'videos/9c524e59ab984e593f83ec3de0bd78774f099c78660a64c4e8a203aede19ad20.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9c524e59ab984e593f83ec3de0bd78774f099c78660a64c4e8a203aede19ad20.mp4',
          name: 'BEG-INT-ADV-Heel_Elevated_Plie_Squats-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 60129,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 913,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: '0732151a15207f57681a1cd29e00860c81898bd0afeb87b5056bd5afdfd91c6e',
          file_name:
            'videos/0732151a15207f57681a1cd29e00860c81898bd0afeb87b5056bd5afdfd91c6e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0732151a15207f57681a1cd29e00860c81898bd0afeb87b5056bd5afdfd91c6e.mp4',
          name: 'BEG-INT-ADV-Heel_Elevated_Plie_Squats-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 69258,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 914,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'd95dd178b1fc74ac5bcf5f503e3b8a8becb078a9a3957225a7bbc0a0fcbd277b',
          file_name:
            'audios/d95dd178b1fc74ac5bcf5f503e3b8a8becb078a9a3957225a7bbc0a0fcbd277b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d95dd178b1fc74ac5bcf5f503e3b8a8becb078a9a3957225a7bbc0a0fcbd277b.mp3',
          name: 'BEG-INT-ADV-Heel_Elevated_Plie_Squats-EXERCISE.mp3',
          description: null,
          size: 34663,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Ab_Corkscrew-EXERCISE': {
      id: 434,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Ab Corkscrew',
      short_name: 'Ab Corkscrew',
      unique_name: 'BEGINNER-Ab_Corkscrew-EXERCISE',
      description:
        '1. Lie on your back with palms flat on the floor. Bring your legs up directly over your hips. Legs together, knees bent, feet flexed and core engaged.\n2. Shift your hips to one side and lift off the floor, pointing knees and toes to the other side. Move legs in a corkscrew motion toward the ceiling.\n3. Lower with control back to start and repeat in the opposite direction. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 915,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '69ef37759a7fe9b0292b9222d8f263efac7f34ed0e01dca9b7d409d92d7650b8',
          file_name:
            'videos/69ef37759a7fe9b0292b9222d8f263efac7f34ed0e01dca9b7d409d92d7650b8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/69ef37759a7fe9b0292b9222d8f263efac7f34ed0e01dca9b7d409d92d7650b8.mp4',
          name: 'BEG-INT-ADV-Ab_Corkscrew-EXERCISE.mp4',
          description: null,
          size: 112447,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 916,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'd2543b6ff1a46dbb657614a858c655501a2a5ba8521d3383389b5e7391cf412a',
          file_name:
            'audios/d2543b6ff1a46dbb657614a858c655501a2a5ba8521d3383389b5e7391cf412a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d2543b6ff1a46dbb657614a858c655501a2a5ba8521d3383389b5e7391cf412a.mp3',
          name: 'BEG-INT-ADV-Ab_Corkscrew-EXERCISE.mp3',
          description: null,
          size: 24946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Ab_Corkscrew-EXERCISE': {
      id: 435,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Ab Corkscrew',
      short_name: 'Ab Corkscrew',
      unique_name: 'INTERMEDIATE-Ab_Corkscrew-EXERCISE',
      description:
        '1. Lie on your back with palms flat on the floor. Bring your legs up directly over your hips. Legs together, knees bent, feet flexed and core engaged.\n2. Shift your hips to one side and lift off the floor, pointing knees and toes to the other side. Move legs in a corkscrew motion toward the ceiling.\n3. Lower with control back to start and repeat in the opposite direction. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 917,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '69ef37759a7fe9b0292b9222d8f263efac7f34ed0e01dca9b7d409d92d7650b8',
          file_name:
            'videos/69ef37759a7fe9b0292b9222d8f263efac7f34ed0e01dca9b7d409d92d7650b8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/69ef37759a7fe9b0292b9222d8f263efac7f34ed0e01dca9b7d409d92d7650b8.mp4',
          name: 'BEG-INT-ADV-Ab_Corkscrew-EXERCISE.mp4',
          description: null,
          size: 112447,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 918,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'd2543b6ff1a46dbb657614a858c655501a2a5ba8521d3383389b5e7391cf412a',
          file_name:
            'audios/d2543b6ff1a46dbb657614a858c655501a2a5ba8521d3383389b5e7391cf412a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d2543b6ff1a46dbb657614a858c655501a2a5ba8521d3383389b5e7391cf412a.mp3',
          name: 'BEG-INT-ADV-Ab_Corkscrew-EXERCISE.mp3',
          description: null,
          size: 24946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Ab_Corkscrew-EXERCISE': {
      id: 436,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Ab Corkscrew',
      short_name: 'Ab Corkscrew',
      unique_name: 'ADVANCED-Ab_Corkscrew-EXERCISE',
      description:
        '1. Lie on your back with palms flat on the floor. Bring your legs up directly over your hips. Legs together, knees bent, feet flexed and core engaged.\n2. Shift your hips to one side and lift off the floor, pointing knees and toes to the other side. Move legs in a corkscrew motion toward the ceiling.\n3. Lower with control back to start and repeat in the opposite direction. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 919,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '69ef37759a7fe9b0292b9222d8f263efac7f34ed0e01dca9b7d409d92d7650b8',
          file_name:
            'videos/69ef37759a7fe9b0292b9222d8f263efac7f34ed0e01dca9b7d409d92d7650b8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/69ef37759a7fe9b0292b9222d8f263efac7f34ed0e01dca9b7d409d92d7650b8.mp4',
          name: 'BEG-INT-ADV-Ab_Corkscrew-EXERCISE.mp4',
          description: null,
          size: 112447,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 920,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'd2543b6ff1a46dbb657614a858c655501a2a5ba8521d3383389b5e7391cf412a',
          file_name:
            'audios/d2543b6ff1a46dbb657614a858c655501a2a5ba8521d3383389b5e7391cf412a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d2543b6ff1a46dbb657614a858c655501a2a5ba8521d3383389b5e7391cf412a.mp3',
          name: 'BEG-INT-ADV-Ab_Corkscrew-EXERCISE.mp3',
          description: null,
          size: 24946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Crunches_with_Under-Knee_Clap-EXERCISE': {
      id: 437,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Crunches with Under-Knee Clap',
      short_name: 'Crunches with Under-Knee Clap',
      unique_name: 'BEGINNER-Crunches_with_Under-Knee_Clap-EXERCISE',
      description:
        '1. Start seated, knees bent, feet flat on the floor. Keeping your chest up, lean back to about a 45 degree angle, arms outstretched in front of you.\n2. Pick one foot off the floor, bringing your knee closer to your chest and lift your upper body back up to sit tall. Clap both hands underneath the lifted knee.\n3. Lower your back down to start position and repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 921,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'b887d83e68db1abc0947ece3aea75f00820432e5ad7322a48fad31c5f529466e',
          file_name:
            'videos/b887d83e68db1abc0947ece3aea75f00820432e5ad7322a48fad31c5f529466e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b887d83e68db1abc0947ece3aea75f00820432e5ad7322a48fad31c5f529466e.mp4',
          name: 'BEG-INT-ADV-Crunches_with_Under-Knee_Clap-EXERCISE.mp4',
          description: null,
          size: 93802,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 922,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '864d5e0d648d67f7b3a8effdf8e6623fea69eef84e8e442a2a2bc452ce98bcde',
          file_name:
            'audios/864d5e0d648d67f7b3a8effdf8e6623fea69eef84e8e442a2a2bc452ce98bcde.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/864d5e0d648d67f7b3a8effdf8e6623fea69eef84e8e442a2a2bc452ce98bcde.mp3',
          name: 'BEG-INT-ADV-Crunches_with_Under-Knee_Clap-EXERCISE.mp3',
          description: null,
          size: 33096,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Crunches_with_Under-Knee_Clap-EXERCISE': {
      id: 438,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Crunches with Under-Knee Clap',
      short_name: 'Crunches with Under-Knee Clap',
      unique_name: 'INTERMEDIATE-Crunches_with_Under-Knee_Clap-EXERCISE',
      description:
        '1. Start seated, knees bent, feet flat on the floor. Keeping your chest up, lean back to about a 45 degree angle, arms outstretched in front of you.\n2. Pick one foot off the floor, bringing your knee closer to your chest and lift your upper body back up to sit tall. Clap both hands underneath the lifted knee.\n3. Lower your back down to start position and repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 923,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'b887d83e68db1abc0947ece3aea75f00820432e5ad7322a48fad31c5f529466e',
          file_name:
            'videos/b887d83e68db1abc0947ece3aea75f00820432e5ad7322a48fad31c5f529466e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b887d83e68db1abc0947ece3aea75f00820432e5ad7322a48fad31c5f529466e.mp4',
          name: 'BEG-INT-ADV-Crunches_with_Under-Knee_Clap-EXERCISE.mp4',
          description: null,
          size: 93802,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 924,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '864d5e0d648d67f7b3a8effdf8e6623fea69eef84e8e442a2a2bc452ce98bcde',
          file_name:
            'audios/864d5e0d648d67f7b3a8effdf8e6623fea69eef84e8e442a2a2bc452ce98bcde.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/864d5e0d648d67f7b3a8effdf8e6623fea69eef84e8e442a2a2bc452ce98bcde.mp3',
          name: 'BEG-INT-ADV-Crunches_with_Under-Knee_Clap-EXERCISE.mp3',
          description: null,
          size: 33096,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Crunches_with_Under-Knee_Clap-EXERCISE': {
      id: 439,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Crunches with Under-Knee Clap',
      short_name: 'Crunches with Under-Knee Clap',
      unique_name: 'ADVANCED-Crunches_with_Under-Knee_Clap-EXERCISE',
      description:
        '1. Start seated, knees bent, feet flat on the floor. Keeping your chest up, lean back to about a 45 degree angle, arms outstretched in front of you.\n2. Pick one foot off the floor, bringing your knee closer to your chest and lift your upper body back up to sit tall. Clap both hands underneath the lifted knee.\n3. Lower your back down to start position and repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 925,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'b887d83e68db1abc0947ece3aea75f00820432e5ad7322a48fad31c5f529466e',
          file_name:
            'videos/b887d83e68db1abc0947ece3aea75f00820432e5ad7322a48fad31c5f529466e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b887d83e68db1abc0947ece3aea75f00820432e5ad7322a48fad31c5f529466e.mp4',
          name: 'BEG-INT-ADV-Crunches_with_Under-Knee_Clap-EXERCISE.mp4',
          description: null,
          size: 93802,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 926,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '864d5e0d648d67f7b3a8effdf8e6623fea69eef84e8e442a2a2bc452ce98bcde',
          file_name:
            'audios/864d5e0d648d67f7b3a8effdf8e6623fea69eef84e8e442a2a2bc452ce98bcde.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/864d5e0d648d67f7b3a8effdf8e6623fea69eef84e8e442a2a2bc452ce98bcde.mp3',
          name: 'BEG-INT-ADV-Crunches_with_Under-Knee_Clap-EXERCISE.mp3',
          description: null,
          size: 33096,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Forearm_Plank_Knee_to_Triceps-EXERCISE': {
      id: 440,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Forearm Plank Knee to Triceps',
      short_name: 'Forearm Plank Knee to Triceps',
      unique_name: 'BEGINNER-Forearm_Plank_Knee_to_Triceps-EXERCISE',
      description:
        '1. Start in Forearm Plank with shoulders over elbows and palms flat. Keep your core tight and spine straight.\n2. Pick one foot off the floor, open up your hips and drive your knee up to the outside of your elbow on the same side to tap your tricep. Keep the other leg straight and engaged.\n3. With control, return to Forearm Plank and repeat with the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 933,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6e0263a93f7712c3d63d976a31ac4ca21fdef38a3a03d60cb065e26a8d4680f2',
          file_name:
            'videos/6e0263a93f7712c3d63d976a31ac4ca21fdef38a3a03d60cb065e26a8d4680f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6e0263a93f7712c3d63d976a31ac4ca21fdef38a3a03d60cb065e26a8d4680f2.mp4',
          name: 'BEG-INT-ADV-Forearm_Plank_Knee_to_Triceps-EXERCISE.mp4',
          description: null,
          size: 120013,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 934,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '75de55ef17a288182c63726fc2f0c3befb494579181d3270a7ee0c5c23bce2df',
          file_name:
            'audios/75de55ef17a288182c63726fc2f0c3befb494579181d3270a7ee0c5c23bce2df.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/75de55ef17a288182c63726fc2f0c3befb494579181d3270a7ee0c5c23bce2df.mp3',
          name: 'BEG-INT-ADV-Forearm_Plank_Knee_to_Triceps-EXERCISE.mp3',
          description: null,
          size: 40306,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Forearm_Plank_Knee_to_Triceps-EXERCISE': {
      id: 441,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Forearm Plank Knee to Triceps',
      short_name: 'Forearm Plank Knee to Triceps',
      unique_name: 'INTERMEDIATE-Forearm_Plank_Knee_to_Triceps-EXERCISE',
      description:
        '1. Start in Forearm Plank with shoulders over elbows and palms flat. Keep your core tight and spine straight.\n2. Pick one foot off the floor, open up your hips and drive your knee up to the outside of your elbow on the same side to tap your tricep. Keep the other leg straight and engaged.\n3. With control, return to Forearm Plank and repeat with the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 935,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6e0263a93f7712c3d63d976a31ac4ca21fdef38a3a03d60cb065e26a8d4680f2',
          file_name:
            'videos/6e0263a93f7712c3d63d976a31ac4ca21fdef38a3a03d60cb065e26a8d4680f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6e0263a93f7712c3d63d976a31ac4ca21fdef38a3a03d60cb065e26a8d4680f2.mp4',
          name: 'BEG-INT-ADV-Forearm_Plank_Knee_to_Triceps-EXERCISE.mp4',
          description: null,
          size: 120013,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 936,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '75de55ef17a288182c63726fc2f0c3befb494579181d3270a7ee0c5c23bce2df',
          file_name:
            'audios/75de55ef17a288182c63726fc2f0c3befb494579181d3270a7ee0c5c23bce2df.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/75de55ef17a288182c63726fc2f0c3befb494579181d3270a7ee0c5c23bce2df.mp3',
          name: 'BEG-INT-ADV-Forearm_Plank_Knee_to_Triceps-EXERCISE.mp3',
          description: null,
          size: 40306,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Forearm_Plank_Knee_to_Triceps-EXERCISE': {
      id: 442,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Forearm Plank Knee to Triceps',
      short_name: 'Forearm Plank Knee to Triceps',
      unique_name: 'ADVANCED-Forearm_Plank_Knee_to_Triceps-EXERCISE',
      description:
        '1. Start in Forearm Plank with shoulders over elbows and palms flat. Keep your core tight and spine straight.\n2. Pick one foot off the floor, open up your hips and drive your knee up to the outside of your elbow on the same side to tap your tricep. Keep the other leg straight and engaged.\n3. With control, return to Forearm Plank and repeat with the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 937,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '6e0263a93f7712c3d63d976a31ac4ca21fdef38a3a03d60cb065e26a8d4680f2',
          file_name:
            'videos/6e0263a93f7712c3d63d976a31ac4ca21fdef38a3a03d60cb065e26a8d4680f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6e0263a93f7712c3d63d976a31ac4ca21fdef38a3a03d60cb065e26a8d4680f2.mp4',
          name: 'BEG-INT-ADV-Forearm_Plank_Knee_to_Triceps-EXERCISE.mp4',
          description: null,
          size: 120013,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 938,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '75de55ef17a288182c63726fc2f0c3befb494579181d3270a7ee0c5c23bce2df',
          file_name:
            'audios/75de55ef17a288182c63726fc2f0c3befb494579181d3270a7ee0c5c23bce2df.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/75de55ef17a288182c63726fc2f0c3befb494579181d3270a7ee0c5c23bce2df.mp3',
          name: 'BEG-INT-ADV-Forearm_Plank_Knee_to_Triceps-EXERCISE.mp3',
          description: null,
          size: 40306,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating_Knee_to_Elbow_Twist-EXERCISE': {
      id: 443,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Alternating Knee to Elbow Twist',
      short_name: 'Alt. Knee to Elbow Twist',
      unique_name: 'BEGINNER-Alternating_Knee_to_Elbow_Twist-EXERCISE',
      description:
        '1. Stand tall with your feet shoulder-width apart, rest your hands behind your head and bring elbows out wide.\n2. Keeping your core tight, transfer all your weight into one leg and bring your other knee up to hip height.\n3. Rotate your torso toward the bent leg and tap your elbow to your knee.\n4. Return to start and repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 945,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'dace24d733526c2243155363ad9eda7a2e10cd33070e143d15f862acff350936',
          file_name:
            'videos/dace24d733526c2243155363ad9eda7a2e10cd33070e143d15f862acff350936.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dace24d733526c2243155363ad9eda7a2e10cd33070e143d15f862acff350936.mp4',
          name: 'BEGINNER-Alternating_Knee_to_Elbow_Twist-EXERCISE.mp4',
          description: null,
          size: 104970,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 946,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '89e1c9cdb39dd10cbe1110c6c52568a84f4804c249883366c36c7ac8099285f4',
          file_name:
            'audios/89e1c9cdb39dd10cbe1110c6c52568a84f4804c249883366c36c7ac8099285f4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/89e1c9cdb39dd10cbe1110c6c52568a84f4804c249883366c36c7ac8099285f4.mp3',
          name: 'BEGINNER-Alternating_Knee_to_Elbow_Twist-EXERCISE.mp3',
          description: null,
          size: 36858,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight_Tricep_Kickbacks_with_Rotation-EXERCISE': {
      id: 444,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bodyweight Tricep Kickbacks with Rotation',
      short_name: 'Tricep Kickbacks with Rotation',
      unique_name:
        'BEGINNER-Bodyweight_Tricep_Kickbacks_with_Rotation-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, knees slightly bent, core tight.\n2. Hinge at the waist until your torso is close to parallel to the floor. Bend elbows back behind you to 90 degrees. Bring fists to your hips, palms in.\n3. Extend your elbows and lift fists up and back behind you. Rotate fists toward the ceiling as you straighten your arms.\n4. Lower your fists back down to start position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 965,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '17fd6be85c08e5c3782a0ed8ceefa22e4f395dfc266c17d85fe98ed649b5b021',
          file_name:
            'videos/17fd6be85c08e5c3782a0ed8ceefa22e4f395dfc266c17d85fe98ed649b5b021.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/17fd6be85c08e5c3782a0ed8ceefa22e4f395dfc266c17d85fe98ed649b5b021.mp4',
          name: 'BEGINNER-Bodyweight_Tricep_Kickbacks_with_Rotation-EXERCISE.mp4',
          description: null,
          size: 51225,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 966,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '7a38d892bb59a4bf22e00bd884a5598d3ce2f7a124258033821c339606c0d3ad',
          file_name:
            'audios/7a38d892bb59a4bf22e00bd884a5598d3ce2f7a124258033821c339606c0d3ad.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7a38d892bb59a4bf22e00bd884a5598d3ce2f7a124258033821c339606c0d3ad.mp3',
          name: 'BEGINNER-Bodyweight_Tricep_Kickbacks_with_Rotation-EXERCISE.mp3',
          description: null,
          size: 45321,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE': {
      id: 445,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Tabletop Single Leg Glute Bridge',
      short_name: 'Reverse Tabletop Glute Bridge',
      unique_name: 'BEGINNER-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE',
      description:
        '1. Start in Reverse Table-Top position with your hands flat on the floor underneath your shoulders, fingers toward hips. Knees bent, stacked over ankles, and hips elevated in line with your shoulders.\n2. Raise one leg up to hip height, keeping your leg straight.\n3. Drop your hips toward the floor.\n4. Drive through your heel to raise hips up again, squeezing at the top.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 979,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '79fcf590fcb6cce4f2dd09e06ad0fdd44ee84d80f28761b03518e58a493def4c',
          file_name:
            'videos/79fcf590fcb6cce4f2dd09e06ad0fdd44ee84d80f28761b03518e58a493def4c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/79fcf590fcb6cce4f2dd09e06ad0fdd44ee84d80f28761b03518e58a493def4c.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 57825,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 980,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'fe9d94c3bb13c85de1201eb90cc9f70256f9468d074b87495bdc399d39dae4b2',
          file_name:
            'videos/fe9d94c3bb13c85de1201eb90cc9f70256f9468d074b87495bdc399d39dae4b2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fe9d94c3bb13c85de1201eb90cc9f70256f9468d074b87495bdc399d39dae4b2.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 55444,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 981,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'ad8649fa167221d2e74ee43cf6751e3252a8c9ca8fc4e1ecb9c153ff7172c59a',
          file_name:
            'audios/ad8649fa167221d2e74ee43cf6751e3252a8c9ca8fc4e1ecb9c153ff7172c59a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ad8649fa167221d2e74ee43cf6751e3252a8c9ca8fc4e1ecb9c153ff7172c59a.mp3',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE.mp3',
          description: null,
          size: 44694,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE': {
      id: 446,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Tabletop Single Leg Glute Bridge',
      short_name: 'Reverse Tabletop Glute Bridge',
      unique_name:
        'INTERMEDIATE-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE',
      description:
        '1. Start in Reverse Table-Top position with your hands flat on the floor underneath your shoulders, fingers toward hips. Knees bent, stacked over ankles, and hips elevated in line with your shoulders.\n2. Raise one leg up to hip height, keeping your leg straight.\n3. Drop your hips toward the floor.\n4. Drive through your heel to raise hips up again, squeezing at the top.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 982,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '79fcf590fcb6cce4f2dd09e06ad0fdd44ee84d80f28761b03518e58a493def4c',
          file_name:
            'videos/79fcf590fcb6cce4f2dd09e06ad0fdd44ee84d80f28761b03518e58a493def4c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/79fcf590fcb6cce4f2dd09e06ad0fdd44ee84d80f28761b03518e58a493def4c.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 57825,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 983,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'fe9d94c3bb13c85de1201eb90cc9f70256f9468d074b87495bdc399d39dae4b2',
          file_name:
            'videos/fe9d94c3bb13c85de1201eb90cc9f70256f9468d074b87495bdc399d39dae4b2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fe9d94c3bb13c85de1201eb90cc9f70256f9468d074b87495bdc399d39dae4b2.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 55444,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 984,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'ad8649fa167221d2e74ee43cf6751e3252a8c9ca8fc4e1ecb9c153ff7172c59a',
          file_name:
            'audios/ad8649fa167221d2e74ee43cf6751e3252a8c9ca8fc4e1ecb9c153ff7172c59a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ad8649fa167221d2e74ee43cf6751e3252a8c9ca8fc4e1ecb9c153ff7172c59a.mp3',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE.mp3',
          description: null,
          size: 44694,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE': {
      id: 447,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Tabletop Single Leg Glute Bridge',
      short_name: 'Reverse Tabletop Glute Bridge',
      unique_name: 'ADVANCED-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE',
      description:
        '1. Start in Reverse Table-Top position with your hands flat on the floor underneath your shoulders, fingers toward hips. Knees bent, stacked over ankles, and hips elevated in line with your shoulders.\n2. Raise one leg up to hip height, keeping your leg straight.\n3. Drop your hips toward the floor.\n4. Drive through your heel to raise hips up again, squeezing at the top.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 985,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '79fcf590fcb6cce4f2dd09e06ad0fdd44ee84d80f28761b03518e58a493def4c',
          file_name:
            'videos/79fcf590fcb6cce4f2dd09e06ad0fdd44ee84d80f28761b03518e58a493def4c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/79fcf590fcb6cce4f2dd09e06ad0fdd44ee84d80f28761b03518e58a493def4c.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 57825,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 986,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'fe9d94c3bb13c85de1201eb90cc9f70256f9468d074b87495bdc399d39dae4b2',
          file_name:
            'videos/fe9d94c3bb13c85de1201eb90cc9f70256f9468d074b87495bdc399d39dae4b2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fe9d94c3bb13c85de1201eb90cc9f70256f9468d074b87495bdc399d39dae4b2.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 55444,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 987,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'ad8649fa167221d2e74ee43cf6751e3252a8c9ca8fc4e1ecb9c153ff7172c59a',
          file_name:
            'audios/ad8649fa167221d2e74ee43cf6751e3252a8c9ca8fc4e1ecb9c153ff7172c59a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ad8649fa167221d2e74ee43cf6751e3252a8c9ca8fc4e1ecb9c153ff7172c59a.mp3',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Single_Leg_Glute_Bridge-EXERCISE.mp3',
          description: null,
          size: 44694,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Sit-Ups_with_Under-Knee_Clap-EXERCISE': {
      id: 448,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Sit-Ups with Under-Knee Clap',
      short_name: 'Sit-Ups with Under-Knee Clap',
      unique_name: 'BEGINNER-Sit-Ups_with_Under-Knee_Clap-EXERCISE',
      description:
        '1. Lie on your back, knees bent and feet flat on the floor. Keep your arms off the floor, reaching toward your feet.\n2. Engage your core and sit up tall as you pick one foot off the floor, bringing your knee closer to your chest. At the top, clap both hands underneath the lifted knee.\n3. Lower back down to start position and repeat on the other side. RIght and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 988,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '54c5ce533e72f893b63c0966d41a5d1fbe98cd8e25c423afa77b36a6e82419c4',
          file_name:
            'videos/54c5ce533e72f893b63c0966d41a5d1fbe98cd8e25c423afa77b36a6e82419c4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/54c5ce533e72f893b63c0966d41a5d1fbe98cd8e25c423afa77b36a6e82419c4.mp4',
          name: 'BEG-INT-ADV-Sit_Ups_with_Under-Knee_Clap-EXERCISE.mp4',
          description: null,
          size: 141743,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 989,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '3a56d951a45aef9823c56d1ff1045bae97c0e38d836f31ef4324227d2277fb59',
          file_name:
            'audios/3a56d951a45aef9823c56d1ff1045bae97c0e38d836f31ef4324227d2277fb59.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3a56d951a45aef9823c56d1ff1045bae97c0e38d836f31ef4324227d2277fb59.mp3',
          name: 'BEG-INT-ADV-Sit_Ups_with_Under-Knee_Clap-EXERCISE.mp3',
          description: null,
          size: 34663,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Sit-Ups_with_Under-Knee_Clap-EXERCISE': {
      id: 449,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Sit-Ups with Under-Knee Clap',
      short_name: 'Sit-Ups with Under-Knee Clap',
      unique_name: 'INTERMEDIATE-Sit-Ups_with_Under-Knee_Clap-EXERCISE',
      description:
        '1. Lie on your back, knees bent and feet flat on the floor. Keep your arms off the floor, reaching toward your feet.\n2. Engage your core and sit up tall as you pick one foot off the floor, bringing your knee closer to your chest. At the top, clap both hands underneath the lifted knee.\n3. Lower back down to start position and repeat on the other side. RIght and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 990,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '54c5ce533e72f893b63c0966d41a5d1fbe98cd8e25c423afa77b36a6e82419c4',
          file_name:
            'videos/54c5ce533e72f893b63c0966d41a5d1fbe98cd8e25c423afa77b36a6e82419c4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/54c5ce533e72f893b63c0966d41a5d1fbe98cd8e25c423afa77b36a6e82419c4.mp4',
          name: 'BEG-INT-ADV-Sit_Ups_with_Under-Knee_Clap-EXERCISE.mp4',
          description: null,
          size: 141743,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 991,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '3a56d951a45aef9823c56d1ff1045bae97c0e38d836f31ef4324227d2277fb59',
          file_name:
            'audios/3a56d951a45aef9823c56d1ff1045bae97c0e38d836f31ef4324227d2277fb59.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3a56d951a45aef9823c56d1ff1045bae97c0e38d836f31ef4324227d2277fb59.mp3',
          name: 'BEG-INT-ADV-Sit_Ups_with_Under-Knee_Clap-EXERCISE.mp3',
          description: null,
          size: 34663,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Sit-Ups_with_Under-Knee_Clap-EXERCISE': {
      id: 450,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Sit-Ups with Under-Knee Clap',
      short_name: 'Sit-Ups with Under-Knee Clap',
      unique_name: 'ADVANCED-Sit-Ups_with_Under-Knee_Clap-EXERCISE',
      description:
        '1. Lie on your back, knees bent and feet flat on the floor. Keep your arms off the floor, reaching toward your feet.\n2. Engage your core and sit up tall as you pick one foot off the floor, bringing your knee closer to your chest. At the top, clap both hands underneath the lifted knee.\n3. Lower back down to start position and repeat on the other side. RIght and left equals one rep.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 992,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '54c5ce533e72f893b63c0966d41a5d1fbe98cd8e25c423afa77b36a6e82419c4',
          file_name:
            'videos/54c5ce533e72f893b63c0966d41a5d1fbe98cd8e25c423afa77b36a6e82419c4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/54c5ce533e72f893b63c0966d41a5d1fbe98cd8e25c423afa77b36a6e82419c4.mp4',
          name: 'BEG-INT-ADV-Sit_Ups_with_Under-Knee_Clap-EXERCISE.mp4',
          description: null,
          size: 141743,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 993,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '3a56d951a45aef9823c56d1ff1045bae97c0e38d836f31ef4324227d2277fb59',
          file_name:
            'audios/3a56d951a45aef9823c56d1ff1045bae97c0e38d836f31ef4324227d2277fb59.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3a56d951a45aef9823c56d1ff1045bae97c0e38d836f31ef4324227d2277fb59.mp3',
          name: 'BEG-INT-ADV-Sit_Ups_with_Under-Knee_Clap-EXERCISE.mp3',
          description: null,
          size: 34663,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Forearm_Plank_Saw-EXERCISE': {
      id: 451,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Forearm Plank Saw',
      short_name: 'Forearm Plank Saw',
      unique_name: 'BEGINNER-Forearm_Plank_Saw-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, clasp hands together resting on the floor, nose over thumbs.\n2. Maintaining a long spine and tight core, push through your toes and shift your weight forward until your chin is past your fists or as far as possible.\n3. With control, shift your weight back to start position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 994,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'c8f520a8729b09b2c7a1cd492fdf0b54a675eb6455a15370ea58d3c52b8d02fb',
          file_name:
            'videos/c8f520a8729b09b2c7a1cd492fdf0b54a675eb6455a15370ea58d3c52b8d02fb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c8f520a8729b09b2c7a1cd492fdf0b54a675eb6455a15370ea58d3c52b8d02fb.mp4',
          name: 'BEG-INT-ADV-Forearm_Plank_Saw-EXERCISE.mp4',
          description: null,
          size: 55934,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 995,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '93db3241ae09620910c8675341974f698f6b31917e73cf75fb526479e82796f8',
          file_name:
            'audios/93db3241ae09620910c8675341974f698f6b31917e73cf75fb526479e82796f8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/93db3241ae09620910c8675341974f698f6b31917e73cf75fb526479e82796f8.mp3',
          name: 'BEG-INT-ADV-Forearm_Plank_Saw-EXERCISE.mp3',
          description: null,
          size: 25886,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Forearm_Plank_Saw-EXERCISE': {
      id: 452,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Forearm Plank Saw',
      short_name: 'Forearm Plank Saw',
      unique_name: 'INTERMEDIATE-Forearm_Plank_Saw-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, clasp hands together resting on the floor, nose over thumbs.\n2. Maintaining a long spine and tight core, push through your toes and shift your weight forward until your chin is past your fists or as far as possible.\n3. With control, shift your weight back to start position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 996,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'c8f520a8729b09b2c7a1cd492fdf0b54a675eb6455a15370ea58d3c52b8d02fb',
          file_name:
            'videos/c8f520a8729b09b2c7a1cd492fdf0b54a675eb6455a15370ea58d3c52b8d02fb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c8f520a8729b09b2c7a1cd492fdf0b54a675eb6455a15370ea58d3c52b8d02fb.mp4',
          name: 'BEG-INT-ADV-Forearm_Plank_Saw-EXERCISE.mp4',
          description: null,
          size: 55934,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 997,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '93db3241ae09620910c8675341974f698f6b31917e73cf75fb526479e82796f8',
          file_name:
            'audios/93db3241ae09620910c8675341974f698f6b31917e73cf75fb526479e82796f8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/93db3241ae09620910c8675341974f698f6b31917e73cf75fb526479e82796f8.mp3',
          name: 'BEG-INT-ADV-Forearm_Plank_Saw-EXERCISE.mp3',
          description: null,
          size: 25886,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Forearm_Plank_Saw-EXERCISE': {
      id: 453,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Forearm Plank Saw',
      short_name: 'Forearm Plank Saw',
      unique_name: 'ADVANCED-Forearm_Plank_Saw-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, clasp hands together resting on the floor, nose over thumbs.\n2. Maintaining a long spine and tight core, push through your toes and shift your weight forward until your chin is past your fists or as far as possible.\n3. With control, shift your weight back to start position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 998,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'c8f520a8729b09b2c7a1cd492fdf0b54a675eb6455a15370ea58d3c52b8d02fb',
          file_name:
            'videos/c8f520a8729b09b2c7a1cd492fdf0b54a675eb6455a15370ea58d3c52b8d02fb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c8f520a8729b09b2c7a1cd492fdf0b54a675eb6455a15370ea58d3c52b8d02fb.mp4',
          name: 'BEG-INT-ADV-Forearm_Plank_Saw-EXERCISE.mp4',
          description: null,
          size: 55934,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 999,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '93db3241ae09620910c8675341974f698f6b31917e73cf75fb526479e82796f8',
          file_name:
            'audios/93db3241ae09620910c8675341974f698f6b31917e73cf75fb526479e82796f8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/93db3241ae09620910c8675341974f698f6b31917e73cf75fb526479e82796f8.mp3',
          name: 'BEG-INT-ADV-Forearm_Plank_Saw-EXERCISE.mp3',
          description: null,
          size: 25886,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Forearm_Plank_with_Alternating_Knee_Drops-EXERCISE': {
      id: 454,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Forearm Plank with Alternating Knee Drops',
      short_name: 'Forearm Plank w. Knee Drops',
      unique_name:
        'BEGINNER-Forearm_Plank_with_Alternating_Knee_Drops-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat.\n2. Maintaining a long spine and tight core, drop one knee toward the floor and lightly tap. Keep other leg straight and engaged.\n3. Return to start and repeat with the other knee. Right and left equals one rep. ',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1000,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '8b62c2c39b1039f0e4e289a4f6cfe43b8a691bb944dd91d00cf35583433a7475',
          file_name:
            'videos/8b62c2c39b1039f0e4e289a4f6cfe43b8a691bb944dd91d00cf35583433a7475.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8b62c2c39b1039f0e4e289a4f6cfe43b8a691bb944dd91d00cf35583433a7475.mp4',
          name: 'BEG-INT-ADV-Forearm_Plank_with_Alternating_Knee_Drops-EXERCISE.mp4',
          description: null,
          size: 45838,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1001,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '67c39e3130d33aafcbf17aba09590465e813198696db0577ae75aa512dde8b6a',
          file_name:
            'audios/67c39e3130d33aafcbf17aba09590465e813198696db0577ae75aa512dde8b6a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/67c39e3130d33aafcbf17aba09590465e813198696db0577ae75aa512dde8b6a.mp3',
          name: 'BEG-INT-ADV-Forearm_Plank_with_Alternating_Knee_Drops-EXERCISE.mp3',
          description: null,
          size: 41560,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Forearm_Plank_with_Alternating_Knee_Drops-EXERCISE': {
      id: 455,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Forearm Plank with Alternating Knee Drops',
      short_name: 'Forearm Plank w. Knee Drops',
      unique_name:
        'INTERMEDIATE-Forearm_Plank_with_Alternating_Knee_Drops-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat.\n2. Maintaining a long spine and tight core, drop one knee toward the floor and lightly tap. Keep other leg straight and engaged.\n3. Return to start and repeat with the other knee. Right and left equals one rep. ',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1002,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '8b62c2c39b1039f0e4e289a4f6cfe43b8a691bb944dd91d00cf35583433a7475',
          file_name:
            'videos/8b62c2c39b1039f0e4e289a4f6cfe43b8a691bb944dd91d00cf35583433a7475.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8b62c2c39b1039f0e4e289a4f6cfe43b8a691bb944dd91d00cf35583433a7475.mp4',
          name: 'BEG-INT-ADV-Forearm_Plank_with_Alternating_Knee_Drops-EXERCISE.mp4',
          description: null,
          size: 45838,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1003,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '67c39e3130d33aafcbf17aba09590465e813198696db0577ae75aa512dde8b6a',
          file_name:
            'audios/67c39e3130d33aafcbf17aba09590465e813198696db0577ae75aa512dde8b6a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/67c39e3130d33aafcbf17aba09590465e813198696db0577ae75aa512dde8b6a.mp3',
          name: 'BEG-INT-ADV-Forearm_Plank_with_Alternating_Knee_Drops-EXERCISE.mp3',
          description: null,
          size: 41560,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Forearm_Plank_with_Alternating_Knee_Drops-EXERCISE': {
      id: 456,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Forearm Plank with Alternating Knee Drops',
      short_name: 'Forearm Plank w. Knee Drops',
      unique_name:
        'ADVANCED-Forearm_Plank_with_Alternating_Knee_Drops-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat.\n2. Maintaining a long spine and tight core, drop one knee toward the floor and lightly tap. Keep other leg straight and engaged.\n3. Return to start and repeat with the other knee. Right and left equals one rep. ',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1004,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '8b62c2c39b1039f0e4e289a4f6cfe43b8a691bb944dd91d00cf35583433a7475',
          file_name:
            'videos/8b62c2c39b1039f0e4e289a4f6cfe43b8a691bb944dd91d00cf35583433a7475.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8b62c2c39b1039f0e4e289a4f6cfe43b8a691bb944dd91d00cf35583433a7475.mp4',
          name: 'BEG-INT-ADV-Forearm_Plank_with_Alternating_Knee_Drops-EXERCISE.mp4',
          description: null,
          size: 45838,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1005,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '67c39e3130d33aafcbf17aba09590465e813198696db0577ae75aa512dde8b6a',
          file_name:
            'audios/67c39e3130d33aafcbf17aba09590465e813198696db0577ae75aa512dde8b6a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/67c39e3130d33aafcbf17aba09590465e813198696db0577ae75aa512dde8b6a.mp3',
          name: 'BEG-INT-ADV-Forearm_Plank_with_Alternating_Knee_Drops-EXERCISE.mp3',
          description: null,
          size: 41560,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Squats_with_Pulse-EXERCISE': {
      id: 457,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Squats with Pulse',
      short_name: 'Squats with Pulse',
      unique_name: 'INTERMEDIATE-Squats_with_Pulse-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Perform one pulse by straightening your legs to come up about half way, then lower back down to the bottom of the squat.\n4. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1024,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '2104324a33b44fff906aa0947f9c64112e283a45fbc30790215dd4c0bcee5907',
          file_name:
            'videos/2104324a33b44fff906aa0947f9c64112e283a45fbc30790215dd4c0bcee5907.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2104324a33b44fff906aa0947f9c64112e283a45fbc30790215dd4c0bcee5907.mp4',
          name: 'INT-ADV-Squats_with_Pulse-EXERCISE.mp4',
          description: null,
          size: 84913,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1025,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '0334a3fb2e35b9a2c28ff2688a4a08c46e41524b57c00ef956616f3dd6b4203c',
          file_name:
            'audios/0334a3fb2e35b9a2c28ff2688a4a08c46e41524b57c00ef956616f3dd6b4203c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0334a3fb2e35b9a2c28ff2688a4a08c46e41524b57c00ef956616f3dd6b4203c.mp3',
          name: 'INT-ADV-Squats_with_Pulse-EXERCISE.mp3',
          description: null,
          size: 23692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Squats_with_Pulse-EXERCISE': {
      id: 458,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Squats with Pulse',
      short_name: 'Squats with Pulse',
      unique_name: 'ADVANCED-Squats_with_Pulse-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Perform one pulse by straightening your legs to come up about half way, then lower back down to the bottom of the squat.\n4. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1026,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '2104324a33b44fff906aa0947f9c64112e283a45fbc30790215dd4c0bcee5907',
          file_name:
            'videos/2104324a33b44fff906aa0947f9c64112e283a45fbc30790215dd4c0bcee5907.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2104324a33b44fff906aa0947f9c64112e283a45fbc30790215dd4c0bcee5907.mp4',
          name: 'INT-ADV-Squats_with_Pulse-EXERCISE.mp4',
          description: null,
          size: 84913,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1027,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '0334a3fb2e35b9a2c28ff2688a4a08c46e41524b57c00ef956616f3dd6b4203c',
          file_name:
            'audios/0334a3fb2e35b9a2c28ff2688a4a08c46e41524b57c00ef956616f3dd6b4203c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0334a3fb2e35b9a2c28ff2688a4a08c46e41524b57c00ef956616f3dd6b4203c.mp3',
          name: 'INT-ADV-Squats_with_Pulse-EXERCISE.mp3',
          description: null,
          size: 23692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Sumo_Squat_Side_Bends-EXERCISE': {
      id: 459,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Sumo Squat Side Bends',
      short_name: 'Sumo Squat Side Bends',
      unique_name: 'BEGINNER-Sumo_Squat_Side_Bends-EXERCISE',
      description:
        '1. Start with feet wider than shoulder-width apart, toes turned out.\n2. Bend knees and sink hips back into a sumo squat with arms down behind legs.\n3. Keep your chest up, core engaged and hips square. Tilt your upper body to one side, closing the gap between your hips and lower ribcage as your arm reaches toward the floor.\n4. Using core, return to start position. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1028,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: 'e0efb70e5c4ae712289194a1bc7f6ab9ef8fdaeeaf437ec4857dfe2c62626523',
          file_name:
            'videos/e0efb70e5c4ae712289194a1bc7f6ab9ef8fdaeeaf437ec4857dfe2c62626523.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e0efb70e5c4ae712289194a1bc7f6ab9ef8fdaeeaf437ec4857dfe2c62626523.mp4',
          name: 'BEGINNER-Sumo_Squat_Side_Bends-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 61035,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1029,
          collection_name: 'videos',
          order: 2,
          version: 200010000,
          hash: 'f51a9deed2847f84cf8eee76a42959e17eb2bbf1abf6b7abc6451b97d0549cf6',
          file_name:
            'videos/f51a9deed2847f84cf8eee76a42959e17eb2bbf1abf6b7abc6451b97d0549cf6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f51a9deed2847f84cf8eee76a42959e17eb2bbf1abf6b7abc6451b97d0549cf6.mp4',
          name: 'BEGINNER-Sumo_Squat_Side_Bends-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 62437,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1030,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: 'e13cdc92363f84c48f1eac638ac3d0217ddf47ef38224bd727f6891bef5b0141',
          file_name:
            'audios/e13cdc92363f84c48f1eac638ac3d0217ddf47ef38224bd727f6891bef5b0141.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e13cdc92363f84c48f1eac638ac3d0217ddf47ef38224bd727f6891bef5b0141.mp3',
          name: 'BEGINNER-Sumo_Squat_Side_Bends-EXERCISE.mp3',
          description: null,
          size: 29325,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Sumo_Squats_with_Pulse-EXERCISE': {
      id: 460,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Sumo Squats with Pulse',
      short_name: 'Sumo Squats with Pulse',
      unique_name: 'BEGINNER-Sumo_Squats_with_Pulse-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointed out and arms in front of your body, palms together.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up, shoulders back and knees wide.\n3. Drive through your heels and return to stand.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1031,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '8e23b863af9f0107025500feb151ab18b93b01950448b2817e4d710ddb6a2001',
          file_name:
            'videos/8e23b863af9f0107025500feb151ab18b93b01950448b2817e4d710ddb6a2001.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8e23b863af9f0107025500feb151ab18b93b01950448b2817e4d710ddb6a2001.mp4',
          name: 'BEG-INT-ADV-Sumo_Squats_with_Pulse-EXERCISE.mp4',
          description: null,
          size: 101478,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1032,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '6da23f6828c71448b36da42a0014fb98cba014d24cc89df1c71464ca0dfbc2a5',
          file_name:
            'audios/6da23f6828c71448b36da42a0014fb98cba014d24cc89df1c71464ca0dfbc2a5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6da23f6828c71448b36da42a0014fb98cba014d24cc89df1c71464ca0dfbc2a5.mp3',
          name: 'BEG-INT-ADV-Sumo_Squats_with_Pulse-EXERCISE.mp3',
          description: null,
          size: 40633,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Sumo_Squats_with_Pulse-EXERCISE': {
      id: 461,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Sumo Squats with Pulse',
      short_name: 'Sumo Squats with Pulse',
      unique_name: 'INTERMEDIATE-Sumo_Squats_with_Pulse-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointed out and arms in front of your body, palms together.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up, shoulders back and knees wide.\n3. Drive through your heels and return to stand.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1033,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '8e23b863af9f0107025500feb151ab18b93b01950448b2817e4d710ddb6a2001',
          file_name:
            'videos/8e23b863af9f0107025500feb151ab18b93b01950448b2817e4d710ddb6a2001.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8e23b863af9f0107025500feb151ab18b93b01950448b2817e4d710ddb6a2001.mp4',
          name: 'BEG-INT-ADV-Sumo_Squats_with_Pulse-EXERCISE.mp4',
          description: null,
          size: 101478,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1034,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '6da23f6828c71448b36da42a0014fb98cba014d24cc89df1c71464ca0dfbc2a5',
          file_name:
            'audios/6da23f6828c71448b36da42a0014fb98cba014d24cc89df1c71464ca0dfbc2a5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6da23f6828c71448b36da42a0014fb98cba014d24cc89df1c71464ca0dfbc2a5.mp3',
          name: 'BEG-INT-ADV-Sumo_Squats_with_Pulse-EXERCISE.mp3',
          description: null,
          size: 40633,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Sumo_Squats_with_Pulse-EXERCISE': {
      id: 462,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Sumo Squats with Pulse',
      short_name: 'Sumo Squats with Pulse',
      unique_name: 'ADVANCED-Sumo_Squats_with_Pulse-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointed out and arms in front of your body, palms together.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up, shoulders back and knees wide.\n3. Drive through your heels and return to stand.',
      preview_time: 10,
      min_app_version: 200010000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1035,
          collection_name: 'videos',
          order: 1,
          version: 200010000,
          hash: '8e23b863af9f0107025500feb151ab18b93b01950448b2817e4d710ddb6a2001',
          file_name:
            'videos/8e23b863af9f0107025500feb151ab18b93b01950448b2817e4d710ddb6a2001.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8e23b863af9f0107025500feb151ab18b93b01950448b2817e4d710ddb6a2001.mp4',
          name: 'BEG-INT-ADV-Sumo_Squats_with_Pulse-EXERCISE.mp4',
          description: null,
          size: 101478,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1036,
          collection_name: 'audios',
          order: 1,
          version: 200010000,
          hash: '6da23f6828c71448b36da42a0014fb98cba014d24cc89df1c71464ca0dfbc2a5',
          file_name:
            'audios/6da23f6828c71448b36da42a0014fb98cba014d24cc89df1c71464ca0dfbc2a5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6da23f6828c71448b36da42a0014fb98cba014d24cc89df1c71464ca0dfbc2a5.mp3',
          name: 'BEG-INT-ADV-Sumo_Squats_with_Pulse-EXERCISE.mp3',
          description: null,
          size: 40633,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Alternating_Single_Leg_Drop-EXERCISE': {
      id: 526,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Alternating Single Leg Drop',
      short_name: 'Alternating Single Leg Drop',
      unique_name: 'BEGINNER-Alternating_Single_Leg_Drop-EXERCISE',
      description:
        '1. Lie on your back. Place your arms by your sides, palms facing down. Bend both knees and lift them off the floor until your knees are directly over your hips.\n2. Engage your core and tuck your pelvis so you maintain a connection between your low back and the floor.\n3. Lower one leg toward the floor until your toe slightly taps.\n4. Return to start and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1164,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '5786366af03042baaa693246b9ce8a4641a5379adf8b415bde59a6089ee8e9bd',
          file_name:
            'videos/5786366af03042baaa693246b9ce8a4641a5379adf8b415bde59a6089ee8e9bd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5786366af03042baaa693246b9ce8a4641a5379adf8b415bde59a6089ee8e9bd.mp4',
          name: 'BEGINNER-Alternating_Single_Leg_Drop-EXERCISE.mp4',
          description: null,
          size: 75829,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1165,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '8cb2413cabd2d1429ef960c81307ce0b159e00ac3275951f067b58f23bd1c215',
          file_name:
            'audios/8cb2413cabd2d1429ef960c81307ce0b159e00ac3275951f067b58f23bd1c215.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8cb2413cabd2d1429ef960c81307ce0b159e00ac3275951f067b58f23bd1c215.mp3',
          name: 'BEGINNER-Alternating_Single_Leg_Drop-EXERCISE.mp3',
          description: null,
          size: 31842,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Ankle_Biters-EXERCISE': {
      id: 527,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Ankle Biters',
      short_name: 'Ankle Biters',
      unique_name: 'BEGINNER-Ankle_Biters-EXERCISE',
      description:
        '1. Lie on your back, knees bent hip-width apart, feet flat on the floor, arms by your sides.\n2. Engage core and crunch up so shoulders, neck, head and arms are off the floor. Leave space between chin and chest.\n3. Keeping your upper body off the floor and arms straight, tilt directly to one side to tap the back of heel.\n4. Immediately tilt in the opposite direction to tap the opposite heel. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1172,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'e7d566e7f3707378a441cd8ee7ad6b0984f7cb9dd972ed910617284cd1eef4e7',
          file_name:
            'videos/e7d566e7f3707378a441cd8ee7ad6b0984f7cb9dd972ed910617284cd1eef4e7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e7d566e7f3707378a441cd8ee7ad6b0984f7cb9dd972ed910617284cd1eef4e7.mp4',
          name: 'BEG-INT-ADV-Ankle_Biters-EXERCISE.mp4',
          description: null,
          size: 32427,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1173,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '7d5498d3833d8ede688db0056c8cd5e8b53efda5ab61b0ed58013a4da496a3a4',
          file_name:
            'audios/7d5498d3833d8ede688db0056c8cd5e8b53efda5ab61b0ed58013a4da496a3a4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7d5498d3833d8ede688db0056c8cd5e8b53efda5ab61b0ed58013a4da496a3a4.mp3',
          name: 'BEG-INT-ADV-Ankle_Biters-EXERCISE.mp3',
          description: null,
          size: 21498,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Ankle_Biters-EXERCISE': {
      id: 528,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Ankle Biters',
      short_name: 'Ankle Biters',
      unique_name: 'INTERMEDIATE-Ankle_Biters-EXERCISE',
      description:
        '1. Lie on your back, knees bent hip-width apart, feet flat on the floor, arms by your sides.\n2. Engage core and crunch up so shoulders, neck, head and arms are off the floor. Leave space between chin and chest.\n3. Keeping your upper body off the floor and arms straight, tilt directly to one side to tap the back of heel.\n4. Immediately tilt in the opposite direction to tap the opposite heel. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1174,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'e7d566e7f3707378a441cd8ee7ad6b0984f7cb9dd972ed910617284cd1eef4e7',
          file_name:
            'videos/e7d566e7f3707378a441cd8ee7ad6b0984f7cb9dd972ed910617284cd1eef4e7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e7d566e7f3707378a441cd8ee7ad6b0984f7cb9dd972ed910617284cd1eef4e7.mp4',
          name: 'BEG-INT-ADV-Ankle_Biters-EXERCISE.mp4',
          description: null,
          size: 32427,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1175,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '7d5498d3833d8ede688db0056c8cd5e8b53efda5ab61b0ed58013a4da496a3a4',
          file_name:
            'audios/7d5498d3833d8ede688db0056c8cd5e8b53efda5ab61b0ed58013a4da496a3a4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7d5498d3833d8ede688db0056c8cd5e8b53efda5ab61b0ed58013a4da496a3a4.mp3',
          name: 'BEG-INT-ADV-Ankle_Biters-EXERCISE.mp3',
          description: null,
          size: 21498,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Ankle_Biters-EXERCISE': {
      id: 529,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Ankle Biters',
      short_name: 'Ankle Biters',
      unique_name: 'ADVANCED-Ankle_Biters-EXERCISE',
      description:
        '1. Lie on your back, knees bent hip-width apart, feet flat on the floor, arms by your sides.\n2. Engage core and crunch up so shoulders, neck, head and arms are off the floor. Leave space between chin and chest.\n3. Keeping your upper body off the floor and arms straight, tilt directly to one side to tap the back of heel.\n4. Immediately tilt in the opposite direction to tap the opposite heel. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1176,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'e7d566e7f3707378a441cd8ee7ad6b0984f7cb9dd972ed910617284cd1eef4e7',
          file_name:
            'videos/e7d566e7f3707378a441cd8ee7ad6b0984f7cb9dd972ed910617284cd1eef4e7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e7d566e7f3707378a441cd8ee7ad6b0984f7cb9dd972ed910617284cd1eef4e7.mp4',
          name: 'BEG-INT-ADV-Ankle_Biters-EXERCISE.mp4',
          description: null,
          size: 32427,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1177,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '7d5498d3833d8ede688db0056c8cd5e8b53efda5ab61b0ed58013a4da496a3a4',
          file_name:
            'audios/7d5498d3833d8ede688db0056c8cd5e8b53efda5ab61b0ed58013a4da496a3a4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7d5498d3833d8ede688db0056c8cd5e8b53efda5ab61b0ed58013a4da496a3a4.mp3',
          name: 'BEG-INT-ADV-Ankle_Biters-EXERCISE.mp3',
          description: null,
          size: 21498,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Apple_Pickers-EXERCISE': {
      id: 530,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Apple Pickers',
      short_name: 'Apple Pickers',
      unique_name: 'BEGINNER-Apple_Pickers-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart. Bring your fists to your shoulders, elbows down.\n2. Pick one knee up to hip height as you reach the opposite arm straight overhead as if you were picking an apple.\n3. Bring your foot and your arm back down to start and repeat other side. (Marching in place with an overhead reach). Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1178,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'f0be5ffa0d83e0db2ef81fe7c83ea6fd0f4c3448dc9ffeb72c037ba7a35295fa',
          file_name:
            'videos/f0be5ffa0d83e0db2ef81fe7c83ea6fd0f4c3448dc9ffeb72c037ba7a35295fa.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f0be5ffa0d83e0db2ef81fe7c83ea6fd0f4c3448dc9ffeb72c037ba7a35295fa.mp4',
          name: 'BEGINNER-Apple_Pickers-EXERCISE.mp4',
          description: null,
          size: 69058,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1179,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '8961edbc4b13b0f6e11c7948d6dcba33eca6f5e79be2379132448dcb2cd5bd51',
          file_name:
            'audios/8961edbc4b13b0f6e11c7948d6dcba33eca6f5e79be2379132448dcb2cd5bd51.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8961edbc4b13b0f6e11c7948d6dcba33eca6f5e79be2379132448dcb2cd5bd51.mp3',
          name: 'BEGINNER-Apple_Pickers-EXERCISE.mp3',
          description: null,
          size: 20244,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Bodyweight_Rear_Delt_Fly-EXERCISE': {
      id: 531,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bodyweight Rear Delt Fly',
      short_name: 'Bodyweight Rear Delt Fly',
      unique_name: 'BEGINNER-Bodyweight_Rear_Delt_Fly-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart, arms by sides.\n2. With chest up and shoulders back, soften knees and hinge at waist until torso is almost parallel to the floor and arms down in front of you, fists facing each other.\n3. With a soft bend in elbows, raise arms out to the sides until elbows are in line with back and fists on shoulder level. Squeeze shoulder blades at the top.\n4. Lower fists to start.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1180,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '1faf1fef6461e28a2f41acd31a315d919e6aef887668ab7fa6c183df2d8b3121',
          file_name:
            'videos/1faf1fef6461e28a2f41acd31a315d919e6aef887668ab7fa6c183df2d8b3121.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1faf1fef6461e28a2f41acd31a315d919e6aef887668ab7fa6c183df2d8b3121.mp4',
          name: 'BEGINNER-Bodyweight_Rear_Delt_Fly-EXERCISE.mp4',
          description: null,
          size: 69437,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1181,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '3968d6ac9b34277c4a16f9b1307637021824443f17034aa37ffc0bbcf3d3dc83',
          file_name:
            'audios/3968d6ac9b34277c4a16f9b1307637021824443f17034aa37ffc0bbcf3d3dc83.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3968d6ac9b34277c4a16f9b1307637021824443f17034aa37ffc0bbcf3d3dc83.mp3',
          name: 'BEGINNER-Bodyweight_Rear_Delt_Fly-EXERCISE.mp3',
          description: null,
          size: 33723,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Calf_Raises-EXERCISE': {
      id: 532,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Calf Raises',
      short_name: 'Calf Raises',
      unique_name: 'BEGINNER-Calf_Raises-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, toes forward, core tight and hands on hips.\n2. Raise onto the balls of both feet as high as you can.\n3. Pause for a beat and lower your heels back down with control to start position.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1182,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'eed39f4a23efa6e252eaa789a23fc6ac793dd60dd49af316a3166957a10948cd',
          file_name:
            'videos/eed39f4a23efa6e252eaa789a23fc6ac793dd60dd49af316a3166957a10948cd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eed39f4a23efa6e252eaa789a23fc6ac793dd60dd49af316a3166957a10948cd.mp4',
          name: 'BEGINNER-Calf_Raises-EXERCISE.mp4',
          description: null,
          size: 40964,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1183,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '9565f52e7489b2d4f3cc5c7bde50b27e6ce8da5b01383948bf1c878216dfe3c6',
          file_name:
            'audios/9565f52e7489b2d4f3cc5c7bde50b27e6ce8da5b01383948bf1c878216dfe3c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9565f52e7489b2d4f3cc5c7bde50b27e6ce8da5b01383948bf1c878216dfe3c6.mp3',
          name: 'BEGINNER-Calf_Raises-EXERCISE.mp3',
          description: null,
          size: 20557,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Chameleons-EXERCISE': {
      id: 533,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Chameleons',
      short_name: 'Chameleons',
      unique_name: 'INTERMEDIATE-Chameleons-EXERCISE',
      description:
        "1. Start in Plank position, shoulders over wrists, long spine.\n2. Perform one Push-Up and as you come up, bend your knees and push weight back until your hips rest close to your heels. Knees are out wide, arms are straight and chest rests in between your knees in Child's Pose.\n3. Using leg, core and shoulder strength, shift your weight forward and return to Plank.",
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1184,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '53db46216bcaaf4a38c286a7c7cfc5908db4fec19782c0cc04dfda54a776f6a6',
          file_name:
            'videos/53db46216bcaaf4a38c286a7c7cfc5908db4fec19782c0cc04dfda54a776f6a6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/53db46216bcaaf4a38c286a7c7cfc5908db4fec19782c0cc04dfda54a776f6a6.mp4',
          name: 'INT-ADV-Chameleons-EXERCISE.mp4',
          description: null,
          size: 99840,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1185,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'c0a528e510eee99813858f024e510c03baf04314da04988c98b3c19c3294ef76',
          file_name:
            'audios/c0a528e510eee99813858f024e510c03baf04314da04988c98b3c19c3294ef76.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c0a528e510eee99813858f024e510c03baf04314da04988c98b3c19c3294ef76.mp3',
          name: 'INT-ADV-Chameleons-EXERCISE.mp3',
          description: null,
          size: 19303,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Chameleons-EXERCISE': {
      id: 534,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Chameleons',
      short_name: 'Chameleons',
      unique_name: 'ADVANCED-Chameleons-EXERCISE',
      description:
        "1. Start in Plank position, shoulders over wrists, long spine.\n2. Perform one Push-Up and as you come up, bend your knees and push weight back until your hips rest close to your heels. Knees are out wide, arms are straight and chest rests in between your knees in Child's Pose.\n3. Using leg, core and shoulder strength, shift your weight forward and return to Plank.",
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1186,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '53db46216bcaaf4a38c286a7c7cfc5908db4fec19782c0cc04dfda54a776f6a6',
          file_name:
            'videos/53db46216bcaaf4a38c286a7c7cfc5908db4fec19782c0cc04dfda54a776f6a6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/53db46216bcaaf4a38c286a7c7cfc5908db4fec19782c0cc04dfda54a776f6a6.mp4',
          name: 'INT-ADV-Chameleons-EXERCISE.mp4',
          description: null,
          size: 99840,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1187,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'c0a528e510eee99813858f024e510c03baf04314da04988c98b3c19c3294ef76',
          file_name:
            'audios/c0a528e510eee99813858f024e510c03baf04314da04988c98b3c19c3294ef76.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c0a528e510eee99813858f024e510c03baf04314da04988c98b3c19c3294ef76.mp3',
          name: 'INT-ADV-Chameleons-EXERCISE.mp3',
          description: null,
          size: 19303,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Clam_Shells-EXERCISE': {
      id: 535,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Clam Shells',
      short_name: 'Clam Shells',
      unique_name: 'BEGINNER-Clam_Shells-EXERCISE',
      description:
        '1. Start in side-lying position, resting on one forearm. Hips, shoulders and feet stacked.\n2. Bend your knees in front of your body, one on top of the other keeping heels in line with your hips and shoulders.\n3. Keeping feet together, open up your hips by raising the top knee. Make sure that the top hip does not roll forward or back.\n4. Pause for a beat and lower back down with control.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1188,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '70f35b649d00e4d229fed2599cdd0a2a24721e2740f19c49aadd374b16917c98',
          file_name:
            'videos/70f35b649d00e4d229fed2599cdd0a2a24721e2740f19c49aadd374b16917c98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/70f35b649d00e4d229fed2599cdd0a2a24721e2740f19c49aadd374b16917c98.mp4',
          name: 'BEG-INT-ADV-Clam_Shells-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 40516,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1189,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: 'f7be89bdd99fdbe19166483461cbd0a4066b295391cbb90378c7643935c8e457',
          file_name:
            'videos/f7be89bdd99fdbe19166483461cbd0a4066b295391cbb90378c7643935c8e457.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f7be89bdd99fdbe19166483461cbd0a4066b295391cbb90378c7643935c8e457.mp4',
          name: 'BEG-INT-ADV-Clam_Shells-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 41016,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1190,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '3e5f9614715991d9be7ce16de7eb55739afda85a05158ebbda2b98f0ac41e586',
          file_name:
            'audios/3e5f9614715991d9be7ce16de7eb55739afda85a05158ebbda2b98f0ac41e586.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3e5f9614715991d9be7ce16de7eb55739afda85a05158ebbda2b98f0ac41e586.mp3',
          name: 'BEG-INT-ADV-Clam_Shells-EXERCISE.mp3',
          description: null,
          size: 19930,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Clam_Shells-EXERCISE': {
      id: 536,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Clam Shells',
      short_name: 'Clam Shells',
      unique_name: 'INTERMEDIATE-Clam_Shells-EXERCISE',
      description:
        '1. Start in side-lying position, resting on one forearm. Hips, shoulders and feet stacked.\n2. Bend your knees in front of your body, one on top of the other keeping heels in line with your hips and shoulders.\n3. Keeping feet together, open up your hips by raising the top knee. Make sure that the top hip does not roll forward or back.\n4. Pause for a beat and lower back down with control.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1191,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '70f35b649d00e4d229fed2599cdd0a2a24721e2740f19c49aadd374b16917c98',
          file_name:
            'videos/70f35b649d00e4d229fed2599cdd0a2a24721e2740f19c49aadd374b16917c98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/70f35b649d00e4d229fed2599cdd0a2a24721e2740f19c49aadd374b16917c98.mp4',
          name: 'BEG-INT-ADV-Clam_Shells-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 40516,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1192,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: 'f7be89bdd99fdbe19166483461cbd0a4066b295391cbb90378c7643935c8e457',
          file_name:
            'videos/f7be89bdd99fdbe19166483461cbd0a4066b295391cbb90378c7643935c8e457.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f7be89bdd99fdbe19166483461cbd0a4066b295391cbb90378c7643935c8e457.mp4',
          name: 'BEG-INT-ADV-Clam_Shells-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 41016,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1193,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '3e5f9614715991d9be7ce16de7eb55739afda85a05158ebbda2b98f0ac41e586',
          file_name:
            'audios/3e5f9614715991d9be7ce16de7eb55739afda85a05158ebbda2b98f0ac41e586.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3e5f9614715991d9be7ce16de7eb55739afda85a05158ebbda2b98f0ac41e586.mp3',
          name: 'BEG-INT-ADV-Clam_Shells-EXERCISE.mp3',
          description: null,
          size: 19930,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Clam_Shells-EXERCISE': {
      id: 537,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Clam Shells',
      short_name: 'Clam Shells',
      unique_name: 'ADVANCED-Clam_Shells-EXERCISE',
      description:
        '1. Start in side-lying position, resting on one forearm. Hips, shoulders and feet stacked.\n2. Bend your knees in front of your body, one on top of the other keeping heels in line with your hips and shoulders.\n3. Keeping feet together, open up your hips by raising the top knee. Make sure that the top hip does not roll forward or back.\n4. Pause for a beat and lower back down with control.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1194,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '70f35b649d00e4d229fed2599cdd0a2a24721e2740f19c49aadd374b16917c98',
          file_name:
            'videos/70f35b649d00e4d229fed2599cdd0a2a24721e2740f19c49aadd374b16917c98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/70f35b649d00e4d229fed2599cdd0a2a24721e2740f19c49aadd374b16917c98.mp4',
          name: 'BEG-INT-ADV-Clam_Shells-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 40516,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1195,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: 'f7be89bdd99fdbe19166483461cbd0a4066b295391cbb90378c7643935c8e457',
          file_name:
            'videos/f7be89bdd99fdbe19166483461cbd0a4066b295391cbb90378c7643935c8e457.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f7be89bdd99fdbe19166483461cbd0a4066b295391cbb90378c7643935c8e457.mp4',
          name: 'BEG-INT-ADV-Clam_Shells-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 41016,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1196,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '3e5f9614715991d9be7ce16de7eb55739afda85a05158ebbda2b98f0ac41e586',
          file_name:
            'audios/3e5f9614715991d9be7ce16de7eb55739afda85a05158ebbda2b98f0ac41e586.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3e5f9614715991d9be7ce16de7eb55739afda85a05158ebbda2b98f0ac41e586.mp3',
          name: 'BEG-INT-ADV-Clam_Shells-EXERCISE.mp3',
          description: null,
          size: 19930,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Climber_Toe_Taps-EXERCISE': {
      id: 538,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Climber Toe Taps',
      short_name: 'Climber Toe Taps',
      unique_name: 'BEGINNER-Climber_Toe_Taps-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Keeping one leg engaged and extended, draw your other knee straight up toward your chest as you lift the opposite arm back to tap your foot.\n3. Return to Plank position and repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1197,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '4268249d9f6cde73db56c6f29d106cd59a689af6d37923269e8f6d2fa98de565',
          file_name:
            'videos/4268249d9f6cde73db56c6f29d106cd59a689af6d37923269e8f6d2fa98de565.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4268249d9f6cde73db56c6f29d106cd59a689af6d37923269e8f6d2fa98de565.mp4',
          name: 'BEGINNER-Climber_Toe_Taps-EXERCISE.mp4',
          description: null,
          size: 93033,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1198,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '59b09fc46d8bb8f7e30a30cc15ce41cfe44ce4200b8a3fec8157364cf2207752',
          file_name:
            'audios/59b09fc46d8bb8f7e30a30cc15ce41cfe44ce4200b8a3fec8157364cf2207752.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/59b09fc46d8bb8f7e30a30cc15ce41cfe44ce4200b8a3fec8157364cf2207752.mp3',
          name: 'BEGINNER-Climber_Toe_Taps-EXERCISE.mp3',
          description: null,
          size: 25259,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Devil_Presses-EXERCISE': {
      id: 539,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Devil Presses',
      short_name: 'Devil Presses',
      unique_name: 'INTERMEDIATE-Devil_Presses-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart, holding a dumbbell in each hand. Bend knees and hinge at waist until you can plant both dumbbells on the floor. Palms face each other.\n2. Jump feet back behind you to Plank position.\n3. Jump feet back in, shoulder-width apart, heels on the floor.\n4. Transfer your weight back into a low squat position, stand up straight and press dumbbells overhead.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1199,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '37d9e9eb74ab12172f8a2b0490bc1600b599f2cb1d3de50317d193802a6831a9',
          file_name:
            'videos/37d9e9eb74ab12172f8a2b0490bc1600b599f2cb1d3de50317d193802a6831a9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/37d9e9eb74ab12172f8a2b0490bc1600b599f2cb1d3de50317d193802a6831a9.mp4',
          name: 'INT-ADV-Devil_Press-EXERCISE.mp4',
          description: null,
          size: 228119,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1200,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '98666619d49a5718fbf76037d2b92eec012157369d079531caa4bf8cfecc2dff',
          file_name:
            'audios/98666619d49a5718fbf76037d2b92eec012157369d079531caa4bf8cfecc2dff.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/98666619d49a5718fbf76037d2b92eec012157369d079531caa4bf8cfecc2dff.mp3',
          name: 'INT-ADV-Devil_Press-EXERCISE.mp3',
          description: null,
          size: 22423,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Devil_Presses-EXERCISE': {
      id: 540,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Devil Presses',
      short_name: 'Devil Presses',
      unique_name: 'ADVANCED-Devil_Presses-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart, holding a dumbbell in each hand. Bend knees and hinge at waist until you can plant both dumbbells on the floor. Palms face each other.\n2. Jump feet back behind you to Plank position.\n3. Jump feet back in, shoulder-width apart, heels on the floor.\n4. Transfer your weight back into a low squat position, stand up straight and press dumbbells overhead.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1201,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '37d9e9eb74ab12172f8a2b0490bc1600b599f2cb1d3de50317d193802a6831a9',
          file_name:
            'videos/37d9e9eb74ab12172f8a2b0490bc1600b599f2cb1d3de50317d193802a6831a9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/37d9e9eb74ab12172f8a2b0490bc1600b599f2cb1d3de50317d193802a6831a9.mp4',
          name: 'INT-ADV-Devil_Press-EXERCISE.mp4',
          description: null,
          size: 228119,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1202,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '98666619d49a5718fbf76037d2b92eec012157369d079531caa4bf8cfecc2dff',
          file_name:
            'audios/98666619d49a5718fbf76037d2b92eec012157369d079531caa4bf8cfecc2dff.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/98666619d49a5718fbf76037d2b92eec012157369d079531caa4bf8cfecc2dff.mp3',
          name: 'INT-ADV-Devil_Press-EXERCISE.mp3',
          description: null,
          size: 22423,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Diagonal_Crunch-EXERCISE': {
      id: 541,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Diagonal Crunch',
      short_name: 'Diagonal Crunch',
      unique_name: 'BEGINNER-Diagonal_Crunch-EXERCISE',
      description:
        '1. Lie on your back, knees bent, feet on the floor, hip-width apart. Cross one ankle over the opposite knee.\n2. Place your hands behind your head with thumbs behind ears and elbows wide.\n3. Engage abs and curl up at a diagonal, so your head, neck and shoulder blades lift to bring the opposite elbow toward the crossed knee. Keep space between chin and chest. Squeeze at the top.\n4. Lower with control. Perform all reps on one side. Repeat.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1203,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '7e53344b4da6e532219ece182eac48309e51698158df3badb028aeb2ab74230c',
          file_name:
            'videos/7e53344b4da6e532219ece182eac48309e51698158df3badb028aeb2ab74230c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7e53344b4da6e532219ece182eac48309e51698158df3badb028aeb2ab74230c.mp4',
          name: 'BEG-INT-ADV-Diagonal_Crunch-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 47419,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1204,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: '1993b1e6c67b9490219176841ca01363e954fb4ab02ae8eeb0a090b2451e91a6',
          file_name:
            'videos/1993b1e6c67b9490219176841ca01363e954fb4ab02ae8eeb0a090b2451e91a6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1993b1e6c67b9490219176841ca01363e954fb4ab02ae8eeb0a090b2451e91a6.mp4',
          name: 'BEG-INT-ADV-Diagonal_Crunch-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 51771,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1205,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '4e1429b33e5be1d50be6b66a59057ee5771e409079c0cf58da7c5ecb18b44ae1',
          file_name:
            'audios/4e1429b33e5be1d50be6b66a59057ee5771e409079c0cf58da7c5ecb18b44ae1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4e1429b33e5be1d50be6b66a59057ee5771e409079c0cf58da7c5ecb18b44ae1.mp3',
          name: 'BEG-INT-ADV-Diagonal_Crunch-EXERCISE.mp3',
          description: null,
          size: 26513,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Diagonal_Crunch-EXERCISE': {
      id: 542,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Diagonal Crunch',
      short_name: 'Diagonal Crunch',
      unique_name: 'INTERMEDIATE-Diagonal_Crunch-EXERCISE',
      description:
        '1. Lie on your back, knees bent, feet on the floor, hip-width apart. Cross one ankle over the opposite knee.\n2. Place your hands behind your head with thumbs behind ears and elbows wide.\n3. Engage abs and curl up at a diagonal, so your head, neck and shoulder blades lift to bring the opposite elbow toward the crossed knee. Keep space between chin and chest. Squeeze at the top.\n4. Lower with control. Perform all reps on one side. Repeat.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1206,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '7e53344b4da6e532219ece182eac48309e51698158df3badb028aeb2ab74230c',
          file_name:
            'videos/7e53344b4da6e532219ece182eac48309e51698158df3badb028aeb2ab74230c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7e53344b4da6e532219ece182eac48309e51698158df3badb028aeb2ab74230c.mp4',
          name: 'BEG-INT-ADV-Diagonal_Crunch-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 47419,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1207,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: '1993b1e6c67b9490219176841ca01363e954fb4ab02ae8eeb0a090b2451e91a6',
          file_name:
            'videos/1993b1e6c67b9490219176841ca01363e954fb4ab02ae8eeb0a090b2451e91a6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1993b1e6c67b9490219176841ca01363e954fb4ab02ae8eeb0a090b2451e91a6.mp4',
          name: 'BEG-INT-ADV-Diagonal_Crunch-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 51771,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1208,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '4e1429b33e5be1d50be6b66a59057ee5771e409079c0cf58da7c5ecb18b44ae1',
          file_name:
            'audios/4e1429b33e5be1d50be6b66a59057ee5771e409079c0cf58da7c5ecb18b44ae1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4e1429b33e5be1d50be6b66a59057ee5771e409079c0cf58da7c5ecb18b44ae1.mp3',
          name: 'BEG-INT-ADV-Diagonal_Crunch-EXERCISE.mp3',
          description: null,
          size: 26513,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Diagonal_Crunch-EXERCISE': {
      id: 543,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Diagonal Crunch',
      short_name: 'Diagonal Crunch',
      unique_name: 'ADVANCED-Diagonal_Crunch-EXERCISE',
      description:
        '1. Lie on your back, knees bent, feet on the floor, hip-width apart. Cross one ankle over the opposite knee.\n2. Place your hands behind your head with thumbs behind ears and elbows wide.\n3. Engage abs and curl up at a diagonal, so your head, neck and shoulder blades lift to bring the opposite elbow toward the crossed knee. Keep space between chin and chest. Squeeze at the top.\n4. Lower with control. Perform all reps on one side. Repeat.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1209,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '7e53344b4da6e532219ece182eac48309e51698158df3badb028aeb2ab74230c',
          file_name:
            'videos/7e53344b4da6e532219ece182eac48309e51698158df3badb028aeb2ab74230c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7e53344b4da6e532219ece182eac48309e51698158df3badb028aeb2ab74230c.mp4',
          name: 'BEG-INT-ADV-Diagonal_Crunch-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 47419,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1210,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: '1993b1e6c67b9490219176841ca01363e954fb4ab02ae8eeb0a090b2451e91a6',
          file_name:
            'videos/1993b1e6c67b9490219176841ca01363e954fb4ab02ae8eeb0a090b2451e91a6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1993b1e6c67b9490219176841ca01363e954fb4ab02ae8eeb0a090b2451e91a6.mp4',
          name: 'BEG-INT-ADV-Diagonal_Crunch-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 51771,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1211,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '4e1429b33e5be1d50be6b66a59057ee5771e409079c0cf58da7c5ecb18b44ae1',
          file_name:
            'audios/4e1429b33e5be1d50be6b66a59057ee5771e409079c0cf58da7c5ecb18b44ae1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4e1429b33e5be1d50be6b66a59057ee5771e409079c0cf58da7c5ecb18b44ae1.mp3',
          name: 'BEG-INT-ADV-Diagonal_Crunch-EXERCISE.mp3',
          description: null,
          size: 26513,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Dumbbell_Forearm_Plank_Punches-EXERCISE': {
      id: 544,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Dumbbell Forearm Plank Punches',
      short_name: 'Dumbbell Forearm Plank Punches',
      unique_name: 'ADVANCED-Dumbbell_Forearm_Plank_Punches-EXERCISE',
      description:
        '1. Start in Forearm Plank position, elbows under shoulders, hips square. Hold one dumbbell in each hand vertically.\n2. Punch one arm out straight in front of you to shoulder height. Keep the dumbbell vertical and hips and shoulders square to the floor.\n3. Return to Plank position and repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1212,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'f7b59725e2f0b83f8eae750362cf5c206134ae64e3a1ee49be97e02c5fb80b35',
          file_name:
            'videos/f7b59725e2f0b83f8eae750362cf5c206134ae64e3a1ee49be97e02c5fb80b35.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f7b59725e2f0b83f8eae750362cf5c206134ae64e3a1ee49be97e02c5fb80b35.mp4',
          name: 'ADVANCED-Dumbbell_Forearm_Plank_Punches-EXERCISE.mp4',
          description: null,
          size: 82913,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1213,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '422c6c1944272125cac20f2c451472a9dde7601a15e7ceafff75c3e9d8e2d191',
          file_name:
            'audios/422c6c1944272125cac20f2c451472a9dde7601a15e7ceafff75c3e9d8e2d191.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/422c6c1944272125cac20f2c451472a9dde7601a15e7ceafff75c3e9d8e2d191.mp3',
          name: 'ADVANCED-Dumbbell_Forearm_Plank_Punches-EXERCISE.mp3',
          description: null,
          size: 63045,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Dumbbell_Plank_Punches-EXERCISE': {
      id: 545,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Dumbbell Plank Punches',
      short_name: 'Dumbbell Plank Punches',
      unique_name: 'ADVANCED-Dumbbell_Plank_Punches-EXERCISE',
      description:
        '1. Start in Plank position. Hold one dumbbell in each hand with your wrists as straight as possible. Keep shoulders over wrists and hips square.\n2. Punch one arm out straight in front of you to shoulder height. Keep dumbbell vertical and hips and shoulders square to the floor.\n3. Return to Plank position and repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1214,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'c8c7c63f0905de4c63b414eb6a91f79d2899a4a7d44240afc76b5876d14cbc87',
          file_name:
            'videos/c8c7c63f0905de4c63b414eb6a91f79d2899a4a7d44240afc76b5876d14cbc87.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c8c7c63f0905de4c63b414eb6a91f79d2899a4a7d44240afc76b5876d14cbc87.mp4',
          name: 'ADVANCED-Dumbbell_Plank_Punches-EXERCISE.mp4',
          description: null,
          size: 101300,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1215,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '42d99aefe91499391d2c20dec5c548e852341cb5188bca0a9ec4abf651589cd5',
          file_name:
            'audios/42d99aefe91499391d2c20dec5c548e852341cb5188bca0a9ec4abf651589cd5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/42d99aefe91499391d2c20dec5c548e852341cb5188bca0a9ec4abf651589cd5.mp3',
          name: 'ADVANCED-Dumbbell_Plank_Punches-EXERCISE.mp3',
          description: null,
          size: 42530,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Dumbbell_Static_Lunge_with_Pulse-EXERCISE': {
      id: 546,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Static Lunge with Pulse',
      short_name: 'Dumbbell Static Lunge with Pulse',
      unique_name: 'ADVANCED-Dumbbell_Static_Lunge_with_Pulse-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, one dumbbell in each hand by your sides. Step forward with one leg, elevate back heel.\n2. Drop your hips down, bending knees to 90 degrees. Front knee directly over ankle and back knee near floor.\n3. Perform a pulse by straightening legs up about half way, then lower back to bottom of the lunge.\n4. Straighten legs to complete rep. Perform all reps one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1216,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'd02943e415ca7078b9d92a2a4c78568265a1fe53c50d709857a56b78aa780497',
          file_name:
            'videos/d02943e415ca7078b9d92a2a4c78568265a1fe53c50d709857a56b78aa780497.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d02943e415ca7078b9d92a2a4c78568265a1fe53c50d709857a56b78aa780497.mp4',
          name: 'ADVANCED-Dumbbell_Static_Lunge_with_Pulse-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 84452,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1217,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: '76c8de4921abf94767b475bef2ac27cc74eefd0299d00747ae7d3996b7306d8f',
          file_name:
            'videos/76c8de4921abf94767b475bef2ac27cc74eefd0299d00747ae7d3996b7306d8f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/76c8de4921abf94767b475bef2ac27cc74eefd0299d00747ae7d3996b7306d8f.mp4',
          name: 'ADVANCED-Dumbbell_Static_Lunge_with_Pulse-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 75451,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1218,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '0e61fc20be468753862dc6e249167b9f26b9babc996832cbac250ae9ea4df050',
          file_name:
            'audios/0e61fc20be468753862dc6e249167b9f26b9babc996832cbac250ae9ea4df050.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0e61fc20be468753862dc6e249167b9f26b9babc996832cbac250ae9ea4df050.mp3',
          name: 'ADVANCED-Dumbbell_Static_Lunge_with_Pulse-EXERCISE.mp3',
          description: null,
          size: 38111,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Fire_Hydrants-EXERCISE': {
      id: 547,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Fire Hydrants',
      short_name: 'Fire Hydrants',
      unique_name: 'BEGINNER-Fire_Hydrants-EXERCISE',
      description:
        '1. Start on all fours with your shoulders over wrists and hips over your knees.\n2. With a straight spine and engaged core, lift one leg out to the side to about hip-height, keeping the knee bent at 90 degrees and foot flexed. Keep shoulders square, pelvis and spine stable. Pause for a beat.\n3. With control, return to start.\n4. Perform all reps on one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1219,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'e7547dd193229d48213d089d15416e0c91e05950ee2908d13305e4f3ff7ec8b8',
          file_name:
            'videos/e7547dd193229d48213d089d15416e0c91e05950ee2908d13305e4f3ff7ec8b8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e7547dd193229d48213d089d15416e0c91e05950ee2908d13305e4f3ff7ec8b8.mp4',
          name: 'BEGINNER-Fire_Hydrants-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 41814,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1220,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: 'f7cf23fae09c69cc77ed009a6a7d0903aeb136cab1c8af79bda372458d6ca57d',
          file_name:
            'videos/f7cf23fae09c69cc77ed009a6a7d0903aeb136cab1c8af79bda372458d6ca57d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f7cf23fae09c69cc77ed009a6a7d0903aeb136cab1c8af79bda372458d6ca57d.mp4',
          name: 'BEGINNER-Fire_Hydrants-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 54303,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1221,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '1ad2beb239f11a4a5583852b660aec8f8b00adde5d9ffb8fa3ff6edf72cd52bd',
          file_name:
            'audios/1ad2beb239f11a4a5583852b660aec8f8b00adde5d9ffb8fa3ff6edf72cd52bd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1ad2beb239f11a4a5583852b660aec8f8b00adde5d9ffb8fa3ff6edf72cd52bd.mp3',
          name: 'BEGINNER-Fire_Hydrants-EXERCISE.mp3',
          description: null,
          size: 21811,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Frog_Squats-EXERCISE': {
      id: 548,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Frog Squats',
      short_name: 'Frog Squats',
      unique_name: 'BEGINNER-Frog_Squats-EXERCISE',
      description:
        '1. Stand with your feet slightly wider than shoulder-width apart, toes pointing out.\n2. Bend knees, sink hips down and back to lower into a wide squat. Keep chest up and place your hands on the floor between your feet.\n3. Keeping the hands on the floor, drive though your heels to straighten your legs as much as possible and push your hips up in the air, moving upper body toward your thighs.\n4. Lower back to low squat position.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1222,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '610499cad5f4d2b677e6067d9c78b9c2cfdc5bc99a883024559bf1fae787e685',
          file_name:
            'videos/610499cad5f4d2b677e6067d9c78b9c2cfdc5bc99a883024559bf1fae787e685.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/610499cad5f4d2b677e6067d9c78b9c2cfdc5bc99a883024559bf1fae787e685.mp4',
          name: 'BEGINNER-Frog_Squats-EXERCISE.mp4',
          description: null,
          size: 61361,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1223,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'f3267b5eb6b337df84fea695cd9e74e2e956d0302f56bdacb28b9942774bac20',
          file_name:
            'audios/f3267b5eb6b337df84fea695cd9e74e2e956d0302f56bdacb28b9942774bac20.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f3267b5eb6b337df84fea695cd9e74e2e956d0302f56bdacb28b9942774bac20.mp3',
          name: 'BEGINNER-Frog_Squats-EXERCISE.mp3',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Frogger_Glute_Lifts-EXERCISE': {
      id: 549,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Frogger Glute Lifts',
      short_name: 'Frogger Glute Lifts',
      unique_name: 'BEGINNER-Frogger_Glute_Lifts-EXERCISE',
      description:
        '1. Lie on your stomach with legs extended long, hands under your chin, elbows wide.\n2. Bend both knees and bring them out wide. Touch the soles of your feet together, rest chin on hands.\n3. Keep upper body planted, engage glutes, and lift both feet up into the air until your thighs leave the ground. Do not arch your back.\n4. Pause for a beat and lower back down with control.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1224,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'a470e98190602e2ed4fb60f983e1d05dc30df46ad611d0d4d0a7151ec53dbb2c',
          file_name:
            'videos/a470e98190602e2ed4fb60f983e1d05dc30df46ad611d0d4d0a7151ec53dbb2c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a470e98190602e2ed4fb60f983e1d05dc30df46ad611d0d4d0a7151ec53dbb2c.mp4',
          name: 'BEGINNER-Frogger_Glute_Lifts-EXERCISE.mp4',
          description: null,
          size: 40054,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1225,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '77cca769eac043aa6288eddae1f4c17f0a6fea8b805a13c96690fc83aef45a0a',
          file_name:
            'audios/77cca769eac043aa6288eddae1f4c17f0a6fea8b805a13c96690fc83aef45a0a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/77cca769eac043aa6288eddae1f4c17f0a6fea8b805a13c96690fc83aef45a0a.mp3',
          name: 'BEGINNER-Frogger_Glute_Lifts-EXERCISE.mp3',
          description: null,
          size: 30578,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Glute_Rainbows-EXERCISE': {
      id: 550,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Glute Rainbows',
      short_name: 'Glute Rainbows',
      unique_name: 'INTERMEDIATE-Glute_Rainbows-EXERCISE',
      description:
        "1. Start on all fours with shoulders over wrists and knees under hips. Keep hips square and core tight.\n2. Extend one leg straight behind you and tap your toe slightly to the side.\n3. Lift your leg up to about hip level and bring it over in an arch motion to tap toe on opposite side. Don't arch your lower back.\n4. Reverse motion and tap toe back at start position. Perform all reps with one leg. Repeat with the other side.",
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1226,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '57eed64b180e6e53cbfdacdd6f0b96ac0b086f11d2eb7285faf6040d7e0c5518',
          file_name:
            'videos/57eed64b180e6e53cbfdacdd6f0b96ac0b086f11d2eb7285faf6040d7e0c5518.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/57eed64b180e6e53cbfdacdd6f0b96ac0b086f11d2eb7285faf6040d7e0c5518.mp4',
          name: 'INT-ADV-Glute_Rainbows-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 64000,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1227,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: 'e1f774d78477c71e483ca92d2e31dd7d9cfc5b91565b4fb4c7f63db5269bcc81',
          file_name:
            'videos/e1f774d78477c71e483ca92d2e31dd7d9cfc5b91565b4fb4c7f63db5269bcc81.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e1f774d78477c71e483ca92d2e31dd7d9cfc5b91565b4fb4c7f63db5269bcc81.mp4',
          name: 'INT-ADV-Glute_Rainbows-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 61972,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1228,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '2be8119b770d0458b70dfe30f6132233648771b50ffdb0cd0780342356dcd7bc',
          file_name:
            'audios/2be8119b770d0458b70dfe30f6132233648771b50ffdb0cd0780342356dcd7bc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2be8119b770d0458b70dfe30f6132233648771b50ffdb0cd0780342356dcd7bc.mp3',
          name: 'INT-ADV-Glute_Rainbows-EXERCISE.mp3',
          description: null,
          size: 26200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Glute_Rainbows-EXERCISE': {
      id: 551,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Glute Rainbows',
      short_name: 'Glute Rainbows',
      unique_name: 'ADVANCED-Glute_Rainbows-EXERCISE',
      description:
        "1. Start on all fours with shoulders over wrists and knees under hips. Keep hips square and core tight.\n2. Extend one leg straight behind you and tap your toe slightly to the side.\n3. Lift your leg up to about hip level and bring it over in an arch motion to tap toe on opposite side. Don't arch your lower back.\n4. Reverse motion and tap toe back at start position. Perform all reps with one leg. Repeat with the other side.",
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1229,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '57eed64b180e6e53cbfdacdd6f0b96ac0b086f11d2eb7285faf6040d7e0c5518',
          file_name:
            'videos/57eed64b180e6e53cbfdacdd6f0b96ac0b086f11d2eb7285faf6040d7e0c5518.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/57eed64b180e6e53cbfdacdd6f0b96ac0b086f11d2eb7285faf6040d7e0c5518.mp4',
          name: 'INT-ADV-Glute_Rainbows-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 64000,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1230,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: 'e1f774d78477c71e483ca92d2e31dd7d9cfc5b91565b4fb4c7f63db5269bcc81',
          file_name:
            'videos/e1f774d78477c71e483ca92d2e31dd7d9cfc5b91565b4fb4c7f63db5269bcc81.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e1f774d78477c71e483ca92d2e31dd7d9cfc5b91565b4fb4c7f63db5269bcc81.mp4',
          name: 'INT-ADV-Glute_Rainbows-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 61972,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1231,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '2be8119b770d0458b70dfe30f6132233648771b50ffdb0cd0780342356dcd7bc',
          file_name:
            'audios/2be8119b770d0458b70dfe30f6132233648771b50ffdb0cd0780342356dcd7bc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2be8119b770d0458b70dfe30f6132233648771b50ffdb0cd0780342356dcd7bc.mp3',
          name: 'INT-ADV-Glute_Rainbows-EXERCISE.mp3',
          description: null,
          size: 26200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Hand_Release_Knee_Push-Ups-EXERCISE': {
      id: 552,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Hand Release Knee Push-Ups',
      short_name: 'Hand Release Knee Push-Ups',
      unique_name: 'BEGINNER-Hand_Release_Knee_Push-Ups-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists. Drop knees straight down to the floor and lift your feet up.\n2. Bend elbows, pointing them back toward your hips. Lower your body all the way to the floor.\n3. Lift both hands off the floor for a beat, then place them back under your shoulders.\n4. Straighten your arms and raise your body back up in one long line from the crown of your head to your tailbone.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1232,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'a4f66b8beadab12e2a3479b9a2a725eaafc60e7f844976093af52e5013eefd3e',
          file_name:
            'videos/a4f66b8beadab12e2a3479b9a2a725eaafc60e7f844976093af52e5013eefd3e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a4f66b8beadab12e2a3479b9a2a725eaafc60e7f844976093af52e5013eefd3e.mp4',
          name: 'BEGINNER-Hand_Release_Knee_Push-Ups-EXERCISE.mp4',
          description: null,
          size: 76033,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1233,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '29ede3abeed15a4608e1d275a379c487ca9092fc78f77067f49dc377ae08886f',
          file_name:
            'audios/29ede3abeed15a4608e1d275a379c487ca9092fc78f77067f49dc377ae08886f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/29ede3abeed15a4608e1d275a379c487ca9092fc78f77067f49dc377ae08886f.mp3',
          name: 'BEGINNER-Hand_Release_Knee_Push-Ups-EXERCISE.mp3',
          description: null,
          size: 28080,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Knee_Plank_Punches-EXERCISE': {
      id: 553,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Knee Plank Punches',
      short_name: 'Knee Plank Punches',
      unique_name: 'BEGINNER-Knee_Plank_Punches-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists. Drop your knees straight down to the floor and lift your feet up.\n2. Punch one arm out straight in front of you to shoulder height. Keep your hips and shoulders square to the floor.\n3. Return to Plank position and repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1234,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '839d4f30d8fb5582ea69d67a2fa8614bd21fbe8179cd7966daacba8175d9af60',
          file_name:
            'videos/839d4f30d8fb5582ea69d67a2fa8614bd21fbe8179cd7966daacba8175d9af60.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/839d4f30d8fb5582ea69d67a2fa8614bd21fbe8179cd7966daacba8175d9af60.mp4',
          name: 'BEGINNER-Knee_Plank_Punches-EXERCISE.mp4',
          description: null,
          size: 77159,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1235,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '4f1402b70ca034f441c7a81ad1835b7cc001c0663092bb8c8ea27a6866e82ae5',
          file_name:
            'audios/4f1402b70ca034f441c7a81ad1835b7cc001c0663092bb8c8ea27a6866e82ae5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4f1402b70ca034f441c7a81ad1835b7cc001c0663092bb8c8ea27a6866e82ae5.mp3',
          name: 'BEGINNER-Knee_Plank_Punches-EXERCISE.mp3',
          description: null,
          size: 27453,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Kneel_to_Stand-EXERCISE': {
      id: 554,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Kneel to Stand',
      short_name: 'Kneel to Stand',
      unique_name: 'BEGINNER-Kneel_to_Stand-EXERCISE',
      description:
        '1. Start in high kneeling position, legs hip-width apart, hands on hips.\n2. Step one leg in front of you to come into a half kneel, bending knee to 90 degree over ankle, supporting the weight with other side.\n3. Drive through your heel to stand on both feet.\n4. Step back with opposite foot, drop knee and come down to a half kneel on other side.\n5. Return to start. Alternate right and left with each rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1236,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '3625a2085406d046f8abe2e3ae286c935961c99a66157aad6e05739d9f0a3392',
          file_name:
            'videos/3625a2085406d046f8abe2e3ae286c935961c99a66157aad6e05739d9f0a3392.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3625a2085406d046f8abe2e3ae286c935961c99a66157aad6e05739d9f0a3392.mp4',
          name: 'BEGINNER-Kneel_to_Stand-EXERCISE.mp4',
          description: null,
          size: 196659,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1237,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'b27f2b04a0fed678df7bf63344a315762b6de4ce007ece41e3718c3a0acf6565',
          file_name:
            'audios/b27f2b04a0fed678df7bf63344a315762b6de4ce007ece41e3718c3a0acf6565.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b27f2b04a0fed678df7bf63344a315762b6de4ce007ece41e3718c3a0acf6565.mp3',
          name: 'BEGINNER-Kneel_to_Stand-EXERCISE.mp3',
          description: null,
          size: 23378,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Kneeling_Squats-EXERCISE': {
      id: 555,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Kneeling Squats',
      short_name: 'Kneeling Squats',
      unique_name: 'INTERMEDIATE-Kneeling_Squats-EXERCISE',
      description:
        '1. Start kneeling with your legs about hip-width apart, chest tall, hands on hips.\n2. Maintaining good posture, drop your hips back toward your heels to touch in a low kneeling position.\n3. Using quad/glute strength, raise your body back up to start.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1238,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '27d7045f367f474118af1a69a68ed69bf2cb011a51d2578992c796057249fc12',
          file_name:
            'videos/27d7045f367f474118af1a69a68ed69bf2cb011a51d2578992c796057249fc12.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/27d7045f367f474118af1a69a68ed69bf2cb011a51d2578992c796057249fc12.mp4',
          name: 'INT-ADV-Kneeling_Squats-EXERCISE.mp4',
          description: null,
          size: 73529,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1239,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'df70b8168fdb5727ba37ac248b594054f37d48575b36adf74ba66331b3aa9559',
          file_name:
            'audios/df70b8168fdb5727ba37ac248b594054f37d48575b36adf74ba66331b3aa9559.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/df70b8168fdb5727ba37ac248b594054f37d48575b36adf74ba66331b3aa9559.mp3',
          name: 'INT-ADV-Kneeling_Squats-EXERCISE.mp3',
          description: null,
          size: 23378,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Kneeling_Squats-EXERCISE': {
      id: 556,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kneeling Squats',
      short_name: 'Kneeling Squats',
      unique_name: 'ADVANCED-Kneeling_Squats-EXERCISE',
      description:
        '1. Start kneeling with your legs about hip-width apart, chest tall, hands on hips.\n2. Maintaining good posture, drop your hips back toward your heels to touch in a low kneeling position.\n3. Using quad/glute strength, raise your body back up to start.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1240,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '27d7045f367f474118af1a69a68ed69bf2cb011a51d2578992c796057249fc12',
          file_name:
            'videos/27d7045f367f474118af1a69a68ed69bf2cb011a51d2578992c796057249fc12.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/27d7045f367f474118af1a69a68ed69bf2cb011a51d2578992c796057249fc12.mp4',
          name: 'INT-ADV-Kneeling_Squats-EXERCISE.mp4',
          description: null,
          size: 73529,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1241,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'df70b8168fdb5727ba37ac248b594054f37d48575b36adf74ba66331b3aa9559',
          file_name:
            'audios/df70b8168fdb5727ba37ac248b594054f37d48575b36adf74ba66331b3aa9559.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/df70b8168fdb5727ba37ac248b594054f37d48575b36adf74ba66331b3aa9559.mp3',
          name: 'INT-ADV-Kneeling_Squats-EXERCISE.mp3',
          description: null,
          size: 23378,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Modified_Forearm_Side_Plank_Crunches-EXERCISE': {
      id: 557,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Modified Forearm Side Plank Crunches',
      short_name: 'Modified Forearm Side Plank Crunches',
      unique_name: 'BEGINNER-Modified_Forearm_Side_Plank_Crunches-EXERCISE',
      description:
        '1. Lie on your side, propping up on forearm, elbow directly under shoulder. Bend bottom leg and extend top leg.\n2. Keep bottom leg on floor, lift hips up so your body is in a straight line. Reach top arm overhead, pit of elbow by your ear.\n3. Simultaneously crunch extended arm and leg in, bringing elbow and knee together.\n4. Pause.\n5. Extend your arm and leg back out. Perform all reps. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1242,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '54786708fbbcd6a925de403ad3acb0270e7c81690e5a2e092c29b26529d05c76',
          file_name:
            'videos/54786708fbbcd6a925de403ad3acb0270e7c81690e5a2e092c29b26529d05c76.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/54786708fbbcd6a925de403ad3acb0270e7c81690e5a2e092c29b26529d05c76.mp4',
          name: 'BEGINNER-Modified_Forearm_Side_Plank_Crunches-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 47584,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1243,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: '751d407fc1157f1a6154beb07507b425cc8a5a5cd17d48ea9e58937a2121ef74',
          file_name:
            'videos/751d407fc1157f1a6154beb07507b425cc8a5a5cd17d48ea9e58937a2121ef74.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/751d407fc1157f1a6154beb07507b425cc8a5a5cd17d48ea9e58937a2121ef74.mp4',
          name: 'BEGINNER-Modified_Forearm_Side_Plank_Crunches-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 46963,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1244,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'c12a9bcf4e78fa67e248053abc40f814bc0dd5668dc75cde1c9347da0f246b65',
          file_name:
            'audios/c12a9bcf4e78fa67e248053abc40f814bc0dd5668dc75cde1c9347da0f246b65.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c12a9bcf4e78fa67e248053abc40f814bc0dd5668dc75cde1c9347da0f246b65.mp3',
          name: 'BEGINNER-Modified_Forearm_Side_Plank_Crunches-EXERCISE.mp3',
          description: null,
          size: 42500,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Modified_Jumping_Jacks-EXERCISE': {
      id: 558,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Modified Jumping Jacks',
      short_name: 'Modified Jumping Jacks',
      unique_name: 'BEGINNER-Modified_Jumping_Jacks-EXERCISE',
      description:
        '1. Stand with your feet close together, arms by sides, core tight.\n2. Bring your arms up overhead to a "V" shape and tap one foot out directly to the side.\n3. Bring your arms and leg back down and return to start.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1245,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'ff7b688bc7d3c0443a5fa81f47122601ac621f8d2ac7adf17e072708ac0ca323',
          file_name:
            'videos/ff7b688bc7d3c0443a5fa81f47122601ac621f8d2ac7adf17e072708ac0ca323.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ff7b688bc7d3c0443a5fa81f47122601ac621f8d2ac7adf17e072708ac0ca323.mp4',
          name: 'BEGINNER-Modified_Jumping_Jacks-EXERCISE.mp4',
          description: null,
          size: 89740,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1246,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '48e5d31803be3aa9b033be68f4b4db14bb9b5755af537c73a911611f998e31b6',
          file_name:
            'audios/48e5d31803be3aa9b033be68f4b4db14bb9b5755af537c73a911611f998e31b6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/48e5d31803be3aa9b033be68f4b4db14bb9b5755af537c73a911611f998e31b6.mp3',
          name: 'BEGINNER-Modified_Jumping_Jacks-EXERCISE.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Modified_Squat_Thrusts-EXERCISE': {
      id: 559,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Modified Squat Thrusts',
      short_name: 'Modified Squat Thrusts',
      unique_name: 'BEGINNER-Modified_Squat_Thrusts-EXERCISE',
      description:
        '1. Start in a squat with your feet a little wider than hip-width apart, hands up in front of your chest, palms face out.\n2. Place your hands on the floor, directly under shoulders and step one foot at a time behind you to Plank position.\n3. Step your feet back in one at a time to start position, heels on the ground.\n4. Transfer your weight back into the starting low squat position.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1247,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '116f0cdae28ccfae6d74f429abd62b79fa2ae1b3e8febf34a6c5eadfaf024c83',
          file_name:
            'videos/116f0cdae28ccfae6d74f429abd62b79fa2ae1b3e8febf34a6c5eadfaf024c83.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/116f0cdae28ccfae6d74f429abd62b79fa2ae1b3e8febf34a6c5eadfaf024c83.mp4',
          name: 'BEGINNER-Modified_Squat_Thrusts-EXERCISE.mp4',
          description: null,
          size: 171513,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1248,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '88fefaa1fb7c320d37344c939d009576a59e0b5c36535d425e4482d2e1016de7',
          file_name:
            'audios/88fefaa1fb7c320d37344c939d009576a59e0b5c36535d425e4482d2e1016de7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/88fefaa1fb7c320d37344c939d009576a59e0b5c36535d425e4482d2e1016de7.mp3',
          name: 'BEGINNER-Modified_Squat_Thrusts-EXERCISE.mp3',
          description: null,
          size: 29021,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Monkeys-EXERCISE': {
      id: 560,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Monkeys',
      short_name: 'Monkeys',
      unique_name: 'BEGINNER-Monkeys-EXERCISE',
      description:
        '1. Start with feet wider than shoulder-width apart. Bend your knees, drop hips down and place hands on floor to the side of one foot. Chest up.\r\n2. Bring your hands to the floor on the opposite side of the other foot.\r\n3. Staying low, press into palms and hop feet so you land on the other side of hands. Bring hands to touch the floor on the other side of feet.\r\n4. Repeat other direction. Down and back is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1249,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '9dd0e1ab88460f1466703dad00d5e2bdd4259dcafffe563b7821c09d71839a1c',
          file_name:
            'videos/9dd0e1ab88460f1466703dad00d5e2bdd4259dcafffe563b7821c09d71839a1c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9dd0e1ab88460f1466703dad00d5e2bdd4259dcafffe563b7821c09d71839a1c.mp4',
          name: 'BEG-INT-ADV-Monkeys-EXERCISE.mp4',
          description: null,
          size: 170164,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1250,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '82693032130f28473f737ff854f7540b6b8d37f467e3721acefedb574f0f2ae4',
          file_name:
            'audios/82693032130f28473f737ff854f7540b6b8d37f467e3721acefedb574f0f2ae4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/82693032130f28473f737ff854f7540b6b8d37f467e3721acefedb574f0f2ae4.mp3',
          name: 'BEG-INT-ADV-Monkeys-EXERCISE.mp3',
          description: null,
          size: 17736,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Monkeys-EXERCISE': {
      id: 561,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Monkeys',
      short_name: 'Monkeys',
      unique_name: 'INTERMEDIATE-Monkeys-EXERCISE',
      description:
        '1. Start with feet wider than shoulder-width apart. Bend your knees, drop hips down and place hands on floor to the side of one foot. Chest up.\r\n2. Bring your hands to the floor on the opposite side of the other foot.\r\n3. Staying low, press into palms and hop feet so you land on the other side of hands. Bring hands to touch the floor on the other side of feet.\r\n4. Repeat other direction. Down and back is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1251,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '9dd0e1ab88460f1466703dad00d5e2bdd4259dcafffe563b7821c09d71839a1c',
          file_name:
            'videos/9dd0e1ab88460f1466703dad00d5e2bdd4259dcafffe563b7821c09d71839a1c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9dd0e1ab88460f1466703dad00d5e2bdd4259dcafffe563b7821c09d71839a1c.mp4',
          name: 'BEG-INT-ADV-Monkeys-EXERCISE.mp4',
          description: null,
          size: 170164,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1252,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '82693032130f28473f737ff854f7540b6b8d37f467e3721acefedb574f0f2ae4',
          file_name:
            'audios/82693032130f28473f737ff854f7540b6b8d37f467e3721acefedb574f0f2ae4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/82693032130f28473f737ff854f7540b6b8d37f467e3721acefedb574f0f2ae4.mp3',
          name: 'BEG-INT-ADV-Monkeys-EXERCISE.mp3',
          description: null,
          size: 17736,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Monkeys-EXERCISE': {
      id: 562,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Monkeys',
      short_name: 'Monkeys',
      unique_name: 'ADVANCED-Monkeys-EXERCISE',
      description:
        '1. Start with feet wider than shoulder-width apart. Bend your knees, drop hips down and place hands on floor to the side of one foot. Chest up.\r\n2. Bring your hands to the floor on the opposite side of the other foot.\r\n3. Staying low, press into palms and hop feet so you land on the other side of hands. Bring hands to touch the floor on the other side of feet.\r\n4. Repeat other direction. Down and back is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1253,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '9dd0e1ab88460f1466703dad00d5e2bdd4259dcafffe563b7821c09d71839a1c',
          file_name:
            'videos/9dd0e1ab88460f1466703dad00d5e2bdd4259dcafffe563b7821c09d71839a1c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9dd0e1ab88460f1466703dad00d5e2bdd4259dcafffe563b7821c09d71839a1c.mp4',
          name: 'BEG-INT-ADV-Monkeys-EXERCISE.mp4',
          description: null,
          size: 170164,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1254,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '82693032130f28473f737ff854f7540b6b8d37f467e3721acefedb574f0f2ae4',
          file_name:
            'audios/82693032130f28473f737ff854f7540b6b8d37f467e3721acefedb574f0f2ae4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/82693032130f28473f737ff854f7540b6b8d37f467e3721acefedb574f0f2ae4.mp3',
          name: 'BEG-INT-ADV-Monkeys-EXERCISE.mp3',
          description: null,
          size: 17736,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Overhead_Punches-EXERCISE': {
      id: 563,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Overhead Punches',
      short_name: 'Overhead Punches',
      unique_name: 'BEGINNER-Overhead_Punches-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart. Bring your fists to your shoulders, palms face in, elbows down.\n2. With core engaged, swiftly punch one fist straight up into the air.\n3. As you bring your arm down, immediately punch upwards with the opposite arm.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1255,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '6fd50e52ca0eed81e2d893b7b4ba9b0146942781663adbd6c09536d6a87cf585',
          file_name:
            'videos/6fd50e52ca0eed81e2d893b7b4ba9b0146942781663adbd6c09536d6a87cf585.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6fd50e52ca0eed81e2d893b7b4ba9b0146942781663adbd6c09536d6a87cf585.mp4',
          name: 'BEGINNER-Overhead_Punches-EXERCISE.mp4',
          description: null,
          size: 47708,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1256,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'f084a021637a8fb61cbc782b0d13185b0602d4e3dbd03f6ddc22d791712383e7',
          file_name:
            'audios/f084a021637a8fb61cbc782b0d13185b0602d4e3dbd03f6ddc22d791712383e7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f084a021637a8fb61cbc782b0d13185b0602d4e3dbd03f6ddc22d791712383e7.mp3',
          name: 'BEGINNER-Overhead_Punches-EXERCISE.mp3',
          description: null,
          size: 24946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Plie_Squats-EXERCISE': {
      id: 564,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Plie Squats',
      short_name: 'Plie Squats',
      unique_name: 'BEGINNER-Plie_Squats-EXERCISE',
      description:
        '1. Start with your feet out wide, roughly double hip-width, toes turned out. Your hands can be in front of you or holding onto something for support.\n2. Keeping your back straight and core engaged, bend your knees and drop your tailbone straight down toward the floor, keeping your knees wide, tracking over your feet.\n3. Drive through your heels and return to start position.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1257,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '0f5e166d60dbb58e561dbcf07d93c8a18a4753cd7a1a120ae46653bbeceb23e2',
          file_name:
            'videos/0f5e166d60dbb58e561dbcf07d93c8a18a4753cd7a1a120ae46653bbeceb23e2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0f5e166d60dbb58e561dbcf07d93c8a18a4753cd7a1a120ae46653bbeceb23e2.mp4',
          name: 'BEGINNER-Plie_Squats-EXERCISE.mp4',
          description: null,
          size: 71811,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1258,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '22ac8b65b0fb59630c0c072f2e3fd4e7375a73db748d6aeefd0efc5027e632fa',
          file_name:
            'audios/22ac8b65b0fb59630c0c072f2e3fd4e7375a73db748d6aeefd0efc5027e632fa.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/22ac8b65b0fb59630c0c072f2e3fd4e7375a73db748d6aeefd0efc5027e632fa.mp3',
          name: 'BEGINNER-Plie_Squats-EXERCISE.mp3',
          description: null,
          size: 22438,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Prone_Ys-EXERCISE': {
      id: 565,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: "Prone Y's",
      short_name: "Prone Y's",
      unique_name: 'BEGINNER-Prone_Ys-EXERCISE',
      description:
        '1. Lie on your stomach with legs extended long, forehead resting on the floor and arms out to a "Y", hands in fists, palms down.\n2. Shrug your shoulders down. Raise both arms toward the ceiling as high as you can while keeping your chest, forehead and lower body on the floor.\n3. Pause for a beat at the top.\n4. Return to start position.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1259,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '523e82d5b3991f53a7cce470a0ebe786c81a8b6a7e22183e8321f5dcf5910513',
          file_name:
            'videos/523e82d5b3991f53a7cce470a0ebe786c81a8b6a7e22183e8321f5dcf5910513.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/523e82d5b3991f53a7cce470a0ebe786c81a8b6a7e22183e8321f5dcf5910513.mp4',
          name: 'BEGINNER-Prone_Ys-EXERCISE.mp4',
          description: null,
          size: 52113,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1260,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'f1bb68e78d64041edb10cbfc5261479e57837d7d0342cd45e04febed90766adc',
          file_name:
            'audios/f1bb68e78d64041edb10cbfc5261479e57837d7d0342cd45e04febed90766adc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f1bb68e78d64041edb10cbfc5261479e57837d7d0342cd45e04febed90766adc.mp3',
          name: 'BEGINNER-Prone_Ys-EXERCISE.mp3',
          description: null,
          size: 22124,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Reverse_Crunch_Pulse-EXERCISE': {
      id: 566,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Reverse Crunch Pulse',
      short_name: 'Reverse Crunch Pulse',
      unique_name: 'BEGINNER-Reverse_Crunch_Pulse-EXERCISE',
      description:
        '1. Lie on your back. Place your arms by your sides, palms facing down. Bring both legs up, knees slightly bent over your hips.\n2. Engage your core and lift your hips off the floor and raise your feet straight up towards the ceiling.\n3. Lower your hips back down and repeat all reps in a continuous movement.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1261,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '8a31dedd1ac5a42365dfc035821ae6a8360f130d87f2f61a885baff3a1b71940',
          file_name:
            'videos/8a31dedd1ac5a42365dfc035821ae6a8360f130d87f2f61a885baff3a1b71940.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8a31dedd1ac5a42365dfc035821ae6a8360f130d87f2f61a885baff3a1b71940.mp4',
          name: 'BEG-INT-ADV-Reverse_Crunch_Pulse-EXERCISE.mp4',
          description: null,
          size: 42531,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1262,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '9bb2aefda4ce550b0b2f1d94e2f4baac8def031ee56d9808542799312761300a',
          file_name:
            'audios/9bb2aefda4ce550b0b2f1d94e2f4baac8def031ee56d9808542799312761300a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9bb2aefda4ce550b0b2f1d94e2f4baac8def031ee56d9808542799312761300a.mp3',
          name: 'BEG-INT-ADV-Reverse_Crunch_Pulse-EXERCISE.mp3',
          description: null,
          size: 27767,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Reverse_Crunch_Pulse-EXERCISE': {
      id: 567,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Reverse Crunch Pulse',
      short_name: 'Reverse Crunch Pulse',
      unique_name: 'INTERMEDIATE-Reverse_Crunch_Pulse-EXERCISE',
      description:
        '1. Lie on your back. Place your arms by your sides, palms facing down. Bring both legs up, knees slightly bent over your hips.\n2. Engage your core and lift your hips off the floor and raise your feet straight up towards the ceiling.\n3. Lower your hips back down and repeat all reps in a continuous movement.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1263,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '8a31dedd1ac5a42365dfc035821ae6a8360f130d87f2f61a885baff3a1b71940',
          file_name:
            'videos/8a31dedd1ac5a42365dfc035821ae6a8360f130d87f2f61a885baff3a1b71940.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8a31dedd1ac5a42365dfc035821ae6a8360f130d87f2f61a885baff3a1b71940.mp4',
          name: 'BEG-INT-ADV-Reverse_Crunch_Pulse-EXERCISE.mp4',
          description: null,
          size: 42531,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1264,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '9bb2aefda4ce550b0b2f1d94e2f4baac8def031ee56d9808542799312761300a',
          file_name:
            'audios/9bb2aefda4ce550b0b2f1d94e2f4baac8def031ee56d9808542799312761300a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9bb2aefda4ce550b0b2f1d94e2f4baac8def031ee56d9808542799312761300a.mp3',
          name: 'BEG-INT-ADV-Reverse_Crunch_Pulse-EXERCISE.mp3',
          description: null,
          size: 27767,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Reverse_Crunch_Pulse-EXERCISE': {
      id: 568,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Reverse Crunch Pulse',
      short_name: 'Reverse Crunch Pulse',
      unique_name: 'ADVANCED-Reverse_Crunch_Pulse-EXERCISE',
      description:
        '1. Lie on your back. Place your arms by your sides, palms facing down. Bring both legs up, knees slightly bent over your hips.\n2. Engage your core and lift your hips off the floor and raise your feet straight up towards the ceiling.\n3. Lower your hips back down and repeat all reps in a continuous movement.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1265,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '8a31dedd1ac5a42365dfc035821ae6a8360f130d87f2f61a885baff3a1b71940',
          file_name:
            'videos/8a31dedd1ac5a42365dfc035821ae6a8360f130d87f2f61a885baff3a1b71940.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8a31dedd1ac5a42365dfc035821ae6a8360f130d87f2f61a885baff3a1b71940.mp4',
          name: 'BEG-INT-ADV-Reverse_Crunch_Pulse-EXERCISE.mp4',
          description: null,
          size: 42531,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1266,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '9bb2aefda4ce550b0b2f1d94e2f4baac8def031ee56d9808542799312761300a',
          file_name:
            'audios/9bb2aefda4ce550b0b2f1d94e2f4baac8def031ee56d9808542799312761300a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9bb2aefda4ce550b0b2f1d94e2f4baac8def031ee56d9808542799312761300a.mp3',
          name: 'BEG-INT-ADV-Reverse_Crunch_Pulse-EXERCISE.mp3',
          description: null,
          size: 27767,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Reverse_Tabletop_Leg_Lifts-EXERCISE': {
      id: 569,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Tabletop Leg Lifts',
      short_name: 'Reverse Tabletop Leg Lifts',
      unique_name: 'BEGINNER-Reverse_Tabletop_Leg_Lifts-EXERCISE',
      description:
        '1. Start in Reverse Tabletop with your hands flat on the floor under your shoulders, fingers toward hips. Knees bent, stacked over ankles, and hips elevated in line with your shoulders.\n2. Straighten one leg long in front of you, heel on the floor.\n3. Keeping your hips square and lifted, kick the extended leg toward the ceiling and lower with control.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1267,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'd79df6cba61f59a64c37e27efa55f3036db1642b35e4474c80bc02ed4c4bd307',
          file_name:
            'videos/d79df6cba61f59a64c37e27efa55f3036db1642b35e4474c80bc02ed4c4bd307.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d79df6cba61f59a64c37e27efa55f3036db1642b35e4474c80bc02ed4c4bd307.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Leg_Lifts-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 63820,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1268,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: '8f46001187d415cb41240e55465ed74909a89f027a4d241a258c37825c30e960',
          file_name:
            'videos/8f46001187d415cb41240e55465ed74909a89f027a4d241a258c37825c30e960.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8f46001187d415cb41240e55465ed74909a89f027a4d241a258c37825c30e960.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Leg_Lifts-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 65697,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1269,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '2e6d82946c26b9dc382bb1b57a42bec38faa65dff58caa7bdca44d003dfd8abc',
          file_name:
            'audios/2e6d82946c26b9dc382bb1b57a42bec38faa65dff58caa7bdca44d003dfd8abc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2e6d82946c26b9dc382bb1b57a42bec38faa65dff58caa7bdca44d003dfd8abc.mp3',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Leg_Lifts-EXERCISE.mp3',
          description: null,
          size: 32469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Reverse_Tabletop_Leg_Lifts-EXERCISE': {
      id: 570,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Tabletop Leg Lifts',
      short_name: 'Reverse Tabletop Leg Lifts',
      unique_name: 'INTERMEDIATE-Reverse_Tabletop_Leg_Lifts-EXERCISE',
      description:
        '1. Start in Reverse Tabletop with your hands flat on the floor under your shoulders, fingers toward hips. Knees bent, stacked over ankles, and hips elevated in line with your shoulders.\n2. Straighten one leg long in front of you, heel on the floor.\n3. Keeping your hips square and lifted, kick the extended leg toward the ceiling and lower with control.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1270,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'd79df6cba61f59a64c37e27efa55f3036db1642b35e4474c80bc02ed4c4bd307',
          file_name:
            'videos/d79df6cba61f59a64c37e27efa55f3036db1642b35e4474c80bc02ed4c4bd307.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d79df6cba61f59a64c37e27efa55f3036db1642b35e4474c80bc02ed4c4bd307.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Leg_Lifts-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 63820,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1271,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: '8f46001187d415cb41240e55465ed74909a89f027a4d241a258c37825c30e960',
          file_name:
            'videos/8f46001187d415cb41240e55465ed74909a89f027a4d241a258c37825c30e960.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8f46001187d415cb41240e55465ed74909a89f027a4d241a258c37825c30e960.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Leg_Lifts-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 65697,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1272,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '2e6d82946c26b9dc382bb1b57a42bec38faa65dff58caa7bdca44d003dfd8abc',
          file_name:
            'audios/2e6d82946c26b9dc382bb1b57a42bec38faa65dff58caa7bdca44d003dfd8abc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2e6d82946c26b9dc382bb1b57a42bec38faa65dff58caa7bdca44d003dfd8abc.mp3',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Leg_Lifts-EXERCISE.mp3',
          description: null,
          size: 32469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Reverse_Tabletop_Leg_Lifts-EXERCISE': {
      id: 571,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Tabletop Leg Lifts',
      short_name: 'Reverse Tabletop Leg Lifts',
      unique_name: 'ADVANCED-Reverse_Tabletop_Leg_Lifts-EXERCISE',
      description:
        '1. Start in Reverse Tabletop with your hands flat on the floor under your shoulders, fingers toward hips. Knees bent, stacked over ankles, and hips elevated in line with your shoulders.\n2. Straighten one leg long in front of you, heel on the floor.\n3. Keeping your hips square and lifted, kick the extended leg toward the ceiling and lower with control.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1273,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'd79df6cba61f59a64c37e27efa55f3036db1642b35e4474c80bc02ed4c4bd307',
          file_name:
            'videos/d79df6cba61f59a64c37e27efa55f3036db1642b35e4474c80bc02ed4c4bd307.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d79df6cba61f59a64c37e27efa55f3036db1642b35e4474c80bc02ed4c4bd307.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Leg_Lifts-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 63820,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1274,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: '8f46001187d415cb41240e55465ed74909a89f027a4d241a258c37825c30e960',
          file_name:
            'videos/8f46001187d415cb41240e55465ed74909a89f027a4d241a258c37825c30e960.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8f46001187d415cb41240e55465ed74909a89f027a4d241a258c37825c30e960.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Leg_Lifts-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 65697,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1275,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '2e6d82946c26b9dc382bb1b57a42bec38faa65dff58caa7bdca44d003dfd8abc',
          file_name:
            'audios/2e6d82946c26b9dc382bb1b57a42bec38faa65dff58caa7bdca44d003dfd8abc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2e6d82946c26b9dc382bb1b57a42bec38faa65dff58caa7bdca44d003dfd8abc.mp3',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Leg_Lifts-EXERCISE.mp3',
          description: null,
          size: 32469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Rolling_Knee_Side_Planks-EXERCISE': {
      id: 572,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Rolling Knee Side Planks',
      short_name: 'Rolling Knee Side Planks',
      unique_name: 'BEGINNER-Rolling_Knee_Side_Planks-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists. Drop your knees straight down to the floor and lift your feet up.\n2. Keeping your body in a straight line, roll to one forearm as you raise your other arm directly overhead and extend the top leg straight in Modified Side Plank.\n3. Roll back down to start position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1276,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '503b1c2f2c8d44973c7d94d84283d51e3a6310077e1c1ad14849deb45dbb0aed',
          file_name:
            'videos/503b1c2f2c8d44973c7d94d84283d51e3a6310077e1c1ad14849deb45dbb0aed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/503b1c2f2c8d44973c7d94d84283d51e3a6310077e1c1ad14849deb45dbb0aed.mp4',
          name: 'BEGINNER-Rolling_Knee_Side_Planks-EXERCISE.mp4',
          description: null,
          size: 223849,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1277,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '19e056722fb6c6bc7b87dfc191237a19b0391c9269338a7713098ccaac3da3ef',
          file_name:
            'audios/19e056722fb6c6bc7b87dfc191237a19b0391c9269338a7713098ccaac3da3ef.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/19e056722fb6c6bc7b87dfc191237a19b0391c9269338a7713098ccaac3da3ef.mp3',
          name: 'BEGINNER-Rolling_Knee_Side_Planks-EXERCISE.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Side_Lunges-EXERCISE': {
      id: 573,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Side Lunges',
      short_name: 'Side Lunges',
      unique_name: 'BEGINNER-Side_Lunges-EXERCISE',
      description:
        '1. Stand tall, feet and legs together in a close stance.\n2. Keeping your chest up, take a big step out to the side as wide as possible, toes forward. When you land, bend your knee and sink hips to about 90 degrees. Keep the other leg straight and feet planted on the floor.\n3. Powerfully drive through your heel and push yourself up to standing.\n4. Perform all reps on one leg. Repeat with the other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1278,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '10d77c3cf7c618c64964b7a0de5ce3ec08384e2e17068b80b84d8b882fdd38ea',
          file_name:
            'videos/10d77c3cf7c618c64964b7a0de5ce3ec08384e2e17068b80b84d8b882fdd38ea.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/10d77c3cf7c618c64964b7a0de5ce3ec08384e2e17068b80b84d8b882fdd38ea.mp4',
          name: 'BEG-INT-ADV-Side_Lunges-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 153986,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1279,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: 'f0cb96b031581e926263c8839a8a66159d0c7453681d4add9fde07b0e230b7f5',
          file_name:
            'videos/f0cb96b031581e926263c8839a8a66159d0c7453681d4add9fde07b0e230b7f5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f0cb96b031581e926263c8839a8a66159d0c7453681d4add9fde07b0e230b7f5.mp4',
          name: 'BEG-INT-ADV-Side_Lunges-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 129432,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1280,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '37d285d202e79e9f0470842e5c1675004a68a291fe1c4d89cd202cf9625d74d5',
          file_name:
            'audios/37d285d202e79e9f0470842e5c1675004a68a291fe1c4d89cd202cf9625d74d5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/37d285d202e79e9f0470842e5c1675004a68a291fe1c4d89cd202cf9625d74d5.mp3',
          name: 'BEG-INT-ADV-Side_Lunges-EXERCISE.mp3',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Side_Lunges-EXERCISE': {
      id: 574,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Side Lunges',
      short_name: 'Side Lunges',
      unique_name: 'INTERMEDIATE-Side_Lunges-EXERCISE',
      description:
        '1. Stand tall, feet and legs together in a close stance.\n2. Keeping your chest up, take a big step out to the side as wide as possible, toes forward. When you land, bend your knee and sink hips to about 90 degrees. Keep the other leg straight and feet planted on the floor.\n3. Powerfully drive through your heel and push yourself up to standing.\n4. Perform all reps on one leg. Repeat with the other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1281,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '10d77c3cf7c618c64964b7a0de5ce3ec08384e2e17068b80b84d8b882fdd38ea',
          file_name:
            'videos/10d77c3cf7c618c64964b7a0de5ce3ec08384e2e17068b80b84d8b882fdd38ea.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/10d77c3cf7c618c64964b7a0de5ce3ec08384e2e17068b80b84d8b882fdd38ea.mp4',
          name: 'BEG-INT-ADV-Side_Lunges-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 153986,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1282,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: 'f0cb96b031581e926263c8839a8a66159d0c7453681d4add9fde07b0e230b7f5',
          file_name:
            'videos/f0cb96b031581e926263c8839a8a66159d0c7453681d4add9fde07b0e230b7f5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f0cb96b031581e926263c8839a8a66159d0c7453681d4add9fde07b0e230b7f5.mp4',
          name: 'BEG-INT-ADV-Side_Lunges-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 129432,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1283,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '37d285d202e79e9f0470842e5c1675004a68a291fe1c4d89cd202cf9625d74d5',
          file_name:
            'audios/37d285d202e79e9f0470842e5c1675004a68a291fe1c4d89cd202cf9625d74d5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/37d285d202e79e9f0470842e5c1675004a68a291fe1c4d89cd202cf9625d74d5.mp3',
          name: 'BEG-INT-ADV-Side_Lunges-EXERCISE.mp3',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Side_Lunges-EXERCISE': {
      id: 575,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Side Lunges',
      short_name: 'Side Lunges',
      unique_name: 'ADVANCED-Side_Lunges-EXERCISE',
      description:
        '1. Stand tall, feet and legs together in a close stance.\n2. Keeping your chest up, take a big step out to the side as wide as possible, toes forward. When you land, bend your knee and sink hips to about 90 degrees. Keep the other leg straight and feet planted on the floor.\n3. Powerfully drive through your heel and push yourself up to standing.\n4. Perform all reps on one leg. Repeat with the other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1284,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '10d77c3cf7c618c64964b7a0de5ce3ec08384e2e17068b80b84d8b882fdd38ea',
          file_name:
            'videos/10d77c3cf7c618c64964b7a0de5ce3ec08384e2e17068b80b84d8b882fdd38ea.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/10d77c3cf7c618c64964b7a0de5ce3ec08384e2e17068b80b84d8b882fdd38ea.mp4',
          name: 'BEG-INT-ADV-Side_Lunges-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 153986,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1285,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: 'f0cb96b031581e926263c8839a8a66159d0c7453681d4add9fde07b0e230b7f5',
          file_name:
            'videos/f0cb96b031581e926263c8839a8a66159d0c7453681d4add9fde07b0e230b7f5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f0cb96b031581e926263c8839a8a66159d0c7453681d4add9fde07b0e230b7f5.mp4',
          name: 'BEG-INT-ADV-Side_Lunges-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 129432,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1286,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '37d285d202e79e9f0470842e5c1675004a68a291fe1c4d89cd202cf9625d74d5',
          file_name:
            'audios/37d285d202e79e9f0470842e5c1675004a68a291fe1c4d89cd202cf9625d74d5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/37d285d202e79e9f0470842e5c1675004a68a291fe1c4d89cd202cf9625d74d5.mp3',
          name: 'BEG-INT-ADV-Side_Lunges-EXERCISE.mp3',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Squat_Thrusts-EXERCISE': {
      id: 576,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Squat Thrusts',
      short_name: 'Squat Thrusts',
      unique_name: 'INTERMEDIATE-Squat_Thrusts-EXERCISE',
      description:
        '1. Start in a squat with your feet a little wider than hip-width apart, hands up in front of your chest, palms facing out.\n2. Place both hands on the floor, directly under shoulders and jump your feet back behind you to Plank position.\n3. Jump your feet back in to start position, heels on the ground.\n4. Transfer your weight back into the starting low squat position.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1287,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '07cb983bf734cd04752760d1e6aba48dff98e129a6040b950fdc6c72e9c8bff9',
          file_name:
            'videos/07cb983bf734cd04752760d1e6aba48dff98e129a6040b950fdc6c72e9c8bff9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/07cb983bf734cd04752760d1e6aba48dff98e129a6040b950fdc6c72e9c8bff9.mp4',
          name: 'INT-ADV-Squat_Thrusts-EXERCISE.mp4',
          description: null,
          size: 105578,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1288,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '01fa23e55931bc044ad0ca2123c6c6b7d423ae4898cefdc9e12e7c0cba99e9ef',
          file_name:
            'audios/01fa23e55931bc044ad0ca2123c6c6b7d423ae4898cefdc9e12e7c0cba99e9ef.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/01fa23e55931bc044ad0ca2123c6c6b7d423ae4898cefdc9e12e7c0cba99e9ef.mp3',
          name: 'INT-ADV-Squat_Thrusts-EXERCISE.mp3',
          description: null,
          size: 22124,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Squat_Thrusts-EXERCISE': {
      id: 577,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Squat Thrusts',
      short_name: 'Squat Thrusts',
      unique_name: 'ADVANCED-Squat_Thrusts-EXERCISE',
      description:
        '1. Start in a squat with your feet a little wider than hip-width apart, hands up in front of your chest, palms facing out.\n2. Place both hands on the floor, directly under shoulders and jump your feet back behind you to Plank position.\n3. Jump your feet back in to start position, heels on the ground.\n4. Transfer your weight back into the starting low squat position.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1289,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '07cb983bf734cd04752760d1e6aba48dff98e129a6040b950fdc6c72e9c8bff9',
          file_name:
            'videos/07cb983bf734cd04752760d1e6aba48dff98e129a6040b950fdc6c72e9c8bff9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/07cb983bf734cd04752760d1e6aba48dff98e129a6040b950fdc6c72e9c8bff9.mp4',
          name: 'INT-ADV-Squat_Thrusts-EXERCISE.mp4',
          description: null,
          size: 105578,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1290,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '01fa23e55931bc044ad0ca2123c6c6b7d423ae4898cefdc9e12e7c0cba99e9ef',
          file_name:
            'audios/01fa23e55931bc044ad0ca2123c6c6b7d423ae4898cefdc9e12e7c0cba99e9ef.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/01fa23e55931bc044ad0ca2123c6c6b7d423ae4898cefdc9e12e7c0cba99e9ef.mp3',
          name: 'INT-ADV-Squat_Thrusts-EXERCISE.mp3',
          description: null,
          size: 22124,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Squat_with_Alternating_Hip_Abduction-EXERCISE': {
      id: 578,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Squat with Alternating Hip Abduction',
      short_name: 'Squat with Alternating Hip Abduction',
      unique_name: 'BEGINNER-Squat_with_Alternating_Hip_Abduction-EXERCISE',
      description:
        '1. Stand with your feet roughly shoulder-width apart.\n2. Keeping your chest up, drive your hips back and bend your knees to squat down as low as you can.\n3. As you come up, lift one leg out to the side keeping hips square, knees and toes facing forward. Only lift as far as you can without opening up your hip and over rotating.\n4. Squat again and repeat with the other leg. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1297,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '08cdfe7b5e2ddfa3d10dc77e84229d70681eb8bb090a4cca0764daf590020012',
          file_name:
            'videos/08cdfe7b5e2ddfa3d10dc77e84229d70681eb8bb090a4cca0764daf590020012.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/08cdfe7b5e2ddfa3d10dc77e84229d70681eb8bb090a4cca0764daf590020012.mp4',
          name: 'BEGINNER-Squat_with_Alternating_Hip_Abduction-EXERCISE.mp4',
          description: null,
          size: 203758,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1298,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'b13563b2247a03d4e44bc034decb75ee4df36f8db6f7717ae336f250d1d85898',
          file_name:
            'audios/b13563b2247a03d4e44bc034decb75ee4df36f8db6f7717ae336f250d1d85898.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b13563b2247a03d4e44bc034decb75ee4df36f8db6f7717ae336f250d1d85898.mp3',
          name: 'BEGINNER-Squat_with_Alternating_Hip_Abduction-EXERCISE.mp3',
          description: null,
          size: 39679,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Squats_with_Side_Kick-EXERCISE': {
      id: 579,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Squats with Side Kick',
      short_name: 'Squats with Side Kick',
      unique_name: 'INTERMEDIATE-Squats_with_Side_Kick-EXERCISE',
      description:
        '1. Stand with your feet roughly shoulder-width apart, hands in fists in front of chin.\n2. Keeping chest up, drive hips back and bend knees to squat as low as you can.\n3. As you come up, pick up one knee and pivot slightly outward on base foot. Kick leg out to the side as your upper body leans away from the kick.\n4. Recoil leg back in to start position. Perform all reps on one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1299,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '6cd6cfce86cb3c11b93a46c2ceb902b445041d0ad958a414ee937fb1d15896bc',
          file_name:
            'videos/6cd6cfce86cb3c11b93a46c2ceb902b445041d0ad958a414ee937fb1d15896bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6cd6cfce86cb3c11b93a46c2ceb902b445041d0ad958a414ee937fb1d15896bc.mp4',
          name: 'INT-ADV-Squats_with_Side_Kick-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 76660,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1300,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: 'd80f6a47025851745cf254c84283175284549d918d2b1a1b1eda6494286c5d9e',
          file_name:
            'videos/d80f6a47025851745cf254c84283175284549d918d2b1a1b1eda6494286c5d9e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d80f6a47025851745cf254c84283175284549d918d2b1a1b1eda6494286c5d9e.mp4',
          name: 'INT-ADV-Squats_with_Side_Kick-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 78969,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1301,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '68872883bfa38d2a7d3a86010ee66bfb7804b97df0c8d96699244a35173a80b9',
          file_name:
            'audios/68872883bfa38d2a7d3a86010ee66bfb7804b97df0c8d96699244a35173a80b9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/68872883bfa38d2a7d3a86010ee66bfb7804b97df0c8d96699244a35173a80b9.mp3',
          name: 'INT-ADV-Squats_with_Side_Kick-EXERCISE.mp3',
          description: null,
          size: 29021,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Squats_with_Side_Kick-EXERCISE': {
      id: 580,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Squats with Side Kick',
      short_name: 'Squats with Side Kick',
      unique_name: 'ADVANCED-Squats_with_Side_Kick-EXERCISE',
      description:
        '1. Stand with your feet roughly shoulder-width apart, hands in fists in front of chin.\n2. Keeping chest up, drive hips back and bend knees to squat as low as you can.\n3. As you come up, pick up one knee and pivot slightly outward on base foot. Kick leg out to the side as your upper body leans away from the kick.\n4. Recoil leg back in to start position. Perform all reps on one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1302,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '6cd6cfce86cb3c11b93a46c2ceb902b445041d0ad958a414ee937fb1d15896bc',
          file_name:
            'videos/6cd6cfce86cb3c11b93a46c2ceb902b445041d0ad958a414ee937fb1d15896bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6cd6cfce86cb3c11b93a46c2ceb902b445041d0ad958a414ee937fb1d15896bc.mp4',
          name: 'INT-ADV-Squats_with_Side_Kick-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 76660,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1303,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: 'd80f6a47025851745cf254c84283175284549d918d2b1a1b1eda6494286c5d9e',
          file_name:
            'videos/d80f6a47025851745cf254c84283175284549d918d2b1a1b1eda6494286c5d9e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d80f6a47025851745cf254c84283175284549d918d2b1a1b1eda6494286c5d9e.mp4',
          name: 'INT-ADV-Squats_with_Side_Kick-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 78969,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1304,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '68872883bfa38d2a7d3a86010ee66bfb7804b97df0c8d96699244a35173a80b9',
          file_name:
            'audios/68872883bfa38d2a7d3a86010ee66bfb7804b97df0c8d96699244a35173a80b9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/68872883bfa38d2a7d3a86010ee66bfb7804b97df0c8d96699244a35173a80b9.mp3',
          name: 'INT-ADV-Squats_with_Side_Kick-EXERCISE.mp3',
          description: null,
          size: 29021,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Stability_Ball_Ab_Roll_Out-EXERCISE': {
      id: 581,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Stability Ball Ab Roll Out',
      short_name: 'Stability Ball Ab Roll Out',
      unique_name: 'INTERMEDIATE-Stability_Ball_Ab_Roll_Out-EXERCISE',
      description:
        '1. Start in a high kneeling position with hands clasped together on top of the Stability Ball.\n2. Keeping core tight and long spine, press hands into the ball and roll it out in front of you as your arms and body straighen. Extend as far as you can, keeping body in one piece and hips in line with upper body.\n3. Reverse the motion by pulling your forearms back in until you return to start.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1305,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '4398872581a5e57675d3027bd0fe06aefad9f4152d193514a3dbc97ee3f470dc',
          file_name:
            'videos/4398872581a5e57675d3027bd0fe06aefad9f4152d193514a3dbc97ee3f470dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4398872581a5e57675d3027bd0fe06aefad9f4152d193514a3dbc97ee3f470dc.mp4',
          name: 'INT-ADV-Stability_Ball_Ab_Roll_Out-EXERCISE.mp4',
          description: null,
          size: 157564,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1306,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '2f9bafbc838df3cfb7fb066fc1e5208231c056038ed6b4e8a3fe11a0ee89564e',
          file_name:
            'audios/2f9bafbc838df3cfb7fb066fc1e5208231c056038ed6b4e8a3fe11a0ee89564e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2f9bafbc838df3cfb7fb066fc1e5208231c056038ed6b4e8a3fe11a0ee89564e.mp3',
          name: 'INT-ADV-Stability_Ball_Ab_Roll_Out-EXERCISE.mp3',
          description: null,
          size: 34036,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Stability_Ball_Ab_Roll_Out-EXERCISE': {
      id: 582,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Stability Ball Ab Roll Out',
      short_name: 'Stability Ball Ab Roll Out',
      unique_name: 'ADVANCED-Stability_Ball_Ab_Roll_Out-EXERCISE',
      description:
        '1. Start in a high kneeling position with hands clasped together on top of the Stability Ball.\n2. Keeping core tight and long spine, press hands into the ball and roll it out in front of you as your arms and body straighen. Extend as far as you can, keeping body in one piece and hips in line with upper body.\n3. Reverse the motion by pulling your forearms back in until you return to start.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1307,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '4398872581a5e57675d3027bd0fe06aefad9f4152d193514a3dbc97ee3f470dc',
          file_name:
            'videos/4398872581a5e57675d3027bd0fe06aefad9f4152d193514a3dbc97ee3f470dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4398872581a5e57675d3027bd0fe06aefad9f4152d193514a3dbc97ee3f470dc.mp4',
          name: 'INT-ADV-Stability_Ball_Ab_Roll_Out-EXERCISE.mp4',
          description: null,
          size: 157564,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1308,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '2f9bafbc838df3cfb7fb066fc1e5208231c056038ed6b4e8a3fe11a0ee89564e',
          file_name:
            'audios/2f9bafbc838df3cfb7fb066fc1e5208231c056038ed6b4e8a3fe11a0ee89564e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2f9bafbc838df3cfb7fb066fc1e5208231c056038ed6b4e8a3fe11a0ee89564e.mp3',
          name: 'INT-ADV-Stability_Ball_Ab_Roll_Out-EXERCISE.mp3',
          description: null,
          size: 34036,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Stability_Ball_Froggers-EXERCISE': {
      id: 583,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Stability Ball Froggers',
      short_name: 'Stability Ball Froggers',
      unique_name: 'INTERMEDIATE-Stability_Ball_Froggers-EXERCISE',
      description:
        '1. Lie with your stomach on a stability ball, hands on the floor under your shoulders.\n2. Bend both knees and bring them out wide. Touch the soles of your feet together.\n3. Keep upper body stable, engage glutes, and lift both feet up into the air until your thighs leave the ball. Do not arch your back.\n4. Pause for a beat and lower back down with control.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1309,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '1937853b39a599e6634358334e8494d933b30cfe8f7c85320545bc86d818437e',
          file_name:
            'videos/1937853b39a599e6634358334e8494d933b30cfe8f7c85320545bc86d818437e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1937853b39a599e6634358334e8494d933b30cfe8f7c85320545bc86d818437e.mp4',
          name: 'INT-ADV-Stability_Ball_Froggers-EXERCISE.mp4',
          description: null,
          size: 61642,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1310,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'e3c9b87269e3ee7112140389b5492242b492e21fa71d4e542dce23ea8e8edd6c',
          file_name:
            'audios/e3c9b87269e3ee7112140389b5492242b492e21fa71d4e542dce23ea8e8edd6c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e3c9b87269e3ee7112140389b5492242b492e21fa71d4e542dce23ea8e8edd6c.mp3',
          name: 'INT-ADV-Stability_Ball_Froggers-EXERCISE.mp3',
          description: null,
          size: 30275,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Stability_Ball_Froggers-EXERCISE': {
      id: 584,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Stability Ball Froggers',
      short_name: 'Stability Ball Froggers',
      unique_name: 'ADVANCED-Stability_Ball_Froggers-EXERCISE',
      description:
        '1. Lie with your stomach on a stability ball, hands on the floor under your shoulders.\n2. Bend both knees and bring them out wide. Touch the soles of your feet together.\n3. Keep upper body stable, engage glutes, and lift both feet up into the air until your thighs leave the ball. Do not arch your back.\n4. Pause for a beat and lower back down with control.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1311,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '1937853b39a599e6634358334e8494d933b30cfe8f7c85320545bc86d818437e',
          file_name:
            'videos/1937853b39a599e6634358334e8494d933b30cfe8f7c85320545bc86d818437e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1937853b39a599e6634358334e8494d933b30cfe8f7c85320545bc86d818437e.mp4',
          name: 'INT-ADV-Stability_Ball_Froggers-EXERCISE.mp4',
          description: null,
          size: 61642,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1312,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'e3c9b87269e3ee7112140389b5492242b492e21fa71d4e542dce23ea8e8edd6c',
          file_name:
            'audios/e3c9b87269e3ee7112140389b5492242b492e21fa71d4e542dce23ea8e8edd6c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e3c9b87269e3ee7112140389b5492242b492e21fa71d4e542dce23ea8e8edd6c.mp3',
          name: 'INT-ADV-Stability_Ball_Froggers-EXERCISE.mp3',
          description: null,
          size: 30275,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Standing_Hamstring_Curls-EXERCISE': {
      id: 585,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Standing Hamstring Curls',
      short_name: 'Standing Hamstring Curls',
      unique_name: 'BEGINNER-Standing_Hamstring_Curls-EXERCISE',
      description:
        '1. Stand tall with your feet and legs in a close stance. Place hands on hips or hold onto a chair or wall for assistance.\n2. Keeping core tight, hips square and thighs parallel, bend one knee bringing your heel toward your glutes. Your shin should be about parallel to the floor. Pause and squeeze.\n3. With control, lower back to start. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1313,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '6d141985a2bd3d02eabb02e438ee4644d95ca238a686dd46da89ace6a35b753b',
          file_name:
            'videos/6d141985a2bd3d02eabb02e438ee4644d95ca238a686dd46da89ace6a35b753b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6d141985a2bd3d02eabb02e438ee4644d95ca238a686dd46da89ace6a35b753b.mp4',
          name: 'BEGINNER-Standing_Hamstring_Curls-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 57089,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1314,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: '0d1d4dcde5d2600e2eb7dbca73dff75442d475629e66b3b3631f7e519f28f33b',
          file_name:
            'videos/0d1d4dcde5d2600e2eb7dbca73dff75442d475629e66b3b3631f7e519f28f33b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0d1d4dcde5d2600e2eb7dbca73dff75442d475629e66b3b3631f7e519f28f33b.mp4',
          name: 'BEGINNER-Standing_Hamstring_Curls-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 51843,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1315,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '9c4d01f2bf829a1ba953fdb9e12a16f9c9a644f7fd2531091e82bec9a4ba7ad9',
          file_name:
            'audios/9c4d01f2bf829a1ba953fdb9e12a16f9c9a644f7fd2531091e82bec9a4ba7ad9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9c4d01f2bf829a1ba953fdb9e12a16f9c9a644f7fd2531091e82bec9a4ba7ad9.mp3',
          name: 'BEGINNER-Standing_Hamstring_Curls-EXERCISE.mp3',
          description: null,
          size: 30588,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Standing_Hip_Abductions-EXERCISE': {
      id: 586,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Standing Hip Abductions',
      short_name: 'Standing Hip Abductions',
      unique_name: 'BEGINNER-Standing_Hip_Abductions-EXERCISE',
      description:
        '1. Stand with your feet about hip-width apart, toes forward, hands on hips and core tight.\n2. Lift one leg out to the side, keeping hips square and knees and toes facing forward. Only lift as far as you can without opening up your hip and over rotating.\n3. Pause and lower back to the floor.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1316,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '5e658f548123a912ccd2ed0b6ee4ff0497ac583b3fda8297ee59926f99dc0fbe',
          file_name:
            'videos/5e658f548123a912ccd2ed0b6ee4ff0497ac583b3fda8297ee59926f99dc0fbe.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5e658f548123a912ccd2ed0b6ee4ff0497ac583b3fda8297ee59926f99dc0fbe.mp4',
          name: 'BEGINNER-Standing_Hip_Abductions-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 60177,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1317,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: '4388fdaa7bc0fc27d94161b1d404778cca7066d75bbd97d40da26d6162ed746d',
          file_name:
            'videos/4388fdaa7bc0fc27d94161b1d404778cca7066d75bbd97d40da26d6162ed746d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4388fdaa7bc0fc27d94161b1d404778cca7066d75bbd97d40da26d6162ed746d.mp4',
          name: 'BEGINNER-Standing_Hip_Abductions-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 61517,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1318,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'b3a17a89f23fee46f2da770582d8b400a1e6180378d3274557291b6c3c06bb89',
          file_name:
            'audios/b3a17a89f23fee46f2da770582d8b400a1e6180378d3274557291b6c3c06bb89.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b3a17a89f23fee46f2da770582d8b400a1e6180378d3274557291b6c3c06bb89.mp3',
          name: 'BEGINNER-Standing_Hip_Abductions-EXERCISE.mp3',
          description: null,
          size: 30275,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Standing_Oblique_Crunches-EXERCISE': {
      id: 587,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Standing Oblique Crunches',
      short_name: 'Standing Oblique Crunches',
      unique_name: 'BEGINNER-Standing_Oblique_Crunches-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart and raise arms overhead in a "V".\n2. Transfer weight to one leg and lean slightly for counterbalance.\n3. Drop other elbow and lift same side knee out to the side of your body simultaneously, bringing them together to crunch in the center. Pause.\n4. Extend arm and leg back out, keeping weight on standing leg. Perform all reps one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1319,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '0bee2b10b5cc815776711581d45601fb8c35c67308052838d51f40bbb79e880c',
          file_name:
            'videos/0bee2b10b5cc815776711581d45601fb8c35c67308052838d51f40bbb79e880c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0bee2b10b5cc815776711581d45601fb8c35c67308052838d51f40bbb79e880c.mp4',
          name: 'BEGINNER-Standing_Oblique_Crunches-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 71473,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1320,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: '72d0f585770a16fa23337777f248b7b66c94c42c047d5879b1196acde5cad02d',
          file_name:
            'videos/72d0f585770a16fa23337777f248b7b66c94c42c047d5879b1196acde5cad02d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/72d0f585770a16fa23337777f248b7b66c94c42c047d5879b1196acde5cad02d.mp4',
          name: 'BEGINNER-Standing_Oblique_Crunches-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 66744,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1321,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'd482952b2fb91218c0819477e3ffd8d103299aa1771a0c189b8046acfa4258ce',
          file_name:
            'audios/d482952b2fb91218c0819477e3ffd8d103299aa1771a0c189b8046acfa4258ce.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d482952b2fb91218c0819477e3ffd8d103299aa1771a0c189b8046acfa4258ce.mp3',
          name: 'BEGINNER-Standing_Oblique_Crunches-EXERCISE.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Step_Tap_and_Reach-EXERCISE': {
      id: 588,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Step Tap and Reach',
      short_name: 'Step Tap and Reach',
      unique_name: 'BEGINNER-Step_Tap_and_Reach-EXERCISE',
      description:
        '1. Stand with your feet about hip-width apart, toes pointing forward, hands by your sides.\n2. Keeping your chest up, bend both knees and perform a mini squat.\n3. As you come up, transfer all your weight onto one leg and tap out to the side with the other leg. Reach the same side arm overhead.\n4. Return arm and leg back to center and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1322,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '7bab270ff19555f47ab7b793d8d80f34f4c36485b220134ad0df7daa40aa46ae',
          file_name:
            'videos/7bab270ff19555f47ab7b793d8d80f34f4c36485b220134ad0df7daa40aa46ae.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7bab270ff19555f47ab7b793d8d80f34f4c36485b220134ad0df7daa40aa46ae.mp4',
          name: 'BEGINNER-Step_Tap_and_Reach-EXERCISE.mp4',
          description: null,
          size: 94279,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1323,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'd392973b8c9eb1af6f80a9d390aeeca3a3a421b8bd1ef5e619188c8be0d91a60',
          file_name:
            'audios/d392973b8c9eb1af6f80a9d390aeeca3a3a421b8bd1ef5e619188c8be0d91a60.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d392973b8c9eb1af6f80a9d390aeeca3a3a421b8bd1ef5e619188c8be0d91a60.mp3',
          name: 'BEGINNER-Step_Tap_and_Reach-EXERCISE.mp3',
          description: null,
          size: 28080,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Step_Touch_and_Press-EXERCISE': {
      id: 589,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Step Touch and Press',
      short_name: 'Step Touch and Press',
      unique_name: 'BEGINNER-Step_Touch_and_Press-EXERCISE',
      description:
        '1. Stand with your feet close together. Bring your hands to shoulder-height, elbows down, palms facing out.\n2. Take a big step directly to the side with one foot.\n3. Step the other foot in to meet it as you push both arms straight out in front of your body.\n4. Bring both arms back to start position and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1324,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: '09152e9f306fb7a82529236cba81a3b8b2a75f3924c2b6404f6fb4ffa8247211',
          file_name:
            'videos/09152e9f306fb7a82529236cba81a3b8b2a75f3924c2b6404f6fb4ffa8247211.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/09152e9f306fb7a82529236cba81a3b8b2a75f3924c2b6404f6fb4ffa8247211.mp4',
          name: 'BEGINNER-Step_Touch_and_Press-EXERCISE.mp4',
          description: null,
          size: 80953,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1325,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '1ba7cf9950685ebad94ff11c4f39d90a1c9fe0c5c21d6309ca0e947d40ad89dd',
          file_name:
            'audios/1ba7cf9950685ebad94ff11c4f39d90a1c9fe0c5c21d6309ca0e947d40ad89dd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1ba7cf9950685ebad94ff11c4f39d90a1c9fe0c5c21d6309ca0e947d40ad89dd.mp3',
          name: 'BEGINNER-Step_Touch_and_Press-EXERCISE.mp3',
          description: null,
          size: 29021,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Straight_Leg_Glute_Lifts-EXERCISE': {
      id: 590,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Straight Leg Glute Lifts',
      short_name: 'Straight Leg Glute Lifts',
      unique_name: 'BEGINNER-Straight_Leg_Glute_Lifts-EXERCISE',
      description:
        "1. Start on all fours with shoulders over wrists and knees under hips. Keep your hips square and core tight.\n2. Extend one leg straight behind you, resting your toe on the floor.\n3. Lift your leg straight up to hip level, parallel to the floor. Pause for a beat and squeeze glutes at the top. Don't arch your lower back. Slowly lower back to start position.\n4. Perform all reps on one leg. Repeat other side.",
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1326,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'bda448fbfcc0dbb0f9c63889727c7fd034120a7901508fb0087e3493b7627b58',
          file_name:
            'videos/bda448fbfcc0dbb0f9c63889727c7fd034120a7901508fb0087e3493b7627b58.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bda448fbfcc0dbb0f9c63889727c7fd034120a7901508fb0087e3493b7627b58.mp4',
          name: 'BEGINNER-Straight_Leg_Glute_Lifts-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 58442,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1327,
          collection_name: 'videos',
          order: 2,
          version: 200020000,
          hash: 'c4b8aad240ad5f6b9f40741249437f581a21b2a2a22661fcdde8b55affa41d08',
          file_name:
            'videos/c4b8aad240ad5f6b9f40741249437f581a21b2a2a22661fcdde8b55affa41d08.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c4b8aad240ad5f6b9f40741249437f581a21b2a2a22661fcdde8b55affa41d08.mp4',
          name: 'BEGINNER-Straight_Leg_Glute_Lifts-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 58288,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1328,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: '92ad2a836af436a740857c2b794507e71d897d2025f356b4d96019f416a41da3',
          file_name:
            'audios/92ad2a836af436a740857c2b794507e71d897d2025f356b4d96019f416a41da3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/92ad2a836af436a740857c2b794507e71d897d2025f356b4d96019f416a41da3.mp3',
          name: 'BEGINNER-Straight_Leg_Glute_Lifts-EXERCISE.mp3',
          description: null,
          size: 27140,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Uppercut_Punches-EXERCISE': {
      id: 591,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Uppercut Punches',
      short_name: 'Uppercut Punches',
      unique_name: 'BEGINNER-Uppercut_Punches-EXERCISE',
      description:
        '1. Start in a wide stance with your feet slightly wider than your hips. Keep your back straight, bend your knees slightly and place both fists under your chin.\n2. Moving toward the center of your body, pivot on one foot and rotate hips and shoulders as you punch your fist up slightly past your chin.\n3. Recoil your punch and return to start. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200020000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1329,
          collection_name: 'videos',
          order: 1,
          version: 200020000,
          hash: 'bf66ad7afea16c08428694062cbae5fe25b0c060cf07eed9dafc78e5879381a2',
          file_name:
            'videos/bf66ad7afea16c08428694062cbae5fe25b0c060cf07eed9dafc78e5879381a2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf66ad7afea16c08428694062cbae5fe25b0c060cf07eed9dafc78e5879381a2.mp4',
          name: 'BEGINNER-Uppercut_Punches-EXERCISE.mp4',
          description: null,
          size: 96890,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1330,
          collection_name: 'audios',
          order: 1,
          version: 200020000,
          hash: 'f1718328a3fa5d77a25c5340bcfb74d4cf9de13ae32490fe9b7c6e12128ed54b',
          file_name:
            'audios/f1718328a3fa5d77a25c5340bcfb74d4cf9de13ae32490fe9b7c6e12128ed54b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f1718328a3fa5d77a25c5340bcfb74d4cf9de13ae32490fe9b7c6e12128ed54b.mp3',
          name: 'BEGINNER-Uppercut_Punches-EXERCISE.mp3',
          description: null,
          size: 24319,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-RESISTANCE_BAND_LOW_ANCHOR_WIDE_ROWS-EXERCISE': {
      id: 598,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Low Anchor Wide Rows',
      short_name: 'Band Low Anchor Wide Rows',
      unique_name: 'INTERMEDIATE-RESISTANCE_BAND_LOW_ANCHOR_WIDE_ROWS-EXERCISE',
      description:
        '1. Secure the door anchor at the bottom of the door. Facing the door, grab one handle in each hand. Walk backward until both your arms and the band are straight with slight tension, palms facing down.\n2. With your core engaged, hinge the hips to slightly lean forward. Shrug shoulders down and back.\n3. Keeping your elbows out wide, pull the band up toward your shoulders.\n4. Extend arms back to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1331,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'a59164f00691dbe30ca5ca53bf26383f0cded2d890c7e16d9d2487859f491ebe',
          file_name:
            'videos/a59164f00691dbe30ca5ca53bf26383f0cded2d890c7e16d9d2487859f491ebe.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a59164f00691dbe30ca5ca53bf26383f0cded2d890c7e16d9d2487859f491ebe.mp4',
          name: 'INT-ADV-Resistance_Band_Low_Anchor_Wide_Rows-EXERCISE.mp4',
          description: null,
          size: 64194,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1332,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'e8e15991f1bfd47baa77b912c14ea19ab12024f8c81b95a21dde0b73b5ffba57',
          file_name:
            'audios/e8e15991f1bfd47baa77b912c14ea19ab12024f8c81b95a21dde0b73b5ffba57.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e8e15991f1bfd47baa77b912c14ea19ab12024f8c81b95a21dde0b73b5ffba57.mp3',
          name: 'INT-ADV-Resistance_Band_Low_Anchor_Wide_Rows-EXERCISE.mp3',
          description: null,
          size: 56704,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-RESISTANCE_BAND_LOW_ANCHOR_WIDE_ROWS-EXERCISE': {
      id: 599,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Low Anchor Wide Rows',
      short_name: 'Band Low Anchor Wide Rows',
      unique_name: 'ADVANCED-RESISTANCE_BAND_LOW_ANCHOR_WIDE_ROWS-EXERCISE',
      description:
        '1. Secure the door anchor at the bottom of the door. Facing the door, grab one handle in each hand. Walk backward until both your arms and the band are straight with slight tension, palms facing down.\n2. With your core engaged, hinge the hips to slightly lean forward. Shrug shoulders down and back.\n3. Keeping your elbows out wide, pull the band up toward your shoulders.\n4. Extend arms back to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1333,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'a59164f00691dbe30ca5ca53bf26383f0cded2d890c7e16d9d2487859f491ebe',
          file_name:
            'videos/a59164f00691dbe30ca5ca53bf26383f0cded2d890c7e16d9d2487859f491ebe.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a59164f00691dbe30ca5ca53bf26383f0cded2d890c7e16d9d2487859f491ebe.mp4',
          name: 'INT-ADV-Resistance_Band_Low_Anchor_Wide_Rows-EXERCISE.mp4',
          description: null,
          size: 64194,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1334,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'e8e15991f1bfd47baa77b912c14ea19ab12024f8c81b95a21dde0b73b5ffba57',
          file_name:
            'audios/e8e15991f1bfd47baa77b912c14ea19ab12024f8c81b95a21dde0b73b5ffba57.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e8e15991f1bfd47baa77b912c14ea19ab12024f8c81b95a21dde0b73b5ffba57.mp3',
          name: 'INT-ADV-Resistance_Band_Low_Anchor_Wide_Rows-EXERCISE.mp3',
          description: null,
          size: 56704,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-RESISTANCE_BAND_LOW_ANCHOR_BICEP_CURL-EXERCISE': {
      id: 600,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Low Anchor Bicep Curl',
      short_name: 'Band Low Anchor Bicep Curls',
      unique_name:
        'INTERMEDIATE-RESISTANCE_BAND_LOW_ANCHOR_BICEP_CURL-EXERCISE',
      description:
        '1. Secure the door anchor to the bottom of the door. With your back facing the door, grab one handle in each hand. Keep arms to your sides, palms facing out and walk forward until the band is straight with slight tension.\n2. Keep your elbows close to your ribcage and curl handles up toward your shoulders.\n3. Lower the band back to the starting position.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1335,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'c50c20374680c14eefa2e6ea78780fe128c5c53476a061de981b9bcc4f5aef8a',
          file_name:
            'videos/c50c20374680c14eefa2e6ea78780fe128c5c53476a061de981b9bcc4f5aef8a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c50c20374680c14eefa2e6ea78780fe128c5c53476a061de981b9bcc4f5aef8a.mp4',
          name: 'INT-ADV-Resistance_Band_Low_Anchor_Bicep_Curl-EXERCISE.mp4',
          description: null,
          size: 78216,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1336,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '4bef6fed153520fef0960f32cbc5a30026d9fb830166b6f7938da652d2293dfe',
          file_name:
            'audios/4bef6fed153520fef0960f32cbc5a30026d9fb830166b6f7938da652d2293dfe.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4bef6fed153520fef0960f32cbc5a30026d9fb830166b6f7938da652d2293dfe.mp3',
          name: 'INT-ADV-Resistance_Band_Low_Anchor_Bicep_Curl-EXERCISE.mp3',
          description: null,
          size: 50252,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-RESISTANCE_BAND_LOW_ANCHOR_BICEP_CURL-EXERCISE': {
      id: 601,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Low Anchor Bicep Curl',
      short_name: 'Band Low Anchor Bicep Curls',
      unique_name: 'ADVANCED-RESISTANCE_BAND_LOW_ANCHOR_BICEP_CURL-EXERCISE',
      description:
        '1. Secure the door anchor to the bottom of the door. With your back facing the door, grab one handle in each hand. Keep arms to your sides, palms facing out and walk forward until the band is straight with slight tension.\n2. Keep your elbows close to your ribcage and curl handles up toward your shoulders.\n3. Lower the band back to the starting position.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1337,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'c50c20374680c14eefa2e6ea78780fe128c5c53476a061de981b9bcc4f5aef8a',
          file_name:
            'videos/c50c20374680c14eefa2e6ea78780fe128c5c53476a061de981b9bcc4f5aef8a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c50c20374680c14eefa2e6ea78780fe128c5c53476a061de981b9bcc4f5aef8a.mp4',
          name: 'INT-ADV-Resistance_Band_Low_Anchor_Bicep_Curl-EXERCISE.mp4',
          description: null,
          size: 78216,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1338,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '4bef6fed153520fef0960f32cbc5a30026d9fb830166b6f7938da652d2293dfe',
          file_name:
            'audios/4bef6fed153520fef0960f32cbc5a30026d9fb830166b6f7938da652d2293dfe.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4bef6fed153520fef0960f32cbc5a30026d9fb830166b6f7938da652d2293dfe.mp3',
          name: 'INT-ADV-Resistance_Band_Low_Anchor_Bicep_Curl-EXERCISE.mp3',
          description: null,
          size: 50252,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-RESISTANCE_BAND_LOW_ANCHOR_HAMMER_CURL-EXERCISE': {
      id: 602,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Low Anchor Hammer Curl',
      short_name: 'Band Low Anchor Hammer Curl',
      unique_name:
        'INTERMEDIATE-RESISTANCE_BAND_LOW_ANCHOR_HAMMER_CURL-EXERCISE',
      description:
        '1. Secure the door anchor to the bottom of the door. With your back facing the door, grab one handle in each hand. Keep arms to your sides, palms facing in and walk forward until the band is straight with slight tension.\n2. Keep your elbows close to your ribcage and curl handles up toward your shoulders.\n3. Lower the band back to the starting position.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1339,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '76d9409ee01470e23c091a417d0eaa38f2d3f250748d7dc61424257bf4f08c65',
          file_name:
            'videos/76d9409ee01470e23c091a417d0eaa38f2d3f250748d7dc61424257bf4f08c65.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/76d9409ee01470e23c091a417d0eaa38f2d3f250748d7dc61424257bf4f08c65.mp4',
          name: 'INT-ADV-Resistance_Band_Low_Anchor_Hammer_Curl-EXERCISE.mp4',
          description: null,
          size: 69385,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1340,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '1db7778fe3ff741aaec1bfa6a154d3ccc7694a3d99b9013cf993f07624521dc7',
          file_name:
            'audios/1db7778fe3ff741aaec1bfa6a154d3ccc7694a3d99b9013cf993f07624521dc7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1db7778fe3ff741aaec1bfa6a154d3ccc7694a3d99b9013cf993f07624521dc7.mp3',
          name: 'INT-ADV-Resistance_Band_Low_Anchor_Hammer_Curl-EXERCISE.mp3',
          description: null,
          size: 38786,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-RESISTANCE_BAND_LOW_ANCHOR_HAMMER_CURL-EXERCISE': {
      id: 603,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Low Anchor Hammer Curl',
      short_name: 'Band Low Anchor Hammer Curl',
      unique_name: 'ADVANCED-RESISTANCE_BAND_LOW_ANCHOR_HAMMER_CURL-EXERCISE',
      description:
        '1. Secure the door anchor to the bottom of the door. With your back facing the door, grab one handle in each hand. Keep arms to your sides, palms facing in and walk forward until the band is straight with slight tension.\n2. Keep your elbows close to your ribcage and curl handles up toward your shoulders.\n3. Lower the band back to the starting position.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1341,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '76d9409ee01470e23c091a417d0eaa38f2d3f250748d7dc61424257bf4f08c65',
          file_name:
            'videos/76d9409ee01470e23c091a417d0eaa38f2d3f250748d7dc61424257bf4f08c65.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/76d9409ee01470e23c091a417d0eaa38f2d3f250748d7dc61424257bf4f08c65.mp4',
          name: 'INT-ADV-Resistance_Band_Low_Anchor_Hammer_Curl-EXERCISE.mp4',
          description: null,
          size: 69385,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1342,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '1db7778fe3ff741aaec1bfa6a154d3ccc7694a3d99b9013cf993f07624521dc7',
          file_name:
            'audios/1db7778fe3ff741aaec1bfa6a154d3ccc7694a3d99b9013cf993f07624521dc7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1db7778fe3ff741aaec1bfa6a154d3ccc7694a3d99b9013cf993f07624521dc7.mp3',
          name: 'INT-ADV-Resistance_Band_Low_Anchor_Hammer_Curl-EXERCISE.mp3',
          description: null,
          size: 38786,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-RESISTANCE_BAND_LOW_HIGH_CHEST_FLY-EXERCISE': {
      id: 604,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Low/High Chest Fly',
      short_name: 'Band Low/High Chest Fly',
      unique_name: 'INTERMEDIATE-RESISTANCE_BAND_LOW_HIGH_CHEST_FLY-EXERCISE',
      description:
        '1. Secure the door anchor to the bottom of the door. Grab one handle in each hand and face away from the door. Raise your arms out to your sides and walk forward until the band is straight with slight tension.\n2. Stagger your stance. Roll your shoulders down and back to maintain good posture. Keep your arms straight with elbows slightly bent, but fixed.\n3. Fly both arms up and in toward your face, palms face each other.\n4. With control, open your arms and bring them to back to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1343,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '4ff1f70af2cb6e68f835363dd877199309dddae2577777424959d60df38bd4d8',
          file_name:
            'videos/4ff1f70af2cb6e68f835363dd877199309dddae2577777424959d60df38bd4d8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4ff1f70af2cb6e68f835363dd877199309dddae2577777424959d60df38bd4d8.mp4',
          name: 'INT-ADV-Resistance_Band_Low-High_Chest_Fly-EXERCISE.mp4',
          description: null,
          size: 89630,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1344,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '9f613b81741c0dbbd870e5b0da8825a08648ece30f46dc6955dd5fd4a4245c6e',
          file_name:
            'audios/9f613b81741c0dbbd870e5b0da8825a08648ece30f46dc6955dd5fd4a4245c6e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9f613b81741c0dbbd870e5b0da8825a08648ece30f46dc6955dd5fd4a4245c6e.mp3',
          name: 'INT-ADV-Resistance_Band_Low-High_Chest_Fly-EXERCISE.mp3',
          description: null,
          size: 46796,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-RESISTANCE_BAND_LOW_HIGH_CHEST_FLY-EXERCISE': {
      id: 605,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Low/High Chest Fly',
      short_name: 'Band Low/High Chest Fly',
      unique_name: 'ADVANCED-RESISTANCE_BAND_LOW_HIGH_CHEST_FLY-EXERCISE',
      description:
        '1. Secure the door anchor to the bottom of the door. Grab one handle in each hand and face away from the door. Raise your arms out to your sides and walk forward until the band is straight with slight tension.\n2. Stagger your stance. Roll your shoulders down and back to maintain good posture. Keep your arms straight with elbows slightly bent, but fixed.\n3. Fly both arms up and in toward your face, palms face each other.\n4. With control, open your arms and bring them to back to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1345,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '4ff1f70af2cb6e68f835363dd877199309dddae2577777424959d60df38bd4d8',
          file_name:
            'videos/4ff1f70af2cb6e68f835363dd877199309dddae2577777424959d60df38bd4d8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4ff1f70af2cb6e68f835363dd877199309dddae2577777424959d60df38bd4d8.mp4',
          name: 'INT-ADV-Resistance_Band_Low-High_Chest_Fly-EXERCISE.mp4',
          description: null,
          size: 89630,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1346,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '9f613b81741c0dbbd870e5b0da8825a08648ece30f46dc6955dd5fd4a4245c6e',
          file_name:
            'audios/9f613b81741c0dbbd870e5b0da8825a08648ece30f46dc6955dd5fd4a4245c6e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9f613b81741c0dbbd870e5b0da8825a08648ece30f46dc6955dd5fd4a4245c6e.mp3',
          name: 'INT-ADV-Resistance_Band_Low-High_Chest_Fly-EXERCISE.mp3',
          description: null,
          size: 46796,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-RESISTANCE_BAND_LOW_HIGH_CHEST_PRESS-EXERCISE': {
      id: 606,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Low/High Chest Press',
      short_name: 'Band Low/High Chest Press',
      unique_name: 'INTERMEDIATE-RESISTANCE_BAND_LOW_HIGH_CHEST_PRESS-EXERCISE',
      description:
        '1. Secure the door anchor to the bottom of the door. With your back facing the door, grab one handle in each hand. Raise your arms, bend elbows to 90 degrees and walk forward until the band is straight with slight tension.\n2. Stagger your stance. Roll your shoulders down and back to maintain good posture.\n3. Press the band up at an angle to straighten both arms up.\n4. Bend elbows and bring arms back to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1347,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '26487ed5c823bc2a304ac97348b5f8cd61dcb89d51e57217411ee14b51c104b4',
          file_name:
            'videos/26487ed5c823bc2a304ac97348b5f8cd61dcb89d51e57217411ee14b51c104b4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/26487ed5c823bc2a304ac97348b5f8cd61dcb89d51e57217411ee14b51c104b4.mp4',
          name: 'INT-ADV-Resistance_Band_Low-High_Chest_Press-EXERCISE.mp4',
          description: null,
          size: 85581,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1348,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '06f22ef1b4c1f0142769f8317e77b7d334f66bd0b923148abfc31c3c6deb33fa',
          file_name:
            'audios/06f22ef1b4c1f0142769f8317e77b7d334f66bd0b923148abfc31c3c6deb33fa.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/06f22ef1b4c1f0142769f8317e77b7d334f66bd0b923148abfc31c3c6deb33fa.mp3',
          name: 'INT-ADV-Resistance_Band_Low-High_Chest_Press-EXERCISE.mp3',
          description: null,
          size: 46276,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-RESISTANCE_BAND_LOW_HIGH_CHEST_PRESS-EXERCISE': {
      id: 607,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Resistance Band Low/High Chest Press',
      short_name: 'Band Low/High Chest Press',
      unique_name: 'ADVANCED-RESISTANCE_BAND_LOW_HIGH_CHEST_PRESS-EXERCISE',
      description:
        '1. Secure the door anchor to the bottom of the door. With your back facing the door, grab one handle in each hand. Raise your arms, bend elbows to 90 degrees and walk forward until the band is straight with slight tension.\n2. Stagger your stance. Roll your shoulders down and back to maintain good posture.\n3. Press the band up at an angle to straighten both arms up.\n4. Bend elbows and bring arms back to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1349,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '26487ed5c823bc2a304ac97348b5f8cd61dcb89d51e57217411ee14b51c104b4',
          file_name:
            'videos/26487ed5c823bc2a304ac97348b5f8cd61dcb89d51e57217411ee14b51c104b4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/26487ed5c823bc2a304ac97348b5f8cd61dcb89d51e57217411ee14b51c104b4.mp4',
          name: 'INT-ADV-Resistance_Band_Low-High_Chest_Press-EXERCISE.mp4',
          description: null,
          size: 85581,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1350,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '06f22ef1b4c1f0142769f8317e77b7d334f66bd0b923148abfc31c3c6deb33fa',
          file_name:
            'audios/06f22ef1b4c1f0142769f8317e77b7d334f66bd0b923148abfc31c3c6deb33fa.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/06f22ef1b4c1f0142769f8317e77b7d334f66bd0b923148abfc31c3c6deb33fa.mp3',
          name: 'INT-ADV-Resistance_Band_Low-High_Chest_Press-EXERCISE.mp3',
          description: null,
          size: 46276,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-RESISTANCE_BAND_WOODCHOPPER_LOW_HIGH-EXERCISE': {
      id: 608,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Resistance Band Woodchopper Low/High',
      short_name: 'Band Woodchopper Low/High',
      unique_name: 'INTERMEDIATE-RESISTANCE_BAND_WOODCHOPPER_LOW_HIGH-EXERCISE',
      description:
        '1. Secure the door anchor at the bottom of the door. Grip the handles with both hands. Walk away from the door until both arms and band are straight with slight tension, fists together.\n2. Turn sideways and lower both arms down at a diagonal toward the door anchor. Keep chest up and feet slightly wider than hip-width apart.\n3. Pull the band up at a diagonal and rotate torso.\n4. With control rotate your body and band back to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1351,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'ec1154b42dc2e70f4efaded54f944494a850b52772fe3c5881ce34f1208039eb',
          file_name:
            'videos/ec1154b42dc2e70f4efaded54f944494a850b52772fe3c5881ce34f1208039eb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ec1154b42dc2e70f4efaded54f944494a850b52772fe3c5881ce34f1208039eb.mp4',
          name: 'INT-ADV-Resistance_Band_Woodchopper_Low-High-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 126002,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1352,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: 'b60ffc6ce31e8459ad1fb511829bb58185205e88ba099f8d397226fd1524facc',
          file_name:
            'videos/b60ffc6ce31e8459ad1fb511829bb58185205e88ba099f8d397226fd1524facc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b60ffc6ce31e8459ad1fb511829bb58185205e88ba099f8d397226fd1524facc.mp4',
          name: 'INT-ADV-Resistance_Band_Woodchopper_Low-High-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 103688,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1353,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '2861d09249f4b5ca5c87d8110bd0e2878f508603ee35f28113c951d86e5151c4',
          file_name:
            'audios/2861d09249f4b5ca5c87d8110bd0e2878f508603ee35f28113c951d86e5151c4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2861d09249f4b5ca5c87d8110bd0e2878f508603ee35f28113c951d86e5151c4.mp3',
          name: 'INT-ADV-Resistance_Band_Woodchopper_Low-High-EXERCISE.mp3',
          description: null,
          size: 51406,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-RESISTANCE_BAND_WOODCHOPPER_LOW_HIGH-EXERCISE': {
      id: 609,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Resistance Band Woodchopper Low/High',
      short_name: 'Band Woodchopper Low/High',
      unique_name: 'ADVANCED-RESISTANCE_BAND_WOODCHOPPER_LOW_HIGH-EXERCISE',
      description:
        '1. Secure the door anchor at the bottom of the door. Grip the handles with both hands. Walk away from the door until both arms and band are straight with slight tension, fists together.\n2. Turn sideways and lower both arms down at a diagonal toward the door anchor. Keep chest up and feet slightly wider than hip-width apart.\n3. Pull the band up at a diagonal and rotate torso.\n4. With control rotate your body and band back to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 9,
          name: 'Resistance Band with Low Anchor',
          unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
          min_app_version: 200030000,
          order: 9000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1354,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'ec1154b42dc2e70f4efaded54f944494a850b52772fe3c5881ce34f1208039eb',
          file_name:
            'videos/ec1154b42dc2e70f4efaded54f944494a850b52772fe3c5881ce34f1208039eb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ec1154b42dc2e70f4efaded54f944494a850b52772fe3c5881ce34f1208039eb.mp4',
          name: 'INT-ADV-Resistance_Band_Woodchopper_Low-High-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 126002,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1355,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: 'b60ffc6ce31e8459ad1fb511829bb58185205e88ba099f8d397226fd1524facc',
          file_name:
            'videos/b60ffc6ce31e8459ad1fb511829bb58185205e88ba099f8d397226fd1524facc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b60ffc6ce31e8459ad1fb511829bb58185205e88ba099f8d397226fd1524facc.mp4',
          name: 'INT-ADV-Resistance_Band_Woodchopper_Low-High-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 103688,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1356,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '2861d09249f4b5ca5c87d8110bd0e2878f508603ee35f28113c951d86e5151c4',
          file_name:
            'audios/2861d09249f4b5ca5c87d8110bd0e2878f508603ee35f28113c951d86e5151c4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2861d09249f4b5ca5c87d8110bd0e2878f508603ee35f28113c951d86e5151c4.mp3',
          name: 'INT-ADV-Resistance_Band_Woodchopper_Low-High-EXERCISE.mp3',
          description: null,
          size: 51406,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_KETTLEBELL_LUNGE_PASS_THROUGH-EXERCISE': {
      id: 610,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Kettlebell Lunge Pass Through',
      short_name: 'Kettlebell Lunge Pass Through',
      unique_name:
        'INTERMEDIATE-ALTERNATING_KETTLEBELL_LUNGE_PASS_THROUGH-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart. Hold a kettlebell in one hand by your side.\n2. Take a big step forward with the leg opposite to the kettlebell. Keeping hips square, drop down into a lunge by bending both knees and pass the bell to the other hand underneath your knee from the inside.\n3. Drive through the front foot and return to standing position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1357,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '52f5e2ed7efb0db6f5f0b92922513d60d425d1ee5b9b319c0d469335b8fbab70',
          file_name:
            'videos/52f5e2ed7efb0db6f5f0b92922513d60d425d1ee5b9b319c0d469335b8fbab70.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/52f5e2ed7efb0db6f5f0b92922513d60d425d1ee5b9b319c0d469335b8fbab70.mp4',
          name: 'INT-ADV-Alternating_Kettlebell_Lunge_Pass_Through-EXERCISE.mp4',
          description: null,
          size: 176776,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1358,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '35b715c5ff89e3489655d632b1394717d4a6121c9ed311724a2d1d79e142d661',
          file_name:
            'audios/35b715c5ff89e3489655d632b1394717d4a6121c9ed311724a2d1d79e142d661.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/35b715c5ff89e3489655d632b1394717d4a6121c9ed311724a2d1d79e142d661.mp3',
          name: 'INT-ADV-Alternating_Kettlebell_Lunge_Pass_Through-EXERCISE.mp3',
          description: null,
          size: 34663,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_KETTLEBELL_LUNGE_PASS_THROUGH-EXERCISE': {
      id: 611,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Kettlebell Lunge Pass Through',
      short_name: 'Kettlebell Lunge Pass Through',
      unique_name:
        'ADVANCED-ALTERNATING_KETTLEBELL_LUNGE_PASS_THROUGH-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart. Hold a kettlebell in one hand by your side.\n2. Take a big step forward with the leg opposite to the kettlebell. Keeping hips square, drop down into a lunge by bending both knees and pass the bell to the other hand underneath your knee from the inside.\n3. Drive through the front foot and return to standing position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1359,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '52f5e2ed7efb0db6f5f0b92922513d60d425d1ee5b9b319c0d469335b8fbab70',
          file_name:
            'videos/52f5e2ed7efb0db6f5f0b92922513d60d425d1ee5b9b319c0d469335b8fbab70.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/52f5e2ed7efb0db6f5f0b92922513d60d425d1ee5b9b319c0d469335b8fbab70.mp4',
          name: 'INT-ADV-Alternating_Kettlebell_Lunge_Pass_Through-EXERCISE.mp4',
          description: null,
          size: 176776,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1360,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '35b715c5ff89e3489655d632b1394717d4a6121c9ed311724a2d1d79e142d661',
          file_name:
            'audios/35b715c5ff89e3489655d632b1394717d4a6121c9ed311724a2d1d79e142d661.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/35b715c5ff89e3489655d632b1394717d4a6121c9ed311724a2d1d79e142d661.mp3',
          name: 'INT-ADV-Alternating_Kettlebell_Lunge_Pass_Through-EXERCISE.mp3',
          description: null,
          size: 34663,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_KETTLEBELL_SWINGS-EXERCISE': {
      id: 612,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Alternating Kettlebell Swings',
      short_name: 'Alternating Kettlebell Swings',
      unique_name: 'INTERMEDIATE-ALTERNATING_KETTLEBELL_SWINGS-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart. Hold a kettlebell in one hand down in front of you.\n2. Bend knees, hinge at hips and swing the bell back in between legs.\n3. When the bell is behind you, explosively drive hips forward to swing the bell in front of you to chest level. At the top, release the bell and grab with other hand.\n4. Let the bell swing down and continue the motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1361,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '4470713339b493d808abf28078035f9ed0b54c6744cef9bf4a9bcbaea54817ac',
          file_name:
            'videos/4470713339b493d808abf28078035f9ed0b54c6744cef9bf4a9bcbaea54817ac.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4470713339b493d808abf28078035f9ed0b54c6744cef9bf4a9bcbaea54817ac.mp4',
          name: 'INT-ADV-Alternating_Kettlebell_Swings-EXERCISE.mp4',
          description: null,
          size: 123993,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1362,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '97b19a90d68666e2d21f23e6450fb36464ee74799d500a325068e3278a1cee92',
          file_name:
            'audios/97b19a90d68666e2d21f23e6450fb36464ee74799d500a325068e3278a1cee92.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/97b19a90d68666e2d21f23e6450fb36464ee74799d500a325068e3278a1cee92.mp3',
          name: 'INT-ADV-Alternating_Kettlebell_Swings-EXERCISE.mp3',
          description: null,
          size: 31529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_KETTLEBELL_SWINGS-EXERCISE': {
      id: 613,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Alternating Kettlebell Swings',
      short_name: 'Alternating Kettlebell Swings',
      unique_name: 'ADVANCED-ALTERNATING_KETTLEBELL_SWINGS-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart. Hold a kettlebell in one hand down in front of you.\n2. Bend knees, hinge at hips and swing the bell back in between legs.\n3. When the bell is behind you, explosively drive hips forward to swing the bell in front of you to chest level. At the top, release the bell and grab with other hand.\n4. Let the bell swing down and continue the motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1363,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '4470713339b493d808abf28078035f9ed0b54c6744cef9bf4a9bcbaea54817ac',
          file_name:
            'videos/4470713339b493d808abf28078035f9ed0b54c6744cef9bf4a9bcbaea54817ac.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4470713339b493d808abf28078035f9ed0b54c6744cef9bf4a9bcbaea54817ac.mp4',
          name: 'INT-ADV-Alternating_Kettlebell_Swings-EXERCISE.mp4',
          description: null,
          size: 123993,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1364,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '97b19a90d68666e2d21f23e6450fb36464ee74799d500a325068e3278a1cee92',
          file_name:
            'audios/97b19a90d68666e2d21f23e6450fb36464ee74799d500a325068e3278a1cee92.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/97b19a90d68666e2d21f23e6450fb36464ee74799d500a325068e3278a1cee92.mp3',
          name: 'INT-ADV-Alternating_Kettlebell_Swings-EXERCISE.mp3',
          description: null,
          size: 31529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-AMERICAN_KETTLEBELL_SWINGS-EXERCISE': {
      id: 614,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'American Kettlebell Swings',
      short_name: 'American Kettlebell Swings',
      unique_name: 'INTERMEDIATE-AMERICAN_KETTLEBELL_SWINGS-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, holding one kettlebell in both hands in front of you.\n2. Keep your chest up and back straight, bend knees, hinge at hips and swing the bell back between legs.\n3. When the bell is behind you, explosively drive hips forward to swing the bell in front and overhead. Arms fully extended and bottom of bell points up.\n4. Let the bell swing down and continue the motion. Connect reps.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1365,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '5836087241b352ca217ae78d95b57b9426db5ab2a46778c28cfd7131c8a38110',
          file_name:
            'videos/5836087241b352ca217ae78d95b57b9426db5ab2a46778c28cfd7131c8a38110.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5836087241b352ca217ae78d95b57b9426db5ab2a46778c28cfd7131c8a38110.mp4',
          name: 'INT-ADV-American_Kettlebell_Swings-EXERCISE.mp4',
          description: null,
          size: 91034,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1366,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '9384709bc78600d7591a011d73486511420ba48ce1942d7c4d7d3af6267a7abd',
          file_name:
            'audios/9384709bc78600d7591a011d73486511420ba48ce1942d7c4d7d3af6267a7abd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9384709bc78600d7591a011d73486511420ba48ce1942d7c4d7d3af6267a7abd.mp3',
          name: 'INT-ADV-American_Kettlebell_Swings-EXERCISE.mp3',
          description: null,
          size: 33096,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-AMERICAN_KETTLEBELL_SWINGS-EXERCISE': {
      id: 615,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'American Kettlebell Swings',
      short_name: 'American Kettlebell Swings',
      unique_name: 'ADVANCED-AMERICAN_KETTLEBELL_SWINGS-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, holding one kettlebell in both hands in front of you.\n2. Keep your chest up and back straight, bend knees, hinge at hips and swing the bell back between legs.\n3. When the bell is behind you, explosively drive hips forward to swing the bell in front and overhead. Arms fully extended and bottom of bell points up.\n4. Let the bell swing down and continue the motion. Connect reps.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1367,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '5836087241b352ca217ae78d95b57b9426db5ab2a46778c28cfd7131c8a38110',
          file_name:
            'videos/5836087241b352ca217ae78d95b57b9426db5ab2a46778c28cfd7131c8a38110.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5836087241b352ca217ae78d95b57b9426db5ab2a46778c28cfd7131c8a38110.mp4',
          name: 'INT-ADV-American_Kettlebell_Swings-EXERCISE.mp4',
          description: null,
          size: 91034,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1368,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '9384709bc78600d7591a011d73486511420ba48ce1942d7c4d7d3af6267a7abd',
          file_name:
            'audios/9384709bc78600d7591a011d73486511420ba48ce1942d7c4d7d3af6267a7abd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9384709bc78600d7591a011d73486511420ba48ce1942d7c4d7d3af6267a7abd.mp3',
          name: 'INT-ADV-American_Kettlebell_Swings-EXERCISE.mp3',
          description: null,
          size: 33096,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_AROUND_THE_WORLD-EXERCISE': {
      id: 616,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Kettlebell Around the World',
      short_name: 'Kettlebell Around the World',
      unique_name: 'INTERMEDIATE-KETTLEBELL_AROUND_THE_WORLD-EXERCISE',
      description:
        '1. Stand with feet about shoulder-width apart. Hold a kettlebell with both hands in front of you.\n2. Release the bell with one hand and use the other to swing it behind your back. Move the free hand behind you and catch the bell.\n3. Swing the kettlebell back in front of you and pass to free hand.\n4. Pass around in one direction in a continuous motion. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1369,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'db2d2253749cb10f8e6fa9342c39bdbeb0f77d8bb1765946b9e965a506c0afb5',
          file_name:
            'videos/db2d2253749cb10f8e6fa9342c39bdbeb0f77d8bb1765946b9e965a506c0afb5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/db2d2253749cb10f8e6fa9342c39bdbeb0f77d8bb1765946b9e965a506c0afb5.mp4',
          name: 'INT-ADV-Kettlebell_Around_the_World-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 62676,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1370,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '41ae0774cab9753e6a5aa539331d58da8f1efc28604b519a36f8571400bb3f0d',
          file_name:
            'videos/41ae0774cab9753e6a5aa539331d58da8f1efc28604b519a36f8571400bb3f0d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/41ae0774cab9753e6a5aa539331d58da8f1efc28604b519a36f8571400bb3f0d.mp4',
          name: 'INT-ADV-Kettlebell_Around_the_World-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 59034,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1371,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '166940ddfee6178baca0b170cd87ab0b4552e81e8bfe651eb0ae24bc3fa7c46b',
          file_name:
            'audios/166940ddfee6178baca0b170cd87ab0b4552e81e8bfe651eb0ae24bc3fa7c46b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/166940ddfee6178baca0b170cd87ab0b4552e81e8bfe651eb0ae24bc3fa7c46b.mp3',
          name: 'INT-ADV-Kettlebell_Around_the_World-EXERCISE.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_AROUND_THE_WORLD-EXERCISE': {
      id: 617,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Kettlebell Around the World',
      short_name: 'Kettlebell Around the World',
      unique_name: 'ADVANCED-KETTLEBELL_AROUND_THE_WORLD-EXERCISE',
      description:
        '1. Stand with feet about shoulder-width apart. Hold a kettlebell with both hands in front of you.\n2. Release the bell with one hand and use the other to swing it behind your back. Move the free hand behind you and catch the bell.\n3. Swing the kettlebell back in front of you and pass to free hand.\n4. Pass around in one direction in a continuous motion. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1372,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'db2d2253749cb10f8e6fa9342c39bdbeb0f77d8bb1765946b9e965a506c0afb5',
          file_name:
            'videos/db2d2253749cb10f8e6fa9342c39bdbeb0f77d8bb1765946b9e965a506c0afb5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/db2d2253749cb10f8e6fa9342c39bdbeb0f77d8bb1765946b9e965a506c0afb5.mp4',
          name: 'INT-ADV-Kettlebell_Around_the_World-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 62676,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1373,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '41ae0774cab9753e6a5aa539331d58da8f1efc28604b519a36f8571400bb3f0d',
          file_name:
            'videos/41ae0774cab9753e6a5aa539331d58da8f1efc28604b519a36f8571400bb3f0d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/41ae0774cab9753e6a5aa539331d58da8f1efc28604b519a36f8571400bb3f0d.mp4',
          name: 'INT-ADV-Kettlebell_Around_the_World-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 59034,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1374,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '166940ddfee6178baca0b170cd87ab0b4552e81e8bfe651eb0ae24bc3fa7c46b',
          file_name:
            'audios/166940ddfee6178baca0b170cd87ab0b4552e81e8bfe651eb0ae24bc3fa7c46b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/166940ddfee6178baca0b170cd87ab0b4552e81e8bfe651eb0ae24bc3fa7c46b.mp3',
          name: 'INT-ADV-Kettlebell_Around_the_World-EXERCISE.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_DEADLIFTS-EXERCISE': {
      id: 618,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Deadlifts',
      short_name: 'Kettlebell Deadlifts',
      unique_name: 'INTERMEDIATE-KETTLEBELL_DEADLIFTS-EXERCISE',
      description:
        '1. Stand with feet hip-width and knees slightly bent in a fixed position. Hold a kettlebell with both hands down in front of you, Keep chest up, shoulders back and core tight.\n2. With back and arms straight, hinge at the hips and slide them back as you lower the bell to the floor.\n3. Brace your core and return to stand. Squeeze glutes at the top without over arching your low back.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1375,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '6e4a6be74cdaec872d208d05d2e14a779983d930a76911b718923b322e0c8874',
          file_name:
            'videos/6e4a6be74cdaec872d208d05d2e14a779983d930a76911b718923b322e0c8874.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6e4a6be74cdaec872d208d05d2e14a779983d930a76911b718923b322e0c8874.mp4',
          name: 'INT-ADV-Kettlebell_Deadlifts-EXERCISE.mp4',
          description: null,
          size: 80270,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1376,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '79541488ad7a5af22b38dacd020de478afa566cbb9d975c551259fab9d28490f',
          file_name:
            'audios/79541488ad7a5af22b38dacd020de478afa566cbb9d975c551259fab9d28490f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/79541488ad7a5af22b38dacd020de478afa566cbb9d975c551259fab9d28490f.mp3',
          name: 'INT-ADV-Kettlebell_Deadlifts-EXERCISE.mp3',
          description: null,
          size: 25886,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_DEADLIFTS-EXERCISE': {
      id: 619,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Deadlifts',
      short_name: 'Kettlebell Deadlifts',
      unique_name: 'ADVANCED-KETTLEBELL_DEADLIFTS-EXERCISE',
      description:
        '1. Stand with feet hip-width and knees slightly bent in a fixed position. Hold a kettlebell with both hands down in front of you, Keep chest up, shoulders back and core tight.\n2. With back and arms straight, hinge at the hips and slide them back as you lower the bell to the floor.\n3. Brace your core and return to stand. Squeeze glutes at the top without over arching your low back.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1377,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '6e4a6be74cdaec872d208d05d2e14a779983d930a76911b718923b322e0c8874',
          file_name:
            'videos/6e4a6be74cdaec872d208d05d2e14a779983d930a76911b718923b322e0c8874.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6e4a6be74cdaec872d208d05d2e14a779983d930a76911b718923b322e0c8874.mp4',
          name: 'INT-ADV-Kettlebell_Deadlifts-EXERCISE.mp4',
          description: null,
          size: 80270,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1378,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '79541488ad7a5af22b38dacd020de478afa566cbb9d975c551259fab9d28490f',
          file_name:
            'audios/79541488ad7a5af22b38dacd020de478afa566cbb9d975c551259fab9d28490f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/79541488ad7a5af22b38dacd020de478afa566cbb9d975c551259fab9d28490f.mp3',
          name: 'INT-ADV-Kettlebell_Deadlifts-EXERCISE.mp3',
          description: null,
          size: 25886,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_FIGURE8S-EXERCISE': {
      id: 620,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Figure 8s',
      short_name: 'Kettlebell Figure 8s',
      unique_name: 'INTERMEDIATE-KETTLEBELL_FIGURE8S-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart. Hold a Kettlebell with both hands down in front of you.\n2. Release the bell with one hand, bend knees and pass it through your legs. The other hand catches it behind you.\n3. Staying low, swing the bell forward  and around your knee. Pass through your legs again, catching it with the opposite hand.\n4. Continue in figure 8 motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1379,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '60b34949ff50219d6a132050f7653014b6ecc7ea89f1ddd6f4168d33af1ccd16',
          file_name:
            'videos/60b34949ff50219d6a132050f7653014b6ecc7ea89f1ddd6f4168d33af1ccd16.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/60b34949ff50219d6a132050f7653014b6ecc7ea89f1ddd6f4168d33af1ccd16.mp4',
          name: 'INT-ADV-Kettlebell_Figure_8s-EXERCISE.mp4',
          description: null,
          size: 107213,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1380,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '6b1757144937dc7db263d3775ca5a8b85c0eb7123d9b8582b5b379c9c507ce1d',
          file_name:
            'audios/6b1757144937dc7db263d3775ca5a8b85c0eb7123d9b8582b5b379c9c507ce1d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6b1757144937dc7db263d3775ca5a8b85c0eb7123d9b8582b5b379c9c507ce1d.mp3',
          name: 'INT-ADV-Kettlebell_Figure_8s-EXERCISE.mp3',
          description: null,
          size: 27453,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_FIGURE8S-EXERCISE': {
      id: 621,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Figure 8s',
      short_name: 'Kettlebell Figure 8s',
      unique_name: 'ADVANCED-KETTLEBELL_FIGURE8S-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart. Hold a Kettlebell with both hands down in front of you.\n2. Release the bell with one hand, bend knees and pass it through your legs. The other hand catches it behind you.\n3. Staying low, swing the bell forward  and around your knee. Pass through your legs again, catching it with the opposite hand.\n4. Continue in figure 8 motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1381,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '60b34949ff50219d6a132050f7653014b6ecc7ea89f1ddd6f4168d33af1ccd16',
          file_name:
            'videos/60b34949ff50219d6a132050f7653014b6ecc7ea89f1ddd6f4168d33af1ccd16.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/60b34949ff50219d6a132050f7653014b6ecc7ea89f1ddd6f4168d33af1ccd16.mp4',
          name: 'INT-ADV-Kettlebell_Figure_8s-EXERCISE.mp4',
          description: null,
          size: 107213,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1382,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '6b1757144937dc7db263d3775ca5a8b85c0eb7123d9b8582b5b379c9c507ce1d',
          file_name:
            'audios/6b1757144937dc7db263d3775ca5a8b85c0eb7123d9b8582b5b379c9c507ce1d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6b1757144937dc7db263d3775ca5a8b85c0eb7123d9b8582b5b379c9c507ce1d.mp3',
          name: 'INT-ADV-Kettlebell_Figure_8s-EXERCISE.mp3',
          description: null,
          size: 27453,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_GOBLET_SQUATS_WITH_PULSE-EXERCISE': {
      id: 622,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Goblet Squats with Pulse',
      short_name: 'Kettlebell Goblet Squats with Pulse',
      unique_name: 'ADVANCED-KETTLEBELL_GOBLET_SQUATS_WITH_PULSE-EXERCISE',
      description:
        '1. Stand with your feet slightly wider than shoulder-width apart. With both hands, hold a kettlebell in front of your chest.\n2. Keeping your chest up and shoulders back, squat as low as possible trying to touch the outside of your elbows with the inside of your knee.\n3. Perform one pulse by straightening legs to come up about half way, then lower back down to the bottom of squat.\n4. Drive through your heels to stand.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1383,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '042927d66843f949456246d7e2f5a6a6dfe78e5ef75de7e0193d3b5f9ed07389',
          file_name:
            'videos/042927d66843f949456246d7e2f5a6a6dfe78e5ef75de7e0193d3b5f9ed07389.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/042927d66843f949456246d7e2f5a6a6dfe78e5ef75de7e0193d3b5f9ed07389.mp4',
          name: 'ADVANCED-Kettlebell_Goblet_Squats_with_Pulse-EXERCISE.mp4',
          description: null,
          size: 73190,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1384,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '4f0090b4ea990fcd63ef7c306693fc39b87bc2754722042561f155755d452df1',
          file_name:
            'audios/4f0090b4ea990fcd63ef7c306693fc39b87bc2754722042561f155755d452df1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4f0090b4ea990fcd63ef7c306693fc39b87bc2754722042561f155755d452df1.mp3',
          name: 'ADVANCED-Kettlebell_Goblet_Squats_with_Pulse-EXERCISE.mp3',
          description: null,
          size: 36544,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_HALOS-EXERCISE': {
      id: 623,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Kettlebell Halos',
      short_name: 'Kettlebell Halos',
      unique_name: 'INTERMEDIATE-KETTLEBELL_HALOS-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, holding a kettlebell with both hands in front of your chest, elbows pointing down.\n2. Keeping your core engaged, raise the kettlebell up and rotate it in a circle around your head.\n3. Perform all reps in one direction. Repeat other direction.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1385,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '6e50b36160e7ade1643460fccab1408ad417b734b637f2be9fd6a988f9ad7ae7',
          file_name:
            'videos/6e50b36160e7ade1643460fccab1408ad417b734b637f2be9fd6a988f9ad7ae7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6e50b36160e7ade1643460fccab1408ad417b734b637f2be9fd6a988f9ad7ae7.mp4',
          name: 'INT-ADV-Kettlebell_Halos-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 79974,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1386,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '3f36ccca546b31829ee1d84abc542eba3eaef0c15b3c15c3f70f7d1c6c81d80d',
          file_name:
            'videos/3f36ccca546b31829ee1d84abc542eba3eaef0c15b3c15c3f70f7d1c6c81d80d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3f36ccca546b31829ee1d84abc542eba3eaef0c15b3c15c3f70f7d1c6c81d80d.mp4',
          name: 'INT-ADV-Kettlebell_Halos-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 84108,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1387,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'b9e4338081b4a875ba7e566a7ee1d33b9c8e3266712ad3d53778ef7e0e832851',
          file_name:
            'audios/b9e4338081b4a875ba7e566a7ee1d33b9c8e3266712ad3d53778ef7e0e832851.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b9e4338081b4a875ba7e566a7ee1d33b9c8e3266712ad3d53778ef7e0e832851.mp3',
          name: 'INT-ADV-Kettlebell_Halos-EXERCISE.mp3',
          description: null,
          size: 24632,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_HALOS-EXERCISE': {
      id: 624,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Kettlebell Halos',
      short_name: 'Kettlebell Halos',
      unique_name: 'ADVANCED-KETTLEBELL_HALOS-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, holding a kettlebell with both hands in front of your chest, elbows pointing down.\n2. Keeping your core engaged, raise the kettlebell up and rotate it in a circle around your head.\n3. Perform all reps in one direction. Repeat other direction.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1388,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '6e50b36160e7ade1643460fccab1408ad417b734b637f2be9fd6a988f9ad7ae7',
          file_name:
            'videos/6e50b36160e7ade1643460fccab1408ad417b734b637f2be9fd6a988f9ad7ae7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6e50b36160e7ade1643460fccab1408ad417b734b637f2be9fd6a988f9ad7ae7.mp4',
          name: 'INT-ADV-Kettlebell_Halos-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 79974,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1389,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '3f36ccca546b31829ee1d84abc542eba3eaef0c15b3c15c3f70f7d1c6c81d80d',
          file_name:
            'videos/3f36ccca546b31829ee1d84abc542eba3eaef0c15b3c15c3f70f7d1c6c81d80d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3f36ccca546b31829ee1d84abc542eba3eaef0c15b3c15c3f70f7d1c6c81d80d.mp4',
          name: 'INT-ADV-Kettlebell_Halos-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 84108,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1390,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'b9e4338081b4a875ba7e566a7ee1d33b9c8e3266712ad3d53778ef7e0e832851',
          file_name:
            'audios/b9e4338081b4a875ba7e566a7ee1d33b9c8e3266712ad3d53778ef7e0e832851.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b9e4338081b4a875ba7e566a7ee1d33b9c8e3266712ad3d53778ef7e0e832851.mp3',
          name: 'INT-ADV-Kettlebell_Halos-EXERCISE.mp3',
          description: null,
          size: 24632,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_KNEEL_TO_STAND-EXERCISE': {
      id: 625,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Kneel to Stand',
      short_name: 'Kettlebell Kneel to Stand',
      unique_name: 'ADVANCED-KETTLEBELL_KNEEL_TO_STAND-EXERCISE',
      description:
        '1. Start high-kneeling, core engaged and spine straight. Hold a kettlebell in both hands in front of your chest.\n2. Step forward with one leg to half-kneel, knee directly over ankle.\n3. Drive through the front foot and come up to stand.\n4. Reverse motion by stepping back with the rear leg to half-kneel, then return the front leg back to start.\n5. Repeat opposite side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1391,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'b3cf3eb1ede3dd58c4e30981e112c524233a44f31e8f37ff3a9ca91262340f59',
          file_name:
            'videos/b3cf3eb1ede3dd58c4e30981e112c524233a44f31e8f37ff3a9ca91262340f59.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b3cf3eb1ede3dd58c4e30981e112c524233a44f31e8f37ff3a9ca91262340f59.mp4',
          name: 'ADVANCED-Kettlebell_Kneel_to_Stand-EXERCISE.mp4',
          description: null,
          size: 238645,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1392,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'f2235e86dfe72037f627919d20db9fd1c571c37705fe2513330294eb85a21e4b',
          file_name:
            'audios/f2235e86dfe72037f627919d20db9fd1c571c37705fe2513330294eb85a21e4b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f2235e86dfe72037f627919d20db9fd1c571c37705fe2513330294eb85a21e4b.mp3',
          name: 'ADVANCED-Kettlebell_Kneel_to_Stand-EXERCISE.mp3',
          description: null,
          size: 28707,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_KNEELING_SQUATS-EXERCISE': {
      id: 626,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Kneeling Squats',
      short_name: 'Kettlebell Kneeling Squats',
      unique_name: 'ADVANCED-KETTLEBELL_KNEELING_SQUATS-EXERCISE',
      description:
        '1. Start in high-kneeling position with your knees about hip-with apart. Hold a kettlebell with both hands in front of your chest.\n2. Keeping chest tall and back straight, lower your hips down to sit lightly on your heels.\n3. Engage your quads and lift your hips back up to high-kneeling position. Squeeze Glutes at top.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1393,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'ae60eb5950d71570b037a86b1503b1bbc20285d2e4e454d4ca871fa2d36a7725',
          file_name:
            'videos/ae60eb5950d71570b037a86b1503b1bbc20285d2e4e454d4ca871fa2d36a7725.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ae60eb5950d71570b037a86b1503b1bbc20285d2e4e454d4ca871fa2d36a7725.mp4',
          name: 'ADVANCED-Kettlebell_Kneeling_Squats-EXERCISE.mp4',
          description: null,
          size: 68685,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1394,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'cc4039d9a6e5fce8538791aa6783eb21054d13aef1a49c4c14467cf7d6d0d433',
          file_name:
            'audios/cc4039d9a6e5fce8538791aa6783eb21054d13aef1a49c4c14467cf7d6d0d433.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cc4039d9a6e5fce8538791aa6783eb21054d13aef1a49c4c14467cf7d6d0d433.mp3',
          name: 'ADVANCED-Kettlebell_Kneeling_Squats-EXERCISE.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_SINGLE_ARM_CORKSCREW_ROWS-EXERCISE': {
      id: 627,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Kettlebell Single Arm Corkscrew Rows',
      short_name: 'Kettlebell Single Arm Corkscrew Rows',
      unique_name: 'INTERMEDIATE-KETTLEBELL_SINGLE_ARM_CORKSCREW_ROWS-EXERCISE',
      description:
        '1. Start in split stance holding kettlebell with the arm on same side as back leg.\n2. Bend knees and hinge at waist. Rest bell lightly on floor, thumb facing back and other hand on front knee. Back straight and hips square.\n3. Bend elbow tight to your body and pull bell toward your hips as you rotate your wrists, palm up.\n4. Lower bell back down as you rotate wrist until thumb points behind you.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1395,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '212bd299b91536f3b5c6d511d451be3f3df52e5686d364005cb18209e6f464d3',
          file_name:
            'videos/212bd299b91536f3b5c6d511d451be3f3df52e5686d364005cb18209e6f464d3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/212bd299b91536f3b5c6d511d451be3f3df52e5686d364005cb18209e6f464d3.mp4',
          name: 'INT-ADV-Kettlebell_Single_Arm_Corkscrew_Rows-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 68584,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1396,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '90816d4a61f1820f6af831519733d850989ad07508eeb39b01062c553800ae79',
          file_name:
            'videos/90816d4a61f1820f6af831519733d850989ad07508eeb39b01062c553800ae79.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/90816d4a61f1820f6af831519733d850989ad07508eeb39b01062c553800ae79.mp4',
          name: 'INT-ADV-Kettlebell_Single_Arm_Corkscrew_Rows-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 61565,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1397,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'b75ae8444ee64e40d0747cf67d002e3dd22414f16779118e339aa8be718cef95',
          file_name:
            'audios/b75ae8444ee64e40d0747cf67d002e3dd22414f16779118e339aa8be718cef95.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b75ae8444ee64e40d0747cf67d002e3dd22414f16779118e339aa8be718cef95.mp3',
          name: 'INT-ADV-Kettlebell_Single_Arm_Corkscrew_Rows-EXERCISE.mp3',
          description: null,
          size: 40306,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_SINGLE_ARM_CORKSCREW_ROWS-EXERCISE': {
      id: 628,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Kettlebell Single Arm Corkscrew Rows',
      short_name: 'Kettlebell Single Arm Corkscrew Rows',
      unique_name: 'ADVANCED-KETTLEBELL_SINGLE_ARM_CORKSCREW_ROWS-EXERCISE',
      description:
        '1. Start in split stance holding kettlebell with the arm on same side as back leg.\n2. Bend knees and hinge at waist. Rest bell lightly on floor, thumb facing back and other hand on front knee. Back straight and hips square.\n3. Bend elbow tight to your body and pull bell toward your hips as you rotate your wrists, palm up.\n4. Lower bell back down as you rotate wrist until thumb points behind you.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1398,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '212bd299b91536f3b5c6d511d451be3f3df52e5686d364005cb18209e6f464d3',
          file_name:
            'videos/212bd299b91536f3b5c6d511d451be3f3df52e5686d364005cb18209e6f464d3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/212bd299b91536f3b5c6d511d451be3f3df52e5686d364005cb18209e6f464d3.mp4',
          name: 'INT-ADV-Kettlebell_Single_Arm_Corkscrew_Rows-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 68584,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1399,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '90816d4a61f1820f6af831519733d850989ad07508eeb39b01062c553800ae79',
          file_name:
            'videos/90816d4a61f1820f6af831519733d850989ad07508eeb39b01062c553800ae79.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/90816d4a61f1820f6af831519733d850989ad07508eeb39b01062c553800ae79.mp4',
          name: 'INT-ADV-Kettlebell_Single_Arm_Corkscrew_Rows-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 61565,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1400,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'b75ae8444ee64e40d0747cf67d002e3dd22414f16779118e339aa8be718cef95',
          file_name:
            'audios/b75ae8444ee64e40d0747cf67d002e3dd22414f16779118e339aa8be718cef95.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b75ae8444ee64e40d0747cf67d002e3dd22414f16779118e339aa8be718cef95.mp3',
          name: 'INT-ADV-Kettlebell_Single_Arm_Corkscrew_Rows-EXERCISE.mp3',
          description: null,
          size: 40306,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_SINGLE_ARM_PUSH_PRESSES-EXERCISE': {
      id: 629,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Kettlebell Single Arm Push Presses',
      short_name: 'Kettlebell Single Arm Push Presses',
      unique_name: 'INTERMEDIATE-KETTLEBELL_SINGLE_ARM_PUSH_PRESSES-EXERCISE',
      description:
        '1. Hold a kettlebell in rack position, elbow close to body and thumb at center of chest. Keep hips square and core engaged.\n2. Bend your knees slightly and explosively dip and drive to stand as you push the bell overhead to full extension, biceps by ears and palms facing forward.\n3. Lower the bell down and rotate your wrist back in to rack position.\n4. Perform all reps one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1401,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '3c15bc024d36d4d3bd12168167a23db90c6152a5ee756571899a32534cb2133b',
          file_name:
            'videos/3c15bc024d36d4d3bd12168167a23db90c6152a5ee756571899a32534cb2133b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3c15bc024d36d4d3bd12168167a23db90c6152a5ee756571899a32534cb2133b.mp4',
          name: 'INT-ADV-Kettlebell_Single_Arm_Push_Presses-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 81225,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1402,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: 'a63a63200d8ad84da8f67e284edc1eeed4f50a4b7e3ef8ddd2e2a85855b9b333',
          file_name:
            'videos/a63a63200d8ad84da8f67e284edc1eeed4f50a4b7e3ef8ddd2e2a85855b9b333.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a63a63200d8ad84da8f67e284edc1eeed4f50a4b7e3ef8ddd2e2a85855b9b333.mp4',
          name: 'INT-ADV-Kettlebell_Single_Arm_Push_Presses-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 88371,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1403,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'c7c421803102b2c3e1e00535a3edf6d2938fe3964483799a6affe581d67dbb68',
          file_name:
            'audios/c7c421803102b2c3e1e00535a3edf6d2938fe3964483799a6affe581d67dbb68.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c7c421803102b2c3e1e00535a3edf6d2938fe3964483799a6affe581d67dbb68.mp3',
          name: 'INT-ADV-Kettlebell_Single_Arm_Push_Presses-EXERCISE.mp3',
          description: null,
          size: 36858,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_SINGLE_ARM_PUSH_PRESSES-EXERCISE': {
      id: 630,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Kettlebell Single Arm Push Presses',
      short_name: 'Kettlebell Single Arm Push Presses',
      unique_name: 'ADVANCED-KETTLEBELL_SINGLE_ARM_PUSH_PRESSES-EXERCISE',
      description:
        '1. Hold a kettlebell in rack position, elbow close to body and thumb at center of chest. Keep hips square and core engaged.\n2. Bend your knees slightly and explosively dip and drive to stand as you push the bell overhead to full extension, biceps by ears and palms facing forward.\n3. Lower the bell down and rotate your wrist back in to rack position.\n4. Perform all reps one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1404,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '3c15bc024d36d4d3bd12168167a23db90c6152a5ee756571899a32534cb2133b',
          file_name:
            'videos/3c15bc024d36d4d3bd12168167a23db90c6152a5ee756571899a32534cb2133b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3c15bc024d36d4d3bd12168167a23db90c6152a5ee756571899a32534cb2133b.mp4',
          name: 'INT-ADV-Kettlebell_Single_Arm_Push_Presses-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 81225,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1405,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: 'a63a63200d8ad84da8f67e284edc1eeed4f50a4b7e3ef8ddd2e2a85855b9b333',
          file_name:
            'videos/a63a63200d8ad84da8f67e284edc1eeed4f50a4b7e3ef8ddd2e2a85855b9b333.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a63a63200d8ad84da8f67e284edc1eeed4f50a4b7e3ef8ddd2e2a85855b9b333.mp4',
          name: 'INT-ADV-Kettlebell_Single_Arm_Push_Presses-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 88371,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1406,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'c7c421803102b2c3e1e00535a3edf6d2938fe3964483799a6affe581d67dbb68',
          file_name:
            'audios/c7c421803102b2c3e1e00535a3edf6d2938fe3964483799a6affe581d67dbb68.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c7c421803102b2c3e1e00535a3edf6d2938fe3964483799a6affe581d67dbb68.mp3',
          name: 'INT-ADV-Kettlebell_Single_Arm_Push_Presses-EXERCISE.mp3',
          description: null,
          size: 36858,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_SUMO_SQUAT_WITH_PULSE-EXERCISE': {
      id: 631,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Sumo Squat with Pulse',
      short_name: 'Kettlebell Sumo Squat with Pulse',
      unique_name: 'INTERMEDIATE-KETTLEBELL_SUMO_SQUAT_WITH_PULSE-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointing out. Hold a kettlebell with both hands down in front of you.\n2. Drive hips back and bend knees to lower into a wide squat, bell moving toward the floor. Keep chest up and shoulders back.\n3. Perform one pulse by straightening legs to come up about half way, then lower back to bottom of squat.\n4. Drive through your heels to stand.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1407,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '8f82d59ffea1917598e2b7d677733e8f3740a5a66279685e6d31b01716085899',
          file_name:
            'videos/8f82d59ffea1917598e2b7d677733e8f3740a5a66279685e6d31b01716085899.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8f82d59ffea1917598e2b7d677733e8f3740a5a66279685e6d31b01716085899.mp4',
          name: 'INT-ADV-Kettlebell_Sumo_Squat_with_Pulse-EXERCISE.mp4',
          description: null,
          size: 104243,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1408,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '84a748c726581878151a8eccc33375d9d719c407e2388800531d4a201173bd69',
          file_name:
            'audios/84a748c726581878151a8eccc33375d9d719c407e2388800531d4a201173bd69.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/84a748c726581878151a8eccc33375d9d719c407e2388800531d4a201173bd69.mp3',
          name: 'INT-ADV-Kettlebell_Sumo_Squat_with_Pulse-EXERCISE.mp3',
          description: null,
          size: 35290,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_SUMO_SQUAT_WITH_PULSE-EXERCISE': {
      id: 632,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Sumo Squat with Pulse',
      short_name: 'Kettlebell Sumo Squat with Pulse',
      unique_name: 'ADVANCED-KETTLEBELL_SUMO_SQUAT_WITH_PULSE-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointing out. Hold a kettlebell with both hands down in front of you.\n2. Drive hips back and bend knees to lower into a wide squat, bell moving toward the floor. Keep chest up and shoulders back.\n3. Perform one pulse by straightening legs to come up about half way, then lower back to bottom of squat.\n4. Drive through your heels to stand.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1409,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '8f82d59ffea1917598e2b7d677733e8f3740a5a66279685e6d31b01716085899',
          file_name:
            'videos/8f82d59ffea1917598e2b7d677733e8f3740a5a66279685e6d31b01716085899.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8f82d59ffea1917598e2b7d677733e8f3740a5a66279685e6d31b01716085899.mp4',
          name: 'INT-ADV-Kettlebell_Sumo_Squat_with_Pulse-EXERCISE.mp4',
          description: null,
          size: 104243,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1410,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '84a748c726581878151a8eccc33375d9d719c407e2388800531d4a201173bd69',
          file_name:
            'audios/84a748c726581878151a8eccc33375d9d719c407e2388800531d4a201173bd69.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/84a748c726581878151a8eccc33375d9d719c407e2388800531d4a201173bd69.mp3',
          name: 'INT-ADV-Kettlebell_Sumo_Squat_with_Pulse-EXERCISE.mp3',
          description: null,
          size: 35290,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_SUMO_SQUATS-EXERCISE': {
      id: 633,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Sumo Squats',
      short_name: 'Kettlebell Sumo Squats',
      unique_name: 'INTERMEDIATE-KETTLEBELL_SUMO_SQUATS-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointing out. Hold a kettlebell with both hands down in front of your body, arms straight.\n2. Drive your hips back and bend your knees to lower into a wide squat, moving the kettlebell towards the floor. Keep your chest up and shoulders back.\n3. Drive through your heels to stand.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1411,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'd83578adbc29010270d8b26ba996a200587e3e9e7ea88e612bccb8b0c2caba7c',
          file_name:
            'videos/d83578adbc29010270d8b26ba996a200587e3e9e7ea88e612bccb8b0c2caba7c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d83578adbc29010270d8b26ba996a200587e3e9e7ea88e612bccb8b0c2caba7c.mp4',
          name: 'INT-ADV-Kettlebell_Sumo_Squats-EXERCISE.mp4',
          description: null,
          size: 98345,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1412,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '707fd196f00452a920d8dd04912a3cb127378bb65d49d26d7ac1974a1cc77fac',
          file_name:
            'audios/707fd196f00452a920d8dd04912a3cb127378bb65d49d26d7ac1974a1cc77fac.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/707fd196f00452a920d8dd04912a3cb127378bb65d49d26d7ac1974a1cc77fac.mp3',
          name: 'INT-ADV-Kettlebell_Sumo_Squats-EXERCISE.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_SUMO_SQUATS-EXERCISE': {
      id: 634,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Sumo Squats',
      short_name: 'Kettlebell Sumo Squats',
      unique_name: 'ADVANCED-KETTLEBELL_SUMO_SQUATS-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointing out. Hold a kettlebell with both hands down in front of your body, arms straight.\n2. Drive your hips back and bend your knees to lower into a wide squat, moving the kettlebell towards the floor. Keep your chest up and shoulders back.\n3. Drive through your heels to stand.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1413,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'd83578adbc29010270d8b26ba996a200587e3e9e7ea88e612bccb8b0c2caba7c',
          file_name:
            'videos/d83578adbc29010270d8b26ba996a200587e3e9e7ea88e612bccb8b0c2caba7c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d83578adbc29010270d8b26ba996a200587e3e9e7ea88e612bccb8b0c2caba7c.mp4',
          name: 'INT-ADV-Kettlebell_Sumo_Squats-EXERCISE.mp4',
          description: null,
          size: 98345,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1414,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '707fd196f00452a920d8dd04912a3cb127378bb65d49d26d7ac1974a1cc77fac',
          file_name:
            'audios/707fd196f00452a920d8dd04912a3cb127378bb65d49d26d7ac1974a1cc77fac.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/707fd196f00452a920d8dd04912a3cb127378bb65d49d26d7ac1974a1cc77fac.mp3',
          name: 'INT-ADV-Kettlebell_Sumo_Squats-EXERCISE.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_SWINGS-EXERCISE': {
      id: 635,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Kettlebell Swings',
      short_name: 'Kettlebell Swings',
      unique_name: 'INTERMEDIATE-KETTLEBELL_SWINGS-EXERCISE',
      description:
        '1. Stand feet hip-width apart holding a kettlebell in both hands in front of you.\n2. Keeping chest up and back straight, bend knees, hinge at your hips and swing the kettlebell back between legs.\n3. When the weight is behind you, explosively drive hips forward to swing the kettlebell in front of you to chest level.\n4. Let the kettlebell swing down and continue this motion. Connect reps.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1415,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '79ae0f3c3a0af261086450024d582ed20d24245032d89dcdcf08cefcd3aa8aa1',
          file_name:
            'videos/79ae0f3c3a0af261086450024d582ed20d24245032d89dcdcf08cefcd3aa8aa1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/79ae0f3c3a0af261086450024d582ed20d24245032d89dcdcf08cefcd3aa8aa1.mp4',
          name: 'INT-ADV-Kettlebell_Swings-EXERCISE.mp4',
          description: null,
          size: 72221,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1416,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '18393b04f02c4803bf997a3a3b7d07a42f96d845e7097a18ca1bccd2d8055085',
          file_name:
            'audios/18393b04f02c4803bf997a3a3b7d07a42f96d845e7097a18ca1bccd2d8055085.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/18393b04f02c4803bf997a3a3b7d07a42f96d845e7097a18ca1bccd2d8055085.mp3',
          name: 'INT-ADV-Kettlebell_Swings-EXERCISE.mp3',
          description: null,
          size: 23692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_SWINGS-EXERCISE': {
      id: 636,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Kettlebell Swings',
      short_name: 'Kettlebell Swings',
      unique_name: 'ADVANCED-KETTLEBELL_SWINGS-EXERCISE',
      description:
        '1. Stand feet hip-width apart holding a kettlebell in both hands in front of you.\n2. Keeping chest up and back straight, bend knees, hinge at your hips and swing the kettlebell back between legs.\n3. When the weight is behind you, explosively drive hips forward to swing the kettlebell in front of you to chest level.\n4. Let the kettlebell swing down and continue this motion. Connect reps.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1417,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '79ae0f3c3a0af261086450024d582ed20d24245032d89dcdcf08cefcd3aa8aa1',
          file_name:
            'videos/79ae0f3c3a0af261086450024d582ed20d24245032d89dcdcf08cefcd3aa8aa1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/79ae0f3c3a0af261086450024d582ed20d24245032d89dcdcf08cefcd3aa8aa1.mp4',
          name: 'INT-ADV-Kettlebell_Swings-EXERCISE.mp4',
          description: null,
          size: 72221,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1418,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '18393b04f02c4803bf997a3a3b7d07a42f96d845e7097a18ca1bccd2d8055085',
          file_name:
            'audios/18393b04f02c4803bf997a3a3b7d07a42f96d845e7097a18ca1bccd2d8055085.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/18393b04f02c4803bf997a3a3b7d07a42f96d845e7097a18ca1bccd2d8055085.mp3',
          name: 'INT-ADV-Kettlebell_Swings-EXERCISE.mp3',
          description: null,
          size: 23692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-PLANK_TO_CHILDS_POSE-EXERCISE': {
      id: 637,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: "Plank to Child's Pose",
      short_name: "Plank to Child's Pose",
      unique_name: 'BEGINNER-PLANK_TO_CHILDS_POSE-EXERCISE',
      description:
        "1. Start in Plank position, shoulders over wrists, long spine.\n2. Engage your core, bend your knees and push weight back until your hips rest close to your heels. Knees are out wide, arms are straight and chest rests in between your knees in Child's Pose.\n3. Using leg, core and shoulder strength, shift your weight forward and return to Plank.",
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1419,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'bd7c85122105094c55b30acd92be9e14403a03510a78145fe4cc3f369edbdb12',
          file_name:
            'videos/bd7c85122105094c55b30acd92be9e14403a03510a78145fe4cc3f369edbdb12.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bd7c85122105094c55b30acd92be9e14403a03510a78145fe4cc3f369edbdb12.mp4',
          name: 'BEGINNER-Plank_to_Childs_Pose-EXERCISE.mp4',
          description: null,
          size: 91880,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1420,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '1654f0c02f99b80a715e6693c51e6296eb81cd4a06831f222e426227663ff6fb',
          file_name:
            'audios/1654f0c02f99b80a715e6693c51e6296eb81cd4a06831f222e426227663ff6fb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1654f0c02f99b80a715e6693c51e6296eb81cd4a06831f222e426227663ff6fb.mp3',
          name: 'BEGINNER-Plank_to_Childs_Pose-EXERCISE.mp3',
          description: null,
          size: 29334,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PLIE_SQUATS_ON_TOES-EXERCISE': {
      id: 638,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Plie Squats on Toes',
      short_name: 'Plie Squats on Toes',
      unique_name: 'INTERMEDIATE-PLIE_SQUATS_ON_TOES-EXERCISE',
      description:
        '1. Start with your feet out wide, roughly double hip-width, toes turned out. Your hands can be in front of you or holding something for support. Lift both heels off the floor.\n2. Keeping back straight and core engaged, bend your knees and drop your tailbone straight down toward the floor. Keep knees wide, tracking over your feet.\n3. Keeping heels elevated, straighten legs and return to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1421,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '92a7a1bced71330698c5d3545573119445ae1e847191a2493f6b7e7c5446f913',
          file_name:
            'videos/92a7a1bced71330698c5d3545573119445ae1e847191a2493f6b7e7c5446f913.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/92a7a1bced71330698c5d3545573119445ae1e847191a2493f6b7e7c5446f913.mp4',
          name: 'INT-ADV-Plie_Squats_on_Toes-EXERCISE.mp4',
          description: null,
          size: 75432,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1422,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'b3ea9454b8e8289d610b492452de2b9bc5fb810e63fc4e1e782d1054c6d7ed0a',
          file_name:
            'audios/b3ea9454b8e8289d610b492452de2b9bc5fb810e63fc4e1e782d1054c6d7ed0a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b3ea9454b8e8289d610b492452de2b9bc5fb810e63fc4e1e782d1054c6d7ed0a.mp3',
          name: 'INT-ADV-Plie_Squats_on_Toes-EXERCISE.mp3',
          description: null,
          size: 30588,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PLIE_SQUATS_ON_TOES-EXERCISE': {
      id: 639,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Plie Squats on Toes',
      short_name: 'Plie Squats on Toes',
      unique_name: 'ADVANCED-PLIE_SQUATS_ON_TOES-EXERCISE',
      description:
        '1. Start with your feet out wide, roughly double hip-width, toes turned out. Your hands can be in front of you or holding something for support. Lift both heels off the floor.\n2. Keeping back straight and core engaged, bend your knees and drop your tailbone straight down toward the floor. Keep knees wide, tracking over your feet.\n3. Keeping heels elevated, straighten legs and return to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1423,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '92a7a1bced71330698c5d3545573119445ae1e847191a2493f6b7e7c5446f913',
          file_name:
            'videos/92a7a1bced71330698c5d3545573119445ae1e847191a2493f6b7e7c5446f913.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/92a7a1bced71330698c5d3545573119445ae1e847191a2493f6b7e7c5446f913.mp4',
          name: 'INT-ADV-Plie_Squats_on_Toes-EXERCISE.mp4',
          description: null,
          size: 75432,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1424,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'b3ea9454b8e8289d610b492452de2b9bc5fb810e63fc4e1e782d1054c6d7ed0a',
          file_name:
            'audios/b3ea9454b8e8289d610b492452de2b9bc5fb810e63fc4e1e782d1054c6d7ed0a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b3ea9454b8e8289d610b492452de2b9bc5fb810e63fc4e1e782d1054c6d7ed0a.mp3',
          name: 'INT-ADV-Plie_Squats_on_Toes-EXERCISE.mp3',
          description: null,
          size: 30588,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-REVERSE_TABLETOP_PUSH_KICKS-EXERCISE': {
      id: 640,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Tabletop Push Kicks',
      short_name: 'Reverse Tabletop Push Kicks',
      unique_name: 'INTERMEDIATE-REVERSE_TABLETOP_PUSH_KICKS-EXERCISE',
      description:
        '1. Start in Reverse Table-Top position, hands flat underneath shoulders, fingers toward hips, knees bent, stacked over ankles, and hips elevated.\n2. Lift up one foot and bring the knee in toward your body as you drop hips to the floor. Keep foot flexed.\n3. Push your leg straight out and drive through the heel on the floor to raise hips up. Knees are aligned.\n4. Recoil knee and drop hips to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1425,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'a314c2d8ae32997c02bed97644ce75470b2dcf655dc66b61e6ed113d6d792f94',
          file_name:
            'videos/a314c2d8ae32997c02bed97644ce75470b2dcf655dc66b61e6ed113d6d792f94.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a314c2d8ae32997c02bed97644ce75470b2dcf655dc66b61e6ed113d6d792f94.mp4',
          name: 'INT-ADV-Reverse_Tabletop_Push_Kicks-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 57399,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1426,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '8aa129545a5612835a0907ed9c2c46db74d8b812f02716e39a28d139d830c9a5',
          file_name:
            'videos/8aa129545a5612835a0907ed9c2c46db74d8b812f02716e39a28d139d830c9a5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8aa129545a5612835a0907ed9c2c46db74d8b812f02716e39a28d139d830c9a5.mp4',
          name: 'INT-ADV-Reverse_Tabletop_Push_Kicks-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 63363,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1427,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'bbfdd66a92b381a2b80f3304179a6009854d75c94607992a36d2b273decad0c6',
          file_name:
            'audios/bbfdd66a92b381a2b80f3304179a6009854d75c94607992a36d2b273decad0c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/bbfdd66a92b381a2b80f3304179a6009854d75c94607992a36d2b273decad0c6.mp3',
          name: 'INT-ADV-Reverse_Tabletop_Push_Kicks-EXERCISE.mp3',
          description: null,
          size: 33723,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-REVERSE_TABLETOP_PUSH_KICKS-EXERCISE': {
      id: 641,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Reverse Tabletop Push Kicks',
      short_name: 'Reverse Tabletop Push Kicks',
      unique_name: 'ADVANCED-REVERSE_TABLETOP_PUSH_KICKS-EXERCISE',
      description:
        '1. Start in Reverse Table-Top position, hands flat underneath shoulders, fingers toward hips, knees bent, stacked over ankles, and hips elevated.\n2. Lift up one foot and bring the knee in toward your body as you drop hips to the floor. Keep foot flexed.\n3. Push your leg straight out and drive through the heel on the floor to raise hips up. Knees are aligned.\n4. Recoil knee and drop hips to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1428,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'a314c2d8ae32997c02bed97644ce75470b2dcf655dc66b61e6ed113d6d792f94',
          file_name:
            'videos/a314c2d8ae32997c02bed97644ce75470b2dcf655dc66b61e6ed113d6d792f94.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a314c2d8ae32997c02bed97644ce75470b2dcf655dc66b61e6ed113d6d792f94.mp4',
          name: 'INT-ADV-Reverse_Tabletop_Push_Kicks-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 57399,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1429,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '8aa129545a5612835a0907ed9c2c46db74d8b812f02716e39a28d139d830c9a5',
          file_name:
            'videos/8aa129545a5612835a0907ed9c2c46db74d8b812f02716e39a28d139d830c9a5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8aa129545a5612835a0907ed9c2c46db74d8b812f02716e39a28d139d830c9a5.mp4',
          name: 'INT-ADV-Reverse_Tabletop_Push_Kicks-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 63363,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1430,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'bbfdd66a92b381a2b80f3304179a6009854d75c94607992a36d2b273decad0c6',
          file_name:
            'audios/bbfdd66a92b381a2b80f3304179a6009854d75c94607992a36d2b273decad0c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/bbfdd66a92b381a2b80f3304179a6009854d75c94607992a36d2b273decad0c6.mp3',
          name: 'INT-ADV-Reverse_Tabletop_Push_Kicks-EXERCISE.mp3',
          description: null,
          size: 33723,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SINGLE_ARM_KETTLEBELL_CLEANS-EXERCISE': {
      id: 642,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Single Arm Kettlebell Cleans',
      short_name: 'Single Arm Kettlebell Cleans',
      unique_name: 'ADVANCED-SINGLE_ARM_KETTLEBELL_CLEANS-EXERCISE',
      description:
        '1. Stand, holding a kettlebell firmly in one hand down in front of you. Thumb points backward.\n2. Bend knees, hinge at hips, and explosively drive your hips forward as you raise your elbow and draw the bell up the midline.\n3. When bell is on chest level, flip wrist and scoop under so bell lands softly on forearm. Elbow in tight, thumb on sternum in rack position.\n4. Turn wrist to reverse motion and lower to start.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1431,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'b80f48165922d2d5b151fe23353b989276343562bca1a517d6aeebff10a43df8',
          file_name:
            'videos/b80f48165922d2d5b151fe23353b989276343562bca1a517d6aeebff10a43df8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b80f48165922d2d5b151fe23353b989276343562bca1a517d6aeebff10a43df8.mp4',
          name: 'ADVANCED-Single_Arm_Kettlebell_Cleans-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 100785,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1432,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '8b6c15743aca51267819723f253dbdf291c8e5dac468f2a0de1edf45527c38d6',
          file_name:
            'videos/8b6c15743aca51267819723f253dbdf291c8e5dac468f2a0de1edf45527c38d6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8b6c15743aca51267819723f253dbdf291c8e5dac468f2a0de1edf45527c38d6.mp4',
          name: 'ADVANCED-Single_Arm_Kettlebell_Cleans-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 98348,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1433,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '7809727da1b9f21d27c4f6b072157396a99eef0a77ec8a94a92f271621cf5be0',
          file_name:
            'audios/7809727da1b9f21d27c4f6b072157396a99eef0a77ec8a94a92f271621cf5be0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7809727da1b9f21d27c4f6b072157396a99eef0a77ec8a94a92f271621cf5be0.mp3',
          name: 'ADVANCED-Single_Arm_Kettlebell_Cleans-EXERCISE.mp3',
          description: null,
          size: 33096,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SINGLE_ARM_KETTLEBELL_GORILLA_ROWS-EXERCISE': {
      id: 643,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Single Arm Kettlebell Gorilla Rows',
      short_name: 'Single Arm Kettlebell Gorilla Rows',
      unique_name: 'INTERMEDIATE-SINGLE_ARM_KETTLEBELL_GORILLA_ROWS-EXERCISE',
      description:
        '1. Stand feet wider than shoulder-width holding a kettlebell in one hand.\n2. Hinge at waist and bend knees so your torso is about parallel to the floor. Extend your arm and place the bell on the floor. Rest the other arm on your leg. Keep back straight and pull shoulders away from ears.\n3. Bend your elbow and pull the bell toward your hips. Keep elbow tight to your body.\n4. Lower back down to floor.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1434,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '4e9d88a2fec3eebf52bc825ac9c7af768d3006f19addf5c37c89d0fad3b905f2',
          file_name:
            'videos/4e9d88a2fec3eebf52bc825ac9c7af768d3006f19addf5c37c89d0fad3b905f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4e9d88a2fec3eebf52bc825ac9c7af768d3006f19addf5c37c89d0fad3b905f2.mp4',
          name: 'INT-ADV-Single_Arm_Kettlebell_Gorilla_Rows-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 53024,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1435,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '5cba2822deb5eaee3edc5fd4771a63d89a028219ec614237cf7d9280e7aa7474',
          file_name:
            'videos/5cba2822deb5eaee3edc5fd4771a63d89a028219ec614237cf7d9280e7aa7474.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5cba2822deb5eaee3edc5fd4771a63d89a028219ec614237cf7d9280e7aa7474.mp4',
          name: 'INT-ADV-Single_Arm_Kettlebell_Gorilla_Rows-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 55177,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1436,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '9bc2e881706843e6ce5e047de58123ac89028b76df42b0752eeed8a6f4243d97',
          file_name:
            'audios/9bc2e881706843e6ce5e047de58123ac89028b76df42b0752eeed8a6f4243d97.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9bc2e881706843e6ce5e047de58123ac89028b76df42b0752eeed8a6f4243d97.mp3',
          name: 'INT-ADV-Single_Arm_Kettlebell_Gorilla_Rows-EXERCISE.mp3',
          description: null,
          size: 39365,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SINGLE_ARM_KETTLEBELL_GORILLA_ROWS-EXERCISE': {
      id: 644,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Single Arm Kettlebell Gorilla Rows',
      short_name: 'Single Arm Kettlebell Gorilla Rows',
      unique_name: 'ADVANCED-SINGLE_ARM_KETTLEBELL_GORILLA_ROWS-EXERCISE',
      description:
        '1. Stand feet wider than shoulder-width holding a kettlebell in one hand.\n2. Hinge at waist and bend knees so your torso is about parallel to the floor. Extend your arm and place the bell on the floor. Rest the other arm on your leg. Keep back straight and pull shoulders away from ears.\n3. Bend your elbow and pull the bell toward your hips. Keep elbow tight to your body.\n4. Lower back down to floor.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1437,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: '4e9d88a2fec3eebf52bc825ac9c7af768d3006f19addf5c37c89d0fad3b905f2',
          file_name:
            'videos/4e9d88a2fec3eebf52bc825ac9c7af768d3006f19addf5c37c89d0fad3b905f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4e9d88a2fec3eebf52bc825ac9c7af768d3006f19addf5c37c89d0fad3b905f2.mp4',
          name: 'INT-ADV-Single_Arm_Kettlebell_Gorilla_Rows-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 53024,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1438,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: '5cba2822deb5eaee3edc5fd4771a63d89a028219ec614237cf7d9280e7aa7474',
          file_name:
            'videos/5cba2822deb5eaee3edc5fd4771a63d89a028219ec614237cf7d9280e7aa7474.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5cba2822deb5eaee3edc5fd4771a63d89a028219ec614237cf7d9280e7aa7474.mp4',
          name: 'INT-ADV-Single_Arm_Kettlebell_Gorilla_Rows-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 55177,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1439,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: '9bc2e881706843e6ce5e047de58123ac89028b76df42b0752eeed8a6f4243d97',
          file_name:
            'audios/9bc2e881706843e6ce5e047de58123ac89028b76df42b0752eeed8a6f4243d97.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9bc2e881706843e6ce5e047de58123ac89028b76df42b0752eeed8a6f4243d97.mp3',
          name: 'INT-ADV-Single_Arm_Kettlebell_Gorilla_Rows-EXERCISE.mp3',
          description: null,
          size: 39365,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SINGLE_ARM_KETTLEBELL_SWINGS-EXERCISE': {
      id: 645,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Single Arm Kettlebell Swings',
      short_name: 'Single Arm Kettlebell Swings',
      unique_name: 'INTERMEDIATE-SINGLE_ARM_KETTLEBELL_SWINGS-EXERCISE',
      description:
        '1. Stand with feet hip-width apart. Hold a kettlebell in one hand down in front of you.\n2. Keeping chest up, bend your knees, hinge at hips and swing the bell back in between legs.\n3. When the bell is behind you, explosively drive hips forward to swing the bell in front of you to chest level.\n4. Let the bell swing down and continue the motion. String reps together. Repeat other side.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1440,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'ed74fde5729ffd0237f249e75726654f895e0876e064dfe9cbf758fe46f06e85',
          file_name:
            'videos/ed74fde5729ffd0237f249e75726654f895e0876e064dfe9cbf758fe46f06e85.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ed74fde5729ffd0237f249e75726654f895e0876e064dfe9cbf758fe46f06e85.mp4',
          name: 'INT-ADV-Single_Arm_Kettlebell_Swings-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 62278,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1441,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: 'd8ef82b3388cf3b910690dc59c9d7102e16f8c0a99a8560d58bc7b1fe590afe2',
          file_name:
            'videos/d8ef82b3388cf3b910690dc59c9d7102e16f8c0a99a8560d58bc7b1fe590afe2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d8ef82b3388cf3b910690dc59c9d7102e16f8c0a99a8560d58bc7b1fe590afe2.mp4',
          name: 'INT-ADV-Single_Arm_Kettlebell_Swings-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 58375,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1442,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'fc21fa145a49282012500182046e4c2199d8d6a6692dc55c0750b87ab00aa5f2',
          file_name:
            'audios/fc21fa145a49282012500182046e4c2199d8d6a6692dc55c0750b87ab00aa5f2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fc21fa145a49282012500182046e4c2199d8d6a6692dc55c0750b87ab00aa5f2.mp3',
          name: 'INT-ADV-Single_Arm_Kettlebell_Swings-EXERCISE.mp3',
          description: null,
          size: 32469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SINGLE_ARM_KETTLEBELL_SWINGS-EXERCISE': {
      id: 646,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Single Arm Kettlebell Swings',
      short_name: 'Single Arm Kettlebell Swings',
      unique_name: 'ADVANCED-SINGLE_ARM_KETTLEBELL_SWINGS-EXERCISE',
      description:
        '1. Stand with feet hip-width apart. Hold a kettlebell in one hand down in front of you.\n2. Keeping chest up, bend your knees, hinge at hips and swing the bell back in between legs.\n3. When the bell is behind you, explosively drive hips forward to swing the bell in front of you to chest level.\n4. Let the bell swing down and continue the motion. String reps together. Repeat other side.',
      preview_time: 10,
      min_app_version: 200030000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1443,
          collection_name: 'videos',
          order: 1,
          version: 200030000,
          hash: 'ed74fde5729ffd0237f249e75726654f895e0876e064dfe9cbf758fe46f06e85',
          file_name:
            'videos/ed74fde5729ffd0237f249e75726654f895e0876e064dfe9cbf758fe46f06e85.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ed74fde5729ffd0237f249e75726654f895e0876e064dfe9cbf758fe46f06e85.mp4',
          name: 'INT-ADV-Single_Arm_Kettlebell_Swings-EXERCISE-RIGHT.mp4',
          description: 'Right Side',
          size: 62278,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1444,
          collection_name: 'videos',
          order: 2,
          version: 200030000,
          hash: 'd8ef82b3388cf3b910690dc59c9d7102e16f8c0a99a8560d58bc7b1fe590afe2',
          file_name:
            'videos/d8ef82b3388cf3b910690dc59c9d7102e16f8c0a99a8560d58bc7b1fe590afe2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d8ef82b3388cf3b910690dc59c9d7102e16f8c0a99a8560d58bc7b1fe590afe2.mp4',
          name: 'INT-ADV-Single_Arm_Kettlebell_Swings-EXERCISE-LEFT.mp4',
          description: 'Left Side',
          size: 58375,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1445,
          collection_name: 'audios',
          order: 1,
          version: 200030000,
          hash: 'fc21fa145a49282012500182046e4c2199d8d6a6692dc55c0750b87ab00aa5f2',
          file_name:
            'audios/fc21fa145a49282012500182046e4c2199d8d6a6692dc55c0750b87ab00aa5f2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fc21fa145a49282012500182046e4c2199d8d6a6692dc55c0750b87ab00aa5f2.mp3',
          name: 'INT-ADV-Single_Arm_Kettlebell_Swings-EXERCISE.mp3',
          description: null,
          size: 32469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-HAND_RELEASE_PUSH-_UPS-EXERCISE': {
      id: 698,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Hand Release Push-Ups',
      short_name: 'Hand Release Push-Ups',
      unique_name: 'INTERMEDIATE-HAND_RELEASE_PUSH-_UPS-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists.\n2. Bend your elbows, pointing them back toward your hips. Lower your body to the floor.\n3. Lift both hands up, pause for a beat and place them back on the floor.\n4. Straighten your arms and raise your body back up to starting position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1895,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '8c0585ba1b8d0d674455ade2e5fa44b302813b003aacd3290d3511e2834b7f04',
          file_name:
            'videos/8c0585ba1b8d0d674455ade2e5fa44b302813b003aacd3290d3511e2834b7f04.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8c0585ba1b8d0d674455ade2e5fa44b302813b003aacd3290d3511e2834b7f04.mp4',
          name: 'INT-ADV-Hand_Release_Push-Ups-EXERCISE',
          description: null,
          size: 56427,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1896,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'd3f3be57f4a24a0301642a674d7419e1b0c7f332c90f1634ea19f121fc837e3d',
          file_name:
            'audios/d3f3be57f4a24a0301642a674d7419e1b0c7f332c90f1634ea19f121fc837e3d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d3f3be57f4a24a0301642a674d7419e1b0c7f332c90f1634ea19f121fc837e3d.mp3',
          name: 'INT-ADV-Hand_Release_Push-Ups-EXERCISE',
          description: null,
          size: 29571,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-HAND_RELEASE_PUSH-_UPS-EXERCISE': {
      id: 699,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Hand Release Push-Ups',
      short_name: 'Hand Release Push-Ups',
      unique_name: 'ADVANCED-HAND_RELEASE_PUSH-_UPS-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists.\n2. Bend your elbows, pointing them back toward your hips. Lower your body to the floor.\n3. Lift both hands up, pause for a beat and place them back on the floor.\n4. Straighten your arms and raise your body back up to starting position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1897,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '8c0585ba1b8d0d674455ade2e5fa44b302813b003aacd3290d3511e2834b7f04',
          file_name:
            'videos/8c0585ba1b8d0d674455ade2e5fa44b302813b003aacd3290d3511e2834b7f04.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8c0585ba1b8d0d674455ade2e5fa44b302813b003aacd3290d3511e2834b7f04.mp4',
          name: 'INT-ADV-Hand_Release_Push-Ups-EXERCISE',
          description: null,
          size: 56427,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1898,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'd3f3be57f4a24a0301642a674d7419e1b0c7f332c90f1634ea19f121fc837e3d',
          file_name:
            'audios/d3f3be57f4a24a0301642a674d7419e1b0c7f332c90f1634ea19f121fc837e3d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d3f3be57f4a24a0301642a674d7419e1b0c7f332c90f1634ea19f121fc837e3d.mp3',
          name: 'INT-ADV-Hand_Release_Push-Ups-EXERCISE',
          description: null,
          size: 29571,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-BODYWEIGHT_CHERRY_PICKERS-EXERCISE': {
      id: 700,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bodyweight Cherry Pickers',
      short_name: 'Bodyweight Cherry Pickers',
      unique_name: 'BEGINNER-BODYWEIGHT_CHERRY_PICKERS-EXERCISE',
      description:
        '1. Start with feet hip-width apart and knees slightly bent in a fixed position. Keep chest up, shoulders back and core tight.\n2. Hinge at the waist and slide hips back as you lower both hands to touch the floor in front of your toes.\n3. With a flat back, raise body up about half way and then lower down, touching floor between your feet.\n4. Stand up using hamstrings and squeeze glutes at the top.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1899,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'adf4397fd4bfe13f42db7b766128db184beea34009bb2a98044f5bf944e544f4',
          file_name:
            'videos/adf4397fd4bfe13f42db7b766128db184beea34009bb2a98044f5bf944e544f4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/adf4397fd4bfe13f42db7b766128db184beea34009bb2a98044f5bf944e544f4.mp4',
          name: 'FSTEP-BEG-Bodyweight_Cherry_Pickers-EXERCISE',
          description: null,
          size: 110142,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1900,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '118bc43f569d7ed369f74a526b684407915fe13f89d8de5982caee47d27ce357',
          file_name:
            'audios/118bc43f569d7ed369f74a526b684407915fe13f89d8de5982caee47d27ce357.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/118bc43f569d7ed369f74a526b684407915fe13f89d8de5982caee47d27ce357.mp3',
          name: 'FSTEP-BEG-Bodyweight_Cherry_Pickers-EXERCISE',
          description: null,
          size: 33646,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SWITCH_LUNGES-EXERCISE': {
      id: 701,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Switch Lunges',
      short_name: 'Switch Lunges',
      unique_name: 'INTERMEDIATE-SWITCH_LUNGES-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart and bring one leg in front of you, the other behind you. Bend both knees to 90 degrees and lower into a lunge.\n2. Staying as low as possible, hop to switch your legs in the air landing in a lunge with the opposite foot forward.\n3. Switch back to the original lunge position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1901,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '3374b2bd1c0b0de2d11b38c73fb8bf1d4a9cdf4db7c20e00f25e2166c64ff28d',
          file_name:
            'videos/3374b2bd1c0b0de2d11b38c73fb8bf1d4a9cdf4db7c20e00f25e2166c64ff28d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3374b2bd1c0b0de2d11b38c73fb8bf1d4a9cdf4db7c20e00f25e2166c64ff28d.mp4',
          name: 'INT-ADV-Switch_Lunges-EXERCISE',
          description: null,
          size: 76692,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1902,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '4058568de360c54aa6e638a725a311184a7ae33b6547a66e8013256f32035f22',
          file_name:
            'audios/4058568de360c54aa6e638a725a311184a7ae33b6547a66e8013256f32035f22.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4058568de360c54aa6e638a725a311184a7ae33b6547a66e8013256f32035f22.mp3',
          name: 'INT-ADV-Switch_Lunges-EXERCISE',
          description: null,
          size: 26123,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SWITCH_LUNGES-EXERCISE': {
      id: 702,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Switch Lunges',
      short_name: 'Switch Lunges',
      unique_name: 'ADVANCED-SWITCH_LUNGES-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart and bring one leg in front of you, the other behind you. Bend both knees to 90 degrees and lower into a lunge.\n2. Staying as low as possible, hop to switch your legs in the air landing in a lunge with the opposite foot forward.\n3. Switch back to the original lunge position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1903,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '3374b2bd1c0b0de2d11b38c73fb8bf1d4a9cdf4db7c20e00f25e2166c64ff28d',
          file_name:
            'videos/3374b2bd1c0b0de2d11b38c73fb8bf1d4a9cdf4db7c20e00f25e2166c64ff28d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3374b2bd1c0b0de2d11b38c73fb8bf1d4a9cdf4db7c20e00f25e2166c64ff28d.mp4',
          name: 'INT-ADV-Switch_Lunges-EXERCISE',
          description: null,
          size: 76692,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1904,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '4058568de360c54aa6e638a725a311184a7ae33b6547a66e8013256f32035f22',
          file_name:
            'audios/4058568de360c54aa6e638a725a311184a7ae33b6547a66e8013256f32035f22.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4058568de360c54aa6e638a725a311184a7ae33b6547a66e8013256f32035f22.mp3',
          name: 'INT-ADV-Switch_Lunges-EXERCISE',
          description: null,
          size: 26123,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DIAMOND_PUSH-_UPS_ON_KNEES-EXERCISE': {
      id: 703,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Diamond Push-Ups on Knees',
      short_name: 'Diamond Push-Ups on Knees',
      unique_name: 'INTERMEDIATE-DIAMOND_PUSH-_UPS_ON_KNEES-EXERCISE',
      description:
        '1. Start in Plank position with your hands flat on the floor in the shape of a diamond underneath your chest. Drop your knees straight down to the floor and lift your feet up.\n2. Bend your elbows, pointing them back towards your hips. Lower your body towards the floor, so the center of your chest is in the center of the diamond.\n3. Straighten your arms and raise your body back up.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1905,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'd50f4775d59efdb7157949f04d28829fea5d4066be85e4a8d7e2bb3b8d19f3e2',
          file_name:
            'videos/d50f4775d59efdb7157949f04d28829fea5d4066be85e4a8d7e2bb3b8d19f3e2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d50f4775d59efdb7157949f04d28829fea5d4066be85e4a8d7e2bb3b8d19f3e2.mp4',
          name: 'INT-ADV-Diamond_Push-Ups_on_Knees-EXERCISE',
          description: null,
          size: 53471,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1906,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '4d9c4f78c2a60d3bb3f679036b131b6f96d5e9fd59dee994761c50a0aec06559',
          file_name:
            'audios/4d9c4f78c2a60d3bb3f679036b131b6f96d5e9fd59dee994761c50a0aec06559.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4d9c4f78c2a60d3bb3f679036b131b6f96d5e9fd59dee994761c50a0aec06559.mp3',
          name: 'INT-ADV-Diamond_Push-Ups_on_Knees-EXERCISE',
          description: null,
          size: 33960,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DIAMOND_PUSH-_UPS_ON_KNEES-EXERCISE': {
      id: 704,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Diamond Push-Ups on Knees',
      short_name: 'Diamond Push-Ups on Knees',
      unique_name: 'ADVANCED-DIAMOND_PUSH-_UPS_ON_KNEES-EXERCISE',
      description:
        '1. Start in Plank position with your hands flat on the floor in the shape of a diamond underneath your chest. Drop your knees straight down to the floor and lift your feet up.\n2. Bend your elbows, pointing them back towards your hips. Lower your body towards the floor, so the center of your chest is in the center of the diamond.\n3. Straighten your arms and raise your body back up.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1907,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'd50f4775d59efdb7157949f04d28829fea5d4066be85e4a8d7e2bb3b8d19f3e2',
          file_name:
            'videos/d50f4775d59efdb7157949f04d28829fea5d4066be85e4a8d7e2bb3b8d19f3e2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d50f4775d59efdb7157949f04d28829fea5d4066be85e4a8d7e2bb3b8d19f3e2.mp4',
          name: 'INT-ADV-Diamond_Push-Ups_on_Knees-EXERCISE',
          description: null,
          size: 53471,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1908,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '4d9c4f78c2a60d3bb3f679036b131b6f96d5e9fd59dee994761c50a0aec06559',
          file_name:
            'audios/4d9c4f78c2a60d3bb3f679036b131b6f96d5e9fd59dee994761c50a0aec06559.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4d9c4f78c2a60d3bb3f679036b131b6f96d5e9fd59dee994761c50a0aec06559.mp3',
          name: 'INT-ADV-Diamond_Push-Ups_on_Knees-EXERCISE',
          description: null,
          size: 33960,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_PUSH_PRESS-EXERCISE': {
      id: 705,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Push Press',
      short_name: 'Dumbbell Push Press',
      unique_name: 'INTERMEDIATE-DUMBBELL_PUSH_PRESS-EXERCISE',
      description:
        '1. Stand with feet about shoulder-width apart. Hold a dumbbell in each hand at your shoulders, palms facing each other, elbows down. Keep hips square and core engaged.\n2. Bend your knees slightly and explosively dip and drive to stand as you push the dumbbells overhead to full extension, biceps by ears.\n3. Lower the dumbbells back down and return to start.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1909,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'd14bf6f5d61abdd1721c0a4a981c71ec09ffb0be461350e64af4bbf8deb20526',
          file_name:
            'videos/d14bf6f5d61abdd1721c0a4a981c71ec09ffb0be461350e64af4bbf8deb20526.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d14bf6f5d61abdd1721c0a4a981c71ec09ffb0be461350e64af4bbf8deb20526.mp4',
          name: 'INT-ADV-Dumbbell_Push_Press-EXERCISE',
          description: null,
          size: 70716,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1910,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'ec1a32d290a31f17f741e593975557f0488ec8b752dd8bde1f8cfa59a7355b29',
          file_name:
            'audios/ec1a32d290a31f17f741e593975557f0488ec8b752dd8bde1f8cfa59a7355b29.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ec1a32d290a31f17f741e593975557f0488ec8b752dd8bde1f8cfa59a7355b29.mp3',
          name: 'INT-ADV-Dumbbell_Push_Press-EXERCISE',
          description: null,
          size: 30512,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_PUSH_PRESS-EXERCISE': {
      id: 706,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Push Press',
      short_name: 'Dumbbell Push Press',
      unique_name: 'ADVANCED-DUMBBELL_PUSH_PRESS-EXERCISE',
      description:
        '1. Stand with feet about shoulder-width apart. Hold a dumbbell in each hand at your shoulders, palms facing each other, elbows down. Keep hips square and core engaged.\n2. Bend your knees slightly and explosively dip and drive to stand as you push the dumbbells overhead to full extension, biceps by ears.\n3. Lower the dumbbells back down and return to start.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1911,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'd14bf6f5d61abdd1721c0a4a981c71ec09ffb0be461350e64af4bbf8deb20526',
          file_name:
            'videos/d14bf6f5d61abdd1721c0a4a981c71ec09ffb0be461350e64af4bbf8deb20526.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d14bf6f5d61abdd1721c0a4a981c71ec09ffb0be461350e64af4bbf8deb20526.mp4',
          name: 'INT-ADV-Dumbbell_Push_Press-EXERCISE',
          description: null,
          size: 70716,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1912,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'ec1a32d290a31f17f741e593975557f0488ec8b752dd8bde1f8cfa59a7355b29',
          file_name:
            'audios/ec1a32d290a31f17f741e593975557f0488ec8b752dd8bde1f8cfa59a7355b29.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ec1a32d290a31f17f741e593975557f0488ec8b752dd8bde1f8cfa59a7355b29.mp3',
          name: 'INT-ADV-Dumbbell_Push_Press-EXERCISE',
          description: null,
          size: 30512,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-BEAR_PLANK_SHOULDER_TAPS-EXERCISE': {
      id: 707,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Bear Plank Shoulder Taps',
      short_name: 'Bear Plank Shoulder Taps',
      unique_name: 'BEGINNER-BEAR_PLANK_SHOULDER_TAPS-EXERCISE',
      description:
        '1. Start on all fours with your shoulders over wrists and knees under hips. Engage your core and hover your knees a few inches off the ground.\n2. Keeping your hips and shoulders square to the floor, lift one hand off the ground and tap the opposite shoulder.\n3. Return to Bear Plank position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1913,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'c3e1e368d40b8a9f131ba48bdec9788537d7155bf255a3b586f0aaeb65917dc1',
          file_name:
            'videos/c3e1e368d40b8a9f131ba48bdec9788537d7155bf255a3b586f0aaeb65917dc1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c3e1e368d40b8a9f131ba48bdec9788537d7155bf255a3b586f0aaeb65917dc1.mp4',
          name: 'FSTEP-BEG-INT-ADV-Bear_Plank_Shoulder_Taps-EXERCISE',
          description: null,
          size: 56110,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1914,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '269512f37c3ea57e5a49ccb15cb61b8bec0c4c4f504d2b838f843cbd82cee9f6',
          file_name:
            'audios/269512f37c3ea57e5a49ccb15cb61b8bec0c4c4f504d2b838f843cbd82cee9f6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/269512f37c3ea57e5a49ccb15cb61b8bec0c4c4f504d2b838f843cbd82cee9f6.mp3',
          name: 'FSTEP-BEG-INT-ADV-Bear_Plank_Shoulder_Taps-EXERCISE',
          description: null,
          size: 33962,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-BEAR_PLANK_SHOULDER_TAPS-EXERCISE': {
      id: 708,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Bear Plank Shoulder Taps',
      short_name: 'Bear Plank Shoulder Taps',
      unique_name: 'INTERMEDIATE-BEAR_PLANK_SHOULDER_TAPS-EXERCISE',
      description:
        '1. Start on all fours with your shoulders over wrists and knees under hips. Engage your core and hover your knees a few inches off the ground.\n2. Keeping your hips and shoulders square to the floor, lift one hand off the ground and tap the opposite shoulder.\n3. Return to Bear Plank position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1915,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'c3e1e368d40b8a9f131ba48bdec9788537d7155bf255a3b586f0aaeb65917dc1',
          file_name:
            'videos/c3e1e368d40b8a9f131ba48bdec9788537d7155bf255a3b586f0aaeb65917dc1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c3e1e368d40b8a9f131ba48bdec9788537d7155bf255a3b586f0aaeb65917dc1.mp4',
          name: 'FSTEP-BEG-INT-ADV-Bear_Plank_Shoulder_Taps-EXERCISE',
          description: null,
          size: 56110,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1916,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '269512f37c3ea57e5a49ccb15cb61b8bec0c4c4f504d2b838f843cbd82cee9f6',
          file_name:
            'audios/269512f37c3ea57e5a49ccb15cb61b8bec0c4c4f504d2b838f843cbd82cee9f6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/269512f37c3ea57e5a49ccb15cb61b8bec0c4c4f504d2b838f843cbd82cee9f6.mp3',
          name: 'FSTEP-BEG-INT-ADV-Bear_Plank_Shoulder_Taps-EXERCISE',
          description: null,
          size: 33962,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-BEAR_PLANK_SHOULDER_TAPS-EXERCISE': {
      id: 709,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Bear Plank Shoulder Taps',
      short_name: 'Bear Plank Shoulder Taps',
      unique_name: 'ADVANCED-BEAR_PLANK_SHOULDER_TAPS-EXERCISE',
      description:
        '1. Start on all fours with your shoulders over wrists and knees under hips. Engage your core and hover your knees a few inches off the ground.\n2. Keeping your hips and shoulders square to the floor, lift one hand off the ground and tap the opposite shoulder.\n3. Return to Bear Plank position.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1917,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'c3e1e368d40b8a9f131ba48bdec9788537d7155bf255a3b586f0aaeb65917dc1',
          file_name:
            'videos/c3e1e368d40b8a9f131ba48bdec9788537d7155bf255a3b586f0aaeb65917dc1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c3e1e368d40b8a9f131ba48bdec9788537d7155bf255a3b586f0aaeb65917dc1.mp4',
          name: 'FSTEP-BEG-INT-ADV-Bear_Plank_Shoulder_Taps-EXERCISE',
          description: null,
          size: 56110,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1918,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '269512f37c3ea57e5a49ccb15cb61b8bec0c4c4f504d2b838f843cbd82cee9f6',
          file_name:
            'audios/269512f37c3ea57e5a49ccb15cb61b8bec0c4c4f504d2b838f843cbd82cee9f6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/269512f37c3ea57e5a49ccb15cb61b8bec0c4c4f504d2b838f843cbd82cee9f6.mp3',
          name: 'FSTEP-BEG-INT-ADV-Bear_Plank_Shoulder_Taps-EXERCISE',
          description: null,
          size: 33962,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_SINGLE_LEG_DROP-EXERCISE': {
      id: 710,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Alternating Single Leg Drop',
      short_name: 'Alternating Single Leg Drop',
      unique_name: 'INTERMEDIATE-ALTERNATING_SINGLE_LEG_DROP-EXERCISE',
      description:
        '1. Lie on your back. Place your arms by your sides, palms face down. Bring both legs up, knees bent at 90 degrees over your hips.\n2. Keeping your low back connected to the floor, drop one leg towards the floor until your toes slightly touch. Return to start.\n3. Repeat with other leg. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1919,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'd6c97febc90dd66776c0944db66cf80fd7578700324dc5e185c3c806c04f8730',
          file_name:
            'videos/d6c97febc90dd66776c0944db66cf80fd7578700324dc5e185c3c806c04f8730.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d6c97febc90dd66776c0944db66cf80fd7578700324dc5e185c3c806c04f8730.mp4',
          name: 'INT-ADV-Alternating_Single_Leg_Drop-EXERCISE',
          description: null,
          size: 56755,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1920,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '61acd03f355e6ec017b5b9518b72b589607e6ec2862dc47f78ae9518a085a1ab',
          file_name:
            'audios/61acd03f355e6ec017b5b9518b72b589607e6ec2862dc47f78ae9518a085a1ab.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/61acd03f355e6ec017b5b9518b72b589607e6ec2862dc47f78ae9518a085a1ab.mp3',
          name: 'INT-ADV-Alternating_Single_Leg_Drop-EXERCISE',
          description: null,
          size: 35216,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_SINGLE_LEG_DROP-EXERCISE': {
      id: 711,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Alternating Single Leg Drop',
      short_name: 'Alternating Single Leg Drop',
      unique_name: 'ADVANCED-ALTERNATING_SINGLE_LEG_DROP-EXERCISE',
      description:
        '1. Lie on your back. Place your arms by your sides, palms face down. Bring both legs up, knees bent at 90 degrees over your hips.\n2. Keeping your low back connected to the floor, drop one leg towards the floor until your toes slightly touch. Return to start.\n3. Repeat with other leg. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1921,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'd6c97febc90dd66776c0944db66cf80fd7578700324dc5e185c3c806c04f8730',
          file_name:
            'videos/d6c97febc90dd66776c0944db66cf80fd7578700324dc5e185c3c806c04f8730.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d6c97febc90dd66776c0944db66cf80fd7578700324dc5e185c3c806c04f8730.mp4',
          name: 'INT-ADV-Alternating_Single_Leg_Drop-EXERCISE',
          description: null,
          size: 56755,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1922,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '61acd03f355e6ec017b5b9518b72b589607e6ec2862dc47f78ae9518a085a1ab',
          file_name:
            'audios/61acd03f355e6ec017b5b9518b72b589607e6ec2862dc47f78ae9518a085a1ab.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/61acd03f355e6ec017b5b9518b72b589607e6ec2862dc47f78ae9518a085a1ab.mp3',
          name: 'INT-ADV-Alternating_Single_Leg_Drop-EXERCISE',
          description: null,
          size: 35216,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-LIZARD_LUNGE_HOPS-EXERCISE': {
      id: 712,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Lizard Lunge Hops',
      short_name: 'Lizard Lunge Hops',
      unique_name: 'INTERMEDIATE-LIZARD_LUNGE_HOPS-EXERCISE',
      description:
        '1. Start in Plank position. Step forward with one leg and place your foot outside the same side hand, front knee bent at 90 degrees.\n2. Staying as low as possible, hop to switch your legs in the air landing in a lunge with the opposite foot forward.\n3. Switch back to the original lunge position. String together in a continuous motion. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1923,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'c601cf8cd0c1f242f88bd65dd17687a9b086a2e52e89b318f7986db828251876',
          file_name:
            'videos/c601cf8cd0c1f242f88bd65dd17687a9b086a2e52e89b318f7986db828251876.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c601cf8cd0c1f242f88bd65dd17687a9b086a2e52e89b318f7986db828251876.mp4',
          name: 'INT-ADV-Lizard_Lunge_Hops-EXERCISE',
          description: null,
          size: 70405,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1924,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'c345b62a57b6b9882f42419dbe77ecb8ed38a374c37ab4ede65e0b3efc5c92cf',
          file_name:
            'audios/c345b62a57b6b9882f42419dbe77ecb8ed38a374c37ab4ede65e0b3efc5c92cf.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c345b62a57b6b9882f42419dbe77ecb8ed38a374c37ab4ede65e0b3efc5c92cf.mp3',
          name: 'INT-ADV-Lizard_Lunge_Hops-EXERCISE',
          description: null,
          size: 30827,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-LIZARD_LUNGE_HOPS-EXERCISE': {
      id: 713,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Lizard Lunge Hops',
      short_name: 'Lizard Lunge Hops',
      unique_name: 'ADVANCED-LIZARD_LUNGE_HOPS-EXERCISE',
      description:
        '1. Start in Plank position. Step forward with one leg and place your foot outside the same side hand, front knee bent at 90 degrees.\n2. Staying as low as possible, hop to switch your legs in the air landing in a lunge with the opposite foot forward.\n3. Switch back to the original lunge position. String together in a continuous motion. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1925,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'c601cf8cd0c1f242f88bd65dd17687a9b086a2e52e89b318f7986db828251876',
          file_name:
            'videos/c601cf8cd0c1f242f88bd65dd17687a9b086a2e52e89b318f7986db828251876.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c601cf8cd0c1f242f88bd65dd17687a9b086a2e52e89b318f7986db828251876.mp4',
          name: 'INT-ADV-Lizard_Lunge_Hops-EXERCISE',
          description: null,
          size: 70405,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1926,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'c345b62a57b6b9882f42419dbe77ecb8ed38a374c37ab4ede65e0b3efc5c92cf',
          file_name:
            'audios/c345b62a57b6b9882f42419dbe77ecb8ed38a374c37ab4ede65e0b3efc5c92cf.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c345b62a57b6b9882f42419dbe77ecb8ed38a374c37ab4ede65e0b3efc5c92cf.mp3',
          name: 'INT-ADV-Lizard_Lunge_Hops-EXERCISE',
          description: null,
          size: 30827,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-LOG_HOPS_ON_FLOOR-EXERCISE': {
      id: 714,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Log Hops on Floor',
      short_name: 'Log Hops on Floor',
      unique_name: 'INTERMEDIATE-LOG_HOPS_ON_FLOOR-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine. Your arms are straight but elbows not locked.\n2. Bend your knees, engage your core and jump both feet to one side with your heels close your glutes. Land soft.\n3. Immediately jump your feet to the other side without a double bounce.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1927,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '9f9dceecddb6f28d07b19ac78ba0259b4e4d0207f7f23e26334d4f4c0679ef16',
          file_name:
            'videos/9f9dceecddb6f28d07b19ac78ba0259b4e4d0207f7f23e26334d4f4c0679ef16.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9f9dceecddb6f28d07b19ac78ba0259b4e4d0207f7f23e26334d4f4c0679ef16.mp4',
          name: 'INT-ADV-Log_Hops_on_Floor-EXERCISE',
          description: null,
          size: 68121,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1928,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '12a492a7268364be763b1f9abf3cef8d63d0887e59651327fc672d933f3f5216',
          file_name:
            'audios/12a492a7268364be763b1f9abf3cef8d63d0887e59651327fc672d933f3f5216.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/12a492a7268364be763b1f9abf3cef8d63d0887e59651327fc672d933f3f5216.mp3',
          name: 'INT-ADV-Log_Hops_on_Floor-EXERCISE',
          description: null,
          size: 29260,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-LOG_HOPS_ON_FLOOR-EXERCISE': {
      id: 715,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Log Hops on Floor',
      short_name: 'Log Hops on Floor',
      unique_name: 'ADVANCED-LOG_HOPS_ON_FLOOR-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine. Your arms are straight but elbows not locked.\n2. Bend your knees, engage your core and jump both feet to one side with your heels close your glutes. Land soft.\n3. Immediately jump your feet to the other side without a double bounce.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1929,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '9f9dceecddb6f28d07b19ac78ba0259b4e4d0207f7f23e26334d4f4c0679ef16',
          file_name:
            'videos/9f9dceecddb6f28d07b19ac78ba0259b4e4d0207f7f23e26334d4f4c0679ef16.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9f9dceecddb6f28d07b19ac78ba0259b4e4d0207f7f23e26334d4f4c0679ef16.mp4',
          name: 'INT-ADV-Log_Hops_on_Floor-EXERCISE',
          description: null,
          size: 68121,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1930,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '12a492a7268364be763b1f9abf3cef8d63d0887e59651327fc672d933f3f5216',
          file_name:
            'audios/12a492a7268364be763b1f9abf3cef8d63d0887e59651327fc672d933f3f5216.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/12a492a7268364be763b1f9abf3cef8d63d0887e59651327fc672d933f3f5216.mp3',
          name: 'INT-ADV-Log_Hops_on_Floor-EXERCISE',
          description: null,
          size: 29260,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-TIGER_PUSH-_UPS-EXERCISE': {
      id: 716,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Tiger Push-Ups',
      short_name: 'Tiger Push-Ups',
      unique_name: 'ADVANCED-TIGER_PUSH-_UPS-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine.\n2. Bend your elbows, pointing them back towards your hips. Lower your body toward the floor.\n3. Bend your knees and push weight back until your hips rest close to your heels and lower your elbows to rest on your forearms.\n4. Shift your weight forward to the bottom of a Push Up.\n5. Straighten your arms and raise your body up to Plank.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1931,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '1c96c7958cf2ab5d2f7aa4490a80839bc61d868359294a6692512ff9f686e2db',
          file_name:
            'videos/1c96c7958cf2ab5d2f7aa4490a80839bc61d868359294a6692512ff9f686e2db.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1c96c7958cf2ab5d2f7aa4490a80839bc61d868359294a6692512ff9f686e2db.mp4',
          name: 'ADV-Tiger_Push-Ups-EXERCISE',
          description: null,
          size: 91850,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1932,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '286044d6193303be34d761a5ba5317660b542ca11f2386584fd73b9eabd5b0b1',
          file_name:
            'audios/286044d6193303be34d761a5ba5317660b542ca11f2386584fd73b9eabd5b0b1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/286044d6193303be34d761a5ba5317660b542ca11f2386584fd73b9eabd5b0b1.mp3',
          name: 'ADV-Tiger_Push-Ups-EXERCISE',
          description: null,
          size: 26439,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SCAPULAR_PUSH-_UPS_ON_KNEES-EXERCISE': {
      id: 729,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Scapular Push-Ups on Knees',
      short_name: 'Scapular Push-Ups on Knees',
      unique_name: 'BEGINNER-SCAPULAR_PUSH-_UPS_ON_KNEES-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists. Drop knees to the floor and lift feet up.\n2. Keeping body in one line and arms straight, retract your shoulder blades by squeezing them back and together as your chest moves slightly toward the floor. Pause.\n3. Keeping arms straight, protract your shoulder blades by pushing them away from each other to create a slight rounding of your upper back.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1963,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'ec806df5b9d1936faffc6335fdc7881e01c4ae2bf8ae91a87d5bfa5af0b72a23',
          file_name:
            'videos/ec806df5b9d1936faffc6335fdc7881e01c4ae2bf8ae91a87d5bfa5af0b72a23.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ec806df5b9d1936faffc6335fdc7881e01c4ae2bf8ae91a87d5bfa5af0b72a23.mp4',
          name: 'BEG-Scapular_Push-Ups_on_Knees-EXERCISE',
          description: null,
          size: 39094,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1964,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'af91739ff998297bb949fa948f2525f560b638789855da8a0a9ab6fe81370a2d',
          file_name:
            'audios/af91739ff998297bb949fa948f2525f560b638789855da8a0a9ab6fe81370a2d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/af91739ff998297bb949fa948f2525f560b638789855da8a0a9ab6fe81370a2d.mp3',
          name: 'BEG-Scapular_Push-Ups_on_Knees-EXERCISE',
          description: null,
          size: 34589,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SERVE_THE_PLATTER-EXERCISE': {
      id: 730,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Serve The Platter',
      short_name: 'Serve The Platter',
      unique_name: 'INTERMEDIATE-SERVE_THE_PLATTER-EXERCISE',
      description:
        '1. Stand tall with your arms by your sides and a dumbbell in each hand. Palms face out. Bend your elbows and curl dumbbells up to waist height, elbows tight to ribcage.\n2. Extend your arms up and away from your body until they are fully extended to shoulder height.\n3. With control, bend your elbows and lower the weights back to your waist at start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1965,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'dc109ab865078adeba2e7871010ebb3f20734256d0d181fa538ea961ea8a0a1d',
          file_name:
            'videos/dc109ab865078adeba2e7871010ebb3f20734256d0d181fa538ea961ea8a0a1d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dc109ab865078adeba2e7871010ebb3f20734256d0d181fa538ea961ea8a0a1d.mp4',
          name: 'INT-ADV-Serve_The_Platter-EXERCISE',
          description: null,
          size: 52299,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1966,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '5206716e107255844762c1c13c9c0bdb24e22de991c8c4d162fd3be19d2b50f4',
          file_name:
            'audios/5206716e107255844762c1c13c9c0bdb24e22de991c8c4d162fd3be19d2b50f4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5206716e107255844762c1c13c9c0bdb24e22de991c8c4d162fd3be19d2b50f4.mp3',
          name: 'INT-ADV-Serve_The_Platter-EXERCISE',
          description: null,
          size: 26125,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SERVE_THE_PLATTER-EXERCISE': {
      id: 731,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Serve The Platter',
      short_name: 'Serve The Platter',
      unique_name: 'ADVANCED-SERVE_THE_PLATTER-EXERCISE',
      description:
        '1. Stand tall with your arms by your sides and a dumbbell in each hand. Palms face out. Bend your elbows and curl dumbbells up to waist height, elbows tight to ribcage.\n2. Extend your arms up and away from your body until they are fully extended to shoulder height.\n3. With control, bend your elbows and lower the weights back to your waist at start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1967,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'dc109ab865078adeba2e7871010ebb3f20734256d0d181fa538ea961ea8a0a1d',
          file_name:
            'videos/dc109ab865078adeba2e7871010ebb3f20734256d0d181fa538ea961ea8a0a1d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dc109ab865078adeba2e7871010ebb3f20734256d0d181fa538ea961ea8a0a1d.mp4',
          name: 'INT-ADV-Serve_The_Platter-EXERCISE',
          description: null,
          size: 52299,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1968,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '5206716e107255844762c1c13c9c0bdb24e22de991c8c4d162fd3be19d2b50f4',
          file_name:
            'audios/5206716e107255844762c1c13c9c0bdb24e22de991c8c4d162fd3be19d2b50f4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5206716e107255844762c1c13c9c0bdb24e22de991c8c4d162fd3be19d2b50f4.mp3',
          name: 'INT-ADV-Serve_The_Platter-EXERCISE',
          description: null,
          size: 26125,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-BODYWEIGHT_REVERSE_FLYS-EXERCISE': {
      id: 732,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bodyweight Reverse Flys',
      short_name: 'Bodyweight Reverse Flys',
      unique_name: 'BEGINNER-BODYWEIGHT_REVERSE_FLYS-EXERCISE',
      description:
        '1. Stand feet shoulder-width apart, knees slightly bent, core tight.\n2. Hinge at the waist until torso is close to parallel to the floor. Arms extended down, hands in fists, palms face each other.\n3. Raise both arms out to your side, keeping soft bend in elbows. Squeeze shoulder blades together at the top. Avoid shrugging, keeping space between your shoulders and ears.\n4. Lower arms back to start.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1969,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f8aaf30dd20acff4080cc617613e78cf96d823b31bda3efa44cae80a278c8ad0',
          file_name:
            'videos/f8aaf30dd20acff4080cc617613e78cf96d823b31bda3efa44cae80a278c8ad0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f8aaf30dd20acff4080cc617613e78cf96d823b31bda3efa44cae80a278c8ad0.mp4',
          name: 'FSTEP-BEG-Bodyweight_Reverse_Flys-EXERCISE',
          description: null,
          size: 46302,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1970,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '2c07a40d031b5cdb2df18367aeac206b7fdafdfce3a991264bbc4603073a363c',
          file_name:
            'audios/2c07a40d031b5cdb2df18367aeac206b7fdafdfce3a991264bbc4603073a363c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2c07a40d031b5cdb2df18367aeac206b7fdafdfce3a991264bbc4603073a363c.mp3',
          name: 'FSTEP-BEG-Bodyweight_Reverse_Flys-EXERCISE',
          description: null,
          size: 33648,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SUPER_PLANK_JACKS-EXERCISE': {
      id: 736,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Super Plank Jacks',
      short_name: 'Super Plank Jacks',
      unique_name: 'INTERMEDIATE-SUPER_PLANK_JACKS-EXERCISE',
      description:
        '1. Start in Plank. Keeping hips and shoulders square to floor, jack feet out into a wide "V" as you lower down to one of your forearms.\n2. Lower the other forearm as you jack your feet back in.\n3. With the starting arm, place hand on the floor where your elbow was, straighten your arm and jack your feet out.\n4. Straighten other arm as you jack your feet back in to Plank. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1977,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f00ed61f41b8f13a23ba1cc95114f830e14d0fbfe544bb69d79dc2172cbb467b',
          file_name:
            'videos/f00ed61f41b8f13a23ba1cc95114f830e14d0fbfe544bb69d79dc2172cbb467b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f00ed61f41b8f13a23ba1cc95114f830e14d0fbfe544bb69d79dc2172cbb467b.mp4',
          name: 'INT-ADV-Super_Plank_Jacks-EXERCISE',
          description: null,
          size: 121053,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1978,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '33a2c05cab047f97312b3a3afa292a5a5bb3c1b6351012ac4c363721783ea9cb',
          file_name:
            'audios/33a2c05cab047f97312b3a3afa292a5a5bb3c1b6351012ac4c363721783ea9cb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/33a2c05cab047f97312b3a3afa292a5a5bb3c1b6351012ac4c363721783ea9cb.mp3',
          name: 'INT-ADV-Super_Plank_Jacks-EXERCISE',
          description: null,
          size: 28946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SUPER_PLANK_JACKS-EXERCISE': {
      id: 737,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Super Plank Jacks',
      short_name: 'Super Plank Jacks',
      unique_name: 'ADVANCED-SUPER_PLANK_JACKS-EXERCISE',
      description:
        '1. Start in Plank. Keeping hips and shoulders square to floor, jack feet out into a wide "V" as you lower down to one of your forearms.\n2. Lower the other forearm as you jack your feet back in.\n3. With the starting arm, place hand on the floor where your elbow was, straighten your arm and jack your feet out.\n4. Straighten other arm as you jack your feet back in to Plank. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1979,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f00ed61f41b8f13a23ba1cc95114f830e14d0fbfe544bb69d79dc2172cbb467b',
          file_name:
            'videos/f00ed61f41b8f13a23ba1cc95114f830e14d0fbfe544bb69d79dc2172cbb467b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f00ed61f41b8f13a23ba1cc95114f830e14d0fbfe544bb69d79dc2172cbb467b.mp4',
          name: 'INT-ADV-Super_Plank_Jacks-EXERCISE',
          description: null,
          size: 121053,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1980,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '33a2c05cab047f97312b3a3afa292a5a5bb3c1b6351012ac4c363721783ea9cb',
          file_name:
            'audios/33a2c05cab047f97312b3a3afa292a5a5bb3c1b6351012ac4c363721783ea9cb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/33a2c05cab047f97312b3a3afa292a5a5bb3c1b6351012ac4c363721783ea9cb.mp3',
          name: 'INT-ADV-Super_Plank_Jacks-EXERCISE',
          description: null,
          size: 28946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-FOREARM_SIDE_PLANK_CRUNCHES-EXERCISE': {
      id: 738,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Forearm Side Plank Crunches',
      short_name: 'Forearm Side Plank Crunches',
      unique_name: 'INTERMEDIATE-FOREARM_SIDE_PLANK_CRUNCHES-EXERCISE',
      description:
        '1. Lie on your side, propping yourself on your forearm, elbow directly under your shoulder, feet stacked.\n2. Lift your hips up so your body is in a straight line in Side Plank. Reach top arm overhead, pit of elbow by ear.\n3. Simultaneously crunch extended arm and leg in, bringing elbow and knee together. Pause.\n4. Extend arm and leg back out. Perform all reps. Repeat other side.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1981,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '25da49c2ba452eefd6388e854233e45ce5e6a9fe12f7ca3916747d5f06220223',
          file_name:
            'videos/25da49c2ba452eefd6388e854233e45ce5e6a9fe12f7ca3916747d5f06220223.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/25da49c2ba452eefd6388e854233e45ce5e6a9fe12f7ca3916747d5f06220223.mp4',
          name: 'INT-ADV-Forearm_Side_Plank_Crunches-EXERCISE-LEFT',
          description: 'Left Side',
          size: 57382,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1982,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: 'e5498dc4db84ed56103f9e6e1d169ec507121c6ccc0fa2cf9b4829791561127e',
          file_name:
            'videos/e5498dc4db84ed56103f9e6e1d169ec507121c6ccc0fa2cf9b4829791561127e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e5498dc4db84ed56103f9e6e1d169ec507121c6ccc0fa2cf9b4829791561127e.mp4',
          name: 'INT-ADV-Forearm_Side_Plank_Crunches-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 57208,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1983,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '38522ea8a308424d12017b1722bb2a77d6043e2185bd6229572adbf0a7a0fdb4',
          file_name:
            'audios/38522ea8a308424d12017b1722bb2a77d6043e2185bd6229572adbf0a7a0fdb4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/38522ea8a308424d12017b1722bb2a77d6043e2185bd6229572adbf0a7a0fdb4.mp3',
          name: 'INT-ADV-Forearm_Side_Plank_Crunches-EXERCISE',
          description: null,
          size: 36156,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-FOREARM_SIDE_PLANK_CRUNCHES-EXERCISE': {
      id: 739,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Forearm Side Plank Crunches',
      short_name: 'Forearm Side Plank Crunches',
      unique_name: 'ADVANCED-FOREARM_SIDE_PLANK_CRUNCHES-EXERCISE',
      description:
        '1. Lie on your side, propping yourself on your forearm, elbow directly under your shoulder, feet stacked.\n2. Lift your hips up so your body is in a straight line in Side Plank. Reach top arm overhead, pit of elbow by ear.\n3. Simultaneously crunch extended arm and leg in, bringing elbow and knee together. Pause.\n4. Extend arm and leg back out. Perform all reps. Repeat other side.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1984,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '25da49c2ba452eefd6388e854233e45ce5e6a9fe12f7ca3916747d5f06220223',
          file_name:
            'videos/25da49c2ba452eefd6388e854233e45ce5e6a9fe12f7ca3916747d5f06220223.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/25da49c2ba452eefd6388e854233e45ce5e6a9fe12f7ca3916747d5f06220223.mp4',
          name: 'INT-ADV-Forearm_Side_Plank_Crunches-EXERCISE-LEFT',
          description: 'Left Side',
          size: 57382,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1985,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: 'e5498dc4db84ed56103f9e6e1d169ec507121c6ccc0fa2cf9b4829791561127e',
          file_name:
            'videos/e5498dc4db84ed56103f9e6e1d169ec507121c6ccc0fa2cf9b4829791561127e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e5498dc4db84ed56103f9e6e1d169ec507121c6ccc0fa2cf9b4829791561127e.mp4',
          name: 'INT-ADV-Forearm_Side_Plank_Crunches-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 57208,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1986,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '38522ea8a308424d12017b1722bb2a77d6043e2185bd6229572adbf0a7a0fdb4',
          file_name:
            'audios/38522ea8a308424d12017b1722bb2a77d6043e2185bd6229572adbf0a7a0fdb4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/38522ea8a308424d12017b1722bb2a77d6043e2185bd6229572adbf0a7a0fdb4.mp3',
          name: 'INT-ADV-Forearm_Side_Plank_Crunches-EXERCISE',
          description: null,
          size: 36156,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-STANDING_GLUTE_KICKBACKS-EXERCISE': {
      id: 740,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Standing Glute Kickbacks',
      short_name: 'Standing Glute Kickbacks',
      unique_name: 'BEGINNER-STANDING_GLUTE_KICKBACKS-EXERCISE',
      description:
        '1. Stand feet in a close stance. Place hands on hips or hold onto a chair or wall for assistance.\n2. Keeping hips square, bend one knee bringing your heel toward your glutes. Shin should be about parallel to the floor.\n3. Push through heel to extend leg straight back behind you, toes toward the floor. Do not arch low back.\n4. Bend knee and return to start. Perform all reps. Repeat other side.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1987,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'c0c2b948683f33c8fc8474b967e53f274f6cdf3ce4e0e003df3b14b0ae934235',
          file_name:
            'videos/c0c2b948683f33c8fc8474b967e53f274f6cdf3ce4e0e003df3b14b0ae934235.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c0c2b948683f33c8fc8474b967e53f274f6cdf3ce4e0e003df3b14b0ae934235.mp4',
          name: 'FSTEP-BEG-Standing_Glute_Kickbacks-EXERCISE-LEFT',
          description: 'Left Side',
          size: 40028,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1988,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: '1c6484b0664f9a3af9fa5281eaec4230ba8387bb605ecaf9b821cea79da63a41',
          file_name:
            'videos/1c6484b0664f9a3af9fa5281eaec4230ba8387bb605ecaf9b821cea79da63a41.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1c6484b0664f9a3af9fa5281eaec4230ba8387bb605ecaf9b821cea79da63a41.mp4',
          name: 'FSTEP-BEG-Standing_Glute_Kickbacks-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 44327,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1989,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '9092dcf7cbca43458df8c0b0e7913a54fee4352b00c42c9c0616bbffcde6481f',
          file_name:
            'audios/9092dcf7cbca43458df8c0b0e7913a54fee4352b00c42c9c0616bbffcde6481f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9092dcf7cbca43458df8c0b0e7913a54fee4352b00c42c9c0616bbffcde6481f.mp3',
          name: 'FSTEP-BEG-Standing_Glute_Kickbacks-EXERCISE',
          description: null,
          size: 33021,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SPRINTER_SIT-_UPS-EXERCISE': {
      id: 741,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Sprinter Sit-Ups',
      short_name: 'Sprinter Sit-Ups',
      unique_name: 'INTERMEDIATE-SPRINTER_SIT-_UPS-EXERCISE',
      description:
        '1. Lie on back with arms by sides. Tuck pelvis and plant lower back on the floor. Raise shoulders, head and arms up and lift both feet about six inches off the floor.\n2. Explosively sit upright while pulling one knee toward chest and shooting the opposite arm forward. Other leg remains straight, opposite elbow bent behind you.\n3. Lower back to start and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1990,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'd72e9e5556cd1c193060b5699e469295d18a0743b18504d704d98b212b86bef6',
          file_name:
            'videos/d72e9e5556cd1c193060b5699e469295d18a0743b18504d704d98b212b86bef6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d72e9e5556cd1c193060b5699e469295d18a0743b18504d704d98b212b86bef6.mp4',
          name: 'INT-ADV-Sprinter_Sit-Ups-EXERCISE',
          description: null,
          size: 89871,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1991,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'b20c4ce5d67b864599217d67c88d5f992b3c8b9048fa311b751d2004586c7d9a',
          file_name:
            'audios/b20c4ce5d67b864599217d67c88d5f992b3c8b9048fa311b751d2004586c7d9a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b20c4ce5d67b864599217d67c88d5f992b3c8b9048fa311b751d2004586c7d9a.mp3',
          name: 'INT-ADV-Sprinter_Sit-Ups-EXERCISE',
          description: null,
          size: 27692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SPRINTER_SIT-_UPS-EXERCISE': {
      id: 742,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Sprinter Sit-Ups',
      short_name: 'Sprinter Sit-Ups',
      unique_name: 'ADVANCED-SPRINTER_SIT-_UPS-EXERCISE',
      description:
        '1. Lie on back with arms by sides. Tuck pelvis and plant lower back on the floor. Raise shoulders, head and arms up and lift both feet about six inches off the floor.\n2. Explosively sit upright while pulling one knee toward chest and shooting the opposite arm forward. Other leg remains straight, opposite elbow bent behind you.\n3. Lower back to start and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1992,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'd72e9e5556cd1c193060b5699e469295d18a0743b18504d704d98b212b86bef6',
          file_name:
            'videos/d72e9e5556cd1c193060b5699e469295d18a0743b18504d704d98b212b86bef6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d72e9e5556cd1c193060b5699e469295d18a0743b18504d704d98b212b86bef6.mp4',
          name: 'INT-ADV-Sprinter_Sit-Ups-EXERCISE',
          description: null,
          size: 89871,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1993,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'b20c4ce5d67b864599217d67c88d5f992b3c8b9048fa311b751d2004586c7d9a',
          file_name:
            'audios/b20c4ce5d67b864599217d67c88d5f992b3c8b9048fa311b751d2004586c7d9a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b20c4ce5d67b864599217d67c88d5f992b3c8b9048fa311b751d2004586c7d9a.mp3',
          name: 'INT-ADV-Sprinter_Sit-Ups-EXERCISE',
          description: null,
          size: 27692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-BURPEES_WITH_FRONT_RAISE-EXERCISE': {
      id: 743,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Burpees with Front Raise',
      short_name: 'Burpees with Front Raise',
      unique_name: 'INTERMEDIATE-BURPEES_WITH_FRONT_RAISE-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart holding a dumbbell in each hand. Raise dumbbells in front of you to shoulder height, arms straight and palms down.\n2. Lower dumbbells back to start. Bend knees and hinge at waist to plant both dumbbells on the floor. Palms face in.\n3. Jump feet behind you to Plank.\n4. Jump feet back in, shoulder-width apart, heels flat.\n5. Transfer weight back to a low squat, stand up and repeat.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1995,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '2ded45f61d0b19c35cdabfebef48ebb1bbd8ba7ff64bcd013c9728ad0b63b3c3',
          file_name:
            'audios/2ded45f61d0b19c35cdabfebef48ebb1bbd8ba7ff64bcd013c9728ad0b63b3c3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2ded45f61d0b19c35cdabfebef48ebb1bbd8ba7ff64bcd013c9728ad0b63b3c3.mp3',
          name: 'INT-ADV-Burpees_with_Front_Raise-EXERCISE',
          description: null,
          size: 29260,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2567,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '0f39b16d45b1e85b97152d215d500b80db4bf3852f60715fa317f8e75f682cc5',
          file_name:
            'videos/0f39b16d45b1e85b97152d215d500b80db4bf3852f60715fa317f8e75f682cc5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0f39b16d45b1e85b97152d215d500b80db4bf3852f60715fa317f8e75f682cc5.mp4',
          name: 'INT-ADV-Burpees_with_Front_Raise-EXERCISE',
          description: null,
          size: 155666,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-BURPEES_WITH_FRONT_RAISE-EXERCISE': {
      id: 744,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Burpees with Front Raise',
      short_name: 'Burpees with Front Raise',
      unique_name: 'ADVANCED-BURPEES_WITH_FRONT_RAISE-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart holding a dumbbell in each hand. Raise dumbbells in front of you to shoulder height, arms straight and palms down.\n2. Lower dumbbells back to start. Bend knees and hinge at waist to plant both dumbbells on the floor. Palms face in.\n3. Jump feet behind you to Plank.\n4. Jump feet back in, shoulder-width apart, heels flat.\n5. Transfer weight back to a low squat, stand up and repeat.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 1997,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '2ded45f61d0b19c35cdabfebef48ebb1bbd8ba7ff64bcd013c9728ad0b63b3c3',
          file_name:
            'audios/2ded45f61d0b19c35cdabfebef48ebb1bbd8ba7ff64bcd013c9728ad0b63b3c3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2ded45f61d0b19c35cdabfebef48ebb1bbd8ba7ff64bcd013c9728ad0b63b3c3.mp3',
          name: 'INT-ADV-Burpees_with_Front_Raise-EXERCISE',
          description: null,
          size: 29260,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2568,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '0f39b16d45b1e85b97152d215d500b80db4bf3852f60715fa317f8e75f682cc5',
          file_name:
            'videos/0f39b16d45b1e85b97152d215d500b80db4bf3852f60715fa317f8e75f682cc5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0f39b16d45b1e85b97152d215d500b80db4bf3852f60715fa317f8e75f682cc5.mp4',
          name: 'INT-ADV-Burpees_with_Front_Raise-EXERCISE',
          description: null,
          size: 155666,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ARNOLD_PRESS-EXERCISE': {
      id: 745,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Arnold Press',
      short_name: 'Arnold Press',
      unique_name: 'INTERMEDIATE-ARNOLD_PRESS-EXERCISE',
      description:
        '1. Stand with a solid foundation, back straight, core engaged. Hold a dumbbell in each hand in front of your chest, shoulder height, palms face in. Keep elbows close to rib cage.\n2. Rotate wrists out, bring elbows away from your body and raise both dumbbells straight overhead to full extension, biceps by ears, palms out.\n3. Lower arms down and rotate wrists back in to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 1998,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '948feb5e73f995e96d777ccb4e039962024c4bf9a5ecc387c5acc0e44c696dc9',
          file_name:
            'videos/948feb5e73f995e96d777ccb4e039962024c4bf9a5ecc387c5acc0e44c696dc9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/948feb5e73f995e96d777ccb4e039962024c4bf9a5ecc387c5acc0e44c696dc9.mp4',
          name: 'INT-ADV-Arnold_Press-EXERCISE',
          description: null,
          size: 72655,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 1999,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '9cabb39344c4b385895c6c68e50ce66e1e25765bf7c5a58540e729b24cb048ab',
          file_name:
            'audios/9cabb39344c4b385895c6c68e50ce66e1e25765bf7c5a58540e729b24cb048ab.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9cabb39344c4b385895c6c68e50ce66e1e25765bf7c5a58540e729b24cb048ab.mp3',
          name: 'INT-ADV-Arnold_Press-EXERCISE',
          description: null,
          size: 24558,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ARNOLD_PRESS-EXERCISE': {
      id: 746,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Arnold Press',
      short_name: 'Arnold Press',
      unique_name: 'ADVANCED-ARNOLD_PRESS-EXERCISE',
      description:
        '1. Stand with a solid foundation, back straight, core engaged. Hold a dumbbell in each hand in front of your chest, shoulder height, palms face in. Keep elbows close to rib cage.\n2. Rotate wrists out, bring elbows away from your body and raise both dumbbells straight overhead to full extension, biceps by ears, palms out.\n3. Lower arms down and rotate wrists back in to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2000,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '948feb5e73f995e96d777ccb4e039962024c4bf9a5ecc387c5acc0e44c696dc9',
          file_name:
            'videos/948feb5e73f995e96d777ccb4e039962024c4bf9a5ecc387c5acc0e44c696dc9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/948feb5e73f995e96d777ccb4e039962024c4bf9a5ecc387c5acc0e44c696dc9.mp4',
          name: 'INT-ADV-Arnold_Press-EXERCISE',
          description: null,
          size: 72655,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2001,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '9cabb39344c4b385895c6c68e50ce66e1e25765bf7c5a58540e729b24cb048ab',
          file_name:
            'audios/9cabb39344c4b385895c6c68e50ce66e1e25765bf7c5a58540e729b24cb048ab.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9cabb39344c4b385895c6c68e50ce66e1e25765bf7c5a58540e729b24cb048ab.mp3',
          name: 'INT-ADV-Arnold_Press-EXERCISE',
          description: null,
          size: 24558,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-BUTTERFLY_SIT_UPS-EXERCISE': {
      id: 747,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Butterfly Sit Ups',
      short_name: 'Butterfly Sit Ups',
      unique_name: 'BEGINNER-BUTTERFLY_SIT_UPS-EXERCISE',
      description:
        '1. Lie on your back with the soles of your feet together, knees out wide and arms long overhead.\n2. Sit up and reach both arms in between your knees and tap them on the floor past your toes. Keep legs on the floor.\n3. Slowly roll back down to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2002,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f206d6348546b11057f959a2212703b254ec994e71d5065600370566b7b9f0cd',
          file_name:
            'videos/f206d6348546b11057f959a2212703b254ec994e71d5065600370566b7b9f0cd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f206d6348546b11057f959a2212703b254ec994e71d5065600370566b7b9f0cd.mp4',
          name: 'FSTEP-BEG-INT-ADV-Butterfly_Sit_Ups-EXERCISE',
          description: null,
          size: 118588,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2003,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'fd16ff834cbc08a8e3bd6720a5f6ef6a664ee50099cac207bd5fe7d7fbc69df8',
          file_name:
            'audios/fd16ff834cbc08a8e3bd6720a5f6ef6a664ee50099cac207bd5fe7d7fbc69df8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fd16ff834cbc08a8e3bd6720a5f6ef6a664ee50099cac207bd5fe7d7fbc69df8.mp3',
          name: 'FSTEP-BEG-INT-ADV-Butterfly_Sit_Ups-EXERCISE',
          description: null,
          size: 28946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-BUTTERFLY_SIT_UPS-EXERCISE': {
      id: 748,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Butterfly Sit Ups',
      short_name: 'Butterfly Sit Ups',
      unique_name: 'INTERMEDIATE-BUTTERFLY_SIT_UPS-EXERCISE',
      description:
        '1. Lie on your back with the soles of your feet together, knees out wide and arms long overhead.\n2. Sit up and reach both arms in between your knees and tap them on the floor past your toes. Keep legs on the floor.\n3. Slowly roll back down to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2004,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f206d6348546b11057f959a2212703b254ec994e71d5065600370566b7b9f0cd',
          file_name:
            'videos/f206d6348546b11057f959a2212703b254ec994e71d5065600370566b7b9f0cd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f206d6348546b11057f959a2212703b254ec994e71d5065600370566b7b9f0cd.mp4',
          name: 'FSTEP-BEG-INT-ADV-Butterfly_Sit_Ups-EXERCISE',
          description: null,
          size: 118588,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2005,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'fd16ff834cbc08a8e3bd6720a5f6ef6a664ee50099cac207bd5fe7d7fbc69df8',
          file_name:
            'audios/fd16ff834cbc08a8e3bd6720a5f6ef6a664ee50099cac207bd5fe7d7fbc69df8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fd16ff834cbc08a8e3bd6720a5f6ef6a664ee50099cac207bd5fe7d7fbc69df8.mp3',
          name: 'FSTEP-BEG-INT-ADV-Butterfly_Sit_Ups-EXERCISE',
          description: null,
          size: 28946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-BUTTERFLY_SIT_UPS-EXERCISE': {
      id: 749,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Butterfly Sit Ups',
      short_name: 'Butterfly Sit Ups',
      unique_name: 'ADVANCED-BUTTERFLY_SIT_UPS-EXERCISE',
      description:
        '1. Lie on your back with the soles of your feet together, knees out wide and arms long overhead.\n2. Sit up and reach both arms in between your knees and tap them on the floor past your toes. Keep legs on the floor.\n3. Slowly roll back down to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2006,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f206d6348546b11057f959a2212703b254ec994e71d5065600370566b7b9f0cd',
          file_name:
            'videos/f206d6348546b11057f959a2212703b254ec994e71d5065600370566b7b9f0cd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f206d6348546b11057f959a2212703b254ec994e71d5065600370566b7b9f0cd.mp4',
          name: 'FSTEP-BEG-INT-ADV-Butterfly_Sit_Ups-EXERCISE',
          description: null,
          size: 118588,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2007,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'fd16ff834cbc08a8e3bd6720a5f6ef6a664ee50099cac207bd5fe7d7fbc69df8',
          file_name:
            'audios/fd16ff834cbc08a8e3bd6720a5f6ef6a664ee50099cac207bd5fe7d7fbc69df8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fd16ff834cbc08a8e3bd6720a5f6ef6a664ee50099cac207bd5fe7d7fbc69df8.mp3',
          name: 'FSTEP-BEG-INT-ADV-Butterfly_Sit_Ups-EXERCISE',
          description: null,
          size: 28946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-MODIFIED_SEAL_JACKS-EXERCISE': {
      id: 753,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Modified Seal Jacks',
      short_name: 'Modified Seal Jacks',
      unique_name: 'BEGINNER-MODIFIED_SEAL_JACKS-EXERCISE',
      description:
        '1. Start standing with your feet together and your arms extended in front of you at shoulder height, palms touching.\n2. Take a big step directly to the side with one foot, opening your arms out to a "T".\n3. Step the other foot in to meet it as you bring your arms back together in front of your body.\n4. Repeat stepping in the other direction. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2014,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '14f8fcbb50b457343f88d19cca2a49711c94832d6209559239e56d779f7383af',
          file_name:
            'videos/14f8fcbb50b457343f88d19cca2a49711c94832d6209559239e56d779f7383af.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/14f8fcbb50b457343f88d19cca2a49711c94832d6209559239e56d779f7383af.mp4',
          name: 'FSTEP-BEG-Modified_Seal_Jacks-EXERCISE',
          description: null,
          size: 80531,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2015,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '740ac605a123716432fac6db678697ff311a904fe60fb2a1c81259f58b3a5e58',
          file_name:
            'audios/740ac605a123716432fac6db678697ff311a904fe60fb2a1c81259f58b3a5e58.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/740ac605a123716432fac6db678697ff311a904fe60fb2a1c81259f58b3a5e58.mp3',
          name: 'FSTEP-BEG-Modified_Seal_Jacks-EXERCISE',
          description: null,
          size: 30514,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-FOREARM_PLANK_HIP_ROCKS-EXERCISE': {
      id: 757,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Forearm Plank Hip Rocks',
      short_name: 'Forearm Plank Hip Rocks',
      unique_name: 'INTERMEDIATE-FOREARM_PLANK_HIP_ROCKS-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat.\n2. Maintaining a long spine and tight core, drop one hip toward the floor, tapping slightly if possible.\n3. Return to Plank and rock to the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2022,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'adffc52600f9c95b5a031604cdfb857b00e1cdbdb0de59f5c57d33da8e415f0e',
          file_name:
            'videos/adffc52600f9c95b5a031604cdfb857b00e1cdbdb0de59f5c57d33da8e415f0e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/adffc52600f9c95b5a031604cdfb857b00e1cdbdb0de59f5c57d33da8e415f0e.mp4',
          name: 'INT-ADV-Forearm_Plank_Hip_Rocks-EXERCISE',
          description: null,
          size: 73467,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2023,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '0644d7e51bbb30a7bc1d4bea98e0c43cef908d86bb566370071373279b9d5478',
          file_name:
            'audios/0644d7e51bbb30a7bc1d4bea98e0c43cef908d86bb566370071373279b9d5478.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0644d7e51bbb30a7bc1d4bea98e0c43cef908d86bb566370071373279b9d5478.mp3',
          name: 'INT-ADV-Forearm_Plank_Hip_Rocks-EXERCISE',
          description: null,
          size: 40636,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-FOREARM_PLANK_HIP_ROCKS-EXERCISE': {
      id: 758,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Forearm Plank Hip Rocks',
      short_name: 'Forearm Plank Hip Rocks',
      unique_name: 'ADVANCED-FOREARM_PLANK_HIP_ROCKS-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat.\n2. Maintaining a long spine and tight core, drop one hip toward the floor, tapping slightly if possible.\n3. Return to Plank and rock to the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2024,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'adffc52600f9c95b5a031604cdfb857b00e1cdbdb0de59f5c57d33da8e415f0e',
          file_name:
            'videos/adffc52600f9c95b5a031604cdfb857b00e1cdbdb0de59f5c57d33da8e415f0e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/adffc52600f9c95b5a031604cdfb857b00e1cdbdb0de59f5c57d33da8e415f0e.mp4',
          name: 'INT-ADV-Forearm_Plank_Hip_Rocks-EXERCISE',
          description: null,
          size: 73467,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2025,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '0644d7e51bbb30a7bc1d4bea98e0c43cef908d86bb566370071373279b9d5478',
          file_name:
            'audios/0644d7e51bbb30a7bc1d4bea98e0c43cef908d86bb566370071373279b9d5478.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0644d7e51bbb30a7bc1d4bea98e0c43cef908d86bb566370071373279b9d5478.mp3',
          name: 'INT-ADV-Forearm_Plank_Hip_Rocks-EXERCISE',
          description: null,
          size: 40636,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ROTATOR_CUFF_EXTERNAL_ROTATION-EXERCISE': {
      id: 759,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Rotator Cuff External Rotation',
      short_name: 'Rotator Cuff External Rotation',
      unique_name: 'BEGINNER-ROTATOR_CUFF_EXTERNAL_ROTATION-EXERCISE',
      description:
        '1. Stand tall with your arms by your sides. Bend your elbows and curl arms up to waist height, elbows tight to ribcage, palms face each other.\n2. Keeping your elbows glued to your sides, open your arms out, away from your midline, parallel to the floor.\n3. Pause and bring arms back in.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2026,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '6d71f27412860c85069844bc21d8b4d124e89350936f06bcfdb5299915cc9e7b',
          file_name:
            'videos/6d71f27412860c85069844bc21d8b4d124e89350936f06bcfdb5299915cc9e7b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6d71f27412860c85069844bc21d8b4d124e89350936f06bcfdb5299915cc9e7b.mp4',
          name: 'BEG-Rotator_Cuff_External_Rotation-EXERCISE',
          description: null,
          size: 37278,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2027,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'f58e865c40657171eefd53bd361153a567d9a28e6b377d7f4b06602a5ebf1f14',
          file_name:
            'audios/f58e865c40657171eefd53bd361153a567d9a28e6b377d7f4b06602a5ebf1f14.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f58e865c40657171eefd53bd361153a567d9a28e6b377d7f4b06602a5ebf1f14.mp3',
          name: 'BEG-Rotator_Cuff_External_Rotation-EXERCISE',
          description: null,
          size: 41799,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ROTATOR_CUFF_UPRIGHT_EXTERNAL_ROTATION-EXERCISE': {
      id: 760,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Rotator Cuff Upright External Rotation',
      short_name: 'Rotator External Rotation',
      unique_name: 'BEGINNER-ROTATOR_CUFF_UPRIGHT_EXTERNAL_ROTATION-EXERCISE',
      description:
        '1. Stand tall with your arms out to sides at shoulder height, elbows bent so forearms are parallel to the floor, hands in fists, palms face down.\n2. Keeping your elbows in line with your shoulders, lift your fists up toward your head to make a "goal post" position. Avoid shrugging and keep space between shoulders and ears.\n3. Pause and return your arms back to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2028,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'fdaa43c1b6425178d1d0f56446621fbb13355440b043879cb0cf244afc5f0e21',
          file_name:
            'videos/fdaa43c1b6425178d1d0f56446621fbb13355440b043879cb0cf244afc5f0e21.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fdaa43c1b6425178d1d0f56446621fbb13355440b043879cb0cf244afc5f0e21.mp4',
          name: 'BEG-Rotator_Cuff_Upright_External_Rotation-EXERCISE',
          description: null,
          size: 29549,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2029,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'c295674e212fb4eb2d63f2812d06a6c7f63ca1ba33f62d6ca8dd78154cd0db81',
          file_name:
            'audios/c295674e212fb4eb2d63f2812d06a6c7f63ca1ba33f62d6ca8dd78154cd0db81.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c295674e212fb4eb2d63f2812d06a6c7f63ca1ba33f62d6ca8dd78154cd0db81.mp3',
          name: 'BEG-Rotator_Cuff_Upright_External_Rotation-EXERCISE',
          description: null,
          size: 49635,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SWIMMERS-EXERCISE': {
      id: 761,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Swimmers',
      short_name: 'Swimmers',
      unique_name: 'BEGINNER-SWIMMERS-EXERCISE',
      description:
        '1. Lie flat on your stomach, legs long and arms extended overhead. Keep your neck in line with your spine and gaze toward the floor.\n2. Lift your arms and legs off the ground.\n3. Keeping arms and legs lifted, flutter opposite arms and legs in a continuous motion. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2030,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '616c6177940f9e0981cdb5ce6da140ab24523a8e54c50c198fa408b452359bcd',
          file_name:
            'videos/616c6177940f9e0981cdb5ce6da140ab24523a8e54c50c198fa408b452359bcd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/616c6177940f9e0981cdb5ce6da140ab24523a8e54c50c198fa408b452359bcd.mp4',
          name: 'FSTEP-BEG-INT-ADV-Swimmers-EXERCISE',
          description: null,
          size: 23381,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2031,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda',
          file_name:
            'audios/8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda.mp3',
          name: 'FSTEP-BEG-INT-ADV-Swimmers-EXERCISE',
          description: null,
          size: 22050,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SWIMMERS-EXERCISE': {
      id: 762,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Swimmers',
      short_name: 'Swimmers',
      unique_name: 'INTERMEDIATE-SWIMMERS-EXERCISE',
      description:
        '1. Lie flat on your stomach, legs long and arms extended overhead. Keep your neck in line with your spine and gaze toward the floor.\n2. Lift your arms and legs off the ground.\n3. Keeping arms and legs lifted, flutter opposite arms and legs in a continuous motion. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2032,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '616c6177940f9e0981cdb5ce6da140ab24523a8e54c50c198fa408b452359bcd',
          file_name:
            'videos/616c6177940f9e0981cdb5ce6da140ab24523a8e54c50c198fa408b452359bcd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/616c6177940f9e0981cdb5ce6da140ab24523a8e54c50c198fa408b452359bcd.mp4',
          name: 'FSTEP-BEG-INT-ADV-Swimmers-EXERCISE',
          description: null,
          size: 23381,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2033,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda',
          file_name:
            'audios/8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda.mp3',
          name: 'FSTEP-BEG-INT-ADV-Swimmers-EXERCISE',
          description: null,
          size: 22050,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SWIMMERS-EXERCISE': {
      id: 763,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Swimmers',
      short_name: 'Swimmers',
      unique_name: 'ADVANCED-SWIMMERS-EXERCISE',
      description:
        '1. Lie flat on your stomach, legs long and arms extended overhead. Keep your neck in line with your spine and gaze toward the floor.\n2. Lift your arms and legs off the ground.\n3. Keeping arms and legs lifted, flutter opposite arms and legs in a continuous motion. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2034,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '616c6177940f9e0981cdb5ce6da140ab24523a8e54c50c198fa408b452359bcd',
          file_name:
            'videos/616c6177940f9e0981cdb5ce6da140ab24523a8e54c50c198fa408b452359bcd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/616c6177940f9e0981cdb5ce6da140ab24523a8e54c50c198fa408b452359bcd.mp4',
          name: 'FSTEP-BEG-INT-ADV-Swimmers-EXERCISE',
          description: null,
          size: 23381,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2035,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda',
          file_name:
            'audios/8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8389eb1e5c88bee57c3a4dcdaf671a5912857757d18900aa1c483023f1871cda.mp3',
          name: 'FSTEP-BEG-INT-ADV-Swimmers-EXERCISE',
          description: null,
          size: 22050,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-TOE_TOUCH_CRUNCHES-EXERCISE': {
      id: 767,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Toe Touch Crunches',
      short_name: 'Toe Touch Crunches',
      unique_name: 'BEGINNER-TOE_TOUCH_CRUNCHES-EXERCISE',
      description:
        '1. Lie on your back with your arms and legs straight up in the air, legs directly over your hips in an "L" shape.\n2. Crunch your upper body off the floor reaching for your toes.\n3. Lower back down to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2042,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '06a18c0a9635f1d54b33be19af0c3631dab9accbbe580ca40dd63003d1e36530',
          file_name:
            'videos/06a18c0a9635f1d54b33be19af0c3631dab9accbbe580ca40dd63003d1e36530.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/06a18c0a9635f1d54b33be19af0c3631dab9accbbe580ca40dd63003d1e36530.mp4',
          name: 'FSTEP-BEG-INT-ADV-Toe_Touch_Crunches-EXERCISE',
          description: null,
          size: 37146,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2043,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'd32e8a39b9042e278386478e16b1a2641131b7937ee8336ee89044c04b8bed3a',
          file_name:
            'audios/d32e8a39b9042e278386478e16b1a2641131b7937ee8336ee89044c04b8bed3a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d32e8a39b9042e278386478e16b1a2641131b7937ee8336ee89044c04b8bed3a.mp3',
          name: 'FSTEP-BEG-INT-ADV-Toe_Touch_Crunches-EXERCISE',
          description: null,
          size: 28633,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-TOE_TOUCH_CRUNCHES-EXERCISE': {
      id: 768,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Toe Touch Crunches',
      short_name: 'Toe Touch Crunches',
      unique_name: 'INTERMEDIATE-TOE_TOUCH_CRUNCHES-EXERCISE',
      description:
        '1. Lie on your back with your arms and legs straight up in the air, legs directly over your hips in an "L" shape.\n2. Crunch your upper body off the floor reaching for your toes.\n3. Lower back down to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2044,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '06a18c0a9635f1d54b33be19af0c3631dab9accbbe580ca40dd63003d1e36530',
          file_name:
            'videos/06a18c0a9635f1d54b33be19af0c3631dab9accbbe580ca40dd63003d1e36530.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/06a18c0a9635f1d54b33be19af0c3631dab9accbbe580ca40dd63003d1e36530.mp4',
          name: 'FSTEP-BEG-INT-ADV-Toe_Touch_Crunches-EXERCISE',
          description: null,
          size: 37146,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2045,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'd32e8a39b9042e278386478e16b1a2641131b7937ee8336ee89044c04b8bed3a',
          file_name:
            'audios/d32e8a39b9042e278386478e16b1a2641131b7937ee8336ee89044c04b8bed3a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d32e8a39b9042e278386478e16b1a2641131b7937ee8336ee89044c04b8bed3a.mp3',
          name: 'FSTEP-BEG-INT-ADV-Toe_Touch_Crunches-EXERCISE',
          description: null,
          size: 28633,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-TOE_TOUCH_CRUNCHES-EXERCISE': {
      id: 769,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Toe Touch Crunches',
      short_name: 'Toe Touch Crunches',
      unique_name: 'ADVANCED-TOE_TOUCH_CRUNCHES-EXERCISE',
      description:
        '1. Lie on your back with your arms and legs straight up in the air, legs directly over your hips in an "L" shape.\n2. Crunch your upper body off the floor reaching for your toes.\n3. Lower back down to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2046,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '06a18c0a9635f1d54b33be19af0c3631dab9accbbe580ca40dd63003d1e36530',
          file_name:
            'videos/06a18c0a9635f1d54b33be19af0c3631dab9accbbe580ca40dd63003d1e36530.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/06a18c0a9635f1d54b33be19af0c3631dab9accbbe580ca40dd63003d1e36530.mp4',
          name: 'FSTEP-BEG-INT-ADV-Toe_Touch_Crunches-EXERCISE',
          description: null,
          size: 37146,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2047,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'd32e8a39b9042e278386478e16b1a2641131b7937ee8336ee89044c04b8bed3a',
          file_name:
            'audios/d32e8a39b9042e278386478e16b1a2641131b7937ee8336ee89044c04b8bed3a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d32e8a39b9042e278386478e16b1a2641131b7937ee8336ee89044c04b8bed3a.mp3',
          name: 'FSTEP-BEG-INT-ADV-Toe_Touch_Crunches-EXERCISE',
          description: null,
          size: 28633,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-PRONE_BODYWEIGHT_WS-EXERCISE': {
      id: 779,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Prone Bodyweight Ws',
      short_name: 'Prone Bodyweight Ws',
      unique_name: 'BEGINNER-PRONE_BODYWEIGHT_WS-EXERCISE',
      description:
        '1. Lie on your stomach with your legs long, forehead on floor and your arms stretched out a "T", shoulder height.\n2. Bend both elbows to 90 in a "goal post" position. Rotate your fists so your thumbs face up.\n3. Squeeze your shoulder blades together as you raise both arms off the floor. Avoid shrugging and keep space between shoulders and ears.\n4. Pause at the top and with control, return to start.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2075,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'a354d0e3cc1b3447cad1a68a402f687ced78cb9b93d4f320eebbc6f1139000db',
          file_name:
            'videos/a354d0e3cc1b3447cad1a68a402f687ced78cb9b93d4f320eebbc6f1139000db.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a354d0e3cc1b3447cad1a68a402f687ced78cb9b93d4f320eebbc6f1139000db.mp4',
          name: 'FSTEP-BEG-Prone_Bodyweight_Ws-EXERCISE',
          description: null,
          size: 36373,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2076,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'aab6fb3377a9995958e00371afbfca04601880962ec506c73aaee3cb3ef35d7c',
          file_name:
            'audios/aab6fb3377a9995958e00371afbfca04601880962ec506c73aaee3cb3ef35d7c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/aab6fb3377a9995958e00371afbfca04601880962ec506c73aaee3cb3ef35d7c.mp3',
          name: 'FSTEP-BEG-Prone_Bodyweight_Ws-EXERCISE',
          description: null,
          size: 34589,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-PRONE_BODYWEIGHT_YS-EXERCISE': {
      id: 780,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Prone Bodyweight Ys',
      short_name: 'Prone Bodyweight Ys',
      unique_name: 'BEGINNER-PRONE_BODYWEIGHT_YS-EXERCISE',
      description:
        '1. Lie on your stomach with your legs long, forehead on floor and your arms overhead in a "Y". Rotate your fists so your thumbs face up.\n2. Squeeze your shoulder blades together as you raise both arms off the floor. Avoid shrugging and keep space between shoulders and ears.\n3. Pause at the top and with control, return to start.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2077,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f9ded216d548b6577241096f311e709264618155ccc55d7ea95d164ffca5bdc9',
          file_name:
            'videos/f9ded216d548b6577241096f311e709264618155ccc55d7ea95d164ffca5bdc9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f9ded216d548b6577241096f311e709264618155ccc55d7ea95d164ffca5bdc9.mp4',
          name: 'FSTEP-BEG-Prone_Bodyweight_Ys-EXERCISE',
          description: null,
          size: 32420,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2078,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'c6d5fba31928334afce3fbee01d631a12f03c74dafbc6536096987c9ac430e7b',
          file_name:
            'audios/c6d5fba31928334afce3fbee01d631a12f03c74dafbc6536096987c9ac430e7b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c6d5fba31928334afce3fbee01d631a12f03c74dafbc6536096987c9ac430e7b.mp3',
          name: 'FSTEP-BEG-Prone_Bodyweight_Ys-EXERCISE',
          description: null,
          size: 34902,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ALTERNATING_DOWN_DOG_WITH_LEG_LIFTS-EXERCISE': {
      id: 781,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Down Dog with Alternating Leg Lifts',
      short_name: 'Down Dog w Alt. Leg Lifts',
      unique_name: 'BEGINNER-ALTERNATING_DOWN_DOG_WITH_LEG_LIFTS-EXERCISE',
      description:
        '1. Start in Down Dog position. Your hands are on the ground with your head between your upper arms, your hips up and back making an inverted "V."\n2. Lift one leg high into the air, hips square and toes pointed down. Squeeze glutes at the top.\n3. Lower your leg back to Down Dog position and repeat other leg. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2079,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '2dfdc0c04b590180d5c4fb39a733710746eb15e0e7c8055cf8b33967588d4351',
          file_name:
            'videos/2dfdc0c04b590180d5c4fb39a733710746eb15e0e7c8055cf8b33967588d4351.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2dfdc0c04b590180d5c4fb39a733710746eb15e0e7c8055cf8b33967588d4351.mp4',
          name: 'BEG-INT-ADV-Alternating_Down_Dog_with_Leg_Lifts-EXERCISE',
          description: null,
          size: 127770,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2561,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144',
          file_name:
            'audios/ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144.mp3',
          name: 'BEG-INT-ADV-Down_Dog_with_Alternating_Leg_Lifts-EXERCISE',
          description: null,
          size: 39384,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_DOWN_DOG_WITH_LEG_LIFTS-EXERCISE': {
      id: 782,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Down Dog with Alternating Leg Lifts',
      short_name: 'Down Dog w Alt. Leg Lifts',
      unique_name: 'INTERMEDIATE-ALTERNATING_DOWN_DOG_WITH_LEG_LIFTS-EXERCISE',
      description:
        '1. Start in Down Dog position. Your hands are on the ground with your head between your upper arms, your hips up and back making an inverted "V."\n2. Lift one leg high into the air, hips square and toes pointed down. Squeeze glutes at the top.\n3. Lower your leg back to Down Dog position and repeat other leg. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2081,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '2dfdc0c04b590180d5c4fb39a733710746eb15e0e7c8055cf8b33967588d4351',
          file_name:
            'videos/2dfdc0c04b590180d5c4fb39a733710746eb15e0e7c8055cf8b33967588d4351.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2dfdc0c04b590180d5c4fb39a733710746eb15e0e7c8055cf8b33967588d4351.mp4',
          name: 'BEG-INT-ADV-Alternating_Down_Dog_with_Leg_Lifts-EXERCISE',
          description: null,
          size: 127770,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2562,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144',
          file_name:
            'audios/ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144.mp3',
          name: 'BEG-INT-ADV-Down_Dog_with_Alternating_Leg_Lifts-EXERCISE',
          description: null,
          size: 39384,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_DOWN_DOG_WITH_LEG_LIFTS-EXERCISE': {
      id: 783,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Down Dog with Alternating Leg Lifts',
      short_name: 'Down Dog w Alt. Leg Lifts',
      unique_name: 'ADVANCED-ALTERNATING_DOWN_DOG_WITH_LEG_LIFTS-EXERCISE',
      description:
        '1. Start in Down Dog position. Your hands are on the ground with your head between your upper arms, your hips up and back making an inverted "V."\n2. Lift one leg high into the air, hips square and toes pointed down. Squeeze glutes at the top.\n3. Lower your leg back to Down Dog position and repeat other leg. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2083,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '2dfdc0c04b590180d5c4fb39a733710746eb15e0e7c8055cf8b33967588d4351',
          file_name:
            'videos/2dfdc0c04b590180d5c4fb39a733710746eb15e0e7c8055cf8b33967588d4351.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2dfdc0c04b590180d5c4fb39a733710746eb15e0e7c8055cf8b33967588d4351.mp4',
          name: 'BEG-INT-ADV-Alternating_Down_Dog_with_Leg_Lifts-EXERCISE',
          description: null,
          size: 127770,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2563,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144',
          file_name:
            'audios/ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ecf4f70c031b7413d053b3066aa8e232eab1a350b8ab93ae8856d4183763d144.mp3',
          name: 'BEG-INT-ADV-Down_Dog_with_Alternating_Leg_Lifts-EXERCISE',
          description: null,
          size: 39384,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MERMAID_TAIL-EXERCISE': {
      id: 787,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Mermaid Tail',
      short_name: 'Mermaid Tail',
      unique_name: 'INTERMEDIATE-MERMAID_TAIL-EXERCISE',
      description:
        '1. Lie on your back with your hands on the floor by your sides, palms flat. Engage your core and tuck your pelvis, so your lower back is planted firmly on the floor. Lift both feet up about six inches.\n2. Keeping feet and legs together, move them from side to side, drawing a shallow "U" shape with your toes.\n3. Move back and forth in a continuous motion. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2091,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '5d85fd4f0b4eaa6c7422e84916e30bc0d7450c454239f9ddebb08a8fd1226ae8',
          file_name:
            'videos/5d85fd4f0b4eaa6c7422e84916e30bc0d7450c454239f9ddebb08a8fd1226ae8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5d85fd4f0b4eaa6c7422e84916e30bc0d7450c454239f9ddebb08a8fd1226ae8.mp4',
          name: 'INT-ADV-Mermaid_Tail-EXERCISE',
          description: null,
          size: 53320,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2092,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '1256fd871d214313d8dba0889a51e2198cbac341cf1f0e2bc54e6b630e867852',
          file_name:
            'audios/1256fd871d214313d8dba0889a51e2198cbac341cf1f0e2bc54e6b630e867852.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1256fd871d214313d8dba0889a51e2198cbac341cf1f0e2bc54e6b630e867852.mp3',
          name: 'INT-ADV-Mermaid_Tail-EXERCISE',
          description: null,
          size: 26125,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MERMAID_TAIL-EXERCISE': {
      id: 788,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Mermaid Tail',
      short_name: 'Mermaid Tail',
      unique_name: 'ADVANCED-MERMAID_TAIL-EXERCISE',
      description:
        '1. Lie on your back with your hands on the floor by your sides, palms flat. Engage your core and tuck your pelvis, so your lower back is planted firmly on the floor. Lift both feet up about six inches.\n2. Keeping feet and legs together, move them from side to side, drawing a shallow "U" shape with your toes.\n3. Move back and forth in a continuous motion. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2093,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '5d85fd4f0b4eaa6c7422e84916e30bc0d7450c454239f9ddebb08a8fd1226ae8',
          file_name:
            'videos/5d85fd4f0b4eaa6c7422e84916e30bc0d7450c454239f9ddebb08a8fd1226ae8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5d85fd4f0b4eaa6c7422e84916e30bc0d7450c454239f9ddebb08a8fd1226ae8.mp4',
          name: 'INT-ADV-Mermaid_Tail-EXERCISE',
          description: null,
          size: 53320,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2094,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '1256fd871d214313d8dba0889a51e2198cbac341cf1f0e2bc54e6b630e867852',
          file_name:
            'audios/1256fd871d214313d8dba0889a51e2198cbac341cf1f0e2bc54e6b630e867852.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1256fd871d214313d8dba0889a51e2198cbac341cf1f0e2bc54e6b630e867852.mp3',
          name: 'INT-ADV-Mermaid_Tail-EXERCISE',
          description: null,
          size: 26125,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_CROSS_BODY_PUNCHES-EXERCISE': {
      id: 789,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Cross Body Punches',
      short_name: 'Dumbbell Cross Body Punches',
      unique_name: 'INTERMEDIATE-DUMBBELL_CROSS_BODY_PUNCHES-EXERCISE',
      description:
        '1. Stand with feet wider than hip-width apart and a soft bend in both knees. Hold a dumbbell in each hand in front of your chest at shoulder height, elbows tight to your body.\n2. Punch one dumbbell across your body, wrist down and rotate your shoulders and hips in the same direction. Pivot on the base foot.\n3. Recoil back to start and repeat other side.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2095,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '76939939ecd1169c3dd03f0fa11e0442d22b0cd2bc5c33ea618b3c5e99b9ff1f',
          file_name:
            'videos/76939939ecd1169c3dd03f0fa11e0442d22b0cd2bc5c33ea618b3c5e99b9ff1f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/76939939ecd1169c3dd03f0fa11e0442d22b0cd2bc5c33ea618b3c5e99b9ff1f.mp4',
          name: 'INT-ADV-Dumbbell_Cross_Body_Punches-EXERCISE',
          description: null,
          size: 98492,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2096,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'd096f25b29095f7232246779a23308b9b448aa09c1ccdecdec49c5ad78415736',
          file_name:
            'audios/d096f25b29095f7232246779a23308b9b448aa09c1ccdecdec49c5ad78415736.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d096f25b29095f7232246779a23308b9b448aa09c1ccdecdec49c5ad78415736.mp3',
          name: 'INT-ADV-Dumbbell_Cross_Body_Punches-EXERCISE',
          description: null,
          size: 36783,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_CROSS_BODY_PUNCHES-EXERCISE': {
      id: 790,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Cross Body Punches',
      short_name: 'Dumbbell Cross Body Punches',
      unique_name: 'ADVANCED-DUMBBELL_CROSS_BODY_PUNCHES-EXERCISE',
      description:
        '1. Stand with feet wider than hip-width apart and a soft bend in both knees. Hold a dumbbell in each hand in front of your chest at shoulder height, elbows tight to your body.\n2. Punch one dumbbell across your body, wrist down and rotate your shoulders and hips in the same direction. Pivot on the base foot.\n3. Recoil back to start and repeat other side.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2097,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '76939939ecd1169c3dd03f0fa11e0442d22b0cd2bc5c33ea618b3c5e99b9ff1f',
          file_name:
            'videos/76939939ecd1169c3dd03f0fa11e0442d22b0cd2bc5c33ea618b3c5e99b9ff1f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/76939939ecd1169c3dd03f0fa11e0442d22b0cd2bc5c33ea618b3c5e99b9ff1f.mp4',
          name: 'INT-ADV-Dumbbell_Cross_Body_Punches-EXERCISE',
          description: null,
          size: 98492,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2098,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'd096f25b29095f7232246779a23308b9b448aa09c1ccdecdec49c5ad78415736',
          file_name:
            'audios/d096f25b29095f7232246779a23308b9b448aa09c1ccdecdec49c5ad78415736.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d096f25b29095f7232246779a23308b9b448aa09c1ccdecdec49c5ad78415736.mp3',
          name: 'INT-ADV-Dumbbell_Cross_Body_Punches-EXERCISE',
          description: null,
          size: 36783,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-REVERSE_FLYS-EXERCISE': {
      id: 791,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Reverse Flys',
      short_name: 'Reverse Flys',
      unique_name: 'INTERMEDIATE-REVERSE_FLYS-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart, knees slightly bent, core tight and back flat. Hold a dumbbell in each hand.\n2. Hinge at the waist until your torso is close to parallel to the floor. Arms extended straight down, palms face in.\n3. Raise both arms out to the sides, keeping a soft bend in your elbows. Squeeze shoulder blades together at the top.\n4. Lower your arms back to start.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2099,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'a626471f0fe11ed9ac4bf4d455eaf9069e8abbb016ac92cfecfe365fcd51dea3',
          file_name:
            'videos/a626471f0fe11ed9ac4bf4d455eaf9069e8abbb016ac92cfecfe365fcd51dea3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a626471f0fe11ed9ac4bf4d455eaf9069e8abbb016ac92cfecfe365fcd51dea3.mp4',
          name: 'INT-ADV-Reverse_Flys-EXERCISE',
          description: null,
          size: 61802,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2100,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '365142335e865f85804c63a1f8572bbfdcb0c8b5cb103112de41930900ccfe19',
          file_name:
            'audios/365142335e865f85804c63a1f8572bbfdcb0c8b5cb103112de41930900ccfe19.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/365142335e865f85804c63a1f8572bbfdcb0c8b5cb103112de41930900ccfe19.mp3',
          name: 'INT-ADV-Reverse_Flys-EXERCISE',
          description: null,
          size: 28946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-REVERSE_FLYS-EXERCISE': {
      id: 792,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Reverse Flys',
      short_name: 'Reverse Flys',
      unique_name: 'ADVANCED-REVERSE_FLYS-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart, knees slightly bent, core tight and back flat. Hold a dumbbell in each hand.\n2. Hinge at the waist until your torso is close to parallel to the floor. Arms extended straight down, palms face in.\n3. Raise both arms out to the sides, keeping a soft bend in your elbows. Squeeze shoulder blades together at the top.\n4. Lower your arms back to start.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2101,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'a626471f0fe11ed9ac4bf4d455eaf9069e8abbb016ac92cfecfe365fcd51dea3',
          file_name:
            'videos/a626471f0fe11ed9ac4bf4d455eaf9069e8abbb016ac92cfecfe365fcd51dea3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a626471f0fe11ed9ac4bf4d455eaf9069e8abbb016ac92cfecfe365fcd51dea3.mp4',
          name: 'INT-ADV-Reverse_Flys-EXERCISE',
          description: null,
          size: 61802,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2102,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '365142335e865f85804c63a1f8572bbfdcb0c8b5cb103112de41930900ccfe19',
          file_name:
            'audios/365142335e865f85804c63a1f8572bbfdcb0c8b5cb103112de41930900ccfe19.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/365142335e865f85804c63a1f8572bbfdcb0c8b5cb103112de41930900ccfe19.mp3',
          name: 'INT-ADV-Reverse_Flys-EXERCISE',
          description: null,
          size: 28946,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_ROTATOR_CUFF_UPRIGHT_EXTERNAL_ROTATION-EXERCISE': {
      id: 793,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Rotator Cuff Upright External Rotation',
      short_name: 'Dumbbell Upright Rotation',
      unique_name:
        'INTERMEDIATE-DUMBBELL_ROTATOR_CUFF_UPRIGHT_EXTERNAL_ROTATION-EXERCISE',
      description:
        '1. Stand tall hold a pair of dumbbells at shoulder height, elbows bent so forearms are parallel to the floor, palms face down.\n2. Keeping your elbows in line with your shoulders, lift dumbbells up toward your head to make a "goal post" position. Avoid shrugging and keep space between shoulders and ears.\n3. Pause and return your arms back to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2103,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '118b62fe947919b6539cf60f26c620b0577f8188aec2877b749debbfd9e566bc',
          file_name:
            'videos/118b62fe947919b6539cf60f26c620b0577f8188aec2877b749debbfd9e566bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/118b62fe947919b6539cf60f26c620b0577f8188aec2877b749debbfd9e566bc.mp4',
          name: 'INT-ADV-Dumbbell_Rotator_Cuff_Upright_External_Rotation-EXERCISE',
          description: null,
          size: 52415,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2104,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'ba85ddf330287f0e26750239ec8851f7a713e94903692b4d19d803308963bcd1',
          file_name:
            'audios/ba85ddf330287f0e26750239ec8851f7a713e94903692b4d19d803308963bcd1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ba85ddf330287f0e26750239ec8851f7a713e94903692b4d19d803308963bcd1.mp3',
          name: 'INT-ADV-Dumbbell_Rotator_Cuff_Upright_External_Rotation-EXERCISE',
          description: null,
          size: 57473,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_ROTATOR_CUFF_UPRIGHT_EXTERNAL_ROTATION-EXERCISE': {
      id: 794,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Rotator Cuff Upright External Rotation',
      short_name: 'Dumbbell Upright Rotation',
      unique_name:
        'ADVANCED-DUMBBELL_ROTATOR_CUFF_UPRIGHT_EXTERNAL_ROTATION-EXERCISE',
      description:
        '1. Stand tall hold a pair of dumbbells at shoulder height, elbows bent so forearms are parallel to the floor, palms face down.\n2. Keeping your elbows in line with your shoulders, lift dumbbells up toward your head to make a "goal post" position. Avoid shrugging and keep space between shoulders and ears.\n3. Pause and return your arms back to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2105,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '118b62fe947919b6539cf60f26c620b0577f8188aec2877b749debbfd9e566bc',
          file_name:
            'videos/118b62fe947919b6539cf60f26c620b0577f8188aec2877b749debbfd9e566bc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/118b62fe947919b6539cf60f26c620b0577f8188aec2877b749debbfd9e566bc.mp4',
          name: 'INT-ADV-Dumbbell_Rotator_Cuff_Upright_External_Rotation-EXERCISE',
          description: null,
          size: 52415,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2106,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'ba85ddf330287f0e26750239ec8851f7a713e94903692b4d19d803308963bcd1',
          file_name:
            'audios/ba85ddf330287f0e26750239ec8851f7a713e94903692b4d19d803308963bcd1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ba85ddf330287f0e26750239ec8851f7a713e94903692b4d19d803308963bcd1.mp3',
          name: 'INT-ADV-Dumbbell_Rotator_Cuff_Upright_External_Rotation-EXERCISE',
          description: null,
          size: 57473,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_ROTATOR_CUFF_EXTERNAL_ROTATION-EXERCISE': {
      id: 795,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Rotator Cuff External Rotation',
      short_name: 'Dumbbell External Rotation',
      unique_name:
        'INTERMEDIATE-DUMBBELL_ROTATOR_CUFF_EXTERNAL_ROTATION-EXERCISE',
      description:
        '1. Stand tall with a dumbbell in each hand by your sides. Bend your elbows and curl arms up to waist height, elbows tight to ribcage, palms face each other.\n2. Keeping your elbows glued to your sides, open your arms out, away from your midline, parallel to the floor.\n3. Pause and bring arms back in.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2107,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '271aa478055d6aa7ca413d0e41d1c1563aefca5e37ba073be162cecb71ab153d',
          file_name:
            'videos/271aa478055d6aa7ca413d0e41d1c1563aefca5e37ba073be162cecb71ab153d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/271aa478055d6aa7ca413d0e41d1c1563aefca5e37ba073be162cecb71ab153d.mp4',
          name: 'INT-ADV-Dumbbell_Rotator_Cuff_External_Rotation-EXERCISE',
          description: null,
          size: 52271,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2108,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '9413c12dcace3b0ecaa6747635e63282f711a6c0be4c522d34c5646b4a614c14',
          file_name:
            'audios/9413c12dcace3b0ecaa6747635e63282f711a6c0be4c522d34c5646b4a614c14.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9413c12dcace3b0ecaa6747635e63282f711a6c0be4c522d34c5646b4a614c14.mp3',
          name: 'INT-ADV-Dumbbell_Rotator_Cuff_External_Rotation-EXERCISE',
          description: null,
          size: 46501,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_ROTATOR_CUFF_EXTERNAL_ROTATION-EXERCISE': {
      id: 796,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Rotator Cuff External Rotation',
      short_name: 'Dumbbell External Rotation',
      unique_name: 'ADVANCED-DUMBBELL_ROTATOR_CUFF_EXTERNAL_ROTATION-EXERCISE',
      description:
        '1. Stand tall with a dumbbell in each hand by your sides. Bend your elbows and curl arms up to waist height, elbows tight to ribcage, palms face each other.\n2. Keeping your elbows glued to your sides, open your arms out, away from your midline, parallel to the floor.\n3. Pause and bring arms back in.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2109,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '271aa478055d6aa7ca413d0e41d1c1563aefca5e37ba073be162cecb71ab153d',
          file_name:
            'videos/271aa478055d6aa7ca413d0e41d1c1563aefca5e37ba073be162cecb71ab153d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/271aa478055d6aa7ca413d0e41d1c1563aefca5e37ba073be162cecb71ab153d.mp4',
          name: 'INT-ADV-Dumbbell_Rotator_Cuff_External_Rotation-EXERCISE',
          description: null,
          size: 52271,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2110,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '9413c12dcace3b0ecaa6747635e63282f711a6c0be4c522d34c5646b4a614c14',
          file_name:
            'audios/9413c12dcace3b0ecaa6747635e63282f711a6c0be4c522d34c5646b4a614c14.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9413c12dcace3b0ecaa6747635e63282f711a6c0be4c522d34c5646b4a614c14.mp3',
          name: 'INT-ADV-Dumbbell_Rotator_Cuff_External_Rotation-EXERCISE',
          description: null,
          size: 46501,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SEESAW_PRESS-EXERCISE': {
      id: 797,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Seesaw Press',
      short_name: 'Seesaw Press',
      unique_name: 'INTERMEDIATE-SEESAW_PRESS-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart. Hold a dumbbell in each hand at your shoulders, palms face in, elbows down.\n2. With core engaged, swiftly press one dumbbell straight up into the air.\n3. As you bring your arm down, immediately press upwards with the opposite arm.\n4. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2111,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f9792f0226ce88c4bf6e790a25dfe04f119b29d891b72fe63f0249ea2e0c4a44',
          file_name:
            'videos/f9792f0226ce88c4bf6e790a25dfe04f119b29d891b72fe63f0249ea2e0c4a44.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f9792f0226ce88c4bf6e790a25dfe04f119b29d891b72fe63f0249ea2e0c4a44.mp4',
          name: 'INT-ADV-Seesaw_Press-EXERCISE',
          description: null,
          size: 45734,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2112,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '9dca68c444669107258c4ac2e7fec5a1aec1a6ccb618734413c5545afc692cc5',
          file_name:
            'audios/9dca68c444669107258c4ac2e7fec5a1aec1a6ccb618734413c5545afc692cc5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9dca68c444669107258c4ac2e7fec5a1aec1a6ccb618734413c5545afc692cc5.mp3',
          name: 'INT-ADV-Seesaw_Press-EXERCISE',
          description: null,
          size: 26125,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SEESAW_PRESS-EXERCISE': {
      id: 798,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Seesaw Press',
      short_name: 'Seesaw Press',
      unique_name: 'ADVANCED-SEESAW_PRESS-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart. Hold a dumbbell in each hand at your shoulders, palms face in, elbows down.\n2. With core engaged, swiftly press one dumbbell straight up into the air.\n3. As you bring your arm down, immediately press upwards with the opposite arm.\n4. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2113,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f9792f0226ce88c4bf6e790a25dfe04f119b29d891b72fe63f0249ea2e0c4a44',
          file_name:
            'videos/f9792f0226ce88c4bf6e790a25dfe04f119b29d891b72fe63f0249ea2e0c4a44.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f9792f0226ce88c4bf6e790a25dfe04f119b29d891b72fe63f0249ea2e0c4a44.mp4',
          name: 'INT-ADV-Seesaw_Press-EXERCISE',
          description: null,
          size: 45734,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2114,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '9dca68c444669107258c4ac2e7fec5a1aec1a6ccb618734413c5545afc692cc5',
          file_name:
            'audios/9dca68c444669107258c4ac2e7fec5a1aec1a6ccb618734413c5545afc692cc5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9dca68c444669107258c4ac2e7fec5a1aec1a6ccb618734413c5545afc692cc5.mp3',
          name: 'INT-ADV-Seesaw_Press-EXERCISE',
          description: null,
          size: 26125,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SINGLE_ARM_THRUSTERS_WITH_ROTATION-EXERCISE': {
      id: 799,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Single Arm Thrusters With Rotation',
      short_name: 'Single Arm Thrusts w Rotation',
      unique_name: 'INTERMEDIATE-SINGLE_ARM_THRUSTERS_WITH_ROTATION-EXERCISE',
      description:
        '1. Stand feet about shoulder-width apart. Hold a dumbbell in each hand at your shoulders, palms face in, elbows down.\n2. Squat as low as possible, bringing elbows close to knees.\n3. Stand and rotate body to one side, pivoting on the base foot and raising the outside dumbbell overhead, bicep by ears.\n4. Squat as you bring the dumbbell to your shoulder. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2115,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '7cef466e983d646e85a4d269b5338410c8a6429c90278f09e37fbe3443607a35',
          file_name:
            'videos/7cef466e983d646e85a4d269b5338410c8a6429c90278f09e37fbe3443607a35.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7cef466e983d646e85a4d269b5338410c8a6429c90278f09e37fbe3443607a35.mp4',
          name: 'INT-ADV-Single_Arm_Thrusters_With_Rotation-EXERCISE',
          description: null,
          size: 160029,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2116,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '4667ed9b3d8ef00ba32fe0779a4145b84b908f436ee52ca7132c4a8025720572',
          file_name:
            'audios/4667ed9b3d8ef00ba32fe0779a4145b84b908f436ee52ca7132c4a8025720572.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4667ed9b3d8ef00ba32fe0779a4145b84b908f436ee52ca7132c4a8025720572.mp3',
          name: 'INT-ADV-Single_Arm_Thrusters_With_Rotation-EXERCISE',
          description: null,
          size: 39604,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SINGLE_ARM_THRUSTERS_WITH_ROTATION-EXERCISE': {
      id: 800,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Single Arm Thrusters With Rotation',
      short_name: 'Single Arm Thrusts w Rotation',
      unique_name: 'ADVANCED-SINGLE_ARM_THRUSTERS_WITH_ROTATION-EXERCISE',
      description:
        '1. Stand feet about shoulder-width apart. Hold a dumbbell in each hand at your shoulders, palms face in, elbows down.\n2. Squat as low as possible, bringing elbows close to knees.\n3. Stand and rotate body to one side, pivoting on the base foot and raising the outside dumbbell overhead, bicep by ears.\n4. Squat as you bring the dumbbell to your shoulder. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2117,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '7cef466e983d646e85a4d269b5338410c8a6429c90278f09e37fbe3443607a35',
          file_name:
            'videos/7cef466e983d646e85a4d269b5338410c8a6429c90278f09e37fbe3443607a35.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7cef466e983d646e85a4d269b5338410c8a6429c90278f09e37fbe3443607a35.mp4',
          name: 'INT-ADV-Single_Arm_Thrusters_With_Rotation-EXERCISE',
          description: null,
          size: 160029,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2118,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '4667ed9b3d8ef00ba32fe0779a4145b84b908f436ee52ca7132c4a8025720572',
          file_name:
            'audios/4667ed9b3d8ef00ba32fe0779a4145b84b908f436ee52ca7132c4a8025720572.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4667ed9b3d8ef00ba32fe0779a4145b84b908f436ee52ca7132c4a8025720572.mp3',
          name: 'INT-ADV-Single_Arm_Thrusters_With_Rotation-EXERCISE',
          description: null,
          size: 39604,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DOUBLE_MOUNTAIN_CLIMBERS-EXERCISE': {
      id: 801,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Double Mountain Climbers',
      short_name: 'Double Mountain Climbers',
      unique_name: 'INTERMEDIATE-DOUBLE_MOUNTAIN_CLIMBERS-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists, hips square.\n2. Bend your knees and hop both feet toward your hands, landing with your knees tucked between arms.\n3. Jump both feet back to Plank position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2119,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '494a8aef3531dd3efa45f59605f347465f9385bd4ac003b762cc6b3cf31b17c8',
          file_name:
            'videos/494a8aef3531dd3efa45f59605f347465f9385bd4ac003b762cc6b3cf31b17c8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/494a8aef3531dd3efa45f59605f347465f9385bd4ac003b762cc6b3cf31b17c8.mp4',
          name: 'INT-ADV-Double_Mountain_Climbers-EXERCISE',
          description: null,
          size: 49245,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2120,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'f94349a5fa68776083f753f6084b4455ebc4a0d23e828700997ea32f8748a1f4',
          file_name:
            'audios/f94349a5fa68776083f753f6084b4455ebc4a0d23e828700997ea32f8748a1f4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f94349a5fa68776083f753f6084b4455ebc4a0d23e828700997ea32f8748a1f4.mp3',
          name: 'INT-ADV-Double_Mountain_Climbers-EXERCISE',
          description: null,
          size: 30827,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DOUBLE_MOUNTAIN_CLIMBERS-EXERCISE': {
      id: 802,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Double Mountain Climbers',
      short_name: 'Double Mountain Climbers',
      unique_name: 'ADVANCED-DOUBLE_MOUNTAIN_CLIMBERS-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists, hips square.\n2. Bend your knees and hop both feet toward your hands, landing with your knees tucked between arms.\n3. Jump both feet back to Plank position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2121,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '494a8aef3531dd3efa45f59605f347465f9385bd4ac003b762cc6b3cf31b17c8',
          file_name:
            'videos/494a8aef3531dd3efa45f59605f347465f9385bd4ac003b762cc6b3cf31b17c8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/494a8aef3531dd3efa45f59605f347465f9385bd4ac003b762cc6b3cf31b17c8.mp4',
          name: 'INT-ADV-Double_Mountain_Climbers-EXERCISE',
          description: null,
          size: 49245,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2122,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'f94349a5fa68776083f753f6084b4455ebc4a0d23e828700997ea32f8748a1f4',
          file_name:
            'audios/f94349a5fa68776083f753f6084b4455ebc4a0d23e828700997ea32f8748a1f4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f94349a5fa68776083f753f6084b4455ebc4a0d23e828700997ea32f8748a1f4.mp3',
          name: 'INT-ADV-Double_Mountain_Climbers-EXERCISE',
          description: null,
          size: 30827,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-BIG_FLUTTER_KICKS-EXERCISE': {
      id: 806,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Big Flutter Kicks',
      short_name: 'Big Flutter Kicks',
      unique_name: 'INTERMEDIATE-BIG_FLUTTER_KICKS-EXERCISE',
      description:
        '1. Lie on your back, arms by your sides, palms flat. Lift your legs straight up until they are directly over your hips.\n2. Keeping your head and shoulders back, lower one leg down toward the floor to a hover.\n3. Bring the top leg down and bottom leg up to switch.\n4. Repeat in a continuous motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2132,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '65c9d76dccb555c3367162bd579db145e2f4838cfa51c9b3d0aa251134e51a8e',
          file_name:
            'videos/65c9d76dccb555c3367162bd579db145e2f4838cfa51c9b3d0aa251134e51a8e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/65c9d76dccb555c3367162bd579db145e2f4838cfa51c9b3d0aa251134e51a8e.mp4',
          name: 'INT-ADV-Big_Flutter_Kicks-EXERCISE',
          description: null,
          size: 43042,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2133,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'f8fac4a2b6e558153c50ef9a298ed13896aebf46b0c2a2d27bf1661d8f7de511',
          file_name:
            'audios/f8fac4a2b6e558153c50ef9a298ed13896aebf46b0c2a2d27bf1661d8f7de511.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f8fac4a2b6e558153c50ef9a298ed13896aebf46b0c2a2d27bf1661d8f7de511.mp3',
          name: 'INT-ADV-Big_Flutter_Kicks-EXERCISE',
          description: null,
          size: 30200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-BIG_FLUTTER_KICKS-EXERCISE': {
      id: 807,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Big Flutter Kicks',
      short_name: 'Big Flutter Kicks',
      unique_name: 'ADVANCED-BIG_FLUTTER_KICKS-EXERCISE',
      description:
        '1. Lie on your back, arms by your sides, palms flat. Lift your legs straight up until they are directly over your hips.\n2. Keeping your head and shoulders back, lower one leg down toward the floor to a hover.\n3. Bring the top leg down and bottom leg up to switch.\n4. Repeat in a continuous motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2134,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '65c9d76dccb555c3367162bd579db145e2f4838cfa51c9b3d0aa251134e51a8e',
          file_name:
            'videos/65c9d76dccb555c3367162bd579db145e2f4838cfa51c9b3d0aa251134e51a8e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/65c9d76dccb555c3367162bd579db145e2f4838cfa51c9b3d0aa251134e51a8e.mp4',
          name: 'INT-ADV-Big_Flutter_Kicks-EXERCISE',
          description: null,
          size: 43042,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2135,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'f8fac4a2b6e558153c50ef9a298ed13896aebf46b0c2a2d27bf1661d8f7de511',
          file_name:
            'audios/f8fac4a2b6e558153c50ef9a298ed13896aebf46b0c2a2d27bf1661d8f7de511.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f8fac4a2b6e558153c50ef9a298ed13896aebf46b0c2a2d27bf1661d8f7de511.mp3',
          name: 'INT-ADV-Big_Flutter_Kicks-EXERCISE',
          description: null,
          size: 30200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-JUMPING_JILLS-EXERCISE': {
      id: 808,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Jumping Jills',
      short_name: 'Jumping Jills',
      unique_name: 'BEGINNER-JUMPING_JILLS-EXERCISE',
      description:
        '1. Stand with your feet together and your arms straight down by your sides.\n2. Jump and land softly on the balls of your feet with one foot in front of you and the other one behind you. Raise the arm opposite to the front foot straight up, and keep the other down by your side.\n3. Immediately jump up and switch your legs and arms.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2136,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '3e8723964317143277390d5759267801b6d0fe5bbc117bb71728c8fbb7e87ef8',
          file_name:
            'videos/3e8723964317143277390d5759267801b6d0fe5bbc117bb71728c8fbb7e87ef8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3e8723964317143277390d5759267801b6d0fe5bbc117bb71728c8fbb7e87ef8.mp4',
          name: 'BEG-Jumping_Jills-EXERCISE',
          description: null,
          size: 41108,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2137,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'df8c578c6a36ad903e1b7861ef11f6f061ae8efca0d4766bddcc4e72371d6545',
          file_name:
            'audios/df8c578c6a36ad903e1b7861ef11f6f061ae8efca0d4766bddcc4e72371d6545.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/df8c578c6a36ad903e1b7861ef11f6f061ae8efca0d4766bddcc4e72371d6545.mp3',
          name: 'BEG-Jumping_Jills-EXERCISE',
          description: null,
          size: 25812,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PLANK_LATERAL_HOP-EXERCISE': {
      id: 812,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Plank Lateral Hop',
      short_name: 'Plank Lateral Hop',
      unique_name: 'INTERMEDIATE-PLANK_LATERAL_HOP-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine and feet together.\n2. Keeping your back straight and core engaged, soften your knees and hop both feet to one side.\n3. Immediately jump your feet to the other side without a double bounce.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2144,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'b2037823fecccf625256943af32c9e8b724e9cc9e3f113bdb416f938246ab3f7',
          file_name:
            'videos/b2037823fecccf625256943af32c9e8b724e9cc9e3f113bdb416f938246ab3f7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b2037823fecccf625256943af32c9e8b724e9cc9e3f113bdb416f938246ab3f7.mp4',
          name: 'INT-ADV-Plank_Lateral_Hop-EXERCISE',
          description: null,
          size: 46911,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2145,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'e1d8615f0b39d9eb19ffbb367bdc340e7bddbf44f56761fe103ad42d71ed7a42',
          file_name:
            'audios/e1d8615f0b39d9eb19ffbb367bdc340e7bddbf44f56761fe103ad42d71ed7a42.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e1d8615f0b39d9eb19ffbb367bdc340e7bddbf44f56761fe103ad42d71ed7a42.mp3',
          name: 'INT-ADV-Plank_Lateral_Hop-EXERCISE',
          description: null,
          size: 30200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PLANK_LATERAL_HOP-EXERCISE': {
      id: 813,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Plank Lateral Hop',
      short_name: 'Plank Lateral Hop',
      unique_name: 'ADVANCED-PLANK_LATERAL_HOP-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists, long spine and feet together.\n2. Keeping your back straight and core engaged, soften your knees and hop both feet to one side.\n3. Immediately jump your feet to the other side without a double bounce.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2146,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'b2037823fecccf625256943af32c9e8b724e9cc9e3f113bdb416f938246ab3f7',
          file_name:
            'videos/b2037823fecccf625256943af32c9e8b724e9cc9e3f113bdb416f938246ab3f7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b2037823fecccf625256943af32c9e8b724e9cc9e3f113bdb416f938246ab3f7.mp4',
          name: 'INT-ADV-Plank_Lateral_Hop-EXERCISE',
          description: null,
          size: 46911,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2147,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'e1d8615f0b39d9eb19ffbb367bdc340e7bddbf44f56761fe103ad42d71ed7a42',
          file_name:
            'audios/e1d8615f0b39d9eb19ffbb367bdc340e7bddbf44f56761fe103ad42d71ed7a42.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e1d8615f0b39d9eb19ffbb367bdc340e7bddbf44f56761fe103ad42d71ed7a42.mp3',
          name: 'INT-ADV-Plank_Lateral_Hop-EXERCISE',
          description: null,
          size: 30200,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-MODIFIED_SIDE_PLANK_CRUNCHES-EXERCISE': {
      id: 814,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Modified Side Plank Crunches',
      short_name: 'Modified Side Plank Crunches',
      unique_name: 'BEGINNER-MODIFIED_SIDE_PLANK_CRUNCHES-EXERCISE',
      description:
        '1. Lie on your side and prop up on one arm, shoulder over wrist. Bend bottom leg and extend top leg.\n2. Keep bottom leg on floor, lift hips up so your body is in a straight line. Reach top arm overhead, pit of your elbow by your ear.\n3. Simultaneously crunch extended arm and leg in, bringing elbow and knee together. Pause.\n4. Extend arm and leg back out. Perform all reps. Repeat other side.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: true,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2148,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '25999e60b8addfac8eb70b5629bdf71bbfcbbc96757c13caed120759b9ca2678',
          file_name:
            'videos/25999e60b8addfac8eb70b5629bdf71bbfcbbc96757c13caed120759b9ca2678.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/25999e60b8addfac8eb70b5629bdf71bbfcbbc96757c13caed120759b9ca2678.mp4',
          name: 'BEG-Modified_Side_Plank_Crunches-EXERCISE-LEFT',
          description: 'Left Side',
          size: 66942,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2149,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: 'ce6d7562b1dac1eefa20450bb0551c64a2fa5b772c8172117d25a9ff1b4d1478',
          file_name:
            'videos/ce6d7562b1dac1eefa20450bb0551c64a2fa5b772c8172117d25a9ff1b4d1478.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ce6d7562b1dac1eefa20450bb0551c64a2fa5b772c8172117d25a9ff1b4d1478.mp4',
          name: 'BEG-Modified_Side_Plank_Crunches-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 73481,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2150,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '67d140c587eb77c1d13e18d35813dbaafbbc63258eaef8eaeff994b2a9247cf9',
          file_name:
            'audios/67d140c587eb77c1d13e18d35813dbaafbbc63258eaef8eaeff994b2a9247cf9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/67d140c587eb77c1d13e18d35813dbaafbbc63258eaef8eaeff994b2a9247cf9.mp3',
          name: 'BEG-Modified_Side_Plank_Crunches-EXERCISE',
          description: null,
          size: 41172,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-REVERSE_CRUNCH_W_LEGS_IN_OUT-EXERCISE': {
      id: 815,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Reverse Crunch with Legs In Out',
      short_name: 'Reverse Crunch w Legs In Out',
      unique_name: 'INTERMEDIATE-REVERSE_CRUNCH_W_LEGS_IN_OUT-EXERCISE',
      description:
        '1. Lie on your back. Place your arms by your sides, palms facing down. Raise both legs straight up over your hips.\r\n2. Lift your hips off the floor and raise your feet straight up to the ceiling.\r\n3. Lower your hips back down, then drop both legs toward the floor to a hover. Open your legs to a wide "V" and then close.\r\n4. Raise both legs back up to starting position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2151,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '213a440b9addf62cc897869ef7bceab00f7a2b7bf894575732301edf59aa6fae',
          file_name:
            'videos/213a440b9addf62cc897869ef7bceab00f7a2b7bf894575732301edf59aa6fae.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/213a440b9addf62cc897869ef7bceab00f7a2b7bf894575732301edf59aa6fae.mp4',
          name: 'INT-ADV-Reverse_Crunch_w_legs_in_out-EXERCISE',
          description: null,
          size: 111197,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2152,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'fb9f7f0a48f477c68b8de68ec01e438699f5b6e37d5852091a5cc9523d620c39',
          file_name:
            'audios/fb9f7f0a48f477c68b8de68ec01e438699f5b6e37d5852091a5cc9523d620c39.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fb9f7f0a48f477c68b8de68ec01e438699f5b6e37d5852091a5cc9523d620c39.mp3',
          name: 'INT-ADV-Reverse_Crunch_w_legs_in_out-EXERCISE',
          description: null,
          size: 37723,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-REVERSE_CRUNCH_W_LEGS_IN_OUT-EXERCISE': {
      id: 816,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Reverse Crunch with Legs In Out',
      short_name: 'Reverse Crunch w Legs In Out',
      unique_name: 'ADVANCED-REVERSE_CRUNCH_W_LEGS_IN_OUT-EXERCISE',
      description:
        '1. Lie on your back. Place your arms by your sides, palms facing down. Raise both legs straight up over your hips.\r\n2. Lift your hips off the floor and raise your feet straight up to the ceiling.\r\n3. Lower your hips back down, then drop both legs toward the floor to a hover. Open your legs to a wide "V" and then close.\r\n4. Raise both legs back up to starting position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2153,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '213a440b9addf62cc897869ef7bceab00f7a2b7bf894575732301edf59aa6fae',
          file_name:
            'videos/213a440b9addf62cc897869ef7bceab00f7a2b7bf894575732301edf59aa6fae.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/213a440b9addf62cc897869ef7bceab00f7a2b7bf894575732301edf59aa6fae.mp4',
          name: 'INT-ADV-Reverse_Crunch_w_legs_in_out-EXERCISE',
          description: null,
          size: 111197,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2154,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'fb9f7f0a48f477c68b8de68ec01e438699f5b6e37d5852091a5cc9523d620c39',
          file_name:
            'audios/fb9f7f0a48f477c68b8de68ec01e438699f5b6e37d5852091a5cc9523d620c39.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fb9f7f0a48f477c68b8de68ec01e438699f5b6e37d5852091a5cc9523d620c39.mp3',
          name: 'INT-ADV-Reverse_Crunch_w_legs_in_out-EXERCISE',
          description: null,
          size: 37723,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ALTERNATING_SIDE_BENDS_W_REACH-EXERCISE': {
      id: 817,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Alternating Side Bends with Reach',
      short_name: 'Alternating Side Bends w Reach',
      unique_name: 'BEGINNER-ALTERNATING_SIDE_BENDS_W_REACH-EXERCISE',
      description:
        '1. Stand tall with your feet shoulder-width apart.\n2. Reach one arm overhead and lean over to feel the stretch in your side. Reach the other arm toward the opposite hip. Keep hips and shoulders square as you hold this position.\n3. Repeat other side.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2155,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'e0a659b36d9dbf91be3444fe8cc8ff435c7bcc8c3ac4678268e515b0b4a263a2',
          file_name:
            'videos/e0a659b36d9dbf91be3444fe8cc8ff435c7bcc8c3ac4678268e515b0b4a263a2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e0a659b36d9dbf91be3444fe8cc8ff435c7bcc8c3ac4678268e515b0b4a263a2.mp4',
          name: 'FSTEP-BEG-Alternating_Side_Bends_w_Reach-EXERCISE',
          description: null,
          size: 118688,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2156,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'b7cf27544076ad0ae40ce2740c5e60ef4780ae1917dcc73b7355ca3e9b1c46a8',
          file_name:
            'audios/b7cf27544076ad0ae40ce2740c5e60ef4780ae1917dcc73b7355ca3e9b1c46a8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b7cf27544076ad0ae40ce2740c5e60ef4780ae1917dcc73b7355ca3e9b1c46a8.mp3',
          name: 'FSTEP-BEG-Alternating_Side_Bends_w_Reach-EXERCISE',
          description: null,
          size: 36470,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-PLANK_KNEE_DROPS-EXERCISE': {
      id: 821,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Plank Knee Drops',
      short_name: 'Plank Knee Drops',
      unique_name: 'BEGINNER-PLANK_KNEE_DROPS-EXERCISE',
      description:
        '1. Start in Plank position with shoulders over wrists, palms flat and hips square.\n2. Maintaining a long spine, engage your core and drop both knees down toward the floor.\n3. Push through your heels to extend your legs and return to Plank. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2163,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '974a0dcb27709e5aead3a142d3226857e14c586569fdc3b5d630ef8f53770d90',
          file_name:
            'videos/974a0dcb27709e5aead3a142d3226857e14c586569fdc3b5d630ef8f53770d90.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/974a0dcb27709e5aead3a142d3226857e14c586569fdc3b5d630ef8f53770d90.mp4',
          name: 'BEG-INT-ADV-Plank_Knee_Drops-EXERCISE',
          description: null,
          size: 51099,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2164,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'd044654932ed213c44b1141d0b8aee4afd852a9302cddb6954bf27ec4433826f',
          file_name:
            'audios/d044654932ed213c44b1141d0b8aee4afd852a9302cddb6954bf27ec4433826f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d044654932ed213c44b1141d0b8aee4afd852a9302cddb6954bf27ec4433826f.mp3',
          name: 'BEG-INT-ADV-Plank_Knee_Drops-EXERCISE',
          description: null,
          size: 27694,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PLANK_KNEE_DROPS-EXERCISE': {
      id: 822,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Plank Knee Drops',
      short_name: 'Plank Knee Drops',
      unique_name: 'INTERMEDIATE-PLANK_KNEE_DROPS-EXERCISE',
      description:
        '1. Start in Plank position with shoulders over wrists, palms flat and hips square.\n2. Maintaining a long spine, engage your core and drop both knees down toward the floor.\n3. Push through your heels to extend your legs and return to Plank. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2165,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '974a0dcb27709e5aead3a142d3226857e14c586569fdc3b5d630ef8f53770d90',
          file_name:
            'videos/974a0dcb27709e5aead3a142d3226857e14c586569fdc3b5d630ef8f53770d90.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/974a0dcb27709e5aead3a142d3226857e14c586569fdc3b5d630ef8f53770d90.mp4',
          name: 'BEG-INT-ADV-Plank_Knee_Drops-EXERCISE',
          description: null,
          size: 51099,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2166,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'd044654932ed213c44b1141d0b8aee4afd852a9302cddb6954bf27ec4433826f',
          file_name:
            'audios/d044654932ed213c44b1141d0b8aee4afd852a9302cddb6954bf27ec4433826f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d044654932ed213c44b1141d0b8aee4afd852a9302cddb6954bf27ec4433826f.mp3',
          name: 'BEG-INT-ADV-Plank_Knee_Drops-EXERCISE',
          description: null,
          size: 27694,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PLANK_KNEE_DROPS-EXERCISE': {
      id: 823,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Plank Knee Drops',
      short_name: 'Plank Knee Drops',
      unique_name: 'ADVANCED-PLANK_KNEE_DROPS-EXERCISE',
      description:
        '1. Start in Plank position with shoulders over wrists, palms flat and hips square.\n2. Maintaining a long spine, engage your core and drop both knees down toward the floor.\n3. Push through your heels to extend your legs and return to Plank. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2167,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '974a0dcb27709e5aead3a142d3226857e14c586569fdc3b5d630ef8f53770d90',
          file_name:
            'videos/974a0dcb27709e5aead3a142d3226857e14c586569fdc3b5d630ef8f53770d90.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/974a0dcb27709e5aead3a142d3226857e14c586569fdc3b5d630ef8f53770d90.mp4',
          name: 'BEG-INT-ADV-Plank_Knee_Drops-EXERCISE',
          description: null,
          size: 51099,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2168,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'd044654932ed213c44b1141d0b8aee4afd852a9302cddb6954bf27ec4433826f',
          file_name:
            'audios/d044654932ed213c44b1141d0b8aee4afd852a9302cddb6954bf27ec4433826f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d044654932ed213c44b1141d0b8aee4afd852a9302cddb6954bf27ec4433826f.mp3',
          name: 'BEG-INT-ADV-Plank_Knee_Drops-EXERCISE',
          description: null,
          size: 27694,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-FOREARM_PLANK_KNEE_DROPS-EXERCISE': {
      id: 824,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Forearm Plank Knee Drops',
      short_name: 'Forearm Plank Knee Drops',
      unique_name: 'BEGINNER-FOREARM_PLANK_KNEE_DROPS-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat and hips square.\n2. Maintaining a long spine, engage your core and drop both knees down toward the floor.\n3. Push through your heels to extend your legs and return to Forearm Plank. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2169,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '7436d08cb5d59368511e365146957ff33fa263d8e54e3965a88cd0370b9d7e3a',
          file_name:
            'videos/7436d08cb5d59368511e365146957ff33fa263d8e54e3965a88cd0370b9d7e3a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7436d08cb5d59368511e365146957ff33fa263d8e54e3965a88cd0370b9d7e3a.mp4',
          name: 'BEG-INT-ADV-Forearm_Plank_Knee_Drops-EXERCISE',
          description: null,
          size: 42306,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2170,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '39bbb9816393de6b354a3dd7aa7e9ae8919f53756f098544c3e2aad7c34204f3',
          file_name:
            'audios/39bbb9816393de6b354a3dd7aa7e9ae8919f53756f098544c3e2aad7c34204f3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/39bbb9816393de6b354a3dd7aa7e9ae8919f53756f098544c3e2aad7c34204f3.mp3',
          name: 'BEG-INT-ADV-Forearm_Plank_Knee_Drops-EXERCISE',
          description: null,
          size: 34591,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-FOREARM_PLANK_KNEE_DROPS-EXERCISE': {
      id: 825,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Forearm Plank Knee Drops',
      short_name: 'Forearm Plank Knee Drops',
      unique_name: 'INTERMEDIATE-FOREARM_PLANK_KNEE_DROPS-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat and hips square.\n2. Maintaining a long spine, engage your core and drop both knees down toward the floor.\n3. Push through your heels to extend your legs and return to Forearm Plank. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2171,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '7436d08cb5d59368511e365146957ff33fa263d8e54e3965a88cd0370b9d7e3a',
          file_name:
            'videos/7436d08cb5d59368511e365146957ff33fa263d8e54e3965a88cd0370b9d7e3a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7436d08cb5d59368511e365146957ff33fa263d8e54e3965a88cd0370b9d7e3a.mp4',
          name: 'BEG-INT-ADV-Forearm_Plank_Knee_Drops-EXERCISE',
          description: null,
          size: 42306,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2172,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '39bbb9816393de6b354a3dd7aa7e9ae8919f53756f098544c3e2aad7c34204f3',
          file_name:
            'audios/39bbb9816393de6b354a3dd7aa7e9ae8919f53756f098544c3e2aad7c34204f3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/39bbb9816393de6b354a3dd7aa7e9ae8919f53756f098544c3e2aad7c34204f3.mp3',
          name: 'BEG-INT-ADV-Forearm_Plank_Knee_Drops-EXERCISE',
          description: null,
          size: 34591,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-FOREARM_PLANK_KNEE_DROPS-EXERCISE': {
      id: 826,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Forearm Plank Knee Drops',
      short_name: 'Forearm Plank Knee Drops',
      unique_name: 'ADVANCED-FOREARM_PLANK_KNEE_DROPS-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat and hips square.\n2. Maintaining a long spine, engage your core and drop both knees down toward the floor.\n3. Push through your heels to extend your legs and return to Forearm Plank. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2173,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '7436d08cb5d59368511e365146957ff33fa263d8e54e3965a88cd0370b9d7e3a',
          file_name:
            'videos/7436d08cb5d59368511e365146957ff33fa263d8e54e3965a88cd0370b9d7e3a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7436d08cb5d59368511e365146957ff33fa263d8e54e3965a88cd0370b9d7e3a.mp4',
          name: 'BEG-INT-ADV-Forearm_Plank_Knee_Drops-EXERCISE',
          description: null,
          size: 42306,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2174,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '39bbb9816393de6b354a3dd7aa7e9ae8919f53756f098544c3e2aad7c34204f3',
          file_name:
            'audios/39bbb9816393de6b354a3dd7aa7e9ae8919f53756f098544c3e2aad7c34204f3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/39bbb9816393de6b354a3dd7aa7e9ae8919f53756f098544c3e2aad7c34204f3.mp3',
          name: 'BEG-INT-ADV-Forearm_Plank_Knee_Drops-EXERCISE',
          description: null,
          size: 34591,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-FOREARM_PLANK_REACH_THROUGH-EXERCISE': {
      id: 827,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Forearm Plank Reach Through ',
      short_name: 'Forearm Plank Reach Through ',
      unique_name: 'INTERMEDIATE-FOREARM_PLANK_REACH_THROUGH-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat.\n2. Thread one arm across your chest and underneath the opposite shoulder. Reach as far as you can, rotating your upper body. Look toward your hand.\n3. Unwind and reach your arm up and gaze to the ceiling, rolling to the sides of your feet to staggered Forearm Side Plank.\n4. Perform all reps one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2175,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '5b4a524f859a7a38f49a30337453e6198e253b70adc281d7f06ca7d007f659cd',
          file_name:
            'videos/5b4a524f859a7a38f49a30337453e6198e253b70adc281d7f06ca7d007f659cd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5b4a524f859a7a38f49a30337453e6198e253b70adc281d7f06ca7d007f659cd.mp4',
          name: 'INT-ADV-Forearm_Plank_Reach_Through-EXERCISE-LEFT',
          description: 'Left Side',
          size: 100480,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2176,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: 'c22b3ca93e359735c1861e72a07d036ed76b41aa2a9624a580ef394ebbec7911',
          file_name:
            'videos/c22b3ca93e359735c1861e72a07d036ed76b41aa2a9624a580ef394ebbec7911.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c22b3ca93e359735c1861e72a07d036ed76b41aa2a9624a580ef394ebbec7911.mp4',
          name: 'INT-ADV-Forearm_Plank_Reach_Through-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 100630,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2177,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '17c098817d852c63e0a86b189c2d4926883895f1b67495cc41f29aa601521813',
          file_name:
            'audios/17c098817d852c63e0a86b189c2d4926883895f1b67495cc41f29aa601521813.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/17c098817d852c63e0a86b189c2d4926883895f1b67495cc41f29aa601521813.mp3',
          name: 'INT-ADV-Forearm_Plank_Reach_Through-EXERCISE',
          description: null,
          size: 33337,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-FOREARM_PLANK_REACH_THROUGH-EXERCISE': {
      id: 828,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Forearm Plank Reach Through ',
      short_name: 'Forearm Plank Reach Through ',
      unique_name: 'ADVANCED-FOREARM_PLANK_REACH_THROUGH-EXERCISE',
      description:
        '1. Start in Forearm Plank with elbows under shoulders, palms flat.\n2. Thread one arm across your chest and underneath the opposite shoulder. Reach as far as you can, rotating your upper body. Look toward your hand.\n3. Unwind and reach your arm up and gaze to the ceiling, rolling to the sides of your feet to staggered Forearm Side Plank.\n4. Perform all reps one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2178,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '5b4a524f859a7a38f49a30337453e6198e253b70adc281d7f06ca7d007f659cd',
          file_name:
            'videos/5b4a524f859a7a38f49a30337453e6198e253b70adc281d7f06ca7d007f659cd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5b4a524f859a7a38f49a30337453e6198e253b70adc281d7f06ca7d007f659cd.mp4',
          name: 'INT-ADV-Forearm_Plank_Reach_Through-EXERCISE-LEFT',
          description: 'Left Side',
          size: 100480,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2179,
          collection_name: 'videos',
          order: 2,
          version: 200060000,
          hash: 'c22b3ca93e359735c1861e72a07d036ed76b41aa2a9624a580ef394ebbec7911',
          file_name:
            'videos/c22b3ca93e359735c1861e72a07d036ed76b41aa2a9624a580ef394ebbec7911.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c22b3ca93e359735c1861e72a07d036ed76b41aa2a9624a580ef394ebbec7911.mp4',
          name: 'INT-ADV-Forearm_Plank_Reach_Through-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 100630,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2180,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '17c098817d852c63e0a86b189c2d4926883895f1b67495cc41f29aa601521813',
          file_name:
            'audios/17c098817d852c63e0a86b189c2d4926883895f1b67495cc41f29aa601521813.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/17c098817d852c63e0a86b189c2d4926883895f1b67495cc41f29aa601521813.mp3',
          name: 'INT-ADV-Forearm_Plank_Reach_Through-EXERCISE',
          description: null,
          size: 33337,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SQUAT_WITH_ALTERNATING_KNEE-EXERCISE': {
      id: 832,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Squats with Alternating Knee',
      short_name: 'Squat with Alternating Knee',
      unique_name: 'BEGINNER-SQUAT_WITH_ALTERNATING_KNEE-EXERCISE',
      description:
        '1. Start standing with your feet roughly shoulder-width apart.\n2. Keeping your chest up, drive your hips back and bend your knees to squat down as low as you can.\n3. As you come up, transfer all your weight onto one leg and bring your other knee up to hip height.\n4. Lower your leg, squat again and repeat with the other leg.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2187,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '8f1eded0f29ebfcca335ba0963559c7feb855a3f8e992e6e684c5914d8fb99cb',
          file_name:
            'videos/8f1eded0f29ebfcca335ba0963559c7feb855a3f8e992e6e684c5914d8fb99cb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8f1eded0f29ebfcca335ba0963559c7feb855a3f8e992e6e684c5914d8fb99cb.mp4',
          name: 'FSTEP-BEG-Squat_with_Alternating_Knee-EXERCISE',
          description: null,
          size: 133844,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2560,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '3c58f7672452e9620c7075f2d4d3844a52c4d1841b894ea4a4b40fd8ddb8d007',
          file_name:
            'audios/3c58f7672452e9620c7075f2d4d3844a52c4d1841b894ea4a4b40fd8ddb8d007.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3c58f7672452e9620c7075f2d4d3844a52c4d1841b894ea4a4b40fd8ddb8d007.mp3',
          name: 'BEGINNER-Squats_with_Alternating_Knee-EXERCISE',
          description: null,
          size: 32841,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-YS-EXERCISE': {
      id: 833,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Ys',
      short_name: 'Ys',
      unique_name: 'INTERMEDIATE-YS-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, knees slightly bent.\n2. Hinge at the waist until your torso is close to parallel to the floor. Arms extended down with a dumbbell in each hand.\n3. Raise both arms up and out to a "Y" shape, biceps in line with ears, fists face each other. Avoid shrugging, keeping space between your shoulders and ears.\n4. Lower your arms back to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2189,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '62ac8fd7a417548627487b643fafb391dfc6bae30406d93c553998aeb296989c',
          file_name:
            'videos/62ac8fd7a417548627487b643fafb391dfc6bae30406d93c553998aeb296989c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/62ac8fd7a417548627487b643fafb391dfc6bae30406d93c553998aeb296989c.mp4',
          name: 'INT-ADV-Ys-EXERCISE',
          description: null,
          size: 69836,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2190,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '9e3feb43a8f5a2bcd7094896a7520f412d019a50144c5b0d52c0b5a7175609d1',
          file_name:
            'audios/9e3feb43a8f5a2bcd7094896a7520f412d019a50144c5b0d52c0b5a7175609d1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9e3feb43a8f5a2bcd7094896a7520f412d019a50144c5b0d52c0b5a7175609d1.mp3',
          name: 'INT-ADV-Ys-EXERCISE',
          description: null,
          size: 20798,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-YS-EXERCISE': {
      id: 834,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Ys',
      short_name: 'Ys',
      unique_name: 'ADVANCED-YS-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, knees slightly bent.\n2. Hinge at the waist until your torso is close to parallel to the floor. Arms extended down with a dumbbell in each hand.\n3. Raise both arms up and out to a "Y" shape, biceps in line with ears, fists face each other. Avoid shrugging, keeping space between your shoulders and ears.\n4. Lower your arms back to start position.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2191,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '62ac8fd7a417548627487b643fafb391dfc6bae30406d93c553998aeb296989c',
          file_name:
            'videos/62ac8fd7a417548627487b643fafb391dfc6bae30406d93c553998aeb296989c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/62ac8fd7a417548627487b643fafb391dfc6bae30406d93c553998aeb296989c.mp4',
          name: 'INT-ADV-Ys-EXERCISE',
          description: null,
          size: 69836,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2192,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '9e3feb43a8f5a2bcd7094896a7520f412d019a50144c5b0d52c0b5a7175609d1',
          file_name:
            'audios/9e3feb43a8f5a2bcd7094896a7520f412d019a50144c5b0d52c0b5a7175609d1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9e3feb43a8f5a2bcd7094896a7520f412d019a50144c5b0d52c0b5a7175609d1.mp3',
          name: 'INT-ADV-Ys-EXERCISE',
          description: null,
          size: 20798,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-WS-EXERCISE': {
      id: 835,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Ws',
      short_name: 'Ws',
      unique_name: 'INTERMEDIATE-WS-EXERCISE',
      description:
        '1. Stand feet shoulder-width apart, knees slightly bent.\n2. Hinge at the waist until torso is close to parallel to floor. Arms extended down with a dumbbell in each hand, palms face back.\n3. Squeeze shoulder blades together and row dumbbells up, keeping elbows wide and in line with shoulders.\n4. Rotate shoulders and raise dumbbells toward your head, keeping elbows wide.\n5. Lower dumbbells back down to a wide row. Straighten arms and return to start.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2193,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '06dd6a0cf064aeb0b52d5ecd42d477395c862b82e3cc915a2318c71508cc3686',
          file_name:
            'videos/06dd6a0cf064aeb0b52d5ecd42d477395c862b82e3cc915a2318c71508cc3686.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/06dd6a0cf064aeb0b52d5ecd42d477395c862b82e3cc915a2318c71508cc3686.mp4',
          name: 'INT-ADV-Ws-EXERCISE',
          description: null,
          size: 117543,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2194,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'c881d34697d1a25b2f33a777964c6e0c8796c2d51092abce7e28dabe4f4376fd',
          file_name:
            'audios/c881d34697d1a25b2f33a777964c6e0c8796c2d51092abce7e28dabe4f4376fd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c881d34697d1a25b2f33a777964c6e0c8796c2d51092abce7e28dabe4f4376fd.mp3',
          name: 'INT-ADV-Ws-EXERCISE',
          description: null,
          size: 24560,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-WS-EXERCISE': {
      id: 836,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Ws',
      short_name: 'Ws',
      unique_name: 'ADVANCED-WS-EXERCISE',
      description:
        '1. Stand feet shoulder-width apart, knees slightly bent.\n2. Hinge at the waist until torso is close to parallel to floor. Arms extended down with a dumbbell in each hand, palms face back.\n3. Squeeze shoulder blades together and row dumbbells up, keeping elbows wide and in line with shoulders.\n4. Rotate shoulders and raise dumbbells toward your head, keeping elbows wide.\n5. Lower dumbbells back down to a wide row. Straighten arms and return to start.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2195,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '06dd6a0cf064aeb0b52d5ecd42d477395c862b82e3cc915a2318c71508cc3686',
          file_name:
            'videos/06dd6a0cf064aeb0b52d5ecd42d477395c862b82e3cc915a2318c71508cc3686.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/06dd6a0cf064aeb0b52d5ecd42d477395c862b82e3cc915a2318c71508cc3686.mp4',
          name: 'INT-ADV-Ws-EXERCISE',
          description: null,
          size: 117543,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2196,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'c881d34697d1a25b2f33a777964c6e0c8796c2d51092abce7e28dabe4f4376fd',
          file_name:
            'audios/c881d34697d1a25b2f33a777964c6e0c8796c2d51092abce7e28dabe4f4376fd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c881d34697d1a25b2f33a777964c6e0c8796c2d51092abce7e28dabe4f4376fd.mp3',
          name: 'INT-ADV-Ws-EXERCISE',
          description: null,
          size: 24560,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-Y_T_WS-EXERCISE': {
      id: 837,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'YTWs ',
      short_name: 'YTWs ',
      unique_name: 'INTERMEDIATE-Y_T_WS-EXERCISE',
      description:
        '1. Stand feet shoulder-width apart, knees slightly bent.\n2. Hinge at the waist until torso is close to parallel to the floor. Arms extended down with a dumbbell in each hand.\n3. Raise both arms up and out to a "Y" fists face each other. Lower arms down.\n4. Raise both arms out to your sides in a "T". Lower arms down.\n5. Perform a wide row. Hold at the top and rotate shoulders to raise dumbbells toward your head.\n6. Lower arms back to a wide row. Straighten arms to return to start. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2197,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f8815392006fe32af04e5c03839adffe59d492ab1ed01fe57fd8b387864e2dc5',
          file_name:
            'videos/f8815392006fe32af04e5c03839adffe59d492ab1ed01fe57fd8b387864e2dc5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f8815392006fe32af04e5c03839adffe59d492ab1ed01fe57fd8b387864e2dc5.mp4',
          name: 'INT-ADV-YTWs-EXERCISE',
          description: null,
          size: 222510,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2198,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '13535d45baa06b030d06f0dc2c00c537f03ce1b9a56ed25e9d6cb6700e4c58ff',
          file_name:
            'audios/13535d45baa06b030d06f0dc2c00c537f03ce1b9a56ed25e9d6cb6700e4c58ff.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/13535d45baa06b030d06f0dc2c00c537f03ce1b9a56ed25e9d6cb6700e4c58ff.mp3',
          name: 'INT-ADV-YTWs-EXERCISE',
          description: null,
          size: 30513,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-Y_T_WS-EXERCISE': {
      id: 838,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'YTWs ',
      short_name: 'YTWs ',
      unique_name: 'ADVANCED-Y_T_WS-EXERCISE',
      description:
        '1. Stand feet shoulder-width apart, knees slightly bent.\n2. Hinge at the waist until torso is close to parallel to the floor. Arms extended down with a dumbbell in each hand.\n3. Raise both arms up and out to a "Y" fists face each other. Lower arms down.\n4. Raise both arms out to your sides in a "T". Lower arms down.\n5. Perform a wide row. Hold at the top and rotate shoulders to raise dumbbells toward your head.\n6. Lower arms back to a wide row. Straighten arms to return to start. ',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2199,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f8815392006fe32af04e5c03839adffe59d492ab1ed01fe57fd8b387864e2dc5',
          file_name:
            'videos/f8815392006fe32af04e5c03839adffe59d492ab1ed01fe57fd8b387864e2dc5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f8815392006fe32af04e5c03839adffe59d492ab1ed01fe57fd8b387864e2dc5.mp4',
          name: 'INT-ADV-YTWs-EXERCISE',
          description: null,
          size: 222510,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2200,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '13535d45baa06b030d06f0dc2c00c537f03ce1b9a56ed25e9d6cb6700e4c58ff',
          file_name:
            'audios/13535d45baa06b030d06f0dc2c00c537f03ce1b9a56ed25e9d6cb6700e4c58ff.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/13535d45baa06b030d06f0dc2c00c537f03ce1b9a56ed25e9d6cb6700e4c58ff.mp3',
          name: 'INT-ADV-YTWs-EXERCISE',
          description: null,
          size: 30513,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-MODIFIED_WINDSHIELD_WIPERS-EXERCISE': {
      id: 842,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Modified Windshield Wipers',
      short_name: 'Modified Windshield Wipers',
      unique_name: 'BEGINNER-MODIFIED_WINDSHIELD_WIPERS-EXERCISE',
      description:
        '1. Lie on your back with arms out to a "T", palms flat. Bend both knees and raise them directly over hips, feet in line with knees.\n2. Keeping shins at a right angle, rotate your hips and lower both knees to one side as close to the floor as possible without touching. Keep shoulders square and upper back on floor.\n3. Raise your knees up to start and drop to opposite side.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 2,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2207,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '23a609670053a77365c94546b117e32f3c3e8966aa35b4b4c7a021096623b13c',
          file_name:
            'videos/23a609670053a77365c94546b117e32f3c3e8966aa35b4b4c7a021096623b13c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/23a609670053a77365c94546b117e32f3c3e8966aa35b4b4c7a021096623b13c.mp4',
          name: 'BEGINNER-Modified_Windshield_Wipers-EXERCISE',
          description: null,
          size: 150276,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2208,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'da3e42de0b974a2962d786bc638a9dc24748a68176e55e6bd066634fc6d06188',
          file_name:
            'audios/da3e42de0b974a2962d786bc638a9dc24748a68176e55e6bd066634fc6d06188.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/da3e42de0b974a2962d786bc638a9dc24748a68176e55e6bd066634fc6d06188.mp3',
          name: 'BEGINNER-Modified_Windshield_Wipers-EXERCISE',
          description: null,
          size: 31529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-STRAIGHT_ARM_KICKBACK_PULSE-EXERCISE': {
      id: 843,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Straight Arm Kickback Pulse',
      short_name: 'Straight Arm Kickback Pulse',
      unique_name: 'BEGINNER-STRAIGHT_ARM_KICKBACK_PULSE-EXERCISE',
      description:
        '1. Stand feet shoulder-width apart, knees slightly bent. Holding your fists by your sides, hinge at the waist until your torso is close to parallel to the floor. Lift your fists back behind you to hip height and rotate fists toward the ceiling.\n2. Keeping arms straight, quickly lift both fists up toward the ceiling and lower back down to hip height.\n3. Pulse in a continuous motion.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2209,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '83472d127a3cb1c67c68d09d94c917d83c8194f30a3270dbd55e618db3ef48ae',
          file_name:
            'videos/83472d127a3cb1c67c68d09d94c917d83c8194f30a3270dbd55e618db3ef48ae.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/83472d127a3cb1c67c68d09d94c917d83c8194f30a3270dbd55e618db3ef48ae.mp4',
          name: 'BEGINNER-Straight_Arm_Kickback_Pulse-EXERCISE',
          description: null,
          size: 34651,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2210,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'a7d6f5e56b9d9ff64a2d354fdbec78a832a2c87abcef054d1928ff392b23c779',
          file_name:
            'audios/a7d6f5e56b9d9ff64a2d354fdbec78a832a2c87abcef054d1928ff392b23c779.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a7d6f5e56b9d9ff64a2d354fdbec78a832a2c87abcef054d1928ff392b23c779.mp3',
          name: 'BEGINNER-Straight_Arm_Kickback_Pulse-EXERCISE',
          description: null,
          size: 30990,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-STANDING_STRAIGHT_LEG_GLUTE_LIFTS-EXERCISE': {
      id: 846,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Standing Straight Leg Glute Lifts',
      short_name: 'Standing Leg Glute Lifts',
      unique_name: 'BEGINNER-STANDING_STRAIGHT_LEG_GLUTE_LIFTS-EXERCISE',
      description:
        '1. Stand with your feet in a close stance, place hands on your hips or hold onto a chair or wall for assistance.\n2. Keeping core tight, hips square and thighs parallel, lift one leg straight back behind you, toes point toward the floor. Squeeze glutes at the top. Do not arch your lower back.\n3. Return to start position. Perform all reps on one leg. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2215,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '1802fafcd437dade4ef333db383cb2a193306473161dd4a32a83010c3dcaadc7',
          file_name:
            'videos/1802fafcd437dade4ef333db383cb2a193306473161dd4a32a83010c3dcaadc7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1802fafcd437dade4ef333db383cb2a193306473161dd4a32a83010c3dcaadc7.mp4',
          name: 'BEGINNER-Standing_Straight_Leg_Glute_Lifts-EXERCISE-LEFT',
          description: 'Left Side',
          size: 42845,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2216,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: '53f953cdec16b6404a36a84de5dc3f42852a273b7244e6f687de7cbf2c4839e5',
          file_name:
            'videos/53f953cdec16b6404a36a84de5dc3f42852a273b7244e6f687de7cbf2c4839e5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/53f953cdec16b6404a36a84de5dc3f42852a273b7244e6f687de7cbf2c4839e5.mp4',
          name: 'BEGINNER-Standing_Straight_Leg_Glute_Lifts-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 41809,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2217,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'd05e7efd52b26ce49ea2cf47d1cc29521d792db16a3f535ebbc642c3d94d0add',
          file_name:
            'audios/d05e7efd52b26ce49ea2cf47d1cc29521d792db16a3f535ebbc642c3d94d0add.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d05e7efd52b26ce49ea2cf47d1cc29521d792db16a3f535ebbc642c3d94d0add.mp3',
          name: 'BEGINNER-Standing_Straight_Leg_Glute_Lifts-EXERCISE',
          description: null,
          size: 34247,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_CHERRY_PICKERS-EXERCISE': {
      id: 847,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Cherry Pickers',
      short_name: 'Kettlebell Cherry Pickers',
      unique_name: 'INTERMEDIATE-KETTLEBELL_CHERRY_PICKERS-EXERCISE',
      description:
        '1. Start with your feet hip-width apart, knees slightly bent. Hold a kettlebell in both hands in front of your hips, chest up and core tight.\n2. Hinge at waist and slide hips back as you lower the bell to touch the floor in front of your toes.\n3. With a flat back, raise body up halfway and then lower down, touching the bell on the floor between your feet.\n4. Stand using hamstrings and squeeze at the top.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2218,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '63d9537c6828e52890f93f9866f62414dae32171a04266c7d6703bcd990f15de',
          file_name:
            'videos/63d9537c6828e52890f93f9866f62414dae32171a04266c7d6703bcd990f15de.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/63d9537c6828e52890f93f9866f62414dae32171a04266c7d6703bcd990f15de.mp4',
          name: 'INT-ADV-Kettlebell_Cherry_Pickers-EXERCISE',
          description: null,
          size: 91642,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2219,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '89b41f87dd8bbd5e36e0c9ab0cb3ef76e0d8ed72b0609778b130354df7f8c5d8',
          file_name:
            'audios/89b41f87dd8bbd5e36e0c9ab0cb3ef76e0d8ed72b0609778b130354df7f8c5d8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/89b41f87dd8bbd5e36e0c9ab0cb3ef76e0d8ed72b0609778b130354df7f8c5d8.mp3',
          name: 'INT-ADV-Kettlebell_Cherry_Pickers-EXERCISE',
          description: null,
          size: 31601,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_CHERRY_PICKERS-EXERCISE': {
      id: 848,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Cherry Pickers',
      short_name: 'Kettlebell Cherry Pickers',
      unique_name: 'ADVANCED-KETTLEBELL_CHERRY_PICKERS-EXERCISE',
      description:
        '1. Start with your feet hip-width apart, knees slightly bent. Hold a kettlebell in both hands in front of your hips, chest up and core tight.\n2. Hinge at waist and slide hips back as you lower the bell to touch the floor in front of your toes.\n3. With a flat back, raise body up halfway and then lower down, touching the bell on the floor between your feet.\n4. Stand using hamstrings and squeeze at the top.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2220,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '63d9537c6828e52890f93f9866f62414dae32171a04266c7d6703bcd990f15de',
          file_name:
            'videos/63d9537c6828e52890f93f9866f62414dae32171a04266c7d6703bcd990f15de.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/63d9537c6828e52890f93f9866f62414dae32171a04266c7d6703bcd990f15de.mp4',
          name: 'INT-ADV-Kettlebell_Cherry_Pickers-EXERCISE',
          description: null,
          size: 91642,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2221,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '89b41f87dd8bbd5e36e0c9ab0cb3ef76e0d8ed72b0609778b130354df7f8c5d8',
          file_name:
            'audios/89b41f87dd8bbd5e36e0c9ab0cb3ef76e0d8ed72b0609778b130354df7f8c5d8.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/89b41f87dd8bbd5e36e0c9ab0cb3ef76e0d8ed72b0609778b130354df7f8c5d8.mp3',
          name: 'INT-ADV-Kettlebell_Cherry_Pickers-EXERCISE',
          description: null,
          size: 31601,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_LATERAL_BOX_STEP_UPS-EXERCISE': {
      id: 849,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Lateral Box Step Ups',
      short_name: 'Dumbbell Lateral Box Step Ups',
      unique_name: 'INTERMEDIATE-DUMBBELL_LATERAL_BOX_STEP_UPS-EXERCISE',
      description:
        '1. Stand beside the long end of a step holding dumbbells by your sides. Feet close to the step.\n2. Step the inside foot, closest to the step, on top and shift the majority of your weight onto that leg.\n3. Maintaining good posture, drive off the leg on the step to stand fully. Lower back down with the same leg. Do not switch at top.\n4. Perform all reps with one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2222,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '0faf0b965789d5ec539a2a480398c88dd5f328500e2169869a8e76e6c9cbc6ed',
          file_name:
            'videos/0faf0b965789d5ec539a2a480398c88dd5f328500e2169869a8e76e6c9cbc6ed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0faf0b965789d5ec539a2a480398c88dd5f328500e2169869a8e76e6c9cbc6ed.mp4',
          name: 'INT-ADV-Dumbbell_Lateral_Box_Step_Ups-EXERCISE-LEFT',
          description: 'Left Side',
          size: 105134,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2223,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: 'e4b7cc7893dcb21b93309fa4917670c8a5b8965b58951e42c37ca55634414228',
          file_name:
            'videos/e4b7cc7893dcb21b93309fa4917670c8a5b8965b58951e42c37ca55634414228.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e4b7cc7893dcb21b93309fa4917670c8a5b8965b58951e42c37ca55634414228.mp4',
          name: 'INT-ADV-Dumbbell_Lateral_Box_Step_Ups-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 106232,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2224,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'cc71f94886d54532207b97d66157838321a6241a3ee7602fb9c80aaffc463d8e',
          file_name:
            'audios/cc71f94886d54532207b97d66157838321a6241a3ee7602fb9c80aaffc463d8e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cc71f94886d54532207b97d66157838321a6241a3ee7602fb9c80aaffc463d8e.mp3',
          name: 'INT-ADV-Dumbbell_Lateral_Box_Step_Ups-EXERCISE',
          description: null,
          size: 37533,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_LATERAL_BOX_STEP_UPS-EXERCISE': {
      id: 850,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Lateral Box Step Ups',
      short_name: 'Dumbbell Lateral Box Step Ups',
      unique_name: 'ADVANCED-DUMBBELL_LATERAL_BOX_STEP_UPS-EXERCISE',
      description:
        '1. Stand beside the long end of a step holding dumbbells by your sides. Feet close to the step.\n2. Step the inside foot, closest to the step, on top and shift the majority of your weight onto that leg.\n3. Maintaining good posture, drive off the leg on the step to stand fully. Lower back down with the same leg. Do not switch at top.\n4. Perform all reps with one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2225,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '0faf0b965789d5ec539a2a480398c88dd5f328500e2169869a8e76e6c9cbc6ed',
          file_name:
            'videos/0faf0b965789d5ec539a2a480398c88dd5f328500e2169869a8e76e6c9cbc6ed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0faf0b965789d5ec539a2a480398c88dd5f328500e2169869a8e76e6c9cbc6ed.mp4',
          name: 'INT-ADV-Dumbbell_Lateral_Box_Step_Ups-EXERCISE-LEFT',
          description: 'Left Side',
          size: 105134,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2226,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: 'e4b7cc7893dcb21b93309fa4917670c8a5b8965b58951e42c37ca55634414228',
          file_name:
            'videos/e4b7cc7893dcb21b93309fa4917670c8a5b8965b58951e42c37ca55634414228.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e4b7cc7893dcb21b93309fa4917670c8a5b8965b58951e42c37ca55634414228.mp4',
          name: 'INT-ADV-Dumbbell_Lateral_Box_Step_Ups-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 106232,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2227,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'cc71f94886d54532207b97d66157838321a6241a3ee7602fb9c80aaffc463d8e',
          file_name:
            'audios/cc71f94886d54532207b97d66157838321a6241a3ee7602fb9c80aaffc463d8e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cc71f94886d54532207b97d66157838321a6241a3ee7602fb9c80aaffc463d8e.mp3',
          name: 'INT-ADV-Dumbbell_Lateral_Box_Step_Ups-EXERCISE',
          description: null,
          size: 37533,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-LATERAL_BOX_STEP_UPS_WITH_KNEE_DRIVE-EXERCISE': {
      id: 851,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Lateral Box Step Ups with Knee Drive',
      short_name: 'Box Step Ups with Knee ',
      unique_name: 'INTERMEDIATE-LATERAL_BOX_STEP_UPS_WITH_KNEE_DRIVE-EXERCISE',
      description:
        '1. Stand beside the long end of a step holding dumbbells by your sides. Feet close to step.\n2. Step the inside foot, closest to step, on top and shift the majority of your weight onto that leg.\n3. Drive off the leg on the step to stand as you drive other knee up parallel to the floor. Lower back down with the same leg. Do not switch at top.\n4. Perform all reps with one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2228,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '6d8ddf2fd3f21c31fec5baf06038ee56006b07366ecdcf8a670c501acb308ba3',
          file_name:
            'videos/6d8ddf2fd3f21c31fec5baf06038ee56006b07366ecdcf8a670c501acb308ba3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6d8ddf2fd3f21c31fec5baf06038ee56006b07366ecdcf8a670c501acb308ba3.mp4',
          name: 'INT-ADV-Lateral_Box_Step_Ups_with_Knee_Drive-EXERCISE-LEFT',
          description: 'Left Side',
          size: 99244,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2229,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: '26d12f454eccfce9218f8948850eb56594a6931f6bc0422bec5fef78606875f2',
          file_name:
            'videos/26d12f454eccfce9218f8948850eb56594a6931f6bc0422bec5fef78606875f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/26d12f454eccfce9218f8948850eb56594a6931f6bc0422bec5fef78606875f2.mp4',
          name: 'INT-ADV-Lateral_Box_Step_Ups_with_Knee_Drive-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 111514,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2230,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '853ae2444e04bf4926d70ff58748e712851b9fa815626f1036c202fb46823a16',
          file_name:
            'audios/853ae2444e04bf4926d70ff58748e712851b9fa815626f1036c202fb46823a16.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/853ae2444e04bf4926d70ff58748e712851b9fa815626f1036c202fb46823a16.mp3',
          name: 'INT-ADV-Lateral_Box_Step_Ups_with_Knee_Drive-EXERCISE',
          description: null,
          size: 41481,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-LATERAL_BOX_STEP_UPS_WITH_KNEE_DRIVE-EXERCISE': {
      id: 852,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Lateral Box Step Ups with Knee Drive',
      short_name: 'Box Step Ups with Knee ',
      unique_name: 'ADVANCED-LATERAL_BOX_STEP_UPS_WITH_KNEE_DRIVE-EXERCISE',
      description:
        '1. Stand beside the long end of a step holding dumbbells by your sides. Feet close to step.\n2. Step the inside foot, closest to step, on top and shift the majority of your weight onto that leg.\n3. Drive off the leg on the step to stand as you drive other knee up parallel to the floor. Lower back down with the same leg. Do not switch at top.\n4. Perform all reps with one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2231,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '6d8ddf2fd3f21c31fec5baf06038ee56006b07366ecdcf8a670c501acb308ba3',
          file_name:
            'videos/6d8ddf2fd3f21c31fec5baf06038ee56006b07366ecdcf8a670c501acb308ba3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6d8ddf2fd3f21c31fec5baf06038ee56006b07366ecdcf8a670c501acb308ba3.mp4',
          name: 'INT-ADV-Lateral_Box_Step_Ups_with_Knee_Drive-EXERCISE-LEFT',
          description: 'Left Side',
          size: 99244,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2232,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: '26d12f454eccfce9218f8948850eb56594a6931f6bc0422bec5fef78606875f2',
          file_name:
            'videos/26d12f454eccfce9218f8948850eb56594a6931f6bc0422bec5fef78606875f2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/26d12f454eccfce9218f8948850eb56594a6931f6bc0422bec5fef78606875f2.mp4',
          name: 'INT-ADV-Lateral_Box_Step_Ups_with_Knee_Drive-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 111514,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2233,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '853ae2444e04bf4926d70ff58748e712851b9fa815626f1036c202fb46823a16',
          file_name:
            'audios/853ae2444e04bf4926d70ff58748e712851b9fa815626f1036c202fb46823a16.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/853ae2444e04bf4926d70ff58748e712851b9fa815626f1036c202fb46823a16.mp3',
          name: 'INT-ADV-Lateral_Box_Step_Ups_with_Knee_Drive-EXERCISE',
          description: null,
          size: 41481,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-EXPLOSIVE_TUCK_JUMPS-EXERCISE': {
      id: 853,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Explosive Tuck Jumps',
      short_name: 'Explosive Tuck Jumps',
      unique_name: 'INTERMEDIATE-EXPLOSIVE_TUCK_JUMPS-EXERCISE',
      description:
        '1. Stand tall with your feet about hip-width apart, chest up and core tight.\n2. Maintaining good posture, bend your knees and swing both arms behind you.\n3. With explosive power, swing your arms in front of you and jump straight up as high as you can, tucking your knees into your chest to tap your hands.\n4. Land softly and repeat.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2234,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '308c19fb6aec6262486586759716ec6a7077b2a1c3704d8ce04f468fa3b386ed',
          file_name:
            'videos/308c19fb6aec6262486586759716ec6a7077b2a1c3704d8ce04f468fa3b386ed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/308c19fb6aec6262486586759716ec6a7077b2a1c3704d8ce04f468fa3b386ed.mp4',
          name: 'INT-ADV-Explosive_Tuck_Jumps-EXERCISE',
          description: null,
          size: 77796,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2235,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'b791fa74482a4c9d05853500d7c68a979a187e3ddd3f9b69a76f1448769376fb',
          file_name:
            'audios/b791fa74482a4c9d05853500d7c68a979a187e3ddd3f9b69a76f1448769376fb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b791fa74482a4c9d05853500d7c68a979a187e3ddd3f9b69a76f1448769376fb.mp3',
          name: 'INT-ADV-Explosive_Tuck_Jumps-EXERCISE',
          description: null,
          size: 34364,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-EXPLOSIVE_TUCK_JUMPS-EXERCISE': {
      id: 854,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Explosive Tuck Jumps',
      short_name: 'Explosive Tuck Jumps',
      unique_name: 'ADVANCED-EXPLOSIVE_TUCK_JUMPS-EXERCISE',
      description:
        '1. Stand tall with your feet about hip-width apart, chest up and core tight.\n2. Maintaining good posture, bend your knees and swing both arms behind you.\n3. With explosive power, swing your arms in front of you and jump straight up as high as you can, tucking your knees into your chest to tap your hands.\n4. Land softly and repeat.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2236,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '308c19fb6aec6262486586759716ec6a7077b2a1c3704d8ce04f468fa3b386ed',
          file_name:
            'videos/308c19fb6aec6262486586759716ec6a7077b2a1c3704d8ce04f468fa3b386ed.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/308c19fb6aec6262486586759716ec6a7077b2a1c3704d8ce04f468fa3b386ed.mp4',
          name: 'INT-ADV-Explosive_Tuck_Jumps-EXERCISE',
          description: null,
          size: 77796,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2237,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'b791fa74482a4c9d05853500d7c68a979a187e3ddd3f9b69a76f1448769376fb',
          file_name:
            'audios/b791fa74482a4c9d05853500d7c68a979a187e3ddd3f9b69a76f1448769376fb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b791fa74482a4c9d05853500d7c68a979a187e3ddd3f9b69a76f1448769376fb.mp3',
          name: 'INT-ADV-Explosive_Tuck_Jumps-EXERCISE',
          description: null,
          size: 34364,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-JUMP_SQUATS-EXERCISE': {
      id: 855,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Jump Squats',
      short_name: 'Jump Squats',
      unique_name: 'INTERMEDIATE-JUMP_SQUATS-EXERCISE',
      description:
        '1. Stand tall with your feet about shoulder-width apart.\n2. Bend your knees and sink your hips back to squat down as low as possible.\n3. From the squat position, jump up as high as you can.\n4. Land softly back into the squat and immediately jump again.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2238,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'da48dc2225f79d9cec49eaf25d3224ecf75f44edbcba7105a19e32666be61fb1',
          file_name:
            'videos/da48dc2225f79d9cec49eaf25d3224ecf75f44edbcba7105a19e32666be61fb1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/da48dc2225f79d9cec49eaf25d3224ecf75f44edbcba7105a19e32666be61fb1.mp4',
          name: 'INT-ADV-Jump_Squats-EXERCISE',
          description: null,
          size: 57325,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2239,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'b2fcbe903bd6996d3f985b77a174c40b4877bd9d830a5d2afd3efac85958fbb7',
          file_name:
            'audios/b2fcbe903bd6996d3f985b77a174c40b4877bd9d830a5d2afd3efac85958fbb7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b2fcbe903bd6996d3f985b77a174c40b4877bd9d830a5d2afd3efac85958fbb7.mp3',
          name: 'INT-ADV-Jump_Squats-EXERCISE',
          description: null,
          size: 24563,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-JUMP_SQUATS-EXERCISE': {
      id: 856,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Jump Squats',
      short_name: 'Jump Squats',
      unique_name: 'ADVANCED-JUMP_SQUATS-EXERCISE',
      description:
        '1. Stand tall with your feet about shoulder-width apart.\n2. Bend your knees and sink your hips back to squat down as low as possible.\n3. From the squat position, jump up as high as you can.\n4. Land softly back into the squat and immediately jump again.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2240,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'da48dc2225f79d9cec49eaf25d3224ecf75f44edbcba7105a19e32666be61fb1',
          file_name:
            'videos/da48dc2225f79d9cec49eaf25d3224ecf75f44edbcba7105a19e32666be61fb1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/da48dc2225f79d9cec49eaf25d3224ecf75f44edbcba7105a19e32666be61fb1.mp4',
          name: 'INT-ADV-Jump_Squats-EXERCISE',
          description: null,
          size: 57325,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2241,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'b2fcbe903bd6996d3f985b77a174c40b4877bd9d830a5d2afd3efac85958fbb7',
          file_name:
            'audios/b2fcbe903bd6996d3f985b77a174c40b4877bd9d830a5d2afd3efac85958fbb7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b2fcbe903bd6996d3f985b77a174c40b4877bd9d830a5d2afd3efac85958fbb7.mp3',
          name: 'INT-ADV-Jump_Squats-EXERCISE',
          description: null,
          size: 24563,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-CURTSY_LUNGES_OVER_STEP-EXERCISE': {
      id: 857,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Curtsy Lunges Over Step',
      short_name: 'Curtsy Lunges Over Step',
      unique_name: 'INTERMEDIATE-CURTSY_LUNGES_OVER_STEP-EXERCISE',
      description:
        '1. Stand in the middle of a step.\n2. Bend knees and step one foot off to the side of the step until toe lightly taps. The majority of weight is on the step.\n3. Drive through the heel on step to stand on one leg, staying as low as possible. Immediately bring the elevated leg back and behind you to tap off step on other side.\n4. Drive through heel on step and repeat. Right and left is one rep.\n5. Perform all reps one side. Repeat with the other side.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2242,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '1f701340f2cc12c35dc6ba0371a61f6fdb94dc9bbaa8a9a50cb940ec27b6b27c',
          file_name:
            'videos/1f701340f2cc12c35dc6ba0371a61f6fdb94dc9bbaa8a9a50cb940ec27b6b27c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1f701340f2cc12c35dc6ba0371a61f6fdb94dc9bbaa8a9a50cb940ec27b6b27c.mp4',
          name: 'INT-ADV-Curtsy_Lunges_Over_Step-EXERCISE-LEFT',
          description: 'Left Side',
          size: 81758,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2243,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: '7508296a2c7e5b26f418dba1e7fbd0cbb09532b692ac2e95b8b551b0ca2be42d',
          file_name:
            'videos/7508296a2c7e5b26f418dba1e7fbd0cbb09532b692ac2e95b8b551b0ca2be42d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7508296a2c7e5b26f418dba1e7fbd0cbb09532b692ac2e95b8b551b0ca2be42d.mp4',
          name: 'INT-ADV-Curtsy_Lunges_Over_Step-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 81492,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2244,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'e34c1bc6c712ff67a7e994da963e374111119cd9e496d9ff1b394ee375bad1d9',
          file_name:
            'audios/e34c1bc6c712ff67a7e994da963e374111119cd9e496d9ff1b394ee375bad1d9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e34c1bc6c712ff67a7e994da963e374111119cd9e496d9ff1b394ee375bad1d9.mp3',
          name: 'INT-ADV-Curtsy_Lunges_Over_Step-EXERCISE',
          description: null,
          size: 32375,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-CURTSY_LUNGES_OVER_STEP-EXERCISE': {
      id: 858,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Curtsy Lunges Over Step',
      short_name: 'Curtsy Lunges Over Step',
      unique_name: 'ADVANCED-CURTSY_LUNGES_OVER_STEP-EXERCISE',
      description:
        '1. Stand in the middle of a step.\n2. Bend knees and step one foot off to the side of the step until toe lightly taps. The majority of weight is on the step.\n3. Drive through the heel on step to stand on one leg, staying as low as possible. Immediately bring the elevated leg back and behind you to tap off step on other side.\n4. Drive through heel on step and repeat. Right and left is one rep.\n5. Perform all reps one side. Repeat with the other side.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2245,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '1f701340f2cc12c35dc6ba0371a61f6fdb94dc9bbaa8a9a50cb940ec27b6b27c',
          file_name:
            'videos/1f701340f2cc12c35dc6ba0371a61f6fdb94dc9bbaa8a9a50cb940ec27b6b27c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1f701340f2cc12c35dc6ba0371a61f6fdb94dc9bbaa8a9a50cb940ec27b6b27c.mp4',
          name: 'INT-ADV-Curtsy_Lunges_Over_Step-EXERCISE-LEFT',
          description: 'Left Side',
          size: 81758,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2246,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: '7508296a2c7e5b26f418dba1e7fbd0cbb09532b692ac2e95b8b551b0ca2be42d',
          file_name:
            'videos/7508296a2c7e5b26f418dba1e7fbd0cbb09532b692ac2e95b8b551b0ca2be42d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7508296a2c7e5b26f418dba1e7fbd0cbb09532b692ac2e95b8b551b0ca2be42d.mp4',
          name: 'INT-ADV-Curtsy_Lunges_Over_Step-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 81492,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2247,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'e34c1bc6c712ff67a7e994da963e374111119cd9e496d9ff1b394ee375bad1d9',
          file_name:
            'audios/e34c1bc6c712ff67a7e994da963e374111119cd9e496d9ff1b394ee375bad1d9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e34c1bc6c712ff67a7e994da963e374111119cd9e496d9ff1b394ee375bad1d9.mp3',
          name: 'INT-ADV-Curtsy_Lunges_Over_Step-EXERCISE',
          description: null,
          size: 32375,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_BOX_SQUATS-EXERCISE': {
      id: 859,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Box Squats',
      short_name: 'Dumbbell Box Squats',
      unique_name: 'INTERMEDIATE-DUMBBELL_BOX_SQUATS-EXERCISE',
      description:
        '1. Start standing in front of the step. Hold a dumbbell in each hand, resting lightly on your shoulders, elbows pointing down.\n2. Maintaining good posture, bend your knees and sink your hips back to slowly lower yourself to sit on the step. Do not fully relax into a seated position, or lightly tap your glutes. Keep your muscles activated.\n3. Drive through your heels and return to stand.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2248,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '07226067d7874f89dc59db949092c68e1494411e59630a03f56ae8072a97df55',
          file_name:
            'videos/07226067d7874f89dc59db949092c68e1494411e59630a03f56ae8072a97df55.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/07226067d7874f89dc59db949092c68e1494411e59630a03f56ae8072a97df55.mp4',
          name: 'INT-ADV-Dumbbell_Box_Squats-EXERCISE',
          description: null,
          size: 76546,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2249,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24',
          file_name:
            'audios/3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24.mp3',
          name: 'INT-ADV-Dumbbell_Box_Squats-EXERCISE',
          description: null,
          size: 29585,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_BOX_SQUATS-EXERCISE': {
      id: 860,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Box Squats',
      short_name: 'Dumbbell Box Squats',
      unique_name: 'ADVANCED-DUMBBELL_BOX_SQUATS-EXERCISE',
      description:
        '1. Start standing in front of the step. Hold a dumbbell in each hand, resting lightly on your shoulders, elbows pointing down.\n2. Maintaining good posture, bend your knees and sink your hips back to slowly lower yourself to sit on the step. Do not fully relax into a seated position, or lightly tap your glutes. Keep your muscles activated.\n3. Drive through your heels and return to stand.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2250,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '07226067d7874f89dc59db949092c68e1494411e59630a03f56ae8072a97df55',
          file_name:
            'videos/07226067d7874f89dc59db949092c68e1494411e59630a03f56ae8072a97df55.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/07226067d7874f89dc59db949092c68e1494411e59630a03f56ae8072a97df55.mp4',
          name: 'INT-ADV-Dumbbell_Box_Squats-EXERCISE',
          description: null,
          size: 76546,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2251,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24',
          file_name:
            'audios/3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24.mp3',
          name: 'INT-ADV-Dumbbell_Box_Squats-EXERCISE',
          description: null,
          size: 29585,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_SUMO_DEADLIFTS-EXERCISE': {
      id: 863,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Sumo Deadlifts',
      short_name: 'Kettlebell Sumo Deadlifts',
      unique_name: 'INTERMEDIATE-KETTLEBELL_SUMO_DEADLIFTS-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointing out and hold a kettlebell with both hands in front of your hips. Knees slightly bent, chest up and core tight.\n2. With back and arms straight, hinge at hips and slide them back as you lower kettlebell to touch the floor.\n3. Stand up straight using your hamstrings and squeeze your glutes at the top.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2257,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '611267f3c0013bac572821bd538897b9b4dcaf16352cc059d0d0b7d59bee57dd',
          file_name:
            'videos/611267f3c0013bac572821bd538897b9b4dcaf16352cc059d0d0b7d59bee57dd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/611267f3c0013bac572821bd538897b9b4dcaf16352cc059d0d0b7d59bee57dd.mp4',
          name: 'INT-ADV-Kettlebell_Sumo_Deadlifts-EXERCISE',
          description: null,
          size: 75975,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2258,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '1ed3a6b6ead6edd3888a7c0a2459e16fa3b22832c2d04f4a540fb14a47a7f390',
          file_name:
            'audios/1ed3a6b6ead6edd3888a7c0a2459e16fa3b22832c2d04f4a540fb14a47a7f390.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1ed3a6b6ead6edd3888a7c0a2459e16fa3b22832c2d04f4a540fb14a47a7f390.mp3',
          name: 'INT-ADV-Kettlebell_Sumo_Deadlifts-EXERCISE',
          description: null,
          size: 33991,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_SUMO_DEADLIFTS-EXERCISE': {
      id: 864,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kettlebell Sumo Deadlifts',
      short_name: 'Kettlebell Sumo Deadlifts',
      unique_name: 'ADVANCED-KETTLEBELL_SUMO_DEADLIFTS-EXERCISE',
      description:
        '1. Stand with your feet wider than shoulder-width apart, toes pointing out and hold a kettlebell with both hands in front of your hips. Knees slightly bent, chest up and core tight.\n2. With back and arms straight, hinge at hips and slide them back as you lower kettlebell to touch the floor.\n3. Stand up straight using your hamstrings and squeeze your glutes at the top.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2259,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '611267f3c0013bac572821bd538897b9b4dcaf16352cc059d0d0b7d59bee57dd',
          file_name:
            'videos/611267f3c0013bac572821bd538897b9b4dcaf16352cc059d0d0b7d59bee57dd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/611267f3c0013bac572821bd538897b9b4dcaf16352cc059d0d0b7d59bee57dd.mp4',
          name: 'INT-ADV-Kettlebell_Sumo_Deadlifts-EXERCISE',
          description: null,
          size: 75975,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2260,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '1ed3a6b6ead6edd3888a7c0a2459e16fa3b22832c2d04f4a540fb14a47a7f390',
          file_name:
            'audios/1ed3a6b6ead6edd3888a7c0a2459e16fa3b22832c2d04f4a540fb14a47a7f390.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1ed3a6b6ead6edd3888a7c0a2459e16fa3b22832c2d04f4a540fb14a47a7f390.mp3',
          name: 'INT-ADV-Kettlebell_Sumo_Deadlifts-EXERCISE',
          description: null,
          size: 33991,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-LATERAL_RHYTHM_RUN-EXERCISE': {
      id: 865,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Lateral Rhythm Run',
      short_name: 'Lateral Rhythm Run',
      unique_name: 'INTERMEDIATE-LATERAL_RHYTHM_RUN-EXERCISE',
      description:
        '1. Stand in the middle of a step.\n2. Keeping majority of your weight over the step, quickly step off to the side with one leg and tap toe on the floor. The other leg remains on the step.\n3. Push off the floor and drive with the foot on the step to switch legs so opposite foot is on the step and the other toe taps.\n4. Immediately hop up and tap down on the opposite side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2261,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '02afaae206f80500281e21f77722afdee2f1cc8bf5077d325865cb3c30e82de9',
          file_name:
            'videos/02afaae206f80500281e21f77722afdee2f1cc8bf5077d325865cb3c30e82de9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/02afaae206f80500281e21f77722afdee2f1cc8bf5077d325865cb3c30e82de9.mp4',
          name: 'INT-ADV-Lateral_Rhythm_Run-EXERCISE',
          description: null,
          size: 65740,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2262,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '592f7c1623d5436187b6132201cfb80031a8bcb8b78efe63e3680b49a674ef8f',
          file_name:
            'audios/592f7c1623d5436187b6132201cfb80031a8bcb8b78efe63e3680b49a674ef8f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/592f7c1623d5436187b6132201cfb80031a8bcb8b78efe63e3680b49a674ef8f.mp3',
          name: 'INT-ADV-Lateral_Rhythm_Run-EXERCISE',
          description: null,
          size: 28605,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-LATERAL_RHYTHM_RUN-EXERCISE': {
      id: 866,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Lateral Rhythm Run',
      short_name: 'Lateral Rhythm Run',
      unique_name: 'ADVANCED-LATERAL_RHYTHM_RUN-EXERCISE',
      description:
        '1. Stand in the middle of a step.\n2. Keeping majority of your weight over the step, quickly step off to the side with one leg and tap toe on the floor. The other leg remains on the step.\n3. Push off the floor and drive with the foot on the step to switch legs so opposite foot is on the step and the other toe taps.\n4. Immediately hop up and tap down on the opposite side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2263,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '02afaae206f80500281e21f77722afdee2f1cc8bf5077d325865cb3c30e82de9',
          file_name:
            'videos/02afaae206f80500281e21f77722afdee2f1cc8bf5077d325865cb3c30e82de9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/02afaae206f80500281e21f77722afdee2f1cc8bf5077d325865cb3c30e82de9.mp4',
          name: 'INT-ADV-Lateral_Rhythm_Run-EXERCISE',
          description: null,
          size: 65740,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2264,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '592f7c1623d5436187b6132201cfb80031a8bcb8b78efe63e3680b49a674ef8f',
          file_name:
            'audios/592f7c1623d5436187b6132201cfb80031a8bcb8b78efe63e3680b49a674ef8f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/592f7c1623d5436187b6132201cfb80031a8bcb8b78efe63e3680b49a674ef8f.mp3',
          name: 'INT-ADV-Lateral_Rhythm_Run-EXERCISE',
          description: null,
          size: 28605,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ECCENTRIC_LATERAL_TAP_DOWNS-EXERCISE': {
      id: 867,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Eccentric Lateral Tap Downs',
      short_name: 'Eccentric Lateral Tap Downs',
      unique_name: 'INTERMEDIATE-ECCENTRIC_LATERAL_TAP_DOWNS-EXERCISE',
      description:
        '1. Stand in the middle of a step.\n2. Transfer all your weight onto one leg, bend your knee and step the other foot off to the side of the step until your toe lightly taps. The majority of your weight is on the step. Work on form and control with the eccentric motion.\n3. Drive through the heel on the step to come up to stand on the working leg.\n4. Perform all reps one side, repeat on the other side.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2265,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '46ae8fde1d78d2d1b7aa04df5bd2a471245190301acd8deebc8711e6ebd41dcc',
          file_name:
            'videos/46ae8fde1d78d2d1b7aa04df5bd2a471245190301acd8deebc8711e6ebd41dcc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/46ae8fde1d78d2d1b7aa04df5bd2a471245190301acd8deebc8711e6ebd41dcc.mp4',
          name: 'INT-ADV-Eccentric_Lateral_Tap_Downs-EXERCISE-LEFT',
          description: 'Left Side',
          size: 59024,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2266,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: '4cbdeb2d74fc1fc94351150c518c66ce4dbb0b46ace85eaed1083a8849f6e67d',
          file_name:
            'videos/4cbdeb2d74fc1fc94351150c518c66ce4dbb0b46ace85eaed1083a8849f6e67d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4cbdeb2d74fc1fc94351150c518c66ce4dbb0b46ace85eaed1083a8849f6e67d.mp4',
          name: 'INT-ADV-Eccentric_Lateral_Tap_Downs-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 70938,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2267,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'f62d66baa1e7a5183ffe3c67519880a435c5d5ee147fea303f0ca68d14748009',
          file_name:
            'audios/f62d66baa1e7a5183ffe3c67519880a435c5d5ee147fea303f0ca68d14748009.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f62d66baa1e7a5183ffe3c67519880a435c5d5ee147fea303f0ca68d14748009.mp3',
          name: 'INT-ADV-Eccentric_Lateral_Tap_Downs-EXERCISE',
          description: null,
          size: 36936,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ECCENTRIC_LATERAL_TAP_DOWNS-EXERCISE': {
      id: 868,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Eccentric Lateral Tap Downs',
      short_name: 'Eccentric Lateral Tap Downs',
      unique_name: 'ADVANCED-ECCENTRIC_LATERAL_TAP_DOWNS-EXERCISE',
      description:
        '1. Stand in the middle of a step.\n2. Transfer all your weight onto one leg, bend your knee and step the other foot off to the side of the step until your toe lightly taps. The majority of your weight is on the step. Work on form and control with the eccentric motion.\n3. Drive through the heel on the step to come up to stand on the working leg.\n4. Perform all reps one side, repeat on the other side.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2268,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '46ae8fde1d78d2d1b7aa04df5bd2a471245190301acd8deebc8711e6ebd41dcc',
          file_name:
            'videos/46ae8fde1d78d2d1b7aa04df5bd2a471245190301acd8deebc8711e6ebd41dcc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/46ae8fde1d78d2d1b7aa04df5bd2a471245190301acd8deebc8711e6ebd41dcc.mp4',
          name: 'INT-ADV-Eccentric_Lateral_Tap_Downs-EXERCISE-LEFT',
          description: 'Left Side',
          size: 59024,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2269,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: '4cbdeb2d74fc1fc94351150c518c66ce4dbb0b46ace85eaed1083a8849f6e67d',
          file_name:
            'videos/4cbdeb2d74fc1fc94351150c518c66ce4dbb0b46ace85eaed1083a8849f6e67d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4cbdeb2d74fc1fc94351150c518c66ce4dbb0b46ace85eaed1083a8849f6e67d.mp4',
          name: 'INT-ADV-Eccentric_Lateral_Tap_Downs-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 70938,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2270,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'f62d66baa1e7a5183ffe3c67519880a435c5d5ee147fea303f0ca68d14748009',
          file_name:
            'audios/f62d66baa1e7a5183ffe3c67519880a435c5d5ee147fea303f0ca68d14748009.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f62d66baa1e7a5183ffe3c67519880a435c5d5ee147fea303f0ca68d14748009.mp3',
          name: 'INT-ADV-Eccentric_Lateral_Tap_Downs-EXERCISE',
          description: null,
          size: 36936,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_UPPERCUTS-EXERCISE': {
      id: 872,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Uppercuts',
      short_name: 'Dumbbell Uppercuts',
      unique_name: 'INTERMEDIATE-DUMBBELL_UPPERCUTS-EXERCISE',
      description:
        '1. Start in a wide stance, feet slightly wider than your hips and hold a dumbbell in each hand. Keep your back straight, bend your knees slightly and place both fists under your chin.\n2. Moving toward the center of your body, pivot on one foot and rotate your hips and shoulders as you punch the dumbbell up slightly past your chin.\n3. Recoil your punch and return to start. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2279,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '7a4f39108943909005c0c620fc1fe2c602916b3fa4f545829335565627f8bdd9',
          file_name:
            'videos/7a4f39108943909005c0c620fc1fe2c602916b3fa4f545829335565627f8bdd9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7a4f39108943909005c0c620fc1fe2c602916b3fa4f545829335565627f8bdd9.mp4',
          name: 'INT-ADV-Dumbbell_Uppercuts-EXERCISE',
          description: null,
          size: 78600,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2280,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '262fcc2ae3fa4c318a9c85ca0141d37d599ffb5c7ad209ceb81699d87faeb769',
          file_name:
            'audios/262fcc2ae3fa4c318a9c85ca0141d37d599ffb5c7ad209ceb81699d87faeb769.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/262fcc2ae3fa4c318a9c85ca0141d37d599ffb5c7ad209ceb81699d87faeb769.mp3',
          name: 'INT-ADV-Dumbbell_Uppercuts-EXERCISE',
          description: null,
          size: 29179,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_UPPERCUTS-EXERCISE': {
      id: 873,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Uppercuts',
      short_name: 'Dumbbell Uppercuts',
      unique_name: 'ADVANCED-DUMBBELL_UPPERCUTS-EXERCISE',
      description:
        '1. Start in a wide stance, feet slightly wider than your hips and hold a dumbbell in each hand. Keep your back straight, bend your knees slightly and place both fists under your chin.\n2. Moving toward the center of your body, pivot on one foot and rotate your hips and shoulders as you punch the dumbbell up slightly past your chin.\n3. Recoil your punch and return to start. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2281,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '7a4f39108943909005c0c620fc1fe2c602916b3fa4f545829335565627f8bdd9',
          file_name:
            'videos/7a4f39108943909005c0c620fc1fe2c602916b3fa4f545829335565627f8bdd9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7a4f39108943909005c0c620fc1fe2c602916b3fa4f545829335565627f8bdd9.mp4',
          name: 'INT-ADV-Dumbbell_Uppercuts-EXERCISE',
          description: null,
          size: 78600,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2282,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '262fcc2ae3fa4c318a9c85ca0141d37d599ffb5c7ad209ceb81699d87faeb769',
          file_name:
            'audios/262fcc2ae3fa4c318a9c85ca0141d37d599ffb5c7ad209ceb81699d87faeb769.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/262fcc2ae3fa4c318a9c85ca0141d37d599ffb5c7ad209ceb81699d87faeb769.mp3',
          name: 'INT-ADV-Dumbbell_Uppercuts-EXERCISE',
          description: null,
          size: 29179,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SIDE_PLANK_CRUNCHES-EXERCISE': {
      id: 876,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Side Plank Crunches',
      short_name: 'Side Plank Crunches',
      unique_name: 'INTERMEDIATE-SIDE_PLANK_CRUNCHES-EXERCISE',
      description:
        '1. Start in Side Plank, with your hand directly under your shoulder, feet stacked.\n2. Reach top arm overhead, pit of elbow by ear.\n3. Simultaneously crunch extended arm and leg in, bringing elbow and knee together. Pause.\n4. Extend arm and leg back out. Perform all reps. Repeat other side.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2287,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '3dc8d44d1fafc11bdb5c6b6c3e32e84c6b4abd84bcd4442a4d6571c4ddf61f27',
          file_name:
            'videos/3dc8d44d1fafc11bdb5c6b6c3e32e84c6b4abd84bcd4442a4d6571c4ddf61f27.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3dc8d44d1fafc11bdb5c6b6c3e32e84c6b4abd84bcd4442a4d6571c4ddf61f27.mp4',
          name: 'INT-ADV-Side_Plank_Crunches-EXERCISE-LEFT',
          description: 'Left Side',
          size: 61339,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2288,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: 'ac7463c9404daa2b4f8a03b7bda70df7015b04b6b045362b83b2c52b10e96457',
          file_name:
            'videos/ac7463c9404daa2b4f8a03b7bda70df7015b04b6b045362b83b2c52b10e96457.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ac7463c9404daa2b4f8a03b7bda70df7015b04b6b045362b83b2c52b10e96457.mp4',
          name: 'INT-ADV-Side_Plank_Crunches-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 62594,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2289,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '287db231d59be0f2edd3a9f3367d88b209dac5f99c7e9724a8a0e0c397b3ff29',
          file_name:
            'audios/287db231d59be0f2edd3a9f3367d88b209dac5f99c7e9724a8a0e0c397b3ff29.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/287db231d59be0f2edd3a9f3367d88b209dac5f99c7e9724a8a0e0c397b3ff29.mp3',
          name: 'INT-ADV-Side_Plank_Crunches-EXERCISE',
          description: null,
          size: 29383,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SIDE_PLANK_CRUNCHES-EXERCISE': {
      id: 877,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Side Plank Crunches',
      short_name: 'Side Plank Crunches',
      unique_name: 'ADVANCED-SIDE_PLANK_CRUNCHES-EXERCISE',
      description:
        '1. Start in Side Plank, with your hand directly under your shoulder, feet stacked.\n2. Reach top arm overhead, pit of elbow by ear.\n3. Simultaneously crunch extended arm and leg in, bringing elbow and knee together. Pause.\n4. Extend arm and leg back out. Perform all reps. Repeat other side.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2290,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '3dc8d44d1fafc11bdb5c6b6c3e32e84c6b4abd84bcd4442a4d6571c4ddf61f27',
          file_name:
            'videos/3dc8d44d1fafc11bdb5c6b6c3e32e84c6b4abd84bcd4442a4d6571c4ddf61f27.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3dc8d44d1fafc11bdb5c6b6c3e32e84c6b4abd84bcd4442a4d6571c4ddf61f27.mp4',
          name: 'INT-ADV-Side_Plank_Crunches-EXERCISE-LEFT',
          description: 'Left Side',
          size: 61339,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2291,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: 'ac7463c9404daa2b4f8a03b7bda70df7015b04b6b045362b83b2c52b10e96457',
          file_name:
            'videos/ac7463c9404daa2b4f8a03b7bda70df7015b04b6b045362b83b2c52b10e96457.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ac7463c9404daa2b4f8a03b7bda70df7015b04b6b045362b83b2c52b10e96457.mp4',
          name: 'INT-ADV-Side_Plank_Crunches-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 62594,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2292,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '287db231d59be0f2edd3a9f3367d88b209dac5f99c7e9724a8a0e0c397b3ff29',
          file_name:
            'audios/287db231d59be0f2edd3a9f3367d88b209dac5f99c7e9724a8a0e0c397b3ff29.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/287db231d59be0f2edd3a9f3367d88b209dac5f99c7e9724a8a0e0c397b3ff29.mp3',
          name: 'INT-ADV-Side_Plank_Crunches-EXERCISE',
          description: null,
          size: 29383,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_FRONT_SQUATS-EXERCISE': {
      id: 891,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Front Squats',
      short_name: 'Dumbbell Front Squats',
      unique_name: 'INTERMEDIATE-DUMBBELL_FRONT_SQUATS-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart. Hold a dumbbell in each hand, resting lightly on your shoulders, elbows pointed down.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2323,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '1b4c542b1e830ab54244d7d913a18a64b203afa2fe0292e696b233524f31fff9',
          file_name:
            'videos/1b4c542b1e830ab54244d7d913a18a64b203afa2fe0292e696b233524f31fff9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1b4c542b1e830ab54244d7d913a18a64b203afa2fe0292e696b233524f31fff9.mp4',
          name: 'INT-ADV-Dumbbell_Front_Squats-EXERCISE',
          description: null,
          size: 64498,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2324,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '471d0cc2849bad8280ad939464309868fbc28e9fc40ed2ae153413641768f742',
          file_name:
            'audios/471d0cc2849bad8280ad939464309868fbc28e9fc40ed2ae153413641768f742.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/471d0cc2849bad8280ad939464309868fbc28e9fc40ed2ae153413641768f742.mp3',
          name: 'INT-ADV-Dumbbell_Front_Squats-EXERCISE',
          description: null,
          size: 30707,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_FRONT_SQUATS-EXERCISE': {
      id: 892,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Front Squats',
      short_name: 'Dumbbell Front Squats',
      unique_name: 'ADVANCED-DUMBBELL_FRONT_SQUATS-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart. Hold a dumbbell in each hand, resting lightly on your shoulders, elbows pointed down.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2325,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '1b4c542b1e830ab54244d7d913a18a64b203afa2fe0292e696b233524f31fff9',
          file_name:
            'videos/1b4c542b1e830ab54244d7d913a18a64b203afa2fe0292e696b233524f31fff9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1b4c542b1e830ab54244d7d913a18a64b203afa2fe0292e696b233524f31fff9.mp4',
          name: 'INT-ADV-Dumbbell_Front_Squats-EXERCISE',
          description: null,
          size: 64498,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2326,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '471d0cc2849bad8280ad939464309868fbc28e9fc40ed2ae153413641768f742',
          file_name:
            'audios/471d0cc2849bad8280ad939464309868fbc28e9fc40ed2ae153413641768f742.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/471d0cc2849bad8280ad939464309868fbc28e9fc40ed2ae153413641768f742.mp3',
          name: 'INT-ADV-Dumbbell_Front_Squats-EXERCISE',
          description: null,
          size: 30707,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_TRICEP_KICKBACKS_WITH_ROTATION-EXERCISE': {
      id: 893,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Tricep Kickbacks with Rotation',
      short_name: 'DB Kickbacks w Rotation',
      unique_name:
        'INTERMEDIATE-DUMBBELL_TRICEP_KICKBACKS_WITH_ROTATION-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart, knees soft. Hold a dumbbell in each hand.\n2. Hinge at the waist until torso is close to parallel to the floor. Bend elbows back behind you to 90 degrees. Bring dumbbells to hips, palms in.\n3. Extend elbows and lift dumbbells up and back behind you. Rotate palms toward ceiling as you straighten arms.\n4. Rotate palms back in as you lower dumbbells to start.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2327,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '26ff20931899412e544fdca1e1c85a4722e28dcd41176992d65eab6c5a3ab140',
          file_name:
            'videos/26ff20931899412e544fdca1e1c85a4722e28dcd41176992d65eab6c5a3ab140.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/26ff20931899412e544fdca1e1c85a4722e28dcd41176992d65eab6c5a3ab140.mp4',
          name: 'INT-ADV-Dumbbell_Tricep_Kickbacks_with_Rotation-EXERCISE',
          description: null,
          size: 57279,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2328,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'cc8e72c4d7d6ca7e7998c72787f7cf6043bd2eb89977be8a8e9eae87471ed094',
          file_name:
            'audios/cc8e72c4d7d6ca7e7998c72787f7cf6043bd2eb89977be8a8e9eae87471ed094.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cc8e72c4d7d6ca7e7998c72787f7cf6043bd2eb89977be8a8e9eae87471ed094.mp3',
          name: 'INT-ADV-Dumbbell_Tricep_Kickbacks_with_Rotation-EXERCISE',
          description: null,
          size: 45737,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_TRICEP_KICKBACKS_WITH_ROTATION-EXERCISE': {
      id: 894,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Tricep Kickbacks with Rotation',
      short_name: 'DB Kickbacks w Rotation',
      unique_name: 'ADVANCED-DUMBBELL_TRICEP_KICKBACKS_WITH_ROTATION-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart, knees soft. Hold a dumbbell in each hand.\n2. Hinge at the waist until torso is close to parallel to the floor. Bend elbows back behind you to 90 degrees. Bring dumbbells to hips, palms in.\n3. Extend elbows and lift dumbbells up and back behind you. Rotate palms toward ceiling as you straighten arms.\n4. Rotate palms back in as you lower dumbbells to start.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2329,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '26ff20931899412e544fdca1e1c85a4722e28dcd41176992d65eab6c5a3ab140',
          file_name:
            'videos/26ff20931899412e544fdca1e1c85a4722e28dcd41176992d65eab6c5a3ab140.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/26ff20931899412e544fdca1e1c85a4722e28dcd41176992d65eab6c5a3ab140.mp4',
          name: 'INT-ADV-Dumbbell_Tricep_Kickbacks_with_Rotation-EXERCISE',
          description: null,
          size: 57279,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2330,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'cc8e72c4d7d6ca7e7998c72787f7cf6043bd2eb89977be8a8e9eae87471ed094',
          file_name:
            'audios/cc8e72c4d7d6ca7e7998c72787f7cf6043bd2eb89977be8a8e9eae87471ed094.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cc8e72c4d7d6ca7e7998c72787f7cf6043bd2eb89977be8a8e9eae87471ed094.mp3',
          name: 'INT-ADV-Dumbbell_Tricep_Kickbacks_with_Rotation-EXERCISE',
          description: null,
          size: 45737,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PLANK_DUMBBELL_PULL_THROUGHS-EXERCISE': {
      id: 895,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Plank Dumbbell Pull Throughs',
      short_name: 'Plank Dumbbell Pull Throughs',
      unique_name: 'INTERMEDIATE-PLANK_DUMBBELL_PULL_THROUGHS-EXERCISE',
      description:
        '1. Start in Plank position with shoulders over wrists, hips square. Place a dumbbell off to one side and behind your wrist horizontally.\n2. Reach arm across and underneath your body to grab the handle of the dumbbell.\n3. Drag the dumbbell to the opposite side and place your hand back on the floor to return to Plank.\n4. Repeat with the other arm. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2331,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '24d1b5d7981d28e88f06d1ef1595360201d58126f98636cb09a482b2988b628f',
          file_name:
            'videos/24d1b5d7981d28e88f06d1ef1595360201d58126f98636cb09a482b2988b628f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/24d1b5d7981d28e88f06d1ef1595360201d58126f98636cb09a482b2988b628f.mp4',
          name: 'INT-ADV-Plank_Dumbbell_Pull_Throughs-EXERCISE',
          description: null,
          size: 88841,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2332,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '6ee2b4b6c801ea64076e21bdd33b804f1618ae7212bfef3dac7347b757e77446',
          file_name:
            'audios/6ee2b4b6c801ea64076e21bdd33b804f1618ae7212bfef3dac7347b757e77446.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6ee2b4b6c801ea64076e21bdd33b804f1618ae7212bfef3dac7347b757e77446.mp3',
          name: 'INT-ADV-Plank_Dumbbell_Pull_Throughs-EXERCISE',
          description: null,
          size: 33013,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PLANK_DUMBBELL_PULL_THROUGHS-EXERCISE': {
      id: 896,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Plank Dumbbell Pull Throughs',
      short_name: 'Plank Dumbbell Pull Throughs',
      unique_name: 'ADVANCED-PLANK_DUMBBELL_PULL_THROUGHS-EXERCISE',
      description:
        '1. Start in Plank position with shoulders over wrists, hips square. Place a dumbbell off to one side and behind your wrist horizontally.\n2. Reach arm across and underneath your body to grab the handle of the dumbbell.\n3. Drag the dumbbell to the opposite side and place your hand back on the floor to return to Plank.\n4. Repeat with the other arm. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2333,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '24d1b5d7981d28e88f06d1ef1595360201d58126f98636cb09a482b2988b628f',
          file_name:
            'videos/24d1b5d7981d28e88f06d1ef1595360201d58126f98636cb09a482b2988b628f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/24d1b5d7981d28e88f06d1ef1595360201d58126f98636cb09a482b2988b628f.mp4',
          name: 'INT-ADV-Plank_Dumbbell_Pull_Throughs-EXERCISE',
          description: null,
          size: 88841,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2334,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '6ee2b4b6c801ea64076e21bdd33b804f1618ae7212bfef3dac7347b757e77446',
          file_name:
            'audios/6ee2b4b6c801ea64076e21bdd33b804f1618ae7212bfef3dac7347b757e77446.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6ee2b4b6c801ea64076e21bdd33b804f1618ae7212bfef3dac7347b757e77446.mp3',
          name: 'INT-ADV-Plank_Dumbbell_Pull_Throughs-EXERCISE',
          description: null,
          size: 33013,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_KETTLEBELL_FORWARD_LUNGES_WITH_PASS-EXERCISE': {
      id: 897,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Kettlebell Forward Lunges with Pass',
      short_name: 'KB Forward Lunges with Pass',
      unique_name:
        'INTERMEDIATE-ALTERNATING_KETTLEBELL_FORWARD_LUNGES_WITH_PASS-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart, holding a kettlebell in one hand by your side.\n2. Keeping hips square, take a big step forward with the leg opposite of the bell and drop down into a lunge with back heel elevated.\n3. Pass the kettlebell under the inside of your front knee and catch with other hand.\n4. Drive through the front foot to stand.\n5. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2335,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '57f2cbf7be52d43fa1f5b33939cf01bb3dd91e92984c822e5dfc0ea8df00fa79',
          file_name:
            'videos/57f2cbf7be52d43fa1f5b33939cf01bb3dd91e92984c822e5dfc0ea8df00fa79.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/57f2cbf7be52d43fa1f5b33939cf01bb3dd91e92984c822e5dfc0ea8df00fa79.mp4',
          name: 'INT-ADV-Alternating_Kettlebell_Forward_Lunges_with_Pass-EXERCISE',
          description: null,
          size: 199816,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2336,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '17c388484ee864e921b8cec2d577cb0b06fb29f5b69536ccd2309069cc0c8c7d',
          file_name:
            'audios/17c388484ee864e921b8cec2d577cb0b06fb29f5b69536ccd2309069cc0c8c7d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/17c388484ee864e921b8cec2d577cb0b06fb29f5b69536ccd2309069cc0c8c7d.mp3',
          name: 'INT-ADV-Alternating_Kettlebell_Forward_Lunges_with_Pass-EXERCISE',
          description: null,
          size: 48365,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_KETTLEBELL_FORWARD_LUNGES_WITH_PASS-EXERCISE': {
      id: 898,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Kettlebell Forward Lunges with Pass',
      short_name: 'KB Forward Lunges with Pass',
      unique_name:
        'ADVANCED-ALTERNATING_KETTLEBELL_FORWARD_LUNGES_WITH_PASS-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart, holding a kettlebell in one hand by your side.\n2. Keeping hips square, take a big step forward with the leg opposite of the bell and drop down into a lunge with back heel elevated.\n3. Pass the kettlebell under the inside of your front knee and catch with other hand.\n4. Drive through the front foot to stand.\n5. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2337,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '57f2cbf7be52d43fa1f5b33939cf01bb3dd91e92984c822e5dfc0ea8df00fa79',
          file_name:
            'videos/57f2cbf7be52d43fa1f5b33939cf01bb3dd91e92984c822e5dfc0ea8df00fa79.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/57f2cbf7be52d43fa1f5b33939cf01bb3dd91e92984c822e5dfc0ea8df00fa79.mp4',
          name: 'INT-ADV-Alternating_Kettlebell_Forward_Lunges_with_Pass-EXERCISE',
          description: null,
          size: 199816,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2338,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '17c388484ee864e921b8cec2d577cb0b06fb29f5b69536ccd2309069cc0c8c7d',
          file_name:
            'audios/17c388484ee864e921b8cec2d577cb0b06fb29f5b69536ccd2309069cc0c8c7d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/17c388484ee864e921b8cec2d577cb0b06fb29f5b69536ccd2309069cc0c8c7d.mp3',
          name: 'INT-ADV-Alternating_Kettlebell_Forward_Lunges_with_Pass-EXERCISE',
          description: null,
          size: 48365,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_KETTLEBELL_REVERSE_LUNGES_WITH_PASS-EXERCISE': {
      id: 899,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Kettlebell Reverse Lunges with Pass',
      short_name: 'KB Reverse Lunges with Pass',
      unique_name:
        'INTERMEDIATE-ALTERNATING_KETTLEBELL_REVERSE_LUNGES_WITH_PASS-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart, holding a kettlebell in one hand by your side.\n2. Keeping hips square, take a big step back with the same side leg as the bell and drop down into a lunge with back heel elevated.\n3. Pass the kettlebell under the inside of your front knee and catch with other hand.\n4. Drive through the front foot to stand.\n5. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2339,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'c68864a5918276106a2584da383679c568d24619472d474137c517a4afd02908',
          file_name:
            'videos/c68864a5918276106a2584da383679c568d24619472d474137c517a4afd02908.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c68864a5918276106a2584da383679c568d24619472d474137c517a4afd02908.mp4',
          name: 'INT-ADV-Alternating_Kettlebell_Reverse_Lunges_with_Pass-EXERCISE',
          description: null,
          size: 178942,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2340,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '7e663765de646f9ffad2b266685a9c6c465b7f8e7c2e64a8642e5c0df3eb8fc1',
          file_name:
            'audios/7e663765de646f9ffad2b266685a9c6c465b7f8e7c2e64a8642e5c0df3eb8fc1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7e663765de646f9ffad2b266685a9c6c465b7f8e7c2e64a8642e5c0df3eb8fc1.mp3',
          name: 'INT-ADV-Alternating_Kettlebell_Reverse_Lunges_with_Pass-EXERCISE',
          description: null,
          size: 47757,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_KETTLEBELL_REVERSE_LUNGES_WITH_PASS-EXERCISE': {
      id: 900,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Kettlebell Reverse Lunges with Pass',
      short_name: 'KB Reverse Lunges with Pass',
      unique_name:
        'ADVANCED-ALTERNATING_KETTLEBELL_REVERSE_LUNGES_WITH_PASS-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart, holding a kettlebell in one hand by your side.\n2. Keeping hips square, take a big step back with the same side leg as the bell and drop down into a lunge with back heel elevated.\n3. Pass the kettlebell under the inside of your front knee and catch with other hand.\n4. Drive through the front foot to stand.\n5. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2341,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'c68864a5918276106a2584da383679c568d24619472d474137c517a4afd02908',
          file_name:
            'videos/c68864a5918276106a2584da383679c568d24619472d474137c517a4afd02908.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c68864a5918276106a2584da383679c568d24619472d474137c517a4afd02908.mp4',
          name: 'INT-ADV-Alternating_Kettlebell_Reverse_Lunges_with_Pass-EXERCISE',
          description: null,
          size: 178942,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2342,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '7e663765de646f9ffad2b266685a9c6c465b7f8e7c2e64a8642e5c0df3eb8fc1',
          file_name:
            'audios/7e663765de646f9ffad2b266685a9c6c465b7f8e7c2e64a8642e5c0df3eb8fc1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7e663765de646f9ffad2b266685a9c6c465b7f8e7c2e64a8642e5c0df3eb8fc1.mp3',
          name: 'INT-ADV-Alternating_Kettlebell_Reverse_Lunges_with_Pass-EXERCISE',
          description: null,
          size: 47757,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_SHOULDER_TO_SHOULDER_PRESSES-EXERCISE': {
      id: 901,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Kettlebell Shoulder to Shoulder Presses',
      short_name: 'KB Shoulder to Shoulder Presses',
      unique_name:
        'INTERMEDIATE-KETTLEBELL_SHOULDER_TO_SHOULDER_PRESSES-EXERCISE',
      description:
        '1. Stand tall with back straight and core engaged. Hold a kettlebell by the horns in both hands and lightly rest the handle on one shoulder. The bottom of bell faces straight ahead, and elbows point down.\n2. Raise the kettlebell straight overhead, biceps by your ears.\n3. Lower the kettlebell back down to the opposite shoulder.\n4. Continue pressing up and over. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2343,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'b28ccc221c190502d8c488e5e753ec5aaf907f28290d094b15686b41cae8707b',
          file_name:
            'videos/b28ccc221c190502d8c488e5e753ec5aaf907f28290d094b15686b41cae8707b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b28ccc221c190502d8c488e5e753ec5aaf907f28290d094b15686b41cae8707b.mp4',
          name: 'INT-ADV-Kettlebell_Shoulder_to_Shoulder_Presses-EXERCISE',
          description: null,
          size: 95121,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2344,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'bbea5607e5afab8634c58568b4377d4bd037033e58129936b355b0e6f55b1866',
          file_name:
            'audios/bbea5607e5afab8634c58568b4377d4bd037033e58129936b355b0e6f55b1866.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/bbea5607e5afab8634c58568b4377d4bd037033e58129936b355b0e6f55b1866.mp3',
          name: 'INT-ADV-Kettlebell_Shoulder_to_Shoulder_Presses-EXERCISE',
          description: null,
          size: 38569,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_SHOULDER_TO_SHOULDER_PRESSES-EXERCISE': {
      id: 902,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Kettlebell Shoulder to Shoulder Presses',
      short_name: 'KB Shoulder to Shoulder Presses',
      unique_name: 'ADVANCED-KETTLEBELL_SHOULDER_TO_SHOULDER_PRESSES-EXERCISE',
      description:
        '1. Stand tall with back straight and core engaged. Hold a kettlebell by the horns in both hands and lightly rest the handle on one shoulder. The bottom of bell faces straight ahead, and elbows point down.\n2. Raise the kettlebell straight overhead, biceps by your ears.\n3. Lower the kettlebell back down to the opposite shoulder.\n4. Continue pressing up and over. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2345,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'b28ccc221c190502d8c488e5e753ec5aaf907f28290d094b15686b41cae8707b',
          file_name:
            'videos/b28ccc221c190502d8c488e5e753ec5aaf907f28290d094b15686b41cae8707b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b28ccc221c190502d8c488e5e753ec5aaf907f28290d094b15686b41cae8707b.mp4',
          name: 'INT-ADV-Kettlebell_Shoulder_to_Shoulder_Presses-EXERCISE',
          description: null,
          size: 95121,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2346,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'bbea5607e5afab8634c58568b4377d4bd037033e58129936b355b0e6f55b1866',
          file_name:
            'audios/bbea5607e5afab8634c58568b4377d4bd037033e58129936b355b0e6f55b1866.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/bbea5607e5afab8634c58568b4377d4bd037033e58129936b355b0e6f55b1866.mp3',
          name: 'INT-ADV-Kettlebell_Shoulder_to_Shoulder_Presses-EXERCISE',
          description: null,
          size: 38569,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_EXPLOSIVE_STEP-_UPS-EXERCISE': {
      id: 903,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Explosive Step-Ups',
      short_name: 'Alternating Explosive Step-Ups',
      unique_name: 'INTERMEDIATE-ALTERNATING_EXPLOSIVE_STEP-_UPS-EXERCISE',
      description:
        '1. Stand with one foot on the step, knee bent at 90 degrees and the other foot on the floor.\n2. Drive off the foot on the step to jump straight up and "get some air."\n3. Switch your legs at the top and land soft with the opposite foot on the step and the other on the floor.\n4. Immediately jump up and repeat with the opposite side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2347,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '0a34952d7d8ca66c4ef0ebeecb20adcf3bbedcb14748b8a8fde453196553d55d',
          file_name:
            'videos/0a34952d7d8ca66c4ef0ebeecb20adcf3bbedcb14748b8a8fde453196553d55d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0a34952d7d8ca66c4ef0ebeecb20adcf3bbedcb14748b8a8fde453196553d55d.mp4',
          name: 'INT-ADV-Alternating_Explosive_Step-Ups-EXERCISE',
          description: null,
          size: 82559,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2348,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'cfdc68a24538b5692910f5ed5c946368e81da9ae01d88308a3580eabc895cea6',
          file_name:
            'audios/cfdc68a24538b5692910f5ed5c946368e81da9ae01d88308a3580eabc895cea6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cfdc68a24538b5692910f5ed5c946368e81da9ae01d88308a3580eabc895cea6.mp3',
          name: 'INT-ADV-Alternating_Explosive_Step-Ups-EXERCISE',
          description: null,
          size: 39891,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_EXPLOSIVE_STEP-_UPS-EXERCISE': {
      id: 904,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Explosive Step-Ups',
      short_name: 'Alternating Explosive Step-Ups',
      unique_name: 'ADVANCED-ALTERNATING_EXPLOSIVE_STEP-_UPS-EXERCISE',
      description:
        '1. Stand with one foot on the step, knee bent at 90 degrees and the other foot on the floor.\n2. Drive off the foot on the step to jump straight up and "get some air."\n3. Switch your legs at the top and land soft with the opposite foot on the step and the other on the floor.\n4. Immediately jump up and repeat with the opposite side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2349,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '0a34952d7d8ca66c4ef0ebeecb20adcf3bbedcb14748b8a8fde453196553d55d',
          file_name:
            'videos/0a34952d7d8ca66c4ef0ebeecb20adcf3bbedcb14748b8a8fde453196553d55d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0a34952d7d8ca66c4ef0ebeecb20adcf3bbedcb14748b8a8fde453196553d55d.mp4',
          name: 'INT-ADV-Alternating_Explosive_Step-Ups-EXERCISE',
          description: null,
          size: 82559,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2350,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'cfdc68a24538b5692910f5ed5c946368e81da9ae01d88308a3580eabc895cea6',
          file_name:
            'audios/cfdc68a24538b5692910f5ed5c946368e81da9ae01d88308a3580eabc895cea6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cfdc68a24538b5692910f5ed5c946368e81da9ae01d88308a3580eabc895cea6.mp3',
          name: 'INT-ADV-Alternating_Explosive_Step-Ups-EXERCISE',
          description: null,
          size: 39891,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SIDE_SHUFFLES-EXERCISE': {
      id: 910,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Side Shuffles',
      short_name: 'Side Shuffles',
      unique_name: 'INTERMEDIATE-SIDE_SHUFFLES-EXERCISE',
      description:
        '1. Start with your feet about shoulder-width apart, knees bent and a slight forward lean in a strong, athletic stance.\n2. Staying low, take five lateral shuffles to the side while pumping your arms in opposition. Keep your core tight and stay light on your feet.\n3. Pause and drive off the working leg to change directions. Down and back is one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2362,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '84400103668929c5d18cd42f6a16e436c8f425aebc64535d411981731ed266b4',
          file_name:
            'videos/84400103668929c5d18cd42f6a16e436c8f425aebc64535d411981731ed266b4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/84400103668929c5d18cd42f6a16e436c8f425aebc64535d411981731ed266b4.mp4',
          name: 'INT-ADV-Side_Shuffles-EXERCISE',
          description: null,
          size: 171327,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2363,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '53f1ba9ce52a992c178503d11c3d12c6c6d319a8f11f82ec42260bf0cbe1b120',
          file_name:
            'audios/53f1ba9ce52a992c178503d11c3d12c6c6d319a8f11f82ec42260bf0cbe1b120.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/53f1ba9ce52a992c178503d11c3d12c6c6d319a8f11f82ec42260bf0cbe1b120.mp3',
          name: 'INT-ADV-Side_Shuffles-EXERCISE',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SIDE_SHUFFLES-EXERCISE': {
      id: 911,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Side Shuffles',
      short_name: 'Side Shuffles',
      unique_name: 'ADVANCED-SIDE_SHUFFLES-EXERCISE',
      description:
        '1. Start with your feet about shoulder-width apart, knees bent and a slight forward lean in a strong, athletic stance.\n2. Staying low, take five lateral shuffles to the side while pumping your arms in opposition. Keep your core tight and stay light on your feet.\n3. Pause and drive off the working leg to change directions. Down and back is one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2364,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '84400103668929c5d18cd42f6a16e436c8f425aebc64535d411981731ed266b4',
          file_name:
            'videos/84400103668929c5d18cd42f6a16e436c8f425aebc64535d411981731ed266b4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/84400103668929c5d18cd42f6a16e436c8f425aebc64535d411981731ed266b4.mp4',
          name: 'INT-ADV-Side_Shuffles-EXERCISE',
          description: null,
          size: 171327,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2365,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '53f1ba9ce52a992c178503d11c3d12c6c6d319a8f11f82ec42260bf0cbe1b120',
          file_name:
            'audios/53f1ba9ce52a992c178503d11c3d12c6c6d319a8f11f82ec42260bf0cbe1b120.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/53f1ba9ce52a992c178503d11c3d12c6c6d319a8f11f82ec42260bf0cbe1b120.mp3',
          name: 'INT-ADV-Side_Shuffles-EXERCISE',
          description: null,
          size: 20871,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SCISSOR_FEET-EXERCISE': {
      id: 912,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Scissor Feet',
      short_name: 'Scissor Feet',
      unique_name: 'INTERMEDIATE-SCISSOR_FEET-EXERCISE',
      description:
        '1. Start standing with your feet together and elbows bent at 90 degrees by your sides.\n2. Jump up, land softly on the balls of your feet with one foot in front of you and the other one behind you. Take your arms with you as if you were running.\n3. Immediately jump back up and switch your legs and arms.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2366,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '20ff9f6bbd947112f9fea095e45085ce80d40a2c7969359c37b81a29bdaed9f5',
          file_name:
            'videos/20ff9f6bbd947112f9fea095e45085ce80d40a2c7969359c37b81a29bdaed9f5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/20ff9f6bbd947112f9fea095e45085ce80d40a2c7969359c37b81a29bdaed9f5.mp4',
          name: 'INT-ADV-Scissor_Feet-EXERCISE',
          description: null,
          size: 80183,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2367,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'ac5f3f3af22033a3ccb2f52ff7dab0956c85549de1f18754ff47b4c9ba7adf21',
          file_name:
            'audios/ac5f3f3af22033a3ccb2f52ff7dab0956c85549de1f18754ff47b4c9ba7adf21.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ac5f3f3af22033a3ccb2f52ff7dab0956c85549de1f18754ff47b4c9ba7adf21.mp3',
          name: 'INT-ADV-Scissor_Feet-EXERCISE',
          description: null,
          size: 19875,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SCISSOR_FEET-EXERCISE': {
      id: 913,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Scissor Feet',
      short_name: 'Scissor Feet',
      unique_name: 'ADVANCED-SCISSOR_FEET-EXERCISE',
      description:
        '1. Start standing with your feet together and elbows bent at 90 degrees by your sides.\n2. Jump up, land softly on the balls of your feet with one foot in front of you and the other one behind you. Take your arms with you as if you were running.\n3. Immediately jump back up and switch your legs and arms.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2368,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '20ff9f6bbd947112f9fea095e45085ce80d40a2c7969359c37b81a29bdaed9f5',
          file_name:
            'videos/20ff9f6bbd947112f9fea095e45085ce80d40a2c7969359c37b81a29bdaed9f5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/20ff9f6bbd947112f9fea095e45085ce80d40a2c7969359c37b81a29bdaed9f5.mp4',
          name: 'INT-ADV-Scissor_Feet-EXERCISE',
          description: null,
          size: 80183,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2369,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'ac5f3f3af22033a3ccb2f52ff7dab0956c85549de1f18754ff47b4c9ba7adf21',
          file_name:
            'audios/ac5f3f3af22033a3ccb2f52ff7dab0956c85549de1f18754ff47b4c9ba7adf21.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ac5f3f3af22033a3ccb2f52ff7dab0956c85549de1f18754ff47b4c9ba7adf21.mp3',
          name: 'INT-ADV-Scissor_Feet-EXERCISE',
          description: null,
          size: 19875,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-FROG_SQUATS_WITH_OVERHEAD_REACH-EXERCISE': {
      id: 914,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Frog Squats with Overhead Reach',
      short_name: 'Frog Squats w Overhead Reach',
      unique_name: 'INTERMEDIATE-FROG_SQUATS_WITH_OVERHEAD_REACH-EXERCISE',
      description:
        '1. Start with your feet wider than shoulder-width apart, toes turned out and your arms hanging down in front of you.\n2. Squat down as low as possible and lightly touch the floor between your feet.\n3. Drive through your heels and return to standing as you reach your arms up straight overhead.\n4. Bring your arms back down and immediately squat again.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2370,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '462f3e9b1191b5eede7c8316ad0e1eb07a3cdbb67734def281a75696345c4500',
          file_name:
            'videos/462f3e9b1191b5eede7c8316ad0e1eb07a3cdbb67734def281a75696345c4500.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/462f3e9b1191b5eede7c8316ad0e1eb07a3cdbb67734def281a75696345c4500.mp4',
          name: 'INT-ADV-Frog_Squats_with_Overhead_Reach-EXERCISE',
          description: null,
          size: 117109,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2371,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '42d5626b0379047e0b77388abbaa072691284a94769a92fde378e1ce539aee77',
          file_name:
            'audios/42d5626b0379047e0b77388abbaa072691284a94769a92fde378e1ce539aee77.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/42d5626b0379047e0b77388abbaa072691284a94769a92fde378e1ce539aee77.mp3',
          name: 'INT-ADV-Frog_Squats_with_Overhead_Reach-EXERCISE',
          description: null,
          size: 51223,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-FROG_SQUATS_WITH_OVERHEAD_REACH-EXERCISE': {
      id: 915,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Frog Squats with Overhead Reach',
      short_name: 'Frog Squats w Overhead Reach',
      unique_name: 'ADVANCED-FROG_SQUATS_WITH_OVERHEAD_REACH-EXERCISE',
      description:
        '1. Start with your feet wider than shoulder-width apart, toes turned out and your arms hanging down in front of you.\n2. Squat down as low as possible and lightly touch the floor between your feet.\n3. Drive through your heels and return to standing as you reach your arms up straight overhead.\n4. Bring your arms back down and immediately squat again.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2372,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '462f3e9b1191b5eede7c8316ad0e1eb07a3cdbb67734def281a75696345c4500',
          file_name:
            'videos/462f3e9b1191b5eede7c8316ad0e1eb07a3cdbb67734def281a75696345c4500.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/462f3e9b1191b5eede7c8316ad0e1eb07a3cdbb67734def281a75696345c4500.mp4',
          name: 'INT-ADV-Frog_Squats_with_Overhead_Reach-EXERCISE',
          description: null,
          size: 117109,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2373,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '42d5626b0379047e0b77388abbaa072691284a94769a92fde378e1ce539aee77',
          file_name:
            'audios/42d5626b0379047e0b77388abbaa072691284a94769a92fde378e1ce539aee77.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/42d5626b0379047e0b77388abbaa072691284a94769a92fde378e1ce539aee77.mp3',
          name: 'INT-ADV-Frog_Squats_with_Overhead_Reach-EXERCISE',
          description: null,
          size: 51223,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-BUTT_KICKERS-EXERCISE': {
      id: 916,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Butt Kickers',
      short_name: 'Butt Kickers',
      unique_name: 'BEGINNER-BUTT_KICKERS-EXERCISE',
      description:
        '1. Jog (or walk) in place, trying to kick your rear with each foot when it is bent behind you.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2374,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'd8e41780aeb1d7e418db87ff72c64674f72795eeb0895ad3ab6beb6a2fbf0132',
          file_name:
            'videos/d8e41780aeb1d7e418db87ff72c64674f72795eeb0895ad3ab6beb6a2fbf0132.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d8e41780aeb1d7e418db87ff72c64674f72795eeb0895ad3ab6beb6a2fbf0132.mp4',
          name: 'BEG-INT-ADV-Butt_Kickers-EXERCISE',
          description: null,
          size: 50971,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2375,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'c77db8f0fc1f73ad02e934c03ebf7b8a246285422c8dfbc61d9c93da44f36284',
          file_name:
            'audios/c77db8f0fc1f73ad02e934c03ebf7b8a246285422c8dfbc61d9c93da44f36284.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c77db8f0fc1f73ad02e934c03ebf7b8a246285422c8dfbc61d9c93da44f36284.mp3',
          name: 'BEG-INT-ADV-Butt_Kickers-EXERCISE',
          description: null,
          size: 20416,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-BUTT_KICKERS-EXERCISE': {
      id: 917,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Butt Kickers',
      short_name: 'Butt Kickers',
      unique_name: 'INTERMEDIATE-BUTT_KICKERS-EXERCISE',
      description:
        '1. Jog (or walk) in place, trying to kick your rear with each foot when it is bent behind you.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2376,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'd8e41780aeb1d7e418db87ff72c64674f72795eeb0895ad3ab6beb6a2fbf0132',
          file_name:
            'videos/d8e41780aeb1d7e418db87ff72c64674f72795eeb0895ad3ab6beb6a2fbf0132.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d8e41780aeb1d7e418db87ff72c64674f72795eeb0895ad3ab6beb6a2fbf0132.mp4',
          name: 'BEG-INT-ADV-Butt_Kickers-EXERCISE',
          description: null,
          size: 50971,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2377,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'c77db8f0fc1f73ad02e934c03ebf7b8a246285422c8dfbc61d9c93da44f36284',
          file_name:
            'audios/c77db8f0fc1f73ad02e934c03ebf7b8a246285422c8dfbc61d9c93da44f36284.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c77db8f0fc1f73ad02e934c03ebf7b8a246285422c8dfbc61d9c93da44f36284.mp3',
          name: 'BEG-INT-ADV-Butt_Kickers-EXERCISE',
          description: null,
          size: 20416,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-BUTT_KICKERS-EXERCISE': {
      id: 918,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Butt Kickers',
      short_name: 'Butt Kickers',
      unique_name: 'ADVANCED-BUTT_KICKERS-EXERCISE',
      description:
        '1. Jog (or walk) in place, trying to kick your rear with each foot when it is bent behind you.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2378,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'd8e41780aeb1d7e418db87ff72c64674f72795eeb0895ad3ab6beb6a2fbf0132',
          file_name:
            'videos/d8e41780aeb1d7e418db87ff72c64674f72795eeb0895ad3ab6beb6a2fbf0132.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d8e41780aeb1d7e418db87ff72c64674f72795eeb0895ad3ab6beb6a2fbf0132.mp4',
          name: 'BEG-INT-ADV-Butt_Kickers-EXERCISE',
          description: null,
          size: 50971,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2379,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'c77db8f0fc1f73ad02e934c03ebf7b8a246285422c8dfbc61d9c93da44f36284',
          file_name:
            'audios/c77db8f0fc1f73ad02e934c03ebf7b8a246285422c8dfbc61d9c93da44f36284.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c77db8f0fc1f73ad02e934c03ebf7b8a246285422c8dfbc61d9c93da44f36284.mp3',
          name: 'BEG-INT-ADV-Butt_Kickers-EXERCISE',
          description: null,
          size: 20416,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SUMO_SCISSORS-EXERCISE': {
      id: 919,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Sumo Scissors',
      short_name: 'Sumo Scissors',
      unique_name: 'BEGINNER-SUMO_SCISSORS-EXERCISE',
      description:
        '1. Stand with your feet together and elbows bent at 90 degrees by your sides.\n2. Jump up and perform 2 Scissor Feet, landing softly with one foot in front of the other. Take your arms with you as if you were running.\n3. After 2 Scissors, jump and land into a Sumo Squat, hands touch the floor.\n4. Jump again and repeat Scissors with the opposite foot forward. Alternate right and left lead each rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2380,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '6de12d2144d6d4f5934caec481ead883761b658bd9a4b229951fc66f1bb66079',
          file_name:
            'videos/6de12d2144d6d4f5934caec481ead883761b658bd9a4b229951fc66f1bb66079.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6de12d2144d6d4f5934caec481ead883761b658bd9a4b229951fc66f1bb66079.mp4',
          name: 'BEG-INT-ADV-Sumo_Scissors-EXERCISE',
          description: null,
          size: 185880,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2381,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'c535b1723b784ffc02cc8b0ffeac29542ff4039ad77c805b674f828f8acc93e4',
          file_name:
            'audios/c535b1723b784ffc02cc8b0ffeac29542ff4039ad77c805b674f828f8acc93e4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c535b1723b784ffc02cc8b0ffeac29542ff4039ad77c805b674f828f8acc93e4.mp3',
          name: 'BEG-INT-ADV-Sumo_Scissors-EXERCISE',
          description: null,
          size: 23692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SUMO_SCISSORS-EXERCISE': {
      id: 920,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Sumo Scissors',
      short_name: 'Sumo Scissors',
      unique_name: 'INTERMEDIATE-SUMO_SCISSORS-EXERCISE',
      description:
        '1. Stand with your feet together and elbows bent at 90 degrees by your sides.\n2. Jump up and perform 2 Scissor Feet, landing softly with one foot in front of the other. Take your arms with you as if you were running.\n3. After 2 Scissors, jump and land into a Sumo Squat, hands touch the floor.\n4. Jump again and repeat Scissors with the opposite foot forward. Alternate right and left lead each rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2382,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '6de12d2144d6d4f5934caec481ead883761b658bd9a4b229951fc66f1bb66079',
          file_name:
            'videos/6de12d2144d6d4f5934caec481ead883761b658bd9a4b229951fc66f1bb66079.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6de12d2144d6d4f5934caec481ead883761b658bd9a4b229951fc66f1bb66079.mp4',
          name: 'BEG-INT-ADV-Sumo_Scissors-EXERCISE',
          description: null,
          size: 185880,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2383,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'c535b1723b784ffc02cc8b0ffeac29542ff4039ad77c805b674f828f8acc93e4',
          file_name:
            'audios/c535b1723b784ffc02cc8b0ffeac29542ff4039ad77c805b674f828f8acc93e4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c535b1723b784ffc02cc8b0ffeac29542ff4039ad77c805b674f828f8acc93e4.mp3',
          name: 'BEG-INT-ADV-Sumo_Scissors-EXERCISE',
          description: null,
          size: 23692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SUMO_SCISSORS-EXERCISE': {
      id: 921,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Sumo Scissors',
      short_name: 'Sumo Scissors',
      unique_name: 'ADVANCED-SUMO_SCISSORS-EXERCISE',
      description:
        '1. Stand with your feet together and elbows bent at 90 degrees by your sides.\n2. Jump up and perform 2 Scissor Feet, landing softly with one foot in front of the other. Take your arms with you as if you were running.\n3. After 2 Scissors, jump and land into a Sumo Squat, hands touch the floor.\n4. Jump again and repeat Scissors with the opposite foot forward. Alternate right and left lead each rep.',
      preview_time: 10,
      min_app_version: 200070000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2384,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '6de12d2144d6d4f5934caec481ead883761b658bd9a4b229951fc66f1bb66079',
          file_name:
            'videos/6de12d2144d6d4f5934caec481ead883761b658bd9a4b229951fc66f1bb66079.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6de12d2144d6d4f5934caec481ead883761b658bd9a4b229951fc66f1bb66079.mp4',
          name: 'BEG-INT-ADV-Sumo_Scissors-EXERCISE',
          description: null,
          size: 185880,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2385,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'c535b1723b784ffc02cc8b0ffeac29542ff4039ad77c805b674f828f8acc93e4',
          file_name:
            'audios/c535b1723b784ffc02cc8b0ffeac29542ff4039ad77c805b674f828f8acc93e4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c535b1723b784ffc02cc8b0ffeac29542ff4039ad77c805b674f828f8acc93e4.mp3',
          name: 'BEG-INT-ADV-Sumo_Scissors-EXERCISE',
          description: null,
          size: 23692,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-NEGATIVE_LEG_DROPS-EXERCISE': {
      id: 930,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Negative Leg Drops',
      short_name: 'Negative Leg Drops',
      unique_name: 'INTERMEDIATE-NEGATIVE_LEG_DROPS-EXERCISE',
      description:
        '1. Lie on your back. Place your arms by your sides, palms facing down. Raise both legs straight up over your hips. \n2. Lift your hips off the floor and raise your feet straight up to the ceiling. \n3. Lower your hips back down, then drop both legs slowly towards the floor as low as possible while still maintaining a lower back connection to the floor. \n4. Raise both legs back up to the starting position.',
      preview_time: 10,
      min_app_version: 200080000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2396,
          collection_name: 'videos',
          order: 1,
          version: 200080000,
          hash: '07013fa3a8b508f89dad617d25fe88ba0c239eca34d4da832a8b42b9288dbd96',
          file_name:
            'videos/07013fa3a8b508f89dad617d25fe88ba0c239eca34d4da832a8b42b9288dbd96.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/07013fa3a8b508f89dad617d25fe88ba0c239eca34d4da832a8b42b9288dbd96.mp4',
          name: 'INT-ADV-Negative_Leg_Drops-EXERCISE',
          description: null,
          size: 152426,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2397,
          collection_name: 'audios',
          order: 1,
          version: 200080000,
          hash: '39dcb542c7f20d161eee9f5330dd02a239fc4f9bbdf628594d0dbcda55f83775',
          file_name:
            'audios/39dcb542c7f20d161eee9f5330dd02a239fc4f9bbdf628594d0dbcda55f83775.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/39dcb542c7f20d161eee9f5330dd02a239fc4f9bbdf628594d0dbcda55f83775.mp3',
          name: 'INT-ADV-Negative_Leg_Drops-EXERCISE',
          description: null,
          size: 28252,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-NEGATIVE_LEG_DROPS-EXERCISE': {
      id: 931,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Negative Leg Drops',
      short_name: 'Negative Leg Drops',
      unique_name: 'ADVANCED-NEGATIVE_LEG_DROPS-EXERCISE',
      description:
        '1. Lie on your back. Place your arms by your sides, palms facing down. Raise both legs straight up over your hips. \n2. Lift your hips off the floor and raise your feet straight up to the ceiling. \n3. Lower your hips back down, then drop both legs slowly towards the floor as low as possible while still maintaining a lower back connection to the floor. \n4. Raise both legs back up to the starting position.',
      preview_time: 10,
      min_app_version: 200080000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2398,
          collection_name: 'videos',
          order: 1,
          version: 200080000,
          hash: '07013fa3a8b508f89dad617d25fe88ba0c239eca34d4da832a8b42b9288dbd96',
          file_name:
            'videos/07013fa3a8b508f89dad617d25fe88ba0c239eca34d4da832a8b42b9288dbd96.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/07013fa3a8b508f89dad617d25fe88ba0c239eca34d4da832a8b42b9288dbd96.mp4',
          name: 'INT-ADV-Negative_Leg_Drops-EXERCISE',
          description: null,
          size: 152426,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2399,
          collection_name: 'audios',
          order: 1,
          version: 200080000,
          hash: '39dcb542c7f20d161eee9f5330dd02a239fc4f9bbdf628594d0dbcda55f83775',
          file_name:
            'audios/39dcb542c7f20d161eee9f5330dd02a239fc4f9bbdf628594d0dbcda55f83775.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/39dcb542c7f20d161eee9f5330dd02a239fc4f9bbdf628594d0dbcda55f83775.mp3',
          name: 'INT-ADV-Negative_Leg_Drops-EXERCISE',
          description: null,
          size: 28252,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-INCHWORMS-EXERCISE': {
      id: 932,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Inchworms',
      short_name: 'Inchworms',
      unique_name: 'BEGINNER-INCHWORMS-EXERCISE',
      description:
        '1. From a standing position, bend from your hips until your hands reach the floor. (You can bend you knees if necessary). \n2. Walk your hands out in front of you until you are in Plank position. Pause for a beat. \n3. Walk your hands back to your feet, keeping your legs as straight as possible. \n4. Return to standing. Repeat.',
      preview_time: 10,
      min_app_version: 200080000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2400,
          collection_name: 'videos',
          order: 1,
          version: 200080000,
          hash: '6ba441151d540a95f65a8563893e89de0b973f61e39dcc3ba0cdd478de2fc095',
          file_name:
            'videos/6ba441151d540a95f65a8563893e89de0b973f61e39dcc3ba0cdd478de2fc095.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6ba441151d540a95f65a8563893e89de0b973f61e39dcc3ba0cdd478de2fc095.mp4',
          name: 'BEG-INT-ADV-Inchworms-EXERCISE',
          description: null,
          size: 347981,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2401,
          collection_name: 'audios',
          order: 1,
          version: 200080000,
          hash: '803eb7821843d5355c96a602906432377b01d5f28313d60b9ced43f6593f4eb3',
          file_name:
            'audios/803eb7821843d5355c96a602906432377b01d5f28313d60b9ced43f6593f4eb3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/803eb7821843d5355c96a602906432377b01d5f28313d60b9ced43f6593f4eb3.mp3',
          name: 'BEG-INT-ADV-Inchworms-EXERCISE',
          description: null,
          size: 19038,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-INCHWORMS-EXERCISE': {
      id: 933,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Inchworms',
      short_name: 'Inchworms',
      unique_name: 'INTERMEDIATE-INCHWORMS-EXERCISE',
      description:
        '1. From a standing position, bend from your hips until your hands reach the floor. (You can bend you knees if necessary). \n2. Walk your hands out in front of you until you are in Plank position. Pause for a beat. \n3. Walk your hands back to your feet, keeping your legs as straight as possible. \n4. Return to standing. Repeat.',
      preview_time: 10,
      min_app_version: 200080000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2402,
          collection_name: 'videos',
          order: 1,
          version: 200080000,
          hash: '6ba441151d540a95f65a8563893e89de0b973f61e39dcc3ba0cdd478de2fc095',
          file_name:
            'videos/6ba441151d540a95f65a8563893e89de0b973f61e39dcc3ba0cdd478de2fc095.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6ba441151d540a95f65a8563893e89de0b973f61e39dcc3ba0cdd478de2fc095.mp4',
          name: 'BEG-INT-ADV-Inchworms-EXERCISE',
          description: null,
          size: 347981,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2403,
          collection_name: 'audios',
          order: 1,
          version: 200080000,
          hash: '803eb7821843d5355c96a602906432377b01d5f28313d60b9ced43f6593f4eb3',
          file_name:
            'audios/803eb7821843d5355c96a602906432377b01d5f28313d60b9ced43f6593f4eb3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/803eb7821843d5355c96a602906432377b01d5f28313d60b9ced43f6593f4eb3.mp3',
          name: 'BEG-INT-ADV-Inchworms-EXERCISE',
          description: null,
          size: 19038,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-INCHWORMS-EXERCISE': {
      id: 934,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Inchworms',
      short_name: 'Inchworms',
      unique_name: 'ADVANCED-INCHWORMS-EXERCISE',
      description:
        '1. From a standing position, bend from your hips until your hands reach the floor. (You can bend you knees if necessary). \n2. Walk your hands out in front of you until you are in Plank position. Pause for a beat. \n3. Walk your hands back to your feet, keeping your legs as straight as possible. \n4. Return to standing. Repeat.',
      preview_time: 10,
      min_app_version: 200080000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2404,
          collection_name: 'videos',
          order: 1,
          version: 200080000,
          hash: '6ba441151d540a95f65a8563893e89de0b973f61e39dcc3ba0cdd478de2fc095',
          file_name:
            'videos/6ba441151d540a95f65a8563893e89de0b973f61e39dcc3ba0cdd478de2fc095.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6ba441151d540a95f65a8563893e89de0b973f61e39dcc3ba0cdd478de2fc095.mp4',
          name: 'BEG-INT-ADV-Inchworms-EXERCISE',
          description: null,
          size: 347981,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2405,
          collection_name: 'audios',
          order: 1,
          version: 200080000,
          hash: '803eb7821843d5355c96a602906432377b01d5f28313d60b9ced43f6593f4eb3',
          file_name:
            'audios/803eb7821843d5355c96a602906432377b01d5f28313d60b9ced43f6593f4eb3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/803eb7821843d5355c96a602906432377b01d5f28313d60b9ced43f6593f4eb3.mp3',
          name: 'BEG-INT-ADV-Inchworms-EXERCISE',
          description: null,
          size: 19038,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-INCLINE_PUSH_UPS-EXERCISE': {
      id: 935,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Incline Push-Ups',
      short_name: 'Incline Push-Ups',
      unique_name: 'INTERMEDIATE-INCLINE_PUSH_UPS-EXERCISE',
      description:
        '1. Start in Incline Plank position. Place your hands on the end of a step, shoulders over wrists. Legs extended and the balls of your feet on the floor. \n2. Bend your elbows, pointing them back toward your hips. Lower your body so the center of your chest meets the edge of the step. \n3. Straighten your arms and raise your body back up in one long line from the crown of your head to your tailbone.',
      preview_time: 10,
      min_app_version: 200080000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2406,
          collection_name: 'videos',
          order: 1,
          version: 200080000,
          hash: '29966b3e6e7645e47305fe715919af3ed9917876ae8d84165bcda1fcbacaa2c5',
          file_name:
            'videos/29966b3e6e7645e47305fe715919af3ed9917876ae8d84165bcda1fcbacaa2c5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/29966b3e6e7645e47305fe715919af3ed9917876ae8d84165bcda1fcbacaa2c5.mp4',
          name: 'INTERMEDIATE-Incline_Push_Ups-EXERCISE',
          description: null,
          size: 103178,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2407,
          collection_name: 'audios',
          order: 1,
          version: 200080000,
          hash: '3d66a2220e867ce7bc291266dd2564c4ca4c07ddb02d4c28e6381b35ff2ed126',
          file_name:
            'audios/3d66a2220e867ce7bc291266dd2564c4ca4c07ddb02d4c28e6381b35ff2ed126.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3d66a2220e867ce7bc291266dd2564c4ca4c07ddb02d4c28e6381b35ff2ed126.mp3',
          name: 'INTERMEDIATE-Incline_Push_Ups-EXERCISE',
          description: null,
          size: 25063,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-IMAGINARY_JUMP_ROPE-EXERCISE': {
      id: 936,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Imaginary Jump Rope',
      short_name: 'Imaginary Jump Rope',
      unique_name: 'BEGINNER-IMAGINARY_JUMP_ROPE-EXERCISE',
      description:
        '1. Stand with your feet roughly shoulder-width apart. Keep your chest up and core tight. Arms are at your sides and fists are by your hips as if you were holding a jump rope. \n2. Keep your elbows close to your sides, circle your wrists back and then forward. \n3. Hop up in the air with both feet when your wrists are in a front of your hips. Land soft and repeat in a continuous rhythm.',
      preview_time: 10,
      min_app_version: 200080000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2408,
          collection_name: 'videos',
          order: 1,
          version: 200080000,
          hash: 'd23e43c740dc72ac94c15e557bd407e4f12ca349a46f6e1d5ff318ab0e20af1e',
          file_name:
            'videos/d23e43c740dc72ac94c15e557bd407e4f12ca349a46f6e1d5ff318ab0e20af1e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d23e43c740dc72ac94c15e557bd407e4f12ca349a46f6e1d5ff318ab0e20af1e.mp4',
          name: 'BEG-FSTEP-Imaginary_Jump_Rope-EXERCISE',
          description: null,
          size: 22866,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2409,
          collection_name: 'audios',
          order: 1,
          version: 200080000,
          hash: 'ed0a4ddaf9252085b634e378460926ce825eb620c880afa6245197190afc2cba',
          file_name:
            'audios/ed0a4ddaf9252085b634e378460926ce825eb620c880afa6245197190afc2cba.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ed0a4ddaf9252085b634e378460926ce825eb620c880afa6245197190afc2cba.mp3',
          name: 'BEG-FSTEP-Imaginary_Jump_Rope-EXERCISE',
          description: null,
          size: 9683,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SLOW_OUTSIDE_MOUNTAIN_CLIMBERS-EXERCISE': {
      id: 937,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Slow Outside Mountain Climbers',
      short_name: 'Slow Outside Mountain Climbers',
      unique_name: 'BEGINNER-SLOW_OUTSIDE_MOUNTAIN_CLIMBERS-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Bring one knee out to the side and as close to the same side tricep as possible. Pause for a beat.\n3. Move your leg back and return to Plank position.\n4. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 200080000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2410,
          collection_name: 'videos',
          order: 1,
          version: 200080000,
          hash: '8385de1ce197eaa749cdd04d4b40a4e3685c72162e50a320c88d153f7db099f1',
          file_name:
            'videos/8385de1ce197eaa749cdd04d4b40a4e3685c72162e50a320c88d153f7db099f1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8385de1ce197eaa749cdd04d4b40a4e3685c72162e50a320c88d153f7db099f1.mp4',
          name: 'BEG-INT-ADV-Slow_Outside_Mountain_Climbers-EXERCISE',
          description: null,
          size: 146660,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2411,
          collection_name: 'audios',
          order: 1,
          version: 200080000,
          hash: '792561ac68bd8365be3aabea6eb4c708e8ac8fcdeabca2caef4fa3669316d2c1',
          file_name:
            'audios/792561ac68bd8365be3aabea6eb4c708e8ac8fcdeabca2caef4fa3669316d2c1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/792561ac68bd8365be3aabea6eb4c708e8ac8fcdeabca2caef4fa3669316d2c1.mp3',
          name: 'BEG-INT-ADV-Slow_Outside_Mountain_Climbers-EXERCISE',
          description: null,
          size: 34529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SLOW_OUTSIDE_MOUNTAIN_CLIMBERS-EXERCISE': {
      id: 938,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Slow Outside Mountain Climbers',
      short_name: 'Slow Outside Mountain Climbers',
      unique_name: 'INTERMEDIATE-SLOW_OUTSIDE_MOUNTAIN_CLIMBERS-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Bring one knee out to the side and as close to the same side tricep as possible. Pause for a beat.\n3. Move your leg back and return to Plank position.\n4. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 200080000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2412,
          collection_name: 'videos',
          order: 1,
          version: 200080000,
          hash: '8385de1ce197eaa749cdd04d4b40a4e3685c72162e50a320c88d153f7db099f1',
          file_name:
            'videos/8385de1ce197eaa749cdd04d4b40a4e3685c72162e50a320c88d153f7db099f1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8385de1ce197eaa749cdd04d4b40a4e3685c72162e50a320c88d153f7db099f1.mp4',
          name: 'BEG-INT-ADV-Slow_Outside_Mountain_Climbers-EXERCISE',
          description: null,
          size: 146660,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2413,
          collection_name: 'audios',
          order: 1,
          version: 200080000,
          hash: '792561ac68bd8365be3aabea6eb4c708e8ac8fcdeabca2caef4fa3669316d2c1',
          file_name:
            'audios/792561ac68bd8365be3aabea6eb4c708e8ac8fcdeabca2caef4fa3669316d2c1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/792561ac68bd8365be3aabea6eb4c708e8ac8fcdeabca2caef4fa3669316d2c1.mp3',
          name: 'BEG-INT-ADV-Slow_Outside_Mountain_Climbers-EXERCISE',
          description: null,
          size: 34529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SLOW_OUTSIDE_MOUNTAIN_CLIMBERS-EXERCISE': {
      id: 939,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Slow Outside Mountain Climbers',
      short_name: 'Slow Outside Mountain Climbers',
      unique_name: 'ADVANCED-SLOW_OUTSIDE_MOUNTAIN_CLIMBERS-EXERCISE',
      description:
        '1. Start in Plank position.\n2. Bring one knee out to the side and as close to the same side tricep as possible. Pause for a beat.\n3. Move your leg back and return to Plank position.\n4. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 200080000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2414,
          collection_name: 'videos',
          order: 1,
          version: 200080000,
          hash: '8385de1ce197eaa749cdd04d4b40a4e3685c72162e50a320c88d153f7db099f1',
          file_name:
            'videos/8385de1ce197eaa749cdd04d4b40a4e3685c72162e50a320c88d153f7db099f1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8385de1ce197eaa749cdd04d4b40a4e3685c72162e50a320c88d153f7db099f1.mp4',
          name: 'BEG-INT-ADV-Slow_Outside_Mountain_Climbers-EXERCISE',
          description: null,
          size: 146660,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2415,
          collection_name: 'audios',
          order: 1,
          version: 200080000,
          hash: '792561ac68bd8365be3aabea6eb4c708e8ac8fcdeabca2caef4fa3669316d2c1',
          file_name:
            'audios/792561ac68bd8365be3aabea6eb4c708e8ac8fcdeabca2caef4fa3669316d2c1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/792561ac68bd8365be3aabea6eb4c708e8ac8fcdeabca2caef4fa3669316d2c1.mp3',
          name: 'BEG-INT-ADV-Slow_Outside_Mountain_Climbers-EXERCISE',
          description: null,
          size: 34529,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_LATERAL_PLANK_WALK_WITH_ARMS-EXERCISE': {
      id: 940,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Mini Band Lateral Plank Walk with Arms',
      short_name: 'Band Lateral Plank Walks w Arms',
      unique_name:
        'INTERMEDIATE-MINI_BAND_LATERAL_PLANK_WALK_WITH_ARMS-EXERCISE',
      description:
        '1. Start in Plank position with a Mini Band around wrists, hands slightly wider than shoulders, feet close together, hips square.\n2. Step one foot to the side in a wide "V" as you move opposite hand in, placing palm under shoulder.\n3. Continue moving laterally by stepping opposite foot in to meet the first and stepping opposite hand wide.\n4. Reverse and travel back to start. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2416,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'b133a17a8218a11d7a12b866684bafbd5322b0394914dcccbee5c6eb9f6c3d7f',
          file_name:
            'videos/b133a17a8218a11d7a12b866684bafbd5322b0394914dcccbee5c6eb9f6c3d7f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b133a17a8218a11d7a12b866684bafbd5322b0394914dcccbee5c6eb9f6c3d7f.mp4',
          name: 'INT-ADV-Mini_Band_Lateral_Plank_Walk_With_Arms-EXERCISE',
          description: null,
          size: 86053,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2417,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'bb8e1ecebc226d07f8cd484f107be5f030416859e89b2e5f125cd304f2df23be',
          file_name:
            'audios/bb8e1ecebc226d07f8cd484f107be5f030416859e89b2e5f125cd304f2df23be.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/bb8e1ecebc226d07f8cd484f107be5f030416859e89b2e5f125cd304f2df23be.mp3',
          name: 'INT-ADV-Mini_Band_Lateral_Plank_Walk_With_Arms-EXERCISE',
          description: null,
          size: 52060,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_LATERAL_PLANK_WALK_WITH_ARMS-EXERCISE': {
      id: 941,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Mini Band Lateral Plank Walk with Arms',
      short_name: 'Band Lateral Plank Walks w Arms',
      unique_name: 'ADVANCED-MINI_BAND_LATERAL_PLANK_WALK_WITH_ARMS-EXERCISE',
      description:
        '1. Start in Plank position with a Mini Band around wrists, hands slightly wider than shoulders, feet close together, hips square.\n2. Step one foot to the side in a wide "V" as you move opposite hand in, placing palm under shoulder.\n3. Continue moving laterally by stepping opposite foot in to meet the first and stepping opposite hand wide.\n4. Reverse and travel back to start. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2418,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'b133a17a8218a11d7a12b866684bafbd5322b0394914dcccbee5c6eb9f6c3d7f',
          file_name:
            'videos/b133a17a8218a11d7a12b866684bafbd5322b0394914dcccbee5c6eb9f6c3d7f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b133a17a8218a11d7a12b866684bafbd5322b0394914dcccbee5c6eb9f6c3d7f.mp4',
          name: 'INT-ADV-Mini_Band_Lateral_Plank_Walk_With_Arms-EXERCISE',
          description: null,
          size: 86053,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2419,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'bb8e1ecebc226d07f8cd484f107be5f030416859e89b2e5f125cd304f2df23be',
          file_name:
            'audios/bb8e1ecebc226d07f8cd484f107be5f030416859e89b2e5f125cd304f2df23be.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/bb8e1ecebc226d07f8cd484f107be5f030416859e89b2e5f125cd304f2df23be.mp3',
          name: 'INT-ADV-Mini_Band_Lateral_Plank_Walk_With_Arms-EXERCISE',
          description: null,
          size: 52060,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_IN-_OUT_PLANK_STEPS_WITH_ARMS-EXERCISE': {
      id: 942,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Mini Band In-Out Plank Steps with Arms',
      short_name: 'Band In-Out Steps with Arms',
      unique_name:
        'INTERMEDIATE-MINI_BAND_IN-_OUT_PLANK_STEPS_WITH_ARMS-EXERCISE',
      description:
        '1. Start in Plank position with a Mini Band around wrists, shoulders over wrists, hips square.\n2. Step one hand to the side and place palm outside shoulder.\n3. Step other hand to opposite side, feeling the resistance of the band.\n4. Leading with the first side, step both hands in one at a time and place palms underneath shoulders in Plank position.\n5. Reverse leading with the other arm. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2420,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '0231da96b67b198a82d082a36c937466729173541fd2a2badde2288bda6ad9b4',
          file_name:
            'videos/0231da96b67b198a82d082a36c937466729173541fd2a2badde2288bda6ad9b4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0231da96b67b198a82d082a36c937466729173541fd2a2badde2288bda6ad9b4.mp4',
          name: 'INT-ADV-Mini_Band_In-Out_Plank_Steps_With_Arms-EXERCISE',
          description: null,
          size: 94570,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2421,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '251d124155b19139afb477b6cc1077902be5f7db90881008d86f5d08f945451f',
          file_name:
            'audios/251d124155b19139afb477b6cc1077902be5f7db90881008d86f5d08f945451f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/251d124155b19139afb477b6cc1077902be5f7db90881008d86f5d08f945451f.mp3',
          name: 'INT-ADV-Mini_Band_In-Out_Plank_Steps_With_Arms-EXERCISE',
          description: null,
          size: 42756,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_IN-_OUT_PLANK_STEPS_WITH_ARMS-EXERCISE': {
      id: 943,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Mini Band In-Out Plank Steps with Arms',
      short_name: 'Band In-Out Steps with Arms',
      unique_name: 'ADVANCED-MINI_BAND_IN-_OUT_PLANK_STEPS_WITH_ARMS-EXERCISE',
      description:
        '1. Start in Plank position with a Mini Band around wrists, shoulders over wrists, hips square.\n2. Step one hand to the side and place palm outside shoulder.\n3. Step other hand to opposite side, feeling the resistance of the band.\n4. Leading with the first side, step both hands in one at a time and place palms underneath shoulders in Plank position.\n5. Reverse leading with the other arm. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2422,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '0231da96b67b198a82d082a36c937466729173541fd2a2badde2288bda6ad9b4',
          file_name:
            'videos/0231da96b67b198a82d082a36c937466729173541fd2a2badde2288bda6ad9b4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0231da96b67b198a82d082a36c937466729173541fd2a2badde2288bda6ad9b4.mp4',
          name: 'INT-ADV-Mini_Band_In-Out_Plank_Steps_With_Arms-EXERCISE',
          description: null,
          size: 94570,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2423,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '251d124155b19139afb477b6cc1077902be5f7db90881008d86f5d08f945451f',
          file_name:
            'audios/251d124155b19139afb477b6cc1077902be5f7db90881008d86f5d08f945451f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/251d124155b19139afb477b6cc1077902be5f7db90881008d86f5d08f945451f.mp3',
          name: 'INT-ADV-Mini_Band_In-Out_Plank_Steps_With_Arms-EXERCISE',
          description: null,
          size: 42756,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_STANDING_STRAIGHT_LEG_GLUTE_LIFTS-EXERCISE': {
      id: 944,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Standing Straight Leg Glute Lifts',
      short_name: 'Band Straight Leg Glute Lifts',
      unique_name:
        'INTERMEDIATE-MINI_BAND_STANDING_STRAIGHT_LEG_GLUTE_LIFTS-EXERCISE',
      description:
        '1. Stand in a close stance with a Mini Band around your ankles. Place hands on hips or hold onto a chair or wall for assistance.\n2. Keeping hips square and thighs parallel, lift one leg straight back behind you, toes point toward the floor. Squeeze glutes at the top. Do not arch low back.\n3. Control the band back to start.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2424,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '65d348d0abcff07db4f312eb1d05880cdb655dca78c6b75898b234a23dad124b',
          file_name:
            'videos/65d348d0abcff07db4f312eb1d05880cdb655dca78c6b75898b234a23dad124b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/65d348d0abcff07db4f312eb1d05880cdb655dca78c6b75898b234a23dad124b.mp4',
          name: 'INT-ADV-Mini_Band_Standing_Straight_Leg_Glute_Lifts-EXERCISE-LEFT',
          description: 'Left Side',
          size: 43132,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2425,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'bfba225b279fd02760a307dd3e27565846e6451556ef7df8c95a075e50d2016c',
          file_name:
            'videos/bfba225b279fd02760a307dd3e27565846e6451556ef7df8c95a075e50d2016c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bfba225b279fd02760a307dd3e27565846e6451556ef7df8c95a075e50d2016c.mp4',
          name: 'INT-ADV-Mini_Band_Standing_Straight_Leg_Glute_Lifts-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 39926,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2426,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'b6626959bbe6a28a38cca8658e13be3c28d1d58dfaf98b4985eaa8280fd47bf1',
          file_name:
            'audios/b6626959bbe6a28a38cca8658e13be3c28d1d58dfaf98b4985eaa8280fd47bf1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b6626959bbe6a28a38cca8658e13be3c28d1d58dfaf98b4985eaa8280fd47bf1.mp3',
          name: 'INT-ADV-Mini_Band_Standing_Straight_Leg_Glute_Lifts-EXERCISE',
          description: null,
          size: 39961,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_STANDING_STRAIGHT_LEG_GLUTE_LIFTS-EXERCISE': {
      id: 945,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Standing Straight Leg Glute Lifts',
      short_name: 'Band Straight Leg Glute Lifts',
      unique_name:
        'ADVANCED-MINI_BAND_STANDING_STRAIGHT_LEG_GLUTE_LIFTS-EXERCISE',
      description:
        '1. Stand in a close stance with a Mini Band around your ankles. Place hands on hips or hold onto a chair or wall for assistance.\n2. Keeping hips square and thighs parallel, lift one leg straight back behind you, toes point toward the floor. Squeeze glutes at the top. Do not arch low back.\n3. Control the band back to start.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2427,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '65d348d0abcff07db4f312eb1d05880cdb655dca78c6b75898b234a23dad124b',
          file_name:
            'videos/65d348d0abcff07db4f312eb1d05880cdb655dca78c6b75898b234a23dad124b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/65d348d0abcff07db4f312eb1d05880cdb655dca78c6b75898b234a23dad124b.mp4',
          name: 'INT-ADV-Mini_Band_Standing_Straight_Leg_Glute_Lifts-EXERCISE-LEFT',
          description: 'Left Side',
          size: 43132,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2428,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'bfba225b279fd02760a307dd3e27565846e6451556ef7df8c95a075e50d2016c',
          file_name:
            'videos/bfba225b279fd02760a307dd3e27565846e6451556ef7df8c95a075e50d2016c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bfba225b279fd02760a307dd3e27565846e6451556ef7df8c95a075e50d2016c.mp4',
          name: 'INT-ADV-Mini_Band_Standing_Straight_Leg_Glute_Lifts-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 39926,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2429,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'b6626959bbe6a28a38cca8658e13be3c28d1d58dfaf98b4985eaa8280fd47bf1',
          file_name:
            'audios/b6626959bbe6a28a38cca8658e13be3c28d1d58dfaf98b4985eaa8280fd47bf1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b6626959bbe6a28a38cca8658e13be3c28d1d58dfaf98b4985eaa8280fd47bf1.mp3',
          name: 'INT-ADV-Mini_Band_Standing_Straight_Leg_Glute_Lifts-EXERCISE',
          description: null,
          size: 39961,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_LOW_SQUAT_TAP_OUTS-EXERCISE': {
      id: 946,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Low Squat Tap Outs',
      short_name: 'Mini Band Low Squat Tap Outs',
      unique_name: 'INTERMEDIATE-MINI_BAND_LOW_SQUAT_TAP_OUTS-EXERCISE',
      description:
        '1. Place a Mini Band around your ankles and stand with your feet close together.\n2. Bend your knees, drop your hips and sink into a narrow squat.\n3. Staying low, tap one toe out to the side using the resistance of the band.\n4. Control the band as you return to the center.\n5. Perform all reps on one leg. Repeat other side. ',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2430,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '8e66b3e7eff538e4ed0e638cb1305c822eeb30f9d4146225c1c19d2e409df8c1',
          file_name:
            'videos/8e66b3e7eff538e4ed0e638cb1305c822eeb30f9d4146225c1c19d2e409df8c1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8e66b3e7eff538e4ed0e638cb1305c822eeb30f9d4146225c1c19d2e409df8c1.mp4',
          name: 'INT-ADV-Mini_Band_Low_Squat_Tap_Outs-EXERCISE-LEFT',
          description: 'Left Side',
          size: 57695,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2431,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'c536741507469edb040aa523c3a68be65f08879ad74bf7fe357c07fce8482c2c',
          file_name:
            'videos/c536741507469edb040aa523c3a68be65f08879ad74bf7fe357c07fce8482c2c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c536741507469edb040aa523c3a68be65f08879ad74bf7fe357c07fce8482c2c.mp4',
          name: 'INT-ADV-Mini_Band_Low_Squat_Tap_Outs-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 60363,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2432,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '27b45b285469b090821637f9d55d1d3adc9fe66b624b963bac475323d23f5f25',
          file_name:
            'audios/27b45b285469b090821637f9d55d1d3adc9fe66b624b963bac475323d23f5f25.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/27b45b285469b090821637f9d55d1d3adc9fe66b624b963bac475323d23f5f25.mp3',
          name: 'INT-ADV-Mini_Band_Low_Squat_Tap_Outs-EXERCISE',
          description: null,
          size: 36790,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_LOW_SQUAT_TAP_OUTS-EXERCISE': {
      id: 947,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Low Squat Tap Outs',
      short_name: 'Mini Band Low Squat Tap Outs',
      unique_name: 'ADVANCED-MINI_BAND_LOW_SQUAT_TAP_OUTS-EXERCISE',
      description:
        '1. Place a Mini Band around your ankles and stand with your feet close together.\n2. Bend your knees, drop your hips and sink into a narrow squat.\n3. Staying low, tap one toe out to the side using the resistance of the band.\n4. Control the band as you return to the center.\n5. Perform all reps on one leg. Repeat other side. ',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2433,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '8e66b3e7eff538e4ed0e638cb1305c822eeb30f9d4146225c1c19d2e409df8c1',
          file_name:
            'videos/8e66b3e7eff538e4ed0e638cb1305c822eeb30f9d4146225c1c19d2e409df8c1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8e66b3e7eff538e4ed0e638cb1305c822eeb30f9d4146225c1c19d2e409df8c1.mp4',
          name: 'INT-ADV-Mini_Band_Low_Squat_Tap_Outs-EXERCISE-LEFT',
          description: 'Left Side',
          size: 57695,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2434,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'c536741507469edb040aa523c3a68be65f08879ad74bf7fe357c07fce8482c2c',
          file_name:
            'videos/c536741507469edb040aa523c3a68be65f08879ad74bf7fe357c07fce8482c2c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c536741507469edb040aa523c3a68be65f08879ad74bf7fe357c07fce8482c2c.mp4',
          name: 'INT-ADV-Mini_Band_Low_Squat_Tap_Outs-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 60363,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2435,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '27b45b285469b090821637f9d55d1d3adc9fe66b624b963bac475323d23f5f25',
          file_name:
            'audios/27b45b285469b090821637f9d55d1d3adc9fe66b624b963bac475323d23f5f25.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/27b45b285469b090821637f9d55d1d3adc9fe66b624b963bac475323d23f5f25.mp3',
          name: 'INT-ADV-Mini_Band_Low_Squat_Tap_Outs-EXERCISE',
          description: null,
          size: 36790,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_LOW_SQUAT_TAP_BACKS-EXERCISE': {
      id: 948,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Low Squat Tap Backs',
      short_name: 'Mini Band Low Squat Tap Backs',
      unique_name: 'INTERMEDIATE-MINI_BAND_LOW_SQUAT_TAP_BACKS-EXERCISE',
      description:
        '1. Place a Mini Band around your ankles and stand with your feet close together.\n2. Bend your knees, drop your hips and sink into a narrow squat.\n3. Staying low, tap one toe directly behind you, using the resistance of the band to strengthen your hamstrings and glutes.\n4. Control the band as you return your foot back to center.\n5. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2436,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'db73a920c96ce52c66231e8adf313b221ce6bd16410a336ba8e1b4c60c8cb437',
          file_name:
            'videos/db73a920c96ce52c66231e8adf313b221ce6bd16410a336ba8e1b4c60c8cb437.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/db73a920c96ce52c66231e8adf313b221ce6bd16410a336ba8e1b4c60c8cb437.mp4',
          name: 'INT-ADV-Mini_Band_Low_Squat_Tap_Backs-EXERCISE-LEFT',
          description: 'Left Side',
          size: 55692,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2437,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'a86f02190c283665416ec8ca730ba60c66c52e424fe2213ec389adfb6135366c',
          file_name:
            'videos/a86f02190c283665416ec8ca730ba60c66c52e424fe2213ec389adfb6135366c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a86f02190c283665416ec8ca730ba60c66c52e424fe2213ec389adfb6135366c.mp4',
          name: 'INT-ADV-Mini_Band_Low_Squat_Tap_Backs-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 55007,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2438,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '272ddfd506512477f7805adf818cad6bfc94a10b94037a1352f373050fc83627',
          file_name:
            'audios/272ddfd506512477f7805adf818cad6bfc94a10b94037a1352f373050fc83627.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/272ddfd506512477f7805adf818cad6bfc94a10b94037a1352f373050fc83627.mp3',
          name: 'INT-ADV-Mini_Band_Low_Squat_Tap_Backs-EXERCISE',
          description: null,
          size: 36985,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_LOW_SQUAT_TAP_BACKS-EXERCISE': {
      id: 949,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Low Squat Tap Backs',
      short_name: 'Mini Band Low Squat Tap Backs',
      unique_name: 'ADVANCED-MINI_BAND_LOW_SQUAT_TAP_BACKS-EXERCISE',
      description:
        '1. Place a Mini Band around your ankles and stand with your feet close together.\n2. Bend your knees, drop your hips and sink into a narrow squat.\n3. Staying low, tap one toe directly behind you, using the resistance of the band to strengthen your hamstrings and glutes.\n4. Control the band as you return your foot back to center.\n5. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2439,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'db73a920c96ce52c66231e8adf313b221ce6bd16410a336ba8e1b4c60c8cb437',
          file_name:
            'videos/db73a920c96ce52c66231e8adf313b221ce6bd16410a336ba8e1b4c60c8cb437.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/db73a920c96ce52c66231e8adf313b221ce6bd16410a336ba8e1b4c60c8cb437.mp4',
          name: 'INT-ADV-Mini_Band_Low_Squat_Tap_Backs-EXERCISE-LEFT',
          description: 'Left Side',
          size: 55692,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2440,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'a86f02190c283665416ec8ca730ba60c66c52e424fe2213ec389adfb6135366c',
          file_name:
            'videos/a86f02190c283665416ec8ca730ba60c66c52e424fe2213ec389adfb6135366c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a86f02190c283665416ec8ca730ba60c66c52e424fe2213ec389adfb6135366c.mp4',
          name: 'INT-ADV-Mini_Band_Low_Squat_Tap_Backs-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 55007,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2441,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '272ddfd506512477f7805adf818cad6bfc94a10b94037a1352f373050fc83627',
          file_name:
            'audios/272ddfd506512477f7805adf818cad6bfc94a10b94037a1352f373050fc83627.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/272ddfd506512477f7805adf818cad6bfc94a10b94037a1352f373050fc83627.mp3',
          name: 'INT-ADV-Mini_Band_Low_Squat_Tap_Backs-EXERCISE',
          description: null,
          size: 36985,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_STANDING_HIP_ABDUCTIONS-EXERCISE': {
      id: 950,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Standing Hip Abductions',
      short_name: 'Band Hip Abductions',
      unique_name: 'INTERMEDIATE-MINI_BAND_STANDING_HIP_ABDUCTIONS-EXERCISE',
      description:
        '1. Place a Mini Band around your ankles and stand with feet hip-width apart. Keep toes forward and core tight.\n2. Using the resistance of the band, lift one leg out to the side, keeping hips square, knees and toes forward. Only lift as far as you can without opening your hip and over rotating.\n3. Pause and lower back to floor with control.\n5. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2442,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'cf40e7e4d29181f2dfff27005b5502efda6d820bf7ccf66eaabea3746c5cd2e2',
          file_name:
            'videos/cf40e7e4d29181f2dfff27005b5502efda6d820bf7ccf66eaabea3746c5cd2e2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cf40e7e4d29181f2dfff27005b5502efda6d820bf7ccf66eaabea3746c5cd2e2.mp4',
          name: 'INT-ADV-Mini_Band_Standing_Hip_Abductions-EXERCISE-LEFT',
          description: 'Left Side',
          size: 50303,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2443,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'a91a6f76ef8d8d763d8027cbb44be85b5911be63f33d7838ef02461d7af9e446',
          file_name:
            'videos/a91a6f76ef8d8d763d8027cbb44be85b5911be63f33d7838ef02461d7af9e446.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a91a6f76ef8d8d763d8027cbb44be85b5911be63f33d7838ef02461d7af9e446.mp4',
          name: 'INT-ADV-Mini_Band_Standing_Hip_Abductions-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 42444,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2444,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'e06145916f9db16c1a10dfc263af559fdcd6fdf6cb3d6f67f2dfe4cb7c07ffc1',
          file_name:
            'audios/e06145916f9db16c1a10dfc263af559fdcd6fdf6cb3d6f67f2dfe4cb7c07ffc1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e06145916f9db16c1a10dfc263af559fdcd6fdf6cb3d6f67f2dfe4cb7c07ffc1.mp3',
          name: 'INT-ADV-Mini_Band_Standing_Hip_Abductions-EXERCISE',
          description: null,
          size: 46405,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_STANDING_HIP_ABDUCTIONS-EXERCISE': {
      id: 951,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Standing Hip Abductions',
      short_name: 'Band Hip Abductions',
      unique_name: 'ADVANCED-MINI_BAND_STANDING_HIP_ABDUCTIONS-EXERCISE',
      description:
        '1. Place a Mini Band around your ankles and stand with feet hip-width apart. Keep toes forward and core tight.\n2. Using the resistance of the band, lift one leg out to the side, keeping hips square, knees and toes forward. Only lift as far as you can without opening your hip and over rotating.\n3. Pause and lower back to floor with control.\n5. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2445,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'cf40e7e4d29181f2dfff27005b5502efda6d820bf7ccf66eaabea3746c5cd2e2',
          file_name:
            'videos/cf40e7e4d29181f2dfff27005b5502efda6d820bf7ccf66eaabea3746c5cd2e2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cf40e7e4d29181f2dfff27005b5502efda6d820bf7ccf66eaabea3746c5cd2e2.mp4',
          name: 'INT-ADV-Mini_Band_Standing_Hip_Abductions-EXERCISE-LEFT',
          description: 'Left Side',
          size: 50303,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2446,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'a91a6f76ef8d8d763d8027cbb44be85b5911be63f33d7838ef02461d7af9e446',
          file_name:
            'videos/a91a6f76ef8d8d763d8027cbb44be85b5911be63f33d7838ef02461d7af9e446.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a91a6f76ef8d8d763d8027cbb44be85b5911be63f33d7838ef02461d7af9e446.mp4',
          name: 'INT-ADV-Mini_Band_Standing_Hip_Abductions-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 42444,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2447,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'e06145916f9db16c1a10dfc263af559fdcd6fdf6cb3d6f67f2dfe4cb7c07ffc1',
          file_name:
            'audios/e06145916f9db16c1a10dfc263af559fdcd6fdf6cb3d6f67f2dfe4cb7c07ffc1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e06145916f9db16c1a10dfc263af559fdcd6fdf6cb3d6f67f2dfe4cb7c07ffc1.mp3',
          name: 'INT-ADV-Mini_Band_Standing_Hip_Abductions-EXERCISE',
          description: null,
          size: 46405,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_GLUTE_KICKBACKS-EXERCISE': {
      id: 952,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Glute Kickbacks',
      short_name: 'Mini Band Glute Kickbacks',
      unique_name: 'INTERMEDIATE-MINI_BAND_GLUTE_KICKBACKS-EXERCISE',
      description:
        '1. Place Mini Band around one leg, below knee. On all fours, kneel on the band to secure. Slip other foot into the band so it is around the center of your shoe. Keep foot flexed.\n2. Keeping hips square and core tight, drive through heel to extend banded leg straight back, toes point down. Do not arch low back.\n3. Return to start.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2448,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '99e6dec325081fdee42ea70ef375825094d2769bcb8985c72b14e4dc46a93986',
          file_name:
            'videos/99e6dec325081fdee42ea70ef375825094d2769bcb8985c72b14e4dc46a93986.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/99e6dec325081fdee42ea70ef375825094d2769bcb8985c72b14e4dc46a93986.mp4',
          name: 'INT-ADV-Mini_Band_Glute_Kickbacks-EXERCISE-LEFT',
          description: 'Left Side',
          size: 54433,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2449,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '6469515c0bf00a96f517e55774f53988cc414bd2c79c147fba8fb83e3c3b2149',
          file_name:
            'videos/6469515c0bf00a96f517e55774f53988cc414bd2c79c147fba8fb83e3c3b2149.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6469515c0bf00a96f517e55774f53988cc414bd2c79c147fba8fb83e3c3b2149.mp4',
          name: 'INT-ADV-Mini_Band_Glute_Kickbacks-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 55747,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2450,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'db3ae0d5fbc446397af7c581451955ff51b3b31e2bb7ae112852f7d4114aa6be',
          file_name:
            'audios/db3ae0d5fbc446397af7c581451955ff51b3b31e2bb7ae112852f7d4114aa6be.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/db3ae0d5fbc446397af7c581451955ff51b3b31e2bb7ae112852f7d4114aa6be.mp3',
          name: 'INT-ADV-Mini_Band_Glute_Kickbacks-EXERCISE',
          description: null,
          size: 32180,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_GLUTE_KICKBACKS-EXERCISE': {
      id: 953,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Glute Kickbacks',
      short_name: 'Mini Band Glute Kickbacks',
      unique_name: 'ADVANCED-MINI_BAND_GLUTE_KICKBACKS-EXERCISE',
      description:
        '1. Place Mini Band around one leg, below knee. On all fours, kneel on the band to secure. Slip other foot into the band so it is around the center of your shoe. Keep foot flexed.\n2. Keeping hips square and core tight, drive through heel to extend banded leg straight back, toes point down. Do not arch low back.\n3. Return to start.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2451,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '99e6dec325081fdee42ea70ef375825094d2769bcb8985c72b14e4dc46a93986',
          file_name:
            'videos/99e6dec325081fdee42ea70ef375825094d2769bcb8985c72b14e4dc46a93986.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/99e6dec325081fdee42ea70ef375825094d2769bcb8985c72b14e4dc46a93986.mp4',
          name: 'INT-ADV-Mini_Band_Glute_Kickbacks-EXERCISE-LEFT',
          description: 'Left Side',
          size: 54433,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2452,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '6469515c0bf00a96f517e55774f53988cc414bd2c79c147fba8fb83e3c3b2149',
          file_name:
            'videos/6469515c0bf00a96f517e55774f53988cc414bd2c79c147fba8fb83e3c3b2149.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6469515c0bf00a96f517e55774f53988cc414bd2c79c147fba8fb83e3c3b2149.mp4',
          name: 'INT-ADV-Mini_Band_Glute_Kickbacks-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 55747,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2453,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'db3ae0d5fbc446397af7c581451955ff51b3b31e2bb7ae112852f7d4114aa6be',
          file_name:
            'audios/db3ae0d5fbc446397af7c581451955ff51b3b31e2bb7ae112852f7d4114aa6be.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/db3ae0d5fbc446397af7c581451955ff51b3b31e2bb7ae112852f7d4114aa6be.mp3',
          name: 'INT-ADV-Mini_Band_Glute_Kickbacks-EXERCISE',
          description: null,
          size: 32180,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_STANDING_HIP_FLEXION-EXERCISE': {
      id: 954,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Standing Hip Flexion',
      short_name: 'Mini Band Standing Hip Flexion',
      unique_name: 'INTERMEDIATE-MINI_BAND_STANDING_HIP_FLEXION-EXERCISE',
      description:
        '1. Place a Mini Band around your shoes in the center of your foot and stand tall with feet about shoulder-width apart.\n2. Transfer all your weight to one leg and drive the other knee straight up to 90 degrees, keeping foot flexed. Pause for a beat.\n3. Control the band as you return to stand.\n4. Perform all reps on one leg. Repeat other side. ',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2454,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'f2e4b017b04d2e5d21a81635ac5382dbf7ef0975ad969d3cd6c216bd01b053c1',
          file_name:
            'videos/f2e4b017b04d2e5d21a81635ac5382dbf7ef0975ad969d3cd6c216bd01b053c1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f2e4b017b04d2e5d21a81635ac5382dbf7ef0975ad969d3cd6c216bd01b053c1.mp4',
          name: 'INT-ADV-Mini_Band_Standing_Hip_Flexion-EXERCISE-LEFT',
          description: 'Left Side',
          size: 66425,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2455,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '0b88eaf2d596be891548122efb2e3aabbda14af661d0a367dd974b1b29a8ceb1',
          file_name:
            'videos/0b88eaf2d596be891548122efb2e3aabbda14af661d0a367dd974b1b29a8ceb1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0b88eaf2d596be891548122efb2e3aabbda14af661d0a367dd974b1b29a8ceb1.mp4',
          name: 'INT-ADV-Mini_Band_Standing_Hip_Flexion-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 70061,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2456,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '2028154878739ca9fc08aea15adb4ef9449f76593d650b0226e7f25d116c1bc7',
          file_name:
            'audios/2028154878739ca9fc08aea15adb4ef9449f76593d650b0226e7f25d116c1bc7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2028154878739ca9fc08aea15adb4ef9449f76593d650b0226e7f25d116c1bc7.mp3',
          name: 'INT-ADV-Mini_Band_Standing_Hip_Flexion-EXERCISE',
          description: null,
          size: 37264,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_STANDING_HIP_FLEXION-EXERCISE': {
      id: 955,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Standing Hip Flexion',
      short_name: 'Mini Band Standing Hip Flexion',
      unique_name: 'ADVANCED-MINI_BAND_STANDING_HIP_FLEXION-EXERCISE',
      description:
        '1. Place a Mini Band around your shoes in the center of your foot and stand tall with feet about shoulder-width apart.\n2. Transfer all your weight to one leg and drive the other knee straight up to 90 degrees, keeping foot flexed. Pause for a beat.\n3. Control the band as you return to stand.\n4. Perform all reps on one leg. Repeat other side. ',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2457,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'f2e4b017b04d2e5d21a81635ac5382dbf7ef0975ad969d3cd6c216bd01b053c1',
          file_name:
            'videos/f2e4b017b04d2e5d21a81635ac5382dbf7ef0975ad969d3cd6c216bd01b053c1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f2e4b017b04d2e5d21a81635ac5382dbf7ef0975ad969d3cd6c216bd01b053c1.mp4',
          name: 'INT-ADV-Mini_Band_Standing_Hip_Flexion-EXERCISE-LEFT',
          description: 'Left Side',
          size: 66425,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2458,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '0b88eaf2d596be891548122efb2e3aabbda14af661d0a367dd974b1b29a8ceb1',
          file_name:
            'videos/0b88eaf2d596be891548122efb2e3aabbda14af661d0a367dd974b1b29a8ceb1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0b88eaf2d596be891548122efb2e3aabbda14af661d0a367dd974b1b29a8ceb1.mp4',
          name: 'INT-ADV-Mini_Band_Standing_Hip_Flexion-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 70061,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2459,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '2028154878739ca9fc08aea15adb4ef9449f76593d650b0226e7f25d116c1bc7',
          file_name:
            'audios/2028154878739ca9fc08aea15adb4ef9449f76593d650b0226e7f25d116c1bc7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2028154878739ca9fc08aea15adb4ef9449f76593d650b0226e7f25d116c1bc7.mp3',
          name: 'INT-ADV-Mini_Band_Standing_Hip_Flexion-EXERCISE',
          description: null,
          size: 37264,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_KNEELING_CONCENTRATION_CURLS-EXERCISE': {
      id: 956,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Mini Band Kneeling Concentration Curls',
      short_name: 'Band Concentration Curls',
      unique_name:
        'INTERMEDIATE-MINI_BAND_KNEELING_CONCENTRATION_CURLS-EXERCISE',
      description:
        '1. Start in half kneel and step in the center of a Mini Band with front foot to secure. Grab the other end of the band with the same side hand as front leg and rest tricep on inner thigh.\n2. Keep arm tight to the inside of leg and curl band up toward shoulder with wrist in neutral position. Pause at the top.\n3. Lower band back down.\n4. Perform all reps with one arm. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2460,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '46ff3f30974e162d182378fbc56d57b3bbe60021fb7b26d75a3e297299783a75',
          file_name:
            'videos/46ff3f30974e162d182378fbc56d57b3bbe60021fb7b26d75a3e297299783a75.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/46ff3f30974e162d182378fbc56d57b3bbe60021fb7b26d75a3e297299783a75.mp4',
          name: 'INT-ADV-Mini_Band_Kneeling_Concentration_Curls-EXERCISE-LEFT',
          description: 'Left Side',
          size: 48016,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2461,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'e8fffdbb83484d8627cd64c46f8b659a29c1f6239f06e7eeeb37345b025e9f01',
          file_name:
            'videos/e8fffdbb83484d8627cd64c46f8b659a29c1f6239f06e7eeeb37345b025e9f01.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e8fffdbb83484d8627cd64c46f8b659a29c1f6239f06e7eeeb37345b025e9f01.mp4',
          name: 'INT-ADV-Mini_Band_Kneeling_Concentration_Curls-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 50373,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2462,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '5e8d3c3c93fc486dee69941d5782869b9e70d20298baf4f7d70282e5a2e14c12',
          file_name:
            'audios/5e8d3c3c93fc486dee69941d5782869b9e70d20298baf4f7d70282e5a2e14c12.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5e8d3c3c93fc486dee69941d5782869b9e70d20298baf4f7d70282e5a2e14c12.mp3',
          name: 'INT-ADV-Mini_Band_Kneeling_Concentration_Curls-EXERCISE',
          description: null,
          size: 41586,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_KNEELING_CONCENTRATION_CURLS-EXERCISE': {
      id: 957,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Mini Band Kneeling Concentration Curls',
      short_name: 'Band Concentration Curls',
      unique_name: 'ADVANCED-MINI_BAND_KNEELING_CONCENTRATION_CURLS-EXERCISE',
      description:
        '1. Start in half kneel and step in the center of a Mini Band with front foot to secure. Grab the other end of the band with the same side hand as front leg and rest tricep on inner thigh.\n2. Keep arm tight to the inside of leg and curl band up toward shoulder with wrist in neutral position. Pause at the top.\n3. Lower band back down.\n4. Perform all reps with one arm. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2463,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '46ff3f30974e162d182378fbc56d57b3bbe60021fb7b26d75a3e297299783a75',
          file_name:
            'videos/46ff3f30974e162d182378fbc56d57b3bbe60021fb7b26d75a3e297299783a75.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/46ff3f30974e162d182378fbc56d57b3bbe60021fb7b26d75a3e297299783a75.mp4',
          name: 'INT-ADV-Mini_Band_Kneeling_Concentration_Curls-EXERCISE-LEFT',
          description: 'Left Side',
          size: 48016,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2464,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'e8fffdbb83484d8627cd64c46f8b659a29c1f6239f06e7eeeb37345b025e9f01',
          file_name:
            'videos/e8fffdbb83484d8627cd64c46f8b659a29c1f6239f06e7eeeb37345b025e9f01.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e8fffdbb83484d8627cd64c46f8b659a29c1f6239f06e7eeeb37345b025e9f01.mp4',
          name: 'INT-ADV-Mini_Band_Kneeling_Concentration_Curls-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 50373,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2465,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '5e8d3c3c93fc486dee69941d5782869b9e70d20298baf4f7d70282e5a2e14c12',
          file_name:
            'audios/5e8d3c3c93fc486dee69941d5782869b9e70d20298baf4f7d70282e5a2e14c12.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5e8d3c3c93fc486dee69941d5782869b9e70d20298baf4f7d70282e5a2e14c12.mp3',
          name: 'INT-ADV-Mini_Band_Kneeling_Concentration_Curls-EXERCISE',
          description: null,
          size: 41586,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-GLIDING_FROGGERS-EXERCISE': {
      id: 958,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Gliding Froggers',
      short_name: 'Gliding Froggers',
      unique_name: 'INTERMEDIATE-GLIDING_FROGGERS-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists and each foot on a Glider.\n2. Using your core, bend both knees and slide your feet toward your hands. Keep your arms straight.\n3. Like the motion of the Breaststroke, slide your feet and extend both legs out to the sides to make a wide "V".\n4. Continue the motion by sliding your feet together to return to start position.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2466,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'ad1171b0cdb4855d840b3c0c3beb1ed9882011627663a95236c6f8250a2bc200',
          file_name:
            'videos/ad1171b0cdb4855d840b3c0c3beb1ed9882011627663a95236c6f8250a2bc200.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ad1171b0cdb4855d840b3c0c3beb1ed9882011627663a95236c6f8250a2bc200.mp4',
          name: 'INT-ADV-Gliding_Froggers-EXERCISE',
          description: null,
          size: 57480,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2467,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '40b40a29f60d1bc3eb15ebfc7bbebc9396452d3e3af35dd9dfadd25632b5723b',
          file_name:
            'audios/40b40a29f60d1bc3eb15ebfc7bbebc9396452d3e3af35dd9dfadd25632b5723b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/40b40a29f60d1bc3eb15ebfc7bbebc9396452d3e3af35dd9dfadd25632b5723b.mp3',
          name: 'INT-ADV-Gliding_Froggers-EXERCISE',
          description: null,
          size: 26719,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-GLIDING_FROGGERS-EXERCISE': {
      id: 959,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Gliding Froggers',
      short_name: 'Gliding Froggers',
      unique_name: 'ADVANCED-GLIDING_FROGGERS-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists and each foot on a Glider.\n2. Using your core, bend both knees and slide your feet toward your hands. Keep your arms straight.\n3. Like the motion of the Breaststroke, slide your feet and extend both legs out to the sides to make a wide "V".\n4. Continue the motion by sliding your feet together to return to start position.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2468,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'ad1171b0cdb4855d840b3c0c3beb1ed9882011627663a95236c6f8250a2bc200',
          file_name:
            'videos/ad1171b0cdb4855d840b3c0c3beb1ed9882011627663a95236c6f8250a2bc200.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ad1171b0cdb4855d840b3c0c3beb1ed9882011627663a95236c6f8250a2bc200.mp4',
          name: 'INT-ADV-Gliding_Froggers-EXERCISE',
          description: null,
          size: 57480,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2469,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '40b40a29f60d1bc3eb15ebfc7bbebc9396452d3e3af35dd9dfadd25632b5723b',
          file_name:
            'audios/40b40a29f60d1bc3eb15ebfc7bbebc9396452d3e3af35dd9dfadd25632b5723b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/40b40a29f60d1bc3eb15ebfc7bbebc9396452d3e3af35dd9dfadd25632b5723b.mp3',
          name: 'INT-ADV-Gliding_Froggers-EXERCISE',
          description: null,
          size: 26719,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-GLIDING_ATOMIC_PUSH_UPS-EXERCISE': {
      id: 960,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Gliding Atomic Push-Ups',
      short_name: 'Gliding Atomic Push-Ups',
      unique_name: 'INTERMEDIATE-GLIDING_ATOMIC_PUSH_UPS-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists and each foot on a Glider.\n2. Bend your elbows, pointing them back toward your hips and perform one Push Up.\n3. Use your core, bend both knees and slide your feet toward your hands. Keep your arms straight.\n4. With your hips and shoulders square to the floor, extend both legs and slide your feet straight back to start position. ',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2470,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '2e51faecf6462185f80c4e78bdef0fc71e0fe37af2a9a75f92f3f998dcf2fb79',
          file_name:
            'videos/2e51faecf6462185f80c4e78bdef0fc71e0fe37af2a9a75f92f3f998dcf2fb79.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2e51faecf6462185f80c4e78bdef0fc71e0fe37af2a9a75f92f3f998dcf2fb79.mp4',
          name: 'INT-ADV-Gliding_Atomic_Push_Ups-EXERCISE',
          description: null,
          size: 56278,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2471,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '07e44b1dd4bc558c555373f12afdad5b0d9db19ce027d257bfbea86a831e609c',
          file_name:
            'audios/07e44b1dd4bc558c555373f12afdad5b0d9db19ce027d257bfbea86a831e609c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/07e44b1dd4bc558c555373f12afdad5b0d9db19ce027d257bfbea86a831e609c.mp3',
          name: 'INT-ADV-Gliding_Atomic_Push_Ups-EXERCISE',
          description: null,
          size: 31604,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-GLIDING_ATOMIC_PUSH_UPS-EXERCISE': {
      id: 961,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Gliding Atomic Push-Ups',
      short_name: 'Gliding Atomic Push-Ups',
      unique_name: 'ADVANCED-GLIDING_ATOMIC_PUSH_UPS-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists and each foot on a Glider.\n2. Bend your elbows, pointing them back toward your hips and perform one Push Up.\n3. Use your core, bend both knees and slide your feet toward your hands. Keep your arms straight.\n4. With your hips and shoulders square to the floor, extend both legs and slide your feet straight back to start position. ',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2472,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '2e51faecf6462185f80c4e78bdef0fc71e0fe37af2a9a75f92f3f998dcf2fb79',
          file_name:
            'videos/2e51faecf6462185f80c4e78bdef0fc71e0fe37af2a9a75f92f3f998dcf2fb79.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2e51faecf6462185f80c4e78bdef0fc71e0fe37af2a9a75f92f3f998dcf2fb79.mp4',
          name: 'INT-ADV-Gliding_Atomic_Push_Ups-EXERCISE',
          description: null,
          size: 56278,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2473,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '07e44b1dd4bc558c555373f12afdad5b0d9db19ce027d257bfbea86a831e609c',
          file_name:
            'audios/07e44b1dd4bc558c555373f12afdad5b0d9db19ce027d257bfbea86a831e609c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/07e44b1dd4bc558c555373f12afdad5b0d9db19ce027d257bfbea86a831e609c.mp3',
          name: 'INT-ADV-Gliding_Atomic_Push_Ups-EXERCISE',
          description: null,
          size: 31604,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PUSH_UPS_TO_GLIDING_PLANK_JACK-EXERCISE': {
      id: 962,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Push-Ups to Gliding Plank Jack',
      short_name: 'Push-Ups to Gliding Plank Jack',
      unique_name: 'INTERMEDIATE-PUSH_UPS_TO_GLIDING_PLANK_JACK-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists and each foot on a Glider.\n2. Bend your elbows, pointing them back toward your hips and perform one Push Up.\n3. Slide your feet out into a wide "V" then back to start position.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2474,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '5125027becfb556e35dcad32b7bf24140ca4cb07983cc0ff7c9f1ea6e33b411f',
          file_name:
            'videos/5125027becfb556e35dcad32b7bf24140ca4cb07983cc0ff7c9f1ea6e33b411f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5125027becfb556e35dcad32b7bf24140ca4cb07983cc0ff7c9f1ea6e33b411f.mp4',
          name: 'INT-ADV-Push_Ups_To_Gliding_Plank_Jack-EXERCISE',
          description: null,
          size: 57318,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2475,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'e855838ad1efce0b8db02dd88d1b654eba6db39e1e08af3bb5c32a48ba35b5db',
          file_name:
            'audios/e855838ad1efce0b8db02dd88d1b654eba6db39e1e08af3bb5c32a48ba35b5db.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e855838ad1efce0b8db02dd88d1b654eba6db39e1e08af3bb5c32a48ba35b5db.mp3',
          name: 'INT-ADV-Push_Ups_To_Gliding_Plank_Jack-EXERCISE',
          description: null,
          size: 34003,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PUSH_UPS_TO_GLIDING_PLANK_JACK-EXERCISE': {
      id: 963,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Push-Ups to Gliding Plank Jack',
      short_name: 'Push-Ups to Gliding Plank Jack',
      unique_name: 'ADVANCED-PUSH_UPS_TO_GLIDING_PLANK_JACK-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists and each foot on a Glider.\n2. Bend your elbows, pointing them back toward your hips and perform one Push Up.\n3. Slide your feet out into a wide "V" then back to start position.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2476,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '5125027becfb556e35dcad32b7bf24140ca4cb07983cc0ff7c9f1ea6e33b411f',
          file_name:
            'videos/5125027becfb556e35dcad32b7bf24140ca4cb07983cc0ff7c9f1ea6e33b411f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5125027becfb556e35dcad32b7bf24140ca4cb07983cc0ff7c9f1ea6e33b411f.mp4',
          name: 'INT-ADV-Push_Ups_To_Gliding_Plank_Jack-EXERCISE',
          description: null,
          size: 57318,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2477,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'e855838ad1efce0b8db02dd88d1b654eba6db39e1e08af3bb5c32a48ba35b5db',
          file_name:
            'audios/e855838ad1efce0b8db02dd88d1b654eba6db39e1e08af3bb5c32a48ba35b5db.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e855838ad1efce0b8db02dd88d1b654eba6db39e1e08af3bb5c32a48ba35b5db.mp3',
          name: 'INT-ADV-Push_Ups_To_Gliding_Plank_Jack-EXERCISE',
          description: null,
          size: 34003,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_LYING_HIP_FLEXION_EXTENSION-EXERCISE': {
      id: 964,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Mini Band Lying Hip Flexion/Extension',
      short_name: 'Mini Band Lying Hip Flexion/Extension',
      unique_name:
        'INTERMEDIATE-MINI_BAND_LYING_HIP_FLEXION_EXTENSION-EXERCISE',
      description:
        '1. Lie on your back with a Mini Band looped around the center of your feet. Arms by your sides, knees bent to 90 degrees, feet in air and flexed.\n2. Keeping core tight and pelvis tucked, straighten one leg and push the band away until foot is about 6 inches from the floor. Pause.\n3. Control band as you return to start and repeat other side in a continous motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2478,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'a08056a097b3e58f86ec5bd802aaaefcd3a9d101ed2cea88c91ea5a973d9492a',
          file_name:
            'videos/a08056a097b3e58f86ec5bd802aaaefcd3a9d101ed2cea88c91ea5a973d9492a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a08056a097b3e58f86ec5bd802aaaefcd3a9d101ed2cea88c91ea5a973d9492a.mp4',
          name: 'INT-ADV-Mini_Band_Lying_Hip_Flexion-Extension-EXERCISE',
          description: null,
          size: 79868,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2479,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '3001823e62f1377b55822c1b40a30375bceb69714a8016c3f50ee996e226caa9',
          file_name:
            'audios/3001823e62f1377b55822c1b40a30375bceb69714a8016c3f50ee996e226caa9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3001823e62f1377b55822c1b40a30375bceb69714a8016c3f50ee996e226caa9.mp3',
          name: 'INT-ADV-Mini_Band_Lying_Hip_Flexion-Extension-EXERCISE',
          description: null,
          size: 40831,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_LYING_HIP_FLEXION_EXTENSION-EXERCISE': {
      id: 965,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Mini Band Lying Hip Flexion/Extension',
      short_name: 'Mini Band Lying Hip Flexion/Extension',
      unique_name: 'ADVANCED-MINI_BAND_LYING_HIP_FLEXION_EXTENSION-EXERCISE',
      description:
        '1. Lie on your back with a Mini Band looped around the center of your feet. Arms by your sides, knees bent to 90 degrees, feet in air and flexed.\n2. Keeping core tight and pelvis tucked, straighten one leg and push the band away until foot is about 6 inches from the floor. Pause.\n3. Control band as you return to start and repeat other side in a continous motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2480,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'a08056a097b3e58f86ec5bd802aaaefcd3a9d101ed2cea88c91ea5a973d9492a',
          file_name:
            'videos/a08056a097b3e58f86ec5bd802aaaefcd3a9d101ed2cea88c91ea5a973d9492a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a08056a097b3e58f86ec5bd802aaaefcd3a9d101ed2cea88c91ea5a973d9492a.mp4',
          name: 'INT-ADV-Mini_Band_Lying_Hip_Flexion-Extension-EXERCISE',
          description: null,
          size: 79868,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2481,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '3001823e62f1377b55822c1b40a30375bceb69714a8016c3f50ee996e226caa9',
          file_name:
            'audios/3001823e62f1377b55822c1b40a30375bceb69714a8016c3f50ee996e226caa9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3001823e62f1377b55822c1b40a30375bceb69714a8016c3f50ee996e226caa9.mp3',
          name: 'INT-ADV-Mini_Band_Lying_Hip_Flexion-Extension-EXERCISE',
          description: null,
          size: 40831,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_REAR_DELT_PULL_APARTS-EXERCISE': {
      id: 966,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Mini Band Rear Delt Pull Aparts',
      short_name: 'Band Rear Delt Pull Aparts',
      unique_name: 'INTERMEDIATE-MINI_BAND_REAR_DELT_PULL_APARTS-EXERCISE',
      description:
        '1. Stand tall with a Mini Band around your hands or wrists, palms bladed. Raise arms in front of you to shoulder height. Your arms are straight and palms face in with slight tension on the band.\n2. Keeping your shoulder blades down and back, open your arms and pull the band apart as far as possible in a controlled motion. Pause for a beat.\n3. Control the band as you bring your arms to start.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2482,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '272074000d0ca3fdf0c54259d208afc30a39d16e3af019cfa29f64987173f4fb',
          file_name:
            'videos/272074000d0ca3fdf0c54259d208afc30a39d16e3af019cfa29f64987173f4fb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/272074000d0ca3fdf0c54259d208afc30a39d16e3af019cfa29f64987173f4fb.mp4',
          name: 'INT-ADV-Mini_Band_Rear_Delt_Pull_Aparts-EXERCISE',
          description: null,
          size: 33630,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2483,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '92bc1125e95c3dfa7a1816ccbea482f209b821e9197854051a54055c4359e471',
          file_name:
            'audios/92bc1125e95c3dfa7a1816ccbea482f209b821e9197854051a54055c4359e471.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/92bc1125e95c3dfa7a1816ccbea482f209b821e9197854051a54055c4359e471.mp3',
          name: 'INT-ADV-Mini_Band_Rear_Delt_Pull_Aparts-EXERCISE',
          description: null,
          size: 38033,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_REAR_DELT_PULL_APARTS-EXERCISE': {
      id: 967,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Mini Band Rear Delt Pull Aparts',
      short_name: 'Band Rear Delt Pull Aparts',
      unique_name: 'ADVANCED-MINI_BAND_REAR_DELT_PULL_APARTS-EXERCISE',
      description:
        '1. Stand tall with a Mini Band around your hands or wrists, palms bladed. Raise arms in front of you to shoulder height. Your arms are straight and palms face in with slight tension on the band.\n2. Keeping your shoulder blades down and back, open your arms and pull the band apart as far as possible in a controlled motion. Pause for a beat.\n3. Control the band as you bring your arms to start.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2484,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '272074000d0ca3fdf0c54259d208afc30a39d16e3af019cfa29f64987173f4fb',
          file_name:
            'videos/272074000d0ca3fdf0c54259d208afc30a39d16e3af019cfa29f64987173f4fb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/272074000d0ca3fdf0c54259d208afc30a39d16e3af019cfa29f64987173f4fb.mp4',
          name: 'INT-ADV-Mini_Band_Rear_Delt_Pull_Aparts-EXERCISE',
          description: null,
          size: 33630,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2485,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '92bc1125e95c3dfa7a1816ccbea482f209b821e9197854051a54055c4359e471',
          file_name:
            'audios/92bc1125e95c3dfa7a1816ccbea482f209b821e9197854051a54055c4359e471.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/92bc1125e95c3dfa7a1816ccbea482f209b821e9197854051a54055c4359e471.mp3',
          name: 'INT-ADV-Mini_Band_Rear_Delt_Pull_Aparts-EXERCISE',
          description: null,
          size: 38033,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_ARCHER_PULLS-EXERCISE': {
      id: 968,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Mini Band Archer Pulls',
      short_name: 'Mini Band Archer Pulls',
      unique_name: 'INTERMEDIATE-MINI_BAND_ARCHER_PULLS-EXERCISE',
      description:
        '1. Stand tall and hold each end of a Mini Band. Raise arms to shoulder height and slightly pivot feet and torso to one side.\n2. Keeping back arm straight, pull the other end of the band back toward shoulder.\n3. Keep elbow lifted and rotate upper body in the direction of the pull. Squeeze shoulder blades.\n4. With control, return to start.\n5. Perform all reps on one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2486,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '91fcbcf82d521b2e91968c2a813cc3d5440c6172e5c508e38c76d04c2f5c8048',
          file_name:
            'videos/91fcbcf82d521b2e91968c2a813cc3d5440c6172e5c508e38c76d04c2f5c8048.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/91fcbcf82d521b2e91968c2a813cc3d5440c6172e5c508e38c76d04c2f5c8048.mp4',
          name: 'INT-ADV-Mini_Band_Archer_Pulls-EXERCISE-LEFT',
          description: 'Left Side',
          size: 53731,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2487,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'bf3c21b1ec6a889ecb2cfa87822b5a69d4a7ea38932acd89d30cffaf9c322c98',
          file_name:
            'videos/bf3c21b1ec6a889ecb2cfa87822b5a69d4a7ea38932acd89d30cffaf9c322c98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf3c21b1ec6a889ecb2cfa87822b5a69d4a7ea38932acd89d30cffaf9c322c98.mp4',
          name: 'INT-ADV-Mini_Band_Archer_Pulls-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 63728,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2488,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'dec6c6ff6976fc674ab9f00a04b6d3972b4c0653c000d9004579e8a619b78e55',
          file_name:
            'audios/dec6c6ff6976fc674ab9f00a04b6d3972b4c0653c000d9004579e8a619b78e55.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dec6c6ff6976fc674ab9f00a04b6d3972b4c0653c000d9004579e8a619b78e55.mp3',
          name: 'INT-ADV-Mini_Band_Archer_Pulls-EXERCISE',
          description: null,
          size: 32377,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_ARCHER_PULLS-EXERCISE': {
      id: 969,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Mini Band Archer Pulls',
      short_name: 'Mini Band Archer Pulls',
      unique_name: 'ADVANCED-MINI_BAND_ARCHER_PULLS-EXERCISE',
      description:
        '1. Stand tall and hold each end of a Mini Band. Raise arms to shoulder height and slightly pivot feet and torso to one side.\n2. Keeping back arm straight, pull the other end of the band back toward shoulder.\n3. Keep elbow lifted and rotate upper body in the direction of the pull. Squeeze shoulder blades.\n4. With control, return to start.\n5. Perform all reps on one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2489,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '91fcbcf82d521b2e91968c2a813cc3d5440c6172e5c508e38c76d04c2f5c8048',
          file_name:
            'videos/91fcbcf82d521b2e91968c2a813cc3d5440c6172e5c508e38c76d04c2f5c8048.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/91fcbcf82d521b2e91968c2a813cc3d5440c6172e5c508e38c76d04c2f5c8048.mp4',
          name: 'INT-ADV-Mini_Band_Archer_Pulls-EXERCISE-LEFT',
          description: 'Left Side',
          size: 53731,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2490,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: 'bf3c21b1ec6a889ecb2cfa87822b5a69d4a7ea38932acd89d30cffaf9c322c98',
          file_name:
            'videos/bf3c21b1ec6a889ecb2cfa87822b5a69d4a7ea38932acd89d30cffaf9c322c98.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf3c21b1ec6a889ecb2cfa87822b5a69d4a7ea38932acd89d30cffaf9c322c98.mp4',
          name: 'INT-ADV-Mini_Band_Archer_Pulls-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 63728,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2491,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'dec6c6ff6976fc674ab9f00a04b6d3972b4c0653c000d9004579e8a619b78e55',
          file_name:
            'audios/dec6c6ff6976fc674ab9f00a04b6d3972b4c0653c000d9004579e8a619b78e55.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dec6c6ff6976fc674ab9f00a04b6d3972b4c0653c000d9004579e8a619b78e55.mp3',
          name: 'INT-ADV-Mini_Band_Archer_Pulls-EXERCISE',
          description: null,
          size: 32377,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-GLIDING_TWISTED_LUNGES-EXERCISE': {
      id: 970,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Gliding Twisted Lunges',
      short_name: 'Gliding Twisted Lunges',
      unique_name: 'INTERMEDIATE-GLIDING_TWISTED_LUNGES-EXERCISE',
      description:
        '1. Start in low lunge, both hands on the ground, Glider under each foot.\n2. Twist torso toward bent knee as you raise arm up. Other hand remains on the floor. Bend back knee and glide foot in so heel is under glutes.\n3. Keeping the twist in upperbody, extend back leg and glide foot back into a Twisted Lunge.\n4. Bend knee and glide foot back in to start.\n5. Perform all reps one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2492,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'eb9dc9b80bc5b584668df1c5dc782735e5705e65e3a88e11df6cc459590d5d13',
          file_name:
            'videos/eb9dc9b80bc5b584668df1c5dc782735e5705e65e3a88e11df6cc459590d5d13.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eb9dc9b80bc5b584668df1c5dc782735e5705e65e3a88e11df6cc459590d5d13.mp4',
          name: 'INT-ADV-Gliding_Twisted_Lunges-EXERCISE-LEFT',
          description: 'Left Side',
          size: 36726,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2493,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '800623f95b0ba403925f334b62ad476c69797e03b96db66e24f86f293770fbba',
          file_name:
            'videos/800623f95b0ba403925f334b62ad476c69797e03b96db66e24f86f293770fbba.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/800623f95b0ba403925f334b62ad476c69797e03b96db66e24f86f293770fbba.mp4',
          name: 'INT-ADV-Gliding_Twisted_Lunges-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 39817,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2494,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '91f39a41d1c827637cd493c7d72f13b85494110213309d6915744860e8a768f2',
          file_name:
            'audios/91f39a41d1c827637cd493c7d72f13b85494110213309d6915744860e8a768f2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/91f39a41d1c827637cd493c7d72f13b85494110213309d6915744860e8a768f2.mp3',
          name: 'INT-ADV-Gliding_Twisted_Lunges-EXERCISE',
          description: null,
          size: 30937,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-GLIDING_TWISTED_LUNGES-EXERCISE': {
      id: 971,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Gliding Twisted Lunges',
      short_name: 'Gliding Twisted Lunges',
      unique_name: 'ADVANCED-GLIDING_TWISTED_LUNGES-EXERCISE',
      description:
        '1. Start in low lunge, both hands on the ground, Glider under each foot.\n2. Twist torso toward bent knee as you raise arm up. Other hand remains on the floor. Bend back knee and glide foot in so heel is under glutes.\n3. Keeping the twist in upperbody, extend back leg and glide foot back into a Twisted Lunge.\n4. Bend knee and glide foot back in to start.\n5. Perform all reps one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2495,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'eb9dc9b80bc5b584668df1c5dc782735e5705e65e3a88e11df6cc459590d5d13',
          file_name:
            'videos/eb9dc9b80bc5b584668df1c5dc782735e5705e65e3a88e11df6cc459590d5d13.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eb9dc9b80bc5b584668df1c5dc782735e5705e65e3a88e11df6cc459590d5d13.mp4',
          name: 'INT-ADV-Gliding_Twisted_Lunges-EXERCISE-LEFT',
          description: 'Left Side',
          size: 36726,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2496,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '800623f95b0ba403925f334b62ad476c69797e03b96db66e24f86f293770fbba',
          file_name:
            'videos/800623f95b0ba403925f334b62ad476c69797e03b96db66e24f86f293770fbba.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/800623f95b0ba403925f334b62ad476c69797e03b96db66e24f86f293770fbba.mp4',
          name: 'INT-ADV-Gliding_Twisted_Lunges-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 39817,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2497,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '91f39a41d1c827637cd493c7d72f13b85494110213309d6915744860e8a768f2',
          file_name:
            'audios/91f39a41d1c827637cd493c7d72f13b85494110213309d6915744860e8a768f2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/91f39a41d1c827637cd493c7d72f13b85494110213309d6915744860e8a768f2.mp3',
          name: 'INT-ADV-Gliding_Twisted_Lunges-EXERCISE',
          description: null,
          size: 30937,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-BEAR_SHOULDER_TAPS_WITH_GLIDING_TUCK-EXERCISE': {
      id: 972,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Bear Shoulder Taps with Gliding Tuck',
      short_name: 'Shoulder Taps with Tuck',
      unique_name: 'INTERMEDIATE-BEAR_SHOULDER_TAPS_WITH_GLIDING_TUCK-EXERCISE',
      description:
        '1. Start in Bear Plank position with a Glider under each foot. Shoulders over wrists and knees under hips.\n2. Keeping hips and shoulders square, lift one hand off the ground and tap the opposite shoulder.\n3. Return to Plank and repeat with the other hand.\n4. Using your core, straighten both legs and glide your feet out to full Plank.\n5. Bend both knees and glide feet toward hands back to start.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2498,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'f33902a7344829e44c130e5a894ed3d0db40a91189f4b86e662d5449542708a4',
          file_name:
            'videos/f33902a7344829e44c130e5a894ed3d0db40a91189f4b86e662d5449542708a4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f33902a7344829e44c130e5a894ed3d0db40a91189f4b86e662d5449542708a4.mp4',
          name: 'INT-ADV-Bear_Shoulder_Taps_with_Gliding_Tuck-EXERCISE',
          description: null,
          size: 67435,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2499,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '537ecce04a8de905f5925d49cedbfffa2810fa4a1b40b620a84c7e1b67116e2b',
          file_name:
            'audios/537ecce04a8de905f5925d49cedbfffa2810fa4a1b40b620a84c7e1b67116e2b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/537ecce04a8de905f5925d49cedbfffa2810fa4a1b40b620a84c7e1b67116e2b.mp3',
          name: 'INT-ADV-Bear_Shoulder_Taps_with_Gliding_Tuck-EXERCISE',
          description: null,
          size: 42266,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-BEAR_SHOULDER_TAPS_WITH_GLIDING_TUCK-EXERCISE': {
      id: 973,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Bear Shoulder Taps with Gliding Tuck',
      short_name: 'Shoulder Taps with Tuck',
      unique_name: 'ADVANCED-BEAR_SHOULDER_TAPS_WITH_GLIDING_TUCK-EXERCISE',
      description:
        '1. Start in Bear Plank position with a Glider under each foot. Shoulders over wrists and knees under hips.\n2. Keeping hips and shoulders square, lift one hand off the ground and tap the opposite shoulder.\n3. Return to Plank and repeat with the other hand.\n4. Using your core, straighten both legs and glide your feet out to full Plank.\n5. Bend both knees and glide feet toward hands back to start.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2500,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'f33902a7344829e44c130e5a894ed3d0db40a91189f4b86e662d5449542708a4',
          file_name:
            'videos/f33902a7344829e44c130e5a894ed3d0db40a91189f4b86e662d5449542708a4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f33902a7344829e44c130e5a894ed3d0db40a91189f4b86e662d5449542708a4.mp4',
          name: 'INT-ADV-Bear_Shoulder_Taps_with_Gliding_Tuck-EXERCISE',
          description: null,
          size: 67435,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2501,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '537ecce04a8de905f5925d49cedbfffa2810fa4a1b40b620a84c7e1b67116e2b',
          file_name:
            'audios/537ecce04a8de905f5925d49cedbfffa2810fa4a1b40b620a84c7e1b67116e2b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/537ecce04a8de905f5925d49cedbfffa2810fa4a1b40b620a84c7e1b67116e2b.mp3',
          name: 'INT-ADV-Bear_Shoulder_Taps_with_Gliding_Tuck-EXERCISE',
          description: null,
          size: 42266,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-GLIDING_HAMSTRING_CURLS-EXERCISE': {
      id: 974,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Gliding Hamstring Curls',
      short_name: 'Gliding Hamstring Curls',
      unique_name: 'INTERMEDIATE-GLIDING_HAMSTRING_CURLS-EXERCISE',
      description:
        "1. Lie on your back with knees bent, hip-width apart and each foot on top of a Glider. Keep arms at your sides, palms down. Keep knees aligned so they don't splay out or buckle in.\n2. Lift your hips up keeping your shoulders and head on the floor.\n3. Extend both knees and slide your feet out to straighten your legs.\n4. Keeping hips up, bend your knees and slide feet toward your hips to start.",
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2502,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'fb51a7fa7f667ae67f7f62e9dff6f5ff9f26db3025d73af3fb529150ee426fb1',
          file_name:
            'videos/fb51a7fa7f667ae67f7f62e9dff6f5ff9f26db3025d73af3fb529150ee426fb1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fb51a7fa7f667ae67f7f62e9dff6f5ff9f26db3025d73af3fb529150ee426fb1.mp4',
          name: 'INT-ADV-Gliding_Hamstring_Curls-EXERCISE',
          description: null,
          size: 37801,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2503,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'e297444d203d7c03570a47216f21731967be2e074779965cc890972bbe5ed74e',
          file_name:
            'audios/e297444d203d7c03570a47216f21731967be2e074779965cc890972bbe5ed74e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e297444d203d7c03570a47216f21731967be2e074779965cc890972bbe5ed74e.mp3',
          name: 'INT-ADV-Gliding_Hamstring_Curls-EXERCISE',
          description: null,
          size: 32756,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-GLIDING_HAMSTRING_CURLS-EXERCISE': {
      id: 975,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Gliding Hamstring Curls',
      short_name: 'Gliding Hamstring Curls',
      unique_name: 'ADVANCED-GLIDING_HAMSTRING_CURLS-EXERCISE',
      description:
        "1. Lie on your back with knees bent, hip-width apart and each foot on top of a Glider. Keep arms at your sides, palms down. Keep knees aligned so they don't splay out or buckle in.\n2. Lift your hips up keeping your shoulders and head on the floor.\n3. Extend both knees and slide your feet out to straighten your legs.\n4. Keeping hips up, bend your knees and slide feet toward your hips to start.",
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2504,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'fb51a7fa7f667ae67f7f62e9dff6f5ff9f26db3025d73af3fb529150ee426fb1',
          file_name:
            'videos/fb51a7fa7f667ae67f7f62e9dff6f5ff9f26db3025d73af3fb529150ee426fb1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fb51a7fa7f667ae67f7f62e9dff6f5ff9f26db3025d73af3fb529150ee426fb1.mp4',
          name: 'INT-ADV-Gliding_Hamstring_Curls-EXERCISE',
          description: null,
          size: 37801,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2505,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'e297444d203d7c03570a47216f21731967be2e074779965cc890972bbe5ed74e',
          file_name:
            'audios/e297444d203d7c03570a47216f21731967be2e074779965cc890972bbe5ed74e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e297444d203d7c03570a47216f21731967be2e074779965cc890972bbe5ed74e.mp3',
          name: 'INT-ADV-Gliding_Hamstring_Curls-EXERCISE',
          description: null,
          size: 32756,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_SQUATS_WITH_ALTERNATING_HIP_ABDUCTION-EXERCISE': {
      id: 976,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Squats with Alternating Hip Abduction',
      short_name: 'Band Squats with Hip Abduction',
      unique_name:
        'INTERMEDIATE-MINI_BAND_SQUATS_WITH_ALTERNATING_HIP_ABDUCTION-EXERCISE',
      description:
        '1. Stand with your feet roughly shoulder-width apart with a Mini Band around your ankles.\n2. Perform a Squat.\n3. As you come up, lift one leg out to the side keeping hips square, knees and toes facing forward. Only lift as far as you can without opening up your hip and over rotating.\n4. Squat again and repeat with other leg. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2506,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '616a756db3481b6c0aab78cecd4cc88ae346b8068636ed05b2b9a48e2dc0594f',
          file_name:
            'videos/616a756db3481b6c0aab78cecd4cc88ae346b8068636ed05b2b9a48e2dc0594f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/616a756db3481b6c0aab78cecd4cc88ae346b8068636ed05b2b9a48e2dc0594f.mp4',
          name: 'INT-ADV-Mini_Band_Squats_with_Alternating_Hip_Abduction-EXERCISE',
          description: null,
          size: 155075,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2507,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'da70da697712fee3cb3ea21830cd99d756914e0337c52279dd4f21faf2b5438e',
          file_name:
            'audios/da70da697712fee3cb3ea21830cd99d756914e0337c52279dd4f21faf2b5438e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/da70da697712fee3cb3ea21830cd99d756914e0337c52279dd4f21faf2b5438e.mp3',
          name: 'INT-ADV-Mini_Band_Squats_with_Alternating_Hip_Abduction-EXERCISE',
          description: null,
          size: 43990,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_SQUATS_WITH_ALTERNATING_HIP_ABDUCTION-EXERCISE': {
      id: 977,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Mini Band Squats with Alternating Hip Abduction',
      short_name: 'Band Squats with Hip Abduction',
      unique_name:
        'ADVANCED-MINI_BAND_SQUATS_WITH_ALTERNATING_HIP_ABDUCTION-EXERCISE',
      description:
        '1. Stand with your feet roughly shoulder-width apart with a Mini Band around your ankles.\n2. Perform a Squat.\n3. As you come up, lift one leg out to the side keeping hips square, knees and toes facing forward. Only lift as far as you can without opening up your hip and over rotating.\n4. Squat again and repeat with other leg. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2508,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '616a756db3481b6c0aab78cecd4cc88ae346b8068636ed05b2b9a48e2dc0594f',
          file_name:
            'videos/616a756db3481b6c0aab78cecd4cc88ae346b8068636ed05b2b9a48e2dc0594f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/616a756db3481b6c0aab78cecd4cc88ae346b8068636ed05b2b9a48e2dc0594f.mp4',
          name: 'INT-ADV-Mini_Band_Squats_with_Alternating_Hip_Abduction-EXERCISE',
          description: null,
          size: 155075,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2509,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'da70da697712fee3cb3ea21830cd99d756914e0337c52279dd4f21faf2b5438e',
          file_name:
            'audios/da70da697712fee3cb3ea21830cd99d756914e0337c52279dd4f21faf2b5438e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/da70da697712fee3cb3ea21830cd99d756914e0337c52279dd4f21faf2b5438e.mp3',
          name: 'INT-ADV-Mini_Band_Squats_with_Alternating_Hip_Abduction-EXERCISE',
          description: null,
          size: 43990,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-GLIDING_KNEE_TUCKS_TO_PIKE-EXERCISE': {
      id: 978,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Gliding Knee Tucks to Pike',
      short_name: 'Gliding Knee Tucks to Pike',
      unique_name: 'INTERMEDIATE-GLIDING_KNEE_TUCKS_TO_PIKE-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists and a Glider under each foot.\n2. Using core, bend knees and slide feet toward hands. Straighten legs and slide back to Plank.\n3. Keeping legs straight, use core and lift hips up as high as possible sliding feet toward your hands. Your arms remain straight and head drops so ears are in line with the pits of elbows.\n4. Drop your hips and slide back to start.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2510,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'a924faa77cb06ff9bed8cf66ccef355514018813984abd388fb5c4dcceffcaf1',
          file_name:
            'videos/a924faa77cb06ff9bed8cf66ccef355514018813984abd388fb5c4dcceffcaf1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a924faa77cb06ff9bed8cf66ccef355514018813984abd388fb5c4dcceffcaf1.mp4',
          name: 'INT-ADV-Gliding_Knee_Tucks_To_Pike-EXERCISE',
          description: null,
          size: 84968,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2511,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'aa2dee20308ad82e17c16498565b0e7ba57a95f5130a7ef1bf81febc9100a1a2',
          file_name:
            'audios/aa2dee20308ad82e17c16498565b0e7ba57a95f5130a7ef1bf81febc9100a1a2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/aa2dee20308ad82e17c16498565b0e7ba57a95f5130a7ef1bf81febc9100a1a2.mp3',
          name: 'INT-ADV-Gliding_Knee_Tucks_To_Pike-EXERCISE',
          description: null,
          size: 31792,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-GLIDING_KNEE_TUCKS_TO_PIKE-EXERCISE': {
      id: 979,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Gliding Knee Tucks to Pike',
      short_name: 'Gliding Knee Tucks to Pike',
      unique_name: 'ADVANCED-GLIDING_KNEE_TUCKS_TO_PIKE-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists and a Glider under each foot.\n2. Using core, bend knees and slide feet toward hands. Straighten legs and slide back to Plank.\n3. Keeping legs straight, use core and lift hips up as high as possible sliding feet toward your hands. Your arms remain straight and head drops so ears are in line with the pits of elbows.\n4. Drop your hips and slide back to start.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2512,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'a924faa77cb06ff9bed8cf66ccef355514018813984abd388fb5c4dcceffcaf1',
          file_name:
            'videos/a924faa77cb06ff9bed8cf66ccef355514018813984abd388fb5c4dcceffcaf1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a924faa77cb06ff9bed8cf66ccef355514018813984abd388fb5c4dcceffcaf1.mp4',
          name: 'INT-ADV-Gliding_Knee_Tucks_To_Pike-EXERCISE',
          description: null,
          size: 84968,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2513,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'aa2dee20308ad82e17c16498565b0e7ba57a95f5130a7ef1bf81febc9100a1a2',
          file_name:
            'audios/aa2dee20308ad82e17c16498565b0e7ba57a95f5130a7ef1bf81febc9100a1a2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/aa2dee20308ad82e17c16498565b0e7ba57a95f5130a7ef1bf81febc9100a1a2.mp3',
          name: 'INT-ADV-Gliding_Knee_Tucks_To_Pike-EXERCISE',
          description: null,
          size: 31792,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-GLIDING_MOUNTAIN_CLIMBERS-EXERCISE': {
      id: 980,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Gliding Mountain Climbers',
      short_name: 'Gliding Mountain Climbers',
      unique_name: 'INTERMEDIATE-GLIDING_MOUNTAIN_CLIMBERS-EXERCISE',
      description:
        '1. Start in Plank with a Glider under each foot.\n2. Bend one knee and glide your foot straight up toward your chest. The other remains engaged and extended.\n3. Keeping hips low, glide that foot back and straighten leg as you glide the opposite knee up toward your chest.\n4. Repeat in a continous motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2514,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'f09057179553339e613ec330d70d17cf53d29e41f765df30626869b2947174e6',
          file_name:
            'videos/f09057179553339e613ec330d70d17cf53d29e41f765df30626869b2947174e6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f09057179553339e613ec330d70d17cf53d29e41f765df30626869b2947174e6.mp4',
          name: 'INT-ADV-Gliding_Mountain_Climbers-EXERCISE',
          description: null,
          size: 30117,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2515,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'e115dffef7b8e5807005ed74e31b6afe5b76f68225e818bb8ded57f999487fa2',
          file_name:
            'audios/e115dffef7b8e5807005ed74e31b6afe5b76f68225e818bb8ded57f999487fa2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e115dffef7b8e5807005ed74e31b6afe5b76f68225e818bb8ded57f999487fa2.mp3',
          name: 'INT-ADV-Gliding_Mountain_Climbers-EXERCISE',
          description: null,
          size: 30359,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-GLIDING_MOUNTAIN_CLIMBERS-EXERCISE': {
      id: 981,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Gliding Mountain Climbers',
      short_name: 'Gliding Mountain Climbers',
      unique_name: 'ADVANCED-GLIDING_MOUNTAIN_CLIMBERS-EXERCISE',
      description:
        '1. Start in Plank with a Glider under each foot.\n2. Bend one knee and glide your foot straight up toward your chest. The other remains engaged and extended.\n3. Keeping hips low, glide that foot back and straighten leg as you glide the opposite knee up toward your chest.\n4. Repeat in a continous motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 12,
          name: 'Gliders',
          unique_name: 'GLIDERS',
          min_app_version: 300000000,
          order: 2000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2516,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'f09057179553339e613ec330d70d17cf53d29e41f765df30626869b2947174e6',
          file_name:
            'videos/f09057179553339e613ec330d70d17cf53d29e41f765df30626869b2947174e6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f09057179553339e613ec330d70d17cf53d29e41f765df30626869b2947174e6.mp4',
          name: 'INT-ADV-Gliding_Mountain_Climbers-EXERCISE',
          description: null,
          size: 30117,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2517,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'e115dffef7b8e5807005ed74e31b6afe5b76f68225e818bb8ded57f999487fa2',
          file_name:
            'audios/e115dffef7b8e5807005ed74e31b6afe5b76f68225e818bb8ded57f999487fa2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e115dffef7b8e5807005ed74e31b6afe5b76f68225e818bb8ded57f999487fa2.mp3',
          name: 'INT-ADV-Gliding_Mountain_Climbers-EXERCISE',
          description: null,
          size: 30359,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SUPINE_ALTERNATING_MINI_BAND_LEG_RAISES-EXERCISE': {
      id: 982,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Supine Alternating Mini Band Leg Raises',
      short_name: 'Supine Band Leg Raises',
      unique_name:
        'INTERMEDIATE-SUPINE_ALTERNATING_MINI_BAND_LEG_RAISES-EXERCISE',
      description:
        '1. Lie on your back with a Mini Band around your ankles. Place your arms by your sides, palms facing down.\n2. Engage your core and raise one foot straight up to the ceiling.\n3. With control, lower that leg and return to start.\n4. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2518,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '1e469416e756a7f96915c3ffce80e437aa08e3477bd97a24cfed0a92260b092f',
          file_name:
            'videos/1e469416e756a7f96915c3ffce80e437aa08e3477bd97a24cfed0a92260b092f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1e469416e756a7f96915c3ffce80e437aa08e3477bd97a24cfed0a92260b092f.mp4',
          name: 'INT-ADV-Supine_Alternating_Mini_Band_Leg_Raises-EXERCISE',
          description: null,
          size: 94937,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2519,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '5fc38f8b574e688190fc1ee618edbc1c8cf39514a0272c5e825f9e04989eb23d',
          file_name:
            'audios/5fc38f8b574e688190fc1ee618edbc1c8cf39514a0272c5e825f9e04989eb23d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5fc38f8b574e688190fc1ee618edbc1c8cf39514a0272c5e825f9e04989eb23d.mp3',
          name: 'INT-ADV-Supine_Alternating_Mini_Band_Leg_Raises-EXERCISE',
          description: null,
          size: 55065,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SUPINE_ALTERNATING_MINI_BAND_LEG_RAISES-EXERCISE': {
      id: 983,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Supine Alternating Mini Band Leg Raises',
      short_name: 'Supine Band Leg Raises',
      unique_name: 'ADVANCED-SUPINE_ALTERNATING_MINI_BAND_LEG_RAISES-EXERCISE',
      description:
        '1. Lie on your back with a Mini Band around your ankles. Place your arms by your sides, palms facing down.\n2. Engage your core and raise one foot straight up to the ceiling.\n3. With control, lower that leg and return to start.\n4. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2520,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '1e469416e756a7f96915c3ffce80e437aa08e3477bd97a24cfed0a92260b092f',
          file_name:
            'videos/1e469416e756a7f96915c3ffce80e437aa08e3477bd97a24cfed0a92260b092f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1e469416e756a7f96915c3ffce80e437aa08e3477bd97a24cfed0a92260b092f.mp4',
          name: 'INT-ADV-Supine_Alternating_Mini_Band_Leg_Raises-EXERCISE',
          description: null,
          size: 94937,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2521,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '5fc38f8b574e688190fc1ee618edbc1c8cf39514a0272c5e825f9e04989eb23d',
          file_name:
            'audios/5fc38f8b574e688190fc1ee618edbc1c8cf39514a0272c5e825f9e04989eb23d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5fc38f8b574e688190fc1ee618edbc1c8cf39514a0272c5e825f9e04989eb23d.mp3',
          name: 'INT-ADV-Supine_Alternating_Mini_Band_Leg_Raises-EXERCISE',
          description: null,
          size: 55065,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_MOUNTAIN_CLIMBERS-EXERCISE': {
      id: 984,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Mini Band Mountain Climbers',
      short_name: 'Mini Band Mountain Climbers',
      unique_name: 'INTERMEDIATE-MINI_BAND_MOUNTAIN_CLIMBERS-EXERCISE',
      description:
        '1. Start in Plank postion with a Mini Band looped over your toes in center of feet with little to no slack.\n2. Pull one knee straight up toward your chest while the other remains engaged and extended.\n3. Keeping hips low, extend bent knee and step it back while drawing the opposite knee up towards chest.\n4. Repeat in continous motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2522,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'bf04b1b082cbb9a2b2cab347bfe3f6b9c06094e5d3c9916b1a90b4640fc37eaa',
          file_name:
            'videos/bf04b1b082cbb9a2b2cab347bfe3f6b9c06094e5d3c9916b1a90b4640fc37eaa.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf04b1b082cbb9a2b2cab347bfe3f6b9c06094e5d3c9916b1a90b4640fc37eaa.mp4',
          name: 'INT-ADV-Mini_Band_Mountain_Climbers-EXERCISE',
          description: null,
          size: 58058,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2523,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '98c8c3a938563c3d246c08e90a3110588674c88368d4d460444cc935af59ee10',
          file_name:
            'audios/98c8c3a938563c3d246c08e90a3110588674c88368d4d460444cc935af59ee10.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/98c8c3a938563c3d246c08e90a3110588674c88368d4d460444cc935af59ee10.mp3',
          name: 'INT-ADV-Mini_Band_Mountain_Climbers-EXERCISE',
          description: null,
          size: 32644,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_MOUNTAIN_CLIMBERS-EXERCISE': {
      id: 985,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Mini Band Mountain Climbers',
      short_name: 'Mini Band Mountain Climbers',
      unique_name: 'ADVANCED-MINI_BAND_MOUNTAIN_CLIMBERS-EXERCISE',
      description:
        '1. Start in Plank postion with a Mini Band looped over your toes in center of feet with little to no slack.\n2. Pull one knee straight up toward your chest while the other remains engaged and extended.\n3. Keeping hips low, extend bent knee and step it back while drawing the opposite knee up towards chest.\n4. Repeat in continous motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2524,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'bf04b1b082cbb9a2b2cab347bfe3f6b9c06094e5d3c9916b1a90b4640fc37eaa',
          file_name:
            'videos/bf04b1b082cbb9a2b2cab347bfe3f6b9c06094e5d3c9916b1a90b4640fc37eaa.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf04b1b082cbb9a2b2cab347bfe3f6b9c06094e5d3c9916b1a90b4640fc37eaa.mp4',
          name: 'INT-ADV-Mini_Band_Mountain_Climbers-EXERCISE',
          description: null,
          size: 58058,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2525,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: '98c8c3a938563c3d246c08e90a3110588674c88368d4d460444cc935af59ee10',
          file_name:
            'audios/98c8c3a938563c3d246c08e90a3110588674c88368d4d460444cc935af59ee10.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/98c8c3a938563c3d246c08e90a3110588674c88368d4d460444cc935af59ee10.mp3',
          name: 'INT-ADV-Mini_Band_Mountain_Climbers-EXERCISE',
          description: null,
          size: 32644,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MINI_BAND_PLANK_TAP_OUTS-EXERCISE': {
      id: 986,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Mini Band Plank Tap Outs',
      short_name: 'Mini Band Plank Tap Outs',
      unique_name: 'INTERMEDIATE-MINI_BAND_PLANK_TAP_OUTS-EXERCISE',
      description:
        '1. Start in Plank position with a Mini Band around your ankles with little to no slack. Keep shoulders over wrists and hips square.\n2. Using the resistance of the band, tap one foot out to the side. With control, return to center.\n3. Tap the other foot out to the side. Return to center. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2526,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'a5616674449cbcfdafd4c8fde4e50a60e2f6154e3ee44e3a977ce904ad10697f',
          file_name:
            'videos/a5616674449cbcfdafd4c8fde4e50a60e2f6154e3ee44e3a977ce904ad10697f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a5616674449cbcfdafd4c8fde4e50a60e2f6154e3ee44e3a977ce904ad10697f.mp4',
          name: 'INT-ADV-Mini_Band_Plank_Tap_Outs-EXERCISE',
          description: null,
          size: 64042,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2527,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'e558c57554c807cd771e0dffa21d3520bdda107b5044e6b99bfc859c5e04e15e',
          file_name:
            'audios/e558c57554c807cd771e0dffa21d3520bdda107b5044e6b99bfc859c5e04e15e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e558c57554c807cd771e0dffa21d3520bdda107b5044e6b99bfc859c5e04e15e.mp3',
          name: 'INT-ADV-Mini_Band_Plank_Tap_Outs-EXERCISE',
          description: null,
          size: 31613,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MINI_BAND_PLANK_TAP_OUTS-EXERCISE': {
      id: 987,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Mini Band Plank Tap Outs',
      short_name: 'Mini Band Plank Tap Outs',
      unique_name: 'ADVANCED-MINI_BAND_PLANK_TAP_OUTS-EXERCISE',
      description:
        '1. Start in Plank position with a Mini Band around your ankles with little to no slack. Keep shoulders over wrists and hips square.\n2. Using the resistance of the band, tap one foot out to the side. With control, return to center.\n3. Tap the other foot out to the side. Return to center. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300000000,
      archived: false,
      equipment: [
        {
          id: 13,
          name: 'Mini Bands',
          unique_name: 'MINI_BANDS',
          min_app_version: 300000000,
          order: 1000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2528,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'a5616674449cbcfdafd4c8fde4e50a60e2f6154e3ee44e3a977ce904ad10697f',
          file_name:
            'videos/a5616674449cbcfdafd4c8fde4e50a60e2f6154e3ee44e3a977ce904ad10697f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a5616674449cbcfdafd4c8fde4e50a60e2f6154e3ee44e3a977ce904ad10697f.mp4',
          name: 'INT-ADV-Mini_Band_Plank_Tap_Outs-EXERCISE',
          description: null,
          size: 64042,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2529,
          collection_name: 'audios',
          order: 1,
          version: 300000000,
          hash: 'e558c57554c807cd771e0dffa21d3520bdda107b5044e6b99bfc859c5e04e15e',
          file_name:
            'audios/e558c57554c807cd771e0dffa21d3520bdda107b5044e6b99bfc859c5e04e15e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e558c57554c807cd771e0dffa21d3520bdda107b5044e6b99bfc859c5e04e15e.mp3',
          name: 'INT-ADV-Mini_Band_Plank_Tap_Outs-EXERCISE',
          description: null,
          size: 31613,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-DUMBBELL_FRONT_SQUATS-EXERCISE': {
      id: 1016,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Front Squats',
      short_name: 'Dumbbell Front Squats',
      unique_name: 'BEGINNER-DUMBBELL_FRONT_SQUATS-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart. Hold a dumbbell in each hand, resting lightly on your shoulders, elbows pointed down.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2647,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '1b4c542b1e830ab54244d7d913a18a64b203afa2fe0292e696b233524f31fff9',
          file_name:
            'videos/1b4c542b1e830ab54244d7d913a18a64b203afa2fe0292e696b233524f31fff9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1b4c542b1e830ab54244d7d913a18a64b203afa2fe0292e696b233524f31fff9.mp4',
          name: 'INT-ADV-Dumbbell_Front_Squats-EXERCISE',
          description: null,
          size: 64498,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2648,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '471d0cc2849bad8280ad939464309868fbc28e9fc40ed2ae153413641768f742',
          file_name:
            'audios/471d0cc2849bad8280ad939464309868fbc28e9fc40ed2ae153413641768f742.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/471d0cc2849bad8280ad939464309868fbc28e9fc40ed2ae153413641768f742.mp3',
          name: 'INT-ADV-Dumbbell_Front_Squats-EXERCISE',
          description: null,
          size: 30707,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-BURPEES_WITH_FRONT_RAISE-EXERCISE': {
      id: 1017,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Burpees with Front Raise',
      short_name: 'Burpees with Front Raise',
      unique_name: 'BEGINNER-BURPEES_WITH_FRONT_RAISE-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart holding a dumbbell in each hand. Raise dumbbells in front of you to shoulder height, arms straight and palms down.\n2. Lower dumbbells back to start. Bend knees and hinge at waist to plant both dumbbells on the floor. Palms face in.\n3. Jump feet behind you to Plank.\n4. Jump feet back in, shoulder-width apart, heels flat.\n5. Transfer weight back to a low squat, stand up and repeat.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2649,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '2ded45f61d0b19c35cdabfebef48ebb1bbd8ba7ff64bcd013c9728ad0b63b3c3',
          file_name:
            'audios/2ded45f61d0b19c35cdabfebef48ebb1bbd8ba7ff64bcd013c9728ad0b63b3c3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2ded45f61d0b19c35cdabfebef48ebb1bbd8ba7ff64bcd013c9728ad0b63b3c3.mp3',
          name: 'INT-ADV-Burpees_with_Front_Raise-EXERCISE',
          description: null,
          size: 29260,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2650,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '0f39b16d45b1e85b97152d215d500b80db4bf3852f60715fa317f8e75f682cc5',
          file_name:
            'videos/0f39b16d45b1e85b97152d215d500b80db4bf3852f60715fa317f8e75f682cc5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0f39b16d45b1e85b97152d215d500b80db4bf3852f60715fa317f8e75f682cc5.mp4',
          name: 'INT-ADV-Burpees_with_Front_Raise-EXERCISE',
          description: null,
          size: 155666,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CLOSE_STANCE_DUMBBELL_SQUATS-EXERCISE': {
      id: 1018,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Close Stance Dumbbell Squats',
      short_name: 'Close Stance Dumbbell Squats',
      unique_name: 'BEGINNER-CLOSE_STANCE_DUMBBELL_SQUATS-EXERCISE',
      description:
        '1. Stand with your legs and feet close together, holding a dumbbell in each hand down by your sides.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2651,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '405543994b45efd344091dbc3e884d1fa5acb7688cedce1bd14bacc06479bd26',
          file_name:
            'videos/405543994b45efd344091dbc3e884d1fa5acb7688cedce1bd14bacc06479bd26.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/405543994b45efd344091dbc3e884d1fa5acb7688cedce1bd14bacc06479bd26.mp4',
          name: 'INT-ADV-Close_Stance_Dumbbell_Squats-EXERCISE.mp4',
          description: null,
          size: 89217,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2652,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'd7b282215838d67efd3544260b3d055d1f9ae485686ffb7557ff4bff3a95b99b',
          file_name:
            'audios/d7b282215838d67efd3544260b3d055d1f9ae485686ffb7557ff4bff3a95b99b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d7b282215838d67efd3544260b3d055d1f9ae485686ffb7557ff4bff3a95b99b.mp3',
          name: 'INT-ADV-Close_Stance_Dumbbell_Squats-EXERCISE.mp3',
          description: null,
          size: 45487,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-Y_T_WS-EXERCISE': {
      id: 1019,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'YTWs ',
      short_name: 'YTWs ',
      unique_name: 'BEGINNER-Y_T_WS-EXERCISE',
      description:
        '1. Stand feet shoulder-width apart, knees slightly bent.\n2. Hinge at the waist until torso is close to parallel to the floor. Arms extended down with a dumbbell in each hand.\n3. Raise both arms up and out to a "Y" fists face each other. Lower arms down.\n4. Raise both arms out to your sides in a "T". Lower arms down.\n5. Perform a wide row. Hold at the top and rotate shoulders to raise dumbbells toward your head.\n6. Lower arms back to a wide row. Straighten arms to return to start. ',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2653,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f8815392006fe32af04e5c03839adffe59d492ab1ed01fe57fd8b387864e2dc5',
          file_name:
            'videos/f8815392006fe32af04e5c03839adffe59d492ab1ed01fe57fd8b387864e2dc5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f8815392006fe32af04e5c03839adffe59d492ab1ed01fe57fd8b387864e2dc5.mp4',
          name: 'INT-ADV-YTWs-EXERCISE',
          description: null,
          size: 222510,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2654,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '13535d45baa06b030d06f0dc2c00c537f03ce1b9a56ed25e9d6cb6700e4c58ff',
          file_name:
            'audios/13535d45baa06b030d06f0dc2c00c537f03ce1b9a56ed25e9d6cb6700e4c58ff.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/13535d45baa06b030d06f0dc2c00c537f03ce1b9a56ed25e9d6cb6700e4c58ff.mp3',
          name: 'INT-ADV-YTWs-EXERCISE',
          description: null,
          size: 30513,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-WS-EXERCISE': {
      id: 1020,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Ws',
      short_name: 'Ws',
      unique_name: 'BEGINNER-WS-EXERCISE',
      description:
        '1. Stand feet shoulder-width apart, knees slightly bent.\n2. Hinge at the waist until torso is close to parallel to floor. Arms extended down with a dumbbell in each hand, palms face back.\n3. Squeeze shoulder blades together and row dumbbells up, keeping elbows wide and in line with shoulders.\n4. Rotate shoulders and raise dumbbells toward your head, keeping elbows wide.\n5. Lower dumbbells back down to a wide row. Straighten arms and return to start.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2655,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '06dd6a0cf064aeb0b52d5ecd42d477395c862b82e3cc915a2318c71508cc3686',
          file_name:
            'videos/06dd6a0cf064aeb0b52d5ecd42d477395c862b82e3cc915a2318c71508cc3686.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/06dd6a0cf064aeb0b52d5ecd42d477395c862b82e3cc915a2318c71508cc3686.mp4',
          name: 'INT-ADV-Ws-EXERCISE',
          description: null,
          size: 117543,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2656,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: 'c881d34697d1a25b2f33a777964c6e0c8796c2d51092abce7e28dabe4f4376fd',
          file_name:
            'audios/c881d34697d1a25b2f33a777964c6e0c8796c2d51092abce7e28dabe4f4376fd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c881d34697d1a25b2f33a777964c6e0c8796c2d51092abce7e28dabe4f4376fd.mp3',
          name: 'INT-ADV-Ws-EXERCISE',
          description: null,
          size: 24560,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-YS-EXERCISE': {
      id: 1021,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Ys',
      short_name: 'Ys',
      unique_name: 'BEGINNER-YS-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, knees slightly bent.\n2. Hinge at the waist until your torso is close to parallel to the floor. Arms extended down with a dumbbell in each hand.\n3. Raise both arms up and out to a "Y" shape, biceps in line with ears, fists face each other. Avoid shrugging, keeping space between your shoulders and ears.\n4. Lower your arms back to start position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2657,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: '62ac8fd7a417548627487b643fafb391dfc6bae30406d93c553998aeb296989c',
          file_name:
            'videos/62ac8fd7a417548627487b643fafb391dfc6bae30406d93c553998aeb296989c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/62ac8fd7a417548627487b643fafb391dfc6bae30406d93c553998aeb296989c.mp4',
          name: 'INT-ADV-Ys-EXERCISE',
          description: null,
          size: 69836,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2658,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '9e3feb43a8f5a2bcd7094896a7520f412d019a50144c5b0d52c0b5a7175609d1',
          file_name:
            'audios/9e3feb43a8f5a2bcd7094896a7520f412d019a50144c5b0d52c0b5a7175609d1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9e3feb43a8f5a2bcd7094896a7520f412d019a50144c5b0d52c0b5a7175609d1.mp3',
          name: 'INT-ADV-Ys-EXERCISE',
          description: null,
          size: 20798,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHEST_PRESS-EXERCISE': {
      id: 1022,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Chest Press',
      short_name: 'Chest Press',
      unique_name: 'BEGINNER-CHEST_PRESS-EXERCISE',
      description:
        '1. Lie on a bench with a dumbbell in each hand and your feet flat on the floor. Allow for a natural curve in your lower back.\n2. Raise the dumbbells up over your shoulders, palms facing your feet. Shrug your shoulders down "into your back pockets".\n3. Bend your elbows, and lower the dumbbells out to the sides until your arms are at 90 degrees.\n4. Squeeze your chest and bring dumbbells back to start position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2659,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'b8d667c74f1be766651eb577bbf10d06cec55f66e5f5265bd13492ce38718b10',
          file_name:
            'videos/b8d667c74f1be766651eb577bbf10d06cec55f66e5f5265bd13492ce38718b10.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b8d667c74f1be766651eb577bbf10d06cec55f66e5f5265bd13492ce38718b10.mp4',
          name: 'PHIL_025_CHEST_PRESS_2_small_720.mp4',
          description: null,
          size: 94503,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2660,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'c06372c00df81543a2a9d971fbae02b012a55b5bb4858aeb3c0adb41faed4656',
          file_name:
            'audios/c06372c00df81543a2a9d971fbae02b012a55b5bb4858aeb3c0adb41faed4656.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c06372c00df81543a2a9d971fbae02b012a55b5bb4858aeb3c0adb41faed4656.mp3',
          name: 'INT-ADV-Chest_Press-EXERCISE.mp3',
          description: null,
          size: 25998,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-PLANK_DUMBBELL_PULL_THROUGHS-EXERCISE': {
      id: 1023,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Plank Dumbbell Pull Throughs',
      short_name: 'Plank Dumbbell Pull Throughs',
      unique_name: 'BEGINNER-PLANK_DUMBBELL_PULL_THROUGHS-EXERCISE',
      description:
        '1. Start in Plank position with shoulders over wrists, hips square. Place a dumbbell off to one side and behind your wrist horizontally.\n2. Reach arm across and underneath your body to grab the handle of the dumbbell.\n3. Drag the dumbbell to the opposite side and place your hand back on the floor to return to Plank.\n4. Repeat with the other arm. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2661,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '24d1b5d7981d28e88f06d1ef1595360201d58126f98636cb09a482b2988b628f',
          file_name:
            'videos/24d1b5d7981d28e88f06d1ef1595360201d58126f98636cb09a482b2988b628f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/24d1b5d7981d28e88f06d1ef1595360201d58126f98636cb09a482b2988b628f.mp4',
          name: 'INT-ADV-Plank_Dumbbell_Pull_Throughs-EXERCISE',
          description: null,
          size: 88841,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2662,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '6ee2b4b6c801ea64076e21bdd33b804f1618ae7212bfef3dac7347b757e77446',
          file_name:
            'audios/6ee2b4b6c801ea64076e21bdd33b804f1618ae7212bfef3dac7347b757e77446.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6ee2b4b6c801ea64076e21bdd33b804f1618ae7212bfef3dac7347b757e77446.mp3',
          name: 'INT-ADV-Plank_Dumbbell_Pull_Throughs-EXERCISE',
          description: null,
          size: 33013,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHEST_FLY-EXERCISE': {
      id: 1024,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Chest Fly',
      short_name: 'Chest Fly',
      unique_name: 'BEGINNER-CHEST_FLY-EXERCISE',
      description:
        '1. Lie on a bench with a dumbbell in each hand and your feet flat on the floor. Allow for a natural curve in your lower back.\n2. Raise dumbbells over your shoulders, palms in. Shrug shoulders down and bend your elbows slightly in a fixed position.\n3. Open your arms and lower dumbbells out to the side aiming for parallel with the floor.\n4. Squeeze your chest and bring dumbbells to start position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2663,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '8c435add29924ec18d75369940d1c6cd980fec15f41237e613a26dc3312b2653',
          file_name:
            'videos/8c435add29924ec18d75369940d1c6cd980fec15f41237e613a26dc3312b2653.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8c435add29924ec18d75369940d1c6cd980fec15f41237e613a26dc3312b2653.mp4',
          name: 'PHIL_024_CHEST_FLY_2_small_720.mp4',
          description: null,
          size: 101810,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2664,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'dbb374447c56e24ce932cb1023d7fda2a0a207f5664b5f061001a58ca7266b33',
          file_name:
            'audios/dbb374447c56e24ce932cb1023d7fda2a0a207f5664b5f061001a58ca7266b33.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dbb374447c56e24ce932cb1023d7fda2a0a207f5664b5f061001a58ca7266b33.mp3',
          name: 'ChestFlys.mp3',
          description: null,
          size: 21308,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-OVERHEAD_TRICEP_EXTENSIONS-EXERCISE': {
      id: 1025,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Overhead Tricep Extensions',
      short_name: 'Overh. Tricep Extensions',
      unique_name: 'BEGINNER-OVERHEAD_TRICEP_EXTENSIONS-EXERCISE',
      description:
        '1. Start standing with your feet shoulder-width apart, core tight and hold one dumbbell vertically in both hands.\n2. Lift the dumbbell overhead until your arms are fully extended, palms face the ceiling and elbows pointing forward.\n3. Bend your elbows and lower the dumbbell behind your head until your arms are just lower than 90 degrees.\n4. Extend your arms and return to starting position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2665,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '98618093aaf49143c5bbd880df207a09e013d0d7ad370230a666354cc802e02e',
          file_name:
            'videos/98618093aaf49143c5bbd880df207a09e013d0d7ad370230a666354cc802e02e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/98618093aaf49143c5bbd880df207a09e013d0d7ad370230a666354cc802e02e.mp4',
          name: '010_OVERHEAD_TRICEP_EXTENSIONS_1_2_30percent_small_720.mp4',
          description: null,
          size: 60082,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2666,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '166114ed9ee22b9a851695df8941ab6121ddaa246dbee69638920f0a74a6f92e',
          file_name:
            'audios/166114ed9ee22b9a851695df8941ab6121ddaa246dbee69638920f0a74a6f92e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/166114ed9ee22b9a851695df8941ab6121ddaa246dbee69638920f0a74a6f92e.mp3',
          name: 'INT-ADV-Overhead_Tricep_Extensions-EXERCISE.mp3',
          description: null,
          size: 33703,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SHOULDER_PRESSES-EXERCISE': {
      id: 1026,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Shoulder Presses',
      short_name: 'Shoulder Presses',
      unique_name: 'BEGINNER-SHOULDER_PRESSES-EXERCISE',
      description:
        '1. Stand with a solid foundation, back straight and core engaged. Hold a dumbbell in each hand at your shoulders, palms facing out.\n2. Raise both dumbbells straight overhead to full extension, biceps by your ears.\n3. Lower the dumbbells back to starting position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2667,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '1391a2505601c848fb84155de4bb1983784a3252e08748cb8b6fad4b89e7efac',
          file_name:
            'videos/1391a2505601c848fb84155de4bb1983784a3252e08748cb8b6fad4b89e7efac.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1391a2505601c848fb84155de4bb1983784a3252e08748cb8b6fad4b89e7efac.mp4',
          name: 'LOGAN_SHOULDER_PRESS_W_DUMBELLS_B_LOOP_SAMLL_720.mp4',
          description: null,
          size: 111634,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2668,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '7a844024994839ef8aa76d875b7a91dda5ae46e2539ec9f5a7a5c2238691256e',
          file_name:
            'audios/7a844024994839ef8aa76d875b7a91dda5ae46e2539ec9f5a7a5c2238691256e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7a844024994839ef8aa76d875b7a91dda5ae46e2539ec9f5a7a5c2238691256e.mp3',
          name: 'Shoulder_Presses.mp3',
          description: null,
          size: 21919,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-BENT_OVER_ROWS-EXERCISE': {
      id: 1027,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bent Over Rows',
      short_name: 'Bent Over Rows',
      unique_name: 'BEGINNER-BENT_OVER_ROWS-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart and a dumbbell in each hand, palms in.\n2. With your back straight, hinge at the waist so your torso is close to parallel with the floor, arms extended down. Pull shoulders away from your ears.\n3. Bend your elbows and pull the dumbbells toward your hips. Keep elbows tight to your body.\n4. Lower dumbbells back to start position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2669,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'b9b04fb9def02d888bc798d7404b70c85fa227b5607a5ef686caeec035fce1dc',
          file_name:
            'videos/b9b04fb9def02d888bc798d7404b70c85fa227b5607a5ef686caeec035fce1dc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b9b04fb9def02d888bc798d7404b70c85fa227b5607a5ef686caeec035fce1dc.mp4',
          name: 'PHIL_019_BENT_OVER_ROWS_1_small_720.mp4',
          description: null,
          size: 58869,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2670,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'a568c307b6362f1bfe737a557e5338ea7420e17dff107a9d1617761dabee3ee0',
          file_name:
            'audios/a568c307b6362f1bfe737a557e5338ea7420e17dff107a9d1617761dabee3ee0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a568c307b6362f1bfe737a557e5338ea7420e17dff107a9d1617761dabee3ee0.mp3',
          name: 'BentOverRows.mp3',
          description: null,
          size: 23324,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ALTERNATING_HAMMER_CURLS-EXERCISE': {
      id: 1028,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Alternating Hammer Curls',
      short_name: 'Alt. Hammer Curls',
      unique_name: 'BEGINNER-ALTERNATING_HAMMER_CURLS-EXERCISE',
      description:
        '1. Start standing with your arms by your sides and a dumbbell in each hand. Palms face each other.\n2. Keep your elbows close to your ribcage and curl one weight up toward your shoulder. Dumbbell stays vertical.\n3. Lower the weight back to the starting position.\n4. Repeat on the other side. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2671,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'ca44999aa6f1d0426ed23c99b69e460c3ffd0c4570d2163c339966f3b48cae68',
          file_name:
            'videos/ca44999aa6f1d0426ed23c99b69e460c3ffd0c4570d2163c339966f3b48cae68.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ca44999aa6f1d0426ed23c99b69e460c3ffd0c4570d2163c339966f3b48cae68.mp4',
          name: '007_ALTERNATING_HAMMER_CURL_3_15percent_plus_30percent_small_720.mp4',
          description: null,
          size: 120354,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2672,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '1be11a503af47b3343406582bf666b4a7712fee8ce2b28cea96ce21370af0af9',
          file_name:
            'audios/1be11a503af47b3343406582bf666b4a7712fee8ce2b28cea96ce21370af0af9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1be11a503af47b3343406582bf666b4a7712fee8ce2b28cea96ce21370af0af9.mp3',
          name: 'AlternatingHammerCurls.mp3',
          description: null,
          size: 28508,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-WIDE_BICEP_CURLS-EXERCISE': {
      id: 1029,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Wide Bicep Curls',
      short_name: 'Wide Bicep Curls',
      unique_name: 'BEGINNER-WIDE_BICEP_CURLS-EXERCISE',
      description:
        '1. Start standing with your feet about shoulder-width apart, hold one dumbbell in each hand, palms facing forward.\n2. Keep your elbows close to your ribcage. Rotate your palms toward the ceiling and curl the dumbbells up and out to the side toward your shoulders.\n3. Lower your arms back down to start position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2673,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'e4fd97261436e2eddcd5961b49f0b04223f5b2511bc04544510fb363f8da8a14',
          file_name:
            'videos/e4fd97261436e2eddcd5961b49f0b04223f5b2511bc04544510fb363f8da8a14.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e4fd97261436e2eddcd5961b49f0b04223f5b2511bc04544510fb363f8da8a14.mp4',
          name: '011_WIDE_CURL_1_3_small_720.mp4',
          description: null,
          size: 92620,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2674,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '29b9283648bf376f32ec781ea49c9323aeb4cf8388527f0834c1ba030b239ac3',
          file_name:
            'audios/29b9283648bf376f32ec781ea49c9323aeb4cf8388527f0834c1ba030b239ac3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/29b9283648bf376f32ec781ea49c9323aeb4cf8388527f0834c1ba030b239ac3.mp3',
          name: 'Wide-Bicep-Curls.mp3',
          description: null,
          size: 30210,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-DUMBBELL_UPPERCUTS-EXERCISE': {
      id: 1030,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Uppercuts',
      short_name: 'Dumbbell Uppercuts',
      unique_name: 'BEGINNER-DUMBBELL_UPPERCUTS-EXERCISE',
      description:
        '1. Start in a wide stance, feet slightly wider than your hips and hold a dumbbell in each hand. Keep your back straight, bend your knees slightly and place both fists under your chin.\n2. Moving toward the center of your body, pivot on one foot and rotate your hips and shoulders as you punch the dumbbell up slightly past your chin.\n3. Recoil your punch and return to start. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2675,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '7a4f39108943909005c0c620fc1fe2c602916b3fa4f545829335565627f8bdd9',
          file_name:
            'videos/7a4f39108943909005c0c620fc1fe2c602916b3fa4f545829335565627f8bdd9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7a4f39108943909005c0c620fc1fe2c602916b3fa4f545829335565627f8bdd9.mp4',
          name: 'INT-ADV-Dumbbell_Uppercuts-EXERCISE',
          description: null,
          size: 78600,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2676,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '262fcc2ae3fa4c318a9c85ca0141d37d599ffb5c7ad209ceb81699d87faeb769',
          file_name:
            'audios/262fcc2ae3fa4c318a9c85ca0141d37d599ffb5c7ad209ceb81699d87faeb769.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/262fcc2ae3fa4c318a9c85ca0141d37d599ffb5c7ad209ceb81699d87faeb769.mp3',
          name: 'INT-ADV-Dumbbell_Uppercuts-EXERCISE',
          description: null,
          size: 29179,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-DUMBBELL_PULLOVERS-EXERCISE': {
      id: 1031,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Pullovers',
      short_name: 'Dumbbell Pullovers',
      unique_name: 'BEGINNER-DUMBBELL_PULLOVERS-EXERCISE',
      description:
        '1. Place your upper back on the bench, just below your shoulder blades. Keep feet on the floor, hip-width apart under your knees.\n2. With both hands, hold one dumbbell vertically overhead, arms directly above your shoulders, elbows slightly bent. Lift hip off the floor.\n3. Keeping elbows in, lower the dumbbell behind you until your forearms are in line with your body.\n4. Raise the dumbbell back up overhead and return to start position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2677,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'e9430ec0c3fed77e7ee2e01710cd3aab71f4d7c8d5258d420dbb725fe5b969ff',
          file_name:
            'videos/e9430ec0c3fed77e7ee2e01710cd3aab71f4d7c8d5258d420dbb725fe5b969ff.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e9430ec0c3fed77e7ee2e01710cd3aab71f4d7c8d5258d420dbb725fe5b969ff.mp4',
          name: 'PHIL_026_DUMBELL_PULLOVER_1_small_720.mp4',
          description: null,
          size: 138375,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2678,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '78df3d3613ac6ac012ed96ada70beb0af9a05ec02649d8053929fec4facc0648',
          file_name:
            'audios/78df3d3613ac6ac012ed96ada70beb0af9a05ec02649d8053929fec4facc0648.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/78df3d3613ac6ac012ed96ada70beb0af9a05ec02649d8053929fec4facc0648.mp3',
          name: 'DumbbellPullovers.mp3',
          description: null,
          size: 26780,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SIT_AND_REACH-EXERCISE': {
      id: 1032,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Sit and Reach',
      short_name: 'Sit and Reach',
      unique_name: 'BEGINNER-SIT_AND_REACH-EXERCISE',
      description:
        '1. Lie on your back with your feet on the floor, knees bent. Hold a single dumbbell horizontally against your chest.\n2. Sit up and extend your arms overhead, reaching the dumbbell toward the ceiling.\n3. Extend fully at the top with a straight spine and "peek through the window" bringing your ears in line with the pits of your elbows.\n4. In a controlled motion, lower down back to start.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2679,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'f644498695d0dedbc2db90c28c2fa4f4f1e448af828b6f69540dc18be8359b63',
          file_name:
            'videos/f644498695d0dedbc2db90c28c2fa4f4f1e448af828b6f69540dc18be8359b63.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f644498695d0dedbc2db90c28c2fa4f4f1e448af828b6f69540dc18be8359b63.mp4',
          name: 'INT-ADV-Sit_and_Reach-EXERCISE.mp4',
          description: null,
          size: 117960,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2680,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: 'c94f4b0e09cfa4f5edb257eda30a1cad415e20b58eefdcc484f2bc7c910a9057',
          file_name:
            'audios/c94f4b0e09cfa4f5edb257eda30a1cad415e20b58eefdcc484f2bc7c910a9057.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c94f4b0e09cfa4f5edb257eda30a1cad415e20b58eefdcc484f2bc7c910a9057.mp3',
          name: 'INT-ADV-Sit_and_Reach-EXERCISE.mp3',
          description: null,
          size: 20732,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-DONKEY_KICKS_WITH_WEIGHT-EXERCISE': {
      id: 1033,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Donkey Kicks with Weight',
      short_name: 'Donkey Kicks with Weight',
      unique_name: 'BEGINNER-DONKEY_KICKS_WITH_WEIGHT-EXERCISE',
      description:
        '1. Start on all fours. Place one dumbbell behind your knee and squeeze. Keep shoulders and hips square, core tight.\n2. Hover weighted knee off the ground and raise your leg up behind you to hip level, driving heel toward the ceiling. Pretend to make a footprint.\n3. Squeeze glutes at the top. Do not arch your lower back. Slowly lower back to start position.\n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2681,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: '7ac6d774c95202e97d27ddab94493bb39efdf3e2dce9468f5c50c2b20a1218e9',
          file_name:
            'videos/7ac6d774c95202e97d27ddab94493bb39efdf3e2dce9468f5c50c2b20a1218e9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7ac6d774c95202e97d27ddab94493bb39efdf3e2dce9468f5c50c2b20a1218e9.mp4',
          name: 'INT-ADV-Donkey_Kicks_with_Weight-EXERCISE-(RIGHT).mp4',
          description: 'Right Side',
          size: 83738,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2682,
          collection_name: 'videos',
          order: 2,
          version: 100050000,
          hash: '42984b156c4ea4cdd1b856d86c3b24ee184716ac20bfe2f8c89ba7d83ca93325',
          file_name:
            'videos/42984b156c4ea4cdd1b856d86c3b24ee184716ac20bfe2f8c89ba7d83ca93325.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/42984b156c4ea4cdd1b856d86c3b24ee184716ac20bfe2f8c89ba7d83ca93325.mp4',
          name: 'INT-ADV-Donkey_Kicks_with_Weight-EXERCISE-(LEFT).mp4',
          description: 'Left Side',
          size: 77587,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2683,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: 'e121bb5260b04156e5831648ef210644c2cb9063885ef11124653158f1c87921',
          file_name:
            'audios/e121bb5260b04156e5831648ef210644c2cb9063885ef11124653158f1c87921.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e121bb5260b04156e5831648ef210644c2cb9063885ef11124653158f1c87921.mp3',
          name: 'INT-ADV-Donkey_Kicks_with_Weight-EXERCISE.mp3',
          description: null,
          size: 26503,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-DUMBBELL_BOX_SQUATS-EXERCISE': {
      id: 1034,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Box Squats',
      short_name: 'Dumbbell Box Squats',
      unique_name: 'BEGINNER-DUMBBELL_BOX_SQUATS-EXERCISE',
      description:
        '1. Start standing in front of the step. Hold a dumbbell in each hand, resting lightly on your shoulders, elbows pointing down.\n2. Maintaining good posture, bend your knees and sink your hips back to slowly lower yourself to sit on the step. Do not fully relax into a seated position, or lightly tap your glutes. Keep your muscles activated.\n3. Drive through your heels and return to stand.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2684,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '07226067d7874f89dc59db949092c68e1494411e59630a03f56ae8072a97df55',
          file_name:
            'videos/07226067d7874f89dc59db949092c68e1494411e59630a03f56ae8072a97df55.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/07226067d7874f89dc59db949092c68e1494411e59630a03f56ae8072a97df55.mp4',
          name: 'INT-ADV-Dumbbell_Box_Squats-EXERCISE',
          description: null,
          size: 76546,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2685,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24',
          file_name:
            'audios/3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3ba0c0485e57a2f83aeb7459540b9c1d5c0ad94f8343141057140a754d188c24.mp3',
          name: 'INT-ADV-Dumbbell_Box_Squats-EXERCISE',
          description: null,
          size: 29585,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SEESAW_PRESS-EXERCISE': {
      id: 1035,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Seesaw Press',
      short_name: 'Seesaw Press',
      unique_name: 'BEGINNER-SEESAW_PRESS-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart. Hold a dumbbell in each hand at your shoulders, palms face in, elbows down.\n2. With core engaged, swiftly press one dumbbell straight up into the air.\n3. As you bring your arm down, immediately press upwards with the opposite arm.\n4. Right and left is one rep. ',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2686,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'f9792f0226ce88c4bf6e790a25dfe04f119b29d891b72fe63f0249ea2e0c4a44',
          file_name:
            'videos/f9792f0226ce88c4bf6e790a25dfe04f119b29d891b72fe63f0249ea2e0c4a44.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f9792f0226ce88c4bf6e790a25dfe04f119b29d891b72fe63f0249ea2e0c4a44.mp4',
          name: 'INT-ADV-Seesaw_Press-EXERCISE',
          description: null,
          size: 45734,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2687,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '9dca68c444669107258c4ac2e7fec5a1aec1a6ccb618734413c5545afc692cc5',
          file_name:
            'audios/9dca68c444669107258c4ac2e7fec5a1aec1a6ccb618734413c5545afc692cc5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9dca68c444669107258c4ac2e7fec5a1aec1a6ccb618734413c5545afc692cc5.mp3',
          name: 'INT-ADV-Seesaw_Press-EXERCISE',
          description: null,
          size: 26125,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-DUMBBELL_SWINGS-EXERCISE': {
      id: 1036,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CARDIO',
      name: 'Dumbbell Swings',
      short_name: 'Dumbbell Swings',
      unique_name: 'BEGINNER-DUMBBELL_SWINGS-EXERCISE',
      description:
        '1. Stand with feet hip-width apart holding a dumbbell in both hands in front of you.\n2. Keeping chest up and back straight, bend knees, hinge at your hips and swing the dumbbell back in between legs.\n3. When the weight is behind you, explosively drive hips forward to swing the dumbbell in front of you to chest level.\n4. Let the dumbbell swing down and continue this motion. String reps together.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2688,
          collection_name: 'videos',
          order: 1,
          version: 100040000,
          hash: 'fab056208d4289949510d10a7687e74b59d6ee40bc9eadc59594d0553e6ff83a',
          file_name:
            'videos/fab056208d4289949510d10a7687e74b59d6ee40bc9eadc59594d0553e6ff83a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fab056208d4289949510d10a7687e74b59d6ee40bc9eadc59594d0553e6ff83a.mp4',
          name: 'INTERMEDIATE-Dumbbell_Swings-EXERCISE.mp4',
          description: null,
          size: 99084,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2689,
          collection_name: 'audios',
          order: 1,
          version: 100040000,
          hash: '7e973962350378af06074d741fcdde017da2dfc049ca4aac156bd4308239025b',
          file_name:
            'audios/7e973962350378af06074d741fcdde017da2dfc049ca4aac156bd4308239025b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7e973962350378af06074d741fcdde017da2dfc049ca4aac156bd4308239025b.mp3',
          name: 'INTERMEDIATE-Dumbbell_Swings-EXERCISE.mp3',
          description: null,
          size: 28754,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-DOUBLE_SUITCASE_SQUATS-EXERCISE': {
      id: 1037,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Double Suitcase Squats',
      short_name: 'Double Suitcase Squats',
      unique_name: 'BEGINNER-DOUBLE_SUITCASE_SQUATS-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart, holding a dumbbell in each hand down by your sides.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower.  Keep your chest up and shoulders back.\n3. Drive through your heels and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2690,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'abe811301c07de6a00cd58e6fffdd6a9a5eac6aed156d1c849d23cf47be2e751',
          file_name:
            'videos/abe811301c07de6a00cd58e6fffdd6a9a5eac6aed156d1c849d23cf47be2e751.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/abe811301c07de6a00cd58e6fffdd6a9a5eac6aed156d1c849d23cf47be2e751.mp4',
          name: 'CARRIE_SUITCASE_SQUAT_1_FULL_REP_LOOP_720.mp4',
          description: null,
          size: 101175,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2691,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'aeb392ba8ac364c24ce95c05b4e082bf337dc107540ca8f6f241207b4a0639d7',
          file_name:
            'audios/aeb392ba8ac364c24ce95c05b4e082bf337dc107540ca8f6f241207b4a0639d7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/aeb392ba8ac364c24ce95c05b4e082bf337dc107540ca8f6f241207b4a0639d7.mp3',
          name: 'Double_Suitcase_Squats.mp3',
          description: null,
          size: 38320,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-GOBLET_SQUAT-EXERCISE': {
      id: 1038,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Goblet Squat',
      short_name: 'Goblet Squat',
      unique_name: 'BEGINNER-GOBLET_SQUAT-EXERCISE',
      description:
        '1. Stand with your feet slightly wider than shoulder-width apart and hold a single dumbbell in front of your chest with both hands.\n2. Keeping your chest up and shoulders back, squat as low as possible trying to touch the outside of your elbows with the inside of your knee.\n3. Drive through your heels and return to standing.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2692,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '6ee33cdd71697afe5ed7ba97eac1a20606124b50d13c4508934ecc3f1e70c25f',
          file_name:
            'videos/6ee33cdd71697afe5ed7ba97eac1a20606124b50d13c4508934ecc3f1e70c25f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6ee33cdd71697afe5ed7ba97eac1a20606124b50d13c4508934ecc3f1e70c25f.mp4',
          name: 'LOGAN_GOBLET_SQUAT_W_DUMBELLS_CA_REV_SMALL_720.mp4',
          description: null,
          size: 87808,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2693,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'a1b99d8523a81f8ba07aca6b94d4f1ff68f1d99bc79f28d4360d2ecb21409bc7',
          file_name:
            'audios/a1b99d8523a81f8ba07aca6b94d4f1ff68f1d99bc79f28d4360d2ecb21409bc7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a1b99d8523a81f8ba07aca6b94d4f1ff68f1d99bc79f28d4360d2ecb21409bc7.mp3',
          name: 'INT-ADV-Goblet_Squat-EXERCISE.mp3',
          description: null,
          size: 26483,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SQUAT_TO_CURL-EXERCISE': {
      id: 1039,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Squat to Curl',
      short_name: 'Squat to Curl',
      unique_name: 'BEGINNER-SQUAT_TO_CURL-EXERCISE',
      description:
        '1. Start standing with your feet shoulder-width apart, holding one dumbbell in each hand, palms facing in.\n2. Squat down and lower the dumbbells toward the floor.\n3. Drive through your heels to stand as you curl the dumbbells toward your shoulders. Keep your elbows close to your ribcage.\n4. Lower your arms back down to starting position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
      ],
      files: [
        {
          id: 2694,
          collection_name: 'videos',
          order: 1,
          version: 100050000,
          hash: 'bda5ee81ac910fe3213823a87f6059b9abae3545c0ab30327cc7d1f07ad227d2',
          file_name:
            'videos/bda5ee81ac910fe3213823a87f6059b9abae3545c0ab30327cc7d1f07ad227d2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bda5ee81ac910fe3213823a87f6059b9abae3545c0ab30327cc7d1f07ad227d2.mp4',
          name: 'INT-ADV-Squat_to_Curl-EXERCISE.mp4',
          description: null,
          size: 127046,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2695,
          collection_name: 'audios',
          order: 1,
          version: 100050000,
          hash: '4f0e8a1dd92c81e763495e0b1dee1155d5b81066fd3ea2ef4b54327118ecfd71',
          file_name:
            'audios/4f0e8a1dd92c81e763495e0b1dee1155d5b81066fd3ea2ef4b54327118ecfd71.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4f0e8a1dd92c81e763495e0b1dee1155d5b81066fd3ea2ef4b54327118ecfd71.mp3',
          name: 'INT-ADV-Squat_with_Curl-EXERCISE.mp3',
          description: null,
          size: 29840,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SERVE_THE_PLATTER-EXERCISE': {
      id: 1040,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Serve The Platter',
      short_name: 'Serve The Platter',
      unique_name: 'BEGINNER-SERVE_THE_PLATTER-EXERCISE',
      description:
        '1. Stand tall with your arms by your sides and a dumbbell in each hand. Palms face out. Bend your elbows and curl dumbbells up to waist height, elbows tight to ribcage.\n2. Extend your arms up and away from your body until they are fully extended to shoulder height.\n3. With control, bend your elbows and lower the weights back to your waist at start position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2696,
          collection_name: 'videos',
          order: 1,
          version: 200060000,
          hash: 'dc109ab865078adeba2e7871010ebb3f20734256d0d181fa538ea961ea8a0a1d',
          file_name:
            'videos/dc109ab865078adeba2e7871010ebb3f20734256d0d181fa538ea961ea8a0a1d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/dc109ab865078adeba2e7871010ebb3f20734256d0d181fa538ea961ea8a0a1d.mp4',
          name: 'INT-ADV-Serve_The_Platter-EXERCISE',
          description: null,
          size: 52299,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2697,
          collection_name: 'audios',
          order: 1,
          version: 200060000,
          hash: '5206716e107255844762c1c13c9c0bdb24e22de991c8c4d162fd3be19d2b50f4',
          file_name:
            'audios/5206716e107255844762c1c13c9c0bdb24e22de991c8c4d162fd3be19d2b50f4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5206716e107255844762c1c13c9c0bdb24e22de991c8c4d162fd3be19d2b50f4.mp3',
          name: 'INT-ADV-Serve_The_Platter-EXERCISE',
          description: null,
          size: 26125,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-BICEP_CURLS-EXERCISE': {
      id: 1041,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Bicep Curls',
      short_name: 'Bicep Curls',
      unique_name: 'BEGINNER-BICEP_CURLS-EXERCISE',
      description:
        '1. Start standing with your arms by your sides and a dumbbell in each hand. Palms face each other.\n2. Keep your elbows close to your ribcage and curl the weight up towards your shoulders as you rotate your wrists so your palms face your body at the top.\n3. Lower the weights back to the starting position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2698,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '7707eb9f5e01500d20d0035a18893148ad4dc6699debe2378f28089675b03455',
          file_name:
            'videos/7707eb9f5e01500d20d0035a18893148ad4dc6699debe2378f28089675b03455.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7707eb9f5e01500d20d0035a18893148ad4dc6699debe2378f28089675b03455.mp4',
          name: 'EVE_BICEP_CURLS_DUMBELLS_2_REV_SMALL_720.mp4',
          description: null,
          size: 76916,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2699,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '2180934007b654e511dc27a57fd3d64e009ea6046ffb4520b55eeea1921aab8d',
          file_name:
            'audios/2180934007b654e511dc27a57fd3d64e009ea6046ffb4520b55eeea1921aab8d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2180934007b654e511dc27a57fd3d64e009ea6046ffb4520b55eeea1921aab8d.mp3',
          name: 'Bicep_Curls.mp3',
          description: null,
          size: 22431,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-TRICEP_KICKBACKS-EXERCISE': {
      id: 1042,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Tricep Kickbacks',
      short_name: 'Tricep Kickbacks',
      unique_name: 'BEGINNER-TRICEP_KICKBACKS-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, knees slightly bent. Hold a dumbbell in each hand.\n2. Hinge at the waist until your torso is close to parallel to the floor. Bend your elbows back behind you to 90 degrees. Bring dumbbells to your hips, palms in.\n3. Extend your elbows and lift dumbbells up and back behind you as you straighten your arms.\n4. Lower dumbbells back to start position.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2700,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: 'cda44244cb7a4db8149caf6a06b69ac84ed6899eda40b345b8b5195eefcb758e',
          file_name:
            'videos/cda44244cb7a4db8149caf6a06b69ac84ed6899eda40b345b8b5195eefcb758e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cda44244cb7a4db8149caf6a06b69ac84ed6899eda40b345b8b5195eefcb758e.mp4',
          name: 'PHIL_018_TRICEP_KICKBACKS_1_small_720.mp4',
          description: null,
          size: 64575,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2701,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: 'd7e776e75e78f3744932b75dba3a4bc7d0a4dc01ba4712b7c80d32c3a96a0949',
          file_name:
            'audios/d7e776e75e78f3744932b75dba3a4bc7d0a4dc01ba4712b7c80d32c3a96a0949.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d7e776e75e78f3744932b75dba3a4bc7d0a4dc01ba4712b7c80d32c3a96a0949.mp3',
          name: 'TricepKickbacks.mp3',
          description: null,
          size: 24188,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-TRIPLE_CRUSH-EXERCISE': {
      id: 1043,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Triple Crush',
      short_name: 'Triple Crush',
      unique_name: 'BEGINNER-TRIPLE_CRUSH-EXERCISE',
      description:
        '1. Stand with feet wider than shoulder-width apart, toes pointed slightly out. With both hands, hold one dumbbell horizontally at the center of your chest.\n2. Squat down and lower the dumbbell toward the floor. Rest elbows inside your knees.\n3. At the bottom of the squat, perform 1/2 of a bicep curl bringing the dumbbell toward your shoulders.\n4. Return to standing and raise the dumbbell overhead, elbows forward.\n5. Bend both elbows and lower the dumbbell behind your head. Straighten arms and return to start.',
      preview_time: 10,
      min_app_version: 300090005,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2702,
          collection_name: 'videos',
          order: 1,
          version: 100000000,
          hash: '759e8108bb39902e1a524bbc41e15641c365385f43b7409b135b516d6a061a06',
          file_name:
            'videos/759e8108bb39902e1a524bbc41e15641c365385f43b7409b135b516d6a061a06.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/759e8108bb39902e1a524bbc41e15641c365385f43b7409b135b516d6a061a06.mp4',
          name: 'TRUDIE_008_TRIPLE_CRUSH_3_small_720.mp4',
          description: null,
          size: 235755,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2703,
          collection_name: 'audios',
          order: 1,
          version: 100000000,
          hash: '50c863e0e7efa2b8ee594e854e3a239f1c0fecac2b60437be762b54f95a9b519',
          file_name:
            'audios/50c863e0e7efa2b8ee594e854e3a239f1c0fecac2b60437be762b54f95a9b519.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/50c863e0e7efa2b8ee594e854e3a239f1c0fecac2b60437be762b54f95a9b519.mp3',
          name: 'INT-ADV-Triple_Crush-EXERCISE.mp3',
          description: null,
          size: 22470,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-KNEE_TUCK_ROCKS-EXERCISE': {
      id: 1044,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Knee Tuck Rocks',
      short_name: 'Knee Tuck Rocks',
      unique_name: 'BEGINNER-KNEE_TUCK_ROCKS-EXERCISE',
      description:
        '1. Sit on the floor with your hands behind you, palms down. Keeping your spine straight, lean back. Lift your legs and bend knees at a 90 degree angle.Tuck your pelvis to support your lower back.\n2. Rock your hips side to side, lifting sits bones one at a time. Crunch your obliques by bringing your hip bone closer to the bottom of your ribcage.\n3. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2704,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '91541aeb28141de6457da6dcafb9f2336f71e5f3c9b746552aea386b5e9eff21',
          file_name:
            'videos/91541aeb28141de6457da6dcafb9f2336f71e5f3c9b746552aea386b5e9eff21.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/91541aeb28141de6457da6dcafb9f2336f71e5f3c9b746552aea386b5e9eff21.mp4',
          name: 'BEG-INT-ADV-Knee_Tuck_Rocks-EXERCISE',
          description: null,
          size: 81284,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3027,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '3faf9a0f4a30ec15ed68f70029a31da85265002b17fb252ea47c2805b3ff2f88',
          file_name:
            'audios/3faf9a0f4a30ec15ed68f70029a31da85265002b17fb252ea47c2805b3ff2f88.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3faf9a0f4a30ec15ed68f70029a31da85265002b17fb252ea47c2805b3ff2f88.mp3',
          name: 'BEG-INT-ADV-Knee_Tuck_Rocks-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KNEE_TUCK_ROCKS-EXERCISE': {
      id: 1045,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Knee Tuck Rocks',
      short_name: 'Knee Tuck Rocks',
      unique_name: 'INTERMEDIATE-KNEE_TUCK_ROCKS-EXERCISE',
      description:
        '1. Sit on the floor with your hands behind you, palms down. Keeping your spine straight, lean back. Lift your legs and bend knees at a 90 degree angle.Tuck your pelvis to support your lower back.\n2. Rock your hips side to side, lifting sits bones one at a time. Crunch your obliques by bringing your hip bone closer to the bottom of your ribcage.\n3. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2706,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '91541aeb28141de6457da6dcafb9f2336f71e5f3c9b746552aea386b5e9eff21',
          file_name:
            'videos/91541aeb28141de6457da6dcafb9f2336f71e5f3c9b746552aea386b5e9eff21.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/91541aeb28141de6457da6dcafb9f2336f71e5f3c9b746552aea386b5e9eff21.mp4',
          name: 'BEG-INT-ADV-Knee_Tuck_Rocks-EXERCISE',
          description: null,
          size: 81284,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3028,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '3faf9a0f4a30ec15ed68f70029a31da85265002b17fb252ea47c2805b3ff2f88',
          file_name:
            'audios/3faf9a0f4a30ec15ed68f70029a31da85265002b17fb252ea47c2805b3ff2f88.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3faf9a0f4a30ec15ed68f70029a31da85265002b17fb252ea47c2805b3ff2f88.mp3',
          name: 'BEG-INT-ADV-Knee_Tuck_Rocks-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KNEE_TUCK_ROCKS-EXERCISE': {
      id: 1046,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Knee Tuck Rocks',
      short_name: 'Knee Tuck Rocks',
      unique_name: 'ADVANCED-KNEE_TUCK_ROCKS-EXERCISE',
      description:
        '1. Sit on the floor with your hands behind you, palms down. Keeping your spine straight, lean back. Lift your legs and bend knees at a 90 degree angle.Tuck your pelvis to support your lower back.\n2. Rock your hips side to side, lifting sits bones one at a time. Crunch your obliques by bringing your hip bone closer to the bottom of your ribcage.\n3. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2708,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '91541aeb28141de6457da6dcafb9f2336f71e5f3c9b746552aea386b5e9eff21',
          file_name:
            'videos/91541aeb28141de6457da6dcafb9f2336f71e5f3c9b746552aea386b5e9eff21.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/91541aeb28141de6457da6dcafb9f2336f71e5f3c9b746552aea386b5e9eff21.mp4',
          name: 'BEG-INT-ADV-Knee_Tuck_Rocks-EXERCISE',
          description: null,
          size: 81284,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3029,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '3faf9a0f4a30ec15ed68f70029a31da85265002b17fb252ea47c2805b3ff2f88',
          file_name:
            'audios/3faf9a0f4a30ec15ed68f70029a31da85265002b17fb252ea47c2805b3ff2f88.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3faf9a0f4a30ec15ed68f70029a31da85265002b17fb252ea47c2805b3ff2f88.mp3',
          name: 'BEG-INT-ADV-Knee_Tuck_Rocks-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-HOLLOW_BODY_ROCKS-EXERCISE': {
      id: 1047,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Hollow Body Rocks',
      short_name: 'Hollow Body Rocks',
      unique_name: 'BEGINNER-HOLLOW_BODY_ROCKS-EXERCISE',
      description:
        '1. Lie on your back with arms and legs straight. \n2. Lift arms and legs off the floor to a hover, chin off chest and engage your core. Tuck your pelvis so your low back is flat to the floor. \n3. From the hollow hold position, rock back and forth with control. \n4. Back and forth is one rep.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2710,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'b5879554bd2d48728803ff99b6e59091f8171cd02134cca0a2c6cc05e6725d3d',
          file_name:
            'videos/b5879554bd2d48728803ff99b6e59091f8171cd02134cca0a2c6cc05e6725d3d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b5879554bd2d48728803ff99b6e59091f8171cd02134cca0a2c6cc05e6725d3d.mp4',
          name: 'BEG-INT-ADV-Hollow_Body_Rocks-EXERCISE',
          description: null,
          size: 153734,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3030,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '007cb5b0040f1a5a8bb2d55e5965bf18e3b96a8cd81e9dd405ec8a91b6818ee4',
          file_name:
            'audios/007cb5b0040f1a5a8bb2d55e5965bf18e3b96a8cd81e9dd405ec8a91b6818ee4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/007cb5b0040f1a5a8bb2d55e5965bf18e3b96a8cd81e9dd405ec8a91b6818ee4.mp3',
          name: 'BEG-INT-ADV-Hollow_Body_Rocks-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-HOLLOW_BODY_ROCKS-EXERCISE': {
      id: 1048,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Hollow Body Rocks',
      short_name: 'Hollow Body Rocks',
      unique_name: 'INTERMEDIATE-HOLLOW_BODY_ROCKS-EXERCISE',
      description:
        '1. Lie on your back with arms and legs straight. \n2. Lift arms and legs off the floor to a hover, chin off chest and engage your core. Tuck your pelvis so your low back is flat to the floor. \n3. From the hollow hold position, rock back and forth with control. \n4. Back and forth is one rep.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2712,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'b5879554bd2d48728803ff99b6e59091f8171cd02134cca0a2c6cc05e6725d3d',
          file_name:
            'videos/b5879554bd2d48728803ff99b6e59091f8171cd02134cca0a2c6cc05e6725d3d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b5879554bd2d48728803ff99b6e59091f8171cd02134cca0a2c6cc05e6725d3d.mp4',
          name: 'BEG-INT-ADV-Hollow_Body_Rocks-EXERCISE',
          description: null,
          size: 153734,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3031,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '007cb5b0040f1a5a8bb2d55e5965bf18e3b96a8cd81e9dd405ec8a91b6818ee4',
          file_name:
            'audios/007cb5b0040f1a5a8bb2d55e5965bf18e3b96a8cd81e9dd405ec8a91b6818ee4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/007cb5b0040f1a5a8bb2d55e5965bf18e3b96a8cd81e9dd405ec8a91b6818ee4.mp3',
          name: 'BEG-INT-ADV-Hollow_Body_Rocks-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-HOLLOW_BODY_ROCKS-EXERCISE': {
      id: 1049,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Hollow Body Rocks',
      short_name: 'Hollow Body Rocks',
      unique_name: 'ADVANCED-HOLLOW_BODY_ROCKS-EXERCISE',
      description:
        '1. Lie on your back with arms and legs straight. \n2. Lift arms and legs off the floor to a hover, chin off chest and engage your core. Tuck your pelvis so your low back is flat to the floor. \n3. From the hollow hold position, rock back and forth with control. \n4. Back and forth is one rep.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2714,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'b5879554bd2d48728803ff99b6e59091f8171cd02134cca0a2c6cc05e6725d3d',
          file_name:
            'videos/b5879554bd2d48728803ff99b6e59091f8171cd02134cca0a2c6cc05e6725d3d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b5879554bd2d48728803ff99b6e59091f8171cd02134cca0a2c6cc05e6725d3d.mp4',
          name: 'BEG-INT-ADV-Hollow_Body_Rocks-EXERCISE',
          description: null,
          size: 153734,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3032,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '007cb5b0040f1a5a8bb2d55e5965bf18e3b96a8cd81e9dd405ec8a91b6818ee4',
          file_name:
            'audios/007cb5b0040f1a5a8bb2d55e5965bf18e3b96a8cd81e9dd405ec8a91b6818ee4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/007cb5b0040f1a5a8bb2d55e5965bf18e3b96a8cd81e9dd405ec8a91b6818ee4.mp3',
          name: 'BEG-INT-ADV-Hollow_Body_Rocks-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-B_STANCE_SQUAT-_STAGGERED_SQUAT-EXERCISE': {
      id: 1062,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'B Stance Squat - Staggered Squat',
      short_name: 'B Stance Squat - Staggered',
      unique_name: 'INTERMEDIATE-B_STANCE_SQUAT-_STAGGERED_SQUAT-EXERCISE',
      description:
        '1.Stand with your feet hip-width apart. Take a small step back with one foot and lift your heel off the floor.\n2. Squat down until the thigh of your front leg is parallel with the floor. Keep your spine neutral and put your weight on your front foot.\n3. Keeping chest up, drive through your front heel and stand back up to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2740,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'ee689ecc4545eb84abbb97f973c2d46aa9497c3097ce3645aec4311bf33a5a0a',
          file_name:
            'videos/ee689ecc4545eb84abbb97f973c2d46aa9497c3097ce3645aec4311bf33a5a0a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ee689ecc4545eb84abbb97f973c2d46aa9497c3097ce3645aec4311bf33a5a0a.mp4',
          name: 'INT-ADV-B_Stance_Squat_-_Staggered_Squat-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 105211,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2741,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '5b69e1a9dabfa59e2d01e10dc064d7291ccd74d4f7b4e99bf77b2c5469db3749',
          file_name:
            'videos/5b69e1a9dabfa59e2d01e10dc064d7291ccd74d4f7b4e99bf77b2c5469db3749.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5b69e1a9dabfa59e2d01e10dc064d7291ccd74d4f7b4e99bf77b2c5469db3749.mp4',
          name: 'INT-ADV-B_Stance_Squat_-_Staggered_Squat-EXERCISE-LEFT',
          description: 'Left Side',
          size: 93987,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3045,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'aacde10108e22bd5ed678892a17a11218cc1e3b03a43c550d63152d483b00aa3',
          file_name:
            'audios/aacde10108e22bd5ed678892a17a11218cc1e3b03a43c550d63152d483b00aa3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/aacde10108e22bd5ed678892a17a11218cc1e3b03a43c550d63152d483b00aa3.mp3',
          name: 'INT-ADV-B_Stance_Squat_-_Staggered_Squat-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 27943,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-B_STANCE_SQUAT-_STAGGERED_SQUAT-EXERCISE': {
      id: 1063,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'B Stance Squat - Staggered Squat',
      short_name: 'B Stance Squat - Staggered',
      unique_name: 'ADVANCED-B_STANCE_SQUAT-_STAGGERED_SQUAT-EXERCISE',
      description:
        '1.Stand with your feet hip-width apart. Take a small step back with one foot and lift your heel off the floor.\n2. Squat down until the thigh of your front leg is parallel with the floor. Keep your spine neutral and put your weight on your front foot.\n3. Keeping chest up, drive through your front heel and stand back up to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2743,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'ee689ecc4545eb84abbb97f973c2d46aa9497c3097ce3645aec4311bf33a5a0a',
          file_name:
            'videos/ee689ecc4545eb84abbb97f973c2d46aa9497c3097ce3645aec4311bf33a5a0a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ee689ecc4545eb84abbb97f973c2d46aa9497c3097ce3645aec4311bf33a5a0a.mp4',
          name: 'INT-ADV-B_Stance_Squat_-_Staggered_Squat-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 105211,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2744,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '5b69e1a9dabfa59e2d01e10dc064d7291ccd74d4f7b4e99bf77b2c5469db3749',
          file_name:
            'videos/5b69e1a9dabfa59e2d01e10dc064d7291ccd74d4f7b4e99bf77b2c5469db3749.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5b69e1a9dabfa59e2d01e10dc064d7291ccd74d4f7b4e99bf77b2c5469db3749.mp4',
          name: 'INT-ADV-B_Stance_Squat_-_Staggered_Squat-EXERCISE-LEFT',
          description: 'Left Side',
          size: 93987,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3046,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'aacde10108e22bd5ed678892a17a11218cc1e3b03a43c550d63152d483b00aa3',
          file_name:
            'audios/aacde10108e22bd5ed678892a17a11218cc1e3b03a43c550d63152d483b00aa3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/aacde10108e22bd5ed678892a17a11218cc1e3b03a43c550d63152d483b00aa3.mp3',
          name: 'INT-ADV-B_Stance_Squat_-_Staggered_Squat-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 27943,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-DUAL_UNDERHAND_DUMBBELL_ROW-EXERCISE': {
      id: 1064,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Dual Underhand Dumbbell Row',
      short_name: 'Dual Underhand Dumbbell Row',
      unique_name: 'BEGINNER-DUAL_UNDERHAND_DUMBBELL_ROW-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart and a dumbbell in each hand, palms face out (supine grip). \n2. With your back straight, hinge at the waist so your torso is close to parallel with the floor, arms extended down. Pull shoulders away from your ears.\n3. Bend your elbows and pull the dumbbells toward your hips. Keep elbows tight to your body.\n4. Lower dumbbells back to start position.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2746,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '07faecbf9ee4db2e8f83defb7ebc5a3c48f063e7362186ce7f4070291fe5d737',
          file_name:
            'videos/07faecbf9ee4db2e8f83defb7ebc5a3c48f063e7362186ce7f4070291fe5d737.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/07faecbf9ee4db2e8f83defb7ebc5a3c48f063e7362186ce7f4070291fe5d737.mp4',
          name: 'BEG-INT-ADV-Dual_Underhand_Dumbbell_Row-EXERCISE',
          description: null,
          size: 79408,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3047,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '1debabb1364395391e8d117d4216c77e16eb02a5271c5bc96a0eab242e71aa6a',
          file_name:
            'audios/1debabb1364395391e8d117d4216c77e16eb02a5271c5bc96a0eab242e71aa6a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1debabb1364395391e8d117d4216c77e16eb02a5271c5bc96a0eab242e71aa6a.mp3',
          name: 'BEG-INT-ADV-Dual_Underhand_Dumbbell_Row-EXERCISE',
          description: null,
          size: 34893,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUAL_UNDERHAND_DUMBBELL_ROW-EXERCISE': {
      id: 1065,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dual Underhand Dumbbell Row',
      short_name: 'Dual Underhand Dumbbell Row',
      unique_name: 'INTERMEDIATE-DUAL_UNDERHAND_DUMBBELL_ROW-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart and a dumbbell in each hand, palms face out (supine grip). \n2. With your back straight, hinge at the waist so your torso is close to parallel with the floor, arms extended down. Pull shoulders away from your ears.\n3. Bend your elbows and pull the dumbbells toward your hips. Keep elbows tight to your body.\n4. Lower dumbbells back to start position.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2748,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '07faecbf9ee4db2e8f83defb7ebc5a3c48f063e7362186ce7f4070291fe5d737',
          file_name:
            'videos/07faecbf9ee4db2e8f83defb7ebc5a3c48f063e7362186ce7f4070291fe5d737.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/07faecbf9ee4db2e8f83defb7ebc5a3c48f063e7362186ce7f4070291fe5d737.mp4',
          name: 'BEG-INT-ADV-Dual_Underhand_Dumbbell_Row-EXERCISE',
          description: null,
          size: 79408,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3048,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '1debabb1364395391e8d117d4216c77e16eb02a5271c5bc96a0eab242e71aa6a',
          file_name:
            'audios/1debabb1364395391e8d117d4216c77e16eb02a5271c5bc96a0eab242e71aa6a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1debabb1364395391e8d117d4216c77e16eb02a5271c5bc96a0eab242e71aa6a.mp3',
          name: 'BEG-INT-ADV-Dual_Underhand_Dumbbell_Row-EXERCISE',
          description: null,
          size: 34893,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUAL_UNDERHAND_DUMBBELL_ROW-EXERCISE': {
      id: 1066,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dual Underhand Dumbbell Row',
      short_name: 'Dual Underhand Dumbbell Row',
      unique_name: 'ADVANCED-DUAL_UNDERHAND_DUMBBELL_ROW-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart and a dumbbell in each hand, palms face out (supine grip). \n2. With your back straight, hinge at the waist so your torso is close to parallel with the floor, arms extended down. Pull shoulders away from your ears.\n3. Bend your elbows and pull the dumbbells toward your hips. Keep elbows tight to your body.\n4. Lower dumbbells back to start position.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2750,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '07faecbf9ee4db2e8f83defb7ebc5a3c48f063e7362186ce7f4070291fe5d737',
          file_name:
            'videos/07faecbf9ee4db2e8f83defb7ebc5a3c48f063e7362186ce7f4070291fe5d737.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/07faecbf9ee4db2e8f83defb7ebc5a3c48f063e7362186ce7f4070291fe5d737.mp4',
          name: 'BEG-INT-ADV-Dual_Underhand_Dumbbell_Row-EXERCISE',
          description: null,
          size: 79408,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3049,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '1debabb1364395391e8d117d4216c77e16eb02a5271c5bc96a0eab242e71aa6a',
          file_name:
            'audios/1debabb1364395391e8d117d4216c77e16eb02a5271c5bc96a0eab242e71aa6a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1debabb1364395391e8d117d4216c77e16eb02a5271c5bc96a0eab242e71aa6a.mp3',
          name: 'BEG-INT-ADV-Dual_Underhand_Dumbbell_Row-EXERCISE',
          description: null,
          size: 34893,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-KICKSTAND_DEADLIFT_TO_SQUAT-_BODYWEIGHT-EXERCISE': {
      id: 1067,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Kickstand Deadlift to Squat - Bodyweight',
      short_name: 'Kickstand Deadlift to Squat',
      unique_name: 'BEGINNER-KICKSTAND_DEADLIFT_TO_SQUAT-_BODYWEIGHT-EXERCISE',
      description:
        '1. Stand with feet hip-width apart. Take a small step back with one foot and lift your heel so you are in a staggard stance. \n2. Transfer your weight to the front leg and hinge at the hips.\n3. Lower your torso until your body is parallel to the floor. \n4. Drive through the heel of your front leg and raise your torso up to start.\n5. Immediately bend both knees and sink hips into a squat. Return to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2752,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '665634e398217aff5bb8166b44616933cef3fe963da1ed70b6a66335546269f4',
          file_name:
            'videos/665634e398217aff5bb8166b44616933cef3fe963da1ed70b6a66335546269f4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/665634e398217aff5bb8166b44616933cef3fe963da1ed70b6a66335546269f4.mp4',
          name: 'BEG-INT-ADV-Kickstand_Deadlift_to_Squat_-_Bodyweight-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 177954,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2753,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '5a84dd74e5d2945da396241486c8b2c24aa08e989ba74bc2a98c161cb933ebb0',
          file_name:
            'videos/5a84dd74e5d2945da396241486c8b2c24aa08e989ba74bc2a98c161cb933ebb0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5a84dd74e5d2945da396241486c8b2c24aa08e989ba74bc2a98c161cb933ebb0.mp4',
          name: 'BEG-INT-ADV-Kickstand_Deadlift_to_Squat_-_Bodyweight-EXERCISE-LEFT',
          description: 'Left Side',
          size: 149346,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3050,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '88292a646dfd452661fe9b60ed49f63475a35538dbb9782ea9df3077442630d5',
          file_name:
            'audios/88292a646dfd452661fe9b60ed49f63475a35538dbb9782ea9df3077442630d5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/88292a646dfd452661fe9b60ed49f63475a35538dbb9782ea9df3077442630d5.mp3',
          name: 'BEG-INT-ADV-Kickstand_Deadlift_to_Squat_-_Bodyweight-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 28845,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KICKSTAND_DEADLIFT_TO_SQUAT-_BODYWEIGHT-EXERCISE': {
      id: 1068,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Kickstand Deadlift to Squat - Bodyweight',
      short_name: 'Kickstand Deadlift to Squat',
      unique_name:
        'INTERMEDIATE-KICKSTAND_DEADLIFT_TO_SQUAT-_BODYWEIGHT-EXERCISE',
      description:
        '1. Stand with feet hip-width apart. Take a small step back with one foot and lift your heel so you are in a staggard stance. \n2. Transfer your weight to the front leg and hinge at the hips.\n3. Lower your torso until your body is parallel to the floor. \n4. Drive through the heel of your front leg and raise your torso up to start.\n5. Immediately bend both knees and sink hips into a squat. Return to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2755,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '665634e398217aff5bb8166b44616933cef3fe963da1ed70b6a66335546269f4',
          file_name:
            'videos/665634e398217aff5bb8166b44616933cef3fe963da1ed70b6a66335546269f4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/665634e398217aff5bb8166b44616933cef3fe963da1ed70b6a66335546269f4.mp4',
          name: 'BEG-INT-ADV-Kickstand_Deadlift_to_Squat_-_Bodyweight-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 177954,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2756,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '5a84dd74e5d2945da396241486c8b2c24aa08e989ba74bc2a98c161cb933ebb0',
          file_name:
            'videos/5a84dd74e5d2945da396241486c8b2c24aa08e989ba74bc2a98c161cb933ebb0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5a84dd74e5d2945da396241486c8b2c24aa08e989ba74bc2a98c161cb933ebb0.mp4',
          name: 'BEG-INT-ADV-Kickstand_Deadlift_to_Squat_-_Bodyweight-EXERCISE-LEFT',
          description: 'Left Side',
          size: 149346,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3051,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '88292a646dfd452661fe9b60ed49f63475a35538dbb9782ea9df3077442630d5',
          file_name:
            'audios/88292a646dfd452661fe9b60ed49f63475a35538dbb9782ea9df3077442630d5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/88292a646dfd452661fe9b60ed49f63475a35538dbb9782ea9df3077442630d5.mp3',
          name: 'BEG-INT-ADV-Kickstand_Deadlift_to_Squat_-_Bodyweight-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 28845,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KICKSTAND_DEADLIFT_TO_SQUAT-_BODYWEIGHT-EXERCISE': {
      id: 1069,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kickstand Deadlift to Squat - Bodyweight',
      short_name: 'Kickstand Deadlift to Squat',
      unique_name: 'ADVANCED-KICKSTAND_DEADLIFT_TO_SQUAT-_BODYWEIGHT-EXERCISE',
      description:
        '1. Stand with feet hip-width apart. Take a small step back with one foot and lift your heel so you are in a staggard stance. \n2. Transfer your weight to the front leg and hinge at the hips.\n3. Lower your torso until your body is parallel to the floor. \n4. Drive through the heel of your front leg and raise your torso up to start.\n5. Immediately bend both knees and sink hips into a squat. Return to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2758,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '665634e398217aff5bb8166b44616933cef3fe963da1ed70b6a66335546269f4',
          file_name:
            'videos/665634e398217aff5bb8166b44616933cef3fe963da1ed70b6a66335546269f4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/665634e398217aff5bb8166b44616933cef3fe963da1ed70b6a66335546269f4.mp4',
          name: 'BEG-INT-ADV-Kickstand_Deadlift_to_Squat_-_Bodyweight-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 177954,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2759,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '5a84dd74e5d2945da396241486c8b2c24aa08e989ba74bc2a98c161cb933ebb0',
          file_name:
            'videos/5a84dd74e5d2945da396241486c8b2c24aa08e989ba74bc2a98c161cb933ebb0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5a84dd74e5d2945da396241486c8b2c24aa08e989ba74bc2a98c161cb933ebb0.mp4',
          name: 'BEG-INT-ADV-Kickstand_Deadlift_to_Squat_-_Bodyweight-EXERCISE-LEFT',
          description: 'Left Side',
          size: 149346,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3052,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '88292a646dfd452661fe9b60ed49f63475a35538dbb9782ea9df3077442630d5',
          file_name:
            'audios/88292a646dfd452661fe9b60ed49f63475a35538dbb9782ea9df3077442630d5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/88292a646dfd452661fe9b60ed49f63475a35538dbb9782ea9df3077442630d5.mp3',
          name: 'BEG-INT-ADV-Kickstand_Deadlift_to_Squat_-_Bodyweight-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 28845,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PARTIAL_REP_SQUAT_BOTTOM12-EXERCISE': {
      id: 1076,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Partial Rep Squat Bottom 1/2',
      short_name: 'Partial Rep Squat Bottom 1/2',
      unique_name: 'INTERMEDIATE-PARTIAL_REP_SQUAT_BOTTOM12-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, hold one dumbbell in both hands. Keep chest up and shoulders back.\n2. Bend your knees and lower down into a squat. This is start position. \n3. Drive through your heels to come up halfway. Keep core tight and good posture. \n4. Lower back down to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2779,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'be7f8685c30eace37b2bdf6357be2c2dc4ed5e1e5351ea3ef305ceefd21ee0ec',
          file_name:
            'videos/be7f8685c30eace37b2bdf6357be2c2dc4ed5e1e5351ea3ef305ceefd21ee0ec.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/be7f8685c30eace37b2bdf6357be2c2dc4ed5e1e5351ea3ef305ceefd21ee0ec.mp4',
          name: 'INT-ADV-Partial_Rep_Squat_Bottom_1-2-EXERCISE',
          description: null,
          size: 76877,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3059,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '4e8373e06b4c1a233fcb064e7cd246bd2e7116771a69d3f61e8ff0b5609eb62a',
          file_name:
            'audios/4e8373e06b4c1a233fcb064e7cd246bd2e7116771a69d3f61e8ff0b5609eb62a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4e8373e06b4c1a233fcb064e7cd246bd2e7116771a69d3f61e8ff0b5609eb62a.mp3',
          name: 'INT-ADV-Partial_Rep_Squat_Bottom_1-2-EXERCISE',
          description: null,
          size: 40941,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PARTIAL_REP_SQUAT_BOTTOM12-EXERCISE': {
      id: 1077,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Partial Rep Squat Bottom 1/2',
      short_name: 'Partial Rep Squat Bottom 1/2',
      unique_name: 'ADVANCED-PARTIAL_REP_SQUAT_BOTTOM12-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, hold one dumbbell in both hands. Keep chest up and shoulders back.\n2. Bend your knees and lower down into a squat. This is start position. \n3. Drive through your heels to come up halfway. Keep core tight and good posture. \n4. Lower back down to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2781,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'be7f8685c30eace37b2bdf6357be2c2dc4ed5e1e5351ea3ef305ceefd21ee0ec',
          file_name:
            'videos/be7f8685c30eace37b2bdf6357be2c2dc4ed5e1e5351ea3ef305ceefd21ee0ec.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/be7f8685c30eace37b2bdf6357be2c2dc4ed5e1e5351ea3ef305ceefd21ee0ec.mp4',
          name: 'INT-ADV-Partial_Rep_Squat_Bottom_1-2-EXERCISE',
          description: null,
          size: 76877,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3060,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '4e8373e06b4c1a233fcb064e7cd246bd2e7116771a69d3f61e8ff0b5609eb62a',
          file_name:
            'audios/4e8373e06b4c1a233fcb064e7cd246bd2e7116771a69d3f61e8ff0b5609eb62a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4e8373e06b4c1a233fcb064e7cd246bd2e7116771a69d3f61e8ff0b5609eb62a.mp3',
          name: 'INT-ADV-Partial_Rep_Squat_Bottom_1-2-EXERCISE',
          description: null,
          size: 40941,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_OVERHEAD_SHRUG-EXERCISE': {
      id: 1081,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Overhead Shrug',
      short_name: 'Dumbbell Overhead Shrug',
      unique_name: 'INTERMEDIATE-DUMBBELL_OVERHEAD_SHRUG-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart, hold a pair of dumbbells directly over your shoulders, arms fully extended, palms face in. \n2. Shrug your shoulders upwards towards your ears. Squeeze Traps at the top. \n3. Slowly lower back down and depress your shoulder blades at the bottom as you return to start position.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 18,
          unique_name: 'TRAPS',
          name: 'Traps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2789,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '696e128e3ee92ce2a4813f4342c08a673401422807bb7eded4266b24ccc7f5d6',
          file_name:
            'videos/696e128e3ee92ce2a4813f4342c08a673401422807bb7eded4266b24ccc7f5d6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/696e128e3ee92ce2a4813f4342c08a673401422807bb7eded4266b24ccc7f5d6.mp4',
          name: 'INT-ADV-Dumbbell_Overhead_Shrug-EXERCISE',
          description: null,
          size: 58086,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3064,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd08edaedec7a0ccd5b57104a6d6fadb0b3df3985f3b8aed1594b2244ac4cdbe0',
          file_name:
            'audios/d08edaedec7a0ccd5b57104a6d6fadb0b3df3985f3b8aed1594b2244ac4cdbe0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d08edaedec7a0ccd5b57104a6d6fadb0b3df3985f3b8aed1594b2244ac4cdbe0.mp3',
          name: 'INT-ADV-Dumbbell_Overhead_Shrug-EXERCISE',
          description: null,
          size: 30573,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_OVERHEAD_SHRUG-EXERCISE': {
      id: 1082,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Overhead Shrug',
      short_name: 'Dumbbell Overhead Shrug',
      unique_name: 'ADVANCED-DUMBBELL_OVERHEAD_SHRUG-EXERCISE',
      description:
        '1. Stand with feet shoulder-width apart, hold a pair of dumbbells directly over your shoulders, arms fully extended, palms face in. \n2. Shrug your shoulders upwards towards your ears. Squeeze Traps at the top. \n3. Slowly lower back down and depress your shoulder blades at the bottom as you return to start position.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 18,
          unique_name: 'TRAPS',
          name: 'Traps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2791,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '696e128e3ee92ce2a4813f4342c08a673401422807bb7eded4266b24ccc7f5d6',
          file_name:
            'videos/696e128e3ee92ce2a4813f4342c08a673401422807bb7eded4266b24ccc7f5d6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/696e128e3ee92ce2a4813f4342c08a673401422807bb7eded4266b24ccc7f5d6.mp4',
          name: 'INT-ADV-Dumbbell_Overhead_Shrug-EXERCISE',
          description: null,
          size: 58086,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3065,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd08edaedec7a0ccd5b57104a6d6fadb0b3df3985f3b8aed1594b2244ac4cdbe0',
          file_name:
            'audios/d08edaedec7a0ccd5b57104a6d6fadb0b3df3985f3b8aed1594b2244ac4cdbe0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d08edaedec7a0ccd5b57104a6d6fadb0b3df3985f3b8aed1594b2244ac4cdbe0.mp3',
          name: 'INT-ADV-Dumbbell_Overhead_Shrug-EXERCISE',
          description: null,
          size: 30573,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_SKIIERS-EXERCISE': {
      id: 1083,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CARDIO',
      name: 'Dumbbell Skiiers',
      short_name: 'Dumbbell Skiiers',
      unique_name: 'INTERMEDIATE-DUMBBELL_SKIIERS-EXERCISE',
      description:
        '1.Stand tall with your feet hip-width apart holding a pair of dumbbells at your sides, palms face in. \n2. Keeping arms straight and core engaged, bend knees, hinge at your hips back and allow dumbbells to swing behind you.\n3. Drive through your heels and explosively drive hips forward to stand, swinging the dumbbells to shoulder height. Your arms should do minimal work; the momentum from your hips power the dumbbells.\n4. With control, allow the dumbbells swing back down and continue this motion. Connect reps.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 18,
          unique_name: 'TRAPS',
          name: 'Traps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2793,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'd2cab4d9fe753e7561a946602141b0d383c978adecff2432ed89bbb979a14048',
          file_name:
            'videos/d2cab4d9fe753e7561a946602141b0d383c978adecff2432ed89bbb979a14048.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d2cab4d9fe753e7561a946602141b0d383c978adecff2432ed89bbb979a14048.mp4',
          name: 'INT-ADV-Dumbbell_Skiiers-EXERCISE',
          description: null,
          size: 111503,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3066,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '9173fa12372e25ec4ae4fa3b89eb9bd8f9cc9ded11f1ef49a7dfa2a85c2f2d0c',
          file_name:
            'audios/9173fa12372e25ec4ae4fa3b89eb9bd8f9cc9ded11f1ef49a7dfa2a85c2f2d0c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9173fa12372e25ec4ae4fa3b89eb9bd8f9cc9ded11f1ef49a7dfa2a85c2f2d0c.mp3',
          name: 'INT-ADV-Dumbbell_Skiiers-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_SKIIERS-EXERCISE': {
      id: 1084,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CARDIO',
      name: 'Dumbbell Skiiers',
      short_name: 'Dumbbell Skiiers',
      unique_name: 'ADVANCED-DUMBBELL_SKIIERS-EXERCISE',
      description:
        '1.Stand tall with your feet hip-width apart holding a pair of dumbbells at your sides, palms face in. \n2. Keeping arms straight and core engaged, bend knees, hinge at your hips back and allow dumbbells to swing behind you.\n3. Drive through your heels and explosively drive hips forward to stand, swinging the dumbbells to shoulder height. Your arms should do minimal work; the momentum from your hips power the dumbbells.\n4. With control, allow the dumbbells swing back down and continue this motion. Connect reps.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 18,
          unique_name: 'TRAPS',
          name: 'Traps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2795,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'd2cab4d9fe753e7561a946602141b0d383c978adecff2432ed89bbb979a14048',
          file_name:
            'videos/d2cab4d9fe753e7561a946602141b0d383c978adecff2432ed89bbb979a14048.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d2cab4d9fe753e7561a946602141b0d383c978adecff2432ed89bbb979a14048.mp4',
          name: 'INT-ADV-Dumbbell_Skiiers-EXERCISE',
          description: null,
          size: 111503,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3067,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '9173fa12372e25ec4ae4fa3b89eb9bd8f9cc9ded11f1ef49a7dfa2a85c2f2d0c',
          file_name:
            'audios/9173fa12372e25ec4ae4fa3b89eb9bd8f9cc9ded11f1ef49a7dfa2a85c2f2d0c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9173fa12372e25ec4ae4fa3b89eb9bd8f9cc9ded11f1ef49a7dfa2a85c2f2d0c.mp3',
          name: 'INT-ADV-Dumbbell_Skiiers-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_PENDLAY_ROW-EXERCISE': {
      id: 1094,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Pendlay Row',
      short_name: 'Dumbbell Pendlay Row',
      unique_name: 'INTERMEDIATE-DUMBBELL_PENDLAY_ROW-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart and a dumbbell in each hand, palms in.\n2. With your back straight, bend your knees and hinge at the waist so your torso is parallel to the floor. Your arms extend down and dumbbells touch the floor. Pull shoulders away from your ears.\n3. Bend your elbows and explosively pull the dumbbells toward your hips. Keep elbows in tight.\n4. Lower back to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2815,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'bffe6a8ca61cdafd3dab94ef427239af9ca8af3b6a60f0303660ece31f054878',
          file_name:
            'videos/bffe6a8ca61cdafd3dab94ef427239af9ca8af3b6a60f0303660ece31f054878.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bffe6a8ca61cdafd3dab94ef427239af9ca8af3b6a60f0303660ece31f054878.mp4',
          name: 'INT-ADV-Dumbbell_Pendlay_Row-EXERCISE',
          description: null,
          size: 74230,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3077,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd80c674b73c1a8ed0a10cbe9cd70759253a4dce2afe8c4b8aa0d054e8cca20eb',
          file_name:
            'audios/d80c674b73c1a8ed0a10cbe9cd70759253a4dce2afe8c4b8aa0d054e8cca20eb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d80c674b73c1a8ed0a10cbe9cd70759253a4dce2afe8c4b8aa0d054e8cca20eb.mp3',
          name: 'INT-ADV-Dumbbell_Pendlay_Row-EXERCISE',
          description: null,
          size: 27405,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_PENDLAY_ROW-EXERCISE': {
      id: 1095,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Pendlay Row',
      short_name: 'Dumbbell Pendlay Row',
      unique_name: 'ADVANCED-DUMBBELL_PENDLAY_ROW-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart and a dumbbell in each hand, palms in.\n2. With your back straight, bend your knees and hinge at the waist so your torso is parallel to the floor. Your arms extend down and dumbbells touch the floor. Pull shoulders away from your ears.\n3. Bend your elbows and explosively pull the dumbbells toward your hips. Keep elbows in tight.\n4. Lower back to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2817,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'bffe6a8ca61cdafd3dab94ef427239af9ca8af3b6a60f0303660ece31f054878',
          file_name:
            'videos/bffe6a8ca61cdafd3dab94ef427239af9ca8af3b6a60f0303660ece31f054878.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bffe6a8ca61cdafd3dab94ef427239af9ca8af3b6a60f0303660ece31f054878.mp4',
          name: 'INT-ADV-Dumbbell_Pendlay_Row-EXERCISE',
          description: null,
          size: 74230,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3078,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd80c674b73c1a8ed0a10cbe9cd70759253a4dce2afe8c4b8aa0d054e8cca20eb',
          file_name:
            'audios/d80c674b73c1a8ed0a10cbe9cd70759253a4dce2afe8c4b8aa0d054e8cca20eb.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d80c674b73c1a8ed0a10cbe9cd70759253a4dce2afe8c4b8aa0d054e8cca20eb.mp3',
          name: 'INT-ADV-Dumbbell_Pendlay_Row-EXERCISE',
          description: null,
          size: 27405,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-INCLINE_SINGLE_ARM_LATERAL_RAISE-EXERCISE': {
      id: 1099,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Incline Single Arm Lateral Raise',
      short_name: 'Incline Single Arm Lateral Raise',
      unique_name: 'INTERMEDIATE-INCLINE_SINGLE_ARM_LATERAL_RAISE-EXERCISE',
      description:
        '1. Lie on your side, propping yourself on your forearm, elbow directly under your shoulder. Bend your bottom leg and extend the top leg. Hold one dumbbell and rest on your side. \n2. Raise your arm up, bringing the dumbbell to shoulder height. Your arm is straight and palm faces down.\n3. Lower your arm back down to starting position.\n4. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 10,
          unique_name: 'DELTS',
          name: 'Delts',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2828,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'da8e30401d00e945b80a84ee38a705155474f78db37bb23cb4cd0db486ddbf67',
          file_name:
            'videos/da8e30401d00e945b80a84ee38a705155474f78db37bb23cb4cd0db486ddbf67.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/da8e30401d00e945b80a84ee38a705155474f78db37bb23cb4cd0db486ddbf67.mp4',
          name: 'INT-ADV-Incline_Single_Arm_Lateral_Raise-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 53903,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2829,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '4b556843d546cc27a510d4f1b66cbdd210a549290d876df80be7ac99a756c172',
          file_name:
            'videos/4b556843d546cc27a510d4f1b66cbdd210a549290d876df80be7ac99a756c172.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4b556843d546cc27a510d4f1b66cbdd210a549290d876df80be7ac99a756c172.mp4',
          name: 'INT-ADV-Incline_Single_Arm_Lateral_Raise-EXERCISE-LEFT',
          description: 'Left Side',
          size: 59956,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3085,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'b9c74a7bbff032c795eeb331a7cd925de04ff90c646efcd0b437611f1fbd9130',
          file_name:
            'audios/b9c74a7bbff032c795eeb331a7cd925de04ff90c646efcd0b437611f1fbd9130.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b9c74a7bbff032c795eeb331a7cd925de04ff90c646efcd0b437611f1fbd9130.mp3',
          name: 'INT-ADV-Incline_Single_Arm_Lateral_Raise-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 36045,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-INCLINE_SINGLE_ARM_LATERAL_RAISE-EXERCISE': {
      id: 1100,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Incline Single Arm Lateral Raise',
      short_name: 'Incline Single Arm Lateral Raise',
      unique_name: 'ADVANCED-INCLINE_SINGLE_ARM_LATERAL_RAISE-EXERCISE',
      description:
        '1. Lie on your side, propping yourself on your forearm, elbow directly under your shoulder. Bend your bottom leg and extend the top leg. Hold one dumbbell and rest on your side. \n2. Raise your arm up, bringing the dumbbell to shoulder height. Your arm is straight and palm faces down.\n3. Lower your arm back down to starting position.\n4. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 10,
          unique_name: 'DELTS',
          name: 'Delts',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2831,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'da8e30401d00e945b80a84ee38a705155474f78db37bb23cb4cd0db486ddbf67',
          file_name:
            'videos/da8e30401d00e945b80a84ee38a705155474f78db37bb23cb4cd0db486ddbf67.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/da8e30401d00e945b80a84ee38a705155474f78db37bb23cb4cd0db486ddbf67.mp4',
          name: 'INT-ADV-Incline_Single_Arm_Lateral_Raise-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 53903,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2832,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '4b556843d546cc27a510d4f1b66cbdd210a549290d876df80be7ac99a756c172',
          file_name:
            'videos/4b556843d546cc27a510d4f1b66cbdd210a549290d876df80be7ac99a756c172.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4b556843d546cc27a510d4f1b66cbdd210a549290d876df80be7ac99a756c172.mp4',
          name: 'INT-ADV-Incline_Single_Arm_Lateral_Raise-EXERCISE-LEFT',
          description: 'Left Side',
          size: 59956,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3086,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'b9c74a7bbff032c795eeb331a7cd925de04ff90c646efcd0b437611f1fbd9130',
          file_name:
            'audios/b9c74a7bbff032c795eeb331a7cd925de04ff90c646efcd0b437611f1fbd9130.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b9c74a7bbff032c795eeb331a7cd925de04ff90c646efcd0b437611f1fbd9130.mp3',
          name: 'INT-ADV-Incline_Single_Arm_Lateral_Raise-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 36045,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-PUSH_UP_WITH_SHOULDER_TAP_ON_KNEES-EXERCISE': {
      id: 1101,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Push Up with Shoulder Tap on Knees',
      short_name: 'Push Up with Shoulder Tap on Knees',
      unique_name: 'BEGINNER-PUSH_UP_WITH_SHOULDER_TAP_ON_KNEES-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists. Drop your knees down to the floor and lift your feet up. \n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor.\n3. Straighten your arms and raise back up.\n4. At the top, lift one hand off the ground and tap the opposite shoulder. Return to Plank. \n5.Push Up again and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2834,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'bf5fcdab2ccd0a34435d7af25f78670b9a2a40a5327b69cdc149b85ca998e585',
          file_name:
            'videos/bf5fcdab2ccd0a34435d7af25f78670b9a2a40a5327b69cdc149b85ca998e585.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf5fcdab2ccd0a34435d7af25f78670b9a2a40a5327b69cdc149b85ca998e585.mp4',
          name: 'BEGINNER-Push_Up_with_Shoulder_Tap_on_Knees-EXERCISE',
          description: null,
          size: 176727,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3087,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '918b5ad58bc20898ac089ca8f6d8b256564bfd77ae18ce08e3a2ff2e8ba83d2c',
          file_name:
            'audios/918b5ad58bc20898ac089ca8f6d8b256564bfd77ae18ce08e3a2ff2e8ba83d2c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/918b5ad58bc20898ac089ca8f6d8b256564bfd77ae18ce08e3a2ff2e8ba83d2c.mp3',
          name: 'BEGINNER-Push_Up_with_Shoulder_Tap_on_Knees-EXERCISE',
          description: null,
          size: 33165,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PUSH_UP_WITH_SHOULDER_TAP-EXERCISE': {
      id: 1102,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Push Up with Shoulder Tap',
      short_name: 'Push Up with Shoulder Tap',
      unique_name: 'INTERMEDIATE-PUSH_UP_WITH_SHOULDER_TAP-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists, hips square. \n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor.\n3. Straighten your arms and raise your body back up. \n4. At the top, lift one hand off the ground and tap the opposite shoulder. Return to Plank. \n5. Perform another push up and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2836,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '3a256b2521366f1518802b625b382044c80ac5fbe18524d7ae9671e25ef874ee',
          file_name:
            'videos/3a256b2521366f1518802b625b382044c80ac5fbe18524d7ae9671e25ef874ee.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3a256b2521366f1518802b625b382044c80ac5fbe18524d7ae9671e25ef874ee.mp4',
          name: 'INT-ADV-Push_Up_with_Shoulder_Tap-EXERCISE',
          description: null,
          size: 186974,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3088,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '8d7cfd4065e8255d995514032942f2a5398cc6591ef9c5286546a38027eda13f',
          file_name:
            'audios/8d7cfd4065e8255d995514032942f2a5398cc6591ef9c5286546a38027eda13f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8d7cfd4065e8255d995514032942f2a5398cc6591ef9c5286546a38027eda13f.mp3',
          name: 'INT-ADV-Push_Up_with_Shoulder_Tap-EXERCISE',
          description: null,
          size: 27405,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PUSH_UP_WITH_SHOULDER_TAP-EXERCISE': {
      id: 1103,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Push Up with Shoulder Tap',
      short_name: 'Push Up with Shoulder Tap',
      unique_name: 'ADVANCED-PUSH_UP_WITH_SHOULDER_TAP-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists, hips square. \n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor.\n3. Straighten your arms and raise your body back up. \n4. At the top, lift one hand off the ground and tap the opposite shoulder. Return to Plank. \n5. Perform another push up and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2838,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '3a256b2521366f1518802b625b382044c80ac5fbe18524d7ae9671e25ef874ee',
          file_name:
            'videos/3a256b2521366f1518802b625b382044c80ac5fbe18524d7ae9671e25ef874ee.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3a256b2521366f1518802b625b382044c80ac5fbe18524d7ae9671e25ef874ee.mp4',
          name: 'INT-ADV-Push_Up_with_Shoulder_Tap-EXERCISE',
          description: null,
          size: 186974,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3089,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '8d7cfd4065e8255d995514032942f2a5398cc6591ef9c5286546a38027eda13f',
          file_name:
            'audios/8d7cfd4065e8255d995514032942f2a5398cc6591ef9c5286546a38027eda13f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8d7cfd4065e8255d995514032942f2a5398cc6591ef9c5286546a38027eda13f.mp3',
          name: 'INT-ADV-Push_Up_with_Shoulder_Tap-EXERCISE',
          description: null,
          size: 27405,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-REVERSE_TABLETOP_MARCHES-EXERCISE': {
      id: 1104,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Reverse Tabletop Marches',
      short_name: 'Reverse Tabletop Marches',
      unique_name: 'BEGINNER-REVERSE_TABLETOP_MARCHES-EXERCISE',
      description:
        '1. Start in Reverse Tabletop position with your hands flat on the floor underneath your shoulders, fingers toward hips. Knees are bent, stacked over ankles, and hips are elevated in line with your shoulders.\n2. Raise one leg up, keeping your knee bent to 90 degrees. Pause. \n3. Return leg to start. Repeat other side. March in a controlled, continous motion.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2840,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'bf2f0634826f95723bd5792b7c31e65604a3314e594fad8f449796aab88ccb57',
          file_name:
            'videos/bf2f0634826f95723bd5792b7c31e65604a3314e594fad8f449796aab88ccb57.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf2f0634826f95723bd5792b7c31e65604a3314e594fad8f449796aab88ccb57.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Marches-EXERCISE',
          description: null,
          size: 159992,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3090,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'fc85f3c6e4f62ace1959799d09249a3ebdad7ef8b99c42531cd5c791d3143d8e',
          file_name:
            'audios/fc85f3c6e4f62ace1959799d09249a3ebdad7ef8b99c42531cd5c791d3143d8e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fc85f3c6e4f62ace1959799d09249a3ebdad7ef8b99c42531cd5c791d3143d8e.mp3',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Marches-EXERCISE',
          description: null,
          size: 32959,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-REVERSE_TABLETOP_MARCHES-EXERCISE': {
      id: 1105,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Reverse Tabletop Marches',
      short_name: 'Reverse Tabletop Marches',
      unique_name: 'INTERMEDIATE-REVERSE_TABLETOP_MARCHES-EXERCISE',
      description:
        '1. Start in Reverse Tabletop position with your hands flat on the floor underneath your shoulders, fingers toward hips. Knees are bent, stacked over ankles, and hips are elevated in line with your shoulders.\n2. Raise one leg up, keeping your knee bent to 90 degrees. Pause. \n3. Return leg to start. Repeat other side. March in a controlled, continous motion.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2842,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'bf2f0634826f95723bd5792b7c31e65604a3314e594fad8f449796aab88ccb57',
          file_name:
            'videos/bf2f0634826f95723bd5792b7c31e65604a3314e594fad8f449796aab88ccb57.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf2f0634826f95723bd5792b7c31e65604a3314e594fad8f449796aab88ccb57.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Marches-EXERCISE',
          description: null,
          size: 159992,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3091,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'fc85f3c6e4f62ace1959799d09249a3ebdad7ef8b99c42531cd5c791d3143d8e',
          file_name:
            'audios/fc85f3c6e4f62ace1959799d09249a3ebdad7ef8b99c42531cd5c791d3143d8e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fc85f3c6e4f62ace1959799d09249a3ebdad7ef8b99c42531cd5c791d3143d8e.mp3',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Marches-EXERCISE',
          description: null,
          size: 32959,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-REVERSE_TABLETOP_MARCHES-EXERCISE': {
      id: 1106,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Reverse Tabletop Marches',
      short_name: 'Reverse Tabletop Marches',
      unique_name: 'ADVANCED-REVERSE_TABLETOP_MARCHES-EXERCISE',
      description:
        '1. Start in Reverse Tabletop position with your hands flat on the floor underneath your shoulders, fingers toward hips. Knees are bent, stacked over ankles, and hips are elevated in line with your shoulders.\n2. Raise one leg up, keeping your knee bent to 90 degrees. Pause. \n3. Return leg to start. Repeat other side. March in a controlled, continous motion.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2844,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'bf2f0634826f95723bd5792b7c31e65604a3314e594fad8f449796aab88ccb57',
          file_name:
            'videos/bf2f0634826f95723bd5792b7c31e65604a3314e594fad8f449796aab88ccb57.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf2f0634826f95723bd5792b7c31e65604a3314e594fad8f449796aab88ccb57.mp4',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Marches-EXERCISE',
          description: null,
          size: 159992,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3092,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'fc85f3c6e4f62ace1959799d09249a3ebdad7ef8b99c42531cd5c791d3143d8e',
          file_name:
            'audios/fc85f3c6e4f62ace1959799d09249a3ebdad7ef8b99c42531cd5c791d3143d8e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fc85f3c6e4f62ace1959799d09249a3ebdad7ef8b99c42531cd5c791d3143d8e.mp3',
          name: 'BEG-INT-ADV-Reverse_Tabletop_Marches-EXERCISE',
          description: null,
          size: 32959,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_STRAIGHT_ARM_KICKBACKS-EXERCISE': {
      id: 1110,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Straight Arm Kickbacks',
      short_name: 'Dumbbell Straight Arm Kickbacks',
      unique_name: 'INTERMEDIATE-DUMBBELL_STRAIGHT_ARM_KICKBACKS-EXERCISE',
      description:
        '1. Stand feet shoulder-width apart, knees slightly bent. Holding a pair of dumbbells by your sides, hinge at the waist until your torso is close to parallel to the floor. \n2. Keeping arms straight, lift the dumbbells back behind you, fists toward the ceiling. Pause. \n3. Lower dumbbells back down to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2852,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'a734a1b19a246564d7d9d2fac9babfabe211e1f8b43bd29da286280d5f2a9618',
          file_name:
            'videos/a734a1b19a246564d7d9d2fac9babfabe211e1f8b43bd29da286280d5f2a9618.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a734a1b19a246564d7d9d2fac9babfabe211e1f8b43bd29da286280d5f2a9618.mp4',
          name: 'INT-ADV-Dumbbell_Straight_Arm_Kickbacks-EXERCISE',
          description: null,
          size: 56894,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3096,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'ed56e97c0f1e8174bba2ddf43c13b6c7aff5dc0766098b685ff8078486c362b5',
          file_name:
            'audios/ed56e97c0f1e8174bba2ddf43c13b6c7aff5dc0766098b685ff8078486c362b5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ed56e97c0f1e8174bba2ddf43c13b6c7aff5dc0766098b685ff8078486c362b5.mp3',
          name: 'INT-ADV-Dumbbell_Straight_Arm_Kickbacks-EXERCISE',
          description: null,
          size: 31705,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_STRAIGHT_ARM_KICKBACKS-EXERCISE': {
      id: 1111,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Straight Arm Kickbacks',
      short_name: 'Dumbbell Straight Arm Kickbacks',
      unique_name: 'ADVANCED-DUMBBELL_STRAIGHT_ARM_KICKBACKS-EXERCISE',
      description:
        '1. Stand feet shoulder-width apart, knees slightly bent. Holding a pair of dumbbells by your sides, hinge at the waist until your torso is close to parallel to the floor. \n2. Keeping arms straight, lift the dumbbells back behind you, fists toward the ceiling. Pause. \n3. Lower dumbbells back down to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2854,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'a734a1b19a246564d7d9d2fac9babfabe211e1f8b43bd29da286280d5f2a9618',
          file_name:
            'videos/a734a1b19a246564d7d9d2fac9babfabe211e1f8b43bd29da286280d5f2a9618.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a734a1b19a246564d7d9d2fac9babfabe211e1f8b43bd29da286280d5f2a9618.mp4',
          name: 'INT-ADV-Dumbbell_Straight_Arm_Kickbacks-EXERCISE',
          description: null,
          size: 56894,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3097,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'ed56e97c0f1e8174bba2ddf43c13b6c7aff5dc0766098b685ff8078486c362b5',
          file_name:
            'audios/ed56e97c0f1e8174bba2ddf43c13b6c7aff5dc0766098b685ff8078486c362b5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ed56e97c0f1e8174bba2ddf43c13b6c7aff5dc0766098b685ff8078486c362b5.mp3',
          name: 'INT-ADV-Dumbbell_Straight_Arm_Kickbacks-EXERCISE',
          description: null,
          size: 31705,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SUMO_SQUAT-_DEADLIFT-EXERCISE': {
      id: 1127,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Sumo Squat - Deadlift',
      short_name: 'Sumo Squat - Deadlift',
      unique_name: 'INTERMEDIATE-SUMO_SQUAT-_DEADLIFT-EXERCISE',
      description:
        '1. Stand with feet wider than shoulder-width apart, toes point out. Hold a pair of dumbbells in front of your hips. Knees slightly bent, chest up and core tight.\n2. Start the motion by hinging at the hips and sliding them back. Then bend both knees to lower the dumbbells toward the floor. Keep arms and back straight.  \n3. Drive through your heels to stand. Squeeze at the top without leaning back.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2901,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '98d2937b6d5d41c145f9a0ffb5f8054dca386eaddba89e28eaf1e68ca4866c91',
          file_name:
            'videos/98d2937b6d5d41c145f9a0ffb5f8054dca386eaddba89e28eaf1e68ca4866c91.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/98d2937b6d5d41c145f9a0ffb5f8054dca386eaddba89e28eaf1e68ca4866c91.mp4',
          name: 'INT-ADV-Sumo_Squat_-_Deadlift-EXERCISE',
          description: null,
          size: 92543,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3113,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd98166ff5a7054d2427075b67e87864d19c1d8f393d6615d4878d3a7ec5073a9',
          file_name:
            'audios/d98166ff5a7054d2427075b67e87864d19c1d8f393d6615d4878d3a7ec5073a9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d98166ff5a7054d2427075b67e87864d19c1d8f393d6615d4878d3a7ec5073a9.mp3',
          name: 'INT-ADV-Sumo_Squat_-_Deadlift-EXERCISE',
          description: null,
          size: 25965,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SUMO_SQUAT-_DEADLIFT-EXERCISE': {
      id: 1128,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Sumo Squat - Deadlift',
      short_name: 'Sumo Squat - Deadlift',
      unique_name: 'ADVANCED-SUMO_SQUAT-_DEADLIFT-EXERCISE',
      description:
        '1. Stand with feet wider than shoulder-width apart, toes point out. Hold a pair of dumbbells in front of your hips. Knees slightly bent, chest up and core tight.\n2. Start the motion by hinging at the hips and sliding them back. Then bend both knees to lower the dumbbells toward the floor. Keep arms and back straight.  \n3. Drive through your heels to stand. Squeeze at the top without leaning back.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2903,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '98d2937b6d5d41c145f9a0ffb5f8054dca386eaddba89e28eaf1e68ca4866c91',
          file_name:
            'videos/98d2937b6d5d41c145f9a0ffb5f8054dca386eaddba89e28eaf1e68ca4866c91.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/98d2937b6d5d41c145f9a0ffb5f8054dca386eaddba89e28eaf1e68ca4866c91.mp4',
          name: 'INT-ADV-Sumo_Squat_-_Deadlift-EXERCISE',
          description: null,
          size: 92543,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3114,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd98166ff5a7054d2427075b67e87864d19c1d8f393d6615d4878d3a7ec5073a9',
          file_name:
            'audios/d98166ff5a7054d2427075b67e87864d19c1d8f393d6615d4878d3a7ec5073a9.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d98166ff5a7054d2427075b67e87864d19c1d8f393d6615d4878d3a7ec5073a9.mp3',
          name: 'INT-ADV-Sumo_Squat_-_Deadlift-EXERCISE',
          description: null,
          size: 25965,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KICKSTAND_DEADLIFT_TO_SQUAT-EXERCISE': {
      id: 1129,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Kickstand Deadlift',
      short_name: 'Dumbbell Kickstand Deadlift',
      unique_name: 'INTERMEDIATE-KICKSTAND_DEADLIFT_TO_SQUAT-EXERCISE',
      description:
        '1. Stand with feet hip-width apart holding a dumbbell in each hand. Take a small step back with one foot and lift your heel into a staggard stance.\n2. Transfer your weight to front leg and hinge at the hips.\n3. Lower your torso until your body is parallel to the floor. \n4. Drive through the heel of front leg, raise back up to start.\n5. Perform all reps. Repeat other side. ',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2905,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '1ec27c251ec1c28794b9216c078734aab199f41aef94439dbab6d19e917d31de',
          file_name:
            'videos/1ec27c251ec1c28794b9216c078734aab199f41aef94439dbab6d19e917d31de.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1ec27c251ec1c28794b9216c078734aab199f41aef94439dbab6d19e917d31de.mp4',
          name: 'INT-ADV-Kickstand_Deadlift_to_Squat-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 107276,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2906,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '41b88a14df9b8ca5c5d80e61f64b78c6dccb4e3b0cce51fabb6452bd0121257a',
          file_name:
            'videos/41b88a14df9b8ca5c5d80e61f64b78c6dccb4e3b0cce51fabb6452bd0121257a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/41b88a14df9b8ca5c5d80e61f64b78c6dccb4e3b0cce51fabb6452bd0121257a.mp4',
          name: 'INT-ADV-Kickstand_Deadlift_to_Squat-EXERCISE-LEFT',
          description: 'Left Side',
          size: 107513,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3115,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '67323536d96cbf15edcdf6acc7f8510b034cbd84f0cc4d10b257c8756536beca',
          file_name:
            'audios/67323536d96cbf15edcdf6acc7f8510b034cbd84f0cc4d10b257c8756536beca.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/67323536d96cbf15edcdf6acc7f8510b034cbd84f0cc4d10b257c8756536beca.mp3',
          name: 'INT-ADV-Dumbbell_Kickstand_Deadlift-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 26063,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KICKSTAND_DEADLIFT_TO_SQUAT-EXERCISE': {
      id: 1130,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Kickstand Deadlift',
      short_name: 'Dumbbell Kickstand Deadlift',
      unique_name: 'ADVANCED-KICKSTAND_DEADLIFT_TO_SQUAT-EXERCISE',
      description:
        '1. Stand with feet hip-width apart holding a dumbbell in each hand. Take a small step back with one foot and lift your heel into a staggard stance.\n2. Transfer your weight to front leg and hinge at the hips.\n3. Lower your torso until your body is parallel to the floor. \n4. Drive through the heel of front leg, raise back up to start.\n5. Perform all reps. Repeat other side. ',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2908,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '1ec27c251ec1c28794b9216c078734aab199f41aef94439dbab6d19e917d31de',
          file_name:
            'videos/1ec27c251ec1c28794b9216c078734aab199f41aef94439dbab6d19e917d31de.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1ec27c251ec1c28794b9216c078734aab199f41aef94439dbab6d19e917d31de.mp4',
          name: 'INT-ADV-Kickstand_Deadlift_to_Squat-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 107276,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2909,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '41b88a14df9b8ca5c5d80e61f64b78c6dccb4e3b0cce51fabb6452bd0121257a',
          file_name:
            'videos/41b88a14df9b8ca5c5d80e61f64b78c6dccb4e3b0cce51fabb6452bd0121257a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/41b88a14df9b8ca5c5d80e61f64b78c6dccb4e3b0cce51fabb6452bd0121257a.mp4',
          name: 'INT-ADV-Kickstand_Deadlift_to_Squat-EXERCISE-LEFT',
          description: 'Left Side',
          size: 107513,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3116,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '67323536d96cbf15edcdf6acc7f8510b034cbd84f0cc4d10b257c8756536beca',
          file_name:
            'audios/67323536d96cbf15edcdf6acc7f8510b034cbd84f0cc4d10b257c8756536beca.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/67323536d96cbf15edcdf6acc7f8510b034cbd84f0cc4d10b257c8756536beca.mp3',
          name: 'INT-ADV-Dumbbell_Kickstand_Deadlift-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 26063,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-HEELS_ELEVATED_SQUAT-EXERCISE': {
      id: 1131,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Heels Elevated Squat',
      short_name: 'Heels Elevated Squat',
      unique_name: 'INTERMEDIATE-HEELS_ELEVATED_SQUAT-EXERCISE',
      description:
        '1. Stand with your heels on a set of dumbbells about shoulder-width apart. Hold a dumbbell in each hand, resting lightly on your shoulders, elbows pointed down.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your feet and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2911,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '285705267fe2ba6d5918826665596f5244cf9638201d19252cde45bd5c1db046',
          file_name:
            'videos/285705267fe2ba6d5918826665596f5244cf9638201d19252cde45bd5c1db046.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/285705267fe2ba6d5918826665596f5244cf9638201d19252cde45bd5c1db046.mp4',
          name: 'INT-ADV-Heels_Elevated_Squat-EXERCISE',
          description: null,
          size: 101619,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3117,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd9b57896aa739809a11e265d5f764f7593079165f8f529085d9ff199be315670',
          file_name:
            'audios/d9b57896aa739809a11e265d5f764f7593079165f8f529085d9ff199be315670.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d9b57896aa739809a11e265d5f764f7593079165f8f529085d9ff199be315670.mp3',
          name: 'INT-ADV-Heels_Elevated_Squat-EXERCISE',
          description: null,
          size: 25965,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-HEELS_ELEVATED_SQUAT-EXERCISE': {
      id: 1132,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Heels Elevated Squat',
      short_name: 'Heels Elevated Squat',
      unique_name: 'ADVANCED-HEELS_ELEVATED_SQUAT-EXERCISE',
      description:
        '1. Stand with your heels on a set of dumbbells about shoulder-width apart. Hold a dumbbell in each hand, resting lightly on your shoulders, elbows pointed down.\n2. Drive your hips back and bend your knees until your legs form a 90 degree angle or lower. Keep your chest up and shoulders back.\n3. Drive through your feet and stand back up to starting position.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2913,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '285705267fe2ba6d5918826665596f5244cf9638201d19252cde45bd5c1db046',
          file_name:
            'videos/285705267fe2ba6d5918826665596f5244cf9638201d19252cde45bd5c1db046.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/285705267fe2ba6d5918826665596f5244cf9638201d19252cde45bd5c1db046.mp4',
          name: 'INT-ADV-Heels_Elevated_Squat-EXERCISE',
          description: null,
          size: 101619,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3118,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd9b57896aa739809a11e265d5f764f7593079165f8f529085d9ff199be315670',
          file_name:
            'audios/d9b57896aa739809a11e265d5f764f7593079165f8f529085d9ff199be315670.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d9b57896aa739809a11e265d5f764f7593079165f8f529085d9ff199be315670.mp3',
          name: 'INT-ADV-Heels_Elevated_Squat-EXERCISE',
          description: null,
          size: 25965,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_SHRUG-EXERCISE': {
      id: 1133,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Shrug',
      short_name: 'Dumbbell Shrug',
      unique_name: 'INTERMEDIATE-DUMBBELL_SHRUG-EXERCISE',
      description:
        '1.Stand with feet shoulder-width apart, hold a pair of dumbbells directly over your shoulders, arms fully extended, palms face in. \n2.Shrug your shoulders upwards towards your ears. Squeeze Traps at the top. Slowly lower back to your start position and depress your shoulders down \n3.Slowly lower back down and depress your shoulder blades at the bottom as you return to start position.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 18,
          unique_name: 'TRAPS',
          name: 'Traps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2915,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'a9a24c57bc97c430b665d8a0ac0162281f36c78e2ecb61272d6fccceccf5669c',
          file_name:
            'videos/a9a24c57bc97c430b665d8a0ac0162281f36c78e2ecb61272d6fccceccf5669c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a9a24c57bc97c430b665d8a0ac0162281f36c78e2ecb61272d6fccceccf5669c.mp4',
          name: 'INT-ADV-Dumbbell_Shrug-EXERCISE',
          description: null,
          size: 52064,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3119,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'f40517c8756cfed9b3e8f9dd379ba76ff7dd405d0c73b4a0cfe0a82ba381ab92',
          file_name:
            'audios/f40517c8756cfed9b3e8f9dd379ba76ff7dd405d0c73b4a0cfe0a82ba381ab92.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f40517c8756cfed9b3e8f9dd379ba76ff7dd405d0c73b4a0cfe0a82ba381ab92.mp3',
          name: 'INT-ADV-Dumbbell_Shrug-EXERCISE',
          description: null,
          size: 22797,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_SHRUG-EXERCISE': {
      id: 1134,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Shrug',
      short_name: 'Dumbbell Shrug',
      unique_name: 'ADVANCED-DUMBBELL_SHRUG-EXERCISE',
      description:
        '1.Stand with feet shoulder-width apart, hold a pair of dumbbells directly over your shoulders, arms fully extended, palms face in. \n2.Shrug your shoulders upwards towards your ears. Squeeze Traps at the top. Slowly lower back to your start position and depress your shoulders down \n3.Slowly lower back down and depress your shoulder blades at the bottom as you return to start position.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 18,
          unique_name: 'TRAPS',
          name: 'Traps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2917,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'a9a24c57bc97c430b665d8a0ac0162281f36c78e2ecb61272d6fccceccf5669c',
          file_name:
            'videos/a9a24c57bc97c430b665d8a0ac0162281f36c78e2ecb61272d6fccceccf5669c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a9a24c57bc97c430b665d8a0ac0162281f36c78e2ecb61272d6fccceccf5669c.mp4',
          name: 'INT-ADV-Dumbbell_Shrug-EXERCISE',
          description: null,
          size: 52064,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3120,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'f40517c8756cfed9b3e8f9dd379ba76ff7dd405d0c73b4a0cfe0a82ba381ab92',
          file_name:
            'audios/f40517c8756cfed9b3e8f9dd379ba76ff7dd405d0c73b4a0cfe0a82ba381ab92.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f40517c8756cfed9b3e8f9dd379ba76ff7dd405d0c73b4a0cfe0a82ba381ab92.mp3',
          name: 'INT-ADV-Dumbbell_Shrug-EXERCISE',
          description: null,
          size: 22797,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DIAMOND_PUSH_UPS-EXERCISE': {
      id: 1135,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Diamond Push Ups',
      short_name: 'Diamond Push Ups',
      unique_name: 'INTERMEDIATE-DIAMOND_PUSH_UPS-EXERCISE',
      description:
        '1. Start in Plank position with your hands flat on the floor in the shape of a diamond underneath your chest. \n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor, so the center of your chest is in the center of the diamond.\n3. Straighten your arms and raise your body back up in one line.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2919,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '2e6f6beb85ecf89ae092b2a6259aff03ea879bbc3f79366be5f35fbbb33e9167',
          file_name:
            'videos/2e6f6beb85ecf89ae092b2a6259aff03ea879bbc3f79366be5f35fbbb33e9167.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2e6f6beb85ecf89ae092b2a6259aff03ea879bbc3f79366be5f35fbbb33e9167.mp4',
          name: 'INT-ADV-Diamond_Push_Ups-EXERCISE',
          description: null,
          size: 101888,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3121,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'c005d2b6bf3657fe357893a468184fa0bab2439458d1acf71bf44bd97a7273fc',
          file_name:
            'audios/c005d2b6bf3657fe357893a468184fa0bab2439458d1acf71bf44bd97a7273fc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c005d2b6bf3657fe357893a468184fa0bab2439458d1acf71bf44bd97a7273fc.mp3',
          name: 'INT-ADV-Diamond_Push_Ups-EXERCISE',
          description: null,
          size: 20781,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DIAMOND_PUSH_UPS-EXERCISE': {
      id: 1136,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Diamond Push Ups',
      short_name: 'Diamond Push Ups',
      unique_name: 'ADVANCED-DIAMOND_PUSH_UPS-EXERCISE',
      description:
        '1. Start in Plank position with your hands flat on the floor in the shape of a diamond underneath your chest. \n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor, so the center of your chest is in the center of the diamond.\n3. Straighten your arms and raise your body back up in one line.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2921,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '2e6f6beb85ecf89ae092b2a6259aff03ea879bbc3f79366be5f35fbbb33e9167',
          file_name:
            'videos/2e6f6beb85ecf89ae092b2a6259aff03ea879bbc3f79366be5f35fbbb33e9167.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2e6f6beb85ecf89ae092b2a6259aff03ea879bbc3f79366be5f35fbbb33e9167.mp4',
          name: 'INT-ADV-Diamond_Push_Ups-EXERCISE',
          description: null,
          size: 101888,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3122,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'c005d2b6bf3657fe357893a468184fa0bab2439458d1acf71bf44bd97a7273fc',
          file_name:
            'audios/c005d2b6bf3657fe357893a468184fa0bab2439458d1acf71bf44bd97a7273fc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c005d2b6bf3657fe357893a468184fa0bab2439458d1acf71bf44bd97a7273fc.mp3',
          name: 'INT-ADV-Diamond_Push_Ups-EXERCISE',
          description: null,
          size: 20781,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DEAD_STOP_LUNGE-EXERCISE': {
      id: 1137,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Dead Stop Lunge',
      short_name: 'Dead Stop Lunge',
      unique_name: 'INTERMEDIATE-DEAD_STOP_LUNGE-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, holding one dumbbell in each hand by your sides. Take a big step forward with one leg, elevate your back heel.\n2. Maintain good posture, bend both knees and lower hips down until the back knee rests on the floor. Pause. \n3. Drive through your heel to straighten legs.\n4. Perform all reps with one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2923,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '5afb495187b56b60cda36bdb04673016c3beb15fd2d57e188159f508c8f1753d',
          file_name:
            'videos/5afb495187b56b60cda36bdb04673016c3beb15fd2d57e188159f508c8f1753d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5afb495187b56b60cda36bdb04673016c3beb15fd2d57e188159f508c8f1753d.mp4',
          name: 'INT-ADV-Dead_Stop_Lunge-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 84473,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2924,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '7ffe59228eb1b214d655fee4de580dd5a0253b636b4b0d71b40ef98fc1998e8b',
          file_name:
            'videos/7ffe59228eb1b214d655fee4de580dd5a0253b636b4b0d71b40ef98fc1998e8b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7ffe59228eb1b214d655fee4de580dd5a0253b636b4b0d71b40ef98fc1998e8b.mp4',
          name: 'INT-ADV-Dead_Stop_Lunge-EXERCISE-LEFT',
          description: 'Left Side',
          size: 82268,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3123,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'e139d9b336c042daf64d9deec42e1f136952aa04fc52b46d7e05363e0867bd16',
          file_name:
            'audios/e139d9b336c042daf64d9deec42e1f136952aa04fc52b46d7e05363e0867bd16.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e139d9b336c042daf64d9deec42e1f136952aa04fc52b46d7e05363e0867bd16.mp3',
          name: 'INT-ADV-Dead_Stop_Lunge-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 21645,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DEAD_STOP_LUNGE-EXERCISE': {
      id: 1138,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Dead Stop Lunge',
      short_name: 'Dead Stop Lunge',
      unique_name: 'ADVANCED-DEAD_STOP_LUNGE-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, holding one dumbbell in each hand by your sides. Take a big step forward with one leg, elevate your back heel.\n2. Maintain good posture, bend both knees and lower hips down until the back knee rests on the floor. Pause. \n3. Drive through your heel to straighten legs.\n4. Perform all reps with one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2926,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '5afb495187b56b60cda36bdb04673016c3beb15fd2d57e188159f508c8f1753d',
          file_name:
            'videos/5afb495187b56b60cda36bdb04673016c3beb15fd2d57e188159f508c8f1753d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5afb495187b56b60cda36bdb04673016c3beb15fd2d57e188159f508c8f1753d.mp4',
          name: 'INT-ADV-Dead_Stop_Lunge-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 84473,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2927,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '7ffe59228eb1b214d655fee4de580dd5a0253b636b4b0d71b40ef98fc1998e8b',
          file_name:
            'videos/7ffe59228eb1b214d655fee4de580dd5a0253b636b4b0d71b40ef98fc1998e8b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7ffe59228eb1b214d655fee4de580dd5a0253b636b4b0d71b40ef98fc1998e8b.mp4',
          name: 'INT-ADV-Dead_Stop_Lunge-EXERCISE-LEFT',
          description: 'Left Side',
          size: 82268,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3124,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'e139d9b336c042daf64d9deec42e1f136952aa04fc52b46d7e05363e0867bd16',
          file_name:
            'audios/e139d9b336c042daf64d9deec42e1f136952aa04fc52b46d7e05363e0867bd16.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e139d9b336c042daf64d9deec42e1f136952aa04fc52b46d7e05363e0867bd16.mp3',
          name: 'INT-ADV-Dead_Stop_Lunge-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 21645,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SIDE_PLANK_LEG_LIFTS-EXERCISE': {
      id: 1160,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Side Plank Leg Lifts',
      short_name: 'Side Plank Leg Lifts',
      unique_name: 'BEGINNER-SIDE_PLANK_LEG_LIFTS-EXERCISE',
      description:
        '1. Lie on your side, propping yourself up on your forearm, elbow directly under your shoulder. Bend your bottom leg and extend the top leg.\n2. Lift your hips up so your body is in a straight line. \n3. Keeping your hips square and toes and knees facing forward, raise your top leg up. \n4. Pause and lower leg down.\n5. Perform all reps on one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2977,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'a99e392b0e36a21edc78c7c52e8fc37939c71d18999330ca891f714021abe125',
          file_name:
            'videos/a99e392b0e36a21edc78c7c52e8fc37939c71d18999330ca891f714021abe125.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a99e392b0e36a21edc78c7c52e8fc37939c71d18999330ca891f714021abe125.mp4',
          name: 'BEG-INT-ADV-Side_Plank_Leg_Lifts-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 61311,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2978,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'b247983d8e054d5ba643dc92acd3760ca9836dfa92527491ba40be9d318f1c4a',
          file_name:
            'videos/b247983d8e054d5ba643dc92acd3760ca9836dfa92527491ba40be9d318f1c4a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b247983d8e054d5ba643dc92acd3760ca9836dfa92527491ba40be9d318f1c4a.mp4',
          name: 'BEG-INT-ADV-Side_Plank_Leg_Lifts-EXERCISE-LEFT',
          description: 'Left Side',
          size: 69744,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3146,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '83195edfe375cde2d913e1da87115c5035f2c29392ed50313d68d405832e028a',
          file_name:
            'audios/83195edfe375cde2d913e1da87115c5035f2c29392ed50313d68d405832e028a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/83195edfe375cde2d913e1da87115c5035f2c29392ed50313d68d405832e028a.mp3',
          name: 'BEG-INT-ADV-Side_Plank_Leg_Lifts-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SIDE_PLANK_LEG_LIFTS-EXERCISE': {
      id: 1161,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Side Plank Leg Lifts',
      short_name: 'Side Plank Leg Lifts',
      unique_name: 'INTERMEDIATE-SIDE_PLANK_LEG_LIFTS-EXERCISE',
      description:
        '1. Lie on your side, propping yourself up on your forearm, elbow directly under your shoulder. Bend your bottom leg and extend the top leg.\n2. Lift your hips up so your body is in a straight line. \n3. Keeping your hips square and toes and knees facing forward, raise your top leg up. \n4. Pause and lower leg down.\n5. Perform all reps on one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2980,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'a99e392b0e36a21edc78c7c52e8fc37939c71d18999330ca891f714021abe125',
          file_name:
            'videos/a99e392b0e36a21edc78c7c52e8fc37939c71d18999330ca891f714021abe125.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a99e392b0e36a21edc78c7c52e8fc37939c71d18999330ca891f714021abe125.mp4',
          name: 'BEG-INT-ADV-Side_Plank_Leg_Lifts-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 61311,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2981,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'b247983d8e054d5ba643dc92acd3760ca9836dfa92527491ba40be9d318f1c4a',
          file_name:
            'videos/b247983d8e054d5ba643dc92acd3760ca9836dfa92527491ba40be9d318f1c4a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b247983d8e054d5ba643dc92acd3760ca9836dfa92527491ba40be9d318f1c4a.mp4',
          name: 'BEG-INT-ADV-Side_Plank_Leg_Lifts-EXERCISE-LEFT',
          description: 'Left Side',
          size: 69744,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3147,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '83195edfe375cde2d913e1da87115c5035f2c29392ed50313d68d405832e028a',
          file_name:
            'audios/83195edfe375cde2d913e1da87115c5035f2c29392ed50313d68d405832e028a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/83195edfe375cde2d913e1da87115c5035f2c29392ed50313d68d405832e028a.mp3',
          name: 'BEG-INT-ADV-Side_Plank_Leg_Lifts-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SIDE_PLANK_LEG_LIFTS-EXERCISE': {
      id: 1162,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Side Plank Leg Lifts',
      short_name: 'Side Plank Leg Lifts',
      unique_name: 'ADVANCED-SIDE_PLANK_LEG_LIFTS-EXERCISE',
      description:
        '1. Lie on your side, propping yourself up on your forearm, elbow directly under your shoulder. Bend your bottom leg and extend the top leg.\n2. Lift your hips up so your body is in a straight line. \n3. Keeping your hips square and toes and knees facing forward, raise your top leg up. \n4. Pause and lower leg down.\n5. Perform all reps on one side. Repeat other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2983,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'a99e392b0e36a21edc78c7c52e8fc37939c71d18999330ca891f714021abe125',
          file_name:
            'videos/a99e392b0e36a21edc78c7c52e8fc37939c71d18999330ca891f714021abe125.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a99e392b0e36a21edc78c7c52e8fc37939c71d18999330ca891f714021abe125.mp4',
          name: 'BEG-INT-ADV-Side_Plank_Leg_Lifts-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 61311,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2984,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'b247983d8e054d5ba643dc92acd3760ca9836dfa92527491ba40be9d318f1c4a',
          file_name:
            'videos/b247983d8e054d5ba643dc92acd3760ca9836dfa92527491ba40be9d318f1c4a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b247983d8e054d5ba643dc92acd3760ca9836dfa92527491ba40be9d318f1c4a.mp4',
          name: 'BEG-INT-ADV-Side_Plank_Leg_Lifts-EXERCISE-LEFT',
          description: 'Left Side',
          size: 69744,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3148,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '83195edfe375cde2d913e1da87115c5035f2c29392ed50313d68d405832e028a',
          file_name:
            'audios/83195edfe375cde2d913e1da87115c5035f2c29392ed50313d68d405832e028a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/83195edfe375cde2d913e1da87115c5035f2c29392ed50313d68d405832e028a.mp3',
          name: 'BEG-INT-ADV-Side_Plank_Leg_Lifts-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-PARTIAL_REP_SQUAT-_BOTTOM12-_BODYWEIGHT-EXERCISE': {
      id: 1163,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Partial Rep Squat - Bottom 1/2 - Bodyweight',
      short_name: 'Partial Rep Squat - Bottom 1/2',
      unique_name: 'BEGINNER-PARTIAL_REP_SQUAT-_BOTTOM12-_BODYWEIGHT-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, chest up and shoulders back. Hands clasped in front of you. \n2. Bend your knees and lower down into a squat. This is start position. \n3. Drive through your heels to come up halfway. Keep core tight and tall posture. \n4. Lower back down to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2986,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '915d66d2e78bd16038b3e8aa653aa283305c4977a9a4ff31e3fe001cccb3733b',
          file_name:
            'videos/915d66d2e78bd16038b3e8aa653aa283305c4977a9a4ff31e3fe001cccb3733b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/915d66d2e78bd16038b3e8aa653aa283305c4977a9a4ff31e3fe001cccb3733b.mp4',
          name: 'BEGINNER-Partial_Rep_Squat_-_Bottom_1-2_-_Bodyweight-EXERCISE',
          description: null,
          size: 62495,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3149,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '0729d3e5d43c6f022f0ea2e6853f699a1d4c8c27ddbbefa26b7186415a2672b0',
          file_name:
            'audios/0729d3e5d43c6f022f0ea2e6853f699a1d4c8c27ddbbefa26b7186415a2672b0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0729d3e5d43c6f022f0ea2e6853f699a1d4c8c27ddbbefa26b7186415a2672b0.mp3',
          name: 'BEGINNER-Partial_Rep_Squat_-_Bottom_1-2_-_Bodyweight-EXERCISE',
          description: null,
          size: 37197,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-L_SIT_LEG_LIFTS-EXERCISE': {
      id: 1167,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'L Sit Leg Lifts',
      short_name: 'L Sit Leg Lifts',
      unique_name: 'BEGINNER-L_SIT_LEG_LIFTS-EXERCISE',
      description:
        '1. Start in a seated position with your legs straight. Bend one knee and place your foot on the floor, close to your body. Place both hands on the floor behind you for support. \n2.Maintaining tall posture, square hips, lift the extended leg straight up as high as you can. Pause for a beat. \n3. Return leg to start position. \n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2997,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '0bebe6a371b37ee63ccfd7df3f6d2278650dc7884096f1300f5e7fe57055fa2d',
          file_name:
            'videos/0bebe6a371b37ee63ccfd7df3f6d2278650dc7884096f1300f5e7fe57055fa2d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0bebe6a371b37ee63ccfd7df3f6d2278650dc7884096f1300f5e7fe57055fa2d.mp4',
          name: 'BEG-INT-ADV-L_Sit_Leg_Lifts-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 50487,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2998,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'e11a69d082076ee4b55ac647396f51774998545317ac52449cdcafb5bd783d5c',
          file_name:
            'videos/e11a69d082076ee4b55ac647396f51774998545317ac52449cdcafb5bd783d5c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e11a69d082076ee4b55ac647396f51774998545317ac52449cdcafb5bd783d5c.mp4',
          name: 'BEG-INT-ADV-L_Sit_Leg_Lifts-EXERCISE-LEFT',
          description: 'Left Side',
          size: 52803,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3153,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'b8e83752bb926d53358d8d61d992e7fbed6907d263f566ac6fb26e8d9080d8db',
          file_name:
            'audios/b8e83752bb926d53358d8d61d992e7fbed6907d263f566ac6fb26e8d9080d8db.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b8e83752bb926d53358d8d61d992e7fbed6907d263f566ac6fb26e8d9080d8db.mp3',
          name: 'BEG-INT-ADV-L_Sit_Leg_Lifts-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-L_SIT_LEG_LIFTS-EXERCISE': {
      id: 1168,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'L Sit Leg Lifts',
      short_name: 'L Sit Leg Lifts',
      unique_name: 'INTERMEDIATE-L_SIT_LEG_LIFTS-EXERCISE',
      description:
        '1. Start in a seated position with your legs straight. Bend one knee and place your foot on the floor, close to your body. Place both hands on the floor behind you for support. \n2.Maintaining tall posture, square hips, lift the extended leg straight up as high as you can. Pause for a beat. \n3. Return leg to start position. \n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3000,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '0bebe6a371b37ee63ccfd7df3f6d2278650dc7884096f1300f5e7fe57055fa2d',
          file_name:
            'videos/0bebe6a371b37ee63ccfd7df3f6d2278650dc7884096f1300f5e7fe57055fa2d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0bebe6a371b37ee63ccfd7df3f6d2278650dc7884096f1300f5e7fe57055fa2d.mp4',
          name: 'BEG-INT-ADV-L_Sit_Leg_Lifts-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 50487,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3001,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'e11a69d082076ee4b55ac647396f51774998545317ac52449cdcafb5bd783d5c',
          file_name:
            'videos/e11a69d082076ee4b55ac647396f51774998545317ac52449cdcafb5bd783d5c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e11a69d082076ee4b55ac647396f51774998545317ac52449cdcafb5bd783d5c.mp4',
          name: 'BEG-INT-ADV-L_Sit_Leg_Lifts-EXERCISE-LEFT',
          description: 'Left Side',
          size: 52803,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3154,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'b8e83752bb926d53358d8d61d992e7fbed6907d263f566ac6fb26e8d9080d8db',
          file_name:
            'audios/b8e83752bb926d53358d8d61d992e7fbed6907d263f566ac6fb26e8d9080d8db.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b8e83752bb926d53358d8d61d992e7fbed6907d263f566ac6fb26e8d9080d8db.mp3',
          name: 'BEG-INT-ADV-L_Sit_Leg_Lifts-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-L_SIT_LEG_LIFTS-EXERCISE': {
      id: 1169,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'L Sit Leg Lifts',
      short_name: 'L Sit Leg Lifts',
      unique_name: 'ADVANCED-L_SIT_LEG_LIFTS-EXERCISE',
      description:
        '1. Start in a seated position with your legs straight. Bend one knee and place your foot on the floor, close to your body. Place both hands on the floor behind you for support. \n2.Maintaining tall posture, square hips, lift the extended leg straight up as high as you can. Pause for a beat. \n3. Return leg to start position. \n4. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3003,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '0bebe6a371b37ee63ccfd7df3f6d2278650dc7884096f1300f5e7fe57055fa2d',
          file_name:
            'videos/0bebe6a371b37ee63ccfd7df3f6d2278650dc7884096f1300f5e7fe57055fa2d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0bebe6a371b37ee63ccfd7df3f6d2278650dc7884096f1300f5e7fe57055fa2d.mp4',
          name: 'BEG-INT-ADV-L_Sit_Leg_Lifts-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 50487,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3004,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'e11a69d082076ee4b55ac647396f51774998545317ac52449cdcafb5bd783d5c',
          file_name:
            'videos/e11a69d082076ee4b55ac647396f51774998545317ac52449cdcafb5bd783d5c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e11a69d082076ee4b55ac647396f51774998545317ac52449cdcafb5bd783d5c.mp4',
          name: 'BEG-INT-ADV-L_Sit_Leg_Lifts-EXERCISE-LEFT',
          description: 'Left Side',
          size: 52803,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3155,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'b8e83752bb926d53358d8d61d992e7fbed6907d263f566ac6fb26e8d9080d8db',
          file_name:
            'audios/b8e83752bb926d53358d8d61d992e7fbed6907d263f566ac6fb26e8d9080d8db.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b8e83752bb926d53358d8d61d992e7fbed6907d263f566ac6fb26e8d9080d8db.mp3',
          name: 'BEG-INT-ADV-L_Sit_Leg_Lifts-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-BEAR_PLANK_GLUTE_KICKBACKS-EXERCISE': {
      id: 1170,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Bear Plank Glute Kickbacks',
      short_name: 'Bear Plank Glute Kickbacks',
      unique_name: 'BEGINNER-BEAR_PLANK_GLUTE_KICKBACKS-EXERCISE',
      description:
        '1. Start on all fours with your shoulders over wrists and knees under hips. \n2. Engage your core and hover your knees a few inches off the ground. Hips square.\n3. Keeping your core tight, extend one leg straight back behind you, toes point toward the floor. Do not arch your lower back.\n4. Return to start position. \n5. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3006,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '4fe30c52a41ea566931684c688c0cd82b0da2780878ca9e9c822bd68cfb8b435',
          file_name:
            'videos/4fe30c52a41ea566931684c688c0cd82b0da2780878ca9e9c822bd68cfb8b435.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4fe30c52a41ea566931684c688c0cd82b0da2780878ca9e9c822bd68cfb8b435.mp4',
          name: 'BEG-INT-ADV-Bear_Plank_Glute_Kickbacks-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 78713,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3007,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'a4e7ca0a9f954f3be8347adf928028fd3ecf218692521bbd0236bbab1acd4e38',
          file_name:
            'videos/a4e7ca0a9f954f3be8347adf928028fd3ecf218692521bbd0236bbab1acd4e38.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a4e7ca0a9f954f3be8347adf928028fd3ecf218692521bbd0236bbab1acd4e38.mp4',
          name: 'BEG-INT-ADV-Bear_Plank_Glute_Kickbacks-EXERCISE-LEFT',
          description: 'Left Side',
          size: 71965,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3156,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'f7e881b71a58dd25dcdf2f0af892c4b36421c11fa25577616d088427679be927',
          file_name:
            'audios/f7e881b71a58dd25dcdf2f0af892c4b36421c11fa25577616d088427679be927.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f7e881b71a58dd25dcdf2f0af892c4b36421c11fa25577616d088427679be927.mp3',
          name: 'BEG-INT-ADV-Bear_Plank_Glute_Kickbacks-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 37034,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-BEAR_PLANK_GLUTE_KICKBACKS-EXERCISE': {
      id: 1171,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Bear Plank Glute Kickbacks',
      short_name: 'Bear Plank Glute Kickbacks',
      unique_name: 'INTERMEDIATE-BEAR_PLANK_GLUTE_KICKBACKS-EXERCISE',
      description:
        '1. Start on all fours with your shoulders over wrists and knees under hips. \n2. Engage your core and hover your knees a few inches off the ground. Hips square.\n3. Keeping your core tight, extend one leg straight back behind you, toes point toward the floor. Do not arch your lower back.\n4. Return to start position. \n5. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3009,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '4fe30c52a41ea566931684c688c0cd82b0da2780878ca9e9c822bd68cfb8b435',
          file_name:
            'videos/4fe30c52a41ea566931684c688c0cd82b0da2780878ca9e9c822bd68cfb8b435.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4fe30c52a41ea566931684c688c0cd82b0da2780878ca9e9c822bd68cfb8b435.mp4',
          name: 'BEG-INT-ADV-Bear_Plank_Glute_Kickbacks-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 78713,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3010,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'a4e7ca0a9f954f3be8347adf928028fd3ecf218692521bbd0236bbab1acd4e38',
          file_name:
            'videos/a4e7ca0a9f954f3be8347adf928028fd3ecf218692521bbd0236bbab1acd4e38.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a4e7ca0a9f954f3be8347adf928028fd3ecf218692521bbd0236bbab1acd4e38.mp4',
          name: 'BEG-INT-ADV-Bear_Plank_Glute_Kickbacks-EXERCISE-LEFT',
          description: 'Left Side',
          size: 71965,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3157,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'f7e881b71a58dd25dcdf2f0af892c4b36421c11fa25577616d088427679be927',
          file_name:
            'audios/f7e881b71a58dd25dcdf2f0af892c4b36421c11fa25577616d088427679be927.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f7e881b71a58dd25dcdf2f0af892c4b36421c11fa25577616d088427679be927.mp3',
          name: 'BEG-INT-ADV-Bear_Plank_Glute_Kickbacks-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 37034,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-BEAR_PLANK_GLUTE_KICKBACKS-EXERCISE': {
      id: 1172,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Bear Plank Glute Kickbacks',
      short_name: 'Bear Plank Glute Kickbacks',
      unique_name: 'ADVANCED-BEAR_PLANK_GLUTE_KICKBACKS-EXERCISE',
      description:
        '1. Start on all fours with your shoulders over wrists and knees under hips. \n2. Engage your core and hover your knees a few inches off the ground. Hips square.\n3. Keeping your core tight, extend one leg straight back behind you, toes point toward the floor. Do not arch your lower back.\n4. Return to start position. \n5. Perform all reps on one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3012,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '4fe30c52a41ea566931684c688c0cd82b0da2780878ca9e9c822bd68cfb8b435',
          file_name:
            'videos/4fe30c52a41ea566931684c688c0cd82b0da2780878ca9e9c822bd68cfb8b435.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4fe30c52a41ea566931684c688c0cd82b0da2780878ca9e9c822bd68cfb8b435.mp4',
          name: 'BEG-INT-ADV-Bear_Plank_Glute_Kickbacks-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 78713,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3013,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'a4e7ca0a9f954f3be8347adf928028fd3ecf218692521bbd0236bbab1acd4e38',
          file_name:
            'videos/a4e7ca0a9f954f3be8347adf928028fd3ecf218692521bbd0236bbab1acd4e38.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a4e7ca0a9f954f3be8347adf928028fd3ecf218692521bbd0236bbab1acd4e38.mp4',
          name: 'BEG-INT-ADV-Bear_Plank_Glute_Kickbacks-EXERCISE-LEFT',
          description: 'Left Side',
          size: 71965,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3158,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'f7e881b71a58dd25dcdf2f0af892c4b36421c11fa25577616d088427679be927',
          file_name:
            'audios/f7e881b71a58dd25dcdf2f0af892c4b36421c11fa25577616d088427679be927.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f7e881b71a58dd25dcdf2f0af892c4b36421c11fa25577616d088427679be927.mp3',
          name: 'BEG-INT-ADV-Bear_Plank_Glute_Kickbacks-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 37034,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-B_STANCE_STAGGERED_SQUAT-_BODYWEIGHT-EXERCISE': {
      id: 1173,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'B Stance Staggered Squat - Bodyweight',
      short_name: 'B Stance Staggered Squat',
      unique_name: 'BEGINNER-B_STANCE_STAGGERED_SQUAT-_BODYWEIGHT-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart. Take a small step back with one foot and lift your heel off the floor.\n2. Squat down until the thigh of your front leg is parallel with the floor. Keep your spine neutral and place the weight onto your front foot.\n3. Keeping chest up, drive through your front heel and stand back up to start.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3015,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: 'fa4677323ead98835b601033528a3a132b95682c45d553e72ae5f74c2cab150b',
          file_name:
            'videos/fa4677323ead98835b601033528a3a132b95682c45d553e72ae5f74c2cab150b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fa4677323ead98835b601033528a3a132b95682c45d553e72ae5f74c2cab150b.mp4',
          name: 'BEGINNER-B_Stance_Staggered_Squat_-_Bodyweight-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 87369,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3016,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: '314c8695fd4c97e88268a091d048b1509b7dc353468ab2f71fa270425a01bf67',
          file_name:
            'videos/314c8695fd4c97e88268a091d048b1509b7dc353468ab2f71fa270425a01bf67.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/314c8695fd4c97e88268a091d048b1509b7dc353468ab2f71fa270425a01bf67.mp4',
          name: 'BEGINNER-B_Stance_Staggered_Squat_-_Bodyweight-EXERCISE-LEFT',
          description: 'Left Side',
          size: 97771,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3159,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: '30e5c273db6dbb12ac94855d350069881b620373ed9db18bbb59c3303c9d1f50',
          file_name:
            'audios/30e5c273db6dbb12ac94855d350069881b620373ed9db18bbb59c3303c9d1f50.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/30e5c273db6dbb12ac94855d350069881b620373ed9db18bbb59c3303c9d1f50.mp3',
          name: 'BEGINNER-B_Stance_Staggered_Squat_-_Bodyweight-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 41423,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ADDUCTOR_LEG_LIFTS-EXERCISE': {
      id: 1174,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Adductor Leg Lifts',
      short_name: 'Adductor Leg Lifts',
      unique_name: 'BEGINNER-ADDUCTOR_LEG_LIFTS-EXERCISE',
      description:
        '1. Start in side-lying position, resting on one forearm. Hips, shoulders and feet stacked, legs are straight.\n2. Keeping your hips square and toes and knees facing forward, cross your top leg over the bottom, resting your foot on the floor. \n3. Lift your bottom leg up as high as you can. Pause for a beat. \n4. Lower slowly with control. Perform all reps on one side. Repeat other leg.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3018,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '0f672ec2785e9d2374a9e48cdc32f71b11cc87a3d2af743cfee6367873d97d42',
          file_name:
            'videos/0f672ec2785e9d2374a9e48cdc32f71b11cc87a3d2af743cfee6367873d97d42.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0f672ec2785e9d2374a9e48cdc32f71b11cc87a3d2af743cfee6367873d97d42.mp4',
          name: 'BEG-INT-ADV-Adductor_Leg_Lifts-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 56989,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3019,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'bd5009777babb1a304eefc87c4addadd2f0ed99fe002df8747dfe315d156dc81',
          file_name:
            'videos/bd5009777babb1a304eefc87c4addadd2f0ed99fe002df8747dfe315d156dc81.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bd5009777babb1a304eefc87c4addadd2f0ed99fe002df8747dfe315d156dc81.mp4',
          name: 'BEG-INT-ADV-Adductor_Leg_Lifts-EXERCISE-LEFT',
          description: 'Left Side',
          size: 61602,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3160,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd2e6f001238b461707e082129e6dbf6d47512e06eca3327f86bf8b5f3984b4de',
          file_name:
            'audios/d2e6f001238b461707e082129e6dbf6d47512e06eca3327f86bf8b5f3984b4de.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d2e6f001238b461707e082129e6dbf6d47512e06eca3327f86bf8b5f3984b4de.mp3',
          name: 'BEG-INT-ADV-Adductor_Leg_Lifts-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ADDUCTOR_LEG_LIFTS-EXERCISE': {
      id: 1175,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Adductor Leg Lifts',
      short_name: 'Adductor Leg Lifts',
      unique_name: 'INTERMEDIATE-ADDUCTOR_LEG_LIFTS-EXERCISE',
      description:
        '1. Start in side-lying position, resting on one forearm. Hips, shoulders and feet stacked, legs are straight.\n2. Keeping your hips square and toes and knees facing forward, cross your top leg over the bottom, resting your foot on the floor. \n3. Lift your bottom leg up as high as you can. Pause for a beat. \n4. Lower slowly with control. Perform all reps on one side. Repeat other leg.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3021,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '0f672ec2785e9d2374a9e48cdc32f71b11cc87a3d2af743cfee6367873d97d42',
          file_name:
            'videos/0f672ec2785e9d2374a9e48cdc32f71b11cc87a3d2af743cfee6367873d97d42.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0f672ec2785e9d2374a9e48cdc32f71b11cc87a3d2af743cfee6367873d97d42.mp4',
          name: 'BEG-INT-ADV-Adductor_Leg_Lifts-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 56989,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3022,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'bd5009777babb1a304eefc87c4addadd2f0ed99fe002df8747dfe315d156dc81',
          file_name:
            'videos/bd5009777babb1a304eefc87c4addadd2f0ed99fe002df8747dfe315d156dc81.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bd5009777babb1a304eefc87c4addadd2f0ed99fe002df8747dfe315d156dc81.mp4',
          name: 'BEG-INT-ADV-Adductor_Leg_Lifts-EXERCISE-LEFT',
          description: 'Left Side',
          size: 61602,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3161,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd2e6f001238b461707e082129e6dbf6d47512e06eca3327f86bf8b5f3984b4de',
          file_name:
            'audios/d2e6f001238b461707e082129e6dbf6d47512e06eca3327f86bf8b5f3984b4de.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d2e6f001238b461707e082129e6dbf6d47512e06eca3327f86bf8b5f3984b4de.mp3',
          name: 'BEG-INT-ADV-Adductor_Leg_Lifts-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ADDUCTOR_LEG_LIFTS-EXERCISE': {
      id: 1176,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Adductor Leg Lifts',
      short_name: 'Adductor Leg Lifts',
      unique_name: 'ADVANCED-ADDUCTOR_LEG_LIFTS-EXERCISE',
      description:
        '1. Start in side-lying position, resting on one forearm. Hips, shoulders and feet stacked, legs are straight.\n2. Keeping your hips square and toes and knees facing forward, cross your top leg over the bottom, resting your foot on the floor. \n3. Lift your bottom leg up as high as you can. Pause for a beat. \n4. Lower slowly with control. Perform all reps on one side. Repeat other leg.',
      preview_time: 10,
      min_app_version: 300110000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3024,
          collection_name: 'videos',
          order: 1,
          version: 300110000,
          hash: '0f672ec2785e9d2374a9e48cdc32f71b11cc87a3d2af743cfee6367873d97d42',
          file_name:
            'videos/0f672ec2785e9d2374a9e48cdc32f71b11cc87a3d2af743cfee6367873d97d42.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0f672ec2785e9d2374a9e48cdc32f71b11cc87a3d2af743cfee6367873d97d42.mp4',
          name: 'BEG-INT-ADV-Adductor_Leg_Lifts-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 56989,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3025,
          collection_name: 'videos',
          order: 2,
          version: 300110000,
          hash: 'bd5009777babb1a304eefc87c4addadd2f0ed99fe002df8747dfe315d156dc81',
          file_name:
            'videos/bd5009777babb1a304eefc87c4addadd2f0ed99fe002df8747dfe315d156dc81.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bd5009777babb1a304eefc87c4addadd2f0ed99fe002df8747dfe315d156dc81.mp4',
          name: 'BEG-INT-ADV-Adductor_Leg_Lifts-EXERCISE-LEFT',
          description: 'Left Side',
          size: 61602,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3162,
          collection_name: 'audios',
          order: 1,
          version: 300110000,
          hash: 'd2e6f001238b461707e082129e6dbf6d47512e06eca3327f86bf8b5f3984b4de',
          file_name:
            'audios/d2e6f001238b461707e082129e6dbf6d47512e06eca3327f86bf8b5f3984b4de.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d2e6f001238b461707e082129e6dbf6d47512e06eca3327f86bf8b5f3984b4de.mp3',
          name: 'BEG-INT-ADV-Adductor_Leg_Lifts-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-CAVEMAN_TWIST-EXERCISE': {
      id: 1177,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Caveman Twist',
      short_name: 'Caveman Twist',
      unique_name: 'ADVANCED-CAVEMAN_TWIST-EXERCISE',
      description:
        '1. Sit on the floor, knees bent, holding a kettlebell next to one hip. \n2. Engage your core, lean back slightly. Raise the kettlebell up and across your body, then rotate it in a circle around your head and down to the opposite hip. \n3. Repeat in the opposite direction. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3163,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'beb5ab90b355cbdea94885595005fc6cbcc8fa719889825d35f5541fa397b642',
          file_name:
            'videos/beb5ab90b355cbdea94885595005fc6cbcc8fa719889825d35f5541fa397b642.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/beb5ab90b355cbdea94885595005fc6cbcc8fa719889825d35f5541fa397b642.mp4',
          name: 'ADVANCED-Caveman_Twist-EXERCISE',
          description: null,
          size: 232502,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3164,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '73f02ac1b8421e551afa4de18aff0e3cf8dbe80985f6714d0a152232941f5120',
          file_name:
            'audios/73f02ac1b8421e551afa4de18aff0e3cf8dbe80985f6714d0a152232941f5120.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/73f02ac1b8421e551afa4de18aff0e3cf8dbe80985f6714d0a152232941f5120.mp3',
          name: 'ADVANCED-Caveman_Twist-EXERCISE',
          description: null,
          size: 22221,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_LAWNMOWER_PULL-EXERCISE': {
      id: 1178,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Kettlebell Lawnmower Pull',
      short_name: 'Kettlebell Lawnmower Pull',
      unique_name: 'ADVANCED-KETTLEBELL_LAWNMOWER_PULL-EXERCISE',
      description:
        '1. Stand with feet hip-width apart. Hold a kettlebell in one hand down in front of you.\n2. Keeping chest up, bend your knees, hinge at the hips and swing the bell back in between your legs.\n3. When the bell is behind you, explosively drive hips forward to swing the bell in front of you. \n4. When at chest level, bend your elbow out wide and pull the kettlebell toward your body. Immediately straighten your arm and punch the bell back out. Keep a tight grip on the handle to keep bell level. \n5. Let the bell swing down and continue the motion. String reps together. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3165,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'cfbe22f9d73d96894b828a5dcf39d8cdb0b57246cf8d048429554cdcef6ca8ba',
          file_name:
            'videos/cfbe22f9d73d96894b828a5dcf39d8cdb0b57246cf8d048429554cdcef6ca8ba.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cfbe22f9d73d96894b828a5dcf39d8cdb0b57246cf8d048429554cdcef6ca8ba.mp4',
          name: 'ADVANCED-Kettlebell_Lawnmower_Pull-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 113452,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3166,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '9b2631bd8ee2e6ad7c0a500a45063bb5331673380a614dc827233a30cce0443a',
          file_name:
            'videos/9b2631bd8ee2e6ad7c0a500a45063bb5331673380a614dc827233a30cce0443a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9b2631bd8ee2e6ad7c0a500a45063bb5331673380a614dc827233a30cce0443a.mp4',
          name: 'ADVANCED-Kettlebell_Lawnmower_Pull-EXERCISE-LEFT',
          description: 'Left Side',
          size: 116618,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3167,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '158afdd23090d8e5edf593ff864ac46ad7b0c55981adee1a73b090a1bbcef819',
          file_name:
            'audios/158afdd23090d8e5edf593ff864ac46ad7b0c55981adee1a73b090a1bbcef819.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/158afdd23090d8e5edf593ff864ac46ad7b0c55981adee1a73b090a1bbcef819.mp3',
          name: 'ADVANCED-Kettlebell_Lawnmower_Pull-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 30765,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-90_DEGREE_LATERAL_RAISES-EXERCISE': {
      id: 1179,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: '90 Degree Lateral Raises',
      short_name: '90 Degree Lateral Raises',
      unique_name: 'BEGINNER-90_DEGREE_LATERAL_RAISES-EXERCISE',
      description:
        '1. Stand up tall and hold a dumbbell in each hand, elbows bent at 90 degrees and tight to sides. Fists face each other. \n2. Raise both arms directly out to your sides, bringing elbows to shoulder height. Your arms maintain 90 degrees and palms face down.\n3. Lower your arms back down to starting position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 10,
          unique_name: 'DELTS',
          name: 'Delts',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3168,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'ec2cd3bfe05588b4cc39032f6bce177c4278f39fc89f1186e7299492f58b34b1',
          file_name:
            'videos/ec2cd3bfe05588b4cc39032f6bce177c4278f39fc89f1186e7299492f58b34b1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ec2cd3bfe05588b4cc39032f6bce177c4278f39fc89f1186e7299492f58b34b1.mp4',
          name: 'BEG-INT-ADV-90_Degree_Lateral_Raises-EXERCISE',
          description: null,
          size: 100975,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3169,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'c8394c1d08e98490a8a81e675d7dcba73f92f128278795b102c510d11b0fa721',
          file_name:
            'audios/c8394c1d08e98490a8a81e675d7dcba73f92f128278795b102c510d11b0fa721.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c8394c1d08e98490a8a81e675d7dcba73f92f128278795b102c510d11b0fa721.mp3',
          name: 'BEG-INT-ADV-90_Degree_Lateral_Raises-EXERCISE',
          description: null,
          size: 32877,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-90_DEGREE_LATERAL_RAISES-EXERCISE': {
      id: 1180,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: '90 Degree Lateral Raises',
      short_name: '90 Degree Lateral Raises',
      unique_name: 'INTERMEDIATE-90_DEGREE_LATERAL_RAISES-EXERCISE',
      description:
        '1. Stand up tall and hold a dumbbell in each hand, elbows bent at 90 degrees and tight to sides. Fists face each other. \n2. Raise both arms directly out to your sides, bringing elbows to shoulder height. Your arms maintain 90 degrees and palms face down.\n3. Lower your arms back down to starting position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 10,
          unique_name: 'DELTS',
          name: 'Delts',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3170,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'ec2cd3bfe05588b4cc39032f6bce177c4278f39fc89f1186e7299492f58b34b1',
          file_name:
            'videos/ec2cd3bfe05588b4cc39032f6bce177c4278f39fc89f1186e7299492f58b34b1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ec2cd3bfe05588b4cc39032f6bce177c4278f39fc89f1186e7299492f58b34b1.mp4',
          name: 'BEG-INT-ADV-90_Degree_Lateral_Raises-EXERCISE',
          description: null,
          size: 100975,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3171,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'c8394c1d08e98490a8a81e675d7dcba73f92f128278795b102c510d11b0fa721',
          file_name:
            'audios/c8394c1d08e98490a8a81e675d7dcba73f92f128278795b102c510d11b0fa721.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c8394c1d08e98490a8a81e675d7dcba73f92f128278795b102c510d11b0fa721.mp3',
          name: 'BEG-INT-ADV-90_Degree_Lateral_Raises-EXERCISE',
          description: null,
          size: 32877,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-90_DEGREE_LATERAL_RAISES-EXERCISE': {
      id: 1181,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: '90 Degree Lateral Raises',
      short_name: '90 Degree Lateral Raises',
      unique_name: 'ADVANCED-90_DEGREE_LATERAL_RAISES-EXERCISE',
      description:
        '1. Stand up tall and hold a dumbbell in each hand, elbows bent at 90 degrees and tight to sides. Fists face each other. \n2. Raise both arms directly out to your sides, bringing elbows to shoulder height. Your arms maintain 90 degrees and palms face down.\n3. Lower your arms back down to starting position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 10,
          unique_name: 'DELTS',
          name: 'Delts',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3172,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'ec2cd3bfe05588b4cc39032f6bce177c4278f39fc89f1186e7299492f58b34b1',
          file_name:
            'videos/ec2cd3bfe05588b4cc39032f6bce177c4278f39fc89f1186e7299492f58b34b1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ec2cd3bfe05588b4cc39032f6bce177c4278f39fc89f1186e7299492f58b34b1.mp4',
          name: 'BEG-INT-ADV-90_Degree_Lateral_Raises-EXERCISE',
          description: null,
          size: 100975,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3173,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'c8394c1d08e98490a8a81e675d7dcba73f92f128278795b102c510d11b0fa721',
          file_name:
            'audios/c8394c1d08e98490a8a81e675d7dcba73f92f128278795b102c510d11b0fa721.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c8394c1d08e98490a8a81e675d7dcba73f92f128278795b102c510d11b0fa721.mp3',
          name: 'BEG-INT-ADV-90_Degree_Lateral_Raises-EXERCISE',
          description: null,
          size: 32877,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-PELVIC_TILT_ON_STABILITY_BALL-EXERCISE': {
      id: 1182,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Pelvic Tilt on Stability Ball',
      short_name: 'Pelvic Tilt on Stability Ball',
      unique_name: 'BEGINNER-PELVIC_TILT_ON_STABILITY_BALL-EXERCISE',
      description:
        '1. Sit on a Stablilty Ball with your feet flat on the ground, hip width apart. Roll shoulders back, maintain tall posture and engage core. Inhale. \n2. Exhale and crunch your abdominals as you tilt your pelvis backward so your lumbar spine is in flexion. \n3. Inhale and return your spine to neutral to reset.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3174,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '70359ad59e22fa72040b1a89a374e837ad5abca11392e274ac48cf8342c0df28',
          file_name:
            'videos/70359ad59e22fa72040b1a89a374e837ad5abca11392e274ac48cf8342c0df28.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/70359ad59e22fa72040b1a89a374e837ad5abca11392e274ac48cf8342c0df28.mp4',
          name: 'BEG-INT-ADV-Pelvic_Tilt_on_Stability_Ball-EXERCISE',
          description: null,
          size: 67755,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3175,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '44adc9fa5c34779829bc8f3f9f290fa51ebdbf37e6ff72a692c796b91ae2438d',
          file_name:
            'audios/44adc9fa5c34779829bc8f3f9f290fa51ebdbf37e6ff72a692c796b91ae2438d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/44adc9fa5c34779829bc8f3f9f290fa51ebdbf37e6ff72a692c796b91ae2438d.mp3',
          name: 'BEG-INT-ADV-Pelvic_Tilt_on_Stability_Ball-EXERCISE',
          description: null,
          size: 30765,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PELVIC_TILT_ON_STABILITY_BALL-EXERCISE': {
      id: 1183,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Pelvic Tilt on Stability Ball',
      short_name: 'Pelvic Tilt on Stability Ball',
      unique_name: 'INTERMEDIATE-PELVIC_TILT_ON_STABILITY_BALL-EXERCISE',
      description:
        '1. Sit on a Stablilty Ball with your feet flat on the ground, hip width apart. Roll shoulders back, maintain tall posture and engage core. Inhale. \n2. Exhale and crunch your abdominals as you tilt your pelvis backward so your lumbar spine is in flexion. \n3. Inhale and return your spine to neutral to reset.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3176,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '70359ad59e22fa72040b1a89a374e837ad5abca11392e274ac48cf8342c0df28',
          file_name:
            'videos/70359ad59e22fa72040b1a89a374e837ad5abca11392e274ac48cf8342c0df28.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/70359ad59e22fa72040b1a89a374e837ad5abca11392e274ac48cf8342c0df28.mp4',
          name: 'BEG-INT-ADV-Pelvic_Tilt_on_Stability_Ball-EXERCISE',
          description: null,
          size: 67755,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3177,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '44adc9fa5c34779829bc8f3f9f290fa51ebdbf37e6ff72a692c796b91ae2438d',
          file_name:
            'audios/44adc9fa5c34779829bc8f3f9f290fa51ebdbf37e6ff72a692c796b91ae2438d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/44adc9fa5c34779829bc8f3f9f290fa51ebdbf37e6ff72a692c796b91ae2438d.mp3',
          name: 'BEG-INT-ADV-Pelvic_Tilt_on_Stability_Ball-EXERCISE',
          description: null,
          size: 30765,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PELVIC_TILT_ON_STABILITY_BALL-EXERCISE': {
      id: 1184,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Pelvic Tilt on Stability Ball',
      short_name: 'Pelvic Tilt on Stability Ball',
      unique_name: 'ADVANCED-PELVIC_TILT_ON_STABILITY_BALL-EXERCISE',
      description:
        '1. Sit on a Stablilty Ball with your feet flat on the ground, hip width apart. Roll shoulders back, maintain tall posture and engage core. Inhale. \n2. Exhale and crunch your abdominals as you tilt your pelvis backward so your lumbar spine is in flexion. \n3. Inhale and return your spine to neutral to reset.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3178,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '70359ad59e22fa72040b1a89a374e837ad5abca11392e274ac48cf8342c0df28',
          file_name:
            'videos/70359ad59e22fa72040b1a89a374e837ad5abca11392e274ac48cf8342c0df28.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/70359ad59e22fa72040b1a89a374e837ad5abca11392e274ac48cf8342c0df28.mp4',
          name: 'BEG-INT-ADV-Pelvic_Tilt_on_Stability_Ball-EXERCISE',
          description: null,
          size: 67755,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3179,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '44adc9fa5c34779829bc8f3f9f290fa51ebdbf37e6ff72a692c796b91ae2438d',
          file_name:
            'audios/44adc9fa5c34779829bc8f3f9f290fa51ebdbf37e6ff72a692c796b91ae2438d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/44adc9fa5c34779829bc8f3f9f290fa51ebdbf37e6ff72a692c796b91ae2438d.mp3',
          name: 'BEG-INT-ADV-Pelvic_Tilt_on_Stability_Ball-EXERCISE',
          description: null,
          size: 30765,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SINGLE_ARM_OVERHEAD_TRICEP_EXTENSION-EXERCISE': {
      id: 1185,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Single Arm Overhead Tricep Extension',
      short_name: 'Single Arm Overhead Tricep Extension',
      unique_name: 'BEGINNER-SINGLE_ARM_OVERHEAD_TRICEP_EXTENSION-EXERCISE',
      description:
        '1. Stand tall with feet hip-width apart. Hold a dumbbell in one hand overhead and bend your elbow so the weight is behind your head. Elbow pointed up and arm is tight to your ear. \n2. Straighten your arm and press the dumbbell straight overhead. \n3. With control, lower the dumbbell back down to start. Perform all reps and repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3180,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'fd54e7ce95237d74087c3dfd83577ebef10e37dcb1c68615fe644464a6f55d57',
          file_name:
            'videos/fd54e7ce95237d74087c3dfd83577ebef10e37dcb1c68615fe644464a6f55d57.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fd54e7ce95237d74087c3dfd83577ebef10e37dcb1c68615fe644464a6f55d57.mp4',
          name: 'BEG-INT-ADV-Single_Arm_Overhead_Tricep_Extension-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 64572,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3181,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '59970bfdab46316c34379a2b501311bad85e5296d2da849cb2b16b472a1afe9c',
          file_name:
            'videos/59970bfdab46316c34379a2b501311bad85e5296d2da849cb2b16b472a1afe9c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/59970bfdab46316c34379a2b501311bad85e5296d2da849cb2b16b472a1afe9c.mp4',
          name: 'BEG-INT-ADV-Single_Arm_Overhead_Tricep_Extension-EXERCISE-LEFT',
          description: 'Left Side',
          size: 67755,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3182,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '7674e39bea9679a0ac0aeb43afb3fdfdb6a2975f0ab40be608ac782ad22bc168',
          file_name:
            'audios/7674e39bea9679a0ac0aeb43afb3fdfdb6a2975f0ab40be608ac782ad22bc168.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7674e39bea9679a0ac0aeb43afb3fdfdb6a2975f0ab40be608ac782ad22bc168.mp3',
          name: 'BEG-INT-ADV-Single_Arm_Overhead_Tricep_Extension-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 37485,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SINGLE_ARM_OVERHEAD_TRICEP_EXTENSION-EXERCISE': {
      id: 1186,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Single Arm Overhead Tricep Extension',
      short_name: 'Single Arm Overhead Tricep Extension',
      unique_name: 'INTERMEDIATE-SINGLE_ARM_OVERHEAD_TRICEP_EXTENSION-EXERCISE',
      description:
        '1. Stand tall with feet hip-width apart. Hold a dumbbell in one hand overhead and bend your elbow so the weight is behind your head. Elbow pointed up and arm is tight to your ear. \n2. Straighten your arm and press the dumbbell straight overhead. \n3. With control, lower the dumbbell back down to start. Perform all reps and repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3183,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'fd54e7ce95237d74087c3dfd83577ebef10e37dcb1c68615fe644464a6f55d57',
          file_name:
            'videos/fd54e7ce95237d74087c3dfd83577ebef10e37dcb1c68615fe644464a6f55d57.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fd54e7ce95237d74087c3dfd83577ebef10e37dcb1c68615fe644464a6f55d57.mp4',
          name: 'BEG-INT-ADV-Single_Arm_Overhead_Tricep_Extension-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 64572,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3184,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '59970bfdab46316c34379a2b501311bad85e5296d2da849cb2b16b472a1afe9c',
          file_name:
            'videos/59970bfdab46316c34379a2b501311bad85e5296d2da849cb2b16b472a1afe9c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/59970bfdab46316c34379a2b501311bad85e5296d2da849cb2b16b472a1afe9c.mp4',
          name: 'BEG-INT-ADV-Single_Arm_Overhead_Tricep_Extension-EXERCISE-LEFT',
          description: 'Left Side',
          size: 67755,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3185,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '7674e39bea9679a0ac0aeb43afb3fdfdb6a2975f0ab40be608ac782ad22bc168',
          file_name:
            'audios/7674e39bea9679a0ac0aeb43afb3fdfdb6a2975f0ab40be608ac782ad22bc168.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7674e39bea9679a0ac0aeb43afb3fdfdb6a2975f0ab40be608ac782ad22bc168.mp3',
          name: 'BEG-INT-ADV-Single_Arm_Overhead_Tricep_Extension-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 37485,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SINGLE_ARM_OVERHEAD_TRICEP_EXTENSION-EXERCISE': {
      id: 1187,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Single Arm Overhead Tricep Extension',
      short_name: 'Single Arm Overhead Tricep Extension',
      unique_name: 'ADVANCED-SINGLE_ARM_OVERHEAD_TRICEP_EXTENSION-EXERCISE',
      description:
        '1. Stand tall with feet hip-width apart. Hold a dumbbell in one hand overhead and bend your elbow so the weight is behind your head. Elbow pointed up and arm is tight to your ear. \n2. Straighten your arm and press the dumbbell straight overhead. \n3. With control, lower the dumbbell back down to start. Perform all reps and repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3186,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'fd54e7ce95237d74087c3dfd83577ebef10e37dcb1c68615fe644464a6f55d57',
          file_name:
            'videos/fd54e7ce95237d74087c3dfd83577ebef10e37dcb1c68615fe644464a6f55d57.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fd54e7ce95237d74087c3dfd83577ebef10e37dcb1c68615fe644464a6f55d57.mp4',
          name: 'BEG-INT-ADV-Single_Arm_Overhead_Tricep_Extension-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 64572,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3187,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '59970bfdab46316c34379a2b501311bad85e5296d2da849cb2b16b472a1afe9c',
          file_name:
            'videos/59970bfdab46316c34379a2b501311bad85e5296d2da849cb2b16b472a1afe9c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/59970bfdab46316c34379a2b501311bad85e5296d2da849cb2b16b472a1afe9c.mp4',
          name: 'BEG-INT-ADV-Single_Arm_Overhead_Tricep_Extension-EXERCISE-LEFT',
          description: 'Left Side',
          size: 67755,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3188,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '7674e39bea9679a0ac0aeb43afb3fdfdb6a2975f0ab40be608ac782ad22bc168',
          file_name:
            'audios/7674e39bea9679a0ac0aeb43afb3fdfdb6a2975f0ab40be608ac782ad22bc168.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7674e39bea9679a0ac0aeb43afb3fdfdb6a2975f0ab40be608ac782ad22bc168.mp3',
          name: 'BEG-INT-ADV-Single_Arm_Overhead_Tricep_Extension-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 37485,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_FRONT_RAISE_NEUTRAL_GRIP-EXERCISE': {
      id: 1188,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Alternating Front Raise Neutral Grip',
      short_name: 'Alternating Front Raise Neutral Grip',
      unique_name: 'INTERMEDIATE-ALTERNATING_FRONT_RAISE_NEUTRAL_GRIP-EXERCISE',
      description:
        '1. Stand up tall and hold a dumbbell in each hand in front of your body. Palms face in. \n2. Roll shoulders back and raise one dumbbell in front of you to shoulder height. Keep arm straight. \n3. With control, lower the weight back down. \n4. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 10,
          unique_name: 'DELTS',
          name: 'Delts',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3189,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '811ad7aa981aa89de5070a1d0af26e4213437b684e7b1da953efe0233af87027',
          file_name:
            'videos/811ad7aa981aa89de5070a1d0af26e4213437b684e7b1da953efe0233af87027.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/811ad7aa981aa89de5070a1d0af26e4213437b684e7b1da953efe0233af87027.mp4',
          name: 'INT-ADV-Alternating_Front_Raise_Neutral_Grip-EXERCISE',
          description: null,
          size: 161889,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3190,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '3ec27b347aa0b50378da80a2a4cc26cc5914b243a49a3786395d4d733f33a5f6',
          file_name:
            'audios/3ec27b347aa0b50378da80a2a4cc26cc5914b243a49a3786395d4d733f33a5f6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3ec27b347aa0b50378da80a2a4cc26cc5914b243a49a3786395d4d733f33a5f6.mp3',
          name: 'INT-ADV-Alternating_Front_Raise_Neutral_Grip-EXERCISE',
          description: null,
          size: 35469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_FRONT_RAISE_NEUTRAL_GRIP-EXERCISE': {
      id: 1189,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Alternating Front Raise Neutral Grip',
      short_name: 'Alternating Front Raise Neutral Grip',
      unique_name: 'ADVANCED-ALTERNATING_FRONT_RAISE_NEUTRAL_GRIP-EXERCISE',
      description:
        '1. Stand up tall and hold a dumbbell in each hand in front of your body. Palms face in. \n2. Roll shoulders back and raise one dumbbell in front of you to shoulder height. Keep arm straight. \n3. With control, lower the weight back down. \n4. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 10,
          unique_name: 'DELTS',
          name: 'Delts',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3191,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '811ad7aa981aa89de5070a1d0af26e4213437b684e7b1da953efe0233af87027',
          file_name:
            'videos/811ad7aa981aa89de5070a1d0af26e4213437b684e7b1da953efe0233af87027.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/811ad7aa981aa89de5070a1d0af26e4213437b684e7b1da953efe0233af87027.mp4',
          name: 'INT-ADV-Alternating_Front_Raise_Neutral_Grip-EXERCISE',
          description: null,
          size: 161889,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3192,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '3ec27b347aa0b50378da80a2a4cc26cc5914b243a49a3786395d4d733f33a5f6',
          file_name:
            'audios/3ec27b347aa0b50378da80a2a4cc26cc5914b243a49a3786395d4d733f33a5f6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3ec27b347aa0b50378da80a2a4cc26cc5914b243a49a3786395d4d733f33a5f6.mp3',
          name: 'INT-ADV-Alternating_Front_Raise_Neutral_Grip-EXERCISE',
          description: null,
          size: 35469,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-CHEST_FLY_WITH_CRUNCH-_FEET_DOWN-EXERCISE': {
      id: 1190,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Chest Fly with Crunch - Feet Down',
      short_name: 'Chest Fly with Crunch - Feet Down',
      unique_name: 'INTERMEDIATE-CHEST_FLY_WITH_CRUNCH-_FEET_DOWN-EXERCISE',
      description:
        '1. Sit on the floor with both knees bent and feet on the floor. Hold a dumbbell in each hand in front of you, above your knees, elbows slightly bent. Roll shoulders back and engage your core. \n2. Straighten your legs, lower your body down to the floor and open your arms out to a "T". \n3. Bend both legs and crunch knees toward your chest as you sit up and fly both dumbbells together to start.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3193,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'de3d66277bf00d7d6d488265584f1ee0f1a4ee5b6d821243bed29700b51ef51e',
          file_name:
            'videos/de3d66277bf00d7d6d488265584f1ee0f1a4ee5b6d821243bed29700b51ef51e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/de3d66277bf00d7d6d488265584f1ee0f1a4ee5b6d821243bed29700b51ef51e.mp4',
          name: 'INT-ADV-Chest_Fly_with_Crunch_-_Feet_Down-EXERCISE',
          description: null,
          size: 123181,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3194,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'f9737206a49eaaa9436c2f79761963ac559073f413286d726dfe6f2beeeeb026',
          file_name:
            'audios/f9737206a49eaaa9436c2f79761963ac559073f413286d726dfe6f2beeeeb026.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f9737206a49eaaa9436c2f79761963ac559073f413286d726dfe6f2beeeeb026.mp3',
          name: 'INT-ADV-Chest_Fly_with_Crunch_-_Feet_Down-EXERCISE',
          description: null,
          size: 37197,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-CHEST_FLY_WITH_CRUNCH-_FEET_DOWN-EXERCISE': {
      id: 1191,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Chest Fly with Crunch - Feet Down',
      short_name: 'Chest Fly with Crunch - Feet Down',
      unique_name: 'ADVANCED-CHEST_FLY_WITH_CRUNCH-_FEET_DOWN-EXERCISE',
      description:
        '1. Sit on the floor with both knees bent and feet on the floor. Hold a dumbbell in each hand in front of you, above your knees, elbows slightly bent. Roll shoulders back and engage your core. \n2. Straighten your legs, lower your body down to the floor and open your arms out to a "T". \n3. Bend both legs and crunch knees toward your chest as you sit up and fly both dumbbells together to start.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3195,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'de3d66277bf00d7d6d488265584f1ee0f1a4ee5b6d821243bed29700b51ef51e',
          file_name:
            'videos/de3d66277bf00d7d6d488265584f1ee0f1a4ee5b6d821243bed29700b51ef51e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/de3d66277bf00d7d6d488265584f1ee0f1a4ee5b6d821243bed29700b51ef51e.mp4',
          name: 'INT-ADV-Chest_Fly_with_Crunch_-_Feet_Down-EXERCISE',
          description: null,
          size: 123181,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3196,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'f9737206a49eaaa9436c2f79761963ac559073f413286d726dfe6f2beeeeb026',
          file_name:
            'audios/f9737206a49eaaa9436c2f79761963ac559073f413286d726dfe6f2beeeeb026.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f9737206a49eaaa9436c2f79761963ac559073f413286d726dfe6f2beeeeb026.mp3',
          name: 'INT-ADV-Chest_Fly_with_Crunch_-_Feet_Down-EXERCISE',
          description: null,
          size: 37197,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-CHEST_FLY_WITH_CRUNCH-_FEET_UP-EXERCISE': {
      id: 1192,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Chest Fly with Crunch - Feet Up',
      short_name: 'Chest Fly with Crunch - Feet Up',
      unique_name: 'INTERMEDIATE-CHEST_FLY_WITH_CRUNCH-_FEET_UP-EXERCISE',
      description:
        '1. Sit with both knees bent and feet hovering off the floor. Hold a dumbbell in each hand in front of you, above your knees, elbows slightly bent. Engage your core and lean back slightly, balancing on sitsbones. \n2. Straighten both legs, lower your body down to the floor and open your arms out to a "T". Keep legs off the floor. \n3. Bend both legs and crunch knees toward your chest as you sit up and fly both dumbbells together to start.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3197,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'fa95a266f09d0c98183bba02db355677082e97174c19e061bf9115c0fb32f7ca',
          file_name:
            'videos/fa95a266f09d0c98183bba02db355677082e97174c19e061bf9115c0fb32f7ca.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fa95a266f09d0c98183bba02db355677082e97174c19e061bf9115c0fb32f7ca.mp4',
          name: 'INT-ADV-Chest_Fly_with_Crunch_-_Feet_Up-EXERCISE',
          description: null,
          size: 121807,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3198,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'de3c0f164f1125d4b4b1731893c0fa1f3bedffd9eabc9fefa7732cb341bb5453',
          file_name:
            'audios/de3c0f164f1125d4b4b1731893c0fa1f3bedffd9eabc9fefa7732cb341bb5453.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/de3c0f164f1125d4b4b1731893c0fa1f3bedffd9eabc9fefa7732cb341bb5453.mp3',
          name: 'INT-ADV-Chest_Fly_with_Crunch_-_Feet_Up-EXERCISE',
          description: null,
          size: 37197,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-CHEST_FLY_WITH_CRUNCH-_FEET_UP-EXERCISE': {
      id: 1193,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Chest Fly with Crunch - Feet Up',
      short_name: 'Chest Fly with Crunch - Feet Up',
      unique_name: 'ADVANCED-CHEST_FLY_WITH_CRUNCH-_FEET_UP-EXERCISE',
      description:
        '1. Sit with both knees bent and feet hovering off the floor. Hold a dumbbell in each hand in front of you, above your knees, elbows slightly bent. Engage your core and lean back slightly, balancing on sitsbones. \n2. Straighten both legs, lower your body down to the floor and open your arms out to a "T". Keep legs off the floor. \n3. Bend both legs and crunch knees toward your chest as you sit up and fly both dumbbells together to start.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3199,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'fa95a266f09d0c98183bba02db355677082e97174c19e061bf9115c0fb32f7ca',
          file_name:
            'videos/fa95a266f09d0c98183bba02db355677082e97174c19e061bf9115c0fb32f7ca.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fa95a266f09d0c98183bba02db355677082e97174c19e061bf9115c0fb32f7ca.mp4',
          name: 'INT-ADV-Chest_Fly_with_Crunch_-_Feet_Up-EXERCISE',
          description: null,
          size: 121807,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3200,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'de3c0f164f1125d4b4b1731893c0fa1f3bedffd9eabc9fefa7732cb341bb5453',
          file_name:
            'audios/de3c0f164f1125d4b4b1731893c0fa1f3bedffd9eabc9fefa7732cb341bb5453.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/de3c0f164f1125d4b4b1731893c0fa1f3bedffd9eabc9fefa7732cb341bb5453.mp3',
          name: 'INT-ADV-Chest_Fly_with_Crunch_-_Feet_Up-EXERCISE',
          description: null,
          size: 37197,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_GROUND_TO_OVERHEAD_SNATCH-EXERCISE': {
      id: 1194,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Ground to Overhead Snatch',
      short_name: 'Dumbbell Ground to Overhead Snatch',
      unique_name: 'INTERMEDIATE-DUMBBELL_GROUND_TO_OVERHEAD_SNATCH-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, holding one dumbbell down in front of you, palm facing your body. \n2. Hinge at your hips and bend your knees as you lower the dumbbell toward the floor. \n3. Drive through your heels and explosively stand as you bend your elbow and draw the dumbbell up your midline. \n4. When the dumbbell is past your hip, shrug your shoulder flip your palm and punch the dumbbell straight up overhead. Biceps by your ears. \n5. Bend your elbow and lower the dumbbell back down. String reps together. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3201,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '86e9821fd6b4ead50ed12d54fd9abc060a2c354513bcc7c7864bef7231eba664',
          file_name:
            'videos/86e9821fd6b4ead50ed12d54fd9abc060a2c354513bcc7c7864bef7231eba664.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86e9821fd6b4ead50ed12d54fd9abc060a2c354513bcc7c7864bef7231eba664.mp4',
          name: 'INT-ADV-Dumbbell_Ground_to_Overhead_Snatch-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 135464,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3202,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '42ec7bf3b6abe3dc4fc3774a648754b010519dd99e86bd888aab344015adba73',
          file_name:
            'videos/42ec7bf3b6abe3dc4fc3774a648754b010519dd99e86bd888aab344015adba73.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/42ec7bf3b6abe3dc4fc3774a648754b010519dd99e86bd888aab344015adba73.mp4',
          name: 'INT-ADV-Dumbbell_Ground_to_Overhead_Snatch-EXERCISE-LEFT',
          description: 'Left Side',
          size: 121204,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3203,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '88e62569e599e78b14c94051106a0f667019a0a68ade02ad55b0b268bc2df6c4',
          file_name:
            'audios/88e62569e599e78b14c94051106a0f667019a0a68ade02ad55b0b268bc2df6c4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/88e62569e599e78b14c94051106a0f667019a0a68ade02ad55b0b268bc2df6c4.mp3',
          name: 'INT-ADV-Dumbbell_Ground_to_Overhead_Snatch-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 37485,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_GROUND_TO_OVERHEAD_SNATCH-EXERCISE': {
      id: 1195,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Dumbbell Ground to Overhead Snatch',
      short_name: 'Dumbbell Ground to Overhead Snatch',
      unique_name: 'ADVANCED-DUMBBELL_GROUND_TO_OVERHEAD_SNATCH-EXERCISE',
      description:
        '1. Stand with your feet shoulder-width apart, holding one dumbbell down in front of you, palm facing your body. \n2. Hinge at your hips and bend your knees as you lower the dumbbell toward the floor. \n3. Drive through your heels and explosively stand as you bend your elbow and draw the dumbbell up your midline. \n4. When the dumbbell is past your hip, shrug your shoulder flip your palm and punch the dumbbell straight up overhead. Biceps by your ears. \n5. Bend your elbow and lower the dumbbell back down. String reps together. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3204,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '86e9821fd6b4ead50ed12d54fd9abc060a2c354513bcc7c7864bef7231eba664',
          file_name:
            'videos/86e9821fd6b4ead50ed12d54fd9abc060a2c354513bcc7c7864bef7231eba664.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86e9821fd6b4ead50ed12d54fd9abc060a2c354513bcc7c7864bef7231eba664.mp4',
          name: 'INT-ADV-Dumbbell_Ground_to_Overhead_Snatch-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 135464,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3205,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '42ec7bf3b6abe3dc4fc3774a648754b010519dd99e86bd888aab344015adba73',
          file_name:
            'videos/42ec7bf3b6abe3dc4fc3774a648754b010519dd99e86bd888aab344015adba73.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/42ec7bf3b6abe3dc4fc3774a648754b010519dd99e86bd888aab344015adba73.mp4',
          name: 'INT-ADV-Dumbbell_Ground_to_Overhead_Snatch-EXERCISE-LEFT',
          description: 'Left Side',
          size: 121204,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3206,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '88e62569e599e78b14c94051106a0f667019a0a68ade02ad55b0b268bc2df6c4',
          file_name:
            'audios/88e62569e599e78b14c94051106a0f667019a0a68ade02ad55b0b268bc2df6c4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/88e62569e599e78b14c94051106a0f667019a0a68ade02ad55b0b268bc2df6c4.mp3',
          name: 'INT-ADV-Dumbbell_Ground_to_Overhead_Snatch-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 37485,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-HALF_KNEELING_WINDMILL-EXERCISE': {
      id: 1196,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Half Kneeling Windmill',
      short_name: 'Half Kneeling Windmill',
      unique_name: 'INTERMEDIATE-HALF_KNEELING_WINDMILL-EXERCISE',
      description:
        '1. Start in a Half-Kneeling position. Hold a kettlebell in the same side arm as the lifted knee. Press bell straight up overhead, elbow by ear, palm faces out. \n2. Look up at the kettlebell, rotate your torso and lower your upperbody until the other hand touches the floor. Your arms should be in one straight line. \n3. Using core strength, raise your body back up to start.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3207,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'd81c7608f44848b3edfee77c0f49bad31495b281018e2401be03226451e01572',
          file_name:
            'videos/d81c7608f44848b3edfee77c0f49bad31495b281018e2401be03226451e01572.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d81c7608f44848b3edfee77c0f49bad31495b281018e2401be03226451e01572.mp4',
          name: 'INT-ADV-Half_Kneeling_Windmill-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 129803,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3208,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '30ec1dcd03d5ae876beeaba7614ee690b5b547236d54b8eb0bf365723e71d806',
          file_name:
            'videos/30ec1dcd03d5ae876beeaba7614ee690b5b547236d54b8eb0bf365723e71d806.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/30ec1dcd03d5ae876beeaba7614ee690b5b547236d54b8eb0bf365723e71d806.mp4',
          name: 'INT-ADV-Half_Kneeling_Windmill-EXERCISE-LEFT',
          description: 'Left Side',
          size: 109419,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3209,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'e6c88e11482801c51b2155a41c1aa4a845726c1526cd4821a944f3e6c170369d',
          file_name:
            'audios/e6c88e11482801c51b2155a41c1aa4a845726c1526cd4821a944f3e6c170369d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e6c88e11482801c51b2155a41c1aa4a845726c1526cd4821a944f3e6c170369d.mp3',
          name: 'INT-ADV-Half_Kneeling_Windmill-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-HALF_KNEELING_WINDMILL-EXERCISE': {
      id: 1197,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Half Kneeling Windmill',
      short_name: 'Half Kneeling Windmill',
      unique_name: 'ADVANCED-HALF_KNEELING_WINDMILL-EXERCISE',
      description:
        '1. Start in a Half-Kneeling position. Hold a kettlebell in the same side arm as the lifted knee. Press bell straight up overhead, elbow by ear, palm faces out. \n2. Look up at the kettlebell, rotate your torso and lower your upperbody until the other hand touches the floor. Your arms should be in one straight line. \n3. Using core strength, raise your body back up to start.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3210,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'd81c7608f44848b3edfee77c0f49bad31495b281018e2401be03226451e01572',
          file_name:
            'videos/d81c7608f44848b3edfee77c0f49bad31495b281018e2401be03226451e01572.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d81c7608f44848b3edfee77c0f49bad31495b281018e2401be03226451e01572.mp4',
          name: 'INT-ADV-Half_Kneeling_Windmill-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 129803,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3211,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '30ec1dcd03d5ae876beeaba7614ee690b5b547236d54b8eb0bf365723e71d806',
          file_name:
            'videos/30ec1dcd03d5ae876beeaba7614ee690b5b547236d54b8eb0bf365723e71d806.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/30ec1dcd03d5ae876beeaba7614ee690b5b547236d54b8eb0bf365723e71d806.mp4',
          name: 'INT-ADV-Half_Kneeling_Windmill-EXERCISE-LEFT',
          description: 'Left Side',
          size: 109419,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3212,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'e6c88e11482801c51b2155a41c1aa4a845726c1526cd4821a944f3e6c170369d',
          file_name:
            'audios/e6c88e11482801c51b2155a41c1aa4a845726c1526cd4821a944f3e6c170369d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e6c88e11482801c51b2155a41c1aa4a845726c1526cd4821a944f3e6c170369d.mp3',
          name: 'INT-ADV-Half_Kneeling_Windmill-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KETTLEBELL_HIP_HALO-EXERCISE': {
      id: 1198,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Kettlebell Hip Halo',
      short_name: 'Kettlebell Hip Halo',
      unique_name: 'INTERMEDIATE-KETTLEBELL_HIP_HALO-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, holding a kettlebell with both hands by one hip. \n2. Keeping your core engaged, raise the kettlebell across your body and rotate it in a circle around your head and back down to the opposite hip.\n3. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3213,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'eab84b250268129ffc843273b482078ac5f1928d02ccb17ce15a8a169c5748f4',
          file_name:
            'videos/eab84b250268129ffc843273b482078ac5f1928d02ccb17ce15a8a169c5748f4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eab84b250268129ffc843273b482078ac5f1928d02ccb17ce15a8a169c5748f4.mp4',
          name: 'INT-ADV-Kettlebell_Hip_Halo-EXERCISE',
          description: null,
          size: 256920,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3214,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '4d562fe0ad79c4f14c4f479d3b5dff70b3483143f8b542a380ff1073aef49a1a',
          file_name:
            'audios/4d562fe0ad79c4f14c4f479d3b5dff70b3483143f8b542a380ff1073aef49a1a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4d562fe0ad79c4f14c4f479d3b5dff70b3483143f8b542a380ff1073aef49a1a.mp3',
          name: 'INT-ADV-Kettlebell_Hip_Halo-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KETTLEBELL_HIP_HALO-EXERCISE': {
      id: 1199,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Kettlebell Hip Halo',
      short_name: 'Kettlebell Hip Halo',
      unique_name: 'ADVANCED-KETTLEBELL_HIP_HALO-EXERCISE',
      description:
        '1. Stand with your feet hip-width apart, holding a kettlebell with both hands by one hip. \n2. Keeping your core engaged, raise the kettlebell across your body and rotate it in a circle around your head and back down to the opposite hip.\n3. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3215,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'eab84b250268129ffc843273b482078ac5f1928d02ccb17ce15a8a169c5748f4',
          file_name:
            'videos/eab84b250268129ffc843273b482078ac5f1928d02ccb17ce15a8a169c5748f4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eab84b250268129ffc843273b482078ac5f1928d02ccb17ce15a8a169c5748f4.mp4',
          name: 'INT-ADV-Kettlebell_Hip_Halo-EXERCISE',
          description: null,
          size: 256920,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3216,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '4d562fe0ad79c4f14c4f479d3b5dff70b3483143f8b542a380ff1073aef49a1a',
          file_name:
            'audios/4d562fe0ad79c4f14c4f479d3b5dff70b3483143f8b542a380ff1073aef49a1a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4d562fe0ad79c4f14c4f479d3b5dff70b3483143f8b542a380ff1073aef49a1a.mp3',
          name: 'INT-ADV-Kettlebell_Hip_Halo-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KICKSTAND_CROSS_BODY_ROMAN_DEADLIFT-EXERCISE': {
      id: 1200,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Kickstand Cross Body Roman Deadlift',
      short_name: 'Kickstand Cross Body Roman Deadlift',
      unique_name: 'INTERMEDIATE-KICKSTAND_CROSS_BODY_ROMAN_DEADLIFT-EXERCISE',
      description:
        '1. Stand with feet hip-width apart. Take a small step back with one foot and lift your heel so you are in a staggard stance. Hold a kettlebell down by your side in the hand of the back leg. \n2. Transfer your weight to the front leg and hinge at the hips.\n3. Lower the kettlebell down and across the front leg until your body is parallel to the floor and the bell is outside your foot. \n4. Drive through the heel of your front leg, raise your torso up to start. \n5. Perform all reps on one side, repeat other leg.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3217,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'd7ae2253e72946ff7b13706b92237bfc6911dceb4ebdfabf3ce7d5919e0fa2c1',
          file_name:
            'videos/d7ae2253e72946ff7b13706b92237bfc6911dceb4ebdfabf3ce7d5919e0fa2c1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d7ae2253e72946ff7b13706b92237bfc6911dceb4ebdfabf3ce7d5919e0fa2c1.mp4',
          name: 'INT-ADV-Kickstand_Cross_Body_Roman_Deadlift-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 119883,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3218,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'a3d7f497096c6bc4c32660eb9c970a4c7823d6c7707a1411b4e554705e66c40c',
          file_name:
            'videos/a3d7f497096c6bc4c32660eb9c970a4c7823d6c7707a1411b4e554705e66c40c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a3d7f497096c6bc4c32660eb9c970a4c7823d6c7707a1411b4e554705e66c40c.mp4',
          name: 'INT-ADV-Kickstand_Cross_Body_Roman_Deadlift-EXERCISE-LEFT',
          description: 'Left Side',
          size: 148571,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3219,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'ba8001bc4e4478c4da3c88c043b2d7a7c7e0511bbd3e1a8f4a63ad74e7bfbc27',
          file_name:
            'audios/ba8001bc4e4478c4da3c88c043b2d7a7c7e0511bbd3e1a8f4a63ad74e7bfbc27.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ba8001bc4e4478c4da3c88c043b2d7a7c7e0511bbd3e1a8f4a63ad74e7bfbc27.mp3',
          name: 'INT-ADV-Kickstand_Cross_Body_Roman_Deadlift-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 38925,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KICKSTAND_CROSS_BODY_ROMAN_DEADLIFT-EXERCISE': {
      id: 1201,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Kickstand Cross Body Roman Deadlift',
      short_name: 'Kickstand Cross Body Roman Deadlift',
      unique_name: 'ADVANCED-KICKSTAND_CROSS_BODY_ROMAN_DEADLIFT-EXERCISE',
      description:
        '1. Stand with feet hip-width apart. Take a small step back with one foot and lift your heel so you are in a staggard stance. Hold a kettlebell down by your side in the hand of the back leg. \n2. Transfer your weight to the front leg and hinge at the hips.\n3. Lower the kettlebell down and across the front leg until your body is parallel to the floor and the bell is outside your foot. \n4. Drive through the heel of your front leg, raise your torso up to start. \n5. Perform all reps on one side, repeat other leg.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3220,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'd7ae2253e72946ff7b13706b92237bfc6911dceb4ebdfabf3ce7d5919e0fa2c1',
          file_name:
            'videos/d7ae2253e72946ff7b13706b92237bfc6911dceb4ebdfabf3ce7d5919e0fa2c1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d7ae2253e72946ff7b13706b92237bfc6911dceb4ebdfabf3ce7d5919e0fa2c1.mp4',
          name: 'INT-ADV-Kickstand_Cross_Body_Roman_Deadlift-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 119883,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3221,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'a3d7f497096c6bc4c32660eb9c970a4c7823d6c7707a1411b4e554705e66c40c',
          file_name:
            'videos/a3d7f497096c6bc4c32660eb9c970a4c7823d6c7707a1411b4e554705e66c40c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a3d7f497096c6bc4c32660eb9c970a4c7823d6c7707a1411b4e554705e66c40c.mp4',
          name: 'INT-ADV-Kickstand_Cross_Body_Roman_Deadlift-EXERCISE-LEFT',
          description: 'Left Side',
          size: 148571,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3222,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'ba8001bc4e4478c4da3c88c043b2d7a7c7e0511bbd3e1a8f4a63ad74e7bfbc27',
          file_name:
            'audios/ba8001bc4e4478c4da3c88c043b2d7a7c7e0511bbd3e1a8f4a63ad74e7bfbc27.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ba8001bc4e4478c4da3c88c043b2d7a7c7e0511bbd3e1a8f4a63ad74e7bfbc27.mp3',
          name: 'INT-ADV-Kickstand_Cross_Body_Roman_Deadlift-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 38925,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-INCLINED_CHEST_PRESS-EXERCISE': {
      id: 1202,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Inclined Chest Press',
      short_name: 'Inclined Chest Press',
      unique_name: 'INTERMEDIATE-INCLINED_CHEST_PRESS-EXERCISE',
      description:
        '1. Place your upper back on a stability ball in a reclined position, feet flat on the floor. Hold a dumbbell in each hand by your shoulders, palms face out, elbows wide and chin neutral. \n2. Straighten your arms and press the dumbbells over your chest.\n3. Squeeze your chest and lower the dumbbells to start position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3223,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '3b22a2687fd3cc626422f4f17f616996279482d609f34b332368644763a29c46',
          file_name:
            'videos/3b22a2687fd3cc626422f4f17f616996279482d609f34b332368644763a29c46.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3b22a2687fd3cc626422f4f17f616996279482d609f34b332368644763a29c46.mp4',
          name: 'INT-ADV-Inclined_Chest_Press-EXERCISE',
          description: null,
          size: 74367,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3224,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'a382003c043b42aa6a58e2edbe6da68583c7d8978e723a4120406ebb10fd448b',
          file_name:
            'audios/a382003c043b42aa6a58e2edbe6da68583c7d8978e723a4120406ebb10fd448b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a382003c043b42aa6a58e2edbe6da68583c7d8978e723a4120406ebb10fd448b.mp3',
          name: 'INT-ADV-Inclined_Chest_Press-EXERCISE',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-INCLINED_CHEST_PRESS-EXERCISE': {
      id: 1203,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Inclined Chest Press',
      short_name: 'Inclined Chest Press',
      unique_name: 'ADVANCED-INCLINED_CHEST_PRESS-EXERCISE',
      description:
        '1. Place your upper back on a stability ball in a reclined position, feet flat on the floor. Hold a dumbbell in each hand by your shoulders, palms face out, elbows wide and chin neutral. \n2. Straighten your arms and press the dumbbells over your chest.\n3. Squeeze your chest and lower the dumbbells to start position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3225,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '3b22a2687fd3cc626422f4f17f616996279482d609f34b332368644763a29c46',
          file_name:
            'videos/3b22a2687fd3cc626422f4f17f616996279482d609f34b332368644763a29c46.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3b22a2687fd3cc626422f4f17f616996279482d609f34b332368644763a29c46.mp4',
          name: 'INT-ADV-Inclined_Chest_Press-EXERCISE',
          description: null,
          size: 74367,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3226,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'a382003c043b42aa6a58e2edbe6da68583c7d8978e723a4120406ebb10fd448b',
          file_name:
            'audios/a382003c043b42aa6a58e2edbe6da68583c7d8978e723a4120406ebb10fd448b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a382003c043b42aa6a58e2edbe6da68583c7d8978e723a4120406ebb10fd448b.mp3',
          name: 'INT-ADV-Inclined_Chest_Press-EXERCISE',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SUPERMAN_PULLDOWN_WITH_ABDUCTION-EXERCISE': {
      id: 1204,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Superman Pulldown with Abduction',
      short_name: 'Superman Pulldown with Abduction',
      unique_name: 'INTERMEDIATE-SUPERMAN_PULLDOWN_WITH_ABDUCTION-EXERCISE',
      description:
        '1. Lie flat on your stomach, legs long and arms extended overhead. Place a stability ball in between your feet. \n2. Lift your legs and arms simultaneously off the ground. Bend both elbows toward your ribcage to engage your back and squeeze your legs together into the ball. Keep your neck in line with your spine and gaze toward the floor.\n3. Pause for a beat and return to starting position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3227,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '0565214e6295cb603ad719443eaa4911a16ca694ab4930b7fb1247aafd384d05',
          file_name:
            'videos/0565214e6295cb603ad719443eaa4911a16ca694ab4930b7fb1247aafd384d05.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0565214e6295cb603ad719443eaa4911a16ca694ab4930b7fb1247aafd384d05.mp4',
          name: 'INT-ADV-Superman_Pulldown_with_Abduction-EXERCISE',
          description: null,
          size: 124346,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3228,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '7d6f3c32a8a791dfdcb6b814993d4a6abfdf287e124e65a24a078848e22b7d79',
          file_name:
            'audios/7d6f3c32a8a791dfdcb6b814993d4a6abfdf287e124e65a24a078848e22b7d79.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7d6f3c32a8a791dfdcb6b814993d4a6abfdf287e124e65a24a078848e22b7d79.mp3',
          name: 'INT-ADV-Superman_Pulldown_with_Abduction-EXERCISE',
          description: null,
          size: 38601,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SUPERMAN_PULLDOWN_WITH_ABDUCTION-EXERCISE': {
      id: 1205,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Superman Pulldown with Abduction',
      short_name: 'Superman Pulldown with Abduction',
      unique_name: 'ADVANCED-SUPERMAN_PULLDOWN_WITH_ABDUCTION-EXERCISE',
      description:
        '1. Lie flat on your stomach, legs long and arms extended overhead. Place a stability ball in between your feet. \n2. Lift your legs and arms simultaneously off the ground. Bend both elbows toward your ribcage to engage your back and squeeze your legs together into the ball. Keep your neck in line with your spine and gaze toward the floor.\n3. Pause for a beat and return to starting position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3229,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '0565214e6295cb603ad719443eaa4911a16ca694ab4930b7fb1247aafd384d05',
          file_name:
            'videos/0565214e6295cb603ad719443eaa4911a16ca694ab4930b7fb1247aafd384d05.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0565214e6295cb603ad719443eaa4911a16ca694ab4930b7fb1247aafd384d05.mp4',
          name: 'INT-ADV-Superman_Pulldown_with_Abduction-EXERCISE',
          description: null,
          size: 124346,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3230,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '7d6f3c32a8a791dfdcb6b814993d4a6abfdf287e124e65a24a078848e22b7d79',
          file_name:
            'audios/7d6f3c32a8a791dfdcb6b814993d4a6abfdf287e124e65a24a078848e22b7d79.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7d6f3c32a8a791dfdcb6b814993d4a6abfdf287e124e65a24a078848e22b7d79.mp3',
          name: 'INT-ADV-Superman_Pulldown_with_Abduction-EXERCISE',
          description: null,
          size: 38601,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-STABILITY_BALL_LEG_EXTENSION-EXERCISE': {
      id: 1206,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Stability Ball Leg Extension',
      short_name: 'Stability Ball Leg Extension',
      unique_name: 'INTERMEDIATE-STABILITY_BALL_LEG_EXTENSION-EXERCISE',
      description:
        '1. Start in Bear Plank position with your hands on the floor, shoulders over wrists and both of your shins on top of a stability ball. Your knees are bent at 90 degrees. \n2. Brace your core and straighten your legs as your hips raise toward the ceiling into a pike. Keep your arms straight and squeeze your quads. \n3. With control, bend both knees to start position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3231,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '520d88f3db66758beacab20c351ea691f3f0ec0253caf44e038fca6dd1f881e9',
          file_name:
            'videos/520d88f3db66758beacab20c351ea691f3f0ec0253caf44e038fca6dd1f881e9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/520d88f3db66758beacab20c351ea691f3f0ec0253caf44e038fca6dd1f881e9.mp4',
          name: 'INT-ADV-Stability_Ball_Leg_Extension-EXERCISE',
          description: null,
          size: 120160,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3232,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '06fa581175e99df30e60a6a452c02d028f670ce8f40cfead61f0b606638520d1',
          file_name:
            'audios/06fa581175e99df30e60a6a452c02d028f670ce8f40cfead61f0b606638520d1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/06fa581175e99df30e60a6a452c02d028f670ce8f40cfead61f0b606638520d1.mp3',
          name: 'INT-ADV-Stability_Ball_Leg_Extension-EXERCISE',
          description: null,
          size: 32877,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-STABILITY_BALL_LEG_EXTENSION-EXERCISE': {
      id: 1207,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Stability Ball Leg Extension',
      short_name: 'Stability Ball Leg Extension',
      unique_name: 'ADVANCED-STABILITY_BALL_LEG_EXTENSION-EXERCISE',
      description:
        '1. Start in Bear Plank position with your hands on the floor, shoulders over wrists and both of your shins on top of a stability ball. Your knees are bent at 90 degrees. \n2. Brace your core and straighten your legs as your hips raise toward the ceiling into a pike. Keep your arms straight and squeeze your quads. \n3. With control, bend both knees to start position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3233,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '520d88f3db66758beacab20c351ea691f3f0ec0253caf44e038fca6dd1f881e9',
          file_name:
            'videos/520d88f3db66758beacab20c351ea691f3f0ec0253caf44e038fca6dd1f881e9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/520d88f3db66758beacab20c351ea691f3f0ec0253caf44e038fca6dd1f881e9.mp4',
          name: 'INT-ADV-Stability_Ball_Leg_Extension-EXERCISE',
          description: null,
          size: 120160,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3234,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '06fa581175e99df30e60a6a452c02d028f670ce8f40cfead61f0b606638520d1',
          file_name:
            'audios/06fa581175e99df30e60a6a452c02d028f670ce8f40cfead61f0b606638520d1.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/06fa581175e99df30e60a6a452c02d028f670ce8f40cfead61f0b606638520d1.mp3',
          name: 'INT-ADV-Stability_Ball_Leg_Extension-EXERCISE',
          description: null,
          size: 32877,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SINGLE_ARM_OFFSET_BENCH_PRESS-EXERCISE': {
      id: 1208,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Single Arm Offset Bench Press',
      short_name: 'Single Arm Offset Bench Press',
      unique_name: 'INTERMEDIATE-SINGLE_ARM_OFFSET_BENCH_PRESS-EXERCISE',
      description:
        '1. Place your upper back on the bench, just below your shoulder blades. Keep your hips up, knees bent at 90 degrees and your feet flat on the floor. Hold one dumbbell with your elbow bent at 90 degrees, upper arm resting on the bench, palm facing out. \n2. Shrug your shoulders down and press the dumbbell up over your shoulder. \n4. Squeeze your chest and bring dumbbell back to start position. Perform all reps on one side. Repeat other arm.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3235,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '84d503e7fa1ec7420c8b36e2a1ab856fe19cca3731134c53b1ad91b5a54b7a25',
          file_name:
            'videos/84d503e7fa1ec7420c8b36e2a1ab856fe19cca3731134c53b1ad91b5a54b7a25.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/84d503e7fa1ec7420c8b36e2a1ab856fe19cca3731134c53b1ad91b5a54b7a25.mp4',
          name: 'INT-ADV-Single_Arm_Offset_Bench_Press-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 53680,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3236,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'eeef1f0d5c58df4a439ea6e735e3ef01b18847a5782418254ae70187e55a27ec',
          file_name:
            'videos/eeef1f0d5c58df4a439ea6e735e3ef01b18847a5782418254ae70187e55a27ec.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eeef1f0d5c58df4a439ea6e735e3ef01b18847a5782418254ae70187e55a27ec.mp4',
          name: 'INT-ADV-Single_Arm_Offset_Bench_Press-EXERCISE-LEFT',
          description: 'Left Side',
          size: 56517,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3237,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '87bb193922f76a9fa294aec9890c006d4196eeb9bc13e69c80a27f2d4a52d601',
          file_name:
            'audios/87bb193922f76a9fa294aec9890c006d4196eeb9bc13e69c80a27f2d4a52d601.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/87bb193922f76a9fa294aec9890c006d4196eeb9bc13e69c80a27f2d4a52d601.mp3',
          name: 'INT-ADV-Single_Arm_Offset_Bench_Press-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 37485,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SINGLE_ARM_OFFSET_BENCH_PRESS-EXERCISE': {
      id: 1209,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Single Arm Offset Bench Press',
      short_name: 'Single Arm Offset Bench Press',
      unique_name: 'ADVANCED-SINGLE_ARM_OFFSET_BENCH_PRESS-EXERCISE',
      description:
        '1. Place your upper back on the bench, just below your shoulder blades. Keep your hips up, knees bent at 90 degrees and your feet flat on the floor. Hold one dumbbell with your elbow bent at 90 degrees, upper arm resting on the bench, palm facing out. \n2. Shrug your shoulders down and press the dumbbell up over your shoulder. \n4. Squeeze your chest and bring dumbbell back to start position. Perform all reps on one side. Repeat other arm.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3238,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '84d503e7fa1ec7420c8b36e2a1ab856fe19cca3731134c53b1ad91b5a54b7a25',
          file_name:
            'videos/84d503e7fa1ec7420c8b36e2a1ab856fe19cca3731134c53b1ad91b5a54b7a25.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/84d503e7fa1ec7420c8b36e2a1ab856fe19cca3731134c53b1ad91b5a54b7a25.mp4',
          name: 'INT-ADV-Single_Arm_Offset_Bench_Press-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 53680,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3239,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'eeef1f0d5c58df4a439ea6e735e3ef01b18847a5782418254ae70187e55a27ec',
          file_name:
            'videos/eeef1f0d5c58df4a439ea6e735e3ef01b18847a5782418254ae70187e55a27ec.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eeef1f0d5c58df4a439ea6e735e3ef01b18847a5782418254ae70187e55a27ec.mp4',
          name: 'INT-ADV-Single_Arm_Offset_Bench_Press-EXERCISE-LEFT',
          description: 'Left Side',
          size: 56517,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3240,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '87bb193922f76a9fa294aec9890c006d4196eeb9bc13e69c80a27f2d4a52d601',
          file_name:
            'audios/87bb193922f76a9fa294aec9890c006d4196eeb9bc13e69c80a27f2d4a52d601.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/87bb193922f76a9fa294aec9890c006d4196eeb9bc13e69c80a27f2d4a52d601.mp3',
          name: 'INT-ADV-Single_Arm_Offset_Bench_Press-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 37485,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PIKED_PUSH_UPS-EXERCISE': {
      id: 1210,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Piked Push Ups',
      short_name: 'Piked Push Ups',
      unique_name: 'INTERMEDIATE-PIKED_PUSH_UPS-EXERCISE',
      description:
        '1. Start in Down Dog position. \n2. Keep your hips up, chin tucked and ears aligned with the pits of your elbows.\n3. Bend your elbows and bring the crown of your head down as far as you can, aiming for the center of your hands.\n4. Push through your palms to extend arms and body back up to start position',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3241,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '810788130a602bc42c660d2e150b704a7b17aec69afdf929c09959f2039c5c83',
          file_name:
            'videos/810788130a602bc42c660d2e150b704a7b17aec69afdf929c09959f2039c5c83.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/810788130a602bc42c660d2e150b704a7b17aec69afdf929c09959f2039c5c83.mp4',
          name: 'INT-ADV-Piked_Push_Ups-EXERCISE',
          description: null,
          size: 80648,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3242,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'a7c7ce9f1811cf8818538ccf5f86cde72b8631c3c2657a8f4368e93d374aeac7',
          file_name:
            'audios/a7c7ce9f1811cf8818538ccf5f86cde72b8631c3c2657a8f4368e93d374aeac7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a7c7ce9f1811cf8818538ccf5f86cde72b8631c3c2657a8f4368e93d374aeac7.mp3',
          name: 'INT-ADV-Piked_Push_Ups-EXERCISE',
          description: null,
          size: 13758,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PIKED_PUSH_UPS-EXERCISE': {
      id: 1211,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Piked Push Ups',
      short_name: 'Piked Push Ups',
      unique_name: 'ADVANCED-PIKED_PUSH_UPS-EXERCISE',
      description:
        '1. Start in Down Dog position. \n2. Keep your hips up, chin tucked and ears aligned with the pits of your elbows.\n3. Bend your elbows and bring the crown of your head down as far as you can, aiming for the center of your hands.\n4. Push through your palms to extend arms and body back up to start position',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3243,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '810788130a602bc42c660d2e150b704a7b17aec69afdf929c09959f2039c5c83',
          file_name:
            'videos/810788130a602bc42c660d2e150b704a7b17aec69afdf929c09959f2039c5c83.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/810788130a602bc42c660d2e150b704a7b17aec69afdf929c09959f2039c5c83.mp4',
          name: 'INT-ADV-Piked_Push_Ups-EXERCISE',
          description: null,
          size: 80648,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3244,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'a7c7ce9f1811cf8818538ccf5f86cde72b8631c3c2657a8f4368e93d374aeac7',
          file_name:
            'audios/a7c7ce9f1811cf8818538ccf5f86cde72b8631c3c2657a8f4368e93d374aeac7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a7c7ce9f1811cf8818538ccf5f86cde72b8631c3c2657a8f4368e93d374aeac7.mp3',
          name: 'INT-ADV-Piked_Push_Ups-EXERCISE',
          description: null,
          size: 13758,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-INCLINE_CHEST_FLY-EXERCISE': {
      id: 1212,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Incline Chest Fly',
      short_name: 'Incline Chest Fly',
      unique_name: 'INTERMEDIATE-INCLINE_CHEST_FLY-EXERCISE',
      description:
        '1. Place your upper back on a stability ball in a reclined position, feet flat on the floor. Hold a dumbbell in each hand.\n2. Raise dumbbells over your shoulders, palms in. Shrug shoulders down and bend your elbows slightly in a fixed position.\n3. Open your arms and lower dumbbells out to the side in a "T". \n4. Squeeze your chest and bring dumbbells to start position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3245,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '86ede42711c6cfea7f77db893fee3787260c85cb61d7ca570735113007ee855b',
          file_name:
            'videos/86ede42711c6cfea7f77db893fee3787260c85cb61d7ca570735113007ee855b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86ede42711c6cfea7f77db893fee3787260c85cb61d7ca570735113007ee855b.mp4',
          name: 'INT-ADV-Incline_Chest_Fly-EXERCISE',
          description: null,
          size: 88467,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3246,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'eb4d45373addf180077142f41d548417fd70eb0815f54d74de825261be6a991a',
          file_name:
            'audios/eb4d45373addf180077142f41d548417fd70eb0815f54d74de825261be6a991a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eb4d45373addf180077142f41d548417fd70eb0815f54d74de825261be6a991a.mp3',
          name: 'INT-ADV-Incline_Chest_Fly-EXERCISE',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-INCLINE_CHEST_FLY-EXERCISE': {
      id: 1213,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Incline Chest Fly',
      short_name: 'Incline Chest Fly',
      unique_name: 'ADVANCED-INCLINE_CHEST_FLY-EXERCISE',
      description:
        '1. Place your upper back on a stability ball in a reclined position, feet flat on the floor. Hold a dumbbell in each hand.\n2. Raise dumbbells over your shoulders, palms in. Shrug shoulders down and bend your elbows slightly in a fixed position.\n3. Open your arms and lower dumbbells out to the side in a "T". \n4. Squeeze your chest and bring dumbbells to start position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3247,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '86ede42711c6cfea7f77db893fee3787260c85cb61d7ca570735113007ee855b',
          file_name:
            'videos/86ede42711c6cfea7f77db893fee3787260c85cb61d7ca570735113007ee855b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/86ede42711c6cfea7f77db893fee3787260c85cb61d7ca570735113007ee855b.mp4',
          name: 'INT-ADV-Incline_Chest_Fly-EXERCISE',
          description: null,
          size: 88467,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3248,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'eb4d45373addf180077142f41d548417fd70eb0815f54d74de825261be6a991a',
          file_name:
            'audios/eb4d45373addf180077142f41d548417fd70eb0815f54d74de825261be6a991a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eb4d45373addf180077142f41d548417fd70eb0815f54d74de825261be6a991a.mp3',
          name: 'INT-ADV-Incline_Chest_Fly-EXERCISE',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-STABILITY_BALL_HIP_THRUST-EXERCISE': {
      id: 1214,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Stability Ball Hip Thrust',
      short_name: 'Stability Ball Hip Thrust',
      unique_name: 'INTERMEDIATE-STABILITY_BALL_HIP_THRUST-EXERCISE',
      description:
        '1. Place your upper back on a stability ball in a reclined position. Keep feet on the floor, hip-width apart under your knees, arms crossed at chest. \n2. Keep core tight and chin slightly tucked. Drive through your heels to push hips up until your thighs and shins are at 90 degrees.\n3. Lower your hips back down.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3249,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '349d8f0addf5a58bd9b919d646affb733178b4e424de98fc301035b0f35097df',
          file_name:
            'videos/349d8f0addf5a58bd9b919d646affb733178b4e424de98fc301035b0f35097df.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/349d8f0addf5a58bd9b919d646affb733178b4e424de98fc301035b0f35097df.mp4',
          name: 'INT-ADV-Stability_Ball_Hip_Thrust-EXERCISE',
          description: null,
          size: 90365,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3250,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '60c97ecc17d37ba5edd52437877d9fa06d6ea532c07ab707edd61bfa2c6132f0',
          file_name:
            'audios/60c97ecc17d37ba5edd52437877d9fa06d6ea532c07ab707edd61bfa2c6132f0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/60c97ecc17d37ba5edd52437877d9fa06d6ea532c07ab707edd61bfa2c6132f0.mp3',
          name: 'INT-ADV-Stability_Ball_Hip_Thrust-EXERCISE',
          description: null,
          size: 21645,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-STABILITY_BALL_HIP_THRUST-EXERCISE': {
      id: 1215,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Stability Ball Hip Thrust',
      short_name: 'Stability Ball Hip Thrust',
      unique_name: 'ADVANCED-STABILITY_BALL_HIP_THRUST-EXERCISE',
      description:
        '1. Place your upper back on a stability ball in a reclined position. Keep feet on the floor, hip-width apart under your knees, arms crossed at chest. \n2. Keep core tight and chin slightly tucked. Drive through your heels to push hips up until your thighs and shins are at 90 degrees.\n3. Lower your hips back down.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 6,
          name: 'Stability Ball',
          unique_name: 'STABILITY_BALL',
          min_app_version: 100070000,
          order: 5000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3251,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '349d8f0addf5a58bd9b919d646affb733178b4e424de98fc301035b0f35097df',
          file_name:
            'videos/349d8f0addf5a58bd9b919d646affb733178b4e424de98fc301035b0f35097df.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/349d8f0addf5a58bd9b919d646affb733178b4e424de98fc301035b0f35097df.mp4',
          name: 'INT-ADV-Stability_Ball_Hip_Thrust-EXERCISE',
          description: null,
          size: 90365,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3252,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '60c97ecc17d37ba5edd52437877d9fa06d6ea532c07ab707edd61bfa2c6132f0',
          file_name:
            'audios/60c97ecc17d37ba5edd52437877d9fa06d6ea532c07ab707edd61bfa2c6132f0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/60c97ecc17d37ba5edd52437877d9fa06d6ea532c07ab707edd61bfa2c6132f0.mp3',
          name: 'INT-ADV-Stability_Ball_Hip_Thrust-EXERCISE',
          description: null,
          size: 21645,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_FLY_TO_CRUSH_PRESS-EXERCISE': {
      id: 1216,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Fly to Crush Press',
      short_name: 'Dumbbell Fly to Crush Press',
      unique_name: 'INTERMEDIATE-DUMBBELL_FLY_TO_CRUSH_PRESS-EXERCISE',
      description:
        '1. Lie on a bench with a dumbbell in each hand and your feet flat on the floor.\n2. Raise dumbbells above your chest, palms in. Shrug shoulders down and bend your elbows slightly in a fixed position.\n3. Open your arms and lower dumbbells out to the side aiming for parallel with the floor.\n4. Squeeze your chest and bring dumbbells together in start position. \n5. Press dumbbells together, bend both elbows and lower the dumbbells to your chest.\n6. Press dumbbells back up to start position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3253,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '5d4c0fc1477026e7723d23d3cae89e3978d04203abff0d1c6a2ed3a5e37e7af4',
          file_name:
            'videos/5d4c0fc1477026e7723d23d3cae89e3978d04203abff0d1c6a2ed3a5e37e7af4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5d4c0fc1477026e7723d23d3cae89e3978d04203abff0d1c6a2ed3a5e37e7af4.mp4',
          name: 'INT-ADV-Dumbbell_Fly_to_Crush_Press-EXERCISE',
          description: null,
          size: 136809,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3254,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '93235238b2a9a1c794e0585a841cb7954cc3034db790e96060f9412a54e2fa33',
          file_name:
            'audios/93235238b2a9a1c794e0585a841cb7954cc3034db790e96060f9412a54e2fa33.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/93235238b2a9a1c794e0585a841cb7954cc3034db790e96060f9412a54e2fa33.mp3',
          name: 'INT-ADV-Dumbbell_Fly_to_Crush_Press-EXERCISE',
          description: null,
          size: 34317,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_FLY_TO_CRUSH_PRESS-EXERCISE': {
      id: 1217,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Fly to Crush Press',
      short_name: 'Dumbbell Fly to Crush Press',
      unique_name: 'ADVANCED-DUMBBELL_FLY_TO_CRUSH_PRESS-EXERCISE',
      description:
        '1. Lie on a bench with a dumbbell in each hand and your feet flat on the floor.\n2. Raise dumbbells above your chest, palms in. Shrug shoulders down and bend your elbows slightly in a fixed position.\n3. Open your arms and lower dumbbells out to the side aiming for parallel with the floor.\n4. Squeeze your chest and bring dumbbells together in start position. \n5. Press dumbbells together, bend both elbows and lower the dumbbells to your chest.\n6. Press dumbbells back up to start position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3255,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '5d4c0fc1477026e7723d23d3cae89e3978d04203abff0d1c6a2ed3a5e37e7af4',
          file_name:
            'videos/5d4c0fc1477026e7723d23d3cae89e3978d04203abff0d1c6a2ed3a5e37e7af4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5d4c0fc1477026e7723d23d3cae89e3978d04203abff0d1c6a2ed3a5e37e7af4.mp4',
          name: 'INT-ADV-Dumbbell_Fly_to_Crush_Press-EXERCISE',
          description: null,
          size: 136809,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3256,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '93235238b2a9a1c794e0585a841cb7954cc3034db790e96060f9412a54e2fa33',
          file_name:
            'audios/93235238b2a9a1c794e0585a841cb7954cc3034db790e96060f9412a54e2fa33.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/93235238b2a9a1c794e0585a841cb7954cc3034db790e96060f9412a54e2fa33.mp3',
          name: 'INT-ADV-Dumbbell_Fly_to_Crush_Press-EXERCISE',
          description: null,
          size: 34317,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_CRUSH_GRIP_BENCH_PRESS-EXERCISE': {
      id: 1218,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Crush Grip Bench Press',
      short_name: 'Dumbbell Crush Grip Bench Press',
      unique_name: 'INTERMEDIATE-DUMBBELL_CRUSH_GRIP_BENCH_PRESS-EXERCISE',
      description:
        '1. Lie on a bench with a dumbbell in each hand by your hips and your feet flat on the floor. Allow for a natural curve in your lower back.\n2. Keep your fists toward each other and crush dumbbells together. Shrug your shoulders down "into your back pockets".\n3. Straighten your arms and raise the dumbbells above your chest. \n4. Bend your elbows, and lower the dumbbells to your sternum, keeping close to sides.\n5. Press dumbbells back up to start position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3257,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '3c251a5ce407a2155129272d0e44a7105879f949bc66c37e1fbc67b117456525',
          file_name:
            'videos/3c251a5ce407a2155129272d0e44a7105879f949bc66c37e1fbc67b117456525.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3c251a5ce407a2155129272d0e44a7105879f949bc66c37e1fbc67b117456525.mp4',
          name: 'INT-ADV-Dumbbell_Crush_Grip_Bench_Press-EXERCISE',
          description: null,
          size: 59028,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3258,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'ce1df6f5281cf9235a2998bca0858ed389e45eb72df6d97090b9295feab332c6',
          file_name:
            'audios/ce1df6f5281cf9235a2998bca0858ed389e45eb72df6d97090b9295feab332c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ce1df6f5281cf9235a2998bca0858ed389e45eb72df6d97090b9295feab332c6.mp3',
          name: 'INT-ADV-Dumbbell_Crush_Grip_Bench_Press-EXERCISE',
          description: null,
          size: 32301,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_CRUSH_GRIP_BENCH_PRESS-EXERCISE': {
      id: 1219,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Crush Grip Bench Press',
      short_name: 'Dumbbell Crush Grip Bench Press',
      unique_name: 'ADVANCED-DUMBBELL_CRUSH_GRIP_BENCH_PRESS-EXERCISE',
      description:
        '1. Lie on a bench with a dumbbell in each hand by your hips and your feet flat on the floor. Allow for a natural curve in your lower back.\n2. Keep your fists toward each other and crush dumbbells together. Shrug your shoulders down "into your back pockets".\n3. Straighten your arms and raise the dumbbells above your chest. \n4. Bend your elbows, and lower the dumbbells to your sternum, keeping close to sides.\n5. Press dumbbells back up to start position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3259,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '3c251a5ce407a2155129272d0e44a7105879f949bc66c37e1fbc67b117456525',
          file_name:
            'videos/3c251a5ce407a2155129272d0e44a7105879f949bc66c37e1fbc67b117456525.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3c251a5ce407a2155129272d0e44a7105879f949bc66c37e1fbc67b117456525.mp4',
          name: 'INT-ADV-Dumbbell_Crush_Grip_Bench_Press-EXERCISE',
          description: null,
          size: 59028,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3260,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'ce1df6f5281cf9235a2998bca0858ed389e45eb72df6d97090b9295feab332c6',
          file_name:
            'audios/ce1df6f5281cf9235a2998bca0858ed389e45eb72df6d97090b9295feab332c6.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/ce1df6f5281cf9235a2998bca0858ed389e45eb72df6d97090b9295feab332c6.mp3',
          name: 'INT-ADV-Dumbbell_Crush_Grip_Bench_Press-EXERCISE',
          description: null,
          size: 32301,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DECLINE_PUSH_UPS-EXERCISE': {
      id: 1220,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Decline Push Ups',
      short_name: 'Decline Push Ups',
      unique_name: 'INTERMEDIATE-DECLINE_PUSH_UPS-EXERCISE',
      description:
        '1. Start in decline Plank position. Place feet on the end of a step, legs extended and hands on floor, shoulders over wrists. \n2. Bend your elbows, pointing them back toward your hips and lower your body toward the floor.\n3. Straighten your arms and raise your body back up in one long line from the crown of your head to your tailbone.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3261,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'c2c2ead663b02d929e3ca9ca6e832f7d14e566e0ecabf94c3818120be74e1a20',
          file_name:
            'videos/c2c2ead663b02d929e3ca9ca6e832f7d14e566e0ecabf94c3818120be74e1a20.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c2c2ead663b02d929e3ca9ca6e832f7d14e566e0ecabf94c3818120be74e1a20.mp4',
          name: 'INT-ADV-Decline_Push_Ups-EXERCISE',
          description: null,
          size: 75834,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3262,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '2e828cbb206bac2512941a0c76c89e86b165047ddb4c75e2e0975907003f0daf',
          file_name:
            'audios/2e828cbb206bac2512941a0c76c89e86b165047ddb4c75e2e0975907003f0daf.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2e828cbb206bac2512941a0c76c89e86b165047ddb4c75e2e0975907003f0daf.mp3',
          name: 'INT-ADV-Decline_Push_Ups-EXERCISE',
          description: null,
          size: 25965,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DECLINE_PUSH_UPS-EXERCISE': {
      id: 1221,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Decline Push Ups',
      short_name: 'Decline Push Ups',
      unique_name: 'ADVANCED-DECLINE_PUSH_UPS-EXERCISE',
      description:
        '1. Start in decline Plank position. Place feet on the end of a step, legs extended and hands on floor, shoulders over wrists. \n2. Bend your elbows, pointing them back toward your hips and lower your body toward the floor.\n3. Straighten your arms and raise your body back up in one long line from the crown of your head to your tailbone.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 2,
          name: 'Bench',
          unique_name: 'BENCH',
          min_app_version: 100020005,
          order: 6000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3263,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'c2c2ead663b02d929e3ca9ca6e832f7d14e566e0ecabf94c3818120be74e1a20',
          file_name:
            'videos/c2c2ead663b02d929e3ca9ca6e832f7d14e566e0ecabf94c3818120be74e1a20.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c2c2ead663b02d929e3ca9ca6e832f7d14e566e0ecabf94c3818120be74e1a20.mp4',
          name: 'INT-ADV-Decline_Push_Ups-EXERCISE',
          description: null,
          size: 75834,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3264,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '2e828cbb206bac2512941a0c76c89e86b165047ddb4c75e2e0975907003f0daf',
          file_name:
            'audios/2e828cbb206bac2512941a0c76c89e86b165047ddb4c75e2e0975907003f0daf.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2e828cbb206bac2512941a0c76c89e86b165047ddb4c75e2e0975907003f0daf.mp3',
          name: 'INT-ADV-Decline_Push_Ups-EXERCISE',
          description: null,
          size: 25965,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SPIDER_GOBLET_SQUAT-EXERCISE': {
      id: 1222,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Spider Goblet Squat',
      short_name: 'Spider Goblet Squat',
      unique_name: 'INTERMEDIATE-SPIDER_GOBLET_SQUAT-EXERCISE',
      description:
        '1. Stand with your feet slightly wider than shoulder-width apart and hold a single dumbbell in front of your chest with both hands.\n2. Keeping your chest up and shoulders back, squat as low as possible trying to touch the outside of your elbows with the inside of your knee.\n3. Straighten legs to stand, transfer all weight to one foot and raise the other knee to hip height. \n4. Return foot to floor and immediately squat again and repeat with the other knee. Right and left is one rep',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3265,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'a565db932fc8224775887e6a030558d54779aac65f2b73eef77c040d49f3fca1',
          file_name:
            'videos/a565db932fc8224775887e6a030558d54779aac65f2b73eef77c040d49f3fca1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a565db932fc8224775887e6a030558d54779aac65f2b73eef77c040d49f3fca1.mp4',
          name: 'INT-ADV-Spider_Goblet_Squat-EXERCISE',
          description: null,
          size: 189378,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3266,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '2500d39cada71c26b3220b7e9a049e3973dfa32abc332ab2835de62dd3318f67',
          file_name:
            'audios/2500d39cada71c26b3220b7e9a049e3973dfa32abc332ab2835de62dd3318f67.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2500d39cada71c26b3220b7e9a049e3973dfa32abc332ab2835de62dd3318f67.mp3',
          name: 'INT-ADV-Spider_Goblet_Squat-EXERCISE',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SPIDER_GOBLET_SQUAT-EXERCISE': {
      id: 1223,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Spider Goblet Squat',
      short_name: 'Spider Goblet Squat',
      unique_name: 'ADVANCED-SPIDER_GOBLET_SQUAT-EXERCISE',
      description:
        '1. Stand with your feet slightly wider than shoulder-width apart and hold a single dumbbell in front of your chest with both hands.\n2. Keeping your chest up and shoulders back, squat as low as possible trying to touch the outside of your elbows with the inside of your knee.\n3. Straighten legs to stand, transfer all weight to one foot and raise the other knee to hip height. \n4. Return foot to floor and immediately squat again and repeat with the other knee. Right and left is one rep',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3267,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'a565db932fc8224775887e6a030558d54779aac65f2b73eef77c040d49f3fca1',
          file_name:
            'videos/a565db932fc8224775887e6a030558d54779aac65f2b73eef77c040d49f3fca1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a565db932fc8224775887e6a030558d54779aac65f2b73eef77c040d49f3fca1.mp4',
          name: 'INT-ADV-Spider_Goblet_Squat-EXERCISE',
          description: null,
          size: 189378,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3268,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '2500d39cada71c26b3220b7e9a049e3973dfa32abc332ab2835de62dd3318f67',
          file_name:
            'audios/2500d39cada71c26b3220b7e9a049e3973dfa32abc332ab2835de62dd3318f67.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2500d39cada71c26b3220b7e9a049e3973dfa32abc332ab2835de62dd3318f67.mp3',
          name: 'INT-ADV-Spider_Goblet_Squat-EXERCISE',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PUSH_UP_AND_BALL_PASS-EXERCISE': {
      id: 1224,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Push Up and Ball Pass',
      short_name: 'Push Up and Ball Pass',
      unique_name: 'INTERMEDIATE-PUSH_UP_AND_BALL_PASS-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists. Place one hand on a medicine ball.\n2. Bend your elbows, pointing them back towards your hips. Lower your body toward the floor.\n3. Straighten your arms and raise your body back up. \n4. Roll the ball laterally to the opposite side and place your hand on the floor. \n5. Place the other hand on the ball and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3269,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'fa9e4aeee16f1b6dc187a3649fc24ec080d88a752bded5805352df300cb9123e',
          file_name:
            'videos/fa9e4aeee16f1b6dc187a3649fc24ec080d88a752bded5805352df300cb9123e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fa9e4aeee16f1b6dc187a3649fc24ec080d88a752bded5805352df300cb9123e.mp4',
          name: 'INT-ADV-Push_Up_and_Ball_Pass-EXERCISE',
          description: null,
          size: 274524,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3270,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '4512d852b6784a824a4fa0415e0b67cc96dc9776b351174dbfdf774665be8fab',
          file_name:
            'audios/4512d852b6784a824a4fa0415e0b67cc96dc9776b351174dbfdf774665be8fab.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4512d852b6784a824a4fa0415e0b67cc96dc9776b351174dbfdf774665be8fab.mp3',
          name: 'INT-ADV-Push_Up_and_Ball_Pass-EXERCISE',
          description: null,
          size: 25965,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PUSH_UP_AND_BALL_PASS-EXERCISE': {
      id: 1225,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Push Up and Ball Pass',
      short_name: 'Push Up and Ball Pass',
      unique_name: 'ADVANCED-PUSH_UP_AND_BALL_PASS-EXERCISE',
      description:
        '1. Start in Plank position, shoulders over wrists. Place one hand on a medicine ball.\n2. Bend your elbows, pointing them back towards your hips. Lower your body toward the floor.\n3. Straighten your arms and raise your body back up. \n4. Roll the ball laterally to the opposite side and place your hand on the floor. \n5. Place the other hand on the ball and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3271,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'fa9e4aeee16f1b6dc187a3649fc24ec080d88a752bded5805352df300cb9123e',
          file_name:
            'videos/fa9e4aeee16f1b6dc187a3649fc24ec080d88a752bded5805352df300cb9123e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/fa9e4aeee16f1b6dc187a3649fc24ec080d88a752bded5805352df300cb9123e.mp4',
          name: 'INT-ADV-Push_Up_and_Ball_Pass-EXERCISE',
          description: null,
          size: 274524,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3272,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '4512d852b6784a824a4fa0415e0b67cc96dc9776b351174dbfdf774665be8fab',
          file_name:
            'audios/4512d852b6784a824a4fa0415e0b67cc96dc9776b351174dbfdf774665be8fab.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4512d852b6784a824a4fa0415e0b67cc96dc9776b351174dbfdf774665be8fab.mp3',
          name: 'INT-ADV-Push_Up_and_Ball_Pass-EXERCISE',
          description: null,
          size: 25965,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PIKED_PUSH_UP_WITH_LEG_UP-EXERCISE': {
      id: 1226,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Piked Push Up with Leg Up',
      short_name: 'Piked Push Up with Leg Up',
      unique_name: 'INTERMEDIATE-PIKED_PUSH_UP_WITH_LEG_UP-EXERCISE',
      description:
        '1. Start in Down Dog. Lift one leg high into the air, hips square and toes pointed down.\n2. Keep chin tucked and ears aligned with the pits of your elbows.\n3. Bend your elbows and bring the crown of your head down as far as you can, aiming for the center of your hands.\n4. Push through your palms to extend arms and body back up to start position. Perform all reps with one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3273,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '1ee6a651b0fc364b40901dff95f6d18d43327ba8bc6cd114db471da86595cda6',
          file_name:
            'videos/1ee6a651b0fc364b40901dff95f6d18d43327ba8bc6cd114db471da86595cda6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1ee6a651b0fc364b40901dff95f6d18d43327ba8bc6cd114db471da86595cda6.mp4',
          name: 'INT-ADV-Piked_Push_Up_with_Leg_Up-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 90618,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3274,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'b15c2c7e5b9620ed776361d4f0ad793cb6c826a31440291c0f6acbcfa8352866',
          file_name:
            'videos/b15c2c7e5b9620ed776361d4f0ad793cb6c826a31440291c0f6acbcfa8352866.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b15c2c7e5b9620ed776361d4f0ad793cb6c826a31440291c0f6acbcfa8352866.mp4',
          name: 'INT-ADV-Piked_Push_Up_with_Leg_Up-EXERCISE-LEFT',
          description: 'Left Side',
          size: 83770,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3275,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'e9f2e564a0148f5c990eb25b7b833ef1a4333c8352fedc4ccb23403a35bff0af',
          file_name:
            'audios/e9f2e564a0148f5c990eb25b7b833ef1a4333c8352fedc4ccb23403a35bff0af.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e9f2e564a0148f5c990eb25b7b833ef1a4333c8352fedc4ccb23403a35bff0af.mp3',
          name: 'INT-ADV-Piked_Push_Up_with_Leg_Up-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25623,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PIKED_PUSH_UP_WITH_LEG_UP-EXERCISE': {
      id: 1227,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Piked Push Up with Leg Up',
      short_name: 'Piked Push Up with Leg Up',
      unique_name: 'ADVANCED-PIKED_PUSH_UP_WITH_LEG_UP-EXERCISE',
      description:
        '1. Start in Down Dog. Lift one leg high into the air, hips square and toes pointed down.\n2. Keep chin tucked and ears aligned with the pits of your elbows.\n3. Bend your elbows and bring the crown of your head down as far as you can, aiming for the center of your hands.\n4. Push through your palms to extend arms and body back up to start position. Perform all reps with one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3276,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '1ee6a651b0fc364b40901dff95f6d18d43327ba8bc6cd114db471da86595cda6',
          file_name:
            'videos/1ee6a651b0fc364b40901dff95f6d18d43327ba8bc6cd114db471da86595cda6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1ee6a651b0fc364b40901dff95f6d18d43327ba8bc6cd114db471da86595cda6.mp4',
          name: 'INT-ADV-Piked_Push_Up_with_Leg_Up-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 90618,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3277,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'b15c2c7e5b9620ed776361d4f0ad793cb6c826a31440291c0f6acbcfa8352866',
          file_name:
            'videos/b15c2c7e5b9620ed776361d4f0ad793cb6c826a31440291c0f6acbcfa8352866.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b15c2c7e5b9620ed776361d4f0ad793cb6c826a31440291c0f6acbcfa8352866.mp4',
          name: 'INT-ADV-Piked_Push_Up_with_Leg_Up-EXERCISE-LEFT',
          description: 'Left Side',
          size: 83770,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3278,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'e9f2e564a0148f5c990eb25b7b833ef1a4333c8352fedc4ccb23403a35bff0af',
          file_name:
            'audios/e9f2e564a0148f5c990eb25b7b833ef1a4333c8352fedc4ccb23403a35bff0af.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/e9f2e564a0148f5c990eb25b7b833ef1a4333c8352fedc4ccb23403a35bff0af.mp3',
          name: 'INT-ADV-Piked_Push_Up_with_Leg_Up-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25623,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MED_BALL_WIPERS-EXERCISE': {
      id: 1228,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Med Ball Wipers',
      short_name: 'Med Ball Wipers',
      unique_name: 'INTERMEDIATE-MED_BALL_WIPERS-EXERCISE',
      description:
        '1. Lie on your back with arms out to a "T", palms flat. Place a medicine ball in between your knees and directly over hips. \n2. Keeping shins at a right angle, rotate your hips and lower both knees to one side as close to the floor as possible without touching. Keep shoulders square and upper back on the floor.\n3. Raise your knees up to start and drop to opposite side.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3279,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '20b6dab41d4302252d8de32ec03f4d57c4ad5e8b99a4fcdd95d1d18c2e99e1dd',
          file_name:
            'videos/20b6dab41d4302252d8de32ec03f4d57c4ad5e8b99a4fcdd95d1d18c2e99e1dd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/20b6dab41d4302252d8de32ec03f4d57c4ad5e8b99a4fcdd95d1d18c2e99e1dd.mp4',
          name: 'INT-ADV-Med_Ball_Wipers-EXERCISE',
          description: null,
          size: 135029,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3280,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '1d038a51c16147f67312202c2bf5b0ae37114a02c5b9d43d7423f02ae10592c5',
          file_name:
            'audios/1d038a51c16147f67312202c2bf5b0ae37114a02c5b9d43d7423f02ae10592c5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1d038a51c16147f67312202c2bf5b0ae37114a02c5b9d43d7423f02ae10592c5.mp3',
          name: 'INT-ADV-Med_Ball_Wipers-EXERCISE',
          description: null,
          size: 21645,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MED_BALL_WIPERS-EXERCISE': {
      id: 1229,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Med Ball Wipers',
      short_name: 'Med Ball Wipers',
      unique_name: 'ADVANCED-MED_BALL_WIPERS-EXERCISE',
      description:
        '1. Lie on your back with arms out to a "T", palms flat. Place a medicine ball in between your knees and directly over hips. \n2. Keeping shins at a right angle, rotate your hips and lower both knees to one side as close to the floor as possible without touching. Keep shoulders square and upper back on the floor.\n3. Raise your knees up to start and drop to opposite side.\n4. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3281,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '20b6dab41d4302252d8de32ec03f4d57c4ad5e8b99a4fcdd95d1d18c2e99e1dd',
          file_name:
            'videos/20b6dab41d4302252d8de32ec03f4d57c4ad5e8b99a4fcdd95d1d18c2e99e1dd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/20b6dab41d4302252d8de32ec03f4d57c4ad5e8b99a4fcdd95d1d18c2e99e1dd.mp4',
          name: 'INT-ADV-Med_Ball_Wipers-EXERCISE',
          description: null,
          size: 135029,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3282,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '1d038a51c16147f67312202c2bf5b0ae37114a02c5b9d43d7423f02ae10592c5',
          file_name:
            'audios/1d038a51c16147f67312202c2bf5b0ae37114a02c5b9d43d7423f02ae10592c5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1d038a51c16147f67312202c2bf5b0ae37114a02c5b9d43d7423f02ae10592c5.mp3',
          name: 'INT-ADV-Med_Ball_Wipers-EXERCISE',
          description: null,
          size: 21645,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MED_BALL_TOE_TAPS-EXERCISE': {
      id: 1230,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Med Ball Toe Taps',
      short_name: 'Med Ball Toe Taps',
      unique_name: 'INTERMEDIATE-MED_BALL_TOE_TAPS-EXERCISE',
      description:
        '1. Place a medicine ball on the floor in front of your feet and stand tall. \n2. Lift one leg up and tap your toe to the ball.\n3. Jump off the standing leg and switch your feet mid-air so you land with the opposite foot on the floor, tapping the other foot to the ball.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3283,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'daaf4ebdca04685c3edc5ddbc2931c30cd6d2049ccf6caab77f40bf96db4803d',
          file_name:
            'videos/daaf4ebdca04685c3edc5ddbc2931c30cd6d2049ccf6caab77f40bf96db4803d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/daaf4ebdca04685c3edc5ddbc2931c30cd6d2049ccf6caab77f40bf96db4803d.mp4',
          name: 'INT-ADV-Med_Ball_Toe_Taps-EXERCISE',
          description: null,
          size: 70621,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3284,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '82400ab2ea08cf10053aa693b4db0c59f5808fe50f1b971d53c8db63880a8509',
          file_name:
            'audios/82400ab2ea08cf10053aa693b4db0c59f5808fe50f1b971d53c8db63880a8509.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/82400ab2ea08cf10053aa693b4db0c59f5808fe50f1b971d53c8db63880a8509.mp3',
          name: 'INT-ADV-Med_Ball_Toe_Taps-EXERCISE',
          description: null,
          size: 21645,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MED_BALL_TOE_TAPS-EXERCISE': {
      id: 1231,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Med Ball Toe Taps',
      short_name: 'Med Ball Toe Taps',
      unique_name: 'ADVANCED-MED_BALL_TOE_TAPS-EXERCISE',
      description:
        '1. Place a medicine ball on the floor in front of your feet and stand tall. \n2. Lift one leg up and tap your toe to the ball.\n3. Jump off the standing leg and switch your feet mid-air so you land with the opposite foot on the floor, tapping the other foot to the ball.\n4. Right and left equals one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3285,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'daaf4ebdca04685c3edc5ddbc2931c30cd6d2049ccf6caab77f40bf96db4803d',
          file_name:
            'videos/daaf4ebdca04685c3edc5ddbc2931c30cd6d2049ccf6caab77f40bf96db4803d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/daaf4ebdca04685c3edc5ddbc2931c30cd6d2049ccf6caab77f40bf96db4803d.mp4',
          name: 'INT-ADV-Med_Ball_Toe_Taps-EXERCISE',
          description: null,
          size: 70621,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3286,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '82400ab2ea08cf10053aa693b4db0c59f5808fe50f1b971d53c8db63880a8509',
          file_name:
            'audios/82400ab2ea08cf10053aa693b4db0c59f5808fe50f1b971d53c8db63880a8509.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/82400ab2ea08cf10053aa693b4db0c59f5808fe50f1b971d53c8db63880a8509.mp3',
          name: 'INT-ADV-Med_Ball_Toe_Taps-EXERCISE',
          description: null,
          size: 21645,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KNEELING_SINGLE_ARM_THRUSTER-EXERCISE': {
      id: 1232,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Kneeling Single Arm Thruster',
      short_name: 'Kneeling Single Arm Thruster',
      unique_name: 'INTERMEDIATE-KNEELING_SINGLE_ARM_THRUSTER-EXERCISE',
      description:
        '1. Start in a low kneel with your legs about hip-width apart, chest tall, hips resting on heels. Hold one kettlebell in racked position, thumb on sternum, elbow pointing down.\n2. Using quad/glute strength, lift your hips up to a full kneeling position as you punch the kettlebell straight overhead. Rotate palm out and keep bicep by ear in full extension. \n3. Lower the bell and your hips back to start. Perform all reps, repeat other arm.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3287,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'ec977f08cf7dcb14c23cff96e4f0ca5869c8ce6ea33eaa7c697ac5f811f06b13',
          file_name:
            'videos/ec977f08cf7dcb14c23cff96e4f0ca5869c8ce6ea33eaa7c697ac5f811f06b13.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ec977f08cf7dcb14c23cff96e4f0ca5869c8ce6ea33eaa7c697ac5f811f06b13.mp4',
          name: 'INT-ADV-Kneeling_Single_Arm_Thruster-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 94378,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3288,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'af4958c380c2b61d44d94781fa15cc279a029a88af12fc5d7fb9f5477ce82808',
          file_name:
            'videos/af4958c380c2b61d44d94781fa15cc279a029a88af12fc5d7fb9f5477ce82808.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/af4958c380c2b61d44d94781fa15cc279a029a88af12fc5d7fb9f5477ce82808.mp4',
          name: 'INT-ADV-Kneeling_Single_Arm_Thruster-EXERCISE-LEFT',
          description: 'Left Side',
          size: 106226,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3289,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '430a0b430c161926dfe8fb1baef67526ed8f4173bcba0a0b544cb27c8fbfed6a',
          file_name:
            'audios/430a0b430c161926dfe8fb1baef67526ed8f4173bcba0a0b544cb27c8fbfed6a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/430a0b430c161926dfe8fb1baef67526ed8f4173bcba0a0b544cb27c8fbfed6a.mp3',
          name: 'INT-ADV-Kneeling_Single_Arm_Thruster-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 32301,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KNEELING_SINGLE_ARM_THRUSTER-EXERCISE': {
      id: 1233,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Kneeling Single Arm Thruster',
      short_name: 'Kneeling Single Arm Thruster',
      unique_name: 'ADVANCED-KNEELING_SINGLE_ARM_THRUSTER-EXERCISE',
      description:
        '1. Start in a low kneel with your legs about hip-width apart, chest tall, hips resting on heels. Hold one kettlebell in racked position, thumb on sternum, elbow pointing down.\n2. Using quad/glute strength, lift your hips up to a full kneeling position as you punch the kettlebell straight overhead. Rotate palm out and keep bicep by ear in full extension. \n3. Lower the bell and your hips back to start. Perform all reps, repeat other arm.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3290,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'ec977f08cf7dcb14c23cff96e4f0ca5869c8ce6ea33eaa7c697ac5f811f06b13',
          file_name:
            'videos/ec977f08cf7dcb14c23cff96e4f0ca5869c8ce6ea33eaa7c697ac5f811f06b13.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ec977f08cf7dcb14c23cff96e4f0ca5869c8ce6ea33eaa7c697ac5f811f06b13.mp4',
          name: 'INT-ADV-Kneeling_Single_Arm_Thruster-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 94378,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3291,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'af4958c380c2b61d44d94781fa15cc279a029a88af12fc5d7fb9f5477ce82808',
          file_name:
            'videos/af4958c380c2b61d44d94781fa15cc279a029a88af12fc5d7fb9f5477ce82808.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/af4958c380c2b61d44d94781fa15cc279a029a88af12fc5d7fb9f5477ce82808.mp4',
          name: 'INT-ADV-Kneeling_Single_Arm_Thruster-EXERCISE-LEFT',
          description: 'Left Side',
          size: 106226,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3292,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '430a0b430c161926dfe8fb1baef67526ed8f4173bcba0a0b544cb27c8fbfed6a',
          file_name:
            'audios/430a0b430c161926dfe8fb1baef67526ed8f4173bcba0a0b544cb27c8fbfed6a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/430a0b430c161926dfe8fb1baef67526ed8f4173bcba0a0b544cb27c8fbfed6a.mp3',
          name: 'INT-ADV-Kneeling_Single_Arm_Thruster-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 32301,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-12_KNEELING_SHOULDER_PRESS-EXERCISE': {
      id: 1234,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: '1/2 Kneeling Shoulder Press',
      short_name: '1/2 Kneeling Shoulder Press',
      unique_name: 'INTERMEDIATE-12_KNEELING_SHOULDER_PRESS-EXERCISE',
      description:
        '1. Start in half kneeling position. Rack a kettlebell in the arm opposite the lifted knee. \n2. Press the kettlebell directly overhead and rotate palm out. Keep elbow close to ear. \n3. Return to start and rack the kettlebell with your thumb on sternum. \n4. Perform all reps. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3293,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '4492801ea715e3e03e288cdd164602c95a1452525f4f03daa814e05076884327',
          file_name:
            'videos/4492801ea715e3e03e288cdd164602c95a1452525f4f03daa814e05076884327.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4492801ea715e3e03e288cdd164602c95a1452525f4f03daa814e05076884327.mp4',
          name: 'INT-ADV-1-2_Kneeling_Shoulder_Press-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 95944,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3294,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '9e7a917195052b7b4e315470db17b23d5f7b9788a370333babc72e71a1c93a1a',
          file_name:
            'videos/9e7a917195052b7b4e315470db17b23d5f7b9788a370333babc72e71a1c93a1a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9e7a917195052b7b4e315470db17b23d5f7b9788a370333babc72e71a1c93a1a.mp4',
          name: 'INT-ADV-1-2_Kneeling_Shoulder_Press-EXERCISE-LEFT',
          description: 'Left Side',
          size: 87359,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3295,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '97719f9f8e678ea7cb3b9c24a6861cc0c6ecb03472c8fd06414bdb30857a9e36',
          file_name:
            'audios/97719f9f8e678ea7cb3b9c24a6861cc0c6ecb03472c8fd06414bdb30857a9e36.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/97719f9f8e678ea7cb3b9c24a6861cc0c6ecb03472c8fd06414bdb30857a9e36.mp3',
          name: 'INT-ADV-1-2_Kneeling_Shoulder_Press-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-12_KNEELING_SHOULDER_PRESS-EXERCISE': {
      id: 1235,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: '1/2 Kneeling Shoulder Press',
      short_name: '1/2 Kneeling Shoulder Press',
      unique_name: 'ADVANCED-12_KNEELING_SHOULDER_PRESS-EXERCISE',
      description:
        '1. Start in half kneeling position. Rack a kettlebell in the arm opposite the lifted knee. \n2. Press the kettlebell directly overhead and rotate palm out. Keep elbow close to ear. \n3. Return to start and rack the kettlebell with your thumb on sternum. \n4. Perform all reps. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 8,
          name: 'Kettlebell',
          unique_name: 'KETTLEBELL',
          min_app_version: 200030000,
          order: 8000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3296,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '4492801ea715e3e03e288cdd164602c95a1452525f4f03daa814e05076884327',
          file_name:
            'videos/4492801ea715e3e03e288cdd164602c95a1452525f4f03daa814e05076884327.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4492801ea715e3e03e288cdd164602c95a1452525f4f03daa814e05076884327.mp4',
          name: 'INT-ADV-1-2_Kneeling_Shoulder_Press-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 95944,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3297,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '9e7a917195052b7b4e315470db17b23d5f7b9788a370333babc72e71a1c93a1a',
          file_name:
            'videos/9e7a917195052b7b4e315470db17b23d5f7b9788a370333babc72e71a1c93a1a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9e7a917195052b7b4e315470db17b23d5f7b9788a370333babc72e71a1c93a1a.mp4',
          name: 'INT-ADV-1-2_Kneeling_Shoulder_Press-EXERCISE-LEFT',
          description: 'Left Side',
          size: 87359,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3298,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '97719f9f8e678ea7cb3b9c24a6861cc0c6ecb03472c8fd06414bdb30857a9e36',
          file_name:
            'audios/97719f9f8e678ea7cb3b9c24a6861cc0c6ecb03472c8fd06414bdb30857a9e36.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/97719f9f8e678ea7cb3b9c24a6861cc0c6ecb03472c8fd06414bdb30857a9e36.mp3',
          name: 'INT-ADV-1-2_Kneeling_Shoulder_Press-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 27117,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SQUAT_AND_THROW-EXERCISE': {
      id: 1236,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Squat and Throw',
      short_name: 'Squat and Throw',
      unique_name: 'BEGINNER-SQUAT_AND_THROW-EXERCISE',
      description:
        '1. Stand with feet about shoulder-width apart. Hold a medicine ball at your chest, elbows down.\n2. Keep your chest up and squat as low as possible. Try to get your elbows close to your knees.\n3. Drive through your heels and explode up to standing, throwing the ball overhead.\n4. Catch the ball and return to squat.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3299,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '8bce6110f03618c8412b105e987c061769bdac5096e276fe4559951a19fcbd2e',
          file_name:
            'videos/8bce6110f03618c8412b105e987c061769bdac5096e276fe4559951a19fcbd2e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8bce6110f03618c8412b105e987c061769bdac5096e276fe4559951a19fcbd2e.mp4',
          name: 'BEG-INT-ADV-Squat_and_Throw-EXERCISE',
          description: null,
          size: 102314,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3300,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '772062764abc7b1e975b9486c59763013e207b1092f7b4e461a88fbf58975411',
          file_name:
            'audios/772062764abc7b1e975b9486c59763013e207b1092f7b4e461a88fbf58975411.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/772062764abc7b1e975b9486c59763013e207b1092f7b4e461a88fbf58975411.mp3',
          name: 'BEG-INT-ADV-Squat_and_Throw-EXERCISE',
          description: null,
          size: 22797,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SQUAT_AND_THROW-EXERCISE': {
      id: 1237,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Squat and Throw',
      short_name: 'Squat and Throw',
      unique_name: 'INTERMEDIATE-SQUAT_AND_THROW-EXERCISE',
      description:
        '1. Stand with feet about shoulder-width apart. Hold a medicine ball at your chest, elbows down.\n2. Keep your chest up and squat as low as possible. Try to get your elbows close to your knees.\n3. Drive through your heels and explode up to standing, throwing the ball overhead.\n4. Catch the ball and return to squat.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3301,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '8bce6110f03618c8412b105e987c061769bdac5096e276fe4559951a19fcbd2e',
          file_name:
            'videos/8bce6110f03618c8412b105e987c061769bdac5096e276fe4559951a19fcbd2e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8bce6110f03618c8412b105e987c061769bdac5096e276fe4559951a19fcbd2e.mp4',
          name: 'BEG-INT-ADV-Squat_and_Throw-EXERCISE',
          description: null,
          size: 102314,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3302,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '772062764abc7b1e975b9486c59763013e207b1092f7b4e461a88fbf58975411',
          file_name:
            'audios/772062764abc7b1e975b9486c59763013e207b1092f7b4e461a88fbf58975411.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/772062764abc7b1e975b9486c59763013e207b1092f7b4e461a88fbf58975411.mp3',
          name: 'BEG-INT-ADV-Squat_and_Throw-EXERCISE',
          description: null,
          size: 22797,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SQUAT_AND_THROW-EXERCISE': {
      id: 1238,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Squat and Throw',
      short_name: 'Squat and Throw',
      unique_name: 'ADVANCED-SQUAT_AND_THROW-EXERCISE',
      description:
        '1. Stand with feet about shoulder-width apart. Hold a medicine ball at your chest, elbows down.\n2. Keep your chest up and squat as low as possible. Try to get your elbows close to your knees.\n3. Drive through your heels and explode up to standing, throwing the ball overhead.\n4. Catch the ball and return to squat.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3303,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '8bce6110f03618c8412b105e987c061769bdac5096e276fe4559951a19fcbd2e',
          file_name:
            'videos/8bce6110f03618c8412b105e987c061769bdac5096e276fe4559951a19fcbd2e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8bce6110f03618c8412b105e987c061769bdac5096e276fe4559951a19fcbd2e.mp4',
          name: 'BEG-INT-ADV-Squat_and_Throw-EXERCISE',
          description: null,
          size: 102314,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3304,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '772062764abc7b1e975b9486c59763013e207b1092f7b4e461a88fbf58975411',
          file_name:
            'audios/772062764abc7b1e975b9486c59763013e207b1092f7b4e461a88fbf58975411.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/772062764abc7b1e975b9486c59763013e207b1092f7b4e461a88fbf58975411.mp3',
          name: 'BEG-INT-ADV-Squat_and_Throw-EXERCISE',
          description: null,
          size: 22797,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-RAINBOW_SLAMS-EXERCISE': {
      id: 1239,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Rainbow Slams',
      short_name: 'Rainbow Slams',
      unique_name: 'BEGINNER-RAINBOW_SLAMS-EXERCISE',
      description:
        '1. Start in a split stance by taking a big step forward with one leg, elevate your back heel and hold a medicine ball overhead.  \n2. Bend both knees and perform a lunge as you slam the ball to the outside of your front foot. \n3. Catch the ball and press it back overhead as you straighten your legs. Pivot 180 degrees so the opposite foot is in front.  \n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3305,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'cff50a0200a160ee84375a95e4fa87e761200c3f2879a8f318fb96cf2c8c2064',
          file_name:
            'videos/cff50a0200a160ee84375a95e4fa87e761200c3f2879a8f318fb96cf2c8c2064.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cff50a0200a160ee84375a95e4fa87e761200c3f2879a8f318fb96cf2c8c2064.mp4',
          name: 'BEG-INT-ADV-Rainbow_Slams-EXERCISE',
          description: null,
          size: 217652,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3306,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '082c1d9e4e416d3c93bdc8b548db5a07f2e0371bb49628ea07ac4603ef32db4f',
          file_name:
            'audios/082c1d9e4e416d3c93bdc8b548db5a07f2e0371bb49628ea07ac4603ef32db4f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/082c1d9e4e416d3c93bdc8b548db5a07f2e0371bb49628ea07ac4603ef32db4f.mp3',
          name: 'BEG-INT-ADV-Rainbow_Slams-EXERCISE',
          description: null,
          size: 22797,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-RAINBOW_SLAMS-EXERCISE': {
      id: 1240,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Rainbow Slams',
      short_name: 'Rainbow Slams',
      unique_name: 'INTERMEDIATE-RAINBOW_SLAMS-EXERCISE',
      description:
        '1. Start in a split stance by taking a big step forward with one leg, elevate your back heel and hold a medicine ball overhead.  \n2. Bend both knees and perform a lunge as you slam the ball to the outside of your front foot. \n3. Catch the ball and press it back overhead as you straighten your legs. Pivot 180 degrees so the opposite foot is in front.  \n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3307,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'cff50a0200a160ee84375a95e4fa87e761200c3f2879a8f318fb96cf2c8c2064',
          file_name:
            'videos/cff50a0200a160ee84375a95e4fa87e761200c3f2879a8f318fb96cf2c8c2064.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cff50a0200a160ee84375a95e4fa87e761200c3f2879a8f318fb96cf2c8c2064.mp4',
          name: 'BEG-INT-ADV-Rainbow_Slams-EXERCISE',
          description: null,
          size: 217652,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3308,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '082c1d9e4e416d3c93bdc8b548db5a07f2e0371bb49628ea07ac4603ef32db4f',
          file_name:
            'audios/082c1d9e4e416d3c93bdc8b548db5a07f2e0371bb49628ea07ac4603ef32db4f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/082c1d9e4e416d3c93bdc8b548db5a07f2e0371bb49628ea07ac4603ef32db4f.mp3',
          name: 'BEG-INT-ADV-Rainbow_Slams-EXERCISE',
          description: null,
          size: 22797,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-RAINBOW_SLAMS-EXERCISE': {
      id: 1241,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Rainbow Slams',
      short_name: 'Rainbow Slams',
      unique_name: 'ADVANCED-RAINBOW_SLAMS-EXERCISE',
      description:
        '1. Start in a split stance by taking a big step forward with one leg, elevate your back heel and hold a medicine ball overhead.  \n2. Bend both knees and perform a lunge as you slam the ball to the outside of your front foot. \n3. Catch the ball and press it back overhead as you straighten your legs. Pivot 180 degrees so the opposite foot is in front.  \n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3309,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'cff50a0200a160ee84375a95e4fa87e761200c3f2879a8f318fb96cf2c8c2064',
          file_name:
            'videos/cff50a0200a160ee84375a95e4fa87e761200c3f2879a8f318fb96cf2c8c2064.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cff50a0200a160ee84375a95e4fa87e761200c3f2879a8f318fb96cf2c8c2064.mp4',
          name: 'BEG-INT-ADV-Rainbow_Slams-EXERCISE',
          description: null,
          size: 217652,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3310,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '082c1d9e4e416d3c93bdc8b548db5a07f2e0371bb49628ea07ac4603ef32db4f',
          file_name:
            'audios/082c1d9e4e416d3c93bdc8b548db5a07f2e0371bb49628ea07ac4603ef32db4f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/082c1d9e4e416d3c93bdc8b548db5a07f2e0371bb49628ea07ac4603ef32db4f.mp3',
          name: 'BEG-INT-ADV-Rainbow_Slams-EXERCISE',
          description: null,
          size: 22797,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-OBLIQUE_SLAMS-EXERCISE': {
      id: 1242,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Oblique Slams',
      short_name: 'Oblique Slams',
      unique_name: 'BEGINNER-OBLIQUE_SLAMS-EXERCISE',
      description:
        '1. Stand with feet about shoulder-width apart holding a medicine ball overhead. \n2. Rotate your torso to one side and slam the ball to the outside of your foot. \n3. Catch the ball and repeat other side. Right and left is one rep',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3311,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '2eeeb4370e389e339ae49d1008c1ed4a035581383849f97d3b6a78f05528b9fd',
          file_name:
            'videos/2eeeb4370e389e339ae49d1008c1ed4a035581383849f97d3b6a78f05528b9fd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2eeeb4370e389e339ae49d1008c1ed4a035581383849f97d3b6a78f05528b9fd.mp4',
          name: 'BEG-INT-ADV-Oblique_Slams-EXERCISE',
          description: null,
          size: 161199,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3312,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'eb258f9660813d4063308914a5b3b75352436b3c86b789a2006e3e34ef0def94',
          file_name:
            'audios/eb258f9660813d4063308914a5b3b75352436b3c86b789a2006e3e34ef0def94.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eb258f9660813d4063308914a5b3b75352436b3c86b789a2006e3e34ef0def94.mp3',
          name: 'BEG-INT-ADV-Oblique_Slams-EXERCISE',
          description: null,
          size: 21645,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-OBLIQUE_SLAMS-EXERCISE': {
      id: 1243,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Oblique Slams',
      short_name: 'Oblique Slams',
      unique_name: 'INTERMEDIATE-OBLIQUE_SLAMS-EXERCISE',
      description:
        '1. Stand with feet about shoulder-width apart holding a medicine ball overhead. \n2. Rotate your torso to one side and slam the ball to the outside of your foot. \n3. Catch the ball and repeat other side. Right and left is one rep',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3313,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '2eeeb4370e389e339ae49d1008c1ed4a035581383849f97d3b6a78f05528b9fd',
          file_name:
            'videos/2eeeb4370e389e339ae49d1008c1ed4a035581383849f97d3b6a78f05528b9fd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2eeeb4370e389e339ae49d1008c1ed4a035581383849f97d3b6a78f05528b9fd.mp4',
          name: 'BEG-INT-ADV-Oblique_Slams-EXERCISE',
          description: null,
          size: 161199,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3314,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'eb258f9660813d4063308914a5b3b75352436b3c86b789a2006e3e34ef0def94',
          file_name:
            'audios/eb258f9660813d4063308914a5b3b75352436b3c86b789a2006e3e34ef0def94.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eb258f9660813d4063308914a5b3b75352436b3c86b789a2006e3e34ef0def94.mp3',
          name: 'BEG-INT-ADV-Oblique_Slams-EXERCISE',
          description: null,
          size: 21645,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-OBLIQUE_SLAMS-EXERCISE': {
      id: 1244,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Oblique Slams',
      short_name: 'Oblique Slams',
      unique_name: 'ADVANCED-OBLIQUE_SLAMS-EXERCISE',
      description:
        '1. Stand with feet about shoulder-width apart holding a medicine ball overhead. \n2. Rotate your torso to one side and slam the ball to the outside of your foot. \n3. Catch the ball and repeat other side. Right and left is one rep',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3315,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '2eeeb4370e389e339ae49d1008c1ed4a035581383849f97d3b6a78f05528b9fd',
          file_name:
            'videos/2eeeb4370e389e339ae49d1008c1ed4a035581383849f97d3b6a78f05528b9fd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2eeeb4370e389e339ae49d1008c1ed4a035581383849f97d3b6a78f05528b9fd.mp4',
          name: 'BEG-INT-ADV-Oblique_Slams-EXERCISE',
          description: null,
          size: 161199,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3316,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'eb258f9660813d4063308914a5b3b75352436b3c86b789a2006e3e34ef0def94',
          file_name:
            'audios/eb258f9660813d4063308914a5b3b75352436b3c86b789a2006e3e34ef0def94.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/eb258f9660813d4063308914a5b3b75352436b3c86b789a2006e3e34ef0def94.mp3',
          name: 'BEG-INT-ADV-Oblique_Slams-EXERCISE',
          description: null,
          size: 21645,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-MED_BALL_UP_DOWNS-EXERCISE': {
      id: 1245,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Med Ball Up Downs',
      short_name: 'Med Ball Up Downs',
      unique_name: 'BEGINNER-MED_BALL_UP_DOWNS-EXERCISE',
      description:
        '1. Stand tall with feet about shoulder-width apart holding a medicine ball out in front of your chest, arms straight. \n2. Keeping core engaged, raise the medicine ball overhead. \n3. Exhale and chop the medicine ball down toward your feet and bend both knees into a partial squat. \n4. Repeat chopping up and down in a continous motion.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3317,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'eeab5f3e93b2bcdbb43c8a59d4e1651ef39fc1c5a79796db7bd29bcc92601ff1',
          file_name:
            'videos/eeab5f3e93b2bcdbb43c8a59d4e1651ef39fc1c5a79796db7bd29bcc92601ff1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eeab5f3e93b2bcdbb43c8a59d4e1651ef39fc1c5a79796db7bd29bcc92601ff1.mp4',
          name: 'BEG-INT-ADV-Med_Ball_Up_Downs-EXERCISE',
          description: null,
          size: 109207,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3318,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '768720707fbc7a01f1bfe6b8bcf91577009f38399bbf8e9fc871c16a08814d2f',
          file_name:
            'audios/768720707fbc7a01f1bfe6b8bcf91577009f38399bbf8e9fc871c16a08814d2f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/768720707fbc7a01f1bfe6b8bcf91577009f38399bbf8e9fc871c16a08814d2f.mp3',
          name: 'BEG-INT-ADV-Med_Ball_Up_Downs-EXERCISE',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-MED_BALL_UP_DOWNS-EXERCISE': {
      id: 1246,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Med Ball Up Downs',
      short_name: 'Med Ball Up Downs',
      unique_name: 'INTERMEDIATE-MED_BALL_UP_DOWNS-EXERCISE',
      description:
        '1. Stand tall with feet about shoulder-width apart holding a medicine ball out in front of your chest, arms straight. \n2. Keeping core engaged, raise the medicine ball overhead. \n3. Exhale and chop the medicine ball down toward your feet and bend both knees into a partial squat. \n4. Repeat chopping up and down in a continous motion.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3319,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'eeab5f3e93b2bcdbb43c8a59d4e1651ef39fc1c5a79796db7bd29bcc92601ff1',
          file_name:
            'videos/eeab5f3e93b2bcdbb43c8a59d4e1651ef39fc1c5a79796db7bd29bcc92601ff1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eeab5f3e93b2bcdbb43c8a59d4e1651ef39fc1c5a79796db7bd29bcc92601ff1.mp4',
          name: 'BEG-INT-ADV-Med_Ball_Up_Downs-EXERCISE',
          description: null,
          size: 109207,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3320,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '768720707fbc7a01f1bfe6b8bcf91577009f38399bbf8e9fc871c16a08814d2f',
          file_name:
            'audios/768720707fbc7a01f1bfe6b8bcf91577009f38399bbf8e9fc871c16a08814d2f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/768720707fbc7a01f1bfe6b8bcf91577009f38399bbf8e9fc871c16a08814d2f.mp3',
          name: 'BEG-INT-ADV-Med_Ball_Up_Downs-EXERCISE',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-MED_BALL_UP_DOWNS-EXERCISE': {
      id: 1247,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Med Ball Up Downs',
      short_name: 'Med Ball Up Downs',
      unique_name: 'ADVANCED-MED_BALL_UP_DOWNS-EXERCISE',
      description:
        '1. Stand tall with feet about shoulder-width apart holding a medicine ball out in front of your chest, arms straight. \n2. Keeping core engaged, raise the medicine ball overhead. \n3. Exhale and chop the medicine ball down toward your feet and bend both knees into a partial squat. \n4. Repeat chopping up and down in a continous motion.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3321,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'eeab5f3e93b2bcdbb43c8a59d4e1651ef39fc1c5a79796db7bd29bcc92601ff1',
          file_name:
            'videos/eeab5f3e93b2bcdbb43c8a59d4e1651ef39fc1c5a79796db7bd29bcc92601ff1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/eeab5f3e93b2bcdbb43c8a59d4e1651ef39fc1c5a79796db7bd29bcc92601ff1.mp4',
          name: 'BEG-INT-ADV-Med_Ball_Up_Downs-EXERCISE',
          description: null,
          size: 109207,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3322,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '768720707fbc7a01f1bfe6b8bcf91577009f38399bbf8e9fc871c16a08814d2f',
          file_name:
            'audios/768720707fbc7a01f1bfe6b8bcf91577009f38399bbf8e9fc871c16a08814d2f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/768720707fbc7a01f1bfe6b8bcf91577009f38399bbf8e9fc871c16a08814d2f.mp3',
          name: 'BEG-INT-ADV-Med_Ball_Up_Downs-EXERCISE',
          description: null,
          size: 25677,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-JACK_AND_PRESS-EXERCISE': {
      id: 1248,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Jack and Press',
      short_name: 'Jack and Press',
      unique_name: 'BEGINNER-JACK_AND_PRESS-EXERCISE',
      description:
        '1. Stand with your feet together, holding a medicine ball at your chest, elbows down. \n2. Jump up and land with your feet slightly wider than shoulder-width apart as you press the ball directly overhead. \n3. Jump your feet back together and bring the ball back to start position. \n4. Jack your feet out and press the ball forward, shoulder height. \n5. Return to start. Pressing up and out is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3323,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'edf2cab459a2885b27a9884ad9ba3bb7135a2604badc865df5bca5eb8b9716bf',
          file_name:
            'videos/edf2cab459a2885b27a9884ad9ba3bb7135a2604badc865df5bca5eb8b9716bf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/edf2cab459a2885b27a9884ad9ba3bb7135a2604badc865df5bca5eb8b9716bf.mp4',
          name: 'BEG-INT-ADV-Jack_and_Press-EXERCISE',
          description: null,
          size: 117952,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3324,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'cae84941272f3e3d3306271e075b623eee4c861ef207d40af48462678d305192',
          file_name:
            'audios/cae84941272f3e3d3306271e075b623eee4c861ef207d40af48462678d305192.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cae84941272f3e3d3306271e075b623eee4c861ef207d40af48462678d305192.mp3',
          name: 'BEG-INT-ADV-Jack_and_Press-EXERCISE',
          description: null,
          size: 18423,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-JACK_AND_PRESS-EXERCISE': {
      id: 1249,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Jack and Press',
      short_name: 'Jack and Press',
      unique_name: 'INTERMEDIATE-JACK_AND_PRESS-EXERCISE',
      description:
        '1. Stand with your feet together, holding a medicine ball at your chest, elbows down. \n2. Jump up and land with your feet slightly wider than shoulder-width apart as you press the ball directly overhead. \n3. Jump your feet back together and bring the ball back to start position. \n4. Jack your feet out and press the ball forward, shoulder height. \n5. Return to start. Pressing up and out is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3325,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'edf2cab459a2885b27a9884ad9ba3bb7135a2604badc865df5bca5eb8b9716bf',
          file_name:
            'videos/edf2cab459a2885b27a9884ad9ba3bb7135a2604badc865df5bca5eb8b9716bf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/edf2cab459a2885b27a9884ad9ba3bb7135a2604badc865df5bca5eb8b9716bf.mp4',
          name: 'BEG-INT-ADV-Jack_and_Press-EXERCISE',
          description: null,
          size: 117952,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3326,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'cae84941272f3e3d3306271e075b623eee4c861ef207d40af48462678d305192',
          file_name:
            'audios/cae84941272f3e3d3306271e075b623eee4c861ef207d40af48462678d305192.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cae84941272f3e3d3306271e075b623eee4c861ef207d40af48462678d305192.mp3',
          name: 'BEG-INT-ADV-Jack_and_Press-EXERCISE',
          description: null,
          size: 18423,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-JACK_AND_PRESS-EXERCISE': {
      id: 1250,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Jack and Press',
      short_name: 'Jack and Press',
      unique_name: 'ADVANCED-JACK_AND_PRESS-EXERCISE',
      description:
        '1. Stand with your feet together, holding a medicine ball at your chest, elbows down. \n2. Jump up and land with your feet slightly wider than shoulder-width apart as you press the ball directly overhead. \n3. Jump your feet back together and bring the ball back to start position. \n4. Jack your feet out and press the ball forward, shoulder height. \n5. Return to start. Pressing up and out is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3327,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'edf2cab459a2885b27a9884ad9ba3bb7135a2604badc865df5bca5eb8b9716bf',
          file_name:
            'videos/edf2cab459a2885b27a9884ad9ba3bb7135a2604badc865df5bca5eb8b9716bf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/edf2cab459a2885b27a9884ad9ba3bb7135a2604badc865df5bca5eb8b9716bf.mp4',
          name: 'BEG-INT-ADV-Jack_and_Press-EXERCISE',
          description: null,
          size: 117952,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3328,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'cae84941272f3e3d3306271e075b623eee4c861ef207d40af48462678d305192',
          file_name:
            'audios/cae84941272f3e3d3306271e075b623eee4c861ef207d40af48462678d305192.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cae84941272f3e3d3306271e075b623eee4c861ef207d40af48462678d305192.mp3',
          name: 'BEG-INT-ADV-Jack_and_Press-EXERCISE',
          description: null,
          size: 18423,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-FRONT_RAISE_CIRCLES-EXERCISE': {
      id: 1251,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Front Raise Circles',
      short_name: 'Front Raise Circles',
      unique_name: 'BEGINNER-FRONT_RAISE_CIRCLES-EXERCISE',
      description:
        '1. Stand tall, holding a medicine ball in front of your chest, arms outstretched. \n2. Keeping core engaged and shoulders down, draw large circles with the ball in one direction, arms stay straight. \n3. Continue to circle for the amount of reps. Repeat other direction.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3329,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '71837100ac6d56dbd196490395a7d7b2e12fc6b332a1bc4370203459a7ef2af3',
          file_name:
            'videos/71837100ac6d56dbd196490395a7d7b2e12fc6b332a1bc4370203459a7ef2af3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/71837100ac6d56dbd196490395a7d7b2e12fc6b332a1bc4370203459a7ef2af3.mp4',
          name: 'BEG-INT-ADV-Front_Raise_Circles-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 48334,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3330,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '1cdae1e447bbc9a30953aac5e3dba2fd1db73ca04c2922811a50ea2296a9f10f',
          file_name:
            'videos/1cdae1e447bbc9a30953aac5e3dba2fd1db73ca04c2922811a50ea2296a9f10f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1cdae1e447bbc9a30953aac5e3dba2fd1db73ca04c2922811a50ea2296a9f10f.mp4',
          name: 'BEG-INT-ADV-Front_Raise_Circles-EXERCISE-LEFT',
          description: 'Left Side',
          size: 51537,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3331,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'caf702dfef264147c5a081d229b907203a4162efd3514d05cf7cf5b5a0f8aa0e',
          file_name:
            'audios/caf702dfef264147c5a081d229b907203a4162efd3514d05cf7cf5b5a0f8aa0e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/caf702dfef264147c5a081d229b907203a4162efd3514d05cf7cf5b5a0f8aa0e.mp3',
          name: 'BEG-INT-ADV-Front_Raise_Circles-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-FRONT_RAISE_CIRCLES-EXERCISE': {
      id: 1252,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Front Raise Circles',
      short_name: 'Front Raise Circles',
      unique_name: 'INTERMEDIATE-FRONT_RAISE_CIRCLES-EXERCISE',
      description:
        '1. Stand tall, holding a medicine ball in front of your chest, arms outstretched. \n2. Keeping core engaged and shoulders down, draw large circles with the ball in one direction, arms stay straight. \n3. Continue to circle for the amount of reps. Repeat other direction.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3332,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '71837100ac6d56dbd196490395a7d7b2e12fc6b332a1bc4370203459a7ef2af3',
          file_name:
            'videos/71837100ac6d56dbd196490395a7d7b2e12fc6b332a1bc4370203459a7ef2af3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/71837100ac6d56dbd196490395a7d7b2e12fc6b332a1bc4370203459a7ef2af3.mp4',
          name: 'BEG-INT-ADV-Front_Raise_Circles-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 48334,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3333,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '1cdae1e447bbc9a30953aac5e3dba2fd1db73ca04c2922811a50ea2296a9f10f',
          file_name:
            'videos/1cdae1e447bbc9a30953aac5e3dba2fd1db73ca04c2922811a50ea2296a9f10f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1cdae1e447bbc9a30953aac5e3dba2fd1db73ca04c2922811a50ea2296a9f10f.mp4',
          name: 'BEG-INT-ADV-Front_Raise_Circles-EXERCISE-LEFT',
          description: 'Left Side',
          size: 51537,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3334,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'caf702dfef264147c5a081d229b907203a4162efd3514d05cf7cf5b5a0f8aa0e',
          file_name:
            'audios/caf702dfef264147c5a081d229b907203a4162efd3514d05cf7cf5b5a0f8aa0e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/caf702dfef264147c5a081d229b907203a4162efd3514d05cf7cf5b5a0f8aa0e.mp3',
          name: 'BEG-INT-ADV-Front_Raise_Circles-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-FRONT_RAISE_CIRCLES-EXERCISE': {
      id: 1253,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Front Raise Circles',
      short_name: 'Front Raise Circles',
      unique_name: 'ADVANCED-FRONT_RAISE_CIRCLES-EXERCISE',
      description:
        '1. Stand tall, holding a medicine ball in front of your chest, arms outstretched. \n2. Keeping core engaged and shoulders down, draw large circles with the ball in one direction, arms stay straight. \n3. Continue to circle for the amount of reps. Repeat other direction.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3335,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '71837100ac6d56dbd196490395a7d7b2e12fc6b332a1bc4370203459a7ef2af3',
          file_name:
            'videos/71837100ac6d56dbd196490395a7d7b2e12fc6b332a1bc4370203459a7ef2af3.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/71837100ac6d56dbd196490395a7d7b2e12fc6b332a1bc4370203459a7ef2af3.mp4',
          name: 'BEG-INT-ADV-Front_Raise_Circles-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 48334,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3336,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '1cdae1e447bbc9a30953aac5e3dba2fd1db73ca04c2922811a50ea2296a9f10f',
          file_name:
            'videos/1cdae1e447bbc9a30953aac5e3dba2fd1db73ca04c2922811a50ea2296a9f10f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1cdae1e447bbc9a30953aac5e3dba2fd1db73ca04c2922811a50ea2296a9f10f.mp4',
          name: 'BEG-INT-ADV-Front_Raise_Circles-EXERCISE-LEFT',
          description: 'Left Side',
          size: 51537,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3337,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'caf702dfef264147c5a081d229b907203a4162efd3514d05cf7cf5b5a0f8aa0e',
          file_name:
            'audios/caf702dfef264147c5a081d229b907203a4162efd3514d05cf7cf5b5a0f8aa0e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/caf702dfef264147c5a081d229b907203a4162efd3514d05cf7cf5b5a0f8aa0e.mp3',
          name: 'BEG-INT-ADV-Front_Raise_Circles-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ALTERNATING_SIDE_LUNGE_AND_CHEST_PRESS-EXERCISE': {
      id: 1254,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Side Lunge and Chest Press',
      short_name: 'Alternating Side Lunge and Chest Press',
      unique_name: 'BEGINNER-ALTERNATING_SIDE_LUNGE_AND_CHEST_PRESS-EXERCISE',
      description:
        '1. Stand tall, feet and legs together in a close stance, holding a medicine ball in front of your chest. \n2. Keeping your chest up, take a big step out to the side as wide as possible, toes forward. \n3. When you land, bend your knee and sink hips to about 90 degrees while pressing the medicine ball straight out in front of your chest. Keep the other leg straight and foot planted on the floor.\n4. Powerfully drive through your heel and push yourself up to stand as you bring the ball back in to start position. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3338,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'd5f162a20efd289be2f9734a5efe0c287216e1d566edda6dc3ae2a32fe6f0c4b',
          file_name:
            'videos/d5f162a20efd289be2f9734a5efe0c287216e1d566edda6dc3ae2a32fe6f0c4b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d5f162a20efd289be2f9734a5efe0c287216e1d566edda6dc3ae2a32fe6f0c4b.mp4',
          name: 'BEG-INT-ADV-Alternating_Side_Lunge_and_Chest_Press-EXERCISE',
          description: null,
          size: 241074,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3339,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'b6fec65aa6426be7cf2211c63a28ef2f731285ce5b2c4f609c3607f38bdf15f7',
          file_name:
            'audios/b6fec65aa6426be7cf2211c63a28ef2f731285ce5b2c4f609c3607f38bdf15f7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b6fec65aa6426be7cf2211c63a28ef2f731285ce5b2c4f609c3607f38bdf15f7.mp3',
          name: 'BEG-INT-ADV-Alternating_Side_Lunge_and_Chest_Press-EXERCISE',
          description: null,
          size: 38637,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-ALTERNATING_SIDE_LUNGE_AND_CHEST_PRESS-EXERCISE': {
      id: 1255,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Side Lunge and Chest Press',
      short_name: 'Alternating Side Lunge and Chest Press',
      unique_name:
        'INTERMEDIATE-ALTERNATING_SIDE_LUNGE_AND_CHEST_PRESS-EXERCISE',
      description:
        '1. Stand tall, feet and legs together in a close stance, holding a medicine ball in front of your chest. \n2. Keeping your chest up, take a big step out to the side as wide as possible, toes forward. \n3. When you land, bend your knee and sink hips to about 90 degrees while pressing the medicine ball straight out in front of your chest. Keep the other leg straight and foot planted on the floor.\n4. Powerfully drive through your heel and push yourself up to stand as you bring the ball back in to start position. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3340,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'd5f162a20efd289be2f9734a5efe0c287216e1d566edda6dc3ae2a32fe6f0c4b',
          file_name:
            'videos/d5f162a20efd289be2f9734a5efe0c287216e1d566edda6dc3ae2a32fe6f0c4b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d5f162a20efd289be2f9734a5efe0c287216e1d566edda6dc3ae2a32fe6f0c4b.mp4',
          name: 'BEG-INT-ADV-Alternating_Side_Lunge_and_Chest_Press-EXERCISE',
          description: null,
          size: 241074,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3341,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'b6fec65aa6426be7cf2211c63a28ef2f731285ce5b2c4f609c3607f38bdf15f7',
          file_name:
            'audios/b6fec65aa6426be7cf2211c63a28ef2f731285ce5b2c4f609c3607f38bdf15f7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b6fec65aa6426be7cf2211c63a28ef2f731285ce5b2c4f609c3607f38bdf15f7.mp3',
          name: 'BEG-INT-ADV-Alternating_Side_Lunge_and_Chest_Press-EXERCISE',
          description: null,
          size: 38637,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-ALTERNATING_SIDE_LUNGE_AND_CHEST_PRESS-EXERCISE': {
      id: 1256,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Alternating Side Lunge and Chest Press',
      short_name: 'Alternating Side Lunge and Chest Press',
      unique_name: 'ADVANCED-ALTERNATING_SIDE_LUNGE_AND_CHEST_PRESS-EXERCISE',
      description:
        '1. Stand tall, feet and legs together in a close stance, holding a medicine ball in front of your chest. \n2. Keeping your chest up, take a big step out to the side as wide as possible, toes forward. \n3. When you land, bend your knee and sink hips to about 90 degrees while pressing the medicine ball straight out in front of your chest. Keep the other leg straight and foot planted on the floor.\n4. Powerfully drive through your heel and push yourself up to stand as you bring the ball back in to start position. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3342,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'd5f162a20efd289be2f9734a5efe0c287216e1d566edda6dc3ae2a32fe6f0c4b',
          file_name:
            'videos/d5f162a20efd289be2f9734a5efe0c287216e1d566edda6dc3ae2a32fe6f0c4b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d5f162a20efd289be2f9734a5efe0c287216e1d566edda6dc3ae2a32fe6f0c4b.mp4',
          name: 'BEG-INT-ADV-Alternating_Side_Lunge_and_Chest_Press-EXERCISE',
          description: null,
          size: 241074,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3343,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'b6fec65aa6426be7cf2211c63a28ef2f731285ce5b2c4f609c3607f38bdf15f7',
          file_name:
            'audios/b6fec65aa6426be7cf2211c63a28ef2f731285ce5b2c4f609c3607f38bdf15f7.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b6fec65aa6426be7cf2211c63a28ef2f731285ce5b2c4f609c3607f38bdf15f7.mp3',
          name: 'BEG-INT-ADV-Alternating_Side_Lunge_and_Chest_Press-EXERCISE',
          description: null,
          size: 38637,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SLAMS-EXERCISE': {
      id: 1257,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Slams',
      short_name: 'Slams',
      unique_name: 'BEGINNER-SLAMS-EXERCISE',
      description:
        '1. Stand with feet about hip-width apart holding a medicine ball in front of your chest. \n2. Extend arms and raise the ball directly overhead. \n3. Exhale, engage core and explosively slam the ball in front of your feet. Bend both knees in a partial squat. \n4. Catch the ball and return to stand.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3344,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '784d25eb09d2dbdea30f2a56311011d73ca283d3add1fa2cc01ea35460dd422b',
          file_name:
            'videos/784d25eb09d2dbdea30f2a56311011d73ca283d3add1fa2cc01ea35460dd422b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/784d25eb09d2dbdea30f2a56311011d73ca283d3add1fa2cc01ea35460dd422b.mp4',
          name: 'BEG-INT-ADV-Slams-EXERCISE',
          description: null,
          size: 97335,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3345,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '6096875fca60f3a857db14c51e2ae1aa3c76e20a1b90cdadfdd45cd6a8a345df',
          file_name:
            'audios/6096875fca60f3a857db14c51e2ae1aa3c76e20a1b90cdadfdd45cd6a8a345df.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6096875fca60f3a857db14c51e2ae1aa3c76e20a1b90cdadfdd45cd6a8a345df.mp3',
          name: 'BEG-INT-ADV-Slams-EXERCISE',
          description: null,
          size: 17325,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SLAMS-EXERCISE': {
      id: 1258,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Slams',
      short_name: 'Slams',
      unique_name: 'INTERMEDIATE-SLAMS-EXERCISE',
      description:
        '1. Stand with feet about hip-width apart holding a medicine ball in front of your chest. \n2. Extend arms and raise the ball directly overhead. \n3. Exhale, engage core and explosively slam the ball in front of your feet. Bend both knees in a partial squat. \n4. Catch the ball and return to stand.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3346,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '784d25eb09d2dbdea30f2a56311011d73ca283d3add1fa2cc01ea35460dd422b',
          file_name:
            'videos/784d25eb09d2dbdea30f2a56311011d73ca283d3add1fa2cc01ea35460dd422b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/784d25eb09d2dbdea30f2a56311011d73ca283d3add1fa2cc01ea35460dd422b.mp4',
          name: 'BEG-INT-ADV-Slams-EXERCISE',
          description: null,
          size: 97335,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3347,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '6096875fca60f3a857db14c51e2ae1aa3c76e20a1b90cdadfdd45cd6a8a345df',
          file_name:
            'audios/6096875fca60f3a857db14c51e2ae1aa3c76e20a1b90cdadfdd45cd6a8a345df.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6096875fca60f3a857db14c51e2ae1aa3c76e20a1b90cdadfdd45cd6a8a345df.mp3',
          name: 'BEG-INT-ADV-Slams-EXERCISE',
          description: null,
          size: 17325,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SLAMS-EXERCISE': {
      id: 1259,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Slams',
      short_name: 'Slams',
      unique_name: 'ADVANCED-SLAMS-EXERCISE',
      description:
        '1. Stand with feet about hip-width apart holding a medicine ball in front of your chest. \n2. Extend arms and raise the ball directly overhead. \n3. Exhale, engage core and explosively slam the ball in front of your feet. Bend both knees in a partial squat. \n4. Catch the ball and return to stand.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3348,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '784d25eb09d2dbdea30f2a56311011d73ca283d3add1fa2cc01ea35460dd422b',
          file_name:
            'videos/784d25eb09d2dbdea30f2a56311011d73ca283d3add1fa2cc01ea35460dd422b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/784d25eb09d2dbdea30f2a56311011d73ca283d3add1fa2cc01ea35460dd422b.mp4',
          name: 'BEG-INT-ADV-Slams-EXERCISE',
          description: null,
          size: 97335,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3349,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '6096875fca60f3a857db14c51e2ae1aa3c76e20a1b90cdadfdd45cd6a8a345df',
          file_name:
            'audios/6096875fca60f3a857db14c51e2ae1aa3c76e20a1b90cdadfdd45cd6a8a345df.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6096875fca60f3a857db14c51e2ae1aa3c76e20a1b90cdadfdd45cd6a8a345df.mp3',
          name: 'BEG-INT-ADV-Slams-EXERCISE',
          description: null,
          size: 17325,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-V_SIT_PRESS-EXERCISE': {
      id: 1260,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'V Sit Press',
      short_name: 'V Sit Press',
      unique_name: 'INTERMEDIATE-V_SIT_PRESS-EXERCISE',
      description:
        '1. Sit on the floor with your knees bent at 90 degrees, legs and feet together. Hold a medicine ball in front of your chest. \n2. Lean back slightly and elevate your feet off the floor. Keep core tight, shoulders back and chin neutral.\n3. Extend your arms and press the medicine ball away from your body.\n4. Bend elbows and return medicine ball back to start position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3350,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '0347a75c2f06b26dc7049b750e0ab915df0107f07a4dbc24cbc7919fa27af389',
          file_name:
            'videos/0347a75c2f06b26dc7049b750e0ab915df0107f07a4dbc24cbc7919fa27af389.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0347a75c2f06b26dc7049b750e0ab915df0107f07a4dbc24cbc7919fa27af389.mp4',
          name: 'INT-ADV-V_Sit_Press-EXERCISE',
          description: null,
          size: 46669,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3351,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '7e0da0cea6d08df7d4088ffc6187b1577f27531c1dbdc6c34629ca1cfb6fb18d',
          file_name:
            'audios/7e0da0cea6d08df7d4088ffc6187b1577f27531c1dbdc6c34629ca1cfb6fb18d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7e0da0cea6d08df7d4088ffc6187b1577f27531c1dbdc6c34629ca1cfb6fb18d.mp3',
          name: 'INT-ADV-V_Sit_Press-EXERCISE',
          description: null,
          size: 24525,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-V_SIT_PRESS-EXERCISE': {
      id: 1261,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'V Sit Press',
      short_name: 'V Sit Press',
      unique_name: 'ADVANCED-V_SIT_PRESS-EXERCISE',
      description:
        '1. Sit on the floor with your knees bent at 90 degrees, legs and feet together. Hold a medicine ball in front of your chest. \n2. Lean back slightly and elevate your feet off the floor. Keep core tight, shoulders back and chin neutral.\n3. Extend your arms and press the medicine ball away from your body.\n4. Bend elbows and return medicine ball back to start position.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3352,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '0347a75c2f06b26dc7049b750e0ab915df0107f07a4dbc24cbc7919fa27af389',
          file_name:
            'videos/0347a75c2f06b26dc7049b750e0ab915df0107f07a4dbc24cbc7919fa27af389.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0347a75c2f06b26dc7049b750e0ab915df0107f07a4dbc24cbc7919fa27af389.mp4',
          name: 'INT-ADV-V_Sit_Press-EXERCISE',
          description: null,
          size: 46669,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3353,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '7e0da0cea6d08df7d4088ffc6187b1577f27531c1dbdc6c34629ca1cfb6fb18d',
          file_name:
            'audios/7e0da0cea6d08df7d4088ffc6187b1577f27531c1dbdc6c34629ca1cfb6fb18d.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/7e0da0cea6d08df7d4088ffc6187b1577f27531c1dbdc6c34629ca1cfb6fb18d.mp3',
          name: 'INT-ADV-V_Sit_Press-EXERCISE',
          description: null,
          size: 24525,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-V_SIT_THROW-EXERCISE': {
      id: 1262,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'V Sit Throw',
      short_name: 'V Sit Throw',
      unique_name: 'INTERMEDIATE-V_SIT_THROW-EXERCISE',
      description:
        '1. Sit on the floor with your knees bent at 90 degrees, legs and feet together. Hold a medicine ball in front of your chest. \n2. Lean back slightly and elevate your feet off the floor. Keep core tight, shoulders back and chin neutral.\n3. Extend your arms and toss the medicine ball up and away from your body.\n4. Catch the medicine ball and return to your chest.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3354,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '9bee52185b7b5e7fd54db3d97a484a311be33ecf54d2392f1bac6879d024d8e7',
          file_name:
            'videos/9bee52185b7b5e7fd54db3d97a484a311be33ecf54d2392f1bac6879d024d8e7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9bee52185b7b5e7fd54db3d97a484a311be33ecf54d2392f1bac6879d024d8e7.mp4',
          name: 'INT-ADV-V_Sit_Throw-EXERCISE',
          description: null,
          size: 56396,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3355,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'f9090c5f4775395a82b25b96020bf66b50b09e19161516cffa4ed10afe30e966',
          file_name:
            'audios/f9090c5f4775395a82b25b96020bf66b50b09e19161516cffa4ed10afe30e966.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f9090c5f4775395a82b25b96020bf66b50b09e19161516cffa4ed10afe30e966.mp3',
          name: 'INT-ADV-V_Sit_Throw-EXERCISE',
          description: null,
          size: 23661,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-V_SIT_THROW-EXERCISE': {
      id: 1263,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'V Sit Throw',
      short_name: 'V Sit Throw',
      unique_name: 'ADVANCED-V_SIT_THROW-EXERCISE',
      description:
        '1. Sit on the floor with your knees bent at 90 degrees, legs and feet together. Hold a medicine ball in front of your chest. \n2. Lean back slightly and elevate your feet off the floor. Keep core tight, shoulders back and chin neutral.\n3. Extend your arms and toss the medicine ball up and away from your body.\n4. Catch the medicine ball and return to your chest.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3356,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '9bee52185b7b5e7fd54db3d97a484a311be33ecf54d2392f1bac6879d024d8e7',
          file_name:
            'videos/9bee52185b7b5e7fd54db3d97a484a311be33ecf54d2392f1bac6879d024d8e7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9bee52185b7b5e7fd54db3d97a484a311be33ecf54d2392f1bac6879d024d8e7.mp4',
          name: 'INT-ADV-V_Sit_Throw-EXERCISE',
          description: null,
          size: 56396,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3357,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'f9090c5f4775395a82b25b96020bf66b50b09e19161516cffa4ed10afe30e966',
          file_name:
            'audios/f9090c5f4775395a82b25b96020bf66b50b09e19161516cffa4ed10afe30e966.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/f9090c5f4775395a82b25b96020bf66b50b09e19161516cffa4ed10afe30e966.mp3',
          name: 'INT-ADV-V_Sit_Throw-EXERCISE',
          description: null,
          size: 23661,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-DIAGONAL_WOODCHOPPERS-EXERCISE': {
      id: 1264,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Diagonal Woodchoppers',
      short_name: 'Diagonal Woodchoppers',
      unique_name: 'BEGINNER-DIAGONAL_WOODCHOPPERS-EXERCISE',
      description:
        '1. Stand tall, feet slightly wider than shoulder-width. Hold a medicine ball with both hands next to one hip. \n2. Keeping hips square, raise both arms up and at a diagonal over the opposite shoulder, arms straight.\n3. Keeping arms straight, engage core and swiftly chop down and across your body back to your hip. Bend knees at the bottom of the chop. \n4. Raise arms back up again to repeat. Perform all reps on one side. Repeat in the other direction.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3358,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '56a1ef425d9e5bd0b6b4d0648db8c371cfb43cb4fad9d68f9a745e78d7634786',
          file_name:
            'videos/56a1ef425d9e5bd0b6b4d0648db8c371cfb43cb4fad9d68f9a745e78d7634786.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/56a1ef425d9e5bd0b6b4d0648db8c371cfb43cb4fad9d68f9a745e78d7634786.mp4',
          name: 'BEG-INT-ADV-Diagonal_Woodchoppers-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 108205,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3359,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'b319276f63e99e4070cc3568f849e195a72a6d6b02361e74a38eaac83c45e687',
          file_name:
            'videos/b319276f63e99e4070cc3568f849e195a72a6d6b02361e74a38eaac83c45e687.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b319276f63e99e4070cc3568f849e195a72a6d6b02361e74a38eaac83c45e687.mp4',
          name: 'BEG-INT-ADV-Diagonal_Woodchoppers-EXERCISE-LEFT',
          description: 'Left Side',
          size: 102087,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3360,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '1dd352caffbed92f7901a6b124e913616b14c2da23ff8a16589cdffeb1f307ac',
          file_name:
            'audios/1dd352caffbed92f7901a6b124e913616b14c2da23ff8a16589cdffeb1f307ac.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1dd352caffbed92f7901a6b124e913616b14c2da23ff8a16589cdffeb1f307ac.mp3',
          name: 'BEG-INT-ADV-Diagonal_Woodchoppers-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 27981,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DIAGONAL_WOODCHOPPERS-EXERCISE': {
      id: 1265,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Diagonal Woodchoppers',
      short_name: 'Diagonal Woodchoppers',
      unique_name: 'INTERMEDIATE-DIAGONAL_WOODCHOPPERS-EXERCISE',
      description:
        '1. Stand tall, feet slightly wider than shoulder-width. Hold a medicine ball with both hands next to one hip. \n2. Keeping hips square, raise both arms up and at a diagonal over the opposite shoulder, arms straight.\n3. Keeping arms straight, engage core and swiftly chop down and across your body back to your hip. Bend knees at the bottom of the chop. \n4. Raise arms back up again to repeat. Perform all reps on one side. Repeat in the other direction.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3361,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '56a1ef425d9e5bd0b6b4d0648db8c371cfb43cb4fad9d68f9a745e78d7634786',
          file_name:
            'videos/56a1ef425d9e5bd0b6b4d0648db8c371cfb43cb4fad9d68f9a745e78d7634786.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/56a1ef425d9e5bd0b6b4d0648db8c371cfb43cb4fad9d68f9a745e78d7634786.mp4',
          name: 'BEG-INT-ADV-Diagonal_Woodchoppers-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 108205,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3362,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'b319276f63e99e4070cc3568f849e195a72a6d6b02361e74a38eaac83c45e687',
          file_name:
            'videos/b319276f63e99e4070cc3568f849e195a72a6d6b02361e74a38eaac83c45e687.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b319276f63e99e4070cc3568f849e195a72a6d6b02361e74a38eaac83c45e687.mp4',
          name: 'BEG-INT-ADV-Diagonal_Woodchoppers-EXERCISE-LEFT',
          description: 'Left Side',
          size: 102087,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3363,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '1dd352caffbed92f7901a6b124e913616b14c2da23ff8a16589cdffeb1f307ac',
          file_name:
            'audios/1dd352caffbed92f7901a6b124e913616b14c2da23ff8a16589cdffeb1f307ac.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1dd352caffbed92f7901a6b124e913616b14c2da23ff8a16589cdffeb1f307ac.mp3',
          name: 'BEG-INT-ADV-Diagonal_Woodchoppers-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 27981,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DIAGONAL_WOODCHOPPERS-EXERCISE': {
      id: 1266,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Diagonal Woodchoppers',
      short_name: 'Diagonal Woodchoppers',
      unique_name: 'ADVANCED-DIAGONAL_WOODCHOPPERS-EXERCISE',
      description:
        '1. Stand tall, feet slightly wider than shoulder-width. Hold a medicine ball with both hands next to one hip. \n2. Keeping hips square, raise both arms up and at a diagonal over the opposite shoulder, arms straight.\n3. Keeping arms straight, engage core and swiftly chop down and across your body back to your hip. Bend knees at the bottom of the chop. \n4. Raise arms back up again to repeat. Perform all reps on one side. Repeat in the other direction.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3364,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '56a1ef425d9e5bd0b6b4d0648db8c371cfb43cb4fad9d68f9a745e78d7634786',
          file_name:
            'videos/56a1ef425d9e5bd0b6b4d0648db8c371cfb43cb4fad9d68f9a745e78d7634786.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/56a1ef425d9e5bd0b6b4d0648db8c371cfb43cb4fad9d68f9a745e78d7634786.mp4',
          name: 'BEG-INT-ADV-Diagonal_Woodchoppers-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 108205,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3365,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'b319276f63e99e4070cc3568f849e195a72a6d6b02361e74a38eaac83c45e687',
          file_name:
            'videos/b319276f63e99e4070cc3568f849e195a72a6d6b02361e74a38eaac83c45e687.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b319276f63e99e4070cc3568f849e195a72a6d6b02361e74a38eaac83c45e687.mp4',
          name: 'BEG-INT-ADV-Diagonal_Woodchoppers-EXERCISE-LEFT',
          description: 'Left Side',
          size: 102087,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3366,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '1dd352caffbed92f7901a6b124e913616b14c2da23ff8a16589cdffeb1f307ac',
          file_name:
            'audios/1dd352caffbed92f7901a6b124e913616b14c2da23ff8a16589cdffeb1f307ac.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1dd352caffbed92f7901a6b124e913616b14c2da23ff8a16589cdffeb1f307ac.mp3',
          name: 'BEG-INT-ADV-Diagonal_Woodchoppers-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 27981,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-RUSSIAN_TWIST_SLAMS-EXERCISE': {
      id: 1267,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Russian Twist Slams',
      short_name: 'Russian Twist Slams',
      unique_name: 'INTERMEDIATE-RUSSIAN_TWIST_SLAMS-EXERCISE',
      description:
        "1. Sit on the floor with your knees bent at 90 degrees, legs and feet together. Hold a medicine ball at your chest. \n2. Keeping core engaged, lean back slightly and raise the medicine ball overhead. \n3. Twist your upper body to one side and slam the ball on the floor by your hip. Feet and legs don't move.\n4. Catch the ball and slam to the other side. Right and left equals one rep.",
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3367,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'ba8d276c02f92bfe02206293c9c8ac5a9293c2211a96c047f2f0317316edbf65',
          file_name:
            'videos/ba8d276c02f92bfe02206293c9c8ac5a9293c2211a96c047f2f0317316edbf65.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ba8d276c02f92bfe02206293c9c8ac5a9293c2211a96c047f2f0317316edbf65.mp4',
          name: 'INT-ADV-Russian_Twist_Slams-EXERCISE',
          description: null,
          size: 119428,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3368,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '6e459623de542a0e6cfc59f3838ab0a957b578fcfde4be769f165323c8439917',
          file_name:
            'audios/6e459623de542a0e6cfc59f3838ab0a957b578fcfde4be769f165323c8439917.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6e459623de542a0e6cfc59f3838ab0a957b578fcfde4be769f165323c8439917.mp3',
          name: 'INT-ADV-Russian_Twist_Slams-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-RUSSIAN_TWIST_SLAMS-EXERCISE': {
      id: 1268,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Russian Twist Slams',
      short_name: 'Russian Twist Slams',
      unique_name: 'ADVANCED-RUSSIAN_TWIST_SLAMS-EXERCISE',
      description:
        "1. Sit on the floor with your knees bent at 90 degrees, legs and feet together. Hold a medicine ball at your chest. \n2. Keeping core engaged, lean back slightly and raise the medicine ball overhead. \n3. Twist your upper body to one side and slam the ball on the floor by your hip. Feet and legs don't move.\n4. Catch the ball and slam to the other side. Right and left equals one rep.",
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3369,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'ba8d276c02f92bfe02206293c9c8ac5a9293c2211a96c047f2f0317316edbf65',
          file_name:
            'videos/ba8d276c02f92bfe02206293c9c8ac5a9293c2211a96c047f2f0317316edbf65.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ba8d276c02f92bfe02206293c9c8ac5a9293c2211a96c047f2f0317316edbf65.mp4',
          name: 'INT-ADV-Russian_Twist_Slams-EXERCISE',
          description: null,
          size: 119428,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3370,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '6e459623de542a0e6cfc59f3838ab0a957b578fcfde4be769f165323c8439917',
          file_name:
            'audios/6e459623de542a0e6cfc59f3838ab0a957b578fcfde4be769f165323c8439917.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6e459623de542a0e6cfc59f3838ab0a957b578fcfde4be769f165323c8439917.mp3',
          name: 'INT-ADV-Russian_Twist_Slams-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-V_SIT_SCISSOR_PASS-EXERCISE': {
      id: 1269,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'V Sit Scissor Pass',
      short_name: 'V Sit Scissor Pass',
      unique_name: 'INTERMEDIATE-V_SIT_SCISSOR_PASS-EXERCISE',
      description:
        '1. Sit on the floor with your knees bent at 90 degrees, legs and feet together. Hold a medicine ball at your chest.   \n2. Lean back slightly and elevate your feet off the floor. Keep core tight, shoulders back and chin neutral.\n3. Lower one leg down toward the floor to a hover and pass the ball underneath the top leg. \n3. Bring the top leg down and bottom leg up to switch.\n4. Repeat in a continuous motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3371,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '17f9d98b96e52f57e8a37bff9da87340752cd6acacfb800944f6e99fe867c33d',
          file_name:
            'videos/17f9d98b96e52f57e8a37bff9da87340752cd6acacfb800944f6e99fe867c33d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/17f9d98b96e52f57e8a37bff9da87340752cd6acacfb800944f6e99fe867c33d.mp4',
          name: 'INT-ADV-V_Sit_Scissor_Pass-EXERCISE',
          description: null,
          size: 112652,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3372,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'cb8c2ab0a12e86661d6f02966b70a290b856b1462f067edc1ae22f0149b83b49',
          file_name:
            'audios/cb8c2ab0a12e86661d6f02966b70a290b856b1462f067edc1ae22f0149b83b49.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cb8c2ab0a12e86661d6f02966b70a290b856b1462f067edc1ae22f0149b83b49.mp3',
          name: 'INT-ADV-V_Sit_Scissor_Pass-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-V_SIT_SCISSOR_PASS-EXERCISE': {
      id: 1270,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'V Sit Scissor Pass',
      short_name: 'V Sit Scissor Pass',
      unique_name: 'ADVANCED-V_SIT_SCISSOR_PASS-EXERCISE',
      description:
        '1. Sit on the floor with your knees bent at 90 degrees, legs and feet together. Hold a medicine ball at your chest.   \n2. Lean back slightly and elevate your feet off the floor. Keep core tight, shoulders back and chin neutral.\n3. Lower one leg down toward the floor to a hover and pass the ball underneath the top leg. \n3. Bring the top leg down and bottom leg up to switch.\n4. Repeat in a continuous motion. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3373,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '17f9d98b96e52f57e8a37bff9da87340752cd6acacfb800944f6e99fe867c33d',
          file_name:
            'videos/17f9d98b96e52f57e8a37bff9da87340752cd6acacfb800944f6e99fe867c33d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/17f9d98b96e52f57e8a37bff9da87340752cd6acacfb800944f6e99fe867c33d.mp4',
          name: 'INT-ADV-V_Sit_Scissor_Pass-EXERCISE',
          description: null,
          size: 112652,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3374,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'cb8c2ab0a12e86661d6f02966b70a290b856b1462f067edc1ae22f0149b83b49',
          file_name:
            'audios/cb8c2ab0a12e86661d6f02966b70a290b856b1462f067edc1ae22f0149b83b49.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cb8c2ab0a12e86661d6f02966b70a290b856b1462f067edc1ae22f0149b83b49.mp3',
          name: 'INT-ADV-V_Sit_Scissor_Pass-EXERCISE',
          description: null,
          size: 25101,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-OFFSET_PUSH_UPS_ON_KNEES-EXERCISE': {
      id: 1271,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Offset Push Ups on Knees',
      short_name: 'Offset Push Ups on Knees',
      unique_name: 'INTERMEDIATE-OFFSET_PUSH_UPS_ON_KNEES-EXERCISE',
      description:
        '1. Start in Plank position, one hand on a medicine ball, shoulders over wrists. Drop your knees straight down to the floor and lift your feet up. \n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor. \n3. Straighten your arms and raise your body back up in one long line from the crown of your head to your tailbone.\n4. Perform all reps. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3375,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '628e5914892a047e4c008a9b8c558cf3e14cdb8cc38b57dc619a3556c91b9b09',
          file_name:
            'videos/628e5914892a047e4c008a9b8c558cf3e14cdb8cc38b57dc619a3556c91b9b09.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/628e5914892a047e4c008a9b8c558cf3e14cdb8cc38b57dc619a3556c91b9b09.mp4',
          name: 'INT-ADV-Offset_Push_Ups_on_Knees-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 84559,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3376,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '2e9a07504398b053b553728f5613bdb425fa825c6ad2d4dd90d1b1396c10822f',
          file_name:
            'videos/2e9a07504398b053b553728f5613bdb425fa825c6ad2d4dd90d1b1396c10822f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2e9a07504398b053b553728f5613bdb425fa825c6ad2d4dd90d1b1396c10822f.mp4',
          name: 'INT-ADV-Offset_Push_Ups_on_Knees-EXERCISE-LEFT',
          description: 'Left Side',
          size: 86303,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3377,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '8e15d7893c6ac4a0759ba315b0cc48664cffe291b47ae825d2475247d296c1ed',
          file_name:
            'audios/8e15d7893c6ac4a0759ba315b0cc48664cffe291b47ae825d2475247d296c1ed.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8e15d7893c6ac4a0759ba315b0cc48664cffe291b47ae825d2475247d296c1ed.mp3',
          name: 'INT-ADV-Offset_Push_Ups_on_Knees-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 31149,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-OFFSET_PUSH_UPS_ON_KNEES-EXERCISE': {
      id: 1272,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Offset Push Ups on Knees',
      short_name: 'Offset Push Ups on Knees',
      unique_name: 'ADVANCED-OFFSET_PUSH_UPS_ON_KNEES-EXERCISE',
      description:
        '1. Start in Plank position, one hand on a medicine ball, shoulders over wrists. Drop your knees straight down to the floor and lift your feet up. \n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor. \n3. Straighten your arms and raise your body back up in one long line from the crown of your head to your tailbone.\n4. Perform all reps. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3378,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '628e5914892a047e4c008a9b8c558cf3e14cdb8cc38b57dc619a3556c91b9b09',
          file_name:
            'videos/628e5914892a047e4c008a9b8c558cf3e14cdb8cc38b57dc619a3556c91b9b09.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/628e5914892a047e4c008a9b8c558cf3e14cdb8cc38b57dc619a3556c91b9b09.mp4',
          name: 'INT-ADV-Offset_Push_Ups_on_Knees-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 84559,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3379,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '2e9a07504398b053b553728f5613bdb425fa825c6ad2d4dd90d1b1396c10822f',
          file_name:
            'videos/2e9a07504398b053b553728f5613bdb425fa825c6ad2d4dd90d1b1396c10822f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2e9a07504398b053b553728f5613bdb425fa825c6ad2d4dd90d1b1396c10822f.mp4',
          name: 'INT-ADV-Offset_Push_Ups_on_Knees-EXERCISE-LEFT',
          description: 'Left Side',
          size: 86303,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3380,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '8e15d7893c6ac4a0759ba315b0cc48664cffe291b47ae825d2475247d296c1ed',
          file_name:
            'audios/8e15d7893c6ac4a0759ba315b0cc48664cffe291b47ae825d2475247d296c1ed.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/8e15d7893c6ac4a0759ba315b0cc48664cffe291b47ae825d2475247d296c1ed.mp3',
          name: 'INT-ADV-Offset_Push_Ups_on_Knees-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 31149,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-KNEELING_WOODCHOPPERS-EXERCISE': {
      id: 1273,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Kneeling Woodchoppers',
      short_name: 'Kneeling Woodchoppers',
      unique_name: 'BEGINNER-KNEELING_WOODCHOPPERS-EXERCISE',
      description:
        '1. Start in half kneeling position, knee over ankle, hips square. Hold a medicine ball in both hands down by the hip of your bottom leg. \n2. Keeping hips square and arms straight, raise the ball up and at a diagonal over the opposite shoulder.\n3. Engage your core and swiftly chop down and across your body back down to your hip. \n4. Raise arms back up again to repeat. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3381,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '547e8fb25fd18a7f508c1ec52c66b2a45df581a753bfefebc1fd4d61b9f27337',
          file_name:
            'videos/547e8fb25fd18a7f508c1ec52c66b2a45df581a753bfefebc1fd4d61b9f27337.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/547e8fb25fd18a7f508c1ec52c66b2a45df581a753bfefebc1fd4d61b9f27337.mp4',
          name: 'BEG-INT-ADV-Kneeling_Woodchoppers-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 90897,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3382,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'a79853849bf44da57ee6dbeb7856cbcb9635df9ff280c05594e606d67f4ed900',
          file_name:
            'videos/a79853849bf44da57ee6dbeb7856cbcb9635df9ff280c05594e606d67f4ed900.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a79853849bf44da57ee6dbeb7856cbcb9635df9ff280c05594e606d67f4ed900.mp4',
          name: 'BEG-INT-ADV-Kneeling_Woodchoppers-EXERCISE-LEFT',
          description: 'Left Side',
          size: 85770,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3383,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '85ea64816f86ce1c18722bd8c528eac0b8dfdb218e9382efc763e90e63bcd599',
          file_name:
            'audios/85ea64816f86ce1c18722bd8c528eac0b8dfdb218e9382efc763e90e63bcd599.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/85ea64816f86ce1c18722bd8c528eac0b8dfdb218e9382efc763e90e63bcd599.mp3',
          name: 'BEG-INT-ADV-Kneeling_Woodchoppers-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25047,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KNEELING_WOODCHOPPERS-EXERCISE': {
      id: 1274,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Kneeling Woodchoppers',
      short_name: 'Kneeling Woodchoppers',
      unique_name: 'INTERMEDIATE-KNEELING_WOODCHOPPERS-EXERCISE',
      description:
        '1. Start in half kneeling position, knee over ankle, hips square. Hold a medicine ball in both hands down by the hip of your bottom leg. \n2. Keeping hips square and arms straight, raise the ball up and at a diagonal over the opposite shoulder.\n3. Engage your core and swiftly chop down and across your body back down to your hip. \n4. Raise arms back up again to repeat. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3384,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '547e8fb25fd18a7f508c1ec52c66b2a45df581a753bfefebc1fd4d61b9f27337',
          file_name:
            'videos/547e8fb25fd18a7f508c1ec52c66b2a45df581a753bfefebc1fd4d61b9f27337.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/547e8fb25fd18a7f508c1ec52c66b2a45df581a753bfefebc1fd4d61b9f27337.mp4',
          name: 'BEG-INT-ADV-Kneeling_Woodchoppers-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 90897,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3385,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'a79853849bf44da57ee6dbeb7856cbcb9635df9ff280c05594e606d67f4ed900',
          file_name:
            'videos/a79853849bf44da57ee6dbeb7856cbcb9635df9ff280c05594e606d67f4ed900.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a79853849bf44da57ee6dbeb7856cbcb9635df9ff280c05594e606d67f4ed900.mp4',
          name: 'BEG-INT-ADV-Kneeling_Woodchoppers-EXERCISE-LEFT',
          description: 'Left Side',
          size: 85770,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3386,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '85ea64816f86ce1c18722bd8c528eac0b8dfdb218e9382efc763e90e63bcd599',
          file_name:
            'audios/85ea64816f86ce1c18722bd8c528eac0b8dfdb218e9382efc763e90e63bcd599.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/85ea64816f86ce1c18722bd8c528eac0b8dfdb218e9382efc763e90e63bcd599.mp3',
          name: 'BEG-INT-ADV-Kneeling_Woodchoppers-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25047,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KNEELING_WOODCHOPPERS-EXERCISE': {
      id: 1275,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Kneeling Woodchoppers',
      short_name: 'Kneeling Woodchoppers',
      unique_name: 'ADVANCED-KNEELING_WOODCHOPPERS-EXERCISE',
      description:
        '1. Start in half kneeling position, knee over ankle, hips square. Hold a medicine ball in both hands down by the hip of your bottom leg. \n2. Keeping hips square and arms straight, raise the ball up and at a diagonal over the opposite shoulder.\n3. Engage your core and swiftly chop down and across your body back down to your hip. \n4. Raise arms back up again to repeat. Perform all reps on one side. Repeat on the other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3387,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '547e8fb25fd18a7f508c1ec52c66b2a45df581a753bfefebc1fd4d61b9f27337',
          file_name:
            'videos/547e8fb25fd18a7f508c1ec52c66b2a45df581a753bfefebc1fd4d61b9f27337.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/547e8fb25fd18a7f508c1ec52c66b2a45df581a753bfefebc1fd4d61b9f27337.mp4',
          name: 'BEG-INT-ADV-Kneeling_Woodchoppers-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 90897,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3388,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'a79853849bf44da57ee6dbeb7856cbcb9635df9ff280c05594e606d67f4ed900',
          file_name:
            'videos/a79853849bf44da57ee6dbeb7856cbcb9635df9ff280c05594e606d67f4ed900.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a79853849bf44da57ee6dbeb7856cbcb9635df9ff280c05594e606d67f4ed900.mp4',
          name: 'BEG-INT-ADV-Kneeling_Woodchoppers-EXERCISE-LEFT',
          description: 'Left Side',
          size: 85770,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3389,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '85ea64816f86ce1c18722bd8c528eac0b8dfdb218e9382efc763e90e63bcd599',
          file_name:
            'audios/85ea64816f86ce1c18722bd8c528eac0b8dfdb218e9382efc763e90e63bcd599.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/85ea64816f86ce1c18722bd8c528eac0b8dfdb218e9382efc763e90e63bcd599.mp3',
          name: 'BEG-INT-ADV-Kneeling_Woodchoppers-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 25047,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-PUSH_UP_AND_BALL_PASS_ON_KNEES-EXERCISE': {
      id: 1276,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Push Up and Ball Pass on Knees',
      short_name: 'Push Up and Ball Pass on Knees',
      unique_name: 'BEGINNER-PUSH_UP_AND_BALL_PASS_ON_KNEES-EXERCISE',
      description:
        '1. Start in Knee Plank, shoulders over wrists, knees on floor and feet raised. Place one hand on a medicine ball.\n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor.\n3. Straighten your arms and raise your body back up. \n4. Roll the ball laterally to the opposite side and place your hand on the floor. \n5. Place the other hand on the ball and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3390,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'b224244db8ff29d8c6eff49959010d23c144e4347ecc42112ff0ce925feca211',
          file_name:
            'videos/b224244db8ff29d8c6eff49959010d23c144e4347ecc42112ff0ce925feca211.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b224244db8ff29d8c6eff49959010d23c144e4347ecc42112ff0ce925feca211.mp4',
          name: 'BEG-INT-ADV-Push_Up_and_Ball_Pass_on_Knees-EXERCISE',
          description: null,
          size: 247856,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3391,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '11f1b9cda5c37874d859e3e1b7a1ef94e3af51d2020dd3b8e2fc20f5f6b4add5',
          file_name:
            'audios/11f1b9cda5c37874d859e3e1b7a1ef94e3af51d2020dd3b8e2fc20f5f6b4add5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/11f1b9cda5c37874d859e3e1b7a1ef94e3af51d2020dd3b8e2fc20f5f6b4add5.mp3',
          name: 'BEG-INT-ADV-Push_Up_and_Ball_Pass_on_Knees-EXERCISE',
          description: null,
          size: 36045,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-PUSH_UP_AND_BALL_PASS_ON_KNEES-EXERCISE': {
      id: 1277,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Push Up and Ball Pass on Knees',
      short_name: 'Push Up and Ball Pass on Knees',
      unique_name: 'INTERMEDIATE-PUSH_UP_AND_BALL_PASS_ON_KNEES-EXERCISE',
      description:
        '1. Start in Knee Plank, shoulders over wrists, knees on floor and feet raised. Place one hand on a medicine ball.\n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor.\n3. Straighten your arms and raise your body back up. \n4. Roll the ball laterally to the opposite side and place your hand on the floor. \n5. Place the other hand on the ball and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3392,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'b224244db8ff29d8c6eff49959010d23c144e4347ecc42112ff0ce925feca211',
          file_name:
            'videos/b224244db8ff29d8c6eff49959010d23c144e4347ecc42112ff0ce925feca211.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b224244db8ff29d8c6eff49959010d23c144e4347ecc42112ff0ce925feca211.mp4',
          name: 'BEG-INT-ADV-Push_Up_and_Ball_Pass_on_Knees-EXERCISE',
          description: null,
          size: 247856,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3393,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '11f1b9cda5c37874d859e3e1b7a1ef94e3af51d2020dd3b8e2fc20f5f6b4add5',
          file_name:
            'audios/11f1b9cda5c37874d859e3e1b7a1ef94e3af51d2020dd3b8e2fc20f5f6b4add5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/11f1b9cda5c37874d859e3e1b7a1ef94e3af51d2020dd3b8e2fc20f5f6b4add5.mp3',
          name: 'BEG-INT-ADV-Push_Up_and_Ball_Pass_on_Knees-EXERCISE',
          description: null,
          size: 36045,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-PUSH_UP_AND_BALL_PASS_ON_KNEES-EXERCISE': {
      id: 1278,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Push Up and Ball Pass on Knees',
      short_name: 'Push Up and Ball Pass on Knees',
      unique_name: 'ADVANCED-PUSH_UP_AND_BALL_PASS_ON_KNEES-EXERCISE',
      description:
        '1. Start in Knee Plank, shoulders over wrists, knees on floor and feet raised. Place one hand on a medicine ball.\n2. Bend your elbows, pointing them back toward your hips. Lower your body toward the floor.\n3. Straighten your arms and raise your body back up. \n4. Roll the ball laterally to the opposite side and place your hand on the floor. \n5. Place the other hand on the ball and repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 19,
          unique_name: 'TRICEPS',
          name: 'Triceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3394,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'b224244db8ff29d8c6eff49959010d23c144e4347ecc42112ff0ce925feca211',
          file_name:
            'videos/b224244db8ff29d8c6eff49959010d23c144e4347ecc42112ff0ce925feca211.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b224244db8ff29d8c6eff49959010d23c144e4347ecc42112ff0ce925feca211.mp4',
          name: 'BEG-INT-ADV-Push_Up_and_Ball_Pass_on_Knees-EXERCISE',
          description: null,
          size: 247856,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3395,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '11f1b9cda5c37874d859e3e1b7a1ef94e3af51d2020dd3b8e2fc20f5f6b4add5',
          file_name:
            'audios/11f1b9cda5c37874d859e3e1b7a1ef94e3af51d2020dd3b8e2fc20f5f6b4add5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/11f1b9cda5c37874d859e3e1b7a1ef94e3af51d2020dd3b8e2fc20f5f6b4add5.mp3',
          name: 'BEG-INT-ADV-Push_Up_and_Ball_Pass_on_Knees-EXERCISE',
          description: null,
          size: 36045,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-JACK_AND_PRESS_MODIFIED-EXERCISE': {
      id: 1279,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Jack and Press Modified',
      short_name: 'Jack and Press Modified',
      unique_name: 'BEGINNER-JACK_AND_PRESS_MODIFIED-EXERCISE',
      description:
        '1. Stand with your feet close together, holding a medicine ball in front of your chest, elbows down, core tight.\n2. Press the ball directly overhead and tap one foot out directly to the side.\n3. Bring your arms down and leg back to start.\n4. Repeat on the other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3396,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'e7206754985a973353965b99d58543e235c5abd81f583dc51a949e8ebb4c0b85',
          file_name:
            'videos/e7206754985a973353965b99d58543e235c5abd81f583dc51a949e8ebb4c0b85.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e7206754985a973353965b99d58543e235c5abd81f583dc51a949e8ebb4c0b85.mp4',
          name: 'BEG-Jack_and_Press_Modified-EXERCISE',
          description: null,
          size: 158720,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3397,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '6904f34dac141f67a6790eb9e41af6feb71b196c068cb38e891bd606306668e4',
          file_name:
            'audios/6904f34dac141f67a6790eb9e41af6feb71b196c068cb38e891bd606306668e4.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6904f34dac141f67a6790eb9e41af6feb71b196c068cb38e891bd606306668e4.mp3',
          name: 'BEG-Jack_and_Press_Modified-EXERCISE',
          description: null,
          size: 30861,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-MODIFIED_MEDICINE_BALL_TOE_TAPS-EXERCISE': {
      id: 1280,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Modified Medicine Ball Toe Taps',
      short_name: 'Modified Medicine Ball Toe Taps',
      unique_name: 'BEGINNER-MODIFIED_MEDICINE_BALL_TOE_TAPS-EXERCISE',
      description:
        '1. Place a medicine ball on the floor in front of your feet and stand tall. \n2. Lift one leg up and tap your toe on the ball as you hop off the opposite foot. \n2. Return foot to floor and hop with both feet. \n3. Repeat on opposite side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 7,
          name: 'Medicine ball',
          unique_name: 'MEDICINE_BALL',
          min_app_version: 300120000,
          order: 950,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3398,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'd0489a3b7b73990e7948b1b5a8961db1a54bf89bea70b7f084275b12c905cbb1',
          file_name:
            'videos/d0489a3b7b73990e7948b1b5a8961db1a54bf89bea70b7f084275b12c905cbb1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d0489a3b7b73990e7948b1b5a8961db1a54bf89bea70b7f084275b12c905cbb1.mp4',
          name: 'BEG-Modified_Medicine_Ball_Toe_Taps-EXERCISE',
          description: null,
          size: 123454,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3399,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'd42b8bc19ab9c2ed7286c737cbe75509f9c504fa9a1c8ed140ce14219a130787',
          file_name:
            'audios/d42b8bc19ab9c2ed7286c737cbe75509f9c504fa9a1c8ed140ce14219a130787.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/d42b8bc19ab9c2ed7286c737cbe75509f9c504fa9a1c8ed140ce14219a130787.mp3',
          name: 'BEG-Modified_Medicine_Ball_Toe_Taps-EXERCISE',
          description: null,
          size: 30573,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DECK_SQUATS-EXERCISE': {
      id: 1281,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Deck Squats',
      short_name: 'Deck Squats',
      unique_name: 'INTERMEDIATE-DECK_SQUATS-EXERCISE',
      description:
        '1. Stand tall with your feet about shoulder-width apart. \n2. Bend both knees and lower down into a deep squat. \n3. Sit on the floor and roll onto your back with your knees tucked in tightly. \n3. Using momentum and core strength, roll forward and place feet on the floor and land back into a deep squat. \n4. Powerfully extend both legs and jump at the top. Land softly and repeat.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3400,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'c5a9f114de4d34eecf2081e03b410f4a29e517e386276371adb95bb8b7864bba',
          file_name:
            'videos/c5a9f114de4d34eecf2081e03b410f4a29e517e386276371adb95bb8b7864bba.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c5a9f114de4d34eecf2081e03b410f4a29e517e386276371adb95bb8b7864bba.mp4',
          name: 'INT-ADV-Deck_Squats-EXERCISE',
          description: null,
          size: 280349,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3401,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '6f6e3e88ac49aa23d9375bb49f0bad23a494dfc41451b8b5caba92b1ad7f8294',
          file_name:
            'audios/6f6e3e88ac49aa23d9375bb49f0bad23a494dfc41451b8b5caba92b1ad7f8294.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6f6e3e88ac49aa23d9375bb49f0bad23a494dfc41451b8b5caba92b1ad7f8294.mp3',
          name: 'INT-ADV-Deck_Squats-EXERCISE',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DECK_SQUATS-EXERCISE': {
      id: 1282,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Deck Squats',
      short_name: 'Deck Squats',
      unique_name: 'ADVANCED-DECK_SQUATS-EXERCISE',
      description:
        '1. Stand tall with your feet about shoulder-width apart. \n2. Bend both knees and lower down into a deep squat. \n3. Sit on the floor and roll onto your back with your knees tucked in tightly. \n3. Using momentum and core strength, roll forward and place feet on the floor and land back into a deep squat. \n4. Powerfully extend both legs and jump at the top. Land softly and repeat.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3402,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'c5a9f114de4d34eecf2081e03b410f4a29e517e386276371adb95bb8b7864bba',
          file_name:
            'videos/c5a9f114de4d34eecf2081e03b410f4a29e517e386276371adb95bb8b7864bba.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c5a9f114de4d34eecf2081e03b410f4a29e517e386276371adb95bb8b7864bba.mp4',
          name: 'INT-ADV-Deck_Squats-EXERCISE',
          description: null,
          size: 280349,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3403,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '6f6e3e88ac49aa23d9375bb49f0bad23a494dfc41451b8b5caba92b1ad7f8294',
          file_name:
            'audios/6f6e3e88ac49aa23d9375bb49f0bad23a494dfc41451b8b5caba92b1ad7f8294.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/6f6e3e88ac49aa23d9375bb49f0bad23a494dfc41451b8b5caba92b1ad7f8294.mp3',
          name: 'INT-ADV-Deck_Squats-EXERCISE',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-BURPEE_WITH2_PUSH-_UPS-EXERCISE': {
      id: 1283,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Burpee with 2 Push-Ups',
      short_name: 'Burpee with 2 Push-Ups',
      unique_name: 'INTERMEDIATE-BURPEE_WITH2_PUSH-_UPS-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Bend your knees and hinge at your waist until you can plant your hands flat on the floor.\n3. Jump your feet back behind you to Plank position and perform two push ups.\n4. Jump your feet back in, shoulder-width apart, heels on the ground.\n5. Sit back into a low squat position and jump straight up into the air, arms extend overhead. Land soft.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3404,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '359627a9e00f6f0c71724e374777de85f24353f2df105adcf6b80a37146034ec',
          file_name:
            'videos/359627a9e00f6f0c71724e374777de85f24353f2df105adcf6b80a37146034ec.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/359627a9e00f6f0c71724e374777de85f24353f2df105adcf6b80a37146034ec.mp4',
          name: 'INT-ADV-Burpee_with_2_Push-Ups-EXERCISE',
          description: null,
          size: 317750,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3405,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'a2ef1c8a393e8b8e90a91cb294e91f5d70aad9a208cc3ad3582786a0cdef913a',
          file_name:
            'audios/a2ef1c8a393e8b8e90a91cb294e91f5d70aad9a208cc3ad3582786a0cdef913a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a2ef1c8a393e8b8e90a91cb294e91f5d70aad9a208cc3ad3582786a0cdef913a.mp3',
          name: 'INT-ADV-Burpee_with_2_Push-Ups-EXERCISE',
          description: null,
          size: 29421,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-BURPEE_WITH2_PUSH-_UPS-EXERCISE': {
      id: 1284,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Burpee with 2 Push-Ups',
      short_name: 'Burpee with 2 Push-Ups',
      unique_name: 'ADVANCED-BURPEE_WITH2_PUSH-_UPS-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart.\n2. Bend your knees and hinge at your waist until you can plant your hands flat on the floor.\n3. Jump your feet back behind you to Plank position and perform two push ups.\n4. Jump your feet back in, shoulder-width apart, heels on the ground.\n5. Sit back into a low squat position and jump straight up into the air, arms extend overhead. Land soft.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 20,
          unique_name: 'FULL_BODY',
          name: 'Full Body',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3406,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '359627a9e00f6f0c71724e374777de85f24353f2df105adcf6b80a37146034ec',
          file_name:
            'videos/359627a9e00f6f0c71724e374777de85f24353f2df105adcf6b80a37146034ec.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/359627a9e00f6f0c71724e374777de85f24353f2df105adcf6b80a37146034ec.mp4',
          name: 'INT-ADV-Burpee_with_2_Push-Ups-EXERCISE',
          description: null,
          size: 317750,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3407,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'a2ef1c8a393e8b8e90a91cb294e91f5d70aad9a208cc3ad3582786a0cdef913a',
          file_name:
            'audios/a2ef1c8a393e8b8e90a91cb294e91f5d70aad9a208cc3ad3582786a0cdef913a.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a2ef1c8a393e8b8e90a91cb294e91f5d70aad9a208cc3ad3582786a0cdef913a.mp3',
          name: 'INT-ADV-Burpee_with_2_Push-Ups-EXERCISE',
          description: null,
          size: 29421,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-OUTSIDE_KICK_TO_BOB_AND_WEAVE-EXERCISE': {
      id: 1285,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Outside Kick to Bob and Weave',
      short_name: 'Outside Kick to Bob and Weave',
      unique_name: 'INTERMEDIATE-OUTSIDE_KICK_TO_BOB_AND_WEAVE-EXERCISE',
      description:
        '1. Stand tall with feet hip-width apart. Fists up by your chin. \n2. Bend both knees into a mini-squat. As you come up, swing one leg up and out, as if swinging it over an invisible chair. \n3. Place foot back on the floor, bend both knees and shift your weight to the opposite side as you draw a "U" with your upper body to start. \n4. Perform all reps with one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3408,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '577c3ac27624c48fa4aacfbdad6c7cf5a0fe2656e80f2008656c7c7ecf3c3748',
          file_name:
            'videos/577c3ac27624c48fa4aacfbdad6c7cf5a0fe2656e80f2008656c7c7ecf3c3748.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/577c3ac27624c48fa4aacfbdad6c7cf5a0fe2656e80f2008656c7c7ecf3c3748.mp4',
          name: 'INT-ADV-Outside_Kick_to_Bob_and_Weave-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 183243,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3409,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '3918bbf953266d3822e7a0bb51a2c8c74980d67dd4668adb7d8d1cf29ce6fbb0',
          file_name:
            'videos/3918bbf953266d3822e7a0bb51a2c8c74980d67dd4668adb7d8d1cf29ce6fbb0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3918bbf953266d3822e7a0bb51a2c8c74980d67dd4668adb7d8d1cf29ce6fbb0.mp4',
          name: 'INT-ADV-Outside_Kick_to_Bob_and_Weave-EXERCISE-LEFT',
          description: 'Left Side',
          size: 153798,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3410,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'dd1af085cea093115e4cf39e4dd52fb1cb7f55e9fbd64521f4c8e3fe931e9164',
          file_name:
            'audios/dd1af085cea093115e4cf39e4dd52fb1cb7f55e9fbd64521f4c8e3fe931e9164.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dd1af085cea093115e4cf39e4dd52fb1cb7f55e9fbd64521f4c8e3fe931e9164.mp3',
          name: 'INT-ADV-Outside_Kick_to_Bob_and_Weave-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 28845,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-OUTSIDE_KICK_TO_BOB_AND_WEAVE-EXERCISE': {
      id: 1286,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Outside Kick to Bob and Weave',
      short_name: 'Outside Kick to Bob and Weave',
      unique_name: 'ADVANCED-OUTSIDE_KICK_TO_BOB_AND_WEAVE-EXERCISE',
      description:
        '1. Stand tall with feet hip-width apart. Fists up by your chin. \n2. Bend both knees into a mini-squat. As you come up, swing one leg up and out, as if swinging it over an invisible chair. \n3. Place foot back on the floor, bend both knees and shift your weight to the opposite side as you draw a "U" with your upper body to start. \n4. Perform all reps with one leg. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3411,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '577c3ac27624c48fa4aacfbdad6c7cf5a0fe2656e80f2008656c7c7ecf3c3748',
          file_name:
            'videos/577c3ac27624c48fa4aacfbdad6c7cf5a0fe2656e80f2008656c7c7ecf3c3748.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/577c3ac27624c48fa4aacfbdad6c7cf5a0fe2656e80f2008656c7c7ecf3c3748.mp4',
          name: 'INT-ADV-Outside_Kick_to_Bob_and_Weave-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 183243,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3412,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: '3918bbf953266d3822e7a0bb51a2c8c74980d67dd4668adb7d8d1cf29ce6fbb0',
          file_name:
            'videos/3918bbf953266d3822e7a0bb51a2c8c74980d67dd4668adb7d8d1cf29ce6fbb0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3918bbf953266d3822e7a0bb51a2c8c74980d67dd4668adb7d8d1cf29ce6fbb0.mp4',
          name: 'INT-ADV-Outside_Kick_to_Bob_and_Weave-EXERCISE-LEFT',
          description: 'Left Side',
          size: 153798,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3413,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'dd1af085cea093115e4cf39e4dd52fb1cb7f55e9fbd64521f4c8e3fe931e9164',
          file_name:
            'audios/dd1af085cea093115e4cf39e4dd52fb1cb7f55e9fbd64521f4c8e3fe931e9164.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dd1af085cea093115e4cf39e4dd52fb1cb7f55e9fbd64521f4c8e3fe931e9164.mp3',
          name: 'INT-ADV-Outside_Kick_to_Bob_and_Weave-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 28845,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-KNEE_TRAVEL-EXERCISE': {
      id: 1287,
      segment_type: 'EXERCISE',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Knee Travel',
      short_name: 'Knee Travel',
      unique_name: 'BEGINNER-KNEE_TRAVEL-EXERCISE',
      description:
        '1. Stand tall behind a step. \n2. Lift one foot up and across to place it on the corner of the bench. \n3. Drive through your heel to stand on the bench as you lift your other knee up to hip height. \n3. Step down with the raised foot and step off the bench with the other. \n4. Repeat other leg. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3414,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'a83afa890c655505405f2650a24805b0c7afd6260211634230512daada56fbc6',
          file_name:
            'videos/a83afa890c655505405f2650a24805b0c7afd6260211634230512daada56fbc6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a83afa890c655505405f2650a24805b0c7afd6260211634230512daada56fbc6.mp4',
          name: 'BEG-INT-ADV-Knee_Travel-EXERCISE',
          description: null,
          size: 255367,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3415,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '5573303900d574168066403846ebd8e55e3c36ede068063fc253566d95814e49',
          file_name:
            'audios/5573303900d574168066403846ebd8e55e3c36ede068063fc253566d95814e49.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5573303900d574168066403846ebd8e55e3c36ede068063fc253566d95814e49.mp3',
          name: 'BEG-INT-ADV-Knee_Travel-EXERCISE',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-KNEE_TRAVEL-EXERCISE': {
      id: 1288,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Knee Travel',
      short_name: 'Knee Travel',
      unique_name: 'INTERMEDIATE-KNEE_TRAVEL-EXERCISE',
      description:
        '1. Stand tall behind a step. \n2. Lift one foot up and across to place it on the corner of the bench. \n3. Drive through your heel to stand on the bench as you lift your other knee up to hip height. \n3. Step down with the raised foot and step off the bench with the other. \n4. Repeat other leg. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3416,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'a83afa890c655505405f2650a24805b0c7afd6260211634230512daada56fbc6',
          file_name:
            'videos/a83afa890c655505405f2650a24805b0c7afd6260211634230512daada56fbc6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a83afa890c655505405f2650a24805b0c7afd6260211634230512daada56fbc6.mp4',
          name: 'BEG-INT-ADV-Knee_Travel-EXERCISE',
          description: null,
          size: 255367,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3417,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '5573303900d574168066403846ebd8e55e3c36ede068063fc253566d95814e49',
          file_name:
            'audios/5573303900d574168066403846ebd8e55e3c36ede068063fc253566d95814e49.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5573303900d574168066403846ebd8e55e3c36ede068063fc253566d95814e49.mp3',
          name: 'BEG-INT-ADV-Knee_Travel-EXERCISE',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-KNEE_TRAVEL-EXERCISE': {
      id: 1289,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Knee Travel',
      short_name: 'Knee Travel',
      unique_name: 'ADVANCED-KNEE_TRAVEL-EXERCISE',
      description:
        '1. Stand tall behind a step. \n2. Lift one foot up and across to place it on the corner of the bench. \n3. Drive through your heel to stand on the bench as you lift your other knee up to hip height. \n3. Step down with the raised foot and step off the bench with the other. \n4. Repeat other leg. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3418,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'a83afa890c655505405f2650a24805b0c7afd6260211634230512daada56fbc6',
          file_name:
            'videos/a83afa890c655505405f2650a24805b0c7afd6260211634230512daada56fbc6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a83afa890c655505405f2650a24805b0c7afd6260211634230512daada56fbc6.mp4',
          name: 'BEG-INT-ADV-Knee_Travel-EXERCISE',
          description: null,
          size: 255367,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3419,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '5573303900d574168066403846ebd8e55e3c36ede068063fc253566d95814e49',
          file_name:
            'audios/5573303900d574168066403846ebd8e55e3c36ede068063fc253566d95814e49.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/5573303900d574168066403846ebd8e55e3c36ede068063fc253566d95814e49.mp3',
          name: 'BEG-INT-ADV-Knee_Travel-EXERCISE',
          description: null,
          size: 19341,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-CARRIES_JUMPSHOTS-EXERCISE': {
      id: 1290,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: "Carrie's Jumpshots",
      short_name: "Carrie's Jumpshots",
      unique_name: 'INTERMEDIATE-CARRIES_JUMPSHOTS-EXERCISE',
      description:
        '1. Stand tall behind a step. \n2. Lift one foot up and across to place it on the corner of the bench. \n3. Drive through your heel and jump up with both feet as you reach your arms in the air. \n4. Land soft on the bench with the lead leg and tap the other toe to the bench \n5. Step down with the foot that tapped and step off the bench with the other. \n6. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3420,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '1375231e938b786df4e3b6e077c638cb5ad3e0cab35b45df40d9a085612fce11',
          file_name:
            'videos/1375231e938b786df4e3b6e077c638cb5ad3e0cab35b45df40d9a085612fce11.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1375231e938b786df4e3b6e077c638cb5ad3e0cab35b45df40d9a085612fce11.mp4',
          name: 'INT-ADV-Carries_Jumpshots-EXERCISE',
          description: null,
          size: 278029,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3421,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'dbb0b0ba86ac979958892edb0d021f2713e14cc370a0df5436670177f59b846f',
          file_name:
            'audios/dbb0b0ba86ac979958892edb0d021f2713e14cc370a0df5436670177f59b846f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dbb0b0ba86ac979958892edb0d021f2713e14cc370a0df5436670177f59b846f.mp3',
          name: 'INT-ADV-Carries_Jumpshots-EXERCISE',
          description: null,
          size: 23949,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-CARRIES_JUMPSHOTS-EXERCISE': {
      id: 1291,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: "Carrie's Jumpshots",
      short_name: "Carrie's Jumpshots",
      unique_name: 'ADVANCED-CARRIES_JUMPSHOTS-EXERCISE',
      description:
        '1. Stand tall behind a step. \n2. Lift one foot up and across to place it on the corner of the bench. \n3. Drive through your heel and jump up with both feet as you reach your arms in the air. \n4. Land soft on the bench with the lead leg and tap the other toe to the bench \n5. Step down with the foot that tapped and step off the bench with the other. \n6. Repeat other side. Right and left is one rep.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 3,
          name: 'Step',
          unique_name: 'STEP',
          min_app_version: 100030000,
          order: 7000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3422,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '1375231e938b786df4e3b6e077c638cb5ad3e0cab35b45df40d9a085612fce11',
          file_name:
            'videos/1375231e938b786df4e3b6e077c638cb5ad3e0cab35b45df40d9a085612fce11.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1375231e938b786df4e3b6e077c638cb5ad3e0cab35b45df40d9a085612fce11.mp4',
          name: 'INT-ADV-Carries_Jumpshots-EXERCISE',
          description: null,
          size: 278029,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3423,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'dbb0b0ba86ac979958892edb0d021f2713e14cc370a0df5436670177f59b846f',
          file_name:
            'audios/dbb0b0ba86ac979958892edb0d021f2713e14cc370a0df5436670177f59b846f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/dbb0b0ba86ac979958892edb0d021f2713e14cc370a0df5436670177f59b846f.mp3',
          name: 'INT-ADV-Carries_Jumpshots-EXERCISE',
          description: null,
          size: 23949,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-GOBLET_FROG_SQUAT_PULSE-EXERCISE': {
      id: 1292,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'LOWER_BODY',
      name: 'Goblet Frog Squat Pulse',
      short_name: 'Goblet Frog Squat Pulse',
      unique_name: 'INTERMEDIATE-GOBLET_FROG_SQUAT_PULSE-EXERCISE',
      description:
        '1. Stand with your feet slightly wider than shoulder-width apart, toes pointing out. Hold a single dumbbell in front of your chest with both hands.\n2. Bend knees, sink hips down and back to lower into a wide squat. Keep chest up and elbows inside knees\n3. Drive though your heels and straighten your legs about 1/4 way up. \n4. Lower hips down into the full squat. Pulse in a continous motion.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3424,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '6074f5137fcaf2169839e182ef70013a610ea9d9a93b3dd3710b53a27ef31796',
          file_name:
            'videos/6074f5137fcaf2169839e182ef70013a610ea9d9a93b3dd3710b53a27ef31796.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6074f5137fcaf2169839e182ef70013a610ea9d9a93b3dd3710b53a27ef31796.mp4',
          name: 'INT-ADV-Goblet_Frog_Squat_Pulse-EXERCISE',
          description: null,
          size: 40714,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3425,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '004f997e06b16fe0e11e82d3ad770262cb2d5f843439523c75a64d6d8a7345ae',
          file_name:
            'audios/004f997e06b16fe0e11e82d3ad770262cb2d5f843439523c75a64d6d8a7345ae.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/004f997e06b16fe0e11e82d3ad770262cb2d5f843439523c75a64d6d8a7345ae.mp3',
          name: 'INT-ADV-Goblet_Frog_Squat_Pulse-EXERCISE',
          description: null,
          size: 29997,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-GOBLET_FROG_SQUAT_PULSE-EXERCISE': {
      id: 1293,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'LOWER_BODY',
      name: 'Goblet Frog Squat Pulse',
      short_name: 'Goblet Frog Squat Pulse',
      unique_name: 'ADVANCED-GOBLET_FROG_SQUAT_PULSE-EXERCISE',
      description:
        '1. Stand with your feet slightly wider than shoulder-width apart, toes pointing out. Hold a single dumbbell in front of your chest with both hands.\n2. Bend knees, sink hips down and back to lower into a wide squat. Keep chest up and elbows inside knees\n3. Drive though your heels and straighten your legs about 1/4 way up. \n4. Lower hips down into the full squat. Pulse in a continous motion.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3426,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '6074f5137fcaf2169839e182ef70013a610ea9d9a93b3dd3710b53a27ef31796',
          file_name:
            'videos/6074f5137fcaf2169839e182ef70013a610ea9d9a93b3dd3710b53a27ef31796.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6074f5137fcaf2169839e182ef70013a610ea9d9a93b3dd3710b53a27ef31796.mp4',
          name: 'INT-ADV-Goblet_Frog_Squat_Pulse-EXERCISE',
          description: null,
          size: 40714,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3427,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '004f997e06b16fe0e11e82d3ad770262cb2d5f843439523c75a64d6d8a7345ae',
          file_name:
            'audios/004f997e06b16fe0e11e82d3ad770262cb2d5f843439523c75a64d6d8a7345ae.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/004f997e06b16fe0e11e82d3ad770262cb2d5f843439523c75a64d6d8a7345ae.mp3',
          name: 'INT-ADV-Goblet_Frog_Squat_Pulse-EXERCISE',
          description: null,
          size: 29997,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_DRAG_CURL-EXERCISE': {
      id: 1294,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Drag Curl',
      short_name: 'Dumbbell Drag Curl',
      unique_name: 'INTERMEDIATE-DUMBBELL_DRAG_CURL-EXERCISE',
      description:
        '1. Stand tall with a dumbbell in each hand, palms facing forward.  \n2. Drag both elbows straight back behind you as you pull the dumbbells up along your torso. Stop at the bottom of your ribcage. Squeeze. \n3. Lower the weights back down to start.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3428,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '5361380b62ad39aa29068175704f0b305f000170623cc142eb600b4a96dfafdf',
          file_name:
            'videos/5361380b62ad39aa29068175704f0b305f000170623cc142eb600b4a96dfafdf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5361380b62ad39aa29068175704f0b305f000170623cc142eb600b4a96dfafdf.mp4',
          name: 'INT-ADV-Dumbbell_Drag_Curl-EXERCISE',
          description: null,
          size: 71713,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3429,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '3f0bfa945f35cd64d66b9050d7a9123a3b47dbbf8e995ae8587b04478d32af7b',
          file_name:
            'audios/3f0bfa945f35cd64d66b9050d7a9123a3b47dbbf8e995ae8587b04478d32af7b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3f0bfa945f35cd64d66b9050d7a9123a3b47dbbf8e995ae8587b04478d32af7b.mp3',
          name: 'INT-ADV-Dumbbell_Drag_Curl-EXERCISE',
          description: null,
          size: 27405,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_DRAG_CURL-EXERCISE': {
      id: 1295,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Drag Curl',
      short_name: 'Dumbbell Drag Curl',
      unique_name: 'ADVANCED-DUMBBELL_DRAG_CURL-EXERCISE',
      description:
        '1. Stand tall with a dumbbell in each hand, palms facing forward.  \n2. Drag both elbows straight back behind you as you pull the dumbbells up along your torso. Stop at the bottom of your ribcage. Squeeze. \n3. Lower the weights back down to start.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3430,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '5361380b62ad39aa29068175704f0b305f000170623cc142eb600b4a96dfafdf',
          file_name:
            'videos/5361380b62ad39aa29068175704f0b305f000170623cc142eb600b4a96dfafdf.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5361380b62ad39aa29068175704f0b305f000170623cc142eb600b4a96dfafdf.mp4',
          name: 'INT-ADV-Dumbbell_Drag_Curl-EXERCISE',
          description: null,
          size: 71713,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3431,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '3f0bfa945f35cd64d66b9050d7a9123a3b47dbbf8e995ae8587b04478d32af7b',
          file_name:
            'audios/3f0bfa945f35cd64d66b9050d7a9123a3b47dbbf8e995ae8587b04478d32af7b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/3f0bfa945f35cd64d66b9050d7a9123a3b47dbbf8e995ae8587b04478d32af7b.mp3',
          name: 'INT-ADV-Dumbbell_Drag_Curl-EXERCISE',
          description: null,
          size: 27405,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-DUMBBELL_CLOSE_GRIP_CURL-EXERCISE': {
      id: 1296,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Close Grip Curl',
      short_name: 'Dumbbell Close Grip Curl',
      unique_name: 'INTERMEDIATE-DUMBBELL_CLOSE_GRIP_CURL-EXERCISE',
      description:
        '1. Stand tall with a dumbbell in each hand. Palms face each other, dumbbells touch in a crush grip. \n2. Keeping your elbows close to your ribcage and dumbbells pressed together, curl the weight up toward your shoulders. \n3. Lower the weights back down to start.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3432,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'acda45c678c6aa92a82b9d98365931849e0596444b6744d79e4092ba9c17d2d2',
          file_name:
            'videos/acda45c678c6aa92a82b9d98365931849e0596444b6744d79e4092ba9c17d2d2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/acda45c678c6aa92a82b9d98365931849e0596444b6744d79e4092ba9c17d2d2.mp4',
          name: 'INT-ADV-Dumbbell_Close_Grip_Curl-EXERCISE',
          description: null,
          size: 84395,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3433,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '11ae3ade4edf6454cb1458878587869aa9b402284a4781985dd5cbcb0e26a91b',
          file_name:
            'audios/11ae3ade4edf6454cb1458878587869aa9b402284a4781985dd5cbcb0e26a91b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/11ae3ade4edf6454cb1458878587869aa9b402284a4781985dd5cbcb0e26a91b.mp3',
          name: 'INT-ADV-Dumbbell_Close_Grip_Curl-EXERCISE',
          description: null,
          size: 29997,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-DUMBBELL_CLOSE_GRIP_CURL-EXERCISE': {
      id: 1297,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'UPPER_BODY',
      name: 'Dumbbell Close Grip Curl',
      short_name: 'Dumbbell Close Grip Curl',
      unique_name: 'ADVANCED-DUMBBELL_CLOSE_GRIP_CURL-EXERCISE',
      description:
        '1. Stand tall with a dumbbell in each hand. Palms face each other, dumbbells touch in a crush grip. \n2. Keeping your elbows close to your ribcage and dumbbells pressed together, curl the weight up toward your shoulders. \n3. Lower the weights back down to start.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 6,
          unique_name: 'BICEPS',
          name: 'Biceps',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3434,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: 'acda45c678c6aa92a82b9d98365931849e0596444b6744d79e4092ba9c17d2d2',
          file_name:
            'videos/acda45c678c6aa92a82b9d98365931849e0596444b6744d79e4092ba9c17d2d2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/acda45c678c6aa92a82b9d98365931849e0596444b6744d79e4092ba9c17d2d2.mp4',
          name: 'INT-ADV-Dumbbell_Close_Grip_Curl-EXERCISE',
          description: null,
          size: 84395,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3435,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: '11ae3ade4edf6454cb1458878587869aa9b402284a4781985dd5cbcb0e26a91b',
          file_name:
            'audios/11ae3ade4edf6454cb1458878587869aa9b402284a4781985dd5cbcb0e26a91b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/11ae3ade4edf6454cb1458878587869aa9b402284a4781985dd5cbcb0e26a91b.mp3',
          name: 'INT-ADV-Dumbbell_Close_Grip_Curl-EXERCISE',
          description: null,
          size: 29997,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'INTERMEDIATE-SINGLE_ARM_OVERHEAD_SQUAT-EXERCISE': {
      id: 1298,
      segment_type: 'EXERCISE',
      fitness_level: 'INTERMEDIATE',
      focus_area: 'CORE',
      name: 'Single Arm Overhead Squat',
      short_name: 'Single Arm Overhead Squat',
      unique_name: 'INTERMEDIATE-SINGLE_ARM_OVERHEAD_SQUAT-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart. Hold one dumbbell overhead, pit of elbow by ear, palm faces out. \n2. Keeping core engaged and arm straight, drive your hips back and bend your knees to squat as low as possible. Make sure to keep your chest up and shoulders back. If the overhead dumbbell travels forward or inward, reduce the depth of your squat. \n3. Drive through your heels to stand back up to start. \n4. Perform all reps. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3436,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '4f2e0643aaf8779f971f8c6b4a4d5252f63a02a3abedaae7e97276bc9a42952e',
          file_name:
            'videos/4f2e0643aaf8779f971f8c6b4a4d5252f63a02a3abedaae7e97276bc9a42952e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4f2e0643aaf8779f971f8c6b4a4d5252f63a02a3abedaae7e97276bc9a42952e.mp4',
          name: 'INT-ADV-Single_Arm_Overhead_Squat-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 152029,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3437,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'f68cd73b914012fe47b78c28972e19024f4a1125e452a1eb53425b743e8d73ee',
          file_name:
            'videos/f68cd73b914012fe47b78c28972e19024f4a1125e452a1eb53425b743e8d73ee.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f68cd73b914012fe47b78c28972e19024f4a1125e452a1eb53425b743e8d73ee.mp4',
          name: 'INT-ADV-Single_Arm_Overhead_Squat-EXERCISE-LEFT',
          description: 'Left Side',
          size: 146220,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3438,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'a828c9cd7aab6428dbe49dc3e49d2e90784a72397e251bc5487aa3bde0267ad0',
          file_name:
            'audios/a828c9cd7aab6428dbe49dc3e49d2e90784a72397e251bc5487aa3bde0267ad0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a828c9cd7aab6428dbe49dc3e49d2e90784a72397e251bc5487aa3bde0267ad0.mp3',
          name: 'INT-ADV-Single_Arm_Overhead_Squat-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 29997,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'ADVANCED-SINGLE_ARM_OVERHEAD_SQUAT-EXERCISE': {
      id: 1299,
      segment_type: 'EXERCISE',
      fitness_level: 'ADVANCED',
      focus_area: 'CORE',
      name: 'Single Arm Overhead Squat',
      short_name: 'Single Arm Overhead Squat',
      unique_name: 'ADVANCED-SINGLE_ARM_OVERHEAD_SQUAT-EXERCISE',
      description:
        '1. Stand with your feet about shoulder-width apart. Hold one dumbbell overhead, pit of elbow by ear, palm faces out. \n2. Keeping core engaged and arm straight, drive your hips back and bend your knees to squat as low as possible. Make sure to keep your chest up and shoulders back. If the overhead dumbbell travels forward or inward, reduce the depth of your squat. \n3. Drive through your heels to stand back up to start. \n4. Perform all reps. Repeat other side.',
      preview_time: 10,
      min_app_version: 300120000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3439,
          collection_name: 'videos',
          order: 1,
          version: 300120000,
          hash: '4f2e0643aaf8779f971f8c6b4a4d5252f63a02a3abedaae7e97276bc9a42952e',
          file_name:
            'videos/4f2e0643aaf8779f971f8c6b4a4d5252f63a02a3abedaae7e97276bc9a42952e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4f2e0643aaf8779f971f8c6b4a4d5252f63a02a3abedaae7e97276bc9a42952e.mp4',
          name: 'INT-ADV-Single_Arm_Overhead_Squat-EXERCISE-RIGHT',
          description: 'Right Side',
          size: 152029,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3440,
          collection_name: 'videos',
          order: 2,
          version: 300120000,
          hash: 'f68cd73b914012fe47b78c28972e19024f4a1125e452a1eb53425b743e8d73ee',
          file_name:
            'videos/f68cd73b914012fe47b78c28972e19024f4a1125e452a1eb53425b743e8d73ee.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f68cd73b914012fe47b78c28972e19024f4a1125e452a1eb53425b743e8d73ee.mp4',
          name: 'INT-ADV-Single_Arm_Overhead_Squat-EXERCISE-LEFT',
          description: 'Left Side',
          size: 146220,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 3441,
          collection_name: 'audios',
          order: 1,
          version: 300120000,
          hash: 'a828c9cd7aab6428dbe49dc3e49d2e90784a72397e251bc5487aa3bde0267ad0',
          file_name:
            'audios/a828c9cd7aab6428dbe49dc3e49d2e90784a72397e251bc5487aa3bde0267ad0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a828c9cd7aab6428dbe49dc3e49d2e90784a72397e251bc5487aa3bde0267ad0.mp3',
          name: 'INT-ADV-Single_Arm_Overhead_Squat-EXERCISE-(RIGHT/LEFT)',
          description: null,
          size: 29997,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CALF_ROLLS-RECOVER_STRETCH': {
      id: 861,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Calf Rolls',
      short_name: 'Calf Rolls',
      unique_name: 'BEGINNER-CALF_ROLLS-RECOVER_STRETCH',
      description:
        '1. Sit with legs straight and arms behind hips, palms flat.\n2. Bend one knee and put foot flat. Place a foam roller horizontally under the calf of your extended leg. Push through foot and hands to raise hips, keeping light pressure on the roller.\n3. Gently move your hips forward and backward as the roller travels up and down your calf, from ankle to the pit of your knee. Control pressure and pace as needed.\n4. Repeat with the other leg.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 10,
          name: 'Foam Roller',
          unique_name: 'FOAM_ROLLER',
          min_app_version: 200070000,
          order: 13000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 7,
          unique_name: 'CALVES',
          name: 'Calves',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2252,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'e83c9c230fefb0b895ceca6e4ee630028adba8d831467cb7eaf27ff1cb2386fd',
          file_name:
            'videos/e83c9c230fefb0b895ceca6e4ee630028adba8d831467cb7eaf27ff1cb2386fd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/e83c9c230fefb0b895ceca6e4ee630028adba8d831467cb7eaf27ff1cb2386fd.mp4',
          name: 'BEGINNER-Calf_Rolls-RECOVER_STRETCH-LEFT',
          description: 'Left Side',
          size: 1306526,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2253,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: 'd68457892ed223ab2ec783de69183d33a2881bb3ccef35d6f424ac6504915d2b',
          file_name:
            'videos/d68457892ed223ab2ec783de69183d33a2881bb3ccef35d6f424ac6504915d2b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d68457892ed223ab2ec783de69183d33a2881bb3ccef35d6f424ac6504915d2b.mp4',
          name: 'BEGINNER-Calf_Rolls-RECOVER_STRETCH-RIGHT',
          description: 'Right Side',
          size: 1362501,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2254,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '9a0807658f224e29a7ad8dcd3a2a6688bd6cec918914c6612b9f847851ed4354',
          file_name:
            'audios/9a0807658f224e29a7ad8dcd3a2a6688bd6cec918914c6612b9f847851ed4354.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/9a0807658f224e29a7ad8dcd3a2a6688bd6cec918914c6612b9f847851ed4354.mp3',
          name: 'BEGINNER-Calf_Rolls-RECOVER_STRETCH',
          description: null,
          size: 21807,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-QUAD_ROLLS-RECOVER_STRETCH': {
      id: 862,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Quad Rolls',
      short_name: 'Quad Rolls',
      unique_name: 'BEGINNER-QUAD_ROLLS-RECOVER_STRETCH',
      description:
        '1. Start in Forearm Plank Position and place a foam roller horizontally underneath your thighs. Drop your bodyweight down to make light contact.\n2. Gently move your body forward and back so the roller travels up and down the length of your quads, from hips to knee. Control the pressure and pace as needed.\n3. Roll back and forth in a continuous motion.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 10,
          name: 'Foam Roller',
          unique_name: 'FOAM_ROLLER',
          min_app_version: 200070000,
          order: 13000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2255,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '20ef8b5ecc9979f0e82447a523301739e3793f2ed03974945e5de155005b4195',
          file_name:
            'videos/20ef8b5ecc9979f0e82447a523301739e3793f2ed03974945e5de155005b4195.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/20ef8b5ecc9979f0e82447a523301739e3793f2ed03974945e5de155005b4195.mp4',
          name: 'BEGINNER-Quad_Rolls-RECOVER_STRETCH',
          description: null,
          size: 1271609,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2256,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'b8b9c1a88fafc9764f760f0d25ce8ae341fa3c1f0aa5d4abf7434b16d10f8236',
          file_name:
            'audios/b8b9c1a88fafc9764f760f0d25ce8ae341fa3c1f0aa5d4abf7434b16d10f8236.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/b8b9c1a88fafc9764f760f0d25ce8ae341fa3c1f0aa5d4abf7434b16d10f8236.mp3',
          name: 'BEGINNER-Quad_Rolls-RECOVER_STRETCH',
          description: null,
          size: 23247,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_SIDE_STRETCH-RECOVER_STRETCH': {
      id: 869,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Chair Side Stretch',
      short_name: 'Chair Side Stretch',
      unique_name: 'BEGINNER-CHAIR_SIDE_STRETCH-RECOVER_STRETCH',
      description:
        '1. Sit up tall on a chair with both feet firmly on the floor. Raise both arms overhead.\n2. Grab one wrist, gently pull up and lean over in the opposite direction until you feel a nice side stretch. Keep hips and shoulders square as you hold this position.\n3. Repeat on the other side.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2271,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '032ce5e435e6138db8fd04cb025ca20b100237662ae4c2ddc8713d9af2ddb5e4',
          file_name:
            'videos/032ce5e435e6138db8fd04cb025ca20b100237662ae4c2ddc8713d9af2ddb5e4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/032ce5e435e6138db8fd04cb025ca20b100237662ae4c2ddc8713d9af2ddb5e4.mp4',
          name: 'BEGINNER-Chair_Side_Stretch-RECOVER_STRETCH-LEFT',
          description: 'Left Side',
          size: 138202,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2272,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: '33288f2681c2470ef4443ccd7d39d06102f8cb5fbbffdd09705f0176af942815',
          file_name:
            'videos/33288f2681c2470ef4443ccd7d39d06102f8cb5fbbffdd09705f0176af942815.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/33288f2681c2470ef4443ccd7d39d06102f8cb5fbbffdd09705f0176af942815.mp4',
          name: 'BEGINNER-Chair_Side_Stretch-RECOVER_STRETCH-RIGHT',
          description: 'Right Side',
          size: 143612,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2273,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '682f88587792b7d6666099ed0fcba56948b6de5d0c0255b7212842f962b68d80',
          file_name:
            'audios/682f88587792b7d6666099ed0fcba56948b6de5d0c0255b7212842f962b68d80.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/682f88587792b7d6666099ed0fcba56948b6de5d0c0255b7212842f962b68d80.mp3',
          name: 'BEGINNER-Chair_Side_Stretch-RECOVER_STRETCH',
          description: null,
          size: 27945,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_ELBOW_CIRCLES_FORWARD_AND_BACKWARD-RECOVER_STRETCH': {
      id: 870,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Chair Elbow Circles Forward and Backward',
      short_name: 'Chair Elbow Circles',
      unique_name:
        'BEGINNER-CHAIR_ELBOW_CIRCLES_FORWARD_AND_BACKWARD-RECOVER_STRETCH',
      description:
        '1. Sit up tall on a chair with with both feet firmly on the floor. Raise your elbows out to shoulder height.\n2. Draw large circles with your elbows forward and backward.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2275,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'a5aa4e7dced6bc9e7c4715eef6ccb85a57754e509930392a5860fd18b96d1d91',
          file_name:
            'audios/a5aa4e7dced6bc9e7c4715eef6ccb85a57754e509930392a5860fd18b96d1d91.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a5aa4e7dced6bc9e7c4715eef6ccb85a57754e509930392a5860fd18b96d1d91.mp3',
          name: 'BEGINNER-Chair_Elbow_Circles_Forward_and_Backward-RECOVER_STRETCH',
          description: null,
          size: 45483,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2613,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '99a09f02c2ad1785208bedcb8c496dd80a90670b4efc0d17c225cc1034649bfe',
          file_name:
            'videos/99a09f02c2ad1785208bedcb8c496dd80a90670b4efc0d17c225cc1034649bfe.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/99a09f02c2ad1785208bedcb8c496dd80a90670b4efc0d17c225cc1034649bfe.mp4',
          name: 'BEGINNER-Chair_Elbow_Circles_Forward_and_Backward-RECOVER_STRETCH-(LEFT)',
          description: 'Left Side',
          size: 255610,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2614,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '7be67a1c8a81e5d475264c526645d86a2bcc04ceb7ee4cfdd9365a6396a09218',
          file_name:
            'videos/7be67a1c8a81e5d475264c526645d86a2bcc04ceb7ee4cfdd9365a6396a09218.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7be67a1c8a81e5d475264c526645d86a2bcc04ceb7ee4cfdd9365a6396a09218.mp4',
          name: 'BEGINNER-Chair_Elbow_Circles_Forward_and_Backward-RECOVER_STRETCH-(RIGHT)',
          description: 'Right Side',
          size: 255749,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_HIP_OPENERS-RECOVER_STRETCH': {
      id: 871,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Chair Hip Openers',
      short_name: 'Chair Hip Openers',
      unique_name: 'BEGINNER-CHAIR_HIP_OPENERS-RECOVER_STRETCH',
      description:
        '1. Sit up tall on a chair with both feet firmly on the floor. Hold the chair for stability.\n2. Pick up one knee and swing it up and out to the side to tap the floor.\n3. Reverse the motion. Repeat other side.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 1,
          unique_name: 'ABDUCTORS',
          name: 'Abductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 3,
          unique_name: 'ADDUCTORS',
          name: 'Adductors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2276,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '9339a74886c8258fd55860ee739232333029d846275281e20546742e8ae72b30',
          file_name:
            'videos/9339a74886c8258fd55860ee739232333029d846275281e20546742e8ae72b30.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/9339a74886c8258fd55860ee739232333029d846275281e20546742e8ae72b30.mp4',
          name: 'BEGINNER-Chair_Hip_Openers-RECOVER_STRETCH-LEFT',
          description: 'Left Side',
          size: 290444,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2277,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: 'd8472e1b8b7ae423981983fd0be9c822883a49bea8a881c2d5afec544ee1fc8c',
          file_name:
            'videos/d8472e1b8b7ae423981983fd0be9c822883a49bea8a881c2d5afec544ee1fc8c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d8472e1b8b7ae423981983fd0be9c822883a49bea8a881c2d5afec544ee1fc8c.mp4',
          name: 'BEGINNER-Chair_Hip_Openers-RECOVER_STRETCH-RIGHT',
          description: 'Right Side',
          size: 287977,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2278,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '0baaba1193d0986953b3760f6d6ae690ddcd4110f1a6be296b78cc64f6961878',
          file_name:
            'audios/0baaba1193d0986953b3760f6d6ae690ddcd4110f1a6be296b78cc64f6961878.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0baaba1193d0986953b3760f6d6ae690ddcd4110f1a6be296b78cc64f6961878.mp3',
          name: 'BEGINNER-Chair_Hip_Openers-RECOVER_STRETCH',
          description: null,
          size: 27453,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SEATED_LEG_EXTENSIONS-RECOVER_STRETCH': {
      id: 874,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Seated Leg Extensions',
      short_name: 'Seated Leg Extensions',
      unique_name: 'BEGINNER-SEATED_LEG_EXTENSIONS-RECOVER_STRETCH',
      description:
        '1. Sit up tall on a chair with both feet firmly on the floor. Keep chest up and core tight.\n2. Straighten one knee to extend your leg long, parallel to the floor.\n3. Pause for a beat as you engage your quads.\n4. With control, lower back to start. Perform all reps with one leg. Repeat with the other side.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2284,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'a2f9d4169569d39a5f48397e63a92ba1148295c60ae853f8bd7531f388b4ea8e',
          file_name:
            'audios/a2f9d4169569d39a5f48397e63a92ba1148295c60ae853f8bd7531f388b4ea8e.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/a2f9d4169569d39a5f48397e63a92ba1148295c60ae853f8bd7531f388b4ea8e.mp3',
          name: 'BEGINNER-Seated_Leg_Extensions-RECOVER_STRETCH',
          description: null,
          size: 29383,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2611,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '96320ccbbccf41c514b241476ea4c2d46028cb274d66c5e7f64a144478f0e5a0',
          file_name:
            'videos/96320ccbbccf41c514b241476ea4c2d46028cb274d66c5e7f64a144478f0e5a0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/96320ccbbccf41c514b241476ea4c2d46028cb274d66c5e7f64a144478f0e5a0.mp4',
          name: 'BEGINNER-Seated_Leg_Extensions-RECOVER_STRETCH-(LEFT)',
          description: 'Left Side',
          size: 215565,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2612,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '4b9cfb8552a3b28dca6e74011347fafbdad4038fc88071a193bbb6db816cd235',
          file_name:
            'videos/4b9cfb8552a3b28dca6e74011347fafbdad4038fc88071a193bbb6db816cd235.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4b9cfb8552a3b28dca6e74011347fafbdad4038fc88071a193bbb6db816cd235.mp4',
          name: 'BEGINNER-Seated_Leg_Extensions-RECOVER_STRETCH-(RIGHT)',
          description: 'Right Side',
          size: 219539,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_SITS-RECOVER_STRETCH': {
      id: 875,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Chair Sits',
      short_name: 'Chair Sits',
      unique_name: 'BEGINNER-CHAIR_SITS-RECOVER_STRETCH',
      description:
        '1 Stand tall in front of a chair. Chest up, shoulders back.\n2. Maintaining good posture, bend your knees and sink your hips back to slowly lower yourself to sit.\n3. Drive through your heels and return to stand. ',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 16,
          unique_name: 'QUADS',
          name: 'Quads',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2285,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '3854de8031985546901e54b219510d3ee18b9cfd2085885860953023b19071aa',
          file_name:
            'videos/3854de8031985546901e54b219510d3ee18b9cfd2085885860953023b19071aa.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3854de8031985546901e54b219510d3ee18b9cfd2085885860953023b19071aa.mp4',
          name: 'BEGINNER-Chair_Sits-RECOVER_STRETCH',
          description: null,
          size: 641810,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2286,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '34151fbc726c9b73621ec9c6617b37d690306ae63d90052aae16b9d64fe5c611',
          file_name:
            'audios/34151fbc726c9b73621ec9c6617b37d690306ae63d90052aae16b9d64fe5c611.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/34151fbc726c9b73621ec9c6617b37d690306ae63d90052aae16b9d64fe5c611.mp3',
          name: 'BEGINNER-Chair_Sits-RECOVER_STRETCH',
          description: null,
          size: 22181,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-ALTERNATING_TRUNK_TWISTS-RECOVER_STRETCH': {
      id: 878,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Alternating Trunk Twists',
      short_name: 'Alternating Trunk Twists',
      unique_name: 'BEGINNER-ALTERNATING_TRUNK_TWISTS-RECOVER_STRETCH',
      description:
        '1. Sit tall on the edge of a chair with feet firmly on floor. Place each hand on opposite shoulders, arms across chest and raise elbows up to shoulder height.\n2. Keeping hips square and gaze forward, rotate your upper body to one side as far as possible to stretch out spine. Pause for a beat to feel the stretch.\n3. Return to center and repeat other side.\n4. Continue twisting right and left.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2293,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '07ee0415b18d75dd6e74f84a1c83b434ba1a02853bb6bf2fce1fb133a50ef2b1',
          file_name:
            'videos/07ee0415b18d75dd6e74f84a1c83b434ba1a02853bb6bf2fce1fb133a50ef2b1.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/07ee0415b18d75dd6e74f84a1c83b434ba1a02853bb6bf2fce1fb133a50ef2b1.mp4',
          name: 'BEGINNER-Alternating_Trunk_Twists-RECOVER_STRETCH',
          description: null,
          size: 498516,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2294,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '2fc39e467c26e523abbd5c8974144c2f43dfe5049b5b6387c6e0352f6466b1f0',
          file_name:
            'audios/2fc39e467c26e523abbd5c8974144c2f43dfe5049b5b6387c6e0352f6466b1f0.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/2fc39e467c26e523abbd5c8974144c2f43dfe5049b5b6387c6e0352f6466b1f0.mp3',
          name: 'BEGINNER-Alternating_Trunk_Twists-RECOVER_STRETCH',
          description: null,
          size: 30333,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_SPINAL_TWISTS-RECOVER_STRETCH': {
      id: 879,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Chair Spinal Twists',
      short_name: 'Chair Spinal Twists',
      unique_name: 'BEGINNER-CHAIR_SPINAL_TWISTS-RECOVER_STRETCH',
      description:
        '1. Sit tall on the edge of a chair with feet firmly on floor. Place one hand on the outside of opposite knee and hold the back of the chair with the other hand.\n2. Keeping hips square, lift up out of your ribcage and twist your torso towards your hands. Push your hand into the outside of your knee slightly to deepen the twist. Pause and breathe.\n3. With control, return to start. Repeat other side.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2296,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '4a83062ca01136d40df6b839cf96e61e34407719a5ef4307bf6633f6cb07c1dd',
          file_name:
            'audios/4a83062ca01136d40df6b839cf96e61e34407719a5ef4307bf6633f6cb07c1dd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4a83062ca01136d40df6b839cf96e61e34407719a5ef4307bf6633f6cb07c1dd.mp3',
          name: 'BEGINNER-Chair_Spinal_Twists-RECOVER_STRETCH',
          description: null,
          size: 29467,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2609,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '80fee1f512417ca97e3bcf0f1360582ca88f2876245e738291f8194e9bf53d3b',
          file_name:
            'videos/80fee1f512417ca97e3bcf0f1360582ca88f2876245e738291f8194e9bf53d3b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/80fee1f512417ca97e3bcf0f1360582ca88f2876245e738291f8194e9bf53d3b.mp4',
          name: 'BEGINNER-Chair_Spinal_Twists-RECOVER_STRETCH-(LEFT)',
          description: 'Left Side',
          size: 153371,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2610,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '7360d63f7a58a440758bcb6efe0288876d22d05b82023cc44b2a7e87b8759038',
          file_name:
            'videos/7360d63f7a58a440758bcb6efe0288876d22d05b82023cc44b2a7e87b8759038.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7360d63f7a58a440758bcb6efe0288876d22d05b82023cc44b2a7e87b8759038.mp4',
          name: 'BEGINNER-Chair_Spinal_Twists-RECOVER_STRETCH-(RIGHT)',
          description: 'Right Side',
          size: 152893,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_CAT_COWS-RECOVER_STRETCH': {
      id: 880,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Chair Cat Cows',
      short_name: 'Chair Cat Cows',
      unique_name: 'BEGINNER-CHAIR_CAT_COWS-RECOVER_STRETCH',
      description:
        '1. Sit up tall on the edge of a chair, feet flat on the floor, hands resting on knees.\n2. Draw your navel in and round your back. Tuck your pelvis as your shoulders, chin and chest round toward your trunk. Pause for a beat in "Cat".\n3. Return to neutral spine.\n4. Arch your back and squeeze your shoulder blades together as you open your chest. Pause for a beat.\n5. Return to neutral spine and repeat.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2297,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '7ac11f16aae5ca9deba7f056e14c4906a0d2aabb60fe5966000495847df3a36e',
          file_name:
            'videos/7ac11f16aae5ca9deba7f056e14c4906a0d2aabb60fe5966000495847df3a36e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7ac11f16aae5ca9deba7f056e14c4906a0d2aabb60fe5966000495847df3a36e.mp4',
          name: 'BEGINNER-Chair_Cat_Cows-RECOVER_STRETCH',
          description: null,
          size: 443463,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2298,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '0d77cffac7649751c3a497d29edb8529be2e81a7bb133b2b9f9d398e55a7bd3f',
          file_name:
            'audios/0d77cffac7649751c3a497d29edb8529be2e81a7bb133b2b9f9d398e55a7bd3f.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/0d77cffac7649751c3a497d29edb8529be2e81a7bb133b2b9f9d398e55a7bd3f.mp3',
          name: 'BEGINNER-Chair_Cat_Cows-RECOVER_STRETCH',
          description: null,
          size: 28317,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_SLOW_UPPER_BODY_CIRCLES-RECOVER_STRETCH': {
      id: 881,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Chair Slow Upper Body Circles',
      short_name: 'Chair Slow Upper Body Circles',
      unique_name: 'BEGINNER-CHAIR_SLOW_UPPER_BODY_CIRCLES-RECOVER_STRETCH',
      description:
        '1. Sit up tall on the edge of a chair, feet flat on the floor, hands resting on knees.\n2. Keeping hips square, draw large circles with your upper body.\n3. Repeat in opposite direction. ',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2300,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '4b4b7ce911c049c052a32857c28c9b3f9e7c31cedaeebcc2f55a4d0e40e37282',
          file_name:
            'audios/4b4b7ce911c049c052a32857c28c9b3f9e7c31cedaeebcc2f55a4d0e40e37282.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/4b4b7ce911c049c052a32857c28c9b3f9e7c31cedaeebcc2f55a4d0e40e37282.mp3',
          name: 'BEGINNER-Chair_Slow_Upper_Body_Circles-RECOVER_STRETCH',
          description: null,
          size: 38599,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2607,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: 'ab968247d26917af5945fbaa57a469939b13e38bc2665d01d924f910f16e92d9',
          file_name:
            'videos/ab968247d26917af5945fbaa57a469939b13e38bc2665d01d924f910f16e92d9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ab968247d26917af5945fbaa57a469939b13e38bc2665d01d924f910f16e92d9.mp4',
          name: 'BEGINNER-Chair_Slow_Upper_Body_Circles-RECOVER_STRETCH-(LEFT)',
          description: 'Left Side',
          size: 306430,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2608,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '39d97b397bd60c5eef5932cee866d791aa77936ccf0928692a8b8447a4f6e534',
          file_name:
            'videos/39d97b397bd60c5eef5932cee866d791aa77936ccf0928692a8b8447a4f6e534.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/39d97b397bd60c5eef5932cee866d791aa77936ccf0928692a8b8447a4f6e534.mp4',
          name: 'BEGINNER-Chair_Slow_Upper_Body_Circles-RECOVER_STRETCH-(RIGHT)',
          description: 'Right Side',
          size: 306423,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_BOOK_ENDS-RECOVER_STRETCH': {
      id: 882,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Chair Book Ends',
      short_name: 'Chair Book Ends',
      unique_name: 'BEGINNER-CHAIR_BOOK_ENDS-RECOVER_STRETCH',
      description:
        '1. Sit tall on a chair, feet flat on the floor. Raise elbows in front of you to shoulder height, arms at 90 degrees framing your face. Hands in fists, palms face each other.\n2. Press arms overhead, biceps by ears.\n3. Rotate fists out and lower elbows to shoulder-height in goal post position.\n4. Squeeze your elbows toward your midline to start.\n5. Repeat in opposite direction.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 4,
          unique_name: 'ARMS',
          name: 'Arms',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2302,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '989dc0800449287a39a9c895f965a205d2c3a4180d9182338c010fcfc9ae5a83',
          file_name:
            'audios/989dc0800449287a39a9c895f965a205d2c3a4180d9182338c010fcfc9ae5a83.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/989dc0800449287a39a9c895f965a205d2c3a4180d9182338c010fcfc9ae5a83.mp3',
          name: 'BEGINNER-Chair_Book_Ends-RECOVER_STRETCH',
          description: null,
          size: 26215,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2605,
          collection_name: 'videos',
          order: 1,
          version: 300000000,
          hash: '80c21c9d21a7aad9142b4e9232d0fff653b84e7dd4afa5c0f70bca5d73f1de9f',
          file_name:
            'videos/80c21c9d21a7aad9142b4e9232d0fff653b84e7dd4afa5c0f70bca5d73f1de9f.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/80c21c9d21a7aad9142b4e9232d0fff653b84e7dd4afa5c0f70bca5d73f1de9f.mp4',
          name: 'BEGINNER-Chair_Book_Ends-RECOVER_STRETCH-(LEFT)',
          description: 'Left Side',
          size: 267145,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2606,
          collection_name: 'videos',
          order: 2,
          version: 300000000,
          hash: '24a0e4473a4d9efe4f63ef72d398f2362ca98fc8a7e6260c0239835c84f547e4',
          file_name:
            'videos/24a0e4473a4d9efe4f63ef72d398f2362ca98fc8a7e6260c0239835c84f547e4.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/24a0e4473a4d9efe4f63ef72d398f2362ca98fc8a7e6260c0239835c84f547e4.mp4',
          name: 'BEGINNER-Chair_Book_Ends-RECOVER_STRETCH-(RIGHT)',
          description: 'Right Side',
          size: 265531,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_ALTERNATING_SINGLE_LEG_TAPDOWNS-RECOVER_STRETCH': {
      id: 883,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Chair Alternating Single Leg Tapdowns',
      short_name: 'Single Leg Tapdowns',
      unique_name:
        'BEGINNER-CHAIR_ALTERNATING_SINGLE_LEG_TAPDOWNS-RECOVER_STRETCH',
      description:
        '1. Sit tall on the edge of a chair, feet flat on the floor. Hold each side of the chair for support. Keeping a straight spine and hips square, lean upper body back and lift both feet off the floor until your knees are over your hips, shins parallel to the floor.\n2. Engage core and lower one leg toward the floor to tap your toe.\n3. Return to start and repeat other side. Right and left is one rep.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2303,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '69c5a36e94c5eceb8b4312e1251f0f58751fc03ac9865328de025477c418e0b7',
          file_name:
            'videos/69c5a36e94c5eceb8b4312e1251f0f58751fc03ac9865328de025477c418e0b7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/69c5a36e94c5eceb8b4312e1251f0f58751fc03ac9865328de025477c418e0b7.mp4',
          name: 'BEGINNER-Chair_Alternating_Single_Leg_Tapdowns-RECOVER_STRETCH',
          description: null,
          size: 552874,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2304,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '78ff438d4612fadd76b766dba1916493b619c0a2e50df750f764634580f27ec2',
          file_name:
            'audios/78ff438d4612fadd76b766dba1916493b619c0a2e50df750f764634580f27ec2.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/78ff438d4612fadd76b766dba1916493b619c0a2e50df750f764634580f27ec2.mp3',
          name: 'BEGINNER-Chair_Alternating_Single_Leg_Tapdowns-RECOVER_STRETCH',
          description: null,
          size: 43495,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_KNEE_TUCKS-RECOVER_STRETCH': {
      id: 884,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Chair Knee Tucks',
      short_name: 'Chair Knee Tucks',
      unique_name: 'BEGINNER-CHAIR_KNEE_TUCKS-RECOVER_STRETCH',
      description:
        '1. Sit up tall on the edge of a chair, feet flat on the floor. Hold each side of the chair for support.\n2. Keeping a tall spine, lift both feet off the floor and tuck your knees into your chest, shins close to parallel to the floor.\n3. Engage your core and lean back as you extend legs long in front of you without touching the floor.\n4. Crunch both knees back into your chest as you sit up tall.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2305,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '1d0d20a5068ebee24c372b150938d8dd73d501a0bb26b383446a4698c429a7e7',
          file_name:
            'videos/1d0d20a5068ebee24c372b150938d8dd73d501a0bb26b383446a4698c429a7e7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1d0d20a5068ebee24c372b150938d8dd73d501a0bb26b383446a4698c429a7e7.mp4',
          name: 'BEGINNER-Chair_Knee_Tucks-RECOVER_STRETCH',
          description: null,
          size: 479203,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2306,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '1664b123c852363484e2c8990f05b362c65ee33a71252a40c699d8f3efa179dd',
          file_name:
            'audios/1664b123c852363484e2c8990f05b362c65ee33a71252a40c699d8f3efa179dd.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1664b123c852363484e2c8990f05b362c65ee33a71252a40c699d8f3efa179dd.mp3',
          name: 'BEGINNER-Chair_Knee_Tucks-RECOVER_STRETCH',
          description: null,
          size: 26011,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_WOOD_CHOPPERS-RECOVER_STRETCH': {
      id: 885,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Chair Wood Choppers',
      short_name: 'Chair Wood Choppers',
      unique_name: 'BEGINNER-CHAIR_WOOD_CHOPPERS-RECOVER_STRETCH',
      description:
        '1. Sit up tall on a chair, feet firmly on floor.\n2. Keeping hips square, raise both arms up and at a diagonal over one shoulder, arms straight and hands close together. You can also hold a light weight or ball.\n3. Keeping arms straight, engage core and swiftly chop down and across your body to the opposite hip.\n4. Raise arms back up again to repeat. ',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2307,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '2e86cc15f97013dda314aca5c50b12cba3dc7e4b8cb560ee6b3e641959b5f9ea',
          file_name:
            'videos/2e86cc15f97013dda314aca5c50b12cba3dc7e4b8cb560ee6b3e641959b5f9ea.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/2e86cc15f97013dda314aca5c50b12cba3dc7e4b8cb560ee6b3e641959b5f9ea.mp4',
          name: 'BEGINNER-Chair_Wood_Choppers-RECOVER_STRETCH-LEFT',
          description: 'Left Side',
          size: 618472,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2308,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: '49f31b70beb8bff6ad22cad795f34cff50dda600454e73ebe2e593ac16ce5bea',
          file_name:
            'videos/49f31b70beb8bff6ad22cad795f34cff50dda600454e73ebe2e593ac16ce5bea.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/49f31b70beb8bff6ad22cad795f34cff50dda600454e73ebe2e593ac16ce5bea.mp4',
          name: 'BEGINNER-Chair_Wood_Choppers-RECOVER_STRETCH-RIGHT',
          description: 'Right Side',
          size: 657403,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2309,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'cc9249716afa408f12ae7d61c30fcb14d7bff3eaf19a22d6fe6aa7d8b7bf26cc',
          file_name:
            'audios/cc9249716afa408f12ae7d61c30fcb14d7bff3eaf19a22d6fe6aa7d8b7bf26cc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cc9249716afa408f12ae7d61c30fcb14d7bff3eaf19a22d6fe6aa7d8b7bf26cc.mp3',
          name: 'BEGINNER-Chair_Wood_Choppers-RECOVER_STRETCH',
          description: null,
          size: 27655,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_KNEE_TO_ELBOW_CRUNCHES-RECOVER_STRETCH': {
      id: 886,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Chair Knee to Elbow Crunches',
      short_name: 'Chair Knee to Elbow Crunches',
      unique_name: 'BEGINNER-CHAIR_KNEE_TO_ELBOW_CRUNCHES-RECOVER_STRETCH',
      description:
        '1. Sit up tall on a chair, feet firmly on floor.\n2. Reach your arm overhead, pit of elbow by ear and extend your leg long to the side of the chair.\n3. Simultaneously crunch extended arm and leg in, bringing elbow and knee together. Pause.\n4. Extend arm and leg back out. Perform all reps. Repeat other side',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2310,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'f7cc4fda89229e6891a066a19b91159106150911e026b85a94dbfd9f661d78fe',
          file_name:
            'videos/f7cc4fda89229e6891a066a19b91159106150911e026b85a94dbfd9f661d78fe.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f7cc4fda89229e6891a066a19b91159106150911e026b85a94dbfd9f661d78fe.mp4',
          name: 'BEGINNER-Chair_Knee_to_Elbow_Crunches-RECOVER_STRETCH-LEFT',
          description: 'Left Side',
          size: 714060,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2311,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: 'd9030f837235cab6415d51f361dc55da0a5be6a9f85d6cb84c4f22ebc43933e2',
          file_name:
            'videos/d9030f837235cab6415d51f361dc55da0a5be6a9f85d6cb84c4f22ebc43933e2.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d9030f837235cab6415d51f361dc55da0a5be6a9f85d6cb84c4f22ebc43933e2.mp4',
          name: 'BEGINNER-Chair_Knee_to_Elbow_Crunches-RECOVER_STRETCH-RIGHT',
          description: 'Right Side',
          size: 687035,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2312,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '43184f209bb4d703fc81fd5fce940e7c8f3d3cfd0408a68c79c58a9e7518c187',
          file_name:
            'audios/43184f209bb4d703fc81fd5fce940e7c8f3d3cfd0408a68c79c58a9e7518c187.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/43184f209bb4d703fc81fd5fce940e7c8f3d3cfd0408a68c79c58a9e7518c187.mp3',
          name: 'BEGINNER-Chair_Knee_to_Elbow_Crunches-RECOVER_STRETCH',
          description: null,
          size: 34535,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHAIR_ALTERNATING_KNEE_TO_ELBOW_TWISTS-RECOVER_STRETCH': {
      id: 887,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Chair Alternating Knee to Elbow Twists',
      short_name: 'Knee to Elbow Twists',
      unique_name:
        'BEGINNER-CHAIR_ALTERNATING_KNEE_TO_ELBOW_TWISTS-RECOVER_STRETCH',
      description:
        '1. Sit up tall on a chair, feet firmly on floor, hands behind your head, elbows point out.\n2. Lift one foot off the floor and bring your knee up toward your chest.\n3. Rotate your torso toward the bent leg and tap your elbow to your knee.\n4. Return to start and repeat other side.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2313,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'ca64aae223de2f614af68949307d1ba798738da89eef0d51c1a28b2dbcfa3d5a',
          file_name:
            'videos/ca64aae223de2f614af68949307d1ba798738da89eef0d51c1a28b2dbcfa3d5a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/ca64aae223de2f614af68949307d1ba798738da89eef0d51c1a28b2dbcfa3d5a.mp4',
          name: 'BEGINNER-Chair_Alternating_Knee_to_Elbow_Twists-RECOVER_STRETCH',
          description: null,
          size: 797741,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2314,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'cb05d283fb962daeb1810f5581b1e41a5f812a5a171065e0a810c6b5c115c2fc',
          file_name:
            'audios/cb05d283fb962daeb1810f5581b1e41a5f812a5a171065e0a810c6b5c115c2fc.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/cb05d283fb962daeb1810f5581b1e41a5f812a5a171065e0a810c6b5c115c2fc.mp3',
          name: 'BEGINNER-Chair_Alternating_Knee_to_Elbow_Twists-RECOVER_STRETCH',
          description: null,
          size: 42603,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SEATED_BICYCLES-RECOVER_STRETCH': {
      id: 888,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'CORE',
      name: 'Seated Bicycles',
      short_name: 'Seated Bicycles',
      unique_name: 'BEGINNER-SEATED_BICYCLES-RECOVER_STRETCH',
      description:
        '1. Sit tall on the edge of a chair, feet flat on floor. Hold the sides of the chair for support.\n2. Keeping a straight spine, lean your upper body back and lift both feet off the floor until your knees are over your hips, shins parallel to the floor.\n3. Extend one leg straight out and twist your torso so opposite shoulder moves towards bent knee.\n4. Repeat other side. Right and left is one rep.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 11,
          name: 'Chair',
          unique_name: 'CHAIR',
          min_app_version: 200070000,
          order: 12000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 2,
          unique_name: 'ABS',
          name: 'Abs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 9,
          unique_name: 'CORE',
          name: 'Core',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 15,
          unique_name: 'OBLIQUES',
          name: 'Obliques',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2315,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'a9d68a9d179295069739cdef22330468d638ee4d380109b50db9321cb4e3bc59',
          file_name:
            'videos/a9d68a9d179295069739cdef22330468d638ee4d380109b50db9321cb4e3bc59.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a9d68a9d179295069739cdef22330468d638ee4d380109b50db9321cb4e3bc59.mp4',
          name: 'BEGINNER-Seated_Bicycles-RECOVER_STRETCH',
          description: null,
          size: 662876,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2316,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '61ceceaf07c27d0b1e7396abe6f3bee4e2439a56f82fec11e68fb17eb3dd630b',
          file_name:
            'audios/61ceceaf07c27d0b1e7396abe6f3bee4e2439a56f82fec11e68fb17eb3dd630b.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/61ceceaf07c27d0b1e7396abe6f3bee4e2439a56f82fec11e68fb17eb3dd630b.mp3',
          name: 'BEGINNER-Seated_Bicycles-RECOVER_STRETCH',
          description: null,
          size: 27058,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-HAMSTRING_ROLLS-RECOVER_STRETCH': {
      id: 889,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Hamstring Rolls',
      short_name: 'Hamstring Rolls',
      unique_name: 'BEGINNER-HAMSTRING_ROLLS-RECOVER_STRETCH',
      description:
        '1. Sit with legs straight and arms behind hips, palms flat.\n2. Bend one knee and put foot flat. Place a foam roller horizontally under extended leg. Push through foot and hands to raise hips, keeping light pressure on the roller.\n3. Move hips forward and back as roller travels up and down the back of your leg, from glutes to pit of knee. Control pressure and pace as needed.\n4. Repeat other leg.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 10,
          name: 'Foam Roller',
          unique_name: 'FOAM_ROLLER',
          min_app_version: 200070000,
          order: 13000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 12,
          unique_name: 'HAMSTRINGS',
          name: 'Hamstrings',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2317,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '7c0983c35a779687dbb1ec361da95713059dab6eaf2e9acf577257da1e44611c',
          file_name:
            'videos/7c0983c35a779687dbb1ec361da95713059dab6eaf2e9acf577257da1e44611c.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7c0983c35a779687dbb1ec361da95713059dab6eaf2e9acf577257da1e44611c.mp4',
          name: 'BEGINNER-Hamstring_Rolls-RECOVER_STRETCH-LEFT',
          description: 'Left Side',
          size: 1157345,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2318,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: '6fe08cf21fab83047720e79becbb1ed0fea394ad307985d94efe34a6b98b35d5',
          file_name:
            'videos/6fe08cf21fab83047720e79becbb1ed0fea394ad307985d94efe34a6b98b35d5.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/6fe08cf21fab83047720e79becbb1ed0fea394ad307985d94efe34a6b98b35d5.mp4',
          name: 'BEGINNER-Hamstring_Rolls-RECOVER_STRETCH-RIGHT',
          description: 'Right Side',
          size: 1241109,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2319,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '02ad8e35d6eb41967e16ddf4bbc3542ba10379e5527b5827b399ce84dabdafba',
          file_name:
            'audios/02ad8e35d6eb41967e16ddf4bbc3542ba10379e5527b5827b399ce84dabdafba.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/02ad8e35d6eb41967e16ddf4bbc3542ba10379e5527b5827b399ce84dabdafba.mp3',
          name: 'BEGINNER-Hamstring_Rolls-RECOVER_STRETCH',
          description: null,
          size: 25927,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-GLUTE_ROLLS-RECOVER_STRETCH': {
      id: 890,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'Glute Rolls',
      short_name: 'Glute Rolls',
      unique_name: 'BEGINNER-GLUTE_ROLLS-RECOVER_STRETCH',
      description:
        '1. Sit on a foam roller with legs straight and arms behind your hips, palms flat.\n2. Bend one knee and cross it over the extended leg, foot flat. Shift weight toward extended leg. Push through foot and hand to raise hips, keeping light pressure on the roller.\n3. Move body forward and back as the roller travels up and down glutes and hip. Control pressure and pace as needed.\n4. Repeat other leg.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 10,
          name: 'Foam Roller',
          unique_name: 'FOAM_ROLLER',
          min_app_version: 200070000,
          order: 13000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 11,
          unique_name: 'GLUTES',
          name: 'Glutes',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2320,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '7de9fac7cea9c75f3ce7a008fe2d3f7ce3545489689ebd24e06163ec7e1dc961',
          file_name:
            'videos/7de9fac7cea9c75f3ce7a008fe2d3f7ce3545489689ebd24e06163ec7e1dc961.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7de9fac7cea9c75f3ce7a008fe2d3f7ce3545489689ebd24e06163ec7e1dc961.mp4',
          name: 'BEGINNER-Glute_Rolls-RECOVER_STRETCH-LEFT',
          description: 'Left Side',
          size: 1074522,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2321,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: '7469ee14ad4940674189e77faa68a4433700bb3c2e4ee07d6f90c61c4e57eabb',
          file_name:
            'videos/7469ee14ad4940674189e77faa68a4433700bb3c2e4ee07d6f90c61c4e57eabb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7469ee14ad4940674189e77faa68a4433700bb3c2e4ee07d6f90c61c4e57eabb.mp4',
          name: 'BEGINNER-Glute_Rolls-RECOVER_STRETCH-RIGHT',
          description: 'Right Side',
          size: 972706,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2322,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'c06dd0e3177e05248d4351ac21f3a72fd5e868ef6c6c6aeea13e54ddbff1d9c3',
          file_name:
            'audios/c06dd0e3177e05248d4351ac21f3a72fd5e868ef6c6c6aeea13e54ddbff1d9c3.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/c06dd0e3177e05248d4351ac21f3a72fd5e868ef6c6c6aeea13e54ddbff1d9c3.mp3',
          name: 'BEGINNER-Glute_Rolls-RECOVER_STRETCH',
          description: null,
          size: 23247,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-SHOULDER_ROLLS-RECOVER_STRETCH': {
      id: 905,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Shoulder Rolls',
      short_name: 'Shoulder Rolls',
      unique_name: 'BEGINNER-SHOULDER_ROLLS-RECOVER_STRETCH',
      description:
        '1. Lie on the floor with knees slightly bent and place a foam roller underneath your shoulder blades horizontally. Hands behind head, elbows point out.\n2. Drive through your heels and lift hips, keeping light pressure on roller.\n3. Move your body forward and back as the roller travels up and down your shoulders. Control pressure and pace as needed. ',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 10,
          name: 'Foam Roller',
          unique_name: 'FOAM_ROLLER',
          min_app_version: 200070000,
          order: 13000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2351,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'a3651255e811537420bb774368489706cf884b6dba99dbe1e8c3958512499214',
          file_name:
            'videos/a3651255e811537420bb774368489706cf884b6dba99dbe1e8c3958512499214.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a3651255e811537420bb774368489706cf884b6dba99dbe1e8c3958512499214.mp4',
          name: 'BEGINNER-Shoulder_Rolls-RECOVER_STRETCH',
          description: null,
          size: 1001331,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2352,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '60b7a69df438544f7e51de0823df6c6c52781a322c5579d442a248502f50851c',
          file_name:
            'audios/60b7a69df438544f7e51de0823df6c6c52781a322c5579d442a248502f50851c.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/60b7a69df438544f7e51de0823df6c6c52781a322c5579d442a248502f50851c.mp3',
          name: 'BEGINNER-Shoulder_Rolls-RECOVER_STRETCH',
          description: null,
          size: 24530,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-BACK_ROLLS-RECOVER_STRETCH': {
      id: 906,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Back Rolls',
      short_name: 'Back Rolls',
      unique_name: 'BEGINNER-BACK_ROLLS-RECOVER_STRETCH',
      description:
        '1. Lie on the floor with knees slightly bent and place a foam roller underneath your back horizontally. Hands behind head, elbows point out.\n2. Drive through your heels and lift hips, keeping light pressure on roller.\n3. Move your body forward and back as the roller travels up and down the length of your spine from shoulders to hips. Control pressure and pace as needed. ',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 10,
          name: 'Foam Roller',
          unique_name: 'FOAM_ROLLER',
          min_app_version: 200070000,
          order: 13000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2353,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '1860ba7aae1014aa2fe5ad2ce82f87a8c74383a6126cd27f06520a63f830f350',
          file_name:
            'videos/1860ba7aae1014aa2fe5ad2ce82f87a8c74383a6126cd27f06520a63f830f350.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1860ba7aae1014aa2fe5ad2ce82f87a8c74383a6126cd27f06520a63f830f350.mp4',
          name: 'BEGINNER-Back_Rolls-RECOVER_STRETCH',
          description: null,
          size: 997223,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2354,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: 'fa089fe6f377cd7b4b7d2da6c381170234bb50dd852002f89cac833e072440be',
          file_name:
            'audios/fa089fe6f377cd7b4b7d2da6c381170234bb50dd852002f89cac833e072440be.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/fa089fe6f377cd7b4b7d2da6c381170234bb50dd852002f89cac833e072440be.mp3',
          name: 'BEGINNER-Back_Rolls-RECOVER_STRETCH',
          description: null,
          size: 23380,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-LOWER_BACK_ROLLS-RECOVER_STRETCH': {
      id: 907,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Lower Back Rolls',
      short_name: 'Lower Back Rolls',
      unique_name: 'BEGINNER-LOWER_BACK_ROLLS-RECOVER_STRETCH',
      description:
        '1. Lie on your back and place a foam roller under your hips horizontally. Place hands on floor by hips, palms flat. Bend knees and raise them directly over hips, feet in line with knees.\n2. Rotate hips and lower knees to one side as you massage low back with the roller. Keep shoulders square and upper back on floor.\n3. Raise knees to start and drop to opposite side. Rock back and forth.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 10,
          name: 'Foam Roller',
          unique_name: 'FOAM_ROLLER',
          min_app_version: 200070000,
          order: 13000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 5,
          unique_name: 'BACK',
          name: 'Back',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2355,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'f01e601ec6709eecc5bf2255b565c48bd1fa76e56402aa6531f7d64cdd275732',
          file_name:
            'videos/f01e601ec6709eecc5bf2255b565c48bd1fa76e56402aa6531f7d64cdd275732.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f01e601ec6709eecc5bf2255b565c48bd1fa76e56402aa6531f7d64cdd275732.mp4',
          name: 'BEGINNER-Lower_Back_Rolls-RECOVER_STRETCH',
          description: null,
          size: 908413,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2356,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '526592d1e63651b3694b206d69e5e6676995173eb8bc9ae168928fd7c6554790',
          file_name:
            'audios/526592d1e63651b3694b206d69e5e6676995173eb8bc9ae168928fd7c6554790.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/526592d1e63651b3694b206d69e5e6676995173eb8bc9ae168928fd7c6554790.mp3',
          name: 'BEGINNER-Lower_Back_Rolls-RECOVER_STRETCH',
          description: null,
          size: 28083,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-I_T_BAND_ROLLS-RECOVER_STRETCH': {
      id: 908,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'LOWER_BODY',
      name: 'IT Band Rolls',
      short_name: 'IT Band Rolls',
      unique_name: 'BEGINNER-I_T_BAND_ROLLS-RECOVER_STRETCH',
      description:
        '1. Lie on one side, propping weight on forearm and stabilizing with top hand.\n2. Place a foam roller horizontally under bottom leg and cross top leg over, foot flat. Push through foot and hands to raise hips, keeping light pressure on roller.\n3. Move your body so the roller travels up and down the side of your thigh, from knee to hip. Control pressure and pace as needed.\n4. Repeat other leg.',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 10,
          name: 'Foam Roller',
          unique_name: 'FOAM_ROLLER',
          min_app_version: 200070000,
          order: 13000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 13,
          unique_name: 'HIPFLEXORS',
          name: 'Hipflexors',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 14,
          unique_name: 'LEGS',
          name: 'Legs',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 24,
          unique_name: 'THIRD_TRIMESTER',
          name: 'Trimester 3',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2357,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: 'cba50d14377727821c2f9c4afaca745604ab16d75d06dc97035f1fe3d0abd56e',
          file_name:
            'videos/cba50d14377727821c2f9c4afaca745604ab16d75d06dc97035f1fe3d0abd56e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/cba50d14377727821c2f9c4afaca745604ab16d75d06dc97035f1fe3d0abd56e.mp4',
          name: 'BEGINNER-IT_Band_Rolls-RECOVER_STRETCH-LEFT',
          description: 'Left Side',
          size: 1103372,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2358,
          collection_name: 'videos',
          order: 2,
          version: 200070000,
          hash: '3a41ae183ebc7c4110c9ff05d1f8a158ab24d114f33703020d04ff660e194e81',
          file_name:
            'videos/3a41ae183ebc7c4110c9ff05d1f8a158ab24d114f33703020d04ff660e194e81.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/3a41ae183ebc7c4110c9ff05d1f8a158ab24d114f33703020d04ff660e194e81.mp4',
          name: 'BEGINNER-IT_Band_Rolls-RECOVER_STRETCH-RIGHT',
          description: 'Right Side',
          size: 1225713,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2359,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '437c692c7b8413cfe1fbba7369b7ffc519224d59a1ff20ce282ebb9bb0523ad5',
          file_name:
            'audios/437c692c7b8413cfe1fbba7369b7ffc519224d59a1ff20ce282ebb9bb0523ad5.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/437c692c7b8413cfe1fbba7369b7ffc519224d59a1ff20ce282ebb9bb0523ad5.mp3',
          name: 'BEGINNER-IT_Band_Rolls-RECOVER_STRETCH',
          description: null,
          size: 27793,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    'BEGINNER-CHEST_OPENER-RECOVER_STRETCH': {
      id: 909,
      segment_type: 'RECOVER_STRETCH',
      fitness_level: 'BEGINNER',
      focus_area: 'UPPER_BODY',
      name: 'Chest Opener',
      short_name: 'Chest Opener',
      unique_name: 'BEGINNER-CHEST_OPENER-RECOVER_STRETCH',
      description:
        '1. Lay on the floor with knees slightly bent, feet flat. Place a foam roller underneath your spine vertically.\n2. Drive through your heels to lift hips up, keeping light pressure on roller.\n3. Raise both arms up and open them out to a T-shape at shoulder height. Rest back of hands on floor. Breathe into the stretch. ',
      preview_time: null,
      min_app_version: 200070000,
      archived: false,
      equipment: [
        {
          id: 10,
          name: 'Foam Roller',
          unique_name: 'FOAM_ROLLER',
          min_app_version: 200070000,
          order: 13000,
          is_visible: false,
        },
      ],
      tags: [
        {
          id: 8,
          unique_name: 'CHEST',
          name: 'Chest',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 17,
          unique_name: 'SHOULDERS',
          name: 'Shoulders',
          tagCategory: {
            id: 1,
            unique_name: 'MUSCLE_GROUP',
            name: 'Muscle Group',
          },
          order: 1,
        },
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2360,
          collection_name: 'videos',
          order: 1,
          version: 200070000,
          hash: '0de0dbe85ebecce6ba23252fa5e370f7bb2fd30a84b2a5222808ac2736c29174',
          file_name:
            'videos/0de0dbe85ebecce6ba23252fa5e370f7bb2fd30a84b2a5222808ac2736c29174.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0de0dbe85ebecce6ba23252fa5e370f7bb2fd30a84b2a5222808ac2736c29174.mp4',
          name: 'BEGINNER-Chest_Opener-RECOVER_STRETCH',
          description: null,
          size: 512405,
          mime_type: 'video/mp4',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
        {
          id: 2361,
          collection_name: 'audios',
          order: 1,
          version: 200070000,
          hash: '1a8c40203a197d8c2a735ab5ce51bfb2bd9b695d0c286d1b3351455f17ed0e17',
          file_name:
            'audios/1a8c40203a197d8c2a735ab5ce51bfb2bd9b695d0c286d1b3351455f17ed0e17.mp3',
          url: 'https://dj14u43q22646.cloudfront.net/audios/1a8c40203a197d8c2a735ab5ce51bfb2bd9b695d0c286d1b3351455f17ed0e17.mp3',
          name: 'BEGINNER-Chest_Opener-RECOVER_STRETCH',
          description: null,
          size: 24047,
          mime_type: 'audio/mpeg',
          is_video_audible: false,
          is_low_resolution_file: false,
          low_resolution_file_hash: null,
        },
      ],
    },
    YOGA_BASICS: {
      id: 1000,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Yoga Basics',
      short_name: 'Yoga Basics',
      unique_name: 'YOGA_BASICS',
      description:
        "*A perfect add-on after your workout, or great on those rest days*\n\nEmbark on a journey to inner peace and flexibility with our Yoga Basics class. Suitable for all levels, this sequence includes fundamental poses like Mountain, Forward Fold, Cobra, and Chair Pose.\n\nIt enhances strength, flexibility, and mindfulness without requiring any equipment, making it accessible to all.\n\nAs you flow through the poses, you'll cultivate a holistic practice for mind, body, and spirit, guided by intentional breathwork and mindful movement.\n\nFrom grounding Mountain Pose to relaxing Savasana, each posture offers an opportunity for growth and self-discovery. Join us and experience the transformative power of yoga.",
      preview_time: null,
      min_app_version: 300030005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2615,
          collection_name: 'videos',
          order: 1,
          version: 300030005,
          hash: 'd307ec3b65c0bfbcd1328631d6e471459b71d4d4c1eaefdccb1d7a6c49d1d6bd',
          file_name:
            'videos/d307ec3b65c0bfbcd1328631d6e471459b71d4d4c1eaefdccb1d7a6c49d1d6bd.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/d307ec3b65c0bfbcd1328631d6e471459b71d4d4c1eaefdccb1d7a6c49d1d6bd.mp4',
          name: 'YogaBasics-Full-Class',
          description: null,
          size: 213345813,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '452e8d79ca7cade21b065a13b4a5e535e2db932916b6c46bdbafb6ddbe463d30',
        },
        {
          id: 2631,
          collection_name: 'videos',
          order: 2,
          version: 300050001,
          hash: '452e8d79ca7cade21b065a13b4a5e535e2db932916b6c46bdbafb6ddbe463d30',
          file_name:
            'videos/452e8d79ca7cade21b065a13b4a5e535e2db932916b6c46bdbafb6ddbe463d30.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/452e8d79ca7cade21b065a13b4a5e535e2db932916b6c46bdbafb6ddbe463d30.mp4',
          name: '452e8d79ca7cade21b065a13b4a5e535e2db932916b6c46bdbafb6ddbe463d30',
          description: null,
          size: 29855412,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    YOGA_FLOW_ESSENTIALS: {
      id: 1001,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Yoga Flow Essentials',
      short_name: 'Yoga Flow Essentials',
      unique_name: 'YOGA_FLOW_ESSENTIALS',
      description:
        "*Designed to replenish energy, this Yoga class is an ideal complement to your fitness routine or a rejuvenating option for rest days. Suitable for all levels.*\n\nWith empowering poses such as Warrior 2, Crescent Lunge, and Triangle Pose, this dynamic flow cultivates strength, flexibility, and inner peace, invigorating both body and spirit.\n\nThis dynamic flow incorporates empowering poses like Warrior 2, Crescent Lunge, and Triangle Pose, promoting strength and flexibility.\n\nBegin with Downward Facing Dog, then transition to High Plank before moving into Rag Doll for spinal decompression. Flow through Mountain Pose, Forward Fold, and Halfway Lift, then into Low Crescent Lunge and Knee Plank for core strength.\n\nFlow through the practice with intention and mindfulness, finishing with Chair Pose and Firelog Pose, connecting deeply with your body and breath.\n\nThis sequence offers more than just physical exercise; it's a journey of self-discovery and transformation through the practice of yoga.",
      preview_time: null,
      min_app_version: 300030005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2616,
          collection_name: 'videos',
          order: 1,
          version: 300030005,
          hash: '54270dd97fe62a598f5ce7a4c099791299fbb8258637c8f6d9fc162755cba8fc',
          file_name:
            'videos/54270dd97fe62a598f5ce7a4c099791299fbb8258637c8f6d9fc162755cba8fc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/54270dd97fe62a598f5ce7a4c099791299fbb8258637c8f6d9fc162755cba8fc.mp4',
          name: 'YogaFlowEssentials-Full-Class',
          description: null,
          size: 320917907,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '731d44997fa05732bf3ac4dc5e0a96616a78099dca12e5f553fce0f7a07363d7',
        },
        {
          id: 2632,
          collection_name: 'videos',
          order: 2,
          version: 300050001,
          hash: '731d44997fa05732bf3ac4dc5e0a96616a78099dca12e5f553fce0f7a07363d7',
          file_name:
            'videos/731d44997fa05732bf3ac4dc5e0a96616a78099dca12e5f553fce0f7a07363d7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/731d44997fa05732bf3ac4dc5e0a96616a78099dca12e5f553fce0f7a07363d7.mp4',
          name: '731d44997fa05732bf3ac4dc5e0a96616a78099dca12e5f553fce0f7a07363d7',
          description: null,
          size: 42523211,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    YOGA_CORE_STRENGTH: {
      id: 1002,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'For Core Strength',
      short_name: 'For Core Strength',
      unique_name: 'YOGA_CORE_STRENGTH',
      description:
        '*Designed to enhance core stability and strength, this class complements your HiNote Life workouts and supports your daily activities.*\n\nThis class emphasizes core strength with poses like Boat, High Plank, and Bridge, fostering stability and balance. Concluding with calming poses such as Cobra and Corpse Pose, it offers a complete release, leaving you centered and rejuvenated.\n\nBegin with Boat Pose, engaging the core muscles to maintain balance, then transition smoothly through variations like Boat to Arms Up and Low Boat. Flow into Waterfall Pose and Yogi Bicycles to further activate the core muscles.\n\nExplore Bridge Pose for back and hip strength, followed by Rock and Roll to transition smoothly between poses. Engage in High Plank variations, incorporating movements like Plank Tap Outs and Forearm Plank to Hip Rocks to further challenge the core.\n\nEnd your practice with calming poses such as Cobra and Savasana, allowing your body to relax and release tension, leaving you feeling centered and revitalized.',
      preview_time: null,
      min_app_version: 300030005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2617,
          collection_name: 'videos',
          order: 1,
          version: 300030005,
          hash: '32706a08cf2e1c6c0589f7a8e5936b2ab596cc62a84efd63e0d6faf4a72464f7',
          file_name:
            'videos/32706a08cf2e1c6c0589f7a8e5936b2ab596cc62a84efd63e0d6faf4a72464f7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/32706a08cf2e1c6c0589f7a8e5936b2ab596cc62a84efd63e0d6faf4a72464f7.mp4',
          name: 'YogaforCore-Full-Class',
          description: null,
          size: 211805165,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            'b5eca22cf25f93f42e3be138d4d32c0bda3017f8e712f481eff6d8a39edcac0e',
        },
        {
          id: 2633,
          collection_name: 'videos',
          order: 2,
          version: 300050001,
          hash: 'b5eca22cf25f93f42e3be138d4d32c0bda3017f8e712f481eff6d8a39edcac0e',
          file_name:
            'videos/b5eca22cf25f93f42e3be138d4d32c0bda3017f8e712f481eff6d8a39edcac0e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b5eca22cf25f93f42e3be138d4d32c0bda3017f8e712f481eff6d8a39edcac0e.mp4',
          name: 'b5eca22cf25f93f42e3be138d4d32c0bda3017f8e712f481eff6d8a39edcac0e',
          description: null,
          size: 24672866,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    YOGA_RESTORATIVE: {
      id: 1003,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Restorative Yoga',
      short_name: 'Restorative Yoga',
      unique_name: 'YOGA_RESTORATIVE',
      description:
        '*This Restorative Yoga practice will help you relax and rejuvenate - getting you ready to take on the day or simply just wind down.*\n\nImmerse yourself in a deeply relaxing practice with poses like Reclined Butterfly and Reclined Figure 4, aimed at releasing tension and restoring balance. Crafted to promote rejuvenation and serenity, this class offers a tranquil experience, leaving you feeling refreshed and revitalized.\n\nBegin by preparing your mind and body for relaxation. Transition into Reclined Butterfly, allowing your hips to open and your body to soften. From there, move into Knees to Chest Pose, gently compressing the lower back and releasing tension.\n\nExplore the benefits of Figure 4 on both the right and left legs, stretching the hips and releasing any built-up tension. Conclude your practice with Savasana, surrendering fully to relaxation and allowing your body to absorb the benefits of your practice.\n\nThis class offers a sanctuary for your mind and body, providing a space for deep rest and rejuvenation. Leave feeling renewed and restored, ready to embrace the serenity that comes from within.',
      preview_time: null,
      min_app_version: 300030005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2618,
          collection_name: 'videos',
          order: 1,
          version: 300030005,
          hash: 'c06228521ce08fa1f38eb6b6367d7a84d54366a8840b449060bda0ac02f59bc6',
          file_name:
            'videos/c06228521ce08fa1f38eb6b6367d7a84d54366a8840b449060bda0ac02f59bc6.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c06228521ce08fa1f38eb6b6367d7a84d54366a8840b449060bda0ac02f59bc6.mp4',
          name: 'YogaRestorative-Full-Class',
          description: null,
          size: 122632189,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '8984bfef0c05d13715eab866462a359436d73fd4486cdbf80a2e502138e26887',
        },
        {
          id: 2634,
          collection_name: 'videos',
          order: 2,
          version: 300050001,
          hash: '8984bfef0c05d13715eab866462a359436d73fd4486cdbf80a2e502138e26887',
          file_name:
            'videos/8984bfef0c05d13715eab866462a359436d73fd4486cdbf80a2e502138e26887.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8984bfef0c05d13715eab866462a359436d73fd4486cdbf80a2e502138e26887.mp4',
          name: '8984bfef0c05d13715eab866462a359436d73fd4486cdbf80a2e502138e26887',
          description: null,
          size: 11767388,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    YOGA_POWER_FLOW: {
      id: 1004,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Power Flow Yoga',
      short_name: 'Power Flow Yoga',
      unique_name: 'YOGA_POWER_FLOW',
      description:
        '*Energize your day with this invigorating dynamic yoga practice.*\n\nDive into this dynamic Yoga flow of poses like Warrior 2 and Star Pose, revitalizing body and mind. This practice ignites energy, empowering you with renewed and ready to seize the day.\n\nBegin with grounding Downward Dog, transitioning through sequences challenging both body and spirit.\n\nExplore variations of Warrior 2, Star Pose, and Goddess Pose, embracing fluidity and breath.\n\nFeel the energy awaken muscles and invigorate the spirit.\n\nEach pose fosters strength, balance, and inner resilience. Conclude with grounding Boat Pose and Reclined Spinal Twist, surrendering into relaxation during Savasana.',
      preview_time: null,
      min_app_version: 300030005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2619,
          collection_name: 'videos',
          order: 1,
          version: 300030005,
          hash: '54cec6eb6813181531ce0ea60766faf6bd52d255dcc4b0e1d1346155ca5ace33',
          file_name:
            'videos/54cec6eb6813181531ce0ea60766faf6bd52d255dcc4b0e1d1346155ca5ace33.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/54cec6eb6813181531ce0ea60766faf6bd52d255dcc4b0e1d1346155ca5ace33.mp4',
          name: 'YogaPowerFlow-Full-Class',
          description: null,
          size: 269227901,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            'a42bc1ae5188ac1dc24fc6e3b495f9af6e108b59a916ab91d578af8c780f55c9',
        },
        {
          id: 2636,
          collection_name: 'videos',
          order: 2,
          version: 300050001,
          hash: 'a42bc1ae5188ac1dc24fc6e3b495f9af6e108b59a916ab91d578af8c780f55c9',
          file_name:
            'videos/a42bc1ae5188ac1dc24fc6e3b495f9af6e108b59a916ab91d578af8c780f55c9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a42bc1ae5188ac1dc24fc6e3b495f9af6e108b59a916ab91d578af8c780f55c9.mp4',
          name: 'a42bc1ae5188ac1dc24fc6e3b495f9af6e108b59a916ab91d578af8c780f55c9',
          description: null,
          size: 40621348,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    YOGA_FOR_EVERYONE: {
      id: 1005,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Yoga for Everyone',
      short_name: 'Yoga for Everyone',
      unique_name: 'YOGA_FOR_EVERYONE',
      description:
        '*This welcoming yoga class is for all levels, even if you have never done Yoga before or the type of person that says ‘I don’t do Yoga’.*\n\nTry this yoga class, regardless if you have tried Yoga before or never thought yoga was for you. This session will explain the key concepts, introduce you to Yoga poses, all designed to welcome you and continue the day with renewed energy.\n\nFeel your muscles awaken. Each pose the instructor guides you through, will help with your strength, balance, and inner resilience.\n\nGive it a try for yourself! Experience the transformative effects of Yoga, leaving you refreshed and ready for whatever the day brings.',
      preview_time: null,
      min_app_version: 300030005,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 25,
          unique_name: 'POSTPARTUM',
          name: 'Postpartum',
          tagCategory: { id: 4, unique_name: 'POSTPARTUM', name: 'Postpartum' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2620,
          collection_name: 'videos',
          order: 1,
          version: 300030005,
          hash: '982ee9844ed4692bbaf16d4660d7e15f79f925ede982e462635d2e75d9b253bb',
          file_name:
            'videos/982ee9844ed4692bbaf16d4660d7e15f79f925ede982e462635d2e75d9b253bb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/982ee9844ed4692bbaf16d4660d7e15f79f925ede982e462635d2e75d9b253bb.mp4',
          name: 'YogaforEveryone-Full-Class',
          description: null,
          size: 218873261,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            'c7a119209df0eefb3cac2168a1433eef6ec668fc9a70a65f8fce955f10b70fa7',
        },
        {
          id: 2635,
          collection_name: 'videos',
          order: 2,
          version: 300050001,
          hash: 'c7a119209df0eefb3cac2168a1433eef6ec668fc9a70a65f8fce955f10b70fa7',
          file_name:
            'videos/c7a119209df0eefb3cac2168a1433eef6ec668fc9a70a65f8fce955f10b70fa7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c7a119209df0eefb3cac2168a1433eef6ec668fc9a70a65f8fce955f10b70fa7.mp4',
          name: 'c7a119209df0eefb3cac2168a1433eef6ec668fc9a70a65f8fce955f10b70fa7',
          description: null,
          size: 30509436,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    INTRO_TO_FIT52: {
      id: 1006,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: "Carrie's Intro Workout",
      short_name: "Carrie's Intro Workout",
      unique_name: 'INTRO_TO_FIT52',
      description:
        "*Carrie's Intro Workout*\n\nJumpstart your fitness journey with Carrie Underwood as she explains the HiNote Life workout format and guides you through an introductory workout!\n\nThis beginner-friendly workout is perfect for anyone new to HiNote Life. Designed to engage your entire body, this session includes a mix of dynamic cardio, strength-building exercises, and relaxing stretches.\n\nJoin Carrie and take your first step towards a healthier, stronger you with HiNote Life!\n\n*Equipment:* None\nIf you wish to level up, two pairs of dumbbells (one heavier and one lighter) can be used.\n\n*Time:* 10 Mins\n\n*Suitable for:* All Fitness Levels",
      preview_time: null,
      min_app_version: 300050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2621,
          collection_name: 'videos',
          order: 1,
          version: 300050000,
          hash: '1d1263a2e597fbefc7b3f81d14931931ba10a4ad63abc4835e1e233b0b63ca45',
          file_name:
            'videos/1d1263a2e597fbefc7b3f81d14931931ba10a4ad63abc4835e1e233b0b63ca45.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1d1263a2e597fbefc7b3f81d14931931ba10a4ad63abc4835e1e233b0b63ca45.mp4',
          name: '1d1263a2e597fbefc7b3f81d14931931ba10a4ad63abc4835e1e233b0b63ca45',
          description: null,
          size: 206991464,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '8b69abe03cbb710efd8e6072260b6d8f8537e393e568f8d0ba2c02652a604809',
        },
        {
          id: 2626,
          collection_name: 'videos',
          order: 2,
          version: 300050001,
          hash: '8b69abe03cbb710efd8e6072260b6d8f8537e393e568f8d0ba2c02652a604809',
          file_name:
            'videos/8b69abe03cbb710efd8e6072260b6d8f8537e393e568f8d0ba2c02652a604809.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8b69abe03cbb710efd8e6072260b6d8f8537e393e568f8d0ba2c02652a604809.mp4',
          name: '8b69abe03cbb710efd8e6072260b6d8f8537e393e568f8d0ba2c02652a604809',
          description: null,
          size: 28310176,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    LOWER_BODY_BURN: {
      id: 1007,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Lower Body Burn',
      short_name: 'Lower Body Burn',
      unique_name: 'LOWER_BODY_BURN',
      description:
        "*Lower Body Burn*\n\nTone and sculpt your legs with Carrie's Lower Body Burn workout! This session is designed to target your glutes, thighs, and calves, providing a comprehensive lower body workout in less than 15 minutes!\n\nWhether you're looking to build strength or achieve lean, defined legs, this workout has you covered. Join Carrie and feel the burn as you work through a variety of exercises, including kickbacks, squats, lunges, and glute bridges, all aimed at delivering a powerful lower body transformation.\n\nLet's get started and make those legs stronger and more toned with HiNote Life!\n\n*Equipment:* Dumbbells, Mini band, Bench/Step or Chair.\nWorkout can also be done without equipment.\n\n*Time:* 13 Mins\n\n*Suitable for:* All Fitness Levels",
      preview_time: null,
      min_app_version: 300050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2622,
          collection_name: 'videos',
          order: 1,
          version: 300050000,
          hash: 'c0f06760f90746a2b730a3a58c2130d1fdc70e68475cbdbdae18888d267f1597',
          file_name:
            'videos/c0f06760f90746a2b730a3a58c2130d1fdc70e68475cbdbdae18888d267f1597.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c0f06760f90746a2b730a3a58c2130d1fdc70e68475cbdbdae18888d267f1597.mp4',
          name: 'c0f06760f90746a2b730a3a58c2130d1fdc70e68475cbdbdae18888d267f1597',
          description: null,
          size: 279326764,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '0f3d3a780004ff59d82e4dd74a8b98a933c615e088beee51c2d356132c80a329',
        },
        {
          id: 2630,
          collection_name: 'videos',
          order: 2,
          version: 300050001,
          hash: '0f3d3a780004ff59d82e4dd74a8b98a933c615e088beee51c2d356132c80a329',
          file_name:
            'videos/0f3d3a780004ff59d82e4dd74a8b98a933c615e088beee51c2d356132c80a329.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0f3d3a780004ff59d82e4dd74a8b98a933c615e088beee51c2d356132c80a329.mp4',
          name: '0f3d3a780004ff59d82e4dd74a8b98a933c615e088beee51c2d356132c80a329',
          description: null,
          size: 34901672,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    UPPER_BODY_BLAST: {
      id: 1008,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Upper Body Blast',
      short_name: 'Upper Body Blast',
      unique_name: 'UPPER_BODY_BLAST',
      description:
        "*Upper Body Blast*\n\nEnergize your strength routine with this Upper Body Blast workout with Eve Overland! This session is designed to tone and strengthen your upper body while elevating your heart rate. Perfect for building endurance and muscle definition, this workout combines dynamic movements and boxing-inspired exercises with effective bodyweight moves.\n\nJoin Eve and get ready to sweat with fun exercises like shuffles, jabs, punches, and more. Let's power through this high-energy workout and take a step towards a fitter, stronger you with HiNote Life!\n\n*Equipment:* None. Workout can also be done with dumbbells to modify up.\n\n*Time:* 13 Mins\n\n*Suitable for:* All Fitness Levels",
      preview_time: null,
      min_app_version: 300050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2623,
          collection_name: 'videos',
          order: 1,
          version: 300050000,
          hash: '8357bfc3c32d199c509bdfd182f47ea839cd08bad4d17e90b22282c138a4940e',
          file_name:
            'videos/8357bfc3c32d199c509bdfd182f47ea839cd08bad4d17e90b22282c138a4940e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8357bfc3c32d199c509bdfd182f47ea839cd08bad4d17e90b22282c138a4940e.mp4',
          name: '8357bfc3c32d199c509bdfd182f47ea839cd08bad4d17e90b22282c138a4940e',
          description: null,
          size: 163535559,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '64ca134995a2556b17d15dd1e01b3c6bad6b61d5c104b9de77865422d684cd5a',
        },
        {
          id: 2627,
          collection_name: 'videos',
          order: 2,
          version: 300050001,
          hash: '64ca134995a2556b17d15dd1e01b3c6bad6b61d5c104b9de77865422d684cd5a',
          file_name:
            'videos/64ca134995a2556b17d15dd1e01b3c6bad6b61d5c104b9de77865422d684cd5a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/64ca134995a2556b17d15dd1e01b3c6bad6b61d5c104b9de77865422d684cd5a.mp4',
          name: '64ca134995a2556b17d15dd1e01b3c6bad6b61d5c104b9de77865422d684cd5a',
          description: null,
          size: 27393446,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    KETTLEBELLS_WITH_CARRIE: {
      id: 1009,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Kettlebells with Carrie',
      short_name: 'Kettlebells with Carrie',
      unique_name: 'KETTLEBELLS_WITH_CARRIE',
      description:
        "*Kettlebells with Carrie*\n\nStep up your routine with this 5 minute kettlebell workout! This session is designed to build strength and power, targeting your entire body with dynamic kettlebell exercises.\n\nPerfect for enhancing muscle tone combined with elements of cardio, this workout includes moves like kettlebell swings, goblet squats, deadlifts, and more.\n\nJoin Carrie and get ready to challenge yourself with a series of powerful kettlebell exercises that will leave you feeling strong and energized. Grab some kettlebells and let's get started!\n\n*Equipment:* Kettlebells. Choose a weight that you are comfortable with. Workout can also be done with dumbbells if kettlebells aren't available.\n\n*Time:* 5 Mins\n\n*Suitable for:* Intermediate & Advanced Fitness Levels",
      preview_time: null,
      min_app_version: 300050000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2624,
          collection_name: 'videos',
          order: 1,
          version: 300050000,
          hash: '1962a9a0d6244046686e1460d33d029a5f6367825f93839ac4104740b1a9cc5a',
          file_name:
            'videos/1962a9a0d6244046686e1460d33d029a5f6367825f93839ac4104740b1a9cc5a.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1962a9a0d6244046686e1460d33d029a5f6367825f93839ac4104740b1a9cc5a.mp4',
          name: '1962a9a0d6244046686e1460d33d029a5f6367825f93839ac4104740b1a9cc5a',
          description: null,
          size: 104517818,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            'f8a35f3aee0562e2265e0f80375b065517f3aa16f57ea87f8921b6550fbd31d8',
        },
        {
          id: 2628,
          collection_name: 'videos',
          order: 2,
          version: 300050001,
          hash: 'f8a35f3aee0562e2265e0f80375b065517f3aa16f57ea87f8921b6550fbd31d8',
          file_name:
            'videos/f8a35f3aee0562e2265e0f80375b065517f3aa16f57ea87f8921b6550fbd31d8.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/f8a35f3aee0562e2265e0f80375b065517f3aa16f57ea87f8921b6550fbd31d8.mp4',
          name: 'f8a35f3aee0562e2265e0f80375b065517f3aa16f57ea87f8921b6550fbd31d8',
          description: null,
          size: 15707325,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    CARRIES_HOT_HIIT: {
      id: 1010,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: "Carrie's Hot HIIT",
      short_name: "Carrie's Hot HIIT",
      unique_name: 'CARRIES_HOT_HIIT',
      description:
        "*Carrie's Hot HIIT*\n\nGet ready to sweat with Carrie's Hot HIIT workout! This high-intensity interval training (HIIT) session is designed to burn calories and build strength, combining powerful cardio bursts with muscle-toning moves.\n\nThe workout follows a HIIT format, with 40 seconds of exercise, 10 second hold, then 10 seconds of rest, with 2 exercises in each combo, 6 reps then 4 reps.  Don't worry, Eve will guide you through the workout!\n\nPerfect for anyone looking to push their limits and achieve maximum results in a short time, this workout includes a variety of exercises such as high knees, jump lunges, mountain climbers, plank shoulder taps, and more.\n\n*Equipment:* None.\n\n*Time:* 8 Mins\n\n*Suitable for:* Intermediate & Advanced Fitness Levels",
      preview_time: null,
      min_app_version: 300050000,
      archived: false,
      equipment: [],
      tags: [],
      files: [
        {
          id: 2625,
          collection_name: 'videos',
          order: 1,
          version: 300050000,
          hash: '0e5d1501b3bea27c950f75b5db3dbeb82714bc5bcd0594ba7beaf4324c1edc28',
          file_name:
            'videos/0e5d1501b3bea27c950f75b5db3dbeb82714bc5bcd0594ba7beaf4324c1edc28.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/0e5d1501b3bea27c950f75b5db3dbeb82714bc5bcd0594ba7beaf4324c1edc28.mp4',
          name: '0e5d1501b3bea27c950f75b5db3dbeb82714bc5bcd0594ba7beaf4324c1edc28',
          description: null,
          size: 164804472,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '287120791c8c1742868b25f7d50826409b0c250c3d76378231ba9d28c58af0fe',
        },
        {
          id: 2629,
          collection_name: 'videos',
          order: 2,
          version: 300050001,
          hash: '287120791c8c1742868b25f7d50826409b0c250c3d76378231ba9d28c58af0fe',
          file_name:
            'videos/287120791c8c1742868b25f7d50826409b0c250c3d76378231ba9d28c58af0fe.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/287120791c8c1742868b25f7d50826409b0c250c3d76378231ba9d28c58af0fe.mp4',
          name: '287120791c8c1742868b25f7d50826409b0c250c3d76378231ba9d28c58af0fe',
          description: null,
          size: 24638259,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    THE_FIT52_TEST: {
      id: 1011,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'The HiNote Life Test',
      short_name: 'The HiNote Life Test',
      unique_name: 'THE_FIT52_TEST',
      description:
        "*The HiNote Life Test*\n\nAssess your strength and flexibility with the HiNote Life Test. Designed by Eve Overland to help you gauge where you are on your fitness journey, allowing you to test your abilities and track your progress over time.\n\nYou can take the HiNote Life Test at anytime, whether you are just getting started and revisit it every few months to see how far you've come. Record your progress in a notebook or on your phone, and check back in on your progress.\n\nThe exercises - ranging from Push-Ups and Planks to Mountain Climbers and Squats - offer different levels to challenge yourself and find out where you stand.\n\nLet's get started and see where you are today with the HiNote Life Test!\n\n*Equipment:* Dumbbells. Can also be done without dumbbells to modify down.\n\n*Time:* 11 Mins\n\n*Suitable for:* All Fitness Levels",
      preview_time: null,
      min_app_version: 300060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2637,
          collection_name: 'videos',
          order: 1,
          version: 300060000,
          hash: '945cebd2756315cc9da9661dc2e44a046cba90429d3d4907379af06af7f1e871',
          file_name:
            'videos/945cebd2756315cc9da9661dc2e44a046cba90429d3d4907379af06af7f1e871.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/945cebd2756315cc9da9661dc2e44a046cba90429d3d4907379af06af7f1e871.mp4',
          name: '945cebd2756315cc9da9661dc2e44a046cba90429d3d4907379af06af7f1e871',
          description: '0',
          size: 137456026,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            'c5722036078107a2ddb350dfb70f1b692572632841faadb108017cb22e082776',
        },
        {
          id: 2642,
          collection_name: 'videos',
          order: 2,
          version: 300060000,
          hash: 'c5722036078107a2ddb350dfb70f1b692572632841faadb108017cb22e082776',
          file_name:
            'videos/c5722036078107a2ddb350dfb70f1b692572632841faadb108017cb22e082776.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c5722036078107a2ddb350dfb70f1b692572632841faadb108017cb22e082776.mp4',
          name: 'c5722036078107a2ddb350dfb70f1b692572632841faadb108017cb22e082776',
          description: null,
          size: 38389586,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    FIVE_X_FIVE_WORKOUT: {
      id: 1012,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: '5 x 5 Workout',
      short_name: '5 x 5 Workout',
      unique_name: 'FIVE_X_FIVE_WORKOUT',
      description:
        "*5 x 5 Workout*\n\nBoost your strength and endurance with this exciting 5x5 Workout!\n\nThis full-body workout is all about maximizing your strength and endurance with a focused, high-intensity routine. The 5x5 structure means you'll be performing 5 exercises - Dumbbell Thrusters, Jump Squats, Renegade Rows, Push-Ups, and Tricep Extensions - completing 5 reps of each exercise, and repeating the circuit for 5 rounds. Designed to challenge every major muscle group, this workout is perfect for building strength, power, and stamina.\n\nLet's get started and challenge yourself with this 5x5 Workout!\n\n*Equipment:* Dumbbells. Can also be done without dumbbells to modify down.\n\n*Time:* 7 Mins\n\n*Suitable for:* All Fitness Levels",
      preview_time: null,
      min_app_version: 300060000,
      archived: false,
      equipment: [],
      tags: [],
      files: [
        {
          id: 2638,
          collection_name: 'videos',
          order: 1,
          version: 300060000,
          hash: 'b455654fa10c69d0ab29f8431b8f4cdf59fd291547f220a92adfe74365e85a38',
          file_name:
            'videos/b455654fa10c69d0ab29f8431b8f4cdf59fd291547f220a92adfe74365e85a38.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b455654fa10c69d0ab29f8431b8f4cdf59fd291547f220a92adfe74365e85a38.mp4',
          name: 'b455654fa10c69d0ab29f8431b8f4cdf59fd291547f220a92adfe74365e85a38',
          description: null,
          size: 86707781,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '5a12bba1fef7ca0074b764ccbbfb19ffc1c7afed60df0642c693ac9e68f6b65e',
        },
        {
          id: 2643,
          collection_name: 'videos',
          order: 2,
          version: 300060000,
          hash: '5a12bba1fef7ca0074b764ccbbfb19ffc1c7afed60df0642c693ac9e68f6b65e',
          file_name:
            'videos/5a12bba1fef7ca0074b764ccbbfb19ffc1c7afed60df0642c693ac9e68f6b65e.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/5a12bba1fef7ca0074b764ccbbfb19ffc1c7afed60df0642c693ac9e68f6b65e.mp4',
          name: '5a12bba1fef7ca0074b764ccbbfb19ffc1c7afed60df0642c693ac9e68f6b65e',
          description: null,
          size: 24555443,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    LEG_DAY_WITH_CARRIE_AND_EVE: {
      id: 1013,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Leg Day with Carrie & Eve',
      short_name: 'Leg Day with Carrie & Eve',
      unique_name: 'LEG_DAY_WITH_CARRIE_AND_EVE',
      description:
        "*Leg Day with Carrie & Eve*\n\nStrengthen and sculpt your legs with both Carrie Underwood and Eve Overland in this Leg Day workout.\n\nThis unique routine has two options. Carrie is demonstrating each exercise, with Eve showing options to modify up or down to adapt the workout to all fitness levels.\n\nDesigned to target your lower body, you'll work through a series of exercises, including squats, deadlifts, and lunges, all focused on engaging your glutes, quads, and hamstrings.\n\nWhether you're looking to enhance your lower body strength or shape and define your legs, this workout has everything you need.\n\n*Equipment:* Dumbbells. Bench. Can also be done without dumbbells to modify down.\n\n*Time:* 8 Mins\n\n*Suitable for:* All Fitness Levels.\nFollow *Eve for Modified Down Exercises*\nFollow *Carrie for Modified Up Exercises*",
      preview_time: null,
      min_app_version: 300060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2639,
          collection_name: 'videos',
          order: 1,
          version: 300060000,
          hash: '702f8386ad346e5f4f801cd558a9bad2a44a75c3b9855c3ed6084f09f1e25a0b',
          file_name:
            'videos/702f8386ad346e5f4f801cd558a9bad2a44a75c3b9855c3ed6084f09f1e25a0b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/702f8386ad346e5f4f801cd558a9bad2a44a75c3b9855c3ed6084f09f1e25a0b.mp4',
          name: '702f8386ad346e5f4f801cd558a9bad2a44a75c3b9855c3ed6084f09f1e25a0b',
          description: null,
          size: 95884181,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '81b5e3146254cab05b3597fdfa5b8e88321e65f35fe7630b6b754658f98944d0',
        },
        {
          id: 2644,
          collection_name: 'videos',
          order: 2,
          version: 300060000,
          hash: '81b5e3146254cab05b3597fdfa5b8e88321e65f35fe7630b6b754658f98944d0',
          file_name:
            'videos/81b5e3146254cab05b3597fdfa5b8e88321e65f35fe7630b6b754658f98944d0.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/81b5e3146254cab05b3597fdfa5b8e88321e65f35fe7630b6b754658f98944d0.mp4',
          name: '81b5e3146254cab05b3597fdfa5b8e88321e65f35fe7630b6b754658f98944d0',
          description: null,
          size: 28530976,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    EVES_COOL_DOWN_SESSION: {
      id: 1014,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: "Eve's Cool-Down Session",
      short_name: "Eve's Cool-Down Session",
      unique_name: 'EVES_COOL_DOWN_SESSION',
      description:
        "*Eve's Cool-Down Session*\n\nUnwind and relax with Eve Overland's HiNote Life Cool-Down Session. This routine is designed to help you gradually bring your heart rate down and gently stretch your muscles after a HiNote Life workout.\n\nThrough a series of stretches, lunges, and yoga-inspired moves, you'll release tension, improve flexibility, and promote recovery.\n\nWhether you've just finished a high-intensity session or need a moment to reset, this routine is perfect for easing your body into a state of relaxation. Let's take a moment to cool down and care for your body with Eve's Cool-Down Routine!\n\n*Equipment:* None.\nA Yoga Mat is recommended.\n\n*Time:* 18 Mins\n\n*Suitable for:* All Fitness Levels",
      preview_time: null,
      min_app_version: 300060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
        {
          id: 23,
          unique_name: 'SECOND_TRIMESTER',
          name: 'Trimester 2',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2640,
          collection_name: 'videos',
          order: 1,
          version: 300060000,
          hash: '325e39be32806329377d399e0dd474c57807d9f650946af9723d6d96ff03d999',
          file_name:
            'videos/325e39be32806329377d399e0dd474c57807d9f650946af9723d6d96ff03d999.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/325e39be32806329377d399e0dd474c57807d9f650946af9723d6d96ff03d999.mp4',
          name: '325e39be32806329377d399e0dd474c57807d9f650946af9723d6d96ff03d999',
          description: null,
          size: 174299712,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            'a8355b896718686c0a783e2eea4bbe0d23efcc53f27ceeb699ac61307fb32e87',
        },
        {
          id: 2645,
          collection_name: 'videos',
          order: 2,
          version: 300060000,
          hash: 'a8355b896718686c0a783e2eea4bbe0d23efcc53f27ceeb699ac61307fb32e87',
          file_name:
            'videos/a8355b896718686c0a783e2eea4bbe0d23efcc53f27ceeb699ac61307fb32e87.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a8355b896718686c0a783e2eea4bbe0d23efcc53f27ceeb699ac61307fb32e87.mp4',
          name: 'a8355b896718686c0a783e2eea4bbe0d23efcc53f27ceeb699ac61307fb32e87',
          description: null,
          size: 53092829,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    EVES_MOBILITY_SESSION: {
      id: 1015,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: "Eve's Mobility Session",
      short_name: "Eve's Mobility Session",
      unique_name: 'EVES_MOBILITY_SESSION',
      description:
        "*Eve's Mobility Session*\n\nEnhance your flexibility and joint mobility with Eve's Mobility Session.\n\nThis workout is designed to improve your range of motion and support overall movement quality, making it perfect for both active recovery days and adding more fluidity to your workouts.\n\nYou'll move through a series of stretches and mobility exercises like Shoulder Dislocates, Hip Hinge to Deep Squat, and Thread the Needle, all aimed at loosening tight muscles and promoting better flexibility.\n\n*Equipment:* A broom stick or PVC pipe.\nA Yoga Mat is recommended.\n\n*Time:* 24 Mins\n\n*Suitable for:* All Fitness Levels",
      preview_time: null,
      min_app_version: 300060000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 2641,
          collection_name: 'videos',
          order: 1,
          version: 300060000,
          hash: 'c5fe436e86603fdc03bfcc267c5407a325c9e23c7870c2b5643da1687aaefb69',
          file_name:
            'videos/c5fe436e86603fdc03bfcc267c5407a325c9e23c7870c2b5643da1687aaefb69.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c5fe436e86603fdc03bfcc267c5407a325c9e23c7870c2b5643da1687aaefb69.mp4',
          name: 'c5fe436e86603fdc03bfcc267c5407a325c9e23c7870c2b5643da1687aaefb69',
          description: null,
          size: 258240135,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '26551fb33f4a676823b50486baba0fd10e68c1c57379d4650c027e6bd25c8f38',
        },
        {
          id: 2646,
          collection_name: 'videos',
          order: 2,
          version: 300060000,
          hash: '26551fb33f4a676823b50486baba0fd10e68c1c57379d4650c027e6bd25c8f38',
          file_name:
            'videos/26551fb33f4a676823b50486baba0fd10e68c1c57379d4650c027e6bd25c8f38.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/26551fb33f4a676823b50486baba0fd10e68c1c57379d4650c027e6bd25c8f38.mp4',
          name: '26551fb33f4a676823b50486baba0fd10e68c1c57379d4650c027e6bd25c8f38',
          description: null,
          size: 73766266,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
      ],
    },
    CARRIES_CARDIO: {
      id: 1303,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: "Carrie's Cardio",
      short_name: "Carrie's Cardio",
      unique_name: 'CARRIES_CARDIO',
      description:
        "*Carrie's Cardio*\n\nGet ready to sweat with Carrie and Eve in this energizing full-body cardio workout! Designed to boost your heart rate and build endurance, Carrie's Cardio is all about high-energy movement and fun.\n\nThis bodyweight-only session combines explosive exercises, core work, and lower-body burners to challenge you from head to toe. Short recovery breaks keep the intensity high and your energy up.\n\nCarrie demos the moves while Eve offers modifications and form tips to keep you moving safely and effectively.\n\nNo equipment needed - just your determination and a towel for sweat!\n\n*Equipment:* None\n\n*Time:* 13 Mins\n\n*Suitable for:* All Fitness Levels\n\n*Focus Areas:* Cardio, Core, Lower Body",
      preview_time: null,
      min_app_version: 300120001,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3451,
          collection_name: 'videos',
          order: 2,
          version: 300120001,
          hash: '05f5881e4b8d6c8fe8ac7ecacb265daa188f45c27a05a9d3312fa2b45a5086a9',
          file_name:
            'videos/05f5881e4b8d6c8fe8ac7ecacb265daa188f45c27a05a9d3312fa2b45a5086a9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/05f5881e4b8d6c8fe8ac7ecacb265daa188f45c27a05a9d3312fa2b45a5086a9.mp4',
          name: '05f5881e4b8d6c8fe8ac7ecacb265daa188f45c27a05a9d3312fa2b45a5086a9',
          description: '0',
          size: 38238353,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
        {
          id: 3452,
          collection_name: 'videos',
          order: 1,
          version: 300120001,
          hash: '802348d7ff3377dc95a56a265bfc0362c0f56f5f020a5f5ca30ade6221e5dec9',
          file_name:
            'videos/802348d7ff3377dc95a56a265bfc0362c0f56f5f020a5f5ca30ade6221e5dec9.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/802348d7ff3377dc95a56a265bfc0362c0f56f5f020a5f5ca30ade6221e5dec9.mp4',
          name: '802348d7ff3377dc95a56a265bfc0362c0f56f5f020a5f5ca30ade6221e5dec9',
          description: '0',
          size: 114142394,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '05f5881e4b8d6c8fe8ac7ecacb265daa188f45c27a05a9d3312fa2b45a5086a9',
        },
      ],
    },
    STRONG_AND_SCULPTED_ARMS: {
      id: 1304,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Strong & Sculpted Arms',
      short_name: 'Strong & Sculpted Arms',
      unique_name: 'STRONG_AND_SCULPTED_ARMS',
      description:
        "*Strong & Sculpted Arms*\n\nGet ready to feel the burn with Eve in this focused arm-sculpting session. Strong & Sculpted Arms targets your biceps, triceps, and shoulders with a series of controlled, high-rep movements that deliver serious muscle engagement and a satisfying pump.\n\nYou'll perform 15 reps per move, alternating pushing, pulling, and holding positions to maximize definition and time under tension. Short rests between sets help maintain intensity while giving you enough time to reset. Expect creative combo moves like iso holds and layered triceps work, with an optional abs and arms finisher to really seal the deal.\n\nWhether you're aiming for tank-top confidence or just love that post-workout pump, this one's for you. Form matters here - choose weights that challenge you while allowing clean, controlled reps.\n\n*Equipment:* Dumbbells (light & medium/heavy sets)\n\n*Time:* 15 minutes\n\n*Suitable for:* All Fitness Levels\n\n*Focus Areas:* Upper Body, Strength, Toning, Shoulders, Biceps, Triceps",
      preview_time: null,
      min_app_version: 300120001,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3453,
          collection_name: 'videos',
          order: 2,
          version: 300120001,
          hash: '17753b5a1fa6b757033072956b8f5a8af3ab96b7bce0e5e1f7f817c575254c02',
          file_name:
            'videos/17753b5a1fa6b757033072956b8f5a8af3ab96b7bce0e5e1f7f817c575254c02.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/17753b5a1fa6b757033072956b8f5a8af3ab96b7bce0e5e1f7f817c575254c02.mp4',
          name: '17753b5a1fa6b757033072956b8f5a8af3ab96b7bce0e5e1f7f817c575254c02',
          description: null,
          size: 35534486,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
        {
          id: 3454,
          collection_name: 'videos',
          order: 1,
          version: 300120001,
          hash: '1eb05566d945fd8c3338a4d8c4e9252840a42c851862ddda3776ca52dbe76adc',
          file_name:
            'videos/1eb05566d945fd8c3338a4d8c4e9252840a42c851862ddda3776ca52dbe76adc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/1eb05566d945fd8c3338a4d8c4e9252840a42c851862ddda3776ca52dbe76adc.mp4',
          name: '1eb05566d945fd8c3338a4d8c4e9252840a42c851862ddda3776ca52dbe76adc',
          description: null,
          size: 109312244,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '17753b5a1fa6b757033072956b8f5a8af3ab96b7bce0e5e1f7f817c575254c02',
        },
      ],
    },
    DUMBBELL_HIIT: {
      id: 1305,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Dumbbell HIIT',
      short_name: 'Dumbbell HIIT',
      unique_name: 'DUMBBELL_HIIT',
      description:
        "*Dumbbell HIIT*\n\nPush your limits in just 15 minutes with this high-intensity dumbbell session that hits every major muscle group. Designed to elevate your heart rate and build strength, this workout delivers powerful results in minimal time.\n\nStart with rotational strength moves, flow into dynamic lower-body combos, and finish strong with upper-body burners, core-activating push-ups, and a surprise finisher from Eve. You'll alternate sides for balanced strength and get just enough recovery to keep intensity high.\n\nEve keeps your form on point with helpful cues and motivation, while Carrie brings the energy to carry you through. Grab your dumbbells and let's do this!\n\n*Equipment:* Dumbbells\n\n*Time:* 15 Minutes\n\n*Suitable for:* All Fitness Levels\n\n*Focus Areas:* Cardio, Core, Lower Body, Upper Body",
      preview_time: null,
      min_app_version: 300120001,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3455,
          collection_name: 'videos',
          order: 2,
          version: 300120001,
          hash: '4b7550e0b5b1da6118cf88f2cce07f085f0b894acc64e4f6a73b323cae8add75',
          file_name:
            'videos/4b7550e0b5b1da6118cf88f2cce07f085f0b894acc64e4f6a73b323cae8add75.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/4b7550e0b5b1da6118cf88f2cce07f085f0b894acc64e4f6a73b323cae8add75.mp4',
          name: '4b7550e0b5b1da6118cf88f2cce07f085f0b894acc64e4f6a73b323cae8add75',
          description: null,
          size: 53850885,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
        {
          id: 3456,
          collection_name: 'videos',
          order: 1,
          version: 300120001,
          hash: 'b70ed39d4e18e61f3d81285f74a1f039e02714a4610e7c23472aeb7b30ccc2e7',
          file_name:
            'videos/b70ed39d4e18e61f3d81285f74a1f039e02714a4610e7c23472aeb7b30ccc2e7.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/b70ed39d4e18e61f3d81285f74a1f039e02714a4610e7c23472aeb7b30ccc2e7.mp4',
          name: 'b70ed39d4e18e61f3d81285f74a1f039e02714a4610e7c23472aeb7b30ccc2e7',
          description: null,
          size: 151582560,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '4b7550e0b5b1da6118cf88f2cce07f085f0b894acc64e4f6a73b323cae8add75',
        },
      ],
    },
    EVES_GO_TO_WARMUP: {
      id: 1306,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: "Eve's Go-To Warm-Up",
      short_name: "Eve's Go-To Warm-Up",
      unique_name: 'EVES_GO_TO_WARMUP',
      description:
        "Eve's Go-To Warm-Up is a quick, full-body dynamic series designed to get you loose, warm, and ready to move. It boosts circulation, opens tight joints, and gently raises your heart rate for a smoother, safer workout.\n\nThe routine flows from upper body and leg mobilization (arm circles, high knees, butt kickers) to heat-building (squats, jacks) and core engagement (inchworms, bear plank), finishing with a slow roll-up.\n\nUse it to prep for a HiNote Life workout or for a standalone energy boost. Eve keeps the pace steady and the moves simple with clear cues.\n\n*Equipment:* None\n\n*Time:* 10 Minutes\n\n*Suitable for:* All Fitness Levels\n\n*Focus Areas:* Full Body, Mobility, Cardio Prep, Core",
      preview_time: null,
      min_app_version: 300140000,
      archived: false,
      equipment: [],
      tags: [
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3457,
          collection_name: 'videos',
          order: 2,
          version: 300140000,
          hash: '8f696dc8bafbe1ee40014b1bcbedcbe372b522151a29ddba0938bf7af899b07b',
          file_name:
            'videos/8f696dc8bafbe1ee40014b1bcbedcbe372b522151a29ddba0938bf7af899b07b.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/8f696dc8bafbe1ee40014b1bcbedcbe372b522151a29ddba0938bf7af899b07b.mp4',
          name: '8f696dc8bafbe1ee40014b1bcbedcbe372b522151a29ddba0938bf7af899b07b',
          description: '0',
          size: 29530465,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
        {
          id: 3458,
          collection_name: 'videos',
          order: 1,
          version: 300140000,
          hash: 'c408b950717c2b4c61666b83509cef8753a41f7bc9dff8e92f4d736e5088560d',
          file_name:
            'videos/c408b950717c2b4c61666b83509cef8753a41f7bc9dff8e92f4d736e5088560d.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/c408b950717c2b4c61666b83509cef8753a41f7bc9dff8e92f4d736e5088560d.mp4',
          name: 'c408b950717c2b4c61666b83509cef8753a41f7bc9dff8e92f4d736e5088560d',
          description: '0',
          size: 93484373,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '8f696dc8bafbe1ee40014b1bcbedcbe372b522151a29ddba0938bf7af899b07b',
        },
      ],
    },
    LOW_IMPACT_LOWER_BODY: {
      id: 1307,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Low Impact Lower Body',
      short_name: 'Low Impact Lower Body',
      unique_name: 'LOW_IMPACT_LOWER_BODY',
      description:
        "This low-impact workout is perfect for anyone who wants stronger, toned legs while being gentle on the joints.\n\nEve guides you through slow, controlled moves that build strength, stability, and balance with no jumping. The routine includes front squats, single leg deadlifts, glute bridges, a grounded series of kickbacks, pulses, and side kicks, and finishes with focused moves like forward leaning lunges and curtsy pulses.\n\nIt's a supportive session, ideal for those easing back into workouts or caring for sensitive knees, offering the option to hold a chair for balance and encouraging you to move at your own pace.\n\n*Equipment:* Dumbbells\n\n*Time:* 16 Minutes\n\n*Suitable for:* All Levels, especially low impact or joint friendly needs\n\n*Focus Areas:* Glutes, Quads, Hamstrings, Hips, Balance, Core Support",
      preview_time: null,
      min_app_version: 300140000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 21,
          unique_name: 'LOW_IMPACT',
          name: 'Low Impact',
          tagCategory: { id: 2, unique_name: 'IMPACT', name: 'Impact' },
          order: 1,
        },
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3459,
          collection_name: 'videos',
          order: 2,
          version: 300140000,
          hash: 'a5674305ab67683ff0441c5b20c5dd1fd3b4d4a91665cdf22b67e450e55e39bb',
          file_name:
            'videos/a5674305ab67683ff0441c5b20c5dd1fd3b4d4a91665cdf22b67e450e55e39bb.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/a5674305ab67683ff0441c5b20c5dd1fd3b4d4a91665cdf22b67e450e55e39bb.mp4',
          name: 'a5674305ab67683ff0441c5b20c5dd1fd3b4d4a91665cdf22b67e450e55e39bb',
          description: null,
          size: 45835820,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
        {
          id: 3460,
          collection_name: 'videos',
          order: 1,
          version: 300140000,
          hash: 'bf0561f4ff416de979b3771b318e7984984f5f80f1fba024e640a00d41d00e19',
          file_name:
            'videos/bf0561f4ff416de979b3771b318e7984984f5f80f1fba024e640a00d41d00e19.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/bf0561f4ff416de979b3771b318e7984984f5f80f1fba024e640a00d41d00e19.mp4',
          name: 'bf0561f4ff416de979b3771b318e7984984f5f80f1fba024e640a00d41d00e19',
          description: null,
          size: 142709333,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            'a5674305ab67683ff0441c5b20c5dd1fd3b4d4a91665cdf22b67e450e55e39bb',
        },
      ],
    },
    DYNAMIC_DUMBBELLS: {
      id: 1308,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Dynamic Dumbbells',
      short_name: 'Dynamic Dumbbells',
      unique_name: 'DYNAMIC_DUMBBELLS',
      description:
        "This dynamic dumbbell routine focuses on strength and control, challenging you with a steady interval format of 50 seconds of work followed by 10 seconds of rest.\n\nEve guides you through a mix of weighted and bodyweight moves designed to build full-body muscular endurance. You'll tackle heavy hitters like double suitcase squats and Arnold presses, move into compound exercises like Romanian deadlifts, and finish strong with a grounded core and glute series.\n\nAs your muscles start to burn, remember to keep your form on point. Grab a set of dumbbells that feels right for you, pace yourself through the intervals, and let's make this workout count!\n\n*Equipment:* Dumbbells\n\n*Time:* 16 mins\n\n*Suitable for:* All Fitness Levels\n\n*Focus Areas:* Full-Body, Muscular Endurance, Glutes, Legs, Shoulders, Core",
      preview_time: null,
      min_app_version: 300150000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3461,
          collection_name: 'videos',
          order: 2,
          version: 300150000,
          hash: '55576455719e626bd77283a0db134da8133fafab31f2085d0deb8aa0af8c9503',
          file_name:
            'videos/55576455719e626bd77283a0db134da8133fafab31f2085d0deb8aa0af8c9503.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/55576455719e626bd77283a0db134da8133fafab31f2085d0deb8aa0af8c9503.mp4',
          name: '55576455719e626bd77283a0db134da8133fafab31f2085d0deb8aa0af8c9503',
          description: null,
          size: 40775586,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
        {
          id: 3462,
          collection_name: 'videos',
          order: 1,
          version: 300150000,
          hash: '7e3ee6beebc72489d8ce39ed4ec2c8550942a373c0ca2517e672f6d6c56e1d38',
          file_name:
            'videos/7e3ee6beebc72489d8ce39ed4ec2c8550942a373c0ca2517e672f6d6c56e1d38.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/7e3ee6beebc72489d8ce39ed4ec2c8550942a373c0ca2517e672f6d6c56e1d38.mp4',
          name: '7e3ee6beebc72489d8ce39ed4ec2c8550942a373c0ca2517e672f6d6c56e1d38',
          description: null,
          size: 131981939,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '55576455719e626bd77283a0db134da8133fafab31f2085d0deb8aa0af8c9503',
        },
      ],
    },
    CHIPPER_WORKOUT: {
      id: 1309,
      segment_type: 'CHAPTERED_ACTIVITY',
      fitness_level: 'BEGINNER',
      focus_area: null,
      name: 'Chipper Workout',
      short_name: 'Chipper Workout',
      unique_name: 'CHIPPER_WORKOUT',
      description:
        'This fast-paced, 4-minute challenge is a fun format that Eve does often with Carrie. In this routine, you will start with 10 reps of the first exercise and "chip" your way down the ladder, dropping one rep per movement until you reach a single rep at the end.\n\nEve guides you through 10 different exercises designed to build full-body strength and keep your heart rate up. The routine kicks off with front squats and jump squats, moves into compound exercises like single-leg deadlifts with bicep curls and dumbbell skiers, and finishes strong with a grounded series including supermans, push-ups to shoulder taps, and a final, single surprise :)\n\nIt\'s all about keeping the intensity high while pushing through every rep with control. Grab a set of dumbbells to challenge yourself, or easily modify by using just your bodyweight—either way, let\'s get after it!\n\n*Equipment:* Dumbbells (or Bodyweight)\n\n*Time:* 4 mins\n\n*Suitable for:* All Fitness Levels\n\n*Focus Areas:* Full-Body, Conditioning, Glutes, Quads, Shoulders, Core, Balance',
      preview_time: null,
      min_app_version: 300150000,
      archived: false,
      equipment: [
        {
          id: 1,
          name: 'Dumbbells',
          unique_name: 'DUMBBELLS',
          min_app_version: 100000000,
          order: 3000,
          is_visible: true,
        },
      ],
      tags: [
        {
          id: 22,
          unique_name: 'FIRST_TRIMESTER',
          name: 'Trimester 1',
          tagCategory: { id: 3, unique_name: 'PREGNANCY', name: 'Pregnancy' },
          order: 1,
        },
      ],
      files: [
        {
          id: 3463,
          collection_name: 'videos',
          order: 2,
          version: 300150000,
          hash: '00185c4dbcf64072c6cb92187a612010a7c665d6aacf61cd4d894223e696c530',
          file_name:
            'videos/00185c4dbcf64072c6cb92187a612010a7c665d6aacf61cd4d894223e696c530.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/00185c4dbcf64072c6cb92187a612010a7c665d6aacf61cd4d894223e696c530.mp4',
          name: '00185c4dbcf64072c6cb92187a612010a7c665d6aacf61cd4d894223e696c530',
          description: null,
          size: 13132650,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: true,
          low_resolution_file_hash: null,
        },
        {
          id: 3464,
          collection_name: 'videos',
          order: 1,
          version: 300150000,
          hash: '55173689e1a538bf46d1170a90ab7251f2b83c8b7518b08fce3add4024ca5ebc',
          file_name:
            'videos/55173689e1a538bf46d1170a90ab7251f2b83c8b7518b08fce3add4024ca5ebc.mp4',
          url: 'https://dj14u43q22646.cloudfront.net/videos/55173689e1a538bf46d1170a90ab7251f2b83c8b7518b08fce3add4024ca5ebc.mp4',
          name: '55173689e1a538bf46d1170a90ab7251f2b83c8b7518b08fce3add4024ca5ebc',
          description: null,
          size: 36034906,
          mime_type: 'video/mp4',
          is_video_audible: true,
          is_low_resolution_file: false,
          low_resolution_file_hash:
            '00185c4dbcf64072c6cb92187a612010a7c665d6aacf61cd4d894223e696c530',
        },
      ],
    },
  },
  equipment: {
    1: {
      id: 1,
      name: 'Dumbbells',
      unique_name: 'DUMBBELLS',
      min_app_version: 100000000,
      order: 3000,
      is_visible: true,
    },
    2: {
      id: 2,
      name: 'Bench',
      unique_name: 'BENCH',
      min_app_version: 100020005,
      order: 6000,
      is_visible: true,
    },
    3: {
      id: 3,
      name: 'Step',
      unique_name: 'STEP',
      min_app_version: 100030000,
      order: 7000,
      is_visible: true,
    },
    5: {
      id: 5,
      name: 'Resistance Band',
      unique_name: 'RESISTANCE_BAND',
      min_app_version: 100070000,
      order: 4000,
      is_visible: true,
    },
    6: {
      id: 6,
      name: 'Stability Ball',
      unique_name: 'STABILITY_BALL',
      min_app_version: 100070000,
      order: 5000,
      is_visible: true,
    },
    7: {
      id: 7,
      name: 'Medicine ball',
      unique_name: 'MEDICINE_BALL',
      min_app_version: 300120000,
      order: 950,
      is_visible: true,
    },
    8: {
      id: 8,
      name: 'Kettlebell',
      unique_name: 'KETTLEBELL',
      min_app_version: 200030000,
      order: 8000,
      is_visible: true,
    },
    9: {
      id: 9,
      name: 'Resistance Band with Low Anchor',
      unique_name: 'RESISTANCE_BAND_LOW_ANCHOR',
      min_app_version: 200030000,
      order: 9000,
      is_visible: true,
    },
    10: {
      id: 10,
      name: 'Foam Roller',
      unique_name: 'FOAM_ROLLER',
      min_app_version: 200070000,
      order: 13000,
      is_visible: false,
    },
    11: {
      id: 11,
      name: 'Chair',
      unique_name: 'CHAIR',
      min_app_version: 200070000,
      order: 12000,
      is_visible: false,
    },
    12: {
      id: 12,
      name: 'Gliders',
      unique_name: 'GLIDERS',
      min_app_version: 300000000,
      order: 2000,
      is_visible: true,
    },
    13: {
      id: 13,
      name: 'Mini Bands',
      unique_name: 'MINI_BANDS',
      min_app_version: 300000000,
      order: 1000,
      is_visible: true,
    },
  },
  achievements: [
    {
      id: 19,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Starter',
      enum_value: 'STARTER',
      display_unit: 'WORKOUTS',
      short_description: '1 activity',
      description: 'Complete 1 activity',
      achieved_message:
        "Way to go! You've completed your first HiNote Life activity. Now onto the next!",
      level: 1,
      order: 1,
      max_progress: 1,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 200000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 2,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'Energize',
      enum_value: 'ENERGIZE',
      display_unit: 'HOURS',
      short_description: '5 hours',
      description: 'Work out for 5 hours',
      achieved_message:
        'You should be feeling energized now that you completed 5 hours of HiNote Life workouts. On to the next one!',
      level: 1,
      order: 1,
      max_progress: 18000,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 100000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 7,
      achievement_id: 3,
      workout_template_types: [],
      challenge: null,
      unit: 'CARDS',
      type: 'NUMBER',
      name: 'Cards Challenge',
      enum_value: 'CARDS_CHALLENGE',
      display_unit: 'CARDS',
      short_description: '52 Cards',
      description: 'Complete 52 Cards',
      achieved_message:
        'Well done! You have completed your first 52 cards. This is the first step on the way to find your path!',
      level: 1,
      order: 1,
      max_progress: 52,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 100000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 20,
      achievement_id: 4,
      workout_template_types: [],
      challenge: {
        id: 1,
        start_at: 1630479600000,
        end_at: 1635663600000,
        description:
          'Get moving with BODYARMOR SportWater this fall! Kick-start a new routine or join us to keep you inspired on your fitness journey. We designed this fitness challenge for busy people like you who are "Made for More" because you do it all. It\'s simple, complete any workout in fit52, every exercise you complete is a card toward exclusive "Made for More achievements" and prizes.',
        title: 'BODYARMOR SportWater',
        subtitle: 'Made for More',
        prize_description: 'Challenge badges and BODYARMOR SportWater prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 138191,
            imageable_type: 'App\\Challenge',
            imageable_id: 1,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/xunyey8qxflsibdoieek',
            version: '1629377866',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 287, y: 0, width: 767, height: 438 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=767,trim.height=438,trim.left=287,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/xunyey8qxflsibdoieek/1629377866.png',
          },
          {
            id: 138192,
            imageable_type: 'App\\Challenge',
            imageable_id: 1,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/kfgk4bexlwxn6lm9qn5z',
            version: '1629377882',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 0, y: 0, width: 264, height: 195 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=264,trim.height=195,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/kfgk4bexlwxn6lm9qn5z/1629377882.png',
          },
        ],
        achievement_id: 4,
      },
      unit: 'CARDS',
      type: 'NUMBER',
      name: 'Made for More\n-Bronze-',
      enum_value: 'MADE_FOR_MORE_BRONZE',
      display_unit: 'CARDS',
      short_description: '250 cards',
      description: 'Complete 250 cards',
      achieved_message:
        'Congrats! You are on a good path to complete the Made for More challenge. Keep going!',
      level: 1,
      order: 1,
      max_progress: 250,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 200020000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 23,
      achievement_id: 5,
      workout_template_types: [
        'FLASH_FIT_UPPER_BODY',
        'FLASH_FIT_LOWER_BODY',
        'FLASH_FIT_CORE',
        'FLASH_FIT_CARDIO',
      ],
      challenge: {
        id: 2,
        start_at: 1635750000000,
        end_at: 1638431999000,
        description:
          "Smash your fitness goals with Eve's Thanksgiving Challenge! It's simple, invite your friends and complete 11 Flash Fits throughout November for the chance to win great fit52 prizes and unlock an exclusive challenge achievement! Looking to take this challenge to the next level? Complete all 11 Flash Fits before Thanksgiving!",
        title: "Eve's Thanksgiving Challenge",
        subtitle: null,
        prize_description: 'Live workout with Eve Overland',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 150847,
            imageable_type: 'App\\Challenge',
            imageable_id: 2,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/y0vn7miyfkfcw9ewxibd',
            version: '1634810077',
            folder: 'image',
            format: 'jpg',
            manipulations: { crop: { x: 0, y: 5, width: 1242, height: 707 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1242,trim.height=707,trim.left=0,trim.top=5/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/y0vn7miyfkfcw9ewxibd/1634810077.jpg',
          },
          {
            id: 150848,
            imageable_type: 'App\\Challenge',
            imageable_id: 2,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/qqkffpnydqqkehsdxtlf',
            version: '1634810087',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 0, y: 0, width: 264, height: 195 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=264,trim.height=195,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/qqkffpnydqqkehsdxtlf/1634810087.png',
          },
        ],
        achievement_id: 5,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: "Eve's\r\nThanksgiving",
      enum_value: 'EVE_THANKSGIVING_CHALLENGE',
      display_unit: 'WORKOUTS',
      short_description: '11 Flash Fit workouts',
      description:
        "Complete 11 Flash Fit's in November and receive an invite to an exclusive live workout with Eve Overland!",
      achieved_message:
        'Great job! You completed 11 Flash Fit workouts in November. Stay tuned for an exclusive invite to a live workout with the fit52fam!',
      level: 1,
      order: 1,
      max_progress: 11,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 200030000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 24,
      achievement_id: 6,
      workout_template_types: [],
      challenge: null,
      unit: 'WEEK_STREAK',
      type: 'NUMBER',
      name: 'Spark',
      enum_value: 'SPARK',
      display_unit: 'WEEK_STREAK',
      short_description: '2 week activity streak',
      description:
        'This tracks your longest all-time streak. Complete 2 weeks to unlock. Your current streak is shown on the Home Screen.',
      achieved_message:
        'Way to go! You just achieved a 2 week activity streak. Keep it going!',
      level: 1,
      order: 1,
      max_progress: 2,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 200030000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 30,
      achievement_id: 7,
      workout_template_types: [],
      challenge: {
        id: 3,
        start_at: 1641189600000,
        end_at: 1649141999000,
        description:
          'This year is all about building healthy habits... with the Commit to Fit Challenge designed to meet you where you are at. Bronze, Silver or Gold... strive towards your own personal goal and cheer on your friends on the Leaderboards. All sessions count towards exclusive rewards. Plus follow @fit52 on social for bonus prizes. What will you commit to in 2022?',
        title: 'BODYARMOR LYTE',
        subtitle: 'Commit to Fit Challenge',
        prize_description: 'Challenge badges and BODYARMOR prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 161887,
            imageable_type: 'App\\Challenge',
            imageable_id: 3,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/apcibwfzzh7ovpwrgf9s',
            version: '1638991065',
            folder: 'image',
            format: 'jpg',
            manipulations: { crop: { x: 223, y: 0, width: 858, height: 489 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=858,trim.height=489,trim.left=223,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/apcibwfzzh7ovpwrgf9s/1638991065.jpg',
          },
          {
            id: 161888,
            imageable_type: 'App\\Challenge',
            imageable_id: 3,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/rtwxssww3c4q8dtfu5tb',
            version: '1638991090',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 0, y: 0, width: 360, height: 360 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=360,trim.height=360,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/rtwxssww3c4q8dtfu5tb/1638991090.png',
          },
        ],
        achievement_id: 7,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Commit to Fit 2022\r\n-Bronze-',
      enum_value: 'COMMIT_TO_FIT22_BRONZE',
      display_unit: 'SESSIONS',
      short_description: '22 sessions => $10 CU Store Credit',
      description:
        'Complete 22 sessions in the Commit to Fit Challenge & receive $10 CU store credit!',
      achieved_message:
        'Congrats! 22 sessions in 2022! Check your email for an exclusive reward of $10 CU store credit!',
      level: 1,
      order: 1,
      max_progress: 22,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 200040000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 33,
      achievement_id: 8,
      workout_template_types: [],
      challenge: {
        id: 4,
        start_at: 1654066801000,
        end_at: 1659337199000,
        description:
          'Stay active this summer with fit52! Every completed activity counts as an Active Day. Some days it might be a Flash Fit, others it could be a Full Workout. The more active days you achieve, the more chances you have to win one of 52 exclusive fit52 prize packs containing a workout towel, phone stand, journal & water bottle. More details at fit52.com/challenge.',
        title: 'Active Days of Summer',
        subtitle: null,
        prize_description: 'Challenge badges and fit52 prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 210226,
            imageable_type: 'App\\Challenge',
            imageable_id: 4,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/annjgau31nigtlcke5n7',
            version: '1652906445',
            folder: 'image',
            format: 'jpg',
            manipulations: { crop: { x: 2, y: 0, width: 1239, height: 706 } },
            user_id: 397939,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=706,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/annjgau31nigtlcke5n7/1652906445.jpg',
          },
          {
            id: 210227,
            imageable_type: 'App\\Challenge',
            imageable_id: 4,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/osziliasas2lhtj40qrm',
            version: '1652906455',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 0, y: 0, width: 300, height: 300 } },
            user_id: 397939,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=300,trim.height=300,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/osziliasas2lhtj40qrm/1652906455.png',
          },
        ],
        achievement_id: 8,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Active Days of Summer\r\n-Bronze-',
      enum_value: 'ACTIVE_DAYS_OF_SUMMER_BRONZE',
      display_unit: 'DAYS_ACTIVE',
      short_description: '20 Active Days => 1 Entry',
      description:
        'Be active for 20 days in the Active Days of Summer Challenge & receive 1 month free HiNote Life!',
      achieved_message:
        'Congrats! 20 active days! You are entered into the HiNote Life prize draw! More activities you do, the more chances of winning!',
      level: 1,
      order: 1,
      max_progress: 20,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 200060000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 36,
      achievement_id: 9,
      workout_template_types: [],
      challenge: {
        id: 5,
        start_at: 1662015601000,
        end_at: 1667285999000,
        description:
          'With fit52 the "Clock Don\'t Stop"! You may know the song, but can you unlock the rewards? All fit52 activities count. The more you do, the more time on the clock! Start with 100 mins to get a free friend membership, or 418 mins to get access to a live workout with Eve. Or go for Gold and get free fit52 minibands. Learn more at: fit52.com/official-challenge-rules-regulations.',
        title: "Clock Don't Stop ⏱️",
        subtitle: null,
        prize_description:
          'Free Friend Memberships, Live Workouts & fit52 Minibands!',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 232546,
            imageable_type: 'App\\Challenge',
            imageable_id: 5,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-ClockDontStop_Card',
            version: '1658261807',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-ClockDontStop_Card/1658261807.jpg',
          },
          {
            id: 232547,
            imageable_type: 'App\\Challenge',
            imageable_id: 5,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-ClockDontStop_Badge',
            version: '1659134865',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-ClockDontStop_Badge/1659134865.png',
          },
        ],
        achievement_id: 9,
      },
      unit: 'MINUTES',
      type: 'TIME',
      name: "Clock Don't Stop ⏱️\n-Bronze-",
      enum_value: 'CLOCK_DONT_STOP_BRONZE',
      display_unit: 'MINUTES',
      short_description: '100 mins = 60d Free for a Friend!',
      description:
        "Be active for 100 minutes in the Clock Don't Stop Challenge & receive a free 60 day membership for a friend!",
      achieved_message:
        'Well done! Check your email for a free HiNote Life 60 day membership for a friend.',
      level: 1,
      order: 1,
      max_progress: 6000,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 200070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 39,
      achievement_id: 10,
      workout_template_types: [],
      challenge: {
        id: 6,
        start_at: 1667286001000,
        end_at: 1671436799000,
        description:
          'This challenge is all about eating healthy! Follow a fit52 recipe or get creative with a meal of your own, then share the photo with the fit52 fam. Every healthy meal shared counts towards the challenge goals. Max 3 meals shared per day. Looking for more healthy eating guidance? Visit caraclarknutrition.com.',
        title: 'Healthy Through The Holidays',
        subtitle: null,
        prize_description: 'Nutrition Tips, Food Logs & Meal Plans',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 244159,
            imageable_type: 'App\\Challenge',
            imageable_id: 6,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-HealthyThroughTheHolidays_Card',
            version: '1662757646',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-HealthyThroughTheHolidays_Card/1662757646.jpg',
          },
          {
            id: 244160,
            imageable_type: 'App\\Challenge',
            imageable_id: 6,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-HealthyThroughTheHolidays_Badge',
            version: '1662757646',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-HealthyThroughTheHolidays_Badge/1662757646.png',
          },
        ],
        achievement_id: 10,
      },
      unit: 'MEALS',
      type: 'NUMBER',
      name: 'Healthy Through The Holidays\n-Bronze-',
      enum_value: 'HEALTHY_THROUGH_THE_HOLIDAYS_BRONZE',
      display_unit: 'MEALS',
      short_description: '10 Meals = Tips from Cara',
      description:
        'Share Photos of 10 Healthy Meals to HiNote Life and unlock Nutrition Tips from Cara Clark!',
      achieved_message:
        'You achieved Bronze! 10 healthy meals shared. Check your inbox for  exclusive Nutrition Tips from Cara Clark!',
      level: 1,
      order: 1,
      max_progress: 10,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 200080000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 42,
      achievement_id: 11,
      workout_template_types: [],
      challenge: {
        id: 7,
        start_at: 1672560000000,
        end_at: 1677657599000,
        description:
          'Let’s start 2023 by being active! Every fit52 activity completed counts as an Active Day. It could be a Stretch, a Flash Fit, or a Full Workout. Do what works best for you and mix it up each day to build healthy habits. The more active days you achieve, the more chances you have of winning exclusive fit52 prizes, including signed fit52 Yoga Mats from Carrie & Eve! More info: fit52.com/challenge.',
        title: 'Be Active in 2023',
        subtitle: null,
        prize_description: 'fit52 Jump Ropes, Water Bottles & Signed Yoga Mats',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264613,
            imageable_type: 'App\\Challenge',
            imageable_id: 7,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-ActiveDays__Challenge1.76_3x',
            version: '1667859855',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-ActiveDays__Challenge1.76_3x/1667859855.jpg',
          },
          {
            id: 264614,
            imageable_type: 'App\\Challenge',
            imageable_id: 7,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-BeActive2023_Black_3x',
            version: '1667863490',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-BeActive2023_Black_3x/1667863490.png',
          },
        ],
        achievement_id: 11,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Be Active in 2023\n-Bronze-',
      enum_value: 'ACTIVE_DAYS_2023_BRONZE',
      display_unit: 'DAYS_ACTIVE',
      short_description: '15 Days = Entry to win jump ropes',
      description:
        'Complete 15 Active Days to unlock an entry to win exclusive jump ropes.',
      achieved_message:
        'Well done! You are now entered to win exclusive jump ropes. Good luck!',
      level: 1,
      order: 1,
      max_progress: 15,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 45,
      achievement_id: 12,
      workout_template_types: [
        'FLASH_FIT_UPPER_BODY',
        'FLASH_FIT_LOWER_BODY',
        'FLASH_FIT_CORE',
        'FLASH_FIT_CARDIO',
        'GENERATOR_15',
        'GENERATOR_30',
        'GENERATOR_45',
      ],
      challenge: {
        id: 8,
        start_at: null,
        end_at: null,
        description:
          'This ‘Fit in a Flash’ is designed to get you moving in short, targeted workouts. This 30 day challenge you can start at anytime. Flash Fit’s are targeted workouts with 13 cards, that can be done in 15 mins or less.  Start your Flash Fit from the Workout screen under ‘Featured Workouts’. Challenge your friends and see how many you can do to unlock Fit in a Flash achievements! All Flash Fit’s count.',
        title: 'Fit in a Flash',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264615,
            imageable_type: 'App\\Challenge',
            imageable_id: 8,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-FitInAFlash__Challenge1.76_3x',
            version: '1667859863',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FitInAFlash__Challenge1.76_3x/1667859863.jpg',
          },
          {
            id: 264616,
            imageable_type: 'App\\Challenge',
            imageable_id: 8,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-FitInAFlash_Black_3x',
            version: '1667863522',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FitInAFlash_Black_3x/1667863522.png',
          },
        ],
        achievement_id: 12,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Fit in a Flash\n-Bronze-',
      enum_value: 'FIT_IN_A_FLASH_BRONZE',
      display_unit: 'WORKOUTS',
      short_description: '5 Flash Fits',
      description:
        'Complete 5 Flash Fits in 30 days as part of this challenge to unlock Bronze.',
      achieved_message:
        'Congrats! You are becoming fit in a flash. Keep going to see if you can unlock Silver & Gold!',
      level: 1,
      order: 1,
      max_progress: 5,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 48,
      achievement_id: 13,
      workout_template_types: [
        'RECOVER_STRETCH_FULL_BODY_FLOW',
        'RECOVER_STRETCH_ENERGY_BOOSTER',
        'RECOVER_STRETCH_REVIVE_RECOVER',
        'RECOVER_STRETCH_HIPS_LEGS',
        'RECOVER_STRETCH_YOGA_FLOW',
        'RECOVER_STRETCH_WIND_DOWN',
        'DAILY_5_STRETCH',
        'DAILY_5_SEATED_STRETCH',
        'RECOVER_STRETCH_BACK_CHEST_FOAM_ROLLER',
        'RECOVER_STRETCH_LOWER_BODY_FOAM_ROLLER',
      ],
      challenge: {
        id: 9,
        start_at: null,
        end_at: null,
        description:
          'Feeling the need to Stretch? Then this 30 day challenge is perfect for you. You can start this challenge anytime, and have 30 days to ‘Stretch it Out’. Any stretch, yoga, or foam rolling sessions in HiNote Life count towards these challenge goals. Focus on building a regular stretching routine, or add a recovery session to complement your workouts. See how many stretch or recovery sessions you can do in 30 days, plus you can always repeat this challenge if you need to ‘Stretch it Out’ further.',
        title: 'Stretch it Out',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264617,
            imageable_type: 'App\\Challenge',
            imageable_id: 9,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-StretchItOut__Challenge1.76_3x',
            version: '1667859855',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-StretchItOut__Challenge1.76_3x/1667859855.jpg',
          },
          {
            id: 264618,
            imageable_type: 'App\\Challenge',
            imageable_id: 9,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-StretchItOut_Black_3x',
            version: '1667863552',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-StretchItOut_Black_3x/1667863552.png',
          },
        ],
        achievement_id: 13,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Stretch it Out\n-Bronze-',
      enum_value: 'STRETCH_IT_OUT_BRONZE',
      display_unit: 'WORKOUTS',
      short_description: '10 Stretch or Recovery Sessions',
      description:
        'Complete 10 Stretch or Recovery Sessions in 30 days to earn Bronze in this challenge.',
      achieved_message:
        'That must feel good! 10 Stretch Sessions complete as part of this challenge. Keep it going!',
      level: 1,
      order: 1,
      max_progress: 10,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 51,
      achievement_id: 14,
      workout_template_types: [
        'DAILY_5_MOVE',
        'DAILY_5_STRETCH',
        'DAILY_5_SEATED_STRETCH',
      ],
      challenge: {
        id: 10,
        start_at: null,
        end_at: null,
        description:
          'This Daily Dose challenge is all about doing 5 exercises or stretches per day, getting in your Daily 5’s. You can start this challenge at any time, and see how many Daily 5’s you can complete in 30 days. All Daily 5’s, Move, Stretch and Seated Stretch count! Perfect if you are short on time, as these activities can be completed in 5 mins. Give it a try and get your Daily Dose of HiNote Life! Don’t forget to challenge your friends to see who can get the longest Daily Streak and achieve Gold!',
        title: 'Daily Dose',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264619,
            imageable_type: 'App\\Challenge',
            imageable_id: 10,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-DailyDose__Challenge1.76_3x',
            version: '1667859860',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-DailyDose__Challenge1.76_3x/1667859860.jpg',
          },
          {
            id: 264620,
            imageable_type: 'App\\Challenge',
            imageable_id: 10,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-DailyDose_Black_3x',
            version: '1667863508',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-DailyDose_Black_3x/1667863508.png',
          },
        ],
        achievement_id: 14,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Daily Dose\n-Bronze-',
      enum_value: 'DAILY_DOSE_BRONZE',
      display_unit: 'WORKOUTS',
      short_description: '10 Daily 5’s',
      description:
        'Complete 10 Daily 5’s in 30 days to earn Bronze in this challenge.',
      achieved_message:
        'You are getting your daily dose of fitness fun! Short, effective workouts unlocks Bronze!',
      level: 1,
      order: 1,
      max_progress: 10,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 54,
      achievement_id: 15,
      workout_template_types: [
        'HALF',
        'FULL',
        'CARD_DRAW_13',
        'LADDER',
        'ALL_FAVORITE_SEGMENTS',
        'CARRIE_FAVORITE_SEGMENTS',
        'EVE_FAVORITE_SEGMENTS',
        'GENERATOR_15',
        'GENERATOR_30',
        'GENERATOR_45',
        'DENIM_AND_RHINESTONES',
      ],
      challenge: {
        id: 11,
        start_at: null,
        end_at: null,
        description:
          'The Full Body Fun challenge is just what the name suggests, all about full body workouts and having fun! You could do 13 card draws, or step up to half or full workouts. As long as you are working out your entire body, it counts towards these challenge goals. Your path workouts also count!  See how many full body workouts you can do in the 30 days and most importantly, have fun!',
        title: 'Full Body Fun',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264621,
            imageable_type: 'App\\Challenge',
            imageable_id: 11,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-FullBodyFun__Challenge1.76_3x',
            version: '1667859866',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FullBodyFun__Challenge1.76_3x/1667859866.jpg',
          },
          {
            id: 264622,
            imageable_type: 'App\\Challenge',
            imageable_id: 11,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-FullBodyFun_Black_3x',
            version: '1667863536',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FullBodyFun_Black_3x/1667863536.png',
          },
        ],
        achievement_id: 15,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Full Body Fun\n-Bronze-',
      enum_value: 'FULL_BODY_FUN_BRONZE',
      display_unit: 'WORKOUTS',
      short_description: '5 of Any Full Body Workout',
      description:
        'Complete 5 Full Workouts in 30 days to earn Bronze in this challenge.',
      achieved_message:
        'You are having fun! 5 Full Body Workouts done and you’ve unlocked Bronze.',
      level: 1,
      order: 1,
      max_progress: 5,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 57,
      achievement_id: 16,
      workout_template_types: [],
      challenge: {
        id: 12,
        start_at: 1677657600000,
        end_at: 1681722000000,
        description:
          "Carrie and Eve. SportWater and LYTE. You and your workout bestie. What makes the perfect duo?\r\n\r\nThe BODYARMOR Duo Challenge is all about challenging yourself and a friend to form a duo and smash your workout goals together. Invite your friends or favorite a member of the fit52fam! Hit the challenge achievements and both you and your workout partner enter to win 1 month's supply of BODYARMOR LYTE and SportWater (US only). Max 2 workouts count each day toward challenge goals.\r\n\r\nStay hydrated with bit.ly/DrinkBODYARMOR",
        title: 'BODYARMOR Duo',
        subtitle: null,
        prize_description: 'BODYARMOR prizes for you and your Duo',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 287669,
            imageable_type: 'App\\Challenge',
            imageable_id: 12,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-BADuo__Challenge1.76_3x',
            version: '1676332613',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-BADuo__Challenge1.76_3x/1676332613.jpg',
          },
          {
            id: 287670,
            imageable_type: 'App\\Challenge',
            imageable_id: 12,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-BAduo_Black_3x',
            version: '1676332598',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-BAduo_Black_3x/1676332598.png',
          },
        ],
        achievement_id: 16,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'BODYARMOR Duo\r\n-Bronze-',
      enum_value: 'BA_DUO_BRONZE',
      display_unit: 'WORKOUTS',
      short_description: '10 Workouts - 1 entry to win',
      description:
        'Complete 10 workouts to enter the draw to win exclusive BODYARMOR prize pack for your Duo! You and a friend both get prizes!',
      achieved_message:
        'Great work! You have completed 10 workouts and earned Bronze. You are entered to win BODYARMOR Prizes!',
      level: 1,
      order: 1,
      max_progress: 10,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300000003,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 60,
      achievement_id: 17,
      workout_template_types: [],
      challenge: {
        id: 13,
        start_at: 1699862400000,
        end_at: 1703275199000,
        description:
          'Get in shape this fall! Finish Flash Fits to win entries for a chance to get one of ten exclusive prize packs valued at $240 from the Official Carrie Underwood Store. Packs include a signed Denim & Rhinestones Deluxe Picture Disc Vinyl - signed by Carrie herself!! Every Flash Fit adds to Challenge achievements, max 3 daily. Details at fit52.com/challenge.',
        title: 'Get Fit this Fall 🍁',
        subtitle: null,
        prize_description: 'Win Official Carrie Underwood Store Prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 339199,
            imageable_type: 'App\\Challenge',
            imageable_id: 13,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-FlashFitFall__Challenge1.76_3x',
            version: '1697129640',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FlashFitFall__Challenge1.76_3x/1697129640.jpg',
          },
          {
            id: 339200,
            imageable_type: 'App\\Challenge',
            imageable_id: 13,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-FlashFitFall_Black_3x',
            version: '1697129641',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FlashFitFall_Black_3x/1697129641.png',
          },
        ],
        achievement_id: 17,
      },
      unit: 'FLASH_FITS',
      type: 'NUMBER',
      name: 'Flash Fit Fall\r\nBronze',
      enum_value: 'GET_FIT_FALL_BRONZE',
      display_unit: 'FLASH_FITS',
      short_description: '5 Flash Fits - 1 entry to win',
      description:
        'By unlocking Bronze in the Fall Challenge you will be entered into the draw to win exclusive Carrie Underwood prizes!',
      achieved_message:
        'You did it! You’ve earned Bronze in the Fall Challenge and are entered into the draw to win an exclusive Carrie Underwood prize pack!',
      level: 1,
      order: 1,
      max_progress: 5,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300010000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 63,
      achievement_id: 18,
      workout_template_types: [],
      challenge: {
        id: 14,
        start_at: null,
        end_at: null,
        description:
          "Join the '30-Day Shape Up' challenge! Be active daily to earn Bronze, Silver, or Gold achievements. Transform in just a month, start anytime, all completed workouts count! Let's get fit together in 30 days!",
        title: '30-Day Shape Up',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 339201,
            imageable_type: 'App\\Challenge',
            imageable_id: 14,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-30DayShapeUp__Challenge1.76_3x',
            version: '1696443839',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-30DayShapeUp__Challenge1.76_3x/1696443839.jpg',
          },
          {
            id: 339202,
            imageable_type: 'App\\Challenge',
            imageable_id: 14,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-30DayShapeUp_Black_3x',
            version: '1696443850',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-30DayShapeUp_Black_3x/1696443850.png',
          },
        ],
        achievement_id: 18,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: '30 Day Shape Up\nBronze',
      enum_value: 'SHAPE_UP_BRONZE',
      display_unit: 'DAYS_ACTIVE',
      short_description: '5 Active Days',
      description:
        'Bronze in the 30 Day Shape Up Challenge is a great achievement to show you are staying active!',
      achieved_message:
        'Amazing effort! You achieved Bronze in the Shape Up Challenge. Can you get Silver or Gold?',
      level: 1,
      order: 1,
      max_progress: 5,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300010000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 66,
      achievement_id: 19,
      workout_template_types: [],
      challenge: {
        id: 15,
        start_at: null,
        end_at: null,
        description:
          "Embark on the '100 reps a Day' challenge! Crush 100 card reps daily for Bronze, Silver or Gold goals. Transform your strength and endurance. Regardless of how many you can achieve, max 100 reps (from card based workouts) count towards challenge goals. Give it a try and see how many days you can do 100 reps!",
        title: '100 Reps a Day',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 339203,
            imageable_type: 'App\\Challenge',
            imageable_id: 15,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/NoLimits__Challenge1.76_3x',
            version: '1696443729',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/NoLimits__Challenge1.76_3x/1696443729.jpg',
          },
          {
            id: 339204,
            imageable_type: 'App\\Challenge',
            imageable_id: 15,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-100RepsADay_Black_3x',
            version: '1696443820',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-100RepsADay_Black_3x/1696443820.png',
          },
        ],
        achievement_id: 19,
      },
      unit: 'REPS',
      type: 'NUMBER',
      name: '100 Reps a Day\nBronze',
      enum_value: 'REPS_A_DAY_BRONZE',
      display_unit: 'REPS',
      short_description: '15 days with 100 Reps',
      description:
        'Can you do it? 1500 reps? A great way to build consistency.',
      achieved_message:
        '100 reps a day! You’ve done it. 15 days where you’ve shown up and completed 100 reps! Way to build a healthy fitness habit!',
      level: 1,
      order: 1,
      max_progress: 1500,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300010000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 69,
      achievement_id: 20,
      workout_template_types: [],
      challenge: {
        id: 16,
        start_at: 1704096000000,
        end_at: 1707076799000,
        description:
          'Kickstart 2024 with the fit52 5x2 Challenge! Aim for 5 weeks with 2 workouts per week. Can you do more? Stay on track and you could win one of 24 fit52 phone stands! Max 1 workout per day counts towards challenge. More details at fit52.com/challenge. Make 2024 your best year with a fresh start to fitness!',
        title: '5x2 - Fresh Start for 2024',
        subtitle: null,
        prize_description: 'Win 1 of 24 exclusive fit52 phone stands',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 344834,
            imageable_type: 'App\\Challenge',
            imageable_id: 16,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-5x2__Challenge1.76_3x',
            version: '1701081278',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-5x2__Challenge1.76_3x/1701081278.jpg',
          },
          {
            id: 344835,
            imageable_type: 'App\\Challenge',
            imageable_id: 16,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-5x2_Black_3x',
            version: '1701081209',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-5x2_Black_3x/1701081209.png',
          },
        ],
        achievement_id: 20,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: '5X2 for 2024\nBronze',
      enum_value: 'FRESH_START_BRONZE',
      display_unit: 'WORKOUTS',
      short_description: '10 Workouts - 1 Entry',
      description:
        'By unlocking Bronze in the 5x2 Challenge you will be entered into the draw to win 1 of 24 exclusive phone stands!',
      achieved_message:
        'Go You! You’ve earned Bronze in the 5x2 Challenge and are entered into the draw to win exclusive phone stands! Let’s strive for Silver now!',
      level: 1,
      order: 1,
      max_progress: 10,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300020000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 76,
      achievement_id: 21,
      workout_template_types: [],
      challenge: {
        id: 17,
        start_at: 1711090801000,
        end_at: 1715669999000,
        description:
          'Get your stretch on this Spring with the fit52 Spring Stretch Challenge! Aim for 10 Stretch & Recovery Sessions to achieve Bronze. Keep up the momentum and you might be the lucky winner of a exclusive 1:1 virtual workout with Eve! All completed Stretch & Recovery sessions count. Discover more at fit52.com/challenge. Start the season with the Spring Stretch Challenge!',
        title: 'Spring Stretch 2024',
        subtitle: null,
        prize_description: 'Win 1:1 Virtual fit52 Workout with Eve!',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 359013,
            imageable_type: 'App\\Challenge',
            imageable_id: 17,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-SpringStretch__Challenge1.76_3x',
            version: '1705333396',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-SpringStretch__Challenge1.76_3x/1705333396.jpg',
          },
          {
            id: 359014,
            imageable_type: 'App\\Challenge',
            imageable_id: 17,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-SpringStretch_Black_3x',
            version: '1705333379',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-SpringStretch_Black_3x/1705333379.png',
          },
        ],
        achievement_id: 21,
      },
      unit: 'STRETCH_SESSIONS',
      type: 'NUMBER',
      name: 'Spring Stretch 2024\nBronze',
      enum_value: 'SPRING_STRETCH_BRONZE',
      display_unit: 'STRETCH_SESSIONS',
      short_description: '10 Stretch Sessions - 1 Entry',
      description:
        'Complete 10 Stretch Sessions to unlock Bronze and enter to win an exclusive 1:1 workout with Eve Overland!',
      achieved_message:
        'You did it! Can you stretch even further and unlock Silver? We believe in you!',
      level: 1,
      order: 1,
      max_progress: 10,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300030000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 79,
      achievement_id: 22,
      workout_template_types: [],
      challenge: {
        id: 18,
        start_at: 1722841200000,
        end_at: 1725908399000,
        description:
          'Build a fitness habit with fit52 and the 5 Weeks to Fit challenge. Perfect if you are just getting started or back into fitness. Take it one day at a time, turn gradual progress into a habit that lasts.\r\n\r\nEvery workout you complete counts as an Active Day - and increases your chances to win exclusive fit52 prizes, including Notebooks, Caps and Gym Bags.\r\n\r\nDon’t miss out on this opportunity to boost your fitness and snag some awesome gear. Learn more at: fit52.com/challenge.',
        title: '5 Weeks To Fit',
        subtitle: null,
        prize_description: 'Challenge badges and fit52 prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 383455,
            imageable_type: 'App\\Challenge',
            imageable_id: 18,
            collection_name: 'challenge_image',
            name: 'uploads/Challenge-5WeeksToFit_Challenge1.76@3x.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/Challenge-5WeeksToFit_Challenge1.76@3x.jpeg',
          },
          {
            id: 383456,
            imageable_type: 'App\\Challenge',
            imageable_id: 18,
            collection_name: 'challenge_icon_image',
            name: 'uploads/Challenge-5WeeksToFit_Black@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/Challenge-5WeeksToFit_Black@3x.png',
          },
        ],
        achievement_id: 22,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: '5 Weeks To Fit\nBronze',
      enum_value: 'FIVE_WEEKS_TO_FIT_BRONZE',
      display_unit: 'DAYS_ACTIVE',
      short_description: 'Draw for 10 exclusive Notebooks',
      description:
        "Can you do 15 days of fitness? It's a great goal and comes with a great prize, you could win one of 10 exclusive notebooks!",
      achieved_message:
        'Great progress. 15 days of Fitness. You are going to smash the 5 weeks to fit! Plus you are entered to win an exclusive notebook!',
      level: 1,
      order: 1,
      max_progress: 15,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300050000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 98,
      achievement_id: 23,
      workout_template_types: [],
      challenge: {
        id: 19,
        start_at: 1741590000000,
        end_at: 1750186799000,
        description:
          'Ready to create lasting fitness habits? Join the fit52 Healthy Habits Challenge — designed to help you build a sustainable routine that you can continue well beyond this challenge.\r\n\r\nEvery workout or yoga session you complete in the app counts as an Active Day. Pick the activities that fit your lifestyle and get moving! Along the way, unlock challenge achievements.',
        title: 'Healthy Habits in 2025',
        subtitle: null,
        prize_description: 'fit52 Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 402378,
            imageable_type: 'App\\Challenge',
            imageable_id: 19,
            collection_name: 'challenge_image',
            name: 'uploads/healthy-habits-challenge-image@3x.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/healthy-habits-challenge-image@3x.jpeg',
          },
          {
            id: 402379,
            imageable_type: 'App\\Challenge',
            imageable_id: 19,
            collection_name: 'challenge_icon_image',
            name: 'uploads/healthy-habits-challenge-badge-black@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/healthy-habits-challenge-badge-black@3x.png',
          },
        ],
        achievement_id: 23,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Healthy Habits in 2025\nBronze',
      enum_value: 'HEALTHY_HABITS_2025_BRONZE',
      display_unit: 'DAYS_ACTIVE',
      short_description: 'Be active for 25 days',
      description: 'Can you do 25 days of healthy habits and unlock bronze?',
      achieved_message:
        'Great progress. 25 days of Fitness. You are off to a great start in 2025!',
      level: 1,
      order: 1,
      max_progress: 25,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300090000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 101,
      achievement_id: 24,
      workout_template_types: [],
      challenge: {
        id: 20,
        start_at: 1735718400000,
        end_at: 1740254399000,
        description:
          "Fuel Your Best Self with the Nourish & Thrive in 2025 Challenge!\r\n\r\nTake charge of your nutrition and set yourself up for success in 2025 with the Nourish & Thrive Challenge. This challenge is perfect for anyone looking to build sustainable, healthy eating habits that last all year long.\r\n\r\nEvery meal you log in fit52 counts toward your challenge progress, bringing you one step closer to your goals! As you complete the challenge, you'll earn achievements and increase your chances to win exclusive nutrition prizes.\r\n\r\nReady to start thriving? Learn more at: fit52.com/challenge.",
        title: 'Nourish & Thrive in 2025',
        subtitle: null,
        prize_description: 'Nutrition Prizes & Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 402380,
            imageable_type: 'App\\Challenge',
            imageable_id: 20,
            collection_name: 'challenge_image',
            name: 'uploads/nourish-thrive-challenge-image@3x.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/nourish-thrive-challenge-image@3x.jpeg',
          },
          {
            id: 402381,
            imageable_type: 'App\\Challenge',
            imageable_id: 20,
            collection_name: 'challenge_icon_image',
            name: 'uploads/nourish-thrive-challenge-badge-black@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/nourish-thrive-challenge-badge-black@3x.png',
          },
        ],
        achievement_id: 24,
      },
      unit: 'MEALS_TRACKED',
      type: 'NUMBER',
      name: 'Nourish & Thrive in 2025\nBronze',
      enum_value: 'NOURISH_AND_THRIVE_2025_BRONZE',
      display_unit: 'MEALS_TRACKED',
      short_description: 'A free exclusive Meal Plan',
      description:
        '25 Meals logged to earn Bronze. This is a great way to show you are Thriving in 2025!',
      achieved_message:
        'Great progress. 25 meals logged. You are entered to win great Cara Clark Nutrition prizes!',
      level: 1,
      order: 1,
      max_progress: 25,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300080000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 104,
      achievement_id: 25,
      workout_template_types: [],
      challenge: {
        id: 21,
        start_at: null,
        end_at: null,
        description:
          "Ready to sculpt strong, toned legs like Carrie Underwood? The 52 Days to Toned Legs Challenge is your ultimate guide to building strength, definition, and confidence in your legs and glutes. This challenge is designed to help you stay consistent with effective, lower body focused workouts that fit into any schedule.\n\nWhy join the Challenge?\nThis challenge is all about helping you:\n- Build strength and power in your legs.\n- Sculpt and tone your thighs, calves, and glutes for a lean, defined look.\n- Feel stronger and more confident with every workout.\n- Get closer to achieving legs like Carrie Underwood's with her proven workout routines!\n\nWhat Counts Towards this Challenge?\nEvery leg-focused workout in HiNote Life counts! Choose from:\n- Flash Fit: Legs\n- Carrie's Leg Workout\n- Lower Body Burn\n- Leg Day with Carrie and Eve\n\nEach completed workout counts toward your progress, so you can mix it up or stick with your favorites.",
        title: '52 Days to Toned Legs',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 402382,
            imageable_type: 'App\\Challenge',
            imageable_id: 21,
            collection_name: 'challenge_image',
            name: 'uploads/toned-legs-challenge-image-updated3x.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/toned-legs-challenge-image-updated3x.jpeg',
          },
          {
            id: 402383,
            imageable_type: 'App\\Challenge',
            imageable_id: 21,
            collection_name: 'challenge_icon_image',
            name: 'uploads/toned-legs-challenge-badge-black3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/toned-legs-challenge-badge-black3x.png',
          },
        ],
        achievement_id: 25,
      },
      unit: 'LEG_WORKOUTS',
      type: 'NUMBER',
      name: '52 Days to Toned Legs\nBronze',
      enum_value: 'FIFTY_TWO_DAYS_TO_TONED_LEGS_BRONZE',
      display_unit: 'LEG_WORKOUTS',
      short_description: '10 Leg Workouts',
      description:
        "Can you complete 10 leg-sculpting workouts? Unlock the Bronze badge and take the first step toward strong, toned legs—just like Carrie's!",
      achieved_message:
        "Awesome job! 10 leg-focused workouts completed. You're building strength & toning up, keep the momentum going!",
      level: 1,
      order: 1,
      max_progress: 10,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300080000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 107,
      achievement_id: 26,
      workout_template_types: [],
      challenge: {
        id: 22,
        start_at: 1735718400000,
        end_at: 1740297599000,
        description:
          'Ready to elevate your fitness in 2025? Join the Sweat, Sip & Win with BODYARMOR Challenge—where hydration fuels your drive to crush your 2025 goals - and to stay refreshed along the way.\r\n\r\nEvery workout, yoga or stretch session in the fit52 app counts as an Active Day towards challenge goals. Stay consistent with fit52, sip smart with BODYARMOR, and rack up those wins! Unlock achievements and boost your chances to score exclusive BODYARMOR & fit52 prizes.\r\n\r\nReady for even more? Combine this challenge with the Nourish & Thrive Nutrition Challenge to amplify your wellness journey and build habits that last.\r\n\r\nLearn more at: fit52.com/challenge',
        title: 'Sweat, Sip & Win with BODYARMOR',
        subtitle: null,
        prize_description: 'BODYARMOR Challenge Prizes & Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 402390,
            imageable_type: 'App\\Challenge',
            imageable_id: 22,
            collection_name: 'challenge_image',
            name: 'uploads/bodyarmor-2025.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/bodyarmor-2025.jpeg',
          },
          {
            id: 402391,
            imageable_type: 'App\\Challenge',
            imageable_id: 22,
            collection_name: 'challenge_icon_image',
            name: 'uploads/bodyarmor-2025-badge-updated.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/bodyarmor-2025-badge-updated.png',
          },
        ],
        achievement_id: 26,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Sweat, Sip & Win with BODYARMOR\nBronze',
      enum_value: 'SWEAT_SIP_WIN_BODYARMOR_BRONZE',
      display_unit: 'DAYS_ACTIVE',
      short_description: 'Entry to win 1 of 10 BODYARMOR Prize Packs',
      description:
        '25 Active Days in the Sweat, Sip & Win with BODYARMOR challenge. Unlock and enter to win a BODYARMOR prize pack!',
      achieved_message:
        "Great progress! 25 Active Days in the Sweat, Sip & Win challenge. You're staying hydrated - keep it up!",
      level: 1,
      order: 1,
      max_progress: 25,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300080001,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 110,
      achievement_id: 27,
      workout_template_types: [],
      challenge: {
        id: 23,
        start_at: 1752562800000,
        end_at: 1758005999000,
        description:
          "Make the most of the season with sunshine, good vibes, and nourishing meals! The Healthy Eating, Summer Living Challenge rewards you for logging 2 or more meals a day. Win great prizes including fit52 notebooks, fit52 muscle tank tops, and fit52 aprons!\r\n\r\nNever tried the fit52 food journal? Now's your chance to jump in and see how easy it is to stay on track.\r\n\r\nEvery day you log 2 or more meals, you'll get closer to unlocking exclusive fit52 nutrition rewards.  A meal is either Breakfast, Lunch, Dinner or a Snack. Whether you're enjoying sunny strolls, weekend getaways, or simply juggling a busy summer routine, consistently logging your meals in the fit52 food journal helps you stay mindful, make smarter choices, and see real progress.\r\n\r\nEach of the Achievements earns entries to the draw to win exclusive fit52 prizes.\r\nBronze = Win 1 of 10 fit52 Notebooks.\r\nSilver = Win 1 of 5 fit52 Aprons.\r\nGold = Win 1 of 3 fit52 Muscle Tops.\r\n\r\nWant to take your summer wellness even further? Combine this with a fit52 workout challenge for a head-to-toe healthy season.\r\n\r\nLet's eat well and live fully - all summer long! Learn more at: fit52.com/challenge.",
        title: 'Healthy Eating, Summer Living',
        subtitle: null,
        prize_description: 'fit52 Nutrition Prizes & Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 431933,
            imageable_type: 'App\\Challenge',
            imageable_id: 23,
            collection_name: 'challenge_image',
            name: 'uploads/healthy-eating-2025-challenge-image@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/healthy-eating-2025-challenge-image@3x.png',
          },
          {
            id: 431934,
            imageable_type: 'App\\Challenge',
            imageable_id: 23,
            collection_name: 'challenge_icon_image',
            name: 'uploads/challenge-badge-healthy-eating-2025-gold@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/challenge-badge-healthy-eating-2025-gold@3x.png',
          },
        ],
        achievement_id: 27,
      },
      unit: 'DAYS_WITH_MEALS',
      type: 'NUMBER',
      name: 'Healthy Eating, Summer Living\nBronze',
      enum_value: 'HEALTHY_EATING_SUMMER_LIVING_BRONZE',
      display_unit: 'DAYS_WITH_MEALS',
      short_description: '15 Days with 2+ Meals',
      description:
        'Can you log 15 days of meals? Unlock Bronze and enter to win 1 of 10 exclusive notebooks!',
      achieved_message:
        "You're building strong habits one meal at a time - keep up the great work this summer!",
      level: 1,
      order: 1,
      max_progress: 15,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300110001,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 113,
      achievement_id: 28,
      workout_template_types: [],
      challenge: {
        id: 24,
        start_at: 1767254400000,
        end_at: 1771747199000,
        description:
          'Start 2026 strong with the Move More in ’26 Challenge. Your job is to complete one Movement Day at a time. A Movement Day is any fit52 activity you do inside the app. Stretch. Workout. Yoga session. Flash Fit. Cardio, they all count.\r\n\r\nComplete your Movement Day and you move closer to unlocking fit52 achievements and earning perks like yoga mats, water bottles, and gym bags.\r\n\r\nThis is about building a daily movement habit, not chasing perfection. Join in, show up in the app, and start the year with consistency and the fit52 fam behind you.\r\n\r\nReady to make daily movement a habit? Join now and kick off the New Year with purpose, consistency, and the support of the fit52 fam.',
        title: 'Move More in 2026',
        subtitle: null,
        prize_description: 'Exclusive fit52 Prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 448672,
            imageable_type: 'App\\Challenge',
            imageable_id: 24,
            collection_name: 'challenge_image',
            name: 'uploads/move-more-in-2026-challenge-image-v2@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/move-more-in-2026-challenge-image-v2@3x.png',
          },
          {
            id: 448673,
            imageable_type: 'App\\Challenge',
            imageable_id: 24,
            collection_name: 'challenge_icon_image',
            name: 'uploads/challenge-badge-move-more-in-2026-gold@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/challenge-badge-move-more-in-2026-gold@3x.png',
          },
        ],
        achievement_id: 28,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Move More in ‘26\nBronze',
      enum_value: 'MOVE_MORE_IN_2026_BRONZE',
      display_unit: 'DAYS_ACTIVE',
      short_description:
        '13 Movement Days = Entry to win 1 of 5 exclusive Water Bottles',
      description:
        'Complete 13 days with movement, and enter to win an exclusive water bottle!',
      achieved_message:
        'You’ve logged 13 Movement Days! You are entered to win an exclusive water bottle. Stay consistent to unlock more rewards.',
      level: 1,
      order: 1,
      max_progress: 13,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300130000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 116,
      achievement_id: 29,
      workout_template_types: [],
      challenge: {
        id: 25,
        start_at: 1767254400000,
        end_at: 1771747199000,
        description:
          'Fuel Your Best Self with the 52-Day Energy Reset in 2026 Challenge!\r\n\r\nTake charge of your nutrition and set yourself up for success in 2026 with the 52-Day Energy Reset Challenge. This challenge is perfect for anyone looking to build sustainable, healthy eating habits that last all year long.\r\n\r\nEvery meal you log in fit52 counts toward your challenge progress, bringing you one step closer to your goals! As you complete the challenge, you’ll earn achievements and increase your chances to win fit52 prizes.\r\n\r\nLooking for a full-body wellness approach? Pair this challenge with the fit52 Move More in 2026 Challenge for an unbeatable combination of fitness and nutrition.\r\n\r\nReady to start thriving? Learn more at: fit52.com/challenge.',
        title: '52-Day Energy Reset',
        subtitle: null,
        prize_description: 'fit52 Nutrition Prizes & Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 448674,
            imageable_type: 'App\\Challenge',
            imageable_id: 25,
            collection_name: 'challenge_image',
            name: 'uploads/52-day-energy-reset-2026-challenge-image-v2@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/52-day-energy-reset-2026-challenge-image-v2@3x.png',
          },
          {
            id: 448675,
            imageable_type: 'App\\Challenge',
            imageable_id: 25,
            collection_name: 'challenge_icon_image',
            name: 'uploads/challenge-badge-52-day-energy-reset-2026-gold-v2@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/challenge-badge-52-day-energy-reset-2026-gold-v2@3x.png',
          },
        ],
        achievement_id: 29,
      },
      unit: 'DAYS_WITH_MEALS_V2',
      type: 'NUMBER',
      name: '52 Day Energy Reset\nBronze',
      enum_value: 'FIFTY_TWO_DAYS_ENERGY_RESET_2026_BRONZE',
      display_unit: 'DAYS_WITH_MEALS_V2',
      short_description:
        '52 Meals = Entry to win 1 of 5 exclusive water bottles',
      description:
        'First stop, 52 meals. Hit Bronze and you are entered to win 1 of 5 exclusive water bottles.',
      achieved_message:
        'You’ve logged 52 meals! You are entered to win 1 of 5 exclusive water bottles. Keep logging to hit 100 meals for Silver.',
      level: 1,
      order: 1,
      max_progress: 52,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300130000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 119,
      achievement_id: 30,
      workout_template_types: [],
      challenge: {
        id: 26,
        start_at: 1773644400000,
        end_at: 1781679599000,
        description:
          "Ready to power up your day?\r\n\r\nProtein is essential for energy, strength, and recovery. Hitting your daily protein target helps you crush your workouts, recover faster, and keeps your energy levels high all day long. Over the next 3 months, build healthy habits by fueling your body for success.\r\n\r\nHow it works:\r\n• Log It: Track your meals, drinks and snacks daily in the HiNote Life Food Journal.\r\n• Hit Your Target: Reach your personalized daily protein goal to make the day count.\r\n• Level Up: The more days you hit your target, the higher you climb! Can you reach Gold?\r\n\r\nWant to customize your targets? You can easily adjust your overall calorie goal or macro percentages, and your daily protein goal will update automatically. If you have a specific protein number in mind, simply enter your exact daily target in your Macro goals.\r\n\r\nReady to win? Join the challenge to enter our exclusive giveaway featuring a lineup of brand-new prizes that will be announced soon. Don't miss out on this opportunity to power up your day and claim exciting new rewards!\r\n\r\nLearn more at: app.hinote.com/challenge",
        title: 'Protein Power Up Challenge',
        subtitle: null,
        prize_description: 'Exclusive Prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 461868,
            imageable_type: 'App\\Challenge',
            imageable_id: 26,
            collection_name: 'challenge_image',
            name: 'uploads/protein-power-up-2026-challenge-image-v2@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/protein-power-up-2026-challenge-image-v2@3x.png',
          },
          {
            id: 461869,
            imageable_type: 'App\\Challenge',
            imageable_id: 26,
            collection_name: 'challenge_icon_image',
            name: 'uploads/challenge-badge-protein-power-up-2026-gold@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/challenge-badge-protein-power-up-2026-gold@3x.png',
          },
        ],
        achievement_id: 30,
      },
      unit: 'DAYS_WITH_PROTEIN_GOAL_REACHED',
      type: 'NUMBER',
      name: 'Protein Power Up\nBronze',
      enum_value: 'PROTEIN_POWER_UP_BRONZE',
      display_unit: 'DAYS_WITH_PROTEIN_GOAL_REACHED',
      short_description: '20 Days meeting Protein Goal',
      description:
        'Build healthier habits! Hit your protein target for 20 days to unlock Bronze and score an entry into our latest giveaway.',
      achieved_message:
        'Great progress! 20 days of hitting your protein goals. Plus, you are officially entered into our brand-new prize giveaway!',
      level: 1,
      order: 1,
      max_progress: 20,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 300150000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 18,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Commit to Fit',
      enum_value: 'COMMIT_TO_FIT',
      display_unit: 'WORKOUTS',
      short_description: '4 workouts',
      description: 'Complete 4 workouts',
      achieved_message:
        'Congrats! You have shown that you can Commit to Fit. Now lean back and relax, you earned it!',
      level: 3,
      order: 2,
      max_progress: 4,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 100060000,
      campaign_guid: 'BODY_ARMOR_COMMIT_TO_FIT',
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 13,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'Checotah to Nashville',
      enum_value: 'CHECOTAH_TO_NASHVILLE',
      display_unit: 'MINUTES',
      short_description: '489 minutes',
      description: 'Work out for 489 minutes',
      achieved_message:
        'Wow! It only took you 489 minutes to complete the journey from Checotah to Nashville.',
      level: 1,
      order: 2,
      max_progress: 29340,
      initial_progress: 18000,
      min_progress: 0,
      min_app_version: 100020000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 8,
      achievement_id: 3,
      workout_template_types: [],
      challenge: null,
      unit: 'CARDS',
      type: 'NUMBER',
      name: "Every Day I'm Shuffling",
      enum_value: 'EVERY_DAY_IM_SHUFFING',
      display_unit: 'CARDS',
      short_description: '520 cards',
      description: 'Complete 520 cards',
      achieved_message:
        'Now that’s a lot of cards. You are well on your way. Keep it up!',
      level: 2,
      order: 2,
      max_progress: 520,
      initial_progress: 52,
      min_progress: 0,
      min_app_version: 100000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 21,
      achievement_id: 4,
      workout_template_types: [],
      challenge: {
        id: 1,
        start_at: 1630479600000,
        end_at: 1635663600000,
        description:
          'Get moving with BODYARMOR SportWater this fall! Kick-start a new routine or join us to keep you inspired on your fitness journey. We designed this fitness challenge for busy people like you who are "Made for More" because you do it all. It\'s simple, complete any workout in fit52, every exercise you complete is a card toward exclusive "Made for More achievements" and prizes.',
        title: 'BODYARMOR SportWater',
        subtitle: 'Made for More',
        prize_description: 'Challenge badges and BODYARMOR SportWater prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 138191,
            imageable_type: 'App\\Challenge',
            imageable_id: 1,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/xunyey8qxflsibdoieek',
            version: '1629377866',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 287, y: 0, width: 767, height: 438 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=767,trim.height=438,trim.left=287,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/xunyey8qxflsibdoieek/1629377866.png',
          },
          {
            id: 138192,
            imageable_type: 'App\\Challenge',
            imageable_id: 1,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/kfgk4bexlwxn6lm9qn5z',
            version: '1629377882',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 0, y: 0, width: 264, height: 195 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=264,trim.height=195,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/kfgk4bexlwxn6lm9qn5z/1629377882.png',
          },
        ],
        achievement_id: 4,
      },
      unit: 'CARDS',
      type: 'NUMBER',
      name: 'Made for More\n-Silver-',
      enum_value: 'MADE_FOR_MORE_SILVER',
      display_unit: 'CARDS',
      short_description: '500 cards',
      description: 'Complete 500 cards',
      achieved_message:
        'Congrats! You are almost there to finish the Made for More challenge. Lets go!',
      level: 2,
      order: 2,
      max_progress: 500,
      initial_progress: 250,
      min_progress: 0,
      min_app_version: 200020000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 25,
      achievement_id: 6,
      workout_template_types: [],
      challenge: null,
      unit: 'WEEK_STREAK',
      type: 'NUMBER',
      name: 'Heating Up',
      enum_value: 'HEATING_UP',
      display_unit: 'WEEK_STREAK',
      short_description: '5 week activity streak',
      description:
        'This tracks your longest all-time streak. Complete 5 weeks to unlock. Your current streak is shown on the Home Screen.',
      achieved_message:
        'Wow! 5 weeks in a row! You are really heating up! Check your email for free fit52 stickers!!',
      level: 2,
      order: 2,
      max_progress: 5,
      initial_progress: 2,
      min_progress: 0,
      min_app_version: 200030000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 31,
      achievement_id: 7,
      workout_template_types: [],
      challenge: {
        id: 3,
        start_at: 1641189600000,
        end_at: 1649141999000,
        description:
          'This year is all about building healthy habits... with the Commit to Fit Challenge designed to meet you where you are at. Bronze, Silver or Gold... strive towards your own personal goal and cheer on your friends on the Leaderboards. All sessions count towards exclusive rewards. Plus follow @fit52 on social for bonus prizes. What will you commit to in 2022?',
        title: 'BODYARMOR LYTE',
        subtitle: 'Commit to Fit Challenge',
        prize_description: 'Challenge badges and BODYARMOR prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 161887,
            imageable_type: 'App\\Challenge',
            imageable_id: 3,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/apcibwfzzh7ovpwrgf9s',
            version: '1638991065',
            folder: 'image',
            format: 'jpg',
            manipulations: { crop: { x: 223, y: 0, width: 858, height: 489 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=858,trim.height=489,trim.left=223,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/apcibwfzzh7ovpwrgf9s/1638991065.jpg',
          },
          {
            id: 161888,
            imageable_type: 'App\\Challenge',
            imageable_id: 3,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/rtwxssww3c4q8dtfu5tb',
            version: '1638991090',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 0, y: 0, width: 360, height: 360 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=360,trim.height=360,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/rtwxssww3c4q8dtfu5tb/1638991090.png',
          },
        ],
        achievement_id: 7,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Commit to Fit 2022\r\n-Silver-',
      enum_value: 'COMMIT_TO_FIT22_SILVER',
      display_unit: 'SESSIONS',
      short_description: '52 sessions => $25 CU Store Credit',
      description:
        'Complete 52 sessions to unlock Silver in the Commit to Fit Challenge & receive $25 CU store credit!',
      achieved_message:
        'Amazing effort! 52 workouts down in HiNote Life! Check your email for your $25 CU store credit!',
      level: 2,
      order: 2,
      max_progress: 52,
      initial_progress: 22,
      min_progress: 0,
      min_app_version: 200040000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 34,
      achievement_id: 8,
      workout_template_types: [],
      challenge: {
        id: 4,
        start_at: 1654066801000,
        end_at: 1659337199000,
        description:
          'Stay active this summer with fit52! Every completed activity counts as an Active Day. Some days it might be a Flash Fit, others it could be a Full Workout. The more active days you achieve, the more chances you have to win one of 52 exclusive fit52 prize packs containing a workout towel, phone stand, journal & water bottle. More details at fit52.com/challenge.',
        title: 'Active Days of Summer',
        subtitle: null,
        prize_description: 'Challenge badges and fit52 prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 210226,
            imageable_type: 'App\\Challenge',
            imageable_id: 4,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/annjgau31nigtlcke5n7',
            version: '1652906445',
            folder: 'image',
            format: 'jpg',
            manipulations: { crop: { x: 2, y: 0, width: 1239, height: 706 } },
            user_id: 397939,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=706,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/annjgau31nigtlcke5n7/1652906445.jpg',
          },
          {
            id: 210227,
            imageable_type: 'App\\Challenge',
            imageable_id: 4,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/osziliasas2lhtj40qrm',
            version: '1652906455',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 0, y: 0, width: 300, height: 300 } },
            user_id: 397939,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=300,trim.height=300,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/osziliasas2lhtj40qrm/1652906455.png',
          },
        ],
        achievement_id: 8,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Active Days of Summer\r\n-Silver-',
      enum_value: 'ACTIVE_DAYS_OF_SUMMER_SILVER',
      display_unit: 'DAYS_ACTIVE',
      short_description: '40 Active Days => 4 Entries',
      description:
        'Be active for 40 days in the Active Days of Summer Challenge & receive 2 months free HiNote Life!',
      achieved_message:
        'Wow! 40 active days! You really are having an active summer!  Plus more chances of winning HiNote Life prizes. Can you achieve Gold? Only 12 more active days!',
      level: 2,
      order: 2,
      max_progress: 40,
      initial_progress: 20,
      min_progress: 0,
      min_app_version: 200060000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 37,
      achievement_id: 9,
      workout_template_types: [],
      challenge: {
        id: 5,
        start_at: 1662015601000,
        end_at: 1667285999000,
        description:
          'With fit52 the "Clock Don\'t Stop"! You may know the song, but can you unlock the rewards? All fit52 activities count. The more you do, the more time on the clock! Start with 100 mins to get a free friend membership, or 418 mins to get access to a live workout with Eve. Or go for Gold and get free fit52 minibands. Learn more at: fit52.com/official-challenge-rules-regulations.',
        title: "Clock Don't Stop ⏱️",
        subtitle: null,
        prize_description:
          'Free Friend Memberships, Live Workouts & fit52 Minibands!',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 232546,
            imageable_type: 'App\\Challenge',
            imageable_id: 5,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-ClockDontStop_Card',
            version: '1658261807',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-ClockDontStop_Card/1658261807.jpg',
          },
          {
            id: 232547,
            imageable_type: 'App\\Challenge',
            imageable_id: 5,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-ClockDontStop_Badge',
            version: '1659134865',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-ClockDontStop_Badge/1659134865.png',
          },
        ],
        achievement_id: 9,
      },
      unit: 'MINUTES',
      type: 'TIME',
      name: "Clock Don't Stop ⏱️\n-Silver-",
      enum_value: 'CLOCK_DONT_STOP_SILVER',
      display_unit: 'MINUTES',
      short_description: '418 mins = Access to Live Workout',
      description:
        "Be active for 418 minutes in the Clock Don't Stop Challenge & receive an invite for an exclusive live workout!",
      achieved_message:
        "You've worked out the same amount of time it would take to listen to all of Carrie's Albums. Check your inbox for your reward!",
      level: 2,
      order: 2,
      max_progress: 25080,
      initial_progress: 6000,
      min_progress: 0,
      min_app_version: 200070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 40,
      achievement_id: 10,
      workout_template_types: [],
      challenge: {
        id: 6,
        start_at: 1667286001000,
        end_at: 1671436799000,
        description:
          'This challenge is all about eating healthy! Follow a fit52 recipe or get creative with a meal of your own, then share the photo with the fit52 fam. Every healthy meal shared counts towards the challenge goals. Max 3 meals shared per day. Looking for more healthy eating guidance? Visit caraclarknutrition.com.',
        title: 'Healthy Through The Holidays',
        subtitle: null,
        prize_description: 'Nutrition Tips, Food Logs & Meal Plans',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 244159,
            imageable_type: 'App\\Challenge',
            imageable_id: 6,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-HealthyThroughTheHolidays_Card',
            version: '1662757646',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-HealthyThroughTheHolidays_Card/1662757646.jpg',
          },
          {
            id: 244160,
            imageable_type: 'App\\Challenge',
            imageable_id: 6,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-HealthyThroughTheHolidays_Badge',
            version: '1662757646',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-HealthyThroughTheHolidays_Badge/1662757646.png',
          },
        ],
        achievement_id: 10,
      },
      unit: 'MEALS',
      type: 'NUMBER',
      name: 'Healthy Through The Holidays\n-Silver-',
      enum_value: 'HEALTHY_THROUGH_THE_HOLIDAYS_SILVER',
      display_unit: 'MEALS',
      short_description: '20 Meals = Exclusive Food Log',
      description:
        'Share Photos of 20 Healthy Meals to HiNote Life and earn an exclusive food log!',
      achieved_message:
        '20 Healthy Meals shared. Silver Unlocked. Amazing Progress. Check your email for your personal exclusive food log! ',
      level: 2,
      order: 2,
      max_progress: 20,
      initial_progress: 10,
      min_progress: 0,
      min_app_version: 200080000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 43,
      achievement_id: 11,
      workout_template_types: [],
      challenge: {
        id: 7,
        start_at: 1672560000000,
        end_at: 1677657599000,
        description:
          'Let’s start 2023 by being active! Every fit52 activity completed counts as an Active Day. It could be a Stretch, a Flash Fit, or a Full Workout. Do what works best for you and mix it up each day to build healthy habits. The more active days you achieve, the more chances you have of winning exclusive fit52 prizes, including signed fit52 Yoga Mats from Carrie & Eve! More info: fit52.com/challenge.',
        title: 'Be Active in 2023',
        subtitle: null,
        prize_description: 'fit52 Jump Ropes, Water Bottles & Signed Yoga Mats',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264613,
            imageable_type: 'App\\Challenge',
            imageable_id: 7,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-ActiveDays__Challenge1.76_3x',
            version: '1667859855',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-ActiveDays__Challenge1.76_3x/1667859855.jpg',
          },
          {
            id: 264614,
            imageable_type: 'App\\Challenge',
            imageable_id: 7,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-BeActive2023_Black_3x',
            version: '1667863490',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-BeActive2023_Black_3x/1667863490.png',
          },
        ],
        achievement_id: 11,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Be Active in 2023\r\n-Silver-',
      enum_value: 'ACTIVE_DAYS_2023_SILVER',
      display_unit: 'DAYS_ACTIVE',
      short_description: '25 Days = Entry to win water bottles',
      description:
        'Complete 25 Active Days to unlock an entry to win exclusive water bottles.',
      achieved_message:
        'Go you! You are now entered to win exclusive water bottles. Can you now go for Gold?',
      level: 2,
      order: 2,
      max_progress: 25,
      initial_progress: 15,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 46,
      achievement_id: 12,
      workout_template_types: [
        'FLASH_FIT_UPPER_BODY',
        'FLASH_FIT_LOWER_BODY',
        'FLASH_FIT_CORE',
        'FLASH_FIT_CARDIO',
        'GENERATOR_15',
        'GENERATOR_30',
        'GENERATOR_45',
      ],
      challenge: {
        id: 8,
        start_at: null,
        end_at: null,
        description:
          'This ‘Fit in a Flash’ is designed to get you moving in short, targeted workouts. This 30 day challenge you can start at anytime. Flash Fit’s are targeted workouts with 13 cards, that can be done in 15 mins or less.  Start your Flash Fit from the Workout screen under ‘Featured Workouts’. Challenge your friends and see how many you can do to unlock Fit in a Flash achievements! All Flash Fit’s count.',
        title: 'Fit in a Flash',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264615,
            imageable_type: 'App\\Challenge',
            imageable_id: 8,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-FitInAFlash__Challenge1.76_3x',
            version: '1667859863',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FitInAFlash__Challenge1.76_3x/1667859863.jpg',
          },
          {
            id: 264616,
            imageable_type: 'App\\Challenge',
            imageable_id: 8,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-FitInAFlash_Black_3x',
            version: '1667863522',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FitInAFlash_Black_3x/1667863522.png',
          },
        ],
        achievement_id: 12,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Fit in a Flash\n-Silver-',
      enum_value: 'FIT_IN_A_FLASH_SILVER',
      display_unit: 'WORKOUTS',
      short_description: '15 Flash Fits',
      description: 'Complete 15 Flash Fits in 30 days to achieve Silver.',
      achieved_message:
        'Well done. You’ve earned Silver in this challenge. Only 10 more Flash Fits to Gold. You can do it!',
      level: 2,
      order: 2,
      max_progress: 15,
      initial_progress: 5,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 49,
      achievement_id: 13,
      workout_template_types: [
        'RECOVER_STRETCH_FULL_BODY_FLOW',
        'RECOVER_STRETCH_ENERGY_BOOSTER',
        'RECOVER_STRETCH_REVIVE_RECOVER',
        'RECOVER_STRETCH_HIPS_LEGS',
        'RECOVER_STRETCH_YOGA_FLOW',
        'RECOVER_STRETCH_WIND_DOWN',
        'DAILY_5_STRETCH',
        'DAILY_5_SEATED_STRETCH',
        'RECOVER_STRETCH_BACK_CHEST_FOAM_ROLLER',
        'RECOVER_STRETCH_LOWER_BODY_FOAM_ROLLER',
      ],
      challenge: {
        id: 9,
        start_at: null,
        end_at: null,
        description:
          'Feeling the need to Stretch? Then this 30 day challenge is perfect for you. You can start this challenge anytime, and have 30 days to ‘Stretch it Out’. Any stretch, yoga, or foam rolling sessions in HiNote Life count towards these challenge goals. Focus on building a regular stretching routine, or add a recovery session to complement your workouts. See how many stretch or recovery sessions you can do in 30 days, plus you can always repeat this challenge if you need to ‘Stretch it Out’ further.',
        title: 'Stretch it Out',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264617,
            imageable_type: 'App\\Challenge',
            imageable_id: 9,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-StretchItOut__Challenge1.76_3x',
            version: '1667859855',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-StretchItOut__Challenge1.76_3x/1667859855.jpg',
          },
          {
            id: 264618,
            imageable_type: 'App\\Challenge',
            imageable_id: 9,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-StretchItOut_Black_3x',
            version: '1667863552',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-StretchItOut_Black_3x/1667863552.png',
          },
        ],
        achievement_id: 13,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Stretch it Out\r\n-Silver-',
      enum_value: 'STRETCH_IT_OUT_SILVER',
      display_unit: 'WORKOUTS',
      short_description: '20 Stretch or Recovery Sessions',
      description:
        'Complete 20 Stretch or Recovery Sessions in 30 days to unlock Silver Challenge achievement.',
      achieved_message:
        'Well done! 20 Stretch/Recovery Sessions complete. Can you do 10 more to unlock Gold?',
      level: 2,
      order: 2,
      max_progress: 20,
      initial_progress: 10,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 52,
      achievement_id: 14,
      workout_template_types: [
        'DAILY_5_MOVE',
        'DAILY_5_STRETCH',
        'DAILY_5_SEATED_STRETCH',
      ],
      challenge: {
        id: 10,
        start_at: null,
        end_at: null,
        description:
          'This Daily Dose challenge is all about doing 5 exercises or stretches per day, getting in your Daily 5’s. You can start this challenge at any time, and see how many Daily 5’s you can complete in 30 days. All Daily 5’s, Move, Stretch and Seated Stretch count! Perfect if you are short on time, as these activities can be completed in 5 mins. Give it a try and get your Daily Dose of HiNote Life! Don’t forget to challenge your friends to see who can get the longest Daily Streak and achieve Gold!',
        title: 'Daily Dose',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264619,
            imageable_type: 'App\\Challenge',
            imageable_id: 10,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-DailyDose__Challenge1.76_3x',
            version: '1667859860',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-DailyDose__Challenge1.76_3x/1667859860.jpg',
          },
          {
            id: 264620,
            imageable_type: 'App\\Challenge',
            imageable_id: 10,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-DailyDose_Black_3x',
            version: '1667863508',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-DailyDose_Black_3x/1667863508.png',
          },
        ],
        achievement_id: 14,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Daily Dose\r\n-Silver-',
      enum_value: 'DAILY_DOSE_SILVER',
      display_unit: 'WORKOUTS',
      short_description: '20 Daily 5’s',
      description: '20 Daily 5’s in 30 days unlocks Silver in this challenge.',
      achieved_message:
        'Congrats to 20 Daily 5’s. You are truly building a fitness habit. Movement every day!',
      level: 2,
      order: 2,
      max_progress: 20,
      initial_progress: 10,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 55,
      achievement_id: 15,
      workout_template_types: [
        'HALF',
        'FULL',
        'CARD_DRAW_13',
        'LADDER',
        'ALL_FAVORITE_SEGMENTS',
        'CARRIE_FAVORITE_SEGMENTS',
        'EVE_FAVORITE_SEGMENTS',
        'GENERATOR_15',
        'GENERATOR_30',
        'GENERATOR_45',
        'DENIM_AND_RHINESTONES',
      ],
      challenge: {
        id: 11,
        start_at: null,
        end_at: null,
        description:
          'The Full Body Fun challenge is just what the name suggests, all about full body workouts and having fun! You could do 13 card draws, or step up to half or full workouts. As long as you are working out your entire body, it counts towards these challenge goals. Your path workouts also count!  See how many full body workouts you can do in the 30 days and most importantly, have fun!',
        title: 'Full Body Fun',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264621,
            imageable_type: 'App\\Challenge',
            imageable_id: 11,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-FullBodyFun__Challenge1.76_3x',
            version: '1667859866',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FullBodyFun__Challenge1.76_3x/1667859866.jpg',
          },
          {
            id: 264622,
            imageable_type: 'App\\Challenge',
            imageable_id: 11,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-FullBodyFun_Black_3x',
            version: '1667863536',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FullBodyFun_Black_3x/1667863536.png',
          },
        ],
        achievement_id: 15,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Full Body Fun\n-Silver-',
      enum_value: 'FULL_BODY_FUN_SILVER',
      display_unit: 'WORKOUTS',
      short_description: '15 of Any Full Body Workout',
      description:
        '15 Full Body Workouts, of any type, earns you Silver! You got this!',
      achieved_message:
        'Silver Unlocked! 15 Full Body Workouts is impressive. Can you do 10 more to get Gold?',
      level: 2,
      order: 2,
      max_progress: 15,
      initial_progress: 5,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 58,
      achievement_id: 16,
      workout_template_types: [],
      challenge: {
        id: 12,
        start_at: 1677657600000,
        end_at: 1681722000000,
        description:
          "Carrie and Eve. SportWater and LYTE. You and your workout bestie. What makes the perfect duo?\r\n\r\nThe BODYARMOR Duo Challenge is all about challenging yourself and a friend to form a duo and smash your workout goals together. Invite your friends or favorite a member of the fit52fam! Hit the challenge achievements and both you and your workout partner enter to win 1 month's supply of BODYARMOR LYTE and SportWater (US only). Max 2 workouts count each day toward challenge goals.\r\n\r\nStay hydrated with bit.ly/DrinkBODYARMOR",
        title: 'BODYARMOR Duo',
        subtitle: null,
        prize_description: 'BODYARMOR prizes for you and your Duo',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 287669,
            imageable_type: 'App\\Challenge',
            imageable_id: 12,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-BADuo__Challenge1.76_3x',
            version: '1676332613',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-BADuo__Challenge1.76_3x/1676332613.jpg',
          },
          {
            id: 287670,
            imageable_type: 'App\\Challenge',
            imageable_id: 12,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-BAduo_Black_3x',
            version: '1676332598',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-BAduo_Black_3x/1676332598.png',
          },
        ],
        achievement_id: 16,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'BODYARMOR Duo\n-Silver-',
      enum_value: 'BA_DUO_SILVER',
      display_unit: 'WORKOUTS',
      short_description: '25 Workouts - 3 entries',
      description:
        '25 workouts gets you an entry to win a BODYARMOR prize pack for you and a friend.',
      achieved_message:
        'Congrats! Silver is yours! You are now entered to win exclusive BODYARMOR prizes for you and a friend. Now let’s go for Gold!',
      level: 2,
      order: 2,
      max_progress: 25,
      initial_progress: 10,
      min_progress: 0,
      min_app_version: 300000003,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 61,
      achievement_id: 17,
      workout_template_types: [],
      challenge: {
        id: 13,
        start_at: 1699862400000,
        end_at: 1703275199000,
        description:
          'Get in shape this fall! Finish Flash Fits to win entries for a chance to get one of ten exclusive prize packs valued at $240 from the Official Carrie Underwood Store. Packs include a signed Denim & Rhinestones Deluxe Picture Disc Vinyl - signed by Carrie herself!! Every Flash Fit adds to Challenge achievements, max 3 daily. Details at fit52.com/challenge.',
        title: 'Get Fit this Fall 🍁',
        subtitle: null,
        prize_description: 'Win Official Carrie Underwood Store Prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 339199,
            imageable_type: 'App\\Challenge',
            imageable_id: 13,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-FlashFitFall__Challenge1.76_3x',
            version: '1697129640',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FlashFitFall__Challenge1.76_3x/1697129640.jpg',
          },
          {
            id: 339200,
            imageable_type: 'App\\Challenge',
            imageable_id: 13,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-FlashFitFall_Black_3x',
            version: '1697129641',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FlashFitFall_Black_3x/1697129641.png',
          },
        ],
        achievement_id: 17,
      },
      unit: 'FLASH_FITS',
      type: 'NUMBER',
      name: 'Flash Fit Fall\r\nSilver',
      enum_value: 'GET_FIT_FALL_SILVER',
      display_unit: 'FLASH_FITS',
      short_description: '15 Flash Fits - 2 entries',
      description:
        'By unlocking Silver, you will get more entries into the draw to win exclusive Carrie Underwood prize packs!',
      achieved_message:
        'Awesome work! You’ve earned Silver & more entries into the draw to win an exclusive Carrie Underwood prize pack!',
      level: 2,
      order: 2,
      max_progress: 15,
      initial_progress: 5,
      min_progress: 0,
      min_app_version: 300010000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 64,
      achievement_id: 18,
      workout_template_types: [],
      challenge: {
        id: 14,
        start_at: null,
        end_at: null,
        description:
          "Join the '30-Day Shape Up' challenge! Be active daily to earn Bronze, Silver, or Gold achievements. Transform in just a month, start anytime, all completed workouts count! Let's get fit together in 30 days!",
        title: '30-Day Shape Up',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 339201,
            imageable_type: 'App\\Challenge',
            imageable_id: 14,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-30DayShapeUp__Challenge1.76_3x',
            version: '1696443839',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-30DayShapeUp__Challenge1.76_3x/1696443839.jpg',
          },
          {
            id: 339202,
            imageable_type: 'App\\Challenge',
            imageable_id: 14,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-30DayShapeUp_Black_3x',
            version: '1696443850',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-30DayShapeUp_Black_3x/1696443850.png',
          },
        ],
        achievement_id: 18,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: '30 Day Shape Up\nSilver',
      enum_value: 'SHAPE_UP_SILVER',
      display_unit: 'DAYS_ACTIVE',
      short_description: '15 Active Days',
      description:
        '15 Active Days in 30 Days!! This gets your momentum going towards Gold!',
      achieved_message:
        'Silver!! Way to go. 15 active days! You are well on your way to building a healthy habit.',
      level: 2,
      order: 2,
      max_progress: 15,
      initial_progress: 5,
      min_progress: 0,
      min_app_version: 300010000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 67,
      achievement_id: 19,
      workout_template_types: [],
      challenge: {
        id: 15,
        start_at: null,
        end_at: null,
        description:
          "Embark on the '100 reps a Day' challenge! Crush 100 card reps daily for Bronze, Silver or Gold goals. Transform your strength and endurance. Regardless of how many you can achieve, max 100 reps (from card based workouts) count towards challenge goals. Give it a try and see how many days you can do 100 reps!",
        title: '100 Reps a Day',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 339203,
            imageable_type: 'App\\Challenge',
            imageable_id: 15,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/NoLimits__Challenge1.76_3x',
            version: '1696443729',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/NoLimits__Challenge1.76_3x/1696443729.jpg',
          },
          {
            id: 339204,
            imageable_type: 'App\\Challenge',
            imageable_id: 15,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-100RepsADay_Black_3x',
            version: '1696443820',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-100RepsADay_Black_3x/1696443820.png',
          },
        ],
        achievement_id: 19,
      },
      unit: 'REPS',
      type: 'NUMBER',
      name: '100 Reps a Day\nSilver',
      enum_value: 'REPS_A_DAY_SILVER',
      display_unit: 'REPS',
      short_description: '24 days with 100 Reps',
      description: 'By hitting 24 days of 100 reps, you will unlock Silver!',
      achieved_message: '100 reps per day for 24 days. What an effort!',
      level: 2,
      order: 2,
      max_progress: 2400,
      initial_progress: 1500,
      min_progress: 0,
      min_app_version: 300010000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 70,
      achievement_id: 20,
      workout_template_types: [],
      challenge: {
        id: 16,
        start_at: 1704096000000,
        end_at: 1707076799000,
        description:
          'Kickstart 2024 with the fit52 5x2 Challenge! Aim for 5 weeks with 2 workouts per week. Can you do more? Stay on track and you could win one of 24 fit52 phone stands! Max 1 workout per day counts towards challenge. More details at fit52.com/challenge. Make 2024 your best year with a fresh start to fitness!',
        title: '5x2 - Fresh Start for 2024',
        subtitle: null,
        prize_description: 'Win 1 of 24 exclusive fit52 phone stands',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 344834,
            imageable_type: 'App\\Challenge',
            imageable_id: 16,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-5x2__Challenge1.76_3x',
            version: '1701081278',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-5x2__Challenge1.76_3x/1701081278.jpg',
          },
          {
            id: 344835,
            imageable_type: 'App\\Challenge',
            imageable_id: 16,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-5x2_Black_3x',
            version: '1701081209',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-5x2_Black_3x/1701081209.png',
          },
        ],
        achievement_id: 20,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: '5X2 for 2024\r\nSilver',
      enum_value: 'FRESH_START_SILVER',
      display_unit: 'WORKOUTS',
      short_description: '15 Workouts - 2 Entries',
      description:
        'By earning Silver in the 5x2 Challenge you will receive even more entries to win 1 of 24 exclusive phone stands!',
      achieved_message:
        'Awesome work! You’ve earned Silver & more entries into the draw to win an exclusive phone stand!',
      level: 2,
      order: 2,
      max_progress: 15,
      initial_progress: 10,
      min_progress: 0,
      min_app_version: 300020000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 77,
      achievement_id: 21,
      workout_template_types: [],
      challenge: {
        id: 17,
        start_at: 1711090801000,
        end_at: 1715669999000,
        description:
          'Get your stretch on this Spring with the fit52 Spring Stretch Challenge! Aim for 10 Stretch & Recovery Sessions to achieve Bronze. Keep up the momentum and you might be the lucky winner of a exclusive 1:1 virtual workout with Eve! All completed Stretch & Recovery sessions count. Discover more at fit52.com/challenge. Start the season with the Spring Stretch Challenge!',
        title: 'Spring Stretch 2024',
        subtitle: null,
        prize_description: 'Win 1:1 Virtual fit52 Workout with Eve!',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 359013,
            imageable_type: 'App\\Challenge',
            imageable_id: 17,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-SpringStretch__Challenge1.76_3x',
            version: '1705333396',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-SpringStretch__Challenge1.76_3x/1705333396.jpg',
          },
          {
            id: 359014,
            imageable_type: 'App\\Challenge',
            imageable_id: 17,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-SpringStretch_Black_3x',
            version: '1705333379',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-SpringStretch_Black_3x/1705333379.png',
          },
        ],
        achievement_id: 21,
      },
      unit: 'STRETCH_SESSIONS',
      type: 'NUMBER',
      name: 'Spring Stretch 2024\nSilver',
      enum_value: 'SPRING_STRETCH_SILVER',
      display_unit: 'STRETCH_SESSIONS',
      short_description: '25 Stretch Sessions - 2 Entries',
      description:
        'Earn silver and double your chances of winning an exclusive virtual workout with Eve Overland!',
      achieved_message:
        'Silver Success! You’ve soared past the basics and clinched Silver in the Spring Stretch Challenge. Ready for Gold? Keep going, champion.',
      level: 2,
      order: 2,
      max_progress: 25,
      initial_progress: 10,
      min_progress: 0,
      min_app_version: 300030000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 80,
      achievement_id: 22,
      workout_template_types: [],
      challenge: {
        id: 18,
        start_at: 1722841200000,
        end_at: 1725908399000,
        description:
          'Build a fitness habit with fit52 and the 5 Weeks to Fit challenge. Perfect if you are just getting started or back into fitness. Take it one day at a time, turn gradual progress into a habit that lasts.\r\n\r\nEvery workout you complete counts as an Active Day - and increases your chances to win exclusive fit52 prizes, including Notebooks, Caps and Gym Bags.\r\n\r\nDon’t miss out on this opportunity to boost your fitness and snag some awesome gear. Learn more at: fit52.com/challenge.',
        title: '5 Weeks To Fit',
        subtitle: null,
        prize_description: 'Challenge badges and fit52 prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 383455,
            imageable_type: 'App\\Challenge',
            imageable_id: 18,
            collection_name: 'challenge_image',
            name: 'uploads/Challenge-5WeeksToFit_Challenge1.76@3x.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/Challenge-5WeeksToFit_Challenge1.76@3x.jpeg',
          },
          {
            id: 383456,
            imageable_type: 'App\\Challenge',
            imageable_id: 18,
            collection_name: 'challenge_icon_image',
            name: 'uploads/Challenge-5WeeksToFit_Black@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/Challenge-5WeeksToFit_Black@3x.png',
          },
        ],
        achievement_id: 22,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: '5 Weeks To Fit\nSilver',
      enum_value: 'FIVE_WEEKS_TO_FIT_SILVER',
      display_unit: 'DAYS_ACTIVE',
      short_description: 'Draw for 5 exclusive Trucker Hats',
      description:
        '25 days of consistent effort is how you build healthy habits. Can you do it? If you can you are entered to an exclusive Trucker Cap!',
      achieved_message:
        'Amazing effort. 25 days done! You are entered to win an exclusive Trucker Cap! Can you strive towards Gold?',
      level: 2,
      order: 2,
      max_progress: 25,
      initial_progress: 15,
      min_progress: 0,
      min_app_version: 300050000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 99,
      achievement_id: 23,
      workout_template_types: [],
      challenge: {
        id: 19,
        start_at: 1741590000000,
        end_at: 1750186799000,
        description:
          'Ready to create lasting fitness habits? Join the fit52 Healthy Habits Challenge — designed to help you build a sustainable routine that you can continue well beyond this challenge.\r\n\r\nEvery workout or yoga session you complete in the app counts as an Active Day. Pick the activities that fit your lifestyle and get moving! Along the way, unlock challenge achievements.',
        title: 'Healthy Habits in 2025',
        subtitle: null,
        prize_description: 'fit52 Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 402378,
            imageable_type: 'App\\Challenge',
            imageable_id: 19,
            collection_name: 'challenge_image',
            name: 'uploads/healthy-habits-challenge-image@3x.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/healthy-habits-challenge-image@3x.jpeg',
          },
          {
            id: 402379,
            imageable_type: 'App\\Challenge',
            imageable_id: 19,
            collection_name: 'challenge_icon_image',
            name: 'uploads/healthy-habits-challenge-badge-black@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/healthy-habits-challenge-badge-black@3x.png',
          },
        ],
        achievement_id: 23,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Healthy Habits in 2025\nSilver',
      enum_value: 'HEALTHY_HABITS_2025_SILVER',
      display_unit: 'DAYS_ACTIVE',
      short_description: 'Be active for 35 days',
      description: 'Can you do 35 days of healthy habits and unlock silver?',
      achieved_message:
        'Nearly there! 35 days of Fitness. You are off to a great start in 2025!',
      level: 2,
      order: 2,
      max_progress: 35,
      initial_progress: 25,
      min_progress: 0,
      min_app_version: 300090000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 102,
      achievement_id: 24,
      workout_template_types: [],
      challenge: {
        id: 20,
        start_at: 1735718400000,
        end_at: 1740254399000,
        description:
          "Fuel Your Best Self with the Nourish & Thrive in 2025 Challenge!\r\n\r\nTake charge of your nutrition and set yourself up for success in 2025 with the Nourish & Thrive Challenge. This challenge is perfect for anyone looking to build sustainable, healthy eating habits that last all year long.\r\n\r\nEvery meal you log in fit52 counts toward your challenge progress, bringing you one step closer to your goals! As you complete the challenge, you'll earn achievements and increase your chances to win exclusive nutrition prizes.\r\n\r\nReady to start thriving? Learn more at: fit52.com/challenge.",
        title: 'Nourish & Thrive in 2025',
        subtitle: null,
        prize_description: 'Nutrition Prizes & Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 402380,
            imageable_type: 'App\\Challenge',
            imageable_id: 20,
            collection_name: 'challenge_image',
            name: 'uploads/nourish-thrive-challenge-image@3x.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/nourish-thrive-challenge-image@3x.jpeg',
          },
          {
            id: 402381,
            imageable_type: 'App\\Challenge',
            imageable_id: 20,
            collection_name: 'challenge_icon_image',
            name: 'uploads/nourish-thrive-challenge-badge-black@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/nourish-thrive-challenge-badge-black@3x.png',
          },
        ],
        achievement_id: 24,
      },
      unit: 'MEALS_TRACKED',
      type: 'NUMBER',
      name: 'Nourish & Thrive in 2025\nSilver',
      enum_value: 'NOURISH_AND_THRIVE_2025_SILVER',
      display_unit: 'MEALS_TRACKED',
      short_description: 'Entry to win Exclusive Merchandise',
      description:
        'Log 25 meals and unlock the Silver achievement, plus enter the draw to win great Cara Clark Nutrition prizes!',
      achieved_message:
        '52 meals done. Go you! Can you keep the habit going towards Gold?',
      level: 2,
      order: 2,
      max_progress: 52,
      initial_progress: 25,
      min_progress: 0,
      min_app_version: 300080000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 105,
      achievement_id: 25,
      workout_template_types: [],
      challenge: {
        id: 21,
        start_at: null,
        end_at: null,
        description:
          "Ready to sculpt strong, toned legs like Carrie Underwood? The 52 Days to Toned Legs Challenge is your ultimate guide to building strength, definition, and confidence in your legs and glutes. This challenge is designed to help you stay consistent with effective, lower body focused workouts that fit into any schedule.\n\nWhy join the Challenge?\nThis challenge is all about helping you:\n- Build strength and power in your legs.\n- Sculpt and tone your thighs, calves, and glutes for a lean, defined look.\n- Feel stronger and more confident with every workout.\n- Get closer to achieving legs like Carrie Underwood's with her proven workout routines!\n\nWhat Counts Towards this Challenge?\nEvery leg-focused workout in HiNote Life counts! Choose from:\n- Flash Fit: Legs\n- Carrie's Leg Workout\n- Lower Body Burn\n- Leg Day with Carrie and Eve\n\nEach completed workout counts toward your progress, so you can mix it up or stick with your favorites.",
        title: '52 Days to Toned Legs',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 402382,
            imageable_type: 'App\\Challenge',
            imageable_id: 21,
            collection_name: 'challenge_image',
            name: 'uploads/toned-legs-challenge-image-updated3x.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/toned-legs-challenge-image-updated3x.jpeg',
          },
          {
            id: 402383,
            imageable_type: 'App\\Challenge',
            imageable_id: 21,
            collection_name: 'challenge_icon_image',
            name: 'uploads/toned-legs-challenge-badge-black3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/toned-legs-challenge-badge-black3x.png',
          },
        ],
        achievement_id: 25,
      },
      unit: 'LEG_WORKOUTS',
      type: 'NUMBER',
      name: '52 Days to Toned Legs\nSilver',
      enum_value: 'FIFTY_TWO_DAYS_TO_TONED_LEGS_SILVER',
      display_unit: 'LEG_WORKOUTS',
      short_description: '20 Leg Workouts',
      description:
        'Can you complete 20 leg-sculpting workouts? Unlock the Silver badge and take your strength and tone to the next level!',
      achieved_message:
        'Fantastic work! 20 leg workouts crushed! Your legs are getting stronger and more sculpted—keep pushing to Gold!',
      level: 2,
      order: 2,
      max_progress: 20,
      initial_progress: 10,
      min_progress: 0,
      min_app_version: 300080000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 108,
      achievement_id: 26,
      workout_template_types: [],
      challenge: {
        id: 22,
        start_at: 1735718400000,
        end_at: 1740297599000,
        description:
          'Ready to elevate your fitness in 2025? Join the Sweat, Sip & Win with BODYARMOR Challenge—where hydration fuels your drive to crush your 2025 goals - and to stay refreshed along the way.\r\n\r\nEvery workout, yoga or stretch session in the fit52 app counts as an Active Day towards challenge goals. Stay consistent with fit52, sip smart with BODYARMOR, and rack up those wins! Unlock achievements and boost your chances to score exclusive BODYARMOR & fit52 prizes.\r\n\r\nReady for even more? Combine this challenge with the Nourish & Thrive Nutrition Challenge to amplify your wellness journey and build habits that last.\r\n\r\nLearn more at: fit52.com/challenge',
        title: 'Sweat, Sip & Win with BODYARMOR',
        subtitle: null,
        prize_description: 'BODYARMOR Challenge Prizes & Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 402390,
            imageable_type: 'App\\Challenge',
            imageable_id: 22,
            collection_name: 'challenge_image',
            name: 'uploads/bodyarmor-2025.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/bodyarmor-2025.jpeg',
          },
          {
            id: 402391,
            imageable_type: 'App\\Challenge',
            imageable_id: 22,
            collection_name: 'challenge_icon_image',
            name: 'uploads/bodyarmor-2025-badge-updated.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/bodyarmor-2025-badge-updated.png',
          },
        ],
        achievement_id: 26,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Sweat, Sip & Win with BODYARMOR\nSilver',
      enum_value: 'SWEAT_SIP_WIN_BODYARMOR_SILVER',
      display_unit: 'DAYS_ACTIVE',
      short_description: 'Entry to win 1 of 3 exclusive fitness Prize Packs',
      description:
        '35 days of healthy habits with BODYARMOR. Earn silver and be entered to win an exclusive fitness prize pack!',
      achieved_message:
        "35 days of healthy habits done with BODYARMOR. You're entered in the draw to win an exclusive fitness prize pack.",
      level: 2,
      order: 2,
      max_progress: 35,
      initial_progress: 25,
      min_progress: 0,
      min_app_version: 300080001,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 111,
      achievement_id: 27,
      workout_template_types: [],
      challenge: {
        id: 23,
        start_at: 1752562800000,
        end_at: 1758005999000,
        description:
          "Make the most of the season with sunshine, good vibes, and nourishing meals! The Healthy Eating, Summer Living Challenge rewards you for logging 2 or more meals a day. Win great prizes including fit52 notebooks, fit52 muscle tank tops, and fit52 aprons!\r\n\r\nNever tried the fit52 food journal? Now's your chance to jump in and see how easy it is to stay on track.\r\n\r\nEvery day you log 2 or more meals, you'll get closer to unlocking exclusive fit52 nutrition rewards.  A meal is either Breakfast, Lunch, Dinner or a Snack. Whether you're enjoying sunny strolls, weekend getaways, or simply juggling a busy summer routine, consistently logging your meals in the fit52 food journal helps you stay mindful, make smarter choices, and see real progress.\r\n\r\nEach of the Achievements earns entries to the draw to win exclusive fit52 prizes.\r\nBronze = Win 1 of 10 fit52 Notebooks.\r\nSilver = Win 1 of 5 fit52 Aprons.\r\nGold = Win 1 of 3 fit52 Muscle Tops.\r\n\r\nWant to take your summer wellness even further? Combine this with a fit52 workout challenge for a head-to-toe healthy season.\r\n\r\nLet's eat well and live fully - all summer long! Learn more at: fit52.com/challenge.",
        title: 'Healthy Eating, Summer Living',
        subtitle: null,
        prize_description: 'fit52 Nutrition Prizes & Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 431933,
            imageable_type: 'App\\Challenge',
            imageable_id: 23,
            collection_name: 'challenge_image',
            name: 'uploads/healthy-eating-2025-challenge-image@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/healthy-eating-2025-challenge-image@3x.png',
          },
          {
            id: 431934,
            imageable_type: 'App\\Challenge',
            imageable_id: 23,
            collection_name: 'challenge_icon_image',
            name: 'uploads/challenge-badge-healthy-eating-2025-gold@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/challenge-badge-healthy-eating-2025-gold@3x.png',
          },
        ],
        achievement_id: 27,
      },
      unit: 'DAYS_WITH_MEALS',
      type: 'NUMBER',
      name: 'Healthy Eating, Summer Living\nSilver',
      enum_value: 'HEALTHY_EATING_SUMMER_LIVING_SILVER',
      display_unit: 'DAYS_WITH_MEALS',
      short_description: '30 Days with 2+ Meals',
      description:
        '35 days of healthy eating - can you get there? Earn Silver and be entered to win 1 of 5 exclusive aprons!',
      achieved_message:
        "Amazing effort. 30 days of healthy eating! You're now in the draw to win 1 of 5 exclusive Aprons!",
      level: 2,
      order: 2,
      max_progress: 30,
      initial_progress: 15,
      min_progress: 0,
      min_app_version: 300110001,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 114,
      achievement_id: 28,
      workout_template_types: [],
      challenge: {
        id: 24,
        start_at: 1767254400000,
        end_at: 1771747199000,
        description:
          'Start 2026 strong with the Move More in ’26 Challenge. Your job is to complete one Movement Day at a time. A Movement Day is any fit52 activity you do inside the app. Stretch. Workout. Yoga session. Flash Fit. Cardio, they all count.\r\n\r\nComplete your Movement Day and you move closer to unlocking fit52 achievements and earning perks like yoga mats, water bottles, and gym bags.\r\n\r\nThis is about building a daily movement habit, not chasing perfection. Join in, show up in the app, and start the year with consistency and the fit52 fam behind you.\r\n\r\nReady to make daily movement a habit? Join now and kick off the New Year with purpose, consistency, and the support of the fit52 fam.',
        title: 'Move More in 2026',
        subtitle: null,
        prize_description: 'Exclusive fit52 Prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 448672,
            imageable_type: 'App\\Challenge',
            imageable_id: 24,
            collection_name: 'challenge_image',
            name: 'uploads/move-more-in-2026-challenge-image-v2@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/move-more-in-2026-challenge-image-v2@3x.png',
          },
          {
            id: 448673,
            imageable_type: 'App\\Challenge',
            imageable_id: 24,
            collection_name: 'challenge_icon_image',
            name: 'uploads/challenge-badge-move-more-in-2026-gold@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/challenge-badge-move-more-in-2026-gold@3x.png',
          },
        ],
        achievement_id: 28,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Move More in ‘26\nSilver',
      enum_value: 'MOVE_MORE_IN_2026_SILVER',
      display_unit: 'DAYS_ACTIVE',
      short_description:
        '26 Movement Days = Entry to win 1 of 3 exclusive Gym Bags',
      description:
        'Complete 26 days with movement, and enter to win an exclusive gym bag!',
      achieved_message:
        'You’ve hit Silver with 26 movement days. Keep going towards Gold, and you’re now entered to win an exclusive gym bag!',
      level: 2,
      order: 2,
      max_progress: 26,
      initial_progress: 13,
      min_progress: 0,
      min_app_version: 300130000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 117,
      achievement_id: 29,
      workout_template_types: [],
      challenge: {
        id: 25,
        start_at: 1767254400000,
        end_at: 1771747199000,
        description:
          'Fuel Your Best Self with the 52-Day Energy Reset in 2026 Challenge!\r\n\r\nTake charge of your nutrition and set yourself up for success in 2026 with the 52-Day Energy Reset Challenge. This challenge is perfect for anyone looking to build sustainable, healthy eating habits that last all year long.\r\n\r\nEvery meal you log in fit52 counts toward your challenge progress, bringing you one step closer to your goals! As you complete the challenge, you’ll earn achievements and increase your chances to win fit52 prizes.\r\n\r\nLooking for a full-body wellness approach? Pair this challenge with the fit52 Move More in 2026 Challenge for an unbeatable combination of fitness and nutrition.\r\n\r\nReady to start thriving? Learn more at: fit52.com/challenge.',
        title: '52-Day Energy Reset',
        subtitle: null,
        prize_description: 'fit52 Nutrition Prizes & Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 448674,
            imageable_type: 'App\\Challenge',
            imageable_id: 25,
            collection_name: 'challenge_image',
            name: 'uploads/52-day-energy-reset-2026-challenge-image-v2@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/52-day-energy-reset-2026-challenge-image-v2@3x.png',
          },
          {
            id: 448675,
            imageable_type: 'App\\Challenge',
            imageable_id: 25,
            collection_name: 'challenge_icon_image',
            name: 'uploads/challenge-badge-52-day-energy-reset-2026-gold-v2@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/challenge-badge-52-day-energy-reset-2026-gold-v2@3x.png',
          },
        ],
        achievement_id: 29,
      },
      unit: 'DAYS_WITH_MEALS_V2',
      type: 'NUMBER',
      name: '52 Day Energy Reset\nSilver',
      enum_value: 'FIFTY_TWO_DAYS_ENERGY_RESET_2026_SILVER',
      display_unit: 'DAYS_WITH_MEALS_V2',
      short_description: '100 Meals = Entry to win 1 of 5 exclusive notebooks',
      description:
        'Target 100 meals to level up your streak. Reach Silver and you are entered to win 1 of 5 exclusive notebooks.',
      achieved_message:
        '100 meals logged! You are entered to win 1 of 5 exclusive notebooks. Keep going, 150 meals earns Gold.',
      level: 2,
      order: 2,
      max_progress: 100,
      initial_progress: 52,
      min_progress: 0,
      min_app_version: 300130000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 120,
      achievement_id: 30,
      workout_template_types: [],
      challenge: {
        id: 26,
        start_at: 1773644400000,
        end_at: 1781679599000,
        description:
          "Ready to power up your day?\r\n\r\nProtein is essential for energy, strength, and recovery. Hitting your daily protein target helps you crush your workouts, recover faster, and keeps your energy levels high all day long. Over the next 3 months, build healthy habits by fueling your body for success.\r\n\r\nHow it works:\r\n• Log It: Track your meals, drinks and snacks daily in the HiNote Life Food Journal.\r\n• Hit Your Target: Reach your personalized daily protein goal to make the day count.\r\n• Level Up: The more days you hit your target, the higher you climb! Can you reach Gold?\r\n\r\nWant to customize your targets? You can easily adjust your overall calorie goal or macro percentages, and your daily protein goal will update automatically. If you have a specific protein number in mind, simply enter your exact daily target in your Macro goals.\r\n\r\nReady to win? Join the challenge to enter our exclusive giveaway featuring a lineup of brand-new prizes that will be announced soon. Don't miss out on this opportunity to power up your day and claim exciting new rewards!\r\n\r\nLearn more at: app.hinote.com/challenge",
        title: 'Protein Power Up Challenge',
        subtitle: null,
        prize_description: 'Exclusive Prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 461868,
            imageable_type: 'App\\Challenge',
            imageable_id: 26,
            collection_name: 'challenge_image',
            name: 'uploads/protein-power-up-2026-challenge-image-v2@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/protein-power-up-2026-challenge-image-v2@3x.png',
          },
          {
            id: 461869,
            imageable_type: 'App\\Challenge',
            imageable_id: 26,
            collection_name: 'challenge_icon_image',
            name: 'uploads/challenge-badge-protein-power-up-2026-gold@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/challenge-badge-protein-power-up-2026-gold@3x.png',
          },
        ],
        achievement_id: 30,
      },
      unit: 'DAYS_WITH_PROTEIN_GOAL_REACHED',
      type: 'NUMBER',
      name: 'Protein Power Up\nSilver',
      enum_value: 'PROTEIN_POWER_UP_SILVER',
      display_unit: 'DAYS_WITH_PROTEIN_GOAL_REACHED',
      short_description: '45 Days meeting Protein Goal',
      description:
        'Consistent fueling brings serious results. Reach your protein target for 45 days to claim Silver and score an entry for brand-new prizes!',
      achieved_message:
        'Amazing effort! 45 days hitting your target unlocks Silver and another giveaway entry. Keep fueling your body right - next up: Gold!',
      level: 2,
      order: 2,
      max_progress: 45,
      initial_progress: 20,
      min_progress: 0,
      min_app_version: 300150000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 1,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Journey Begins',
      enum_value: 'JOURNEY_BEGINS',
      display_unit: 'WORKOUTS',
      short_description: '5 activities',
      description: 'Complete 5 activities',
      achieved_message:
        'Great work, your hard work paid off! Congrats on starting your journey with five HiNote Life activities. Keep it going!',
      level: 1,
      order: 3,
      max_progress: 5,
      initial_progress: 0,
      min_progress: 0,
      min_app_version: 100000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 14,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'Peterborough to Nashville',
      enum_value: 'PETERBOROUGH_TO_NASHVILLE',
      display_unit: 'MINUTES',
      short_description: '762 minutes',
      description: 'Work out for 762 minutes',
      achieved_message:
        'You have completed the journey from Peterborough, Canada to Nashville in 762 minutes.',
      level: 1,
      order: 3,
      max_progress: 45720,
      initial_progress: 29340,
      min_progress: 0,
      min_app_version: 100020000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 9,
      achievement_id: 3,
      workout_template_types: [],
      challenge: null,
      unit: 'CARDS',
      type: 'NUMBER',
      name: 'Blown Away',
      enum_value: 'BLOWN_AWAY',
      display_unit: 'CARDS',
      short_description: '5,200 cards',
      description: 'Complete 5,200 cards',
      achieved_message:
        'This one is special. 5,200 cards! You should be blown away by this achievement.',
      level: 3,
      order: 3,
      max_progress: 5200,
      initial_progress: 520,
      min_progress: 0,
      min_app_version: 100000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 22,
      achievement_id: 4,
      workout_template_types: [],
      challenge: {
        id: 1,
        start_at: 1630479600000,
        end_at: 1635663600000,
        description:
          'Get moving with BODYARMOR SportWater this fall! Kick-start a new routine or join us to keep you inspired on your fitness journey. We designed this fitness challenge for busy people like you who are "Made for More" because you do it all. It\'s simple, complete any workout in fit52, every exercise you complete is a card toward exclusive "Made for More achievements" and prizes.',
        title: 'BODYARMOR SportWater',
        subtitle: 'Made for More',
        prize_description: 'Challenge badges and BODYARMOR SportWater prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 138191,
            imageable_type: 'App\\Challenge',
            imageable_id: 1,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/xunyey8qxflsibdoieek',
            version: '1629377866',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 287, y: 0, width: 767, height: 438 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=767,trim.height=438,trim.left=287,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/xunyey8qxflsibdoieek/1629377866.png',
          },
          {
            id: 138192,
            imageable_type: 'App\\Challenge',
            imageable_id: 1,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/kfgk4bexlwxn6lm9qn5z',
            version: '1629377882',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 0, y: 0, width: 264, height: 195 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=264,trim.height=195,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/kfgk4bexlwxn6lm9qn5z/1629377882.png',
          },
        ],
        achievement_id: 4,
      },
      unit: 'CARDS',
      type: 'NUMBER',
      name: 'Made for More\n-Gold-',
      enum_value: 'MADE_FOR_MORE_GOLD',
      display_unit: 'CARDS',
      short_description: '1500 cards',
      description: 'Complete 1500 cards',
      achieved_message:
        'Congrats! You are all done with the Made for More challenge!',
      level: 3,
      order: 3,
      max_progress: 1500,
      initial_progress: 500,
      min_progress: 0,
      min_app_version: 200020000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 26,
      achievement_id: 6,
      workout_template_types: [],
      challenge: null,
      unit: 'WEEK_STREAK',
      type: 'NUMBER',
      name: 'Momentum',
      enum_value: 'MOMENTUM',
      display_unit: 'WEEK_STREAK',
      short_description: '20 week activity streak',
      description:
        'This tracks your longest all-time streak. Complete 20 weeks to unlock. Your current streak is shown on the Home Screen.',
      achieved_message: 'Look at your progress! 20 weeks! Way to go!',
      level: 3,
      order: 3,
      max_progress: 20,
      initial_progress: 5,
      min_progress: 0,
      min_app_version: 200030000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 32,
      achievement_id: 7,
      workout_template_types: [],
      challenge: {
        id: 3,
        start_at: 1641189600000,
        end_at: 1649141999000,
        description:
          'This year is all about building healthy habits... with the Commit to Fit Challenge designed to meet you where you are at. Bronze, Silver or Gold... strive towards your own personal goal and cheer on your friends on the Leaderboards. All sessions count towards exclusive rewards. Plus follow @fit52 on social for bonus prizes. What will you commit to in 2022?',
        title: 'BODYARMOR LYTE',
        subtitle: 'Commit to Fit Challenge',
        prize_description: 'Challenge badges and BODYARMOR prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 161887,
            imageable_type: 'App\\Challenge',
            imageable_id: 3,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/apcibwfzzh7ovpwrgf9s',
            version: '1638991065',
            folder: 'image',
            format: 'jpg',
            manipulations: { crop: { x: 223, y: 0, width: 858, height: 489 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=858,trim.height=489,trim.left=223,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/apcibwfzzh7ovpwrgf9s/1638991065.jpg',
          },
          {
            id: 161888,
            imageable_type: 'App\\Challenge',
            imageable_id: 3,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/rtwxssww3c4q8dtfu5tb',
            version: '1638991090',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 0, y: 0, width: 360, height: 360 } },
            user_id: 114975,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=360,trim.height=360,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/rtwxssww3c4q8dtfu5tb/1638991090.png',
          },
        ],
        achievement_id: 7,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Commit to Fit 2022\r\n-Gold-',
      enum_value: 'COMMIT_TO_FIT22_GOLD',
      display_unit: 'SESSIONS',
      short_description: '90 sessions => $50 CU Store Credit',
      description:
        'Complete 90 sessions to earn Gold in the Commit to Fit Challenge & receive $50 CU store credit!',
      achieved_message:
        'Wow! 90 sessions in 90 days. That is impressive! Check your email for your special reward of $50 CU Store Credit.',
      level: 3,
      order: 3,
      max_progress: 90,
      initial_progress: 52,
      min_progress: 0,
      min_app_version: 200040000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 35,
      achievement_id: 8,
      workout_template_types: [],
      challenge: {
        id: 4,
        start_at: 1654066801000,
        end_at: 1659337199000,
        description:
          'Stay active this summer with fit52! Every completed activity counts as an Active Day. Some days it might be a Flash Fit, others it could be a Full Workout. The more active days you achieve, the more chances you have to win one of 52 exclusive fit52 prize packs containing a workout towel, phone stand, journal & water bottle. More details at fit52.com/challenge.',
        title: 'Active Days of Summer',
        subtitle: null,
        prize_description: 'Challenge badges and fit52 prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 210226,
            imageable_type: 'App\\Challenge',
            imageable_id: 4,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/annjgau31nigtlcke5n7',
            version: '1652906445',
            folder: 'image',
            format: 'jpg',
            manipulations: { crop: { x: 2, y: 0, width: 1239, height: 706 } },
            user_id: 397939,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=1239,trim.height=706,trim.left=2,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/annjgau31nigtlcke5n7/1652906445.jpg',
          },
          {
            id: 210227,
            imageable_type: 'App\\Challenge',
            imageable_id: 4,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/osziliasas2lhtj40qrm',
            version: '1652906455',
            folder: 'image',
            format: 'png',
            manipulations: { crop: { x: 0, y: 0, width: 300, height: 300 } },
            user_id: 397939,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto,trim.width=300,trim.height=300,trim.left=0,trim.top=0/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/osziliasas2lhtj40qrm/1652906455.png',
          },
        ],
        achievement_id: 8,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Active Days of Summer\r\n-Gold-',
      enum_value: 'ACTIVE_DAYS_OF_SUMMER_GOLD',
      display_unit: 'DAYS_ACTIVE',
      short_description: '52 Active Days => 10 Entries',
      description:
        'Be active for 52 days in the Active Days of Summer Challenge & receive 3 months free HiNote Life!',
      achieved_message:
        'Amazing!! You truly are living the HiNote Life. 52 active days! Keep an eye on your emails for the winners of the exclusive HiNote Life prizes.',
      level: 3,
      order: 3,
      max_progress: 52,
      initial_progress: 40,
      min_progress: 0,
      min_app_version: 200060000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 38,
      achievement_id: 9,
      workout_template_types: [],
      challenge: {
        id: 5,
        start_at: 1662015601000,
        end_at: 1667285999000,
        description:
          'With fit52 the "Clock Don\'t Stop"! You may know the song, but can you unlock the rewards? All fit52 activities count. The more you do, the more time on the clock! Start with 100 mins to get a free friend membership, or 418 mins to get access to a live workout with Eve. Or go for Gold and get free fit52 minibands. Learn more at: fit52.com/official-challenge-rules-regulations.',
        title: "Clock Don't Stop ⏱️",
        subtitle: null,
        prize_description:
          'Free Friend Memberships, Live Workouts & fit52 Minibands!',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 232546,
            imageable_type: 'App\\Challenge',
            imageable_id: 5,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-ClockDontStop_Card',
            version: '1658261807',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-ClockDontStop_Card/1658261807.jpg',
          },
          {
            id: 232547,
            imageable_type: 'App\\Challenge',
            imageable_id: 5,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-ClockDontStop_Badge',
            version: '1659134865',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-ClockDontStop_Badge/1659134865.png',
          },
        ],
        achievement_id: 9,
      },
      unit: 'MINUTES',
      type: 'TIME',
      name: "Clock Don't Stop ⏱️\r\n-Gold-",
      enum_value: 'CLOCK_DONT_STOP_GOLD',
      display_unit: 'MINUTES',
      short_description: '1500 = Free exclusive Miniband',
      description:
        "Be active for 1500 minutes in the Clock Don't Stop Challenge & receive free exclusive minibands!",
      achieved_message:
        'Amazing effort! Check your inbox for more info on your FREE exclusive minibands.',
      level: 3,
      order: 3,
      max_progress: 90000,
      initial_progress: 25080,
      min_progress: 0,
      min_app_version: 200070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 41,
      achievement_id: 10,
      workout_template_types: [],
      challenge: {
        id: 6,
        start_at: 1667286001000,
        end_at: 1671436799000,
        description:
          'This challenge is all about eating healthy! Follow a fit52 recipe or get creative with a meal of your own, then share the photo with the fit52 fam. Every healthy meal shared counts towards the challenge goals. Max 3 meals shared per day. Looking for more healthy eating guidance? Visit caraclarknutrition.com.',
        title: 'Healthy Through The Holidays',
        subtitle: null,
        prize_description: 'Nutrition Tips, Food Logs & Meal Plans',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 244159,
            imageable_type: 'App\\Challenge',
            imageable_id: 6,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-HealthyThroughTheHolidays_Card',
            version: '1662757646',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-HealthyThroughTheHolidays_Card/1662757646.jpg',
          },
          {
            id: 244160,
            imageable_type: 'App\\Challenge',
            imageable_id: 6,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-HealthyThroughTheHolidays_Badge',
            version: '1662757646',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-HealthyThroughTheHolidays_Badge/1662757646.png',
          },
        ],
        achievement_id: 10,
      },
      unit: 'MEALS',
      type: 'NUMBER',
      name: 'Healthy Through The Holidays\n-Gold-',
      enum_value: 'HEALTHY_THROUGH_THE_HOLIDAYS_GOLD',
      display_unit: 'MEALS',
      short_description: '30 Meals = Exclusive Meal Plan',
      description:
        'Share Photos of 30 Healthy Meals to HiNote Life and recieve an exclusive meal plan!',
      achieved_message:
        'You got Gold! 30 healthy meals shared, unlocking your exclusive meal plan! Check your email for details.',
      level: 3,
      order: 3,
      max_progress: 30,
      initial_progress: 20,
      min_progress: 0,
      min_app_version: 200080000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 44,
      achievement_id: 11,
      workout_template_types: [],
      challenge: {
        id: 7,
        start_at: 1672560000000,
        end_at: 1677657599000,
        description:
          'Let’s start 2023 by being active! Every fit52 activity completed counts as an Active Day. It could be a Stretch, a Flash Fit, or a Full Workout. Do what works best for you and mix it up each day to build healthy habits. The more active days you achieve, the more chances you have of winning exclusive fit52 prizes, including signed fit52 Yoga Mats from Carrie & Eve! More info: fit52.com/challenge.',
        title: 'Be Active in 2023',
        subtitle: null,
        prize_description: 'fit52 Jump Ropes, Water Bottles & Signed Yoga Mats',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264613,
            imageable_type: 'App\\Challenge',
            imageable_id: 7,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-ActiveDays__Challenge1.76_3x',
            version: '1667859855',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-ActiveDays__Challenge1.76_3x/1667859855.jpg',
          },
          {
            id: 264614,
            imageable_type: 'App\\Challenge',
            imageable_id: 7,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-BeActive2023_Black_3x',
            version: '1667863490',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-BeActive2023_Black_3x/1667863490.png',
          },
        ],
        achievement_id: 11,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Be Active in 2023\r\n-Gold-',
      enum_value: 'ACTIVE_DAYS_2023_GOLD',
      display_unit: 'DAYS_ACTIVE',
      short_description: '52 Days = Entry to win signed Yoga Mats',
      description:
        'Complete 52 Active Days to unlock an entry to win exclusive yoga mats signed by Carrie & Eve!',
      achieved_message:
        'You did it! 52 Active Days. Great start to 2023. You are now entered to win an exclusive yoga mat signed by Carrie and Eve! ',
      level: 3,
      order: 3,
      max_progress: 52,
      initial_progress: 25,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 47,
      achievement_id: 12,
      workout_template_types: [
        'FLASH_FIT_UPPER_BODY',
        'FLASH_FIT_LOWER_BODY',
        'FLASH_FIT_CORE',
        'FLASH_FIT_CARDIO',
        'GENERATOR_15',
        'GENERATOR_30',
        'GENERATOR_45',
      ],
      challenge: {
        id: 8,
        start_at: null,
        end_at: null,
        description:
          'This ‘Fit in a Flash’ is designed to get you moving in short, targeted workouts. This 30 day challenge you can start at anytime. Flash Fit’s are targeted workouts with 13 cards, that can be done in 15 mins or less.  Start your Flash Fit from the Workout screen under ‘Featured Workouts’. Challenge your friends and see how many you can do to unlock Fit in a Flash achievements! All Flash Fit’s count.',
        title: 'Fit in a Flash',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264615,
            imageable_type: 'App\\Challenge',
            imageable_id: 8,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-FitInAFlash__Challenge1.76_3x',
            version: '1667859863',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FitInAFlash__Challenge1.76_3x/1667859863.jpg',
          },
          {
            id: 264616,
            imageable_type: 'App\\Challenge',
            imageable_id: 8,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-FitInAFlash_Black_3x',
            version: '1667863522',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FitInAFlash_Black_3x/1667863522.png',
          },
        ],
        achievement_id: 12,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Fit in a Flash\r\n-Gold-',
      enum_value: 'FIT_IN_A_FLASH_GOLD',
      display_unit: 'WORKOUTS',
      short_description: '25 Flash Fits',
      description:
        'Complete 25 Flash Fits in 30 days to achieve Gold in this challenge.',
      achieved_message:
        'Wow! That was impressive. 25 Flash Fits in 30 days. Way to conquer this challenge.',
      level: 3,
      order: 3,
      max_progress: 25,
      initial_progress: 15,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 50,
      achievement_id: 13,
      workout_template_types: [
        'RECOVER_STRETCH_FULL_BODY_FLOW',
        'RECOVER_STRETCH_ENERGY_BOOSTER',
        'RECOVER_STRETCH_REVIVE_RECOVER',
        'RECOVER_STRETCH_HIPS_LEGS',
        'RECOVER_STRETCH_YOGA_FLOW',
        'RECOVER_STRETCH_WIND_DOWN',
        'DAILY_5_STRETCH',
        'DAILY_5_SEATED_STRETCH',
        'RECOVER_STRETCH_BACK_CHEST_FOAM_ROLLER',
        'RECOVER_STRETCH_LOWER_BODY_FOAM_ROLLER',
      ],
      challenge: {
        id: 9,
        start_at: null,
        end_at: null,
        description:
          'Feeling the need to Stretch? Then this 30 day challenge is perfect for you. You can start this challenge anytime, and have 30 days to ‘Stretch it Out’. Any stretch, yoga, or foam rolling sessions in HiNote Life count towards these challenge goals. Focus on building a regular stretching routine, or add a recovery session to complement your workouts. See how many stretch or recovery sessions you can do in 30 days, plus you can always repeat this challenge if you need to ‘Stretch it Out’ further.',
        title: 'Stretch it Out',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264617,
            imageable_type: 'App\\Challenge',
            imageable_id: 9,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-StretchItOut__Challenge1.76_3x',
            version: '1667859855',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-StretchItOut__Challenge1.76_3x/1667859855.jpg',
          },
          {
            id: 264618,
            imageable_type: 'App\\Challenge',
            imageable_id: 9,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-StretchItOut_Black_3x',
            version: '1667863552',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-StretchItOut_Black_3x/1667863552.png',
          },
        ],
        achievement_id: 13,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Stretch it Out\r\n-Gold-',
      enum_value: 'STRETCH_IT_OUT_GOLD',
      display_unit: 'WORKOUTS',
      short_description: '30 Stretch or Recovery Sessions',
      description:
        'Complete 30 Stretch or Recovery Sessions in 30 days to unlock this Gold challenge achievement.',
      achieved_message:
        'Way to build a stretching habit! You’ve shown what you can do in 30 days, keep it going!',
      level: 3,
      order: 3,
      max_progress: 30,
      initial_progress: 20,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 53,
      achievement_id: 14,
      workout_template_types: [
        'DAILY_5_MOVE',
        'DAILY_5_STRETCH',
        'DAILY_5_SEATED_STRETCH',
      ],
      challenge: {
        id: 10,
        start_at: null,
        end_at: null,
        description:
          'This Daily Dose challenge is all about doing 5 exercises or stretches per day, getting in your Daily 5’s. You can start this challenge at any time, and see how many Daily 5’s you can complete in 30 days. All Daily 5’s, Move, Stretch and Seated Stretch count! Perfect if you are short on time, as these activities can be completed in 5 mins. Give it a try and get your Daily Dose of HiNote Life! Don’t forget to challenge your friends to see who can get the longest Daily Streak and achieve Gold!',
        title: 'Daily Dose',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264619,
            imageable_type: 'App\\Challenge',
            imageable_id: 10,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-DailyDose__Challenge1.76_3x',
            version: '1667859860',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-DailyDose__Challenge1.76_3x/1667859860.jpg',
          },
          {
            id: 264620,
            imageable_type: 'App\\Challenge',
            imageable_id: 10,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-DailyDose_Black_3x',
            version: '1667863508',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-DailyDose_Black_3x/1667863508.png',
          },
        ],
        achievement_id: 14,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Daily Dose\r\n-Gold-',
      enum_value: 'DAILY_DOSE_GOLD',
      display_unit: 'WORKOUTS',
      short_description: '30 Daily 5’s',
      description:
        'You are on your way to Gold. 30 Daily 5’s completes this challenge!',
      achieved_message:
        "Impressive! 30 Daily 5’s in 30 days! Share this Reward, be proud of what you've achieved!",
      level: 3,
      order: 3,
      max_progress: 30,
      initial_progress: 20,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 56,
      achievement_id: 15,
      workout_template_types: [
        'HALF',
        'FULL',
        'CARD_DRAW_13',
        'LADDER',
        'ALL_FAVORITE_SEGMENTS',
        'CARRIE_FAVORITE_SEGMENTS',
        'EVE_FAVORITE_SEGMENTS',
        'GENERATOR_15',
        'GENERATOR_30',
        'GENERATOR_45',
        'DENIM_AND_RHINESTONES',
      ],
      challenge: {
        id: 11,
        start_at: null,
        end_at: null,
        description:
          'The Full Body Fun challenge is just what the name suggests, all about full body workouts and having fun! You could do 13 card draws, or step up to half or full workouts. As long as you are working out your entire body, it counts towards these challenge goals. Your path workouts also count!  See how many full body workouts you can do in the 30 days and most importantly, have fun!',
        title: 'Full Body Fun',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 264621,
            imageable_type: 'App\\Challenge',
            imageable_id: 11,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-FullBodyFun__Challenge1.76_3x',
            version: '1667859866',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FullBodyFun__Challenge1.76_3x/1667859866.jpg',
          },
          {
            id: 264622,
            imageable_type: 'App\\Challenge',
            imageable_id: 11,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-FullBodyFun_Black_3x',
            version: '1667863536',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FullBodyFun_Black_3x/1667863536.png',
          },
        ],
        achievement_id: 15,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Full Body Fun\r\n-Gold-',
      enum_value: 'FULL_BODY_FUN_GOLD',
      display_unit: 'WORKOUTS',
      short_description: '25 of Any Full Body Workout',
      description:
        '25 Full Body Workouts to Unlock Gold in this challenge. You are on your way!',
      achieved_message:
        '25 Full Body Workouts done! Bet that felt good. What challenge will you do next?',
      level: 3,
      order: 3,
      max_progress: 25,
      initial_progress: 15,
      min_progress: 0,
      min_app_version: 300000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 59,
      achievement_id: 16,
      workout_template_types: [],
      challenge: {
        id: 12,
        start_at: 1677657600000,
        end_at: 1681722000000,
        description:
          "Carrie and Eve. SportWater and LYTE. You and your workout bestie. What makes the perfect duo?\r\n\r\nThe BODYARMOR Duo Challenge is all about challenging yourself and a friend to form a duo and smash your workout goals together. Invite your friends or favorite a member of the fit52fam! Hit the challenge achievements and both you and your workout partner enter to win 1 month's supply of BODYARMOR LYTE and SportWater (US only). Max 2 workouts count each day toward challenge goals.\r\n\r\nStay hydrated with bit.ly/DrinkBODYARMOR",
        title: 'BODYARMOR Duo',
        subtitle: null,
        prize_description: 'BODYARMOR prizes for you and your Duo',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 287669,
            imageable_type: 'App\\Challenge',
            imageable_id: 12,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-BADuo__Challenge1.76_3x',
            version: '1676332613',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-BADuo__Challenge1.76_3x/1676332613.jpg',
          },
          {
            id: 287670,
            imageable_type: 'App\\Challenge',
            imageable_id: 12,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-BAduo_Black_3x',
            version: '1676332598',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-BAduo_Black_3x/1676332598.png',
          },
        ],
        achievement_id: 16,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'BODYARMOR Duo\n-Gold-',
      enum_value: 'BA_DUO_GOLD',
      display_unit: 'WORKOUTS',
      short_description: '52 Workouts - 5 entries',
      description:
        '52 Workouts to achieve Gold. This unlocks your chance to win exclusive BODYARMOR prizes for you and a friend.',
      achieved_message:
        'Well done! You got Gold! You’ve earned an entry to win a BODYARMOR Prize Pack for you and a friend. What a Duo!',
      level: 3,
      order: 3,
      max_progress: 52,
      initial_progress: 25,
      min_progress: 0,
      min_app_version: 300000003,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 62,
      achievement_id: 17,
      workout_template_types: [],
      challenge: {
        id: 13,
        start_at: 1699862400000,
        end_at: 1703275199000,
        description:
          'Get in shape this fall! Finish Flash Fits to win entries for a chance to get one of ten exclusive prize packs valued at $240 from the Official Carrie Underwood Store. Packs include a signed Denim & Rhinestones Deluxe Picture Disc Vinyl - signed by Carrie herself!! Every Flash Fit adds to Challenge achievements, max 3 daily. Details at fit52.com/challenge.',
        title: 'Get Fit this Fall 🍁',
        subtitle: null,
        prize_description: 'Win Official Carrie Underwood Store Prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 339199,
            imageable_type: 'App\\Challenge',
            imageable_id: 13,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-FlashFitFall__Challenge1.76_3x',
            version: '1697129640',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FlashFitFall__Challenge1.76_3x/1697129640.jpg',
          },
          {
            id: 339200,
            imageable_type: 'App\\Challenge',
            imageable_id: 13,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-FlashFitFall_Black_3x',
            version: '1697129641',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-FlashFitFall_Black_3x/1697129641.png',
          },
        ],
        achievement_id: 17,
      },
      unit: 'FLASH_FITS',
      type: 'NUMBER',
      name: 'Flash Fit Fall\r\nGold',
      enum_value: 'GET_FIT_FALL_GOLD',
      display_unit: 'FLASH_FITS',
      short_description: '30 Flash Fits - 3 entries',
      description:
        'By achieving gold you will receive maximum entries into the draw to win exclusive Carrie Underwood prize packs!',
      achieved_message:
        'Gold! You truly are a champion! Good luck in the draw to win exclusive Carrie Underwood prize packs!',
      level: 3,
      order: 3,
      max_progress: 30,
      initial_progress: 15,
      min_progress: 0,
      min_app_version: 300010000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 65,
      achievement_id: 18,
      workout_template_types: [],
      challenge: {
        id: 14,
        start_at: null,
        end_at: null,
        description:
          "Join the '30-Day Shape Up' challenge! Be active daily to earn Bronze, Silver, or Gold achievements. Transform in just a month, start anytime, all completed workouts count! Let's get fit together in 30 days!",
        title: '30-Day Shape Up',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 339201,
            imageable_type: 'App\\Challenge',
            imageable_id: 14,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-30DayShapeUp__Challenge1.76_3x',
            version: '1696443839',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-30DayShapeUp__Challenge1.76_3x/1696443839.jpg',
          },
          {
            id: 339202,
            imageable_type: 'App\\Challenge',
            imageable_id: 14,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-30DayShapeUp_Black_3x',
            version: '1696443850',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-30DayShapeUp_Black_3x/1696443850.png',
          },
        ],
        achievement_id: 18,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: '30 Day Shape Up\nGold',
      enum_value: 'SHAPE_UP_GOLD',
      display_unit: 'DAYS_ACTIVE',
      short_description: '30 Active Days',
      description:
        'Gold would be a fantastic achievement! Can you unlock 30 active days in 30 days?',
      achieved_message:
        'Gold! Huge effort. 30 active days in 30 days! Share this and be proud!',
      level: 3,
      order: 3,
      max_progress: 30,
      initial_progress: 15,
      min_progress: 0,
      min_app_version: 300010000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 68,
      achievement_id: 19,
      workout_template_types: [],
      challenge: {
        id: 15,
        start_at: null,
        end_at: null,
        description:
          "Embark on the '100 reps a Day' challenge! Crush 100 card reps daily for Bronze, Silver or Gold goals. Transform your strength and endurance. Regardless of how many you can achieve, max 100 reps (from card based workouts) count towards challenge goals. Give it a try and see how many days you can do 100 reps!",
        title: '100 Reps a Day',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 339203,
            imageable_type: 'App\\Challenge',
            imageable_id: 15,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/NoLimits__Challenge1.76_3x',
            version: '1696443729',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/NoLimits__Challenge1.76_3x/1696443729.jpg',
          },
          {
            id: 339204,
            imageable_type: 'App\\Challenge',
            imageable_id: 15,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-100RepsADay_Black_3x',
            version: '1696443820',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-100RepsADay_Black_3x/1696443820.png',
          },
        ],
        achievement_id: 19,
      },
      unit: 'REPS',
      type: 'NUMBER',
      name: '100 Reps a Day\nGold',
      enum_value: 'REPS_A_DAY_GOLD',
      display_unit: 'REPS',
      short_description: '30 days with 100 Reps',
      description:
        'By hitting 100 reps a day for 30 days, you will prove to yourself that you can build a healthy fitness habit. Go you!',
      achieved_message:
        'What an effort!! 30 days in a row with 100 reps. You should be totally proud of yourself!',
      level: 3,
      order: 3,
      max_progress: 3000,
      initial_progress: 2400,
      min_progress: 0,
      min_app_version: 300010000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 71,
      achievement_id: 20,
      workout_template_types: [],
      challenge: {
        id: 16,
        start_at: 1704096000000,
        end_at: 1707076799000,
        description:
          'Kickstart 2024 with the fit52 5x2 Challenge! Aim for 5 weeks with 2 workouts per week. Can you do more? Stay on track and you could win one of 24 fit52 phone stands! Max 1 workout per day counts towards challenge. More details at fit52.com/challenge. Make 2024 your best year with a fresh start to fitness!',
        title: '5x2 - Fresh Start for 2024',
        subtitle: null,
        prize_description: 'Win 1 of 24 exclusive fit52 phone stands',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 344834,
            imageable_type: 'App\\Challenge',
            imageable_id: 16,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-5x2__Challenge1.76_3x',
            version: '1701081278',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-5x2__Challenge1.76_3x/1701081278.jpg',
          },
          {
            id: 344835,
            imageable_type: 'App\\Challenge',
            imageable_id: 16,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-5x2_Black_3x',
            version: '1701081209',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-5x2_Black_3x/1701081209.png',
          },
        ],
        achievement_id: 20,
      },
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: '5X2 for 2024\nGold',
      enum_value: 'FRESH_START_GOLD',
      display_unit: 'WORKOUTS',
      short_description: '20 Workouts - 3 Entries',
      description:
        'Earning Gold for the 5x2 challenge will kickstart your 2024 with consistency. Plus you will be entered to win exclusive prizes!',
      achieved_message:
        'Gold! You have started 2024 with a bang! Keep the momentum going and best of luck in the draw to win exclusive prizes!',
      level: 3,
      order: 3,
      max_progress: 20,
      initial_progress: 15,
      min_progress: 0,
      min_app_version: 300020000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 78,
      achievement_id: 21,
      workout_template_types: [],
      challenge: {
        id: 17,
        start_at: 1711090801000,
        end_at: 1715669999000,
        description:
          'Get your stretch on this Spring with the fit52 Spring Stretch Challenge! Aim for 10 Stretch & Recovery Sessions to achieve Bronze. Keep up the momentum and you might be the lucky winner of a exclusive 1:1 virtual workout with Eve! All completed Stretch & Recovery sessions count. Discover more at fit52.com/challenge. Start the season with the Spring Stretch Challenge!',
        title: 'Spring Stretch 2024',
        subtitle: null,
        prize_description: 'Win 1:1 Virtual fit52 Workout with Eve!',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 359013,
            imageable_type: 'App\\Challenge',
            imageable_id: 17,
            collection_name: 'challenge_image',
            name: 'fit52/ugc/Challenge-SpringStretch__Challenge1.76_3x',
            version: '1705333396',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-SpringStretch__Challenge1.76_3x/1705333396.jpg',
          },
          {
            id: 359014,
            imageable_type: 'App\\Challenge',
            imageable_id: 17,
            collection_name: 'challenge_icon_image',
            name: 'fit52/ugc/Challenge-SpringStretch_Black_3x',
            version: '1705333379',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://fit52-ugc-us-east-1.s3.amazonaws.com/res/m56-studios/image/upload/fit52/ugc/Challenge-SpringStretch_Black_3x/1705333379.png',
          },
        ],
        achievement_id: 21,
      },
      unit: 'STRETCH_SESSIONS',
      type: 'NUMBER',
      name: 'Spring Stretch 2024\nGold',
      enum_value: 'SPRING_STRETCH_GOLD',
      display_unit: 'STRETCH_SESSIONS',
      short_description: '50 Stretch Sessions - 3 Entries',
      description:
        'Achieve gold and 3x your opportunities to win an exclusive virtual workout with Eve Overland',
      achieved_message:
        'Gold Triumph! You’ve reached the pinnacle of success, securing Gold. Your dedication and skill are truly inspiring. Keep shining!',
      level: 3,
      order: 3,
      max_progress: 50,
      initial_progress: 25,
      min_progress: 0,
      min_app_version: 300030000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 81,
      achievement_id: 22,
      workout_template_types: [],
      challenge: {
        id: 18,
        start_at: 1722841200000,
        end_at: 1725908399000,
        description:
          'Build a fitness habit with fit52 and the 5 Weeks to Fit challenge. Perfect if you are just getting started or back into fitness. Take it one day at a time, turn gradual progress into a habit that lasts.\r\n\r\nEvery workout you complete counts as an Active Day - and increases your chances to win exclusive fit52 prizes, including Notebooks, Caps and Gym Bags.\r\n\r\nDon’t miss out on this opportunity to boost your fitness and snag some awesome gear. Learn more at: fit52.com/challenge.',
        title: '5 Weeks To Fit',
        subtitle: null,
        prize_description: 'Challenge badges and fit52 prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 383455,
            imageable_type: 'App\\Challenge',
            imageable_id: 18,
            collection_name: 'challenge_image',
            name: 'uploads/Challenge-5WeeksToFit_Challenge1.76@3x.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/Challenge-5WeeksToFit_Challenge1.76@3x.jpeg',
          },
          {
            id: 383456,
            imageable_type: 'App\\Challenge',
            imageable_id: 18,
            collection_name: 'challenge_icon_image',
            name: 'uploads/Challenge-5WeeksToFit_Black@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/Challenge-5WeeksToFit_Black@3x.png',
          },
        ],
        achievement_id: 22,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: '5 Weeks To Fit\nGold',
      enum_value: 'FIVE_WEEKS_TO_FIT_GOLD',
      display_unit: 'DAYS_ACTIVE',
      short_description: 'Draw for 1 exclusive Gym Bag',
      description:
        '35 Days. 5 Weeks. That would be a huge achievement. Earn Gold and be entered to win an exclusive gym bag!',
      achieved_message:
        'You did it!  5 Weeks to Fit! Congratulations, you are entered to win an exclusive gym bag. Winners announced in September.',
      level: 3,
      order: 3,
      max_progress: 35,
      initial_progress: 25,
      min_progress: 0,
      min_app_version: 300050000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 100,
      achievement_id: 23,
      workout_template_types: [],
      challenge: {
        id: 19,
        start_at: 1741590000000,
        end_at: 1750186799000,
        description:
          'Ready to create lasting fitness habits? Join the fit52 Healthy Habits Challenge — designed to help you build a sustainable routine that you can continue well beyond this challenge.\r\n\r\nEvery workout or yoga session you complete in the app counts as an Active Day. Pick the activities that fit your lifestyle and get moving! Along the way, unlock challenge achievements.',
        title: 'Healthy Habits in 2025',
        subtitle: null,
        prize_description: 'fit52 Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 402378,
            imageable_type: 'App\\Challenge',
            imageable_id: 19,
            collection_name: 'challenge_image',
            name: 'uploads/healthy-habits-challenge-image@3x.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/healthy-habits-challenge-image@3x.jpeg',
          },
          {
            id: 402379,
            imageable_type: 'App\\Challenge',
            imageable_id: 19,
            collection_name: 'challenge_icon_image',
            name: 'uploads/healthy-habits-challenge-badge-black@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/healthy-habits-challenge-badge-black@3x.png',
          },
        ],
        achievement_id: 23,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Healthy Habits in 2025\nGold',
      enum_value: 'HEALTHY_HABITS_2025_GOLD',
      display_unit: 'DAYS_ACTIVE',
      short_description: 'Be active for 52 days',
      description: 'Can you do 52 days of healthy habits and unlock gold?',
      achieved_message:
        'You did it! 52 days of Fitness. You are off to a great start in 2025!',
      level: 3,
      order: 3,
      max_progress: 52,
      initial_progress: 35,
      min_progress: 0,
      min_app_version: 300090000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 103,
      achievement_id: 24,
      workout_template_types: [],
      challenge: {
        id: 20,
        start_at: 1735718400000,
        end_at: 1740254399000,
        description:
          "Fuel Your Best Self with the Nourish & Thrive in 2025 Challenge!\r\n\r\nTake charge of your nutrition and set yourself up for success in 2025 with the Nourish & Thrive Challenge. This challenge is perfect for anyone looking to build sustainable, healthy eating habits that last all year long.\r\n\r\nEvery meal you log in fit52 counts toward your challenge progress, bringing you one step closer to your goals! As you complete the challenge, you'll earn achievements and increase your chances to win exclusive nutrition prizes.\r\n\r\nReady to start thriving? Learn more at: fit52.com/challenge.",
        title: 'Nourish & Thrive in 2025',
        subtitle: null,
        prize_description: 'Nutrition Prizes & Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 402380,
            imageable_type: 'App\\Challenge',
            imageable_id: 20,
            collection_name: 'challenge_image',
            name: 'uploads/nourish-thrive-challenge-image@3x.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/nourish-thrive-challenge-image@3x.jpeg',
          },
          {
            id: 402381,
            imageable_type: 'App\\Challenge',
            imageable_id: 20,
            collection_name: 'challenge_icon_image',
            name: 'uploads/nourish-thrive-challenge-badge-black@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/nourish-thrive-challenge-badge-black@3x.png',
          },
        ],
        achievement_id: 24,
      },
      unit: 'MEALS_TRACKED',
      type: 'NUMBER',
      name: 'Nourish & Thrive in 2025\nGold',
      enum_value: 'NOURISH_AND_THRIVE_2025_GOLD',
      display_unit: 'MEALS_TRACKED',
      short_description:
        "Entry to win 1 of 3 signed edition of Carrie's Find Your Path book",
      description:
        'Log 100 meals and earn Gold! Plus you will enter the draw to win great Cara Clark Nutrition prizes!',
      achieved_message:
        'Amazing effort! You are entered to win more great prizes! Keep this healthy habit going throughout 2025!',
      level: 3,
      order: 3,
      max_progress: 100,
      initial_progress: 52,
      min_progress: 0,
      min_app_version: 300080000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 106,
      achievement_id: 25,
      workout_template_types: [],
      challenge: {
        id: 21,
        start_at: null,
        end_at: null,
        description:
          "Ready to sculpt strong, toned legs like Carrie Underwood? The 52 Days to Toned Legs Challenge is your ultimate guide to building strength, definition, and confidence in your legs and glutes. This challenge is designed to help you stay consistent with effective, lower body focused workouts that fit into any schedule.\n\nWhy join the Challenge?\nThis challenge is all about helping you:\n- Build strength and power in your legs.\n- Sculpt and tone your thighs, calves, and glutes for a lean, defined look.\n- Feel stronger and more confident with every workout.\n- Get closer to achieving legs like Carrie Underwood's with her proven workout routines!\n\nWhat Counts Towards this Challenge?\nEvery leg-focused workout in HiNote Life counts! Choose from:\n- Flash Fit: Legs\n- Carrie's Leg Workout\n- Lower Body Burn\n- Leg Day with Carrie and Eve\n\nEach completed workout counts toward your progress, so you can mix it up or stick with your favorites.",
        title: '52 Days to Toned Legs',
        subtitle: null,
        prize_description: 'HiNote Life Challenge Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 402382,
            imageable_type: 'App\\Challenge',
            imageable_id: 21,
            collection_name: 'challenge_image',
            name: 'uploads/toned-legs-challenge-image-updated3x.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/toned-legs-challenge-image-updated3x.jpeg',
          },
          {
            id: 402383,
            imageable_type: 'App\\Challenge',
            imageable_id: 21,
            collection_name: 'challenge_icon_image',
            name: 'uploads/toned-legs-challenge-badge-black3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/toned-legs-challenge-badge-black3x.png',
          },
        ],
        achievement_id: 25,
      },
      unit: 'LEG_WORKOUTS',
      type: 'NUMBER',
      name: '52 Days to Toned Legs\nGold',
      enum_value: 'FIFTY_TWO_DAYS_TO_TONED_LEGS_GOLD',
      display_unit: 'LEG_WORKOUTS',
      short_description: '35 Leg Workouts',
      description:
        'Can you complete 35 leg workouts? Unlock the Gold badge and achieve ultimate strength and definition—your toned legs are within reach!',
      achieved_message:
        "Amazing dedication! 35 leg workouts completed! Your strength and toned legs are a testament to your hard work - Congrats! You've earned this!",
      level: 3,
      order: 3,
      max_progress: 35,
      initial_progress: 20,
      min_progress: 0,
      min_app_version: 300080000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 109,
      achievement_id: 26,
      workout_template_types: [],
      challenge: {
        id: 22,
        start_at: 1735718400000,
        end_at: 1740297599000,
        description:
          'Ready to elevate your fitness in 2025? Join the Sweat, Sip & Win with BODYARMOR Challenge—where hydration fuels your drive to crush your 2025 goals - and to stay refreshed along the way.\r\n\r\nEvery workout, yoga or stretch session in the fit52 app counts as an Active Day towards challenge goals. Stay consistent with fit52, sip smart with BODYARMOR, and rack up those wins! Unlock achievements and boost your chances to score exclusive BODYARMOR & fit52 prizes.\r\n\r\nReady for even more? Combine this challenge with the Nourish & Thrive Nutrition Challenge to amplify your wellness journey and build habits that last.\r\n\r\nLearn more at: fit52.com/challenge',
        title: 'Sweat, Sip & Win with BODYARMOR',
        subtitle: null,
        prize_description: 'BODYARMOR Challenge Prizes & Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 402390,
            imageable_type: 'App\\Challenge',
            imageable_id: 22,
            collection_name: 'challenge_image',
            name: 'uploads/bodyarmor-2025.jpeg',
            version: '0',
            folder: 'image',
            format: 'jpg',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/bodyarmor-2025.jpeg',
          },
          {
            id: 402391,
            imageable_type: 'App\\Challenge',
            imageable_id: 22,
            collection_name: 'challenge_icon_image',
            name: 'uploads/bodyarmor-2025-badge-updated.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/bodyarmor-2025-badge-updated.png',
          },
        ],
        achievement_id: 26,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Sweat, Sip & Win with BODYARMOR\nGold',
      enum_value: 'SWEAT_SIP_WIN_BODYARMOR_GOLD',
      display_unit: 'DAYS_ACTIVE',
      short_description:
        'Entry to win a limited edition Guitar signed by Carrie Underwood',
      description:
        '52 Days in the Sweat, Sip & Win Challenge. That would be something! Unlock and be entered to win a guitar signed by Carrie!',
      achieved_message:
        "You did it! You've crushed the Sweat, Sip & Win challenge. You're entered to win a guitar signed by Carrie!",
      level: 3,
      order: 3,
      max_progress: 52,
      initial_progress: 35,
      min_progress: 0,
      min_app_version: 300080001,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 112,
      achievement_id: 27,
      workout_template_types: [],
      challenge: {
        id: 23,
        start_at: 1752562800000,
        end_at: 1758005999000,
        description:
          "Make the most of the season with sunshine, good vibes, and nourishing meals! The Healthy Eating, Summer Living Challenge rewards you for logging 2 or more meals a day. Win great prizes including fit52 notebooks, fit52 muscle tank tops, and fit52 aprons!\r\n\r\nNever tried the fit52 food journal? Now's your chance to jump in and see how easy it is to stay on track.\r\n\r\nEvery day you log 2 or more meals, you'll get closer to unlocking exclusive fit52 nutrition rewards.  A meal is either Breakfast, Lunch, Dinner or a Snack. Whether you're enjoying sunny strolls, weekend getaways, or simply juggling a busy summer routine, consistently logging your meals in the fit52 food journal helps you stay mindful, make smarter choices, and see real progress.\r\n\r\nEach of the Achievements earns entries to the draw to win exclusive fit52 prizes.\r\nBronze = Win 1 of 10 fit52 Notebooks.\r\nSilver = Win 1 of 5 fit52 Aprons.\r\nGold = Win 1 of 3 fit52 Muscle Tops.\r\n\r\nWant to take your summer wellness even further? Combine this with a fit52 workout challenge for a head-to-toe healthy season.\r\n\r\nLet's eat well and live fully - all summer long! Learn more at: fit52.com/challenge.",
        title: 'Healthy Eating, Summer Living',
        subtitle: null,
        prize_description: 'fit52 Nutrition Prizes & Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 431933,
            imageable_type: 'App\\Challenge',
            imageable_id: 23,
            collection_name: 'challenge_image',
            name: 'uploads/healthy-eating-2025-challenge-image@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/healthy-eating-2025-challenge-image@3x.png',
          },
          {
            id: 431934,
            imageable_type: 'App\\Challenge',
            imageable_id: 23,
            collection_name: 'challenge_icon_image',
            name: 'uploads/challenge-badge-healthy-eating-2025-gold@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/challenge-badge-healthy-eating-2025-gold@3x.png',
          },
        ],
        achievement_id: 27,
      },
      unit: 'DAYS_WITH_MEALS',
      type: 'NUMBER',
      name: 'Healthy Eating, Summer Living\nGold',
      enum_value: 'HEALTHY_EATING_SUMMER_LIVING_GOLD',
      display_unit: 'DAYS_WITH_MEALS',
      short_description: '45 Days with 2+ Meals',
      description:
        '45 days of healthy eating—can you go for Gold? Earn Gold  and secure your chance to win 1 of 3 exclusive muscle tops!',
      achieved_message:
        "You did it! 45 days of healthy eating this summer. You've built lasting habits and earned your entry to win 1 of 3 exclusive muscle tops!",
      level: 3,
      order: 3,
      max_progress: 45,
      initial_progress: 30,
      min_progress: 0,
      min_app_version: 300110001,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 115,
      achievement_id: 28,
      workout_template_types: [],
      challenge: {
        id: 24,
        start_at: 1767254400000,
        end_at: 1771747199000,
        description:
          'Start 2026 strong with the Move More in ’26 Challenge. Your job is to complete one Movement Day at a time. A Movement Day is any fit52 activity you do inside the app. Stretch. Workout. Yoga session. Flash Fit. Cardio, they all count.\r\n\r\nComplete your Movement Day and you move closer to unlocking fit52 achievements and earning perks like yoga mats, water bottles, and gym bags.\r\n\r\nThis is about building a daily movement habit, not chasing perfection. Join in, show up in the app, and start the year with consistency and the fit52 fam behind you.\r\n\r\nReady to make daily movement a habit? Join now and kick off the New Year with purpose, consistency, and the support of the fit52 fam.',
        title: 'Move More in 2026',
        subtitle: null,
        prize_description: 'Exclusive fit52 Prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 448672,
            imageable_type: 'App\\Challenge',
            imageable_id: 24,
            collection_name: 'challenge_image',
            name: 'uploads/move-more-in-2026-challenge-image-v2@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/move-more-in-2026-challenge-image-v2@3x.png',
          },
          {
            id: 448673,
            imageable_type: 'App\\Challenge',
            imageable_id: 24,
            collection_name: 'challenge_icon_image',
            name: 'uploads/challenge-badge-move-more-in-2026-gold@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/challenge-badge-move-more-in-2026-gold@3x.png',
          },
        ],
        achievement_id: 28,
      },
      unit: 'DAYS_ACTIVE',
      type: 'NUMBER',
      name: 'Move More in ‘26\nGold',
      enum_value: 'MOVE_MORE_IN_2026_GOLD',
      display_unit: 'DAYS_ACTIVE',
      short_description: '45 Movement Days = Entry to win a exclusive Yoga Mat',
      description:
        'Log 45 days with movement and earn Gold! Plus you will enter the draw to win a Yoga Mat!',
      achieved_message:
        'Well done! 45 movement days logged puts you in the running to win an exclusive Yoga Mat. Keep the momentum in 2026!',
      level: 3,
      order: 3,
      max_progress: 45,
      initial_progress: 26,
      min_progress: 0,
      min_app_version: 300130000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 118,
      achievement_id: 29,
      workout_template_types: [],
      challenge: {
        id: 25,
        start_at: 1767254400000,
        end_at: 1771747199000,
        description:
          'Fuel Your Best Self with the 52-Day Energy Reset in 2026 Challenge!\r\n\r\nTake charge of your nutrition and set yourself up for success in 2026 with the 52-Day Energy Reset Challenge. This challenge is perfect for anyone looking to build sustainable, healthy eating habits that last all year long.\r\n\r\nEvery meal you log in fit52 counts toward your challenge progress, bringing you one step closer to your goals! As you complete the challenge, you’ll earn achievements and increase your chances to win fit52 prizes.\r\n\r\nLooking for a full-body wellness approach? Pair this challenge with the fit52 Move More in 2026 Challenge for an unbeatable combination of fitness and nutrition.\r\n\r\nReady to start thriving? Learn more at: fit52.com/challenge.',
        title: '52-Day Energy Reset',
        subtitle: null,
        prize_description: 'fit52 Nutrition Prizes & Achievements',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 448674,
            imageable_type: 'App\\Challenge',
            imageable_id: 25,
            collection_name: 'challenge_image',
            name: 'uploads/52-day-energy-reset-2026-challenge-image-v2@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/52-day-energy-reset-2026-challenge-image-v2@3x.png',
          },
          {
            id: 448675,
            imageable_type: 'App\\Challenge',
            imageable_id: 25,
            collection_name: 'challenge_icon_image',
            name: 'uploads/challenge-badge-52-day-energy-reset-2026-gold-v2@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/challenge-badge-52-day-energy-reset-2026-gold-v2@3x.png',
          },
        ],
        achievement_id: 29,
      },
      unit: 'DAYS_WITH_MEALS_V2',
      type: 'NUMBER',
      name: '52 Day Energy Reset\nGold',
      enum_value: 'FIFTY_TWO_DAYS_ENERGY_RESET_2026_GOLD',
      display_unit: 'DAYS_WITH_MEALS_V2',
      short_description: '150 Meals = Entry to win 1 of 3 exclusive aprons',
      description:
        'Go for 150 meals to lock in Gold. Make it and you are entered to win 1 of 3 exclusive aprons.',
      achieved_message:
        'Gold level reached. 150 meals logged, entry secured for 1 of 3 exclusive aprons. Keep the habit going!',
      level: 3,
      order: 3,
      max_progress: 150,
      initial_progress: 100,
      min_progress: 0,
      min_app_version: 300130000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 121,
      achievement_id: 30,
      workout_template_types: [],
      challenge: {
        id: 26,
        start_at: 1773644400000,
        end_at: 1781679599000,
        description:
          "Ready to power up your day?\r\n\r\nProtein is essential for energy, strength, and recovery. Hitting your daily protein target helps you crush your workouts, recover faster, and keeps your energy levels high all day long. Over the next 3 months, build healthy habits by fueling your body for success.\r\n\r\nHow it works:\r\n• Log It: Track your meals, drinks and snacks daily in the HiNote Life Food Journal.\r\n• Hit Your Target: Reach your personalized daily protein goal to make the day count.\r\n• Level Up: The more days you hit your target, the higher you climb! Can you reach Gold?\r\n\r\nWant to customize your targets? You can easily adjust your overall calorie goal or macro percentages, and your daily protein goal will update automatically. If you have a specific protein number in mind, simply enter your exact daily target in your Macro goals.\r\n\r\nReady to win? Join the challenge to enter our exclusive giveaway featuring a lineup of brand-new prizes that will be announced soon. Don't miss out on this opportunity to power up your day and claim exciting new rewards!\r\n\r\nLearn more at: app.hinote.com/challenge",
        title: 'Protein Power Up Challenge',
        subtitle: null,
        prize_description: 'Exclusive Prizes',
        reference_text: null,
        reference_link: null,
        images: [
          {
            id: 461868,
            imageable_type: 'App\\Challenge',
            imageable_id: 26,
            collection_name: 'challenge_image',
            name: 'uploads/protein-power-up-2026-challenge-image-v2@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/protein-power-up-2026-challenge-image-v2@3x.png',
          },
          {
            id: 461869,
            imageable_type: 'App\\Challenge',
            imageable_id: 26,
            collection_name: 'challenge_icon_image',
            name: 'uploads/challenge-badge-protein-power-up-2026-gold@3x.png',
            version: '0',
            folder: 'image',
            format: 'png',
            manipulations: null,
            user_id: null,
            url: 'https://fit52.co/cdn-cgi/image/quality=85,format=auto/https://dm59aq7ed9v8.cloudfront.net/uploads/challenge-badge-protein-power-up-2026-gold@3x.png',
          },
        ],
        achievement_id: 30,
      },
      unit: 'DAYS_WITH_PROTEIN_GOAL_REACHED',
      type: 'NUMBER',
      name: 'Protein Power Up\nGold',
      enum_value: 'PROTEIN_POWER_UP_GOLD',
      display_unit: 'DAYS_WITH_PROTEIN_GOAL_REACHED',
      short_description: '75 Days meeting Protein Goal',
      description:
        'Go for the ultimate goal! Hit your protein target for 75 days to unlock Gold and earn an entry into our exclusive giveaway.',
      achieved_message:
        'You did it! 75 days of hitting your targets. You’ve unlocked Gold, built incredible habits, and earned your achievement!',
      level: 3,
      order: 3,
      max_progress: 75,
      initial_progress: 45,
      min_progress: 0,
      min_app_version: 300150000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 12,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Fisher',
      enum_value: 'FISHER',
      display_unit: 'WORKOUTS',
      short_description: '20 activities',
      description: 'Complete 20 activities',
      achieved_message:
        'Did you know? Starting in her hometown Checotah, it takes Carrie 20ish hours to visit Mike in Peterborough, Canada.',
      level: 2,
      order: 4,
      max_progress: 20,
      initial_progress: 5,
      min_progress: 0,
      min_app_version: 100020000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 3,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'Clock Don’t Stop',
      enum_value: 'CLOCK_DONT_STOP',
      display_unit: 'HOURS',
      short_description: '25 hours',
      description: 'Work out for 25 hours',
      achieved_message:
        'Now that’s impressive! You have put in more than 24 hours of HiNote Life workouts. Respect!',
      level: 2,
      order: 4,
      max_progress: 90000,
      initial_progress: 18000,
      min_progress: 0,
      min_app_version: 100000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 10,
      achievement_id: 3,
      workout_template_types: [],
      challenge: null,
      unit: 'CARDS',
      type: 'NUMBER',
      name: 'Superstar',
      enum_value: 'SUPERSTAR',
      display_unit: 'CARDS',
      short_description: '25,000 cards',
      description: 'Complete 25,000 cards',
      achieved_message:
        'Wow. So many cards. So many exercises. That has to be worth sharing :)',
      level: 4,
      order: 4,
      max_progress: 25000,
      initial_progress: 5200,
      min_progress: 0,
      min_app_version: 100000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 27,
      achievement_id: 6,
      workout_template_types: [],
      challenge: null,
      unit: 'WEEK_STREAK',
      type: 'NUMBER',
      name: '52 Weeks of HiNote Life',
      enum_value: '52_WEEKS_OF_FIT52',
      display_unit: 'WEEK_STREAK',
      short_description: '52 week activity streak',
      description:
        'This tracks your longest all-time streak. Complete 52 weeks to unlock. Your current streak is shown on the Home Screen.',
      achieved_message:
        'We are so proud of you! 52 week streak!! You truly are living your best HiNote Life.',
      level: 4,
      order: 4,
      max_progress: 52,
      initial_progress: 20,
      min_progress: 0,
      min_app_version: 200030000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 89,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Fit Start',
      enum_value: 'FIT_START',
      display_unit: 'WORKOUTS',
      short_description: '52 activities',
      description: 'Complete 52 activities',
      achieved_message:
        "Great job! You've completed 52 activities. You're off to a strong start on your fitness journey!",
      level: 5,
      order: 5,
      max_progress: 52,
      initial_progress: 20,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 15,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: '1983',
      enum_value: '1983',
      display_unit: 'MINUTES',
      short_description: '1,983 minutes',
      description: 'Work out for 1,983 minutes',
      achieved_message:
        "Stunning. 1983 brought us Carrie. You've just worked out for a total of 1,983 minutes. Coincidence?",
      level: 3,
      order: 5,
      max_progress: 118980,
      initial_progress: 90000,
      min_progress: 0,
      min_app_version: 100020000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 11,
      achievement_id: 3,
      workout_template_types: [],
      challenge: null,
      unit: 'CARDS',
      type: 'NUMBER',
      name: 'Platinum Record',
      enum_value: 'PLATINUM_RECORD',
      display_unit: 'CARDS',
      short_description: '52,000 cards',
      description: 'Complete 52,000 cards',
      achieved_message:
        'Amazing! 52,000 cards. Over 1,000 workouts. That is some serious sweat! This record should be certified platinum.',
      level: 5,
      order: 5,
      max_progress: 52000,
      initial_progress: 25000,
      min_progress: 0,
      min_app_version: 100000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 28,
      achievement_id: 6,
      workout_template_types: [],
      challenge: null,
      unit: 'WEEK_STREAK',
      type: 'NUMBER',
      name: '2 Years of HiNote Life',
      enum_value: '2_YEARS_OF_FIT52',
      display_unit: 'WEEK_STREAK',
      short_description: '104 week activity streak',
      description:
        'This tracks your longest all-time streak. Complete 104 weeks to unlock. Your current streak is shown on the Home Screen.',
      achieved_message:
        'Incredible. 2 whole years of HiNote Life, every single week. You are an inspiration to the HiNote Life community!',
      level: 5,
      order: 5,
      max_progress: 104,
      initial_progress: 52,
      min_progress: 0,
      min_app_version: 200030000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 90,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Century Circuit',
      enum_value: 'CENTURY_CIRCUIT',
      display_unit: 'WORKOUTS',
      short_description: '100 activities',
      description: 'Complete 100 activities',
      achieved_message:
        "Great work! 100 activities completed. You've mastered the Century Circuit. Keep the momentum going",
      level: 6,
      order: 6,
      max_progress: 100,
      initial_progress: 52,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 16,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'Jacob',
      enum_value: 'JACOB',
      display_unit: 'MINUTES',
      short_description: '2,019 minutes',
      description: 'Work out for 2,019 minutes',
      achieved_message:
        "You've completed 2,019 minutes. 2019 is the year Carrie became a mother of two.",
      level: 3,
      order: 6,
      max_progress: 121140,
      initial_progress: 118980,
      min_progress: 0,
      min_app_version: 100020000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 17,
      achievement_id: 3,
      workout_template_types: [],
      challenge: null,
      unit: 'CARDS',
      type: 'NUMBER',
      name: 'Double Platinum',
      enum_value: 'DOUBLE_PLATINUM',
      display_unit: 'CARDS',
      short_description: '200,000 cards',
      description: 'Complete 200,000 cards',
      achieved_message:
        "Certified double platinum! You've officially completed 200,000 cards.",
      level: 6,
      order: 6,
      max_progress: 200000,
      initial_progress: 52000,
      min_progress: 0,
      min_app_version: 100020000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 29,
      achievement_id: 6,
      workout_template_types: [],
      challenge: null,
      unit: 'WEEK_STREAK',
      type: 'NUMBER',
      name: '3 Years of HiNote Life',
      enum_value: '3_YEARS_OF_FIT52',
      display_unit: 'WEEK_STREAK',
      short_description: '156 week activity streak',
      description:
        'This tracks your longest all-time streak. Complete 156 weeks to unlock. Your current streak is shown on the Home Screen.',
      achieved_message:
        '3 Years. Way to show up! Check your email for details of your exclusive fit52 reward’',
      level: 6,
      order: 6,
      max_progress: 156,
      initial_progress: 104,
      min_progress: 0,
      min_app_version: 200030000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 91,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'HiNote Life Elite',
      enum_value: 'FIT52_ELITE',
      display_unit: 'WORKOUTS',
      short_description: '250 activities',
      description: 'Complete 250 activities',
      achieved_message:
        'Amazing! 250 activities under your belt. Welcome to the HiNote Life Elite club. Keep it up!',
      level: 7,
      order: 7,
      max_progress: 250,
      initial_progress: 100,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 4,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'The Champion',
      enum_value: 'THE_CHAMPION',
      display_unit: 'HOURS',
      short_description: '52 hours',
      description: 'Work out for 52 hours',
      achieved_message:
        '52 cards. 52 weeks. 52 hours of HiNote Life workouts. You are The Champion!',
      level: 3,
      order: 7,
      max_progress: 187200,
      initial_progress: 90000,
      min_progress: 0,
      min_app_version: 100000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 82,
      achievement_id: 3,
      workout_template_types: [],
      challenge: null,
      unit: 'CARDS',
      type: 'NUMBER',
      name: 'Card Conqueror',
      enum_value: 'CARD_CONQUEROR',
      display_unit: 'CARDS',
      short_description: '252,000 cards',
      description: 'Complete 252,000 cards',
      achieved_message:
        'Outstanding! 252,000 cards conquered. Your dedication is unmatched. Keep up the great work!',
      level: 7,
      order: 7,
      max_progress: 252000,
      initial_progress: 200000,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 72,
      achievement_id: 6,
      workout_template_types: [],
      challenge: null,
      unit: 'WEEK_STREAK',
      type: 'NUMBER',
      name: '4 Years of HiNote Life',
      enum_value: '4_YEARS_OF_FIT52',
      display_unit: 'WEEK_STREAK',
      short_description: '208 week activity streak',
      description:
        'This tracks your longest all-time streak. Complete 208 weeks to unlock. Your current streak is shown on the Home Screen.',
      achieved_message:
        "Incredible! You've powered through a 4-year activity streak. Keep up the great work - Year 5 awaits!",
      level: 7,
      order: 7,
      max_progress: 208,
      initial_progress: 156,
      min_progress: 0,
      min_app_version: 300020006,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 92,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'HiNote Life All Star',
      enum_value: 'FIT52_ALL_STAR',
      display_unit: 'WORKOUTS',
      short_description: '520 activities',
      description: 'Complete 520 activities',
      achieved_message:
        "520 activities completed. Way to go! You've earned your place as a HiNote Life All Star. Keep shining bright!",
      level: 8,
      order: 8,
      max_progress: 520,
      initial_progress: 250,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 5,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'Idol Badge',
      enum_value: 'IDOL_BADGE',
      display_unit: 'HOURS',
      short_description: '250 hours',
      description: 'Work out for 250 hours',
      achieved_message:
        '250 hours of HiNote Life workouts is inspiring! Keep up the great work!',
      level: 4,
      order: 8,
      max_progress: 900000,
      initial_progress: 187200,
      min_progress: 0,
      min_app_version: 100000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 83,
      achievement_id: 3,
      workout_template_types: [],
      challenge: null,
      unit: 'CARDS',
      type: 'NUMBER',
      name: 'Ace of All Cards',
      enum_value: 'ACE_OF_ALL_CARDS',
      display_unit: 'CARDS',
      short_description: '520,000 cards',
      description: 'Complete 520,000 cards',
      achieved_message:
        "Phenomenal! 520,000 cards played. You're truly the ace of all cards. Keep dominating!",
      level: 8,
      order: 8,
      max_progress: 520000,
      initial_progress: 252000,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 73,
      achievement_id: 6,
      workout_template_types: [],
      challenge: null,
      unit: 'WEEK_STREAK',
      type: 'NUMBER',
      name: '5 Years of HiNote Life',
      enum_value: '5_YEARS_OF_FIT52',
      display_unit: 'WEEK_STREAK',
      short_description: '260 week activity streak',
      description:
        'This tracks your longest all-time streak. Complete 260 weeks to unlock. Your current streak is shown on the Home Screen.',
      achieved_message:
        'Amazing! Celebrating a 5-year streak of fitness commitment. Onwards to an amazing 6th year!',
      level: 8,
      order: 8,
      max_progress: 260,
      initial_progress: 208,
      min_progress: 0,
      min_app_version: 300020006,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 93,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Grand Grind',
      enum_value: 'GRAND_GRIND',
      display_unit: 'WORKOUTS',
      short_description: '1000 activities',
      description: 'Complete 1000 activities',
      achieved_message:
        'Impressive! 1,000 activities completed. Your dedication is truly inspiring. Keep grinding!',
      level: 9,
      order: 9,
      max_progress: 1000,
      initial_progress: 520,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 6,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'Gold Record',
      enum_value: 'GOLD_RECORD',
      display_unit: 'HOURS',
      short_description: '520 hours',
      description: 'Work out for 520 hours',
      achieved_message:
        '520 hours is a long time! Now, take a moment, be proud of all the hard work and enjoy this well-deserved milestone!',
      level: 5,
      order: 9,
      max_progress: 1872000,
      initial_progress: 900000,
      min_progress: 0,
      min_app_version: 100000000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 74,
      achievement_id: 6,
      workout_template_types: [],
      challenge: null,
      unit: 'WEEK_STREAK',
      type: 'NUMBER',
      name: '6 Years of HiNote Life',
      enum_value: '6_YEARS_OF_FIT52',
      display_unit: 'WEEK_STREAK',
      short_description: '312 week activity streak',
      description:
        'This tracks your longest all-time streak. Complete 312 weeks to unlock. Your current streak is shown on the Home Screen.',
      achieved_message:
        "Unstoppable! 6 years of consistent activities. You're doing great - let's aim for lucky year 7!",
      level: 9,
      order: 9,
      max_progress: 312,
      initial_progress: 260,
      min_progress: 0,
      min_app_version: 300020006,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 94,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: '2k Triumph',
      enum_value: '2K_TRIUMPH',
      display_unit: 'WORKOUTS',
      short_description: '2000 activities',
      description: 'Complete 2000 activities',
      achieved_message:
        'Wow! 2,000 activities done. This is a remarkable milestone. Celebrate your triumph!',
      level: 10,
      order: 10,
      max_progress: 2000,
      initial_progress: 1000,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 84,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'Look at You',
      enum_value: 'LOOK_AT_YOU',
      display_unit: 'HOURS',
      short_description: '1000 hours',
      description: 'Workout for 1000 hours',
      achieved_message:
        'Awesome! 1,000 hours of workouts. Your commitment is paying off. Look at you go!',
      level: 10,
      order: 10,
      max_progress: 3600000,
      initial_progress: 1872000,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 75,
      achievement_id: 6,
      workout_template_types: [],
      challenge: null,
      unit: 'WEEK_STREAK',
      type: 'NUMBER',
      name: '7 Years of HiNote Life',
      enum_value: '7_YEARS_OF_FIT52',
      display_unit: 'WEEK_STREAK',
      short_description: '364 week activity streak',
      description:
        'This tracks your longest all-time streak. Complete 364 weeks to unlock. Your current streak is shown on the Home Screen.',
      achieved_message:
        "Phenomenal! You've turned days into weeks, weeks into months, and months into 7 years of healthier living, a monumental achievement!",
      level: 10,
      order: 10,
      max_progress: 364,
      initial_progress: 312,
      min_progress: 0,
      min_app_version: 300020006,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 95,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Triple Threat',
      enum_value: 'TRIPLE_THREAT',
      display_unit: 'WORKOUTS',
      short_description: '3000 activities',
      description: 'Complete 3000 activities',
      achieved_message:
        "Outstanding! 3,000 activities accomplished. You're a fitness triple threat. Way to go!",
      level: 11,
      order: 11,
      max_progress: 3000,
      initial_progress: 2000,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 85,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'The Fighter',
      enum_value: 'THE_FIGHTER',
      display_unit: 'HOURS',
      short_description: '1520 hours',
      description: 'Workout for 1520 hours',
      achieved_message:
        'Incredible! 1,520 hours of workouts. You embody the spirit of a true fighter. Keep pushing!',
      level: 11,
      order: 11,
      max_progress: 5472000,
      initial_progress: 3600000,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 96,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: '4k Fitness Frontier',
      enum_value: '4K_FITNESS_FRONTIER',
      display_unit: 'WORKOUTS',
      short_description: '4000 activities',
      description: 'Complete 4000 activities',
      achieved_message:
        "Incredible! 4,000 activities finished. You've reached the fitness frontier. Keep exploring!",
      level: 12,
      order: 12,
      max_progress: 4000,
      initial_progress: 3000,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 86,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'Time Trailblazer',
      enum_value: 'TIME_TRAILBLAZER',
      display_unit: 'HOURS',
      short_description: '2000 hours',
      description: 'Workout for 2000 hours',
      achieved_message:
        "Amazing! 2,000 hours of workouts. You've blazed a trail of dedication and hard work. Keep leading!",
      level: 12,
      order: 12,
      max_progress: 7200000,
      initial_progress: 5472000,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 97,
      achievement_id: 1,
      workout_template_types: [],
      challenge: null,
      unit: 'WORKOUTS',
      type: 'NUMBER',
      name: 'Five Star Fitness',
      enum_value: 'FIVE_STAR_FITNESS',
      display_unit: 'WORKOUTS',
      short_description: '5200 activities',
      description: 'Complete 5200 activities',
      achieved_message:
        "Phenomenal! 5,200 activities completed. You've earned five-star fitness status. Keep shining!",
      level: 13,
      order: 13,
      max_progress: 5200,
      initial_progress: 4000,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 87,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'Time Titan',
      enum_value: 'TIME_TITAN',
      display_unit: 'HOURS',
      short_description: '2520 hours',
      description: 'Workout for 2520 hours',
      achieved_message:
        "Incredible! 2,520 hours of workouts. You're a true Time Titan. Keep adding to those hours!",
      level: 13,
      order: 13,
      max_progress: 9072000,
      initial_progress: 7200000,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
    {
      id: 88,
      achievement_id: 2,
      workout_template_types: [],
      challenge: null,
      unit: 'HOURS',
      type: 'TIME',
      name: 'Timeless',
      enum_value: 'TIMELESS',
      display_unit: 'HOURS',
      short_description: '5200 hours',
      description: 'Workout for 5200 hours',
      achieved_message:
        'Unbelievable! 5,200 hours of workouts. Your dedication is timeless. Keep shining bright!',
      level: 14,
      order: 14,
      max_progress: 18720000,
      initial_progress: 9072000,
      min_progress: 0,
      min_app_version: 300070000,
      campaign_guid: null,
      user_achievement_level_id: null,
      progress: null,
      achieved_at: null,
    },
  ],
};

export default configData;
